// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23052c65%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/images/dashboard/login-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./assets/fonts/flag-icon/es-ct.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./assets/fonts/flag-icon/eu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./assets/fonts/flag-icon/gb-eng.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./assets/fonts/flag-icon/gb-nir.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./assets/fonts/flag-icon/gb-sct.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./assets/fonts/flag-icon/gb-wls.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./assets/fonts/flag-icon/un.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./assets/fonts/flag-icon/ad.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./assets/fonts/flag-icon/ae.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./assets/fonts/flag-icon/af.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./assets/fonts/flag-icon/ag.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("./assets/fonts/flag-icon/ai.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("./assets/fonts/flag-icon/al.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("./assets/fonts/flag-icon/am.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("./assets/fonts/flag-icon/ao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("./assets/fonts/flag-icon/aq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("./assets/fonts/flag-icon/ar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("./assets/fonts/flag-icon/as.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("./assets/fonts/flag-icon/at.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("./assets/fonts/flag-icon/au.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("./assets/fonts/flag-icon/aw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("./assets/fonts/flag-icon/ax.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("./assets/fonts/flag-icon/az.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("./assets/fonts/flag-icon/ba.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("./assets/fonts/flag-icon/bb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("./assets/fonts/flag-icon/bd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("./assets/fonts/flag-icon/be.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("./assets/fonts/flag-icon/bf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("./assets/fonts/flag-icon/bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("./assets/fonts/flag-icon/bh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("./assets/fonts/flag-icon/bi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("./assets/fonts/flag-icon/bj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("./assets/fonts/flag-icon/bl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("./assets/fonts/flag-icon/bm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("./assets/fonts/flag-icon/bn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("./assets/fonts/flag-icon/bo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("./assets/fonts/flag-icon/bq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("./assets/fonts/flag-icon/br.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("./assets/fonts/flag-icon/bs.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("./assets/fonts/flag-icon/bt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("./assets/fonts/flag-icon/bv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("./assets/fonts/flag-icon/bw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("./assets/fonts/flag-icon/by.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("./assets/fonts/flag-icon/bz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("./assets/fonts/flag-icon/ca.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("./assets/fonts/flag-icon/cc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("./assets/fonts/flag-icon/cd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("./assets/fonts/flag-icon/cf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("./assets/fonts/flag-icon/cg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("./assets/fonts/flag-icon/ch.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("./assets/fonts/flag-icon/ci.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("./assets/fonts/flag-icon/ck.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("./assets/fonts/flag-icon/cl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("./assets/fonts/flag-icon/cm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("./assets/fonts/flag-icon/cn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("./assets/fonts/flag-icon/co.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("./assets/fonts/flag-icon/cr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("./assets/fonts/flag-icon/cu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("./assets/fonts/flag-icon/cv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("./assets/fonts/flag-icon/cw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("./assets/fonts/flag-icon/cx.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("./assets/fonts/flag-icon/cy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("./assets/fonts/flag-icon/cz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("./assets/fonts/flag-icon/de.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("./assets/fonts/flag-icon/dj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("./assets/fonts/flag-icon/dk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("./assets/fonts/flag-icon/dm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("./assets/fonts/flag-icon/do.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("./assets/fonts/flag-icon/dz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("./assets/fonts/flag-icon/ec.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("./assets/fonts/flag-icon/ee.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("./assets/fonts/flag-icon/eg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("./assets/fonts/flag-icon/eh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("./assets/fonts/flag-icon/er.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("./assets/fonts/flag-icon/es.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("./assets/fonts/flag-icon/et.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("./assets/fonts/flag-icon/fi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("./assets/fonts/flag-icon/fj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("./assets/fonts/flag-icon/fk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("./assets/fonts/flag-icon/fm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("./assets/fonts/flag-icon/fo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("./assets/fonts/flag-icon/fr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("./assets/fonts/flag-icon/ga.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("./assets/fonts/flag-icon/gb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("./assets/fonts/flag-icon/gd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("./assets/fonts/flag-icon/ge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("./assets/fonts/flag-icon/gf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("./assets/fonts/flag-icon/gg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("./assets/fonts/flag-icon/gh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("./assets/fonts/flag-icon/gi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("./assets/fonts/flag-icon/gl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("./assets/fonts/flag-icon/gm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("./assets/fonts/flag-icon/gn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("./assets/fonts/flag-icon/gp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("./assets/fonts/flag-icon/gq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("./assets/fonts/flag-icon/gr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_116___ = new URL("./assets/fonts/flag-icon/gs.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_117___ = new URL("./assets/fonts/flag-icon/gt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_118___ = new URL("./assets/fonts/flag-icon/gu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_119___ = new URL("./assets/fonts/flag-icon/gw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_120___ = new URL("./assets/fonts/flag-icon/gy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_121___ = new URL("./assets/fonts/flag-icon/hk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_122___ = new URL("./assets/fonts/flag-icon/hm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_123___ = new URL("./assets/fonts/flag-icon/hn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_124___ = new URL("./assets/fonts/flag-icon/hr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_125___ = new URL("./assets/fonts/flag-icon/ht.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_126___ = new URL("./assets/fonts/flag-icon/hu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_127___ = new URL("./assets/fonts/flag-icon/id.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_128___ = new URL("./assets/fonts/flag-icon/ie.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_129___ = new URL("./assets/fonts/flag-icon/il.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_130___ = new URL("./assets/fonts/flag-icon/im.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_131___ = new URL("./assets/fonts/flag-icon/in.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_132___ = new URL("./assets/fonts/flag-icon/io.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_133___ = new URL("./assets/fonts/flag-icon/iq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_134___ = new URL("./assets/fonts/flag-icon/ir.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_135___ = new URL("./assets/fonts/flag-icon/is.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_136___ = new URL("./assets/fonts/flag-icon/it.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_137___ = new URL("./assets/fonts/flag-icon/je.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_138___ = new URL("./assets/fonts/flag-icon/jm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_139___ = new URL("./assets/fonts/flag-icon/jo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_140___ = new URL("./assets/fonts/flag-icon/jp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_141___ = new URL("./assets/fonts/flag-icon/ke.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_142___ = new URL("./assets/fonts/flag-icon/kg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_143___ = new URL("./assets/fonts/flag-icon/kh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_144___ = new URL("./assets/fonts/flag-icon/ki.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_145___ = new URL("./assets/fonts/flag-icon/km.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_146___ = new URL("./assets/fonts/flag-icon/kn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_147___ = new URL("./assets/fonts/flag-icon/kp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_148___ = new URL("./assets/fonts/flag-icon/kr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_149___ = new URL("./assets/fonts/flag-icon/kw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_150___ = new URL("./assets/fonts/flag-icon/ky.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_151___ = new URL("./assets/fonts/flag-icon/kz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_152___ = new URL("./assets/fonts/flag-icon/la.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_153___ = new URL("./assets/fonts/flag-icon/lb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_154___ = new URL("./assets/fonts/flag-icon/lc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_155___ = new URL("./assets/fonts/flag-icon/li.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_156___ = new URL("./assets/fonts/flag-icon/lk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_157___ = new URL("./assets/fonts/flag-icon/lr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_158___ = new URL("./assets/fonts/flag-icon/ls.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_159___ = new URL("./assets/fonts/flag-icon/lt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_160___ = new URL("./assets/fonts/flag-icon/lu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_161___ = new URL("./assets/fonts/flag-icon/lv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_162___ = new URL("./assets/fonts/flag-icon/ly.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_163___ = new URL("./assets/fonts/flag-icon/ma.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_164___ = new URL("./assets/fonts/flag-icon/mc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_165___ = new URL("./assets/fonts/flag-icon/md.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_166___ = new URL("./assets/fonts/flag-icon/me.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_167___ = new URL("./assets/fonts/flag-icon/mf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_168___ = new URL("./assets/fonts/flag-icon/mg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_169___ = new URL("./assets/fonts/flag-icon/mh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_170___ = new URL("./assets/fonts/flag-icon/mk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_171___ = new URL("./assets/fonts/flag-icon/ml.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_172___ = new URL("./assets/fonts/flag-icon/mm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_173___ = new URL("./assets/fonts/flag-icon/mn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_174___ = new URL("./assets/fonts/flag-icon/mo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_175___ = new URL("./assets/fonts/flag-icon/mp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_176___ = new URL("./assets/fonts/flag-icon/mq.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_177___ = new URL("./assets/fonts/flag-icon/mr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_178___ = new URL("./assets/fonts/flag-icon/ms.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_179___ = new URL("./assets/fonts/flag-icon/mt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_180___ = new URL("./assets/fonts/flag-icon/mu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_181___ = new URL("./assets/fonts/flag-icon/mv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_182___ = new URL("./assets/fonts/flag-icon/mw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_183___ = new URL("./assets/fonts/flag-icon/mx.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_184___ = new URL("./assets/fonts/flag-icon/my.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_185___ = new URL("./assets/fonts/flag-icon/mz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_186___ = new URL("./assets/fonts/flag-icon/na.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_187___ = new URL("./assets/fonts/flag-icon/nc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_188___ = new URL("./assets/fonts/flag-icon/ne.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_189___ = new URL("./assets/fonts/flag-icon/nf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_190___ = new URL("./assets/fonts/flag-icon/ng.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_191___ = new URL("./assets/fonts/flag-icon/ni.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_192___ = new URL("./assets/fonts/flag-icon/nl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_193___ = new URL("./assets/fonts/flag-icon/no.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_194___ = new URL("./assets/fonts/flag-icon/np.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_195___ = new URL("./assets/fonts/flag-icon/nr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_196___ = new URL("./assets/fonts/flag-icon/nu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_197___ = new URL("./assets/fonts/flag-icon/nz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_198___ = new URL("./assets/fonts/flag-icon/om.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_199___ = new URL("./assets/fonts/flag-icon/pa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_200___ = new URL("./assets/fonts/flag-icon/pe.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_201___ = new URL("./assets/fonts/flag-icon/pf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_202___ = new URL("./assets/fonts/flag-icon/pg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_203___ = new URL("./assets/fonts/flag-icon/ph.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_204___ = new URL("./assets/fonts/flag-icon/pk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_205___ = new URL("./assets/fonts/flag-icon/pl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_206___ = new URL("./assets/fonts/flag-icon/pm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_207___ = new URL("./assets/fonts/flag-icon/pn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_208___ = new URL("./assets/fonts/flag-icon/pr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_209___ = new URL("./assets/fonts/flag-icon/ps.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_210___ = new URL("./assets/fonts/flag-icon/pt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_211___ = new URL("./assets/fonts/flag-icon/pw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_212___ = new URL("./assets/fonts/flag-icon/py.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_213___ = new URL("./assets/fonts/flag-icon/qa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_214___ = new URL("./assets/fonts/flag-icon/re.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_215___ = new URL("./assets/fonts/flag-icon/ro.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_216___ = new URL("./assets/fonts/flag-icon/rs.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_217___ = new URL("./assets/fonts/flag-icon/ru.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_218___ = new URL("./assets/fonts/flag-icon/rw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_219___ = new URL("./assets/fonts/flag-icon/sa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_220___ = new URL("./assets/fonts/flag-icon/sb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_221___ = new URL("./assets/fonts/flag-icon/sc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_222___ = new URL("./assets/fonts/flag-icon/sd.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_223___ = new URL("./assets/fonts/flag-icon/se.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_224___ = new URL("./assets/fonts/flag-icon/sg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_225___ = new URL("./assets/fonts/flag-icon/sh.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_226___ = new URL("./assets/fonts/flag-icon/si.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_227___ = new URL("./assets/fonts/flag-icon/sj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_228___ = new URL("./assets/fonts/flag-icon/sk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_229___ = new URL("./assets/fonts/flag-icon/sl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_230___ = new URL("./assets/fonts/flag-icon/sm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_231___ = new URL("./assets/fonts/flag-icon/sn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_232___ = new URL("./assets/fonts/flag-icon/so.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_233___ = new URL("./assets/fonts/flag-icon/sr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_234___ = new URL("./assets/fonts/flag-icon/ss.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_235___ = new URL("./assets/fonts/flag-icon/st.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_236___ = new URL("./assets/fonts/flag-icon/sv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_237___ = new URL("./assets/fonts/flag-icon/sx.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_238___ = new URL("./assets/fonts/flag-icon/sy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_239___ = new URL("./assets/fonts/flag-icon/sz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_240___ = new URL("./assets/fonts/flag-icon/tc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_241___ = new URL("./assets/fonts/flag-icon/td.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_242___ = new URL("./assets/fonts/flag-icon/tf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_243___ = new URL("./assets/fonts/flag-icon/tg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_244___ = new URL("./assets/fonts/flag-icon/th.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_245___ = new URL("./assets/fonts/flag-icon/tj.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_246___ = new URL("./assets/fonts/flag-icon/tk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_247___ = new URL("./assets/fonts/flag-icon/tl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_248___ = new URL("./assets/fonts/flag-icon/tm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_249___ = new URL("./assets/fonts/flag-icon/tn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_250___ = new URL("./assets/fonts/flag-icon/to.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_251___ = new URL("./assets/fonts/flag-icon/tr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_252___ = new URL("./assets/fonts/flag-icon/tt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_253___ = new URL("./assets/fonts/flag-icon/tv.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_254___ = new URL("./assets/fonts/flag-icon/tw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_255___ = new URL("./assets/fonts/flag-icon/tz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_256___ = new URL("./assets/fonts/flag-icon/ua.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_257___ = new URL("./assets/fonts/flag-icon/ug.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_258___ = new URL("./assets/fonts/flag-icon/um.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_259___ = new URL("./assets/fonts/flag-icon/us.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_260___ = new URL("./assets/fonts/flag-icon/uy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_261___ = new URL("./assets/fonts/flag-icon/uz.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_262___ = new URL("./assets/fonts/flag-icon/va.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_263___ = new URL("./assets/fonts/flag-icon/vc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_264___ = new URL("./assets/fonts/flag-icon/ve.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_265___ = new URL("./assets/fonts/flag-icon/vg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_266___ = new URL("./assets/fonts/flag-icon/vi.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_267___ = new URL("./assets/fonts/flag-icon/vn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_268___ = new URL("./assets/fonts/flag-icon/vu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_269___ = new URL("./assets/fonts/flag-icon/wf.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_270___ = new URL("./assets/fonts/flag-icon/ws.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_271___ = new URL("./assets/fonts/flag-icon/ye.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_272___ = new URL("./assets/fonts/flag-icon/yt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_273___ = new URL("./assets/fonts/flag-icon/za.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_274___ = new URL("./assets/fonts/flag-icon/zm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_275___ = new URL("./assets/fonts/flag-icon/zw.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_276___ = new URL("./assets/fonts/themify.eot?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_277___ = new URL("./assets/fonts/themify.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_278___ = new URL("./assets/fonts/themify.woff?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_279___ = new URL("./assets/fonts/themify.ttf?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_280___ = new URL("./assets/fonts/themify.svg?-fvbane", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_281___ = new URL("./assets/fonts/ico/icofont.eot?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_282___ = new URL("./assets/fonts/ico/icofont.ttf?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_283___ = new URL("./assets/fonts/ico/icofont.woff?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_284___ = new URL("./assets/fonts/ico/icofont.svg?v=1.0.0-beta", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_285___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_286___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_287___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.woff2?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_288___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_289___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.ttf?v=4.7.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_290___ = new URL("./assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
var ___CSS_LOADER_URL_REPLACEMENT_116___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_116___);
var ___CSS_LOADER_URL_REPLACEMENT_117___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_117___);
var ___CSS_LOADER_URL_REPLACEMENT_118___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_118___);
var ___CSS_LOADER_URL_REPLACEMENT_119___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_119___);
var ___CSS_LOADER_URL_REPLACEMENT_120___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_120___);
var ___CSS_LOADER_URL_REPLACEMENT_121___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_121___);
var ___CSS_LOADER_URL_REPLACEMENT_122___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_122___);
var ___CSS_LOADER_URL_REPLACEMENT_123___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_123___);
var ___CSS_LOADER_URL_REPLACEMENT_124___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_124___);
var ___CSS_LOADER_URL_REPLACEMENT_125___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_125___);
var ___CSS_LOADER_URL_REPLACEMENT_126___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_126___);
var ___CSS_LOADER_URL_REPLACEMENT_127___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_127___);
var ___CSS_LOADER_URL_REPLACEMENT_128___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_128___);
var ___CSS_LOADER_URL_REPLACEMENT_129___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_129___);
var ___CSS_LOADER_URL_REPLACEMENT_130___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_130___);
var ___CSS_LOADER_URL_REPLACEMENT_131___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_131___);
var ___CSS_LOADER_URL_REPLACEMENT_132___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_132___);
var ___CSS_LOADER_URL_REPLACEMENT_133___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_133___);
var ___CSS_LOADER_URL_REPLACEMENT_134___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_134___);
var ___CSS_LOADER_URL_REPLACEMENT_135___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_135___);
var ___CSS_LOADER_URL_REPLACEMENT_136___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_136___);
var ___CSS_LOADER_URL_REPLACEMENT_137___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_137___);
var ___CSS_LOADER_URL_REPLACEMENT_138___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_138___);
var ___CSS_LOADER_URL_REPLACEMENT_139___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_139___);
var ___CSS_LOADER_URL_REPLACEMENT_140___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_140___);
var ___CSS_LOADER_URL_REPLACEMENT_141___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_141___);
var ___CSS_LOADER_URL_REPLACEMENT_142___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_142___);
var ___CSS_LOADER_URL_REPLACEMENT_143___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_143___);
var ___CSS_LOADER_URL_REPLACEMENT_144___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_144___);
var ___CSS_LOADER_URL_REPLACEMENT_145___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_145___);
var ___CSS_LOADER_URL_REPLACEMENT_146___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_146___);
var ___CSS_LOADER_URL_REPLACEMENT_147___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_147___);
var ___CSS_LOADER_URL_REPLACEMENT_148___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_148___);
var ___CSS_LOADER_URL_REPLACEMENT_149___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_149___);
var ___CSS_LOADER_URL_REPLACEMENT_150___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_150___);
var ___CSS_LOADER_URL_REPLACEMENT_151___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_151___);
var ___CSS_LOADER_URL_REPLACEMENT_152___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_152___);
var ___CSS_LOADER_URL_REPLACEMENT_153___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_153___);
var ___CSS_LOADER_URL_REPLACEMENT_154___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_154___);
var ___CSS_LOADER_URL_REPLACEMENT_155___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_155___);
var ___CSS_LOADER_URL_REPLACEMENT_156___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_156___);
var ___CSS_LOADER_URL_REPLACEMENT_157___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_157___);
var ___CSS_LOADER_URL_REPLACEMENT_158___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_158___);
var ___CSS_LOADER_URL_REPLACEMENT_159___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_159___);
var ___CSS_LOADER_URL_REPLACEMENT_160___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_160___);
var ___CSS_LOADER_URL_REPLACEMENT_161___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_161___);
var ___CSS_LOADER_URL_REPLACEMENT_162___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_162___);
var ___CSS_LOADER_URL_REPLACEMENT_163___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_163___);
var ___CSS_LOADER_URL_REPLACEMENT_164___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_164___);
var ___CSS_LOADER_URL_REPLACEMENT_165___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_165___);
var ___CSS_LOADER_URL_REPLACEMENT_166___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_166___);
var ___CSS_LOADER_URL_REPLACEMENT_167___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_167___);
var ___CSS_LOADER_URL_REPLACEMENT_168___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_168___);
var ___CSS_LOADER_URL_REPLACEMENT_169___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_169___);
var ___CSS_LOADER_URL_REPLACEMENT_170___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_170___);
var ___CSS_LOADER_URL_REPLACEMENT_171___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_171___);
var ___CSS_LOADER_URL_REPLACEMENT_172___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_172___);
var ___CSS_LOADER_URL_REPLACEMENT_173___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_173___);
var ___CSS_LOADER_URL_REPLACEMENT_174___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_174___);
var ___CSS_LOADER_URL_REPLACEMENT_175___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_175___);
var ___CSS_LOADER_URL_REPLACEMENT_176___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_176___);
var ___CSS_LOADER_URL_REPLACEMENT_177___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_177___);
var ___CSS_LOADER_URL_REPLACEMENT_178___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_178___);
var ___CSS_LOADER_URL_REPLACEMENT_179___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_179___);
var ___CSS_LOADER_URL_REPLACEMENT_180___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_180___);
var ___CSS_LOADER_URL_REPLACEMENT_181___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_181___);
var ___CSS_LOADER_URL_REPLACEMENT_182___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_182___);
var ___CSS_LOADER_URL_REPLACEMENT_183___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_183___);
var ___CSS_LOADER_URL_REPLACEMENT_184___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_184___);
var ___CSS_LOADER_URL_REPLACEMENT_185___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_185___);
var ___CSS_LOADER_URL_REPLACEMENT_186___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_186___);
var ___CSS_LOADER_URL_REPLACEMENT_187___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_187___);
var ___CSS_LOADER_URL_REPLACEMENT_188___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_188___);
var ___CSS_LOADER_URL_REPLACEMENT_189___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_189___);
var ___CSS_LOADER_URL_REPLACEMENT_190___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_190___);
var ___CSS_LOADER_URL_REPLACEMENT_191___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_191___);
var ___CSS_LOADER_URL_REPLACEMENT_192___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_192___);
var ___CSS_LOADER_URL_REPLACEMENT_193___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_193___);
var ___CSS_LOADER_URL_REPLACEMENT_194___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_194___);
var ___CSS_LOADER_URL_REPLACEMENT_195___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_195___);
var ___CSS_LOADER_URL_REPLACEMENT_196___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_196___);
var ___CSS_LOADER_URL_REPLACEMENT_197___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_197___);
var ___CSS_LOADER_URL_REPLACEMENT_198___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_198___);
var ___CSS_LOADER_URL_REPLACEMENT_199___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_199___);
var ___CSS_LOADER_URL_REPLACEMENT_200___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_200___);
var ___CSS_LOADER_URL_REPLACEMENT_201___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_201___);
var ___CSS_LOADER_URL_REPLACEMENT_202___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_202___);
var ___CSS_LOADER_URL_REPLACEMENT_203___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_203___);
var ___CSS_LOADER_URL_REPLACEMENT_204___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_204___);
var ___CSS_LOADER_URL_REPLACEMENT_205___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_205___);
var ___CSS_LOADER_URL_REPLACEMENT_206___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_206___);
var ___CSS_LOADER_URL_REPLACEMENT_207___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_207___);
var ___CSS_LOADER_URL_REPLACEMENT_208___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_208___);
var ___CSS_LOADER_URL_REPLACEMENT_209___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_209___);
var ___CSS_LOADER_URL_REPLACEMENT_210___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_210___);
var ___CSS_LOADER_URL_REPLACEMENT_211___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_211___);
var ___CSS_LOADER_URL_REPLACEMENT_212___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_212___);
var ___CSS_LOADER_URL_REPLACEMENT_213___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_213___);
var ___CSS_LOADER_URL_REPLACEMENT_214___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_214___);
var ___CSS_LOADER_URL_REPLACEMENT_215___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_215___);
var ___CSS_LOADER_URL_REPLACEMENT_216___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_216___);
var ___CSS_LOADER_URL_REPLACEMENT_217___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_217___);
var ___CSS_LOADER_URL_REPLACEMENT_218___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_218___);
var ___CSS_LOADER_URL_REPLACEMENT_219___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_219___);
var ___CSS_LOADER_URL_REPLACEMENT_220___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_220___);
var ___CSS_LOADER_URL_REPLACEMENT_221___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_221___);
var ___CSS_LOADER_URL_REPLACEMENT_222___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_222___);
var ___CSS_LOADER_URL_REPLACEMENT_223___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_223___);
var ___CSS_LOADER_URL_REPLACEMENT_224___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_224___);
var ___CSS_LOADER_URL_REPLACEMENT_225___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_225___);
var ___CSS_LOADER_URL_REPLACEMENT_226___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_226___);
var ___CSS_LOADER_URL_REPLACEMENT_227___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_227___);
var ___CSS_LOADER_URL_REPLACEMENT_228___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_228___);
var ___CSS_LOADER_URL_REPLACEMENT_229___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_229___);
var ___CSS_LOADER_URL_REPLACEMENT_230___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_230___);
var ___CSS_LOADER_URL_REPLACEMENT_231___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_231___);
var ___CSS_LOADER_URL_REPLACEMENT_232___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_232___);
var ___CSS_LOADER_URL_REPLACEMENT_233___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_233___);
var ___CSS_LOADER_URL_REPLACEMENT_234___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_234___);
var ___CSS_LOADER_URL_REPLACEMENT_235___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_235___);
var ___CSS_LOADER_URL_REPLACEMENT_236___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_236___);
var ___CSS_LOADER_URL_REPLACEMENT_237___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_237___);
var ___CSS_LOADER_URL_REPLACEMENT_238___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_238___);
var ___CSS_LOADER_URL_REPLACEMENT_239___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_239___);
var ___CSS_LOADER_URL_REPLACEMENT_240___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_240___);
var ___CSS_LOADER_URL_REPLACEMENT_241___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_241___);
var ___CSS_LOADER_URL_REPLACEMENT_242___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_242___);
var ___CSS_LOADER_URL_REPLACEMENT_243___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_243___);
var ___CSS_LOADER_URL_REPLACEMENT_244___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_244___);
var ___CSS_LOADER_URL_REPLACEMENT_245___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_245___);
var ___CSS_LOADER_URL_REPLACEMENT_246___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_246___);
var ___CSS_LOADER_URL_REPLACEMENT_247___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_247___);
var ___CSS_LOADER_URL_REPLACEMENT_248___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_248___);
var ___CSS_LOADER_URL_REPLACEMENT_249___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_249___);
var ___CSS_LOADER_URL_REPLACEMENT_250___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_250___);
var ___CSS_LOADER_URL_REPLACEMENT_251___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_251___);
var ___CSS_LOADER_URL_REPLACEMENT_252___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_252___);
var ___CSS_LOADER_URL_REPLACEMENT_253___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_253___);
var ___CSS_LOADER_URL_REPLACEMENT_254___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_254___);
var ___CSS_LOADER_URL_REPLACEMENT_255___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_255___);
var ___CSS_LOADER_URL_REPLACEMENT_256___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_256___);
var ___CSS_LOADER_URL_REPLACEMENT_257___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_257___);
var ___CSS_LOADER_URL_REPLACEMENT_258___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_258___);
var ___CSS_LOADER_URL_REPLACEMENT_259___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_259___);
var ___CSS_LOADER_URL_REPLACEMENT_260___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_260___);
var ___CSS_LOADER_URL_REPLACEMENT_261___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_261___);
var ___CSS_LOADER_URL_REPLACEMENT_262___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_262___);
var ___CSS_LOADER_URL_REPLACEMENT_263___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_263___);
var ___CSS_LOADER_URL_REPLACEMENT_264___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_264___);
var ___CSS_LOADER_URL_REPLACEMENT_265___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_265___);
var ___CSS_LOADER_URL_REPLACEMENT_266___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_266___);
var ___CSS_LOADER_URL_REPLACEMENT_267___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_267___);
var ___CSS_LOADER_URL_REPLACEMENT_268___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_268___);
var ___CSS_LOADER_URL_REPLACEMENT_269___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_269___);
var ___CSS_LOADER_URL_REPLACEMENT_270___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_270___);
var ___CSS_LOADER_URL_REPLACEMENT_271___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_271___);
var ___CSS_LOADER_URL_REPLACEMENT_272___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_272___);
var ___CSS_LOADER_URL_REPLACEMENT_273___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_273___);
var ___CSS_LOADER_URL_REPLACEMENT_274___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_274___);
var ___CSS_LOADER_URL_REPLACEMENT_275___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_275___);
var ___CSS_LOADER_URL_REPLACEMENT_276___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_276___);
var ___CSS_LOADER_URL_REPLACEMENT_277___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_277___, { hash: "?#iefix-fvbane" });
var ___CSS_LOADER_URL_REPLACEMENT_278___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_278___);
var ___CSS_LOADER_URL_REPLACEMENT_279___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_279___);
var ___CSS_LOADER_URL_REPLACEMENT_280___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_280___, { hash: "#themify" });
var ___CSS_LOADER_URL_REPLACEMENT_281___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_281___);
var ___CSS_LOADER_URL_REPLACEMENT_282___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_281___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_283___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_282___);
var ___CSS_LOADER_URL_REPLACEMENT_284___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_283___);
var ___CSS_LOADER_URL_REPLACEMENT_285___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_284___, { hash: "#icofont" });
var ___CSS_LOADER_URL_REPLACEMENT_286___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_285___);
var ___CSS_LOADER_URL_REPLACEMENT_287___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_286___, { hash: "?#iefix&v=4.7.0" });
var ___CSS_LOADER_URL_REPLACEMENT_288___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_287___);
var ___CSS_LOADER_URL_REPLACEMENT_289___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_288___);
var ___CSS_LOADER_URL_REPLACEMENT_290___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_289___);
var ___CSS_LOADER_URL_REPLACEMENT_291___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_290___, { hash: "#fontawesomeregular" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.2 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-border-color: #86b7fe;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/**=====================
    Admin CSS Start
==========================**/
.card-left {
  z-index: 1;
}

.checkbox-space {
  padding: 0;
}

.form-group {
  margin-bottom: 1rem;
}

.page-wrapper .page-body-wrapper footer.footer.open {
  margin-left: 0;
}

.modal .modal-dialog .modal-content .modal-header .close {
  background-color: unset;
  border: unset;
}
.modal .modal-dialog .modal-content .modal-header .close span {
  font-size: 24px;
}

.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div, .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,
.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,
.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div {
  background-color: #fafafa;
}
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div, .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,
.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div,
.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div {
  background-color: #ffffff;
}

.order-datatable .rdt_Table {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.order-datatable .rdt_Table .rdt_TableCell,
.order-datatable .rdt_Table .rdt_TableCol {
  padding: 7px 5px;
}
.order-datatable .rdt_Table .rdt_TableHead {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
  z-index: 1;
}
.order-datatable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  flex: 100 0 auto;
  width: 100px;
  padding: 5px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}
.order-datatable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable {
  justify-content: center;
  padding: 18px;
  background-color: #f8f8f9;
}
.order-datatable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b {
  font-size: 14px;
  color: #313131;
}
.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  justify-content: center;
  font-size: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
}
.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div, .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) > div, .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5) > div, .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div {
  background-color: #ffffff;
}
.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div {
  padding: 5px;
  background-color: #fafafa;
  flex: 100 0 auto;
  width: 100px;
  line-height: 1.5;
}
.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div .badge {
  padding: 4px 6px 5px;
}
.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {
  border-right: 0;
}

.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child .rdt_TableCol_Sortable,
.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child .rdt_TableCol_Sortable,
.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child .rdt_TableCol_Sortable {
  padding: 10px;
}
.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div, .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div {
  background-color: #fafafa !important;
}

.product-list .rdt_Table,
.translation-list .rdt_Table,
.category-table .rdt_Table,
.transactions .rdt_Table,
.product-physical .rdt_Table {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.product-list .rdt_Table .rdt_TableCell,
.product-list .rdt_Table .rdt_TableCol,
.translation-list .rdt_Table .rdt_TableCell,
.translation-list .rdt_Table .rdt_TableCol,
.category-table .rdt_Table .rdt_TableCell,
.category-table .rdt_Table .rdt_TableCol,
.transactions .rdt_Table .rdt_TableCell,
.transactions .rdt_Table .rdt_TableCol,
.product-physical .rdt_Table .rdt_TableCell,
.product-physical .rdt_Table .rdt_TableCol {
  padding: 7px 5px;
}
.product-list .rdt_Table .rdt_TableHead,
.translation-list .rdt_Table .rdt_TableHead,
.category-table .rdt_Table .rdt_TableHead,
.transactions .rdt_Table .rdt_TableHead,
.product-physical .rdt_Table .rdt_TableHead {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
  z-index: 1;
}
.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
.transactions .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  flex: 100 0 auto;
  width: 100px;
  padding: 5px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}
.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,
.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,
.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,
.transactions .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,
.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable {
  justify-content: center;
  padding: 18px;
  background-color: #f8f8f9;
}
.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,
.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,
.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,
.transactions .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,
.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b {
  font-size: 14px;
  color: #313131;
}
.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  justify-content: center;
  font-size: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
}
.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div, .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div, .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,
.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,
.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,
.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,
.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,
.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,
.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div {
  background-color: #ffffff;
}
.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,
.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,
.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div {
  padding: 5px;
  background-color: #fafafa;
  flex: 100 0 auto;
  width: 100px;
  line-height: 1.5;
}
.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,
.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {
  border-right: 0;
}

.react-datepicker__input-container input {
  border-radius: 0.25rem;
  padding: 0.48rem 0.75rem;
  border: 1px solid #ced4da;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range {
  background-color: #12571a !important;
}

.form-label-center .form-group label {
  margin-top: 8px;
}
.form-label-center .form-group .form-group {
  margin-bottom: 0;
}

.tab-coupon li {
  color: #12571a;
}

.styles_modal__gNwvD {
  padding: 0;
}
.styles_modal__gNwvD button svg {
  width: 18px;
}

.product-page-details h2, .product-page-details .h2 {
  margin-bottom: 5px !important;
}
.product-page-details label {
  margin-bottom: 0 !important;
}
.product-page-details .product-price h3, .product-page-details .product-price .h3 {
  color: #222222;
}

.product-slider {
  margin-bottom: 20px;
}

.small-slick .slick-slide.slick-current div .item {
  border: 1px solid #12571a;
}

.checkbox_animated {
  cursor: pointer;
  position: relative;
  margin: 0 20px 0 0;
}
.checkbox_animated:checked, .checkbox_animated:not(:checked) {
  box-shadow: none;
}
.checkbox_animated:before {
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transform: rotate(-45deg) scale(0, 0);
  content: "";
  position: absolute;
  left: 0.25rem;
  top: 0.225rem;
  z-index: 1;
  width: 0.75rem;
  height: 0.375rem;
  border: 2px solid #12571a;
  border-top-style: none;
  border-right-style: none;
}
.checkbox_animated:after {
  content: "";
  position: absolute;
  top: -0.125rem;
  left: -1px;
  width: 1.3rem;
  height: 1.3rem;
  background: #ffffff;
  border: 2px solid #e8ebf2;
  cursor: pointer;
}
.checkbox_animated:checked:before {
  transform: rotate(-45deg) scale(1, 1);
}

.radio_animated {
  position: relative;
  margin: 0 1rem 0 0;
  cursor: pointer;
  vertical-align: -2px;
}
.radio_animated:checked, .radio_animated:not(:checked) {
  box-shadow: none;
}
.radio_animated:before {
  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);
  transform: scale(0, 0);
  content: "";
  position: absolute;
  top: 0;
  left: 0.125rem;
  z-index: 1;
  width: 0.75rem;
  height: 0.75rem;
  background: #12571a;
  border-radius: 50%;
}
.radio_animated:after {
  content: "";
  position: absolute;
  top: -0.25rem;
  left: -0.125rem;
  width: 1.25rem;
  height: 1.25rem;
  background: #ffffff;
  border: 2px solid #e8ebf2;
  border-radius: 50%;
}
.radio_animated:checked:before {
  transform: scale(1, 1);
}

a:hover {
  color: #12571a;
}

.btn-popup {
  margin-bottom: 30px;
}

.add-product .bigImg img {
  width: 500px;
}
.add-product ul li {
  display: flex;
  margin-bottom: 15px;
}
.add-product ul li .box-input-file {
  width: 50px;
  height: 50px;
  background-color: #dddddd;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
.add-product ul li .box-input-file .upload {
  position: absolute;
  width: 70px;
  left: 0;
  right: 0;
  opacity: 0;
}

.file-upload-product .uploadImg {
  width: 50px !important;
  height: 50px !important;
}

.dropzone {
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  padding: 50px;
  border: 2px dashed #12571a;
  border-radius: 15px;
  border-image: none;
  background: transparent;
  box-sizing: border-box;
  min-height: 150px;
  position: relative;
}
.dropzone i {
  font-size: 50px;
  color: #12571a;
}
.dropzone .dzu-input {
  border: 1px solid #ddd;
  padding: 6px;
  margin-left: 15px;
}
.dropzone .dzu-previewStatusContainer,
.dropzone .dzu-submitButtonContainer {
  display: none;
}
.dropzone .dzu-previewImage {
  width: 75px;
}

.digital-add .col-form-label {
  font-family: Nunito;
}
.digital-add .form-control {
  font-size: 14px;
}
.digital-add .form-group .radio_animated {
  margin-right: 16px;
}
.digital-add textarea {
  width: 100%;
}

.add-product-form .form-group {
  align-items: center;
}
.add-product-form .form-group label {
  font-size: 16px;
  font-weight: 600;
}
.add-product-form .form-group:last-child {
  align-items: end;
}
.add-product-form .form-group .form-control {
  font-size: 14px;
}
.add-product-form fieldset {
  padding-left: 15px;
  border: none;
}
.add-product-form .qty-box {
  width: 15%;
}
.add-product-form .qty-box .touchspin {
  text-align: center;
}
.add-product-form .qty-box .bootstrap-touchspin-prefix {
  display: none;
}
.add-product-form .qty-box .bootstrap-touchspin-postfix {
  display: none;
}
.add-product-form .qty-box .input-group {
  justify-content: flex-start;
}
.add-product-form .qty-box .input-group button {
  padding: 12px;
}
.add-product-form .qty-box .input-group button i {
  font-weight: 900;
  color: #222222;
}
.add-product-form .qty-box .input-group .btn-primary {
  background-color: transparent !important;
  border: 1px solid #ddd !important;
}
.add-product-form .qty-box .input-group .btn-primary.bootstrap-touchspin-down {
  border-right: none !important;
}
.add-product-form .qty-box .input-group .input-group-append {
  margin-left: 0;
}
.add-product-form .qty-box .input-group .input-group-append .btn {
  border-left: none !important;
}

.chart-block canvas {
  width: 100%;
}

.sales-carousel .value-graph h3, .sales-carousel .value-graph .h3 {
  color: #313131;
  font-weight: 600;
}
.sales-carousel .media .small-box {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.small-chartjs canvas {
  width: 100% !important;
  height: 60px !important;
}

.order-graph h6, .order-graph .h6 {
  color: #313131;
  font-family: Nunito;
  font-weight: 700;
  margin-bottom: 20px;
}
.order-graph .order-graph-bottom {
  margin-top: 30px;
}
.order-graph .order-graph-bottom h6, .order-graph .order-graph-bottom .h6 {
  color: #999;
  margin-left: 15px;
  margin-right: 30px;
}
.order-graph .order-graph-bottom h6 span, .order-graph .order-graph-bottom .h6 span {
  color: #313131;
}
.order-graph .order-graph-bottom .media {
  margin-bottom: 20px;
}
.order-graph .order-graph-bottom .media:last-child {
  margin-bottom: 0;
}
.order-graph .order-graph-bottom .media .order-shape-primary {
  background-color: #12571a;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .media .order-shape-secondary {
  background-color: #13c9ca;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .media .order-shape-success {
  background-color: #81ba00;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .media .order-shape-danger {
  background-color: #a5a5a5;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .media .order-shape-info {
  background-color: #00a8ff;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .media .order-shape-light {
  background-color: #f8f8f9;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .media .order-shape-dark {
  background-color: #2a3142;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .media .order-shape-warning {
  background-color: #ffbc58;
  width: 18px;
  height: 8px;
  margin-top: 7px;
  border-radius: 4px;
}
.order-graph .order-graph-bottom .order-color-primary {
  background-color: #12571a;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}
.order-graph .order-graph-bottom .order-color-secondary {
  background-color: #13c9ca;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}
.order-graph .order-graph-bottom .order-color-success {
  background-color: #81ba00;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}
.order-graph .order-graph-bottom .order-color-danger {
  background-color: #a5a5a5;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}
.order-graph .order-graph-bottom .order-color-info {
  background-color: #00a8ff;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}
.order-graph .order-graph-bottom .order-color-light {
  background-color: #f8f8f9;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}
.order-graph .order-graph-bottom .order-color-dark {
  background-color: #2a3142;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}
.order-graph .order-graph-bottom .order-color-warning {
  background-color: #ffbc58;
  width: 8px;
  height: 8px;
  margin-top: 7px;
  border-radius: 2px;
}

.datepickers-container {
  top: -86px;
}

.datepicker--nav {
  color: #12571a;
}

.datepicker--nav-action {
  color: #12571a;
  background-color: #12571a;
}

.datepicker--nav-action:hover {
  color: #12571a;
}

.datepicker--nav-title i {
  color: #12571a;
}

.table thead th {
  border-bottom: 2px solid #e8ebf2;
}

.authentication-box {
  min-width: 100vw;
  min-height: 100vh;
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.authentication-box .slick-slider {
  margin-bottom: 30px;
}
.authentication-box .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #12571a;
}
.authentication-box .back-btn {
  float: right;
  margin: 0;
  font-size: 14px;
  position: relative;
  padding-left: 60px !important;
}
.authentication-box .back-btn svg {
  position: absolute;
  left: 30px;
  height: 18px;
}
.authentication-box .row {
  align-items: center;
}
.authentication-box .tab2-card .nav-tabs .nav-link {
  font-size: 18px;
}
.authentication-box .tab2-card .nav-tabs .nav-link svg {
  width: 20px;
  vertical-align: sub;
  margin-right: 5px;
}
.authentication-box .form-horizontal .form-terms .custom-control {
  padding-left: 24px;
}
.authentication-box .form-horizontal .form-terms .custom-control span a {
  text-decoration: none;
}
.authentication-box .form-horizontal .form-terms .custom-control span .forgot-pass {
  color: #12571a;
}
.authentication-box .btn-primary {
  border-radius: 25px;
  margin-top: 12px;
  font-weight: 400;
  padding: 11px 45px;
}
.authentication-box .form-footer {
  position: relative;
  padding-top: 25px;
  border-top: 1px solid #f3f3f3;
  margin-top: 25px;
}
.authentication-box .form-footer > span {
  position: absolute;
  top: -11px;
  padding-right: 20px;
  background-color: #fff;
  color: #909090;
}
.authentication-box .form-footer .social {
  margin-bottom: 0;
  border-bottom: 0;
}
.authentication-box .form-footer .social li {
  padding: 10px;
  border-radius: 100%;
  border: 1px solid #12571a;
  height: 40px;
  width: 40px;
  margin-right: 10px;
  text-align: center;
  display: inline-block;
}
.authentication-box .form-footer .social li i {
  font-size: 12px;
}
.authentication-box .slick-dots li.slick-active button:before {
  color: #ffffff;
}
.authentication-box .slick-dots li button:before {
  font-size: 12px;
  color: #ffffff;
}
.authentication-box .container {
  max-width: 900px;
}
.authentication-box .container .bg-primary {
  padding: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-position: center;
  box-shadow: 1px 5px 24px 0 rgba(13, 84, 4, 0.8);
}
.authentication-box .container .form-group {
  margin-bottom: 1.5rem;
}
.authentication-box .container .svg-icon {
  padding: 24px;
  margin: 0 auto;
  border: 2px dashed #ffffff;
  border-radius: 100%;
  height: 130px;
  width: 130px;
  margin-bottom: 40px;
}
.authentication-box .container .svg-icon img {
  width: 100%;
}
.authentication-box .container p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 15px;
  line-height: 2;
  text-align: center;
}
.authentication-box .container h3, .authentication-box .container .h3 {
  color: #ffffff;
  font-weight: 600;
  text-align: center;
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.auth-form .form-control {
  border-radius: 25px;
  padding: 9px 25px;
  border: 1px solid #eaeaea;
}

.switch-sm .switch {
  width: 25px;
  height: 16px;
  margin-top: 10px;
  margin-bottom: 0px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li {
  width: 100%;
}
.page-wrapper .page-body-wrapper footer p {
  line-height: 1.7;
}
.page-wrapper .page-body-wrapper .page-header .row h3, .page-wrapper .page-body-wrapper .page-header .row .h3 {
  color: #000;
}

.widget-cards {
  border-radius: 25px !important;
}

.static-top-widget div.align-self-center svg {
  width: 25px;
  height: 25px;
  vertical-align: middle;
}
.static-top-widget .media-body {
  align-self: center !important;
}
.static-top-widget .media-body h3, .static-top-widget .media-body .h3 {
  font-family: work-Sans, sans-serif;
  color: #ffffff;
}
.static-top-widget .media-body h3 small, .static-top-widget .media-body .h3 small, .static-top-widget .media-body h3 .small, .static-top-widget .media-body .h3 .small {
  font-size: 11px;
}
.static-top-widget .icons-widgets .text-center {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flot-chart-container {
  height: 400px;
}

.user-status table tbody tr td {
  vertical-align: middle;
  padding: 12px;
  border-top: 1px solid #dee2e6;
}
.user-status table tbody tr td .d-inline-block {
  margin-top: 11px;
}
.user-status table tbody tr td .image-sm-size img {
  width: 41px;
}
.user-status table tbody tr:last-child td {
  padding-bottom: 0;
  border-bottom: 0;
}
.user-status table thead tr th {
  border-top: 0;
  font-size: 16px;
  color: #2a3142;
  font-weight: 600;
  padding: 0 12px 12px;
}

.card-block .table-responsive .table caption {
  padding-left: 10px;
}
.card-block .table-responsive .table-bordered td {
  vertical-align: middle;
}
.card-block .table-border-radius {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.products-admin .product-box {
  padding: 20px;
}
.products-admin .product-box .img-wrapper {
  position: relative;
}
.products-admin .product-box .lable-block .lable3 {
  border-radius: 100%;
  background-color: #12571a;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  position: absolute;
  padding: 12px 6px;
  text-transform: uppercase;
  color: #ffffff;
  top: 7px;
  left: 7px;
  z-index: 1;
}
.products-admin .product-box .lable-block .lable4 {
  position: absolute;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  writing-mode: vertical-rl;
  transform: rotate(-180deg);
  top: 7px;
  right: 7px;
  letter-spacing: 0.1em;
  z-index: 1;
}
.products-admin .product-box .product-detail .rating {
  margin-top: 15px !important;
}
.products-admin .product-box .product-detail .rating i {
  padding-right: 5px;
}
.products-admin .product-box .product-detail .rating i:nth-child(-n+4) {
  color: #ffa200;
}
.products-admin .product-box .product-detail .rating i:last-child {
  color: #ffa200;
}
.products-admin .product-box .product-detail a {
  text-decoration: none;
}
.products-admin .product-box .product-detail h6, .products-admin .product-box .product-detail .h6 {
  line-height: 1;
  margin-bottom: 0;
  padding-top: 2px;
  padding-bottom: 5px;
  transition: all 0.5s ease;
  font-size: 16px;
  color: #777777;
}
.products-admin .product-box .product-detail h4, .products-admin .product-box .product-detail .h4 {
  font-size: 18px;
  color: #222222;
  font-weight: 700;
  margin-bottom: 0;
  transition: all 0.5s ease;
  color: #222222 !important;
}
.products-admin .product-box .product-detail del {
  font-size: 14px;
  color: #aaaaaa;
  font-weight: 400;
}
.products-admin .product-box .product-detail .color-variant {
  padding-top: 15px;
}
.products-admin .product-box .product-detail .color-variant li {
  display: inline-block;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  margin-right: 5px;
  transition: all 0.1s ease;
  cursor: pointer;
}
.products-admin .product-box .front {
  position: relative;
}
.products-admin .product-box .front .product-hover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  opacity: 0;
  border-radius: 100%;
  transform: scale(0);
  transition: all 0.3s ease;
}
.products-admin .product-box .front .product-hover ul li {
  display: inline-block;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);
  padding: 9px 14px;
  background-color: #ffffff;
  font-size: 18px;
  border-radius: 100%;
  line-height: 1.6;
  height: 45px;
  width: 45px;
  margin: 0 3px;
}
.products-admin .product-box .front .product-hover ul li .btn {
  padding: 0;
  background-color: transparent;
}
.products-admin .product-box .front .product-hover ul li .btn .editBtn {
  width: 18px;
}
.products-admin .product-box .front .product-hover ul li .btn svg {
  stroke-width: 1;
}
.products-admin .product-box .front .product-hover ul li .btn .deleteBtn {
  width: 19px;
  margin-top: 0;
  margin-left: -2px;
}
.products-admin .product-box .front:hover .product-hover {
  opacity: 1;
  border-radius: 0%;
  transform: scale(1);
  transition: all 0.3s ease;
}

.size-modal.modal-dialog .modal-header {
  align-items: flex-start;
}

.product-right .timer {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 40px;
  display: inline-block;
  margin-top: 10px;
  background-color: #f7f7f7;
}
.product-right .timer p {
  color: #222222;
  font-size: 18px;
}
.product-right .timer span {
  width: 70px;
  display: inline-block;
}
.product-right .timer span .padding-l {
  padding-left: 22px;
  display: inline;
}
.product-right .timer .timer-cal {
  font-size: 12px;
  color: #777777;
}
.product-right .size-box {
  margin-top: 10px;
  margin-bottom: 10px;
}
.product-right .size-box ul li {
  height: 35px;
  width: 35px;
  border-radius: 50%;
  margin-right: 10px;
  cursor: pointer;
  border: 1px solid #f7f7f7;
  text-align: center;
  display: inline-block;
}
.product-right .size-box ul li.active {
  background-color: #f7f7f7 !important;
}
.product-right .size-box ul li a {
  color: #222222 !important;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-decoration: none;
}
.product-right .color-variant {
  margin-bottom: 10px !important;
}
.product-right .color-variant li {
  height: 30px;
  width: 30px;
  cursor: pointer;
  display: inline-block;
  border-radius: 100%;
  margin-right: 5px;
  transition: all 0.1s ease;
  vertical-align: middle;
}
.product-right .product-title {
  color: #222222;
  text-transform: capitalize;
  font-weight: 700;
  margin-bottom: 0;
}
.product-right .product-title a {
  color: #12571a !important;
  text-decoration: none;
}
.product-right .product-title p {
  margin-bottom: 0;
  line-height: 1.5em;
}
.product-right .product-title h3, .product-right .product-title .h3 {
  font-size: 26px;
  color: #222222;
  margin-bottom: 15px;
}
.product-right h2, .product-right .h2 {
  text-transform: uppercase;
  margin-bottom: 15px;
  font-size: 25px;
  line-height: 1.2em;
}

.bg-light0 {
  background-color: #d0edff;
}

.bg-light1 {
  background-color: #f1e7e6;
}

.bg-light2 {
  background-color: #bfbfbf;
}

.react-tabs .nav-tabs .nav-link {
  color: #333333;
  transition: 0.3s;
  cursor: pointer;
}
.react-tabs .nav-tabs .nav-link.react-tabs__tab--selected, .react-tabs .nav-tabs .nav-link:hover, .react-tabs .nav-tabs .nav-link:focus {
  border-color: transparent transparent transparent !important;
  border-bottom: 2px solid #12571a !important;
  color: #12571a;
  outline: transparent;
}

.deactivate-account {
  margin-top: 30px;
}
.deactivate-account .btn {
  margin-top: 20px;
}

.account-setting h5, .account-setting .h5 {
  margin-bottom: 20px;
}

.profile-card ul {
  margin-bottom: 30px;
  border-bottom: 1px solid #dee2e6;
}
.profile-card ul li svg {
  width: 18px;
  vertical-align: middle;
}

.profile-details img {
  margin-bottom: 20px;
}
.profile-details .social {
  margin-top: 15px;
}
.profile-details .social .btn-showcase {
  margin-bottom: -10px;
}
.profile-details .social .btn-showcase .btn {
  padding: 8px 13px;
  margin: 0 5px 20px;
  border-radius: 100%;
  width: 40px;
  height: 40px;
}
.profile-details .social .btn-showcase .btn-fb {
  background-color: #50598e;
  color: #ffffff;
}
.profile-details .social .btn-showcase .btn-google {
  background-color: #c64e40;
  color: #ffffff;
}
.profile-details .social .btn-showcase .btn-twitter {
  background-color: #6fa2d8;
  color: #ffffff;
}

.project-status {
  margin-top: 20px;
}
.project-status .media {
  margin-top: 20px;
}

.sm-progress-bar {
  height: 6px;
}

.profile-table table tbody tr td {
  padding: 12px;
  border-bottom: 0;
}
.profile-table table tbody tr td:first-child {
  width: 250px;
}
.profile-table table th,
.profile-table table td {
  border-top: none;
}

.report-employee .card-header {
  border-bottom: none !important;
}
.report-employee .flot-chart-container {
  height: 323px;
}

.sales-chart {
  height: 307px;
}

.expense-chart #area-chart1 {
  height: 307px;
}

.profile-card .media {
  align-items: center;
}
.profile-card .media img {
  margin-right: 20px;
}

.dropzone .dz-preview {
  box-shadow: 0px 0px 3px #12571a;
}
.dropzone .dz-preview .dz-error-message {
  color: #12571a !important;
  background: transparent !important;
  border: 1px solid #12571a !important;
}
.dropzone .dz-preview .dz-error-message:after {
  border-bottom: 6px solid #12571a !important;
}

.tab-coupon {
  margin-bottom: 30px;
}

.needs-validation .permission-block .attribute-blocks {
  padding-left: 15px;
}
.needs-validation .permission-block .attribute-blocks .row {
  padding-left: 20px;
}
.needs-validation .permission-block .attribute-blocks + .attribute-blocks h5, .needs-validation .permission-block .attribute-blocks + .attribute-blocks .h5 {
  margin-top: 30px;
}
.needs-validation .permission-block .attribute-blocks h6, .needs-validation .permission-block .attribute-blocks .h6 {
  border-bottom: 1px solid #eff0f1;
  margin-bottom: 15px;
  padding-bottom: 5px;
}
.needs-validation h4, .needs-validation .h4 {
  font-weight: 600;
  margin-bottom: 20px;
}
.needs-validation input {
  font-size: 14px;
}
.needs-validation .form-group {
  align-items: center;
}
.needs-validation .form-group label {
  margin-bottom: 0;
}
.needs-validation .form-group label span {
  color: red;
}
.needs-validation .form-group .checkbox {
  padding-left: 0;
}
.needs-validation .editor-label {
  align-items: end;
}
.needs-validation .editor-space {
  padding: 0;
}
.needs-validation .checkbox input {
  opacity: 0;
}
.needs-validation .checkbox label {
  display: inline-block;
  position: relative;
  padding-left: 16px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
}
.needs-validation .checkbox label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  left: 0;
  margin-left: -16px;
  border: 1px solid #e8ebf2;
  border-radius: 3px;
  background-color: #fff;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}
.needs-validation .checkbox input[type=checkbox]:checked + label::before {
  font-family: IcoFont;
  content: "\\efab";
  text-align: center;
  line-height: 1;
  font-size: 18px;
}
.needs-validation .checkbox-primary input[type=checkbox]:checked + label::before {
  border-color: #12571a;
  color: #12571a;
}
.needs-validation .radio-animated label {
  margin-right: 20px;
}
.needs-validation textarea {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.badge-warning {
  color: #ffffff;
}

.user-list img {
  border-radius: 100%;
}

/**=====================
  Admin CSS Ends
==========================**/
/**=====================
      Button CSS start
==========================**/
.btn {
  font-size: 14px;
  padding: 0.5rem 1.5rem;
  border-radius: 5px;
  letter-spacing: 1px;
  line-height: 20px;
  text-transform: uppercase;
  font-weight: 700;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 18px;
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 12px;
}

.btn-xs {
  padding: 0.05rem 0.4rem;
  font-size: 11px;
}

.large-btn {
  margin-bottom: -20px;
}
.large-btn .btn {
  margin-right: 5px;
  margin-bottom: 15px;
}

.input-air-primary {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-primary:focus {
  border-color: #12571a;
}

.input-air-secondary {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-secondary:focus {
  border-color: #13c9ca;
}

.input-air-success {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-success:focus {
  border-color: #81ba00;
}

.input-air-danger {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-danger:focus {
  border-color: #a5a5a5;
}

.input-air-info {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-info:focus {
  border-color: #00a8ff;
}

.input-air-light {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-light:focus {
  border-color: #f8f8f9;
}

.input-air-dark {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-dark:focus {
  border-color: #2a3142;
}

.input-air-warning {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}
.input-air-warning:focus {
  border-color: #ffbc58;
}

.form-bg-primary {
  background: #12571a;
  border-color: #12571a;
  color: #ffffff;
}
.form-bg-primary:focus {
  border-color: #12571a;
  background: #12571a;
  color: #ffffff;
}
.form-bg-primary:focus:active {
  border-color: #12571a;
  background: #12571a;
  color: #ffffff;
}

.form-bg-secondary {
  background: #13c9ca;
  border-color: #13c9ca;
  color: #ffffff;
}
.form-bg-secondary:focus {
  border-color: #13c9ca;
  background: #13c9ca;
  color: #ffffff;
}
.form-bg-secondary:focus:active {
  border-color: #13c9ca;
  background: #13c9ca;
  color: #ffffff;
}

.form-bg-success {
  background: #81ba00;
  border-color: #81ba00;
  color: #ffffff;
}
.form-bg-success:focus {
  border-color: #81ba00;
  background: #81ba00;
  color: #ffffff;
}
.form-bg-success:focus:active {
  border-color: #81ba00;
  background: #81ba00;
  color: #ffffff;
}

.form-bg-danger {
  background: #a5a5a5;
  border-color: #a5a5a5;
  color: #ffffff;
}
.form-bg-danger:focus {
  border-color: #a5a5a5;
  background: #a5a5a5;
  color: #ffffff;
}
.form-bg-danger:focus:active {
  border-color: #a5a5a5;
  background: #a5a5a5;
  color: #ffffff;
}

.form-bg-info {
  background: #00a8ff;
  border-color: #00a8ff;
  color: #ffffff;
}
.form-bg-info:focus {
  border-color: #00a8ff;
  background: #00a8ff;
  color: #ffffff;
}
.form-bg-info:focus:active {
  border-color: #00a8ff;
  background: #00a8ff;
  color: #ffffff;
}

.form-bg-light {
  background: #f8f8f9;
  border-color: #f8f8f9;
  color: #2a3142;
}
.form-bg-light:focus {
  border-color: #f8f8f9;
  background: #f8f8f9;
  color: #2a3142;
}
.form-bg-light:focus:active {
  border-color: #f8f8f9;
  background: #f8f8f9;
  color: #2a3142;
}

.form-bg-dark {
  background: #2a3142;
  border-color: #2a3142;
  color: #ffffff;
}
.form-bg-dark:focus {
  border-color: #2a3142;
  background: #2a3142;
  color: #ffffff;
}
.form-bg-dark:focus:active {
  border-color: #2a3142;
  background: #2a3142;
  color: #ffffff;
}

.form-bg-warning {
  background: #ffbc58;
  border-color: #ffbc58;
  color: #ffffff;
}
.form-bg-warning:focus {
  border-color: #ffbc58;
  background: #ffbc58;
  color: #ffffff;
}
.form-bg-warning:focus:active {
  border-color: #ffbc58;
  background: #ffbc58;
  color: #ffffff;
}

.btn-warning {
  color: #ffffff;
}
.btn-warning:hover, .btn-warning.disabled {
  color: #ffffff;
}

.btn-primary-gradien {
  background-image: linear-gradient(to right, #197924 0%, #0b3510 51%, #197924 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-primary-gradien:focus, .btn-primary-gradien:active, .btn-primary-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #197924, 0%, #0b3510, 100%, #ffffff) !important;
}

.btn-secondary-gradien {
  background-image: linear-gradient(to right, #1ce9ea 0%, #0fa4a5 51%, #1ce9ea 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-secondary-gradien:hover, .btn-secondary-gradien:focus, .btn-secondary-gradien:active, .btn-secondary-gradien.active, .btn-secondary-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #1ce9ea, 0%, #0fa4a5, 100%, #ffffff) !important;
}

.btn-success-gradien {
  background-image: linear-gradient(to right, #9de300 0%, #659100 51%, #9de300 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-success-gradien:hover, .btn-success-gradien:focus, .btn-success-gradien:active, .btn-success-gradien.active, .btn-success-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #9de300, 0%, #659100, 100%, #ffffff) !important;
}

.btn-danger-gradien {
  background-image: linear-gradient(to right, #b9b9b9 0%, #919191 51%, #b9b9b9 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-danger-gradien:hover, .btn-danger-gradien:focus, .btn-danger-gradien:active, .btn-danger-gradien.active, .btn-danger-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #b9b9b9, 0%, #919191, 100%, #ffffff) !important;
}

.btn-warning-gradien {
  background-image: linear-gradient(to right, #ffcc81 0%, #ffac2f 51%, #ffcc81 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-warning-gradien:hover, .btn-warning-gradien:focus, .btn-warning-gradien:active, .btn-warning-gradien.active, .btn-warning-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #ffcc81, 0%, #ffac2f, 100%, #ffffff) !important;
}

.btn-info-gradien {
  background-image: linear-gradient(to right, #29b6ff 0%, #008dd6 51%, #29b6ff 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-info-gradien:hover, .btn-info-gradien:focus, .btn-info-gradien:active, .btn-info-gradien.active, .btn-info-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #29b6ff, 0%, #008dd6, 100%, #ffffff) !important;
}

.btn-light {
  margin-left: 7px;
}

.btn-light-gradien {
  background-image: linear-gradient(to right, white 0%, #e2e2e6 51%, white 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-light-gradien:hover, .btn-light-gradien:focus, .btn-light-gradien:active, .btn-light-gradien.active, .btn-light-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, white, 0%, #e2e2e6, 100%, #ffffff) !important;
}

.btn-dark-gradien {
  background-image: linear-gradient(to right, #3a445b 0%, #1a1e29 51%, #3a445b 100%);
  border: none;
  color: #ffffff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}
.btn-dark-gradien:hover, .btn-dark-gradien:focus, .btn-dark-gradien:active, .btn-dark-gradien.active, .btn-dark-gradien.hover {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #3a445b, 0%, #1a1e29, 100%, #ffffff) !important;
}

[class*=-gradien]:hover {
  background-size: 50% 100%;
  transition: all 0.3s ease;
  color: #ffffff;
}

/**=====================
 Button CSS end
==========================**/
/**=====================
      Card CSS Start
==========================**/
.card {
  margin-bottom: 30px;
  border: 0px;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  border-radius: 8px;
  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);
}
.card .card-header {
  background-color: #ffffff;
  border-bottom: none;
  padding: 30px;
  border-bottom: 1px solid #f8f8f9;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.card .card-header h5, .card .card-header .h5 {
  font-size: 18px;
  margin-bottom: 0;
  text-transform: capitalize;
  font-weight: 600;
  line-height: 24px;
}
.card .card-header > span {
  font-size: 12px;
  color: #777777;
  margin-top: 5px;
  display: block;
  letter-spacing: 1px;
}
.card .card-body {
  padding: 30px;
  background-color: transparent;
}
.card .card-body p:last-child {
  margin-bottom: 0;
}
.card .sub-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
  margin-bottom: 8px;
  font-size: 18px;
}
.card .card-footer {
  background-color: #ffffff;
  border-top: 1px solid #f8f8f9;
  padding: 30px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.card-header .nav-material {
  margin-bottom: -13px;
}

/**=====================
     Card CSS End
==========================**/
/**=====================
      Footer CSS Start
==========================**/
footer {
  background-color: #ffffff;
  border-top: 1px solid #f8f8f9;
  padding: 15px;
  bottom: 0;
  left: 0;
}
footer a {
  font-weight: 600;
}

.page-wrapper .page-body-wrapper footer {
  margin-left: 255px;
  transition: all 0.3s ease;
  bottom: 0;
  z-index: 8;
}
.page-wrapper .page-body-wrapper footer p {
  color: rgb(165, 165, 165);
}
.page-wrapper .page-body-wrapper footer p i {
  color: #a5a5a5;
  margin-left: 5px;
}

/**=====================
      Footer CSS Ends
==========================**/
/**=====================
      General CSS Start
==========================**/
h1, .h1 {
  font-size: 60px;
  color: #222222;
  font-weight: 700;
  text-transform: uppercase;
}
h1 span, .h1 span {
  font-size: 107px;
  font-weight: 700;
  color: #12571a;
}

h2, .h2 {
  font-size: 36px;
  text-transform: uppercase;
  font-weight: 700;
  color: #000000;
  line-height: 1;
  letter-spacing: 0.02em;
}

h3, .h3 {
  font-size: 24px;
  font-weight: 400;
  color: #777777;
  letter-spacing: 0.03em;
}

h4, .h4 {
  font-size: 18px;
  text-transform: capitalize;
  font-weight: 400;
  letter-spacing: 0.03em;
  line-height: 1;
}

del {
  font-size: 14px;
  color: #aaaaaa;
  font-weight: 400;
}

h5, .h5 {
  font-size: 16px;
  font-weight: 400;
  color: #222222;
  line-height: 24px;
  letter-spacing: 0.05em;
}

h6, .h6 {
  font-size: 14px;
  font-weight: 400;
  color: #777777;
  line-height: 24px;
}

body {
  background-color: rgba(246, 246, 246, 0.6);
  font-size: 14px;
  overflow-x: hidden;
  font-family: work-Sans, sans-serif;
  color: #313131;
  position: relative;
}

ul {
  padding-left: 0px;
  list-style-type: none;
  margin-bottom: 0;
  padding-right: 0px;
}

li {
  display: inline-block;
}

* a {
  color: #12571a;
}

*.btn:focus {
  box-shadow: none !important;
}

p {
  color: #777777;
  font-size: 13px;
  line-height: 1.7;
  letter-spacing: 0.7px;
}

code {
  color: #12571a !important;
  background-color: #f8f8f9;
  padding: 3px;
  margin: 0 3px;
  border-radius: 2px;
}

a {
  transition: 0.5s ease;
}
a:hover {
  text-decoration: none;
  transition: 0.5s ease;
}
a:focus {
  outline: none;
}

button:focus {
  outline: none;
}

:focus {
  outline-color: #12571a;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

svg {
  vertical-align: baseline;
}

input:focus {
  outline-color: transparent;
}

.txt-dark {
  color: #1b252a !important;
}

.txt-success {
  color: #81ba00 !important;
}

.txt-danger {
  color: #a5a5a5 !important;
}

/**=====================
      General CSS Ends
==========================**/
/**=====================
    Header CSS Start
==========================**/
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li.active > a, .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li:hover > a {
  color: #313131;
  border-left-color: #2a3142;
  transition: 0.3s;
}

.onhover-show-div {
  box-shadow: 0 0 2px 2px #f8f8f9;
  transform: translateY(30px);
  opacity: 0;
  visibility: hidden;
  left: 0;
}

.nav-menus .onhover-dropdown:hover .onhover-show-div {
  opacity: 1;
  transform: translateY(0px);
  visibility: visible;
}
.nav-menus .onhover-dropdown:hover .onhover-show-div:before {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ffffff;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 2;
}
.nav-menus .onhover-dropdown:hover .onhover-show-div:after {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #898989;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 1;
}

/*======= Page Header css Start ======= */
.page-wrapper .page-main-header {
  background-color: #ffffff;
  height: 80px;
  position: fixed;
  top: 0;
  z-index: 10;
  box-shadow: 0 0 10px 1px rgba(68, 102, 242, 0.05);
  width: calc(100% - 255px);
  display: flex;
  align-items: center;
  margin-left: 255px;
  transition: 0.3s;
}
.page-wrapper .page-main-header.open {
  margin-left: 0;
  width: 100%;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-body {
  min-height: calc(100vh - 80px);
  margin-top: 80px;
  padding: 0 15px;
  position: relative;
  background-color: #f8f8f9;
}
.page-wrapper .page-body-wrapper .page-header {
  padding-top: 30px;
  padding-bottom: 30px;
}
.page-wrapper .page-body-wrapper .page-header .row {
  align-items: center;
}
.page-wrapper .page-body-wrapper .page-header .row .page-header-left {
  display: flex;
  align-items: center;
}
.page-wrapper .page-body-wrapper .page-header .row h3, .page-wrapper .page-body-wrapper .page-header .row .h3 {
  font-size: 24px;
  margin-bottom: 0;
  font-weight: 800;
  text-transform: uppercase;
  font-family: Nunito;
}
.page-wrapper .page-body-wrapper .page-header .row h3 small, .page-wrapper .page-body-wrapper .page-header .row .h3 small, .page-wrapper .page-body-wrapper .page-header .row h3 .small, .page-wrapper .page-body-wrapper .page-header .row .h3 .small {
  display: block;
  font-size: 12px;
  margin-top: 7px;
  letter-spacing: 1px;
  text-transform: capitalize;
  color: #777777;
  font-weight: 400;
}
.page-wrapper .page-body-wrapper .page-header .breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 0;
}
.page-wrapper .page-body-wrapper .page-header .breadcrumb .breadcrumb-item {
  font-family: Nunito;
}
.page-wrapper .page-body-wrapper .page-header .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
  content: "/";
}
.page-wrapper .page-body-wrapper .page-header .breadcrumb .breadcrumb-item a svg {
  width: 14px;
  height: 14px;
  vertical-align: text-top;
}

/*======= Page Header css ends  ======= */
/**======Main Header css Start ======**/
.page-main-header {
  max-width: 100vw;
}
.page-main-header .main-header-right {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  margin: 0;
}
.page-main-header .main-header-right svg {
  color: #12571a;
}
.page-main-header .main-header-right svg line,
.page-main-header .main-header-right svg polyline {
  color: #12571a;
}
.page-main-header .main-header-right .nav-left i {
  margin-right: 20px;
}
.page-main-header .main-header-right .nav-left input:focus {
  outline: 0 !important;
}
.page-main-header .main-header-right .nav-right {
  text-align: right;
  padding-left: 0px;
}
.page-main-header .main-header-right .nav-right ul li .media .dotted-animation {
  position: relative;
  right: -3px;
  top: -7px;
}
.page-main-header .main-header-right .nav-right ul li .media .dotted-animation .animate-circle {
  position: absolute;
  top: -20px;
  right: -4px;
  height: 25px;
  width: 25px;
  z-index: 10;
  border: 5px solid #12571a;
  border-radius: 70px;
  animation: heartbit 1s ease-out;
  animation-iteration-count: infinite;
}
.page-main-header .main-header-right .nav-right ul li .media .dotted-animation .main-circle {
  width: 6px;
  height: 6px;
  border-radius: 30px;
  background-color: #12571a;
  position: absolute;
  right: 6px;
  top: -10px;
}
.page-main-header .main-header-right .nav-right ul li svg {
  margin-top: 10px;
  width: 18px;
  height: 18px;
}
.page-main-header .main-header-right .nav-right ul li svg path {
  color: #12571a;
}
.page-main-header .main-header-right .nav-right ul li .dot {
  width: 3px;
  height: 3px;
  border-radius: 30px;
  background-color: #12571a;
  position: absolute;
  right: 17px;
  bottom: 6px;
  animation: blink 1.5s infinite;
}
.page-main-header .main-header-right .nav-right ul li .dot-chat {
  right: 4px;
  bottom: -11px;
}
.page-main-header .main-header-right .nav-right .notification {
  position: absolute;
  top: 21px;
  right: -1px;
  font-size: 9px;
  animation: blink 1.5s infinite;
}
@keyframes blink {
  0% {
    opacity: 1;
  }
  70% {
    opacity: 1;
  }
  80% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.page-main-header .main-header-right .nav-right .icon-user {
  font-size: 16px;
}
@keyframes heartbit {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  25% {
    transform: scale(0.1);
    opacity: 0.1;
  }
  50% {
    transform: scale(0.5);
    opacity: 0.3;
  }
  75% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.page-main-header .main-header-right .nav-right > ul {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.page-main-header .main-header-right .nav-right > ul > li {
  position: relative;
  border-left: 1px solid #eff0f1;
  padding: 0 20px;
}
.page-main-header .main-header-right .nav-right > ul > li:first-child {
  width: 25%;
  border-left: none;
}
.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group {
  width: 100%;
  position: relative;
}
.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:focus {
  outline-color: transparent;
}
.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group input:focus {
  outline-color: transparent;
  box-shadow: none;
}
.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:before {
  position: absolute;
  content: "";
  width: 1px;
  height: 25px;
  background: #e8ebf2;
  left: 51px;
  top: 11px;
}
.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:after {
  position: absolute;
  content: "\\f002";
  font-family: FontAwesome;
  top: 12px;
  left: 22px;
  color: #8e8e8e;
}
.page-main-header .main-header-right .nav-right > ul > li:last-child {
  border-left: none;
  padding-right: 0;
}
.page-main-header .main-header-right .nav-right > ul > li:nth-child(5) {
  border-left: none;
  border-right: 1px solid #eff0f1;
  padding-left: 0;
}
.page-main-header .main-header-right .nav-right > ul > li a.txt-dark {
  text-decoration: none;
}
.page-main-header .main-header-right .nav-right > ul > li h6, .page-main-header .main-header-right .nav-right > ul > li .h6 {
  margin-top: 4px;
  margin-bottom: 4px;
  color: #12571a;
}
.page-main-header .main-header-right .nav-right > ul > li h6 ul, .page-main-header .main-header-right .nav-right > ul > li .h6 ul {
  left: inherit;
  right: -10px;
  width: 130px;
}
.page-main-header .main-header-right .nav-right > ul > li h6 ul:before, .page-main-header .main-header-right .nav-right > ul > li .h6 ul:before, .page-main-header .main-header-right .nav-right > ul > li h6 ul:after, .page-main-header .main-header-right .nav-right > ul > li .h6 ul:after {
  left: inherit;
  right: 10px;
}
.page-main-header .main-header-right .nav-right > ul > li h6 ul li, .page-main-header .main-header-right .nav-right > ul > li .h6 ul li {
  display: block;
}
.page-main-header .main-header-right .nav-right > ul > li h6 ul li a, .page-main-header .main-header-right .nav-right > ul > li .h6 ul li a {
  font-size: 14px;
  color: #2a3142;
}
.page-main-header .main-header-right .nav-right > ul > li h6 ul li a i, .page-main-header .main-header-right .nav-right > ul > li .h6 ul li a i {
  margin-left: 10px;
  font-size: 13px;
  color: #2a3142;
}
.page-main-header .main-header-right .nav-right > ul .flag-icon {
  font-size: 16px;
}
.page-main-header .main-header-right .nav-right .notification-dropdown {
  top: 57px;
}
.page-main-header .main-header-right .nav-right .language-dropdown {
  width: 160px;
  text-align: left;
  top: 57px;
}
.page-main-header .main-header-right .nav-right .language-dropdown li {
  padding-top: 10px;
}
.page-main-header .main-header-right .nav-right .language-dropdown li a {
  color: #2a3142;
  text-decoration: none;
}
.page-main-header .main-header-right .nav-right .language-dropdown li a i {
  margin-right: 10px;
}
.page-main-header .main-header-right .nav-right .language-dropdown li:first-child {
  padding-top: 0;
}
.page-main-header .main-header-right .nav-right .profile-dropdown {
  right: -10px;
  left: inherit;
  width: 150px;
  top: 63px;
}
.page-main-header .main-header-right .nav-right .profile-dropdown:before, .page-main-header .main-header-right .nav-right .profile-dropdown:after {
  left: inherit;
  right: 10px;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li {
  display: block;
  text-align: left;
  padding-top: 10px;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li:nth-child(3) {
  padding-bottom: 10px;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li:nth-child(4) {
  border-top: 1px solid #eff0f1;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li:first-child {
  padding-top: 0;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a {
  color: #12571a;
  transition: 0.3s;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg {
  color: #12571a !important;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg path,
.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg line,
.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg polyline {
  color: #12571a !important;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li a {
  color: #313131;
  transition: 0.3s;
  display: flex;
  align-items: center;
  text-decoration: none;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li a svg {
  margin-right: 10px;
  color: #313131;
}
.page-main-header .main-header-right .nav-right .profile-dropdown li a svg polyline {
  color: #313131;
}
.page-main-header .main-header-right li {
  display: inline-block;
  position: relative;
}

.nav-menus .notification-badge {
  position: absolute;
  right: 10px;
  top: 1px;
  padding: 4px 7px;
}
.nav-menus .onhover-dropdown {
  cursor: pointer;
  position: relative;
}
.nav-menus .onhover-dropdown:before {
  display: none;
}
.nav-menus .search-form input {
  border: 1px solid #eff0f1;
  padding: 10px 10px 10px 70px;
  border-radius: 50px;
  background-color: #f8f8f9;
  font-size: 14px;
}

ul.notification-dropdown.onhover-show-div {
  width: 330px;
  right: -18px;
  left: initial;
}
ul.notification-dropdown.onhover-show-div:before, ul.notification-dropdown.onhover-show-div:after {
  left: inherit !important;
  right: 35px !important;
}
ul.notification-dropdown.onhover-show-div li {
  display: block;
  padding: 12px 20px;
  border-bottom: 1px solid #f8f8f9;
  text-align: left;
}
ul.notification-dropdown.onhover-show-div li a {
  text-decoration: none;
}
ul.notification-dropdown.onhover-show-div li h6 small, ul.notification-dropdown.onhover-show-div li .h6 small, ul.notification-dropdown.onhover-show-div li h6 .small, ul.notification-dropdown.onhover-show-div li .h6 .small {
  padding-top: 5px;
  color: #898989;
  font-size: 12px;
}
ul.notification-dropdown.onhover-show-div li span svg {
  margin-top: 0 !important;
  margin-right: 10px;
  vertical-align: text-top;
}
ul.notification-dropdown.onhover-show-div li span .shopping-color path,
ul.notification-dropdown.onhover-show-div li span .shopping-color line {
  color: #12571a;
}
ul.notification-dropdown.onhover-show-div li span .download-color path,
ul.notification-dropdown.onhover-show-div li span .download-color line {
  color: #81ba00;
}
ul.notification-dropdown.onhover-show-div li span .alert-color path,
ul.notification-dropdown.onhover-show-div li span .alert-color line {
  color: #a5a5a5;
}
ul.notification-dropdown.onhover-show-div li p {
  margin-left: 30px;
}
ul.notification-dropdown.onhover-show-div li + li:hover {
  background-color: #f8f8f9;
}

.onhover-show-div {
  top: 80px;
  position: absolute;
  z-index: 8;
  background-color: #ffffff;
  transition: all linear 0.3s;
}
.onhover-show-div li a svg {
  margin-top: 0 !important;
}
.onhover-show-div li a svg path,
.onhover-show-div li a svg line {
  color: #313131 !important;
}

/**======Main Header css Ends ======**/
/**=====================
    Sidebar CSS Start
==========================**/
.page-wrapper .page-body-wrapper .sidebar {
  height: calc(100vh - 80px);
  overflow: auto;
  box-shadow: 0 0 11px rgba(143, 164, 232, 0.08);
}
.page-wrapper .page-body-wrapper .page-sidebar {
  width: 255px;
  position: fixed;
  background: #ffffff;
  top: 0;
  height: 100vh;
  z-index: 9;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .main-header-left {
  display: inline-flex;
  width: 100%;
  height: 80px;
  padding: 12px;
  align-items: center;
  background-color: transparent;
  z-index: 10;
  box-shadow: -3px 1px 3px 1px rgba(68, 102, 242, 0.1);
}
.page-wrapper .page-body-wrapper .page-sidebar .main-header-left .logo-wrapper {
  padding-left: 10px;
  height: 100%;
  display: flex;
  align-items: center;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {
  padding: 25px 10px;
  box-shadow: 3px 2px 7px -1px rgba(127, 151, 249, 0.13);
  position: relative;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6, .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .h6 {
  color: #12571a;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1.5px;
  margin-bottom: 3px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 10px;
  margin-bottom: 0px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user img {
  box-shadow: 0 0 15px rgba(68, 102, 242, 0.3);
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {
  list-style: none;
  margin: 0;
  padding: 20px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {
  font-size: 14px;
  letter-spacing: 0.5px;
  padding-bottom: 12px;
  padding-top: 12px;
  text-transform: capitalize;
  font-weight: 600;
  color: #313131;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header svg {
  width: 14px;
  height: 14px;
  margin-right: 14px;
  stroke-width: 3px;
  vertical-align: text-bottom;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu.menu-open li.active .fa-angle-down:before {
  content: "\\f104";
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a {
  display: block;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.active {
  color: #12571a;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a:hover {
  color: #12571a;
  padding-left: 3px;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i {
  margin-right: 7px;
  text-align: right;
  margin-top: 3px;
  font-size: 15px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i:before {
  content: "\\f105";
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i ~ i {
  margin-right: 0;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li .label {
  margin-top: 3px;
  margin-right: 5px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li .badge {
  margin-left: 50px;
  text-transform: capitalize;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {
  margin-bottom: 0;
  padding: 15px;
  color: #313131;
  font-weight: 600;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li > a > .fa-angle-down {
  width: auto;
  height: auto;
  padding: 0;
  margin-right: 10px;
  margin-top: 10px;
  transform: rotate(-90deg);
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > a > .fa-angle-right:before {
  content: "\\f107";
  font-family: FontAwesome;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > .sidebar-submenu {
  display: block;
  transform: rotateX(0deg);
  transform-origin: 10% 10%;
  transition: transform 0.3s, opacity 0.3s;
  transform-style: preserve-3d;
  margin-left: 25px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > .sidebar-submenu a i.pull-right {
  margin-top: 10px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {
  text-decoration: none;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu {
  display: none;
  transform-style: preserve-3d;
  transform: rotateX(-90deg);
  list-style: none;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu .sidebar-submenu {
  padding-top: 0 !important;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a {
  padding-bottom: 7px;
  padding-top: 7px;
  font-size: 14px;
  color: #898989;
  transition: 0.3s;
  text-transform: capitalize;
  position: relative;
  padding-left: 10px;
  line-height: 2.5;
  letter-spacing: 0.7px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > .fa-circle {
  width: 12px;
  font-size: 4px;
  position: absolute;
  left: 0;
  top: 13px;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > i {
  width: auto;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > .fa-angle-down {
  width: auto;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a:hover {
  color: #12571a;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a.active {
  color: #12571a;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li.active > a {
  color: #313131;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li.active > a.active {
  color: #12571a;
}
.page-wrapper .page-body-wrapper .page-sidebar ~ .page-body {
  margin-left: 255px;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar.open {
  display: block;
  margin-left: calc(-260px);
}
.page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body {
  margin-left: 0;
  transition: 0.3s;
}
.page-wrapper .page-body-wrapper .page-sidebar.open ~ footer {
  margin-left: 0;
  padding-right: 15px;
}
.page-wrapper .page-body-wrapper .page-sidebar.open ~ .footer-fix {
  width: calc(100% - 0px);
}
.page-wrapper .page-body-wrapper .sidebar-close .page-sidebar {
  transition: 0.3s;
  transform: translate(-255px);
}
.page-wrapper .page-body-wrapper .sidebar-close .page-body {
  transition: 0.3s;
  margin-left: 0 !important;
}

.right-sidebar {
  top: 81px;
  right: -285px;
  height: 100%;
  position: fixed;
  width: 285px;
  z-index: 9;
  background-color: #fff;
  transition: 0.5s;
  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);
}
.right-sidebar.show {
  right: 0;
  transition: 0.3s;
}
.right-sidebar .modal-header .modal-title {
  padding-top: 2px;
}
.right-sidebar .friend-list-search {
  position: relative;
  background-color: #f8f8f9;
  padding: 20px;
}
.right-sidebar .friend-list-search input {
  color: #898989;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #f8f8f9;
  padding: 10px 15px;
  border-radius: 25px;
  letter-spacing: 1px;
}
.right-sidebar .friend-list-search .fa {
  position: absolute;
  right: 35px;
  top: 34px;
  font-size: 14px;
  color: #e8ebf2;
}
.right-sidebar .chat-box .people-list ul {
  padding-top: 20px;
}
.right-sidebar .chat-box .people-list ul li {
  position: relative;
}
.right-sidebar svg {
  width: 16px;
  height: 16px;
  margin-top: 5px;
}

/**=====================
    Sidebar CSS Ends
==========================**/
/**=====================
      Generic CSS Start
==========================**/
/*====== Padding css starts ======*/
.p-0 {
  padding: 0px;
}

.p-5 {
  padding: 5px;
}

.p-10 {
  padding: 10px;
}

.p-15 {
  padding: 15px;
}

.p-20 {
  padding: 20px;
}

.p-25 {
  padding: 25px;
}

.p-30 {
  padding: 30px;
}

.p-35 {
  padding: 35px;
}

.p-40 {
  padding: 40px;
}

.p-45 {
  padding: 45px;
}

.p-50 {
  padding: 50px;
}

/*====== Padding css ends ======*/
/*====== Padding-left css starts ======*/
.p-l-0 {
  padding-left: 0px;
}

.p-l-5 {
  padding-left: 5px;
}

.p-l-10 {
  padding-left: 10px;
}

.p-l-15 {
  padding-left: 15px;
}

.p-l-20 {
  padding-left: 20px;
}

.p-l-25 {
  padding-left: 25px;
}

.p-l-30 {
  padding-left: 30px;
}

.p-l-35 {
  padding-left: 35px;
}

.p-l-40 {
  padding-left: 40px;
}

.p-l-45 {
  padding-left: 45px;
}

.p-l-50 {
  padding-left: 50px;
}

/*====== Padding-left css ends ======*/
/*====== Padding-top css starts ======*/
.p-t-0 {
  padding-top: 0px !important;
}

.p-t-5 {
  padding-top: 5px !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

.p-t-15 {
  padding-top: 15px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.p-t-25 {
  padding-top: 25px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.p-t-35 {
  padding-top: 35px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.p-t-45 {
  padding-top: 45px !important;
}

.p-t-50 {
  padding-top: 50px !important;
}

/*====== Padding-top css ends ======*/
/*====== Padding-bottom css starts ======*/
.p-b-0 {
  padding-bottom: 0px !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.p-b-15 {
  padding-bottom: 15px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.p-b-35 {
  padding-bottom: 35px !important;
}

.p-b-40 {
  padding-bottom: 40px !important;
}

.p-b-45 {
  padding-bottom: 45px !important;
}

.p-b-50 {
  padding-bottom: 50px !important;
}

/*====== Padding-bottom css ends ======*/
/*====== Padding-right css starts ======*/
.p-r-0 {
  padding-right: 0px;
}

.p-r-5 {
  padding-right: 5px;
}

.p-r-10 {
  padding-right: 10px;
}

.p-r-15 {
  padding-right: 15px;
}

.p-r-20 {
  padding-right: 20px;
}

.p-r-25 {
  padding-right: 25px;
}

.p-r-30 {
  padding-right: 30px;
}

.p-r-35 {
  padding-right: 35px;
}

.p-r-40 {
  padding-right: 40px;
}

.p-r-45 {
  padding-right: 45px;
}

.p-r-50 {
  padding-right: 50px;
}

/*====== Padding-right css ends ======*/
/*====== Margin css starts ======*/
.m-0 {
  margin: 0px !important;
}

.m-5 {
  margin: 5px !important;
}

.m-10 {
  margin: 10px !important;
}

.m-15 {
  margin: 15px !important;
}

.m-20 {
  margin: 20px !important;
}

.m-25 {
  margin: 25px !important;
}

.m-30 {
  margin: 30px !important;
}

.m-35 {
  margin: 35px !important;
}

.m-40 {
  margin: 40px !important;
}

.m-45 {
  margin: 45px !important;
}

.m-50 {
  margin: 50px !important;
}

/*====== Margin css ends ======*/
/*====== Margin-top css starts ======*/
.m-t-0 {
  margin-top: 0px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-t-25 {
  margin-top: 25px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-t-35 {
  margin-top: 35px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.m-t-45 {
  margin-top: 45px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

/*====== Margin-top css ends ======*/
/*====== Margin-Bottom css starts ======*/
.m-b-0 {
  margin-bottom: 0px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.m-b-35 {
  margin-bottom: 35px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.m-b-45 {
  margin-bottom: 45px !important;
}

.m-b-50 {
  margin-bottom: 50px !important;
}

/*====== Margin-Bottom css ends ======*/
/*====== Margin-left css starts ======*/
.m-l-0 {
  margin-left: 0px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.m-l-25 {
  margin-left: 25px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.m-l-45 {
  margin-left: 45px !important;
}

.m-l-50 {
  margin-left: 50px !important;
}

/*====== Margin-left css ends ======*/
/*====== Margin-right css starts ======*/
.m-r-0 {
  margin-right: 0px;
}

.m-r-5 {
  margin-right: 5px;
}

.m-r-10 {
  margin-right: 10px;
}

.m-r-15 {
  margin-right: 15px;
}

.m-r-20 {
  margin-right: 20px;
}

.m-r-25 {
  margin-right: 25px;
}

.m-r-30 {
  margin-right: 30px;
}

.m-r-35 {
  margin-right: 35px;
}

.m-r-40 {
  margin-right: 40px;
}

.m-r-45 {
  margin-right: 45px;
}

.m-r-50 {
  margin-right: 50px;
}

/*====== Margin-right css ends ======*/
/*====== Border-radius css starts ======*/
.b-r-0 {
  border-radius: 0px !important;
}

.b-r-1 {
  border-radius: 1px !important;
}

.b-r-2 {
  border-radius: 2px !important;
}

.b-r-3 {
  border-radius: 3px !important;
}

.b-r-4 {
  border-radius: 4px !important;
}

.b-r-5 {
  border-radius: 5px !important;
}

.b-r-6 {
  border-radius: 6px !important;
}

.b-r-7 {
  border-radius: 7px !important;
}

.b-r-8 {
  border-radius: 8px !important;
}

.b-r-9 {
  border-radius: 9px !important;
}

.b-r-10 {
  border-radius: 10px !important;
}

/*====== Border-radius css ends ======*/
/*====== Font-size css starts ======*/
.f-12 {
  font-size: 12px;
}

.f-14 {
  font-size: 14px;
}

.f-16 {
  font-size: 16px;
}

.f-18 {
  font-size: 18px;
}

.f-20 {
  font-size: 20px;
}

.f-22 {
  font-size: 22px;
}

.f-24 {
  font-size: 24px;
}

.f-26 {
  font-size: 26px;
}

.f-28 {
  font-size: 28px;
}

.f-30 {
  font-size: 30px;
}

.f-32 {
  font-size: 32px;
}

.f-34 {
  font-size: 34px;
}

.f-36 {
  font-size: 36px;
}

.f-38 {
  font-size: 38px;
}

.f-40 {
  font-size: 40px;
}

.f-42 {
  font-size: 42px;
}

.f-44 {
  font-size: 44px;
}

.f-46 {
  font-size: 46px;
}

.f-48 {
  font-size: 48px;
}

.f-50 {
  font-size: 50px;
}

.f-52 {
  font-size: 52px;
}

.f-54 {
  font-size: 54px;
}

.f-56 {
  font-size: 56px;
}

.f-58 {
  font-size: 58px;
}

.f-60 {
  font-size: 60px;
}

.f-62 {
  font-size: 62px;
}

.f-64 {
  font-size: 64px;
}

.f-66 {
  font-size: 66px;
}

.f-68 {
  font-size: 68px;
}

.f-70 {
  font-size: 70px;
}

.f-72 {
  font-size: 72px;
}

.f-74 {
  font-size: 74px;
}

.f-76 {
  font-size: 76px;
}

.f-78 {
  font-size: 78px;
}

.f-80 {
  font-size: 80px;
}

.f-82 {
  font-size: 82px;
}

.f-84 {
  font-size: 84px;
}

.f-86 {
  font-size: 86px;
}

.f-88 {
  font-size: 88px;
}

.f-90 {
  font-size: 90px;
}

.f-92 {
  font-size: 92px;
}

.f-94 {
  font-size: 94px;
}

.f-96 {
  font-size: 96px;
}

.f-98 {
  font-size: 98px;
}

.f-100 {
  font-size: 100px;
}

/*====== Font-size css ends ======*/
/*====== Font-weight css starts ======*/
.f-w-100 {
  font-weight: 100;
}

.f-w-300 {
  font-weight: 300;
}

.f-w-400 {
  font-weight: 400;
}

.f-w-600 {
  font-weight: 600;
}

.f-w-700 {
  font-weight: 700;
}

.f-w-900 {
  font-weight: 900;
}

/*====== Font-weight css ends ======*/
/*====== Font-style css starts ======*/
.f-s-normal {
  font-style: normal;
}

.f-s-italic {
  font-style: italic;
}

.f-s-oblique {
  font-style: oblique;
}

.f-s-initial {
  font-style: initial;
}

.f-s-inherit {
  font-style: inherit;
}

/*====== Font-style css ends ======*/
/*====== Text-Decoration css starts ======*/
.text-overline {
  text-decoration: overline;
}

.text-line-through {
  text-decoration: line-through;
}

.text-underline {
  text-decoration: underline;
}

.text-dashed {
  -webkit-text-decoration: dashed;
          text-decoration: dashed;
}

.text-blink {
  text-decoration: blink;
}

.text-dotted {
  -webkit-text-decoration: dotted;
          text-decoration: dotted;
}

.text-initial {
  text-decoration: initial;
}

.text-none {
  text-decoration: none;
}

.text-solid {
  -webkit-text-decoration: solid;
          text-decoration: solid;
}

.text-wavy {
  -webkit-text-decoration: wavy;
          text-decoration: wavy;
}

.text-inherit {
  text-decoration: inherit;
}

.text-double {
  -webkit-text-decoration: double;
          text-decoration: double;
}

/*====== Text-Decoration css ends ======*/
/*====== Vertical-Align css starts ======*/
.baseline {
  vertical-align: baseline;
}

.sub {
  vertical-align: sub;
}

.super {
  vertical-align: super;
}

.top {
  vertical-align: top;
}

.text-top {
  vertical-align: text-top;
}

.middle {
  vertical-align: middle;
}

.bottom {
  vertical-align: bottom;
}

.text-bottom {
  vertical-align: text-bottom;
}

.initial {
  vertical-align: initial;
}

.inherit {
  vertical-align: inherit;
}

/*====== Vertical-Align css ends ======*/
/*====== Position css starts ======*/
.p-static {
  position: static;
}

.p-absolute {
  position: absolute;
}

.p-fixed {
  position: fixed;
}

.p-relative {
  position: relative;
}

.p-initial {
  position: initial;
}

.p-inherit {
  position: inherit;
}

/*====== Position css ends ======*/
/*====== Float css starts ======*/
.f-left {
  float: left;
}

.f-right {
  float: right;
}

.f-none {
  float: none;
}

/*====== Float css ends ======*/
/*====== Overflow css starts ======*/
.o-hidden {
  overflow: hidden;
}

.o-visible {
  overflow: visible;
}

.o-auto {
  overflow: auto;
}

/*====== Overflow css ends ======*/
/*====== Image-sizes css starts ======*/
.img-10 {
  width: 10px !important;
}

.img-20 {
  width: 20px !important;
}

.img-30 {
  width: 30px !important;
}

.img-40 {
  width: 40px !important;
}

.img-50 {
  width: 50px !important;
}

.img-60 {
  width: 60px !important;
}

.img-70 {
  width: 70px !important;
}

.img-80 {
  width: 80px !important;
}

.img-90 {
  width: 90px !important;
}

.img-100 {
  width: 100px !important;
}

/*====== Image-sizes css ends ======*/
/*======= Text css starts ===========*/
.font-primary {
  color: #12571a !important;
}

.font-secondary {
  color: #13c9ca !important;
}

.font-success {
  color: #81ba00 !important;
}

.font-danger {
  color: #a5a5a5 !important;
}

.font-info {
  color: #00a8ff !important;
}

.font-light {
  color: #f8f8f9 !important;
}

.font-dark {
  color: #2a3142 !important;
}

.font-warning {
  color: #ffbc58 !important;
}

/*======= Text css ends ===========*/
/*======= Label-color css starts  ======= */
.label {
  border-radius: 2px;
  color: #ffffff;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 0;
  text-transform: capitalize;
}

/*======= Label-color css ends  ======= */
/*======= Badge-color css starts  ======= */
.badge-primary {
  background-color: #12571a;
}

.badge-secondary {
  background-color: #13c9ca;
}

.badge-success {
  background-color: #81ba00;
}

.badge-danger {
  background-color: #a5a5a5;
}

.badge-info {
  background-color: #00a8ff;
}

.badge-light {
  background-color: #f8f8f9;
}

.badge-dark {
  background-color: #2a3142;
}

.badge-warning {
  background-color: #ffbc58;
}

/*======= Badge-color css end  ======= */
/*======= Background-color css starts  ======= */
.bg-primary {
  background-color: #12571a !important;
  color: #ffffff;
}

.bg-secondary {
  background-color: #13c9ca !important;
  color: #ffffff;
}

.bg-success {
  background-color: #81ba00 !important;
  color: #ffffff;
}

.bg-danger {
  background-color: #a5a5a5 !important;
  color: #ffffff;
}

.bg-info {
  background-color: #00a8ff !important;
  color: #ffffff;
}

.bg-light {
  background-color: #f8f8f9 !important;
  color: #ffffff;
}

.bg-dark {
  background-color: #2a3142 !important;
  color: #ffffff;
}

.bg-warning {
  background-color: #ffbc58 !important;
  color: #ffffff;
}

/*======= Background-color css end  ======= */
/*======= Font-color css starts  ======= */
/*======= Font-color css end  ======= */
/*======= Button-color css starts  ======= */
.btn-primary {
  background-color: #12571a !important;
  border-color: #12571a !important;
}
.btn-primary.disabled {
  background-color: #12571a !important;
  border-color: #12571a !important;
}
.btn-primary:disabled {
  background-color: #12571a !important;
  border-color: #12571a !important;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active {
  background-color: #092d0d !important;
  border-color: #092d0d !important;
}
.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem #2ed441;
}

.btn-secondary {
  background-color: #13c9ca !important;
  border-color: #13c9ca !important;
}
.btn-secondary.disabled {
  background-color: #13c9ca !important;
  border-color: #13c9ca !important;
}
.btn-secondary:disabled {
  background-color: #13c9ca !important;
  border-color: #13c9ca !important;
}
.btn-secondary:hover, .btn-secondary:focus, .btn-secondary:active, .btn-secondary.active {
  background-color: #0f9b9b !important;
  border-color: #0f9b9b !important;
}
.btn-secondary:focus {
  box-shadow: 0 0 0 0.2rem #83f3f3;
}

.btn-success {
  background-color: #81ba00 !important;
  border-color: #81ba00 !important;
}
.btn-success.disabled {
  background-color: #81ba00 !important;
  border-color: #81ba00 !important;
}
.btn-success:disabled {
  background-color: #81ba00 !important;
  border-color: #81ba00 !important;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active {
  background-color: #5e8700 !important;
  border-color: #5e8700 !important;
}
.btn-success:focus {
  box-shadow: 0 0 0 0.2rem #cbff54;
}

.btn-danger {
  background-color: #a5a5a5 !important;
  border-color: #a5a5a5 !important;
}
.btn-danger.disabled {
  background-color: #a5a5a5 !important;
  border-color: #a5a5a5 !important;
}
.btn-danger:disabled {
  background-color: #a5a5a5 !important;
  border-color: #a5a5a5 !important;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active {
  background-color: #8c8c8c !important;
  border-color: #8c8c8c !important;
}
.btn-danger:focus {
  box-shadow: 0 0 0 0.2rem #f2f2f2;
}

.btn-info {
  background-color: #00a8ff !important;
  border-color: #00a8ff !important;
}
.btn-info.disabled {
  background-color: #00a8ff !important;
  border-color: #00a8ff !important;
}
.btn-info:disabled {
  background-color: #00a8ff !important;
  border-color: #00a8ff !important;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active {
  background-color: #0086cc !important;
  border-color: #0086cc !important;
}
.btn-info:focus {
  box-shadow: 0 0 0 0.2rem #99dcff;
}

.btn-light {
  background-color: #f8f8f9 !important;
  border-color: #f8f8f9 !important;
}
.btn-light.disabled {
  background-color: #f8f8f9 !important;
  border-color: #f8f8f9 !important;
}
.btn-light:disabled {
  background-color: #f8f8f9 !important;
  border-color: #f8f8f9 !important;
}
.btn-light:hover, .btn-light:focus, .btn-light:active, .btn-light.active {
  background-color: #dddde1 !important;
  border-color: #dddde1 !important;
}
.btn-light:focus {
  box-shadow: 0 0 0 0.2rem white;
}

.btn-dark {
  background-color: #2a3142 !important;
  border-color: #2a3142 !important;
}
.btn-dark.disabled {
  background-color: #2a3142 !important;
  border-color: #2a3142 !important;
}
.btn-dark:disabled {
  background-color: #2a3142 !important;
  border-color: #2a3142 !important;
}
.btn-dark:hover, .btn-dark:focus, .btn-dark:active, .btn-dark.active {
  background-color: #161a23 !important;
  border-color: #161a23 !important;
}
.btn-dark:focus {
  box-shadow: 0 0 0 0.2rem #67779e;
}

.btn-warning {
  background-color: #ffbc58 !important;
  border-color: #ffbc58 !important;
}
.btn-warning.disabled {
  background-color: #ffbc58 !important;
  border-color: #ffbc58 !important;
}
.btn-warning:disabled {
  background-color: #ffbc58 !important;
  border-color: #ffbc58 !important;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active {
  background-color: #ffa825 !important;
  border-color: #ffa825 !important;
}
.btn-warning:focus {
  box-shadow: 0 0 0 0.2rem #fff9f1;
}

/*======= Button-color css ends  ======= */
.btn-primary:not([disabled]):not(.disabled).active {
  background-color: #092d0d;
  border-color: #092d0d;
  box-shadow: none !important;
}
.btn-primary:not([disabled]):not(.disabled).active:hover, .btn-primary:not([disabled]):not(.disabled).active:focus, .btn-primary:not([disabled]):not(.disabled).active:active, .btn-primary:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #092d0d;
  border-color: #092d0d;
}

.btn-secondary:not([disabled]):not(.disabled).active {
  background-color: #0f9b9b;
  border-color: #0f9b9b;
  box-shadow: none !important;
}
.btn-secondary:not([disabled]):not(.disabled).active:hover, .btn-secondary:not([disabled]):not(.disabled).active:focus, .btn-secondary:not([disabled]):not(.disabled).active:active, .btn-secondary:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #0f9b9b;
  border-color: #0f9b9b;
}

.btn-success:not([disabled]):not(.disabled).active {
  background-color: #5e8700;
  border-color: #5e8700;
  box-shadow: none !important;
}
.btn-success:not([disabled]):not(.disabled).active:hover, .btn-success:not([disabled]):not(.disabled).active:focus, .btn-success:not([disabled]):not(.disabled).active:active, .btn-success:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #5e8700;
  border-color: #5e8700;
}

.btn-danger:not([disabled]):not(.disabled).active {
  background-color: #8c8c8c;
  border-color: #8c8c8c;
  box-shadow: none !important;
}
.btn-danger:not([disabled]):not(.disabled).active:hover, .btn-danger:not([disabled]):not(.disabled).active:focus, .btn-danger:not([disabled]):not(.disabled).active:active, .btn-danger:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #8c8c8c;
  border-color: #8c8c8c;
}

.btn-info:not([disabled]):not(.disabled).active {
  background-color: #0086cc;
  border-color: #0086cc;
  box-shadow: none !important;
}
.btn-info:not([disabled]):not(.disabled).active:hover, .btn-info:not([disabled]):not(.disabled).active:focus, .btn-info:not([disabled]):not(.disabled).active:active, .btn-info:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #0086cc;
  border-color: #0086cc;
}

.btn-light:not([disabled]):not(.disabled).active {
  background-color: #dddde1;
  border-color: #dddde1;
  box-shadow: none !important;
}
.btn-light:not([disabled]):not(.disabled).active:hover, .btn-light:not([disabled]):not(.disabled).active:focus, .btn-light:not([disabled]):not(.disabled).active:active, .btn-light:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #dddde1;
  border-color: #dddde1;
}

.btn-dark:not([disabled]):not(.disabled).active {
  background-color: #161a23;
  border-color: #161a23;
  box-shadow: none !important;
}
.btn-dark:not([disabled]):not(.disabled).active:hover, .btn-dark:not([disabled]):not(.disabled).active:focus, .btn-dark:not([disabled]):not(.disabled).active:active, .btn-dark:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #161a23;
  border-color: #161a23;
}

.btn-warning:not([disabled]):not(.disabled).active {
  background-color: #ffa825;
  border-color: #ffa825;
  box-shadow: none !important;
}
.btn-warning:not([disabled]):not(.disabled).active:hover, .btn-warning:not([disabled]):not(.disabled).active:focus, .btn-warning:not([disabled]):not(.disabled).active:active, .btn-warning:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #ffa825;
  border-color: #ffa825;
}

.btn-outline-primary-2x:not([disabled]):not(.disabled).active {
  background-color: #12571a;
  border-color: #12571a;
  box-shadow: none !important;
  color: white;
}
.btn-outline-primary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-primary-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #092d0d !important;
  border-color: #092d0d !important;
}

.btn-outline-secondary-2x:not([disabled]):not(.disabled).active {
  background-color: #13c9ca;
  border-color: #13c9ca;
  box-shadow: none !important;
  color: white;
}
.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #0f9b9b !important;
  border-color: #0f9b9b !important;
}

.btn-outline-success-2x:not([disabled]):not(.disabled).active {
  background-color: #81ba00;
  border-color: #81ba00;
  box-shadow: none !important;
  color: white;
}
.btn-outline-success-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-success-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-success-2x:not([disabled]):not(.disabled).active:active, .btn-outline-success-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #5e8700 !important;
  border-color: #5e8700 !important;
}

.btn-outline-danger-2x:not([disabled]):not(.disabled).active {
  background-color: #a5a5a5;
  border-color: #a5a5a5;
  box-shadow: none !important;
  color: white;
}
.btn-outline-danger-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:active, .btn-outline-danger-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #8c8c8c !important;
  border-color: #8c8c8c !important;
}

.btn-outline-info-2x:not([disabled]):not(.disabled).active {
  background-color: #00a8ff;
  border-color: #00a8ff;
  box-shadow: none !important;
  color: white;
}
.btn-outline-info-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-info-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-info-2x:not([disabled]):not(.disabled).active:active, .btn-outline-info-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #0086cc !important;
  border-color: #0086cc !important;
}

.btn-outline-light-2x:not([disabled]):not(.disabled).active {
  background-color: #f8f8f9;
  border-color: #f8f8f9;
  box-shadow: none !important;
  color: white;
}
.btn-outline-light-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-light-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-light-2x:not([disabled]):not(.disabled).active:active, .btn-outline-light-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #dddde1 !important;
  border-color: #dddde1 !important;
}

.btn-outline-dark-2x:not([disabled]):not(.disabled).active {
  background-color: #2a3142;
  border-color: #2a3142;
  box-shadow: none !important;
  color: white;
}
.btn-outline-dark-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:active, .btn-outline-dark-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #161a23 !important;
  border-color: #161a23 !important;
}

.btn-outline-warning-2x:not([disabled]):not(.disabled).active {
  background-color: #ffbc58;
  border-color: #ffbc58;
  box-shadow: none !important;
  color: white;
}
.btn-outline-warning-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:active, .btn-outline-warning-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #ffa825 !important;
  border-color: #ffa825 !important;
}

/*======= Table-Border-Bottom-color css starts  ======= */
table thead .border-bottom-primary th,
table tbody .border-bottom-primary th,
table tbody .border-bottom-primary td {
  border-bottom: 1px solid #12571a;
}

table thead .border-bottom-secondary th,
table tbody .border-bottom-secondary th,
table tbody .border-bottom-secondary td {
  border-bottom: 1px solid #13c9ca;
}

table thead .border-bottom-success th,
table tbody .border-bottom-success th,
table tbody .border-bottom-success td {
  border-bottom: 1px solid #81ba00;
}

table thead .border-bottom-danger th,
table tbody .border-bottom-danger th,
table tbody .border-bottom-danger td {
  border-bottom: 1px solid #a5a5a5;
}

table thead .border-bottom-info th,
table tbody .border-bottom-info th,
table tbody .border-bottom-info td {
  border-bottom: 1px solid #00a8ff;
}

table thead .border-bottom-light th,
table tbody .border-bottom-light th,
table tbody .border-bottom-light td {
  border-bottom: 1px solid #f8f8f9;
}

table thead .border-bottom-dark th,
table tbody .border-bottom-dark th,
table tbody .border-bottom-dark td {
  border-bottom: 1px solid #2a3142;
}

table thead .border-bottom-warning th,
table tbody .border-bottom-warning th,
table tbody .border-bottom-warning td {
  border-bottom: 1px solid #ffbc58;
}

/*======= Table-Border-Bottom-color css ends  ======= */
/*======= Table styling css starts  ======= */
.table-styling .table-primary,
.table-styling.table-primary {
  background-color: #12571a;
  color: #ffffff;
  border: 3px solid #12571a;
}
.table-styling .table-primary thead,
.table-styling.table-primary thead {
  background-color: #092d0d;
  border: 3px solid #092d0d;
}

.table-styling .table-secondary,
.table-styling.table-secondary {
  background-color: #13c9ca;
  color: #ffffff;
  border: 3px solid #13c9ca;
}
.table-styling .table-secondary thead,
.table-styling.table-secondary thead {
  background-color: #0f9b9b;
  border: 3px solid #0f9b9b;
}

.table-styling .table-success,
.table-styling.table-success {
  background-color: #81ba00;
  color: #ffffff;
  border: 3px solid #81ba00;
}
.table-styling .table-success thead,
.table-styling.table-success thead {
  background-color: #5e8700;
  border: 3px solid #5e8700;
}

.table-styling .table-danger,
.table-styling.table-danger {
  background-color: #a5a5a5;
  color: #ffffff;
  border: 3px solid #a5a5a5;
}
.table-styling .table-danger thead,
.table-styling.table-danger thead {
  background-color: #8c8c8c;
  border: 3px solid #8c8c8c;
}

.table-styling .table-info,
.table-styling.table-info {
  background-color: #00a8ff;
  color: #ffffff;
  border: 3px solid #00a8ff;
}
.table-styling .table-info thead,
.table-styling.table-info thead {
  background-color: #0086cc;
  border: 3px solid #0086cc;
}

.table-styling .table-light,
.table-styling.table-light {
  background-color: #f8f8f9;
  color: #ffffff;
  border: 3px solid #f8f8f9;
}
.table-styling .table-light thead,
.table-styling.table-light thead {
  background-color: #dddde1;
  border: 3px solid #dddde1;
}

.table-styling .table-dark,
.table-styling.table-dark {
  background-color: #2a3142;
  color: #ffffff;
  border: 3px solid #2a3142;
}
.table-styling .table-dark thead,
.table-styling.table-dark thead {
  background-color: #161a23;
  border: 3px solid #161a23;
}

.table-styling .table-warning,
.table-styling.table-warning {
  background-color: #ffbc58;
  color: #ffffff;
  border: 3px solid #ffbc58;
}
.table-styling .table-warning thead,
.table-styling.table-warning thead {
  background-color: #ffa825;
  border: 3px solid #ffa825;
}

/*======= Table styling css ends  ======= */
/*======= All-Borders-color css starts  ======= */
.b-primary {
  border: 1px solid #12571a !important;
}

.b-t-primary {
  border-top: 1px solid #12571a !important;
}

.b-b-primary {
  border-bottom: 1px solid #12571a !important;
}

.b-l-primary {
  border-left: 1px solid #12571a !important;
}

.b-r-primary {
  border-right: 1px solid #12571a !important;
}

.b-secondary {
  border: 1px solid #13c9ca !important;
}

.b-t-secondary {
  border-top: 1px solid #13c9ca !important;
}

.b-b-secondary {
  border-bottom: 1px solid #13c9ca !important;
}

.b-l-secondary {
  border-left: 1px solid #13c9ca !important;
}

.b-r-secondary {
  border-right: 1px solid #13c9ca !important;
}

.b-success {
  border: 1px solid #81ba00 !important;
}

.b-t-success {
  border-top: 1px solid #81ba00 !important;
}

.b-b-success {
  border-bottom: 1px solid #81ba00 !important;
}

.b-l-success {
  border-left: 1px solid #81ba00 !important;
}

.b-r-success {
  border-right: 1px solid #81ba00 !important;
}

.b-danger {
  border: 1px solid #a5a5a5 !important;
}

.b-t-danger {
  border-top: 1px solid #a5a5a5 !important;
}

.b-b-danger {
  border-bottom: 1px solid #a5a5a5 !important;
}

.b-l-danger {
  border-left: 1px solid #a5a5a5 !important;
}

.b-r-danger {
  border-right: 1px solid #a5a5a5 !important;
}

.b-info {
  border: 1px solid #00a8ff !important;
}

.b-t-info {
  border-top: 1px solid #00a8ff !important;
}

.b-b-info {
  border-bottom: 1px solid #00a8ff !important;
}

.b-l-info {
  border-left: 1px solid #00a8ff !important;
}

.b-r-info {
  border-right: 1px solid #00a8ff !important;
}

.b-light {
  border: 1px solid #f8f8f9 !important;
}

.b-t-light {
  border-top: 1px solid #f8f8f9 !important;
}

.b-b-light {
  border-bottom: 1px solid #f8f8f9 !important;
}

.b-l-light {
  border-left: 1px solid #f8f8f9 !important;
}

.b-r-light {
  border-right: 1px solid #f8f8f9 !important;
}

.b-dark {
  border: 1px solid #2a3142 !important;
}

.b-t-dark {
  border-top: 1px solid #2a3142 !important;
}

.b-b-dark {
  border-bottom: 1px solid #2a3142 !important;
}

.b-l-dark {
  border-left: 1px solid #2a3142 !important;
}

.b-r-dark {
  border-right: 1px solid #2a3142 !important;
}

.b-warning {
  border: 1px solid #ffbc58 !important;
}

.b-t-warning {
  border-top: 1px solid #ffbc58 !important;
}

.b-b-warning {
  border-bottom: 1px solid #ffbc58 !important;
}

.b-l-warning {
  border-left: 1px solid #ffbc58 !important;
}

.b-r-warning {
  border-right: 1px solid #ffbc58 !important;
}

/*======= All-Borders-color css ends  ======= */
/*====== Border width css starts ======*/
.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-6 {
  border-width: 6px !important;
}

.border-7 {
  border-width: 7px !important;
}

.border-8 {
  border-width: 8px !important;
}

.border-9 {
  border-width: 9px !important;
}

.border-10 {
  border-width: 10px !important;
}

/*====== Border width css ends ======*/
.opacity-0 {
  opacity: 0;
}

.shadow-0 {
  box-shadow: none;
}

/**====== custom scrollbar css start ======**/
.digits {
  font-family: work-Sans, sans-serif;
}

.custom-scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #e8ebf2;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(18, 87, 26, 0.17);
}

/**====== Custom scrollbar css end ======**/
/**====== Animation css Start ======**/
.line pre {
  font-size: 100%;
}

/**====== Animation css end ======**/
/**=====================
      Generic CSS Ends
==========================**/
/**=====================
     Chat CSS Start
==========================**/
.chat-box .toogle-bar {
  display: none;
}
.chat-box .people-list .search {
  position: relative;
}
.chat-box .people-list .search .form-control {
  background-color: #f1f4fb;
  border: 1px solid #f8f8f9;
}
.chat-box .people-list .search .form-control::placeholder {
  color: #aaaaaa;
}
.chat-box .people-list .search i {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 14px;
  color: #e8ebf2;
}
.chat-box .people-list ul {
  padding: 0;
}
.chat-box .people-list ul li {
  padding-bottom: 20px;
}
.chat-box .people-list ul li:last-child {
  padding-bottom: 0;
}
.chat-box .user-image {
  float: left;
  width: 52px;
  height: 52px;
  margin-right: 5px;
}
.chat-box .about {
  float: left;
  margin-top: 5px;
  padding-left: 10px;
}
.chat-box .about .name {
  color: #2a3142;
  letter-spacing: 1px;
  font-weight: 600;
}
.chat-box .status {
  color: #aaaaaa;
  letter-spacing: 1px;
  font-size: 12px;
  margin-top: 5px;
}
.chat-box .status .chat-status {
  font-weight: 600;
  color: #313131;
}
.chat-box .status p {
  font-size: 14px;
}

.status-circle {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 40px;
  left: 40px;
  border-radius: 50%;
  border: 2px solid #ffffff;
}

.away {
  background-color: #ffbc58;
}

.online {
  background-color: #81ba00;
}

.offline {
  background-color: #a5a5a5;
}

/**=====================
      Chat CSS Ends
==========================**/
.market-chart {
  height: 303px;
}

.needs-validation .form-select {
  background: white;
}
.needs-validation .form-control {
  border-radius: 0.25rem;
  padding: 0.48rem 0.75rem;
}

.license-key[disabled] {
  cursor: not-allowed;
}

.checkbox label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
}
.checkbox .form-check-input {
  margin-top: 13px;
  margin-bottom: 10px;
}

.form-row .form-control {
  font-size: 14px;
  letter-spacing: 1px;
}
.form-row .form-select {
  font-size: 14px;
  letter-spacing: 1px;
}

/*=====================
    Responsive CSS start
==========================*/
@media only screen and (max-width: 1780px) and (min-width: 1661px) {
  .add-product-form .qty-box {
    width: 20%;
  }
  .products-table table tr td:first-child {
    min-width: 255px;
  }
}
@media only screen and (max-width: 1660px) {
  .translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+1) {
    width: 200px;
  }
  .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2),
  .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2),
  .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2) {
    width: 170px;
  }
  .add-product-form .qty-box {
    width: 20%;
  }
  .products-table table tr td:first-child {
    min-width: 268px;
  }
}
@media screen and (max-width: 1440px) and (min-width: 1366px) {
  .flot-chart-container {
    height: 350px;
  }
  .product-adding .col-xl-5 {
    flex: 0 0 36%;
    max-width: 36%;
  }
  .product-adding .col-xl-7 {
    flex: 0 0 64%;
    max-width: 64%;
  }
}
@media only screen and (max-width: 1366px) {
  .transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell + .rdt_TableCell {
    width: 150px;
  }
  .product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
    width: 150px;
  }
  .report-employee h2, .report-employee .h2 {
    font-size: 32px;
  }
  .add-product-form .qty-box {
    width: 24%;
  }
  .slick-slide img {
    margin: 0 auto;
  }
  .page-main-header .main-header-right .nav-right > ul > li:first-child {
    width: 32%;
  }
  .product-adding .add-product-form {
    margin-top: 30px;
  }
  .user-list table tr td:nth-child(5),
  .user-list table tr th:nth-child(5) {
    width: 195px !important;
  }
}
@media only screen and (max-width: 1199px) {
  .product-page-details {
    margin-top: 30px;
  }
  .user-list table tr th,
  .user-list table tr td {
    width: 200px !important;
  }
}
@media screen and (max-device-width: 1366px) and (min-device-width: 1200px) {
  .xl-100 {
    max-width: 100%;
    flex: 0 0 100%;
  }
  .xl-50 {
    max-width: 50%;
    flex: 0 0 50%;
  }
  .product-adding .col-xl-5,
  .product-adding .col-xl-7 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .product-adding .add-product-form {
    margin-top: 30px;
  }
  .user-list table tr td:first-child,
  .user-list table tr th:first-child {
    width: 130px !important;
  }
  .profile-table table tr th,
  .profile-table table tr td {
    width: 200px !important;
  }
}
@media only screen and (max-width: 991px) {
  .page-wrapper .page-main-header .main-header-right .main-header-left {
    padding: 0;
  }
  .authentication-box {
    padding: 30px;
  }
  .authentication-box .container .bg-primary {
    padding: 40px;
  }
  .btn-popup {
    margin-bottom: 20px;
  }
  .order-graph .order-graph-bottom {
    margin-top: 20px;
  }
  .card .card-body,
  .card .card-header {
    padding: 20px;
  }
  .page-wrapper .page-main-header.open {
    z-index: 11;
  }
  .right-sidebar {
    top: 127px;
  }
  .page-wrapper .page-body-wrapper .page-header .row h3, .page-wrapper .page-body-wrapper .page-header .row .h3 {
    font-size: 22px;
  }
  .page-wrapper .page-body-wrapper .page-header .row .pull-right {
    float: none;
    margin-top: 5px;
  }
  .page-wrapper .page-body-wrapper .page-sidebar {
    top: 60px !important;
    height: calc(100vh - 60px) !important;
  }
  .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body {
    margin-left: 0;
    margin-top: 60px;
  }
  .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body .page-header .row .page-header-left {
    display: inherit;
  }
  .page-wrapper .page-body-wrapper .sidebar {
    height: calc(100vh - 60px);
  }
  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body {
    margin-top: 60px;
  }
  .page-wrapper .page-body-wrapper footer {
    margin-left: 0;
  }
  .page-wrapper .page-main-header {
    height: 60px;
    margin-left: 0;
    width: 100%;
    z-index: 11;
  }
  .page-wrapper .page-main-header .main-header-left .logo-wrapper img {
    height: 23px;
    margin-top: 0;
    margin-right: 15px;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right {
    position: unset;
    padding: 0;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul {
    top: 60px;
    position: absolute;
    z-index: -1;
    background-color: #fff;
    transition: all linear 0.3s;
    box-shadow: 0 2px 2px 2px #efefef;
    width: 100%;
    left: 0;
    padding: 0 40px;
    transform: translateY(-35px) scaleY(0);
    opacity: 0;
    visibility: hidden;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li {
    margin: 10px 0;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > .mobile-toggle {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > .mobile-toggle svg circle {
    color: #12571a;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul.open {
    z-index: 1;
    opacity: 1;
    transform: translateY(0px) scaleY(1);
    visibility: visible;
  }
  .page-header {
    padding-top: 25px !important;
    padding-bottom: 25px !important;
  }
  .page-header .row .page-header-left .breadcrumb {
    margin-top: 5px;
    margin-left: 0;
  }
  .product-page-details {
    text-align: left !important;
  }
  .add-product .bigImg img {
    width: 460px;
  }
  .product-adding .add-product-form {
    margin-top: 20px;
  }
  .tab-coupon {
    margin-bottom: 20px;
  }
  .deactivate-account {
    margin-top: 20px;
  }
  .sell-graph canvas {
    height: 312px !important;
  }
  .needs-validation h4, .needs-validation .h4 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  .react-tabs .react-datepicker-wrapper .react-datepicker__input-container {
    margin-left: 0;
  }
  .checkbox-space {
    padding: 0 15px;
  }
  .react-datepicker__input-container {
    margin-left: 15px;
  }
  .authentication-box .form-footer,
  .authentication-box .form-button {
    text-align: center;
  }
  .authentication-box .form-footer > span,
  .authentication-box .form-button > span {
    padding: 0;
    left: 0;
    right: 0;
  }
  .page-main-header .main-header-right .nav-right > ul > li:first-child {
    width: 40%;
  }
  .products-table table tr td:first-child,
  .products-table table tr th:first-child {
    min-width: 280px;
  }
  .products-table table tr td:nth-child(3),
  .products-table table tr th:nth-child(3) {
    min-width: 110px;
  }
  .page-wrapper .page-body-wrapper .page-header .row .col {
    flex-basis: unset;
  }
  .page-wrapper .page-body-wrapper .page-header .row .col .pull-right {
    float: none;
    margin-top: 20px;
  }
  .page-wrapper .page-body-wrapper footer .row div {
    text-align: center;
  }
  .page-wrapper .page-body-wrapper footer .row div .pull-right {
    float: none;
  }
  .footer-fix .pull-right {
    float: none !important;
    text-align: center !important;
  }
  .add-product-form .form-group .form-control,
  .add-product-form .form-group select {
    width: 100% !important;
    margin: 0 !important;
  }
  .add-product-form .input-group .touchspin {
    width: 30% !important;
  }
  .add-product-form .radio-animated label {
    margin-bottom: 0;
  }
  .add-product-form .editor-space {
    padding: 0 15px;
  }
  .add-product-form textarea {
    margin: 0 15px;
  }
  .add-product-form .qty-box {
    width: 29%;
  }
  .add-product .bigImg img {
    width: 400px;
  }
  .digital-add textarea {
    margin: 0 !important;
  }
  .digital-add .form-group select,
  .digital-add .form-group .form-control {
    width: 100% !important;
  }
  .digital-add .form-group label {
    margin-bottom: 0 !important;
  }
  .needs-validation .form-group.row {
    margin-left: 0;
    margin-right: 0;
  }
  .needs-validation .form-group .form-control,
  .needs-validation .form-group select {
    width: 100%;
    margin: 0 auto;
  }
  .needs-validation .form-group .checkbox {
    padding-left: 15px;
  }
  .needs-validation .form-group label {
    margin-bottom: 4px;
  }
  .needs-validation .radio-animated label {
    margin-bottom: 0;
  }
  .needs-validation .editor-space {
    padding: 0 15px;
  }
  .needs-validation textarea {
    margin: 0 15px;
  }
}
@media only screen and (max-width: 577px) {
  footer {
    margin-bottom: 0 !important;
  }
}
@media only screen and (max-width: 575px) {
  .react-tabs .needs-validation .row > div[class*=col-] {
    padding: 0 12px !important;
  }
  .authentication-box .btn-primary {
    margin-top: 10px;
  }
  .sales-chart {
    height: 200px;
  }
  .report-last-sm canvas {
    height: 200px !important;
  }
  .dropzone .dzu-input {
    width: 90%;
  }
  .product-right .timer span {
    width: 55px;
  }
  .market-chart {
    height: 205px;
  }
  .ct-4.flot-chart-container {
    height: 240px;
  }
  .sell-graph canvas {
    height: 250px !important;
  }
  .btn-popup {
    margin-bottom: 15px;
  }
  .static-top-widget div.align-self-center svg {
    width: 20px;
    height: 20px;
  }
  .latest-order-table table tr td {
    min-width: 100px;
  }
  .latest-order-table table tr td + td {
    min-width: 150px;
  }
  .latest-order-table table tr td:nth-child(3) {
    min-width: 200px;
  }
  .card {
    margin-bottom: 15px;
  }
  .card .card-header {
    padding: 15px;
  }
  .card .card-header h5, .card .card-header .h5 {
    font-size: 17px;
  }
  .card .card-body {
    padding: 15px;
  }
  .sm-order-space,
  .xl-space {
    margin-top: 15px;
  }
  .order-graph .order-graph-bottom {
    margin-top: 15px;
  }
  .order-graph .order-graph-bottom h6, .order-graph .order-graph-bottom .h6 {
    margin-right: 0;
  }
  .order-graph .order-graph-bottom .media {
    margin-bottom: 15px;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .d-sm-none:after {
    display: none;
  }
  ul.notification-dropdown.onhover-show-div {
    width: 284px;
    right: -112px;
  }
  ul.notification-dropdown.onhover-show-div:before, ul.notification-dropdown.onhover-show-div:after {
    right: 135px !important;
  }
  .page-wrapper .page-main-header .main-header-right {
    padding: 0 15px;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul {
    padding: 0 0;
    justify-content: flex-start;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li:first-child {
    width: auto;
    margin: 0;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:before {
    display: none;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:after {
    display: none;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-group {
    margin-bottom: 0;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-control-plaintext.open {
    transform: translateY(0px) scaleY(1);
    opacity: 1;
    visibility: visible;
    transition: all linear 0.3s;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-control-plaintext {
    top: 60px;
    position: absolute;
    transition: all linear 0.3s;
    left: 0;
    background-color: #fff;
    transform: translateY(-35px) scaleY(0);
    opacity: 0;
    visibility: hidden;
    width: 180px;
    padding: 10px 10px 10px 15px;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .mobile-search svg {
    color: #12571a;
  }
  .page-wrapper .search-form .form-group {
    margin-right: 0;
  }
  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body .activity .media .gradient-round.gradient-line-1:after {
    bottom: -41px;
  }
  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body .activity .media .gradient-round.small-line:after {
    bottom: -19px;
    height: 12px;
  }
  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body .activity .media .gradient-round.medium-line:after {
    bottom: -34px;
  }
  .page-wrapper .page-body-wrapper .page-body {
    padding: 0;
  }
  .page-wrapper .page-body-wrapper .page-header {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .profile-details img {
    margin-bottom: 15px;
  }
  .project-status {
    margin-top: 15px;
  }
  .project-status .media {
    margin-top: 15px;
  }
  .profile-card ul {
    display: inherit;
    margin-bottom: 15px;
  }
  .profile-card ul li {
    display: block;
    text-align: center;
  }
  .profile-table table tbody tr td:first-child {
    min-width: 150px;
  }
  .account-setting h5, .account-setting .h5 {
    margin-bottom: 15px;
  }
  .deactivate-account {
    margin-top: 15px;
  }
  .deactivate-account .btn {
    margin-top: 15px;
  }
  .sm-label-radio {
    margin-bottom: 4px !important;
  }
  .permission-block .attribute-blocks .form-group {
    padding-bottom: 15px;
  }
  .needs-validation textarea {
    margin: 0 10px;
  }
  .needs-validation h4, .needs-validation .h4 {
    margin-bottom: 15px;
  }
  .needs-validation .permission-block .attribute-blocks .row {
    padding-left: 15px;
  }
  .needs-validation .permission-block .attribute-blocks + .attribute-blocks h5, .needs-validation .permission-block .attribute-blocks + .attribute-blocks .h5 {
    margin-top: 20px;
  }
  .needs-validation .radio_animated {
    margin: 0 10px 0 0;
  }
  .needs-validation .radio-animated label {
    margin-right: 15px;
  }
  .tab-coupon {
    display: grid;
    text-align: center;
  }
  .add-product-form .form-group .form-control {
    width: 93%;
    margin: 0 auto;
  }
  .add-product-form .form-group .col-xl-8 {
    padding: 0;
  }
  .add-product-form .form-group fieldset {
    padding-left: 0;
  }
  .add-product-form .form-group label {
    padding: 0;
  }
  .add-product-form .qty-box {
    width: 162px;
  }
  .add-product-form .qty-box .input-group .form-control {
    width: 80px;
  }
  .add-product-form .description-sm {
    padding: 0 !important;
  }
  .add-product ul li .box-input-file {
    width: 15px;
    height: 15px;
  }
  .add-product ul li .box-input-file img {
    width: 40px !important;
    height: 40px !important;
  }
  .file-upload-product {
    margin-top: 11px;
  }
  .file-upload-product li {
    margin-bottom: 34px !important;
  }
}
@media only screen and (max-width: 360px) {
  .product-right .timer {
    padding: 15px 0 15px 30px;
  }
  .page-main-header .main-header-right .nav-right .profile-dropdown {
    right: 6px;
  }
  .authentication-box {
    padding: 30px 15px;
  }
  .authentication-box .forgot-pass {
    float: none;
    padding-top: 10px;
  }
  .authentication-box .container .form-group {
    margin-bottom: 1rem;
  }
  .authentication-box .container h3, .authentication-box .container .h3 {
    font-size: 20px;
  }
  .authentication-box .container p {
    line-height: 1.6;
  }
  .authentication-box .container .bg-primary {
    padding: 30px 15px;
  }
  .authentication-box .container .svg-icon {
    padding: 17px;
    height: 90px;
    width: 90px;
    margin-bottom: 25px;
  }
  .authentication-box .container .svg-icon svg {
    height: 50px;
  }
  .nav-menus .notification-badge {
    right: 0;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li {
    padding: 0 13px;
  }
  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li .dot {
    right: 13px;
  }
  .footer {
    padding-left: 0;
    padding-right: 0 !important;
  }
  .footer p {
    font-size: 12px;
  }
  .add-product .bigImg img {
    width: 300px;
  }
  .product-page-main .btn {
    padding: 5px 12px;
  }
}
@media only screen and (max-height: 800px) {
  .right-sidebar .chat-box .friend-list {
    max-height: calc(100vh - 150px);
    overflow: scroll;
  }
}
/*=====================
  Responsive CSS End
==========================*/
.custom-theme {
  position: fixed;
  right: 0;
  width: 40px;
  height: 38px;
  display: flex;
  z-index: 1;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-decoration: none;
  border-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: #f7f7f7;
  box-shadow: 0px 0px 5px 0px rgba(154, 154, 154, 0.54);
  top: calc(50% + 34px);
  cursor: pointer;
}

/**=====================
    RTL CSS Start
==========================**/
body.rtl {
  direction: rtl;
}
body.rtl .m-r-15 {
  margin-left: 15px;
  margin-right: unset;
}
body.rtl .me-2,
body.rtl .mx-2 {
  margin-left: 0.5rem !important;
  margin-right: unset !important;
}
body.rtl .form-select {
  padding: 0.375rem 0.75rem 0.375rem 1.75rem;
}
body.rtl .ps-0,
body.rtl .px-0 {
  padding-right: 0 !important;
  padding-left: unset !important;
}
body.rtl .me-sm-2 {
  margin-right: unset;
  margin-left: 0.5rem !important;
}
body.rtl .m-r-10 {
  margin-left: 10px;
  margin-right: unset;
}
body.rtl .radio_animated,
body.rtl .checkbox_animated {
  margin: 0 8px 0 1rem;
}
body.rtl .btn-light {
  margin-left: unset;
  margin-right: 7px;
}
body.rtl .onhover-show-div {
  left: unset;
  right: 0;
}
body.rtl .page-wrapper .page-body-wrapper footer.footer.open {
  margin-right: 0;
  margin-left: unset;
}
body.rtl .page-wrapper .page-main-header .main-header-left .logo-wrapper img {
  margin-left: 15px;
  margin-right: unset;
}
body.rtl .rdt_Pagination > div {
  direction: ltr;
}
body.rtl .digital-add .form-group .radio_animated {
  margin-left: 8px;
  margin-right: unset;
}
body.rtl .dropzone .dzu-input {
  margin-right: 15px;
  margin-left: unset;
}
body.rtl .product-right .timer {
  padding: 15px 40px 15px 0;
}
body.rtl .product-right .timer span .padding-l {
  padding-left: unset;
  padding-right: 22px;
}
body.rtl .breadcrumb-item + .breadcrumb-item {
  padding-right: 0.5rem;
  padding-left: unset;
}
body.rtl .breadcrumb-item + .breadcrumb-item::before {
  float: right;
  padding-left: 0.5rem;
  padding-right: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li {
  border-left: unset;
  border-right: 1px solid #eff0f1;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:hover .language-dropdown.onhover-show-div::before {
  right: 10px !important;
  left: unset !important;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:hover .language-dropdown.onhover-show-div::after {
  right: 10px !important;
  left: unset !important;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:nth-child(5) {
  border-right: unset;
  border-left: 1px solid #eff0f1;
  padding-left: 20px;
  padding-right: 0;
}
body.rtl .page-main-header .main-header-right .nav-right .profile-dropdown {
  right: unset;
  left: -10px;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i::before {
  content: "\\f104";
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .main-header-left .logo-wrapper {
  padding-left: unset;
  padding-right: 10px;
}
body.rtl .authentication-box .back-btn {
  float: left;
}
body.rtl .authentication-box .form-footer > span {
  padding-right: unset;
  padding-left: 20px;
}
body.rtl .authentication-box .form-horizontal .form-terms .custom-control {
  padding-left: unset;
  padding-right: 24px;
}
body.rtl .authentication-box .tab2-card .nav-tabs .nav-link svg {
  margin-left: 5px;
  margin-right: unset;
}
body.rtl .needs-validation .form-group {
  text-align: right;
}
body.rtl .needs-validation .form-group .checkbox {
  padding-right: 0;
  padding-left: unset;
}
body.rtl .needs-validation .permission-block .attribute-blocks {
  padding-right: 15px;
  padding-left: unset;
  text-align: right;
}
body.rtl .needs-validation .permission-block .attribute-blocks .row {
  padding-right: 20px;
  padding-left: unset;
}
body.rtl .needs-validation .checkbox {
  right: 0;
  margin-left: -16px;
}
body.rtl .needs-validation .checkbox label {
  padding-right: 16px;
  padding-left: unset;
}
body.rtl .needs-validation .checkbox label::before {
  right: 0;
  left: unset;
  margin-left: unset;
  margin-right: -16px;
}
body.rtl .needs-validation .radio-animated label {
  margin-left: 20px;
  margin-right: unset;
}
body.rtl .modal-footer > :not(:last-child) {
  margin-left: 0.25rem;
  margin-right: unset;
}
body.rtl .jsgrid-button + .jsgrid-button {
  margin-right: 5px;
  margin-left: unset;
}
body.rtl .custom-theme {
  left: 0;
  right: unset;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
body.rtl .text-end {
  text-align: left !important;
}
body.rtl .br-wrapper {
  text-align: right;
}
body.rtl .card .card-header .card-header-right {
  left: 20px;
  right: unset;
}
body.rtl .card .card-header .card-header-right .card-option {
  text-align: left;
}
body.rtl .card .card-header .card-header-right .card-option.list-unstyled {
  padding-right: 0;
  padding-left: unset;
}
body.rtl code[class*=language-],
body.rtl pre[class*=language-] {
  text-align: right;
}
body.rtl .code-box-copy__btn {
  right: unset;
  left: 11px;
}
body.rtl table thead tr th,
body.rtl table thead tr td,
body.rtl table tbody tr th,
body.rtl table tbody tr td {
  text-align: right;
}
body.rtl .pull-right {
  float: left;
}
body.rtl .status-circle {
  right: 40px;
  left: unset;
}
body.rtl .right-sidebar.show {
  left: 0;
  right: unset;
}
body.rtl .right-sidebar .friend-list-search .fa {
  left: 35px;
  right: unset;
}
body.rtl .right-sidebar .chat-box .about {
  float: right;
  padding-right: 10px;
  padding-left: unset;
  text-align: right;
}
body.rtl .right-sidebar .chat-box .friend-list {
  text-align: right;
}
body.rtl .right-sidebar .chat-box .user-image {
  float: right;
  margin-left: 5px;
  margin-right: 0;
}
body.rtl .nav-menus .search-form input {
  padding: 10px 70px 10px 10px;
}
body.rtl ul.notification-dropdown.onhover-show-div li {
  text-align: right;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6, body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .h6,
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {
  text-align: center;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li {
  text-align: right;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > .sidebar-submenu {
  margin-right: 15px;
  margin-left: unset;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a {
  padding-right: 10px;
  padding-left: unset;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > .fa-circle {
  right: 0;
  left: unset;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header svg {
  margin-right: unset;
  margin-left: 14px;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body {
  margin-right: 255px;
  margin-left: unset;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar.open {
  margin-right: -260px;
  margin-left: unset;
}
body.rtl .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body,
body.rtl .page-wrapper .page-body-wrapper .page-sidebar.open ~ footer {
  margin-right: 0;
}
body.rtl .page-wrapper .page-body-wrapper .page-header .row h3, body.rtl .page-wrapper .page-body-wrapper .page-header .row .h3 {
  text-align: right;
}
body.rtl .page-wrapper .page-body-wrapper footer {
  margin-right: 255px;
  margin-left: unset;
}
body.rtl .page-wrapper .page-body-wrapper footer p i {
  margin-right: 5px;
  margin-left: unset;
}
body.rtl .page-main-header {
  margin-right: 255px;
  margin-left: unset;
}
body.rtl .page-main-header .main-header-right .nav-right {
  text-align: left;
  padding-right: 0;
  padding-left: 12px;
}
body.rtl .page-main-header .main-header-right .nav-right .profile-dropdown li svg {
  margin-right: unset;
  margin-left: 10px;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li {
  text-align: right;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:before {
  right: 0;
  left: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li .dot {
  left: 17px;
  right: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li .media .dotted-animation {
  left: -3px;
  right: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li .media .dotted-animation .main-circle {
  left: 6px;
  right: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li .media .dotted-animation .animate-circle {
  left: -4px;
  right: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:before {
  left: 10px;
  right: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:after {
  left: 10px;
  right: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li.onhover-dropdown:last-child {
  padding-left: 0;
  padding-right: 20px;
  border-right: none;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:first-child {
  border-right: none;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:after {
  right: 22px;
  left: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:before {
  right: 51px;
  left: unset;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li:last-child {
  padding-right: 20px;
  padding-left: 0;
}
body.rtl .page-main-header .main-header-right .nav-right > ul > li i.ms-2 {
  margin-right: 0.5rem !important;
  margin-left: unset !important;
}
body.rtl .page-main-header .main-header-right .nav-right .language-dropdown {
  text-align: right;
}
body.rtl .page-main-header .main-header-right .nav-right .language-dropdown li a i {
  margin-left: 10px;
}
body.rtl .page-main-header .main-header-right .nav-right .profile-dropdown li a svg {
  margin-right: unset;
  margin-left: 10px;
}
body.rtl .page-main-header .main-header-right .mobile-sidebar {
  padding-right: 20px;
}
body.rtl .page-main-header.open {
  margin-right: 0;
}
body.rtl ul.notification-dropdown.onhover-show-div {
  right: initial;
  left: -30px;
  padding: 0;
}
body.rtl ul.notification-dropdown.onhover-show-div:before {
  right: inherit !important;
  left: 35px !important;
}
body.rtl ul.notification-dropdown.onhover-show-div:after {
  right: inherit !important;
  left: 35px !important;
}
body.rtl ul.notification-dropdown.onhover-show-div li {
  margin-right: 0 !important;
}
body.rtl ul.notification-dropdown.onhover-show-div li span.badge {
  margin-left: unset !important;
}
body.rtl ul.notification-dropdown.onhover-show-div li span svg {
  margin-right: unset;
  margin-left: 10px;
}
body.rtl ul.notification-dropdown.onhover-show-div li .notification-icon {
  margin-left: 20px;
  margin-right: unset;
}
body.rtl .owl-carousel {
  direction: ltr;
}
body.rtl .media .media-body {
  text-align: right;
}
body.rtl .order-graph .order-graph-bottom h6, body.rtl .order-graph .order-graph-bottom .h6 {
  margin-right: 15px !important;
  margin-left: 30px;
}
body.rtl .latest-order-table .btn {
  float: right;
}
body.rtl .product-physical table tr th:nth-child(2),
body.rtl .product-physical table tr td:nth-child(2) {
  text-align: right;
}
body.rtl .product-page-details .color-variant,
body.rtl .product-page-details .size-box,
body.rtl .product-right .color-variant,
body.rtl .product-right .size-box {
  text-align: right;
}
body.rtl .add-product-form .qty-box .input-group .input-group-append .btn {
  border-right: none !important;
  border-left: 1px solid #dddddd !important;
}
body.rtl .add-product-form .qty-box .input-group .btn-primary.bootstrap-touchspin-down {
  border-left: none !important;
  border-right: 1px solid #dddddd !important;
}
body.rtl .add-product-form .offset-sm-4 {
  text-align: right;
}
body.rtl .timer {
  float: right;
}
body.rtl .timer ~ .m-t-15 {
  clear: both;
  text-align: right;
  padding-top: 15px;
}
body.rtl .timer span .padding-l {
  right: 35px;
  left: unset;
  padding-right: 0;
}
body.rtl .product-list table tr td,
body.rtl .product-list table tr th,
body.rtl .report-table table tr td,
body.rtl .report-table table tr th {
  text-align: right !important;
}
body.rtl .product-list table tr td:last-child,
body.rtl .product-list table tr th:last-child,
body.rtl .report-table table tr td:last-child,
body.rtl .report-table table tr th:last-child {
  text-align: center !important;
}
body.rtl .dropzone .dz-preview .dz-error-mark,
body.rtl .dropzone .dz-preview .dz-success-mark {
  left: unset;
  right: 48%;
  margin-right: -27px;
  margin-left: unset;
}
body.rtl .dropzone.dz-clickable .dz-message * {
  text-align: center;
}
body.rtl .digital-add .col-form-label {
  display: block;
  text-align: right;
}
body.rtl .dataTables_wrapper .dataTables_filter input[type=search] {
  margin-right: 10px;
  margin-left: unset;
}
body.rtl .dataTables_wrapper table.dataTable .vendor-list img {
  margin-left: 20px;
  margin-right: unset;
}
body.rtl .category-table table tr td:nth-child(3),
body.rtl .category-table table tr th:nth-child(3) {
  text-align: right;
}
body.rtl .media-table table tr td:last-child,
body.rtl .media-table table tr th:last-child {
  text-align: right !important;
}
body.rtl .profile-details h5, body.rtl .profile-details .h5 {
  text-align: center;
}
body.rtl .account-setting {
  text-align: right;
}
@media only screen and (max-width: 991px) {
  body.rtl .product-page-details {
    text-align: right !important;
  }
  body.rtl .page-wrapper .page-main-header {
    margin-right: 0;
  }
  body.rtl .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body,
  body.rtl .page-wrapper .page-body-wrapper .page-sidebar ~ footer {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  body.rtl .needs-validation .form-group .checkbox {
    padding-right: 15px;
    padding-left: unset;
  }
  body.rtl .page-wrapper .page-body-wrapper footer p {
    text-align: center;
  }
}
@media only screen and (max-width: 575px) {
  body.rtl .add-product-form .form-group fieldset {
    padding-left: 12px;
    padding-right: 0;
  }
  body.rtl .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-control-plaintext {
    left: unset;
    right: 0;
  }
  body.rtl ul.notification-dropdown.onhover-show-div {
    right: unset;
    left: -112px;
  }
  body.rtl ul.notification-dropdown.onhover-show-div::before, body.rtl ul.notification-dropdown.onhover-show-div::after {
    right: unset !important;
    left: 135px !important;
  }
}
@media only screen and (max-width: 360px) {
  body.rtl .page-wrapper .page-main-header .main-header-right .nav-right > ul > li .dot {
    left: 13px;
    right: unset;
  }
  body.rtl .product-right .timer {
    padding: 15px 30px 15px 0;
  }
}
@media (min-width: 1200px) {
  body.rtl .offset-xl-3 {
    margin-right: 25%;
    margin-left: unset;
  }
}

/**=====================
    RTL CSS End
==========================**/
.flag-icon-background, .flag-icon {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
}

.flag-icon {
  position: relative;
  display: inline-block;
  width: 1.3333333333em;
  line-height: 1em;
}
.flag-icon:before {
  content: " ";
}
.flag-icon.flag-icon-squared {
  width: 1em;
}

.flag-icon-es-ct {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.flag-icon-es-ct.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.flag-icon-eu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.flag-icon-eu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.flag-icon-gb-eng {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.flag-icon-gb-eng.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.flag-icon-gb-nir {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.flag-icon-gb-nir.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.flag-icon-gb-sct {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.flag-icon-gb-sct.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.flag-icon-gb-wls {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.flag-icon-gb-wls.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.flag-icon-un {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.flag-icon-un.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.flag-icon-ad {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.flag-icon-ad.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

.flag-icon-ae {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.flag-icon-ae.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

.flag-icon-af {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.flag-icon-af.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

.flag-icon-ag {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.flag-icon-ag.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

.flag-icon-ai {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.flag-icon-ai.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

.flag-icon-al {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.flag-icon-al.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.flag-icon-am {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}
.flag-icon-am.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

.flag-icon-ao {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.flag-icon-ao.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.flag-icon-aq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.flag-icon-aq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.flag-icon-ar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.flag-icon-ar.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

.flag-icon-as {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.flag-icon-as.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

.flag-icon-at {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
.flag-icon-at.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.flag-icon-au {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.flag-icon-au.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

.flag-icon-aw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.flag-icon-aw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

.flag-icon-ax {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.flag-icon-ax.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.flag-icon-az {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}
.flag-icon-az.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

.flag-icon-ba {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}
.flag-icon-ba.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}

.flag-icon-bb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}
.flag-icon-bb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

.flag-icon-bd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}
.flag-icon-bd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.flag-icon-be {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.flag-icon-be.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

.flag-icon-bf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}
.flag-icon-bf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

.flag-icon-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}
.flag-icon-bg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.flag-icon-bh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}
.flag-icon-bh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.flag-icon-bi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}
.flag-icon-bi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

.flag-icon-bj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}
.flag-icon-bj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

.flag-icon-bl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}
.flag-icon-bl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.flag-icon-bm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}
.flag-icon-bm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}

.flag-icon-bn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}
.flag-icon-bn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

.flag-icon-bo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}
.flag-icon-bo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.flag-icon-bq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}
.flag-icon-bq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

.flag-icon-br {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}
.flag-icon-br.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}

.flag-icon-bs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}
.flag-icon-bs.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}

.flag-icon-bt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}
.flag-icon-bt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}

.flag-icon-bv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}
.flag-icon-bv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}

.flag-icon-bw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}
.flag-icon-bw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}

.flag-icon-by {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}
.flag-icon-by.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}

.flag-icon-bz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}
.flag-icon-bz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}

.flag-icon-ca {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}
.flag-icon-ca.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}

.flag-icon-cc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}
.flag-icon-cc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}

.flag-icon-cd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}
.flag-icon-cd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
}

.flag-icon-cf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}
.flag-icon-cf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}

.flag-icon-cg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}
.flag-icon-cg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}

.flag-icon-ch {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}
.flag-icon-ch.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
}

.flag-icon-ci {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
}
.flag-icon-ci.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
}

.flag-icon-ck {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
}
.flag-icon-ck.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
}

.flag-icon-cl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
}
.flag-icon-cl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
}

.flag-icon-cm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
}
.flag-icon-cm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
}

.flag-icon-cn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
}
.flag-icon-cn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
}

.flag-icon-co {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
}
.flag-icon-co.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
}

.flag-icon-cr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
}
.flag-icon-cr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
}

.flag-icon-cu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
}
.flag-icon-cu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
}

.flag-icon-cv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
}
.flag-icon-cv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
}

.flag-icon-cw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
}
.flag-icon-cw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
}

.flag-icon-cx {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
}
.flag-icon-cx.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
}

.flag-icon-cy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
}
.flag-icon-cy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
}

.flag-icon-cz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
}
.flag-icon-cz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
}

.flag-icon-de {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
}
.flag-icon-de.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
}

.flag-icon-dj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
}
.flag-icon-dj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
}

.flag-icon-dk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
}
.flag-icon-dk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
}

.flag-icon-dm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
}
.flag-icon-dm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
}

.flag-icon-do {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
}
.flag-icon-do.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
}

.flag-icon-dz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
}
.flag-icon-dz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
}

.flag-icon-ec {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
}
.flag-icon-ec.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
}

.flag-icon-ee {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
}
.flag-icon-ee.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
}

.flag-icon-eg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
}
.flag-icon-eg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
}

.flag-icon-eh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
}
.flag-icon-eh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
}

.flag-icon-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
}
.flag-icon-er.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
}

.flag-icon-es {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
}
.flag-icon-es.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
}

.flag-icon-et {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
}
.flag-icon-et.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
}

.flag-icon-fi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
}
.flag-icon-fi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
}

.flag-icon-fj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
}
.flag-icon-fj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
}

.flag-icon-fk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
}
.flag-icon-fk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
}

.flag-icon-fm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
}
.flag-icon-fm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
}

.flag-icon-fo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
}
.flag-icon-fo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
}

.flag-icon-fr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
}
.flag-icon-fr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
}

.flag-icon-ga {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
}
.flag-icon-ga.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
}

.flag-icon-gb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
}
.flag-icon-gb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
}

.flag-icon-gd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
}
.flag-icon-gd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
}

.flag-icon-ge {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
}
.flag-icon-ge.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
}

.flag-icon-gf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
}
.flag-icon-gf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
}

.flag-icon-gg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
}
.flag-icon-gg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
}

.flag-icon-gh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
}
.flag-icon-gh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
}

.flag-icon-gi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
}
.flag-icon-gi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
}

.flag-icon-gl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
}
.flag-icon-gl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
}

.flag-icon-gm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
}
.flag-icon-gm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
}

.flag-icon-gn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
}
.flag-icon-gn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
}

.flag-icon-gp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
}
.flag-icon-gp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
}

.flag-icon-gq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
}
.flag-icon-gq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
}

.flag-icon-gr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
}
.flag-icon-gr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
}

.flag-icon-gs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
}
.flag-icon-gs.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
}

.flag-icon-gt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
}
.flag-icon-gt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
}

.flag-icon-gu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_118___});
}
.flag-icon-gu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_118___});
}

.flag-icon-gw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_119___});
}
.flag-icon-gw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_119___});
}

.flag-icon-gy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_120___});
}
.flag-icon-gy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_120___});
}

.flag-icon-hk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_121___});
}
.flag-icon-hk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_121___});
}

.flag-icon-hm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_122___});
}
.flag-icon-hm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_122___});
}

.flag-icon-hn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_123___});
}
.flag-icon-hn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_123___});
}

.flag-icon-hr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_124___});
}
.flag-icon-hr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_124___});
}

.flag-icon-ht {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_125___});
}
.flag-icon-ht.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_125___});
}

.flag-icon-hu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_126___});
}
.flag-icon-hu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_126___});
}

.flag-icon-id {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_127___});
}
.flag-icon-id.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_127___});
}

.flag-icon-ie {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_128___});
}
.flag-icon-ie.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_128___});
}

.flag-icon-il {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_129___});
}
.flag-icon-il.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_129___});
}

.flag-icon-im {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_130___});
}
.flag-icon-im.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_130___});
}

.flag-icon-in {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_131___});
}
.flag-icon-in.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_131___});
}

.flag-icon-io {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_132___});
}
.flag-icon-io.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_132___});
}

.flag-icon-iq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_133___});
}
.flag-icon-iq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_133___});
}

.flag-icon-ir {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_134___});
}
.flag-icon-ir.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_134___});
}

.flag-icon-is {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_135___});
}
.flag-icon-is.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_135___});
}

.flag-icon-it {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_136___});
}
.flag-icon-it.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_136___});
}

.flag-icon-je {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_137___});
}
.flag-icon-je.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_137___});
}

.flag-icon-jm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_138___});
}
.flag-icon-jm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_138___});
}

.flag-icon-jo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_139___});
}
.flag-icon-jo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_139___});
}

.flag-icon-jp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_140___});
}
.flag-icon-jp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_140___});
}

.flag-icon-ke {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_141___});
}
.flag-icon-ke.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_141___});
}

.flag-icon-kg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_142___});
}
.flag-icon-kg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_142___});
}

.flag-icon-kh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_143___});
}
.flag-icon-kh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_143___});
}

.flag-icon-ki {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_144___});
}
.flag-icon-ki.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_144___});
}

.flag-icon-km {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_145___});
}
.flag-icon-km.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_145___});
}

.flag-icon-kn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_146___});
}
.flag-icon-kn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_146___});
}

.flag-icon-kp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_147___});
}
.flag-icon-kp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_147___});
}

.flag-icon-kr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_148___});
}
.flag-icon-kr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_148___});
}

.flag-icon-kw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_149___});
}
.flag-icon-kw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_149___});
}

.flag-icon-ky {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_150___});
}
.flag-icon-ky.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_150___});
}

.flag-icon-kz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_151___});
}
.flag-icon-kz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_151___});
}

.flag-icon-la {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_152___});
}
.flag-icon-la.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_152___});
}

.flag-icon-lb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_153___});
}
.flag-icon-lb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_153___});
}

.flag-icon-lc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_154___});
}
.flag-icon-lc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_154___});
}

.flag-icon-li {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_155___});
}
.flag-icon-li.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_155___});
}

.flag-icon-lk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_156___});
}
.flag-icon-lk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_156___});
}

.flag-icon-lr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_157___});
}
.flag-icon-lr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_157___});
}

.flag-icon-ls {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_158___});
}
.flag-icon-ls.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_158___});
}

.flag-icon-lt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_159___});
}
.flag-icon-lt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_159___});
}

.flag-icon-lu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_160___});
}
.flag-icon-lu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_160___});
}

.flag-icon-lv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_161___});
}
.flag-icon-lv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_161___});
}

.flag-icon-ly {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_162___});
}
.flag-icon-ly.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_162___});
}

.flag-icon-ma {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_163___});
}
.flag-icon-ma.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_163___});
}

.flag-icon-mc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_164___});
}
.flag-icon-mc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_164___});
}

.flag-icon-md {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_165___});
}
.flag-icon-md.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_165___});
}

.flag-icon-me {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_166___});
}
.flag-icon-me.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_166___});
}

.flag-icon-mf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_167___});
}
.flag-icon-mf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_167___});
}

.flag-icon-mg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_168___});
}
.flag-icon-mg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_168___});
}

.flag-icon-mh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_169___});
}
.flag-icon-mh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_169___});
}

.flag-icon-mk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_170___});
}
.flag-icon-mk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_170___});
}

.flag-icon-ml {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_171___});
}
.flag-icon-ml.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_171___});
}

.flag-icon-mm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_172___});
}
.flag-icon-mm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_172___});
}

.flag-icon-mn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_173___});
}
.flag-icon-mn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_173___});
}

.flag-icon-mo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_174___});
}
.flag-icon-mo.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_174___});
}

.flag-icon-mp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_175___});
}
.flag-icon-mp.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_175___});
}

.flag-icon-mq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_176___});
}
.flag-icon-mq.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_176___});
}

.flag-icon-mr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_177___});
}
.flag-icon-mr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_177___});
}

.flag-icon-ms {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_178___});
}
.flag-icon-ms.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_178___});
}

.flag-icon-mt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_179___});
}
.flag-icon-mt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_179___});
}

.flag-icon-mu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_180___});
}
.flag-icon-mu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_180___});
}

.flag-icon-mv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_181___});
}
.flag-icon-mv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_181___});
}

.flag-icon-mw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_182___});
}
.flag-icon-mw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_182___});
}

.flag-icon-mx {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_183___});
}
.flag-icon-mx.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_183___});
}

.flag-icon-my {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_184___});
}
.flag-icon-my.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_184___});
}

.flag-icon-mz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_185___});
}
.flag-icon-mz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_185___});
}

.flag-icon-na {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_186___});
}
.flag-icon-na.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_186___});
}

.flag-icon-nc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_187___});
}
.flag-icon-nc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_187___});
}

.flag-icon-ne {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_188___});
}
.flag-icon-ne.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_188___});
}

.flag-icon-nf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_189___});
}
.flag-icon-nf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_189___});
}

.flag-icon-ng {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_190___});
}
.flag-icon-ng.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_190___});
}

.flag-icon-ni {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_191___});
}
.flag-icon-ni.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_191___});
}

.flag-icon-nl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_192___});
}
.flag-icon-nl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_192___});
}

.flag-icon-no {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_193___});
}
.flag-icon-no.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_193___});
}

.flag-icon-np {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_194___});
}
.flag-icon-np.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_194___});
}

.flag-icon-nr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_195___});
}
.flag-icon-nr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_195___});
}

.flag-icon-nu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_196___});
}
.flag-icon-nu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_196___});
}

.flag-icon-nz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_197___});
}
.flag-icon-nz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_197___});
}

.flag-icon-om {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_198___});
}
.flag-icon-om.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_198___});
}

.flag-icon-pa {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_199___});
}
.flag-icon-pa.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_199___});
}

.flag-icon-pe {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_200___});
}
.flag-icon-pe.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_200___});
}

.flag-icon-pf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_201___});
}
.flag-icon-pf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_201___});
}

.flag-icon-pg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_202___});
}
.flag-icon-pg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_202___});
}

.flag-icon-ph {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_203___});
}
.flag-icon-ph.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_203___});
}

.flag-icon-pk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_204___});
}
.flag-icon-pk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_204___});
}

.flag-icon-pl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_205___});
}
.flag-icon-pl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_205___});
}

.flag-icon-pm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_206___});
}
.flag-icon-pm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_206___});
}

.flag-icon-pn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_207___});
}
.flag-icon-pn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_207___});
}

.flag-icon-pr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_208___});
}
.flag-icon-pr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_208___});
}

.flag-icon-ps {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_209___});
}
.flag-icon-ps.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_209___});
}

.flag-icon-pt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_210___});
}
.flag-icon-pt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_210___});
}

.flag-icon-pw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_211___});
}
.flag-icon-pw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_211___});
}

.flag-icon-py {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_212___});
}
.flag-icon-py.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_212___});
}

.flag-icon-qa {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_213___});
}
.flag-icon-qa.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_213___});
}

.flag-icon-re {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_214___});
}
.flag-icon-re.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_214___});
}

.flag-icon-ro {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_215___});
}
.flag-icon-ro.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_215___});
}

.flag-icon-rs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_216___});
}
.flag-icon-rs.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_216___});
}

.flag-icon-ru {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_217___});
}
.flag-icon-ru.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_217___});
}

.flag-icon-rw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_218___});
}
.flag-icon-rw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_218___});
}

.flag-icon-sa {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_219___});
}
.flag-icon-sa.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_219___});
}

.flag-icon-sb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_220___});
}
.flag-icon-sb.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_220___});
}

.flag-icon-sc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_221___});
}
.flag-icon-sc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_221___});
}

.flag-icon-sd {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_222___});
}
.flag-icon-sd.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_222___});
}

.flag-icon-se {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_223___});
}
.flag-icon-se.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_223___});
}

.flag-icon-sg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_224___});
}
.flag-icon-sg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_224___});
}

.flag-icon-sh {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_225___});
}
.flag-icon-sh.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_225___});
}

.flag-icon-si {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_226___});
}
.flag-icon-si.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_226___});
}

.flag-icon-sj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_227___});
}
.flag-icon-sj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_227___});
}

.flag-icon-sk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_228___});
}
.flag-icon-sk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_228___});
}

.flag-icon-sl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_229___});
}
.flag-icon-sl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_229___});
}

.flag-icon-sm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_230___});
}
.flag-icon-sm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_230___});
}

.flag-icon-sn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_231___});
}
.flag-icon-sn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_231___});
}

.flag-icon-so {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_232___});
}
.flag-icon-so.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_232___});
}

.flag-icon-sr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_233___});
}
.flag-icon-sr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_233___});
}

.flag-icon-ss {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_234___});
}
.flag-icon-ss.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_234___});
}

.flag-icon-st {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_235___});
}
.flag-icon-st.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_235___});
}

.flag-icon-sv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_236___});
}
.flag-icon-sv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_236___});
}

.flag-icon-sx {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_237___});
}
.flag-icon-sx.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_237___});
}

.flag-icon-sy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_238___});
}
.flag-icon-sy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_238___});
}

.flag-icon-sz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_239___});
}
.flag-icon-sz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_239___});
}

.flag-icon-tc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_240___});
}
.flag-icon-tc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_240___});
}

.flag-icon-td {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_241___});
}
.flag-icon-td.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_241___});
}

.flag-icon-tf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_242___});
}
.flag-icon-tf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_242___});
}

.flag-icon-tg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_243___});
}
.flag-icon-tg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_243___});
}

.flag-icon-th {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_244___});
}
.flag-icon-th.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_244___});
}

.flag-icon-tj {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_245___});
}
.flag-icon-tj.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_245___});
}

.flag-icon-tk {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_246___});
}
.flag-icon-tk.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_246___});
}

.flag-icon-tl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_247___});
}
.flag-icon-tl.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_247___});
}

.flag-icon-tm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_248___});
}
.flag-icon-tm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_248___});
}

.flag-icon-tn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_249___});
}
.flag-icon-tn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_249___});
}

.flag-icon-to {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_250___});
}
.flag-icon-to.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_250___});
}

.flag-icon-tr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_251___});
}
.flag-icon-tr.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_251___});
}

.flag-icon-tt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_252___});
}
.flag-icon-tt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_252___});
}

.flag-icon-tv {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_253___});
}
.flag-icon-tv.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_253___});
}

.flag-icon-tw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_254___});
}
.flag-icon-tw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_254___});
}

.flag-icon-tz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_255___});
}
.flag-icon-tz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_255___});
}

.flag-icon-ua {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_256___});
}
.flag-icon-ua.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_256___});
}

.flag-icon-ug {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_257___});
}
.flag-icon-ug.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_257___});
}

.flag-icon-um {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_258___});
}
.flag-icon-um.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_258___});
}

.flag-icon-us {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_259___});
}
.flag-icon-us.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_259___});
}

.flag-icon-uy {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_260___});
}
.flag-icon-uy.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_260___});
}

.flag-icon-uz {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_261___});
}
.flag-icon-uz.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_261___});
}

.flag-icon-va {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_262___});
}
.flag-icon-va.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_262___});
}

.flag-icon-vc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_263___});
}
.flag-icon-vc.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_263___});
}

.flag-icon-ve {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_264___});
}
.flag-icon-ve.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_264___});
}

.flag-icon-vg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_265___});
}
.flag-icon-vg.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_265___});
}

.flag-icon-vi {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_266___});
}
.flag-icon-vi.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_266___});
}

.flag-icon-vn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_267___});
}
.flag-icon-vn.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_267___});
}

.flag-icon-vu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_268___});
}
.flag-icon-vu.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_268___});
}

.flag-icon-wf {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_269___});
}
.flag-icon-wf.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_269___});
}

.flag-icon-ws {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_270___});
}
.flag-icon-ws.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_270___});
}

.flag-icon-ye {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_271___});
}
.flag-icon-ye.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_271___});
}

.flag-icon-yt {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_272___});
}
.flag-icon-yt.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_272___});
}

.flag-icon-za {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_273___});
}
.flag-icon-za.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_273___});
}

.flag-icon-zm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_274___});
}
.flag-icon-zm.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_274___});
}

.flag-icon-zw {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_275___});
}
.flag-icon-zw.flag-icon-squared {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_275___});
}

/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: "themify";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_276___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_277___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_278___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_279___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_280___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=icon-],
[class*=" icon-"] {
  font-family: "themify";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  *margin-right: 0.3em;
}

[class^=icon-]:before,
[class*=" icon-"]:before {
  text-decoration: inherit;
  display: inline-block;
  speak: none;
}

/* makes the font 33% larger relative to the icon container */
.icon-large:before {
  vertical-align: -10%;
  font-size: 1.3333333333em;
}

/* makes sure icons active on rollover in links */
a [class^=icon-],
a [class*=" icon-"] {
  display: inline;
}

/* increased font size for icon-large */
[class^=icon-].icon-fixed-width,
[class*=" icon-"].icon-fixed-width {
  display: inline-block;
  width: 1.1428571429em;
  text-align: right;
  padding-right: 0.2857142857em;
}
[class^=icon-].icon-fixed-width.icon-large,
[class*=" icon-"].icon-fixed-width.icon-large {
  width: 1.4285714286em;
}

.icons-ul {
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.icons-ul > li {
  position: relative;
}
.icons-ul .icon-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  text-align: center;
  line-height: inherit;
}

[class^=icon-].hide,
[class*=" icon-"].hide {
  display: none;
}

.icon-muted {
  color: #eeeeee;
}

.icon-light {
  color: white;
}

.icon-dark {
  color: #333333;
}

.icon-border {
  border: solid 1px #eeeeee;
  padding: 0.2em 0.25em 0.15em;
  border-radius: 3px;
}

.icon-2x {
  font-size: 2em;
}
.icon-2x.icon-border {
  border-width: 2px;
  border-radius: 4px;
}

.icon-3x {
  font-size: 3em;
}
.icon-3x.icon-border {
  border-width: 3px;
  border-radius: 5px;
}

.icon-4x {
  font-size: 4em;
}
.icon-4x.icon-border {
  border-width: 4px;
  border-radius: 6px;
}

.icon-5x {
  font-size: 5em;
}
.icon-5x.icon-border {
  border-width: 5px;
  border-radius: 7px;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

[class^=icon-].pull-left,
[class*=" icon-"].pull-left {
  margin-right: 0.3em;
}
[class^=icon-].pull-right,
[class*=" icon-"].pull-right {
  margin-left: 0.3em;
}

/* EXTRAS
 * -------------------------- */
/* Stacked and layered icon */
.icon-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: -35%;
}
.icon-stack [class^=icon-],
.icon-stack [class*=" icon-"] {
  display: block;
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 1em;
  line-height: inherit;
  *line-height: 2em;
}
.icon-stack .icon-stack-base {
  font-size: 2em;
  *line-height: 1em;
}

/* Animated rotating icon */
.icon-spin {
  display: inline-block;
  animation: spin 2s infinite linear;
}

/* Prevent stack and spinners from being taken inline when inside a link */
a .icon-stack,
a .icon-spin {
  display: inline-block;
  text-decoration: none;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
/* Icon rotations and mirroring */
.icon-rotate-90:before {
  transform: rotate(90deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}

.icon-rotate-180:before {
  transform: rotate(180deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
}

.icon-rotate-270:before {
  transform: rotate(270deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.icon-flip-horizontal:before {
  transform: scale(-1, 1);
}

.icon-flip-vertical:before {
  transform: scale(1, -1);
}

/* ensure rotation occurs inside anchor tags */
a .icon-rotate-90:before, a .icon-rotate-180:before, a .icon-rotate-270:before, a .icon-flip-horizontal:before, a .icon-flip-vertical:before {
  display: inline-block;
}

.icon-wand:before {
  content: "\\e600";
}

.icon-volume:before {
  content: "\\e601";
}

.icon-user:before {
  content: "\\e602";
}

.icon-unlock:before {
  content: "\\e603";
}

.icon-unlink:before {
  content: "\\e604";
}

.icon-trash:before {
  content: "\\e605";
}

.icon-thought:before {
  content: "\\e606";
}

.icon-target:before {
  content: "\\e607";
}

.icon-tag:before {
  content: "\\e608";
}

.icon-tablet:before {
  content: "\\e609";
}

.icon-star:before {
  content: "\\e60a";
}

.icon-spray:before {
  content: "\\e60b";
}

.icon-signal:before {
  content: "\\e60c";
}

.icon-shopping-cart:before {
  content: "\\e60d";
}

.icon-shopping-cart-full:before {
  content: "\\e60e";
}

.icon-settings:before {
  content: "\\e60f";
}

.ti-search:before {
  content: "\\e610";
}

.icon-zoom-in:before {
  content: "\\e611";
}

.icon-zoom-out:before {
  content: "\\e612";
}

.icon-cut:before {
  content: "\\e613";
}

.icon-ruler:before {
  content: "\\e614";
}

.icon-ruler-pencil:before {
  content: "\\e615";
}

.icon-ruler-alt:before {
  content: "\\e616";
}

.icon-bookmark:before {
  content: "\\e617";
}

.icon-bookmark-alt:before {
  content: "\\e618";
}

.icon-reload:before {
  content: "\\e619";
}

.icon-plus:before {
  content: "\\e61a";
}

.icon-pin:before {
  content: "\\e61b";
}

.icon-pencil:before {
  content: "\\e61c";
}

.icon-pencil-alt:before {
  content: "\\e61d";
}

.icon-paint-roller:before {
  content: "\\e61e";
}

.icon-paint-bucket:before {
  content: "\\e61f";
}

.icon-na:before {
  content: "\\e620";
}

.icon-mobile:before {
  content: "\\e621";
}

.icon-minus:before {
  content: "\\e622";
}

.icon-medall:before {
  content: "\\e623";
}

.icon-medall-alt:before {
  content: "\\e624";
}

.icon-marker:before {
  content: "\\e625";
}

.icon-marker-alt:before {
  content: "\\e626";
}

.icon-arrow-up:before {
  content: "\\e627";
}

.icon-arrow-right:before {
  content: "\\e628";
}

.icon-arrow-left:before {
  content: "\\e629";
}

.icon-arrow-down:before {
  content: "\\e62a";
}

.icon-lock:before {
  content: "\\e62b";
}

.icon-location-arrow:before {
  content: "\\e62c";
}

.icon-link:before {
  content: "\\e62d";
}

.icon-layout:before {
  content: "\\e62e";
}

.icon-layers:before {
  content: "\\e62f";
}

.icon-layers-alt:before {
  content: "\\e630";
}

.icon-key:before {
  content: "\\e631";
}

.icon-import:before {
  content: "\\e632";
}

.icon-image:before {
  content: "\\e633";
}

.icon-heart:before {
  content: "\\e634";
}

.icon-heart-broken:before {
  content: "\\e635";
}

.icon-hand-stop:before {
  content: "\\e636";
}

.icon-hand-open:before {
  content: "\\e637";
}

.icon-hand-drag:before {
  content: "\\e638";
}

.icon-folder:before {
  content: "\\e639";
}

.icon-flag:before {
  content: "\\e63a";
}

.icon-flag-alt:before {
  content: "\\e63b";
}

.icon-flag-alt-2:before {
  content: "\\e63c";
}

.icon-eye:before {
  content: "\\e63d";
}

.icon-export:before {
  content: "\\e63e";
}

.icon-exchange-vertical:before {
  content: "\\e63f";
}

.icon-desktop:before {
  content: "\\e640";
}

.icon-cup:before {
  content: "\\e641";
}

.icon-crown:before {
  content: "\\e642";
}

.icon-comments:before {
  content: "\\e643";
}

.icon-comment:before {
  content: "\\e644";
}

.icon-comment-alt:before {
  content: "\\e645";
}

.icon-close:before {
  content: "\\e646";
}

.icon-clip:before {
  content: "\\e647";
}

.icon-angle-up:before {
  content: "\\e648";
}

.icon-angle-right:before {
  content: "\\e649";
}

.icon-angle-left:before {
  content: "\\e64a";
}

.icon-angle-down:before {
  content: "\\e64b";
}

.icon-check:before {
  content: "\\e64c";
}

.icon-check-box:before {
  content: "\\e64d";
}

.icon-camera:before {
  content: "\\e64e";
}

.icon-announcement:before {
  content: "\\e64f";
}

.icon-brush:before {
  content: "\\e650";
}

.icon-briefcase:before {
  content: "\\e651";
}

.icon-bolt:before {
  content: "\\e652";
}

.icon-bolt-alt:before {
  content: "\\e653";
}

.icon-blackboard:before {
  content: "\\e654";
}

.icon-bag:before {
  content: "\\e655";
}

.icon-move:before {
  content: "\\e656";
}

.icon-arrows-vertical:before {
  content: "\\e657";
}

.icon-arrows-horizontal:before {
  content: "\\e658";
}

.icon-fullscreen:before {
  content: "\\e659";
}

.icon-arrow-top-right:before {
  content: "\\e65a";
}

.icon-arrow-top-left:before {
  content: "\\e65b";
}

.icon-arrow-circle-up:before {
  content: "\\e65c";
}

.icon-arrow-circle-right:before {
  content: "\\e65d";
}

.icon-arrow-circle-left:before {
  content: "\\e65e";
}

.icon-arrow-circle-down:before {
  content: "\\e65f";
}

.icon-angle-double-up:before {
  content: "\\e660";
}

.icon-angle-double-right:before {
  content: "\\e661";
}

.icon-angle-double-left:before {
  content: "\\e662";
}

.icon-angle-double-down:before {
  content: "\\e663";
}

.icon-zip:before {
  content: "\\e664";
}

.icon-world:before {
  content: "\\e665";
}

.icon-wheelchair:before {
  content: "\\e666";
}

.icon-view-list:before {
  content: "\\e667";
}

.icon-view-list-alt:before {
  content: "\\e668";
}

.icon-view-grid:before {
  content: "\\e669";
}

.icon-uppercase:before {
  content: "\\e66a";
}

.icon-upload:before {
  content: "\\e66b";
}

.icon-underline:before {
  content: "\\e66c";
}

.icon-truck:before {
  content: "\\e66d";
}

.icon-timer:before {
  content: "\\e66e";
}

.icon-ticket:before {
  content: "\\e66f";
}

.icon-thumb-up:before {
  content: "\\e670";
}

.icon-thumb-down:before {
  content: "\\e671";
}

.icon-text:before {
  content: "\\e672";
}

.icon-stats-up:before {
  content: "\\e673";
}

.icon-stats-down:before {
  content: "\\e674";
}

.icon-split-v:before {
  content: "\\e675";
}

.icon-split-h:before {
  content: "\\e676";
}

.icon-smallcap:before {
  content: "\\e677";
}

.icon-shine:before {
  content: "\\e678";
}

.icon-shift-right:before {
  content: "\\e679";
}

.icon-shift-left:before {
  content: "\\e67a";
}

.icon-shield:before {
  content: "\\e67b";
}

.icon-notepad:before {
  content: "\\e67c";
}

.icon-server:before {
  content: "\\e67d";
}

.icon-quote-right:before {
  content: "\\e67e";
}

.icon-quote-left:before {
  content: "\\e67f";
}

.icon-pulse:before {
  content: "\\e680";
}

.icon-printer:before {
  content: "\\e681";
}

.icon-power-off:before {
  content: "\\e682";
}

.icon-plug:before {
  content: "\\e683";
}

.icon-pie-chart:before {
  content: "\\e684";
}

.icon-paragraph:before {
  content: "\\e685";
}

.icon-panel:before {
  content: "\\e686";
}

.icon-package:before {
  content: "\\e687";
}

.icon-music:before {
  content: "\\e688";
}

.icon-music-alt:before {
  content: "\\e689";
}

.icon-mouse:before {
  content: "\\e68a";
}

.icon-mouse-alt:before {
  content: "\\e68b";
}

.icon-money:before {
  content: "\\e68c";
}

.icon-microphone:before {
  content: "\\e68d";
}

.icon-menu:before {
  content: "\\e68e";
}

.icon-menu-alt:before {
  content: "\\e68f";
}

.icon-map:before {
  content: "\\e690";
}

.icon-map-alt:before {
  content: "\\e691";
}

.icon-loop:before {
  content: "\\e692";
}

.icon-location-pin:before {
  content: "\\e693";
}

.icon-list:before {
  content: "\\e694";
}

.icon-light-bulb:before {
  content: "\\e695";
}

.icon-Italic:before {
  content: "\\e696";
}

.icon-info:before {
  content: "\\e697";
}

.icon-infinite:before {
  content: "\\e698";
}

.icon-id-badge:before {
  content: "\\e699";
}

.icon-hummer:before {
  content: "\\e69a";
}

.icon-home:before {
  content: "\\e69b";
}

.icon-help:before {
  content: "\\e69c";
}

.icon-headphone:before {
  content: "\\e69d";
}

.icon-harddrives:before {
  content: "\\e69e";
}

.icon-harddrive:before {
  content: "\\e69f";
}

.icon-gift:before {
  content: "\\e6a0";
}

.icon-game:before {
  content: "\\e6a1";
}

.icon-filter:before {
  content: "\\e6a2";
}

.icon-files:before {
  content: "\\e6a3";
}

.icon-file:before {
  content: "\\e6a4";
}

.icon-eraser:before {
  content: "\\e6a5";
}

.icon-envelope:before {
  content: "\\e6a6";
}

.icon-download:before {
  content: "\\e6a7";
}

.icon-direction:before {
  content: "\\e6a8";
}

.icon-direction-alt:before {
  content: "\\e6a9";
}

.icon-dashboard:before {
  content: "\\e6aa";
}

.icon-control-stop:before {
  content: "\\e6ab";
}

.icon-control-shuffle:before {
  content: "\\e6ac";
}

.icon-control-play:before {
  content: "\\e6ad";
}

.icon-control-pause:before {
  content: "\\e6ae";
}

.icon-control-forward:before {
  content: "\\e6af";
}

.icon-control-backward:before {
  content: "\\e6b0";
}

.icon-cloud:before {
  content: "\\e6b1";
}

.icon-cloud-up:before {
  content: "\\e6b2";
}

.icon-cloud-down:before {
  content: "\\e6b3";
}

.icon-clipboard:before {
  content: "\\e6b4";
}

.icon-car:before {
  content: "\\e6b5";
}

.icon-calendar:before {
  content: "\\e6b6";
}

.icon-book:before {
  content: "\\e6b7";
}

.icon-bell:before {
  content: "\\e6b8";
}

.icon-basketball:before {
  content: "\\e6b9";
}

.icon-bar-chart:before {
  content: "\\e6ba";
}

.icon-bar-chart-alt:before {
  content: "\\e6bb";
}

.icon-back-right:before {
  content: "\\e6bc";
}

.icon-back-left:before {
  content: "\\e6bd";
}

.icon-arrows-corner:before {
  content: "\\e6be";
}

.icon-archive:before {
  content: "\\e6bf";
}

.icon-anchor:before {
  content: "\\e6c0";
}

.icon-align-right:before {
  content: "\\e6c1";
}

.icon-align-left:before {
  content: "\\e6c2";
}

.icon-align-justify:before {
  content: "\\e6c3";
}

.icon-align-center:before {
  content: "\\e6c4";
}

.icon-alert:before {
  content: "\\e6c5";
}

.icon-alarm-clock:before {
  content: "\\e6c6";
}

.icon-agenda:before {
  content: "\\e6c7";
}

.icon-write:before {
  content: "\\e6c8";
}

.icon-window:before {
  content: "\\e6c9";
}

.icon-widgetized:before {
  content: "\\e6ca";
}

.icon-widget:before {
  content: "\\e6cb";
}

.icon-widget-alt:before {
  content: "\\e6cc";
}

.icon-wallet:before {
  content: "\\e6cd";
}

.icon-video-clapper:before {
  content: "\\e6ce";
}

.icon-video-camera:before {
  content: "\\e6cf";
}

.icon-vector:before {
  content: "\\e6d0";
}

.icon-themify-logo:before {
  content: "\\e6d1";
}

.icon-themify-favicon:before {
  content: "\\e6d2";
}

.icon-themify-favicon-alt:before {
  content: "\\e6d3";
}

.icon-support:before {
  content: "\\e6d4";
}

.icon-stamp:before {
  content: "\\e6d5";
}

.icon-split-v-alt:before {
  content: "\\e6d6";
}

.icon-slice:before {
  content: "\\e6d7";
}

.icon-shortcode:before {
  content: "\\e6d8";
}

.icon-shift-right-alt:before {
  content: "\\e6d9";
}

.icon-shift-left-alt:before {
  content: "\\e6da";
}

.icon-ruler-alt-2:before {
  content: "\\e6db";
}

.icon-receipt:before {
  content: "\\e6dc";
}

.icon-pin2:before {
  content: "\\e6dd";
}

.icon-pin-alt:before {
  content: "\\e6de";
}

.icon-pencil-alt2:before {
  content: "\\e6df";
}

.icon-palette:before {
  content: "\\e6e0";
}

.icon-more:before {
  content: "\\e6e1";
}

.icon-more-alt:before {
  content: "\\e6e2";
}

.icon-microphone-alt:before {
  content: "\\e6e3";
}

.icon-magnet:before {
  content: "\\e6e4";
}

.icon-line-double:before {
  content: "\\e6e5";
}

.icon-line-dotted:before {
  content: "\\e6e6";
}

.icon-line-dashed:before {
  content: "\\e6e7";
}

.icon-layout-width-full:before {
  content: "\\e6e8";
}

.icon-layout-width-default:before {
  content: "\\e6e9";
}

.icon-layout-width-default-alt:before {
  content: "\\e6ea";
}

.icon-layout-tab:before {
  content: "\\e6eb";
}

.icon-layout-tab-window:before {
  content: "\\e6ec";
}

.icon-layout-tab-v:before {
  content: "\\e6ed";
}

.icon-layout-tab-min:before {
  content: "\\e6ee";
}

.icon-layout-slider:before {
  content: "\\e6ef";
}

.icon-layout-slider-alt:before {
  content: "\\e6f0";
}

.icon-layout-sidebar-right:before {
  content: "\\e6f1";
}

.icon-layout-sidebar-none:before {
  content: "\\e6f2";
}

.icon-layout-sidebar-left:before {
  content: "\\e6f3";
}

.icon-layout-placeholder:before {
  content: "\\e6f4";
}

.icon-layout-menu:before {
  content: "\\e6f5";
}

.icon-layout-menu-v:before {
  content: "\\e6f6";
}

.icon-layout-menu-separated:before {
  content: "\\e6f7";
}

.icon-layout-menu-full:before {
  content: "\\e6f8";
}

.icon-layout-media-right-alt:before {
  content: "\\e6f9";
}

.icon-layout-media-right:before {
  content: "\\e6fa";
}

.icon-layout-media-overlay:before {
  content: "\\e6fb";
}

.icon-layout-media-overlay-alt:before {
  content: "\\e6fc";
}

.icon-layout-media-overlay-alt-2:before {
  content: "\\e6fd";
}

.icon-layout-media-left-alt:before {
  content: "\\e6fe";
}

.icon-layout-media-left:before {
  content: "\\e6ff";
}

.icon-layout-media-center-alt:before {
  content: "\\e700";
}

.icon-layout-media-center:before {
  content: "\\e701";
}

.icon-layout-list-thumb:before {
  content: "\\e702";
}

.icon-layout-list-thumb-alt:before {
  content: "\\e703";
}

.icon-layout-list-post:before {
  content: "\\e704";
}

.icon-layout-list-large-image:before {
  content: "\\e705";
}

.icon-layout-line-solid:before {
  content: "\\e706";
}

.icon-layout-grid4:before {
  content: "\\e707";
}

.icon-layout-grid3:before {
  content: "\\e708";
}

.icon-layout-grid2:before {
  content: "\\e709";
}

.icon-layout-grid2-thumb:before {
  content: "\\e70a";
}

.icon-layout-cta-right:before {
  content: "\\e70b";
}

.icon-layout-cta-left:before {
  content: "\\e70c";
}

.icon-layout-cta-center:before {
  content: "\\e70d";
}

.icon-layout-cta-btn-right:before {
  content: "\\e70e";
}

.icon-layout-cta-btn-left:before {
  content: "\\e70f";
}

.icon-layout-column4:before {
  content: "\\e710";
}

.icon-layout-column3:before {
  content: "\\e711";
}

.icon-layout-column2:before {
  content: "\\e712";
}

.icon-layout-accordion-separated:before {
  content: "\\e713";
}

.icon-layout-accordion-merged:before {
  content: "\\e714";
}

.icon-layout-accordion-list:before {
  content: "\\e715";
}

.icon-ink-pen:before {
  content: "\\e716";
}

.icon-info-alt:before {
  content: "\\e717";
}

.icon-help-alt:before {
  content: "\\e718";
}

.icon-headphone-alt:before {
  content: "\\e719";
}

.icon-hand-point-up:before {
  content: "\\e71a";
}

.icon-hand-point-right:before {
  content: "\\e71b";
}

.icon-hand-point-left:before {
  content: "\\e71c";
}

.icon-hand-point-down:before {
  content: "\\e71d";
}

.icon-gallery:before {
  content: "\\e71e";
}

.icon-face-smile:before {
  content: "\\e71f";
}

.icon-face-sad:before {
  content: "\\e720";
}

.icon-credit-card:before {
  content: "\\e721";
}

.icon-control-skip-forward:before {
  content: "\\e722";
}

.icon-control-skip-backward:before {
  content: "\\e723";
}

.icon-control-record:before {
  content: "\\e724";
}

.icon-control-eject:before {
  content: "\\e725";
}

.icon-comments-smiley:before {
  content: "\\e726";
}

.icon-brush-alt:before {
  content: "\\e727";
}

.icon-youtube:before {
  content: "\\e728";
}

.icon-vimeo:before {
  content: "\\e729";
}

.icon-twitter:before {
  content: "\\e72a";
}

.icon-time:before {
  content: "\\e72b";
}

.icon-tumblr:before {
  content: "\\e72c";
}

.icon-skype:before {
  content: "\\e72d";
}

.icon-share:before {
  content: "\\e72e";
}

.icon-share-alt:before {
  content: "\\e72f";
}

.icon-rocket:before {
  content: "\\e730";
}

.icon-pinterest:before {
  content: "\\e731";
}

.icon-new-window:before {
  content: "\\e732";
}

.icon-microsoft:before {
  content: "\\e733";
}

.icon-list-ol:before {
  content: "\\e734";
}

.icon-linkedin:before {
  content: "\\e735";
}

.icon-layout-sidebar-2:before {
  content: "\\e736";
}

.icon-layout-grid4-alt:before {
  content: "\\e737";
}

.icon-layout-grid3-alt:before {
  content: "\\e738";
}

.icon-layout-grid2-alt:before {
  content: "\\e739";
}

.icon-layout-column4-alt:before {
  content: "\\e73a";
}

.icon-layout-column3-alt:before {
  content: "\\e73b";
}

.icon-layout-column2-alt:before {
  content: "\\e73c";
}

.icon-instagram:before {
  content: "\\e73d";
}

.icon-google:before {
  content: "\\e73e";
}

.icon-github:before {
  content: "\\e73f";
}

.icon-flickr:before {
  content: "\\e740";
}

.icon-facebook:before {
  content: "\\e741";
}

.icon-dropbox:before {
  content: "\\e742";
}

.icon-dribbble:before {
  content: "\\e743";
}

.icon-apple:before {
  content: "\\e744";
}

.icon-android:before {
  content: "\\e745";
}

.icon-save:before {
  content: "\\e746";
}

.icon-save-alt:before {
  content: "\\e747";
}

.icon-yahoo:before {
  content: "\\e748";
}

.icon-wordpress:before {
  content: "\\e749";
}

.icon-vimeo-alt:before {
  content: "\\e74a";
}

.icon-twitter-alt:before {
  content: "\\e74b";
}

.icon-tumblr-alt:before {
  content: "\\e74c";
}

.icon-trello:before {
  content: "\\e74d";
}

.icon-stack-overflow:before {
  content: "\\e74e";
}

.icon-soundcloud:before {
  content: "\\e74f";
}

.icon-sharethis:before {
  content: "\\e750";
}

.icon-sharethis-alt:before {
  content: "\\e751";
}

.icon-reddit:before {
  content: "\\e752";
}

.icon-pinterest-alt:before {
  content: "\\e753";
}

.icon-microsoft-alt:before {
  content: "\\e754";
}

.icon-linux:before {
  content: "\\e755";
}

.icon-jsfiddle:before {
  content: "\\e756";
}

.icon-joomla:before {
  content: "\\e757";
}

.icon-html5:before {
  content: "\\e758";
}

.icon-flickr-alt:before {
  content: "\\e759";
}

.icon-email:before {
  content: "\\e75a";
}

.icon-drupal:before {
  content: "\\e75b";
}

.icon-dropbox-alt:before {
  content: "\\e75c";
}

.icon-css3:before {
  content: "\\e75d";
}

.icon-rss:before {
  content: "\\e75e";
}

.icon-rss-alt:before {
  content: "\\e75f";
}

/**
 * @package IcoFont by ThemeHunt - https://themehunt.com
 * @version 1.0.0 Beta
 * @author IcoFont http://icofont.com
 * @copyright Copyright (c) 2018 IcoFont
 * @license - http://icofont.com/license/
*/
@font-face {
  font-family: "icofont";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_281___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_282___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_283___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_284___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_285___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.icofont {
  font-family: "IcoFont" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icofont-angry-monster:before {
  content: "\\e901";
}

.icofont-bathtub:before {
  content: "\\e902";
}

.icofont-bird-wings:before {
  content: "\\e903";
}

.icofont-bow:before {
  content: "\\e904";
}

.icofont-brain-alt:before {
  content: "\\e905";
}

.icofont-butterfly-alt:before {
  content: "\\e906";
}

.icofont-castle:before {
  content: "\\e907";
}

.icofont-circuit:before {
  content: "\\e908";
}

.icofont-dart:before {
  content: "\\e909";
}

.icofont-dice-alt:before {
  content: "\\e90a";
}

.icofont-disability-race:before {
  content: "\\e90b";
}

.icofont-diving-goggle:before {
  content: "\\e90c";
}

.icofont-fire-alt:before {
  content: "\\e90d";
}

.icofont-flame-torch:before {
  content: "\\e90e";
}

.icofont-flora-flower:before {
  content: "\\e90f";
}

.icofont-flora:before {
  content: "\\e910";
}

.icofont-gift-box:before {
  content: "\\e911";
}

.icofont-halloween-pumpkin:before {
  content: "\\e912";
}

.icofont-hand-power:before {
  content: "\\e913";
}

.icofont-hand-thunder:before {
  content: "\\e914";
}

.icofont-king-crown:before {
  content: "\\e915";
}

.icofont-king-monster:before {
  content: "\\e916";
}

.icofont-love:before {
  content: "\\e917";
}

.icofont-magician-hat:before {
  content: "\\e918";
}

.icofont-native-american:before {
  content: "\\e919";
}

.icofont-open-eye:before {
  content: "\\e91a";
}

.icofont-owl-look:before {
  content: "\\e91b";
}

.icofont-phoenix:before {
  content: "\\e91c";
}

.icofont-queen-crown:before {
  content: "\\e91d";
}

.icofont-robot-face:before {
  content: "\\e91e";
}

.icofont-sand-clock:before {
  content: "\\e91f";
}

.icofont-shield-alt:before {
  content: "\\e920";
}

.icofont-ship-wheel:before {
  content: "\\e921";
}

.icofont-skull-danger:before {
  content: "\\e922";
}

.icofont-skull-face:before {
  content: "\\e923";
}

.icofont-snail:before {
  content: "\\e924";
}

.icofont-snow-alt:before {
  content: "\\e925";
}

.icofont-snow-flake:before {
  content: "\\e926";
}

.icofont-snowmobile:before {
  content: "\\e927";
}

.icofont-space-shuttle:before {
  content: "\\e928";
}

.icofont-star-shape:before {
  content: "\\e929";
}

.icofont-swirl:before {
  content: "\\e92a";
}

.icofont-tattoo-wing:before {
  content: "\\e92b";
}

.icofont-throne:before {
  content: "\\e92c";
}

.icofont-touch:before {
  content: "\\e92d";
}

.icofont-tree-alt:before {
  content: "\\e92e";
}

.icofont-triangle:before {
  content: "\\e92f";
}

.icofont-unity-hand:before {
  content: "\\e930";
}

.icofont-weed:before {
  content: "\\e931";
}

.icofont-woman-bird:before {
  content: "\\e932";
}

.icofont-animal-bat:before {
  content: "\\e933";
}

.icofont-animal-bear-tracks:before {
  content: "\\e934";
}

.icofont-animal-bear:before {
  content: "\\e935";
}

.icofont-animal-bird-alt:before {
  content: "\\e936";
}

.icofont-animal-bird:before {
  content: "\\e937";
}

.icofont-animal-bone:before {
  content: "\\e938";
}

.icofont-animal-bull:before {
  content: "\\e939";
}

.icofont-animal-camel-alt:before {
  content: "\\e93a";
}

.icofont-animal-camel-head:before {
  content: "\\e93b";
}

.icofont-animal-camel:before {
  content: "\\e93c";
}

.icofont-animal-cat-alt-1:before {
  content: "\\e93d";
}

.icofont-animal-cat-alt-2:before {
  content: "\\e93e";
}

.icofont-animal-cat-alt-3:before {
  content: "\\e93f";
}

.icofont-animal-cat-alt-4:before {
  content: "\\e940";
}

.icofont-animal-cat-with-dog:before {
  content: "\\e941";
}

.icofont-animal-cat:before {
  content: "\\e942";
}

.icofont-animal-cow-head:before {
  content: "\\e943";
}

.icofont-animal-cow:before {
  content: "\\e944";
}

.icofont-animal-crab:before {
  content: "\\e945";
}

.icofont-animal-crocodile:before {
  content: "\\e946";
}

.icofont-animal-deer-head:before {
  content: "\\e947";
}

.icofont-animal-dog-alt:before {
  content: "\\e948";
}

.icofont-animal-dog-barking:before {
  content: "\\e949";
}

.icofont-animal-dog:before {
  content: "\\e94a";
}

.icofont-animal-dolphin:before {
  content: "\\e94b";
}

.icofont-animal-duck-tracks:before {
  content: "\\e94c";
}

.icofont-animal-eagle-head:before {
  content: "\\e94d";
}

.icofont-animal-eaten-fish:before {
  content: "\\e94e";
}

.icofont-animal-elephant-alt:before {
  content: "\\e94f";
}

.icofont-animal-elephant-head-alt:before {
  content: "\\e950";
}

.icofont-animal-elephant-head:before {
  content: "\\e951";
}

.icofont-animal-elephant:before {
  content: "\\e952";
}

.icofont-animal-elk:before {
  content: "\\e953";
}

.icofont-animal-fish-alt-1:before {
  content: "\\e954";
}

.icofont-animal-fish-alt-2:before {
  content: "\\e955";
}

.icofont-animal-fish-alt-3:before {
  content: "\\e956";
}

.icofont-animal-fish-alt-4:before {
  content: "\\e957";
}

.icofont-animal-fish:before {
  content: "\\e958";
}

.icofont-animal-fox-alt:before {
  content: "\\e959";
}

.icofont-animal-fox:before {
  content: "\\e95a";
}

.icofont-animal-frog-tracks:before {
  content: "\\e95b";
}

.icofont-animal-frog:before {
  content: "\\e95c";
}

.icofont-animal-froggy:before {
  content: "\\e95d";
}

.icofont-animal-giraffe-alt:before {
  content: "\\e95e";
}

.icofont-animal-giraffe:before {
  content: "\\e95f";
}

.icofont-animal-goat-head-alt-1:before {
  content: "\\e960";
}

.icofont-animal-goat-head-alt-2:before {
  content: "\\e961";
}

.icofont-animal-goat-head:before {
  content: "\\e962";
}

.icofont-animal-gorilla:before {
  content: "\\e963";
}

.icofont-animal-hen-tracks:before {
  content: "\\e964";
}

.icofont-animal-horse-head-alt-1:before {
  content: "\\e965";
}

.icofont-animal-horse-head-alt-2:before {
  content: "\\e966";
}

.icofont-animal-horse-head:before {
  content: "\\e967";
}

.icofont-animal-horse-tracks:before {
  content: "\\e968";
}

.icofont-animal-jellyfish:before {
  content: "\\e969";
}

.icofont-animal-kangaroo:before {
  content: "\\e96a";
}

.icofont-animal-lemur:before {
  content: "\\e96b";
}

.icofont-animal-lion-alt:before {
  content: "\\e96c";
}

.icofont-animal-lion-head-alt:before {
  content: "\\e96d";
}

.icofont-animal-lion-head:before {
  content: "\\e96e";
}

.icofont-animal-lion:before {
  content: "\\e96f";
}

.icofont-animal-monkey-alt-1:before {
  content: "\\e970";
}

.icofont-animal-monkey-alt-2:before {
  content: "\\e971";
}

.icofont-animal-monkey-alt-3:before {
  content: "\\e972";
}

.icofont-animal-monkey:before {
  content: "\\e973";
}

.icofont-animal-octopus-alt:before {
  content: "\\e974";
}

.icofont-animal-octopus:before {
  content: "\\e975";
}

.icofont-animal-owl:before {
  content: "\\e976";
}

.icofont-animal-panda-alt:before {
  content: "\\e977";
}

.icofont-animal-panda:before {
  content: "\\e978";
}

.icofont-animal-panther:before {
  content: "\\e979";
}

.icofont-animal-parrot-lip:before {
  content: "\\e97a";
}

.icofont-animal-parrot:before {
  content: "\\e97b";
}

.icofont-animal-paw:before {
  content: "\\e97c";
}

.icofont-animal-pelican:before {
  content: "\\e97d";
}

.icofont-animal-penguin:before {
  content: "\\e97e";
}

.icofont-animal-pig-alt:before {
  content: "\\e97f";
}

.icofont-animal-pig:before {
  content: "\\e980";
}

.icofont-animal-pigeon-alt:before {
  content: "\\e981";
}

.icofont-animal-pigeon:before {
  content: "\\e982";
}

.icofont-animal-pigeons:before {
  content: "\\e983";
}

.icofont-animal-rabbit-running:before {
  content: "\\e984";
}

.icofont-animal-rat-alt:before {
  content: "\\e985";
}

.icofont-animal-rhino-head:before {
  content: "\\e986";
}

.icofont-animal-rhino:before {
  content: "\\e987";
}

.icofont-animal-rooster:before {
  content: "\\e988";
}

.icofont-animal-seahorse:before {
  content: "\\e989";
}

.icofont-animal-seal:before {
  content: "\\e98a";
}

.icofont-animal-shrimp:before {
  content: "\\e98b";
}

.icofont-animal-snail-alt-1:before {
  content: "\\e98c";
}

.icofont-animal-snail-alt-2:before {
  content: "\\e98d";
}

.icofont-animal-snail:before {
  content: "\\e98e";
}

.icofont-animal-snake:before {
  content: "\\e98f";
}

.icofont-animal-squid:before {
  content: "\\e990";
}

.icofont-animal-squirrel:before {
  content: "\\e991";
}

.icofont-animal-tiger-alt:before {
  content: "\\e992";
}

.icofont-animal-tiger:before {
  content: "\\e993";
}

.icofont-animal-turtle:before {
  content: "\\e994";
}

.icofont-animal-whale:before {
  content: "\\e995";
}

.icofont-animal-woodpecker:before {
  content: "\\e996";
}

.icofont-animal-zebra:before {
  content: "\\e997";
}

.icofont-brand-acer:before {
  content: "\\e998";
}

.icofont-brand-adidas:before {
  content: "\\e999";
}

.icofont-brand-adobe:before {
  content: "\\e99a";
}

.icofont-brand-air-new-zealand:before {
  content: "\\e99b";
}

.icofont-brand-airbnb:before {
  content: "\\e99c";
}

.icofont-brand-aircell:before {
  content: "\\e99d";
}

.icofont-brand-airtel:before {
  content: "\\e99e";
}

.icofont-brand-alcatel:before {
  content: "\\e99f";
}

.icofont-brand-alibaba:before {
  content: "\\e9a0";
}

.icofont-brand-aliexpress:before {
  content: "\\e9a1";
}

.icofont-brand-alipay:before {
  content: "\\e9a2";
}

.icofont-brand-amazon:before {
  content: "\\e9a3";
}

.icofont-brand-amd:before {
  content: "\\e9a4";
}

.icofont-brand-american-airlines:before {
  content: "\\e9a5";
}

.icofont-brand-android-robot:before {
  content: "\\e9a6";
}

.icofont-brand-android:before {
  content: "\\e9a7";
}

.icofont-brand-aol:before {
  content: "\\e9a8";
}

.icofont-brand-apple:before {
  content: "\\e9a9";
}

.icofont-brand-appstore:before {
  content: "\\e9aa";
}

.icofont-brand-asus:before {
  content: "\\e9ab";
}

.icofont-brand-ati:before {
  content: "\\e9ac";
}

.icofont-brand-att:before {
  content: "\\e9ad";
}

.icofont-brand-audi:before {
  content: "\\e9ae";
}

.icofont-brand-axiata:before {
  content: "\\e9af";
}

.icofont-brand-bada:before {
  content: "\\e9b0";
}

.icofont-brand-bbc:before {
  content: "\\e9b1";
}

.icofont-brand-bing:before {
  content: "\\e9b2";
}

.icofont-brand-blackberry:before {
  content: "\\e9b3";
}

.icofont-brand-bmw:before {
  content: "\\e9b4";
}

.icofont-brand-box:before {
  content: "\\e9b5";
}

.icofont-brand-burger-king:before {
  content: "\\e9b6";
}

.icofont-brand-business-insider:before {
  content: "\\e9b7";
}

.icofont-brand-buzzfeed:before {
  content: "\\e9b8";
}

.icofont-brand-cannon:before {
  content: "\\e9b9";
}

.icofont-brand-casio:before {
  content: "\\e9ba";
}

.icofont-brand-china-mobile:before {
  content: "\\e9bb";
}

.icofont-brand-china-telecom:before {
  content: "\\e9bc";
}

.icofont-brand-china-unicom:before {
  content: "\\e9bd";
}

.icofont-brand-cisco:before {
  content: "\\e9be";
}

.icofont-brand-citibank:before {
  content: "\\e9bf";
}

.icofont-brand-cnet:before {
  content: "\\e9c0";
}

.icofont-brand-cnn:before {
  content: "\\e9c1";
}

.icofont-brand-cocal-cola:before {
  content: "\\e9c2";
}

.icofont-brand-compaq:before {
  content: "\\e9c3";
}

.icofont-brand-copy:before {
  content: "\\e9c4";
}

.icofont-brand-debian:before {
  content: "\\e9c5";
}

.icofont-brand-delicious:before {
  content: "\\e9c6";
}

.icofont-brand-dell:before {
  content: "\\e9c7";
}

.icofont-brand-designbump:before {
  content: "\\e9c8";
}

.icofont-brand-designfloat:before {
  content: "\\e9c9";
}

.icofont-brand-disney:before {
  content: "\\e9ca";
}

.icofont-brand-dodge:before {
  content: "\\e9cb";
}

.icofont-brand-dove:before {
  content: "\\e9cc";
}

.icofont-brand-ebay:before {
  content: "\\e9cd";
}

.icofont-brand-eleven:before {
  content: "\\e9ce";
}

.icofont-brand-emirates:before {
  content: "\\e9cf";
}

.icofont-brand-espn:before {
  content: "\\e9d0";
}

.icofont-brand-etihad-airways:before {
  content: "\\e9d1";
}

.icofont-brand-etisalat:before {
  content: "\\e9d2";
}

.icofont-brand-etsy:before {
  content: "\\e9d3";
}

.icofont-brand-facebook:before {
  content: "\\e9d4";
}

.icofont-brand-fastrack:before {
  content: "\\e9d5";
}

.icofont-brand-fedex:before {
  content: "\\e9d6";
}

.icofont-brand-ferrari:before {
  content: "\\e9d7";
}

.icofont-brand-fitbit:before {
  content: "\\e9d8";
}

.icofont-brand-flikr:before {
  content: "\\e9d9";
}

.icofont-brand-forbes:before {
  content: "\\e9da";
}

.icofont-brand-foursquare:before {
  content: "\\e9db";
}

.icofont-brand-fox:before {
  content: "\\e9dc";
}

.icofont-brand-foxconn:before {
  content: "\\e9dd";
}

.icofont-brand-fujitsu:before {
  content: "\\e9de";
}

.icofont-brand-general-electric:before {
  content: "\\e9df";
}

.icofont-brand-gillette:before {
  content: "\\e9e0";
}

.icofont-brand-gizmodo:before {
  content: "\\e9e1";
}

.icofont-brand-gnome:before {
  content: "\\e9e2";
}

.icofont-brand-google:before {
  content: "\\e9e3";
}

.icofont-brand-gopro:before {
  content: "\\e9e4";
}

.icofont-brand-gucci:before {
  content: "\\e9e5";
}

.icofont-brand-hallmark:before {
  content: "\\e9e6";
}

.icofont-brand-hi5:before {
  content: "\\e9e7";
}

.icofont-brand-honda:before {
  content: "\\e9e8";
}

.icofont-brand-hp:before {
  content: "\\e9e9";
}

.icofont-brand-hsbc:before {
  content: "\\e9ea";
}

.icofont-brand-htc:before {
  content: "\\e9eb";
}

.icofont-brand-huawei:before {
  content: "\\e9ec";
}

.icofont-brand-hulu:before {
  content: "\\e9ed";
}

.icofont-brand-hyundai:before {
  content: "\\e9ee";
}

.icofont-brand-ibm:before {
  content: "\\e9ef";
}

.icofont-brand-icofont:before {
  content: "\\e9f0";
}

.icofont-brand-icq:before {
  content: "\\e9f1";
}

.icofont-brand-ikea:before {
  content: "\\e9f2";
}

.icofont-brand-imdb:before {
  content: "\\e9f3";
}

.icofont-brand-indiegogo:before {
  content: "\\e9f4";
}

.icofont-brand-intel:before {
  content: "\\e9f5";
}

.icofont-brand-ipair:before {
  content: "\\e9f6";
}

.icofont-brand-jaguar:before {
  content: "\\e9f7";
}

.icofont-brand-java:before {
  content: "\\e9f8";
}

.icofont-brand-joomshaper:before {
  content: "\\e9f9";
}

.icofont-brand-kickstarter:before {
  content: "\\e9fa";
}

.icofont-brand-kik:before {
  content: "\\e9fb";
}

.icofont-brand-lastfm:before {
  content: "\\e9fc";
}

.icofont-brand-lego:before {
  content: "\\e9fd";
}

.icofont-brand-lenovo:before {
  content: "\\e9fe";
}

.icofont-brand-levis:before {
  content: "\\e9ff";
}

.icofont-brand-lexus:before {
  content: "\\ea00";
}

.icofont-brand-lg:before {
  content: "\\ea01";
}

.icofont-brand-life-hacker:before {
  content: "\\ea02";
}

.icofont-brand-line-messenger:before {
  content: "\\ea03";
}

.icofont-brand-linkedin:before {
  content: "\\ea04";
}

.icofont-brand-linux-mint:before {
  content: "\\ea05";
}

.icofont-brand-linux:before {
  content: "\\ea06";
}

.icofont-brand-lionix:before {
  content: "\\ea07";
}

.icofont-brand-live-messenger:before {
  content: "\\ea08";
}

.icofont-brand-loreal:before {
  content: "\\ea09";
}

.icofont-brand-louis-vuitton:before {
  content: "\\ea0a";
}

.icofont-brand-mac-os:before {
  content: "\\ea0b";
}

.icofont-brand-marvel-app:before {
  content: "\\ea0c";
}

.icofont-brand-mashable:before {
  content: "\\ea0d";
}

.icofont-brand-mazda:before {
  content: "\\ea0e";
}

.icofont-brand-mcdonals:before {
  content: "\\ea0f";
}

.icofont-brand-mercedes:before {
  content: "\\ea10";
}

.icofont-brand-micromax:before {
  content: "\\ea11";
}

.icofont-brand-microsoft:before {
  content: "\\ea12";
}

.icofont-brand-mobileme:before {
  content: "\\ea13";
}

.icofont-brand-mobily:before {
  content: "\\ea14";
}

.icofont-brand-motorola:before {
  content: "\\ea15";
}

.icofont-brand-msi:before {
  content: "\\ea16";
}

.icofont-brand-mts:before {
  content: "\\ea17";
}

.icofont-brand-myspace:before {
  content: "\\ea18";
}

.icofont-brand-mytv:before {
  content: "\\ea19";
}

.icofont-brand-nasa:before {
  content: "\\ea1a";
}

.icofont-brand-natgeo:before {
  content: "\\ea1b";
}

.icofont-brand-nbc:before {
  content: "\\ea1c";
}

.icofont-brand-nescafe:before {
  content: "\\ea1d";
}

.icofont-brand-nestle:before {
  content: "\\ea1e";
}

.icofont-brand-netflix:before {
  content: "\\ea1f";
}

.icofont-brand-nexus:before {
  content: "\\ea20";
}

.icofont-brand-nike:before {
  content: "\\ea21";
}

.icofont-brand-nokia:before {
  content: "\\ea22";
}

.icofont-brand-nvidia:before {
  content: "\\ea23";
}

.icofont-brand-omega:before {
  content: "\\ea24";
}

.icofont-brand-opensuse:before {
  content: "\\ea25";
}

.icofont-brand-oracle:before {
  content: "\\ea26";
}

.icofont-brand-panasonic:before {
  content: "\\ea27";
}

.icofont-brand-paypal:before {
  content: "\\ea28";
}

.icofont-brand-pepsi:before {
  content: "\\ea29";
}

.icofont-brand-philips:before {
  content: "\\ea2a";
}

.icofont-brand-pizza-hut:before {
  content: "\\ea2b";
}

.icofont-brand-playstation:before {
  content: "\\ea2c";
}

.icofont-brand-puma:before {
  content: "\\ea2d";
}

.icofont-brand-qatar-air:before {
  content: "\\ea2e";
}

.icofont-brand-qvc:before {
  content: "\\ea2f";
}

.icofont-brand-readernaut:before {
  content: "\\ea30";
}

.icofont-brand-redbull:before {
  content: "\\ea31";
}

.icofont-brand-reebok:before {
  content: "\\ea32";
}

.icofont-brand-reuters:before {
  content: "\\ea33";
}

.icofont-brand-samsung:before {
  content: "\\ea34";
}

.icofont-brand-sap:before {
  content: "\\ea35";
}

.icofont-brand-saudia-airlines:before {
  content: "\\ea36";
}

.icofont-brand-scribd:before {
  content: "\\ea37";
}

.icofont-brand-shell:before {
  content: "\\ea38";
}

.icofont-brand-siemens:before {
  content: "\\ea39";
}

.icofont-brand-sk-telecom:before {
  content: "\\ea3a";
}

.icofont-brand-slideshare:before {
  content: "\\ea3b";
}

.icofont-brand-smashing-magazine:before {
  content: "\\ea3c";
}

.icofont-brand-snapchat:before {
  content: "\\ea3d";
}

.icofont-brand-sony-ericsson:before {
  content: "\\ea3e";
}

.icofont-brand-sony:before {
  content: "\\ea3f";
}

.icofont-brand-soundcloud:before {
  content: "\\ea40";
}

.icofont-brand-sprint:before {
  content: "\\ea41";
}

.icofont-brand-squidoo:before {
  content: "\\ea42";
}

.icofont-brand-starbucks:before {
  content: "\\ea43";
}

.icofont-brand-stc:before {
  content: "\\ea44";
}

.icofont-brand-steam:before {
  content: "\\ea45";
}

.icofont-brand-suzuki:before {
  content: "\\ea46";
}

.icofont-brand-symbian:before {
  content: "\\ea47";
}

.icofont-brand-t-mobile:before {
  content: "\\ea48";
}

.icofont-brand-tango:before {
  content: "\\ea49";
}

.icofont-brand-target:before {
  content: "\\ea4a";
}

.icofont-brand-tata-indicom:before {
  content: "\\ea4b";
}

.icofont-brand-techcrunch:before {
  content: "\\ea4c";
}

.icofont-brand-telenor:before {
  content: "\\ea4d";
}

.icofont-brand-teliasonera:before {
  content: "\\ea4e";
}

.icofont-brand-tesla:before {
  content: "\\ea4f";
}

.icofont-brand-the-verge:before {
  content: "\\ea50";
}

.icofont-brand-thenextweb:before {
  content: "\\ea51";
}

.icofont-brand-toshiba:before {
  content: "\\ea52";
}

.icofont-brand-toyota:before {
  content: "\\ea53";
}

.icofont-brand-tribenet:before {
  content: "\\ea54";
}

.icofont-brand-ubuntu:before {
  content: "\\ea55";
}

.icofont-brand-unilever:before {
  content: "\\ea56";
}

.icofont-brand-vaio:before {
  content: "\\ea57";
}

.icofont-brand-verizon:before {
  content: "\\ea58";
}

.icofont-brand-viber:before {
  content: "\\ea59";
}

.icofont-brand-vodafone:before {
  content: "\\ea5a";
}

.icofont-brand-volkswagen:before {
  content: "\\ea5b";
}

.icofont-brand-walmart:before {
  content: "\\ea5c";
}

.icofont-brand-warnerbros:before {
  content: "\\ea5d";
}

.icofont-brand-whatsapp:before {
  content: "\\ea5e";
}

.icofont-brand-wikipedia:before {
  content: "\\ea5f";
}

.icofont-brand-windows:before {
  content: "\\ea60";
}

.icofont-brand-wire:before {
  content: "\\ea61";
}

.icofont-brand-yahoobuzz:before {
  content: "\\ea62";
}

.icofont-brand-yamaha:before {
  content: "\\ea63";
}

.icofont-brand-youtube:before {
  content: "\\ea64";
}

.icofont-brand-zain:before {
  content: "\\ea65";
}

.icofont-bank-alt:before {
  content: "\\ea66";
}

.icofont-barcode:before {
  content: "\\ea67";
}

.icofont-basket:before {
  content: "\\ea68";
}

.icofont-bill-alt:before {
  content: "\\ea69";
}

.icofont-billboard:before {
  content: "\\ea6a";
}

.icofont-briefcase-alt-1:before {
  content: "\\ea6b";
}

.icofont-briefcase-alt-2:before {
  content: "\\ea6c";
}

.icofont-building-alt:before {
  content: "\\ea6d";
}

.icofont-businessman:before {
  content: "\\ea6e";
}

.icofont-businesswoman:before {
  content: "\\ea6f";
}

.icofont-cart-alt:before {
  content: "\\ea70";
}

.icofont-chair:before {
  content: "\\ea71";
}

.icofont-clip:before {
  content: "\\ea72";
}

.icofont-coins:before {
  content: "\\ea73";
}

.icofont-company:before {
  content: "\\ea74";
}

.icofont-contact-add:before {
  content: "\\ea75";
}

.icofont-deal:before {
  content: "\\ea76";
}

.icofont-files:before {
  content: "\\ea77";
}

.icofont-growth:before {
  content: "\\ea78";
}

.icofont-id-card:before {
  content: "\\ea79";
}

.icofont-idea:before {
  content: "\\ea7a";
}

.icofont-list:before {
  content: "\\ea7b";
}

.icofont-meeting-add:before {
  content: "\\ea7c";
}

.icofont-money-bag:before {
  content: "\\ea7d";
}

.icofont-people:before {
  content: "\\ea7e";
}

.icofont-pie-chart:before {
  content: "\\ea7f";
}

.icofont-presentation-alt:before {
  content: "\\ea80";
}

.icofont-stamp:before {
  content: "\\ea81";
}

.icofont-stock-mobile:before {
  content: "\\ea82";
}

.icofont-support:before {
  content: "\\ea83";
}

.icofont-tasks-alt:before {
  content: "\\ea84";
}

.icofont-wheel:before {
  content: "\\ea85";
}

.icofont-chart-arrows-axis:before {
  content: "\\ea86";
}

.icofont-chart-bar-graph:before {
  content: "\\ea87";
}

.icofont-chart-flow-alt-1:before {
  content: "\\ea88";
}

.icofont-chart-flow-alt-2:before {
  content: "\\ea89";
}

.icofont-chart-flow:before {
  content: "\\ea8a";
}

.icofont-chart-histogram-alt:before {
  content: "\\ea8b";
}

.icofont-chart-histogram:before {
  content: "\\ea8c";
}

.icofont-chart-line-alt:before {
  content: "\\ea8d";
}

.icofont-chart-line:before {
  content: "\\ea8e";
}

.icofont-chart-pie-alt:before {
  content: "\\ea8f";
}

.icofont-chart-pie:before {
  content: "\\ea90";
}

.icofont-chart-radar-graph:before {
  content: "\\ea91";
}

.icofont-cur-afghani-false:before {
  content: "\\ea92";
}

.icofont-cur-afghani-minus:before {
  content: "\\ea93";
}

.icofont-cur-afghani-plus:before {
  content: "\\ea94";
}

.icofont-cur-afghani-true:before {
  content: "\\ea95";
}

.icofont-cur-afghani:before {
  content: "\\ea96";
}

.icofont-cur-baht-false:before {
  content: "\\ea97";
}

.icofont-cur-baht-minus:before {
  content: "\\ea98";
}

.icofont-cur-baht-plus:before {
  content: "\\ea99";
}

.icofont-cur-baht-true:before {
  content: "\\ea9a";
}

.icofont-cur-baht:before {
  content: "\\ea9b";
}

.icofont-cur-bitcoin-false:before {
  content: "\\ea9c";
}

.icofont-cur-bitcoin-minus:before {
  content: "\\ea9d";
}

.icofont-cur-bitcoin-plus:before {
  content: "\\ea9e";
}

.icofont-cur-bitcoin-true:before {
  content: "\\ea9f";
}

.icofont-cur-bitcoin:before {
  content: "\\eaa0";
}

.icofont-cur-dollar-flase:before {
  content: "\\eaa1";
}

.icofont-cur-dollar-minus:before {
  content: "\\eaa2";
}

.icofont-cur-dollar-plus:before {
  content: "\\eaa3";
}

.icofont-cur-dollar-true:before {
  content: "\\eaa4";
}

.icofont-cur-dollar:before {
  content: "\\eaa5";
}

.icofont-cur-dong-false:before {
  content: "\\eaa6";
}

.icofont-cur-dong-minus:before {
  content: "\\eaa7";
}

.icofont-cur-dong-plus:before {
  content: "\\eaa8";
}

.icofont-cur-dong-true:before {
  content: "\\eaa9";
}

.icofont-cur-dong:before {
  content: "\\eaaa";
}

.icofont-cur-euro-false:before {
  content: "\\eaab";
}

.icofont-cur-euro-minus:before {
  content: "\\eaac";
}

.icofont-cur-euro-plus:before {
  content: "\\eaad";
}

.icofont-cur-euro-true:before {
  content: "\\eaae";
}

.icofont-cur-euro:before {
  content: "\\eaaf";
}

.icofont-cur-frank-false:before {
  content: "\\eab0";
}

.icofont-cur-frank-minus:before {
  content: "\\eab1";
}

.icofont-cur-frank-plus:before {
  content: "\\eab2";
}

.icofont-cur-frank-true:before {
  content: "\\eab3";
}

.icofont-cur-frank:before {
  content: "\\eab4";
}

.icofont-cur-hryvnia-false:before {
  content: "\\eab5";
}

.icofont-cur-hryvnia-minus:before {
  content: "\\eab6";
}

.icofont-cur-hryvnia-plus:before {
  content: "\\eab7";
}

.icofont-cur-hryvnia-true:before {
  content: "\\eab8";
}

.icofont-cur-hryvnia:before {
  content: "\\eab9";
}

.icofont-cur-lira-false:before {
  content: "\\eaba";
}

.icofont-cur-lira-minus:before {
  content: "\\eabb";
}

.icofont-cur-lira-plus:before {
  content: "\\eabc";
}

.icofont-cur-lira-true:before {
  content: "\\eabd";
}

.icofont-cur-lira:before {
  content: "\\eabe";
}

.icofont-cur-peseta-false:before {
  content: "\\eabf";
}

.icofont-cur-peseta-minus:before {
  content: "\\eac0";
}

.icofont-cur-peseta-plus:before {
  content: "\\eac1";
}

.icofont-cur-peseta-true:before {
  content: "\\eac2";
}

.icofont-cur-peseta:before {
  content: "\\eac3";
}

.icofont-cur-peso-false:before {
  content: "\\eac4";
}

.icofont-cur-peso-minus:before {
  content: "\\eac5";
}

.icofont-cur-peso-plus:before {
  content: "\\eac6";
}

.icofont-cur-peso-true:before {
  content: "\\eac7";
}

.icofont-cur-peso:before {
  content: "\\eac8";
}

.icofont-cur-pound-false:before {
  content: "\\eac9";
}

.icofont-cur-pound-minus:before {
  content: "\\eaca";
}

.icofont-cur-pound-plus:before {
  content: "\\eacb";
}

.icofont-cur-pound-true:before {
  content: "\\eacc";
}

.icofont-cur-pound:before {
  content: "\\eacd";
}

.icofont-cur-renminbi-false:before {
  content: "\\eace";
}

.icofont-cur-renminbi-minus:before {
  content: "\\eacf";
}

.icofont-cur-renminbi-plus:before {
  content: "\\ead0";
}

.icofont-cur-renminbi-true:before {
  content: "\\ead1";
}

.icofont-cur-renminbi:before {
  content: "\\ead2";
}

.icofont-cur-riyal-false:before {
  content: "\\ead3";
}

.icofont-cur-riyal-minus:before {
  content: "\\ead4";
}

.icofont-cur-riyal-plus:before {
  content: "\\ead5";
}

.icofont-cur-riyal-true:before {
  content: "\\ead6";
}

.icofont-cur-riyal:before {
  content: "\\ead7";
}

.icofont-cur-rouble-false:before {
  content: "\\ead8";
}

.icofont-cur-rouble-minus:before {
  content: "\\ead9";
}

.icofont-cur-rouble-plus:before {
  content: "\\eada";
}

.icofont-cur-rouble-true:before {
  content: "\\eadb";
}

.icofont-cur-rouble:before {
  content: "\\eadc";
}

.icofont-cur-rupee-false:before {
  content: "\\eadd";
}

.icofont-cur-rupee-minus:before {
  content: "\\eade";
}

.icofont-cur-rupee-plus:before {
  content: "\\eadf";
}

.icofont-cur-rupee-true:before {
  content: "\\eae0";
}

.icofont-cur-rupee:before {
  content: "\\eae1";
}

.icofont-cur-taka-false:before {
  content: "\\eae2";
}

.icofont-cur-taka-minus:before {
  content: "\\eae3";
}

.icofont-cur-taka-plus:before {
  content: "\\eae4";
}

.icofont-cur-taka-true:before {
  content: "\\eae5";
}

.icofont-cur-taka:before {
  content: "\\eae6";
}

.icofont-cur-turkish-lira-false:before {
  content: "\\eae7";
}

.icofont-cur-turkish-lira-minus:before {
  content: "\\eae8";
}

.icofont-cur-turkish-lira-plus:before {
  content: "\\eae9";
}

.icofont-cur-turkish-lira-true:before {
  content: "\\eaea";
}

.icofont-cur-turkish-lira:before {
  content: "\\eaeb";
}

.icofont-cur-won-false:before {
  content: "\\eaec";
}

.icofont-cur-won-minus:before {
  content: "\\eaed";
}

.icofont-cur-won-plus:before {
  content: "\\eaee";
}

.icofont-cur-won-true:before {
  content: "\\eaef";
}

.icofont-cur-won:before {
  content: "\\eaf0";
}

.icofont-cur-yen-false:before {
  content: "\\eaf1";
}

.icofont-cur-yen-minus:before {
  content: "\\eaf2";
}

.icofont-cur-yen-plus:before {
  content: "\\eaf3";
}

.icofont-cur-yen-true:before {
  content: "\\eaf4";
}

.icofont-cur-yen:before {
  content: "\\eaf5";
}

.icofont-android-nexus:before {
  content: "\\eaf6";
}

.icofont-android-tablet:before {
  content: "\\eaf7";
}

.icofont-apple-watch:before {
  content: "\\eaf8";
}

.icofont-drwaing-tablet:before {
  content: "\\eaf9";
}

.icofont-earphone:before {
  content: "\\eafa";
}

.icofont-flash-drive:before {
  content: "\\eafb";
}

.icofont-game-control:before {
  content: "\\eafc";
}

.icofont-headphone-alt:before {
  content: "\\eafd";
}

.icofont-htc-one:before {
  content: "\\eafe";
}

.icofont-imac:before {
  content: "\\eaff";
}

.icofont-ipad-touch:before {
  content: "\\eb00";
}

.icofont-iphone:before {
  content: "\\eb01";
}

.icofont-ipod-nano:before {
  content: "\\eb02";
}

.icofont-ipod-touch:before {
  content: "\\eb03";
}

.icofont-keyboard-alt:before {
  content: "\\eb04";
}

.icofont-keyboard-wireless:before {
  content: "\\eb05";
}

.icofont-laptop-alt:before {
  content: "\\eb06";
}

.icofont-macbook:before {
  content: "\\eb07";
}

.icofont-magic-mouse:before {
  content: "\\eb08";
}

.icofont-microphone-alt:before {
  content: "\\eb09";
}

.icofont-monitor:before {
  content: "\\eb0a";
}

.icofont-mouse:before {
  content: "\\eb0b";
}

.icofont-nintendo:before {
  content: "\\eb0c";
}

.icofont-playstation:before {
  content: "\\eb0d";
}

.icofont-psvita:before {
  content: "\\eb0e";
}

.icofont-radio-mic:before {
  content: "\\eb0f";
}

.icofont-refrigerator:before {
  content: "\\eb10";
}

.icofont-samsung-galaxy:before {
  content: "\\eb11";
}

.icofont-surface-tablet:before {
  content: "\\eb12";
}

.icofont-washing-machine:before {
  content: "\\eb13";
}

.icofont-wifi-router:before {
  content: "\\eb14";
}

.icofont-wii-u:before {
  content: "\\eb15";
}

.icofont-windows-lumia:before {
  content: "\\eb16";
}

.icofont-wireless-mouse:before {
  content: "\\eb17";
}

.icofont-xbox-360:before {
  content: "\\eb18";
}

.icofont-arrow-down:before {
  content: "\\eb19";
}

.icofont-arrow-left:before {
  content: "\\eb1a";
}

.icofont-arrow-right:before {
  content: "\\eb1b";
}

.icofont-arrow-up:before {
  content: "\\eb1c";
}

.icofont-block-down:before {
  content: "\\eb1d";
}

.icofont-block-left:before {
  content: "\\eb1e";
}

.icofont-block-right:before {
  content: "\\eb1f";
}

.icofont-block-up:before {
  content: "\\eb20";
}

.icofont-bubble-down:before {
  content: "\\eb21";
}

.icofont-bubble-left:before {
  content: "\\eb22";
}

.icofont-bubble-right:before {
  content: "\\eb23";
}

.icofont-bubble-up:before {
  content: "\\eb24";
}

.icofont-caret-down:before {
  content: "\\eb25";
}

.icofont-caret-left:before {
  content: "\\eb26";
}

.icofont-caret-right:before {
  content: "\\eb27";
}

.icofont-caret-up:before {
  content: "\\eb28";
}

.icofont-circled-down:before {
  content: "\\eb29";
}

.icofont-circled-left:before {
  content: "\\eb2a";
}

.icofont-circled-right:before {
  content: "\\eb2b";
}

.icofont-circled-up:before {
  content: "\\eb2c";
}

.icofont-collapse:before {
  content: "\\eb2d";
}

.icofont-cursor-drag:before {
  content: "\\eb2e";
}

.icofont-curved-double-left:before {
  content: "\\eb2f";
}

.icofont-curved-double-right:before {
  content: "\\eb30";
}

.icofont-curved-down:before {
  content: "\\eb31";
}

.icofont-curved-left:before {
  content: "\\eb32";
}

.icofont-curved-right:before {
  content: "\\eb33";
}

.icofont-curved-up:before {
  content: "\\eb34";
}

.icofont-dotted-down:before {
  content: "\\eb35";
}

.icofont-dotted-left:before {
  content: "\\eb36";
}

.icofont-dotted-right:before {
  content: "\\eb37";
}

.icofont-dotted-up:before {
  content: "\\eb38";
}

.icofont-double-left:before {
  content: "\\eb39";
}

.icofont-double-right:before {
  content: "\\eb3a";
}

.icofont-drag:before {
  content: "\\eb3b";
}

.icofont-drag1:before {
  content: "\\eb3c";
}

.icofont-drag2:before {
  content: "\\eb3d";
}

.icofont-drag3:before {
  content: "\\eb3e";
}

.icofont-expand-alt:before {
  content: "\\eb3f";
}

.icofont-hand-down:before {
  content: "\\eb40";
}

.icofont-hand-drag:before {
  content: "\\eb41";
}

.icofont-hand-drag1:before {
  content: "\\eb42";
}

.icofont-hand-drag2:before {
  content: "\\eb43";
}

.icofont-hand-drawn-alt-down:before {
  content: "\\eb44";
}

.icofont-hand-drawn-alt-left:before {
  content: "\\eb45";
}

.icofont-hand-drawn-alt-right:before {
  content: "\\eb46";
}

.icofont-hand-drawn-alt-up:before {
  content: "\\eb47";
}

.icofont-hand-drawn-down:before {
  content: "\\eb48";
}

.icofont-hand-drawn-left:before {
  content: "\\eb49";
}

.icofont-hand-drawn-right:before {
  content: "\\eb4a";
}

.icofont-hand-drawn-up:before {
  content: "\\eb4b";
}

.icofont-hand-left:before {
  content: "\\eb4c";
}

.icofont-hand-right:before {
  content: "\\eb4d";
}

.icofont-hand-up:before {
  content: "\\eb4e";
}

.icofont-line-block-down:before {
  content: "\\eb4f";
}

.icofont-line-block-left:before {
  content: "\\eb50";
}

.icofont-line-block-right:before {
  content: "\\eb51";
}

.icofont-line-block-up:before {
  content: "\\eb52";
}

.icofont-long-arrow-down:before {
  content: "\\eb53";
}

.icofont-long-arrow-left:before {
  content: "\\eb54";
}

.icofont-long-arrow-right:before {
  content: "\\eb55";
}

.icofont-long-arrow-up:before {
  content: "\\eb56";
}

.icofont-rounded-collapse:before {
  content: "\\eb57";
}

.icofont-rounded-double-left:before {
  content: "\\eb58";
}

.icofont-rounded-double-right:before {
  content: "\\eb59";
}

.icofont-rounded-down:before {
  content: "\\eb5a";
}

.icofont-rounded-expand:before {
  content: "\\eb5b";
}

.icofont-rounded-left-down:before {
  content: "\\eb5c";
}

.icofont-rounded-left-up:before {
  content: "\\eb5d";
}

.icofont-rounded-left:before {
  content: "\\eb5e";
}

.icofont-rounded-right-down:before {
  content: "\\eb5f";
}

.icofont-rounded-right-up:before {
  content: "\\eb60";
}

.icofont-rounded-right:before {
  content: "\\eb61";
}

.icofont-rounded-up:before {
  content: "\\eb62";
}

.icofont-scroll-bubble-down:before {
  content: "\\eb63";
}

.icofont-scroll-bubble-left:before {
  content: "\\eb64";
}

.icofont-scroll-bubble-right:before {
  content: "\\eb65";
}

.icofont-scroll-bubble-up:before {
  content: "\\eb66";
}

.icofont-scroll-double-down:before {
  content: "\\eb67";
}

.icofont-scroll-double-left:before {
  content: "\\eb68";
}

.icofont-scroll-double-right:before {
  content: "\\eb69";
}

.icofont-scroll-double-up:before {
  content: "\\eb6a";
}

.icofont-scroll-down:before {
  content: "\\eb6b";
}

.icofont-scroll-left:before {
  content: "\\eb6c";
}

.icofont-scroll-long-down:before {
  content: "\\eb6d";
}

.icofont-scroll-long-left:before {
  content: "\\eb6e";
}

.icofont-scroll-long-right:before {
  content: "\\eb6f";
}

.icofont-scroll-long-up:before {
  content: "\\eb70";
}

.icofont-scroll-right:before {
  content: "\\eb71";
}

.icofont-scroll-up:before {
  content: "\\eb72";
}

.icofont-simple-down:before {
  content: "\\eb73";
}

.icofont-simple-left-down:before {
  content: "\\eb74";
}

.icofont-simple-left-up:before {
  content: "\\eb75";
}

.icofont-simple-left:before {
  content: "\\eb76";
}

.icofont-simple-right-down:before {
  content: "\\eb77";
}

.icofont-simple-right-up:before {
  content: "\\eb78";
}

.icofont-simple-right:before {
  content: "\\eb79";
}

.icofont-simple-up:before {
  content: "\\eb7a";
}

.icofont-square-down:before {
  content: "\\eb7b";
}

.icofont-square-left:before {
  content: "\\eb7c";
}

.icofont-square-right:before {
  content: "\\eb7d";
}

.icofont-square-up:before {
  content: "\\eb7e";
}

.icofont-stylish-down:before {
  content: "\\eb7f";
}

.icofont-stylish-left:before {
  content: "\\eb80";
}

.icofont-stylish-right:before {
  content: "\\eb81";
}

.icofont-stylish-up:before {
  content: "\\eb82";
}

.icofont-swoosh-down:before {
  content: "\\eb83";
}

.icofont-swoosh-left:before {
  content: "\\eb84";
}

.icofont-swoosh-right:before {
  content: "\\eb85";
}

.icofont-swoosh-up:before {
  content: "\\eb86";
}

.icofont-thin-double-left:before {
  content: "\\eb87";
}

.icofont-thin-double-right:before {
  content: "\\eb88";
}

.icofont-thin-down:before {
  content: "\\eb89";
}

.icofont-thin-left:before {
  content: "\\eb8a";
}

.icofont-thin-right:before {
  content: "\\eb8b";
}

.icofont-thin-up:before {
  content: "\\eb8c";
}

.icofont-atom:before {
  content: "\\eb8d";
}

.icofont-award:before {
  content: "\\eb8e";
}

.icofont-bell-alt:before {
  content: "\\eb8f";
}

.icofont-book-alt:before {
  content: "\\eb90";
}

.icofont-brainstorming:before {
  content: "\\eb91";
}

.icofont-certificate-alt-1:before {
  content: "\\eb92";
}

.icofont-certificate-alt-2:before {
  content: "\\eb93";
}

.icofont-dna-alt-2:before {
  content: "\\eb94";
}

.icofont-education:before {
  content: "\\eb95";
}

.icofont-electron:before {
  content: "\\eb96";
}

.icofont-fountain-pen:before {
  content: "\\eb97";
}

.icofont-globe-alt:before {
  content: "\\eb98";
}

.icofont-graduate-alt:before {
  content: "\\eb99";
}

.icofont-group-students:before {
  content: "\\eb9a";
}

.icofont-hat-alt:before {
  content: "\\eb9b";
}

.icofont-hat:before {
  content: "\\eb9c";
}

.icofont-instrument:before {
  content: "\\eb9d";
}

.icofont-lamp-light:before {
  content: "\\eb9e";
}

.icofont-microscope-alt:before {
  content: "\\eb9f";
}

.icofont-paper:before {
  content: "\\eba0";
}

.icofont-pen-alt-4:before {
  content: "\\eba1";
}

.icofont-pen-nib:before {
  content: "\\eba2";
}

.icofont-pencil-alt-5:before {
  content: "\\eba3";
}

.icofont-quill-pen:before {
  content: "\\eba4";
}

.icofont-read-book-alt:before {
  content: "\\eba5";
}

.icofont-read-book:before {
  content: "\\eba6";
}

.icofont-school-bag:before {
  content: "\\eba7";
}

.icofont-school-bus:before {
  content: "\\eba8";
}

.icofont-student-alt:before {
  content: "\\eba9";
}

.icofont-student:before {
  content: "\\ebaa";
}

.icofont-teacher:before {
  content: "\\ebab";
}

.icofont-test-bulb:before {
  content: "\\ebac";
}

.icofont-test-tube-alt:before {
  content: "\\ebad";
}

.icofont-university:before {
  content: "\\ebae";
}

.icofont-emo-angry:before {
  content: "\\ebaf";
}

.icofont-emo-astonished:before {
  content: "\\ebb0";
}

.icofont-emo-confounded:before {
  content: "\\ebb1";
}

.icofont-emo-confused:before {
  content: "\\ebb2";
}

.icofont-emo-crying:before {
  content: "\\ebb3";
}

.icofont-emo-dizzy:before {
  content: "\\ebb4";
}

.icofont-emo-expressionless:before {
  content: "\\ebb5";
}

.icofont-emo-heart-eyes:before {
  content: "\\ebb6";
}

.icofont-emo-laughing:before {
  content: "\\ebb7";
}

.icofont-emo-nerd-smile:before {
  content: "\\ebb8";
}

.icofont-emo-open-mouth:before {
  content: "\\ebb9";
}

.icofont-emo-rage:before {
  content: "\\ebba";
}

.icofont-emo-rolling-eyes:before {
  content: "\\ebbb";
}

.icofont-emo-sad:before {
  content: "\\ebbc";
}

.icofont-emo-simple-smile:before {
  content: "\\ebbd";
}

.icofont-emo-slightly-smile:before {
  content: "\\ebbe";
}

.icofont-emo-smirk:before {
  content: "\\ebbf";
}

.icofont-emo-stuck-out-tongue:before {
  content: "\\ebc0";
}

.icofont-emo-wink-smile:before {
  content: "\\ebc1";
}

.icofont-emo-worried:before {
  content: "\\ebc2";
}

.icofont-architecture-alt:before {
  content: "\\ebc3";
}

.icofont-architecture:before {
  content: "\\ebc4";
}

.icofont-barricade:before {
  content: "\\ebc5";
}

.icofont-bricks:before {
  content: "\\ebc6";
}

.icofont-calculations:before {
  content: "\\ebc7";
}

.icofont-cement-mix:before {
  content: "\\ebc8";
}

.icofont-cement-mixer:before {
  content: "\\ebc9";
}

.icofont-danger-zone:before {
  content: "\\ebca";
}

.icofont-drill:before {
  content: "\\ebcb";
}

.icofont-eco-energy:before {
  content: "\\ebcc";
}

.icofont-eco-environmen:before {
  content: "\\ebcd";
}

.icofont-energy-air:before {
  content: "\\ebce";
}

.icofont-energy-oil:before {
  content: "\\ebcf";
}

.icofont-energy-savings:before {
  content: "\\ebd0";
}

.icofont-energy-solar:before {
  content: "\\ebd1";
}

.icofont-energy-water:before {
  content: "\\ebd2";
}

.icofont-engineer:before {
  content: "\\ebd3";
}

.icofont-fire-extinguisher-alt:before {
  content: "\\ebd4";
}

.icofont-fix-tools:before {
  content: "\\ebd5";
}

.icofont-glue-oil:before {
  content: "\\ebd6";
}

.icofont-hammer-alt:before {
  content: "\\ebd7";
}

.icofont-help-robot:before {
  content: "\\ebd8";
}

.icofont-industries-alt-1:before {
  content: "\\ebd9";
}

.icofont-industries-alt-2:before {
  content: "\\ebda";
}

.icofont-industries-alt-3:before {
  content: "\\ebdb";
}

.icofont-industries-alt-4:before {
  content: "\\ebdc";
}

.icofont-industries-alt-5:before {
  content: "\\ebdd";
}

.icofont-industries:before {
  content: "\\ebde";
}

.icofont-labour:before {
  content: "\\ebdf";
}

.icofont-mining:before {
  content: "\\ebe0";
}

.icofont-paint-brush:before {
  content: "\\ebe1";
}

.icofont-pollution:before {
  content: "\\ebe2";
}

.icofont-power-zone:before {
  content: "\\ebe3";
}

.icofont-radio-active:before {
  content: "\\ebe4";
}

.icofont-recycle-alt:before {
  content: "\\ebe5";
}

.icofont-recycling-man:before {
  content: "\\ebe6";
}

.icofont-safety-hat-light:before {
  content: "\\ebe7";
}

.icofont-safety-hat:before {
  content: "\\ebe8";
}

.icofont-saw:before {
  content: "\\ebe9";
}

.icofont-screw-driver:before {
  content: "\\ebea";
}

.icofont-settings-alt:before {
  content: "\\ebeb";
}

.icofont-tools-alt-1:before {
  content: "\\ebec";
}

.icofont-tools-alt-2:before {
  content: "\\ebed";
}

.icofont-tools-bag:before {
  content: "\\ebee";
}

.icofont-trolley:before {
  content: "\\ebef";
}

.icofont-trowel:before {
  content: "\\ebf0";
}

.icofont-under-construction-alt:before {
  content: "\\ebf1";
}

.icofont-under-construction:before {
  content: "\\ebf2";
}

.icofont-vehicle-cement:before {
  content: "\\ebf3";
}

.icofont-vehicle-crane:before {
  content: "\\ebf4";
}

.icofont-vehicle-delivery-van:before {
  content: "\\ebf5";
}

.icofont-vehicle-dozer:before {
  content: "\\ebf6";
}

.icofont-vehicle-excavator:before {
  content: "\\ebf7";
}

.icofont-vehicle-trucktor:before {
  content: "\\ebf8";
}

.icofont-vehicle-wrecking:before {
  content: "\\ebf9";
}

.icofont-worker-group:before {
  content: "\\ebfa";
}

.icofont-worker:before {
  content: "\\ebfb";
}

.icofont-wrench:before {
  content: "\\ebfc";
}

.icofont-file-audio:before {
  content: "\\ebfd";
}

.icofont-file-avi-mp4:before {
  content: "\\ebfe";
}

.icofont-file-bmp:before {
  content: "\\ebff";
}

.icofont-file-code:before {
  content: "\\ec00";
}

.icofont-file-css:before {
  content: "\\ec01";
}

.icofont-file-document:before {
  content: "\\ec02";
}

.icofont-file-eps:before {
  content: "\\ec03";
}

.icofont-file-excel:before {
  content: "\\ec04";
}

.icofont-file-exe:before {
  content: "\\ec05";
}

.icofont-file-file:before {
  content: "\\ec06";
}

.icofont-file-flv:before {
  content: "\\ec07";
}

.icofont-file-gif:before {
  content: "\\ec08";
}

.icofont-file-html5:before {
  content: "\\ec09";
}

.icofont-file-image:before {
  content: "\\ec0a";
}

.icofont-file-iso:before {
  content: "\\ec0b";
}

.icofont-file-java:before {
  content: "\\ec0c";
}

.icofont-file-javascript:before {
  content: "\\ec0d";
}

.icofont-file-jpg:before {
  content: "\\ec0e";
}

.icofont-file-midi:before {
  content: "\\ec0f";
}

.icofont-file-mov:before {
  content: "\\ec10";
}

.icofont-file-mp3:before {
  content: "\\ec11";
}

.icofont-file-pdf:before {
  content: "\\ec12";
}

.icofont-file-php:before {
  content: "\\ec13";
}

.icofont-file-png:before {
  content: "\\ec14";
}

.icofont-file-powerpoint:before {
  content: "\\ec15";
}

.icofont-file-presentation:before {
  content: "\\ec16";
}

.icofont-file-psb:before {
  content: "\\ec17";
}

.icofont-file-psd:before {
  content: "\\ec18";
}

.icofont-file-python:before {
  content: "\\ec19";
}

.icofont-file-ruby:before {
  content: "\\ec1a";
}

.icofont-file-spreadsheet:before {
  content: "\\ec1b";
}

.icofont-file-sql:before {
  content: "\\ec1c";
}

.icofont-file-svg:before {
  content: "\\ec1d";
}

.icofont-file-text:before {
  content: "\\ec1e";
}

.icofont-file-tiff:before {
  content: "\\ec1f";
}

.icofont-file-video:before {
  content: "\\ec20";
}

.icofont-file-wave:before {
  content: "\\ec21";
}

.icofont-file-wmv:before {
  content: "\\ec22";
}

.icofont-file-word:before {
  content: "\\ec23";
}

.icofont-file-zip:before {
  content: "\\ec24";
}

.icofont-apple:before {
  content: "\\ec25";
}

.icofont-arabian-coffee:before {
  content: "\\ec26";
}

.icofont-artichoke:before {
  content: "\\ec27";
}

.icofont-asparagus:before {
  content: "\\ec28";
}

.icofont-avocado:before {
  content: "\\ec29";
}

.icofont-baby-food:before {
  content: "\\ec2a";
}

.icofont-banana:before {
  content: "\\ec2b";
}

.icofont-bbq:before {
  content: "\\ec2c";
}

.icofont-beans:before {
  content: "\\ec2d";
}

.icofont-beer:before {
  content: "\\ec2e";
}

.icofont-bell-pepper-capsicum:before {
  content: "\\ec2f";
}

.icofont-birthday-cake:before {
  content: "\\ec30";
}

.icofont-bread:before {
  content: "\\ec31";
}

.icofont-broccoli:before {
  content: "\\ec32";
}

.icofont-burger:before {
  content: "\\ec33";
}

.icofont-cabbage:before {
  content: "\\ec34";
}

.icofont-carrot:before {
  content: "\\ec35";
}

.icofont-cauli-flower:before {
  content: "\\ec36";
}

.icofont-cheese:before {
  content: "\\ec37";
}

.icofont-chef:before {
  content: "\\ec38";
}

.icofont-cherry:before {
  content: "\\ec39";
}

.icofont-chicken-fry:before {
  content: "\\ec3a";
}

.icofont-chicken:before {
  content: "\\ec3b";
}

.icofont-cocktail:before {
  content: "\\ec3c";
}

.icofont-coconut:before {
  content: "\\ec3d";
}

.icofont-coffee-alt:before {
  content: "\\ec3e";
}

.icofont-coffee-mug:before {
  content: "\\ec3f";
}

.icofont-coffee-pot:before {
  content: "\\ec40";
}

.icofont-cola:before {
  content: "\\ec41";
}

.icofont-corn:before {
  content: "\\ec42";
}

.icofont-croissant:before {
  content: "\\ec43";
}

.icofont-crop-plant:before {
  content: "\\ec44";
}

.icofont-cucumber:before {
  content: "\\ec45";
}

.icofont-cup-cake:before {
  content: "\\ec46";
}

.icofont-dining-table:before {
  content: "\\ec47";
}

.icofont-donut:before {
  content: "\\ec48";
}

.icofont-egg-plant:before {
  content: "\\ec49";
}

.icofont-egg-poached:before {
  content: "\\ec4a";
}

.icofont-farmer:before {
  content: "\\ec4b";
}

.icofont-farmer1:before {
  content: "\\ec4c";
}

.icofont-fast-food:before {
  content: "\\ec4d";
}

.icofont-fish:before {
  content: "\\ec4e";
}

.icofont-food-basket:before {
  content: "\\ec4f";
}

.icofont-food-cart:before {
  content: "\\ec50";
}

.icofont-fork-and-knife:before {
  content: "\\ec51";
}

.icofont-french-fries:before {
  content: "\\ec52";
}

.icofont-fresh-juice:before {
  content: "\\ec53";
}

.icofont-fruits:before {
  content: "\\ec54";
}

.icofont-grapes:before {
  content: "\\ec55";
}

.icofont-honey:before {
  content: "\\ec56";
}

.icofont-hot-dog:before {
  content: "\\ec57";
}

.icofont-hotel-alt:before {
  content: "\\ec58";
}

.icofont-ice-cream-alt:before {
  content: "\\ec59";
}

.icofont-ice-cream:before {
  content: "\\ec5a";
}

.icofont-ketchup:before {
  content: "\\ec5b";
}

.icofont-kiwi:before {
  content: "\\ec5c";
}

.icofont-layered-cake:before {
  content: "\\ec5d";
}

.icofont-lemon-alt:before {
  content: "\\ec5e";
}

.icofont-lobster:before {
  content: "\\ec5f";
}

.icofont-mango:before {
  content: "\\ec60";
}

.icofont-milk:before {
  content: "\\ec61";
}

.icofont-mushroom:before {
  content: "\\ec62";
}

.icofont-noodles:before {
  content: "\\ec63";
}

.icofont-onion:before {
  content: "\\ec64";
}

.icofont-orange:before {
  content: "\\ec65";
}

.icofont-pear:before {
  content: "\\ec66";
}

.icofont-peas:before {
  content: "\\ec67";
}

.icofont-pepper:before {
  content: "\\ec68";
}

.icofont-pie-alt:before {
  content: "\\ec69";
}

.icofont-pineapple:before {
  content: "\\ec6a";
}

.icofont-pizza-slice:before {
  content: "\\ec6b";
}

.icofont-pizza:before {
  content: "\\ec6c";
}

.icofont-plant:before {
  content: "\\ec6d";
}

.icofont-popcorn:before {
  content: "\\ec6e";
}

.icofont-potato:before {
  content: "\\ec6f";
}

.icofont-pumpkin:before {
  content: "\\ec70";
}

.icofont-raddish:before {
  content: "\\ec71";
}

.icofont-restaurant-menu:before {
  content: "\\ec72";
}

.icofont-restaurant:before {
  content: "\\ec73";
}

.icofont-salt-and-pepper:before {
  content: "\\ec74";
}

.icofont-sandwich:before {
  content: "\\ec75";
}

.icofont-sausage:before {
  content: "\\ec76";
}

.icofont-shrimp:before {
  content: "\\ec77";
}

.icofont-sof-drinks:before {
  content: "\\ec78";
}

.icofont-soup-bowl:before {
  content: "\\ec79";
}

.icofont-spoon-and-fork:before {
  content: "\\ec7a";
}

.icofont-steak:before {
  content: "\\ec7b";
}

.icofont-strawberry:before {
  content: "\\ec7c";
}

.icofont-sub-sandwich:before {
  content: "\\ec7d";
}

.icofont-sushi:before {
  content: "\\ec7e";
}

.icofont-taco:before {
  content: "\\ec7f";
}

.icofont-tea-pot:before {
  content: "\\ec80";
}

.icofont-tea:before {
  content: "\\ec81";
}

.icofont-tomato:before {
  content: "\\ec82";
}

.icofont-waiter-alt:before {
  content: "\\ec83";
}

.icofont-watermelon:before {
  content: "\\ec84";
}

.icofont-wheat:before {
  content: "\\ec85";
}

.icofont-abc:before {
  content: "\\ec86";
}

.icofont-baby-cloth:before {
  content: "\\ec87";
}

.icofont-baby-milk-bottle:before {
  content: "\\ec88";
}

.icofont-baby-trolley:before {
  content: "\\ec89";
}

.icofont-back-pack:before {
  content: "\\ec8a";
}

.icofont-candy:before {
  content: "\\ec8b";
}

.icofont-cycling:before {
  content: "\\ec8c";
}

.icofont-holding-hands:before {
  content: "\\ec8d";
}

.icofont-infant-nipple:before {
  content: "\\ec8e";
}

.icofont-kids-scooter:before {
  content: "\\ec8f";
}

.icofont-safety-pin:before {
  content: "\\ec90";
}

.icofont-teddy-bear:before {
  content: "\\ec91";
}

.icofont-toy-ball:before {
  content: "\\ec92";
}

.icofont-toy-cat:before {
  content: "\\ec93";
}

.icofont-toy-duck:before {
  content: "\\ec94";
}

.icofont-toy-elephant:before {
  content: "\\ec95";
}

.icofont-toy-hand:before {
  content: "\\ec96";
}

.icofont-toy-horse:before {
  content: "\\ec97";
}

.icofont-toy-lattu:before {
  content: "\\ec98";
}

.icofont-toy-train:before {
  content: "\\ec99";
}

.icofont-unique-idea:before {
  content: "\\ec9a";
}

.icofont-bag-alt:before {
  content: "\\ec9b";
}

.icofont-burglar:before {
  content: "\\ec9c";
}

.icofont-cannon-firing:before {
  content: "\\ec9d";
}

.icofont-cc-camera:before {
  content: "\\ec9e";
}

.icofont-cop-badge:before {
  content: "\\ec9f";
}

.icofont-cop:before {
  content: "\\eca0";
}

.icofont-court-hammer:before {
  content: "\\eca1";
}

.icofont-court:before {
  content: "\\eca2";
}

.icofont-finger-print:before {
  content: "\\eca3";
}

.icofont-handcuff-alt:before {
  content: "\\eca4";
}

.icofont-handcuff:before {
  content: "\\eca5";
}

.icofont-investigation:before {
  content: "\\eca6";
}

.icofont-investigator:before {
  content: "\\eca7";
}

.icofont-jail:before {
  content: "\\eca8";
}

.icofont-judge:before {
  content: "\\eca9";
}

.icofont-law-alt-1:before {
  content: "\\ecaa";
}

.icofont-law-alt-2:before {
  content: "\\ecab";
}

.icofont-law-alt-3:before {
  content: "\\ecac";
}

.icofont-law-book:before {
  content: "\\ecad";
}

.icofont-law-document:before {
  content: "\\ecae";
}

.icofont-law:before {
  content: "\\ecaf";
}

.icofont-lawyer-alt-1:before {
  content: "\\ecb0";
}

.icofont-lawyer-alt-2:before {
  content: "\\ecb1";
}

.icofont-lawyer:before {
  content: "\\ecb2";
}

.icofont-order:before {
  content: "\\ecb3";
}

.icofont-pistol:before {
  content: "\\ecb4";
}

.icofont-police-badge:before {
  content: "\\ecb5";
}

.icofont-police-cap:before {
  content: "\\ecb6";
}

.icofont-police-car-alt-1:before {
  content: "\\ecb7";
}

.icofont-police-car-alt-2:before {
  content: "\\ecb8";
}

.icofont-police-hat:before {
  content: "\\ecb9";
}

.icofont-police-van:before {
  content: "\\ecba";
}

.icofont-police:before {
  content: "\\ecbb";
}

.icofont-protect:before {
  content: "\\ecbc";
}

.icofont-scales:before {
  content: "\\ecbd";
}

.icofont-thief-alt:before {
  content: "\\ecbe";
}

.icofont-thief:before {
  content: "\\ecbf";
}

.icofont-abacus-alt:before {
  content: "\\ecc0";
}

.icofont-abacus:before {
  content: "\\ecc1";
}

.icofont-angle:before {
  content: "\\ecc2";
}

.icofont-calculator-alt-1:before {
  content: "\\ecc3";
}

.icofont-calculator-alt-2:before {
  content: "\\ecc4";
}

.icofont-circle-ruler-alt:before {
  content: "\\ecc5";
}

.icofont-circle-ruler:before {
  content: "\\ecc6";
}

.icofont-compass-alt-1:before {
  content: "\\ecc7";
}

.icofont-compass-alt-2:before {
  content: "\\ecc8";
}

.icofont-compass-alt-3:before {
  content: "\\ecc9";
}

.icofont-compass-alt-4:before {
  content: "\\ecca";
}

.icofont-degrees-alt-1:before {
  content: "\\eccb";
}

.icofont-degrees-alt-2:before {
  content: "\\eccc";
}

.icofont-degrees:before {
  content: "\\eccd";
}

.icofont-golden-ratio:before {
  content: "\\ecce";
}

.icofont-marker-alt-1:before {
  content: "\\eccf";
}

.icofont-marker-alt-2:before {
  content: "\\ecd0";
}

.icofont-marker-alt-3:before {
  content: "\\ecd1";
}

.icofont-mathematical-alt-1:before {
  content: "\\ecd2";
}

.icofont-mathematical-alt-2:before {
  content: "\\ecd3";
}

.icofont-mathematical:before {
  content: "\\ecd4";
}

.icofont-pen-alt-1:before {
  content: "\\ecd5";
}

.icofont-pen-alt-2:before {
  content: "\\ecd6";
}

.icofont-pen-alt-3:before {
  content: "\\ecd7";
}

.icofont-pen-holder-alt-1:before {
  content: "\\ecd8";
}

.icofont-pen-holder:before {
  content: "\\ecd9";
}

.icofont-pencil-alt-1:before {
  content: "\\ecda";
}

.icofont-pencil-alt-2:before {
  content: "\\ecdb";
}

.icofont-pencil-alt-3:before {
  content: "\\ecdc";
}

.icofont-pencil-alt-4:before {
  content: "\\ecdd";
}

.icofont-ruler-alt-1:before {
  content: "\\ecde";
}

.icofont-ruler-alt-2:before {
  content: "\\ecdf";
}

.icofont-ruler-compass-alt:before {
  content: "\\ece0";
}

.icofont-ruler-compass:before {
  content: "\\ece1";
}

.icofont-ruler-pencil-alt-1:before {
  content: "\\ece2";
}

.icofont-ruler-pencil-alt-2:before {
  content: "\\ece3";
}

.icofont-ruler-pencil:before {
  content: "\\ece4";
}

.icofont-ruler:before {
  content: "\\ece5";
}

.icofont-rulers-alt:before {
  content: "\\ece6";
}

.icofont-rulers:before {
  content: "\\ece7";
}

.icofont-square-root:before {
  content: "\\ece8";
}

.icofont-aids:before {
  content: "\\ece9";
}

.icofont-ambulance:before {
  content: "\\ecea";
}

.icofont-autism:before {
  content: "\\eceb";
}

.icofont-bandage:before {
  content: "\\ecec";
}

.icofont-bed-patient:before {
  content: "\\eced";
}

.icofont-blind:before {
  content: "\\ecee";
}

.icofont-blood-drop:before {
  content: "\\ecef";
}

.icofont-blood-test:before {
  content: "\\ecf0";
}

.icofont-blood:before {
  content: "\\ecf1";
}

.icofont-capsule:before {
  content: "\\ecf2";
}

.icofont-crutches:before {
  content: "\\ecf3";
}

.icofont-dna-alt-1:before {
  content: "\\ecf4";
}

.icofont-dna:before {
  content: "\\ecf5";
}

.icofont-doctor-alt:before {
  content: "\\ecf6";
}

.icofont-doctor:before {
  content: "\\ecf7";
}

.icofont-drug-pack:before {
  content: "\\ecf8";
}

.icofont-drug:before {
  content: "\\ecf9";
}

.icofont-eye-alt:before {
  content: "\\ecfa";
}

.icofont-first-aid-alt:before {
  content: "\\ecfb";
}

.icofont-garbage:before {
  content: "\\ecfc";
}

.icofont-heart-alt:before {
  content: "\\ecfd";
}

.icofont-heartbeat:before {
  content: "\\ecfe";
}

.icofont-herbal:before {
  content: "\\ecff";
}

.icofont-hospital:before {
  content: "\\ed00";
}

.icofont-icu:before {
  content: "\\ed01";
}

.icofont-injection-syringe:before {
  content: "\\ed02";
}

.icofont-laboratory:before {
  content: "\\ed03";
}

.icofont-medical-sign-alt:before {
  content: "\\ed04";
}

.icofont-medical-sign:before {
  content: "\\ed05";
}

.icofont-nurse-alt:before {
  content: "\\ed06";
}

.icofont-nurse:before {
  content: "\\ed07";
}

.icofont-nursing-home:before {
  content: "\\ed08";
}

.icofont-operation-theater:before {
  content: "\\ed09";
}

.icofont-paralysis-disability:before {
  content: "\\ed0a";
}

.icofont-pills:before {
  content: "\\ed0b";
}

.icofont-prescription:before {
  content: "\\ed0c";
}

.icofont-pulse:before {
  content: "\\ed0d";
}

.icofont-stethoscope-alt:before {
  content: "\\ed0e";
}

.icofont-stethoscope:before {
  content: "\\ed0f";
}

.icofont-stretcher:before {
  content: "\\ed10";
}

.icofont-surgeon-alt:before {
  content: "\\ed11";
}

.icofont-surgeon:before {
  content: "\\ed12";
}

.icofont-tablets:before {
  content: "\\ed13";
}

.icofont-test-bottle:before {
  content: "\\ed14";
}

.icofont-test-tube:before {
  content: "\\ed15";
}

.icofont-thermometer-alt:before {
  content: "\\ed16";
}

.icofont-tooth:before {
  content: "\\ed17";
}

.icofont-xray:before {
  content: "\\ed18";
}

.icofont-ui-add:before {
  content: "\\ed19";
}

.icofont-ui-alarm:before {
  content: "\\ed1a";
}

.icofont-ui-battery:before {
  content: "\\ed1b";
}

.icofont-ui-block:before {
  content: "\\ed1c";
}

.icofont-ui-bluetooth:before {
  content: "\\ed1d";
}

.icofont-ui-brightness:before {
  content: "\\ed1e";
}

.icofont-ui-browser:before {
  content: "\\ed1f";
}

.icofont-ui-calculator:before {
  content: "\\ed20";
}

.icofont-ui-calendar:before {
  content: "\\ed21";
}

.icofont-ui-call:before {
  content: "\\ed22";
}

.icofont-ui-camera:before {
  content: "\\ed23";
}

.icofont-ui-cart:before {
  content: "\\ed24";
}

.icofont-ui-cell-phone:before {
  content: "\\ed25";
}

.icofont-ui-chat:before {
  content: "\\ed26";
}

.icofont-ui-check:before {
  content: "\\ed27";
}

.icofont-ui-clip-board:before {
  content: "\\ed28";
}

.icofont-ui-clip:before {
  content: "\\ed29";
}

.icofont-ui-clock:before {
  content: "\\ed2a";
}

.icofont-ui-close:before {
  content: "\\ed2b";
}

.icofont-ui-contact-list:before {
  content: "\\ed2c";
}

.icofont-ui-copy:before {
  content: "\\ed2d";
}

.icofont-ui-cut:before {
  content: "\\ed2e";
}

.icofont-ui-delete:before {
  content: "\\ed2f";
}

.icofont-ui-dial-phone:before {
  content: "\\ed30";
}

.icofont-ui-edit:before {
  content: "\\ed31";
}

.icofont-ui-email:before {
  content: "\\ed32";
}

.icofont-ui-file:before {
  content: "\\ed33";
}

.icofont-ui-fire-wall:before {
  content: "\\ed34";
}

.icofont-ui-flash-light:before {
  content: "\\ed35";
}

.icofont-ui-flight:before {
  content: "\\ed36";
}

.icofont-ui-folder:before {
  content: "\\ed37";
}

.icofont-ui-game:before {
  content: "\\ed38";
}

.icofont-ui-handicapped:before {
  content: "\\ed39";
}

.icofont-ui-head-phone:before {
  content: "\\ed3a";
}

.icofont-ui-home:before {
  content: "\\ed3b";
}

.icofont-ui-image:before {
  content: "\\ed3c";
}

.icofont-ui-keyboard:before {
  content: "\\ed3d";
}

.icofont-ui-laoding:before {
  content: "\\ed3e";
}

.icofont-ui-lock:before {
  content: "\\ed3f";
}

.icofont-ui-love-add:before {
  content: "\\ed40";
}

.icofont-ui-love-broken:before {
  content: "\\ed41";
}

.icofont-ui-love-remove:before {
  content: "\\ed42";
}

.icofont-ui-love:before {
  content: "\\ed43";
}

.icofont-ui-map:before {
  content: "\\ed44";
}

.icofont-ui-message:before {
  content: "\\ed45";
}

.icofont-ui-messaging:before {
  content: "\\ed46";
}

.icofont-ui-movie:before {
  content: "\\ed47";
}

.icofont-ui-music-player:before {
  content: "\\ed48";
}

.icofont-ui-music:before {
  content: "\\ed49";
}

.icofont-ui-mute:before {
  content: "\\ed4a";
}

.icofont-ui-network:before {
  content: "\\ed4b";
}

.icofont-ui-next:before {
  content: "\\ed4c";
}

.icofont-ui-note:before {
  content: "\\ed4d";
}

.icofont-ui-office:before {
  content: "\\ed4e";
}

.icofont-ui-password:before {
  content: "\\ed4f";
}

.icofont-ui-pause:before {
  content: "\\ed50";
}

.icofont-ui-play-stop:before {
  content: "\\ed51";
}

.icofont-ui-play:before {
  content: "\\ed52";
}

.icofont-ui-pointer:before {
  content: "\\ed53";
}

.icofont-ui-power:before {
  content: "\\ed54";
}

.icofont-ui-press:before {
  content: "\\ed55";
}

.icofont-ui-previous:before {
  content: "\\ed56";
}

.icofont-ui-rate-add:before {
  content: "\\ed57";
}

.icofont-ui-rate-blank:before {
  content: "\\ed58";
}

.icofont-ui-rate-remove:before {
  content: "\\ed59";
}

.icofont-ui-rating:before {
  content: "\\ed5a";
}

.icofont-ui-record:before {
  content: "\\ed5b";
}

.icofont-ui-remove:before {
  content: "\\ed5c";
}

.icofont-ui-reply:before {
  content: "\\ed5d";
}

.icofont-ui-rotation:before {
  content: "\\ed5e";
}

.icofont-ui-rss:before {
  content: "\\ed5f";
}

.icofont-ui-search:before {
  content: "\\ed60";
}

.icofont-ui-settings:before {
  content: "\\ed61";
}

.icofont-ui-social-link:before {
  content: "\\ed62";
}

.icofont-ui-tag:before {
  content: "\\ed63";
}

.icofont-ui-text-chat:before {
  content: "\\ed64";
}

.icofont-ui-text-loading:before {
  content: "\\ed65";
}

.icofont-ui-theme:before {
  content: "\\ed66";
}

.icofont-ui-timer:before {
  content: "\\ed67";
}

.icofont-ui-touch-phone:before {
  content: "\\ed68";
}

.icofont-ui-travel:before {
  content: "\\ed69";
}

.icofont-ui-unlock:before {
  content: "\\ed6a";
}

.icofont-ui-user-group:before {
  content: "\\ed6b";
}

.icofont-ui-user:before {
  content: "\\ed6c";
}

.icofont-ui-v-card:before {
  content: "\\ed6d";
}

.icofont-ui-video-chat:before {
  content: "\\ed6e";
}

.icofont-ui-video-message:before {
  content: "\\ed6f";
}

.icofont-ui-video-play:before {
  content: "\\ed70";
}

.icofont-ui-video:before {
  content: "\\ed71";
}

.icofont-ui-volume:before {
  content: "\\ed72";
}

.icofont-ui-weather:before {
  content: "\\ed73";
}

.icofont-ui-wifi:before {
  content: "\\ed74";
}

.icofont-ui-zoom-in:before {
  content: "\\ed75";
}

.icofont-ui-zoom-out:before {
  content: "\\ed76";
}

.icofont-cassette-player:before {
  content: "\\ed77";
}

.icofont-cassette:before {
  content: "\\ed78";
}

.icofont-forward:before {
  content: "\\ed79";
}

.icofont-game:before {
  content: "\\ed7a";
}

.icofont-guiter:before {
  content: "\\ed7b";
}

.icofont-headphone-alt-1:before {
  content: "\\ed7c";
}

.icofont-headphone-alt-2:before {
  content: "\\ed7d";
}

.icofont-headphone-alt-3:before {
  content: "\\ed7e";
}

.icofont-listening:before {
  content: "\\ed7f";
}

.icofont-megaphone-alt:before {
  content: "\\ed80";
}

.icofont-megaphone:before {
  content: "\\ed81";
}

.icofont-movie:before {
  content: "\\ed82";
}

.icofont-mp3-player:before {
  content: "\\ed83";
}

.icofont-multimedia:before {
  content: "\\ed84";
}

.icofont-music-disk:before {
  content: "\\ed85";
}

.icofont-music-note:before {
  content: "\\ed86";
}

.icofont-pause:before {
  content: "\\ed87";
}

.icofont-play-alt-1:before {
  content: "\\ed88";
}

.icofont-play-alt-2:before {
  content: "\\ed89";
}

.icofont-play-alt-3:before {
  content: "\\ed8a";
}

.icofont-play-pause:before {
  content: "\\ed8b";
}

.icofont-record:before {
  content: "\\ed8c";
}

.icofont-retro-music-disk:before {
  content: "\\ed8d";
}

.icofont-rewind:before {
  content: "\\ed8e";
}

.icofont-song-notes:before {
  content: "\\ed8f";
}

.icofont-sound-wave-alt:before {
  content: "\\ed90";
}

.icofont-sound-wave:before {
  content: "\\ed91";
}

.icofont-stop:before {
  content: "\\ed92";
}

.icofont-video-alt:before {
  content: "\\ed93";
}

.icofont-video-cam:before {
  content: "\\ed94";
}

.icofont-volume-bar:before {
  content: "\\ed95";
}

.icofont-volume-mute:before {
  content: "\\ed96";
}

.icofont-youtube-play:before {
  content: "\\ed97";
}

.icofont-amazon-alt:before {
  content: "\\ed98";
}

.icofont-amazon:before {
  content: "\\ed99";
}

.icofont-american-express-alt:before {
  content: "\\ed9a";
}

.icofont-american-express:before {
  content: "\\ed9b";
}

.icofont-apple-pay-alt:before {
  content: "\\ed9c";
}

.icofont-apple-pay:before {
  content: "\\ed9d";
}

.icofont-bank-transfer-alt:before {
  content: "\\ed9e";
}

.icofont-bank-transfer:before {
  content: "\\ed9f";
}

.icofont-braintree-alt:before {
  content: "\\eda0";
}

.icofont-braintree:before {
  content: "\\eda1";
}

.icofont-cash-on-delivery-alt:before {
  content: "\\eda2";
}

.icofont-cash-on-delivery:before {
  content: "\\eda3";
}

.icofont-checkout-alt:before {
  content: "\\eda4";
}

.icofont-checkout:before {
  content: "\\eda5";
}

.icofont-diners-club-alt-1:before {
  content: "\\eda6";
}

.icofont-diners-club-alt-2:before {
  content: "\\eda7";
}

.icofont-diners-club-alt-3:before {
  content: "\\eda8";
}

.icofont-diners-club:before {
  content: "\\eda9";
}

.icofont-discover-alt:before {
  content: "\\edaa";
}

.icofont-discover:before {
  content: "\\edab";
}

.icofont-eway-alt:before {
  content: "\\edac";
}

.icofont-eway:before {
  content: "\\edad";
}

.icofont-google-wallet-alt-1:before {
  content: "\\edae";
}

.icofont-google-wallet-alt-2:before {
  content: "\\edaf";
}

.icofont-google-wallet-alt-3:before {
  content: "\\edb0";
}

.icofont-google-wallet:before {
  content: "\\edb1";
}

.icofont-jcb-alt:before {
  content: "\\edb2";
}

.icofont-jcb:before {
  content: "\\edb3";
}

.icofont-maestro-alt:before {
  content: "\\edb4";
}

.icofont-maestro:before {
  content: "\\edb5";
}

.icofont-mastercard-alt:before {
  content: "\\edb6";
}

.icofont-mastercard:before {
  content: "\\edb7";
}

.icofont-payoneer-alt:before {
  content: "\\edb8";
}

.icofont-payoneer:before {
  content: "\\edb9";
}

.icofont-paypal-alt:before {
  content: "\\edba";
}

.icofont-paypal:before {
  content: "\\edbb";
}

.icofont-sage-alt:before {
  content: "\\edbc";
}

.icofont-sage:before {
  content: "\\edbd";
}

.icofont-skrill-alt:before {
  content: "\\edbe";
}

.icofont-skrill:before {
  content: "\\edbf";
}

.icofont-stripe-alt:before {
  content: "\\edc0";
}

.icofont-stripe:before {
  content: "\\edc1";
}

.icofont-visa-alt:before {
  content: "\\edc2";
}

.icofont-visa-electron:before {
  content: "\\edc3";
}

.icofont-visa:before {
  content: "\\edc4";
}

.icofont-western-union-alt:before {
  content: "\\edc5";
}

.icofont-western-union:before {
  content: "\\edc6";
}

.icofont-boy:before {
  content: "\\edc7";
}

.icofont-business-man-alt-1:before {
  content: "\\edc8";
}

.icofont-business-man-alt-2:before {
  content: "\\edc9";
}

.icofont-business-man-alt-3:before {
  content: "\\edca";
}

.icofont-business-man:before {
  content: "\\edcb";
}

.icofont-funky-man:before {
  content: "\\edcc";
}

.icofont-girl-alt:before {
  content: "\\edcd";
}

.icofont-girl:before {
  content: "\\edce";
}

.icofont-hotel-boy-alt:before {
  content: "\\edcf";
}

.icofont-hotel-boy:before {
  content: "\\edd0";
}

.icofont-man-in-glasses:before {
  content: "\\edd1";
}

.icofont-user-alt-1:before {
  content: "\\edd2";
}

.icofont-user-alt-2:before {
  content: "\\edd3";
}

.icofont-user-alt-3:before {
  content: "\\edd4";
}

.icofont-user-alt-4:before {
  content: "\\edd5";
}

.icofont-user-alt-5:before {
  content: "\\edd6";
}

.icofont-user-alt-6:before {
  content: "\\edd7";
}

.icofont-user-alt-7:before {
  content: "\\edd8";
}

.icofont-user-female:before {
  content: "\\edd9";
}

.icofont-user-male:before {
  content: "\\edda";
}

.icofont-user-suited:before {
  content: "\\eddb";
}

.icofont-user:before {
  content: "\\eddc";
}

.icofont-users-alt-1:before {
  content: "\\eddd";
}

.icofont-users-alt-2:before {
  content: "\\edde";
}

.icofont-users-alt-3:before {
  content: "\\eddf";
}

.icofont-users-alt-4:before {
  content: "\\ede0";
}

.icofont-users-alt-5:before {
  content: "\\ede1";
}

.icofont-users-alt-6:before {
  content: "\\ede2";
}

.icofont-users-social:before {
  content: "\\ede3";
}

.icofont-users:before {
  content: "\\ede4";
}

.icofont-waiter:before {
  content: "\\ede5";
}

.icofont-woman-in-glasses:before {
  content: "\\ede6";
}

.icofont-document-search:before {
  content: "\\ede7";
}

.icofont-folder-search:before {
  content: "\\ede8";
}

.icofont-home-search:before {
  content: "\\ede9";
}

.icofont-job-search:before {
  content: "\\edea";
}

.icofont-map-search:before {
  content: "\\edeb";
}

.icofont-restaurant-search:before {
  content: "\\edec";
}

.icofont-search-alt-1:before {
  content: "\\eded";
}

.icofont-search-alt-2:before {
  content: "\\edee";
}

.icofont-search:before {
  content: "\\edef";
}

.icofont-stock-search:before {
  content: "\\edf0";
}

.icofont-user-search:before {
  content: "\\edf1";
}

.icofont-social-aim:before {
  content: "\\edf2";
}

.icofont-social-badoo:before {
  content: "\\edf3";
}

.icofont-social-bebo:before {
  content: "\\edf4";
}

.icofont-social-behance:before {
  content: "\\edf5";
}

.icofont-social-blogger:before {
  content: "\\edf6";
}

.icofont-social-bootstrap:before {
  content: "\\edf7";
}

.icofont-social-brightkite:before {
  content: "\\edf8";
}

.icofont-social-cloudapp:before {
  content: "\\edf9";
}

.icofont-social-concrete5:before {
  content: "\\edfa";
}

.icofont-social-designbump:before {
  content: "\\edfb";
}

.icofont-social-designfloat:before {
  content: "\\edfc";
}

.icofont-social-deviantart:before {
  content: "\\edfd";
}

.icofont-social-digg:before {
  content: "\\edfe";
}

.icofont-social-dotcms:before {
  content: "\\edff";
}

.icofont-social-dribble:before {
  content: "\\ee00";
}

.icofont-social-dropbox:before {
  content: "\\ee01";
}

.icofont-brand-drupal:before {
  content: "\\ee02";
}

.icofont-social-ebuddy:before {
  content: "\\ee03";
}

.icofont-social-ello:before {
  content: "\\ee04";
}

.icofont-social-ember:before {
  content: "\\ee05";
}

.icofont-social-envato:before {
  content: "\\ee06";
}

.icofont-social-evernote:before {
  content: "\\ee07";
}

.icofont-social-facebook:before {
  content: "\\ee08";
}

.icofont-social-feedburner:before {
  content: "\\ee09";
}

.icofont-social-folkd:before {
  content: "\\ee0a";
}

.icofont-social-friendfeed:before {
  content: "\\ee0b";
}

.icofont-social-ghost:before {
  content: "\\ee0c";
}

.icofont-social-github:before {
  content: "\\ee0d";
}

.icofont-social-gnome:before {
  content: "\\ee0e";
}

.icofont-social-google-buzz:before {
  content: "\\ee0f";
}

.icofont-social-google-map:before {
  content: "\\ee10";
}

.icofont-social-google-plus:before {
  content: "\\ee11";
}

.icofont-social-google-talk:before {
  content: "\\ee12";
}

.icofont-social-hype-machine:before {
  content: "\\ee13";
}

.icofont-social-instagram:before {
  content: "\\ee14";
}

.icofont-brand-joomla:before {
  content: "\\ee15";
}

.icofont-social-kickstarter:before {
  content: "\\ee16";
}

.icofont-social-line:before {
  content: "\\ee17";
}

.icofont-social-linux-mint:before {
  content: "\\ee18";
}

.icofont-social-livejournal:before {
  content: "\\ee19";
}

.icofont-social-magento:before {
  content: "\\ee1a";
}

.icofont-social-meetup:before {
  content: "\\ee1b";
}

.icofont-social-mixx:before {
  content: "\\ee1c";
}

.icofont-social-newsvine:before {
  content: "\\ee1d";
}

.icofont-social-nimbuss:before {
  content: "\\ee1e";
}

.icofont-social-opencart:before {
  content: "\\ee1f";
}

.icofont-social-oscommerce:before {
  content: "\\ee20";
}

.icofont-social-pandora:before {
  content: "\\ee21";
}

.icofont-social-picasa:before {
  content: "\\ee22";
}

.icofont-social-pinterest:before {
  content: "\\ee23";
}

.icofont-social-prestashop:before {
  content: "\\ee24";
}

.icofont-social-qik:before {
  content: "\\ee25";
}

.icofont-social-readernaut:before {
  content: "\\ee26";
}

.icofont-social-reddit:before {
  content: "\\ee27";
}

.icofont-social-rss:before {
  content: "\\ee28";
}

.icofont-social-shopify:before {
  content: "\\ee29";
}

.icofont-social-silverstripe:before {
  content: "\\ee2a";
}

.icofont-social-skype:before {
  content: "\\ee2b";
}

.icofont-social-slashdot:before {
  content: "\\ee2c";
}

.icofont-social-smugmug:before {
  content: "\\ee2d";
}

.icofont-social-steam:before {
  content: "\\ee2e";
}

.icofont-social-stumbleupon:before {
  content: "\\ee2f";
}

.icofont-social-technorati:before {
  content: "\\ee30";
}

.icofont-social-telegram:before {
  content: "\\ee31";
}

.icofont-social-tinder:before {
  content: "\\ee32";
}

.icofont-social-tumblr:before {
  content: "\\ee33";
}

.icofont-social-twitter:before {
  content: "\\ee34";
}

.icofont-social-typo3:before {
  content: "\\ee35";
}

.icofont-social-ubercart:before {
  content: "\\ee36";
}

.icofont-social-viber:before {
  content: "\\ee37";
}

.icofont-social-viddler:before {
  content: "\\ee38";
}

.icofont-social-vimeo:before {
  content: "\\ee39";
}

.icofont-social-vine:before {
  content: "\\ee3a";
}

.icofont-social-virb:before {
  content: "\\ee3b";
}

.icofont-social-virtuemart:before {
  content: "\\ee3c";
}

.icofont-social-wechat:before {
  content: "\\ee3d";
}

.icofont-brand-wordpress:before {
  content: "\\ee3e";
}

.icofont-social-xing:before {
  content: "\\ee3f";
}

.icofont-social-yahoo:before {
  content: "\\ee40";
}

.icofont-social-yelp:before {
  content: "\\ee41";
}

.icofont-social-zencart:before {
  content: "\\ee42";
}

.icofont-badminton-birdie:before {
  content: "\\ee43";
}

.icofont-baseball:before {
  content: "\\ee44";
}

.icofont-baseballer:before {
  content: "\\ee45";
}

.icofont-basketball-hoop:before {
  content: "\\ee46";
}

.icofont-basketball:before {
  content: "\\ee47";
}

.icofont-billiard-ball:before {
  content: "\\ee48";
}

.icofont-boot-alt-1:before {
  content: "\\ee49";
}

.icofont-boot-alt-2:before {
  content: "\\ee4a";
}

.icofont-bowling-alt:before {
  content: "\\ee4b";
}

.icofont-bowling:before {
  content: "\\ee4c";
}

.icofont-canoe:before {
  content: "\\ee4d";
}

.icofont-cheer-leader:before {
  content: "\\ee4e";
}

.icofont-climbing:before {
  content: "\\ee4f";
}

.icofont-corner:before {
  content: "\\ee50";
}

.icofont-cyclist:before {
  content: "\\ee51";
}

.icofont-dumbbell-alt:before {
  content: "\\ee52";
}

.icofont-dumbbell:before {
  content: "\\ee53";
}

.icofont-field-alt:before {
  content: "\\ee54";
}

.icofont-field:before {
  content: "\\ee55";
}

.icofont-football-alt:before {
  content: "\\ee56";
}

.icofont-foul:before {
  content: "\\ee57";
}

.icofont-goal-keeper:before {
  content: "\\ee58";
}

.icofont-goal:before {
  content: "\\ee59";
}

.icofont-golf-alt:before {
  content: "\\ee5a";
}

.icofont-golf-bag:before {
  content: "\\ee5b";
}

.icofont-golf-field:before {
  content: "\\ee5c";
}

.icofont-golf:before {
  content: "\\ee5d";
}

.icofont-golfer:before {
  content: "\\ee5e";
}

.icofont-gym-alt-1:before {
  content: "\\ee5f";
}

.icofont-gym-alt-2:before {
  content: "\\ee60";
}

.icofont-gym-alt-3:before {
  content: "\\ee61";
}

.icofont-gym:before {
  content: "\\ee62";
}

.icofont-hand-grippers:before {
  content: "\\ee63";
}

.icofont-heart-beat-alt:before {
  content: "\\ee64";
}

.icofont-helmet:before {
  content: "\\ee65";
}

.icofont-hockey-alt:before {
  content: "\\ee66";
}

.icofont-hockey:before {
  content: "\\ee67";
}

.icofont-ice-skate:before {
  content: "\\ee68";
}

.icofont-jersey-alt:before {
  content: "\\ee69";
}

.icofont-jersey:before {
  content: "\\ee6a";
}

.icofont-jumping:before {
  content: "\\ee6b";
}

.icofont-kick:before {
  content: "\\ee6c";
}

.icofont-leg:before {
  content: "\\ee6d";
}

.icofont-match-review:before {
  content: "\\ee6e";
}

.icofont-medal-alt:before {
  content: "\\ee6f";
}

.icofont-muscle-alt:before {
  content: "\\ee70";
}

.icofont-muscle:before {
  content: "\\ee71";
}

.icofont-offside:before {
  content: "\\ee72";
}

.icofont-olympic-logo:before {
  content: "\\ee73";
}

.icofont-olympic:before {
  content: "\\ee74";
}

.icofont-padding:before {
  content: "\\ee75";
}

.icofont-penalty-card:before {
  content: "\\ee76";
}

.icofont-racer:before {
  content: "\\ee77";
}

.icofont-racing-car:before {
  content: "\\ee78";
}

.icofont-racing-flag-alt:before {
  content: "\\ee79";
}

.icofont-racing-flag:before {
  content: "\\ee7a";
}

.icofont-racings-wheel:before {
  content: "\\ee7b";
}

.icofont-referee:before {
  content: "\\ee7c";
}

.icofont-refree-jersey:before {
  content: "\\ee7d";
}

.icofont-result:before {
  content: "\\ee7e";
}

.icofont-rugby-ball:before {
  content: "\\ee7f";
}

.icofont-rugby-player:before {
  content: "\\ee80";
}

.icofont-rugby:before {
  content: "\\ee81";
}

.icofont-runner-alt-1:before {
  content: "\\ee82";
}

.icofont-runner-alt-2:before {
  content: "\\ee83";
}

.icofont-runner:before {
  content: "\\ee84";
}

.icofont-score-board:before {
  content: "\\ee85";
}

.icofont-skiing-man:before {
  content: "\\ee86";
}

.icofont-skydiving-goggles:before {
  content: "\\ee87";
}

.icofont-snow-mobile:before {
  content: "\\ee88";
}

.icofont-steering:before {
  content: "\\ee89";
}

.icofont-substitute:before {
  content: "\\ee8a";
}

.icofont-swimmer:before {
  content: "\\ee8b";
}

.icofont-table-tennis:before {
  content: "\\ee8c";
}

.icofont-team-alt:before {
  content: "\\ee8d";
}

.icofont-team:before {
  content: "\\ee8e";
}

.icofont-tennis-player:before {
  content: "\\ee8f";
}

.icofont-tennis:before {
  content: "\\ee90";
}

.icofont-time:before {
  content: "\\ee91";
}

.icofont-track:before {
  content: "\\ee92";
}

.icofont-tracking:before {
  content: "\\ee93";
}

.icofont-trophy-alt:before {
  content: "\\ee94";
}

.icofont-trophy:before {
  content: "\\ee95";
}

.icofont-volleyball-alt:before {
  content: "\\ee96";
}

.icofont-volleyball-fire:before {
  content: "\\ee97";
}

.icofont-volleyball:before {
  content: "\\ee98";
}

.icofont-water-bottle:before {
  content: "\\ee99";
}

.icofont-whisle:before {
  content: "\\ee9a";
}

.icofont-win-trophy:before {
  content: "\\ee9b";
}

.icofont-align-center:before {
  content: "\\ee9c";
}

.icofont-align-left:before {
  content: "\\ee9d";
}

.icofont-align-right:before {
  content: "\\ee9e";
}

.icofont-all-caps:before {
  content: "\\ee9f";
}

.icofont-bold:before {
  content: "\\eea0";
}

.icofont-brush:before {
  content: "\\eea1";
}

.icofont-clip-board:before {
  content: "\\eea2";
}

.icofont-code-alt:before {
  content: "\\eea3";
}

.icofont-color-bucket:before {
  content: "\\eea4";
}

.icofont-color-picker:before {
  content: "\\eea5";
}

.icofont-copy-alt:before {
  content: "\\eea6";
}

.icofont-copy-black:before {
  content: "\\eea7";
}

.icofont-cut:before {
  content: "\\eea8";
}

.icofont-delete-alt:before {
  content: "\\eea9";
}

.icofont-edit-alt:before {
  content: "\\eeaa";
}

.icofont-eraser-alt:before {
  content: "\\eeab";
}

.icofont-file-alt:before {
  content: "\\eeac";
}

.icofont-font:before {
  content: "\\eead";
}

.icofont-header:before {
  content: "\\eeae";
}

.icofont-indent:before {
  content: "\\eeaf";
}

.icofont-italic-alt:before {
  content: "\\eeb0";
}

.icofont-justify-all:before {
  content: "\\eeb1";
}

.icofont-justify-center:before {
  content: "\\eeb2";
}

.icofont-justify-left:before {
  content: "\\eeb3";
}

.icofont-justify-right:before {
  content: "\\eeb4";
}

.icofont-line-height:before {
  content: "\\eeb5";
}

.icofont-link-alt:before {
  content: "\\eeb6";
}

.icofont-listine-dots:before {
  content: "\\eeb7";
}

.icofont-listing-box:before {
  content: "\\eeb8";
}

.icofont-listing-number:before {
  content: "\\eeb9";
}

.icofont-marker:before {
  content: "\\eeba";
}

.icofont-outdent:before {
  content: "\\eebb";
}

.icofont-paper-clip:before {
  content: "\\eebc";
}

.icofont-paragraph:before {
  content: "\\eebd";
}

.icofont-pin:before {
  content: "\\eebe";
}

.icofont-printer:before {
  content: "\\eebf";
}

.icofont-redo:before {
  content: "\\eec0";
}

.icofont-rotation:before {
  content: "\\eec1";
}

.icofont-save:before {
  content: "\\eec2";
}

.icofont-small-cap:before {
  content: "\\eec3";
}

.icofont-strike-through:before {
  content: "\\eec4";
}

.icofont-sub-listing:before {
  content: "\\eec5";
}

.icofont-subscript:before {
  content: "\\eec6";
}

.icofont-superscript:before {
  content: "\\eec7";
}

.icofont-table:before {
  content: "\\eec8";
}

.icofont-text-height:before {
  content: "\\eec9";
}

.icofont-text-width:before {
  content: "\\eeca";
}

.icofont-trash:before {
  content: "\\eecb";
}

.icofont-underline:before {
  content: "\\eecc";
}

.icofont-undo:before {
  content: "\\eecd";
}

.icofont-unlink:before {
  content: "\\eece";
}

.icofont-air-balloon:before {
  content: "\\eecf";
}

.icofont-airplane-alt:before {
  content: "\\eed0";
}

.icofont-airplane:before {
  content: "\\eed1";
}

.icofont-ambulance-crescent:before {
  content: "\\eed2";
}

.icofont-ambulance-cross:before {
  content: "\\eed3";
}

.icofont-articulated-truck:before {
  content: "\\eed4";
}

.icofont-auto-rickshaw:before {
  content: "\\eed5";
}

.icofont-bicycle-alt-1:before {
  content: "\\eed6";
}

.icofont-bicycle-alt-2:before {
  content: "\\eed7";
}

.icofont-bull-dozer:before {
  content: "\\eed8";
}

.icofont-bus-alt-1:before {
  content: "\\eed9";
}

.icofont-bus-alt-2:before {
  content: "\\eeda";
}

.icofont-bus-alt-3:before {
  content: "\\eedb";
}

.icofont-cable-car:before {
  content: "\\eedc";
}

.icofont-car-alt-1:before {
  content: "\\eedd";
}

.icofont-car-alt-2:before {
  content: "\\eede";
}

.icofont-car-alt-3:before {
  content: "\\eedf";
}

.icofont-car-alt-4:before {
  content: "\\eee0";
}

.icofont-concrete-mixer:before {
  content: "\\eee1";
}

.icofont-delivery-time:before {
  content: "\\eee2";
}

.icofont-excavator:before {
  content: "\\eee3";
}

.icofont-fast-delivery:before {
  content: "\\eee4";
}

.icofont-fire-truck-alt:before {
  content: "\\eee5";
}

.icofont-fire-truck:before {
  content: "\\eee6";
}

.icofont-fork-lift:before {
  content: "\\eee7";
}

.icofont-free-delivery:before {
  content: "\\eee8";
}

.icofont-golf-cart:before {
  content: "\\eee9";
}

.icofont-helicopter:before {
  content: "\\eeea";
}

.icofont-motor-bike-alt:before {
  content: "\\eeeb";
}

.icofont-motor-bike:before {
  content: "\\eeec";
}

.icofont-motor-biker:before {
  content: "\\eeed";
}

.icofont-oil-truck:before {
  content: "\\eeee";
}

.icofont-police-car:before {
  content: "\\eeef";
}

.icofont-rickshaw:before {
  content: "\\eef0";
}

.icofont-rocket-alt-1:before {
  content: "\\eef1";
}

.icofont-rocket-alt-2:before {
  content: "\\eef2";
}

.icofont-sail-boat:before {
  content: "\\eef3";
}

.icofont-scooter:before {
  content: "\\eef4";
}

.icofont-sea-plane:before {
  content: "\\eef5";
}

.icofont-ship-alt:before {
  content: "\\eef6";
}

.icofont-speed-boat:before {
  content: "\\eef7";
}

.icofont-taxi:before {
  content: "\\eef8";
}

.icofont-tow-truck:before {
  content: "\\eef9";
}

.icofont-tractor:before {
  content: "\\eefa";
}

.icofont-traffic-light:before {
  content: "\\eefb";
}

.icofont-train-line:before {
  content: "\\eefc";
}

.icofont-train-steam:before {
  content: "\\eefd";
}

.icofont-tram:before {
  content: "\\eefe";
}

.icofont-truck-alt:before {
  content: "\\eeff";
}

.icofont-truck-loaded:before {
  content: "\\ef00";
}

.icofont-truck:before {
  content: "\\ef01";
}

.icofont-van-alt:before {
  content: "\\ef02";
}

.icofont-van:before {
  content: "\\ef03";
}

.icofont-yacht:before {
  content: "\\ef04";
}

.icofont-5-star-hotel:before {
  content: "\\ef05";
}

.icofont-anchor-alt:before {
  content: "\\ef06";
}

.icofont-beach-bed:before {
  content: "\\ef07";
}

.icofont-camping-vest:before {
  content: "\\ef08";
}

.icofont-coconut-alt:before {
  content: "\\ef09";
}

.icofont-direction-sign:before {
  content: "\\ef0a";
}

.icofont-hill-side:before {
  content: "\\ef0b";
}

.icofont-island-alt:before {
  content: "\\ef0c";
}

.icofont-long-drive:before {
  content: "\\ef0d";
}

.icofont-map-pins:before {
  content: "\\ef0e";
}

.icofont-plane-ticket:before {
  content: "\\ef0f";
}

.icofont-sail-boat-alt-1:before {
  content: "\\ef10";
}

.icofont-sail-boat-alt-2:before {
  content: "\\ef11";
}

.icofont-sandals-female:before {
  content: "\\ef12";
}

.icofont-sandals-male:before {
  content: "\\ef13";
}

.icofont-travelling:before {
  content: "\\ef14";
}

.icofont-breakdown:before {
  content: "\\ef15";
}

.icofont-celsius:before {
  content: "\\ef16";
}

.icofont-clouds:before {
  content: "\\ef17";
}

.icofont-cloudy:before {
  content: "\\ef18";
}

.icofont-compass-alt:before {
  content: "\\ef19";
}

.icofont-dust:before {
  content: "\\ef1a";
}

.icofont-eclipse:before {
  content: "\\ef1b";
}

.icofont-fahrenheit:before {
  content: "\\ef1c";
}

.icofont-forest-fire:before {
  content: "\\ef1d";
}

.icofont-full-night:before {
  content: "\\ef1e";
}

.icofont-full-sunny:before {
  content: "\\ef1f";
}

.icofont-hail-night:before {
  content: "\\ef20";
}

.icofont-hail-rainy-night:before {
  content: "\\ef21";
}

.icofont-hail-rainy-sunny:before {
  content: "\\ef22";
}

.icofont-hail-rainy:before {
  content: "\\ef23";
}

.icofont-hail-sunny:before {
  content: "\\ef24";
}

.icofont-hail-thunder-night:before {
  content: "\\ef25";
}

.icofont-hail-thunder-sunny:before {
  content: "\\ef26";
}

.icofont-hail-thunder:before {
  content: "\\ef27";
}

.icofont-hail:before {
  content: "\\ef28";
}

.icofont-hill-night:before {
  content: "\\ef29";
}

.icofont-hill-sunny:before {
  content: "\\ef2a";
}

.icofont-hill:before {
  content: "\\ef2b";
}

.icofont-hurricane:before {
  content: "\\ef2c";
}

.icofont-island:before {
  content: "\\ef2d";
}

.icofont-meteor:before {
  content: "\\ef2e";
}

.icofont-night:before {
  content: "\\ef2f";
}

.icofont-rainy-night:before {
  content: "\\ef30";
}

.icofont-rainy-sunny:before {
  content: "\\ef31";
}

.icofont-rainy-thunder:before {
  content: "\\ef32";
}

.icofont-rainy:before {
  content: "\\ef33";
}

.icofont-showy-night-hail:before {
  content: "\\ef34";
}

.icofont-snow-temp:before {
  content: "\\ef35";
}

.icofont-snow:before {
  content: "\\ef36";
}

.icofont-snowy-hail:before {
  content: "\\ef37";
}

.icofont-snowy-night-rainy:before {
  content: "\\ef38";
}

.icofont-snowy-night:before {
  content: "\\ef39";
}

.icofont-snowy-rainy:before {
  content: "\\ef3a";
}

.icofont-snowy-sunny-hail:before {
  content: "\\ef3b";
}

.icofont-snowy-sunny-rainy:before {
  content: "\\ef3c";
}

.icofont-snowy-sunny:before {
  content: "\\ef3d";
}

.icofont-snowy-thunder-night:before {
  content: "\\ef3e";
}

.icofont-snowy-thunder-sunny:before {
  content: "\\ef3f";
}

.icofont-snowy-thunder:before {
  content: "\\ef40";
}

.icofont-snowy-windy-night:before {
  content: "\\ef41";
}

.icofont-snowy-windy-sunny:before {
  content: "\\ef42";
}

.icofont-snowy-windy:before {
  content: "\\ef43";
}

.icofont-snowy:before {
  content: "\\ef44";
}

.icofont-sun-alt:before {
  content: "\\ef45";
}

.icofont-sun-rise:before {
  content: "\\ef46";
}

.icofont-sun-set:before {
  content: "\\ef47";
}

.icofont-sunny-day-temp:before {
  content: "\\ef48";
}

.icofont-sunny:before {
  content: "\\ef49";
}

.icofont-thermometer:before {
  content: "\\ef4a";
}

.icofont-thinder-light:before {
  content: "\\ef4b";
}

.icofont-tornado:before {
  content: "\\ef4c";
}

.icofont-umbrella-alt:before {
  content: "\\ef4d";
}

.icofont-volcano:before {
  content: "\\ef4e";
}

.icofont-wave:before {
  content: "\\ef4f";
}

.icofont-wind-scale-0:before {
  content: "\\ef50";
}

.icofont-wind-scale-1:before {
  content: "\\ef51";
}

.icofont-wind-scale-2:before {
  content: "\\ef52";
}

.icofont-wind-scale-3:before {
  content: "\\ef53";
}

.icofont-wind-scale-4:before {
  content: "\\ef54";
}

.icofont-wind-scale-5:before {
  content: "\\ef55";
}

.icofont-wind-scale-6:before {
  content: "\\ef56";
}

.icofont-wind-scale-7:before {
  content: "\\ef57";
}

.icofont-wind-scale-8:before {
  content: "\\ef58";
}

.icofont-wind-scale-9:before {
  content: "\\ef59";
}

.icofont-wind-scale-10:before {
  content: "\\ef5a";
}

.icofont-wind-scale-11:before {
  content: "\\ef5b";
}

.icofont-wind-scale-12:before {
  content: "\\ef5c";
}

.icofont-wind-waves:before {
  content: "\\ef5d";
}

.icofont-wind:before {
  content: "\\ef5e";
}

.icofont-windy-hail:before {
  content: "\\ef5f";
}

.icofont-windy-night:before {
  content: "\\ef60";
}

.icofont-windy-raining:before {
  content: "\\ef61";
}

.icofont-windy-sunny:before {
  content: "\\ef62";
}

.icofont-windy-thunder-raining:before {
  content: "\\ef63";
}

.icofont-windy-thunder:before {
  content: "\\ef64";
}

.icofont-windy:before {
  content: "\\ef65";
}

.icofont-addons:before {
  content: "\\ef66";
}

.icofont-address-book:before {
  content: "\\ef67";
}

.icofont-adjust:before {
  content: "\\ef68";
}

.icofont-alarm:before {
  content: "\\ef69";
}

.icofont-anchor:before {
  content: "\\ef6a";
}

.icofont-archive:before {
  content: "\\ef6b";
}

.icofont-at:before {
  content: "\\ef6c";
}

.icofont-attachment:before {
  content: "\\ef6d";
}

.icofont-audio:before {
  content: "\\ef6e";
}

.icofont-auto-mobile:before {
  content: "\\ef6f";
}

.icofont-automation:before {
  content: "\\ef70";
}

.icofont-baby:before {
  content: "\\ef71";
}

.icofont-badge:before {
  content: "\\ef72";
}

.icofont-bag:before {
  content: "\\ef73";
}

.icofont-ban:before {
  content: "\\ef74";
}

.icofont-bank:before {
  content: "\\ef75";
}

.icofont-bar-code:before {
  content: "\\ef76";
}

.icofont-bars:before {
  content: "\\ef77";
}

.icofont-battery-empty:before {
  content: "\\ef78";
}

.icofont-battery-full:before {
  content: "\\ef79";
}

.icofont-battery-half:before {
  content: "\\ef7a";
}

.icofont-battery-low:before {
  content: "\\ef7b";
}

.icofont-beach:before {
  content: "\\ef7c";
}

.icofont-beaker:before {
  content: "\\ef7d";
}

.icofont-bear:before {
  content: "\\ef7e";
}

.icofont-beard:before {
  content: "\\ef7f";
}

.icofont-bed:before {
  content: "\\ef80";
}

.icofont-bell:before {
  content: "\\ef81";
}

.icofont-beverage:before {
  content: "\\ef82";
}

.icofont-bicycle:before {
  content: "\\ef83";
}

.icofont-bill:before {
  content: "\\ef84";
}

.icofont-bin:before {
  content: "\\ef85";
}

.icofont-binary:before {
  content: "\\ef86";
}

.icofont-binoculars:before {
  content: "\\ef87";
}

.icofont-bird:before {
  content: "\\ef88";
}

.icofont-birds:before {
  content: "\\ef89";
}

.icofont-black-board:before {
  content: "\\ef8a";
}

.icofont-bluetooth:before {
  content: "\\ef8b";
}

.icofont-bolt:before {
  content: "\\ef8c";
}

.icofont-bomb:before {
  content: "\\ef8d";
}

.icofont-book-mark:before {
  content: "\\ef8e";
}

.icofont-book:before {
  content: "\\ef8f";
}

.icofont-boot:before {
  content: "\\ef90";
}

.icofont-box:before {
  content: "\\ef91";
}

.icofont-brain:before {
  content: "\\ef92";
}

.icofont-briefcase:before {
  content: "\\ef93";
}

.icofont-broken:before {
  content: "\\ef94";
}

.icofont-bucket:before {
  content: "\\ef95";
}

.icofont-bucket1:before {
  content: "\\ef96";
}

.icofont-bucket2:before {
  content: "\\ef97";
}

.icofont-bug:before {
  content: "\\ef98";
}

.icofont-building:before {
  content: "\\ef99";
}

.icofont-bullet:before {
  content: "\\ef9a";
}

.icofont-bullhorn:before {
  content: "\\ef9b";
}

.icofont-bullseye:before {
  content: "\\ef9c";
}

.icofont-bus:before {
  content: "\\ef9d";
}

.icofont-butterfly:before {
  content: "\\ef9e";
}

.icofont-cab:before {
  content: "\\ef9f";
}

.icofont-calculator:before {
  content: "\\efa0";
}

.icofont-calendar:before {
  content: "\\efa1";
}

.icofont-camera-alt:before {
  content: "\\efa2";
}

.icofont-camera:before {
  content: "\\efa3";
}

.icofont-car:before {
  content: "\\efa4";
}

.icofont-card:before {
  content: "\\efa5";
}

.icofont-cart:before {
  content: "\\efa6";
}

.icofont-cc:before {
  content: "\\efa7";
}

.icofont-certificate:before {
  content: "\\efa8";
}

.icofont-charging:before {
  content: "\\efa9";
}

.icofont-chat:before {
  content: "\\efaa";
}

.icofont-check-alt:before {
  content: "\\efab";
}

.icofont-check-circled:before {
  content: "\\efac";
}

.icofont-check:before {
  content: "\\efad";
}

.icofont-checked:before {
  content: "\\efae";
}

.icofont-children-care:before {
  content: "\\efaf";
}

.icofont-clock-time:before {
  content: "\\efb0";
}

.icofont-close-circled:before {
  content: "\\efb1";
}

.icofont-close-line-circled:before {
  content: "\\efb2";
}

.icofont-close-line-squared-alt:before {
  content: "\\efb3";
}

.icofont-close-line-squared:before {
  content: "\\efb4";
}

.icofont-close-line:before {
  content: "\\efb5";
}

.icofont-close-squared-alt:before {
  content: "\\efb6";
}

.icofont-close-squared:before {
  content: "\\efb7";
}

.icofont-close:before {
  content: "\\efb8";
}

.icofont-cloud-download:before {
  content: "\\efb9";
}

.icofont-cloud-refresh:before {
  content: "\\efba";
}

.icofont-cloud-upload:before {
  content: "\\efbb";
}

.icofont-cloud:before {
  content: "\\efbc";
}

.icofont-code-not-allowed:before {
  content: "\\efbd";
}

.icofont-code:before {
  content: "\\efbe";
}

.icofont-coffee-cup:before {
  content: "\\efbf";
}

.icofont-comment:before {
  content: "\\efc0";
}

.icofont-compass:before {
  content: "\\efc1";
}

.icofont-computer:before {
  content: "\\efc2";
}

.icofont-connection:before {
  content: "\\efc3";
}

.icofont-console:before {
  content: "\\efc4";
}

.icofont-contacts:before {
  content: "\\efc5";
}

.icofont-contrast:before {
  content: "\\efc6";
}

.icofont-copy:before {
  content: "\\efc7";
}

.icofont-copyright:before {
  content: "\\efc8";
}

.icofont-credit-card:before {
  content: "\\efc9";
}

.icofont-crop:before {
  content: "\\efca";
}

.icofont-crown:before {
  content: "\\efcb";
}

.icofont-cube:before {
  content: "\\efcc";
}

.icofont-cubes:before {
  content: "\\efcd";
}

.icofont-culinary:before {
  content: "\\efce";
}

.icofont-dashboard-web:before {
  content: "\\efcf";
}

.icofont-dashboard:before {
  content: "\\efd0";
}

.icofont-data:before {
  content: "\\efd1";
}

.icofont-database-add:before {
  content: "\\efd2";
}

.icofont-database-locked:before {
  content: "\\efd3";
}

.icofont-database-remove:before {
  content: "\\efd4";
}

.icofont-database:before {
  content: "\\efd5";
}

.icofont-delete:before {
  content: "\\efd6";
}

.icofont-diamond:before {
  content: "\\efd7";
}

.icofont-dice:before {
  content: "\\efd8";
}

.icofont-disabled:before {
  content: "\\efd9";
}

.icofont-disc:before {
  content: "\\efda";
}

.icofont-diskette:before {
  content: "\\efdb";
}

.icofont-document-folder:before {
  content: "\\efdc";
}

.icofont-download-alt:before {
  content: "\\efdd";
}

.icofont-download:before {
  content: "\\efde";
}

.icofont-downloaded:before {
  content: "\\efdf";
}

.icofont-earth:before {
  content: "\\efe0";
}

.icofont-ebook:before {
  content: "\\efe1";
}

.icofont-edit:before {
  content: "\\efe2";
}

.icofont-eject:before {
  content: "\\efe3";
}

.icofont-email:before {
  content: "\\efe4";
}

.icofont-envelope-open:before {
  content: "\\efe5";
}

.icofont-envelope:before {
  content: "\\efe6";
}

.icofont-eraser:before {
  content: "\\efe7";
}

.icofont-error:before {
  content: "\\efe8";
}

.icofont-exchange:before {
  content: "\\efe9";
}

.icofont-exclamation-circle:before {
  content: "\\efea";
}

.icofont-exclamation-square:before {
  content: "\\efeb";
}

.icofont-exclamation-tringle:before {
  content: "\\efec";
}

.icofont-exclamation:before {
  content: "\\efed";
}

.icofont-exit:before {
  content: "\\efee";
}

.icofont-expand:before {
  content: "\\efef";
}

.icofont-external-link:before {
  content: "\\eff0";
}

.icofont-external:before {
  content: "\\eff1";
}

.icofont-eye-blocked:before {
  content: "\\eff2";
}

.icofont-eye-dropper:before {
  content: "\\eff3";
}

.icofont-eye:before {
  content: "\\eff4";
}

.icofont-favourite:before {
  content: "\\eff5";
}

.icofont-fax:before {
  content: "\\eff6";
}

.icofont-female:before {
  content: "\\eff7";
}

.icofont-file:before {
  content: "\\eff8";
}

.icofont-film:before {
  content: "\\eff9";
}

.icofont-filter:before {
  content: "\\effa";
}

.icofont-fire-burn:before {
  content: "\\effb";
}

.icofont-fire-extinguisher:before {
  content: "\\effc";
}

.icofont-fire:before {
  content: "\\effd";
}

.icofont-first-aid:before {
  content: "\\effe";
}

.icofont-flag-alt-1:before {
  content: "\\efff";
}

.icofont-flag-alt-2:before {
  content: "\\f000";
}

.icofont-flag:before {
  content: "\\f001";
}

.icofont-flash-light:before {
  content: "\\f002";
}

.icofont-flash:before {
  content: "\\f003";
}

.icofont-flask:before {
  content: "\\f004";
}

.icofont-focus:before {
  content: "\\f005";
}

.icofont-folder-open:before {
  content: "\\f006";
}

.icofont-folder:before {
  content: "\\f007";
}

.icofont-foot-print:before {
  content: "\\f008";
}

.icofont-football-american:before {
  content: "\\f009";
}

.icofont-football:before {
  content: "\\f00a";
}

.icofont-game-console:before {
  content: "\\f00b";
}

.icofont-game-pad:before {
  content: "\\f00c";
}

.icofont-gavel:before {
  content: "\\f00d";
}

.icofont-gear:before {
  content: "\\f00e";
}

.icofont-gears:before {
  content: "\\f00f";
}

.icofont-gift:before {
  content: "\\f010";
}

.icofont-glass:before {
  content: "\\f011";
}

.icofont-globe:before {
  content: "\\f012";
}

.icofont-graduate:before {
  content: "\\f013";
}

.icofont-graffiti:before {
  content: "\\f014";
}

.icofont-grocery:before {
  content: "\\f015";
}

.icofont-group:before {
  content: "\\f016";
}

.icofont-hammer:before {
  content: "\\f017";
}

.icofont-hand:before {
  content: "\\f018";
}

.icofont-hanger:before {
  content: "\\f019";
}

.icofont-hard-disk:before {
  content: "\\f01a";
}

.icofont-headphone:before {
  content: "\\f01b";
}

.icofont-heart-beat:before {
  content: "\\f01c";
}

.icofont-heart:before {
  content: "\\f01d";
}

.icofont-history:before {
  content: "\\f01e";
}

.icofont-home:before {
  content: "\\f01f";
}

.icofont-horn:before {
  content: "\\f020";
}

.icofont-hotel:before {
  content: "\\f021";
}

.icofont-hour-glass:before {
  content: "\\f022";
}

.icofont-id:before {
  content: "\\f023";
}

.icofont-image:before {
  content: "\\f024";
}

.icofont-inbox:before {
  content: "\\f025";
}

.icofont-infinite:before {
  content: "\\f026";
}

.icofont-info-circle:before {
  content: "\\f027";
}

.icofont-info-square:before {
  content: "\\f028";
}

.icofont-info:before {
  content: "\\f029";
}

.icofont-institution:before {
  content: "\\f02a";
}

.icofont-interface:before {
  content: "\\f02b";
}

.icofont-invisible:before {
  content: "\\f02c";
}

.icofont-italic:before {
  content: "\\f02d";
}

.icofont-jacket:before {
  content: "\\f02e";
}

.icofont-jar:before {
  content: "\\f02f";
}

.icofont-jewlery:before {
  content: "\\f030";
}

.icofont-karate:before {
  content: "\\f031";
}

.icofont-key-hole:before {
  content: "\\f032";
}

.icofont-key:before {
  content: "\\f033";
}

.icofont-keyboard:before {
  content: "\\f034";
}

.icofont-kid:before {
  content: "\\f035";
}

.icofont-label:before {
  content: "\\f036";
}

.icofont-lamp:before {
  content: "\\f037";
}

.icofont-laptop:before {
  content: "\\f038";
}

.icofont-layers:before {
  content: "\\f039";
}

.icofont-layout:before {
  content: "\\f03a";
}

.icofont-leaf:before {
  content: "\\f03b";
}

.icofont-leaflet:before {
  content: "\\f03c";
}

.icofont-learn:before {
  content: "\\f03d";
}

.icofont-legal:before {
  content: "\\f03e";
}

.icofont-lego:before {
  content: "\\f03f";
}

.icofont-lemon:before {
  content: "\\f040";
}

.icofont-lens:before {
  content: "\\f041";
}

.icofont-letter:before {
  content: "\\f042";
}

.icofont-letterbox:before {
  content: "\\f043";
}

.icofont-library:before {
  content: "\\f044";
}

.icofont-license:before {
  content: "\\f045";
}

.icofont-life-bouy:before {
  content: "\\f046";
}

.icofont-life-buoy:before {
  content: "\\f047";
}

.icofont-life-jacket:before {
  content: "\\f048";
}

.icofont-life-ring:before {
  content: "\\f049";
}

.icofont-light-bulb:before {
  content: "\\f04a";
}

.icofont-lighter:before {
  content: "\\f04b";
}

.icofont-lightning-ray:before {
  content: "\\f04c";
}

.icofont-like:before {
  content: "\\f04d";
}

.icofont-link:before {
  content: "\\f04e";
}

.icofont-live-support:before {
  content: "\\f04f";
}

.icofont-location-arrow:before {
  content: "\\f050";
}

.icofont-location-pin:before {
  content: "\\f051";
}

.icofont-lock:before {
  content: "\\f052";
}

.icofont-login:before {
  content: "\\f053";
}

.icofont-logout:before {
  content: "\\f054";
}

.icofont-lollipop:before {
  content: "\\f055";
}

.icofont-look:before {
  content: "\\f056";
}

.icofont-loop:before {
  content: "\\f057";
}

.icofont-luggage:before {
  content: "\\f058";
}

.icofont-lunch:before {
  content: "\\f059";
}

.icofont-lungs:before {
  content: "\\f05a";
}

.icofont-magic-alt:before {
  content: "\\f05b";
}

.icofont-magic:before {
  content: "\\f05c";
}

.icofont-magnet:before {
  content: "\\f05d";
}

.icofont-mail-box:before {
  content: "\\f05e";
}

.icofont-mail:before {
  content: "\\f05f";
}

.icofont-male:before {
  content: "\\f060";
}

.icofont-map:before {
  content: "\\f061";
}

.icofont-math:before {
  content: "\\f062";
}

.icofont-maximize:before {
  content: "\\f063";
}

.icofont-measure:before {
  content: "\\f064";
}

.icofont-medal:before {
  content: "\\f065";
}

.icofont-medical:before {
  content: "\\f066";
}

.icofont-medicine:before {
  content: "\\f067";
}

.icofont-mega-phone:before {
  content: "\\f068";
}

.icofont-memorial:before {
  content: "\\f069";
}

.icofont-memory-card:before {
  content: "\\f06a";
}

.icofont-mic-mute:before {
  content: "\\f06b";
}

.icofont-mic:before {
  content: "\\f06c";
}

.icofont-micro-chip:before {
  content: "\\f06d";
}

.icofont-microphone:before {
  content: "\\f06e";
}

.icofont-microscope:before {
  content: "\\f06f";
}

.icofont-military:before {
  content: "\\f070";
}

.icofont-mill:before {
  content: "\\f071";
}

.icofont-minus-circle:before {
  content: "\\f072";
}

.icofont-minus-square:before {
  content: "\\f073";
}

.icofont-minus:before {
  content: "\\f074";
}

.icofont-mobile-phone:before {
  content: "\\f075";
}

.icofont-molecule:before {
  content: "\\f076";
}

.icofont-money:before {
  content: "\\f077";
}

.icofont-moon:before {
  content: "\\f078";
}

.icofont-mop:before {
  content: "\\f079";
}

.icofont-muffin:before {
  content: "\\f07a";
}

.icofont-music-alt:before {
  content: "\\f07b";
}

.icofont-music-notes:before {
  content: "\\f07c";
}

.icofont-music:before {
  content: "\\f07d";
}

.icofont-mustache:before {
  content: "\\f07e";
}

.icofont-mute-volume:before {
  content: "\\f07f";
}

.icofont-navigation-menu:before {
  content: "\\f080";
}

.icofont-navigation:before {
  content: "\\f081";
}

.icofont-network-tower:before {
  content: "\\f082";
}

.icofont-network:before {
  content: "\\f083";
}

.icofont-news:before {
  content: "\\f084";
}

.icofont-newspaper:before {
  content: "\\f085";
}

.icofont-no-smoking:before {
  content: "\\f086";
}

.icofont-not-allowed:before {
  content: "\\f087";
}

.icofont-notebook:before {
  content: "\\f088";
}

.icofont-notepad:before {
  content: "\\f089";
}

.icofont-notification:before {
  content: "\\f08a";
}

.icofont-numbered:before {
  content: "\\f08b";
}

.icofont-opposite:before {
  content: "\\f08c";
}

.icofont-optic:before {
  content: "\\f08d";
}

.icofont-options:before {
  content: "\\f08e";
}

.icofont-package:before {
  content: "\\f08f";
}

.icofont-page:before {
  content: "\\f090";
}

.icofont-paint:before {
  content: "\\f091";
}

.icofont-paper-plane:before {
  content: "\\f092";
}

.icofont-paperclip:before {
  content: "\\f093";
}

.icofont-papers:before {
  content: "\\f094";
}

.icofont-paw:before {
  content: "\\f095";
}

.icofont-pay:before {
  content: "\\f096";
}

.icofont-pen:before {
  content: "\\f097";
}

.icofont-pencil:before {
  content: "\\f098";
}

.icofont-penguin-linux:before {
  content: "\\f099";
}

.icofont-pestle:before {
  content: "\\f09a";
}

.icofont-phone-circle:before {
  content: "\\f09b";
}

.icofont-phone:before {
  content: "\\f09c";
}

.icofont-picture:before {
  content: "\\f09d";
}

.icofont-pie:before {
  content: "\\f09e";
}

.icofont-pine:before {
  content: "\\f09f";
}

.icofont-pixels:before {
  content: "\\f0a0";
}

.icofont-play:before {
  content: "\\f0a1";
}

.icofont-plugin:before {
  content: "\\f0a2";
}

.icofont-plus-circle:before {
  content: "\\f0a3";
}

.icofont-plus-square:before {
  content: "\\f0a4";
}

.icofont-plus:before {
  content: "\\f0a5";
}

.icofont-polygonal:before {
  content: "\\f0a6";
}

.icofont-power:before {
  content: "\\f0a7";
}

.icofont-presentation:before {
  content: "\\f0a8";
}

.icofont-price:before {
  content: "\\f0a9";
}

.icofont-print:before {
  content: "\\f0aa";
}

.icofont-puzzle:before {
  content: "\\f0ab";
}

.icofont-qr-code:before {
  content: "\\f0ac";
}

.icofont-queen:before {
  content: "\\f0ad";
}

.icofont-question-circle:before {
  content: "\\f0ae";
}

.icofont-question-square:before {
  content: "\\f0af";
}

.icofont-question:before {
  content: "\\f0b0";
}

.icofont-quote-left:before {
  content: "\\f0b1";
}

.icofont-quote-right:before {
  content: "\\f0b2";
}

.icofont-radio:before {
  content: "\\f0b3";
}

.icofont-random:before {
  content: "\\f0b4";
}

.icofont-recycle:before {
  content: "\\f0b5";
}

.icofont-refresh:before {
  content: "\\f0b6";
}

.icofont-repair:before {
  content: "\\f0b7";
}

.icofont-reply-all:before {
  content: "\\f0b8";
}

.icofont-reply:before {
  content: "\\f0b9";
}

.icofont-resize:before {
  content: "\\f0ba";
}

.icofont-responsive:before {
  content: "\\f0bb";
}

.icofont-retweet:before {
  content: "\\f0bc";
}

.icofont-road:before {
  content: "\\f0bd";
}

.icofont-robot:before {
  content: "\\f0be";
}

.icofont-rocket:before {
  content: "\\f0bf";
}

.icofont-royal:before {
  content: "\\f0c0";
}

.icofont-rss-feed:before {
  content: "\\f0c1";
}

.icofont-safety:before {
  content: "\\f0c2";
}

.icofont-sale-discount:before {
  content: "\\f0c3";
}

.icofont-satellite:before {
  content: "\\f0c4";
}

.icofont-send-mail:before {
  content: "\\f0c5";
}

.icofont-server:before {
  content: "\\f0c6";
}

.icofont-settings:before {
  content: "\\f0c7";
}

.icofont-share-alt:before {
  content: "\\f0c8";
}

.icofont-share-boxed:before {
  content: "\\f0c9";
}

.icofont-share:before {
  content: "\\f0ca";
}

.icofont-shield:before {
  content: "\\f0cb";
}

.icofont-ship:before {
  content: "\\f0cc";
}

.icofont-shopping-cart:before {
  content: "\\f0cd";
}

.icofont-sign-in:before {
  content: "\\f0ce";
}

.icofont-sign-out:before {
  content: "\\f0cf";
}

.icofont-signal:before {
  content: "\\f0d0";
}

.icofont-site-map:before {
  content: "\\f0d1";
}

.icofont-smart-phone:before {
  content: "\\f0d2";
}

.icofont-soccer:before {
  content: "\\f0d3";
}

.icofont-sort-alt:before {
  content: "\\f0d4";
}

.icofont-sort:before {
  content: "\\f0d5";
}

.icofont-space:before {
  content: "\\f0d6";
}

.icofont-spanner:before {
  content: "\\f0d7";
}

.icofont-speech-comments:before {
  content: "\\f0d8";
}

.icofont-speed-meter:before {
  content: "\\f0d9";
}

.icofont-spinner-alt-1:before {
  content: "\\f0da";
}

.icofont-spinner-alt-2:before {
  content: "\\f0db";
}

.icofont-spinner-alt-3:before {
  content: "\\f0dc";
}

.icofont-spinner-alt-4:before {
  content: "\\f0dd";
}

.icofont-spinner-alt-5:before {
  content: "\\f0de";
}

.icofont-spinner-alt-6:before {
  content: "\\f0df";
}

.icofont-spinner:before {
  content: "\\f0e0";
}

.icofont-spreadsheet:before {
  content: "\\f0e1";
}

.icofont-square:before {
  content: "\\f0e2";
}

.icofont-ssl-security:before {
  content: "\\f0e3";
}

.icofont-star-alt-1:before {
  content: "\\f0e4";
}

.icofont-star-alt-2:before {
  content: "\\f0e5";
}

.icofont-star:before {
  content: "\\f0e6";
}

.icofont-street-view:before {
  content: "\\f0e7";
}

.icofont-sun:before {
  content: "\\f0e8";
}

.icofont-support-faq:before {
  content: "\\f0e9";
}

.icofont-tack-pin:before {
  content: "\\f0ea";
}

.icofont-tag:before {
  content: "\\f0eb";
}

.icofont-tags:before {
  content: "\\f0ec";
}

.icofont-tasks:before {
  content: "\\f0ed";
}

.icofont-telephone:before {
  content: "\\f0ee";
}

.icofont-telescope:before {
  content: "\\f0ef";
}

.icofont-terminal:before {
  content: "\\f0f0";
}

.icofont-thumbs-down:before {
  content: "\\f0f1";
}

.icofont-thumbs-up:before {
  content: "\\f0f2";
}

.icofont-tick-boxed:before {
  content: "\\f0f3";
}

.icofont-tick-mark:before {
  content: "\\f0f4";
}

.icofont-ticket:before {
  content: "\\f0f5";
}

.icofont-tie:before {
  content: "\\f0f6";
}

.icofont-toggle-off:before {
  content: "\\f0f7";
}

.icofont-toggle-on:before {
  content: "\\f0f8";
}

.icofont-tools:before {
  content: "\\f0f9";
}

.icofont-transparent:before {
  content: "\\f0fa";
}

.icofont-tree:before {
  content: "\\f0fb";
}

.icofont-umbrella:before {
  content: "\\f0fc";
}

.icofont-unlock:before {
  content: "\\f0fd";
}

.icofont-unlocked:before {
  content: "\\f0fe";
}

.icofont-upload-alt:before {
  content: "\\f0ff";
}

.icofont-upload:before {
  content: "\\f100";
}

.icofont-usb-drive:before {
  content: "\\f101";
}

.icofont-usb:before {
  content: "\\f102";
}

.icofont-vector-path:before {
  content: "\\f103";
}

.icofont-verification-check:before {
  content: "\\f104";
}

.icofont-video-clapper:before {
  content: "\\f105";
}

.icofont-video:before {
  content: "\\f106";
}

.icofont-volume-down:before {
  content: "\\f107";
}

.icofont-volume-off:before {
  content: "\\f108";
}

.icofont-volume-up:before {
  content: "\\f109";
}

.icofont-wall-clock:before {
  content: "\\f10a";
}

.icofont-wall:before {
  content: "\\f10b";
}

.icofont-wallet:before {
  content: "\\f10c";
}

.icofont-warning-alt:before {
  content: "\\f10d";
}

.icofont-warning:before {
  content: "\\f10e";
}

.icofont-water-drop:before {
  content: "\\f10f";
}

.icofont-web:before {
  content: "\\f110";
}

.icofont-wheelchair:before {
  content: "\\f111";
}

.icofont-wifi-alt:before {
  content: "\\f112";
}

.icofont-wifi:before {
  content: "\\f113";
}

.icofont-world:before {
  content: "\\f114";
}

.icofont-zigzag:before {
  content: "\\f115";
}

.icofont-zipped:before {
  content: "\\f116";
}

.icofont-social-500px:before {
  content: "\\f117";
}

.icofont-social-baidu-tieba:before {
  content: "\\f118";
}

.icofont-social-bbm-messenger:before {
  content: "\\f119";
}

.icofont-social-delicious:before {
  content: "\\f11a";
}

.icofont-social-dribbble:before {
  content: "\\f11b";
}

.icofont-social-facebook-messenger:before {
  content: "\\f11c";
}

.icofont-social-flikr:before {
  content: "\\f11d";
}

.icofont-social-foursquare:before {
  content: "\\f11e";
}

.icofont-social-google-hangouts:before {
  content: "\\f11f";
}

.icofont-social-kakaotalk:before {
  content: "\\f120";
}

.icofont-social-kik:before {
  content: "\\f121";
}

.icofont-social-kiwibox:before {
  content: "\\f122";
}

.icofont-social-linkedin:before {
  content: "\\f123";
}

.icofont-social-meetme:before {
  content: "\\f124";
}

.icofont-social-odnoklassniki:before {
  content: "\\f125";
}

.icofont-social-photobucket:before {
  content: "\\f126";
}

.icofont-social-qq:before {
  content: "\\f127";
}

.icofont-social-renren:before {
  content: "\\f128";
}

.icofont-social-slack:before {
  content: "\\f129";
}

.icofont-social-slidshare:before {
  content: "\\f12a";
}

.icofont-social-snapchat:before {
  content: "\\f12b";
}

.icofont-social-soundcloud:before {
  content: "\\f12c";
}

.icofont-social-spotify:before {
  content: "\\f12d";
}

.icofont-social-stack-exchange:before {
  content: "\\f12e";
}

.icofont-social-stack-overflow:before {
  content: "\\f12f";
}

.icofont-social-tagged:before {
  content: "\\f130";
}

.icofont-social-trello:before {
  content: "\\f131";
}

.icofont-social-twitch:before {
  content: "\\f132";
}

.icofont-social-vk:before {
  content: "\\f133";
}

.icofont-social-weibo:before {
  content: "\\f134";
}

.icofont-social-whatsapp:before {
  content: "\\f135";
}

.icofont-social-youku:before {
  content: "\\f136";
}

.icofont-social-youtube-play:before {
  content: "\\f137";
}

.icofont-social-youtube:before {
  content: "\\f138";
}

.icofont-brand-xiaomi:before {
  content: "\\f139";
}

/*Font size*/
.icofont-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}

.icofont-2x {
  font-size: 2em;
}

.icofont-3x {
  font-size: 3em;
}

.icofont-4x {
  font-size: 4em;
}

.icofont-5x {
  font-size: 5em;
}

.icofont-fw {
  display: inline-block;
  width: 1.28571429em;
  text-align: center;
  width: 1.28571429em;
  text-align: center;
}

/*Fixed Width Icons*/
/*Custom list icons*/
.icofont-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.icofont-ul > li {
  position: relative;
}

.icofont-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}

/*Animation*/
.icofont-rotate {
  display: inline-block;
  animation: icofont-rotate 2s infinite linear;
}
@keyframes icofont-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
/*!
 *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: "FontAwesome";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_286___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_287___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_288___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_289___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_290___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_291___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* makes the font 33% larger relative to the icon container */
.fa-lg {
  font-size: 1.3333333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-fw {
  width: 1.2857142857em;
  text-align: center;
}

.fa-ul {
  padding-left: 0;
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  top: 0.1428571429em;
  text-align: center;
}
.fa-li.fa-lg {
  left: -1.8571428571em;
}

.fa-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eee;
  border-radius: 0.1em;
}

.fa-pull-left {
  float: left;
}

.fa-pull-right {
  float: right;
}

.fa.fa-pull-left {
  margin-right: 0.3em;
}
.fa.fa-pull-right {
  margin-left: 0.3em;
}

/* Deprecated as of 4.4.0 */
.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

.fa.pull-left {
  margin-right: 0.3em;
}
.fa.pull-right {
  margin-left: 0.3em;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

.fa-pulse {
  animation: fa-spin 1s infinite steps(8);
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical {
  filter: none;
}

.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.fa-stack-1x, .fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
  font-size: 2em;
}

.fa-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
   readers do not read off random characters that represent icons */
.fa-glass:before {
  content: "\\f000";
}

.fa-music:before {
  content: "\\f001";
}

.fa-search:before {
  content: "\\f002";
}

.fa-envelope-o:before {
  content: "\\f003";
}

.fa-heart:before {
  content: "\\f004";
}

.fa-star:before {
  content: "\\f005";
}

.fa-star-o:before {
  content: "\\f006";
}

.fa-user:before {
  content: "\\f007";
}

.fa-film:before {
  content: "\\f008";
}

.fa-th-large:before {
  content: "\\f009";
}

.fa-th:before {
  content: "\\f00a";
}

.fa-th-list:before {
  content: "\\f00b";
}

.fa-check:before {
  content: "\\f00c";
}

.fa-remove:before,
.fa-close:before,
.fa-times:before {
  content: "\\f00d";
}

.fa-search-plus:before {
  content: "\\f00e";
}

.fa-search-minus:before {
  content: "\\f010";
}

.fa-power-off:before {
  content: "\\f011";
}

.fa-signal:before {
  content: "\\f012";
}

.fa-gear:before,
.fa-cog:before {
  content: "\\f013";
}

.fa-trash-o:before {
  content: "\\f014";
}

.fa-home:before {
  content: "\\f015";
}

.fa-file-o:before {
  content: "\\f016";
}

.fa-clock-o:before {
  content: "\\f017";
}

.fa-road:before {
  content: "\\f018";
}

.fa-download:before {
  content: "\\f019";
}

.fa-arrow-circle-o-down:before {
  content: "\\f01a";
}

.fa-arrow-circle-o-up:before {
  content: "\\f01b";
}

.fa-inbox:before {
  content: "\\f01c";
}

.fa-play-circle-o:before {
  content: "\\f01d";
}

.fa-rotate-right:before,
.fa-repeat:before {
  content: "\\f01e";
}

.fa-refresh:before {
  content: "\\f021";
}

.fa-list-alt:before {
  content: "\\f022";
}

.fa-lock:before {
  content: "\\f023";
}

.fa-flag:before {
  content: "\\f024";
}

.fa-headphones:before {
  content: "\\f025";
}

.fa-volume-off:before {
  content: "\\f026";
}

.fa-volume-down:before {
  content: "\\f027";
}

.fa-volume-up:before {
  content: "\\f028";
}

.fa-qrcode:before {
  content: "\\f029";
}

.fa-barcode:before {
  content: "\\f02a";
}

.fa-tag:before {
  content: "\\f02b";
}

.fa-tags:before {
  content: "\\f02c";
}

.fa-book:before {
  content: "\\f02d";
}

.fa-bookmark:before {
  content: "\\f02e";
}

.fa-print:before {
  content: "\\f02f";
}

.fa-camera:before {
  content: "\\f030";
}

.fa-font:before {
  content: "\\f031";
}

.fa-bold:before {
  content: "\\f032";
}

.fa-italic:before {
  content: "\\f033";
}

.fa-text-height:before {
  content: "\\f034";
}

.fa-text-width:before {
  content: "\\f035";
}

.fa-align-left:before {
  content: "\\f036";
}

.fa-align-center:before {
  content: "\\f037";
}

.fa-align-right:before {
  content: "\\f038";
}

.fa-align-justify:before {
  content: "\\f039";
}

.fa-list:before {
  content: "\\f03a";
}

.fa-dedent:before,
.fa-outdent:before {
  content: "\\f03b";
}

.fa-indent:before {
  content: "\\f03c";
}

.fa-video-camera:before {
  content: "\\f03d";
}

.fa-photo:before,
.fa-image:before,
.fa-picture-o:before {
  content: "\\f03e";
}

.fa-pencil:before {
  content: "\\f040";
}

.fa-map-marker:before {
  content: "\\f041";
}

.fa-adjust:before {
  content: "\\f042";
}

.fa-tint:before {
  content: "\\f043";
}

.fa-edit:before,
.fa-pencil-square-o:before {
  content: "\\f044";
}

.fa-share-square-o:before {
  content: "\\f045";
}

.fa-check-square-o:before {
  content: "\\f046";
}

.fa-arrows:before {
  content: "\\f047";
}

.fa-step-backward:before {
  content: "\\f048";
}

.fa-fast-backward:before {
  content: "\\f049";
}

.fa-backward:before {
  content: "\\f04a";
}

.fa-play:before {
  content: "\\f04b";
}

.fa-pause:before {
  content: "\\f04c";
}

.fa-stop:before {
  content: "\\f04d";
}

.fa-forward:before {
  content: "\\f04e";
}

.fa-fast-forward:before {
  content: "\\f050";
}

.fa-step-forward:before {
  content: "\\f051";
}

.fa-eject:before {
  content: "\\f052";
}

.fa-chevron-left:before {
  content: "\\f053";
}

.fa-chevron-right:before {
  content: "\\f054";
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-minus-circle:before {
  content: "\\f056";
}

.fa-times-circle:before {
  content: "\\f057";
}

.fa-check-circle:before {
  content: "\\f058";
}

.fa-question-circle:before {
  content: "\\f059";
}

.fa-info-circle:before {
  content: "\\f05a";
}

.fa-crosshairs:before {
  content: "\\f05b";
}

.fa-times-circle-o:before {
  content: "\\f05c";
}

.fa-check-circle-o:before {
  content: "\\f05d";
}

.fa-ban:before {
  content: "\\f05e";
}

.fa-arrow-left:before {
  content: "\\f060";
}

.fa-arrow-right:before {
  content: "\\f061";
}

.fa-arrow-up:before {
  content: "\\f062";
}

.fa-arrow-down:before {
  content: "\\f063";
}

.fa-mail-forward:before,
.fa-share:before {
  content: "\\f064";
}

.fa-expand:before {
  content: "\\f065";
}

.fa-compress:before {
  content: "\\f066";
}

.fa-plus:before {
  content: "\\f067";
}

.fa-minus:before {
  content: "\\f068";
}

.fa-asterisk:before {
  content: "\\f069";
}

.fa-exclamation-circle:before {
  content: "\\f06a";
}

.fa-gift:before {
  content: "\\f06b";
}

.fa-leaf:before {
  content: "\\f06c";
}

.fa-fire:before {
  content: "\\f06d";
}

.fa-eye:before {
  content: "\\f06e";
}

.fa-eye-slash:before {
  content: "\\f070";
}

.fa-warning:before,
.fa-exclamation-triangle:before {
  content: "\\f071";
}

.fa-plane:before {
  content: "\\f072";
}

.fa-calendar:before {
  content: "\\f073";
}

.fa-random:before {
  content: "\\f074";
}

.fa-comment:before {
  content: "\\f075";
}

.fa-magnet:before {
  content: "\\f076";
}

.fa-chevron-up:before {
  content: "\\f077";
}

.fa-chevron-down:before {
  content: "\\f078";
}

.fa-retweet:before {
  content: "\\f079";
}

.fa-shopping-cart:before {
  content: "\\f07a";
}

.fa-folder:before {
  content: "\\f07b";
}

.fa-folder-open:before {
  content: "\\f07c";
}

.fa-arrows-v:before {
  content: "\\f07d";
}

.fa-arrows-h:before {
  content: "\\f07e";
}

.fa-bar-chart-o:before,
.fa-bar-chart:before {
  content: "\\f080";
}

.fa-twitter-square:before {
  content: "\\f081";
}

.fa-facebook-square:before {
  content: "\\f082";
}

.fa-camera-retro:before {
  content: "\\f083";
}

.fa-key:before {
  content: "\\f084";
}

.fa-gears:before,
.fa-cogs:before {
  content: "\\f085";
}

.fa-comments:before {
  content: "\\f086";
}

.fa-thumbs-o-up:before {
  content: "\\f087";
}

.fa-thumbs-o-down:before {
  content: "\\f088";
}

.fa-star-half:before {
  content: "\\f089";
}

.fa-heart-o:before {
  content: "\\f08a";
}

.fa-sign-out:before {
  content: "\\f08b";
}

.fa-linkedin-square:before {
  content: "\\f08c";
}

.fa-thumb-tack:before {
  content: "\\f08d";
}

.fa-external-link:before {
  content: "\\f08e";
}

.fa-sign-in:before {
  content: "\\f090";
}

.fa-trophy:before {
  content: "\\f091";
}

.fa-github-square:before {
  content: "\\f092";
}

.fa-upload:before {
  content: "\\f093";
}

.fa-lemon-o:before {
  content: "\\f094";
}

.fa-phone:before {
  content: "\\f095";
}

.fa-square-o:before {
  content: "\\f096";
}

.fa-bookmark-o:before {
  content: "\\f097";
}

.fa-phone-square:before {
  content: "\\f098";
}

.fa-twitter:before {
  content: "\\f099";
}

.fa-facebook-f:before,
.fa-facebook:before {
  content: "\\f09a";
}

.fa-github:before {
  content: "\\f09b";
}

.fa-unlock:before {
  content: "\\f09c";
}

.fa-credit-card:before {
  content: "\\f09d";
}

.fa-feed:before,
.fa-rss:before {
  content: "\\f09e";
}

.fa-hdd-o:before {
  content: "\\f0a0";
}

.fa-bullhorn:before {
  content: "\\f0a1";
}

.fa-bell:before {
  content: "\\f0f3";
}

.fa-certificate:before {
  content: "\\f0a3";
}

.fa-hand-o-right:before {
  content: "\\f0a4";
}

.fa-hand-o-left:before {
  content: "\\f0a5";
}

.fa-hand-o-up:before {
  content: "\\f0a6";
}

.fa-hand-o-down:before {
  content: "\\f0a7";
}

.fa-arrow-circle-left:before {
  content: "\\f0a8";
}

.fa-arrow-circle-right:before {
  content: "\\f0a9";
}

.fa-arrow-circle-up:before {
  content: "\\f0aa";
}

.fa-arrow-circle-down:before {
  content: "\\f0ab";
}

.fa-globe:before {
  content: "\\f0ac";
}

.fa-wrench:before {
  content: "\\f0ad";
}

.fa-tasks:before {
  content: "\\f0ae";
}

.fa-filter:before {
  content: "\\f0b0";
}

.fa-briefcase:before {
  content: "\\f0b1";
}

.fa-arrows-alt:before {
  content: "\\f0b2";
}

.fa-group:before,
.fa-users:before {
  content: "\\f0c0";
}

.fa-chain:before,
.fa-link:before {
  content: "\\f0c1";
}

.fa-cloud:before {
  content: "\\f0c2";
}

.fa-flask:before {
  content: "\\f0c3";
}

.fa-cut:before,
.fa-scissors:before {
  content: "\\f0c4";
}

.fa-copy:before,
.fa-files-o:before {
  content: "\\f0c5";
}

.fa-paperclip:before {
  content: "\\f0c6";
}

.fa-save:before,
.fa-floppy-o:before {
  content: "\\f0c7";
}

.fa-square:before {
  content: "\\f0c8";
}

.fa-navicon:before,
.fa-reorder:before,
.fa-bars:before {
  content: "\\f0c9";
}

.fa-list-ul:before {
  content: "\\f0ca";
}

.fa-list-ol:before {
  content: "\\f0cb";
}

.fa-strikethrough:before {
  content: "\\f0cc";
}

.fa-underline:before {
  content: "\\f0cd";
}

.fa-table:before {
  content: "\\f0ce";
}

.fa-magic:before {
  content: "\\f0d0";
}

.fa-truck:before {
  content: "\\f0d1";
}

.fa-pinterest:before {
  content: "\\f0d2";
}

.fa-pinterest-square:before {
  content: "\\f0d3";
}

.fa-google-plus-square:before {
  content: "\\f0d4";
}

.fa-google-plus:before {
  content: "\\f0d5";
}

.fa-money:before {
  content: "\\f0d6";
}

.fa-caret-down:before {
  content: "\\f0d7";
}

.fa-caret-up:before {
  content: "\\f0d8";
}

.fa-caret-left:before {
  content: "\\f0d9";
}

.fa-caret-right:before {
  content: "\\f0da";
}

.fa-columns:before {
  content: "\\f0db";
}

.fa-unsorted:before,
.fa-sort:before {
  content: "\\f0dc";
}

.fa-sort-down:before,
.fa-sort-desc:before {
  content: "\\f0dd";
}

.fa-sort-up:before,
.fa-sort-asc:before {
  content: "\\f0de";
}

.fa-envelope:before {
  content: "\\f0e0";
}

.fa-linkedin:before {
  content: "\\f0e1";
}

.fa-rotate-left:before,
.fa-undo:before {
  content: "\\f0e2";
}

.fa-legal:before,
.fa-gavel:before {
  content: "\\f0e3";
}

.fa-dashboard:before,
.fa-tachometer:before {
  content: "\\f0e4";
}

.fa-comment-o:before {
  content: "\\f0e5";
}

.fa-comments-o:before {
  content: "\\f0e6";
}

.fa-flash:before,
.fa-bolt:before {
  content: "\\f0e7";
}

.fa-sitemap:before {
  content: "\\f0e8";
}

.fa-umbrella:before {
  content: "\\f0e9";
}

.fa-paste:before,
.fa-clipboard:before {
  content: "\\f0ea";
}

.fa-lightbulb-o:before {
  content: "\\f0eb";
}

.fa-exchange:before {
  content: "\\f0ec";
}

.fa-cloud-download:before {
  content: "\\f0ed";
}

.fa-cloud-upload:before {
  content: "\\f0ee";
}

.fa-user-md:before {
  content: "\\f0f0";
}

.fa-stethoscope:before {
  content: "\\f0f1";
}

.fa-suitcase:before {
  content: "\\f0f2";
}

.fa-bell-o:before {
  content: "\\f0a2";
}

.fa-coffee:before {
  content: "\\f0f4";
}

.fa-cutlery:before {
  content: "\\f0f5";
}

.fa-file-text-o:before {
  content: "\\f0f6";
}

.fa-building-o:before {
  content: "\\f0f7";
}

.fa-hospital-o:before {
  content: "\\f0f8";
}

.fa-ambulance:before {
  content: "\\f0f9";
}

.fa-medkit:before {
  content: "\\f0fa";
}

.fa-fighter-jet:before {
  content: "\\f0fb";
}

.fa-beer:before {
  content: "\\f0fc";
}

.fa-h-square:before {
  content: "\\f0fd";
}

.fa-plus-square:before {
  content: "\\f0fe";
}

.fa-angle-double-left:before {
  content: "\\f100";
}

.fa-angle-double-right:before {
  content: "\\f101";
}

.fa-angle-double-up:before {
  content: "\\f102";
}

.fa-angle-double-down:before {
  content: "\\f103";
}

.fa-angle-left:before {
  content: "\\f104";
}

.fa-angle-right:before {
  content: "\\f105";
}

.fa-angle-up:before {
  content: "\\f106";
}

.fa-angle-down:before {
  content: "\\f107";
}

.fa-desktop:before {
  content: "\\f108";
}

.fa-laptop:before {
  content: "\\f109";
}

.fa-tablet:before {
  content: "\\f10a";
}

.fa-mobile-phone:before,
.fa-mobile:before {
  content: "\\f10b";
}

.fa-circle-o:before {
  content: "\\f10c";
}

.fa-quote-left:before {
  content: "\\f10d";
}

.fa-quote-right:before {
  content: "\\f10e";
}

.fa-spinner:before {
  content: "\\f110";
}

.fa-circle:before {
  content: "\\f111";
}

.fa-mail-reply:before,
.fa-reply:before {
  content: "\\f112";
}

.fa-github-alt:before {
  content: "\\f113";
}

.fa-folder-o:before {
  content: "\\f114";
}

.fa-folder-open-o:before {
  content: "\\f115";
}

.fa-smile-o:before {
  content: "\\f118";
}

.fa-frown-o:before {
  content: "\\f119";
}

.fa-meh-o:before {
  content: "\\f11a";
}

.fa-gamepad:before {
  content: "\\f11b";
}

.fa-keyboard-o:before {
  content: "\\f11c";
}

.fa-flag-o:before {
  content: "\\f11d";
}

.fa-flag-checkered:before {
  content: "\\f11e";
}

.fa-terminal:before {
  content: "\\f120";
}

.fa-code:before {
  content: "\\f121";
}

.fa-mail-reply-all:before,
.fa-reply-all:before {
  content: "\\f122";
}

.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: "\\f123";
}

.fa-location-arrow:before {
  content: "\\f124";
}

.fa-crop:before {
  content: "\\f125";
}

.fa-code-fork:before {
  content: "\\f126";
}

.fa-unlink:before,
.fa-chain-broken:before {
  content: "\\f127";
}

.fa-question:before {
  content: "\\f128";
}

.fa-info:before {
  content: "\\f129";
}

.fa-exclamation:before {
  content: "\\f12a";
}

.fa-superscript:before {
  content: "\\f12b";
}

.fa-subscript:before {
  content: "\\f12c";
}

.fa-eraser:before {
  content: "\\f12d";
}

.fa-puzzle-piece:before {
  content: "\\f12e";
}

.fa-microphone:before {
  content: "\\f130";
}

.fa-microphone-slash:before {
  content: "\\f131";
}

.fa-shield:before {
  content: "\\f132";
}

.fa-calendar-o:before {
  content: "\\f133";
}

.fa-fire-extinguisher:before {
  content: "\\f134";
}

.fa-rocket:before {
  content: "\\f135";
}

.fa-maxcdn:before {
  content: "\\f136";
}

.fa-chevron-circle-left:before {
  content: "\\f137";
}

.fa-chevron-circle-right:before {
  content: "\\f138";
}

.fa-chevron-circle-up:before {
  content: "\\f139";
}

.fa-chevron-circle-down:before {
  content: "\\f13a";
}

.fa-html5:before {
  content: "\\f13b";
}

.fa-css3:before {
  content: "\\f13c";
}

.fa-anchor:before {
  content: "\\f13d";
}

.fa-unlock-alt:before {
  content: "\\f13e";
}

.fa-bullseye:before {
  content: "\\f140";
}

.fa-ellipsis-h:before {
  content: "\\f141";
}

.fa-ellipsis-v:before {
  content: "\\f142";
}

.fa-rss-square:before {
  content: "\\f143";
}

.fa-play-circle:before {
  content: "\\f144";
}

.fa-ticket:before {
  content: "\\f145";
}

.fa-minus-square:before {
  content: "\\f146";
}

.fa-minus-square-o:before {
  content: "\\f147";
}

.fa-level-up:before {
  content: "\\f148";
}

.fa-level-down:before {
  content: "\\f149";
}

.fa-check-square:before {
  content: "\\f14a";
}

.fa-pencil-square:before {
  content: "\\f14b";
}

.fa-external-link-square:before {
  content: "\\f14c";
}

.fa-share-square:before {
  content: "\\f14d";
}

.fa-compass:before {
  content: "\\f14e";
}

.fa-toggle-down:before,
.fa-caret-square-o-down:before {
  content: "\\f150";
}

.fa-toggle-up:before,
.fa-caret-square-o-up:before {
  content: "\\f151";
}

.fa-toggle-right:before,
.fa-caret-square-o-right:before {
  content: "\\f152";
}

.fa-euro:before,
.fa-eur:before {
  content: "\\f153";
}

.fa-gbp:before {
  content: "\\f154";
}

.fa-dollar:before,
.fa-usd:before {
  content: "\\f155";
}

.fa-rupee:before,
.fa-inr:before {
  content: "\\f156";
}

.fa-cny:before,
.fa-rmb:before,
.fa-yen:before,
.fa-jpy:before {
  content: "\\f157";
}

.fa-ruble:before,
.fa-rouble:before,
.fa-rub:before {
  content: "\\f158";
}

.fa-won:before,
.fa-krw:before {
  content: "\\f159";
}

.fa-bitcoin:before,
.fa-btc:before {
  content: "\\f15a";
}

.fa-file:before {
  content: "\\f15b";
}

.fa-file-text:before {
  content: "\\f15c";
}

.fa-sort-alpha-asc:before {
  content: "\\f15d";
}

.fa-sort-alpha-desc:before {
  content: "\\f15e";
}

.fa-sort-amount-asc:before {
  content: "\\f160";
}

.fa-sort-amount-desc:before {
  content: "\\f161";
}

.fa-sort-numeric-asc:before {
  content: "\\f162";
}

.fa-sort-numeric-desc:before {
  content: "\\f163";
}

.fa-thumbs-up:before {
  content: "\\f164";
}

.fa-thumbs-down:before {
  content: "\\f165";
}

.fa-youtube-square:before {
  content: "\\f166";
}

.fa-youtube:before {
  content: "\\f167";
}

.fa-xing:before {
  content: "\\f168";
}

.fa-xing-square:before {
  content: "\\f169";
}

.fa-youtube-play:before {
  content: "\\f16a";
}

.fa-dropbox:before {
  content: "\\f16b";
}

.fa-stack-overflow:before {
  content: "\\f16c";
}

.fa-instagram:before {
  content: "\\f16d";
}

.fa-flickr:before {
  content: "\\f16e";
}

.fa-adn:before {
  content: "\\f170";
}

.fa-bitbucket:before {
  content: "\\f171";
}

.fa-bitbucket-square:before {
  content: "\\f172";
}

.fa-tumblr:before {
  content: "\\f173";
}

.fa-tumblr-square:before {
  content: "\\f174";
}

.fa-long-arrow-down:before {
  content: "\\f175";
}

.fa-long-arrow-up:before {
  content: "\\f176";
}

.fa-long-arrow-left:before {
  content: "\\f177";
}

.fa-long-arrow-right:before {
  content: "\\f178";
}

.fa-apple:before {
  content: "\\f179";
}

.fa-windows:before {
  content: "\\f17a";
}

.fa-android:before {
  content: "\\f17b";
}

.fa-linux:before {
  content: "\\f17c";
}

.fa-dribbble:before {
  content: "\\f17d";
}

.fa-skype:before {
  content: "\\f17e";
}

.fa-foursquare:before {
  content: "\\f180";
}

.fa-trello:before {
  content: "\\f181";
}

.fa-female:before {
  content: "\\f182";
}

.fa-male:before {
  content: "\\f183";
}

.fa-gittip:before,
.fa-gratipay:before {
  content: "\\f184";
}

.fa-sun-o:before {
  content: "\\f185";
}

.fa-moon-o:before {
  content: "\\f186";
}

.fa-archive:before {
  content: "\\f187";
}

.fa-bug:before {
  content: "\\f188";
}

.fa-vk:before {
  content: "\\f189";
}

.fa-weibo:before {
  content: "\\f18a";
}

.fa-renren:before {
  content: "\\f18b";
}

.fa-pagelines:before {
  content: "\\f18c";
}

.fa-stack-exchange:before {
  content: "\\f18d";
}

.fa-arrow-circle-o-right:before {
  content: "\\f18e";
}

.fa-arrow-circle-o-left:before {
  content: "\\f190";
}

.fa-toggle-left:before,
.fa-caret-square-o-left:before {
  content: "\\f191";
}

.fa-dot-circle-o:before {
  content: "\\f192";
}

.fa-wheelchair:before {
  content: "\\f193";
}

.fa-vimeo-square:before {
  content: "\\f194";
}

.fa-turkish-lira:before,
.fa-try:before {
  content: "\\f195";
}

.fa-plus-square-o:before {
  content: "\\f196";
}

.fa-space-shuttle:before {
  content: "\\f197";
}

.fa-slack:before {
  content: "\\f198";
}

.fa-envelope-square:before {
  content: "\\f199";
}

.fa-wordpress:before {
  content: "\\f19a";
}

.fa-openid:before {
  content: "\\f19b";
}

.fa-institution:before,
.fa-bank:before,
.fa-university:before {
  content: "\\f19c";
}

.fa-mortar-board:before,
.fa-graduation-cap:before {
  content: "\\f19d";
}

.fa-yahoo:before {
  content: "\\f19e";
}

.fa-google:before {
  content: "\\f1a0";
}

.fa-reddit:before {
  content: "\\f1a1";
}

.fa-reddit-square:before {
  content: "\\f1a2";
}

.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}

.fa-stumbleupon:before {
  content: "\\f1a4";
}

.fa-delicious:before {
  content: "\\f1a5";
}

.fa-digg:before {
  content: "\\f1a6";
}

.fa-pied-piper-pp:before {
  content: "\\f1a7";
}

.fa-pied-piper-alt:before {
  content: "\\f1a8";
}

.fa-drupal:before {
  content: "\\f1a9";
}

.fa-joomla:before {
  content: "\\f1aa";
}

.fa-language:before {
  content: "\\f1ab";
}

.fa-fax:before {
  content: "\\f1ac";
}

.fa-building:before {
  content: "\\f1ad";
}

.fa-child:before {
  content: "\\f1ae";
}

.fa-paw:before {
  content: "\\f1b0";
}

.fa-spoon:before {
  content: "\\f1b1";
}

.fa-cube:before {
  content: "\\f1b2";
}

.fa-cubes:before {
  content: "\\f1b3";
}

.fa-behance:before {
  content: "\\f1b4";
}

.fa-behance-square:before {
  content: "\\f1b5";
}

.fa-steam:before {
  content: "\\f1b6";
}

.fa-steam-square:before {
  content: "\\f1b7";
}

.fa-recycle:before {
  content: "\\f1b8";
}

.fa-automobile:before,
.fa-car:before {
  content: "\\f1b9";
}

.fa-cab:before,
.fa-taxi:before {
  content: "\\f1ba";
}

.fa-tree:before {
  content: "\\f1bb";
}

.fa-spotify:before {
  content: "\\f1bc";
}

.fa-deviantart:before {
  content: "\\f1bd";
}

.fa-soundcloud:before {
  content: "\\f1be";
}

.fa-database:before {
  content: "\\f1c0";
}

.fa-file-pdf-o:before {
  content: "\\f1c1";
}

.fa-file-word-o:before {
  content: "\\f1c2";
}

.fa-file-excel-o:before {
  content: "\\f1c3";
}

.fa-file-powerpoint-o:before {
  content: "\\f1c4";
}

.fa-file-photo-o:before,
.fa-file-picture-o:before,
.fa-file-image-o:before {
  content: "\\f1c5";
}

.fa-file-zip-o:before,
.fa-file-archive-o:before {
  content: "\\f1c6";
}

.fa-file-sound-o:before,
.fa-file-audio-o:before {
  content: "\\f1c7";
}

.fa-file-movie-o:before,
.fa-file-video-o:before {
  content: "\\f1c8";
}

.fa-file-code-o:before {
  content: "\\f1c9";
}

.fa-vine:before {
  content: "\\f1ca";
}

.fa-codepen:before {
  content: "\\f1cb";
}

.fa-jsfiddle:before {
  content: "\\f1cc";
}

.fa-life-bouy:before,
.fa-life-buoy:before,
.fa-life-saver:before,
.fa-support:before,
.fa-life-ring:before {
  content: "\\f1cd";
}

.fa-circle-o-notch:before {
  content: "\\f1ce";
}

.fa-ra:before,
.fa-resistance:before,
.fa-rebel:before {
  content: "\\f1d0";
}

.fa-ge:before,
.fa-empire:before {
  content: "\\f1d1";
}

.fa-git-square:before {
  content: "\\f1d2";
}

.fa-git:before {
  content: "\\f1d3";
}

.fa-y-combinator-square:before,
.fa-yc-square:before,
.fa-hacker-news:before {
  content: "\\f1d4";
}

.fa-tencent-weibo:before {
  content: "\\f1d5";
}

.fa-qq:before {
  content: "\\f1d6";
}

.fa-wechat:before,
.fa-weixin:before {
  content: "\\f1d7";
}

.fa-send:before,
.fa-paper-plane:before {
  content: "\\f1d8";
}

.fa-send-o:before,
.fa-paper-plane-o:before {
  content: "\\f1d9";
}

.fa-history:before {
  content: "\\f1da";
}

.fa-circle-thin:before {
  content: "\\f1db";
}

.fa-header:before {
  content: "\\f1dc";
}

.fa-paragraph:before {
  content: "\\f1dd";
}

.fa-sliders:before {
  content: "\\f1de";
}

.fa-share-alt:before {
  content: "\\f1e0";
}

.fa-share-alt-square:before {
  content: "\\f1e1";
}

.fa-bomb:before {
  content: "\\f1e2";
}

.fa-soccer-ball-o:before,
.fa-futbol-o:before {
  content: "\\f1e3";
}

.fa-tty:before {
  content: "\\f1e4";
}

.fa-binoculars:before {
  content: "\\f1e5";
}

.fa-plug:before {
  content: "\\f1e6";
}

.fa-slideshare:before {
  content: "\\f1e7";
}

.fa-twitch:before {
  content: "\\f1e8";
}

.fa-yelp:before {
  content: "\\f1e9";
}

.fa-newspaper-o:before {
  content: "\\f1ea";
}

.fa-wifi:before {
  content: "\\f1eb";
}

.fa-calculator:before {
  content: "\\f1ec";
}

.fa-paypal:before {
  content: "\\f1ed";
}

.fa-google-wallet:before {
  content: "\\f1ee";
}

.fa-cc-visa:before {
  content: "\\f1f0";
}

.fa-cc-mastercard:before {
  content: "\\f1f1";
}

.fa-cc-discover:before {
  content: "\\f1f2";
}

.fa-cc-amex:before {
  content: "\\f1f3";
}

.fa-cc-paypal:before {
  content: "\\f1f4";
}

.fa-cc-stripe:before {
  content: "\\f1f5";
}

.fa-bell-slash:before {
  content: "\\f1f6";
}

.fa-bell-slash-o:before {
  content: "\\f1f7";
}

.fa-trash:before {
  content: "\\f1f8";
}

.fa-copyright:before {
  content: "\\f1f9";
}

.fa-at:before {
  content: "\\f1fa";
}

.fa-eyedropper:before {
  content: "\\f1fb";
}

.fa-paint-brush:before {
  content: "\\f1fc";
}

.fa-birthday-cake:before {
  content: "\\f1fd";
}

.fa-area-chart:before {
  content: "\\f1fe";
}

.fa-pie-chart:before {
  content: "\\f200";
}

.fa-line-chart:before {
  content: "\\f201";
}

.fa-lastfm:before {
  content: "\\f202";
}

.fa-lastfm-square:before {
  content: "\\f203";
}

.fa-toggle-off:before {
  content: "\\f204";
}

.fa-toggle-on:before {
  content: "\\f205";
}

.fa-bicycle:before {
  content: "\\f206";
}

.fa-bus:before {
  content: "\\f207";
}

.fa-ioxhost:before {
  content: "\\f208";
}

.fa-angellist:before {
  content: "\\f209";
}

.fa-cc:before {
  content: "\\f20a";
}

.fa-shekel:before,
.fa-sheqel:before,
.fa-ils:before {
  content: "\\f20b";
}

.fa-meanpath:before {
  content: "\\f20c";
}

.fa-buysellads:before {
  content: "\\f20d";
}

.fa-connectdevelop:before {
  content: "\\f20e";
}

.fa-dashcube:before {
  content: "\\f210";
}

.fa-forumbee:before {
  content: "\\f211";
}

.fa-leanpub:before {
  content: "\\f212";
}

.fa-sellsy:before {
  content: "\\f213";
}

.fa-shirtsinbulk:before {
  content: "\\f214";
}

.fa-simplybuilt:before {
  content: "\\f215";
}

.fa-skyatlas:before {
  content: "\\f216";
}

.fa-cart-plus:before {
  content: "\\f217";
}

.fa-cart-arrow-down:before {
  content: "\\f218";
}

.fa-diamond:before {
  content: "\\f219";
}

.fa-ship:before {
  content: "\\f21a";
}

.fa-user-secret:before {
  content: "\\f21b";
}

.fa-motorcycle:before {
  content: "\\f21c";
}

.fa-street-view:before {
  content: "\\f21d";
}

.fa-heartbeat:before {
  content: "\\f21e";
}

.fa-venus:before {
  content: "\\f221";
}

.fa-mars:before {
  content: "\\f222";
}

.fa-mercury:before {
  content: "\\f223";
}

.fa-intersex:before,
.fa-transgender:before {
  content: "\\f224";
}

.fa-transgender-alt:before {
  content: "\\f225";
}

.fa-venus-double:before {
  content: "\\f226";
}

.fa-mars-double:before {
  content: "\\f227";
}

.fa-venus-mars:before {
  content: "\\f228";
}

.fa-mars-stroke:before {
  content: "\\f229";
}

.fa-mars-stroke-v:before {
  content: "\\f22a";
}

.fa-mars-stroke-h:before {
  content: "\\f22b";
}

.fa-neuter:before {
  content: "\\f22c";
}

.fa-genderless:before {
  content: "\\f22d";
}

.fa-facebook-official:before {
  content: "\\f230";
}

.fa-pinterest-p:before {
  content: "\\f231";
}

.fa-whatsapp:before {
  content: "\\f232";
}

.fa-server:before {
  content: "\\f233";
}

.fa-user-plus:before {
  content: "\\f234";
}

.fa-user-times:before {
  content: "\\f235";
}

.fa-hotel:before,
.fa-bed:before {
  content: "\\f236";
}

.fa-viacoin:before {
  content: "\\f237";
}

.fa-train:before {
  content: "\\f238";
}

.fa-subway:before {
  content: "\\f239";
}

.fa-medium:before {
  content: "\\f23a";
}

.fa-yc:before,
.fa-y-combinator:before {
  content: "\\f23b";
}

.fa-optin-monster:before {
  content: "\\f23c";
}

.fa-opencart:before {
  content: "\\f23d";
}

.fa-expeditedssl:before {
  content: "\\f23e";
}

.fa-battery-4:before,
.fa-battery:before,
.fa-battery-full:before {
  content: "\\f240";
}

.fa-battery-3:before,
.fa-battery-three-quarters:before {
  content: "\\f241";
}

.fa-battery-2:before,
.fa-battery-half:before {
  content: "\\f242";
}

.fa-battery-1:before,
.fa-battery-quarter:before {
  content: "\\f243";
}

.fa-battery-0:before,
.fa-battery-empty:before {
  content: "\\f244";
}

.fa-mouse-pointer:before {
  content: "\\f245";
}

.fa-i-cursor:before {
  content: "\\f246";
}

.fa-object-group:before {
  content: "\\f247";
}

.fa-object-ungroup:before {
  content: "\\f248";
}

.fa-sticky-note:before {
  content: "\\f249";
}

.fa-sticky-note-o:before {
  content: "\\f24a";
}

.fa-cc-jcb:before {
  content: "\\f24b";
}

.fa-cc-diners-club:before {
  content: "\\f24c";
}

.fa-clone:before {
  content: "\\f24d";
}

.fa-balance-scale:before {
  content: "\\f24e";
}

.fa-hourglass-o:before {
  content: "\\f250";
}

.fa-hourglass-1:before,
.fa-hourglass-start:before {
  content: "\\f251";
}

.fa-hourglass-2:before,
.fa-hourglass-half:before {
  content: "\\f252";
}

.fa-hourglass-3:before,
.fa-hourglass-end:before {
  content: "\\f253";
}

.fa-hourglass:before {
  content: "\\f254";
}

.fa-hand-grab-o:before,
.fa-hand-rock-o:before {
  content: "\\f255";
}

.fa-hand-stop-o:before,
.fa-hand-paper-o:before {
  content: "\\f256";
}

.fa-hand-scissors-o:before {
  content: "\\f257";
}

.fa-hand-lizard-o:before {
  content: "\\f258";
}

.fa-hand-spock-o:before {
  content: "\\f259";
}

.fa-hand-pointer-o:before {
  content: "\\f25a";
}

.fa-hand-peace-o:before {
  content: "\\f25b";
}

.fa-trademark:before {
  content: "\\f25c";
}

.fa-registered:before {
  content: "\\f25d";
}

.fa-creative-commons:before {
  content: "\\f25e";
}

.fa-gg:before {
  content: "\\f260";
}

.fa-gg-circle:before {
  content: "\\f261";
}

.fa-tripadvisor:before {
  content: "\\f262";
}

.fa-odnoklassniki:before {
  content: "\\f263";
}

.fa-odnoklassniki-square:before {
  content: "\\f264";
}

.fa-get-pocket:before {
  content: "\\f265";
}

.fa-wikipedia-w:before {
  content: "\\f266";
}

.fa-safari:before {
  content: "\\f267";
}

.fa-chrome:before {
  content: "\\f268";
}

.fa-firefox:before {
  content: "\\f269";
}

.fa-opera:before {
  content: "\\f26a";
}

.fa-internet-explorer:before {
  content: "\\f26b";
}

.fa-tv:before,
.fa-television:before {
  content: "\\f26c";
}

.fa-contao:before {
  content: "\\f26d";
}

.fa-500px:before {
  content: "\\f26e";
}

.fa-amazon:before {
  content: "\\f270";
}

.fa-calendar-plus-o:before {
  content: "\\f271";
}

.fa-calendar-minus-o:before {
  content: "\\f272";
}

.fa-calendar-times-o:before {
  content: "\\f273";
}

.fa-calendar-check-o:before {
  content: "\\f274";
}

.fa-industry:before {
  content: "\\f275";
}

.fa-map-pin:before {
  content: "\\f276";
}

.fa-map-signs:before {
  content: "\\f277";
}

.fa-map-o:before {
  content: "\\f278";
}

.fa-map:before {
  content: "\\f279";
}

.fa-commenting:before {
  content: "\\f27a";
}

.fa-commenting-o:before {
  content: "\\f27b";
}

.fa-houzz:before {
  content: "\\f27c";
}

.fa-vimeo:before {
  content: "\\f27d";
}

.fa-black-tie:before {
  content: "\\f27e";
}

.fa-fonticons:before {
  content: "\\f280";
}

.fa-reddit-alien:before {
  content: "\\f281";
}

.fa-edge:before {
  content: "\\f282";
}

.fa-credit-card-alt:before {
  content: "\\f283";
}

.fa-codiepie:before {
  content: "\\f284";
}

.fa-modx:before {
  content: "\\f285";
}

.fa-fort-awesome:before {
  content: "\\f286";
}

.fa-usb:before {
  content: "\\f287";
}

.fa-product-hunt:before {
  content: "\\f288";
}

.fa-mixcloud:before {
  content: "\\f289";
}

.fa-scribd:before {
  content: "\\f28a";
}

.fa-pause-circle:before {
  content: "\\f28b";
}

.fa-pause-circle-o:before {
  content: "\\f28c";
}

.fa-stop-circle:before {
  content: "\\f28d";
}

.fa-stop-circle-o:before {
  content: "\\f28e";
}

.fa-shopping-bag:before {
  content: "\\f290";
}

.fa-shopping-basket:before {
  content: "\\f291";
}

.fa-hashtag:before {
  content: "\\f292";
}

.fa-bluetooth:before {
  content: "\\f293";
}

.fa-bluetooth-b:before {
  content: "\\f294";
}

.fa-percent:before {
  content: "\\f295";
}

.fa-gitlab:before {
  content: "\\f296";
}

.fa-wpbeginner:before {
  content: "\\f297";
}

.fa-wpforms:before {
  content: "\\f298";
}

.fa-envira:before {
  content: "\\f299";
}

.fa-universal-access:before {
  content: "\\f29a";
}

.fa-wheelchair-alt:before {
  content: "\\f29b";
}

.fa-question-circle-o:before {
  content: "\\f29c";
}

.fa-blind:before {
  content: "\\f29d";
}

.fa-audio-description:before {
  content: "\\f29e";
}

.fa-volume-control-phone:before {
  content: "\\f2a0";
}

.fa-braille:before {
  content: "\\f2a1";
}

.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}

.fa-asl-interpreting:before,
.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.fa-deafness:before,
.fa-hard-of-hearing:before,
.fa-deaf:before {
  content: "\\f2a4";
}

.fa-glide:before {
  content: "\\f2a5";
}

.fa-glide-g:before {
  content: "\\f2a6";
}

.fa-signing:before,
.fa-sign-language:before {
  content: "\\f2a7";
}

.fa-low-vision:before {
  content: "\\f2a8";
}

.fa-viadeo:before {
  content: "\\f2a9";
}

.fa-viadeo-square:before {
  content: "\\f2aa";
}

.fa-snapchat:before {
  content: "\\f2ab";
}

.fa-snapchat-ghost:before {
  content: "\\f2ac";
}

.fa-snapchat-square:before {
  content: "\\f2ad";
}

.fa-pied-piper:before {
  content: "\\f2ae";
}

.fa-first-order:before {
  content: "\\f2b0";
}

.fa-yoast:before {
  content: "\\f2b1";
}

.fa-themeisle:before {
  content: "\\f2b2";
}

.fa-google-plus-circle:before,
.fa-google-plus-official:before {
  content: "\\f2b3";
}

.fa-fa:before,
.fa-font-awesome:before {
  content: "\\f2b4";
}

.fa-handshake-o:before {
  content: "\\f2b5";
}

.fa-envelope-open:before {
  content: "\\f2b6";
}

.fa-envelope-open-o:before {
  content: "\\f2b7";
}

.fa-linode:before {
  content: "\\f2b8";
}

.fa-address-book:before {
  content: "\\f2b9";
}

.fa-address-book-o:before {
  content: "\\f2ba";
}

.fa-vcard:before,
.fa-address-card:before {
  content: "\\f2bb";
}

.fa-vcard-o:before,
.fa-address-card-o:before {
  content: "\\f2bc";
}

.fa-user-circle:before {
  content: "\\f2bd";
}

.fa-user-circle-o:before {
  content: "\\f2be";
}

.fa-user-o:before {
  content: "\\f2c0";
}

.fa-id-badge:before {
  content: "\\f2c1";
}

.fa-drivers-license:before,
.fa-id-card:before {
  content: "\\f2c2";
}

.fa-drivers-license-o:before,
.fa-id-card-o:before {
  content: "\\f2c3";
}

.fa-quora:before {
  content: "\\f2c4";
}

.fa-free-code-camp:before {
  content: "\\f2c5";
}

.fa-telegram:before {
  content: "\\f2c6";
}

.fa-thermometer-4:before,
.fa-thermometer:before,
.fa-thermometer-full:before {
  content: "\\f2c7";
}

.fa-thermometer-3:before,
.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.fa-thermometer-2:before,
.fa-thermometer-half:before {
  content: "\\f2c9";
}

.fa-thermometer-1:before,
.fa-thermometer-quarter:before {
  content: "\\f2ca";
}

.fa-thermometer-0:before,
.fa-thermometer-empty:before {
  content: "\\f2cb";
}

.fa-shower:before {
  content: "\\f2cc";
}

.fa-bathtub:before,
.fa-s15:before,
.fa-bath:before {
  content: "\\f2cd";
}

.fa-podcast:before {
  content: "\\f2ce";
}

.fa-window-maximize:before {
  content: "\\f2d0";
}

.fa-window-minimize:before {
  content: "\\f2d1";
}

.fa-window-restore:before {
  content: "\\f2d2";
}

.fa-times-rectangle:before,
.fa-window-close:before {
  content: "\\f2d3";
}

.fa-times-rectangle-o:before,
.fa-window-close-o:before {
  content: "\\f2d4";
}

.fa-bandcamp:before {
  content: "\\f2d5";
}

.fa-grav:before {
  content: "\\f2d6";
}

.fa-etsy:before {
  content: "\\f2d7";
}

.fa-imdb:before {
  content: "\\f2d8";
}

.fa-ravelry:before {
  content: "\\f2d9";
}

.fa-eercast:before {
  content: "\\f2da";
}

.fa-microchip:before {
  content: "\\f2db";
}

.fa-snowflake-o:before {
  content: "\\f2dc";
}

.fa-superpowers:before {
  content: "\\f2dd";
}

.fa-wpexplorer:before {
  content: "\\f2de";
}

.fa-meetup:before {
  content: "\\f2e0";
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

.date-row {
  display: flex;
  justify-content: space-between;
  background-color: #f8f9fa;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 8px;
  align-items: center;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./node_modules/bootstrap-scss/mixins/_banner.scss","webpack://./node_modules/bootstrap-scss/_root.scss","webpack://./node_modules/bootstrap-scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap-scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap-scss/_reboot.scss","webpack://./node_modules/bootstrap-scss/_variables.scss","webpack://./node_modules/bootstrap-scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap-scss/_type.scss","webpack://./node_modules/bootstrap-scss/mixins/_lists.scss","webpack://./node_modules/bootstrap-scss/_images.scss","webpack://./node_modules/bootstrap-scss/mixins/_image.scss","webpack://./node_modules/bootstrap-scss/_containers.scss","webpack://./node_modules/bootstrap-scss/mixins/_container.scss","webpack://./node_modules/bootstrap-scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap-scss/_grid.scss","webpack://./node_modules/bootstrap-scss/mixins/_grid.scss","webpack://./node_modules/bootstrap-scss/_tables.scss","webpack://./node_modules/bootstrap-scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap-scss/forms/_labels.scss","webpack://./node_modules/bootstrap-scss/forms/_form-text.scss","webpack://./node_modules/bootstrap-scss/forms/_form-control.scss","webpack://./node_modules/bootstrap-scss/mixins/_transition.scss","webpack://./node_modules/bootstrap-scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap-scss/forms/_form-select.scss","webpack://./node_modules/bootstrap-scss/forms/_form-check.scss","webpack://./node_modules/bootstrap-scss/forms/_form-range.scss","webpack://./node_modules/bootstrap-scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap-scss/forms/_input-group.scss","webpack://./node_modules/bootstrap-scss/mixins/_forms.scss","webpack://./node_modules/bootstrap-scss/_buttons.scss","webpack://./node_modules/bootstrap-scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap-scss/_transitions.scss","webpack://./node_modules/bootstrap-scss/_dropdown.scss","webpack://./node_modules/bootstrap-scss/mixins/_caret.scss","webpack://./node_modules/bootstrap-scss/_button-group.scss","webpack://./node_modules/bootstrap-scss/_nav.scss","webpack://./node_modules/bootstrap-scss/_navbar.scss","webpack://./node_modules/bootstrap-scss/_card.scss","webpack://./node_modules/bootstrap-scss/_accordion.scss","webpack://./node_modules/bootstrap-scss/_breadcrumb.scss","webpack://./node_modules/bootstrap-scss/_pagination.scss","webpack://./node_modules/bootstrap-scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap-scss/_badge.scss","webpack://./node_modules/bootstrap-scss/_alert.scss","webpack://./node_modules/bootstrap-scss/_progress.scss","webpack://./node_modules/bootstrap-scss/_list-group.scss","webpack://./node_modules/bootstrap-scss/_close.scss","webpack://./node_modules/bootstrap-scss/_toasts.scss","webpack://./node_modules/bootstrap-scss/_modal.scss","webpack://./node_modules/bootstrap-scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap-scss/_tooltip.scss","webpack://./node_modules/bootstrap-scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap-scss/_popover.scss","webpack://./node_modules/bootstrap-scss/_carousel.scss","webpack://./node_modules/bootstrap-scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap-scss/_spinners.scss","webpack://./node_modules/bootstrap-scss/_offcanvas.scss","webpack://./node_modules/bootstrap-scss/_placeholders.scss","webpack://./node_modules/bootstrap-scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap-scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap-scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap-scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap-scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap-scss/helpers/_position.scss","webpack://./node_modules/bootstrap-scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap-scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap-scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap-scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap-scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap-scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap-scss/helpers/_vr.scss","webpack://./node_modules/bootstrap-scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap-scss/utilities/_api.scss","webpack://./src/assets/scss/theme/_admin_style.scss","webpack://./src/assets/scss/theme/_variables.scss","webpack://./src/assets/scss/theme/_rtl.scss","webpack://./src/assets/scss/flag-icon/_flag-icon-base.scss","webpack://./src/assets/scss/themify/_path.scss","webpack://./src/assets/scss/themify/_core.scss","webpack://./src/assets/scss/themify/_mixins.scss","webpack://./src/assets/scss/themify/_variables.scss","webpack://./src/assets/scss/themify/_extras.scss","webpack://./src/assets/scss/themify/_icons.scss","webpack://./src/assets/scss/icoicon/_icons.scss","webpack://./src/assets/scss/font-awesome.scss","webpack://./src/assets/scss/font-awesome/_path.scss","webpack://./src/assets/scss/font-awesome/_core.scss","webpack://./src/assets/scss/font-awesome/_larger.scss","webpack://./src/assets/scss/font-awesome/_fixed-width.scss","webpack://./src/assets/scss/font-awesome/_list.scss","webpack://./src/assets/scss/font-awesome/_variables.scss","webpack://./src/assets/scss/font-awesome/_bordered-pulled.scss","webpack://./src/assets/scss/font-awesome/_animated.scss","webpack://./src/assets/scss/font-awesome/_rotated-flipped.scss","webpack://./src/assets/scss/font-awesome/_mixins.scss","webpack://./src/assets/scss/font-awesome/_stacked.scss","webpack://./src/assets/scss/font-awesome/_icons.scss","webpack://./src/assets/scss/font-awesome/_screen-reader.scss","webpack://./src/assets/scss/app.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFFF;;AI9GI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFFJ;;AKtKA;;;EAGE,sBAAA;ALyKF;;AK1JI;EANJ;IAOM,uBAAA;EL8JJ;AACF;;AKjJA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALoJF;;AK3IA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AN3e9B;;AKpIA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ALqIF;;AKlIA;EFuMQ,iCAAA;AHjER;AG3FI;EE3CJ;IF8MQ,iBAAA;EHpEN;AACF;;AKtIA;EFkMQ,iCAAA;AHxDR;AGpGI;EEtCJ;IFyMQ,eAAA;EH3DN;AACF;;AK1IA;EF6LQ,+BAAA;AH/CR;AG7GI;EEjCJ;IFoMQ,kBAAA;EHlDN;AACF;;AK9IA;EFwLQ,iCAAA;AHtCR;AGtHI;EE5BJ;IF+LQ,iBAAA;EHzCN;AACF;;AKlJA;EF+KM,kBALI;AHpBV;;AKjJA;EF0KM,eALI;AHhBV;;AK1IA;EACE,aAAA;EACA,mBCwV0B;AN3M5B;;AKnIA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ALsIF;;AKhIA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALmIF;;AK7HA;;EAEE,kBAAA;ALgIF;;AK7HA;;;EAGE,aAAA;EACA,mBAAA;ALgIF;;AK7HA;;;;EAIE,gBAAA;ALgIF;;AK7HA;EACE,gBC6b4B;AN7T9B;;AK3HA;EACE,qBAAA;EACA,cAAA;AL8HF;;AKxHA;EACE,gBAAA;AL2HF;;AKnHA;;EAEE,mBCsa4B;ANhT9B;;AK9GA;EF6EM,kBALI;AH0CV;;AK3GA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AL8GF;;AKrGA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALwGF;;AKrGA;EAAM,eAAA;ALyGN;;AKxGA;EAAM,WAAA;AL4GN;;AKvGA;EACE,gEAAA;EACA,0BCgNwC;ANtG1C;AKxGE;EACE,mDAAA;AL0GJ;;AK/FE;EAEE,cAAA;EACA,qBAAA;ALiGJ;;AK1FA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AHqFV;;AKtFA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AH6FV;AKrFE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ALuFJ;;AKnFA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ALsFF;AKnFE;EACE,cAAA;ALqFJ;;AKjFA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBCu5CkC;EDt5ClC,sCCu5CkC;EC5rDhC,sBAAA;AP0XJ;AKlFE;EACE,UAAA;EF7BE,cALI;AHuHV;;AK1EA;EACE,gBAAA;AL6EF;;AKvEA;;EAEE,sBAAA;AL0EF;;AKlEA;EACE,oBAAA;EACA,yBAAA;ALqEF;;AKlEA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ALqEF;;AK9DA;EAEE,mBAAA;EACA,gCAAA;ALgEF;;AK7DA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ALgEF;;AKxDA;EACE,qBAAA;AL2DF;;AKrDA;EAEE,gBAAA;ALuDF;;AK/CA;EACE,UAAA;ALkDF;;AK7CA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ALgDF;;AK5CA;;EAEE,oBAAA;AL+CF;;AK1CA;EACE,eAAA;AL6CF;;AK1CA;EAGE,iBAAA;AL2CF;AKxCE;EACE,UAAA;AL0CJ;;AKnCA;EACE,wBAAA;ALsCF;;AK9BA;;;;EAIE,0BAAA;ALiCF;AK9BI;;;;EACE,eAAA;ALmCN;;AK5BA;EACE,UAAA;EACA,kBAAA;AL+BF;;AK1BA;EACE,gBAAA;AL6BF;;AKnBA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALsBF;;AKdA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;ALgBF;AGhYI;EEyWJ;IFtMQ,iBAAA;EHiON;AACF;AKnBE;EACE,WAAA;ALqBJ;;AKdA;;;;;;;EAOE,UAAA;ALiBF;;AKdA;EACE,YAAA;ALiBF;;AKRA;EACE,6BAAA;EACA,oBAAA;ALWF;;AKHA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALGF;;AKEA;EACE,UAAA;ALCF;;AKMA;EACE,aAAA;EACA,0BAAA;ALHF;;AKQA;EACE,qBAAA;ALLF;;AKUA;EACE,SAAA;ALPF;;AKcA;EACE,kBAAA;EACA,eAAA;ALXF;;AKmBA;EACE,wBAAA;ALhBF;;AKwBA;EACE,wBAAA;ALrBF;;AQhjBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANrF9B;;AQ9iBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANzD9B;AGhdI;EKpGF;ILuQM,eAAA;EHiTN;AACF;;AQzjBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AN9C9B;AG3dI;EKpGF;ILuQM,iBAAA;EH4TN;AACF;;AQpkBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANnC9B;AGteI;EKpGF;ILuQM,eAAA;EHuUN;AACF;;AQ/kBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANxB9B;AGjfI;EKpGF;ILuQM,iBAAA;EHkVN;AACF;;AQ1lBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANb9B;AG5fI;EKpGF;ILuQM,eAAA;EH6VN;AACF;;AQrmBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANF9B;AGvgBI;EKpGF;ILuQM,iBAAA;EHwWN;AACF;;AQxlBA;ECvDE,eAAA;EACA,gBAAA;ATmpBF;;AQxlBA;EC5DE,eAAA;EACA,gBAAA;ATwpBF;;AQ1lBA;EACE,qBAAA;AR6lBF;AQ3lBE;EACE,oBFsoB0B;ANzC9B;;AQnlBA;EL8MM,kBALI;EKvMR,yBAAA;ARslBF;;AQllBA;EACE,mBFiUO;EH1HH,kBALI;AHoZV;AQnlBE;EACE,gBAAA;ARqlBJ;;AQjlBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AN0qBX;AQllBE;EACE,aAAA;ARolBJ;;AUprBA;ECIE,eAAA;EAGA,YAAA;AXkrBF;;AUnrBA;EACE,gBJ6jDkC;EI5jDlC,mCJ6jDkC;EI5jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AX2rBF;;AU7qBA;EAEE,qBAAA;AV+qBF;;AU5qBA;EACE,qBAAA;EACA,cAAA;AV+qBF;;AU5qBA;EPyPM,kBALI;EOlPR,gCJgjDkC;ANj4BpC;;AYjtBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Ab8tBF;;AcxqBI;EF5CE;IACE,gBNkee;ENsPrB;AACF;Ac9qBI;EF5CE;IACE,gBNkee;EN2PrB;AACF;AcnrBI;EF5CE;IACE,gBNkee;ENgQrB;AACF;AcxrBI;EF5CE;IACE,iBNkee;ENqQrB;AACF;Ac7rBI;EF5CE;IACE,iBNkee;EN0QrB;AACF;Ae7vBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfmwBJ;;Ae9vBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhBuwBF;AerwBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhBiwBF;;AgBltBM;EACE,SAAA;AhBqtBR;;AgBltBM;EApCJ,cAAA;EACA,WAAA;AhB0vBF;;AgB5uBE;EACE,cAAA;EACA,WAAA;AhB+uBJ;;AgBjvBE;EACE,cAAA;EACA,UAAA;AhBovBJ;;AgBtvBE;EACE,cAAA;EACA,mBAAA;AhByvBJ;;AgB3vBE;EACE,cAAA;EACA,UAAA;AhB8vBJ;;AgBhwBE;EACE,cAAA;EACA,UAAA;AhBmwBJ;;AgBrwBE;EACE,cAAA;EACA,mBAAA;AhBwwBJ;;AgBzuBM;EAhDJ,cAAA;EACA,WAAA;AhB6xBF;;AgBxuBU;EAhEN,cAAA;EACA,kBAAA;AhB4yBJ;;AgB7uBU;EAhEN,cAAA;EACA,mBAAA;AhBizBJ;;AgBlvBU;EAhEN,cAAA;EACA,UAAA;AhBszBJ;;AgBvvBU;EAhEN,cAAA;EACA,mBAAA;AhB2zBJ;;AgB5vBU;EAhEN,cAAA;EACA,mBAAA;AhBg0BJ;;AgBjwBU;EAhEN,cAAA;EACA,UAAA;AhBq0BJ;;AgBtwBU;EAhEN,cAAA;EACA,mBAAA;AhB00BJ;;AgB3wBU;EAhEN,cAAA;EACA,mBAAA;AhB+0BJ;;AgBhxBU;EAhEN,cAAA;EACA,UAAA;AhBo1BJ;;AgBrxBU;EAhEN,cAAA;EACA,mBAAA;AhBy1BJ;;AgB1xBU;EAhEN,cAAA;EACA,mBAAA;AhB81BJ;;AgB/xBU;EAhEN,cAAA;EACA,WAAA;AhBm2BJ;;AgB5xBY;EAxDV,wBAAA;AhBw1BF;;AgBhyBY;EAxDV,yBAAA;AhB41BF;;AgBpyBY;EAxDV,gBAAA;AhBg2BF;;AgBxyBY;EAxDV,yBAAA;AhBo2BF;;AgB5yBY;EAxDV,yBAAA;AhBw2BF;;AgBhzBY;EAxDV,gBAAA;AhB42BF;;AgBpzBY;EAxDV,yBAAA;AhBg3BF;;AgBxzBY;EAxDV,yBAAA;AhBo3BF;;AgB5zBY;EAxDV,gBAAA;AhBw3BF;;AgBh0BY;EAxDV,yBAAA;AhB43BF;;AgBp0BY;EAxDV,yBAAA;AhBg4BF;;AgB7zBQ;;EAEE,gBAAA;AhBg0BV;;AgB7zBQ;;EAEE,gBAAA;AhBg0BV;;AgBv0BQ;;EAEE,sBAAA;AhB00BV;;AgBv0BQ;;EAEE,sBAAA;AhB00BV;;AgBj1BQ;;EAEE,qBAAA;AhBo1BV;;AgBj1BQ;;EAEE,qBAAA;AhBo1BV;;AgB31BQ;;EAEE,mBAAA;AhB81BV;;AgB31BQ;;EAEE,mBAAA;AhB81BV;;AgBr2BQ;;EAEE,qBAAA;AhBw2BV;;AgBr2BQ;;EAEE,qBAAA;AhBw2BV;;AgB/2BQ;;EAEE,mBAAA;AhBk3BV;;AgB/2BQ;;EAEE,mBAAA;AhBk3BV;;Ac56BI;EEUE;IACE,SAAA;EhBs6BN;EgBn6BI;IApCJ,cAAA;IACA,WAAA;EhB08BA;EgB57BA;IACE,cAAA;IACA,WAAA;EhB87BF;EgBh8BA;IACE,cAAA;IACA,UAAA;EhBk8BF;EgBp8BA;IACE,cAAA;IACA,mBAAA;EhBs8BF;EgBx8BA;IACE,cAAA;IACA,UAAA;EhB08BF;EgB58BA;IACE,cAAA;IACA,UAAA;EhB88BF;EgBh9BA;IACE,cAAA;IACA,mBAAA;EhBk9BF;EgBn7BI;IAhDJ,cAAA;IACA,WAAA;EhBs+BA;EgBj7BQ;IAhEN,cAAA;IACA,kBAAA;EhBo/BF;EgBr7BQ;IAhEN,cAAA;IACA,mBAAA;EhBw/BF;EgBz7BQ;IAhEN,cAAA;IACA,UAAA;EhB4/BF;EgB77BQ;IAhEN,cAAA;IACA,mBAAA;EhBggCF;EgBj8BQ;IAhEN,cAAA;IACA,mBAAA;EhBogCF;EgBr8BQ;IAhEN,cAAA;IACA,UAAA;EhBwgCF;EgBz8BQ;IAhEN,cAAA;IACA,mBAAA;EhB4gCF;EgB78BQ;IAhEN,cAAA;IACA,mBAAA;EhBghCF;EgBj9BQ;IAhEN,cAAA;IACA,UAAA;EhBohCF;EgBr9BQ;IAhEN,cAAA;IACA,mBAAA;EhBwhCF;EgBz9BQ;IAhEN,cAAA;IACA,mBAAA;EhB4hCF;EgB79BQ;IAhEN,cAAA;IACA,WAAA;EhBgiCF;EgBz9BU;IAxDV,cAAA;EhBohCA;EgB59BU;IAxDV,wBAAA;EhBuhCA;EgB/9BU;IAxDV,yBAAA;EhB0hCA;EgBl+BU;IAxDV,gBAAA;EhB6hCA;EgBr+BU;IAxDV,yBAAA;EhBgiCA;EgBx+BU;IAxDV,yBAAA;EhBmiCA;EgB3+BU;IAxDV,gBAAA;EhBsiCA;EgB9+BU;IAxDV,yBAAA;EhByiCA;EgBj/BU;IAxDV,yBAAA;EhB4iCA;EgBp/BU;IAxDV,gBAAA;EhB+iCA;EgBv/BU;IAxDV,yBAAA;EhBkjCA;EgB1/BU;IAxDV,yBAAA;EhBqjCA;EgBl/BM;;IAEE,gBAAA;EhBo/BR;EgBj/BM;;IAEE,gBAAA;EhBm/BR;EgB1/BM;;IAEE,sBAAA;EhB4/BR;EgBz/BM;;IAEE,sBAAA;EhB2/BR;EgBlgCM;;IAEE,qBAAA;EhBogCR;EgBjgCM;;IAEE,qBAAA;EhBmgCR;EgB1gCM;;IAEE,mBAAA;EhB4gCR;EgBzgCM;;IAEE,mBAAA;EhB2gCR;EgBlhCM;;IAEE,qBAAA;EhBohCR;EgBjhCM;;IAEE,qBAAA;EhBmhCR;EgB1hCM;;IAEE,mBAAA;EhB4hCR;EgBzhCM;;IAEE,mBAAA;EhB2hCR;AACF;ActlCI;EEUE;IACE,SAAA;EhB+kCN;EgB5kCI;IApCJ,cAAA;IACA,WAAA;EhBmnCA;EgBrmCA;IACE,cAAA;IACA,WAAA;EhBumCF;EgBzmCA;IACE,cAAA;IACA,UAAA;EhB2mCF;EgB7mCA;IACE,cAAA;IACA,mBAAA;EhB+mCF;EgBjnCA;IACE,cAAA;IACA,UAAA;EhBmnCF;EgBrnCA;IACE,cAAA;IACA,UAAA;EhBunCF;EgBznCA;IACE,cAAA;IACA,mBAAA;EhB2nCF;EgB5lCI;IAhDJ,cAAA;IACA,WAAA;EhB+oCA;EgB1lCQ;IAhEN,cAAA;IACA,kBAAA;EhB6pCF;EgB9lCQ;IAhEN,cAAA;IACA,mBAAA;EhBiqCF;EgBlmCQ;IAhEN,cAAA;IACA,UAAA;EhBqqCF;EgBtmCQ;IAhEN,cAAA;IACA,mBAAA;EhByqCF;EgB1mCQ;IAhEN,cAAA;IACA,mBAAA;EhB6qCF;EgB9mCQ;IAhEN,cAAA;IACA,UAAA;EhBirCF;EgBlnCQ;IAhEN,cAAA;IACA,mBAAA;EhBqrCF;EgBtnCQ;IAhEN,cAAA;IACA,mBAAA;EhByrCF;EgB1nCQ;IAhEN,cAAA;IACA,UAAA;EhB6rCF;EgB9nCQ;IAhEN,cAAA;IACA,mBAAA;EhBisCF;EgBloCQ;IAhEN,cAAA;IACA,mBAAA;EhBqsCF;EgBtoCQ;IAhEN,cAAA;IACA,WAAA;EhBysCF;EgBloCU;IAxDV,cAAA;EhB6rCA;EgBroCU;IAxDV,wBAAA;EhBgsCA;EgBxoCU;IAxDV,yBAAA;EhBmsCA;EgB3oCU;IAxDV,gBAAA;EhBssCA;EgB9oCU;IAxDV,yBAAA;EhBysCA;EgBjpCU;IAxDV,yBAAA;EhB4sCA;EgBppCU;IAxDV,gBAAA;EhB+sCA;EgBvpCU;IAxDV,yBAAA;EhBktCA;EgB1pCU;IAxDV,yBAAA;EhBqtCA;EgB7pCU;IAxDV,gBAAA;EhBwtCA;EgBhqCU;IAxDV,yBAAA;EhB2tCA;EgBnqCU;IAxDV,yBAAA;EhB8tCA;EgB3pCM;;IAEE,gBAAA;EhB6pCR;EgB1pCM;;IAEE,gBAAA;EhB4pCR;EgBnqCM;;IAEE,sBAAA;EhBqqCR;EgBlqCM;;IAEE,sBAAA;EhBoqCR;EgB3qCM;;IAEE,qBAAA;EhB6qCR;EgB1qCM;;IAEE,qBAAA;EhB4qCR;EgBnrCM;;IAEE,mBAAA;EhBqrCR;EgBlrCM;;IAEE,mBAAA;EhBorCR;EgB3rCM;;IAEE,qBAAA;EhB6rCR;EgB1rCM;;IAEE,qBAAA;EhB4rCR;EgBnsCM;;IAEE,mBAAA;EhBqsCR;EgBlsCM;;IAEE,mBAAA;EhBosCR;AACF;Ac/vCI;EEUE;IACE,SAAA;EhBwvCN;EgBrvCI;IApCJ,cAAA;IACA,WAAA;EhB4xCA;EgB9wCA;IACE,cAAA;IACA,WAAA;EhBgxCF;EgBlxCA;IACE,cAAA;IACA,UAAA;EhBoxCF;EgBtxCA;IACE,cAAA;IACA,mBAAA;EhBwxCF;EgB1xCA;IACE,cAAA;IACA,UAAA;EhB4xCF;EgB9xCA;IACE,cAAA;IACA,UAAA;EhBgyCF;EgBlyCA;IACE,cAAA;IACA,mBAAA;EhBoyCF;EgBrwCI;IAhDJ,cAAA;IACA,WAAA;EhBwzCA;EgBnwCQ;IAhEN,cAAA;IACA,kBAAA;EhBs0CF;EgBvwCQ;IAhEN,cAAA;IACA,mBAAA;EhB00CF;EgB3wCQ;IAhEN,cAAA;IACA,UAAA;EhB80CF;EgB/wCQ;IAhEN,cAAA;IACA,mBAAA;EhBk1CF;EgBnxCQ;IAhEN,cAAA;IACA,mBAAA;EhBs1CF;EgBvxCQ;IAhEN,cAAA;IACA,UAAA;EhB01CF;EgB3xCQ;IAhEN,cAAA;IACA,mBAAA;EhB81CF;EgB/xCQ;IAhEN,cAAA;IACA,mBAAA;EhBk2CF;EgBnyCQ;IAhEN,cAAA;IACA,UAAA;EhBs2CF;EgBvyCQ;IAhEN,cAAA;IACA,mBAAA;EhB02CF;EgB3yCQ;IAhEN,cAAA;IACA,mBAAA;EhB82CF;EgB/yCQ;IAhEN,cAAA;IACA,WAAA;EhBk3CF;EgB3yCU;IAxDV,cAAA;EhBs2CA;EgB9yCU;IAxDV,wBAAA;EhBy2CA;EgBjzCU;IAxDV,yBAAA;EhB42CA;EgBpzCU;IAxDV,gBAAA;EhB+2CA;EgBvzCU;IAxDV,yBAAA;EhBk3CA;EgB1zCU;IAxDV,yBAAA;EhBq3CA;EgB7zCU;IAxDV,gBAAA;EhBw3CA;EgBh0CU;IAxDV,yBAAA;EhB23CA;EgBn0CU;IAxDV,yBAAA;EhB83CA;EgBt0CU;IAxDV,gBAAA;EhBi4CA;EgBz0CU;IAxDV,yBAAA;EhBo4CA;EgB50CU;IAxDV,yBAAA;EhBu4CA;EgBp0CM;;IAEE,gBAAA;EhBs0CR;EgBn0CM;;IAEE,gBAAA;EhBq0CR;EgB50CM;;IAEE,sBAAA;EhB80CR;EgB30CM;;IAEE,sBAAA;EhB60CR;EgBp1CM;;IAEE,qBAAA;EhBs1CR;EgBn1CM;;IAEE,qBAAA;EhBq1CR;EgB51CM;;IAEE,mBAAA;EhB81CR;EgB31CM;;IAEE,mBAAA;EhB61CR;EgBp2CM;;IAEE,qBAAA;EhBs2CR;EgBn2CM;;IAEE,qBAAA;EhBq2CR;EgB52CM;;IAEE,mBAAA;EhB82CR;EgB32CM;;IAEE,mBAAA;EhB62CR;AACF;Acx6CI;EEUE;IACE,SAAA;EhBi6CN;EgB95CI;IApCJ,cAAA;IACA,WAAA;EhBq8CA;EgBv7CA;IACE,cAAA;IACA,WAAA;EhBy7CF;EgB37CA;IACE,cAAA;IACA,UAAA;EhB67CF;EgB/7CA;IACE,cAAA;IACA,mBAAA;EhBi8CF;EgBn8CA;IACE,cAAA;IACA,UAAA;EhBq8CF;EgBv8CA;IACE,cAAA;IACA,UAAA;EhBy8CF;EgB38CA;IACE,cAAA;IACA,mBAAA;EhB68CF;EgB96CI;IAhDJ,cAAA;IACA,WAAA;EhBi+CA;EgB56CQ;IAhEN,cAAA;IACA,kBAAA;EhB++CF;EgBh7CQ;IAhEN,cAAA;IACA,mBAAA;EhBm/CF;EgBp7CQ;IAhEN,cAAA;IACA,UAAA;EhBu/CF;EgBx7CQ;IAhEN,cAAA;IACA,mBAAA;EhB2/CF;EgB57CQ;IAhEN,cAAA;IACA,mBAAA;EhB+/CF;EgBh8CQ;IAhEN,cAAA;IACA,UAAA;EhBmgDF;EgBp8CQ;IAhEN,cAAA;IACA,mBAAA;EhBugDF;EgBx8CQ;IAhEN,cAAA;IACA,mBAAA;EhB2gDF;EgB58CQ;IAhEN,cAAA;IACA,UAAA;EhB+gDF;EgBh9CQ;IAhEN,cAAA;IACA,mBAAA;EhBmhDF;EgBp9CQ;IAhEN,cAAA;IACA,mBAAA;EhBuhDF;EgBx9CQ;IAhEN,cAAA;IACA,WAAA;EhB2hDF;EgBp9CU;IAxDV,cAAA;EhB+gDA;EgBv9CU;IAxDV,wBAAA;EhBkhDA;EgB19CU;IAxDV,yBAAA;EhBqhDA;EgB79CU;IAxDV,gBAAA;EhBwhDA;EgBh+CU;IAxDV,yBAAA;EhB2hDA;EgBn+CU;IAxDV,yBAAA;EhB8hDA;EgBt+CU;IAxDV,gBAAA;EhBiiDA;EgBz+CU;IAxDV,yBAAA;EhBoiDA;EgB5+CU;IAxDV,yBAAA;EhBuiDA;EgB/+CU;IAxDV,gBAAA;EhB0iDA;EgBl/CU;IAxDV,yBAAA;EhB6iDA;EgBr/CU;IAxDV,yBAAA;EhBgjDA;EgB7+CM;;IAEE,gBAAA;EhB++CR;EgB5+CM;;IAEE,gBAAA;EhB8+CR;EgBr/CM;;IAEE,sBAAA;EhBu/CR;EgBp/CM;;IAEE,sBAAA;EhBs/CR;EgB7/CM;;IAEE,qBAAA;EhB+/CR;EgB5/CM;;IAEE,qBAAA;EhB8/CR;EgBrgDM;;IAEE,mBAAA;EhBugDR;EgBpgDM;;IAEE,mBAAA;EhBsgDR;EgB7gDM;;IAEE,qBAAA;EhB+gDR;EgB5gDM;;IAEE,qBAAA;EhB8gDR;EgBrhDM;;IAEE,mBAAA;EhBuhDR;EgBphDM;;IAEE,mBAAA;EhBshDR;AACF;AcjlDI;EEUE;IACE,SAAA;EhB0kDN;EgBvkDI;IApCJ,cAAA;IACA,WAAA;EhB8mDA;EgBhmDA;IACE,cAAA;IACA,WAAA;EhBkmDF;EgBpmDA;IACE,cAAA;IACA,UAAA;EhBsmDF;EgBxmDA;IACE,cAAA;IACA,mBAAA;EhB0mDF;EgB5mDA;IACE,cAAA;IACA,UAAA;EhB8mDF;EgBhnDA;IACE,cAAA;IACA,UAAA;EhBknDF;EgBpnDA;IACE,cAAA;IACA,mBAAA;EhBsnDF;EgBvlDI;IAhDJ,cAAA;IACA,WAAA;EhB0oDA;EgBrlDQ;IAhEN,cAAA;IACA,kBAAA;EhBwpDF;EgBzlDQ;IAhEN,cAAA;IACA,mBAAA;EhB4pDF;EgB7lDQ;IAhEN,cAAA;IACA,UAAA;EhBgqDF;EgBjmDQ;IAhEN,cAAA;IACA,mBAAA;EhBoqDF;EgBrmDQ;IAhEN,cAAA;IACA,mBAAA;EhBwqDF;EgBzmDQ;IAhEN,cAAA;IACA,UAAA;EhB4qDF;EgB7mDQ;IAhEN,cAAA;IACA,mBAAA;EhBgrDF;EgBjnDQ;IAhEN,cAAA;IACA,mBAAA;EhBorDF;EgBrnDQ;IAhEN,cAAA;IACA,UAAA;EhBwrDF;EgBznDQ;IAhEN,cAAA;IACA,mBAAA;EhB4rDF;EgB7nDQ;IAhEN,cAAA;IACA,mBAAA;EhBgsDF;EgBjoDQ;IAhEN,cAAA;IACA,WAAA;EhBosDF;EgB7nDU;IAxDV,cAAA;EhBwrDA;EgBhoDU;IAxDV,wBAAA;EhB2rDA;EgBnoDU;IAxDV,yBAAA;EhB8rDA;EgBtoDU;IAxDV,gBAAA;EhBisDA;EgBzoDU;IAxDV,yBAAA;EhBosDA;EgB5oDU;IAxDV,yBAAA;EhBusDA;EgB/oDU;IAxDV,gBAAA;EhB0sDA;EgBlpDU;IAxDV,yBAAA;EhB6sDA;EgBrpDU;IAxDV,yBAAA;EhBgtDA;EgBxpDU;IAxDV,gBAAA;EhBmtDA;EgB3pDU;IAxDV,yBAAA;EhBstDA;EgB9pDU;IAxDV,yBAAA;EhBytDA;EgBtpDM;;IAEE,gBAAA;EhBwpDR;EgBrpDM;;IAEE,gBAAA;EhBupDR;EgB9pDM;;IAEE,sBAAA;EhBgqDR;EgB7pDM;;IAEE,sBAAA;EhB+pDR;EgBtqDM;;IAEE,qBAAA;EhBwqDR;EgBrqDM;;IAEE,qBAAA;EhBuqDR;EgB9qDM;;IAEE,mBAAA;EhBgrDR;EgB7qDM;;IAEE,mBAAA;EhB+qDR;EgBtrDM;;IAEE,qBAAA;EhBwrDR;EgBrrDM;;IAEE,qBAAA;EhBurDR;EgB9rDM;;IAEE,mBAAA;EhBgsDR;EgB7rDM;;IAEE,mBAAA;EhB+rDR;AACF;AiBrzDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjBozDF;AiB7yDE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AjB8yDJ;AiB3yDE;EACE,uBAAA;AjB6yDJ;AiB1yDE;EACE,sBAAA;AjB4yDJ;;AiBxyDA;EACE,+DAAA;AjB2yDF;;AiBpyDA;EACE,iBAAA;AjBuyDF;;AiB7xDE;EACE,wBAAA;AjBgyDJ;;AiBjxDE;EACE,sCAAA;AjBoxDJ;AiBjxDI;EACE,sCAAA;AjBmxDN;;AiB5wDE;EACE,sBAAA;AjB+wDJ;AiB5wDE;EACE,mBAAA;AjB8wDJ;;AiBpwDE;EACE,oDAAA;EACA,8CAAA;AjBuwDJ;;AiBjwDE;EACE,oDAAA;EACA,8CAAA;AjBowDJ;;AiB5vDA;EACE,oDAAA;EACA,8CAAA;AjB+vDF;;AiBvvDE;EACE,mDAAA;EACA,6CAAA;AjB0vDJ;;AkBt4DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBk4DJ;;AkBp5DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBg5DJ;;AkBl6DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB85DJ;;AkBh7DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB46DJ;;AkB97DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB07DJ;;AkB58DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBw8DJ;;AkB19DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBs9DJ;;AkBx+DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBo+DJ;;AiBn1DI;EACE,gBAAA;EACA,iCAAA;AjBs1DN;;Acj7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB41DJ;AACF;Acx7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBk2DJ;AACF;Ac97DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBw2DJ;AACF;Acp8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB82DJ;AACF;Ac18DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBo3DJ;AACF;AmBxhEA;EACE,qBbu2BsC;ANmrCxC;;AmBjhEA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;ANm7C9B;;AmB9gEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AHmxDV;;AmB9gEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AHyxDV;;AoB/iEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;ANitCxC;;AqBrjEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;ArBmjEF;AsBrjEM;EDhBN;ICiBQ,gBAAA;EtBwjEN;AACF;AqBtjEE;EACE,gBAAA;ArBwjEJ;AqBtjEI;EACE,eAAA;ArBwjEN;AqBnjEE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,qBf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;AN+hDxB;AqB7iEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBiiEJ;AqB5hEE;EACE,cAAA;EACA,UAAA;ArB8hEJ;AqB1hEE;EACE,gCf40BoC;Ee10BpC,UAAA;ArB2hEJ;AqBnhEE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;ArBkhEJ;AqB9gEE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArBghEJ;AsBtmEM;ED0EJ;ICzEM,gBAAA;EtBymEN;AACF;AqBlhEE;EACE,wCf47B8B;ANwlClC;;AqB3gEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ArB8gEF;AqB5gEE;EACE,UAAA;ArB8gEJ;AqB3gEE;EAEE,gBAAA;EACA,eAAA;ArB4gEJ;;AqBjgEA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;APyoEJ;AqBlgEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;ANg4C9B;;AqBhgEA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;APqpEJ;AqBjgEE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;ANw4C9B;;AqB3/DE;EACE,oEf6uBoC;ANixCxC;AqB3/DE;EACE,mEf0uBoC;ANmxCxC;AqB1/DE;EACE,iEfuuBoC;ANqxCxC;;AqBv/DA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;ANy6C9B;AqBx/DE;EACE,eAAA;ArB0/DJ;AqBv/DE;EACE,oBAAA;EdvLA,sCAAA;APirEJ;AqBt/DE;EACE,oBAAA;Ed5LA,sCAAA;APqrEJ;AqBr/DE;EAAoB,+Df8sBkB;AN0yCxC;AqBv/DE;EAAoB,6Df8sBkB;AN4yCxC;;AwBzsEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AxBysEF;AsB9sEM;EEfN;IFgBQ,gBAAA;EtBitEN;AACF;AwB5sEE;EACE,qBlBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;ANyuClC;AwBtsEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxBusEJ;AwBpsEE;EAEE,wClBu1BoC;AN82CxC;AwBhsEE;EACE,kBAAA;EACA,uCAAA;AxBksEJ;;AwB9rEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AP4uEJ;;AwB9rEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;APovEJ;;AwB5rEI;EACE,gEAAA;AxB+rEN;;AyBvwEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;ANq2C1C;AyBxwEE;EACE,WAAA;EACA,mBAAA;AzB0wEJ;;AyBtwEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzBywEF;AyBvwEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzBywEJ;;AyBrwEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,iCAAA;UAAA,yBAAA;AzBuwEF;AyBpwEE;ElB3BE,qBAAA;APkyEJ;AyBnwEE;EAEE,kBnBm4BsC;ANi4C1C;AyBjwEE;EACE,uBnB03BsC;ANy4C1C;AyBhwEE;EACE,qBnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;ANowDxB;AyB/vEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;AN8xEV;AyB/vEI;EAII,iEAAA;AzB8vER;AyB1vEI;EAII,iEAAA;AzByvER;AyBpvEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,iEAAA;AzBkvEN;AyB9uEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AN84C3C;AyBzuEI;EACE,eAAA;EACA,YnBy1BqC;ANk5C3C;;AyB7tEA;EACE,mBnBo1BgC;AN44ClC;AyB9tEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzB+tEJ;AsBj1EM;EG0GJ;IHzGM,gBAAA;EtBo1EN;AACF;AyBluEI;EACE,4DAAA;AzBouEN;AyBjuEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AzB+tER;AyB1tEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzB4tEJ;AyB1tEI;EACE,oBAAA;EACA,cAAA;AzB4tEN;;AyBvtEA;EACE,qBAAA;EACA,kBnBsyBgC;ANo7ClC;;AyBvtEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzB0tEF;AyBttEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;ANkkD9B;;AyBjtEI;EACE,4DAAA;AzBotEN;;A0Bv4EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1B04EF;A0Bx4EE;EACE,UAAA;A1B04EJ;A0Bt4EI;EAA0B,kEpB8gCa;AN23C3C;A0Bx4EI;EAA0B,kEpB6gCa;AN83C3C;A0Bx4EE;EACE,SAAA;A1B04EJ;A0Bv4EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1Bw4EJ;AsBv5EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtB05EN;AACF;A0B34EI;EHjCF,yBjB8hCyC;ANi5C3C;A0Bz4EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;APy6EJ;A0Bv4EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1Bw4EJ;AsBj7EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtBo7EN;AACF;A0B34EI;EH3DF,yBjB8hCyC;AN26C3C;A0Bz4EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;APm8EJ;A0Bv4EE;EACE,oBAAA;A1By4EJ;A0Bv4EI;EACE,2CpBg9BqC;ANy7C3C;A0Bt4EI;EACE,2CpB48BqC;AN47C3C;;A2B/9EA;EACE,kBAAA;A3Bk+EF;A2Bh+EE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AN27CxC;A2B/9EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;A3Bi+EJ;AsBt+EM;EKTJ;ILUM,gBAAA;EtBy+EN;AACF;A2Bn+EE;;EAEE,qBAAA;A3Bq+EJ;A2Bn+EI;;EACE,kBAAA;A3Bs+EN;A2Bn+EI;;;EAEE,qBrB4gCkC;EqB3gClC,wBrB4gCkC;AN09CxC;A2Bn+EI;;EACE,qBrBugCkC;EqBtgClC,wBrBugCkC;AN+9CxC;A2Bl+EE;EACE,qBrBigCoC;EqBhgCpC,wBrBigCoC;ANm+CxC;A2B79EI;;;;EACE,2CAAA;EACA,8DrB2/BkC;ANu+CxC;A2Bh+EM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBm/BgC;EqBl/BhC,WAAA;EACA,mCrBg0BgC;ECh3BpC,sCAAA;APshFJ;A2B/9EI;EACE,2CAAA;EACA,8DrB0+BkC;ANu/CxC;A2B59EI;EACE,sCAAA;A3B89EN;A2B19EE;;EAEE,crB1EO;ANsiFX;A2B19EI;;EACE,wCrB0yBkC;ANmrDxC;;A4BpjFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5BujFF;A4BrjFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5BujFJ;A4BnjFE;;;EAGE,UAAA;A5BqjFJ;A4B/iFE;EACE,kBAAA;EACA,UAAA;A5BijFJ;A4B/iFI;EACE,UAAA;A5BijFN;;A4BtiFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;APglFJ;;A4BhiFA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;APylFJ;;A4BhiFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;APkmFJ;;A4BhiFA;;EAEE,mBAAA;A5BmiFF;;A4BthFI;;;;ErBjEA,0BAAA;EACA,6BAAA;AP8lFJ;A4BrhFI;;;;ErB1EA,0BAAA;EACA,6BAAA;APqmFJ;A4B/gFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AP4lFJ;A4B/gFE;;ErB9EE,yBAAA;EACA,4BAAA;APimFJ;;A6BznFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;ANykDzB;;A6BxnFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;APspFJ;;A6BtnFI;;;;EAEE,cAAA;A7B2nFN;;A6B1qFI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BunFR;A6BpnFM;EACE,+CvB4gCiB;EuB3gCjB,2DvB2gCiB;AN2mDzB;;A6BvrFI;EA0EI,oCvB40BgC;EuB30BhC,kFAAA;A7BinFR;;A6B5rFI;EAkFE,+CvB0/BmB;ANonDzB;A6B3mFQ;EAEE,iEAAA;EACA,uBvB05B8B;EuBz5B9B,+DAAA;EACA,2EAAA;A7B4mFV;A6BxmFM;EACE,+CvB6+BiB;EuB5+BjB,2DvB4+BiB;AN8nDzB;;A6B1sFI;EAwGI,yCAAA;A7BsmFR;;A6B9sFI;EA+GE,+CvB69BmB;ANsoDzB;A6BjmFM;EACE,4CvB09BiB;ANyoDzB;A6BhmFM;EACE,2DvBs9BiB;AN4oDzB;A6B/lFM;EACE,iCvBk9BiB;AN+oDzB;;A6B5lFI;EACE,kBAAA;A7B+lFN;;A6B/tFI;;;;;EA0IM,UAAA;A7B6lFV;;A6BntFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;ANmqDzB;;A6BltFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;APgvFJ;;A6BhtFI;;;;EAEE,cAAA;A7BqtFN;;A6BpwFI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BitFR;A6B9sFM;EACE,iDvB4gCiB;EuB3gCjB,0DvB2gCiB;ANqsDzB;;A6BjxFI;EA0EI,oCvB40BgC;EuB30BhC,kFAAA;A7B2sFR;;A6BtxFI;EAkFE,iDvB0/BmB;AN8sDzB;A6BrsFQ;EAEE,kEAAA;EACA,uBvB05B8B;EuBz5B9B,+DAAA;EACA,2EAAA;A7BssFV;A6BlsFM;EACE,iDvB6+BiB;EuB5+BjB,0DvB4+BiB;ANwtDzB;;A6BpyFI;EAwGI,yCAAA;A7BgsFR;;A6BxyFI;EA+GE,iDvB69BmB;ANguDzB;A6B3rFM;EACE,8CvB09BiB;ANmuDzB;A6B1rFM;EACE,0DvBs9BiB;ANsuDzB;A6BzrFM;EACE,mCvBk9BiB;ANyuDzB;;A6BtrFI;EACE,kBAAA;A7ByrFN;;A6BzzFI;;;;;EA4IM,UAAA;A7BqrFV;;A8Bn0FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9Bi0FF;AsBr1FM;EQhBN;IRiBQ,gBAAA;EtBw1FN;AACF;A8Bp0FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9Bq0FJ;A8Bl0FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9Bm0FJ;A8Bh0FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9B8zFN;A8B1zFE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9BwzFN;A8BpzFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9BgzFJ;A8B7yFI;EAKI,0CAAA;A9B2yFR;A8BtyFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9BqyFJ;;A8BzxFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bm4FF;;A8B1yFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bo5FF;;A8B3zFE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bq6FF;;A8B50FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bs7FF;;A8B71FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bu8FF;;A8B92FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bw9FF;;A8B/3FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/By+FF;;A8Bh5FE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B0/FF;;A8Bv4FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bk/FF;;A8Bx5FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BmgGF;;A8Bz6FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BohGF;;A8B17FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BqiGF;;A8B38FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BsjGF;;A8B59FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BukGF;;A8B7+FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BwlGF;;A8B9/FE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BymGF;;A8BngGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxBuRwC;AN8uF1C;A8B3/FE;EACE,0BAAA;A9B6/FJ;A8B1/FE;EACE,gCAAA;A9B4/FJ;;A8Bj/FA;ECxIE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A/B6nGF;;A8Bp/FA;EC5IE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/BooGF;;AgCvsGA;EVgBM,gCUfJ;AhC0sGF;AsBvrGM;EUpBN;IVqBQ,gBAAA;EtB0rGN;AACF;AgC7sGE;EACE,UAAA;AhC+sGJ;;AgCzsGE;EACE,aAAA;AhC4sGJ;;AgCxsGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhC2sGF;AsBzsGM;EULN;IVMQ,gBAAA;EtB4sGN;AACF;AgC9sGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhCgtGJ;AsBntGM;EUAJ;IVCM,gBAAA;EtBstGN;AACF;;AiC3uGA;;;;;;EAME,kBAAA;AjC8uGF;;AiC3uGA;EACE,mBAAA;AjC8uGF;AkCttGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlC8vGF;AkCpsGI;EACE,cAAA;AlCssGN;;AiCpvGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AP8xGJ;AiCjvGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjCmvGJ;;AiC3tGI;EACE,oBAAA;AjC8tGN;AiC5tGM;EACE,WAAA;EACA,OAAA;AjC8tGR;;AiC1tGI;EACE,kBAAA;AjC6tGN;AiC3tGM;EACE,QAAA;EACA,UAAA;AjC6tGR;;AcvwGI;EmB4BA;IACE,oBAAA;EjC+uGJ;EiC7uGI;IACE,WAAA;IACA,OAAA;EjC+uGN;EiC3uGE;IACE,kBAAA;EjC6uGJ;EiC3uGI;IACE,QAAA;IACA,UAAA;EjC6uGN;AACF;AcxxGI;EmB4BA;IACE,oBAAA;EjC+vGJ;EiC7vGI;IACE,WAAA;IACA,OAAA;EjC+vGN;EiC3vGE;IACE,kBAAA;EjC6vGJ;EiC3vGI;IACE,QAAA;IACA,UAAA;EjC6vGN;AACF;AcxyGI;EmB4BA;IACE,oBAAA;EjC+wGJ;EiC7wGI;IACE,WAAA;IACA,OAAA;EjC+wGN;EiC3wGE;IACE,kBAAA;EjC6wGJ;EiC3wGI;IACE,QAAA;IACA,UAAA;EjC6wGN;AACF;AcxzGI;EmB4BA;IACE,oBAAA;EjC+xGJ;EiC7xGI;IACE,WAAA;IACA,OAAA;EjC+xGN;EiC3xGE;IACE,kBAAA;EjC6xGJ;EiC3xGI;IACE,QAAA;IACA,UAAA;EjC6xGN;AACF;Acx0GI;EmB4BA;IACE,oBAAA;EjC+yGJ;EiC7yGI;IACE,WAAA;IACA,OAAA;EjC+yGN;EiC3yGE;IACE,kBAAA;EjC6yGJ;EiC3yGI;IACE,QAAA;IACA,UAAA;EjC6yGN;AACF;AiCpyGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjCsyGJ;AkC13GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlC25GF;AkCx2GI;EACE,cAAA;AlC02GN;;AiC1yGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjC6yGJ;AkC/4GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlCy6GF;AkC73GI;EACE,cAAA;AlC+3GN;AiCrzGI;EACE,iBAAA;AjCuzGN;;AiCjzGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjCozGJ;AkCv6GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlCy6GN;AkC95GM;EACE,aAAA;AlCg6GR;AkC75GM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlCm8GF;AkC75GI;EACE,cAAA;AlC+5GN;AiCp0GI;EACE,iBAAA;AjCs0GN;;AiC/zGA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjCk0GF;;AiC5zGA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;APs+GJ;AiC7zGE;EAEE,0CAAA;EV1LF,kDU4LuB;AjC6zGzB;AiC1zGE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjC2zGzB;AiCxzGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjCyzGJ;;AiCnzGA;EACE,cAAA;AjCszGF;;AiClzGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjCqzGF;;AiCjzGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjCozGF;;AiChzGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjCkzGF;;AmCxiHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnC2iHF;AmCziHE;;EACE,kBAAA;EACA,cAAA;AnC4iHJ;AmCviHE;;;;;;;;;;;;EAME,UAAA;AnC+iHJ;;AmC1iHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnC6iHF;AmC3iHE;EACE,WAAA;AnC6iHJ;;AmCziHA;E5BhBI,sCAAA;AP6jHJ;AmCziHE;;EAEE,8CAAA;AnC2iHJ;AmCviHE;;;E5BVE,0BAAA;EACA,6BAAA;APsjHJ;AmCniHE;;;E5BNE,yBAAA;EACA,4BAAA;AP8iHJ;;AmCthHA;EACE,wBAAA;EACA,uBAAA;AnCyhHF;AmCvhHE;EAGE,cAAA;AnCuhHJ;AmCphHE;EACE,eAAA;AnCshHJ;;AmClhHA;EACE,uBAAA;EACA,sBAAA;AnCqhHF;;AmClhHA;EACE,sBAAA;EACA,qBAAA;AnCqhHF;;AmCjgHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnCogHF;AmClgHE;;EAEE,WAAA;AnCogHJ;AmCjgHE;;EAEE,6CAAA;AnCmgHJ;AmC//GE;;E5B1FE,6BAAA;EACA,4BAAA;AP6lHJ;AmC//GE;;E5B7GE,yBAAA;EACA,0BAAA;APgnHJ;;AoCxoHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApCuoHF;;AoCpoHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApCuoHF;AsBnpHM;EcGN;IdFQ,gBAAA;EtBspHN;AACF;AoC1oHE;EAEE,qCAAA;ApC2oHJ;AoCvoHE;EACE,UAAA;EACA,kD9BkhBoB;ANunGxB;AoCroHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApCsoHJ;;AoC9nHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApC8nHF;AoC5nHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AP4qHJ;AoC7nHI;EAGE,kBAAA;EACA,wDAAA;ApC6nHN;AoCznHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApC2nHJ;AoCxnHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AP2rHJ;;AoChnHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApCknHF;AoC/mHE;E7B5FE,gDAAA;AP8sHJ;AoC9mHE;;EAEE,4CAAA;EbjHF,oDakHuB;ApCgnHzB;;AoCvmHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApCumHF;AoCrmHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApCumHJ;AoCrmHI;EAEE,iCAAA;ApCsmHN;AoClmHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApComHJ;;AoC1lHE;;EAEE,cAAA;EACA,kBAAA;ApC6lHJ;;AoCxlHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ApC2lHJ;;AoCrlHE;;EACE,WAAA;ApCylHJ;;AoC/kHE;EACE,aAAA;ApCklHJ;AoChlHE;EACE,cAAA;ApCklHJ;;AqC/wHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArC+wHF;AqCzwHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArCixHJ;AqC7vHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArC+vHF;AqC7vHE;EAEE,yCAAA;ArC8vHJ;;AqCpvHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCmvHF;AqChvHI;EAEE,oCAAA;ArCivHN;AqC7uHE;EACE,gBAAA;ArC+uHJ;;AqCtuHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArCyuHF;AqCvuHE;;;EAGE,oCAAA;ArCyuHJ;;AqC5tHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ArC6tHF;;AqCztHA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArC4tHF;AsBr2HM;EeiIN;IfhIQ,gBAAA;EtBw2HN;AACF;AqC/tHE;EACE,qBAAA;ArCiuHJ;AqC9tHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArCguHJ;;AqC1tHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArC6tHF;;AqC1tHA;EACE,yCAAA;EACA,gBAAA;ArC6tHF;;Acv1HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCotHN;EqCltHM;IACE,mBAAA;ErCotHR;EqCltHQ;IACE,kBAAA;ErCotHV;EqCjtHQ;IACE,kDAAA;IACA,iDAAA;ErCmtHV;EqC/sHM;IACE,iBAAA;ErCitHR;EqC9sHM;IACE,wBAAA;IACA,gBAAA;ErCgtHR;EqC7sHM;IACE,aAAA;ErC+sHR;EqC5sHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC4sHR;EqCzsHQ;IACE,aAAA;ErC2sHV;EqCxsHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC0sHV;AACF;Acv4HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCmwHN;EqCjwHM;IACE,mBAAA;ErCmwHR;EqCjwHQ;IACE,kBAAA;ErCmwHV;EqChwHQ;IACE,kDAAA;IACA,iDAAA;ErCkwHV;EqC9vHM;IACE,iBAAA;ErCgwHR;EqC7vHM;IACE,wBAAA;IACA,gBAAA;ErC+vHR;EqC5vHM;IACE,aAAA;ErC8vHR;EqC3vHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC2vHR;EqCxvHQ;IACE,aAAA;ErC0vHV;EqCvvHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCyvHV;AACF;Act7HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCkzHN;EqChzHM;IACE,mBAAA;ErCkzHR;EqChzHQ;IACE,kBAAA;ErCkzHV;EqC/yHQ;IACE,kDAAA;IACA,iDAAA;ErCizHV;EqC7yHM;IACE,iBAAA;ErC+yHR;EqC5yHM;IACE,wBAAA;IACA,gBAAA;ErC8yHR;EqC3yHM;IACE,aAAA;ErC6yHR;EqC1yHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC0yHR;EqCvyHQ;IACE,aAAA;ErCyyHV;EqCtyHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCwyHV;AACF;Acr+HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCi2HN;EqC/1HM;IACE,mBAAA;ErCi2HR;EqC/1HQ;IACE,kBAAA;ErCi2HV;EqC91HQ;IACE,kDAAA;IACA,iDAAA;ErCg2HV;EqC51HM;IACE,iBAAA;ErC81HR;EqC31HM;IACE,wBAAA;IACA,gBAAA;ErC61HR;EqC11HM;IACE,aAAA;ErC41HR;EqCz1HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCy1HR;EqCt1HQ;IACE,aAAA;ErCw1HV;EqCr1HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCu1HV;AACF;AcphII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCg5HN;EqC94HM;IACE,mBAAA;ErCg5HR;EqC94HQ;IACE,kBAAA;ErCg5HV;EqC74HQ;IACE,kDAAA;IACA,iDAAA;ErC+4HV;EqC34HM;IACE,iBAAA;ErC64HR;EqC14HM;IACE,wBAAA;IACA,gBAAA;ErC44HR;EqCz4HM;IACE,aAAA;ErC24HR;EqCx4HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCw4HR;EqCr4HQ;IACE,aAAA;ErCu4HV;EqCp4HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCs4HV;AACF;AqC77HI;EAEI,iBAAA;EACA,2BAAA;ArC87HR;AqC57HQ;EACE,mBAAA;ArC87HV;AqC57HU;EACE,kBAAA;ArC87HZ;AqC37HU;EACE,kDAAA;EACA,iDAAA;ArC67HZ;AqCz7HQ;EACE,iBAAA;ArC27HV;AqCx7HQ;EACE,wBAAA;EACA,gBAAA;ArC07HV;AqCv7HQ;EACE,aAAA;ArCy7HV;AqCt7HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArCs7HV;AqCn7HU;EACE,aAAA;ArCq7HZ;AqCl7HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArCo7HZ;;AqCn6HA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArCq6HF;;AqC/5HI;EACE,qEAAA;ArCk6HN;;AsC3rIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AP6sIJ;AsCxrIE;EACE,eAAA;EACA,cAAA;AtC0rIJ;AsCvrIE;EACE,mBAAA;EACA,sBAAA;AtCyrIJ;AsCvrII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;APgtIJ;AsCvrII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;APusIJ;AsCprIE;;EAEE,aAAA;AtCsrIJ;;AsClrIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtCmrIF;;AsChrIA;EACE,4CAAA;EACA,iCAAA;AtCmrIF;;AsChrIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtCmrIF;;AsChrIA;EACE,gBAAA;AtCmrIF;;AsC3qIE;EACE,oCAAA;AtC8qIJ;;AsCtqIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtCyqIF;AsCvqIE;E/B7FE,wFAAA;APuwIJ;;AsCrqIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtCwqIF;AsCtqIE;E/BxGE,wFAAA;APixIJ;;AsC/pIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtCkqIF;AsChqIE;EACE,mCAAA;EACA,sCAAA;AtCkqIJ;;AsC9pIA;EACE,uDAAA;EACA,sDAAA;AtCiqIF;;AsC7pIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AP2yIJ;;AsC7pIA;;;EAGE,WAAA;AtCgqIF;;AsC7pIA;;E/B3II,0DAAA;EACA,2DAAA;AP6yIJ;;AsC9pIA;;E/BlII,8DAAA;EACA,6DAAA;APqyIJ;;AsCvpIE;EACE,0CAAA;AtC0pIJ;AcrxII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtC0pIF;EsCvpIE;IAEE,SAAA;IACA,gBAAA;EtCwpIJ;EsCtpII;IACE,cAAA;IACA,cAAA;EtCwpIN;EsCnpIM;I/B3KJ,0BAAA;IACA,6BAAA;EPi0IF;EsCppIQ;;IAGE,0BAAA;EtCqpIV;EsCnpIQ;;IAGE,6BAAA;EtCopIV;EsChpIM;I/B5KJ,yBAAA;IACA,4BAAA;EP+zIF;EsCjpIQ;;IAGE,yBAAA;EtCkpIV;EsChpIQ;;IAGE,4BAAA;EtCipIV;AACF;;AuCt3IA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,8CAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvCw3IF;;AuCp3IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC2PI,eALI;EoCpPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCtBE,gBAAA;EgCwBF,qBAAA;EjB3BI,0CiB4BJ;AvCu3IF;AsB/4IM;EiBWN;IjBVQ,gBAAA;EtBk5IN;AACF;AuC13IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvC43IJ;AuC13II;EACE,qDAAA;EACA,iDAAA;AvC43IN;AuCv3IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;AvCy3IJ;AsBx6IM;EiBsCJ;IjBrCM,gBAAA;EtB26IN;AACF;AuC33IE;EACE,UAAA;AvC63IJ;AuC13IE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AvC43IJ;;AuCx3IA;EACE,gBAAA;AvC23IF;;AuCx3IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvC23IF;AuCz3IE;EhC/DE,yDAAA;EACA,0DAAA;AP27IJ;AuC13II;EhClEA,+DAAA;EACA,gEAAA;AP+7IJ;AuCz3IE;EACE,aAAA;AvC23IJ;AuCv3IE;EhC9DE,6DAAA;EACA,4DAAA;APw7IJ;AuCv3IM;EhClEF,mEAAA;EACA,kEAAA;AP47IJ;AuCt3II;EhCvEA,6DAAA;EACA,4DAAA;APg8IJ;;AuCp3IA;EACE,8EAAA;AvCu3IF;;AuC92IE;EACE,eAAA;AvCi3IJ;AuC92IE;EACE,eAAA;EACA,cAAA;EhCpHA,gBAAA;APq+IJ;AuC92II;EAAgB,aAAA;AvCi3IpB;AuCh3II;EAAe,gBAAA;AvCm3InB;AuCh3IM;EhC3HF,gBAAA;AP8+IJ;;AuCz2II;EACE,iEAAA;EACA,wEAAA;AvC42IN;;AwCtgJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;APsgJJ;;AwChgJE;EACE,iDAAA;AxCmgJJ;AwCjgJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AxCmgJN;AwC//IE;EACE,6CAAA;AxCigJJ;;AyCtiJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AT2jJF;;AyCpiJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzCuiJF;AsBxjJM;EmBQN;InBPQ,gBAAA;EtB2jJN;AACF;AyC1iJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzC2iJJ;AyCxiJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzC0iJJ;AyCviJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzCwiJJ;AyCriJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzCsiJJ;;AyCjiJE;EACE,8CnC8sCgC;ANs1GpC;AyC/hJM;ElC9BF,0DAAA;EACA,6DAAA;APgkJJ;AyC7hJM;ElClDF,2DAAA;EACA,8DAAA;APklJJ;;AyChhJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A1CsnJF;;AyCnhJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1C6nJF;;A2C/nJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;APooJJ;A2C3nJE;EACE,aAAA;A3C6nJJ;;A2CxnJA;EACE,kBAAA;EACA,SAAA;A3C2nJF;;A4C3pJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AP+pJJ;;A4CvpJA;EAEE,cAAA;A5CypJF;;A4CrpJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5CwpJF;;A4ChpJA;EACE,mBtCo+C8B;AN+qGhC;A4ChpJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5CkpJJ;;A4C1oJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C6oJJ;;A4CjpJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5CopJJ;;A4CxpJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C2pJJ;;A4C/pJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CkqJJ;;A4CtqJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5CyqJJ;;A4C7qJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5CgrJJ;;A4CprJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5CurJJ;;A4C3rJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5C8rJJ;;A6C1vJE;EACE;IAAK,2BvCuhD2B;ENuuGlC;AACF;A6C1vJA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;APkwJJ;;A6CrvJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7CwvJF;AsB7wJM;EuBYN;IvBXQ,gBAAA;EtBgxJN;AACF;;A6C1vJA;EtBAE,qMAAA;EsBEA,oEAAA;A7C6vJF;;A6C1vJA;EACE,iBAAA;A7C6vJF;;A6C1vJA;EACE,WAAA;A7C6vJF;;A6CzvJE;EACE,kDAAA;A7C4vJJ;A6CzvJM;EAJJ;IAKM,eAAA;E7C4vJN;AACF;;A8CxzJA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;APk0JJ;;A8CnzJA;EACE,qBAAA;EACA,sBAAA;A9CszJF;A8CpzJE;EAEE,oCAAA;EACA,0BAAA;A9CqzJJ;;A8C5yJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9C+yJF;A8C5yJE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9C6yJJ;A8C1yJE;EACE,+CAAA;EACA,uDAAA;A9C4yJJ;;A8CpyJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9CuyJF;A8CryJE;EvCvDE,+BAAA;EACA,gCAAA;AP+1JJ;A8CryJE;EvC7CE,mCAAA;EACA,kCAAA;APq1JJ;A8CryJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9CsyJJ;A8ClyJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9CoyJJ;A8ChyJE;EACE,mBAAA;A9CkyJJ;A8ChyJI;EACE,wDAAA;EACA,mDAAA;A9CkyJN;;A8CrxJI;EACE,mBAAA;A9CwxJN;A8CrxJQ;EvCvDJ,6DAAA;EAZA,0BAAA;AP41JJ;A8CpxJQ;EvCxEJ,2DAAA;EAYA,4BAAA;APo1JJ;A8CnxJQ;EACE,aAAA;A9CqxJV;A8ClxJQ;EACE,mDAAA;EACA,oBAAA;A9CoxJV;A8ClxJU;EACE,yDAAA;EACA,oDAAA;A9CoxJZ;;Ac12JI;EgC8DA;IACE,mBAAA;E9CgzJJ;E8C7yJM;IvCvDJ,6DAAA;IAZA,0BAAA;EPo3JF;E8C5yJM;IvCxEJ,2DAAA;IAYA,4BAAA;EP42JF;E8C3yJM;IACE,aAAA;E9C6yJR;E8C1yJM;IACE,mDAAA;IACA,oBAAA;E9C4yJR;E8C1yJQ;IACE,yDAAA;IACA,oDAAA;E9C4yJV;AACF;Acn4JI;EgC8DA;IACE,mBAAA;E9Cw0JJ;E8Cr0JM;IvCvDJ,6DAAA;IAZA,0BAAA;EP44JF;E8Cp0JM;IvCxEJ,2DAAA;IAYA,4BAAA;EPo4JF;E8Cn0JM;IACE,aAAA;E9Cq0JR;E8Cl0JM;IACE,mDAAA;IACA,oBAAA;E9Co0JR;E8Cl0JQ;IACE,yDAAA;IACA,oDAAA;E9Co0JV;AACF;Ac35JI;EgC8DA;IACE,mBAAA;E9Cg2JJ;E8C71JM;IvCvDJ,6DAAA;IAZA,0BAAA;EPo6JF;E8C51JM;IvCxEJ,2DAAA;IAYA,4BAAA;EP45JF;E8C31JM;IACE,aAAA;E9C61JR;E8C11JM;IACE,mDAAA;IACA,oBAAA;E9C41JR;E8C11JQ;IACE,yDAAA;IACA,oDAAA;E9C41JV;AACF;Acn7JI;EgC8DA;IACE,mBAAA;E9Cw3JJ;E8Cr3JM;IvCvDJ,6DAAA;IAZA,0BAAA;EP47JF;E8Cp3JM;IvCxEJ,2DAAA;IAYA,4BAAA;EPo7JF;E8Cn3JM;IACE,aAAA;E9Cq3JR;E8Cl3JM;IACE,mDAAA;IACA,oBAAA;E9Co3JR;E8Cl3JQ;IACE,yDAAA;IACA,oDAAA;E9Co3JV;AACF;Ac38JI;EgC8DA;IACE,mBAAA;E9Cg5JJ;E8C74JM;IvCvDJ,6DAAA;IAZA,0BAAA;EPo9JF;E8C54JM;IvCxEJ,2DAAA;IAYA,4BAAA;EP48JF;E8C34JM;IACE,aAAA;E9C64JR;E8C14JM;IACE,mDAAA;IACA,oBAAA;E9C44JR;E8C14JQ;IACE,yDAAA;IACA,oDAAA;E9C44JV;AACF;A8C/3JA;EvChJI,gBAAA;APkhKJ;A8C/3JE;EACE,mDAAA;A9Ci4JJ;A8C/3JI;EACE,sBAAA;A9Ci4JN;;A8Cp3JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Cu3JJ;;A8Cj4JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9Co4JJ;;A8C94JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Ci5JJ;;A8C35JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9C85JJ;;A8Cx6JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9C26JJ;;A8Cr7JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9Cw7JJ;;A8Cl8JE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9Cq8JJ;;A8C/8JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9Ck9JJ;;A+C9oKA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCmpD2B;EyClpD3B,WzCkpD2B;EyCjpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/C8oKF;A+C3oKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/C6oKJ;A+C1oKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/C4oKJ;A+CzoKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/C0oKJ;;A+CloKA;EAHE,wCAAA;A/CyoKF;;A+ChoKI;EATF,wCAAA;A/C6oKF;;AgD9rKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;APusKJ;AgD5rKE;EACE,UAAA;AhD8rKJ;AgD3rKE;EACE,aAAA;AhD6rKJ;;AgDzrKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhD2rKF;AgDzrKE;EACE,sCAAA;AhD2rKJ;;AgDvrKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AP2tKJ;AgDzrKE;EACE,oDAAA;EACA,sCAAA;AhD2rKJ;;AgDvrKA;EACE,kCAAA;EACA,qBAAA;AhD0rKF;;AiDxvKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjDsvKF;;AiD/uKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjDivKF;AiD9uKE;E3B5CI,mC2B6CF;EACA,8B3Cg8CgC;ANgzHpC;AsB1xKM;E2BwCJ;I3BvCM,gBAAA;EtB6xKN;AACF;AiDnvKE;EACE,e3C87CgC;ANuzHpC;AiDjvKE;EACE,sB3C27CgC;ANwzHpC;;AiD/uKA;EACE,+CAAA;AjDkvKF;AiDhvKE;EACE,gBAAA;EACA,gBAAA;AjDkvKJ;AiD/uKE;EACE,gBAAA;AjDivKJ;;AiD7uKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjDgvKF;;AiD5uKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjD4uKF;;AiDxuKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjD8uK9D;AkD11KE;EAAS,UAAA;AlD61KX;AkD51KE;EAAS,mCD2GiF;AjDovK5F;;AiD/uKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E1CtGE,2DAAA;EACA,4DAAA;APy1KJ;AiDjvKE;EACE,kGAAA;EACA,sJAAA;AjDmvKJ;;AiD9uKA;EACE,gBAAA;EACA,8CAAA;AjDivKF;;AiD5uKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjD6uKF;;AiDzuKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C1HE,+DAAA;EACA,8DAAA;APu2KJ;AiDxuKE;EACE,8CAAA;AjD0uKJ;;Act1KI;EmCkHF;IACE,0BAAA;IACA,2CAAA;EjDwuKF;EiDpuKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjDsuKF;EiDnuKA;IACE,uBAAA;EjDquKF;AACF;Acr2KI;EmCoIF;;IAEE,uBAAA;EjDouKF;AACF;Ac32KI;EmC2IF;IACE,wBAAA;EjDmuKF;AACF;AiD1tKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjD4tKN;AiD1tKM;EACE,YAAA;EACA,SAAA;E1C1MJ,gBAAA;APu6KJ;AiDztKM;;E1C9MF,gBAAA;AP26KJ;AiDxtKM;EACE,gBAAA;AjD0tKR;;Acr3KI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDgvKJ;EiD9uKI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EP27KF;EiD7uKI;;I1C9MF,gBAAA;EP+7KF;EiD5uKI;IACE,gBAAA;EjD8uKN;AACF;Ac14KI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDowKJ;EiDlwKI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EP+8KF;EiDjwKI;;I1C9MF,gBAAA;EPm9KF;EiDhwKI;IACE,gBAAA;EjDkwKN;AACF;Ac95KI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDwxKJ;EiDtxKI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EPm+KF;EiDrxKI;;I1C9MF,gBAAA;EPu+KF;EiDpxKI;IACE,gBAAA;EjDsxKN;AACF;Acl7KI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD4yKJ;EiD1yKI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EPu/KF;EiDzyKI;;I1C9MF,gBAAA;EP2/KF;EiDxyKI;IACE,gBAAA;EjD0yKN;AACF;Act8KI;EmCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDg0KJ;EiD9zKI;IACE,YAAA;IACA,SAAA;I1C1MJ,gBAAA;EP2gLF;EiD7zKI;;I1C9MF,gBAAA;EP+gLF;EiD5zKI;IACE,gBAAA;EjD8zKN;AACF;AmDriLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnD6iLF;AmD3iLE;EAAS,kCAAA;AnD8iLX;AmD5iLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnD8iLJ;AmD5iLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnD8iLN;;AmDziLA;EACE,iDAAA;AnD4iLF;AmD1iLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnD4iLJ;;AmDxiLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnD2iLF;AmDziLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnD2iLJ;;AmDviLA,mBAAA;AAEA;EACE,8CAAA;AnDyiLF;AmDviLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDyiLJ;;AmDriLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDwiLF;AmDtiLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDwiLJ;;AmDpiLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;APwnLJ;;AqD3oLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;APsqLJ;AqDlpLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArDopLJ;AqDlpLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArDmpLN;;AqD7oLE;EACE,oFAAA;ArDgpLJ;AqD9oLI;EAEE,wFAAA;ArD+oLN;AqD5oLI;EACE,SAAA;EACA,gDAAA;ArD8oLN;AqD3oLI;EACE,sCAAA;EACA,sCAAA;ArD6oLN;;AqDxoLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArD0oLJ;AqDxoLI;EAEE,kIAAA;ArDyoLN;AqDtoLI;EACE,OAAA;EACA,kDAAA;ArDwoLN;AqDroLI;EACE,oCAAA;EACA,wCAAA;ArDuoLN;;AqDloLA,mBAAA;AAGE;EACE,iFAAA;ArDmoLJ;AqDjoLI;EAEE,wFAAA;ArDkoLN;AqD/nLI;EACE,MAAA;EACA,mDAAA;ArDioLN;AqD9nLI;EACE,mCAAA;EACA,yCAAA;ArDgoLN;AqD3nLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArD6nLJ;;AqDznLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArD2nLJ;AqDznLI;EAEE,kIAAA;ArD0nLN;AqDvnLI;EACE,QAAA;EACA,iDAAA;ArDynLN;AqDtnLI;EACE,qCAAA;EACA,uCAAA;ArDwnLN;;AqDnnLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;APkwLJ;AqDpmLE;EACE,aAAA;ArDsmLJ;;AqDlmLA;EACE,0EAAA;EACA,mCAAA;ArDqmLF;;AsD1xLA;EACE,kBAAA;AtD6xLF;;AsD1xLA;EACE,mBAAA;AtD6xLF;;AsD1xLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtD6xLF;AuDnzLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDqzLJ;;AsD9xLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtDiyLF;AsBhzLM;EgCQN;IhCPQ,gBAAA;EtBmzLN;AACF;;AsDnyLA;;;EAGE,cAAA;AtDsyLF;;AsDnyLA;;EAEE,2BAAA;AtDsyLF;;AsDnyLA;;EAEE,4BAAA;AtDsyLF;;AsD7xLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDgyLJ;AsD7xLE;;;EAGE,UAAA;EACA,UAAA;AtD+xLJ;AsD5xLE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtD8xLJ;AsBv1LM;EgCqDJ;;IhCpDM,gBAAA;EtB21LN;AACF;;AsD3xLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDghDmC;EgD/gDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhD2gDmC;EgBjmD/B,8BgCuFJ;AtD6xLF;AsBh3LM;EgCkEN;;IhCjEQ,gBAAA;EtBo3LN;AACF;AsDhyLE;;;EAEE,WhDpGO;EgDqGP,qBAAA;EACA,UAAA;EACA,YhDmgDiC;ANgyIrC;;AsDhyLA;EACE,OAAA;AtDmyLF;;AsDhyLA;EACE,QAAA;AtDmyLF;;AsD9xLA;;EAEE,qBAAA;EACA,WhDogDmC;EgDngDnC,YhDmgDmC;EgDlgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtDiyLF;;AsD9xLA;;;;;;;GAAA;AAQA;EACE,0DAAA;AtDiyLF;;AsD/xLA;EACE,0DAAA;AtDkyLF;;AsD1xLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhD48CmC;EgD38CnC,mBAAA;EACA,gBhD08CmC;ANk1IrC;AsD1xLE;EACE,uBAAA;EACA,cAAA;EACA,WhD08CiC;EgDz8CjC,WhD08CiC;EgDz8CjC,UAAA;EACA,iBhD08CiC;EgDz8CjC,gBhDy8CiC;EgDx8CjC,mBAAA;EACA,eAAA;EACA,sBhD1KO;EgD2KP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhDi8CiC;EgBzmD/B,6BgCyKF;AtD2xLJ;AsBh8LM;EgCoJJ;IhCnJM,gBAAA;EtBm8LN;AACF;AsD7xLE;EACE,UhD87CiC;ANi2IrC;;AsDtxLA;EACE,kBAAA;EACA,UAAA;EACA,ehDw7CmC;EgDv7CnC,SAAA;EACA,oBhDq7CmC;EgDp7CnC,uBhDo7CmC;EgDn7CnC,WhDrMS;EgDsMT,kBAAA;AtDyxLF;;AsDnxLE;;EAEE,gChDy7CiC;AN61IrC;AsDnxLE;EACE,sBhDxMO;AN69LX;AsDlxLE;EACE,WhD5MO;ANg+LX;;AsD9xLE;;;EAEE,gChDy7CiC;ANy2IrC;AsD/xLE;EACE,sBhDxMO;ANy+LX;AsD9xLE;EACE,WhD5MO;AN4+LX;;AwD1/LA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxD4/LF;;AwDx/LA;EACE;IAAK,0CAAA;ExD4/LL;AACF;AwDz/LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxDw/LF;;AwDr/LA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxDu/LF;;AwD9+LA;EACE;IACE,mBAAA;ExDi/LF;EwD/+LA;IACE,UAAA;IACA,eAAA;ExDi/LF;AACF;AwD7+LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxD4+LF;;AwDz+LA;EACE,wBAAA;EACA,yBAAA;AxD4+LF;;AwDx+LE;EACE;;IAEE,kCAAA;ExD2+LJ;AACF;AyD3jMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzD4jMF;;Ac//LI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD6iMJ;AACF;AsBxkMM;EmCYJ;InCXM,gBAAA;EtB2kMN;AACF;AcrhMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDojMN;EyDjjMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDmjMN;EyDhjMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDkjMN;EyD/iMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDijMN;EyD9iMI;IAEE,eAAA;EzD+iMN;EyD5iMI;IAGE,mBAAA;EzD4iMN;AACF;AczkMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD2iMN;EyDziMM;IACE,aAAA;EzD2iMR;EyDxiMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDyiMR;AACF;;Ac7kMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD2nMJ;AACF;AsBtpMM;EmCYJ;InCXM,gBAAA;EtBypMN;AACF;AcnmMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDkoMN;EyD/nMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDioMN;EyD9nMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDgoMN;EyD7nMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD+nMN;EyD5nMI;IAEE,eAAA;EzD6nMN;EyD1nMI;IAGE,mBAAA;EzD0nMN;AACF;AcvpMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDynMN;EyDvnMM;IACE,aAAA;EzDynMR;EyDtnMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDunMR;AACF;;Ac3pMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDysMJ;AACF;AsBpuMM;EmCYJ;InCXM,gBAAA;EtBuuMN;AACF;AcjrMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDgtMN;EyD7sMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD+sMN;EyD5sMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD8sMN;EyD3sMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD6sMN;EyD1sMI;IAEE,eAAA;EzD2sMN;EyDxsMI;IAGE,mBAAA;EzDwsMN;AACF;AcruMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDusMN;EyDrsMM;IACE,aAAA;EzDusMR;EyDpsMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDqsMR;AACF;;AczuMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDuxMJ;AACF;AsBlzMM;EmCYJ;InCXM,gBAAA;EtBqzMN;AACF;Ac/vMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD8xMN;EyD3xMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD6xMN;EyD1xMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD4xMN;EyDzxMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD2xMN;EyDxxMI;IAEE,eAAA;EzDyxMN;EyDtxMI;IAGE,mBAAA;EzDsxMN;AACF;AcnzMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDqxMN;EyDnxMM;IACE,aAAA;EzDqxMR;EyDlxMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDmxMR;AACF;;AcvzMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDq2MJ;AACF;AsBh4MM;EmCYJ;InCXM,gBAAA;EtBm4MN;AACF;Ac70MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD42MN;EyDz2MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD22MN;EyDx2MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD02MN;EyDv2MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDy2MN;EyDt2MI;IAEE,eAAA;EzDu2MN;EyDp2MI;IAGE,mBAAA;EzDo2MN;AACF;Acj4MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDm2MN;EyDj2MM;IACE,aAAA;EzDm2MR;EyDh2MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDi2MR;AACF;;AyDj7ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzDk7MN;AsB58MM;EmCYJ;InCXM,gBAAA;EtB+8MN;AACF;AyDr7MM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDu7MR;AyDp7MM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzDs7MR;AyDn7MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDq7MR;AyDl7MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDo7MR;AyDj7MM;EAEE,eAAA;AzDk7MR;AyD/6MM;EAGE,mBAAA;AzD+6MR;;AyDp5MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;ANkgNX;AkDzgNE;EAAS,UAAA;AlD4gNX;AkD3gNE;EAAS,Y5Ci+CyB;AN6iKpC;;AyDh6MA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;AzDm6MF;AyDj6ME;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;AzDm6MJ;;AyD/5MA;EACE,gBAAA;EACA,kDAAA;AzDk6MF;;AyD/5MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDk6MF;;A0DljNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;ANqwKpC;A0DnjNE;EACE,qBAAA;EACA,WAAA;A1DqjNJ;;A0DhjNA;EACE,iBAAA;A1DmjNF;;A0DhjNA;EACE,iBAAA;A1DmjNF;;A0DhjNA;EACE,iBAAA;A1DmjNF;;A0D9iNE;EACE,mDAAA;A1DijNJ;;A0D7iNA;EACE;IACE,YpDmxCgC;EN6xKlC;AACF;A0D7iNA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A1D+iNF;;A0D5iNA;EACE;IACE,+BAAA;YAAA,uBAAA;E1D+iNF;AACF;AuD9lNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDgmNJ;;A2DnmNE;EACE,sBAAA;EACA,iFAAA;A3DsmNJ;;A2DxmNE;EACE,sBAAA;EACA,mFAAA;A3D2mNJ;;A2D7mNE;EACE,sBAAA;EACA,iFAAA;A3DgnNJ;;A2DlnNE;EACE,sBAAA;EACA,8EAAA;A3DqnNJ;;A2DvnNE;EACE,sBAAA;EACA,iFAAA;A3D0nNJ;;A2D5nNE;EACE,sBAAA;EACA,gFAAA;A3D+nNJ;;A2DjoNE;EACE,sBAAA;EACA,+EAAA;A3DooNJ;;A2DtoNE;EACE,sBAAA;EACA,8EAAA;A3DyoNJ;;A4D3oNE;EACE,wEAAA;EACA,kGAAA;A5D8oNJ;A4D3oNM;EAGE,8DAAA;EACA,wFAAA;A5D2oNR;;A4DppNE;EACE,0EAAA;EACA,oGAAA;A5DupNJ;A4DppNM;EAGE,8DAAA;EACA,wFAAA;A5DopNR;;A4D7pNE;EACE,wEAAA;EACA,kGAAA;A5DgqNJ;A4D7pNM;EAGE,8DAAA;EACA,wFAAA;A5D6pNR;;A4DtqNE;EACE,qEAAA;EACA,+FAAA;A5DyqNJ;A4DtqNM;EAGE,+DAAA;EACA,yFAAA;A5DsqNR;;A4D/qNE;EACE,wEAAA;EACA,kGAAA;A5DkrNJ;A4D/qNM;EAGE,+DAAA;EACA,yFAAA;A5D+qNR;;A4DxrNE;EACE,uEAAA;EACA,iGAAA;A5D2rNJ;A4DxrNM;EAGE,8DAAA;EACA,wFAAA;A5DwrNR;;A4DjsNE;EACE,sEAAA;EACA,gGAAA;A5DosNJ;A4DjsNM;EAGE,gEAAA;EACA,0FAAA;A5DisNR;;A4D1sNE;EACE,qEAAA;EACA,+FAAA;A5D6sNJ;A4D1sNM;EAGE,6DAAA;EACA,uFAAA;A5D0sNR;;A4DnsNA;EACE,+EAAA;EACA,yGAAA;A5DssNF;A4DnsNI;EAEE,kFAAA;EACA,4GAAA;A5DosNN;;A6D9tNA;EACE,UAAA;EAEA,kJAAA;A7DguNF;;A8DnuNA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A9DsuNF;A8DpuNE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9DsuNJ;AsB/tNM;EwCZJ;IxCaM,gBAAA;EtBkuNN;AACF;;A8DpuNI;EACE,mEAAA;A9DuuNN;;A+D1vNA;EACE,kBAAA;EACA,WAAA;A/D6vNF;A+D3vNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/D6vNJ;A+D1vNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/D4vNJ;;A+DvvNE;EACE,uBAAA;A/D0vNJ;;A+D3vNE;EACE,sBAAA;A/D8vNJ;;A+D/vNE;EACE,yBAAA;A/DkwNJ;;A+DnwNE;EACE,iCAAA;A/DswNJ;;AgE3xNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;ANurLpC;;AgE3xNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AN+rLpC;;AgEtxNI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;ANssLpC;;AgEtxNI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;AN4sLpC;;Ac1vNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENmtLlC;EgEnyNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENwtLlC;AACF;AcvwNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN+tLlC;EgE/yNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENouLlC;AACF;AcnxNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN2uLlC;EgE3zNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENgvLlC;AACF;Ac/xNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENuvLlC;EgEv0NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN4vLlC;AACF;Ac3yNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENmwLlC;EgEn1NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENwwLlC;AACF;AiEr3NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEu3NF;;AiEp3NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEu3NF;;AkE/3NA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnEg4NF;AmE73NE;;EACE,6BAAA;AnEg4NJ;;AoE94NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEi5NJ;;AqEz5NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtE65NF;;AuEn6NA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AN2uM9B;;AwE12NQ;EAOI,mCAAA;AxEu2NZ;;AwE92NQ;EAOI,8BAAA;AxE22NZ;;AwEl3NQ;EAOI,iCAAA;AxE+2NZ;;AwEt3NQ;EAOI,iCAAA;AxEm3NZ;;AwE13NQ;EAOI,sCAAA;AxEu3NZ;;AwE93NQ;EAOI,mCAAA;AxE23NZ;;AwEl4NQ;EAOI,sBAAA;AxE+3NZ;;AwEt4NQ;EAOI,uBAAA;AxEm4NZ;;AwE14NQ;EAOI,sBAAA;AxEu4NZ;;AwE94NQ;EAOI,8BAAA;AxE24NZ;;AwEl5NQ;EAOI,4BAAA;AxE+4NZ;;AwEt5NQ;EAOI,2BAAA;AxEm5NZ;;AwE15NQ;EAOI,iCAAA;AxEu5NZ;;AwE95NQ;EAOI,2BAAA;AxE25NZ;;AwEl6NQ;EAOI,qBAAA;AxE+5NZ;;AwEt6NQ;EAOI,wBAAA;AxEm6NZ;;AwE16NQ;EAOI,uBAAA;AxEu6NZ;;AwE96NQ;EAOI,wBAAA;AxE26NZ;;AwEl7NQ;EAOI,qBAAA;AxE+6NZ;;AwEt7NQ;EAOI,yBAAA;AxEm7NZ;;AwE17NQ;EAOI,2BAAA;AxEu7NZ;;AwE97NQ;EAOI,4BAAA;AxE27NZ;;AwEl8NQ;EAOI,2BAAA;AxE+7NZ;;AwEt8NQ;EAOI,2BAAA;AxEm8NZ;;AwE18NQ;EAOI,6BAAA;AxEu8NZ;;AwE98NQ;EAOI,8BAAA;AxE28NZ;;AwEl9NQ;EAOI,6BAAA;AxE+8NZ;;AwEt9NQ;EAOI,2BAAA;AxEm9NZ;;AwE19NQ;EAOI,6BAAA;AxEu9NZ;;AwE99NQ;EAOI,8BAAA;AxE29NZ;;AwEl+NQ;EAOI,6BAAA;AxE+9NZ;;AwEt+NQ;EAOI,0BAAA;AxEm+NZ;;AwE1+NQ;EAOI,gCAAA;AxEu+NZ;;AwE9+NQ;EAOI,yBAAA;AxE2+NZ;;AwEl/NQ;EAOI,wBAAA;AxE++NZ;;AwEt/NQ;EAOI,+BAAA;AxEm/NZ;;AwE1/NQ;EAOI,yBAAA;AxEu/NZ;;AwE9/NQ;EAOI,6BAAA;AxE2/NZ;;AwElgOQ;EAOI,8BAAA;AxE+/NZ;;AwEtgOQ;EAOI,wBAAA;AxEmgOZ;;AwE1gOQ;EAOI,+BAAA;AxEugOZ;;AwE9gOQ;EAOI,wBAAA;AxE2gOZ;;AwElhOQ;EAOI,2CAAA;AxE+gOZ;;AwEthOQ;EAOI,8CAAA;AxEmhOZ;;AwE1hOQ;EAOI,8CAAA;AxEuhOZ;;AwE9hOQ;EAOI,2BAAA;AxE2hOZ;;AwE5iOQ;EACE,gFAAA;AxE+iOV;;AwEhjOQ;EACE,kFAAA;AxEmjOV;;AwEpjOQ;EACE,gFAAA;AxEujOV;;AwExjOQ;EACE,6EAAA;AxE2jOV;;AwE5jOQ;EACE,gFAAA;AxE+jOV;;AwEhkOQ;EACE,+EAAA;AxEmkOV;;AwEpkOQ;EACE,8EAAA;AxEukOV;;AwExkOQ;EACE,6EAAA;AxE2kOV;;AwElkOQ;EAOI,2BAAA;AxE+jOZ;;AwEtkOQ;EAOI,6BAAA;AxEmkOZ;;AwE1kOQ;EAOI,6BAAA;AxEukOZ;;AwE9kOQ;EAOI,0BAAA;AxE2kOZ;;AwEllOQ;EAOI,2BAAA;AxE+kOZ;;AwEtlOQ;EAOI,iBAAA;AxEmlOZ;;AwE1lOQ;EAOI,mBAAA;AxEulOZ;;AwE9lOQ;EAOI,oBAAA;AxE2lOZ;;AwElmOQ;EAOI,oBAAA;AxE+lOZ;;AwEtmOQ;EAOI,sBAAA;AxEmmOZ;;AwE1mOQ;EAOI,uBAAA;AxEumOZ;;AwE9mOQ;EAOI,kBAAA;AxE2mOZ;;AwElnOQ;EAOI,oBAAA;AxE+mOZ;;AwEtnOQ;EAOI,qBAAA;AxEmnOZ;;AwE1nOQ;EAOI,mBAAA;AxEunOZ;;AwE9nOQ;EAOI,qBAAA;AxE2nOZ;;AwEloOQ;EAOI,sBAAA;AxE+nOZ;;AwEtoOQ;EAOI,2CAAA;AxEmoOZ;;AwE1oOQ;EAOI,sCAAA;AxEuoOZ;;AwE9oOQ;EAOI,sCAAA;AxE2oOZ;;AwElpOQ;EAOI,uFAAA;AxE+oOZ;;AwEtpOQ;EAOI,oBAAA;AxEmpOZ;;AwE1pOQ;EAOI,2FAAA;AxEupOZ;;AwE9pOQ;EAOI,wBAAA;AxE2pOZ;;AwElqOQ;EAOI,6FAAA;AxE+pOZ;;AwEtqOQ;EAOI,0BAAA;AxEmqOZ;;AwE1qOQ;EAOI,8FAAA;AxEuqOZ;;AwE9qOQ;EAOI,2BAAA;AxE2qOZ;;AwElrOQ;EAOI,4FAAA;AxE+qOZ;;AwEtrOQ;EAOI,yBAAA;AxEmrOZ;;AwE1rOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEwrOZ;;AwE/rOQ;EAIQ,sBAAA;EAGJ,gFAAA;AxE6rOZ;;AwEpsOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEksOZ;;AwEzsOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxEusOZ;;AwE9sOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxE4sOZ;;AwEntOQ;EAIQ,sBAAA;EAGJ,6EAAA;AxEitOZ;;AwExtOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEstOZ;;AwE7tOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxE2tOZ;;AwEluOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEguOZ;;AwEvuOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEquOZ;;AwE5uOQ;EAOI,wDAAA;AxEyuOZ;;AwEhvOQ;EAOI,0DAAA;AxE6uOZ;;AwEpvOQ;EAOI,wDAAA;AxEivOZ;;AwExvOQ;EAOI,qDAAA;AxEqvOZ;;AwE5vOQ;EAOI,wDAAA;AxEyvOZ;;AwEhwOQ;EAOI,uDAAA;AxE6vOZ;;AwEpwOQ;EAOI,sDAAA;AxEiwOZ;;AwExwOQ;EAOI,qDAAA;AxEqwOZ;;AwE5wOQ;EAOI,4BAAA;AxEywOZ;;AwEhxOQ;EAOI,4BAAA;AxE6wOZ;;AwEpxOQ;EAOI,4BAAA;AxEixOZ;;AwExxOQ;EAOI,4BAAA;AxEqxOZ;;AwE5xOQ;EAOI,4BAAA;AxEyxOZ;;AwE1yOQ;EACE,wBAAA;AxE6yOV;;AwE9yOQ;EACE,yBAAA;AxEizOV;;AwElzOQ;EACE,wBAAA;AxEqzOV;;AwEtzOQ;EACE,yBAAA;AxEyzOV;;AwE1zOQ;EACE,sBAAA;AxE6zOV;;AwEpzOQ;EAOI,qBAAA;AxEizOZ;;AwExzOQ;EAOI,qBAAA;AxEqzOZ;;AwE5zOQ;EAOI,qBAAA;AxEyzOZ;;AwEh0OQ;EAOI,sBAAA;AxE6zOZ;;AwEp0OQ;EAOI,sBAAA;AxEi0OZ;;AwEx0OQ;EAOI,0BAAA;AxEq0OZ;;AwE50OQ;EAOI,uBAAA;AxEy0OZ;;AwEh1OQ;EAOI,2BAAA;AxE60OZ;;AwEp1OQ;EAOI,sBAAA;AxEi1OZ;;AwEx1OQ;EAOI,sBAAA;AxEq1OZ;;AwE51OQ;EAOI,sBAAA;AxEy1OZ;;AwEh2OQ;EAOI,uBAAA;AxE61OZ;;AwEp2OQ;EAOI,uBAAA;AxEi2OZ;;AwEx2OQ;EAOI,2BAAA;AxEq2OZ;;AwE52OQ;EAOI,wBAAA;AxEy2OZ;;AwEh3OQ;EAOI,4BAAA;AxE62OZ;;AwEp3OQ;EAOI,yBAAA;AxEi3OZ;;AwEx3OQ;EAOI,8BAAA;AxEq3OZ;;AwE53OQ;EAOI,iCAAA;AxEy3OZ;;AwEh4OQ;EAOI,sCAAA;AxE63OZ;;AwEp4OQ;EAOI,yCAAA;AxEi4OZ;;AwEx4OQ;EAOI,uBAAA;AxEq4OZ;;AwE54OQ;EAOI,uBAAA;AxEy4OZ;;AwEh5OQ;EAOI,yBAAA;AxE64OZ;;AwEp5OQ;EAOI,yBAAA;AxEi5OZ;;AwEx5OQ;EAOI,0BAAA;AxEq5OZ;;AwE55OQ;EAOI,4BAAA;AxEy5OZ;;AwEh6OQ;EAOI,kCAAA;AxE65OZ;;AwEp6OQ;EAOI,sCAAA;AxEi6OZ;;AwEx6OQ;EAOI,oCAAA;AxEq6OZ;;AwE56OQ;EAOI,kCAAA;AxEy6OZ;;AwEh7OQ;EAOI,yCAAA;AxE66OZ;;AwEp7OQ;EAOI,wCAAA;AxEi7OZ;;AwEx7OQ;EAOI,wCAAA;AxEq7OZ;;AwE57OQ;EAOI,kCAAA;AxEy7OZ;;AwEh8OQ;EAOI,gCAAA;AxE67OZ;;AwEp8OQ;EAOI,8BAAA;AxEi8OZ;;AwEx8OQ;EAOI,gCAAA;AxEq8OZ;;AwE58OQ;EAOI,+BAAA;AxEy8OZ;;AwEh9OQ;EAOI,oCAAA;AxE68OZ;;AwEp9OQ;EAOI,kCAAA;AxEi9OZ;;AwEx9OQ;EAOI,gCAAA;AxEq9OZ;;AwE59OQ;EAOI,uCAAA;AxEy9OZ;;AwEh+OQ;EAOI,sCAAA;AxE69OZ;;AwEp+OQ;EAOI,iCAAA;AxEi+OZ;;AwEx+OQ;EAOI,2BAAA;AxEq+OZ;;AwE5+OQ;EAOI,iCAAA;AxEy+OZ;;AwEh/OQ;EAOI,+BAAA;AxE6+OZ;;AwEp/OQ;EAOI,6BAAA;AxEi/OZ;;AwEx/OQ;EAOI,+BAAA;AxEq/OZ;;AwE5/OQ;EAOI,8BAAA;AxEy/OZ;;AwEhgPQ;EAOI,oBAAA;AxE6/OZ;;AwEpgPQ;EAOI,mBAAA;AxEigPZ;;AwExgPQ;EAOI,mBAAA;AxEqgPZ;;AwE5gPQ;EAOI,mBAAA;AxEygPZ;;AwEhhPQ;EAOI,mBAAA;AxE6gPZ;;AwEphPQ;EAOI,mBAAA;AxEihPZ;;AwExhPQ;EAOI,mBAAA;AxEqhPZ;;AwE5hPQ;EAOI,mBAAA;AxEyhPZ;;AwEhiPQ;EAOI,oBAAA;AxE6hPZ;;AwEpiPQ;EAOI,0BAAA;AxEiiPZ;;AwExiPQ;EAOI,yBAAA;AxEqiPZ;;AwE5iPQ;EAOI,uBAAA;AxEyiPZ;;AwEhjPQ;EAOI,yBAAA;AxE6iPZ;;AwEpjPQ;EAOI,uBAAA;AxEijPZ;;AwExjPQ;EAOI,uBAAA;AxEqjPZ;;AwE5jPQ;EAOI,0BAAA;EAAA,yBAAA;AxE0jPZ;;AwEjkPQ;EAOI,gCAAA;EAAA,+BAAA;AxE+jPZ;;AwEtkPQ;EAOI,+BAAA;EAAA,8BAAA;AxEokPZ;;AwE3kPQ;EAOI,6BAAA;EAAA,4BAAA;AxEykPZ;;AwEhlPQ;EAOI,+BAAA;EAAA,8BAAA;AxE8kPZ;;AwErlPQ;EAOI,6BAAA;EAAA,4BAAA;AxEmlPZ;;AwE1lPQ;EAOI,6BAAA;EAAA,4BAAA;AxEwlPZ;;AwE/lPQ;EAOI,wBAAA;EAAA,2BAAA;AxE6lPZ;;AwEpmPQ;EAOI,8BAAA;EAAA,iCAAA;AxEkmPZ;;AwEzmPQ;EAOI,6BAAA;EAAA,gCAAA;AxEumPZ;;AwE9mPQ;EAOI,2BAAA;EAAA,8BAAA;AxE4mPZ;;AwEnnPQ;EAOI,6BAAA;EAAA,gCAAA;AxEinPZ;;AwExnPQ;EAOI,2BAAA;EAAA,8BAAA;AxEsnPZ;;AwE7nPQ;EAOI,2BAAA;EAAA,8BAAA;AxE2nPZ;;AwEloPQ;EAOI,wBAAA;AxE+nPZ;;AwEtoPQ;EAOI,8BAAA;AxEmoPZ;;AwE1oPQ;EAOI,6BAAA;AxEuoPZ;;AwE9oPQ;EAOI,2BAAA;AxE2oPZ;;AwElpPQ;EAOI,6BAAA;AxE+oPZ;;AwEtpPQ;EAOI,2BAAA;AxEmpPZ;;AwE1pPQ;EAOI,2BAAA;AxEupPZ;;AwE9pPQ;EAOI,0BAAA;AxE2pPZ;;AwElqPQ;EAOI,gCAAA;AxE+pPZ;;AwEtqPQ;EAOI,+BAAA;AxEmqPZ;;AwE1qPQ;EAOI,6BAAA;AxEuqPZ;;AwE9qPQ;EAOI,+BAAA;AxE2qPZ;;AwElrPQ;EAOI,6BAAA;AxE+qPZ;;AwEtrPQ;EAOI,6BAAA;AxEmrPZ;;AwE1rPQ;EAOI,2BAAA;AxEurPZ;;AwE9rPQ;EAOI,iCAAA;AxE2rPZ;;AwElsPQ;EAOI,gCAAA;AxE+rPZ;;AwEtsPQ;EAOI,8BAAA;AxEmsPZ;;AwE1sPQ;EAOI,gCAAA;AxEusPZ;;AwE9sPQ;EAOI,8BAAA;AxE2sPZ;;AwEltPQ;EAOI,8BAAA;AxE+sPZ;;AwEttPQ;EAOI,yBAAA;AxEmtPZ;;AwE1tPQ;EAOI,+BAAA;AxEutPZ;;AwE9tPQ;EAOI,8BAAA;AxE2tPZ;;AwEluPQ;EAOI,4BAAA;AxE+tPZ;;AwEtuPQ;EAOI,8BAAA;AxEmuPZ;;AwE1uPQ;EAOI,4BAAA;AxEuuPZ;;AwE9uPQ;EAOI,4BAAA;AxE2uPZ;;AwElvPQ;EAOI,qBAAA;AxE+uPZ;;AwEtvPQ;EAOI,2BAAA;AxEmvPZ;;AwE1vPQ;EAOI,0BAAA;AxEuvPZ;;AwE9vPQ;EAOI,wBAAA;AxE2vPZ;;AwElwPQ;EAOI,0BAAA;AxE+vPZ;;AwEtwPQ;EAOI,wBAAA;AxEmwPZ;;AwE1wPQ;EAOI,2BAAA;EAAA,0BAAA;AxEwwPZ;;AwE/wPQ;EAOI,iCAAA;EAAA,gCAAA;AxE6wPZ;;AwEpxPQ;EAOI,gCAAA;EAAA,+BAAA;AxEkxPZ;;AwEzxPQ;EAOI,8BAAA;EAAA,6BAAA;AxEuxPZ;;AwE9xPQ;EAOI,gCAAA;EAAA,+BAAA;AxE4xPZ;;AwEnyPQ;EAOI,8BAAA;EAAA,6BAAA;AxEiyPZ;;AwExyPQ;EAOI,yBAAA;EAAA,4BAAA;AxEsyPZ;;AwE7yPQ;EAOI,+BAAA;EAAA,kCAAA;AxE2yPZ;;AwElzPQ;EAOI,8BAAA;EAAA,iCAAA;AxEgzPZ;;AwEvzPQ;EAOI,4BAAA;EAAA,+BAAA;AxEqzPZ;;AwE5zPQ;EAOI,8BAAA;EAAA,iCAAA;AxE0zPZ;;AwEj0PQ;EAOI,4BAAA;EAAA,+BAAA;AxE+zPZ;;AwEt0PQ;EAOI,yBAAA;AxEm0PZ;;AwE10PQ;EAOI,+BAAA;AxEu0PZ;;AwE90PQ;EAOI,8BAAA;AxE20PZ;;AwEl1PQ;EAOI,4BAAA;AxE+0PZ;;AwEt1PQ;EAOI,8BAAA;AxEm1PZ;;AwE11PQ;EAOI,4BAAA;AxEu1PZ;;AwE91PQ;EAOI,2BAAA;AxE21PZ;;AwEl2PQ;EAOI,iCAAA;AxE+1PZ;;AwEt2PQ;EAOI,gCAAA;AxEm2PZ;;AwE12PQ;EAOI,8BAAA;AxEu2PZ;;AwE92PQ;EAOI,gCAAA;AxE22PZ;;AwEl3PQ;EAOI,8BAAA;AxE+2PZ;;AwEt3PQ;EAOI,4BAAA;AxEm3PZ;;AwE13PQ;EAOI,kCAAA;AxEu3PZ;;AwE93PQ;EAOI,iCAAA;AxE23PZ;;AwEl4PQ;EAOI,+BAAA;AxE+3PZ;;AwEt4PQ;EAOI,iCAAA;AxEm4PZ;;AwE14PQ;EAOI,+BAAA;AxEu4PZ;;AwE94PQ;EAOI,0BAAA;AxE24PZ;;AwEl5PQ;EAOI,gCAAA;AxE+4PZ;;AwEt5PQ;EAOI,+BAAA;AxEm5PZ;;AwE15PQ;EAOI,6BAAA;AxEu5PZ;;AwE95PQ;EAOI,+BAAA;AxE25PZ;;AwEl6PQ;EAOI,6BAAA;AxE+5PZ;;AwEt6PQ;EAOI,iBAAA;AxEm6PZ;;AwE16PQ;EAOI,uBAAA;AxEu6PZ;;AwE96PQ;EAOI,sBAAA;AxE26PZ;;AwEl7PQ;EAOI,oBAAA;AxE+6PZ;;AwEt7PQ;EAOI,sBAAA;AxEm7PZ;;AwE17PQ;EAOI,oBAAA;AxEu7PZ;;AwE97PQ;EAOI,qBAAA;AxE27PZ;;AwEl8PQ;EAOI,2BAAA;AxE+7PZ;;AwEt8PQ;EAOI,0BAAA;AxEm8PZ;;AwE18PQ;EAOI,wBAAA;AxEu8PZ;;AwE98PQ;EAOI,0BAAA;AxE28PZ;;AwEl9PQ;EAOI,wBAAA;AxE+8PZ;;AwEt9PQ;EAOI,wBAAA;AxEm9PZ;;AwE19PQ;EAOI,8BAAA;AxEu9PZ;;AwE99PQ;EAOI,6BAAA;AxE29PZ;;AwEl+PQ;EAOI,2BAAA;AxE+9PZ;;AwEt+PQ;EAOI,6BAAA;AxEm+PZ;;AwE1+PQ;EAOI,2BAAA;AxEu+PZ;;AwE9+PQ;EAOI,gDAAA;AxE2+PZ;;AwEl/PQ;EAOI,4CAAA;AxE++PZ;;AwEt/PQ;EAOI,4CAAA;AxEm/PZ;;AwE1/PQ;EAOI,0CAAA;AxEu/PZ;;AwE9/PQ;EAOI,4CAAA;AxE2/PZ;;AwElgQQ;EAOI,6BAAA;AxE+/PZ;;AwEtgQQ;EAOI,0BAAA;AxEmgQZ;;AwE1gQQ;EAOI,6BAAA;AxEugQZ;;AwE9gQQ;EAOI,6BAAA;AxE2gQZ;;AwElhQQ;EAOI,+BAAA;AxE+gQZ;;AwEthQQ;EAOI,2BAAA;AxEmhQZ;;AwE1hQQ;EAOI,2BAAA;AxEuhQZ;;AwE9hQQ;EAOI,2BAAA;AxE2hQZ;;AwEliQQ;EAOI,2BAAA;AxE+hQZ;;AwEtiQQ;EAOI,2BAAA;AxEmiQZ;;AwE1iQQ;EAOI,8BAAA;AxEuiQZ;;AwE9iQQ;EAOI,yBAAA;AxE2iQZ;;AwEljQQ;EAOI,4BAAA;AxE+iQZ;;AwEtjQQ;EAOI,2BAAA;AxEmjQZ;;AwE1jQQ;EAOI,yBAAA;AxEujQZ;;AwE9jQQ;EAOI,2BAAA;AxE2jQZ;;AwElkQQ;EAOI,4BAAA;AxE+jQZ;;AwEtkQQ;EAOI,6BAAA;AxEmkQZ;;AwE1kQQ;EAOI,gCAAA;AxEukQZ;;AwE9kQQ;EAOI,qCAAA;AxE2kQZ;;AwEllQQ;EAOI,wCAAA;AxE+kQZ;;AwEtlQQ;EAOI,oCAAA;AxEmlQZ;;AwE1lQQ;EAOI,oCAAA;AxEulQZ;;AwE9lQQ;EAOI,qCAAA;AxE2lQZ;;AwElmQQ;EAOI,8BAAA;AxE+lQZ;;AwEtmQQ;EAOI,8BAAA;AxEmmQZ;;AwExnQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxEymQZ;;AwEtlQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AxE+mQZ;;AwEtnQQ;EAIQ,oBAAA;EAGJ,uEAAA;AxEonQZ;;AwE3nQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEynQZ;;AwEhoQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxE8nQZ;;AwEroQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEmoQZ;;AwE1oQQ;EAIQ,oBAAA;EAGJ,oEAAA;AxEwoQZ;;AwE/oQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE6oQZ;;AwEppQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEkpQZ;;AwEzpQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEupQZ;;AwE9pQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE4pQZ;;AwEnqQQ;EAIQ,oBAAA;EAGJ,wEAAA;AxEiqQZ;;AwExqQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEsqQZ;;AwE7qQQ;EAIQ,oBAAA;EAGJ,oCAAA;AxE2qQZ;;AwElrQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEgrQZ;;AwEvrQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEqrQZ;;AwE5rQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE0rQZ;;AwEjsQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE+rQZ;;AwEtsQQ;EAIQ,oBAAA;EAGJ,yBAAA;AxEosQZ;;AwErtQQ;EACE,uBAAA;AxEwtQV;;AwEztQQ;EACE,sBAAA;AxE4tQV;;AwE7tQQ;EACE,uBAAA;AxEguQV;;AwEjuQQ;EACE,oBAAA;AxEouQV;;AwE3tQQ;EAOI,iDAAA;AxEwtQZ;;AwE/tQQ;EAOI,mDAAA;AxE4tQZ;;AwEnuQQ;EAOI,iDAAA;AxEguQZ;;AwEvuQQ;EAOI,8CAAA;AxEouQZ;;AwE3uQQ;EAOI,iDAAA;AxEwuQZ;;AwE/uQQ;EAOI,gDAAA;AxE4uQZ;;AwEnvQQ;EAOI,+CAAA;AxEgvQZ;;AwEvvQQ;EAOI,8CAAA;AxEovQZ;;AwErwQQ;EACE,sBAAA;AxEwwQV;;AwEpwQU;EACE,sBAAA;AxEuwQZ;;AwE7wQQ;EACE,uBAAA;AxEgxQV;;AwE5wQU;EACE,uBAAA;AxE+wQZ;;AwErxQQ;EACE,sBAAA;AxEwxQV;;AwEpxQU;EACE,sBAAA;AxEuxQZ;;AwE7xQQ;EACE,uBAAA;AxEgyQV;;AwE5xQU;EACE,uBAAA;AxE+xQZ;;AwEryQQ;EACE,oBAAA;AxEwyQV;;AwEpyQU;EACE,oBAAA;AxEuyQZ;;AwEnyQQ;EAOI,yCAAA;AxEgyQZ;;AwE3xQU;EAOI,yCAAA;AxEwxQd;;AwE3yQQ;EAOI,wCAAA;AxEwyQZ;;AwEnyQU;EAOI,wCAAA;AxEgyQd;;AwEnzQQ;EAOI,yCAAA;AxEgzQZ;;AwE3yQU;EAOI,yCAAA;AxEwyQd;;AwE3zQQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEyzQZ;;AwEh0QQ;EAIQ,8BAAA;EAGJ,iGAAA;AxE8zQZ;;AwEr0QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEm0QZ;;AwE10QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEw0QZ;;AwE/0QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE60QZ;;AwEp1QQ;EAIQ,8BAAA;EAGJ,8FAAA;AxEk1QZ;;AwEz1QQ;EAIQ,8BAAA;EAGJ,6FAAA;AxEu1QZ;;AwE91QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxE41QZ;;AwEn2QQ;EAIQ,8BAAA;EAGJ,qGAAA;AxEi2QZ;;AwEl3QQ;EACE,8BAAA;AxEq3QV;;AwEj3QU;EACE,8BAAA;AxEo3QZ;;AwE13QQ;EACE,gCAAA;AxE63QV;;AwEz3QU;EACE,gCAAA;AxE43QZ;;AwEl4QQ;EACE,iCAAA;AxEq4QV;;AwEj4QU;EACE,iCAAA;AxEo4QZ;;AwE14QQ;EACE,gCAAA;AxE64QV;;AwEz4QU;EACE,gCAAA;AxE44QZ;;AwEl5QQ;EACE,iCAAA;AxEq5QV;;AwEj5QU;EACE,iCAAA;AxEo5QZ;;AwE15QQ;EACE,8BAAA;AxE65QV;;AwEz5QU;EACE,8BAAA;AxE45QZ;;AwEx5QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEs5QZ;;AwE75QQ;EAIQ,kBAAA;EAGJ,gFAAA;AxE25QZ;;AwEl6QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEg6QZ;;AwEv6QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEq6QZ;;AwE56QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE06QZ;;AwEj7QQ;EAIQ,kBAAA;EAGJ,6EAAA;AxE+6QZ;;AwEt7QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEo7QZ;;AwE37QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEy7QZ;;AwEh8QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxE87QZ;;AwEr8QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEm8QZ;;AwE18QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEw8QZ;;AwE/8QQ;EAIQ,kBAAA;EAGJ,wCAAA;AxE68QZ;;AwEp9QQ;EAIQ,kBAAA;EAGJ,mFAAA;AxEk9QZ;;AwEz9QQ;EAIQ,kBAAA;EAGJ,kFAAA;AxEu9QZ;;AwEx+QQ;EACE,oBAAA;AxE2+QV;;AwE5+QQ;EACE,qBAAA;AxE++QV;;AwEh/QQ;EACE,oBAAA;AxEm/QV;;AwEp/QQ;EACE,qBAAA;AxEu/QV;;AwEx/QQ;EACE,kBAAA;AxE2/QV;;AwEl/QQ;EAOI,wDAAA;AxE++QZ;;AwEt/QQ;EAOI,0DAAA;AxEm/QZ;;AwE1/QQ;EAOI,wDAAA;AxEu/QZ;;AwE9/QQ;EAOI,qDAAA;AxE2/QZ;;AwElgRQ;EAOI,wDAAA;AxE+/QZ;;AwEtgRQ;EAOI,uDAAA;AxEmgRZ;;AwE1gRQ;EAOI,sDAAA;AxEugRZ;;AwE9gRQ;EAOI,qDAAA;AxE2gRZ;;AwElhRQ;EAOI,+CAAA;AxE+gRZ;;AwEthRQ;EAOI,mCAAA;UAAA,2BAAA;AxEmhRZ;;AwE1hRQ;EAOI,oCAAA;UAAA,4BAAA;AxEuhRZ;;AwE9hRQ;EAOI,oCAAA;UAAA,4BAAA;AxE2hRZ;;AwEliRQ;EAOI,+BAAA;AxE+hRZ;;AwEtiRQ;EAOI,+BAAA;AxEmiRZ;;AwE1iRQ;EAOI,iDAAA;AxEuiRZ;;AwE9iRQ;EAOI,2BAAA;AxE2iRZ;;AwEljRQ;EAOI,oDAAA;AxE+iRZ;;AwEtjRQ;EAOI,iDAAA;AxEmjRZ;;AwE1jRQ;EAOI,oDAAA;AxEujRZ;;AwE9jRQ;EAOI,oDAAA;AxE2jRZ;;AwElkRQ;EAOI,qDAAA;AxE+jRZ;;AwEtkRQ;EAOI,6BAAA;AxEmkRZ;;AwE1kRQ;EAOI,sDAAA;AxEukRZ;;AwE9kRQ;EAOI,0DAAA;EAAA,2DAAA;AxE4kRZ;;AwEnlRQ;EAOI,oCAAA;EAAA,qCAAA;AxEilRZ;;AwExlRQ;EAOI,6DAAA;EAAA,8DAAA;AxEslRZ;;AwE7lRQ;EAOI,0DAAA;EAAA,2DAAA;AxE2lRZ;;AwElmRQ;EAOI,6DAAA;EAAA,8DAAA;AxEgmRZ;;AwEvmRQ;EAOI,6DAAA;EAAA,8DAAA;AxEqmRZ;;AwE5mRQ;EAOI,8DAAA;EAAA,+DAAA;AxE0mRZ;;AwEjnRQ;EAOI,sCAAA;EAAA,uCAAA;AxE+mRZ;;AwEtnRQ;EAOI,+DAAA;EAAA,gEAAA;AxEonRZ;;AwE3nRQ;EAOI,2DAAA;EAAA,8DAAA;AxEynRZ;;AwEhoRQ;EAOI,qCAAA;EAAA,wCAAA;AxE8nRZ;;AwEroRQ;EAOI,8DAAA;EAAA,iEAAA;AxEmoRZ;;AwE1oRQ;EAOI,2DAAA;EAAA,8DAAA;AxEwoRZ;;AwE/oRQ;EAOI,8DAAA;EAAA,iEAAA;AxE6oRZ;;AwEppRQ;EAOI,8DAAA;EAAA,iEAAA;AxEkpRZ;;AwEzpRQ;EAOI,+DAAA;EAAA,kEAAA;AxEupRZ;;AwE9pRQ;EAOI,uCAAA;EAAA,0CAAA;AxE4pRZ;;AwEnqRQ;EAOI,gEAAA;EAAA,mEAAA;AxEiqRZ;;AwExqRQ;EAOI,8DAAA;EAAA,6DAAA;AxEsqRZ;;AwE7qRQ;EAOI,wCAAA;EAAA,uCAAA;AxE2qRZ;;AwElrRQ;EAOI,iEAAA;EAAA,gEAAA;AxEgrRZ;;AwEvrRQ;EAOI,8DAAA;EAAA,6DAAA;AxEqrRZ;;AwE5rRQ;EAOI,iEAAA;EAAA,gEAAA;AxE0rRZ;;AwEjsRQ;EAOI,iEAAA;EAAA,gEAAA;AxE+rRZ;;AwEtsRQ;EAOI,kEAAA;EAAA,iEAAA;AxEosRZ;;AwE3sRQ;EAOI,0CAAA;EAAA,yCAAA;AxEysRZ;;AwEhtRQ;EAOI,mEAAA;EAAA,kEAAA;AxE8sRZ;;AwErtRQ;EAOI,6DAAA;EAAA,0DAAA;AxEmtRZ;;AwE1tRQ;EAOI,uCAAA;EAAA,oCAAA;AxEwtRZ;;AwE/tRQ;EAOI,gEAAA;EAAA,6DAAA;AxE6tRZ;;AwEpuRQ;EAOI,6DAAA;EAAA,0DAAA;AxEkuRZ;;AwEzuRQ;EAOI,gEAAA;EAAA,6DAAA;AxEuuRZ;;AwE9uRQ;EAOI,gEAAA;EAAA,6DAAA;AxE4uRZ;;AwEnvRQ;EAOI,iEAAA;EAAA,8DAAA;AxEivRZ;;AwExvRQ;EAOI,yCAAA;EAAA,sCAAA;AxEsvRZ;;AwE7vRQ;EAOI,kEAAA;EAAA,+DAAA;AxE2vRZ;;AwElwRQ;EAOI,8BAAA;AxE+vRZ;;AwEtwRQ;EAOI,6BAAA;AxEmwRZ;;AwE1wRQ;EAOI,sBAAA;AxEuwRZ;;AwE9wRQ;EAOI,qBAAA;AxE2wRZ;;AwElxRQ;EAOI,qBAAA;AxE+wRZ;;AwEtxRQ;EAOI,qBAAA;AxEmxRZ;;AwE1xRQ;EAOI,qBAAA;AxEuxRZ;;AcjyRI;E0DGI;IAOI,sBAAA;ExE4xRV;EwEnyRM;IAOI,uBAAA;ExE+xRV;EwEtyRM;IAOI,sBAAA;ExEkyRV;EwEzyRM;IAOI,8BAAA;ExEqyRV;EwE5yRM;IAOI,4BAAA;ExEwyRV;EwE/yRM;IAOI,2BAAA;ExE2yRV;EwElzRM;IAOI,iCAAA;ExE8yRV;EwErzRM;IAOI,2BAAA;ExEizRV;EwExzRM;IAOI,0BAAA;ExEozRV;EwE3zRM;IAOI,gCAAA;ExEuzRV;EwE9zRM;IAOI,yBAAA;ExE0zRV;EwEj0RM;IAOI,wBAAA;ExE6zRV;EwEp0RM;IAOI,+BAAA;ExEg0RV;EwEv0RM;IAOI,yBAAA;ExEm0RV;EwE10RM;IAOI,6BAAA;ExEs0RV;EwE70RM;IAOI,8BAAA;ExEy0RV;EwEh1RM;IAOI,wBAAA;ExE40RV;EwEn1RM;IAOI,+BAAA;ExE+0RV;EwEt1RM;IAOI,wBAAA;ExEk1RV;EwEz1RM;IAOI,yBAAA;ExEq1RV;EwE51RM;IAOI,8BAAA;ExEw1RV;EwE/1RM;IAOI,iCAAA;ExE21RV;EwEl2RM;IAOI,sCAAA;ExE81RV;EwEr2RM;IAOI,yCAAA;ExEi2RV;EwEx2RM;IAOI,uBAAA;ExEo2RV;EwE32RM;IAOI,uBAAA;ExEu2RV;EwE92RM;IAOI,yBAAA;ExE02RV;EwEj3RM;IAOI,yBAAA;ExE62RV;EwEp3RM;IAOI,0BAAA;ExEg3RV;EwEv3RM;IAOI,4BAAA;ExEm3RV;EwE13RM;IAOI,kCAAA;ExEs3RV;EwE73RM;IAOI,sCAAA;ExEy3RV;EwEh4RM;IAOI,oCAAA;ExE43RV;EwEn4RM;IAOI,kCAAA;ExE+3RV;EwEt4RM;IAOI,yCAAA;ExEk4RV;EwEz4RM;IAOI,wCAAA;ExEq4RV;EwE54RM;IAOI,wCAAA;ExEw4RV;EwE/4RM;IAOI,kCAAA;ExE24RV;EwEl5RM;IAOI,gCAAA;ExE84RV;EwEr5RM;IAOI,8BAAA;ExEi5RV;EwEx5RM;IAOI,gCAAA;ExEo5RV;EwE35RM;IAOI,+BAAA;ExEu5RV;EwE95RM;IAOI,oCAAA;ExE05RV;EwEj6RM;IAOI,kCAAA;ExE65RV;EwEp6RM;IAOI,gCAAA;ExEg6RV;EwEv6RM;IAOI,uCAAA;ExEm6RV;EwE16RM;IAOI,sCAAA;ExEs6RV;EwE76RM;IAOI,iCAAA;ExEy6RV;EwEh7RM;IAOI,2BAAA;ExE46RV;EwEn7RM;IAOI,iCAAA;ExE+6RV;EwEt7RM;IAOI,+BAAA;ExEk7RV;EwEz7RM;IAOI,6BAAA;ExEq7RV;EwE57RM;IAOI,+BAAA;ExEw7RV;EwE/7RM;IAOI,8BAAA;ExE27RV;EwEl8RM;IAOI,oBAAA;ExE87RV;EwEr8RM;IAOI,mBAAA;ExEi8RV;EwEx8RM;IAOI,mBAAA;ExEo8RV;EwE38RM;IAOI,mBAAA;ExEu8RV;EwE98RM;IAOI,mBAAA;ExE08RV;EwEj9RM;IAOI,mBAAA;ExE68RV;EwEp9RM;IAOI,mBAAA;ExEg9RV;EwEv9RM;IAOI,mBAAA;ExEm9RV;EwE19RM;IAOI,oBAAA;ExEs9RV;EwE79RM;IAOI,0BAAA;ExEy9RV;EwEh+RM;IAOI,yBAAA;ExE49RV;EwEn+RM;IAOI,uBAAA;ExE+9RV;EwEt+RM;IAOI,yBAAA;ExEk+RV;EwEz+RM;IAOI,uBAAA;ExEq+RV;EwE5+RM;IAOI,uBAAA;ExEw+RV;EwE/+RM;IAOI,0BAAA;IAAA,yBAAA;ExE4+RV;EwEn/RM;IAOI,gCAAA;IAAA,+BAAA;ExEg/RV;EwEv/RM;IAOI,+BAAA;IAAA,8BAAA;ExEo/RV;EwE3/RM;IAOI,6BAAA;IAAA,4BAAA;ExEw/RV;EwE//RM;IAOI,+BAAA;IAAA,8BAAA;ExE4/RV;EwEngSM;IAOI,6BAAA;IAAA,4BAAA;ExEggSV;EwEvgSM;IAOI,6BAAA;IAAA,4BAAA;ExEogSV;EwE3gSM;IAOI,wBAAA;IAAA,2BAAA;ExEwgSV;EwE/gSM;IAOI,8BAAA;IAAA,iCAAA;ExE4gSV;EwEnhSM;IAOI,6BAAA;IAAA,gCAAA;ExEghSV;EwEvhSM;IAOI,2BAAA;IAAA,8BAAA;ExEohSV;EwE3hSM;IAOI,6BAAA;IAAA,gCAAA;ExEwhSV;EwE/hSM;IAOI,2BAAA;IAAA,8BAAA;ExE4hSV;EwEniSM;IAOI,2BAAA;IAAA,8BAAA;ExEgiSV;EwEviSM;IAOI,wBAAA;ExEmiSV;EwE1iSM;IAOI,8BAAA;ExEsiSV;EwE7iSM;IAOI,6BAAA;ExEyiSV;EwEhjSM;IAOI,2BAAA;ExE4iSV;EwEnjSM;IAOI,6BAAA;ExE+iSV;EwEtjSM;IAOI,2BAAA;ExEkjSV;EwEzjSM;IAOI,2BAAA;ExEqjSV;EwE5jSM;IAOI,0BAAA;ExEwjSV;EwE/jSM;IAOI,gCAAA;ExE2jSV;EwElkSM;IAOI,+BAAA;ExE8jSV;EwErkSM;IAOI,6BAAA;ExEikSV;EwExkSM;IAOI,+BAAA;ExEokSV;EwE3kSM;IAOI,6BAAA;ExEukSV;EwE9kSM;IAOI,6BAAA;ExE0kSV;EwEjlSM;IAOI,2BAAA;ExE6kSV;EwEplSM;IAOI,iCAAA;ExEglSV;EwEvlSM;IAOI,gCAAA;ExEmlSV;EwE1lSM;IAOI,8BAAA;ExEslSV;EwE7lSM;IAOI,gCAAA;ExEylSV;EwEhmSM;IAOI,8BAAA;ExE4lSV;EwEnmSM;IAOI,8BAAA;ExE+lSV;EwEtmSM;IAOI,yBAAA;ExEkmSV;EwEzmSM;IAOI,+BAAA;ExEqmSV;EwE5mSM;IAOI,8BAAA;ExEwmSV;EwE/mSM;IAOI,4BAAA;ExE2mSV;EwElnSM;IAOI,8BAAA;ExE8mSV;EwErnSM;IAOI,4BAAA;ExEinSV;EwExnSM;IAOI,4BAAA;ExEonSV;EwE3nSM;IAOI,qBAAA;ExEunSV;EwE9nSM;IAOI,2BAAA;ExE0nSV;EwEjoSM;IAOI,0BAAA;ExE6nSV;EwEpoSM;IAOI,wBAAA;ExEgoSV;EwEvoSM;IAOI,0BAAA;ExEmoSV;EwE1oSM;IAOI,wBAAA;ExEsoSV;EwE7oSM;IAOI,2BAAA;IAAA,0BAAA;ExE0oSV;EwEjpSM;IAOI,iCAAA;IAAA,gCAAA;ExE8oSV;EwErpSM;IAOI,gCAAA;IAAA,+BAAA;ExEkpSV;EwEzpSM;IAOI,8BAAA;IAAA,6BAAA;ExEspSV;EwE7pSM;IAOI,gCAAA;IAAA,+BAAA;ExE0pSV;EwEjqSM;IAOI,8BAAA;IAAA,6BAAA;ExE8pSV;EwErqSM;IAOI,yBAAA;IAAA,4BAAA;ExEkqSV;EwEzqSM;IAOI,+BAAA;IAAA,kCAAA;ExEsqSV;EwE7qSM;IAOI,8BAAA;IAAA,iCAAA;ExE0qSV;EwEjrSM;IAOI,4BAAA;IAAA,+BAAA;ExE8qSV;EwErrSM;IAOI,8BAAA;IAAA,iCAAA;ExEkrSV;EwEzrSM;IAOI,4BAAA;IAAA,+BAAA;ExEsrSV;EwE7rSM;IAOI,yBAAA;ExEyrSV;EwEhsSM;IAOI,+BAAA;ExE4rSV;EwEnsSM;IAOI,8BAAA;ExE+rSV;EwEtsSM;IAOI,4BAAA;ExEksSV;EwEzsSM;IAOI,8BAAA;ExEqsSV;EwE5sSM;IAOI,4BAAA;ExEwsSV;EwE/sSM;IAOI,2BAAA;ExE2sSV;EwEltSM;IAOI,iCAAA;ExE8sSV;EwErtSM;IAOI,gCAAA;ExEitSV;EwExtSM;IAOI,8BAAA;ExEotSV;EwE3tSM;IAOI,gCAAA;ExEutSV;EwE9tSM;IAOI,8BAAA;ExE0tSV;EwEjuSM;IAOI,4BAAA;ExE6tSV;EwEpuSM;IAOI,kCAAA;ExEguSV;EwEvuSM;IAOI,iCAAA;ExEmuSV;EwE1uSM;IAOI,+BAAA;ExEsuSV;EwE7uSM;IAOI,iCAAA;ExEyuSV;EwEhvSM;IAOI,+BAAA;ExE4uSV;EwEnvSM;IAOI,0BAAA;ExE+uSV;EwEtvSM;IAOI,gCAAA;ExEkvSV;EwEzvSM;IAOI,+BAAA;ExEqvSV;EwE5vSM;IAOI,6BAAA;ExEwvSV;EwE/vSM;IAOI,+BAAA;ExE2vSV;EwElwSM;IAOI,6BAAA;ExE8vSV;EwErwSM;IAOI,iBAAA;ExEiwSV;EwExwSM;IAOI,uBAAA;ExEowSV;EwE3wSM;IAOI,sBAAA;ExEuwSV;EwE9wSM;IAOI,oBAAA;ExE0wSV;EwEjxSM;IAOI,sBAAA;ExE6wSV;EwEpxSM;IAOI,oBAAA;ExEgxSV;EwEvxSM;IAOI,qBAAA;ExEmxSV;EwE1xSM;IAOI,2BAAA;ExEsxSV;EwE7xSM;IAOI,0BAAA;ExEyxSV;EwEhySM;IAOI,wBAAA;ExE4xSV;EwEnySM;IAOI,0BAAA;ExE+xSV;EwEtySM;IAOI,wBAAA;ExEkySV;EwEzySM;IAOI,wBAAA;ExEqySV;EwE5ySM;IAOI,8BAAA;ExEwySV;EwE/ySM;IAOI,6BAAA;ExE2ySV;EwElzSM;IAOI,2BAAA;ExE8ySV;EwErzSM;IAOI,6BAAA;ExEizSV;EwExzSM;IAOI,2BAAA;ExEozSV;EwE3zSM;IAOI,2BAAA;ExEuzSV;EwE9zSM;IAOI,4BAAA;ExE0zSV;EwEj0SM;IAOI,6BAAA;ExE6zSV;AACF;Acx0SI;E0DGI;IAOI,sBAAA;ExEk0SV;EwEz0SM;IAOI,uBAAA;ExEq0SV;EwE50SM;IAOI,sBAAA;ExEw0SV;EwE/0SM;IAOI,8BAAA;ExE20SV;EwEl1SM;IAOI,4BAAA;ExE80SV;EwEr1SM;IAOI,2BAAA;ExEi1SV;EwEx1SM;IAOI,iCAAA;ExEo1SV;EwE31SM;IAOI,2BAAA;ExEu1SV;EwE91SM;IAOI,0BAAA;ExE01SV;EwEj2SM;IAOI,gCAAA;ExE61SV;EwEp2SM;IAOI,yBAAA;ExEg2SV;EwEv2SM;IAOI,wBAAA;ExEm2SV;EwE12SM;IAOI,+BAAA;ExEs2SV;EwE72SM;IAOI,yBAAA;ExEy2SV;EwEh3SM;IAOI,6BAAA;ExE42SV;EwEn3SM;IAOI,8BAAA;ExE+2SV;EwEt3SM;IAOI,wBAAA;ExEk3SV;EwEz3SM;IAOI,+BAAA;ExEq3SV;EwE53SM;IAOI,wBAAA;ExEw3SV;EwE/3SM;IAOI,yBAAA;ExE23SV;EwEl4SM;IAOI,8BAAA;ExE83SV;EwEr4SM;IAOI,iCAAA;ExEi4SV;EwEx4SM;IAOI,sCAAA;ExEo4SV;EwE34SM;IAOI,yCAAA;ExEu4SV;EwE94SM;IAOI,uBAAA;ExE04SV;EwEj5SM;IAOI,uBAAA;ExE64SV;EwEp5SM;IAOI,yBAAA;ExEg5SV;EwEv5SM;IAOI,yBAAA;ExEm5SV;EwE15SM;IAOI,0BAAA;ExEs5SV;EwE75SM;IAOI,4BAAA;ExEy5SV;EwEh6SM;IAOI,kCAAA;ExE45SV;EwEn6SM;IAOI,sCAAA;ExE+5SV;EwEt6SM;IAOI,oCAAA;ExEk6SV;EwEz6SM;IAOI,kCAAA;ExEq6SV;EwE56SM;IAOI,yCAAA;ExEw6SV;EwE/6SM;IAOI,wCAAA;ExE26SV;EwEl7SM;IAOI,wCAAA;ExE86SV;EwEr7SM;IAOI,kCAAA;ExEi7SV;EwEx7SM;IAOI,gCAAA;ExEo7SV;EwE37SM;IAOI,8BAAA;ExEu7SV;EwE97SM;IAOI,gCAAA;ExE07SV;EwEj8SM;IAOI,+BAAA;ExE67SV;EwEp8SM;IAOI,oCAAA;ExEg8SV;EwEv8SM;IAOI,kCAAA;ExEm8SV;EwE18SM;IAOI,gCAAA;ExEs8SV;EwE78SM;IAOI,uCAAA;ExEy8SV;EwEh9SM;IAOI,sCAAA;ExE48SV;EwEn9SM;IAOI,iCAAA;ExE+8SV;EwEt9SM;IAOI,2BAAA;ExEk9SV;EwEz9SM;IAOI,iCAAA;ExEq9SV;EwE59SM;IAOI,+BAAA;ExEw9SV;EwE/9SM;IAOI,6BAAA;ExE29SV;EwEl+SM;IAOI,+BAAA;ExE89SV;EwEr+SM;IAOI,8BAAA;ExEi+SV;EwEx+SM;IAOI,oBAAA;ExEo+SV;EwE3+SM;IAOI,mBAAA;ExEu+SV;EwE9+SM;IAOI,mBAAA;ExE0+SV;EwEj/SM;IAOI,mBAAA;ExE6+SV;EwEp/SM;IAOI,mBAAA;ExEg/SV;EwEv/SM;IAOI,mBAAA;ExEm/SV;EwE1/SM;IAOI,mBAAA;ExEs/SV;EwE7/SM;IAOI,mBAAA;ExEy/SV;EwEhgTM;IAOI,oBAAA;ExE4/SV;EwEngTM;IAOI,0BAAA;ExE+/SV;EwEtgTM;IAOI,yBAAA;ExEkgTV;EwEzgTM;IAOI,uBAAA;ExEqgTV;EwE5gTM;IAOI,yBAAA;ExEwgTV;EwE/gTM;IAOI,uBAAA;ExE2gTV;EwElhTM;IAOI,uBAAA;ExE8gTV;EwErhTM;IAOI,0BAAA;IAAA,yBAAA;ExEkhTV;EwEzhTM;IAOI,gCAAA;IAAA,+BAAA;ExEshTV;EwE7hTM;IAOI,+BAAA;IAAA,8BAAA;ExE0hTV;EwEjiTM;IAOI,6BAAA;IAAA,4BAAA;ExE8hTV;EwEriTM;IAOI,+BAAA;IAAA,8BAAA;ExEkiTV;EwEziTM;IAOI,6BAAA;IAAA,4BAAA;ExEsiTV;EwE7iTM;IAOI,6BAAA;IAAA,4BAAA;ExE0iTV;EwEjjTM;IAOI,wBAAA;IAAA,2BAAA;ExE8iTV;EwErjTM;IAOI,8BAAA;IAAA,iCAAA;ExEkjTV;EwEzjTM;IAOI,6BAAA;IAAA,gCAAA;ExEsjTV;EwE7jTM;IAOI,2BAAA;IAAA,8BAAA;ExE0jTV;EwEjkTM;IAOI,6BAAA;IAAA,gCAAA;ExE8jTV;EwErkTM;IAOI,2BAAA;IAAA,8BAAA;ExEkkTV;EwEzkTM;IAOI,2BAAA;IAAA,8BAAA;ExEskTV;EwE7kTM;IAOI,wBAAA;ExEykTV;EwEhlTM;IAOI,8BAAA;ExE4kTV;EwEnlTM;IAOI,6BAAA;ExE+kTV;EwEtlTM;IAOI,2BAAA;ExEklTV;EwEzlTM;IAOI,6BAAA;ExEqlTV;EwE5lTM;IAOI,2BAAA;ExEwlTV;EwE/lTM;IAOI,2BAAA;ExE2lTV;EwElmTM;IAOI,0BAAA;ExE8lTV;EwErmTM;IAOI,gCAAA;ExEimTV;EwExmTM;IAOI,+BAAA;ExEomTV;EwE3mTM;IAOI,6BAAA;ExEumTV;EwE9mTM;IAOI,+BAAA;ExE0mTV;EwEjnTM;IAOI,6BAAA;ExE6mTV;EwEpnTM;IAOI,6BAAA;ExEgnTV;EwEvnTM;IAOI,2BAAA;ExEmnTV;EwE1nTM;IAOI,iCAAA;ExEsnTV;EwE7nTM;IAOI,gCAAA;ExEynTV;EwEhoTM;IAOI,8BAAA;ExE4nTV;EwEnoTM;IAOI,gCAAA;ExE+nTV;EwEtoTM;IAOI,8BAAA;ExEkoTV;EwEzoTM;IAOI,8BAAA;ExEqoTV;EwE5oTM;IAOI,yBAAA;ExEwoTV;EwE/oTM;IAOI,+BAAA;ExE2oTV;EwElpTM;IAOI,8BAAA;ExE8oTV;EwErpTM;IAOI,4BAAA;ExEipTV;EwExpTM;IAOI,8BAAA;ExEopTV;EwE3pTM;IAOI,4BAAA;ExEupTV;EwE9pTM;IAOI,4BAAA;ExE0pTV;EwEjqTM;IAOI,qBAAA;ExE6pTV;EwEpqTM;IAOI,2BAAA;ExEgqTV;EwEvqTM;IAOI,0BAAA;ExEmqTV;EwE1qTM;IAOI,wBAAA;ExEsqTV;EwE7qTM;IAOI,0BAAA;ExEyqTV;EwEhrTM;IAOI,wBAAA;ExE4qTV;EwEnrTM;IAOI,2BAAA;IAAA,0BAAA;ExEgrTV;EwEvrTM;IAOI,iCAAA;IAAA,gCAAA;ExEorTV;EwE3rTM;IAOI,gCAAA;IAAA,+BAAA;ExEwrTV;EwE/rTM;IAOI,8BAAA;IAAA,6BAAA;ExE4rTV;EwEnsTM;IAOI,gCAAA;IAAA,+BAAA;ExEgsTV;EwEvsTM;IAOI,8BAAA;IAAA,6BAAA;ExEosTV;EwE3sTM;IAOI,yBAAA;IAAA,4BAAA;ExEwsTV;EwE/sTM;IAOI,+BAAA;IAAA,kCAAA;ExE4sTV;EwEntTM;IAOI,8BAAA;IAAA,iCAAA;ExEgtTV;EwEvtTM;IAOI,4BAAA;IAAA,+BAAA;ExEotTV;EwE3tTM;IAOI,8BAAA;IAAA,iCAAA;ExEwtTV;EwE/tTM;IAOI,4BAAA;IAAA,+BAAA;ExE4tTV;EwEnuTM;IAOI,yBAAA;ExE+tTV;EwEtuTM;IAOI,+BAAA;ExEkuTV;EwEzuTM;IAOI,8BAAA;ExEquTV;EwE5uTM;IAOI,4BAAA;ExEwuTV;EwE/uTM;IAOI,8BAAA;ExE2uTV;EwElvTM;IAOI,4BAAA;ExE8uTV;EwErvTM;IAOI,2BAAA;ExEivTV;EwExvTM;IAOI,iCAAA;ExEovTV;EwE3vTM;IAOI,gCAAA;ExEuvTV;EwE9vTM;IAOI,8BAAA;ExE0vTV;EwEjwTM;IAOI,gCAAA;ExE6vTV;EwEpwTM;IAOI,8BAAA;ExEgwTV;EwEvwTM;IAOI,4BAAA;ExEmwTV;EwE1wTM;IAOI,kCAAA;ExEswTV;EwE7wTM;IAOI,iCAAA;ExEywTV;EwEhxTM;IAOI,+BAAA;ExE4wTV;EwEnxTM;IAOI,iCAAA;ExE+wTV;EwEtxTM;IAOI,+BAAA;ExEkxTV;EwEzxTM;IAOI,0BAAA;ExEqxTV;EwE5xTM;IAOI,gCAAA;ExEwxTV;EwE/xTM;IAOI,+BAAA;ExE2xTV;EwElyTM;IAOI,6BAAA;ExE8xTV;EwEryTM;IAOI,+BAAA;ExEiyTV;EwExyTM;IAOI,6BAAA;ExEoyTV;EwE3yTM;IAOI,iBAAA;ExEuyTV;EwE9yTM;IAOI,uBAAA;ExE0yTV;EwEjzTM;IAOI,sBAAA;ExE6yTV;EwEpzTM;IAOI,oBAAA;ExEgzTV;EwEvzTM;IAOI,sBAAA;ExEmzTV;EwE1zTM;IAOI,oBAAA;ExEszTV;EwE7zTM;IAOI,qBAAA;ExEyzTV;EwEh0TM;IAOI,2BAAA;ExE4zTV;EwEn0TM;IAOI,0BAAA;ExE+zTV;EwEt0TM;IAOI,wBAAA;ExEk0TV;EwEz0TM;IAOI,0BAAA;ExEq0TV;EwE50TM;IAOI,wBAAA;ExEw0TV;EwE/0TM;IAOI,wBAAA;ExE20TV;EwEl1TM;IAOI,8BAAA;ExE80TV;EwEr1TM;IAOI,6BAAA;ExEi1TV;EwEx1TM;IAOI,2BAAA;ExEo1TV;EwE31TM;IAOI,6BAAA;ExEu1TV;EwE91TM;IAOI,2BAAA;ExE01TV;EwEj2TM;IAOI,2BAAA;ExE61TV;EwEp2TM;IAOI,4BAAA;ExEg2TV;EwEv2TM;IAOI,6BAAA;ExEm2TV;AACF;Ac92TI;E0DGI;IAOI,sBAAA;ExEw2TV;EwE/2TM;IAOI,uBAAA;ExE22TV;EwEl3TM;IAOI,sBAAA;ExE82TV;EwEr3TM;IAOI,8BAAA;ExEi3TV;EwEx3TM;IAOI,4BAAA;ExEo3TV;EwE33TM;IAOI,2BAAA;ExEu3TV;EwE93TM;IAOI,iCAAA;ExE03TV;EwEj4TM;IAOI,2BAAA;ExE63TV;EwEp4TM;IAOI,0BAAA;ExEg4TV;EwEv4TM;IAOI,gCAAA;ExEm4TV;EwE14TM;IAOI,yBAAA;ExEs4TV;EwE74TM;IAOI,wBAAA;ExEy4TV;EwEh5TM;IAOI,+BAAA;ExE44TV;EwEn5TM;IAOI,yBAAA;ExE+4TV;EwEt5TM;IAOI,6BAAA;ExEk5TV;EwEz5TM;IAOI,8BAAA;ExEq5TV;EwE55TM;IAOI,wBAAA;ExEw5TV;EwE/5TM;IAOI,+BAAA;ExE25TV;EwEl6TM;IAOI,wBAAA;ExE85TV;EwEr6TM;IAOI,yBAAA;ExEi6TV;EwEx6TM;IAOI,8BAAA;ExEo6TV;EwE36TM;IAOI,iCAAA;ExEu6TV;EwE96TM;IAOI,sCAAA;ExE06TV;EwEj7TM;IAOI,yCAAA;ExE66TV;EwEp7TM;IAOI,uBAAA;ExEg7TV;EwEv7TM;IAOI,uBAAA;ExEm7TV;EwE17TM;IAOI,yBAAA;ExEs7TV;EwE77TM;IAOI,yBAAA;ExEy7TV;EwEh8TM;IAOI,0BAAA;ExE47TV;EwEn8TM;IAOI,4BAAA;ExE+7TV;EwEt8TM;IAOI,kCAAA;ExEk8TV;EwEz8TM;IAOI,sCAAA;ExEq8TV;EwE58TM;IAOI,oCAAA;ExEw8TV;EwE/8TM;IAOI,kCAAA;ExE28TV;EwEl9TM;IAOI,yCAAA;ExE88TV;EwEr9TM;IAOI,wCAAA;ExEi9TV;EwEx9TM;IAOI,wCAAA;ExEo9TV;EwE39TM;IAOI,kCAAA;ExEu9TV;EwE99TM;IAOI,gCAAA;ExE09TV;EwEj+TM;IAOI,8BAAA;ExE69TV;EwEp+TM;IAOI,gCAAA;ExEg+TV;EwEv+TM;IAOI,+BAAA;ExEm+TV;EwE1+TM;IAOI,oCAAA;ExEs+TV;EwE7+TM;IAOI,kCAAA;ExEy+TV;EwEh/TM;IAOI,gCAAA;ExE4+TV;EwEn/TM;IAOI,uCAAA;ExE++TV;EwEt/TM;IAOI,sCAAA;ExEk/TV;EwEz/TM;IAOI,iCAAA;ExEq/TV;EwE5/TM;IAOI,2BAAA;ExEw/TV;EwE//TM;IAOI,iCAAA;ExE2/TV;EwElgUM;IAOI,+BAAA;ExE8/TV;EwErgUM;IAOI,6BAAA;ExEigUV;EwExgUM;IAOI,+BAAA;ExEogUV;EwE3gUM;IAOI,8BAAA;ExEugUV;EwE9gUM;IAOI,oBAAA;ExE0gUV;EwEjhUM;IAOI,mBAAA;ExE6gUV;EwEphUM;IAOI,mBAAA;ExEghUV;EwEvhUM;IAOI,mBAAA;ExEmhUV;EwE1hUM;IAOI,mBAAA;ExEshUV;EwE7hUM;IAOI,mBAAA;ExEyhUV;EwEhiUM;IAOI,mBAAA;ExE4hUV;EwEniUM;IAOI,mBAAA;ExE+hUV;EwEtiUM;IAOI,oBAAA;ExEkiUV;EwEziUM;IAOI,0BAAA;ExEqiUV;EwE5iUM;IAOI,yBAAA;ExEwiUV;EwE/iUM;IAOI,uBAAA;ExE2iUV;EwEljUM;IAOI,yBAAA;ExE8iUV;EwErjUM;IAOI,uBAAA;ExEijUV;EwExjUM;IAOI,uBAAA;ExEojUV;EwE3jUM;IAOI,0BAAA;IAAA,yBAAA;ExEwjUV;EwE/jUM;IAOI,gCAAA;IAAA,+BAAA;ExE4jUV;EwEnkUM;IAOI,+BAAA;IAAA,8BAAA;ExEgkUV;EwEvkUM;IAOI,6BAAA;IAAA,4BAAA;ExEokUV;EwE3kUM;IAOI,+BAAA;IAAA,8BAAA;ExEwkUV;EwE/kUM;IAOI,6BAAA;IAAA,4BAAA;ExE4kUV;EwEnlUM;IAOI,6BAAA;IAAA,4BAAA;ExEglUV;EwEvlUM;IAOI,wBAAA;IAAA,2BAAA;ExEolUV;EwE3lUM;IAOI,8BAAA;IAAA,iCAAA;ExEwlUV;EwE/lUM;IAOI,6BAAA;IAAA,gCAAA;ExE4lUV;EwEnmUM;IAOI,2BAAA;IAAA,8BAAA;ExEgmUV;EwEvmUM;IAOI,6BAAA;IAAA,gCAAA;ExEomUV;EwE3mUM;IAOI,2BAAA;IAAA,8BAAA;ExEwmUV;EwE/mUM;IAOI,2BAAA;IAAA,8BAAA;ExE4mUV;EwEnnUM;IAOI,wBAAA;ExE+mUV;EwEtnUM;IAOI,8BAAA;ExEknUV;EwEznUM;IAOI,6BAAA;ExEqnUV;EwE5nUM;IAOI,2BAAA;ExEwnUV;EwE/nUM;IAOI,6BAAA;ExE2nUV;EwEloUM;IAOI,2BAAA;ExE8nUV;EwEroUM;IAOI,2BAAA;ExEioUV;EwExoUM;IAOI,0BAAA;ExEooUV;EwE3oUM;IAOI,gCAAA;ExEuoUV;EwE9oUM;IAOI,+BAAA;ExE0oUV;EwEjpUM;IAOI,6BAAA;ExE6oUV;EwEppUM;IAOI,+BAAA;ExEgpUV;EwEvpUM;IAOI,6BAAA;ExEmpUV;EwE1pUM;IAOI,6BAAA;ExEspUV;EwE7pUM;IAOI,2BAAA;ExEypUV;EwEhqUM;IAOI,iCAAA;ExE4pUV;EwEnqUM;IAOI,gCAAA;ExE+pUV;EwEtqUM;IAOI,8BAAA;ExEkqUV;EwEzqUM;IAOI,gCAAA;ExEqqUV;EwE5qUM;IAOI,8BAAA;ExEwqUV;EwE/qUM;IAOI,8BAAA;ExE2qUV;EwElrUM;IAOI,yBAAA;ExE8qUV;EwErrUM;IAOI,+BAAA;ExEirUV;EwExrUM;IAOI,8BAAA;ExEorUV;EwE3rUM;IAOI,4BAAA;ExEurUV;EwE9rUM;IAOI,8BAAA;ExE0rUV;EwEjsUM;IAOI,4BAAA;ExE6rUV;EwEpsUM;IAOI,4BAAA;ExEgsUV;EwEvsUM;IAOI,qBAAA;ExEmsUV;EwE1sUM;IAOI,2BAAA;ExEssUV;EwE7sUM;IAOI,0BAAA;ExEysUV;EwEhtUM;IAOI,wBAAA;ExE4sUV;EwEntUM;IAOI,0BAAA;ExE+sUV;EwEttUM;IAOI,wBAAA;ExEktUV;EwEztUM;IAOI,2BAAA;IAAA,0BAAA;ExEstUV;EwE7tUM;IAOI,iCAAA;IAAA,gCAAA;ExE0tUV;EwEjuUM;IAOI,gCAAA;IAAA,+BAAA;ExE8tUV;EwEruUM;IAOI,8BAAA;IAAA,6BAAA;ExEkuUV;EwEzuUM;IAOI,gCAAA;IAAA,+BAAA;ExEsuUV;EwE7uUM;IAOI,8BAAA;IAAA,6BAAA;ExE0uUV;EwEjvUM;IAOI,yBAAA;IAAA,4BAAA;ExE8uUV;EwErvUM;IAOI,+BAAA;IAAA,kCAAA;ExEkvUV;EwEzvUM;IAOI,8BAAA;IAAA,iCAAA;ExEsvUV;EwE7vUM;IAOI,4BAAA;IAAA,+BAAA;ExE0vUV;EwEjwUM;IAOI,8BAAA;IAAA,iCAAA;ExE8vUV;EwErwUM;IAOI,4BAAA;IAAA,+BAAA;ExEkwUV;EwEzwUM;IAOI,yBAAA;ExEqwUV;EwE5wUM;IAOI,+BAAA;ExEwwUV;EwE/wUM;IAOI,8BAAA;ExE2wUV;EwElxUM;IAOI,4BAAA;ExE8wUV;EwErxUM;IAOI,8BAAA;ExEixUV;EwExxUM;IAOI,4BAAA;ExEoxUV;EwE3xUM;IAOI,2BAAA;ExEuxUV;EwE9xUM;IAOI,iCAAA;ExE0xUV;EwEjyUM;IAOI,gCAAA;ExE6xUV;EwEpyUM;IAOI,8BAAA;ExEgyUV;EwEvyUM;IAOI,gCAAA;ExEmyUV;EwE1yUM;IAOI,8BAAA;ExEsyUV;EwE7yUM;IAOI,4BAAA;ExEyyUV;EwEhzUM;IAOI,kCAAA;ExE4yUV;EwEnzUM;IAOI,iCAAA;ExE+yUV;EwEtzUM;IAOI,+BAAA;ExEkzUV;EwEzzUM;IAOI,iCAAA;ExEqzUV;EwE5zUM;IAOI,+BAAA;ExEwzUV;EwE/zUM;IAOI,0BAAA;ExE2zUV;EwEl0UM;IAOI,gCAAA;ExE8zUV;EwEr0UM;IAOI,+BAAA;ExEi0UV;EwEx0UM;IAOI,6BAAA;ExEo0UV;EwE30UM;IAOI,+BAAA;ExEu0UV;EwE90UM;IAOI,6BAAA;ExE00UV;EwEj1UM;IAOI,iBAAA;ExE60UV;EwEp1UM;IAOI,uBAAA;ExEg1UV;EwEv1UM;IAOI,sBAAA;ExEm1UV;EwE11UM;IAOI,oBAAA;ExEs1UV;EwE71UM;IAOI,sBAAA;ExEy1UV;EwEh2UM;IAOI,oBAAA;ExE41UV;EwEn2UM;IAOI,qBAAA;ExE+1UV;EwEt2UM;IAOI,2BAAA;ExEk2UV;EwEz2UM;IAOI,0BAAA;ExEq2UV;EwE52UM;IAOI,wBAAA;ExEw2UV;EwE/2UM;IAOI,0BAAA;ExE22UV;EwEl3UM;IAOI,wBAAA;ExE82UV;EwEr3UM;IAOI,wBAAA;ExEi3UV;EwEx3UM;IAOI,8BAAA;ExEo3UV;EwE33UM;IAOI,6BAAA;ExEu3UV;EwE93UM;IAOI,2BAAA;ExE03UV;EwEj4UM;IAOI,6BAAA;ExE63UV;EwEp4UM;IAOI,2BAAA;ExEg4UV;EwEv4UM;IAOI,2BAAA;ExEm4UV;EwE14UM;IAOI,4BAAA;ExEs4UV;EwE74UM;IAOI,6BAAA;ExEy4UV;AACF;Acp5UI;E0DGI;IAOI,sBAAA;ExE84UV;EwEr5UM;IAOI,uBAAA;ExEi5UV;EwEx5UM;IAOI,sBAAA;ExEo5UV;EwE35UM;IAOI,8BAAA;ExEu5UV;EwE95UM;IAOI,4BAAA;ExE05UV;EwEj6UM;IAOI,2BAAA;ExE65UV;EwEp6UM;IAOI,iCAAA;ExEg6UV;EwEv6UM;IAOI,2BAAA;ExEm6UV;EwE16UM;IAOI,0BAAA;ExEs6UV;EwE76UM;IAOI,gCAAA;ExEy6UV;EwEh7UM;IAOI,yBAAA;ExE46UV;EwEn7UM;IAOI,wBAAA;ExE+6UV;EwEt7UM;IAOI,+BAAA;ExEk7UV;EwEz7UM;IAOI,yBAAA;ExEq7UV;EwE57UM;IAOI,6BAAA;ExEw7UV;EwE/7UM;IAOI,8BAAA;ExE27UV;EwEl8UM;IAOI,wBAAA;ExE87UV;EwEr8UM;IAOI,+BAAA;ExEi8UV;EwEx8UM;IAOI,wBAAA;ExEo8UV;EwE38UM;IAOI,yBAAA;ExEu8UV;EwE98UM;IAOI,8BAAA;ExE08UV;EwEj9UM;IAOI,iCAAA;ExE68UV;EwEp9UM;IAOI,sCAAA;ExEg9UV;EwEv9UM;IAOI,yCAAA;ExEm9UV;EwE19UM;IAOI,uBAAA;ExEs9UV;EwE79UM;IAOI,uBAAA;ExEy9UV;EwEh+UM;IAOI,yBAAA;ExE49UV;EwEn+UM;IAOI,yBAAA;ExE+9UV;EwEt+UM;IAOI,0BAAA;ExEk+UV;EwEz+UM;IAOI,4BAAA;ExEq+UV;EwE5+UM;IAOI,kCAAA;ExEw+UV;EwE/+UM;IAOI,sCAAA;ExE2+UV;EwEl/UM;IAOI,oCAAA;ExE8+UV;EwEr/UM;IAOI,kCAAA;ExEi/UV;EwEx/UM;IAOI,yCAAA;ExEo/UV;EwE3/UM;IAOI,wCAAA;ExEu/UV;EwE9/UM;IAOI,wCAAA;ExE0/UV;EwEjgVM;IAOI,kCAAA;ExE6/UV;EwEpgVM;IAOI,gCAAA;ExEggVV;EwEvgVM;IAOI,8BAAA;ExEmgVV;EwE1gVM;IAOI,gCAAA;ExEsgVV;EwE7gVM;IAOI,+BAAA;ExEygVV;EwEhhVM;IAOI,oCAAA;ExE4gVV;EwEnhVM;IAOI,kCAAA;ExE+gVV;EwEthVM;IAOI,gCAAA;ExEkhVV;EwEzhVM;IAOI,uCAAA;ExEqhVV;EwE5hVM;IAOI,sCAAA;ExEwhVV;EwE/hVM;IAOI,iCAAA;ExE2hVV;EwEliVM;IAOI,2BAAA;ExE8hVV;EwEriVM;IAOI,iCAAA;ExEiiVV;EwExiVM;IAOI,+BAAA;ExEoiVV;EwE3iVM;IAOI,6BAAA;ExEuiVV;EwE9iVM;IAOI,+BAAA;ExE0iVV;EwEjjVM;IAOI,8BAAA;ExE6iVV;EwEpjVM;IAOI,oBAAA;ExEgjVV;EwEvjVM;IAOI,mBAAA;ExEmjVV;EwE1jVM;IAOI,mBAAA;ExEsjVV;EwE7jVM;IAOI,mBAAA;ExEyjVV;EwEhkVM;IAOI,mBAAA;ExE4jVV;EwEnkVM;IAOI,mBAAA;ExE+jVV;EwEtkVM;IAOI,mBAAA;ExEkkVV;EwEzkVM;IAOI,mBAAA;ExEqkVV;EwE5kVM;IAOI,oBAAA;ExEwkVV;EwE/kVM;IAOI,0BAAA;ExE2kVV;EwEllVM;IAOI,yBAAA;ExE8kVV;EwErlVM;IAOI,uBAAA;ExEilVV;EwExlVM;IAOI,yBAAA;ExEolVV;EwE3lVM;IAOI,uBAAA;ExEulVV;EwE9lVM;IAOI,uBAAA;ExE0lVV;EwEjmVM;IAOI,0BAAA;IAAA,yBAAA;ExE8lVV;EwErmVM;IAOI,gCAAA;IAAA,+BAAA;ExEkmVV;EwEzmVM;IAOI,+BAAA;IAAA,8BAAA;ExEsmVV;EwE7mVM;IAOI,6BAAA;IAAA,4BAAA;ExE0mVV;EwEjnVM;IAOI,+BAAA;IAAA,8BAAA;ExE8mVV;EwErnVM;IAOI,6BAAA;IAAA,4BAAA;ExEknVV;EwEznVM;IAOI,6BAAA;IAAA,4BAAA;ExEsnVV;EwE7nVM;IAOI,wBAAA;IAAA,2BAAA;ExE0nVV;EwEjoVM;IAOI,8BAAA;IAAA,iCAAA;ExE8nVV;EwEroVM;IAOI,6BAAA;IAAA,gCAAA;ExEkoVV;EwEzoVM;IAOI,2BAAA;IAAA,8BAAA;ExEsoVV;EwE7oVM;IAOI,6BAAA;IAAA,gCAAA;ExE0oVV;EwEjpVM;IAOI,2BAAA;IAAA,8BAAA;ExE8oVV;EwErpVM;IAOI,2BAAA;IAAA,8BAAA;ExEkpVV;EwEzpVM;IAOI,wBAAA;ExEqpVV;EwE5pVM;IAOI,8BAAA;ExEwpVV;EwE/pVM;IAOI,6BAAA;ExE2pVV;EwElqVM;IAOI,2BAAA;ExE8pVV;EwErqVM;IAOI,6BAAA;ExEiqVV;EwExqVM;IAOI,2BAAA;ExEoqVV;EwE3qVM;IAOI,2BAAA;ExEuqVV;EwE9qVM;IAOI,0BAAA;ExE0qVV;EwEjrVM;IAOI,gCAAA;ExE6qVV;EwEprVM;IAOI,+BAAA;ExEgrVV;EwEvrVM;IAOI,6BAAA;ExEmrVV;EwE1rVM;IAOI,+BAAA;ExEsrVV;EwE7rVM;IAOI,6BAAA;ExEyrVV;EwEhsVM;IAOI,6BAAA;ExE4rVV;EwEnsVM;IAOI,2BAAA;ExE+rVV;EwEtsVM;IAOI,iCAAA;ExEksVV;EwEzsVM;IAOI,gCAAA;ExEqsVV;EwE5sVM;IAOI,8BAAA;ExEwsVV;EwE/sVM;IAOI,gCAAA;ExE2sVV;EwEltVM;IAOI,8BAAA;ExE8sVV;EwErtVM;IAOI,8BAAA;ExEitVV;EwExtVM;IAOI,yBAAA;ExEotVV;EwE3tVM;IAOI,+BAAA;ExEutVV;EwE9tVM;IAOI,8BAAA;ExE0tVV;EwEjuVM;IAOI,4BAAA;ExE6tVV;EwEpuVM;IAOI,8BAAA;ExEguVV;EwEvuVM;IAOI,4BAAA;ExEmuVV;EwE1uVM;IAOI,4BAAA;ExEsuVV;EwE7uVM;IAOI,qBAAA;ExEyuVV;EwEhvVM;IAOI,2BAAA;ExE4uVV;EwEnvVM;IAOI,0BAAA;ExE+uVV;EwEtvVM;IAOI,wBAAA;ExEkvVV;EwEzvVM;IAOI,0BAAA;ExEqvVV;EwE5vVM;IAOI,wBAAA;ExEwvVV;EwE/vVM;IAOI,2BAAA;IAAA,0BAAA;ExE4vVV;EwEnwVM;IAOI,iCAAA;IAAA,gCAAA;ExEgwVV;EwEvwVM;IAOI,gCAAA;IAAA,+BAAA;ExEowVV;EwE3wVM;IAOI,8BAAA;IAAA,6BAAA;ExEwwVV;EwE/wVM;IAOI,gCAAA;IAAA,+BAAA;ExE4wVV;EwEnxVM;IAOI,8BAAA;IAAA,6BAAA;ExEgxVV;EwEvxVM;IAOI,yBAAA;IAAA,4BAAA;ExEoxVV;EwE3xVM;IAOI,+BAAA;IAAA,kCAAA;ExEwxVV;EwE/xVM;IAOI,8BAAA;IAAA,iCAAA;ExE4xVV;EwEnyVM;IAOI,4BAAA;IAAA,+BAAA;ExEgyVV;EwEvyVM;IAOI,8BAAA;IAAA,iCAAA;ExEoyVV;EwE3yVM;IAOI,4BAAA;IAAA,+BAAA;ExEwyVV;EwE/yVM;IAOI,yBAAA;ExE2yVV;EwElzVM;IAOI,+BAAA;ExE8yVV;EwErzVM;IAOI,8BAAA;ExEizVV;EwExzVM;IAOI,4BAAA;ExEozVV;EwE3zVM;IAOI,8BAAA;ExEuzVV;EwE9zVM;IAOI,4BAAA;ExE0zVV;EwEj0VM;IAOI,2BAAA;ExE6zVV;EwEp0VM;IAOI,iCAAA;ExEg0VV;EwEv0VM;IAOI,gCAAA;ExEm0VV;EwE10VM;IAOI,8BAAA;ExEs0VV;EwE70VM;IAOI,gCAAA;ExEy0VV;EwEh1VM;IAOI,8BAAA;ExE40VV;EwEn1VM;IAOI,4BAAA;ExE+0VV;EwEt1VM;IAOI,kCAAA;ExEk1VV;EwEz1VM;IAOI,iCAAA;ExEq1VV;EwE51VM;IAOI,+BAAA;ExEw1VV;EwE/1VM;IAOI,iCAAA;ExE21VV;EwEl2VM;IAOI,+BAAA;ExE81VV;EwEr2VM;IAOI,0BAAA;ExEi2VV;EwEx2VM;IAOI,gCAAA;ExEo2VV;EwE32VM;IAOI,+BAAA;ExEu2VV;EwE92VM;IAOI,6BAAA;ExE02VV;EwEj3VM;IAOI,+BAAA;ExE62VV;EwEp3VM;IAOI,6BAAA;ExEg3VV;EwEv3VM;IAOI,iBAAA;ExEm3VV;EwE13VM;IAOI,uBAAA;ExEs3VV;EwE73VM;IAOI,sBAAA;ExEy3VV;EwEh4VM;IAOI,oBAAA;ExE43VV;EwEn4VM;IAOI,sBAAA;ExE+3VV;EwEt4VM;IAOI,oBAAA;ExEk4VV;EwEz4VM;IAOI,qBAAA;ExEq4VV;EwE54VM;IAOI,2BAAA;ExEw4VV;EwE/4VM;IAOI,0BAAA;ExE24VV;EwEl5VM;IAOI,wBAAA;ExE84VV;EwEr5VM;IAOI,0BAAA;ExEi5VV;EwEx5VM;IAOI,wBAAA;ExEo5VV;EwE35VM;IAOI,wBAAA;ExEu5VV;EwE95VM;IAOI,8BAAA;ExE05VV;EwEj6VM;IAOI,6BAAA;ExE65VV;EwEp6VM;IAOI,2BAAA;ExEg6VV;EwEv6VM;IAOI,6BAAA;ExEm6VV;EwE16VM;IAOI,2BAAA;ExEs6VV;EwE76VM;IAOI,2BAAA;ExEy6VV;EwEh7VM;IAOI,4BAAA;ExE46VV;EwEn7VM;IAOI,6BAAA;ExE+6VV;AACF;Ac17VI;E0DGI;IAOI,sBAAA;ExEo7VV;EwE37VM;IAOI,uBAAA;ExEu7VV;EwE97VM;IAOI,sBAAA;ExE07VV;EwEj8VM;IAOI,8BAAA;ExE67VV;EwEp8VM;IAOI,4BAAA;ExEg8VV;EwEv8VM;IAOI,2BAAA;ExEm8VV;EwE18VM;IAOI,iCAAA;ExEs8VV;EwE78VM;IAOI,2BAAA;ExEy8VV;EwEh9VM;IAOI,0BAAA;ExE48VV;EwEn9VM;IAOI,gCAAA;ExE+8VV;EwEt9VM;IAOI,yBAAA;ExEk9VV;EwEz9VM;IAOI,wBAAA;ExEq9VV;EwE59VM;IAOI,+BAAA;ExEw9VV;EwE/9VM;IAOI,yBAAA;ExE29VV;EwEl+VM;IAOI,6BAAA;ExE89VV;EwEr+VM;IAOI,8BAAA;ExEi+VV;EwEx+VM;IAOI,wBAAA;ExEo+VV;EwE3+VM;IAOI,+BAAA;ExEu+VV;EwE9+VM;IAOI,wBAAA;ExE0+VV;EwEj/VM;IAOI,yBAAA;ExE6+VV;EwEp/VM;IAOI,8BAAA;ExEg/VV;EwEv/VM;IAOI,iCAAA;ExEm/VV;EwE1/VM;IAOI,sCAAA;ExEs/VV;EwE7/VM;IAOI,yCAAA;ExEy/VV;EwEhgWM;IAOI,uBAAA;ExE4/VV;EwEngWM;IAOI,uBAAA;ExE+/VV;EwEtgWM;IAOI,yBAAA;ExEkgWV;EwEzgWM;IAOI,yBAAA;ExEqgWV;EwE5gWM;IAOI,0BAAA;ExEwgWV;EwE/gWM;IAOI,4BAAA;ExE2gWV;EwElhWM;IAOI,kCAAA;ExE8gWV;EwErhWM;IAOI,sCAAA;ExEihWV;EwExhWM;IAOI,oCAAA;ExEohWV;EwE3hWM;IAOI,kCAAA;ExEuhWV;EwE9hWM;IAOI,yCAAA;ExE0hWV;EwEjiWM;IAOI,wCAAA;ExE6hWV;EwEpiWM;IAOI,wCAAA;ExEgiWV;EwEviWM;IAOI,kCAAA;ExEmiWV;EwE1iWM;IAOI,gCAAA;ExEsiWV;EwE7iWM;IAOI,8BAAA;ExEyiWV;EwEhjWM;IAOI,gCAAA;ExE4iWV;EwEnjWM;IAOI,+BAAA;ExE+iWV;EwEtjWM;IAOI,oCAAA;ExEkjWV;EwEzjWM;IAOI,kCAAA;ExEqjWV;EwE5jWM;IAOI,gCAAA;ExEwjWV;EwE/jWM;IAOI,uCAAA;ExE2jWV;EwElkWM;IAOI,sCAAA;ExE8jWV;EwErkWM;IAOI,iCAAA;ExEikWV;EwExkWM;IAOI,2BAAA;ExEokWV;EwE3kWM;IAOI,iCAAA;ExEukWV;EwE9kWM;IAOI,+BAAA;ExE0kWV;EwEjlWM;IAOI,6BAAA;ExE6kWV;EwEplWM;IAOI,+BAAA;ExEglWV;EwEvlWM;IAOI,8BAAA;ExEmlWV;EwE1lWM;IAOI,oBAAA;ExEslWV;EwE7lWM;IAOI,mBAAA;ExEylWV;EwEhmWM;IAOI,mBAAA;ExE4lWV;EwEnmWM;IAOI,mBAAA;ExE+lWV;EwEtmWM;IAOI,mBAAA;ExEkmWV;EwEzmWM;IAOI,mBAAA;ExEqmWV;EwE5mWM;IAOI,mBAAA;ExEwmWV;EwE/mWM;IAOI,mBAAA;ExE2mWV;EwElnWM;IAOI,oBAAA;ExE8mWV;EwErnWM;IAOI,0BAAA;ExEinWV;EwExnWM;IAOI,yBAAA;ExEonWV;EwE3nWM;IAOI,uBAAA;ExEunWV;EwE9nWM;IAOI,yBAAA;ExE0nWV;EwEjoWM;IAOI,uBAAA;ExE6nWV;EwEpoWM;IAOI,uBAAA;ExEgoWV;EwEvoWM;IAOI,0BAAA;IAAA,yBAAA;ExEooWV;EwE3oWM;IAOI,gCAAA;IAAA,+BAAA;ExEwoWV;EwE/oWM;IAOI,+BAAA;IAAA,8BAAA;ExE4oWV;EwEnpWM;IAOI,6BAAA;IAAA,4BAAA;ExEgpWV;EwEvpWM;IAOI,+BAAA;IAAA,8BAAA;ExEopWV;EwE3pWM;IAOI,6BAAA;IAAA,4BAAA;ExEwpWV;EwE/pWM;IAOI,6BAAA;IAAA,4BAAA;ExE4pWV;EwEnqWM;IAOI,wBAAA;IAAA,2BAAA;ExEgqWV;EwEvqWM;IAOI,8BAAA;IAAA,iCAAA;ExEoqWV;EwE3qWM;IAOI,6BAAA;IAAA,gCAAA;ExEwqWV;EwE/qWM;IAOI,2BAAA;IAAA,8BAAA;ExE4qWV;EwEnrWM;IAOI,6BAAA;IAAA,gCAAA;ExEgrWV;EwEvrWM;IAOI,2BAAA;IAAA,8BAAA;ExEorWV;EwE3rWM;IAOI,2BAAA;IAAA,8BAAA;ExEwrWV;EwE/rWM;IAOI,wBAAA;ExE2rWV;EwElsWM;IAOI,8BAAA;ExE8rWV;EwErsWM;IAOI,6BAAA;ExEisWV;EwExsWM;IAOI,2BAAA;ExEosWV;EwE3sWM;IAOI,6BAAA;ExEusWV;EwE9sWM;IAOI,2BAAA;ExE0sWV;EwEjtWM;IAOI,2BAAA;ExE6sWV;EwEptWM;IAOI,0BAAA;ExEgtWV;EwEvtWM;IAOI,gCAAA;ExEmtWV;EwE1tWM;IAOI,+BAAA;ExEstWV;EwE7tWM;IAOI,6BAAA;ExEytWV;EwEhuWM;IAOI,+BAAA;ExE4tWV;EwEnuWM;IAOI,6BAAA;ExE+tWV;EwEtuWM;IAOI,6BAAA;ExEkuWV;EwEzuWM;IAOI,2BAAA;ExEquWV;EwE5uWM;IAOI,iCAAA;ExEwuWV;EwE/uWM;IAOI,gCAAA;ExE2uWV;EwElvWM;IAOI,8BAAA;ExE8uWV;EwErvWM;IAOI,gCAAA;ExEivWV;EwExvWM;IAOI,8BAAA;ExEovWV;EwE3vWM;IAOI,8BAAA;ExEuvWV;EwE9vWM;IAOI,yBAAA;ExE0vWV;EwEjwWM;IAOI,+BAAA;ExE6vWV;EwEpwWM;IAOI,8BAAA;ExEgwWV;EwEvwWM;IAOI,4BAAA;ExEmwWV;EwE1wWM;IAOI,8BAAA;ExEswWV;EwE7wWM;IAOI,4BAAA;ExEywWV;EwEhxWM;IAOI,4BAAA;ExE4wWV;EwEnxWM;IAOI,qBAAA;ExE+wWV;EwEtxWM;IAOI,2BAAA;ExEkxWV;EwEzxWM;IAOI,0BAAA;ExEqxWV;EwE5xWM;IAOI,wBAAA;ExEwxWV;EwE/xWM;IAOI,0BAAA;ExE2xWV;EwElyWM;IAOI,wBAAA;ExE8xWV;EwEryWM;IAOI,2BAAA;IAAA,0BAAA;ExEkyWV;EwEzyWM;IAOI,iCAAA;IAAA,gCAAA;ExEsyWV;EwE7yWM;IAOI,gCAAA;IAAA,+BAAA;ExE0yWV;EwEjzWM;IAOI,8BAAA;IAAA,6BAAA;ExE8yWV;EwErzWM;IAOI,gCAAA;IAAA,+BAAA;ExEkzWV;EwEzzWM;IAOI,8BAAA;IAAA,6BAAA;ExEszWV;EwE7zWM;IAOI,yBAAA;IAAA,4BAAA;ExE0zWV;EwEj0WM;IAOI,+BAAA;IAAA,kCAAA;ExE8zWV;EwEr0WM;IAOI,8BAAA;IAAA,iCAAA;ExEk0WV;EwEz0WM;IAOI,4BAAA;IAAA,+BAAA;ExEs0WV;EwE70WM;IAOI,8BAAA;IAAA,iCAAA;ExE00WV;EwEj1WM;IAOI,4BAAA;IAAA,+BAAA;ExE80WV;EwEr1WM;IAOI,yBAAA;ExEi1WV;EwEx1WM;IAOI,+BAAA;ExEo1WV;EwE31WM;IAOI,8BAAA;ExEu1WV;EwE91WM;IAOI,4BAAA;ExE01WV;EwEj2WM;IAOI,8BAAA;ExE61WV;EwEp2WM;IAOI,4BAAA;ExEg2WV;EwEv2WM;IAOI,2BAAA;ExEm2WV;EwE12WM;IAOI,iCAAA;ExEs2WV;EwE72WM;IAOI,gCAAA;ExEy2WV;EwEh3WM;IAOI,8BAAA;ExE42WV;EwEn3WM;IAOI,gCAAA;ExE+2WV;EwEt3WM;IAOI,8BAAA;ExEk3WV;EwEz3WM;IAOI,4BAAA;ExEq3WV;EwE53WM;IAOI,kCAAA;ExEw3WV;EwE/3WM;IAOI,iCAAA;ExE23WV;EwEl4WM;IAOI,+BAAA;ExE83WV;EwEr4WM;IAOI,iCAAA;ExEi4WV;EwEx4WM;IAOI,+BAAA;ExEo4WV;EwE34WM;IAOI,0BAAA;ExEu4WV;EwE94WM;IAOI,gCAAA;ExE04WV;EwEj5WM;IAOI,+BAAA;ExE64WV;EwEp5WM;IAOI,6BAAA;ExEg5WV;EwEv5WM;IAOI,+BAAA;ExEm5WV;EwE15WM;IAOI,6BAAA;ExEs5WV;EwE75WM;IAOI,iBAAA;ExEy5WV;EwEh6WM;IAOI,uBAAA;ExE45WV;EwEn6WM;IAOI,sBAAA;ExE+5WV;EwEt6WM;IAOI,oBAAA;ExEk6WV;EwEz6WM;IAOI,sBAAA;ExEq6WV;EwE56WM;IAOI,oBAAA;ExEw6WV;EwE/6WM;IAOI,qBAAA;ExE26WV;EwEl7WM;IAOI,2BAAA;ExE86WV;EwEr7WM;IAOI,0BAAA;ExEi7WV;EwEx7WM;IAOI,wBAAA;ExEo7WV;EwE37WM;IAOI,0BAAA;ExEu7WV;EwE97WM;IAOI,wBAAA;ExE07WV;EwEj8WM;IAOI,wBAAA;ExE67WV;EwEp8WM;IAOI,8BAAA;ExEg8WV;EwEv8WM;IAOI,6BAAA;ExEm8WV;EwE18WM;IAOI,2BAAA;ExEs8WV;EwE78WM;IAOI,6BAAA;ExEy8WV;EwEh9WM;IAOI,2BAAA;ExE48WV;EwEn9WM;IAOI,2BAAA;ExE+8WV;EwEt9WM;IAOI,4BAAA;ExEk9WV;EwEz9WM;IAOI,6BAAA;ExEq9WV;AACF;AyE5gXA;ED+CQ;IAOI,4BAAA;ExE09WV;EwEj+WM;IAOI,0BAAA;ExE69WV;EwEp+WM;IAOI,6BAAA;ExEg+WV;EwEv+WM;IAOI,4BAAA;ExEm+WV;AACF;AyEvgXA;ED4BQ;IAOI,0BAAA;ExEw+WV;EwE/+WM;IAOI,gCAAA;ExE2+WV;EwEl/WM;IAOI,yBAAA;ExE8+WV;EwEr/WM;IAOI,wBAAA;ExEi/WV;EwEx/WM;IAOI,+BAAA;ExEo/WV;EwE3/WM;IAOI,yBAAA;ExEu/WV;EwE9/WM;IAOI,6BAAA;ExE0/WV;EwEjgXM;IAOI,8BAAA;ExE6/WV;EwEpgXM;IAOI,wBAAA;ExEggXV;EwEvgXM;IAOI,+BAAA;ExEmgXV;EwE1gXM;IAOI,wBAAA;ExEsgXV;AACF;A0EhlXA;;4BAAA;AAGA;EACE,UAAA;A1EklXF;;A0EhlXA;EACE,UAAA;A1EmlXF;;A0EjlXA;EACE,mBAAA;A1EolXF;;A0E/kXM;EACE,cAAA;A1EklXR;;A0EzkXQ;EACE,uBAAA;EACA,aAAA;A1E4kXV;A0E3kXU;EACE,eAAA;A1E6kXZ;;A0E7jXY;;;EACE,yBC0CE;A3EwhXhB;A0E7jXY;;;EACE,yBC1CN;A3E2mXR;;A0ExjXE;EACE,oCAAA;A1E2jXJ;A0E1jXI;;EAEE,gBAAA;A1E4jXN;A0E1jXI;EACE,4CAAA;EACA,UAAA;A1E4jXN;A0E1jXQ;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;A1E4jXV;A0E3jXU;EACE,uBAAA;EACA,aAAA;EACA,yBCCE;A3E4jXd;A0E3jXU;EACE,eAAA;EACA,cC8BY;A3E+hXxB;A0EtjXQ;EACE,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,yBCpFF;A3E4oXR;A0EnjXY;EACE,yBC1FN;A3E+oXR;A0EljXU;EACE,YAAA;EACA,yBCjBI;EDkBJ,gBAAA;EACA,YAAA;EACA,gBAAA;A1EojXZ;A0EnjXY;EACE,oBAAA;A1EqjXd;A0EljXU;EACE,eAAA;A1EojXZ;;A0EriXY;;;EACE,aAAA;A1E0iXd;A0E/hXY;;;;;EACE,oCAAA;A1EqiXd;;A0ExhXE;;;;;EACE,oCAAA;A1E+hXJ;A0E9hXI;;;;;;;;;;EAEE,gBAAA;A1EwiXN;A0EtiXI;;;;;EACE,4CAAA;EACA,UAAA;A1E4iXN;A0E1iXQ;;;;;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;A1EgjXV;A0E/iXU;;;;;EACE,uBAAA;EACA,aAAA;EACA,yBC7FE;A3EkpXd;A0EnjXU;;;;;EACE,eAAA;EACA,cChEY;A3EynXxB;A0EljXQ;;;;;EACE,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,yBClLF;A3E0uXR;A0EpjXY;;;;;;;;;;;;;EACE,yBCvLN;A3EyvXR;A0E/jXU;;;;;EACE,YAAA;EACA,yBC9GI;ED+GJ,gBAAA;EACA,YAAA;EACA,gBAAA;A1EqkXZ;A0EnkXU;;;;;EACE,eAAA;A1EykXZ;;A0EjkXE;EACE,sBAAA;EACA,wBAAA;EACA,yBAAA;A1EokXJ;;A0EjkXA;;;;;;EAME,oCAAA;A1EokXF;;A0EhkXI;EACE,eAAA;A1EmkXN;A0EjkXI;EACE,gBAAA;A1EmkXN;;A0E9jXE;EACE,cCxNY;A3EyxXhB;;A0E9jXA;EACE,UAAA;A1EikXF;A0E/jXI;EACE,WAAA;A1EikXN;;A0E5jXE;EACE,6BAAA;A1E+jXJ;A0E7jXE;EACE,2BAAA;A1E+jXJ;A0E5jXI;EACE,cCpPM;A3EkzXZ;;A0E1jXA;EACE,mBAAA;A1E6jXF;;A0EvjXQ;EACE,yBAAA;A1E0jXV;;A0EpjXA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;A1EujXF;A0EtjXE;EAEE,gBAAA;A1EujXJ;A0ErjXE;EACE,6DAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;A1EujXJ;A0ErjXE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,mBCvSI;EDwSJ,yBAAA;EACA,eAAA;A1EujXJ;A0ErjXE;EACE,qCAAA;A1EujXJ;;A0EpjXA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;A1EujXF;A0EtjXE;EAEE,gBAAA;A1EujXJ;A0ErjXE;EACE,6DAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,mBCtTY;EDuTZ,kBAAA;A1EujXJ;A0ErjXE;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBC5UI;ED6UJ,yBAAA;EACA,kBAAA;A1EujXJ;A0ErjXE;EACE,sBAAA;A1EujXJ;;A0EnjXE;EACE,cC1UY;A3Eg4XhB;;A0EnjXA;EACE,mBAAA;A1EsjXF;;A0EjjXI;EACE,YAAA;A1EojXN;A0EhjXI;EACE,aAAA;EACA,mBAAA;A1EkjXN;A0EjjXM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;A1EmjXR;A0EljXQ;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;A1EojXV;;A0E7iXE;EACE,sBAAA;EACA,uBAAA;A1EgjXJ;;A0E7iXA;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;A1EgjXF;A0E/iXE;EACE,eAAA;EACA,cCnYY;A3Eo7XhB;A0E/iXE;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;A1EijXJ;A0E/iXE;;EAEE,aAAA;A1EijXJ;A0E/iXE;EACE,WAAA;A1EijXJ;;A0E7iXE;EACE,mBCnaU;A3Em9Xd;A0E9iXE;EACE,eAAA;A1EgjXJ;A0E7iXI;EACE,kBAAA;A1E+iXN;A0E5iXE;EACE,WAAA;A1E8iXJ;;A0E1iXE;EACE,mBAAA;A1E6iXJ;A0E5iXI;EACE,eAAA;EACA,gBAAA;A1E8iXN;A0E5iXI;EACE,gBAAA;A1E8iXN;A0E5iXI;EACE,eAAA;A1E8iXN;A0E3iXE;EACE,kBAAA;EACA,YAAA;A1E6iXJ;A0E3iXE;EACE,UAAA;A1E6iXJ;A0E5iXI;EACE,kBAAA;A1E8iXN;A0E5iXI;EACE,aAAA;A1E8iXN;A0E5iXI;EACE,aAAA;A1E8iXN;A0E5iXI;EACE,2BAAA;A1E8iXN;A0E7iXM;EACE,aAAA;A1E+iXR;A0E9iXQ;EACE,gBAAA;EACA,cAAA;A1EgjXV;A0E7iXM;EACE,wCAAA;EACA,iCAAA;A1E+iXR;A0E9iXQ;EACE,6BAAA;A1EgjXV;A0E7iXM;EACE,cAAA;A1E+iXR;A0E9iXQ;EACE,4BAAA;A1EgjXV;;A0E1iXA;EACE,WAAA;A1E6iXF;;A0EziXI;EACE,cCnYkB;EDoYlB,gBAAA;A1E4iXN;A0ExiXI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1E0iXN;;A0EriXE;EACE,sBAAA;EACA,uBAAA;A1EwiXJ;;A0EpiXE;EACE,cCzZoB;ED0ZpB,mBCpgBU;EDqgBV,gBAAA;EACA,mBAAA;A1EuiXJ;A0EriXE;EACE,gBAAA;A1EuiXJ;A0EtiXI;EACE,WCxbO;EDybP,iBAAA;EACA,kBAAA;A1EwiXN;A0EviXM;EACE,cCragB;A3E88XxB;A0EtiXI;EACE,mBAAA;A1EwiXN;A0EviXM;EACE,gBAAA;A1EyiXR;A0EliXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EoiXV;A0EziXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1E2iXV;A0EhjXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EkjXV;A0EvjXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EyjXV;A0E9jXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EgkXV;A0ErkXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EukXV;A0E5kXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1E8kXV;A0EnlXQ;EACE,yBAN+B;EAO/B,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EqlXV;A0E5kXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1E8kXR;A0EnlXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EqlXR;A0E1lXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1E4lXR;A0EjmXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EmmXR;A0ExmXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1E0mXR;A0E/mXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EinXR;A0EtnXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1EwnXR;A0E7nXM;EACE,yBAN+B;EAO/B,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;A1E+nXR;;A0E1nXA;EACE,UAAA;A1E6nXF;;A0E3nXA;EACE,cCziBc;A3EuqYhB;;A0E5nXA;EACE,cC5iBc;ED6iBd,yBC7iBc;A3E4qYhB;;A0E7nXA;EACE,cChjBc;A3EgrYhB;;A0E9nXA;EACE,cCnjBc;A3EorYhB;;A0E7nXI;EACE,gCAAA;A1EgoXN;;A0E5nXA;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1E+nXF;A0E9nXE;EACE,mBAAA;A1EgoXJ;A0E9nXE;EAGE,yBC1kBY;A3EwsYhB;A0E5nXE;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;A1E8nXJ;A0E7nXI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;A1E+nXN;A0E5nXE;EACE,mBAAA;A1E8nXJ;A0E1nXM;EACE,eAAA;A1E4nXR;A0E3nXQ;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;A1E6nXV;A0EtnXM;EACE,kBAAA;A1EwnXR;A0EtnXU;EACE,qBAAA;A1EwnXZ;A0EtnXU;EACE,cChnBI;A3EwuYhB;A0ElnXE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;A1EonXJ;A0ElnXE;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;A1EonXJ;A0EnnXI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;A1EqnXN;A0EnnXI;EACE,gBAAA;EACA,gBAAA;A1EqnXN;A0EpnXM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A1EsnXR;A0ErnXQ;EACE,eAAA;A1EunXV;A0E/mXQ;EACE,cC1qBF;A3E2xYR;A0E7mXQ;EACE,eAAA;EACA,cChrBF;A3E+xYR;A0E1mXE;EACE,gBAAA;A1E4mXJ;A0E3mXI;EACE,aAAA;EACA,0DAAA;EACA,2BAAA;EACA,+CAAA;A1E6mXN;A0E3mXI;EACE,qBAAA;A1E6mXN;A0E3mXI;EACE,aAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;A1E6mXN;A0E5mXM;EACE,WAAA;A1E8mXR;A0E3mXI;EACE,+BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;A1E6mXN;A0E3mXI;EACE,cCntBE;EDotBF,gBAAA;EACA,kBAAA;A1E6mXN;;A0EzmXA;EACE,aAAA;EACA,uBAAA;A1E4mXF;;A0E1mXA;EACE,SAAA;A1E6mXF;;A0E1mXE;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;A1E6mXJ;;A0EzmXE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;A1E4mXJ;;A0ErmXQ;EACE,WAAA;A1EwmXV;A0EnmXM;EACE,gBAAA;A1EqmXR;A0EhmXQ;EACE,WAAA;A1EkmXV;;A0E5lXA;EACE,8BAAA;A1E+lXF;;A0E3lXI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;A1E8lXN;A0E3lXE;EACE,6BAAA;A1E6lXJ;A0E5lXI;EACE,kCAAA;EACA,cCrxBE;A3Em3YR;A0E7lXM;EACE,eAAA;A1E+lXR;A0E1lXI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBChyBE;EDiyBF,aAAA;EACA,mBAAA;EACA,uBAAA;A1E4lXN;;A0ExlXA;EACE,aAAA;A1E2lXF;;A0ErlXQ;EACE,sBAAA;EACA,aAAA;EACA,6BAAA;A1EwlXV;A0EvlXU;EACE,gBAAA;A1EylXZ;A0EtlXY;EACE,WAAA;A1EwlXd;A0EplXQ;EACE,iBAAA;EACA,gBAAA;A1EslXV;A0EhlXQ;EACE,aAAA;EACA,eAAA;EACA,cC3vBG;ED4vBH,gBAAA;EACA,oBAAA;A1EklXV;;A0EzkXM;EACE,kBAAA;A1E4kXR;A0ExkXM;EACE,sBAAA;A1E0kXR;A0EtkXE;EACE,8BAAA;EACA,+BAAA;A1EwkXJ;;A0EnkXE;EACE,aAAA;A1EskXJ;A0ErkXI;EACE,kBAAA;A1EukXN;A0EpkXM;EACE,mBAAA;EACA,yBC91BQ;ED+1BR,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cCj3BA;EDk3BA,QAAA;EACA,SAAA;EACA,UAAA;A1EskXR;A0EpkXM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;EACA,UAAA;A1EskXR;A0ElkXM;EACE,2BAAA;A1EokXR;A0EnkXQ;EACE,kBAAA;A1EqkXV;A0EpkXU;EACE,cCl3BE;A3Ew7Yd;A0EpkXU;EACE,cCr3BE;A3E27Yd;A0ElkXM;EACE,qBAAA;A1EokXR;A0ElkXM;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,cCn5BD;A3Eu9YP;A0ElkXM;EACE,eAAA;EACA,cC15BI;ED25BJ,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;A1EokXR;A0ElkXM;EACE,eAAA;EACA,cCh5BI;EDi5BJ,gBAAA;A1EokXR;A0ElkXM;EACE,iBAAA;A1EokXR;A0EnkXQ;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;A1EqkXV;A0EjkXI;EACE,kBAAA;A1EmkXN;A0ElkXM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;A1EokXR;A0ElkXU;EACE,qBAAA;EACA,+CAAA;EACA,iBAAA;EACA,yBC18BJ;ED28BI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;A1EokXZ;A0EnkXY;EACE,UAAA;EACA,6BCt4BM;A3E28YpB;A0EpkXc;EACE,WAAA;A1EskXhB;A0EpkXc;EACE,eAAA;A1EskXhB;A0EpkXc;EACE,WAAA;EACA,aAAA;EACA,iBAAA;A1EskXhB;A0E/jXQ;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;A1EikXV;;A0ExjXI;EACE,uBAAA;A1E2jXN;;A0EtjXE;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;A1EyjXJ;A0ExjXI;EACE,cAAA;EACA,eAAA;A1E0jXN;A0ExjXI;EACE,WAAA;EACA,qBAAA;A1E0jXN;A0EzjXM;EACE,kBAAA;EACA,eAAA;A1E2jXR;A0ExjXI;EACE,eAAA;EACA,cAAA;A1E0jXN;A0EvjXE;EACE,gBAAA;EACA,mBAAA;A1EyjXJ;A0EvjXM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;A1EyjXR;A0ExjXQ;EACE,oCAAA;A1E0jXV;A0ExjXQ;EACE,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;A1E0jXV;A0ErjXE;EACE,8BAAA;A1EujXJ;A0EtjXI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;A1EwjXN;A0ErjXE;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;A1EujXJ;A0EtjXI;EACE,yBAAA;EACA,qBAAA;A1EwjXN;A0EtjXI;EACE,gBAAA;EACA,kBAAA;A1EwjXN;A0EtjXI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;A1EwjXN;A0ErjXE;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;A1EujXJ;;A0EpjXA;EACE,yBCxiCW;A3E+lZb;;A0ErjXA;EACE,yBC1iCK;A3EkmZP;;A0EtjXA;EACE,yBC5iCK;A3EqmZP;;A0EpjXI;EACE,cCzlCO;ED0lCP,gBAAA;EACA,eAAA;A1EujXN;A0EtjXM;EAGE,4DAAA;EACA,2CAAA;EACA,cC3lCQ;ED4lCR,oBC3hCY;A3EilZpB;;A0EjjXA;EACE,gBAAA;A1EojXF;A0EnjXE;EACE,gBAAA;A1EqjXJ;;A0EjjXE;EACE,mBAAA;A1EojXJ;;A0EhjXE;EACE,mBAAA;EACA,gCAAA;A1EmjXJ;A0EjjXM;EACE,WAAA;EACA,sBAAA;A1EmjXR;;A0E7iXE;EACE,mBAAA;A1EgjXJ;A0E9iXE;EACE,gBAAA;A1EgjXJ;A0E/iXI;EACE,oBAAA;A1EijXN;A0EhjXM;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;A1EkjXR;A0EhjXM;EACE,yBAAA;EACA,cCrpCA;A3EusZR;A0EhjXM;EACE,yBAAA;EACA,cCzpCA;A3E2sZR;A0EhjXM;EACE,yBAAA;EACA,cC7pCA;A3E+sZR;;A0E7iXA;EACE,gBAAA;A1EgjXF;A0E/iXE;EACE,gBAAA;A1EijXJ;;A0E9iXA;EACE,WAAA;A1EijXF;;A0E3iXQ;EACE,aAAA;EACA,gBAAA;A1E8iXV;A0E7iXU;EACE,YAAA;A1E+iXZ;A0E1iXI;;EAEE,gBAAA;A1E4iXN;;A0EtiXE;EACE,8BAAA;A1EyiXJ;A0EviXE;EACE,aAAA;A1EyiXJ;;A0EtiXA;EACE,aAAA;A1EyiXF;;A0EtiXE;EACE,aAAA;A1EyiXJ;;A0EpiXE;EACE,mBAAA;A1EuiXJ;A0EtiXI;EACE,kBAAA;A1EwiXN;;A0EliXE;EACE,+BAAA;A1EqiXJ;A0EpiXI;EACE,yBAAA;EACA,kCAAA;EACA,oCAAA;A1EsiXN;A0EriXM;EACE,2CAAA;A1EuiXR;;A0EjiXA;EACE,mBAAA;A1EoiXF;;A0EhiXI;EACE,kBAAA;A1EmiXN;A0EliXM;EACE,kBAAA;A1EoiXR;A0EjiXQ;EACE,gBAAA;A1EmiXV;A0EhiXM;EACE,gCAAA;EACA,mBAAA;EACA,mBAAA;A1EkiXR;A0E9hXE;EACE,gBAAA;EACA,mBAAA;A1EgiXJ;A0E9hXE;EACE,eAAA;A1EgiXJ;A0E9hXE;EACE,mBAAA;A1EgiXJ;A0E/hXI;EACE,gBAAA;A1EiiXN;A0EhiXM;EACE,UAAA;A1EkiXR;A0E/hXI;EACE,eAAA;A1EiiXN;A0E9hXE;EACE,gBAAA;A1EgiXJ;A0E9hXE;EACE,UAAA;A1EgiXJ;A0E7hXI;EACE,UAAA;A1E+hXN;A0E7hXI;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;A1E+hXN;A0E9hXM;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,6DAAA;A1EgiXR;A0E7hXI;EACE,oBCtzCK;EDuzCL,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;A1E+hXN;A0E3hXI;EACE,qBC9yCU;ED+yCV,cC/yCU;A3E40ZhB;A0EzhXI;EACE,kBAAA;A1E2hXN;A0ExhXE;EACE,yBAAA;EACA,sBAAA;A1E0hXJ;;A0EthXA;EACE,cC10CM;A3Em2ZR;;A0EthXE;EACE,mBAAA;A1EyhXJ;;A0EthXA;;4BAAA;AAGA;;4BAAA;AAkCA;EACE,eCrrCc;EDsrCd,sBCrrCY;EDsrCZ,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;A1E0/WF;;A0Ex/WA;EACE,eC5rCiB;A3EurZnB;;A0Ez/WA;EACE,eC9rCiB;A3E0rZnB;;A0E1/WA;EACE,uBC/rCe;EDgsCf,eCjsCiB;A3E8rZnB;;A0E3/WA;EAKE,oBAAA;A1E0/WF;A0E9/WE;EACE,iBAAA;EACA,mBAAA;A1EggXJ;;A0Et/WE;EACE,6DAAA;A1Ey/WJ;A0Ex/WI;EACE,qBARyB;A1EkgX/B;;A0E7/WE;EACE,6DAAA;A1EggXJ;A0E//WI;EACE,qBARyB;A1EygX/B;;A0EpgXE;EACE,6DAAA;A1EugXJ;A0EtgXI;EACE,qBARyB;A1EghX/B;;A0E3gXE;EACE,6DAAA;A1E8gXJ;A0E7gXI;EACE,qBARyB;A1EuhX/B;;A0ElhXE;EACE,6DAAA;A1EqhXJ;A0EphXI;EACE,qBARyB;A1E8hX/B;;A0EzhXE;EACE,6DAAA;A1E4hXJ;A0E3hXI;EACE,qBARyB;A1EqiX/B;;A0EhiXE;EACE,6DAAA;A1EmiXJ;A0EliXI;EACE,qBARyB;A1E4iX/B;;A0EviXE;EACE,6DAAA;A1E0iXJ;A0EziXI;EACE,qBARyB;A1EmjX/B;;A0EjiXE;EACE,mBAN2B;EAO3B,qBAP2B;EAWzB,cCz6CE;A3E08ZR;A0E/hXI;EACE,qBAdyB;EAezB,mBAfyB;EAmBvB,cCj7CA;A3E+8ZR;A0E5hXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EA2BrB,cCz7CF;A3Eo9ZR;;A0EjjXE;EACE,mBAN2B;EAO3B,qBAP2B;EAWzB,cCz6CE;A3E09ZR;A0E/iXI;EACE,qBAdyB;EAezB,mBAfyB;EAmBvB,cCj7CA;A3E+9ZR;A0E5iXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EA2BrB,cCz7CF;A3Eo+ZR;;A0EjkXE;EACE,mBAN2B;EAO3B,qBAP2B;EAWzB,cCz6CE;A3E0+ZR;A0E/jXI;EACE,qBAdyB;EAezB,mBAfyB;EAmBvB,cCj7CA;A3E++ZR;A0E5jXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EA2BrB,cCz7CF;A3Eo/ZR;;A0EjlXE;EACE,mBAN2B;EAO3B,qBAP2B;EAWzB,cCz6CE;A3E0/ZR;A0E/kXI;EACE,qBAdyB;EAezB,mBAfyB;EAmBvB,cCj7CA;A3E+/ZR;A0E5kXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EA2BrB,cCz7CF;A3EogaR;;A0EjmXE;EACE,mBAN2B;EAO3B,qBAP2B;EAWzB,cCz6CE;A3E0gaR;A0E/lXI;EACE,qBAdyB;EAezB,mBAfyB;EAmBvB,cCj7CA;A3E+gaR;A0E5lXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EA2BrB,cCz7CF;A3EohaR;;A0EjnXE;EACE,mBAN2B;EAO3B,qBAP2B;EASzB,cC51CO;A3E+8Zb;A0E/mXI;EACE,qBAdyB;EAezB,mBAfyB;EAiBvB,cCp2CK;A3Eo9Zb;A0E5mXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EAyBrB,cC52CG;A3Ey9Zb;;A0EjoXE;EACE,mBAN2B;EAO3B,qBAP2B;EAWzB,cCz6CE;A3E0iaR;A0E/nXI;EACE,qBAdyB;EAezB,mBAfyB;EAmBvB,cCj7CA;A3E+iaR;A0E5nXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EA2BrB,cCz7CF;A3EojaR;;A0EjpXE;EACE,mBAN2B;EAO3B,qBAP2B;EAWzB,cCz6CE;A3E0jaR;A0E/oXI;EACE,qBAdyB;EAezB,mBAfyB;EAmBvB,cCj7CA;A3E+jaR;A0E5oXM;EACE,qBAtBuB;EAuBvB,mBAvBuB;EA2BrB,cCz7CF;A3EokaR;;A0EroXA;EACE,cCh8CM;A3EwkaR;A0EvoXE;EAEE,cCn8CI;A3E2kaR;;A0EroXA;EAvGE,kFAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1E2uXF;A0EpoXE;EAGE,gBAAA;EACA,iCAAA;EACA,2FAAA;A1EooXJ;;A0E1nXA;EA/HE,kFAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1EwvXF;A0EznXE;EAKE,gBAAA;EACA,iCAAA;EACA,2FAAA;A1EunXJ;;A0E7mXA;EAzJE,kFAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1EqwXF;A0E5mXE;EAKE,gBAAA;EACA,iCAAA;EACA,2FAAA;A1E0mXJ;;A0EhmXA;EAnLE,kFAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1EkxXF;A0E/lXE;EAKE,gBAAA;EACA,iCAAA;EACA,2FAAA;A1E6lXJ;;A0EnlXA;EA7ME,kFAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1E+xXF;A0EllXE;EAKE,gBAAA;EACA,iCAAA;EACA,2FAAA;A1EglXJ;;A0EtkXA;EAvOE,kFAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1E4yXF;A0ErkXE;EAKE,gBAAA;EACA,iCAAA;EACA,2FAAA;A1EmkXJ;;A0EzjXA;EACE,gBAAA;A1E4jXF;;A0E1jXA;EApQE,8EAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1E6zXF;A0EzjXE;EAKE,gBAAA;EACA,iCAAA;EACA,yFAAA;A1EujXJ;;A0E7iXA;EA9RE,kFAAA;EAMA,YAAA;EACA,cCt2CM;EDu2CN,0BAAA;EACA,yBAAA;A1E00XF;A0E5iXE;EAKE,gBAAA;EACA,iCAAA;EACA,2FAAA;A1E0iXJ;;A0E/hXE;EACE,yBAAA;EACA,yBAAA;EACA,cC3pDI;A3E6raR;;A0E/hXA;;4BAAA;AAGA;;4BAAA;AAGA;EACE,mBCr/CmB;EDs/CnB,WCr/CkB;EDs/ClB,yBAAA;EACA,qBAAA;EACA,kBCt/CoB;EDu/CpB,mDCt/CgB;A3EwhalB;A0EjiXE;EACE,yBC5qDI;ED6qDJ,mBAAA;EACA,aC//CW;EDggDX,gCAAA;EACA,2BC7/CkB;ED8/ClB,4BC9/CkB;A3EiiatB;A0EliXI;EACE,eC5/CkB;ED6/ClB,gBAAA;EACA,0BC7/CuB;ED8/CvB,gBCjgDoB;EDkgDpB,iBAAA;A1EoiXN;A0EliXI;EACE,eChgDkB;EDigDlB,cCnlDuB;EDolDvB,eAAA;EACA,cAAA;EACA,mBAAA;A1EoiXN;A0EjiXE;EACE,aCnhDW;EDohDX,6BCtnDgB;A3EypapB;A0EjiXM;EACE,gBAAA;A1EmiXR;A0E/hXE;EACE,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;A1EiiXJ;A0E/hXE;EACE,yBCjtDI;EDktDJ,6BAAA;EACA,aCpiDW;EDqiDX,8BCjiDkB;EDkiDlB,+BCliDkB;A3EmkatB;;A0E7hXE;EACE,oBAAA;A1EgiXJ;;A0E7hXA;;4BAAA;AAGA;;4BAAA;AAGA;EACE,yBCpuDM;EDquDN,6BAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;A1EgiXF;A0E/hXE;EACE,gBAAA;A1EiiXJ;;A0E5hXI;EACE,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;A1E+hXN;A0E9hXM;EACE,yBAAA;A1EgiXR;A0E/hXQ;EACE,cClrDK;EDmrDL,gBAAA;A1EiiXV;;A0E3hXA;;4BAAA;AAGA;;4BAAA;AAIA;EACE,eAAA;EACA,cCnwDU;EDowDV,gBAAA;EACA,yBAAA;A1E6hXF;A0E5hXE;EACE,gBAAA;EACA,gBAAA;EACA,cCjwDY;A3E+xahB;;A0E3hXA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,cClxDM;EDmxDN,cAAA;EACA,sBAAA;A1E8hXF;;A0E5hXA;EACE,eAAA;EACA,gBAAA;EACA,cCpxDK;EDqxDL,sBAAA;A1E+hXF;;A0E7hXA;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;A1EgiXF;;A0E9hXA;EACE,eAAA;EACA,cCjxDU;EDkxDV,gBAAA;A1EiiXF;;A0E/hXA;EACE,eAAA;EACA,gBAAA;EACA,cCzyDU;ED0yDV,iBAAA;EACA,sBAAA;A1EkiXF;;A0EhiXA;EACE,eAAA;EACA,gBAAA;EACA,cC7yDK;ED8yDL,iBAAA;A1EmiXF;;A0EjiXA;EACE,0CC1qDc;ED2qDd,eC1qDe;ED2qDf,kBAAA;EACA,kCAAA;EACA,cCrtDsB;EDstDtB,kBAAA;A1EoiXF;;A0EliXA;EACE,iBC/qDgB;EDgrDhB,qBAAA;EACA,gBAAA;EACA,kBCjrDiB;A3EstanB;;A0EniXA;EACE,qBAAA;A1EsiXF;;A0EpiXA;EACE,cC7zDc;A3Eo2ahB;;A0EriXA;EACE,2BAAA;A1EwiXF;;A0EtiXA;EACE,cCx0DK;EDy0DL,eC1rDoB;ED2rDpB,gBC1rDsB;ED2rDtB,qBC1rDyB;A3Emua3B;;A0EviXA;EACE,yBAAA;EACA,yBChxDY;EDixDZ,YC5rDiB;ED6rDjB,aC5rDgB;ED6rDhB,kBC5rDwB;A3Esua1B;;A0ExiXA;EACE,qBAAA;A1E2iXF;A0E1iXE;EACE,qBAAA;EACA,qBAAA;A1E4iXJ;A0E1iXE;EACE,aAAA;A1E4iXJ;;A0ExiXE;EACE,aAAA;A1E2iXJ;;A0ExiXA;EACE,sBC/1Dc;A3E04ahB;;A0EziXA;EACE,mBAAA;EACA,YAAA;A1E4iXF;;A0E1iXA;EACE,wBAAA;A1E6iXF;;A0E1iXE;EACE,0BCzyDgB;A3Es1apB;;A0E1iXA;EACE,yBAAA;A1E6iXF;;A0E3iXA;EACE,yBAAA;A1E8iXF;;A0E5iXA;EACE,yBAAA;A1E+iXF;;A0E7iXA;;4BAAA;AAGA;;4BAAA;AAIA;EACE,cCnyDsB;EDoyDtB,0BCh0DW;EDi0DX,gBC5xDmB;A3E20arB;;A0E7iXA;EACE,+BAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;A1EgjXF;;A0E9iXA;EACE,UAAA;EACA,0BAAA;EACA,mBAAA;A1EijXF;A0EhjXE;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;A1EkjXJ;A0EhjXE;EACE,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;A1EkjXJ;;A0E/hXA,yCAAA;AAEE;EACE,yBCr8DI;EDs8DJ,YA9DU;EA+DV,eC9zDmB;ED+zDnB,MC9zDc;ED+zDd,WC9zDkB;ED+zDlB,iDC9zDiB;ED+zDjB,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBCp2DY;EDq2DZ,gBC/1DiB;A3Eg4arB;A0EhiXI;EACE,cAAA;EACA,WAAA;EACA,gBCn2De;A3Eq4arB;A0E9hXI;EACE,8BAAA;EACA,gBAjFQ;EAkFR,eC91Dc;ED+1Dd,kBAAA;EACA,yBCt5DQ;A3Es7ad;A0E9hXI;EACE,iBCh2DgB;EDi2DhB,oBCj2DgB;A3Ei4atB;A0E/hXM;EACE,mBAAA;A1EiiXR;A0EhiXQ;EACE,aAAA;EACA,mBAAA;A1EkiXV;A0EhiXQ;EACE,eCx2Da;EDy2Db,gBCx2DiB;EDy2DjB,gBCx2De;EDy2Df,yBCx2DiB;EDy2DjB,mBC/+DI;A3Eihbd;A0EjiXU;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,cC34DiB;ED44DjB,gBAAA;A1EmiXZ;A0E/hXM;EACE,6BC56DY;ED66DZ,UAAA;EACA,gBAAA;A1EiiXR;A0EhiXQ;EACE,mBChgEI;A3Ekibd;A0EhiXY;EACE,YC33DO;A3E65arB;A0E9hXY;EACE,WCj4DI;EDk4DJ,YCl4DI;EDm4DJ,wBCj4Dc;A3Ei6a5B;;A0ExhXA,yCAAA;AACA,uCAAA;AACA;EACE,gBAAA;A1E2hXF;A0E1hXE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eCn6DwB;EDo6DxB,SAAA;A1E4hXJ;A0E3hXI;EACE,cC/gEU;A3E4ibhB;A0E5hXM;;EAEE,cClhEQ;A3EgjbhB;A0E1hXM;EACE,kBAAA;A1E4hXR;A0E1hXM;EACE,qBAAA;A1E4hXR;A0EzhXI;EACE,iBAAA;EACA,iBCp7DwB;A3E+8a9B;A0EvhXY;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A1EyhXd;A0ExhXc;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;A1E0hXhB;A0ExhXc;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBCvjEA;EDwjEA,kBAAA;EACA,UAAA;EACA,UAAA;A1E0hXhB;A0EthXU;EACE,gBCj9D4B;EDk9D5B,WCp9DsB;EDq9DtB,YCr9DsB;A3E6+alC;A0EvhXY;EACE,cCnkEE;A3E4lbhB;A0EthXU;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBC1kEI;ED2kEJ,kBAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;A1EwhXZ;A0EthXU;EACE,UAAA;EACA,aAAA;A1EwhXZ;A0EphXM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;A1EshXR;A0ErhXQ;EACE;IACE,UAAA;E1EuhXV;E0EphXQ;IACE,UAAA;E1EshXV;E0EnhXQ;IACE,UAAA;E1EqhXV;E0ElhXQ;IACE,UAAA;E1EohXV;AACF;A0EjhXM;EACE,eAAA;A1EmhXR;A0EjhXM;EACE;IACE,mBAAA;IACA,UAAA;E1EmhXR;E0EjhXM;IACE,qBAAA;IACA,YAAA;E1EmhXR;E0EjhXM;IACE,qBAAA;IACA,YAAA;E1EmhXR;E0EjhXM;IACE,qBAAA;IACA,YAAA;E1EmhXR;E0EjhXM;IACE,mBAAA;IACA,UAAA;E1EmhXR;AACF;A0EjhXM;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;A1EmhXR;A0ElhXQ;EACE,kBAAA;EACA,8BAAA;EACA,eAAA;A1EohXV;A0EnhXU;EACE,UAAA;EACA,iBAAA;A1EqhXZ;A0EnhXc;EACE,WAAA;EACA,kBAAA;A1EqhXhB;A0EphXgB;EACE,0BAAA;A1EshXlB;A0EnhXkB;EACE,0BAAA;EACA,gBAAA;A1EqhXpB;A0ElhXgB;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBCvmEL;EDwmEK,UAAA;EACA,SAAA;A1EohXlB;A0ElhXgB;EACE,kBAAA;EACA,gBAAA;EACA,wBC7rEH;ED8rEG,SAAA;EACA,UAAA;EACA,cAAA;A1EohXlB;A0E/gXU;EACE,iBAAA;EACA,gBAAA;A1EihXZ;A0E/gXU;EACE,iBAAA;EACA,+BAAA;EACA,eAAA;A1EihXZ;A0E/gXU;EACE,qBAAA;A1EihXZ;A0E/gXU;EACE,eAAA;EACA,kBAAA;EACA,cClsEI;A3EmtbhB;A0EhhXY;EACE,aAAA;EACA,YAAA;EACA,YAAA;A1EkhXd;A0EjhXc;EAEE,aAAA;EACA,WAAA;A1EkhXhB;A0EhhXc;EACE,cAAA;A1EkhXhB;A0EjhXgB;EACE,eAAA;EACA,cCjpEL;A3Eoqbb;A0ElhXkB;EACE,iBAAA;EACA,eAAA;EACA,cCrpEP;A3Eyqbb;A0E7gXQ;EACE,eAAA;A1E+gXV;A0E5gXM;EACE,SAAA;A1E8gXR;A0E5gXM;EACE,YAAA;EACA,gBAAA;EACA,SAAA;A1E8gXR;A0E7gXQ;EACE,iBAAA;A1E+gXV;A0E9gXU;EACE,cC1qEC;ED2qED,qBAAA;A1EghXZ;A0E/gXY;EACE,kBAAA;A1EihXd;A0E9gXU;EACE,cAAA;A1EghXZ;A0E5gXM;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;A1E8gXR;A0E7gXQ;EAEE,aAAA;EACA,WAAA;A1E8gXV;A0E5gXQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;A1E8gXV;A0E7gXU;EACE,oBAAA;A1E+gXZ;A0E7gXU;EACE,6BAAA;A1E+gXZ;A0E7gXU;EACE,cAAA;A1E+gXZ;A0E5gXY;EACE,cC7wEE;ED8wEF,gBC1qEO;A3EwrbrB;A0E7gXc;EACE,yBAAA;A1E+gXhB;A0E9gXgB;;;EAGE,yBAAA;A1EghXlB;A0E3gXU;EACE,cC/rEY;EDgsEZ,gBCvrES;EDwrET,aAAA;EACA,mBAAA;EACA,qBAAA;A1E6gXZ;A0E5gXY;EACE,kBAAA;EACA,cCtsEU;A3EotbxB;A0E7gXc;EACE,cCxsEQ;A3EutbxB;A0ExgXI;EACE,qBAAA;EACA,kBAAA;A1E0gXN;;A0ErgXE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;A1EwgXJ;A0EtgXE;EACE,eAAA;EACA,kBAAA;A1EwgXJ;A0EvgXI;EACE,aAAA;A1EygXN;A0EhgXI;EACE,yBAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBC9wEQ;ED+wER,eAAA;A1EkgXN;;A0E9/WA;EACE,YAAA;EACA,YAAA;EACA,aAAA;A1EigXF;A0EhgXE;EAEE,wBAAA;EACA,sBAAA;A1EigXJ;A0E//WE;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;A1EigXJ;A0EhgXI;EACE,qBAAA;A1EkgXN;A0E//WM;EACE,gBAAA;EACA,cCnyEI;EDoyEJ,eAAA;A1EigXR;A0E7/WM;EACE,wBAAA;EACA,kBAAA;EACA,wBAAA;A1E+/WR;A0E5/WQ;;EAEE,cC92EM;A3E42bhB;A0E1/WQ;;EAEE,cC9zEM;A3E0zbhB;A0Ex/WQ;;EAEE,cCj0EK;A3E2zbf;A0Et/WI;EACE,iBAAA;A1Ew/WN;A0Er/WM;EACE,yBCz0EM;A3Eg0bd;;A0El/WA;EACE,SA7gBY;EA8gBZ,kBAAA;EACA,UAAA;EACA,yBCx5EM;EDy5EN,2BAAA;A1Eq/WF;A0Ej/WM;EACE,wBAAA;A1Em/WR;A0El/WQ;;EAEE,yBAAA;A1Eo/WV;;A0E9+WA,sCAAA;AACA;;4BAAA;AAKI;EACE,0BAAA;EACA,cAAA;EACA,8CCn0EW;A3EkzbjB;A0E7+WI;EACE,YCz0EU;ED00EV,eCz0Ea;ED00Eb,mBCr7EE;EDs7EF,MAAA;EACA,aAAA;EACA,UCz0EY;ED00EZ,gBCz0Ee;A3EwzbrB;A0E9+WM;EACE,oBAAA;EACA,WAAA;EACA,YArjBM;EAsjBN,aC30Ec;ED40Ed,mBAAA;EACA,6BCn3EY;EDo3EZ,WCtzEc;EDuzEd,oDAAA;A1Eg/WR;A0E/+WQ;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;A1Ei/WV;A0E9+WM;EACE,kBChwEuB;EDiwEvB,sDChwEsB;EDiwEtB,kBAAA;A1Eg/WR;A0E/+WQ;EACE,cCn8EM;EDo8EN,yBClwE0B;EDmwE1B,gBClwEwB;EDmwExB,qBClwE4B;EDmwE5B,kBClwEqB;A3Emvb/B;A0E/+WQ;EACE,yBCxwE0B;EDywE1B,gBCxwEwB;EDywExB,eCtwE4B;EDuwE5B,kBCtwEyB;A3EuvbnC;A0E/+WQ;EACE,4CCxwEmB;A3Eyvb7B;A0E9+WM;EACE,gBCzwEkB;ED0wElB,SCzwEmB;ED0wEnB,aC5wEe;A3E4vbvB;A0E/+WQ;EACE,eCxwEU;EDywEV,qBCxwEe;EDywEf,oBCpwEe;EDqwEf,iBCtwEY;EDuwEZ,0BC1wEc;ED2wEd,gBC1wEY;ED2wEZ,cCn4Ec;A3Eo3bxB;A0Eh/WU;EACE,WCnxEQ;EDoxER,YCpxEQ;EDqxER,kBCpxEU;EDqxEV,iBCpxEgB;EDqxEhB,2BAAA;A1Ek/WZ;A0E1+WkB;EACE,gBAAA;EACA,gBC14EC;A3Es3brB;A0Ep+WU;EACE,cAAA;EACA,gBCp5ES;A3E03brB;A0Er+WY;EACE,cC1/EE;ED2/EF,gBCv5EO;A3E83brB;A0Er+WY;EACE,cC9/EE;ED+/EF,iBCryEkB;EDsyElB,gBC55EO;A3Em4brB;A0Er+WY;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,eCzyEO;A3EgxbrB;A0Et+Wc;EACE,gBCxyEK;A3EgxbrB;A0Et+Wc;EACE,eAAA;A1Ew+WhB;A0Ep+WU;EACE,eAAA;EACA,iBAAA;A1Es+WZ;A0Ep+WU;EACE,iBAAA;EACA,0BAAA;A1Es+WZ;A0E59WU;EACE,gBCx0EgB;EDy0EhB,aC10EiB;ED20EjB,cCv8EY;EDw8EZ,gBCh1EU;EDi1EV,gBCh8ES;A3E85brB;A0E39WY;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBC18EO;A3Eu6brB;A0Et9WkB;EACE,gBCv1EA;EDw1EA,wBCzkFL;ED0kFK,gBCp9EC;A3E46brB;A0En9WY;EACE,cAAA;EACA,wBAAA;EACA,yBAAA;EACA,wCAAA;EAEA,4BAAA;EACA,iBAAA;A1Eo9Wd;A0El9WgB;EACE,gBAAA;A1Eo9WlB;A0E98WQ;EACE,qBAAA;A1Eg9WV;A0E98WQ;EACE,aAAA;EACA,4BAAA;EACA,0BAAA;EACA,gBAAA;A1Eg9WV;A0E/8WU;EACE,yBAAA;A1Ei9WZ;A0E98WY;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cC/hFF;EDgiFE,gBC1/EO;ED2/EP,0BCt4EW;EDu4EX,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;A1Eg9Wd;A0E98WgB;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;A1Eg9WlB;A0E98WgB;EACE,WAAA;A1Eg9WlB;A0E98WgB;EACE,WAAA;A1Eg9WlB;A0E78Wc;EACE,cCpnFA;EDqnFA,gBCjhFK;A3Eg+brB;A0E78Wc;EACE,cCxnFA;A3EukchB;A0E58WY;EACE,cCjiFU;A3E++bxB;A0E78Wc;EACE,cC9nFA;A3E6kchB;A0Ez8WM;EACE,kBCviFQ;EDwiFR,gBCliFa;A3E6+brB;A0Ez8WM;EACE,cAAA;EACA,yBAAA;A1E28WR;A0E18WQ;EACE,cAAA;EACA,gBCziFW;A3Eq/brB;A0E18WQ;EACE,cAAA;EACA,mBAAA;A1E48WV;A0E18WQ;EACE,uBAAA;A1E48WV;A0Ev8WM;EACE,gBCtjFa;EDujFb,4BAAA;A1Ey8WR;A0Ev8WM;EACE,gBC1jFa;ED2jFb,yBAAA;A1Ey8WR;;A0Ep8WA;EACE,SAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,6CAAA;A1Eu8WF;A0Et8WE;EACE,QAAA;EACA,gBC5kFiB;A3EohcrB;A0Er8WI;EACE,gBAAA;A1Eu8WN;A0Ep8WE;EACE,kBAAA;EACA,yBC/nFU;EDgoFV,aAAA;A1Es8WJ;A0Er8WI;EACE,cC9nFM;ED+nFN,WAAA;EACA,yBC1sFE;ED2sFF,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;A1Eu8WN;A0Er8WI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,cC5oFO;A3Emlcb;A0El8WM;EACE,iBAAA;A1Eo8WR;A0En8WQ;EACE,kBAAA;A1Eq8WV;A0Eh8WE;EACE,WAAA;EACA,YAAA;EACA,eAAA;A1Ek8WJ;;A0E/7WA;;4BAAA;AAGA;;4BAAA;AAGA,mCAAA;AAGE;EACE,YAAA;A1Eg8WJ;;A0Ej8WE;EACE,YAAA;A1Eo8WJ;;A0Er8WE;EACE,aAAA;A1Ew8WJ;;A0Ez8WE;EACE,aAAA;A1E48WJ;;A0E78WE;EACE,aAAA;A1Eg9WJ;;A0Ej9WE;EACE,aAAA;A1Eo9WJ;;A0Er9WE;EACE,aAAA;A1Ew9WJ;;A0Ez9WE;EACE,aAAA;A1E49WJ;;A0E79WE;EACE,aAAA;A1Eg+WJ;;A0Ej+WE;EACE,aAAA;A1Eo+WJ;;A0Er+WE;EACE,aAAA;A1Ew+WJ;;A0Ep+WA,iCAAA;AACA,wCAAA;AAGE;EACE,iBAAA;A1Eq+WJ;;A0Et+WE;EACE,iBAAA;A1Ey+WJ;;A0E1+WE;EACE,kBAAA;A1E6+WJ;;A0E9+WE;EACE,kBAAA;A1Ei/WJ;;A0El/WE;EACE,kBAAA;A1Eq/WJ;;A0Et/WE;EACE,kBAAA;A1Ey/WJ;;A0E1/WE;EACE,kBAAA;A1E6/WJ;;A0E9/WE;EACE,kBAAA;A1EigXJ;;A0ElgXE;EACE,kBAAA;A1EqgXJ;;A0EtgXE;EACE,kBAAA;A1EygXJ;;A0E1gXE;EACE,kBAAA;A1E6gXJ;;A0EzgXA,sCAAA;AACA,uCAAA;AAGE;EACE,2BAAA;A1E0gXJ;;A0E3gXE;EACE,2BAAA;A1E8gXJ;;A0E/gXE;EACE,4BAAA;A1EkhXJ;;A0EnhXE;EACE,4BAAA;A1EshXJ;;A0EvhXE;EACE,4BAAA;A1E0hXJ;;A0E3hXE;EACE,4BAAA;A1E8hXJ;;A0E/hXE;EACE,4BAAA;A1EkiXJ;;A0EniXE;EACE,4BAAA;A1EsiXJ;;A0EviXE;EACE,4BAAA;A1E0iXJ;;A0E3iXE;EACE,4BAAA;A1E8iXJ;;A0E/iXE;EACE,4BAAA;A1EkjXJ;;A0E9iXA,qCAAA;AACA,0CAAA;AAGE;EACE,8BAAA;A1E+iXJ;;A0EhjXE;EACE,8BAAA;A1EmjXJ;;A0EpjXE;EACE,+BAAA;A1EujXJ;;A0ExjXE;EACE,+BAAA;A1E2jXJ;;A0E5jXE;EACE,+BAAA;A1E+jXJ;;A0EhkXE;EACE,+BAAA;A1EmkXJ;;A0EpkXE;EACE,+BAAA;A1EukXJ;;A0ExkXE;EACE,+BAAA;A1E2kXJ;;A0E5kXE;EACE,+BAAA;A1E+kXJ;;A0EhlXE;EACE,+BAAA;A1EmlXJ;;A0EplXE;EACE,+BAAA;A1EulXJ;;A0EnlXA,wCAAA;AACA,yCAAA;AAGE;EACE,kBAAA;A1EolXJ;;A0ErlXE;EACE,kBAAA;A1EwlXJ;;A0EzlXE;EACE,mBAAA;A1E4lXJ;;A0E7lXE;EACE,mBAAA;A1EgmXJ;;A0EjmXE;EACE,mBAAA;A1EomXJ;;A0ErmXE;EACE,mBAAA;A1EwmXJ;;A0EzmXE;EACE,mBAAA;A1E4mXJ;;A0E7mXE;EACE,mBAAA;A1EgnXJ;;A0EjnXE;EACE,mBAAA;A1EonXJ;;A0ErnXE;EACE,mBAAA;A1EwnXJ;;A0EznXE;EACE,mBAAA;A1E4nXJ;;A0ExnXA,uCAAA;AACA,kCAAA;AAGE;EACE,sBAAA;A1EynXJ;;A0E1nXE;EACE,sBAAA;A1E6nXJ;;A0E9nXE;EACE,uBAAA;A1EioXJ;;A0EloXE;EACE,uBAAA;A1EqoXJ;;A0EtoXE;EACE,uBAAA;A1EyoXJ;;A0E1oXE;EACE,uBAAA;A1E6oXJ;;A0E9oXE;EACE,uBAAA;A1EipXJ;;A0ElpXE;EACE,uBAAA;A1EqpXJ;;A0EtpXE;EACE,uBAAA;A1EypXJ;;A0E1pXE;EACE,uBAAA;A1E6pXJ;;A0E9pXE;EACE,uBAAA;A1EiqXJ;;A0E7pXA,gCAAA;AACA,sCAAA;AAGE;EACE,0BAAA;A1E8pXJ;;A0E/pXE;EACE,0BAAA;A1EkqXJ;;A0EnqXE;EACE,2BAAA;A1EsqXJ;;A0EvqXE;EACE,2BAAA;A1E0qXJ;;A0E3qXE;EACE,2BAAA;A1E8qXJ;;A0E/qXE;EACE,2BAAA;A1EkrXJ;;A0EnrXE;EACE,2BAAA;A1EsrXJ;;A0EvrXE;EACE,2BAAA;A1E0rXJ;;A0E3rXE;EACE,2BAAA;A1E8rXJ;;A0E/rXE;EACE,2BAAA;A1EksXJ;;A0EnsXE;EACE,2BAAA;A1EssXJ;;A0ElsXA,oCAAA;AACA,yCAAA;AAGE;EACE,6BAAA;A1EmsXJ;;A0EpsXE;EACE,6BAAA;A1EusXJ;;A0ExsXE;EACE,8BAAA;A1E2sXJ;;A0E5sXE;EACE,8BAAA;A1E+sXJ;;A0EhtXE;EACE,8BAAA;A1EmtXJ;;A0EptXE;EACE,8BAAA;A1EutXJ;;A0ExtXE;EACE,8BAAA;A1E2tXJ;;A0E5tXE;EACE,8BAAA;A1E+tXJ;;A0EhuXE;EACE,8BAAA;A1EmuXJ;;A0EpuXE;EACE,8BAAA;A1EuuXJ;;A0ExuXE;EACE,8BAAA;A1E2uXJ;;A0EvuXA,uCAAA;AACA,uCAAA;AAGE;EACE,2BAAA;A1EwuXJ;;A0EzuXE;EACE,2BAAA;A1E4uXJ;;A0E7uXE;EACE,4BAAA;A1EgvXJ;;A0EjvXE;EACE,4BAAA;A1EovXJ;;A0ErvXE;EACE,4BAAA;A1EwvXJ;;A0EzvXE;EACE,4BAAA;A1E4vXJ;;A0E7vXE;EACE,4BAAA;A1EgwXJ;;A0EjwXE;EACE,4BAAA;A1EowXJ;;A0ErwXE;EACE,4BAAA;A1EwwXJ;;A0EzwXE;EACE,4BAAA;A1E4wXJ;;A0E7wXE;EACE,4BAAA;A1EgxXJ;;A0E5wXA,qCAAA;AACA,wCAAA;AAGE;EACE,iBAAA;A1E6wXJ;;A0E9wXE;EACE,iBAAA;A1EixXJ;;A0ElxXE;EACE,kBAAA;A1EqxXJ;;A0EtxXE;EACE,kBAAA;A1EyxXJ;;A0E1xXE;EACE,kBAAA;A1E6xXJ;;A0E9xXE;EACE,kBAAA;A1EiyXJ;;A0ElyXE;EACE,kBAAA;A1EqyXJ;;A0EtyXE;EACE,kBAAA;A1EyyXJ;;A0E1yXE;EACE,kBAAA;A1E6yXJ;;A0E9yXE;EACE,kBAAA;A1EizXJ;;A0ElzXE;EACE,kBAAA;A1EqzXJ;;A0EjzXA,sCAAA;AACA,yCAAA;AAGE;EACE,6BAAA;A1EkzXJ;;A0EnzXE;EACE,6BAAA;A1EszXJ;;A0EvzXE;EACE,6BAAA;A1E0zXJ;;A0E3zXE;EACE,6BAAA;A1E8zXJ;;A0E/zXE;EACE,6BAAA;A1Ek0XJ;;A0En0XE;EACE,6BAAA;A1Es0XJ;;A0Ev0XE;EACE,6BAAA;A1E00XJ;;A0E30XE;EACE,6BAAA;A1E80XJ;;A0E/0XE;EACE,6BAAA;A1Ek1XJ;;A0En1XE;EACE,6BAAA;A1Es1XJ;;A0Ev1XE;EACE,8BAAA;A1E01XJ;;A0Et1XA,uCAAA;AACA,qCAAA;AAGE;EACE,eAAA;A1Eu1XJ;;A0Ex1XE;EACE,eAAA;A1E21XJ;;A0E51XE;EACE,eAAA;A1E+1XJ;;A0Eh2XE;EACE,eAAA;A1Em2XJ;;A0Ep2XE;EACE,eAAA;A1Eu2XJ;;A0Ex2XE;EACE,eAAA;A1E22XJ;;A0E52XE;EACE,eAAA;A1E+2XJ;;A0Eh3XE;EACE,eAAA;A1Em3XJ;;A0Ep3XE;EACE,eAAA;A1Eu3XJ;;A0Ex3XE;EACE,eAAA;A1E23XJ;;A0E53XE;EACE,eAAA;A1E+3XJ;;A0Eh4XE;EACE,eAAA;A1Em4XJ;;A0Ep4XE;EACE,eAAA;A1Eu4XJ;;A0Ex4XE;EACE,eAAA;A1E24XJ;;A0E54XE;EACE,eAAA;A1E+4XJ;;A0Eh5XE;EACE,eAAA;A1Em5XJ;;A0Ep5XE;EACE,eAAA;A1Eu5XJ;;A0Ex5XE;EACE,eAAA;A1E25XJ;;A0E55XE;EACE,eAAA;A1E+5XJ;;A0Eh6XE;EACE,eAAA;A1Em6XJ;;A0Ep6XE;EACE,eAAA;A1Eu6XJ;;A0Ex6XE;EACE,eAAA;A1E26XJ;;A0E56XE;EACE,eAAA;A1E+6XJ;;A0Eh7XE;EACE,eAAA;A1Em7XJ;;A0Ep7XE;EACE,eAAA;A1Eu7XJ;;A0Ex7XE;EACE,eAAA;A1E27XJ;;A0E57XE;EACE,eAAA;A1E+7XJ;;A0Eh8XE;EACE,eAAA;A1Em8XJ;;A0Ep8XE;EACE,eAAA;A1Eu8XJ;;A0Ex8XE;EACE,eAAA;A1E28XJ;;A0E58XE;EACE,eAAA;A1E+8XJ;;A0Eh9XE;EACE,eAAA;A1Em9XJ;;A0Ep9XE;EACE,eAAA;A1Eu9XJ;;A0Ex9XE;EACE,eAAA;A1E29XJ;;A0E59XE;EACE,eAAA;A1E+9XJ;;A0Eh+XE;EACE,eAAA;A1Em+XJ;;A0Ep+XE;EACE,eAAA;A1Eu+XJ;;A0Ex+XE;EACE,eAAA;A1E2+XJ;;A0E5+XE;EACE,eAAA;A1E++XJ;;A0Eh/XE;EACE,eAAA;A1Em/XJ;;A0Ep/XE;EACE,eAAA;A1Eu/XJ;;A0Ex/XE;EACE,eAAA;A1E2/XJ;;A0E5/XE;EACE,eAAA;A1E+/XJ;;A0EhgYE;EACE,eAAA;A1EmgYJ;;A0EpgYE;EACE,gBAAA;A1EugYJ;;A0EngYA,mCAAA;AACA,uCAAA;AAGE;EACE,gBAHA;A1EugYJ;;A0ErgYE;EACE,gBAHA;A1E2gYJ;;A0EzgYE;EACE,gBAHA;A1E+gYJ;;A0E7gYE;EACE,gBAHA;A1EmhYJ;;A0EjhYE;EACE,gBAHA;A1EuhYJ;;A0ErhYE;EACE,gBAHA;A1E2hYJ;;A0ErhYA,qCAAA;AACA,sCAAA;AAGE;EACE,kBAHA;A1EyhYJ;;A0EvhYE;EACE,kBAHA;A1E6hYJ;;A0E3hYE;EACE,mBAHA;A1EiiYJ;;A0E/hYE;EACE,mBAHA;A1EqiYJ;;A0EniYE;EACE,mBAHA;A1EyiYJ;;A0EniYA,oCAAA;AACA,2CAAA;AAIE;EACE,yBAJA;A1EuiYJ;;A0EpiYE;EACE,6BAJA;A1E2iYJ;;A0ExiYE;EACE,0BAJA;A1E+iYJ;;A0E5iYE;EACE,+BAJA;UAIA,uBAJA;A1EmjYJ;;A0EhjYE;EACE,sBAJA;A1EujYJ;;A0EpjYE;EACE,+BAJA;UAIA,uBAJA;A1E2jYJ;;A0ExjYE;EACE,wBAJA;A1E+jYJ;;A0E5jYE;EACE,qBAJA;A1EmkYJ;;A0EhkYE;EACE,8BAJA;UAIA,sBAJA;A1EukYJ;;A0EpkYE;EACE,6BAJA;UAIA,qBAJA;A1E2kYJ;;A0ExkYE;EACE,wBAJA;A1E+kYJ;;A0E5kYE;EACE,+BAJA;UAIA,uBAJA;A1EmlYJ;;A0E5kYA,yCAAA;AACA,0CAAA;AAIE;EACE,wBAJA;A1EglYJ;;A0E7kYE;EACE,mBAJA;A1EolYJ;;A0EjlYE;EACE,qBAJA;A1EwlYJ;;A0ErlYE;EACE,mBAJA;A1E4lYJ;;A0EzlYE;EACE,wBAJA;A1EgmYJ;;A0E7lYE;EACE,sBAJA;A1EomYJ;;A0EjmYE;EACE,sBAJA;A1EwmYJ;;A0ErmYE;EACE,2BAJA;A1E4mYJ;;A0EzmYE;EACE,uBAJA;A1EgnYJ;;A0E7mYE;EACE,uBAJA;A1EonYJ;;A0E7mYA,wCAAA;AACA,oCAAA;AAGE;EACE,gBAHA;A1EinYJ;;A0E/mYE;EACE,kBAHA;A1EqnYJ;;A0EnnYE;EACE,eAHA;A1EynYJ;;A0EvnYE;EACE,kBAHA;A1E6nYJ;;A0E3nYE;EACE,iBAHA;A1EioYJ;;A0E/nYE;EACE,iBAHA;A1EqoYJ;;A0E/nYA,kCAAA;AACA,iCAAA;AAGE;EACE,WAHA;A1EmoYJ;;A0EjoYE;EACE,YAHA;A1EuoYJ;;A0EroYE;EACE,WAHA;A1E2oYJ;;A0EroYA,+BAAA;AACA,oCAAA;AAGE;EACE,gBAHA;A1EyoYJ;;A0EvoYE;EACE,iBAHA;A1E6oYJ;;A0E3oYE;EACE,cAHA;A1EipYJ;;A0E3oYA,kCAAA;AACA,uCAAA;AAGE;EACE,sBAAA;A1E4oYJ;;A0E7oYE;EACE,sBAAA;A1EgpYJ;;A0EjpYE;EACE,sBAAA;A1EopYJ;;A0ErpYE;EACE,sBAAA;A1EwpYJ;;A0EzpYE;EACE,sBAAA;A1E4pYJ;;A0E7pYE;EACE,sBAAA;A1EgqYJ;;A0EjqYE;EACE,sBAAA;A1EoqYJ;;A0ErqYE;EACE,sBAAA;A1EwqYJ;;A0EzqYE;EACE,sBAAA;A1E4qYJ;;A0E7qYE;EACE,uBAAA;A1EgrYJ;;A0E5qYA,qCAAA;AACA,sCAAA;AAME;EACE,yBAAA;A1E0qYJ;;A0E3qYE;EACE,yBAAA;A1E8qYJ;;A0E/qYE;EACE,yBAAA;A1EkrYJ;;A0EnrYE;EACE,yBAAA;A1EsrYJ;;A0EvrYE;EACE,yBAAA;A1E0rYJ;;A0E3rYE;EACE,yBAAA;A1E8rYJ;;A0E/rYE;EACE,yBAAA;A1EksYJ;;A0EnsYE;EACE,yBAAA;A1EssYJ;;A0EnsYA,oCAAA;AACA,2CAAA;AACA;EACE,kBAAA;EACA,cC36FM;ED46FN,eAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;A1EssYF;;A0EpsYA,yCAAA;AACA,2CAAA;AAME;EACE,yBAAA;A1EksYJ;;A0EnsYE;EACE,yBAAA;A1EssYJ;;A0EvsYE;EACE,yBAAA;A1E0sYJ;;A0E3sYE;EACE,yBAAA;A1E8sYJ;;A0E/sYE;EACE,yBAAA;A1EktYJ;;A0EntYE;EACE,yBAAA;A1EstYJ;;A0EvtYE;EACE,yBAAA;A1E0tYJ;;A0E3tYE;EACE,yBAAA;A1E8tYJ;;A0E3tYA,wCAAA;AACA,gDAAA;AAOE;EACE,oCAAA;EACA,cCt8FI;A3E8peR;;A0E1tYE;EACE,oCAAA;EACA,cCt8FI;A3EmqeR;;A0E/tYE;EACE,oCAAA;EACA,cCt8FI;A3EwqeR;;A0EpuYE;EACE,oCAAA;EACA,cCt8FI;A3E6qeR;;A0EzuYE;EACE,oCAAA;EACA,cCt8FI;A3EkreR;;A0E9uYE;EACE,oCAAA;EACA,cCt8FI;A3EureR;;A0EnvYE;EACE,oCAAA;EACA,cCt8FI;A3E4reR;;A0ExvYE;EACE,oCAAA;EACA,cCt8FI;A3EiseR;;A0ExvYA,6CAAA;AACA,0CAAA;AAKA,uCAAA;AACA,4CAAA;AAOE;EACE,oCAAA;EACA,gCAAA;A1EivYJ;A0EhvYI;EACE,oCAAA;EACA,gCAAA;A1EkvYN;A0EhvYI;EACE,oCAAA;EACA,gCAAA;A1EkvYN;A0EhvYI;EAIE,oCAAA;EACA,gCAAA;A1E+uYN;A0E7uYI;EACE,gCAAA;A1E+uYN;;A0ElwYE;EACE,oCAAA;EACA,gCAAA;A1EqwYJ;A0EpwYI;EACE,oCAAA;EACA,gCAAA;A1EswYN;A0EpwYI;EACE,oCAAA;EACA,gCAAA;A1EswYN;A0EpwYI;EAIE,oCAAA;EACA,gCAAA;A1EmwYN;A0EjwYI;EACE,gCAAA;A1EmwYN;;A0EtxYE;EACE,oCAAA;EACA,gCAAA;A1EyxYJ;A0ExxYI;EACE,oCAAA;EACA,gCAAA;A1E0xYN;A0ExxYI;EACE,oCAAA;EACA,gCAAA;A1E0xYN;A0ExxYI;EAIE,oCAAA;EACA,gCAAA;A1EuxYN;A0ErxYI;EACE,gCAAA;A1EuxYN;;A0E1yYE;EACE,oCAAA;EACA,gCAAA;A1E6yYJ;A0E5yYI;EACE,oCAAA;EACA,gCAAA;A1E8yYN;A0E5yYI;EACE,oCAAA;EACA,gCAAA;A1E8yYN;A0E5yYI;EAIE,oCAAA;EACA,gCAAA;A1E2yYN;A0EzyYI;EACE,gCAAA;A1E2yYN;;A0E9zYE;EACE,oCAAA;EACA,gCAAA;A1Ei0YJ;A0Eh0YI;EACE,oCAAA;EACA,gCAAA;A1Ek0YN;A0Eh0YI;EACE,oCAAA;EACA,gCAAA;A1Ek0YN;A0Eh0YI;EAIE,oCAAA;EACA,gCAAA;A1E+zYN;A0E7zYI;EACE,gCAAA;A1E+zYN;;A0El1YE;EACE,oCAAA;EACA,gCAAA;A1Eq1YJ;A0Ep1YI;EACE,oCAAA;EACA,gCAAA;A1Es1YN;A0Ep1YI;EACE,oCAAA;EACA,gCAAA;A1Es1YN;A0Ep1YI;EAIE,oCAAA;EACA,gCAAA;A1Em1YN;A0Ej1YI;EACE,8BAAA;A1Em1YN;;A0Et2YE;EACE,oCAAA;EACA,gCAAA;A1Ey2YJ;A0Ex2YI;EACE,oCAAA;EACA,gCAAA;A1E02YN;A0Ex2YI;EACE,oCAAA;EACA,gCAAA;A1E02YN;A0Ex2YI;EAIE,oCAAA;EACA,gCAAA;A1Eu2YN;A0Er2YI;EACE,gCAAA;A1Eu2YN;;A0E13YE;EACE,oCAAA;EACA,gCAAA;A1E63YJ;A0E53YI;EACE,oCAAA;EACA,gCAAA;A1E83YN;A0E53YI;EACE,oCAAA;EACA,gCAAA;A1E83YN;A0E53YI;EAIE,oCAAA;EACA,gCAAA;A1E23YN;A0Ez3YI;EACE,gCAAA;A1E23YN;;A0Ev3YA,0CAAA;AAOE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1Eo3YJ;A0En3YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1Ek3YN;;A0E53YE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1E+3YJ;A0E93YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1E63YN;;A0Ev4YE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1E04YJ;A0Ez4YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1Ew4YN;;A0El5YE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1Eq5YJ;A0Ep5YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1Em5YN;;A0E75YE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1Eg6YJ;A0E/5YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1E85YN;;A0Ex6YE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1E26YJ;A0E16YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1Ey6YN;;A0En7YE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1Es7YJ;A0Er7YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1Eo7YN;;A0E97YE;EACE,yBAAA;EACA,qBAAA;EACA,2BAAA;A1Ei8YJ;A0Eh8YI;EAIE,YAAA;EACA,yBAAA;EACA,qBAAA;A1E+7YN;;A0Er7YE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1Ew7YJ;A0Ev7YI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1Es7YN;;A0El8YE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1Eq8YJ;A0Ep8YI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1Em8YN;;A0E/8YE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1Ek9YJ;A0Ej9YI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1Eg9YN;;A0E59YE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1E+9YJ;A0E99YI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1E69YN;;A0Ez+YE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1E4+YJ;A0E3+YI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1E0+YN;;A0Et/YE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1Ey/YJ;A0Ex/YI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1Eu/YN;;A0EngZE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1EsgZJ;A0ErgZI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1EogZN;;A0EhhZE;EACE,yBAN2B;EAO3B,qBAP2B;EAQ3B,2BAAA;EACA,YAAA;A1EmhZJ;A0ElhZI;EAIE,YAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;A1EihZN;;A0E7gZA,yDAAA;AAME;;;EAGE,gCAAA;A1E2gZJ;;A0E9gZE;;;EAGE,gCAAA;A1EihZJ;;A0EphZE;;;EAGE,gCAAA;A1EuhZJ;;A0E1hZE;;;EAGE,gCAAA;A1E6hZJ;;A0EhiZE;;;EAGE,gCAAA;A1EmiZJ;;A0EtiZE;;;EAGE,gCAAA;A1EyiZJ;;A0E5iZE;;;EAGE,gCAAA;A1E+iZJ;;A0EljZE;;;EAGE,gCAAA;A1EqjZJ;;A0EljZA,uDAAA;AACA,6CAAA;AAME;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1EgjZJ;A0E/iZI;;EACE,yBAAA;EACA,yBAAA;A1EkjZN;;A0EzjZE;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1E4jZJ;A0E3jZI;;EACE,yBAAA;EACA,yBAAA;A1E8jZN;;A0ErkZE;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1EwkZJ;A0EvkZI;;EACE,yBAAA;EACA,yBAAA;A1E0kZN;;A0EjlZE;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1EolZJ;A0EnlZI;;EACE,yBAAA;EACA,yBAAA;A1EslZN;;A0E7lZE;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1EgmZJ;A0E/lZI;;EACE,yBAAA;EACA,yBAAA;A1EkmZN;;A0EzmZE;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1E4mZJ;A0E3mZI;;EACE,yBAAA;EACA,yBAAA;A1E8mZN;;A0ErnZE;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1EwnZJ;A0EvnZI;;EACE,yBAAA;EACA,yBAAA;A1E0nZN;;A0EjoZE;;EAEE,yBAAA;EACA,cC/iGI;EDgjGJ,yBAAA;A1EooZJ;A0EnoZI;;EACE,yBAAA;EACA,yBAAA;A1EsoZN;;A0EloZA,2CAAA;AACA,iDAAA;AAME;EACE,oCAAA;A1EgoZJ;;A0E9nZE;EACE,wCAAA;A1EioZJ;;A0E/nZE;EACE,2CAAA;A1EkoZJ;;A0EhoZE;EACE,yCAAA;A1EmoZJ;;A0EjoZE;EACE,0CAAA;A1EooZJ;;A0EjpZE;EACE,oCAAA;A1EopZJ;;A0ElpZE;EACE,wCAAA;A1EqpZJ;;A0EnpZE;EACE,2CAAA;A1EspZJ;;A0EppZE;EACE,yCAAA;A1EupZJ;;A0ErpZE;EACE,0CAAA;A1EwpZJ;;A0ErqZE;EACE,oCAAA;A1EwqZJ;;A0EtqZE;EACE,wCAAA;A1EyqZJ;;A0EvqZE;EACE,2CAAA;A1E0qZJ;;A0ExqZE;EACE,yCAAA;A1E2qZJ;;A0EzqZE;EACE,0CAAA;A1E4qZJ;;A0EzrZE;EACE,oCAAA;A1E4rZJ;;A0E1rZE;EACE,wCAAA;A1E6rZJ;;A0E3rZE;EACE,2CAAA;A1E8rZJ;;A0E5rZE;EACE,yCAAA;A1E+rZJ;;A0E7rZE;EACE,0CAAA;A1EgsZJ;;A0E7sZE;EACE,oCAAA;A1EgtZJ;;A0E9sZE;EACE,wCAAA;A1EitZJ;;A0E/sZE;EACE,2CAAA;A1EktZJ;;A0EhtZE;EACE,yCAAA;A1EmtZJ;;A0EjtZE;EACE,0CAAA;A1EotZJ;;A0EjuZE;EACE,oCAAA;A1EouZJ;;A0EluZE;EACE,wCAAA;A1EquZJ;;A0EnuZE;EACE,2CAAA;A1EsuZJ;;A0EpuZE;EACE,yCAAA;A1EuuZJ;;A0EruZE;EACE,0CAAA;A1EwuZJ;;A0ErvZE;EACE,oCAAA;A1EwvZJ;;A0EtvZE;EACE,wCAAA;A1EyvZJ;;A0EvvZE;EACE,2CAAA;A1E0vZJ;;A0ExvZE;EACE,yCAAA;A1E2vZJ;;A0EzvZE;EACE,0CAAA;A1E4vZJ;;A0EzwZE;EACE,oCAAA;A1E4wZJ;;A0E1wZE;EACE,wCAAA;A1E6wZJ;;A0E3wZE;EACE,2CAAA;A1E8wZJ;;A0E5wZE;EACE,yCAAA;A1E+wZJ;;A0E7wZE;EACE,0CAAA;A1EgxZJ;;A0E7wZA,+CAAA;AACA,wCAAA;AAGE;EACE,4BAAA;A1E8wZJ;;A0E/wZE;EACE,4BAAA;A1EkxZJ;;A0EnxZE;EACE,4BAAA;A1EsxZJ;;A0EvxZE;EACE,4BAAA;A1E0xZJ;;A0E3xZE;EACE,4BAAA;A1E8xZJ;;A0E/xZE;EACE,4BAAA;A1EkyZJ;;A0EnyZE;EACE,4BAAA;A1EsyZJ;;A0EvyZE;EACE,4BAAA;A1E0yZJ;;A0E3yZE;EACE,4BAAA;A1E8yZJ;;A0E/yZE;EACE,6BAAA;A1EkzZJ;;A0E9yZA,sCAAA;AACA;EACE,UAAA;A1EizZF;;A0E/yZA;EACE,gBAAA;A1EkzZF;;A0EhzZA,6CAAA;AACA;EACE,kCAAA;A1EmzZF;;A0EhzZE;EACE,yCAAA;A1EmzZJ;A0EjzZE;EACE,UAAA;A1EmzZJ;A0EjzZE;EACE,wCAAA;A1EmzZJ;;A0EhzZA,2CAAA;AACA,sCAAA;AAEE;EACE,eAAA;A1EkzZJ;;A0E/yZA,oCAAA;AACA;;4BAAA;AAGA;;4BAAA;AAIE;EACE,aAAA;A1EizZJ;A0E9yZI;EACE,kBAAA;A1EgzZN;A0E/yZM;EACE,yBC17Fc;ED27Fd,yBAAA;A1EizZR;A0EhzZQ;EACE,cC/jGE;A3Ei3fZ;A0E/yZM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,cCrkGK;A3Es3fb;A0E9yZI;EACE,UAAA;A1EgzZN;A0E/yZM;EACE,oBAAA;A1EizZR;A0EhzZQ;EACE,iBAAA;A1EkzZV;A0E7yZE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;A1E+yZJ;A0E7yZE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;A1E+yZJ;A0E9yZI;EACE,cC3lGO;ED4lGP,mBAAA;EACA,gBAAA;A1EgzZN;A0E7yZE;EACE,cCrmGQ;EDsmGR,mBAAA;EACA,eAAA;EACA,eAAA;A1E+yZJ;A0E9yZI;EACE,gBAAA;EACA,cC3kGkB;A3E23fxB;A0E9yZI;EACE,eAAA;A1EgzZN;;A0E5yZA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;A1E+yZF;;A0E7yZA;EACE,yBC/nGc;A3E+6fhB;;A0E9yZA;EACE,yBCpoGc;A3Eq7fhB;;A0E/yZA;EACE,yBCpoGa;A3Es7ff;;A0EhzZA;;4BAAA;AAGA;EACE,aAAA;A1EmzZF;;A0EhzZE;EACE,iBAAA;A1EmzZJ;A0EjzZE;EACE,sBAAA;EACA,wBAAA;A1EmzZJ;;A0EhzZA;EACE,mBAAA;A1EmzZF;;A0EhzZE;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;A1EmzZJ;A0EjzZE;EACE,gBAAA;EACA,mBAAA;A1EmzZJ;;A0E/yZE;EACE,eAAA;EACA,mBAAA;A1EkzZJ;A0EhzZE;EACE,eAAA;EACA,mBAAA;A1EkzZJ;;A0E/yZA;;2BAAA;AAGA;EAEI;IACE,UAAA;E1EizZJ;E0E1yZQ;IACE,gBAAA;E1E4yZV;AACF;A0EtyZA;EAMY;IACE,YAAA;E1EmyZZ;E0ErxZU;;;IACE,YAAA;E1EyxZZ;E0EjxZE;IACE,UAAA;E1EmxZJ;E0E5wZQ;IACE,gBAAA;E1E8wZV;AACF;A0ExwZA;EACE;IACE,aAAA;E1E0wZF;E0EvwZE;IACE,aAAA;IACA,cAAA;E1EywZJ;E0EvwZE;IACE,aAAA;IACA,cAAA;E1EywZJ;AACF;A0EtwZA;EAMY;IACE,YAAA;E1EmwZZ;E0ExvZQ;IACE,YAAA;E1E0vZV;E0EnvZE;IACE,eAAA;E1EqvZJ;E0EjvZE;IACE,UAAA;E1EmvZJ;E0E/uZE;IACE,cAAA;E1EivZJ;E0EzuZU;IACE,UAAA;E1E2uZZ;E0EnuZE;IACE,gBAAA;E1EquZJ;E0E7tZQ;;IACE,uBAAA;E1EguZV;AACF;A0E1tZA;EAEE;IACE,gBAAA;E1E2tZF;E0EttZM;;IAEE,uBAAA;E1EwtZR;AACF;A0EntZA;EACE;IACE,eAAA;IACA,cAAA;E1EqtZF;E0EntZA;IACE,cAAA;IACA,aAAA;E1EqtZF;E0EltZE;;IAEE,cAAA;IACA,eAAA;E1EotZJ;E0EltZE;IACE,gBAAA;E1EotZJ;E0E5sZQ;;IACE,uBAAA;E1E+sZV;E0ErsZM;;IAEE,uBAAA;E1EusZR;AACF;A0ElsZA;EAIQ;IACE,UAAA;E1EisZR;E0E5rZA;IACE,aAAA;E1E8rZF;E0E5rZI;IACE,aAAA;E1E8rZN;E0E1rZA;IACE,mBAAA;E1E4rZF;E0EzrZE;IACE,gBAAA;E1E2rZJ;E0EvrZE;;IAEE,aAAA;E1EyrZJ;E0EprZI;IACE,WAAA;E1EsrZN;E0ElrZA;IACE,UAAA;E1EorZF;E0E9qZQ;IACE,eAAA;E1EgrZV;E0E9qZQ;IACE,WAAA;IACA,eAAA;E1EgrZV;E0E5qZI;IACE,oBAAA;IACA,qCAAA;E1E8qZN;E0E5qZQ;IACE,cAAA;IACA,gBAAA;E1E8qZV;E0E3qZc;IACE,gBAAA;E1E6qZhB;E0EtqZI;IACE,0BAAA;E1EwqZN;E0EpqZQ;IACE,gBAAA;E1EsqZV;E0ElqZI;IACE,cAAA;E1EoqZN;E0EjqZE;IACE,YAAA;IACA,cAAA;IACA,WAAA;IACA,WAAA;E1EmqZJ;E0EhqZQ;IACE,YAAA;IACA,aAAA;IACA,kBAAA;E1EkqZV;E0E7pZM;IACE,eAAA;IACA,UAAA;E1E+pZR;E0E9pZQ;IACE,SAAA;IACA,kBAAA;IACA,WAAA;IACA,sBAAA;IAEA,2BAAA;IAEA,iCAAA;IACA,WAAA;IACA,OAAA;IACA,eAAA;IAEA,sCAAA;IACA,UAAA;IACA,kBAAA;E1EgqZV;E0E/pZU;IACE,cAAA;E1EiqZZ;E0E9pZQ;IACE,eAAA;IAGA,aAAA;IAGA,mBAAA;E1EgqZV;E0E9pZY;IACE,cClkHA;E3EkugBd;E0E5pZQ;IACE,UAAA;IACA,UAAA;IAEA,oCAAA;IACA,mBAAA;E1E8pZV;E0ExpZA;IACE,4BAAA;IACA,+BAAA;E1E0pZF;E0EvpZM;IACE,eAAA;IACA,cAAA;E1EypZR;E0EnpZA;IACE,2BAAA;E1EqpZF;E0EhpZI;IACE,YAAA;E1EkpZN;E0E7oZE;IACE,gBAAA;E1E+oZJ;E0E3oZA;IACE,mBAAA;E1E6oZF;E0E1oZA;IACE,gBAAA;E1E4oZF;E0ExoZE;IACE,wBAAA;E1E0oZJ;E0EroZE;IACE,eAAA;E1EuoZJ;AACF;A0EpoZA;EAGM;IACE,cAAA;E1EooZN;E0EhoZA;IACE,eAAA;E1EkoZF;E0EhoZA;IACE,iBAAA;E1EkoZF;E0E/nZE;;IAEE,kBAAA;E1EioZJ;E0EhoZI;;IACE,UAAA;IACA,OAAA;IACA,QAAA;E1EmoZN;E0E1nZU;IACE,UAAA;E1E4nZZ;E0EhnZQ;;IACE,gBAAA;E1EmnZV;E0EjnZQ;;IACE,gBAAA;E1EonZV;E0E1mZQ;IACE,iBAAA;E1E4mZV;E0E3mZU;IACE,WAAA;IACA,gBAAA;E1E6mZZ;E0EtmZQ;IACE,kBAAA;E1EwmZV;E0EvmZU;IACE,WAAA;E1EymZZ;E0EjmZE;IACE,sBAAA;IACA,6BAAA;E1EmmZJ;E0E7lZI;;IAEE,sBAAA;IACA,oBAAA;E1E+lZN;E0E3lZI;IACE,qBAAA;E1E6lZN;E0EzlZI;IACE,gBAAA;E1E2lZN;E0ExlZE;IACE,eAAA;E1E0lZJ;E0ExlZE;IACE,cAAA;E1E0lZJ;E0ExlZE;IACE,UAAA;E1E0lZJ;E0ErlZI;IACE,YAAA;E1EulZN;E0EllZE;IACE,oBAAA;E1EolZJ;E0EjlZI;;IAEE,sBAAA;E1EmlZN;E0EjlZI;IACE,2BAAA;E1EmlZN;E0E5kZI;IACE,cAAA;IACA,eAAA;E1E8kZN;E0E5kZI;;IAEE,WAAA;IACA,cAAA;E1E8kZN;E0E5kZI;IACE,kBAAA;E1E8kZN;E0E5kZI;IACE,kBAAA;E1E8kZN;E0E1kZI;IACE,gBAAA;E1E4kZN;E0EzkZE;IACE,eAAA;E1E2kZJ;E0EzkZE;IACE,cAAA;E1E2kZJ;AACF;A0ExkZA;EACE;IACE,2BAAA;E1E0kZF;AACF;A0ExkZA;EAIQ;IACE,0BAAA;E1EukZR;E0ElkZA;IACE,gBAAA;E1EokZF;E0ElkZA;IACE,aAAA;E1EokZF;E0EjkZE;IACE,wBAAA;E1EmkZJ;E0E/jZE;IACE,UAAA;E1EikZJ;E0E5jZI;IACE,WAAA;E1E8jZN;E0E1jZA;IACE,aAAA;E1E4jZF;E0EzjZE;IACE,aAAA;E1E2jZJ;E0EvjZE;IACE,wBAAA;E1EyjZJ;E0EtjZA;IACE,mBAAA;E1EwjZF;E0EnjZM;IACE,WAAA;IACA,YAAA;E1EqjZR;E0E7iZM;IACE,gBAAA;E1E+iZR;E0E9iZQ;IACE,gBAAA;E1EgjZV;E0E9iZQ;IACE,gBAAA;E1EgjZV;E0E1iZA;IACE,mBAAA;E1E4iZF;E0E3iZE;IACE,aAAA;E1E6iZJ;E0E5iZI;IACE,eAAA;E1E8iZN;E0E3iZE;IACE,aAAA;E1E6iZJ;E0E1iZA;;IAEE,gBAAA;E1E4iZF;E0EziZE;IACE,gBAAA;E1E2iZJ;E0E1iZI;IACE,eAAA;E1E4iZN;E0E1iZI;IACE,mBAAA;E1E4iZN;E0EviZE;IACE,qBAAA;E1EyiZJ;E0EriZE;IACE,aAAA;E1EuiZJ;E0EliZI;IACE,YAAA;IACA,aAAA;E1EoiZN;E0EniZM;IAEE,uBAAA;E1EoiZR;E0E7hZI;IACE,eAAA;E1E+hZN;E0E7hZQ;IACE,YAAA;IACA,2BAAA;E1E+hZV;E0E7hZY;IAWE,WAAA;IACA,SAAA;E1EqhZd;E0E9hZkB;IACE,aAAA;E1EgiZpB;E0E9hZkB;IACE,aAAA;E1EgiZpB;E0EvhZY;IACE,gBAAA;E1EyhZd;E0EvhZY;IAEE,oCAAA;IACA,UAAA;IACA,mBAAA;IAEA,2BAAA;E1EyhZd;E0EvhZY;IACE,SAAA;IACA,kBAAA;IAEA,2BAAA;IACA,OAAA;IACA,sBAAA;IAEA,sCAAA;IACA,UAAA;IACA,kBAAA;IACA,YAAA;IACA,4BAAA;E1EyhZd;E0EthZc;IACE,cC79HF;E3Eq/gBd;E0E/gZI;IACE,eAAA;E1EihZN;E0EvgZgB;IACE,aAAA;E1EygZlB;E0ErgZgB;IACE,aAAA;IACA,YAAA;E1EugZlB;E0EngZgB;IACE,aAAA;E1EqgZlB;E0E7/YI;IACE,UAAA;E1E+/YN;E0E7/YI;IACE,4BAAA;IACA,+BAAA;E1E+/YN;E0Ez/YE;IACE,mBAAA;E1E2/YJ;E0Ex/YA;IACE,gBAAA;E1E0/YF;E0Ez/YE;IACE,gBAAA;E1E2/YJ;E0Ev/YE;IACE,gBAAA;IACA,mBAAA;E1Ey/YJ;E0Ex/YI;IACE,cAAA;IACA,kBAAA;E1E0/YN;E0Ej/YU;IACE,gBAAA;E1Em/YZ;E0E3+YE;IACE,mBAAA;E1E6+YJ;E0E1+YA;IACE,gBAAA;E1E4+YF;E0E3+YE;IACE,gBAAA;E1E6+YJ;E0Ez+YA;IACE,6BAAA;E1E2+YF;E0Ev+YI;IACE,oBAAA;E1Ey+YN;E0Ep+YE;IACE,cAAA;E1Es+YJ;E0Ep+YE;IACE,mBAAA;E1Es+YJ;E0El+YM;IACE,kBAAA;E1Eo+YR;E0Ej+YQ;IACE,gBAAA;E1Em+YV;E0E99YE;IACE,kBAAA;E1Eg+YJ;E0E79YI;IACE,kBAAA;E1E+9YN;E0E19YA;IACE,aAAA;IACA,kBAAA;E1E49YF;E0Ev9YI;IACE,UAAA;IACA,cAAA;E1Ey9YN;E0Ev9YI;IACE,UAAA;E1Ey9YN;E0Ev9YI;IACE,eAAA;E1Ey9YN;E0Ev9YI;IACE,UAAA;E1Ey9YN;E0Et9YE;IACE,YAAA;E1Ew9YJ;E0Et9YM;IACE,WAAA;E1Ew9YR;E0Ep9YE;IACE,qBAAA;E1Es9YJ;E0Eh9YM;IACE,WAAA;IACA,YAAA;E1Ek9YR;E0Ej9YQ;IACE,sBAAA;IACA,uBAAA;E1Em9YV;E0E78YA;IACE,gBAAA;E1E+8YF;E0E98YE;IACE,8BAAA;E1Eg9YJ;AACF;A0E78YA;EAEI;IACE,yBAAA;E1E88YJ;E0Ex8YM;IACE,UAAA;E1E08YR;E0Er8YA;IACE,kBAAA;E1Eu8YF;E0Et8YE;IACE,WAAA;IACA,iBAAA;E1Ew8YJ;E0Er8YI;IACE,mBAAA;E1Eu8YN;E0Er8YI;IACE,eAAA;E1Eu8YN;E0Er8YI;IACE,gBAAA;E1Eu8YN;E0Er8YI;IACE,kBAAA;E1Eu8YN;E0Er8YI;IACE,aAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;E1Eu8YN;E0Et8YM;IACE,YAAA;E1Ew8YR;E0El8YE;IACE,QAAA;E1Eo8YJ;E0E57YU;IACE,eAAA;E1E87YZ;E0E77YY;IACE,WAAA;E1E+7Yd;E0Ev7YA;IACE,eAAA;IACA,2BAAA;E1Ey7YF;E0Ex7YE;IACE,eAAA;E1E07YJ;E0Er7YI;IACE,YAAA;E1Eu7YN;E0Ej7YE;IACE,iBAAA;E1Em7YJ;AACF;A0Eh7YA;EAGM;IACE,+BAAA;IACA,gBAAA;E1Eg7YN;AACF;A0E56YA;;2BAAA;AEjxIA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBDyBW;ECxBX,qDAAA;EACA,qBAAA;EACA,eAAA;A5EkshBF;;A4EhshBA;;4BAAA;AAIE;EACE,cAAA;A5EkshBJ;A4EjshBI;EACE,iBAAA;EACA,mBAAA;A5EmshBN;A4EjshBI;;EAEE,8BAAA;EACA,8BAAA;A5EmshBN;A4EjshBI;EACE,0CAAA;A5EmshBN;A4EjshBI;;EAEE,2BAAA;EACA,8BAAA;A5EmshBN;A4EjshBI;EACE,mBAAA;EACA,8BAAA;A5EmshBN;A4EjshBI;EACE,iBAAA;EACA,mBAAA;A5EmshBN;A4EjshBI;;EAEE,oBAAA;A5EmshBN;A4EjshBI;EACE,kBAAA;EACA,iBAAA;A5EmshBN;A4EjshBI;EACE,WAAA;EACA,QAAA;A5EmshBN;A4E9rhBU;EACE,eAAA;EACA,kBAAA;A5EgshBZ;A4EvrhBY;EACE,iBAAA;EACA,mBAAA;A5EyrhBd;A4ElrhBM;EACE,cAAA;A5EorhBR;A4E/qhBQ;EACE,gBAAA;EACA,mBAAA;A5EirhBV;A4E5qhBM;EACE,kBAAA;EACA,kBAAA;A5E8qhBR;A4E1qhBM;EACE,yBAAA;A5E4qhBR;A4E1qhBU;EACE,mBAAA;EACA,mBAAA;A5E4qhBZ;A4EtqhBM;EACE,qBAAA;EACA,mBAAA;A5EwqhBR;A4EvqhBQ;EACE,YAAA;EACA,oBAAA;EACA,oBAAA;A5EyqhBV;A4EjqhBY;EACE,kBAAA;EACA,+BAAA;A5EmqhBd;A4EhqhBkB;EACE,sBAAA;EACA,sBAAA;A5EkqhBpB;A4EhqhBkB;EACE,sBAAA;EACA,sBAAA;A5EkqhBpB;A4E9phBc;EACE,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;A5EgqhBhB;A4E5phBU;EACE,YAAA;EACA,WAAA;A5E8phBZ;A4ElphBkB;EACE,gBAAA;A5EophBpB;A4E7ohBY;EACE,mBAAA;EACA,mBAAA;A5E+ohBd;A4ExohBM;EACE,WAAA;A5E0ohBR;A4EvohBQ;EACE,oBAAA;EACA,kBAAA;A5EyohBV;A4EpohBU;EACE,mBAAA;EACA,mBAAA;A5EsohBZ;A4E/nhBY;EACE,gBAAA;EACA,mBAAA;A5EiohBd;A4E1nhBM;EACE,iBAAA;A5E4nhBR;A4E3nhBQ;EACE,gBAAA;EACA,mBAAA;A5E6nhBV;A4EznhBQ;EACE,mBAAA;EACA,mBAAA;EACA,iBAAA;A5E2nhBV;A4E1nhBU;EACE,mBAAA;EACA,mBAAA;A5E4nhBZ;A4ExnhBM;EAWE,QAAA;EACA,kBAAA;A5EgnhBR;A4E3nhBQ;EACE,mBAAA;EACA,mBAAA;A5E6nhBV;A4E5nhBU;EACE,QAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;A5E8nhBZ;A4EvnhBQ;EACE,iBAAA;EACA,mBAAA;A5EynhBV;A4EpnhBM;EACE,oBAAA;EACA,mBAAA;A5EsnhBR;A4ElnhBM;EACE,iBAAA;EACA,kBAAA;A5EonhBR;A4EjnhBI;EACE,OAAA;EACA,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;A5EmnhBN;A4EjnhBI;EACE,2BAAA;A5EmnhBN;A4EjnhBI;EACE,iBAAA;A5EmnhBN;A4E/mhBQ;EACE,UAAA;EACA,YAAA;A5EinhBV;A4EhnhBU;EACE,gBAAA;A5EknhBZ;A4EjnhBY;EACE,gBAAA;EACA,mBAAA;A5EmnhBd;A4E7mhBI;;EAEE,iBAAA;A5E+mhBN;A4E7mhBI;EACE,YAAA;EACA,UAAA;A5E+mhBN;A4EzmhBU;;;;EAEE,iBAAA;A5E6mhBZ;A4ExmhBI;EACE,WAAA;A5E0mhBN;A4ExmhBI;EACE,WAAA;EACA,WAAA;A5E0mhBN;A4EvmhBM;EACE,OAAA;EACA,YAAA;A5EymhBR;A4EtmhBQ;EACE,UAAA;EACA,YAAA;A5EwmhBV;A4EpmhBQ;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;A5EsmhBV;A4EpmhBQ;EACE,iBAAA;A5EsmhBV;A4EpmhBQ;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A5EsmhBV;A4EhmhBQ;EACE,4BAAA;A5EkmhBV;A4E3lhBU;EACE,iBAAA;A5E6lhBZ;A4EnlhBY;;EAEE,kBAAA;A5EqlhBd;A4EjlhBY;EACE,iBAAA;A5EmlhBd;A4EjlhBgB;EACE,kBAAA;EACA,kBAAA;A5EmlhBlB;A4E7khBgB;EACE,mBAAA;EACA,mBAAA;A5E+khBlB;A4E9khBkB;EACE,QAAA;EACA,WAAA;A5EglhBpB;A4E1khBc;EACE,mBAAA;EACA,iBAAA;A5E4khBhB;A4ExkhBU;EACE,mBAAA;EACA,kBAAA;A5E0khBZ;A4ExkhBU;EACE,oBAAA;EACA,kBAAA;A5E0khBZ;A4EzkhBY;;EAEE,eAAA;A5E2khBd;A4ErkhBY;EACE,iBAAA;A5EukhBd;A4EnkhBQ;EACE,mBAAA;EACA,kBAAA;A5EqkhBV;A4EnkhBY;EACE,iBAAA;EACA,kBAAA;A5EqkhBd;A4E9jhBI;EACE,mBAAA;EACA,kBAAA;A5EgkhBN;A4E9jhBQ;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;A5EgkhBV;A4E7jhBc;EACE,mBAAA;EACA,iBAAA;A5E+jhBhB;A4E1jhBY;EA6DE,iBAAA;A5EgghBd;A4E5jhBc;EACE,QAAA;EACA,WAAA;A5E8jhBhB;A4E5jhBc;EACE,UAAA;EACA,YAAA;A5E8jhBhB;A4E3jhBgB;EACE,UAAA;EACA,YAAA;A5E6jhBlB;A4E5jhBkB;EACE,SAAA;EACA,YAAA;A5E8jhBpB;A4E5jhBkB;EACE,UAAA;EACA,YAAA;A5E8jhBpB;A4EvjhBoB;EACE,UAAA;EACA,YAAA;A5EyjhBtB;A4EvjhBoB;EACE,UAAA;EACA,YAAA;A5EyjhBtB;A4ErjhBgB;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;A5EujhBlB;A4EpjhBc;EACE,kBAAA;A5EsjhBhB;A4EnjhBoB;EACE,WAAA;EACA,WAAA;A5EqjhBtB;A4EnjhBoB;EACE,WAAA;EACA,WAAA;A5EqjhBtB;A4EhjhBc;EACE,mBAAA;EACA,eAAA;A5EkjhBhB;A4E9ihBgB;EACE,+BAAA;EACA,6BAAA;A5EgjhBlB;A4E3ihBU;EACE,iBAAA;A5E6ihBZ;A4E1ihBgB;EACE,iBAAA;A5E4ihBlB;A4EpihBgB;EACE,mBAAA;EACA,iBAAA;A5EsihBlB;A4EhihBQ;EACE,mBAAA;A5EkihBV;A4E/hhBM;EACE,eAAA;A5EiihBR;A4E5hhBQ;EACE,cAAA;EACA,WAAA;EACA,UAAA;A5E8hhBV;A4E7hhBU;EACE,yBAAA;EACA,qBAAA;A5E+hhBZ;A4E7hhBU;EACE,yBAAA;EACA,qBAAA;A5E+hhBZ;A4E7hhBU;EACE,0BAAA;A5E+hhBZ;A4E7hhBc;EACE,6BAAA;A5E+hhBhB;A4E7hhBc;EACE,mBAAA;EACA,iBAAA;A5E+hhBhB;A4E5hhBY;EACE,iBAAA;EACA,mBAAA;A5E8hhBd;A4ExhhBI;EACE,cAAA;A5E0hhBN;A4EthhBM;EACE,iBAAA;A5EwhhBR;A4EnhhBQ;EACE,6BAAA;EACA,iBAAA;A5EqhhBV;A4EhhhBM;EACE,YAAA;A5EkhhBR;A4EzghBY;;EACE,iBAAA;A5E4ghBd;A4EpghBM;;;;EAEE,iBAAA;A5EwghBR;A4EjghBY;EACE,6BAAA;EACA,yCAAA;A5EmghBd;A4E//gBY;EACE,4BAAA;EACA,0CAAA;A5EighBd;A4E5/gBM;EACE,iBAAA;A5E8/gBR;A4E3/gBI;EACE,YAAA;A5E6/gBN;A4E5/gBM;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;A5E8/gBR;A4E3/gBQ;EACE,WAAA;EACA,WAAA;EACA,gBAAA;A5E6/gBV;A4Er/gBU;;;;EAEE,4BAAA;A5Ey/gBZ;A4Ex/gBY;;;;EACE,6BAAA;A5E6/gBd;A4Er/gBQ;;EAEE,WAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;A5Eu/gBV;A4El/gBU;EACE,kBAAA;A5Eo/gBZ;A4E9+gBM;EACE,cAAA;EACA,iBAAA;A5Eg/gBR;A4E1+gBQ;EACE,kBAAA;EACA,kBAAA;A5E4+gBV;A4Et+gBY;EACE,iBAAA;EACA,mBAAA;A5Ew+gBd;A4E79gBY;;EACE,iBAAA;A5Eg+gBd;A4Er9gBY;;EACE,4BAAA;A5Ew9gBd;A4Eh9gBM;EACE,kBAAA;A5Ek9gBR;A4E/8gBI;EACE,iBAAA;A5Ei9gBN;A4E/8gBI;EACE;IACE,4BAAA;E5Ei9gBN;E4E98gBM;IACE,eAAA;E5Eg9gBR;E4E58gBU;;IAEE,eAAA;E5E88gBZ;AACF;A4Ez8gBI;EAGM;IACE,mBAAA;IACA,mBAAA;E5Ey8gBV;E4El8gBU;IACE,kBAAA;E5Eo8gBZ;AACF;A4E/7gBI;EAGM;IACE,kBAAA;IACA,gBAAA;E5E+7gBV;E4Er7gBgB;IACE,WAAA;IACA,QAAA;E5Eu7gBlB;E4E/6gBI;IACE,YAAA;IACA,YAAA;E5Ei7gBN;E4Eh7gBM;IACE,uBAAA;IACA,sBAAA;E5Ek7gBR;AACF;A4E/6gBI;EAOc;IACE,UAAA;IACA,YAAA;E5E26gBlB;E4El6gBM;IACE,yBAAA;E5Eo6gBR;AACF;A4Ej6gBI;EACE;IACE,iBAAA;IACA,kBAAA;E5Em6gBN;AACF;;A4E/5gBA;;4BAAA;ACr1BA;EACE,wBAAA;EACA,wBAAA;EACA,4BAAA;A7E0viBF;;A6EvviBA;EAEE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;A7EyviBF;A6ExviBE;EACE,YAAA;A7E0viBJ;A6ExviBE;EACE,UAAA;A7E0viBJ;;A6ErviBE;EACE,0DAAA;A7EwviBJ;A6EvviBI;EACE,0DAAA;A7EyviBN;;A6E5viBE;EACE,0DAAA;A7E+viBJ;A6E9viBI;EACE,0DAAA;A7EgwiBN;;A6EnwiBE;EACE,0DAAA;A7EswiBJ;A6ErwiBI;EACE,0DAAA;A7EuwiBN;;A6E1wiBE;EACE,0DAAA;A7E6wiBJ;A6E5wiBI;EACE,0DAAA;A7E8wiBN;;A6EjxiBE;EACE,0DAAA;A7EoxiBJ;A6EnxiBI;EACE,0DAAA;A7EqxiBN;;A6ExxiBE;EACE,0DAAA;A7E2xiBJ;A6E1xiBI;EACE,0DAAA;A7E4xiBN;;A6E/xiBE;EACE,0DAAA;A7EkyiBJ;A6EjyiBI;EACE,0DAAA;A7EmyiBN;;A6EtyiBE;EACE,0DAAA;A7EyyiBJ;A6ExyiBI;EACE,0DAAA;A7E0yiBN;;A6E7yiBE;EACE,0DAAA;A7EgziBJ;A6E/yiBI;EACE,0DAAA;A7EiziBN;;A6EpziBE;EACE,0DAAA;A7EuziBJ;A6EtziBI;EACE,0DAAA;A7EwziBN;;A6E3ziBE;EACE,0DAAA;A7E8ziBJ;A6E7ziBI;EACE,0DAAA;A7E+ziBN;;A6El0iBE;EACE,0DAAA;A7Eq0iBJ;A6Ep0iBI;EACE,0DAAA;A7Es0iBN;;A6Ez0iBE;EACE,0DAAA;A7E40iBJ;A6E30iBI;EACE,0DAAA;A7E60iBN;;A6Eh1iBE;EACE,0DAAA;A7Em1iBJ;A6El1iBI;EACE,0DAAA;A7Eo1iBN;;A6Ev1iBE;EACE,0DAAA;A7E01iBJ;A6Ez1iBI;EACE,0DAAA;A7E21iBN;;A6E91iBE;EACE,0DAAA;A7Ei2iBJ;A6Eh2iBI;EACE,0DAAA;A7Ek2iBN;;A6Er2iBE;EACE,0DAAA;A7Ew2iBJ;A6Ev2iBI;EACE,0DAAA;A7Ey2iBN;;A6E52iBE;EACE,0DAAA;A7E+2iBJ;A6E92iBI;EACE,0DAAA;A7Eg3iBN;;A6En3iBE;EACE,0DAAA;A7Es3iBJ;A6Er3iBI;EACE,0DAAA;A7Eu3iBN;;A6E13iBE;EACE,0DAAA;A7E63iBJ;A6E53iBI;EACE,0DAAA;A7E83iBN;;A6Ej4iBE;EACE,0DAAA;A7Eo4iBJ;A6En4iBI;EACE,0DAAA;A7Eq4iBN;;A6Ex4iBE;EACE,0DAAA;A7E24iBJ;A6E14iBI;EACE,0DAAA;A7E44iBN;;A6E/4iBE;EACE,0DAAA;A7Ek5iBJ;A6Ej5iBI;EACE,0DAAA;A7Em5iBN;;A6Et5iBE;EACE,0DAAA;A7Ey5iBJ;A6Ex5iBI;EACE,0DAAA;A7E05iBN;;A6E75iBE;EACE,0DAAA;A7Eg6iBJ;A6E/5iBI;EACE,0DAAA;A7Ei6iBN;;A6Ep6iBE;EACE,0DAAA;A7Eu6iBJ;A6Et6iBI;EACE,0DAAA;A7Ew6iBN;;A6E36iBE;EACE,0DAAA;A7E86iBJ;A6E76iBI;EACE,0DAAA;A7E+6iBN;;A6El7iBE;EACE,0DAAA;A7Eq7iBJ;A6Ep7iBI;EACE,0DAAA;A7Es7iBN;;A6Ez7iBE;EACE,0DAAA;A7E47iBJ;A6E37iBI;EACE,0DAAA;A7E67iBN;;A6Eh8iBE;EACE,0DAAA;A7Em8iBJ;A6El8iBI;EACE,0DAAA;A7Eo8iBN;;A6Ev8iBE;EACE,0DAAA;A7E08iBJ;A6Ez8iBI;EACE,0DAAA;A7E28iBN;;A6E98iBE;EACE,0DAAA;A7Ei9iBJ;A6Eh9iBI;EACE,0DAAA;A7Ek9iBN;;A6Er9iBE;EACE,0DAAA;A7Ew9iBJ;A6Ev9iBI;EACE,0DAAA;A7Ey9iBN;;A6E59iBE;EACE,0DAAA;A7E+9iBJ;A6E99iBI;EACE,0DAAA;A7Eg+iBN;;A6En+iBE;EACE,0DAAA;A7Es+iBJ;A6Er+iBI;EACE,0DAAA;A7Eu+iBN;;A6E1+iBE;EACE,0DAAA;A7E6+iBJ;A6E5+iBI;EACE,0DAAA;A7E8+iBN;;A6Ej/iBE;EACE,0DAAA;A7Eo/iBJ;A6En/iBI;EACE,0DAAA;A7Eq/iBN;;A6Ex/iBE;EACE,0DAAA;A7E2/iBJ;A6E1/iBI;EACE,0DAAA;A7E4/iBN;;A6E//iBE;EACE,0DAAA;A7EkgjBJ;A6EjgjBI;EACE,0DAAA;A7EmgjBN;;A6EtgjBE;EACE,0DAAA;A7EygjBJ;A6ExgjBI;EACE,0DAAA;A7E0gjBN;;A6E7gjBE;EACE,0DAAA;A7EghjBJ;A6E/gjBI;EACE,0DAAA;A7EihjBN;;A6EphjBE;EACE,0DAAA;A7EuhjBJ;A6EthjBI;EACE,0DAAA;A7EwhjBN;;A6E3hjBE;EACE,0DAAA;A7E8hjBJ;A6E7hjBI;EACE,0DAAA;A7E+hjBN;;A6ElijBE;EACE,0DAAA;A7EqijBJ;A6EpijBI;EACE,0DAAA;A7EsijBN;;A6EzijBE;EACE,0DAAA;A7E4ijBJ;A6E3ijBI;EACE,0DAAA;A7E6ijBN;;A6EhjjBE;EACE,0DAAA;A7EmjjBJ;A6EljjBI;EACE,0DAAA;A7EojjBN;;A6EvjjBE;EACE,0DAAA;A7E0jjBJ;A6EzjjBI;EACE,0DAAA;A7E2jjBN;;A6E9jjBE;EACE,0DAAA;A7EikjBJ;A6EhkjBI;EACE,0DAAA;A7EkkjBN;;A6ErkjBE;EACE,0DAAA;A7EwkjBJ;A6EvkjBI;EACE,0DAAA;A7EykjBN;;A6E5kjBE;EACE,0DAAA;A7E+kjBJ;A6E9kjBI;EACE,0DAAA;A7EgljBN;;A6EnljBE;EACE,0DAAA;A7EsljBJ;A6ErljBI;EACE,0DAAA;A7EuljBN;;A6E1ljBE;EACE,0DAAA;A7E6ljBJ;A6E5ljBI;EACE,0DAAA;A7E8ljBN;;A6EjmjBE;EACE,0DAAA;A7EomjBJ;A6EnmjBI;EACE,0DAAA;A7EqmjBN;;A6ExmjBE;EACE,0DAAA;A7E2mjBJ;A6E1mjBI;EACE,0DAAA;A7E4mjBN;;A6E/mjBE;EACE,0DAAA;A7EknjBJ;A6EjnjBI;EACE,0DAAA;A7EmnjBN;;A6EtnjBE;EACE,0DAAA;A7EynjBJ;A6ExnjBI;EACE,0DAAA;A7E0njBN;;A6E7njBE;EACE,0DAAA;A7EgojBJ;A6E/njBI;EACE,0DAAA;A7EiojBN;;A6EpojBE;EACE,0DAAA;A7EuojBJ;A6EtojBI;EACE,0DAAA;A7EwojBN;;A6E3ojBE;EACE,0DAAA;A7E8ojBJ;A6E7ojBI;EACE,0DAAA;A7E+ojBN;;A6ElpjBE;EACE,0DAAA;A7EqpjBJ;A6EppjBI;EACE,0DAAA;A7EspjBN;;A6EzpjBE;EACE,0DAAA;A7E4pjBJ;A6E3pjBI;EACE,0DAAA;A7E6pjBN;;A6EhqjBE;EACE,0DAAA;A7EmqjBJ;A6ElqjBI;EACE,0DAAA;A7EoqjBN;;A6EvqjBE;EACE,0DAAA;A7E0qjBJ;A6EzqjBI;EACE,0DAAA;A7E2qjBN;;A6E9qjBE;EACE,0DAAA;A7EirjBJ;A6EhrjBI;EACE,0DAAA;A7EkrjBN;;A6ErrjBE;EACE,0DAAA;A7EwrjBJ;A6EvrjBI;EACE,0DAAA;A7EyrjBN;;A6E5rjBE;EACE,0DAAA;A7E+rjBJ;A6E9rjBI;EACE,0DAAA;A7EgsjBN;;A6EnsjBE;EACE,0DAAA;A7EssjBJ;A6ErsjBI;EACE,0DAAA;A7EusjBN;;A6E1sjBE;EACE,0DAAA;A7E6sjBJ;A6E5sjBI;EACE,0DAAA;A7E8sjBN;;A6EjtjBE;EACE,0DAAA;A7EotjBJ;A6EntjBI;EACE,0DAAA;A7EqtjBN;;A6ExtjBE;EACE,0DAAA;A7E2tjBJ;A6E1tjBI;EACE,0DAAA;A7E4tjBN;;A6E/tjBE;EACE,0DAAA;A7EkujBJ;A6EjujBI;EACE,0DAAA;A7EmujBN;;A6EtujBE;EACE,0DAAA;A7EyujBJ;A6ExujBI;EACE,0DAAA;A7E0ujBN;;A6E7ujBE;EACE,0DAAA;A7EgvjBJ;A6E/ujBI;EACE,0DAAA;A7EivjBN;;A6EpvjBE;EACE,0DAAA;A7EuvjBJ;A6EtvjBI;EACE,0DAAA;A7EwvjBN;;A6E3vjBE;EACE,0DAAA;A7E8vjBJ;A6E7vjBI;EACE,0DAAA;A7E+vjBN;;A6ElwjBE;EACE,0DAAA;A7EqwjBJ;A6EpwjBI;EACE,0DAAA;A7EswjBN;;A6EzwjBE;EACE,0DAAA;A7E4wjBJ;A6E3wjBI;EACE,0DAAA;A7E6wjBN;;A6EhxjBE;EACE,0DAAA;A7EmxjBJ;A6ElxjBI;EACE,0DAAA;A7EoxjBN;;A6EvxjBE;EACE,0DAAA;A7E0xjBJ;A6EzxjBI;EACE,0DAAA;A7E2xjBN;;A6E9xjBE;EACE,0DAAA;A7EiyjBJ;A6EhyjBI;EACE,0DAAA;A7EkyjBN;;A6EryjBE;EACE,2DAAA;A7EwyjBJ;A6EvyjBI;EACE,2DAAA;A7EyyjBN;;A6E5yjBE;EACE,2DAAA;A7E+yjBJ;A6E9yjBI;EACE,2DAAA;A7EgzjBN;;A6EnzjBE;EACE,2DAAA;A7EszjBJ;A6ErzjBI;EACE,2DAAA;A7EuzjBN;;A6E1zjBE;EACE,2DAAA;A7E6zjBJ;A6E5zjBI;EACE,2DAAA;A7E8zjBN;;A6Ej0jBE;EACE,2DAAA;A7Eo0jBJ;A6En0jBI;EACE,2DAAA;A7Eq0jBN;;A6Ex0jBE;EACE,2DAAA;A7E20jBJ;A6E10jBI;EACE,2DAAA;A7E40jBN;;A6E/0jBE;EACE,2DAAA;A7Ek1jBJ;A6Ej1jBI;EACE,2DAAA;A7Em1jBN;;A6Et1jBE;EACE,2DAAA;A7Ey1jBJ;A6Ex1jBI;EACE,2DAAA;A7E01jBN;;A6E71jBE;EACE,2DAAA;A7Eg2jBJ;A6E/1jBI;EACE,2DAAA;A7Ei2jBN;;A6Ep2jBE;EACE,2DAAA;A7Eu2jBJ;A6Et2jBI;EACE,2DAAA;A7Ew2jBN;;A6E32jBE;EACE,2DAAA;A7E82jBJ;A6E72jBI;EACE,2DAAA;A7E+2jBN;;A6El3jBE;EACE,2DAAA;A7Eq3jBJ;A6Ep3jBI;EACE,2DAAA;A7Es3jBN;;A6Ez3jBE;EACE,2DAAA;A7E43jBJ;A6E33jBI;EACE,2DAAA;A7E63jBN;;A6Eh4jBE;EACE,2DAAA;A7Em4jBJ;A6El4jBI;EACE,2DAAA;A7Eo4jBN;;A6Ev4jBE;EACE,2DAAA;A7E04jBJ;A6Ez4jBI;EACE,2DAAA;A7E24jBN;;A6E94jBE;EACE,2DAAA;A7Ei5jBJ;A6Eh5jBI;EACE,2DAAA;A7Ek5jBN;;A6Er5jBE;EACE,2DAAA;A7Ew5jBJ;A6Ev5jBI;EACE,2DAAA;A7Ey5jBN;;A6E55jBE;EACE,2DAAA;A7E+5jBJ;A6E95jBI;EACE,2DAAA;A7Eg6jBN;;A6En6jBE;EACE,2DAAA;A7Es6jBJ;A6Er6jBI;EACE,2DAAA;A7Eu6jBN;;A6E16jBE;EACE,2DAAA;A7E66jBJ;A6E56jBI;EACE,2DAAA;A7E86jBN;;A6Ej7jBE;EACE,2DAAA;A7Eo7jBJ;A6En7jBI;EACE,2DAAA;A7Eq7jBN;;A6Ex7jBE;EACE,2DAAA;A7E27jBJ;A6E17jBI;EACE,2DAAA;A7E47jBN;;A6E/7jBE;EACE,2DAAA;A7Ek8jBJ;A6Ej8jBI;EACE,2DAAA;A7Em8jBN;;A6Et8jBE;EACE,2DAAA;A7Ey8jBJ;A6Ex8jBI;EACE,2DAAA;A7E08jBN;;A6E78jBE;EACE,2DAAA;A7Eg9jBJ;A6E/8jBI;EACE,2DAAA;A7Ei9jBN;;A6Ep9jBE;EACE,2DAAA;A7Eu9jBJ;A6Et9jBI;EACE,2DAAA;A7Ew9jBN;;A6E39jBE;EACE,2DAAA;A7E89jBJ;A6E79jBI;EACE,2DAAA;A7E+9jBN;;A6El+jBE;EACE,2DAAA;A7Eq+jBJ;A6Ep+jBI;EACE,2DAAA;A7Es+jBN;;A6Ez+jBE;EACE,2DAAA;A7E4+jBJ;A6E3+jBI;EACE,2DAAA;A7E6+jBN;;A6Eh/jBE;EACE,2DAAA;A7Em/jBJ;A6El/jBI;EACE,2DAAA;A7Eo/jBN;;A6Ev/jBE;EACE,2DAAA;A7E0/jBJ;A6Ez/jBI;EACE,2DAAA;A7E2/jBN;;A6E9/jBE;EACE,2DAAA;A7EigkBJ;A6EhgkBI;EACE,2DAAA;A7EkgkBN;;A6ErgkBE;EACE,2DAAA;A7EwgkBJ;A6EvgkBI;EACE,2DAAA;A7EygkBN;;A6E5gkBE;EACE,2DAAA;A7E+gkBJ;A6E9gkBI;EACE,2DAAA;A7EghkBN;;A6EnhkBE;EACE,2DAAA;A7EshkBJ;A6ErhkBI;EACE,2DAAA;A7EuhkBN;;A6E1hkBE;EACE,2DAAA;A7E6hkBJ;A6E5hkBI;EACE,2DAAA;A7E8hkBN;;A6EjikBE;EACE,2DAAA;A7EoikBJ;A6EnikBI;EACE,2DAAA;A7EqikBN;;A6ExikBE;EACE,2DAAA;A7E2ikBJ;A6E1ikBI;EACE,2DAAA;A7E4ikBN;;A6E/ikBE;EACE,2DAAA;A7EkjkBJ;A6EjjkBI;EACE,2DAAA;A7EmjkBN;;A6EtjkBE;EACE,2DAAA;A7EyjkBJ;A6ExjkBI;EACE,2DAAA;A7E0jkBN;;A6E7jkBE;EACE,2DAAA;A7EgkkBJ;A6E/jkBI;EACE,2DAAA;A7EikkBN;;A6EpkkBE;EACE,2DAAA;A7EukkBJ;A6EtkkBI;EACE,2DAAA;A7EwkkBN;;A6E3kkBE;EACE,2DAAA;A7E8kkBJ;A6E7kkBI;EACE,2DAAA;A7E+kkBN;;A6EllkBE;EACE,2DAAA;A7EqlkBJ;A6EplkBI;EACE,2DAAA;A7EslkBN;;A6EzlkBE;EACE,2DAAA;A7E4lkBJ;A6E3lkBI;EACE,2DAAA;A7E6lkBN;;A6EhmkBE;EACE,2DAAA;A7EmmkBJ;A6ElmkBI;EACE,2DAAA;A7EomkBN;;A6EvmkBE;EACE,2DAAA;A7E0mkBJ;A6EzmkBI;EACE,2DAAA;A7E2mkBN;;A6E9mkBE;EACE,2DAAA;A7EinkBJ;A6EhnkBI;EACE,2DAAA;A7EknkBN;;A6ErnkBE;EACE,2DAAA;A7EwnkBJ;A6EvnkBI;EACE,2DAAA;A7EynkBN;;A6E5nkBE;EACE,2DAAA;A7E+nkBJ;A6E9nkBI;EACE,2DAAA;A7EgokBN;;A6EnokBE;EACE,2DAAA;A7EsokBJ;A6ErokBI;EACE,2DAAA;A7EuokBN;;A6E1okBE;EACE,2DAAA;A7E6okBJ;A6E5okBI;EACE,2DAAA;A7E8okBN;;A6EjpkBE;EACE,2DAAA;A7EopkBJ;A6EnpkBI;EACE,2DAAA;A7EqpkBN;;A6ExpkBE;EACE,2DAAA;A7E2pkBJ;A6E1pkBI;EACE,2DAAA;A7E4pkBN;;A6E/pkBE;EACE,2DAAA;A7EkqkBJ;A6EjqkBI;EACE,2DAAA;A7EmqkBN;;A6EtqkBE;EACE,2DAAA;A7EyqkBJ;A6ExqkBI;EACE,2DAAA;A7E0qkBN;;A6E7qkBE;EACE,2DAAA;A7EgrkBJ;A6E/qkBI;EACE,2DAAA;A7EirkBN;;A6EprkBE;EACE,2DAAA;A7EurkBJ;A6EtrkBI;EACE,2DAAA;A7EwrkBN;;A6E3rkBE;EACE,2DAAA;A7E8rkBJ;A6E7rkBI;EACE,2DAAA;A7E+rkBN;;A6ElskBE;EACE,2DAAA;A7EqskBJ;A6EpskBI;EACE,2DAAA;A7EsskBN;;A6EzskBE;EACE,2DAAA;A7E4skBJ;A6E3skBI;EACE,2DAAA;A7E6skBN;;A6EhtkBE;EACE,2DAAA;A7EmtkBJ;A6EltkBI;EACE,2DAAA;A7EotkBN;;A6EvtkBE;EACE,2DAAA;A7E0tkBJ;A6EztkBI;EACE,2DAAA;A7E2tkBN;;A6E9tkBE;EACE,2DAAA;A7EiukBJ;A6EhukBI;EACE,2DAAA;A7EkukBN;;A6ErukBE;EACE,2DAAA;A7EwukBJ;A6EvukBI;EACE,2DAAA;A7EyukBN;;A6E5ukBE;EACE,2DAAA;A7E+ukBJ;A6E9ukBI;EACE,2DAAA;A7EgvkBN;;A6EnvkBE;EACE,2DAAA;A7EsvkBJ;A6ErvkBI;EACE,2DAAA;A7EuvkBN;;A6E1vkBE;EACE,2DAAA;A7E6vkBJ;A6E5vkBI;EACE,2DAAA;A7E8vkBN;;A6EjwkBE;EACE,2DAAA;A7EowkBJ;A6EnwkBI;EACE,2DAAA;A7EqwkBN;;A6ExwkBE;EACE,2DAAA;A7E2wkBJ;A6E1wkBI;EACE,2DAAA;A7E4wkBN;;A6E/wkBE;EACE,2DAAA;A7EkxkBJ;A6EjxkBI;EACE,2DAAA;A7EmxkBN;;A6EtxkBE;EACE,2DAAA;A7EyxkBJ;A6ExxkBI;EACE,2DAAA;A7E0xkBN;;A6E7xkBE;EACE,2DAAA;A7EgykBJ;A6E/xkBI;EACE,2DAAA;A7EiykBN;;A6EpykBE;EACE,2DAAA;A7EuykBJ;A6EtykBI;EACE,2DAAA;A7EwykBN;;A6E3ykBE;EACE,2DAAA;A7E8ykBJ;A6E7ykBI;EACE,2DAAA;A7E+ykBN;;A6ElzkBE;EACE,2DAAA;A7EqzkBJ;A6EpzkBI;EACE,2DAAA;A7EszkBN;;A6EzzkBE;EACE,2DAAA;A7E4zkBJ;A6E3zkBI;EACE,2DAAA;A7E6zkBN;;A6Eh0kBE;EACE,2DAAA;A7Em0kBJ;A6El0kBI;EACE,2DAAA;A7Eo0kBN;;A6Ev0kBE;EACE,2DAAA;A7E00kBJ;A6Ez0kBI;EACE,2DAAA;A7E20kBN;;A6E90kBE;EACE,2DAAA;A7Ei1kBJ;A6Eh1kBI;EACE,2DAAA;A7Ek1kBN;;A6Er1kBE;EACE,2DAAA;A7Ew1kBJ;A6Ev1kBI;EACE,2DAAA;A7Ey1kBN;;A6E51kBE;EACE,2DAAA;A7E+1kBJ;A6E91kBI;EACE,2DAAA;A7Eg2kBN;;A6En2kBE;EACE,2DAAA;A7Es2kBJ;A6Er2kBI;EACE,2DAAA;A7Eu2kBN;;A6E12kBE;EACE,2DAAA;A7E62kBJ;A6E52kBI;EACE,2DAAA;A7E82kBN;;A6Ej3kBE;EACE,2DAAA;A7Eo3kBJ;A6En3kBI;EACE,2DAAA;A7Eq3kBN;;A6Ex3kBE;EACE,2DAAA;A7E23kBJ;A6E13kBI;EACE,2DAAA;A7E43kBN;;A6E/3kBE;EACE,2DAAA;A7Ek4kBJ;A6Ej4kBI;EACE,2DAAA;A7Em4kBN;;A6Et4kBE;EACE,2DAAA;A7Ey4kBJ;A6Ex4kBI;EACE,2DAAA;A7E04kBN;;A6E74kBE;EACE,2DAAA;A7Eg5kBJ;A6E/4kBI;EACE,2DAAA;A7Ei5kBN;;A6Ep5kBE;EACE,2DAAA;A7Eu5kBJ;A6Et5kBI;EACE,2DAAA;A7Ew5kBN;;A6E35kBE;EACE,2DAAA;A7E85kBJ;A6E75kBI;EACE,2DAAA;A7E+5kBN;;A6El6kBE;EACE,2DAAA;A7Eq6kBJ;A6Ep6kBI;EACE,2DAAA;A7Es6kBN;;A6Ez6kBE;EACE,2DAAA;A7E46kBJ;A6E36kBI;EACE,2DAAA;A7E66kBN;;A6Eh7kBE;EACE,2DAAA;A7Em7kBJ;A6El7kBI;EACE,2DAAA;A7Eo7kBN;;A6Ev7kBE;EACE,2DAAA;A7E07kBJ;A6Ez7kBI;EACE,2DAAA;A7E27kBN;;A6E97kBE;EACE,2DAAA;A7Ei8kBJ;A6Eh8kBI;EACE,2DAAA;A7Ek8kBN;;A6Er8kBE;EACE,2DAAA;A7Ew8kBJ;A6Ev8kBI;EACE,2DAAA;A7Ey8kBN;;A6E58kBE;EACE,2DAAA;A7E+8kBJ;A6E98kBI;EACE,2DAAA;A7Eg9kBN;;A6En9kBE;EACE,2DAAA;A7Es9kBJ;A6Er9kBI;EACE,2DAAA;A7Eu9kBN;;A6E19kBE;EACE,2DAAA;A7E69kBJ;A6E59kBI;EACE,2DAAA;A7E89kBN;;A6Ej+kBE;EACE,2DAAA;A7Eo+kBJ;A6En+kBI;EACE,2DAAA;A7Eq+kBN;;A6Ex+kBE;EACE,2DAAA;A7E2+kBJ;A6E1+kBI;EACE,2DAAA;A7E4+kBN;;A6E/+kBE;EACE,2DAAA;A7Ek/kBJ;A6Ej/kBI;EACE,2DAAA;A7Em/kBN;;A6Et/kBE;EACE,2DAAA;A7Ey/kBJ;A6Ex/kBI;EACE,2DAAA;A7E0/kBN;;A6E7/kBE;EACE,2DAAA;A7EgglBJ;A6E//kBI;EACE,2DAAA;A7EiglBN;;A6EpglBE;EACE,2DAAA;A7EuglBJ;A6EtglBI;EACE,2DAAA;A7EwglBN;;A6E3glBE;EACE,2DAAA;A7E8glBJ;A6E7glBI;EACE,2DAAA;A7E+glBN;;A6ElhlBE;EACE,2DAAA;A7EqhlBJ;A6EphlBI;EACE,2DAAA;A7EshlBN;;A6EzhlBE;EACE,2DAAA;A7E4hlBJ;A6E3hlBI;EACE,2DAAA;A7E6hlBN;;A6EhilBE;EACE,2DAAA;A7EmilBJ;A6ElilBI;EACE,2DAAA;A7EoilBN;;A6EvilBE;EACE,2DAAA;A7E0ilBJ;A6EzilBI;EACE,2DAAA;A7E2ilBN;;A6E9ilBE;EACE,2DAAA;A7EijlBJ;A6EhjlBI;EACE,2DAAA;A7EkjlBN;;A6ErjlBE;EACE,2DAAA;A7EwjlBJ;A6EvjlBI;EACE,2DAAA;A7EyjlBN;;A6E5jlBE;EACE,2DAAA;A7E+jlBJ;A6E9jlBI;EACE,2DAAA;A7EgklBN;;A6EnklBE;EACE,2DAAA;A7EsklBJ;A6ErklBI;EACE,2DAAA;A7EuklBN;;A6E1klBE;EACE,2DAAA;A7E6klBJ;A6E5klBI;EACE,2DAAA;A7E8klBN;;A6EjllBE;EACE,2DAAA;A7EollBJ;A6EnllBI;EACE,2DAAA;A7EqllBN;;A6ExllBE;EACE,2DAAA;A7E2llBJ;A6E1llBI;EACE,2DAAA;A7E4llBN;;A6E/llBE;EACE,2DAAA;A7EkmlBJ;A6EjmlBI;EACE,2DAAA;A7EmmlBN;;A6EtmlBE;EACE,2DAAA;A7EymlBJ;A6ExmlBI;EACE,2DAAA;A7E0mlBN;;A6E7mlBE;EACE,2DAAA;A7EgnlBJ;A6E/mlBI;EACE,2DAAA;A7EinlBN;;A6EpnlBE;EACE,2DAAA;A7EunlBJ;A6EtnlBI;EACE,2DAAA;A7EwnlBN;;A6E3nlBE;EACE,2DAAA;A7E8nlBJ;A6E7nlBI;EACE,2DAAA;A7E+nlBN;;A6ElolBE;EACE,2DAAA;A7EqolBJ;A6EpolBI;EACE,2DAAA;A7EsolBN;;A6EzolBE;EACE,2DAAA;A7E4olBJ;A6E3olBI;EACE,2DAAA;A7E6olBN;;A6EhplBE;EACE,2DAAA;A7EmplBJ;A6ElplBI;EACE,2DAAA;A7EoplBN;;A6EvplBE;EACE,2DAAA;A7E0plBJ;A6EzplBI;EACE,2DAAA;A7E2plBN;;A6E9plBE;EACE,2DAAA;A7EiqlBJ;A6EhqlBI;EACE,2DAAA;A7EkqlBN;;A6ErqlBE;EACE,2DAAA;A7EwqlBJ;A6EvqlBI;EACE,2DAAA;A7EyqlBN;;A6E5qlBE;EACE,2DAAA;A7E+qlBJ;A6E9qlBI;EACE,2DAAA;A7EgrlBN;;A6EnrlBE;EACE,2DAAA;A7EsrlBJ;A6ErrlBI;EACE,2DAAA;A7EurlBN;;A6E1rlBE;EACE,2DAAA;A7E6rlBJ;A6E5rlBI;EACE,2DAAA;A7E8rlBN;;A6EjslBE;EACE,2DAAA;A7EoslBJ;A6EnslBI;EACE,2DAAA;A7EqslBN;;A6ExslBE;EACE,2DAAA;A7E2slBJ;A6E1slBI;EACE,2DAAA;A7E4slBN;;A6E/slBE;EACE,2DAAA;A7EktlBJ;A6EjtlBI;EACE,2DAAA;A7EmtlBN;;A6EttlBE;EACE,2DAAA;A7EytlBJ;A6ExtlBI;EACE,2DAAA;A7E0tlBN;;A6E7tlBE;EACE,2DAAA;A7EgulBJ;A6E/tlBI;EACE,2DAAA;A7EiulBN;;A6EpulBE;EACE,2DAAA;A7EuulBJ;A6EtulBI;EACE,2DAAA;A7EwulBN;;A6E3ulBE;EACE,2DAAA;A7E8ulBJ;A6E7ulBI;EACE,2DAAA;A7E+ulBN;;A6ElvlBE;EACE,2DAAA;A7EqvlBJ;A6EpvlBI;EACE,2DAAA;A7EsvlBN;;A6EzvlBE;EACE,2DAAA;A7E4vlBJ;A6E3vlBI;EACE,2DAAA;A7E6vlBN;;A6EhwlBE;EACE,2DAAA;A7EmwlBJ;A6ElwlBI;EACE,2DAAA;A7EowlBN;;A6EvwlBE;EACE,2DAAA;A7E0wlBJ;A6EzwlBI;EACE,2DAAA;A7E2wlBN;;A6E9wlBE;EACE,2DAAA;A7EixlBJ;A6EhxlBI;EACE,2DAAA;A7EkxlBN;;A6ErxlBE;EACE,2DAAA;A7EwxlBJ;A6EvxlBI;EACE,2DAAA;A7EyxlBN;;A6E5xlBE;EACE,2DAAA;A7E+xlBJ;A6E9xlBI;EACE,2DAAA;A7EgylBN;;A6EnylBE;EACE,2DAAA;A7EsylBJ;A6ErylBI;EACE,2DAAA;A7EuylBN;;A6E1ylBE;EACE,2DAAA;A7E6ylBJ;A6E5ylBI;EACE,2DAAA;A7E8ylBN;;A6EjzlBE;EACE,2DAAA;A7EozlBJ;A6EnzlBI;EACE,2DAAA;A7EqzlBN;;A6ExzlBE;EACE,2DAAA;A7E2zlBJ;A6E1zlBI;EACE,2DAAA;A7E4zlBN;;A6E/zlBE;EACE,2DAAA;A7Ek0lBJ;A6Ej0lBI;EACE,2DAAA;A7Em0lBN;;A6Et0lBE;EACE,2DAAA;A7Ey0lBJ;A6Ex0lBI;EACE,2DAAA;A7E00lBN;;A6E70lBE;EACE,2DAAA;A7Eg1lBJ;A6E/0lBI;EACE,2DAAA;A7Ei1lBN;;A6Ep1lBE;EACE,2DAAA;A7Eu1lBJ;A6Et1lBI;EACE,2DAAA;A7Ew1lBN;;A6E31lBE;EACE,2DAAA;A7E81lBJ;A6E71lBI;EACE,2DAAA;A7E+1lBN;;A6El2lBE;EACE,2DAAA;A7Eq2lBJ;A6Ep2lBI;EACE,2DAAA;A7Es2lBN;;A6Ez2lBE;EACE,2DAAA;A7E42lBJ;A6E32lBI;EACE,2DAAA;A7E62lBN;;A6Eh3lBE;EACE,2DAAA;A7Em3lBJ;A6El3lBI;EACE,2DAAA;A7Eo3lBN;;A6Ev3lBE;EACE,2DAAA;A7E03lBJ;A6Ez3lBI;EACE,2DAAA;A7E23lBN;;A6E93lBE;EACE,2DAAA;A7Ei4lBJ;A6Eh4lBI;EACE,2DAAA;A7Ek4lBN;;A6Er4lBE;EACE,2DAAA;A7Ew4lBJ;A6Ev4lBI;EACE,2DAAA;A7Ey4lBN;;A6E54lBE;EACE,2DAAA;A7E+4lBJ;A6E94lBI;EACE,2DAAA;A7Eg5lBN;;A6En5lBE;EACE,2DAAA;A7Es5lBJ;A6Er5lBI;EACE,2DAAA;A7Eu5lBN;;A6E15lBE;EACE,2DAAA;A7E65lBJ;A6E55lBI;EACE,2DAAA;A7E85lBN;;A6Ej6lBE;EACE,2DAAA;A7Eo6lBJ;A6En6lBI;EACE,2DAAA;A7Eq6lBN;;A6Ex6lBE;EACE,2DAAA;A7E26lBJ;A6E16lBI;EACE,2DAAA;A7E46lBN;;A6E/6lBE;EACE,2DAAA;A7Ek7lBJ;A6Ej7lBI;EACE,2DAAA;A7Em7lBN;;A6Et7lBE;EACE,2DAAA;A7Ey7lBJ;A6Ex7lBI;EACE,2DAAA;A7E07lBN;;A6E77lBE;EACE,2DAAA;A7Eg8lBJ;A6E/7lBI;EACE,2DAAA;A7Ei8lBN;;A6Ep8lBE;EACE,2DAAA;A7Eu8lBJ;A6Et8lBI;EACE,2DAAA;A7Ew8lBN;;A6E38lBE;EACE,2DAAA;A7E88lBJ;A6E78lBI;EACE,2DAAA;A7E+8lBN;;A6El9lBE;EACE,2DAAA;A7Eq9lBJ;A6Ep9lBI;EACE,2DAAA;A7Es9lBN;;A6Ez9lBE;EACE,2DAAA;A7E49lBJ;A6E39lBI;EACE,2DAAA;A7E69lBN;;A6Eh+lBE;EACE,2DAAA;A7Em+lBJ;A6El+lBI;EACE,2DAAA;A7Eo+lBN;;A6Ev+lBE;EACE,2DAAA;A7E0+lBJ;A6Ez+lBI;EACE,2DAAA;A7E2+lBN;;A6E9+lBE;EACE,2DAAA;A7Ei/lBJ;A6Eh/lBI;EACE,2DAAA;A7Ek/lBN;;A8E1gmBA;+BAAA;AAGA;EACC,sBAAA;EACA,8CAAA;EACA,2PAAA;EAIA,mBAAA;EACA,kBAAA;A9EygmBD;A+EnhmBA;;ECWE,sBAAA;EACF,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;GhF4gmBE,mBgF3gmBA;AhF4gmBF;;A+E3hmBA;;EAEE,wBAAA;EACA,qBAAA;EACA,WAAA;A/E8hmBF;;A+E3hmBA,6DAAA;AACA;EACE,oBAAA;EACA,yBAAA;A/E8hmBF;;A+E3hmBA,iDAAA;AAEE;;EAEE,eAAA;A/E6hmBJ;;A+EzhmBA,uCAAA;AAGE;;EACE,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;A/E2hmBJ;A+E1hmBI;;EACE,qBAAA;A/E6hmBN;;A+ExhmBA;EACE,2BEpCe;EFqCf,qBAAA;A/E2hmBF;A+EzhmBE;EAAO,kBAAA;A/E4hmBT;A+E1hmBE;EACE,kBAAA;EACA,qBAAA;EACA,qBE5Ca;EF6Cb,kBAAA;EACA,oBAAA;A/E4hmBJ;;A+ErhmBE;;EACE,aAAA;A/EyhmBJ;;A+ErhmBA;EAAc,cE7DF;AjFslmBZ;;A+ExhmBA;EAAc,YE7DF;AjFylmBZ;;A+E3hmBA;EAAa,cE7DF;AjF4lmBX;;A+E1hmBA;EACE,yBAAA;EACA,4BAAA;EC9CA,kBD+CuB;A/E+hmBzB;;A+EzhmBA;EACE,cAAA;A/E4hmBF;A+E3hmBE;EACE,iBAAA;ECxDF,kBDyDyB;A/E+hmB3B;;A+E5hmBA;EACE,cAAA;A/E+hmBF;A+E9hmBE;EACE,iBAAA;EC/DF,kBDgEyB;A/EkimB3B;;A+E/hmBA;EACE,cAAA;A/EkimBF;A+EjimBE;EACE,iBAAA;ECtEF,kBDuEyB;A/EqimB3B;;A+EjimBA;EACE,cAAA;A/EoimBF;A+EnimBE;EACE,iBAAA;EC9EF,kBD+EyB;A/EuimB3B;;A+E9hmBA;EAAc,YAAA;A/EkimBd;;A+EjimBA;EAAa,WAAA;A/EqimBb;;A+EjimBE;;EACE,mBAAA;A/EqimBJ;A+EnimBE;;EACE,kBAAA;A/EsimBJ;;AkFlqmBA;+BAAA;AAGA,6BAAA;AF6BE;EACE,kBAAA;EACA,qBAAA;EACA,UAJsB;EAKtB,WALoC;EAMpC,gBANsB;EAOtB,oBAAA;AhFwomBJ;AgFvomBI;;EAEE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAfuD;EAgBvD,oBAAA;GhFyomBJ,gBgFzpmBsC;AhF0pmBxC;AgFvomBI;EACE,cApB6E;GhF6pmBjF,gBgFxomBI;AhFyomBN;;AkFvrmBA,2BAAA;AACA;EACE,qBAAA;EAIA,kCAAA;AlF0rmBF;;AkFvrmBA,0EAAA;AACA;;EAEE,qBAAA;EACA,qBAAA;AlF0rmBF;AkFvqmBA;EACE;IAAK,uBAAA;ElF2smBL;EkF1smBA;IAAO,yBAAA;ElF6smBP;AACF;AkF/rmBA,iCAAA;AACA;EAKE,wBAAA;EACA,gEAAA;AlFismBF;;AkF9rmBA;EAKE,yBAAA;EACA,gEAAA;AlFismBF;;AkF9rmBA;EAKE,yBAAA;EACA,gEAAA;AlFismBF;;AkF9rmBA;EAKE,uBAAA;AlFismBF;;AkF9rmBA;EAKE,uBAAA;AlFismBF;;AkF9rmBA,8CAAA;AAGI;EAAW,qBAAA;AlFgsmBf;;AmFtymBA;EAAmB,gBAAA;AnF0ymBnB;;AmFzymBA;EAAqB,gBAAA;AnF6ymBrB;;AmF5ymBA;EAAmB,gBAAA;AnFgzmBnB;;AmF/ymBA;EAAqB,gBAAA;AnFmzmBrB;;AmFlzmBA;EAAqB,gBAAA;AnFszmBrB;;AmFrzmBA;EAAoB,gBAAA;AnFyzmBpB;;AmFxzmBA;EAAsB,gBAAA;AnF4zmBtB;;AmF3zmBA;EAAqB,gBAAA;AnF+zmBrB;;AmF9zmBA;EAAkB,gBAAA;AnFk0mBlB;;AmFj0mBA;EAAqB,gBAAA;AnFq0mBrB;;AmFp0mBA;EAAmB,gBAAA;AnFw0mBnB;;AmFv0mBA;EAAoB,gBAAA;AnF20mBpB;;AmF10mBA;EAAqB,gBAAA;AnF80mBrB;;AmF70mBA;EAA4B,gBAAA;AnFi1mB5B;;AmFh1mBA;EAAiC,gBAAA;AnFo1mBjC;;AmFn1mBA;EAAuB,gBAAA;AnFu1mBvB;;AmFt1mBA;EAAmB,gBAAA;AnF01mBnB;;AmFz1mBA;EAAsB,gBAAA;AnF61mBtB;;AmF51mBA;EAAuB,gBAAA;AnFg2mBvB;;AmF/1mBA;EAAkB,gBAAA;AnFm2mBlB;;AmFl2mBA;EAAoB,gBAAA;AnFs2mBpB;;AmFr2mBA;EAA2B,gBAAA;AnFy2mB3B;;AmFx2mBA;EAAwB,gBAAA;AnF42mBxB;;AmF32mBA;EAAuB,gBAAA;AnF+2mBvB;;AmF92mBA;EAA2B,gBAAA;AnFk3mB3B;;AmFj3mBA;EAAqB,gBAAA;AnFq3mBrB;;AmFp3mBA;EAAmB,gBAAA;AnFw3mBnB;;AmFv3mBA;EAAkB,gBAAA;AnF23mBlB;;AmF13mBA;EAAqB,gBAAA;AnF83mBrB;;AmF73mBA;EAAyB,gBAAA;AnFi4mBzB;;AmFh4mBA;EAA2B,gBAAA;AnFo4mB3B;;AmFn4mBA;EAA2B,gBAAA;AnFu4mB3B;;AmFt4mBA;EAAiB,gBAAA;AnF04mBjB;;AmFz4mBA;EAAqB,gBAAA;AnF64mBrB;;AmF54mBA;EAAoB,gBAAA;AnFg5mBpB;;AmF/4mBA;EAAqB,gBAAA;AnFm5mBrB;;AmFl5mBA;EAAyB,gBAAA;AnFs5mBzB;;AmFr5mBA;EAAqB,gBAAA;AnFy5mBrB;;AmFx5mBA;EAAyB,gBAAA;AnF45mBzB;;AmF35mBA;EAAuB,gBAAA;AnF+5mBvB;;AmF95mBA;EAA0B,gBAAA;AnFk6mB1B;;AmFj6mBA;EAAyB,gBAAA;AnFq6mBzB;;AmFp6mBA;EAAyB,gBAAA;AnFw6mBzB;;AmFv6mBA;EAAmB,gBAAA;AnF26mBnB;;AmF16mBA;EAA6B,gBAAA;AnF86mB7B;;AmF76mBA;EAAmB,gBAAA;AnFi7mBnB;;AmFh7mBA;EAAqB,gBAAA;AnFo7mBrB;;AmFn7mBA;EAAqB,gBAAA;AnFu7mBrB;;AmFt7mBA;EAAyB,gBAAA;AnF07mBzB;;AmFz7mBA;EAAkB,gBAAA;AnF67mBlB;;AmF57mBA;EAAqB,gBAAA;AnFg8mBrB;;AmF/7mBA;EAAoB,gBAAA;AnFm8mBpB;;AmFl8mBA;EAAoB,gBAAA;AnFs8mBpB;;AmFr8mBA;EAA2B,gBAAA;AnFy8mB3B;;AmFx8mBA;EAAwB,gBAAA;AnF48mBxB;;AmF38mBA;EAAwB,gBAAA;AnF+8mBxB;;AmF98mBA;EAAwB,gBAAA;AnFk9mBxB;;AmFj9mBA;EAAqB,gBAAA;AnFq9mBrB;;AmFp9mBA;EAAmB,gBAAA;AnFw9mBnB;;AmFv9mBA;EAAuB,gBAAA;AnF29mBvB;;AmF19mBA;EAAyB,gBAAA;AnF89mBzB;;AmF79mBA;EAAkB,gBAAA;AnFi+mBlB;;AmFh+mBA;EAAqB,gBAAA;AnFo+mBrB;;AmFn+mBA;EAAgC,gBAAA;AnFu+mBhC;;AmFt+mBA;EAAsB,gBAAA;AnF0+mBtB;;AmFz+mBA;EAAkB,gBAAA;AnF6+mBlB;;AmF5+mBA;EAAoB,gBAAA;AnFg/mBpB;;AmF/+mBA;EAAuB,gBAAA;AnFm/mBvB;;AmFl/mBA;EAAsB,gBAAA;AnFs/mBtB;;AmFr/mBA;EAA0B,gBAAA;AnFy/mB1B;;AmFx/mBA;EAAoB,gBAAA;AnF4/mBpB;;AmF3/mBA;EAAmB,gBAAA;AnF+/mBnB;;AmF9/mBA;EAAuB,gBAAA;AnFkgnBvB;;AmFjgnBA;EAA0B,gBAAA;AnFqgnB1B;;AmFpgnBA;EAAyB,gBAAA;AnFwgnBzB;;AmFvgnBA;EAAyB,gBAAA;AnF2gnBzB;;AmF1gnBA;EAAoB,gBAAA;AnF8gnBpB;;AmF7gnBA;EAAwB,gBAAA;AnFihnBxB;;AmFhhnBA;EAAqB,gBAAA;AnFohnBrB;;AmFnhnBA;EAA2B,gBAAA;AnFuhnB3B;;AmFthnBA;EAAoB,gBAAA;AnF0hnBpB;;AmFzhnBA;EAAwB,gBAAA;AnF6hnBxB;;AmF5hnBA;EAAmB,gBAAA;AnFginBnB;;AmF/hnBA;EAAuB,gBAAA;AnFminBvB;;AmFlinBA;EAAyB,gBAAA;AnFsinBzB;;AmFrinBA;EAAkB,gBAAA;AnFyinBlB;;AmFxinBA;EAAmB,gBAAA;AnF4inBnB;;AmF3inBA;EAA8B,gBAAA;AnF+inB9B;;AmF9inBA;EAAgC,gBAAA;AnFkjnBhC;;AmFjjnBA;EAAyB,gBAAA;AnFqjnBzB;;AmFpjnBA;EAA8B,gBAAA;AnFwjnB9B;;AmFvjnBA;EAA6B,gBAAA;AnF2jnB7B;;AmF1jnBA;EAA8B,gBAAA;AnF8jnB9B;;AmF7jnBA;EAAiC,gBAAA;AnFiknBjC;;AmFhknBA;EAAgC,gBAAA;AnFoknBhC;;AmFnknBA;EAAgC,gBAAA;AnFuknBhC;;AmFtknBA;EAA8B,gBAAA;AnF0knB9B;;AmFzknBA;EAAiC,gBAAA;AnF6knBjC;;AmF5knBA;EAAgC,gBAAA;AnFglnBhC;;AmF/knBA;EAAgC,gBAAA;AnFmlnBhC;;AmFllnBA;EAAkB,gBAAA;AnFslnBlB;;AmFrlnBA;EAAoB,gBAAA;AnFylnBpB;;AmFxlnBA;EAAyB,gBAAA;AnF4lnBzB;;AmF3lnBA;EAAwB,gBAAA;AnF+lnBxB;;AmF9lnBA;EAA4B,gBAAA;AnFkmnB5B;;AmFjmnBA;EAAwB,gBAAA;AnFqmnBxB;;AmFpmnBA;EAAwB,gBAAA;AnFwmnBxB;;AmFvmnBA;EAAqB,gBAAA;AnF2mnBrB;;AmF1mnBA;EAAwB,gBAAA;AnF8mnBxB;;AmF7mnBA;EAAoB,gBAAA;AnFinnBpB;;AmFhnnBA;EAAoB,gBAAA;AnFonnBpB;;AmFnnnBA;EAAqB,gBAAA;AnFunnBrB;;AmFtnnBA;EAAuB,gBAAA;AnF0nnBvB;;AmFznnBA;EAAyB,gBAAA;AnF6nnBzB;;AmF5nnBA;EAAmB,gBAAA;AnFgonBnB;;AmF/nnBA;EAAuB,gBAAA;AnFmonBvB;;AmFlonBA;EAAyB,gBAAA;AnFsonBzB;;AmFronBA;EAAsB,gBAAA;AnFyonBtB;;AmFxonBA;EAAsB,gBAAA;AnF4onBtB;;AmF3onBA;EAAuB,gBAAA;AnF+onBvB;;AmF9onBA;EAAoB,gBAAA;AnFkpnBpB;;AmFjpnBA;EAA0B,gBAAA;AnFqpnB1B;;AmFppnBA;EAAyB,gBAAA;AnFwpnBzB;;AmFvpnBA;EAAqB,gBAAA;AnF2pnBrB;;AmF1pnBA;EAAsB,gBAAA;AnF8pnBtB;;AmF7pnBA;EAAqB,gBAAA;AnFiqnBrB;;AmFhqnBA;EAA0B,gBAAA;AnFoqnB1B;;AmFnqnBA;EAAyB,gBAAA;AnFuqnBzB;;AmFtqnBA;EAAoB,gBAAA;AnF0qnBpB;;AmFzqnBA;EAAsB,gBAAA;AnF6qnBtB;;AmF5qnBA;EAAwB,gBAAA;AnFgrnBxB;;AmF/qnBA;EAAmB,gBAAA;AnFmrnBnB;;AmFlrnBA;EAAwB,gBAAA;AnFsrnBxB;;AmFrrnBA;EAAwB,gBAAA;AnFyrnBxB;;AmFxrnBA;EAAoB,gBAAA;AnF4rnBpB;;AmF3rnBA;EAAsB,gBAAA;AnF+rnBtB;;AmF9rnBA;EAAoB,gBAAA;AnFksnBpB;;AmFjsnBA;EAAwB,gBAAA;AnFqsnBxB;;AmFpsnBA;EAAoB,gBAAA;AnFwsnBpB;;AmFvsnBA;EAAwB,gBAAA;AnF2snBxB;;AmF1snBA;EAAoB,gBAAA;AnF8snBpB;;AmF7snBA;EAAyB,gBAAA;AnFitnBzB;;AmFhtnBA;EAAmB,gBAAA;AnFotnBnB;;AmFntnBA;EAAuB,gBAAA;AnFutnBvB;;AmFttnBA;EAAkB,gBAAA;AnF0tnBlB;;AmFztnBA;EAAsB,gBAAA;AnF6tnBtB;;AmF5tnBA;EAAmB,gBAAA;AnFgunBnB;;AmF/tnBA;EAA2B,gBAAA;AnFmunB3B;;AmFlunBA;EAAmB,gBAAA;AnFsunBnB;;AmFrunBA;EAAyB,gBAAA;AnFyunBzB;;AmFxunBA;EAAqB,gBAAA;AnF4unBrB;;AmF3unBA;EAAmB,gBAAA;AnF+unBnB;;AmF9unBA;EAAuB,gBAAA;AnFkvnBvB;;AmFjvnBA;EAAuB,gBAAA;AnFqvnBvB;;AmFpvnBA;EAAqB,gBAAA;AnFwvnBrB;;AmFvvnBA;EAAmB,gBAAA;AnF2vnBnB;;AmF1vnBA;EAAmB,gBAAA;AnF8vnBnB;;AmF7vnBA;EAAwB,gBAAA;AnFiwnBxB;;AmFhwnBA;EAAyB,gBAAA;AnFownBzB;;AmFnwnBA;EAAwB,gBAAA;AnFuwnBxB;;AmFtwnBA;EAAmB,gBAAA;AnF0wnBnB;;AmFzwnBA;EAAmB,gBAAA;AnF6wnBnB;;AmF5wnBA;EAAqB,gBAAA;AnFgxnBrB;;AmF/wnBA;EAAoB,gBAAA;AnFmxnBpB;;AmFlxnBA;EAAmB,gBAAA;AnFsxnBnB;;AmFrxnBA;EAAqB,gBAAA;AnFyxnBrB;;AmFxxnBA;EAAuB,gBAAA;AnF4xnBvB;;AmF3xnBA;EAAuB,gBAAA;AnF+xnBvB;;AmF9xnBA;EAAwB,gBAAA;AnFkynBxB;;AmFjynBA;EAA4B,gBAAA;AnFqynB5B;;AmFpynBA;EAAwB,gBAAA;AnFwynBxB;;AmFvynBA;EAA2B,gBAAA;AnF2ynB3B;;AmF1ynBA;EAA8B,gBAAA;AnF8ynB9B;;AmF7ynBA;EAA2B,gBAAA;AnFiznB3B;;AmFhznBA;EAA4B,gBAAA;AnFoznB5B;;AmFnznBA;EAA8B,gBAAA;AnFuznB9B;;AmFtznBA;EAA+B,gBAAA;AnF0znB/B;;AmFzznBA;EAAoB,gBAAA;AnF6znBpB;;AmF5znBA;EAAuB,gBAAA;AnFg0nBvB;;AmF/znBA;EAAyB,gBAAA;AnFm0nBzB;;AmFl0nBA;EAAwB,gBAAA;AnFs0nBxB;;AmFr0nBA;EAAkB,gBAAA;AnFy0nBlB;;AmFx0nBA;EAAuB,gBAAA;AnF40nBvB;;AmF30nBA;EAAmB,gBAAA;AnF+0nBnB;;AmF90nBA;EAAmB,gBAAA;AnFk1nBnB;;AmFj1nBA;EAAyB,gBAAA;AnFq1nBzB;;AmFp1nBA;EAAwB,gBAAA;AnFw1nBxB;;AmFv1nBA;EAA4B,gBAAA;AnF21nB5B;;AmF11nBA;EAAyB,gBAAA;AnF81nBzB;;AmF71nBA;EAAwB,gBAAA;AnFi2nBxB;;AmFh2nBA;EAA4B,gBAAA;AnFo2nB5B;;AmFn2nBA;EAAsB,gBAAA;AnFu2nBtB;;AmFt2nBA;EAAqB,gBAAA;AnF02nBrB;;AmFz2nBA;EAA0B,gBAAA;AnF62nB1B;;AmF52nBA;EAAyB,gBAAA;AnFg3nBzB;;AmF/2nBA;EAA4B,gBAAA;AnFm3nB5B;;AmFl3nBA;EAA2B,gBAAA;AnFs3nB3B;;AmFr3nBA;EAAoB,gBAAA;AnFy3nBpB;;AmFx3nBA;EAA0B,gBAAA;AnF43nB1B;;AmF33nBA;EAAqB,gBAAA;AnF+3nBrB;;AmF93nBA;EAAoB,gBAAA;AnFk4nBpB;;AmFj4nBA;EAAqB,gBAAA;AnFq4nBrB;;AmFp4nBA;EAAyB,gBAAA;AnFw4nBzB;;AmFv4nBA;EAAqB,gBAAA;AnF24nBrB;;AmF14nBA;EAAyB,gBAAA;AnF84nBzB;;AmF74nBA;EAAqB,gBAAA;AnFi5nBrB;;AmFh5nBA;EAA4B,gBAAA;AnFo5nB5B;;AmFn5nBA;EAA2B,gBAAA;AnFu5nB3B;;AmFt5nBA;EAAqB,gBAAA;AnF05nBrB;;AmFz5nBA;EAA2B,gBAAA;AnF65nB3B;;AmF55nBA;EAA8B,gBAAA;AnFg6nB9B;;AmF/5nBA;EAAkC,gBAAA;AnFm6nBlC;;AmFl6nBA;EAAsB,gBAAA;AnFs6nBtB;;AmFr6nBA;EAAoB,gBAAA;AnFy6nBpB;;AmFx6nBA;EAA0B,gBAAA;AnF46nB1B;;AmF36nBA;EAAoB,gBAAA;AnF+6nBpB;;AmF96nBA;EAAwB,gBAAA;AnFk7nBxB;;AmFj7nBA;EAA8B,gBAAA;AnFq7nB9B;;AmFp7nBA;EAA6B,gBAAA;AnFw7nB7B;;AmFv7nBA;EAA0B,gBAAA;AnF27nB1B;;AmF17nBA;EAAsB,gBAAA;AnF87nBtB;;AmF77nBA;EAAmB,gBAAA;AnFi8nBnB;;AmFh8nBA;EAAsB,gBAAA;AnFo8nBtB;;AmFn8nBA;EAA0B,gBAAA;AnFu8nB1B;;AmFt8nBA;EAAsB,gBAAA;AnF08nBtB;;AmFz8nBA;EAAmB,gBAAA;AnF68nBnB;;AmF58nBA;EAAuB,gBAAA;AnFg9nBvB;;AmF/8nBA;EAA6B,gBAAA;AnFm9nB7B;;AmFl9nBA;EAAqB,gBAAA;AnFs9nBrB;;AmFr9nBA;EAA0B,gBAAA;AnFy9nB1B;;AmFx9nBA;EAA0B,gBAAA;AnF49nB1B;;AmF39nBA;EAA0B,gBAAA;AnF+9nB1B;;AmF99nBA;EAAgC,gBAAA;AnFk+nBhC;;AmFj+nBA;EAAmC,gBAAA;AnFq+nBnC;;AmFp+nBA;EAAuC,gBAAA;AnFw+nBvC;;AmFv+nBA;EAAyB,gBAAA;AnF2+nBzB;;AmF1+nBA;EAAgC,gBAAA;AnF8+nBhC;;AmF7+nBA;EAA2B,gBAAA;AnFi/nB3B;;AmFh/nBA;EAA6B,gBAAA;AnFo/nB7B;;AmFn/nBA;EAA4B,gBAAA;AnFu/nB5B;;AmFt/nBA;EAAgC,gBAAA;AnF0/nBhC;;AmFz/nBA;EAAmC,gBAAA;AnF6/nBnC;;AmF5/nBA;EAAkC,gBAAA;AnFggoBlC;;AmF//nBA;EAAkC,gBAAA;AnFmgoBlC;;AmFlgoBA;EAAiC,gBAAA;AnFsgoBjC;;AmFrgoBA;EAA0B,gBAAA;AnFygoB1B;;AmFxgoBA;EAA4B,gBAAA;AnF4goB5B;;AmF3goBA;EAAoC,gBAAA;AnF+goBpC;;AmF9goBA;EAA+B,gBAAA;AnFkhoB/B;;AmFjhoBA;EAAqC,gBAAA;AnFqhoBrC;;AmFphoBA;EAAiC,gBAAA;AnFwhoBjC;;AmFvhoBA;EAAmC,gBAAA;AnF2hoBnC;;AmF1hoBA;EAAuC,gBAAA;AnF8hoBvC;;AmF7hoBA;EAAyC,gBAAA;AnFiioBzC;;AmFhioBA;EAAoC,gBAAA;AnFoioBpC;;AmFnioBA;EAAgC,gBAAA;AnFuioBhC;;AmFtioBA;EAAsC,gBAAA;AnF0ioBtC;;AmFzioBA;EAAkC,gBAAA;AnF6ioBlC;;AmF5ioBA;EAAgC,gBAAA;AnFgjoBhC;;AmF/ioBA;EAAoC,gBAAA;AnFmjoBpC;;AmFljoBA;EAA+B,gBAAA;AnFsjoB/B;;AmFrjoBA;EAAsC,gBAAA;AnFyjoBtC;;AmFxjoBA;EAAgC,gBAAA;AnF4joBhC;;AmF3joBA;EAA2B,gBAAA;AnF+joB3B;;AmF9joBA;EAA2B,gBAAA;AnFkkoB3B;;AmFjkoBA;EAA2B,gBAAA;AnFqkoB3B;;AmFpkoBA;EAAiC,gBAAA;AnFwkoBjC;;AmFvkoBA;EAA+B,gBAAA;AnF2koB/B;;AmF1koBA;EAA8B,gBAAA;AnF8koB9B;;AmF7koBA;EAAgC,gBAAA;AnFiloBhC;;AmFhloBA;EAAmC,gBAAA;AnFoloBnC;;AmFnloBA;EAAkC,gBAAA;AnFuloBlC;;AmFtloBA;EAA6B,gBAAA;AnF0loB7B;;AmFzloBA;EAA6B,gBAAA;AnF6loB7B;;AmF5loBA;EAA6B,gBAAA;AnFgmoB7B;;AmF/loBA;EAAyC,gBAAA;AnFmmoBzC;;AmFlmoBA;EAAsC,gBAAA;AnFsmoBtC;;AmFrmoBA;EAAoC,gBAAA;AnFymoBpC;;AmFxmoBA;EAAsB,gBAAA;AnF4moBtB;;AmF3moBA;EAAuB,gBAAA;AnF+moBvB;;AmF9moBA;EAAuB,gBAAA;AnFknoBvB;;AmFjnoBA;EAA4B,gBAAA;AnFqnoB5B;;AmFpnoBA;EAA4B,gBAAA;AnFwnoB5B;;AmFvnoBA;EAA+B,gBAAA;AnF2noB/B;;AmF1noBA;EAA8B,gBAAA;AnF8noB9B;;AmF7noBA;EAA8B,gBAAA;AnFiooB9B;;AmFhooBA;EAAsB,gBAAA;AnFoooBtB;;AmFnooBA;EAAyB,gBAAA;AnFuooBzB;;AmFtooBA;EAAuB,gBAAA;AnF0ooBvB;;AmFzooBA;EAA0B,gBAAA;AnF6ooB1B;;AmF5ooBA;EAAmC,gBAAA;AnFgpoBnC;;AmF/ooBA;EAAoC,gBAAA;AnFmpoBpC;;AmFlpoBA;EAA6B,gBAAA;AnFspoB7B;;AmFrpoBA;EAA4B,gBAAA;AnFypoB5B;;AmFxpoBA;EAA8B,gBAAA;AnF4poB9B;;AmF3poBA;EAAwB,gBAAA;AnF+poBxB;;AmF9poBA;EAAsB,gBAAA;AnFkqoBtB;;AmFjqoBA;EAAoB,gBAAA;AnFqqoBpB;;AmFpqoBA;EAAsB,gBAAA;AnFwqoBtB;;AmFvqoBA;EAAmB,gBAAA;AnF2qoBnB;;AmF1qoBA;EAAqB,gBAAA;AnF8qoBrB;;AmF7qoBA;EAAoB,gBAAA;AnFiroBpB;;AmFhroBA;EAAoB,gBAAA;AnForoBpB;;AmFnroBA;EAAwB,gBAAA;AnFuroBxB;;AmFtroBA;EAAqB,gBAAA;AnF0roBrB;;AmFzroBA;EAAwB,gBAAA;AnF6roBxB;;AmF5roBA;EAAyB,gBAAA;AnFgsoBzB;;AmF/roBA;EAAwB,gBAAA;AnFmsoBxB;;AmFlsoBA;EAAsB,gBAAA;AnFssoBtB;;AmFrsoBA;EAAuB,gBAAA;AnFysoBvB;;AmFxsoBA;EAA+B,gBAAA;AnF4soB/B;;AmF3soBA;EAA+B,gBAAA;AnF+soB/B;;AmF9soBA;EAA+B,gBAAA;AnFktoB/B;;AmFjtoBA;EAA+B,gBAAA;AnFqtoB/B;;AmFptoBA;EAAiC,gBAAA;AnFwtoBjC;;AmFvtoBA;EAAiC,gBAAA;AnF2toBjC;;AmF1toBA;EAAiC,gBAAA;AnF8toBjC;;AmF7toBA;EAAwB,gBAAA;AnFiuoBxB;;AmFhuoBA;EAAqB,gBAAA;AnFouoBrB;;AmFnuoBA;EAAqB,gBAAA;AnFuuoBrB;;AmFtuoBA;EAAqB,gBAAA;AnF0uoBrB;;AmFzuoBA;EAAuB,gBAAA;AnF6uoBvB;;AmF5uoBA;EAAsB,gBAAA;AnFgvoBtB;;AmF/uoBA;EAAuB,gBAAA;AnFmvoBvB;;AmFlvoBA;EAAoB,gBAAA;AnFsvoBpB;;AmFrvoBA;EAAsB,gBAAA;AnFyvoBtB;;AmFxvoBA;EAAmB,gBAAA;AnF4voBnB;;AmF3voBA;EAAuB,gBAAA;AnF+voBvB;;AmF9voBA;EAAoB,gBAAA;AnFkwoBpB;;AmFjwoBA;EAAwB,gBAAA;AnFqwoBxB;;AmFpwoBA;EAAwB,gBAAA;AnFwwoBxB;;AmFvwoBA;EAA0B,gBAAA;AnF2woB1B;;AmF1woBA;EAAyB,gBAAA;AnF8woBzB;;AmF7woBA;EAAqB,gBAAA;AnFixoBrB;;AmFhxoBA;EAA6B,gBAAA;AnFoxoB7B;;AmFnxoBA;EAAyB,gBAAA;AnFuxoBzB;;AmFtxoBA;EAAwB,gBAAA;AnF0xoBxB;;AmFzxoBA;EAA4B,gBAAA;AnF6xoB5B;;AmF5xoBA;EAAqB,gBAAA;AnFgyoBrB;;AmF/xoBA;EAA4B,gBAAA;AnFmyoB5B;;AmFlyoBA;EAA4B,gBAAA;AnFsyoB5B;;AmFryoBA;EAAoB,gBAAA;AnFyyoBpB;;AmFxyoBA;EAAuB,gBAAA;AnF4yoBvB;;AmF3yoBA;EAAqB,gBAAA;AnF+yoBrB;;AmF9yoBA;EAAoB,gBAAA;AnFkzoBpB;;AmFjzoBA;EAAyB,gBAAA;AnFqzoBzB;;AmFpzoBA;EAAoB,gBAAA;AnFwzoBpB;;AmFvzoBA;EAAqB,gBAAA;AnF2zoBrB;;AmF1zoBA;EAA0B,gBAAA;AnF8zoB1B;;AmF7zoBA;EAAmB,gBAAA;AnFi0oBnB;;AmFh0oBA;EAAkB,gBAAA;AnFo0oBlB;;AmFn0oBA;EAAsB,gBAAA;AnFu0oBtB;;AoFtqpBA;;;;;;CAAA;AAQA;EACC,sBAAA;EACA,8CAAA;EACA,2PAAA;EACA,mBAAA;EACA,kBAAA;ApFwqpBD;AoFpqpBA;EACC,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA;EACC,gBAAA;ApFsqpBD;;AoFnqpBA,YAAA;AAEA;EACC,uBAAA;EACA,mBAAA;EACA,oBAAA;ApFqqpBD;;AoFlqpBA;EACC,cAAA;ApFqqpBD;;AoFlqpBA;EACC,cAAA;ApFqqpBD;;AoFlqpBA;EACC,cAAA;ApFqqpBD;;AoFlqpBA;EACC,cAAA;ApFqqpBD;;AoFlqpBA;EACC,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;ApFqqpBD;;AoFlqpBA,oBAAA;AAEA,oBAAA;AAEA;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;ApFmqpBD;AoFlqpBC;EACC,kBAAA;ApFoqpBF;;AoFhqpBA;EACC,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;ApFmqpBD;;AoFhqpBA,YAAA;AAEA;EACC,qBAAA;EAEA,4CAAA;ApFkqpBD;AoFlppBA;EACC;IAEC,uBAAA;EpF+ppBA;EoF5ppBD;IAEC,yBAAA;EpF8ppBA;AACF;AqFn/5BA;;;EAAA;ACAA;+BAAA;AAGC;EACC,0BAAA;EACA,8CAAA;EACA,sTAAA;EAMA,mBAAA;EACA,kBAAA;AtFm/5BF;AuF7/5BA;EACE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AvF+/5BF;;AwFrg6BA,6DAAA;AACA;EACE,yBAAA;EACA,mBAAA;EACA,oBAAA;AxFwg6BF;;AwFtg6BA;EAAwB,cAAA;AxF0g6BxB;;AwFzg6BA;EAAwB,cAAA;AxF6g6BxB;;AwF5g6BA;EAAwB,cAAA;AxFgh6BxB;;AwF/g6BA;EAAwB,cAAA;AxFmh6BxB;;AyF7h6BA;EACE,qBAAA;EACA,kBAAA;AzFgi6BF;;A0Fji6BA;EACE,eAAA;EACA,2BCMoB;EDLpB,qBAAA;A1Foi6BF;A0Fni6BE;EAAO,kBAAA;A1Fsi6BT;;A0Fpi6BA;EACE,kBAAA;EACA,qBAAA;EACA,qBCDoB;EDEpB,mBAAA;EACA,kBAAA;A1Fui6BF;A0Fti6BE;EACE,qBAAA;A1Fwi6BJ;;A4Frj6BA;EACE,4BAAA;EACA,yBAAA;EACA,oBAAA;A5Fwj6BF;;A4Frj6BA;EAA+B,WAAA;A5Fyj6B/B;;A4Fxj6BA;EAAgC,YAAA;A5F4j6BhC;;A4Fzj6BE;EAAgC,mBAAA;A5F6j6BlC;A4F5j6BE;EAAiC,kBAAA;A5F+j6BnC;;A4F5j6BA,2BAAA;AACA;EAAc,YAAA;A5Fgk6Bd;;A4F/j6BA;EAAa,WAAA;A5Fmk6Bb;;A4Fhk6BE;EAAc,mBAAA;A5Fok6BhB;A4Fnk6BE;EAAe,kBAAA;A5Fsk6BjB;;A6F1l6BA;EAEU,qCAAA;A7F6l6BV;;A6F1l6BA;EAEU,uCAAA;A7F6l6BV;A6F/k6BA;EACE;IAEU,uBAAA;E7F4l6BV;E6F1l6BA;IAEU,yBAAA;E7F4l6BV;AACF;A8Fzn6BA;ECWE,sEAAA;EAGQ,wBAAA;A/Fin6BV;;A8F9n6BA;ECUE,sEAAA;EAGQ,yBAAA;A/Fwn6BV;;A8Fpo6BA;ECSE,sEAAA;EAGQ,yBAAA;A/F+n6BV;;A8Fzo6BA;ECcE,gFAAA;EAGQ,uBAAA;A/F+n6BV;;A8F/o6BA;ECaE,gFAAA;EAGQ,uBAAA;A/Fso6BV;;A8Fjp6BA;;;;;EAKE,YAAA;A9Fop6BF;;AgGnq6BA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AhGsq6BF;;AgGpq6BA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AhGuq6BF;;AgGrq6BA;EAA8B,oBAAA;AhGyq6B9B;;AgGxq6BA;EAA8B,cAAA;AhG4q6B9B;;AgG3q6BA;EAA6B,WLTP;A3Fwr6BtB;;AiGls6BA;mEAAA;AAGA;EAAkC,gBNwUnB;A3F635Bf;;AiGps6BA;EAAkC,gBN2dnB;A3F6u5Bf;;AiGvs6BA;EAAmC,gBN0jBnB;A3Fip5BhB;;AiG1s6BA;EAAuC,gBNsOnB;A3Fw+5BpB;;AiG7s6BA;EAAkC,gBNuWnB;A3F025Bf;;AiGht6BA;EAAiC,gBNknBnB;A3Fkm5Bd;;AiGnt6BA;EAAmC,gBNsnBnB;A3Fim5BhB;;AiGtt6BA;EAAiC,gBNytBnB;A3Fig5Bd;;AiGzt6BA;EAAiC,gBNmRnB;A3F085Bd;;AiG5t6BA;EAAqC,gBNupBnB;A3Fyk5BlB;;AiG/t6BA;EAA+B,gBNqpBnB;A3F8k5BZ;;AiGlu6BA;EAAoC,gBNspBnB;A3Fgl5BjB;;AiGru6BA;EAAkC,gBNyInB;A3Fgm6Bf;;AiGxu6BA;;;EAEkC,gBNqqBnB;A3Fuk5Bf;;AiG3u6BA;EAAwC,gBN8iBnB;A3Fis5BrB;;AiG9u6BA;EAAyC,gBN4iBnB;A3Fss5BtB;;AiGjv6BA;EAAsC,gBN4fnB;A3Fyv5BnB;;AiGpv6BA;EAAmC,gBNikBnB;A3Fur5BhB;;AiGvv6BA;;EACgC,gBNgKnB;A3F2l6Bb;;AiG1v6BA;EAAoC,gBN+qBnB;A3F+k5BjB;;AiG7v6BA;EAAiC,gBNwVnB;A3Fy65Bd;;AiGhw6BA;EAAmC,gBNuPnB;A3F6g6BhB;;AiGnw6BA;EAAoC,gBNgJnB;A3Fun6BjB;;AiGtw6BA;EAAiC,gBNmhBnB;A3Fuv5Bd;;AiGzw6BA;EAAqC,gBNgMnB;A3F6k6BlB;;AiG5w6BA;EAAgD,gBNYnB;A3Fow6B7B;;AiG/w6BA;EAA8C,gBNcnB;A3Fqw6B3B;;AiGlx6BA;EAAkC,gBNqWnB;A3Fi75Bf;;AiGrx6BA;EAA0C,gBNwenB;A3Fiz5BvB;;AiGxx6BA;;EACmC,gBNsgBnB;A3Fsx5BhB;;AiG3x6BA;EAAoC,gBNggBnB;A3F+x5BjB;;AiG9x6BA;EAAqC,gBNwYnB;A3F055BlB;;AiGjy6BA;EAAiC,gBN2YnB;A3F055Bd;;AiGpy6BA;EAAiC,gBN4PnB;A3F4i6Bd;;AiGvy6BA;EAAuC,gBNoUnB;A3Fu+5BpB;;AiG1y6BA;EAAuC,gBNitBnB;A3F6l5BpB;;AiG7y6BA;EAAwC,gBN+sBnB;A3Fkm5BrB;;AiGhz6BA;EAAsC,gBNgtBnB;A3Fom5BnB;;AiGnz6BA;EAAmC,gBNyenB;A3F805BhB;;AiGtz6BA;EAAoC,gBNwBnB;A3Fky6BjB;;AiGzz6BA;EAAgC,gBNymBnB;A3Fot5Bb;;AiG5z6BA;EAAiC,gBNymBnB;A3Fut5Bd;;AiG/z6BA;EAAiC,gBNyDnB;A3F0w6Bd;;AiGl06BA;EAAqC,gBNyDnB;A3F6w6BlB;;AiGr06BA;EAAkC,gBN+dnB;A3F025Bf;;AiGx06BA;EAAmC,gBN2EnB;A3Fiw6BhB;;AiG306BA;EAAiC,gBN0PnB;A3Fql6Bd;;AiG906BA;EAAiC,gBNiDnB;A3Fiy6Bd;;AiGj16BA;EAAmC,gBN0VnB;A3F2/5BhB;;AiGp16BA;EAAwC,gBNwmBnB;A3Fgv5BrB;;AiGv16BA;EAAuC,gBNwmBnB;A3Fmv5BpB;;AiG116BA;EAAuC,gBNpCnB;A3Fk46BpB;;AiG716BA;EAAyC,gBNvCnB;A3Fw46BtB;;AiGh26BA;EAAwC,gBNrCnB;A3Fy46BrB;;AiGn26BA;EAA0C,gBNxCnB;A3F+46BvB;;AiGt26BA;EAAiC,gBN+WnB;A3F2/5Bd;;AiGz26BA;;EACoC,gBN2anB;A3Fk85BjB;;AiG526BA;EAAmC,gBNsUnB;A3F0i6BhB;;AiG/26BA;EAAyC,gBNkrBnB;A3Fis5BtB;;AiGl36BA;;;EAEsC,gBN0bnB;A3F475BnB;;AiGr36BA;EAAmC,gBNkbnB;A3Fu85BhB;;AiGx36BA;EAAuC,gBNwXnB;A3Fog6BpB;;AiG336BA;EAAmC,gBNtDnB;A3Fq76BhB;;AiG936BA;EAAiC,gBNmnBnB;A3F+w5Bd;;AiGj46BA;;EAC4C,gBN+anB;A3Fs95BzB;;AiGp46BA;EAA2C,gBN8fnB;A3F045BxB;;AiGv46BA;EAA2C,gBN+EnB;A3F4z6BxB;;AiG146BA;EAAmC,gBNzBnB;A3Fu66BhB;;AiG746BA;EAA0C,gBNmjBnB;A3F815BvB;;AiGh56BA;EAA0C,gBNqLnB;A3F+t6BvB;;AiGn56BA;EAAqC,gBNlBnB;A3Fy66BlB;;AiGt56BA;EAAiC,gBNsbnB;A3Fo+5Bd;;AiGz56BA;EAAkC,gBNganB;A3F6/5Bf;;AiG556BA;EAAiC,gBNmjBnB;A3F625Bd;;AiG/56BA;EAAoC,gBN+NnB;A3Fos6BjB;;AiGl66BA;EAAyC,gBNgLnB;A3Fsv6BtB;;AiGr66BA;EAAyC,gBN4iBnB;A3F635BtB;;AiGx66BA;EAAkC,gBN+InB;A3F6x6Bf;;AiG366BA;EAAyC,gBNyEnB;A3Fs26BtB;;AiG966BA;EAA0C,gBNyEnB;A3Fy26BvB;;AiGj76BA;EAAwC,gBNkbnB;A3Fmg6BrB;;AiGp76BA;EAAyC,gBNuXnB;A3Fik6BtB;;AiGv76BA;EAAyC,gBN2lBnB;A3Fg25BtB;;AiG176BA;EAAyC,gBN2DnB;A3Fm46BtB;;AiG776BA;EAA4C,gBNybnB;A3Fwg6BzB;;AiGh86BA;EAAwC,gBN0SnB;A3F0p6BrB;;AiGn86BA;EAAuC,gBN0GnB;A3F616BpB;;AiGt86BA;EAA2C,gBNulBnB;A3Fm35BxB;;AiGz86BA;EAA2C,gBNuDnB;A3Fs56BxB;;AiG586BA;EAAgC,gBNnCnB;A3Fm/6Bb;;AiG/86BA;EAAuC,gBNnDnB;A3Fsg7BpB;;AiGl96BA;EAAwC,gBNnDnB;A3Fyg7BrB;;AiGr96BA;EAAqC,gBNnDnB;A3F4g7BlB;;AiGx96BA;EAAuC,gBNvDnB;A3Fmh7BpB;;AiG396BA;;EACkC,gBN4dnB;A3Fmg6Bf;;AiG996BA;EAAmC,gBN8InB;A3Fo16BhB;;AiGj+6BA;EAAqC,gBNsFnB;A3F+46BlB;;AiGp+6BA;EAAiC,gBN+ZnB;A3Fyk6Bd;;AiGv+6BA;EAAkC,gBNoWnB;A3Fuo6Bf;;AiG1+6BA;EAAqC,gBNpDnB;A3Fki7BlB;;AiG7+6BA;EAA+C,gBNuInB;A3F026B5B;;AiGh/6BA;EAAiC,gBNkNnB;A3Fky6Bd;;AiGn/6BA;EAAiC,gBN0SnB;A3F6s6Bd;;AiGt/6BA;EAAiC,gBN6KnB;A3F606Bd;;AiGz/6BA;EAAgC,gBNyInB;A3Fo36Bb;;AiG5/6BA;EAAsC,gBNyInB;A3Fu36BnB;;AiG//6BA;;EACiD,gBNiInB;A3Fk46B9B;;AiGlg7BA;EAAkC,gBN+YnB;A3Fun6Bf;;AiGrg7BA;EAAqC,gBAAA;AjGyg7BrC;;AiGxg7BA;EAAmC,gBNoanB;A3Fwm6BhB;;AiG3g7BA;EAAoC,gBNgEnB;A3F+86BjB;;AiG9g7BA;EAAmC,gBN6TnB;A3Fqt6BhB;;AiGjh7BA;EAAuC,gBNuCnB;A3F8+6BpB;;AiGph7BA;EAAyC,gBNmCnB;A3Fq/6BtB;;AiGvh7BA;EAAoC,gBN+anB;A3F4m6BjB;;AiG1h7BA;EAA0C,gBNkdnB;A3F4k6BvB;;AiG7h7BA;EAAmC,gBN0KnB;A3Fu36BhB;;AiGhi7BA;EAAwC,gBN2KnB;A3Fy36BrB;;AiGni7BA;EAAqC,gBN3EnB;A3Fkn7BlB;;AiGti7BA;EAAqC,gBN7EnB;A3Fun7BlB;;AiGzi7BA;;EACsC,gBNlEnB;A3F+m7BnB;;AiG5i7BA;EAA2C,gBN+kBnB;A3Fi+5BxB;;AiG/i7BA;EAA4C,gBN4HnB;A3Fu76BzB;;AiGlj7BA;EAAyC,gBNTnB;A3F+j7BtB;;AiGrj7BA;EAAgC,gBN2QnB;A3F8y6Bb;;AiGxj7BA;;EACiC,gBN6CnB;A3F+g7Bd;;AiG3j7BA;EAAqC,gBNkDnB;A3F6g7BlB;;AiG9j7BA;EAAwC,gBNsiBnB;A3F4h6BrB;;AiGjk7BA;EAA0C,gBNoiBnB;A3Fii6BvB;;AiGpk7BA;EAAsC,gBN2enB;A3F6l6BnB;;AiGvk7BA;EAAoC,gBN8NnB;A3F626BjB;;AiG1k7BA;EAAqC,gBNocnB;A3F0o6BlB;;AiG7k7BA;EAA4C,gBNuRnB;A3F0z6BzB;;AiGhl7BA;EAAuC,gBN6hBnB;A3Fuj6BpB;;AiGnl7BA;EAA0C,gBNsGnB;A3Fi/6BvB;;AiGtl7BA;EAAoC,gBN8bnB;A3F4p6BjB;;AiGzl7BA;EAAmC,gBNqjBnB;A3Fwi6BhB;;AiG5l7BA;EAA0C,gBNgLnB;A3Fg76BvB;;AiG/l7BA;EAAmC,gBNukBnB;A3F4h6BhB;;AiGlm7BA;EAAoC,gBNqQnB;A3Fi26BjB;;AiGrm7BA;EAAkC,gBNiWnB;A3Fww6Bf;;AiGxm7BA;EAAqC,gBN2dnB;A3Fip6BlB;;AiG3m7BA;EAAuC,gBNjDnB;A3Fgq7BpB;;AiG9m7BA;EAAyC,gBN+VnB;A3Fmx6BtB;;AiGjn7BA;EAAoC,gBNsjBnB;A3F+j6BjB;;AiGpn7BA;;EACqC,gBNgGnB;A3Fwh7BlB;;AiGvn7BA;EAAmC,gBNoKnB;A3Fu96BhB;;AiG1n7BA;EAAmC,gBN0jBnB;A3Fok6BhB;;AiG7n7BA;EAAwC,gBNoCnB;A3F6l7BrB;;AiGho7BA;;EACgC,gBN+YnB;A3Fqv6Bb;;AiGno7BA;EAAkC,gBNoMnB;A3Fm86Bf;;AiGto7BA;EAAqC,gBNrDnB;A3F+r7BlB;;AiGzo7BA;EAAiC,gBNhFnB;A3F6t7Bd;;AiG5o7BA;EAAwC,gBNrBnB;A3Fqq7BrB;;AiG/o7BA;EAAyC,gBNoLnB;A3F+96BtB;;AiGlp7BA;EAAwC,gBNkLnB;A3Fo+6BrB;;AiGrp7BA;EAAsC,gBNmLnB;A3Fs+6BnB;;AiGxp7BA;EAAwC,gBN+KnB;A3F6+6BrB;;AiG3p7BA;EAA8C,gBNrInB;A3Foy7B3B;;AiG9p7BA;EAA+C,gBNjInB;A3Fmy7B5B;;AiGjq7BA;EAA4C,gBNjInB;A3Fsy7BzB;;AiGpq7BA;EAA8C,gBNzInB;A3Fiz7B3B;;AiGvq7BA;EAAkC,gBN2JnB;A3Fgh7Bf;;AiG1q7BA;EAAmC,gBN6lBnB;A3Fil6BhB;;AiG7q7BA;EAAkC,gBNqenB;A3F4s6Bf;;AiGhr7BA;EAAmC,gBNyGnB;A3F2k7BhB;;AiGnr7BA;EAAsC,gBNzEnB;A3Fgw7BnB;;AiGtr7BA;EAAuC,gBNlInB;A3F4z7BpB;;AiGzr7BA;;EACkC,gBNijBnB;A3F4o6Bf;;AiG5r7BA;;EACiC,gBN4OnB;A3Fo96Bd;;AiG/r7BA;EAAkC,gBNdnB;A3Fit7Bf;;AiGls7BA;EAAkC,gBN0GnB;A3F4l7Bf;;AiGrs7BA;;EACqC,gBN6XnB;A3F406BlB;;AiGxs7BA;;EACoC,gBN2FnB;A3Fin7BjB;;AiG3s7BA;EAAsC,gBN6SnB;A3Fk66BnB;;AiG9s7BA;;EACqC,gBNqGnB;A3F6m7BlB;;AiGjt7BA;EAAmC,gBNgbnB;A3Fqy6BhB;;AiGpt7BA;;;EAEiC,gBNlInB;A3F017Bd;;AiGvt7BA;EAAoC,gBNsOnB;A3Fq/6BjB;;AiG1t7BA;EAAoC,gBNoOnB;A3F0/6BjB;;AiG7t7BA;EAA0C,gBN+bnB;A3Fky6BvB;;AiGhu7BA;EAAsC,gBN2gBnB;A3Fyt6BnB;;AiGnu7BA;EAAkC,gBNucnB;A3Fgy6Bf;;AiGtu7BA;EAAkC,gBNyOnB;A3Fig7Bf;;AiGzu7BA;EAAkC,gBN6fnB;A3Fgv6Bf;;AiG5u7BA;EAAsC,gBNmTnB;A3F676BnB;;AiG/u7BA;EAA6C,gBNoTnB;A3F+76B1B;;AiGlv7BA;EAA+C,gBNgInB;A3Fsn7B5B;;AiGrv7BA;EAAwC,gBN4HnB;A3F6n7BrB;;AiGxv7BA;EAAkC,gBNqQnB;A3Fu/6Bf;;AiG3v7BA;EAAuC,gBNpFnB;A3Fm17BpB;;AiG9v7BA;EAAqC,gBN9EnB;A3Fg17BlB;;AiGjw7BA;EAAuC,gBNrFnB;A3F017BpB;;AiGpw7BA;EAAwC,gBNrFnB;A3F617BrB;;AiGvw7BA;EAAoC,gBNhCnB;A3F2y7BjB;;AiG1w7BA;;EACiC,gBN0YnB;A3Fo46Bd;;AiG7w7BA;;EACsC,gBN8YnB;A3Fm46BnB;;AiGhx7BA;;EACqC,gBN2YnB;A3Fy46BlB;;AiGnx7BA;EAAqC,gBNUnB;A3F6w7BlB;;AiGtx7BA;EAAqC,gBNuMnB;A3Fml7BlB;;AiGzx7BA;;EACiC,gBNqfnB;A3Fwy6Bd;;AiG5x7BA;;EACkC,gBNoFnB;A3F4s7Bf;;AiG/x7BA;;EACuC,gBN+anB;A3Fo36BpB;;AiGly7BA;EAAsC,gBN7CnB;A3Fm17BnB;;AiGry7BA;EAAuC,gBN1CnB;A3Fm17BpB;;AiGxy7BA;;EACiC,gBNpInB;A3Fg77Bd;;AiG3y7BA;EAAoC,gBN6WnB;A3Fk86BjB;;AiG9y7BA;EAAqC,gBNyenB;A3Fy06BlB;;AiGjz7BA;;EACsC,gBNrEnB;A3F037BnB;;AiGpz7BA;EAAwC,gBNqLnB;A3Fmo7BrB;;AiGvz7BA;EAAqC,gBNGnB;A3Fwz7BlB;;AiG1z7BA;EAA2C,gBNnEnB;A3Fi47BxB;;AiG7z7BA;EAAyC,gBNnEnB;A3Fo47BtB;;AiGh07BA;EAAoC,gBNifnB;A3Fm16BjB;;AiGn07BA;EAAwC,gBN8YnB;A3Fy76BrB;;AiGt07BA;EAAqC,gBNyZnB;A3Fi76BlB;;AiGz07BA;EAAmC,gBN9JnB;A3F2+7BhB;;AiG507BA;EAAmC,gBNlEnB;A3Fk57BhB;;AiG/07BA;EAAoC,gBN1CnB;A3F637BjB;;AiGl17BA;EAAwC,gBN8BnB;A3Fwz7BrB;;AiGr17BA;EAAuC,gBN1InB;A3Fm+7BpB;;AiGx17BA;EAAuC,gBNsHnB;A3Fsu7BpB;;AiG317BA;EAAsC,gBNrOnB;A3Fok8BnB;;AiG917BA;EAAmC,gBN4MnB;A3Fsp7BhB;;AiGj27BA;EAAwC,gBNUnB;A3F217BrB;;AiGp27BA;EAAiC,gBN3KnB;A3Fmh8Bd;;AiGv27BA;EAAqC,gBNuFnB;A3Fox7BlB;;AiG127BA;EAAwC,gBN2QnB;A3Fmm7BrB;;AiG727BA;EAA8C,gBNrOnB;A3Fsl8B3B;;AiGh37BA;EAA+C,gBNrOnB;A3Fyl8B5B;;AiGn37BA;EAA4C,gBNrOnB;A3F4l8BzB;;AiGt37BA;EAA8C,gBNzOnB;A3Fmm8B3B;;AiGz37BA;EAAuC,gBNrOnB;A3Fkm8BpB;;AiG537BA;EAAwC,gBNrOnB;A3Fqm8BrB;;AiG/37BA;EAAqC,gBNrOnB;A3Fwm8BlB;;AiGl47BA;EAAuC,gBNzOnB;A3F+m8BpB;;AiGr47BA;EAAoC,gBNpDnB;A3F677BjB;;AiGx47BA;EAAmC,gBN4InB;A3Fgw7BhB;;AiG347BA;EAAmC,gBNwYnB;A3Fug7BhB;;AiG947BA;;EACmC,gBNuMnB;A3F2s7BhB;;AiGj57BA;EAAqC,gBNzGnB;A3F8/7BlB;;AiGp57BA;EAAuC,gBNyQnB;A3F+o7BpB;;AiGv57BA;EAAwC,gBNyQnB;A3Fkp7BrB;;AiG157BA;EAAoC,gBN+VnB;A3F+j7BjB;;AiG757BA;EAAmC,gBN9GnB;A3F+g8BhB;;AiGh67BA;;EACkC,gBNoRnB;A3Fgp7Bf;;AiGn67BA;EAAuC,gBN+CnB;A3Fw37BpB;;AiGt67BA;EAAqC,gBNmBnB;A3Fu57BlB;;AiGz67BA;EAA0C,gBNoBnB;A3Fy57BvB;;AiG567BA;EAAoC,gBNqUnB;A3F2m7BjB;;AiG/67BA;EAAoC,gBN2BnB;A3Fw57BjB;;AiGl77BA;EAAkC,gBNgLnB;A3Fsw7Bf;;AiGr77BA;EAAoC,gBN2BnB;A3F857BjB;;AiGx77BA;EAAuC,gBNuHnB;A3Fq07BpB;;AiG377BA;EAAmC,gBNMnB;A3Fy77BhB;;AiG977BA;EAA2C,gBNInB;A3F877BxB;;AiGj87BA;EAAqC,gBN6XnB;A3Fwk7BlB;;AiGp87BA;EAAiC,gBNhHnB;A3Fwj8Bd;;AiGv87BA;;EACsC,gBNuQnB;A3Fos7BnB;;AiG187BA;;;EAEwC,gBNsVnB;A3Fwn7BrB;;AiG787BA;EAA2C,gBNwInB;A3Fy07BxB;;AiGh97BA;EAAiC,gBNhGnB;A3Foj8Bd;;AiGn97BA;EAAsC,gBNvHnB;A3F8k8BnB;;AiGt97BA;;EACyC,gBNtJnB;A3Fgn8BtB;;AiGz97BA;EAAqC,gBNyOnB;A3Fov7BlB;;AiG597BA;EAAiC,gBN0FnB;A3Fs47Bd;;AiG/97BA;EAAwC,gBN1DnB;A3F6h8BrB;;AiGl+7BA;EAAwC,gBNkWnB;A3Foo7BrB;;AiGr+7BA;EAAsC,gBN4VnB;A3F6o7BnB;;AiGx+7BA;EAAmC,gBNlEnB;A3F8i8BhB;;AiG3+7BA;EAAyC,gBNgOnB;A3F+w7BtB;;AiG9+7BA;EAAuC,gBN2JnB;A3Fu17BpB;;AiGj/7BA;EAA6C,gBN2JnB;A3F017B1B;;AiGp/7BA;EAAmC,gBNsRnB;A3Fku7BhB;;AiGv/7BA;EAAuC,gBN5LnB;A3Fur8BpB;;AiG1/7BA;EAA8C,gBNxBnB;A3Fsh8B3B;;AiG7/7BA;EAAmC,gBNuPnB;A3F0w7BhB;;AiGhg8BA;EAAmC,gBN6InB;A3Fu37BhB;;AiGng8BA;EAAgD,gBN9JnB;A3Fqq8B7B;;AiGtg8BA;EAAiD,gBN9JnB;A3Fwq8B9B;;AiGzg8BA;EAA8C,gBN9JnB;A3F2q8B3B;;AiG5g8BA;EAAgD,gBNlKnB;A3Fkr8B7B;;AiG/g8BA;EAAkC,gBN8DnB;A3Fq97Bf;;AiGlh8BA;EAAiC,gBNrHnB;A3F2o8Bd;;AiGrh8BA;EAAmC,gBNvSnB;A3Fg08BhB;;AiGxh8BA;EAAuC,gBN2ZnB;A3Fio7BpB;;AiG3h8BA;EAAqC,gBNhNnB;A3F+u8BlB;;AiG9h8BA;EAAuC,gBN7FnB;A3F+n8BpB;;AiGji8BA;EAAuC,gBN7FnB;A3Fko8BpB;;AiGpi8BA;EAAuC,gBN+OnB;A3Fyz7BpB;;AiGvi8BA;EAAwC,gBNiMnB;A3F027BrB;;AiG1i8BA;EAAmC,gBN6WnB;A3Fis7BhB;;AiG7i8BA;EAAyC,gBN0InB;A3Fu67BtB;;AiGhj8BA;EAA2C,gBN0InB;A3F067BxB;;AiGnj8BA;EAAqC,gBNqFnB;A3Fk+7BlB;;AiGtj8BA;EAAuC,gBNmFnB;A3Fu+7BpB;;AiGzj8BA;EAAyC,gBNnLnB;A3Fgv8BtB;;AiG5j8BA;EAA0C,gBN0KnB;A3Fs57BvB;;AiG/j8BA;EAAiD,gBNpFnB;A3Fup8B9B;;AiGlk8BA;EAAyC,gBNwPnB;A3F807BtB;;AiGrk8BA;EAAoC,gBNjJnB;A3F0t8BjB;;AiGxk8BA;;EACgD,gBN/MnB;A3F2x8B7B;;AiG3k8BA;;EAC8C,gBN9MnB;A3F6x8B3B;;AiG9k8BA;;EACiD,gBNjNnB;A3Fmy8B9B;;AiGjl8BA;;EACgC,gBNvGnB;A3F4r8Bb;;AiGpl8BA;EAAgC,gBNhCnB;A3Fwn8Bb;;AiGvl8BA;;EACgC,gBNqYnB;A3Fst7Bb;;AiG1l8BA;;EACgC,gBN4CnB;A3Fkj8Bb;;AiG7l8BA;;;;EAGgC,gBNgDnB;A3Fij8Bb;;AiGhm8BA;;;EAEgC,gBNiNnB;A3Fm57Bb;;AiGnm8BA;;EACgC,gBN+CnB;A3Fwj8Bb;;AiGtm8BA;;EACgC,gBN3PnB;A3Fq28Bb;;AiGzm8BA;EAAiC,gBNhGnB;A3F6s8Bd;;AiG5m8BA;EAAsC,gBNpFnB;A3Fos8BnB;;AiG/m8BA;EAA2C,gBN0PnB;A3Fy37BxB;;AiGln8BA;EAA4C,gBN0PnB;A3F437BzB;;AiGrn8BA;EAA4C,gBN0PnB;A3F+37BzB;;AiGxn8BA;EAA6C,gBN0PnB;A3Fk47B1B;;AiG3n8BA;EAA6C,gBN6PnB;A3Fk47B1B;;AiG9n8BA;EAA8C,gBN6PnB;A3Fq47B3B;;AiGjo8BA;EAAsC,gBNkUnB;A3Fm07BnB;;AiGpo8BA;EAAwC,gBN8TnB;A3F007BrB;;AiGvo8BA;EAA2C,gBNyanB;A3Fku7BxB;;AiG1o8BA;EAAoC,gBNsanB;A3Fwu7BjB;;AiG7o8BA;EAAiC,gBN2ZnB;A3Fsv7Bd;;AiGhp8BA;EAAwC,gBN2ZnB;A3Fyv7BrB;;AiGnp8BA;EAAyC,gBNoanB;A3Fmv7BtB;;AiGtp8BA;EAAoC,gBNxJnB;A3Fkz8BjB;;AiGzp8BA;EAA2C,gBN8PnB;A3F+57BxB;;AiG5p8BA;EAAsC,gBNgBnB;A3Fgp8BnB;;AiG/p8BA;EAAmC,gBNpFnB;A3Fuv8BhB;;AiGlq8BA;EAAgC,gBN3WnB;A3Fih9Bb;;AiGrq8BA;EAAsC,gBN/RnB;A3Fw88BnB;;AiGxq8BA;EAA6C,gBN/RnB;A3F288B1B;;AiG3q8BA;EAAmC,gBN+UnB;A3Fg27BhB;;AiG9q8BA;EAA0C,gBN+UnB;A3Fm27BvB;;AiGjr8BA;EAA4C,gBNgDnB;A3Fqo8BzB;;AiGpr8BA;EAA0C,gBNkDnB;A3Fso8BvB;;AiGvr8BA;EAA4C,gBN+CnB;A3F4o8BzB;;AiG1r8BA;EAA6C,gBN+CnB;A3F+o8B1B;;AiG7r8BA;EAAkC,gBNjWnB;A3Fki9Bf;;AiGhs8BA;EAAoC,gBNmYnB;A3Fi07BjB;;AiGns8BA;EAAoC,gBN7WnB;A3Foj9BjB;;AiGts8BA;EAAkC,gBNkCnB;A3Fwq8Bf;;AiGzs8BA;EAAqC,gBN5KnB;A3Fy38BlB;;AiG5s8BA;EAAkC,gBNgNnB;A3Fgg8Bf;;AiG/s8BA;EAAuC,gBNxFnB;A3F2y8BpB;;AiGlt8BA;EAAmC,gBN4TnB;A3F057BhB;;AiGrt8BA;EAAmC,gBNtInB;A3F+18BhB;;AiGxt8BA;EAAiC,gBN6CnB;A3F+q8Bd;;AiG3t8BA;;EACqC,gBN5DnB;A3F2x8BlB;;AiG9t8BA;EAAkC,gBN8PnB;A3Fo+7Bf;;AiGju8BA;EAAmC,gBNuEnB;A3F8p8BhB;;AiGpu8BA;EAAoC,gBN9WnB;A3Fsl9BjB;;AiGvu8BA;EAAgC,gBNtSnB;A3Fih9Bb;;AiG1u8BA;EAA+B,gBNiWnB;A3F647BZ;;AiG7u8BA;EAAkC,gBNuWnB;A3F047Bf;;AiGhv8BA;EAAmC,gBN+InB;A3Fqm8BhB;;AiGnv8BA;EAAsC,gBNkFnB;A3Fqq8BnB;;AiGtv8BA;EAA2C,gBN6NnB;A3F6h8BxB;;AiGzv8BA;EAAiD,gBN/WnB;A3F4m9B9B;;AiG5v8BA;EAAgD,gBNjXnB;A3Fin9B7B;;AiG/v8BA;;EACgD,gBNzRnB;A3F4h9B7B;;AiGlw8BA;EAAyC,gBNnMnB;A3Fy88BtB;;AiGrw8BA;EAAuC,gBNiWnB;A3Fw67BpB;;AiGxw8BA;EAAyC,gBNoVnB;A3Fw77BtB;;AiG3w8BA;;EACgC,gBN0SnB;A3Fq+7Bb;;AiG9w8BA;EAA0C,gBN0GnB;A3Fwq8BvB;;AiGjx8BA;EAA0C,gBN4MnB;A3Fyk8BvB;;AiGpx8BA;EAAkC,gBNsLnB;A3Fkm8Bf;;AiGvx8BA;EAA4C,gBNzLnB;A3Fo98BzB;;AiG1x8BA;EAAsC,gBNoWnB;A3F077BnB;;AiG7x8BA;EAAmC,gBN8DnB;A3Fmu8BhB;;AiGhy8BA;;;EAEuC,gBN8SnB;A3Fs/7BpB;;AiGny8BA;;EAC2C,gBN1FnB;A3Fi48BxB;;AiGty8BA;EAAkC,gBNsWnB;A3Fo87Bf;;AiGzy8BA;EAAmC,gBNlGnB;A3F+48BhB;;AiG5y8BA;EAAmC,gBNgHnB;A3Fgs8BhB;;AiG/y8BA;EAA0C,gBNiHnB;A3Fks8BvB;;AiGlz8BA;EAA+C,gBNyNnB;A3F6l8B5B;;AiGrz8BA;EAAwC,gBNuNnB;A3Fkm8BrB;;AiGxz8BA;EAAsC,gBN/NnB;A3F2h9BnB;;AiG3z8BA;EAAiC,gBN5NnB;A3F2h9Bd;;AiG9z8BA;EAA0C,gBN2EnB;A3Fuv8BvB;;AiGj08BA;EAA2C,gBNyEnB;A3F4v8BxB;;AiGp08BA;EAAmC,gBNvNnB;A3F+h9BhB;;AiGv08BA;EAAmC,gBNzCnB;A3Fo38BhB;;AiG108BA;EAAqC,gBNpCnB;A3Fk38BlB;;AiG708BA;EAAgC,gBNtLnB;A3Fug9Bb;;AiGh18BA;EAAqC,gBN7UnB;A3Fiq9BlB;;AiGn18BA;EAAkC,gBN1RnB;A3Fin9Bf;;AiGt18BA;EAAgC,gBNsDnB;A3Foy8Bb;;AiGz18BA;EAAkC,gBNmLnB;A3F0q8Bf;;AiG518BA;EAAiC,gBNrPnB;A3Fql9Bd;;AiG/18BA;EAAkC,gBNrPnB;A3Fwl9Bf;;AiGl28BA;EAAoC,gBN7WnB;A3Fmt9BjB;;AiGr28BA;EAA2C,gBN7WnB;A3Fst9BxB;;AiGx28BA;EAAkC,gBN0LnB;A3Fkr8Bf;;AiG328BA;EAAyC,gBN0LnB;A3Fqr8BtB;;AiG928BA;EAAoC,gBNyFnB;A3Fyx8BjB;;AiGj38BA;;EACgC,gBNzUnB;A3F8r9Bb;;AiGp38BA;;EACiC,gBN+MnB;A3Fyq8Bd;;AiGv38BA;EAAiC,gBN4PnB;A3F+n8Bd;;AiG138BA;EAAoC,gBNuKnB;A3Fut8BjB;;AiG738BA;EAAuC,gBNtPnB;A3Fun9BpB;;AiGh48BA;EAAuC,gBNiKnB;A3Fmu8BpB;;AiGn48BA;EAAqC,gBN9PnB;A3Fqo9BlB;;AiGt48BA;EAAuC,gBN/LnB;A3Fyk9BpB;;AiGz48BA;EAAwC,gBNxLnB;A3Fqk9BrB;;AiG548BA;EAAyC,gBNrMnB;A3Fql9BtB;;AiG/48BA;EAA8C,gBN/LnB;A3Fkl9B3B;;AiGl58BA;;;EAEyC,gBNxMnB;A3F8l9BtB;;AiGr58BA;;EAC2C,gBN9MnB;A3Fum9BxB;;AiGx58BA;;EACyC,gBN/MnB;A3F2m9BtB;;AiG358BA;;EACyC,gBNpMnB;A3Fmm9BtB;;AiG958BA;EAAwC,gBNjNnB;A3Fmn9BrB;;AiGj68BA;EAAiC,gBNuRnB;A3F8o8Bd;;AiGp68BA;EAAoC,gBN5SnB;A3Fot9BjB;;AiGv68BA;EAAqC,gBN9EnB;A3Fy/8BlB;;AiG168BA;;;;;EAIsC,gBNnEnB;A3Fi/8BnB;;AiG768BA;EAA2C,gBN/TnB;A3Fgv9BxB;;AiGh78BA;;;EAEkC,gBNqDnB;A3F+38Bf;;AiGn78BA;;EACmC,gBNnQnB;A3F0r9BhB;;AiGt78BA;EAAuC,gBNzKnB;A3Fmm9BpB;;AiGz78BA;EAAgC,gBN3KnB;A3Fwm9Bb;;AiG578BA;;;EAEwC,gBNxJnB;A3Fwl9BrB;;AiG/78BA;EAA0C,gBN2KnB;A3Fwx8BvB;;AiGl88BA;EAA+B,gBNiCnB;A3Fq68BZ;;AiGr88BA;;EACmC,gBN0QnB;A3F+r8BhB;;AiGx88BA;;EACwC,gBNVnB;A3Fs98BrB;;AiG388BA;;EAC0C,gBNXnB;A3F098BvB;;AiG988BA;EAAoC,gBN1InB;A3F4l9BjB;;AiGj98BA;EAAwC,gBNlVnB;A3Fuy9BrB;;AiGp98BA;EAAmC,gBNjJnB;A3Fym9BhB;;AiGv98BA;EAAsC,gBNbnB;A3Fw+8BnB;;AiG198BA;EAAoC,gBN+FnB;A3F+38BjB;;AiG798BA;EAAsC,gBNuEnB;A3F058BnB;;AiGh+8BA;EAA6C,gBNuEnB;A3F658B1B;;AiGn+8BA;EAAiC,gBNzZnB;A3Fg49Bd;;AiGt+8BA;;EACqC,gBN5MnB;A3Fsr9BlB;;AiGz+8BA;EAAgC,gBN0MnB;A3Fmy8Bb;;AiG5+8BA;EAAuC,gBNxanB;A3Fw59BpB;;AiG/+8BA;EAAiC,gBNInB;A3F++8Bd;;AiGl/8BA;EAAuC,gBNuFnB;A3F+58BpB;;AiGr/8BA;EAAmC,gBN2MnB;A3F8y8BhB;;AiGx/8BA;EAAiC,gBN+QnB;A3F6u8Bd;;AiG3/8BA;EAAwC,gBNzCnB;A3Fwi9BrB;;AiG9/8BA;EAAiC,gBNwPnB;A3F0w8Bd;;AiGjg9BA;EAAuC,gBNrZnB;A3F059BpB;;AiGpg9BA;EAAmC,gBNvBnB;A3F+h9BhB;;AiGvg9BA;EAA0C,gBN3LnB;A3Fss9BvB;;AiG1g9BA;EAAoC,gBN5XnB;A3F049BjB;;AiG7g9BA;EAA0C,gBNhYnB;A3Fi59BvB;;AiGhh9BA;EAAwC,gBNnYnB;A3Fu59BrB;;AiGnh9BA;EAAoC,gBNtYnB;A3F659BjB;;AiGth9BA;EAAsC,gBNlYnB;A3F459BnB;;AiGzh9BA;EAAsC,gBNlYnB;A3F+59BnB;;AiG5h9BA;EAAuC,gBN3bnB;A3F299BpB;;AiG/h9BA;EAAyC,gBN3bnB;A3F899BtB;;AiGli9BA;EAAkC,gBN+KnB;A3Fu38Bf;;AiGri9BA;EAAsC,gBNnVnB;A3F439BnB;;AiGxi9BA;EAA+B,gBN9dnB;A3F0g+BZ;;AiG3i9BA;EAAuC,gBN5RnB;A3F209BpB;;AiG9i9BA;EAAwC,gBN/CnB;A3Fim9BrB;;AiGjj9BA;EAA0C,gBN9bnB;A3Fm/9BvB;;AiGpj9BA;EAAuC,gBNtfnB;A3F8i+BpB;;AiGvj9BA;EAAsC,gBN/BnB;A3F0l9BnB;;AiG1j9BA;EAAuC,gBNzHnB;A3Fur9BpB;;AiG7j9BA;EAAmC,gBNvInB;A3Fws9BhB;;AiGhk9BA;EAA0C,gBNvInB;A3F2s9BvB;;AiGnk9BA;EAAuC,gBN4JnB;A3F268BpB;;AiGtk9BA;EAAsC,gBN4JnB;A3F868BnB;;AiGzk9BA;EAAoC,gBNxcnB;A3Fqh+BjB;;AiG5k9BA;EAAgC,gBNjbnB;A3Fig+Bb;;AiG/k9BA;EAAoC,gBNvJnB;A3F0u9BjB;;AiGll9BA;EAAsC,gBN3gBnB;A3Fim+BnB;;AiGrl9BA;EAA+B,gBN7ZnB;A3Fs/9BZ;;AiGxl9BA;;;EAEgC,gBNzKnB;A3Fqw9Bb;;AiG3l9BA;EAAqC,gBNpGnB;A3Fms9BlB;;AiG9l9BA;EAAuC,gBNxbnB;A3F0h+BpB;;AiGjm9BA;EAA2C,gBN5WnB;A3Fi99BxB;;AiGpm9BA;EAAqC,gBN9VnB;A3Fs89BlB;;AiGvm9BA;EAAqC,gBN9PnB;A3Fy29BlB;;AiG1m9BA;EAAoC,gBNrJnB;A3Fmw9BjB;;AiG7m9BA;EAAmC,gBNenB;A3Fkm9BhB;;AiGhn9BA;EAAyC,gBN2BnB;A3Fyl9BtB;;AiGnn9BA;EAAwC,gBNoCnB;A3Fml9BrB;;AiGtn9BA;EAAqC,gBNqCnB;A3Fql9BlB;;AiGzn9BA;EAAsC,gBN5anB;A3Fyi+BnB;;AiG5n9BA;EAA4C,gBN9anB;A3F8i+BzB;;AiG/n9BA;EAAoC,gBN/VnB;A3Fk+9BjB;;AiGlo9BA;EAAiC,gBNoBnB;A3Fkn9Bd;;AiGro9BA;EAAwC,gBN8KnB;A3F298BrB;;AiGxo9BA;EAAuC,gBN/FnB;A3F2u9BpB;;AiG3o9BA;EAAwC,gBN6EnB;A3Fkk9BrB;;AiG9o9BA;EAAsC,gBN9MnB;A3Fg29BnB;;AiGjp9BA;EAAkC,gBN+KnB;A3Fs+8Bf;;AiGpp9BA;EAAiC,gBN7HnB;A3Fqx9Bd;;AiGvp9BA;EAAoC,gBNnHnB;A3F8w9BjB;;AiG1p9BA;;EACwC,gBNkInB;A3F4h9BrB;;AiG7p9BA;EAA4C,gBNkInB;A3F+h9BzB;;AiGhq9BA;EAAyC,gBN0KnB;A3F0/8BtB;;AiGnq9BA;EAAwC,gBNlInB;A3Fyy9BrB;;AiGtq9BA;EAAuC,gBNyKnB;A3Fig9BpB;;AiGzq9BA;EAAwC,gBNnInB;A3Fgz9BrB;;AiG5q9BA;EAA0C,gBNlInB;A3Fkz9BvB;;AiG/q9BA;EAA0C,gBNpInB;A3Fuz9BvB;;AiGlr9BA;EAAmC,gBN1GnB;A3Fgy9BhB;;AiGrr9BA;EAAuC,gBN7QnB;A3Fs89BpB;;AiGxr9BA;EAA8C,gBN1UnB;A3Fsg+B3B;;AiG3r9BA;EAAwC,gBNzEnB;A3Fww9BrB;;AiG9r9BA;EAAqC,gBNkLnB;A3Fgh9BlB;;AiGjs9BA;EAAmC,gBNXnB;A3Fgt9BhB;;AiGps9BA;EAAsC,gBNuJnB;A3Fij9BnB;;AiGvs9BA;EAAuC,gBNwJnB;A3Fmj9BpB;;AiG1s9BA;;EACgC,gBN/fnB;A3F6s+Bb;;AiG7s9BA;EAAoC,gBN4JnB;A3Fqj9BjB;;AiGht9BA;EAAkC,gBN8GnB;A3Fsm9Bf;;AiGnt9BA;EAAmC,gBNwDnB;A3F+p9BhB;;AiGtt9BA;EAAmC,gBN9InB;A3Fw29BhB;;AiGzt9BA;;EACyC,gBN0LnB;A3Fmi9BtB;;AiG5t9BA;EAA0C,gBNjHnB;A3Fi19BvB;;AiG/t9BA;EAAqC,gBNrHnB;A3Fw19BlB;;AiGlu9BA;EAAyC,gBNnWnB;A3Fyk+BtB;;AiGru9BA;;;EAEyC,gBN/gBnB;A3Fwv+BtB;;AiGxu9BA;;EACmD,gBN9gBnB;A3F0v+BhC;;AiG3u9BA;;EACyC,gBNlhBnB;A3Fiw+BtB;;AiG9u9BA;;EAC4C,gBNnhBnB;A3Fqw+BzB;;AiGjv9BA;;EAC0C,gBNxhBnB;A3F6w+BvB;;AiGpv9BA;EAA0C,gBN3InB;A3Fm49BvB;;AiGvv9BA;EAAqC,gBN3OnB;A3Fs+9BlB;;AiG1v9BA;EAAyC,gBNxInB;A3Fs49BtB;;AiG7v9BA;EAA2C,gBNxInB;A3Fy49BxB;;AiGhw9BA;EAAwC,gBNwBnB;A3F4u9BrB;;AiGnw9BA;EAA0C,gBNwBnB;A3F+u9BvB;;AiGtw9BA;EAAmC,gBN/dnB;A3Fyu+BhB;;AiGzw9BA;EAA2C,gBNlenB;A3F+u+BxB;;AiG5w9BA;EAAkC,gBNpcnB;A3Fot+Bf;;AiG/w9BA;EAA0C,gBNljBnB;A3Fq0+BvB;;AiGlx9BA;EAAwC,gBNxPnB;A3F8g+BrB;;AiGrx9BA;;EAC4C,gBNzPnB;A3Fkh+BzB;;AiGxx9BA;;EAC2C,gBN7PnB;A3Fyh+BxB;;AiG3x9BA;;EAC0C,gBNhQnB;A3F+h+BvB;;AiG9x9BA;EAAsC,gBNrQnB;A3Fui+BnB;;AiGjy9BA;;EACwC,gBNxRnB;A3F6j+BrB;;AiGpy9BA;;EACyC,gBN7RnB;A3Fqk+BtB;;AiGvy9BA;EAA4C,gBN1RnB;A3Fqk+BzB;;AiG1y9BA;EAA0C,gBNpSnB;A3Fkl+BvB;;AiG7y9BA;EAAyC,gBN3RnB;A3F4k+BtB;;AiGhz9BA;EAA2C,gBN/RnB;A3Fml+BxB;;AiGnz9BA;EAAyC,gBNjSnB;A3Fwl+BtB;;AiGtz9BA;EAAsC,gBN+DnB;A3F2v9BnB;;AiGzz9BA;EAAuC,gBN/FnB;A3F459BpB;;AiG5z9BA;EAA6C,gBN/bnB;A3F+v+B1B;;AiG/z9BA;EAA+B,gBNtUnB;A3Fyo+BZ;;AiGl09BA;EAAsC,gBNtUnB;A3F4o+BnB;;AiGr09BA;EAAwC,gBNkEnB;A3Fuw9BrB;;AiGx09BA;EAA0C,gBNrKnB;A3Fi/9BvB;;AiG309BA;EAAiD,gBNrKnB;A3Fo/9B9B;;AiG909BA;EAAuC,gBN5UnB;A3F8p+BpB;;AiGj19BA;EAAwC,gBNwHnB;A3F6t9BrB;;AiGp19BA;EAAmC,gBNnFnB;A3F269BhB;;AiGv19BA;EAAmC,gBNzenB;A3Fo0+BhB;;AiG119BA;EAAoC,gBN9WnB;A3F4s+BjB;;AiG719BA;EAAkC,gBNxKnB;A3Fyg+Bf;;AiGh29BA;EAA8C,gBNpQnB;A3Fwm+B3B;;AiGn29BA;;EACuC,gBNSnB;A3F819BpB;;AiGt29BA;EAAmC,gBNjdnB;A3F2z+BhB;;AiGz29BA;EAAkC,gBNzoBnB;A3Fs/+Bf;;AiG529BA;EAAmC,gBN/nBnB;A3F+++BhB;;AiG/29BA;EAA4C,gBN3hBnB;A3F84+BzB;;AiGl39BA;EAA6C,gBN9hBnB;A3Fo5+B1B;;AiGr39BA;EAA6C,gBN5hBnB;A3Fq5+B1B;;AiGx39BA;EAA6C,gBNjiBnB;A3F65+B1B;;AiG339BA;EAAqC,gBNpRnB;A3Fmp+BlB;;AiG939BA;EAAoC,gBN5NnB;A3F8l+BjB;;AiGj49BA;EAAsC,gBN5NnB;A3Fim+BnB;;AiGp49BA;EAAkC,gBN/NnB;A3Fum+Bf;;AiGv49BA;EAAgC,gBNlOnB;A3F6m+Bb;;AiG149BA;EAAuC,gBNpenB;A3Fk3+BpB;;AiG749BA;EAAyC,gBNpenB;A3Fq3+BtB;;AiGh59BA;EAAkC,gBNtSnB;A3F0r+Bf;;AiGn59BA;EAAkC,gBNiFnB;A3Fs09Bf;;AiGt59BA;EAAsC,gBNlkBnB;A3F49+BnB;;AiGz59BA;EAAsC,gBNrXnB;A3Fkx+BnB;;AiG559BA;EAAyC,gBNpInB;A3Foi+BtB;;AiG/59BA;EAAiC,gBNpcnB;A3Fu2+Bd;;AiGl69BA;EAA4C,gBNhenB;A3Fs4+BzB;;AiGr69BA;EAAqC,gBNpfnB;A3F65+BlB;;AiGx69BA;EAAiC,gBNlNnB;A3F8n+Bd;;AiG369BA;EAAyC,gBN1XnB;A3Fyy+BtB;;AiG969BA;EAAgC,gBNoDnB;A3F839Bb;;AiGj79BA;EAAyC,gBN3JnB;A3Fgl+BtB;;AiGp79BA;EAAqC,gBNzNnB;A3Fip+BlB;;AiGv79BA;EAAmC,gBNlHnB;A3F6i+BhB;;AiG179BA;EAAyC,gBN7LnB;A3F2n+BtB;;AiG779BA;EAA2C,gBN7LnB;A3F8n+BxB;;AiGh89BA;EAAwC,gBN3CnB;A3F++9BrB;;AiGn89BA;EAA0C,gBN3CnB;A3Fk/9BvB;;AiGt89BA;EAAyC,gBNrGnB;A3F+i+BtB;;AiGz89BA;EAA4C,gBNrGnB;A3Fkj+BzB;;AiG589BA;EAAoC,gBN7UnB;A3F6x+BjB;;AiG/89BA;EAAsC,gBNnlBnB;A3Fsi/BnB;;AiGl99BA;EAAwC,gBNnlBnB;A3Fyi/BrB;;AiGr99BA;EAAoC,gBN/LnB;A3Fwp+BjB;;AiGx99BA;EAAmC,gBNlXnB;A3F80+BhB;;AiG399BA;EAAuC,gBNkFnB;A3F649BpB;;AiG999BA;EAAoC,gBNmFnB;A3F+49BjB;;AiGj+9BA;EAAmC,gBN9cnB;A3Fm7+BhB;;AiGp+9BA;EAA6C,gBN2BnB;A3F689B1B;;AiGv+9BA;EAA2C,gBNmEnB;A3Fw69BxB;;AiG1+9BA;EAA8C,gBNxKnB;A3Fsp+B3B;;AiG7+9BA;EAAkC,gBN9lBnB;A3F+k/Bf;;AiGh/9BA;EAA8C,gBNtoBnB;A3F0n/B3B;;AiGn/9BA;EAAiD,gBNqDnB;A3Fk89B9B;;AiGt/9BA;EAAoC,gBNxlBnB;A3Fkl/BjB;;AiGz/9BA;EAAwD,gBN5oBnB;A3Fyo/BrC;;AiG5/9BA;;EACgE,gBN9qBnB;A3F8q/B7C;;AiG//9BA;;;EAEiC,gBNvfnB;A3F0/+Bd;;AiGlg+BA;EAAkC,gBNhYnB;A3Fs4+Bf;;AiGrg+BA;EAAoC,gBNhYnB;A3Fy4+BjB;;AiGxg+BA;;EAC0C,gBN1HnB;A3Fso+BvB;;AiG3g+BA;EAAuC,gBNzRnB;A3Fwy+BpB;;AiG9g+BA;EAAmC,gBNiCnB;A3Fi/9BhB;;AiGjh+BA;EAA0C,gBNiCnB;A3Fo/9BvB;;AiGph+BA;EAAqC,gBNlHnB;A3F0o+BlB;;AiGvh+BA;EAA2C,gBNlHnB;A3F6o+BxB;;AiG1h+BA;EAA4C,gBNlHnB;A3Fgp+BzB;;AiG7h+BA;EAAuC,gBNrNnB;A3Fsv+BpB;;AiGhi+BA;EAAwC,gBNpbnB;A3Fw9+BrB;;AiGni+BA;EAAkC,gBNmEnB;A3Fo+9Bf;;AiGti+BA;EAAsC,gBNpDnB;A3F8l+BnB;;AiGzi+BA;;EACiD,gBNzYnB;A3Fs7+B9B;;AiG5i+BA;;EACyC,gBN7anB;A3F69+BtB;;AiG/i+BA;EAAwC,gBNtXnB;A3Fy6+BrB;;AiGlj+BA;EAA0C,gBNlfnB;A3Fwi/BvB;;AiGrj+BA;EAA4C,gBNlfnB;A3F2i/BzB;;AiGxj+BA;EAAmC,gBNtTnB;A3Fk3+BhB;;AiG3j+BA;EAAyC,gBNptBnB;A3Fmx/BtB;;AiG9j+BA;EAA2C,gBNptBnB;A3Fsx/BxB;;AiGjk+BA;;EACyC,gBNrtBnB;A3F0x/BtB;;AiGpk+BA;;EAC2C,gBNttBnB;A3F8x/BxB;;AiGvk+BA;EAAwC,gBNJnB;A3F+k+BrB;;AiG1k+BA;EAA0C,gBNJnB;A3Fkl+BvB;;AiG7k+BA;EAAmC,gBNHnB;A3Fol+BhB;;AiGhl+BA;EAAqC,gBN3WnB;A3F+7+BlB;;AiGnl+BA;;EACoC,gBN5WnB;A3Fm8+BjB;;AiGtl+BA;;EACsC,gBN7WnB;A3Fu8+BnB;;AiGzl+BA;EAAkC,gBNtNnB;A3Fmz+Bf;;AiG5l+BA;EAA2C,gBN3bnB;A3F2h/BxB;;AiG/l+BA;EAAqC,gBNtFnB;A3Fyr+BlB;;AiGlm+BA;;;EAE6C,gBNxEnB;A3F8q+B1B;;AiGrm+BA;;EACuD,gBNvEnB;A3Fgr+BpC;;AiGxm+BA;;EAC6C,gBN3EnB;A3Fur+B1B;;AiG3m+BA;;EACgD,gBN5EnB;A3F2r+B7B;;AiG9m+BA;;EAC8C,gBNjFnB;A3Fms+B3B;;AiGjn+BA;EAAmC,gBN3KnB;A3Fgy+BhB;;AiGpn+BA;;;EAEiC,gBNzrBnB;A3Fiz/Bd;;AiGvn+BA;EAAoC,gBNlPnB;A3F62+BjB;;AiG1n+BA;EAA4C,gBNKnB;A3Fyn+BzB;;AiG7n+BA;EAA4C,gBNKnB;A3F4n+BzB;;AiGho+BA;EAA2C,gBNKnB;A3F+n+BxB;;AiGno+BA;;EACyC,gBNDnB;A3Fwo+BtB;;AiGto+BA;;EAC2C,gBNFnB;A3F4o+BxB;;AiGzo+BA;EAAqC,gBNxsBnB;A3Fq1/BlB;;AiG5o+BA;EAAiC,gBNpbnB;A3Fok/Bd;;AiG/o+BA;EAAiC,gBN1hBnB;A3F6q/Bd;;AiGlp+BA;EAAiC,gBNxYnB;A3F8h/Bd;;AiGrp+BA;EAAoC,gBN/OnB;A3Fw4+BjB;;AiGxp+BA;EAAoC,gBNziBnB;A3Fqs/BjB;;AiG3p+BA;EAAsC,gBNjUnB;A3Fg++BnB;;AiG9p+BA;EAAwC,gBN7KnB;A3F+0+BrB;;AiGjq+BA;EAAwC,gBNhInB;A3Fqy+BrB;;AiGpq+BA;EAAuC,gBNJnB;A3F4q+BpB;;AiGvq+BA;EAAmC,gBNxUnB;A3Fm/+BhB;;AkG57/BA;EH8BE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;A/Fk6/BF;;A+Fx5/BE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;A/F05/BJ;;AmG18/BA;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AnG68/BF","sourcesContent":["@charset \"UTF-8\";\n/*!\n * Bootstrap  v5.3.2 (https://getbootstrap.com/)\n * Copyright 2011-2023 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13, 110, 253;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 25, 135, 84;\n  --bs-info-rgb: 13, 202, 240;\n  --bs-warning-rgb: 255, 193, 7;\n  --bs-danger-rgb: 220, 53, 69;\n  --bs-light-rgb: 248, 249, 250;\n  --bs-dark-rgb: 33, 37, 41;\n  --bs-primary-text-emphasis: #052c65;\n  --bs-secondary-text-emphasis: #2b2f32;\n  --bs-success-text-emphasis: #0a3622;\n  --bs-info-text-emphasis: #055160;\n  --bs-warning-text-emphasis: #664d03;\n  --bs-danger-text-emphasis: #58151c;\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: #cfe2ff;\n  --bs-secondary-bg-subtle: #e2e3e5;\n  --bs-success-bg-subtle: #d1e7dd;\n  --bs-info-bg-subtle: #cff4fc;\n  --bs-warning-bg-subtle: #fff3cd;\n  --bs-danger-bg-subtle: #f8d7da;\n  --bs-light-bg-subtle: #fcfcfd;\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: #9ec5fe;\n  --bs-secondary-border-subtle: #c4c8cb;\n  --bs-success-border-subtle: #a3cfbb;\n  --bs-info-border-subtle: #9eeaf9;\n  --bs-warning-border-subtle: #ffe69c;\n  --bs-danger-border-subtle: #f1aeb5;\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-color-rgb: 33, 37, 41;\n  --bs-body-bg: #fff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(33, 37, 41, 0.75);\n  --bs-secondary-color-rgb: 33, 37, 41;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(33, 37, 41, 0.5);\n  --bs-tertiary-color-rgb: 33, 37, 41;\n  --bs-tertiary-bg: #f8f9fa;\n  --bs-tertiary-bg-rgb: 248, 249, 250;\n  --bs-heading-color: inherit;\n  --bs-link-color: #0d6efd;\n  --bs-link-color-rgb: 13, 110, 253;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: #0a58ca;\n  --bs-link-hover-color-rgb: 10, 88, 202;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #212529;\n  --bs-highlight-bg: #fff3cd;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n  --bs-form-valid-color: #198754;\n  --bs-form-valid-border-color: #198754;\n  --bs-form-invalid-color: #dc3545;\n  --bs-form-invalid-border-color: #dc3545;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dee2e6;\n  --bs-body-color-rgb: 222, 226, 230;\n  --bs-body-bg: #212529;\n  --bs-body-bg-rgb: 33, 37, 41;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(222, 226, 230, 0.75);\n  --bs-secondary-color-rgb: 222, 226, 230;\n  --bs-secondary-bg: #343a40;\n  --bs-secondary-bg-rgb: 52, 58, 64;\n  --bs-tertiary-color: rgba(222, 226, 230, 0.5);\n  --bs-tertiary-color-rgb: 222, 226, 230;\n  --bs-tertiary-bg: #2b3035;\n  --bs-tertiary-bg-rgb: 43, 48, 53;\n  --bs-primary-text-emphasis: #6ea8fe;\n  --bs-secondary-text-emphasis: #a7acb1;\n  --bs-success-text-emphasis: #75b798;\n  --bs-info-text-emphasis: #6edff6;\n  --bs-warning-text-emphasis: #ffda6a;\n  --bs-danger-text-emphasis: #ea868f;\n  --bs-light-text-emphasis: #f8f9fa;\n  --bs-dark-text-emphasis: #dee2e6;\n  --bs-primary-bg-subtle: #031633;\n  --bs-secondary-bg-subtle: #161719;\n  --bs-success-bg-subtle: #051b11;\n  --bs-info-bg-subtle: #032830;\n  --bs-warning-bg-subtle: #332701;\n  --bs-danger-bg-subtle: #2c0b0e;\n  --bs-light-bg-subtle: #343a40;\n  --bs-dark-bg-subtle: #1a1d20;\n  --bs-primary-border-subtle: #084298;\n  --bs-secondary-border-subtle: #41464b;\n  --bs-success-border-subtle: #0f5132;\n  --bs-info-border-subtle: #087990;\n  --bs-warning-border-subtle: #997404;\n  --bs-danger-border-subtle: #842029;\n  --bs-light-border-subtle: #495057;\n  --bs-dark-border-subtle: #343a40;\n  --bs-heading-color: inherit;\n  --bs-link-color: #6ea8fe;\n  --bs-link-hover-color: #8bb9fe;\n  --bs-link-color-rgb: 110, 168, 254;\n  --bs-link-hover-color-rgb: 139, 185, 254;\n  --bs-code-color: #e685b5;\n  --bs-highlight-color: #dee2e6;\n  --bs-highlight-bg: #664d03;\n  --bs-border-color: #495057;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: #75b798;\n  --bs-form-valid-border-color: #75b798;\n  --bs-form-invalid-color: #ea868f;\n  --bs-form-invalid-border-color: #ea868f;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.5rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.325rem + 0.9vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 2rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.75rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.5rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.25rem;\n}\n\nh6, .h6 {\n  font-size: 1rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-emphasis-color);\n  --bs-table-bg: var(--bs-body-bg);\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-emphasis-color);\n  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n  --bs-table-active-color: var(--bs-emphasis-color);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-emphasis-color);\n  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: #cfe2ff;\n  --bs-table-border-color: #a6b5cc;\n  --bs-table-striped-bg: #c5d7f2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bacbe6;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfd1ec;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: #e2e3e5;\n  --bs-table-border-color: #b5b6b7;\n  --bs-table-striped-bg: #d7d8da;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #cbccce;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #d1d2d4;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: #d1e7dd;\n  --bs-table-border-color: #a7b9b1;\n  --bs-table-striped-bg: #c7dbd2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bcd0c7;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #c1d6cc;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: #cff4fc;\n  --bs-table-border-color: #a6c3ca;\n  --bs-table-striped-bg: #c5e8ef;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #badce3;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfe2e9;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: #fff3cd;\n  --bs-table-border-color: #ccc2a4;\n  --bs-table-striped-bg: #f2e7c3;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e6dbb9;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #ece1be;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8d7da;\n  --bs-table-border-color: #c6acae;\n  --bs-table-striped-bg: #eccccf;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfc2c4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5c7ca;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #f8f9fa;\n  --bs-table-border-color: #c6c7c8;\n  --bs-table-striped-bg: #ecedee;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dfe0e1;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e5e6e7;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #212529;\n  --bs-table-border-color: #4d5154;\n  --bs-table-striped-bg: #2c3034;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #373b3e;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #323539;\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + var(--bs-border-width));\n  padding-bottom: calc(0.375rem + var(--bs-border-width));\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + var(--bs-border-width));\n  padding-bottom: calc(0.5rem + var(--bs-border-width));\n  font-size: 1.25rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + var(--bs-border-width));\n  padding-bottom: calc(0.25rem + var(--bs-border-width));\n  font-size: 0.875rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--bs-secondary-color);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: var(--bs-secondary-bg);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: var(--bs-border-width) 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n  padding: 0.375rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: var(--bs-secondary-bg);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--bs-body-bg);\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-check-input:checked {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #b6d4fe;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #0d6efd;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #b6d4fe;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: var(--bs-border-width) 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: var(--bs-secondary-bg);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-tertiary-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(var(--bs-border-width) * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: var(--bs-border-radius);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0b5ed7;\n  --bs-btn-hover-border-color: #0a58ca;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0a58ca;\n  --bs-btn-active-border-color: #0a53be;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0d6efd;\n  --bs-btn-disabled-border-color: #0d6efd;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #5c636a;\n  --bs-btn-hover-border-color: #565e64;\n  --bs-btn-focus-shadow-rgb: 130, 138, 145;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #565e64;\n  --bs-btn-active-border-color: #51585e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #6c757d;\n  --bs-btn-disabled-border-color: #6c757d;\n}\n\n.btn-success {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #157347;\n  --bs-btn-hover-border-color: #146c43;\n  --bs-btn-focus-shadow-rgb: 60, 153, 110;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #146c43;\n  --bs-btn-active-border-color: #13653f;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #198754;\n  --bs-btn-disabled-border-color: #198754;\n}\n\n.btn-info {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #31d2f2;\n  --bs-btn-hover-border-color: #25cff2;\n  --bs-btn-focus-shadow-rgb: 11, 172, 204;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #3dd5f3;\n  --bs-btn-active-border-color: #25cff2;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #0dcaf0;\n  --bs-btn-disabled-border-color: #0dcaf0;\n}\n\n.btn-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffca2c;\n  --bs-btn-hover-border-color: #ffc720;\n  --bs-btn-focus-shadow-rgb: 217, 164, 6;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffcd39;\n  --bs-btn-active-border-color: #ffc720;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ffc107;\n  --bs-btn-disabled-border-color: #ffc107;\n}\n\n.btn-danger {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #bb2d3b;\n  --bs-btn-hover-border-color: #b02a37;\n  --bs-btn-focus-shadow-rgb: 225, 83, 97;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #b02a37;\n  --bs-btn-active-border-color: #a52834;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #dc3545;\n  --bs-btn-disabled-border-color: #dc3545;\n}\n\n.btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d3d4d5;\n  --bs-btn-hover-border-color: #c6c7c8;\n  --bs-btn-focus-shadow-rgb: 211, 212, 213;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #c6c7c8;\n  --bs-btn-active-border-color: #babbbc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f8f9fa;\n  --bs-btn-disabled-border-color: #f8f9fa;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #424649;\n  --bs-btn-hover-border-color: #373b3e;\n  --bs-btn-focus-shadow-rgb: 66, 70, 73;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #4d5154;\n  --bs-btn-active-border-color: #373b3e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #212529;\n  --bs-btn-disabled-border-color: #212529;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0d6efd;\n  --bs-btn-hover-border-color: #0d6efd;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0d6efd;\n  --bs-btn-active-border-color: #0d6efd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0d6efd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0d6efd;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #6c757d;\n  --bs-btn-hover-border-color: #6c757d;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #6c757d;\n  --bs-btn-active-border-color: #6c757d;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #6c757d;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #198754;\n  --bs-btn-border-color: #198754;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #198754;\n  --bs-btn-hover-border-color: #198754;\n  --bs-btn-focus-shadow-rgb: 25, 135, 84;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #198754;\n  --bs-btn-active-border-color: #198754;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #198754;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #198754;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #0dcaf0;\n  --bs-btn-border-color: #0dcaf0;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #0dcaf0;\n  --bs-btn-hover-border-color: #0dcaf0;\n  --bs-btn-focus-shadow-rgb: 13, 202, 240;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #0dcaf0;\n  --bs-btn-active-border-color: #0dcaf0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0dcaf0;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0dcaf0;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ffc107;\n  --bs-btn-border-color: #ffc107;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffc107;\n  --bs-btn-hover-border-color: #ffc107;\n  --bs-btn-focus-shadow-rgb: 255, 193, 7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffc107;\n  --bs-btn-active-border-color: #ffc107;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffc107;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffc107;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #dc3545;\n  --bs-btn-border-color: #dc3545;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #dc3545;\n  --bs-btn-hover-border-color: #dc3545;\n  --bs-btn-focus-shadow-rgb: 220, 53, 69;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #dc3545;\n  --bs-btn-active-border-color: #dc3545;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #dc3545;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #dc3545;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #f8f9fa;\n  --bs-btn-border-color: #f8f9fa;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f8f9fa;\n  --bs-btn-hover-border-color: #f8f9fa;\n  --bs-btn-focus-shadow-rgb: 248, 249, 250;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f8f9fa;\n  --bs-btn-active-border-color: #f8f9fa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f8f9fa;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f8f9fa;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #212529;\n  --bs-btn-border-color: #212529;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #212529;\n  --bs-btn-hover-border-color: #212529;\n  --bs-btn-focus-shadow-rgb: 33, 37, 41;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #212529;\n  --bs-btn-active-border-color: #212529;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #212529;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #212529;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  text-decoration: underline;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 1.25rem;\n  --bs-btn-border-radius: var(--bs-border-radius-lg);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.25rem;\n  --bs-btn-padding-x: 0.5rem;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-border-radius: var(--bs-border-radius-sm);\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: var(--bs-border-radius);\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: var(--bs-box-shadow);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #6c757d;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #dee2e6;\n  --bs-dropdown-bg: #343a40;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dee2e6;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #0d6efd;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: var(--bs-border-radius);\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(var(--bs-border-width) * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #0d6efd;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.3125rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.25rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.25rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23052c65'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-border-color: #86b7fe;\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%236ea8fe'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-body-bg);\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #0d6efd;\n  --bs-pagination-active-border-color: #0d6efd;\n  --bs-pagination-disabled-color: var(--bs-secondary-color);\n  --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.25rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: var(--bs-border-radius);\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-secondary-bg);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #0d6efd;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #0d6efd;\n  --bs-list-group-active-border-color: #0d6efd;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: var(--bs-border-width);\n  --bs-modal-border-radius: var(--bs-border-radius-lg);\n  --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.875rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: var(--bs-emphasis-color);\n  --bs-tooltip-border-radius: var(--bs-border-radius);\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.875rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: var(--bs-border-radius-lg);\n  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: inherit;\n  --bs-popover-header-bg: var(--bs-secondary-bg);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: #000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.25rem !important;\n}\n\n.fs-6 {\n  font-size: 1rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.5rem !important;\n  }\n  .fs-2 {\n    font-size: 2rem !important;\n  }\n  .fs-3 {\n    font-size: 1.75rem !important;\n  }\n  .fs-4 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n/**=====================\n    Admin CSS Start\n==========================**/\n.card-left {\n  z-index: 1;\n}\n\n.checkbox-space {\n  padding: 0;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.page-wrapper .page-body-wrapper footer.footer.open {\n  margin-left: 0;\n}\n\n.modal .modal-dialog .modal-content .modal-header .close {\n  background-color: unset;\n  border: unset;\n}\n.modal .modal-dialog .modal-content .modal-header .close span {\n  font-size: 24px;\n}\n\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div, .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,\n.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,\n.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div {\n  background-color: #fafafa;\n}\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div, .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,\n.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div,\n.products-list.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div {\n  background-color: #ffffff;\n}\n\n.order-datatable .rdt_Table {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.order-datatable .rdt_Table .rdt_TableCell,\n.order-datatable .rdt_Table .rdt_TableCol {\n  padding: 7px 5px;\n}\n.order-datatable .rdt_Table .rdt_TableHead {\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\n  z-index: 1;\n}\n.order-datatable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {\n  flex: 100 0 auto;\n  width: 100px;\n  padding: 5px;\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n.order-datatable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable {\n  justify-content: center;\n  padding: 18px;\n  background-color: #f8f8f9;\n}\n.order-datatable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b {\n  font-size: 14px;\n  color: #313131;\n}\n.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  justify-content: center;\n  font-size: 14px;\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n  background-color: #ffffff;\n}\n.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div, .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) > div, .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5) > div, .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div {\n  background-color: #ffffff;\n}\n.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div {\n  padding: 5px;\n  background-color: #fafafa;\n  flex: 100 0 auto;\n  width: 100px;\n  line-height: 1.5;\n}\n.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div .badge {\n  padding: 4px 6px 5px;\n}\n.order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {\n  border-right: 0;\n}\n\n.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child .rdt_TableCol_Sortable,\n.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child .rdt_TableCol_Sortable,\n.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:last-child .rdt_TableCol_Sortable {\n  padding: 10px;\n}\n.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div, .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div {\n  background-color: #fafafa !important;\n}\n\n.product-list .rdt_Table,\n.translation-list .rdt_Table,\n.category-table .rdt_Table,\n.transactions .rdt_Table,\n.product-physical .rdt_Table {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.product-list .rdt_Table .rdt_TableCell,\n.product-list .rdt_Table .rdt_TableCol,\n.translation-list .rdt_Table .rdt_TableCell,\n.translation-list .rdt_Table .rdt_TableCol,\n.category-table .rdt_Table .rdt_TableCell,\n.category-table .rdt_Table .rdt_TableCol,\n.transactions .rdt_Table .rdt_TableCell,\n.transactions .rdt_Table .rdt_TableCol,\n.product-physical .rdt_Table .rdt_TableCell,\n.product-physical .rdt_Table .rdt_TableCol {\n  padding: 7px 5px;\n}\n.product-list .rdt_Table .rdt_TableHead,\n.translation-list .rdt_Table .rdt_TableHead,\n.category-table .rdt_Table .rdt_TableHead,\n.transactions .rdt_Table .rdt_TableHead,\n.product-physical .rdt_Table .rdt_TableHead {\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\n  z-index: 1;\n}\n.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n.transactions .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {\n  flex: 100 0 auto;\n  width: 100px;\n  padding: 5px;\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,\n.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,\n.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,\n.transactions .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable,\n.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable {\n  justify-content: center;\n  padding: 18px;\n  background-color: #f8f8f9;\n}\n.product-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,\n.translation-list .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,\n.category-table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,\n.transactions .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b,\n.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol b {\n  font-size: 14px;\n  color: #313131;\n}\n.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  justify-content: center;\n  font-size: 14px;\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n  background-color: #ffffff;\n}\n.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div, .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div, .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,\n.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,\n.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,\n.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div,\n.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child > div,\n.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) > div,\n.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child > div {\n  background-color: #ffffff;\n}\n.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,\n.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div,\n.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell > div {\n  padding: 5px;\n  background-color: #fafafa;\n  flex: 100 0 auto;\n  width: 100px;\n  line-height: 1.5;\n}\n.product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n.translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n.category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n.transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child,\n.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {\n  border-right: 0;\n}\n\n.react-datepicker__input-container input {\n  border-radius: 0.25rem;\n  padding: 0.48rem 0.75rem;\n  border: 1px solid #ced4da;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range {\n  background-color: #12571a !important;\n}\n\n.form-label-center .form-group label {\n  margin-top: 8px;\n}\n.form-label-center .form-group .form-group {\n  margin-bottom: 0;\n}\n\n.tab-coupon li {\n  color: #12571a;\n}\n\n.styles_modal__gNwvD {\n  padding: 0;\n}\n.styles_modal__gNwvD button svg {\n  width: 18px;\n}\n\n.product-page-details h2, .product-page-details .h2 {\n  margin-bottom: 5px !important;\n}\n.product-page-details label {\n  margin-bottom: 0 !important;\n}\n.product-page-details .product-price h3, .product-page-details .product-price .h3 {\n  color: #222222;\n}\n\n.product-slider {\n  margin-bottom: 20px;\n}\n\n.small-slick .slick-slide.slick-current div .item {\n  border: 1px solid #12571a;\n}\n\n.checkbox_animated {\n  cursor: pointer;\n  position: relative;\n  margin: 0 20px 0 0;\n}\n.checkbox_animated:checked, .checkbox_animated:not(:checked) {\n  box-shadow: none;\n}\n.checkbox_animated:before {\n  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\n  transform: rotate(-45deg) scale(0, 0);\n  content: \"\";\n  position: absolute;\n  left: 0.25rem;\n  top: 0.225rem;\n  z-index: 1;\n  width: 0.75rem;\n  height: 0.375rem;\n  border: 2px solid #12571a;\n  border-top-style: none;\n  border-right-style: none;\n}\n.checkbox_animated:after {\n  content: \"\";\n  position: absolute;\n  top: -0.125rem;\n  left: -1px;\n  width: 1.3rem;\n  height: 1.3rem;\n  background: #ffffff;\n  border: 2px solid #e8ebf2;\n  cursor: pointer;\n}\n.checkbox_animated:checked:before {\n  transform: rotate(-45deg) scale(1, 1);\n}\n\n.radio_animated {\n  position: relative;\n  margin: 0 1rem 0 0;\n  cursor: pointer;\n  vertical-align: -2px;\n}\n.radio_animated:checked, .radio_animated:not(:checked) {\n  box-shadow: none;\n}\n.radio_animated:before {\n  transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\n  transform: scale(0, 0);\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0.125rem;\n  z-index: 1;\n  width: 0.75rem;\n  height: 0.75rem;\n  background: #12571a;\n  border-radius: 50%;\n}\n.radio_animated:after {\n  content: \"\";\n  position: absolute;\n  top: -0.25rem;\n  left: -0.125rem;\n  width: 1.25rem;\n  height: 1.25rem;\n  background: #ffffff;\n  border: 2px solid #e8ebf2;\n  border-radius: 50%;\n}\n.radio_animated:checked:before {\n  transform: scale(1, 1);\n}\n\na:hover {\n  color: #12571a;\n}\n\n.btn-popup {\n  margin-bottom: 30px;\n}\n\n.add-product .bigImg img {\n  width: 500px;\n}\n.add-product ul li {\n  display: flex;\n  margin-bottom: 15px;\n}\n.add-product ul li .box-input-file {\n  width: 50px;\n  height: 50px;\n  background-color: #dddddd;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n}\n.add-product ul li .box-input-file .upload {\n  position: absolute;\n  width: 70px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n}\n\n.file-upload-product .uploadImg {\n  width: 50px !important;\n  height: 50px !important;\n}\n\n.dropzone {\n  text-align: center;\n  margin-right: auto;\n  margin-left: auto;\n  padding: 50px;\n  border: 2px dashed #12571a;\n  border-radius: 15px;\n  border-image: none;\n  background: transparent;\n  box-sizing: border-box;\n  min-height: 150px;\n  position: relative;\n}\n.dropzone i {\n  font-size: 50px;\n  color: #12571a;\n}\n.dropzone .dzu-input {\n  border: 1px solid #ddd;\n  padding: 6px;\n  margin-left: 15px;\n}\n.dropzone .dzu-previewStatusContainer,\n.dropzone .dzu-submitButtonContainer {\n  display: none;\n}\n.dropzone .dzu-previewImage {\n  width: 75px;\n}\n\n.digital-add .col-form-label {\n  font-family: Nunito;\n}\n.digital-add .form-control {\n  font-size: 14px;\n}\n.digital-add .form-group .radio_animated {\n  margin-right: 16px;\n}\n.digital-add textarea {\n  width: 100%;\n}\n\n.add-product-form .form-group {\n  align-items: center;\n}\n.add-product-form .form-group label {\n  font-size: 16px;\n  font-weight: 600;\n}\n.add-product-form .form-group:last-child {\n  align-items: end;\n}\n.add-product-form .form-group .form-control {\n  font-size: 14px;\n}\n.add-product-form fieldset {\n  padding-left: 15px;\n  border: none;\n}\n.add-product-form .qty-box {\n  width: 15%;\n}\n.add-product-form .qty-box .touchspin {\n  text-align: center;\n}\n.add-product-form .qty-box .bootstrap-touchspin-prefix {\n  display: none;\n}\n.add-product-form .qty-box .bootstrap-touchspin-postfix {\n  display: none;\n}\n.add-product-form .qty-box .input-group {\n  justify-content: flex-start;\n}\n.add-product-form .qty-box .input-group button {\n  padding: 12px;\n}\n.add-product-form .qty-box .input-group button i {\n  font-weight: 900;\n  color: #222222;\n}\n.add-product-form .qty-box .input-group .btn-primary {\n  background-color: transparent !important;\n  border: 1px solid #ddd !important;\n}\n.add-product-form .qty-box .input-group .btn-primary.bootstrap-touchspin-down {\n  border-right: none !important;\n}\n.add-product-form .qty-box .input-group .input-group-append {\n  margin-left: 0;\n}\n.add-product-form .qty-box .input-group .input-group-append .btn {\n  border-left: none !important;\n}\n\n.chart-block canvas {\n  width: 100%;\n}\n\n.sales-carousel .value-graph h3, .sales-carousel .value-graph .h3 {\n  color: #313131;\n  font-weight: 600;\n}\n.sales-carousel .media .small-box {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.small-chartjs canvas {\n  width: 100% !important;\n  height: 60px !important;\n}\n\n.order-graph h6, .order-graph .h6 {\n  color: #313131;\n  font-family: Nunito;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.order-graph .order-graph-bottom {\n  margin-top: 30px;\n}\n.order-graph .order-graph-bottom h6, .order-graph .order-graph-bottom .h6 {\n  color: #999;\n  margin-left: 15px;\n  margin-right: 30px;\n}\n.order-graph .order-graph-bottom h6 span, .order-graph .order-graph-bottom .h6 span {\n  color: #313131;\n}\n.order-graph .order-graph-bottom .media {\n  margin-bottom: 20px;\n}\n.order-graph .order-graph-bottom .media:last-child {\n  margin-bottom: 0;\n}\n.order-graph .order-graph-bottom .media .order-shape-primary {\n  background-color: #12571a;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .media .order-shape-secondary {\n  background-color: #13c9ca;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .media .order-shape-success {\n  background-color: #81ba00;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .media .order-shape-danger {\n  background-color: #a5a5a5;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .media .order-shape-info {\n  background-color: #00a8ff;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .media .order-shape-light {\n  background-color: #f8f8f9;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .media .order-shape-dark {\n  background-color: #2a3142;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .media .order-shape-warning {\n  background-color: #ffbc58;\n  width: 18px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 4px;\n}\n.order-graph .order-graph-bottom .order-color-primary {\n  background-color: #12571a;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.order-graph .order-graph-bottom .order-color-secondary {\n  background-color: #13c9ca;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.order-graph .order-graph-bottom .order-color-success {\n  background-color: #81ba00;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.order-graph .order-graph-bottom .order-color-danger {\n  background-color: #a5a5a5;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.order-graph .order-graph-bottom .order-color-info {\n  background-color: #00a8ff;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.order-graph .order-graph-bottom .order-color-light {\n  background-color: #f8f8f9;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.order-graph .order-graph-bottom .order-color-dark {\n  background-color: #2a3142;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n.order-graph .order-graph-bottom .order-color-warning {\n  background-color: #ffbc58;\n  width: 8px;\n  height: 8px;\n  margin-top: 7px;\n  border-radius: 2px;\n}\n\n.datepickers-container {\n  top: -86px;\n}\n\n.datepicker--nav {\n  color: #12571a;\n}\n\n.datepicker--nav-action {\n  color: #12571a;\n  background-color: #12571a;\n}\n\n.datepicker--nav-action:hover {\n  color: #12571a;\n}\n\n.datepicker--nav-title i {\n  color: #12571a;\n}\n\n.table thead th {\n  border-bottom: 2px solid #e8ebf2;\n}\n\n.authentication-box {\n  min-width: 100vw;\n  min-height: 100vh;\n  width: auto;\n  height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.authentication-box .slick-slider {\n  margin-bottom: 30px;\n}\n.authentication-box .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #12571a;\n}\n.authentication-box .back-btn {\n  float: right;\n  margin: 0;\n  font-size: 14px;\n  position: relative;\n  padding-left: 60px !important;\n}\n.authentication-box .back-btn svg {\n  position: absolute;\n  left: 30px;\n  height: 18px;\n}\n.authentication-box .row {\n  align-items: center;\n}\n.authentication-box .tab2-card .nav-tabs .nav-link {\n  font-size: 18px;\n}\n.authentication-box .tab2-card .nav-tabs .nav-link svg {\n  width: 20px;\n  vertical-align: sub;\n  margin-right: 5px;\n}\n.authentication-box .form-horizontal .form-terms .custom-control {\n  padding-left: 24px;\n}\n.authentication-box .form-horizontal .form-terms .custom-control span a {\n  text-decoration: none;\n}\n.authentication-box .form-horizontal .form-terms .custom-control span .forgot-pass {\n  color: #12571a;\n}\n.authentication-box .btn-primary {\n  border-radius: 25px;\n  margin-top: 12px;\n  font-weight: 400;\n  padding: 11px 45px;\n}\n.authentication-box .form-footer {\n  position: relative;\n  padding-top: 25px;\n  border-top: 1px solid #f3f3f3;\n  margin-top: 25px;\n}\n.authentication-box .form-footer > span {\n  position: absolute;\n  top: -11px;\n  padding-right: 20px;\n  background-color: #fff;\n  color: #909090;\n}\n.authentication-box .form-footer .social {\n  margin-bottom: 0;\n  border-bottom: 0;\n}\n.authentication-box .form-footer .social li {\n  padding: 10px;\n  border-radius: 100%;\n  border: 1px solid #12571a;\n  height: 40px;\n  width: 40px;\n  margin-right: 10px;\n  text-align: center;\n  display: inline-block;\n}\n.authentication-box .form-footer .social li i {\n  font-size: 12px;\n}\n.authentication-box .slick-dots li.slick-active button:before {\n  color: #ffffff;\n}\n.authentication-box .slick-dots li button:before {\n  font-size: 12px;\n  color: #ffffff;\n}\n.authentication-box .container {\n  max-width: 900px;\n}\n.authentication-box .container .bg-primary {\n  padding: 50px;\n  background-image: url(\"../../images/dashboard/login-bg.png\");\n  background-position: center;\n  box-shadow: 1px 5px 24px 0 rgba(13, 84, 4, 0.8);\n}\n.authentication-box .container .form-group {\n  margin-bottom: 1.5rem;\n}\n.authentication-box .container .svg-icon {\n  padding: 24px;\n  margin: 0 auto;\n  border: 2px dashed #ffffff;\n  border-radius: 100%;\n  height: 130px;\n  width: 130px;\n  margin-bottom: 40px;\n}\n.authentication-box .container .svg-icon img {\n  width: 100%;\n}\n.authentication-box .container p {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 15px;\n  line-height: 2;\n  text-align: center;\n}\n.authentication-box .container h3, .authentication-box .container .h3 {\n  color: #ffffff;\n  font-weight: 600;\n  text-align: center;\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1 1;\n}\n\n.auth-form .form-control {\n  border-radius: 25px;\n  padding: 9px 25px;\n  border: 1px solid #eaeaea;\n}\n\n.switch-sm .switch {\n  width: 25px;\n  height: 16px;\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li {\n  width: 100%;\n}\n.page-wrapper .page-body-wrapper footer p {\n  line-height: 1.7;\n}\n.page-wrapper .page-body-wrapper .page-header .row h3, .page-wrapper .page-body-wrapper .page-header .row .h3 {\n  color: #000;\n}\n\n.widget-cards {\n  border-radius: 25px !important;\n}\n\n.static-top-widget div.align-self-center svg {\n  width: 25px;\n  height: 25px;\n  vertical-align: middle;\n}\n.static-top-widget .media-body {\n  align-self: center !important;\n}\n.static-top-widget .media-body h3, .static-top-widget .media-body .h3 {\n  font-family: work-Sans, sans-serif;\n  color: #ffffff;\n}\n.static-top-widget .media-body h3 small, .static-top-widget .media-body .h3 small, .static-top-widget .media-body h3 .small, .static-top-widget .media-body .h3 .small {\n  font-size: 11px;\n}\n.static-top-widget .icons-widgets .text-center {\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  background-color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flot-chart-container {\n  height: 400px;\n}\n\n.user-status table tbody tr td {\n  vertical-align: middle;\n  padding: 12px;\n  border-top: 1px solid #dee2e6;\n}\n.user-status table tbody tr td .d-inline-block {\n  margin-top: 11px;\n}\n.user-status table tbody tr td .image-sm-size img {\n  width: 41px;\n}\n.user-status table tbody tr:last-child td {\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n.user-status table thead tr th {\n  border-top: 0;\n  font-size: 16px;\n  color: #2a3142;\n  font-weight: 600;\n  padding: 0 12px 12px;\n}\n\n.card-block .table-responsive .table caption {\n  padding-left: 10px;\n}\n.card-block .table-responsive .table-bordered td {\n  vertical-align: middle;\n}\n.card-block .table-border-radius {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.products-admin .product-box {\n  padding: 20px;\n}\n.products-admin .product-box .img-wrapper {\n  position: relative;\n}\n.products-admin .product-box .lable-block .lable3 {\n  border-radius: 100%;\n  background-color: #12571a;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 700;\n  position: absolute;\n  padding: 12px 6px;\n  text-transform: uppercase;\n  color: #ffffff;\n  top: 7px;\n  left: 7px;\n  z-index: 1;\n}\n.products-admin .product-box .lable-block .lable4 {\n  position: absolute;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  writing-mode: vertical-rl;\n  transform: rotate(-180deg);\n  top: 7px;\n  right: 7px;\n  letter-spacing: 0.1em;\n  z-index: 1;\n}\n.products-admin .product-box .product-detail .rating {\n  margin-top: 15px !important;\n}\n.products-admin .product-box .product-detail .rating i {\n  padding-right: 5px;\n}\n.products-admin .product-box .product-detail .rating i:nth-child(-n+4) {\n  color: #ffa200;\n}\n.products-admin .product-box .product-detail .rating i:last-child {\n  color: #ffa200;\n}\n.products-admin .product-box .product-detail a {\n  text-decoration: none;\n}\n.products-admin .product-box .product-detail h6, .products-admin .product-box .product-detail .h6 {\n  line-height: 1;\n  margin-bottom: 0;\n  padding-top: 2px;\n  padding-bottom: 5px;\n  transition: all 0.5s ease;\n  font-size: 16px;\n  color: #777777;\n}\n.products-admin .product-box .product-detail h4, .products-admin .product-box .product-detail .h4 {\n  font-size: 18px;\n  color: #222222;\n  font-weight: 700;\n  margin-bottom: 0;\n  transition: all 0.5s ease;\n  color: #222222 !important;\n}\n.products-admin .product-box .product-detail del {\n  font-size: 14px;\n  color: #aaaaaa;\n  font-weight: 400;\n}\n.products-admin .product-box .product-detail .color-variant {\n  padding-top: 15px;\n}\n.products-admin .product-box .product-detail .color-variant li {\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  border-radius: 100%;\n  margin-right: 5px;\n  transition: all 0.1s ease;\n  cursor: pointer;\n}\n.products-admin .product-box .front {\n  position: relative;\n}\n.products-admin .product-box .front .product-hover {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.7);\n  opacity: 0;\n  border-radius: 100%;\n  transform: scale(0);\n  transition: all 0.3s ease;\n}\n.products-admin .product-box .front .product-hover ul li {\n  display: inline-block;\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n  padding: 9px 14px;\n  background-color: #ffffff;\n  font-size: 18px;\n  border-radius: 100%;\n  line-height: 1.6;\n  height: 45px;\n  width: 45px;\n  margin: 0 3px;\n}\n.products-admin .product-box .front .product-hover ul li .btn {\n  padding: 0;\n  background-color: transparent;\n}\n.products-admin .product-box .front .product-hover ul li .btn .editBtn {\n  width: 18px;\n}\n.products-admin .product-box .front .product-hover ul li .btn svg {\n  stroke-width: 1;\n}\n.products-admin .product-box .front .product-hover ul li .btn .deleteBtn {\n  width: 19px;\n  margin-top: 0;\n  margin-left: -2px;\n}\n.products-admin .product-box .front:hover .product-hover {\n  opacity: 1;\n  border-radius: 0%;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n\n.size-modal.modal-dialog .modal-header {\n  align-items: flex-start;\n}\n\n.product-right .timer {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  padding-left: 40px;\n  display: inline-block;\n  margin-top: 10px;\n  background-color: #f7f7f7;\n}\n.product-right .timer p {\n  color: #222222;\n  font-size: 18px;\n}\n.product-right .timer span {\n  width: 70px;\n  display: inline-block;\n}\n.product-right .timer span .padding-l {\n  padding-left: 22px;\n  display: inline;\n}\n.product-right .timer .timer-cal {\n  font-size: 12px;\n  color: #777777;\n}\n.product-right .size-box {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.product-right .size-box ul li {\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  margin-right: 10px;\n  cursor: pointer;\n  border: 1px solid #f7f7f7;\n  text-align: center;\n  display: inline-block;\n}\n.product-right .size-box ul li.active {\n  background-color: #f7f7f7 !important;\n}\n.product-right .size-box ul li a {\n  color: #222222 !important;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-decoration: none;\n}\n.product-right .color-variant {\n  margin-bottom: 10px !important;\n}\n.product-right .color-variant li {\n  height: 30px;\n  width: 30px;\n  cursor: pointer;\n  display: inline-block;\n  border-radius: 100%;\n  margin-right: 5px;\n  transition: all 0.1s ease;\n  vertical-align: middle;\n}\n.product-right .product-title {\n  color: #222222;\n  text-transform: capitalize;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n.product-right .product-title a {\n  color: #12571a !important;\n  text-decoration: none;\n}\n.product-right .product-title p {\n  margin-bottom: 0;\n  line-height: 1.5em;\n}\n.product-right .product-title h3, .product-right .product-title .h3 {\n  font-size: 26px;\n  color: #222222;\n  margin-bottom: 15px;\n}\n.product-right h2, .product-right .h2 {\n  text-transform: uppercase;\n  margin-bottom: 15px;\n  font-size: 25px;\n  line-height: 1.2em;\n}\n\n.bg-light0 {\n  background-color: #d0edff;\n}\n\n.bg-light1 {\n  background-color: #f1e7e6;\n}\n\n.bg-light2 {\n  background-color: #bfbfbf;\n}\n\n.react-tabs .nav-tabs .nav-link {\n  color: #333333;\n  transition: 0.3s;\n  cursor: pointer;\n}\n.react-tabs .nav-tabs .nav-link.react-tabs__tab--selected, .react-tabs .nav-tabs .nav-link:hover, .react-tabs .nav-tabs .nav-link:focus {\n  border-color: transparent transparent transparent !important;\n  border-bottom: 2px solid #12571a !important;\n  color: #12571a;\n  outline: transparent;\n}\n\n.deactivate-account {\n  margin-top: 30px;\n}\n.deactivate-account .btn {\n  margin-top: 20px;\n}\n\n.account-setting h5, .account-setting .h5 {\n  margin-bottom: 20px;\n}\n\n.profile-card ul {\n  margin-bottom: 30px;\n  border-bottom: 1px solid #dee2e6;\n}\n.profile-card ul li svg {\n  width: 18px;\n  vertical-align: middle;\n}\n\n.profile-details img {\n  margin-bottom: 20px;\n}\n.profile-details .social {\n  margin-top: 15px;\n}\n.profile-details .social .btn-showcase {\n  margin-bottom: -10px;\n}\n.profile-details .social .btn-showcase .btn {\n  padding: 8px 13px;\n  margin: 0 5px 20px;\n  border-radius: 100%;\n  width: 40px;\n  height: 40px;\n}\n.profile-details .social .btn-showcase .btn-fb {\n  background-color: #50598e;\n  color: #ffffff;\n}\n.profile-details .social .btn-showcase .btn-google {\n  background-color: #c64e40;\n  color: #ffffff;\n}\n.profile-details .social .btn-showcase .btn-twitter {\n  background-color: #6fa2d8;\n  color: #ffffff;\n}\n\n.project-status {\n  margin-top: 20px;\n}\n.project-status .media {\n  margin-top: 20px;\n}\n\n.sm-progress-bar {\n  height: 6px;\n}\n\n.profile-table table tbody tr td {\n  padding: 12px;\n  border-bottom: 0;\n}\n.profile-table table tbody tr td:first-child {\n  width: 250px;\n}\n.profile-table table th,\n.profile-table table td {\n  border-top: none;\n}\n\n.report-employee .card-header {\n  border-bottom: none !important;\n}\n.report-employee .flot-chart-container {\n  height: 323px;\n}\n\n.sales-chart {\n  height: 307px;\n}\n\n.expense-chart #area-chart1 {\n  height: 307px;\n}\n\n.profile-card .media {\n  align-items: center;\n}\n.profile-card .media img {\n  margin-right: 20px;\n}\n\n.dropzone .dz-preview {\n  box-shadow: 0px 0px 3px #12571a;\n}\n.dropzone .dz-preview .dz-error-message {\n  color: #12571a !important;\n  background: transparent !important;\n  border: 1px solid #12571a !important;\n}\n.dropzone .dz-preview .dz-error-message:after {\n  border-bottom: 6px solid #12571a !important;\n}\n\n.tab-coupon {\n  margin-bottom: 30px;\n}\n\n.needs-validation .permission-block .attribute-blocks {\n  padding-left: 15px;\n}\n.needs-validation .permission-block .attribute-blocks .row {\n  padding-left: 20px;\n}\n.needs-validation .permission-block .attribute-blocks + .attribute-blocks h5, .needs-validation .permission-block .attribute-blocks + .attribute-blocks .h5 {\n  margin-top: 30px;\n}\n.needs-validation .permission-block .attribute-blocks h6, .needs-validation .permission-block .attribute-blocks .h6 {\n  border-bottom: 1px solid #eff0f1;\n  margin-bottom: 15px;\n  padding-bottom: 5px;\n}\n.needs-validation h4, .needs-validation .h4 {\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n.needs-validation input {\n  font-size: 14px;\n}\n.needs-validation .form-group {\n  align-items: center;\n}\n.needs-validation .form-group label {\n  margin-bottom: 0;\n}\n.needs-validation .form-group label span {\n  color: red;\n}\n.needs-validation .form-group .checkbox {\n  padding-left: 0;\n}\n.needs-validation .editor-label {\n  align-items: end;\n}\n.needs-validation .editor-space {\n  padding: 0;\n}\n.needs-validation .checkbox input {\n  opacity: 0;\n}\n.needs-validation .checkbox label {\n  display: inline-block;\n  position: relative;\n  padding-left: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.needs-validation .checkbox label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 19px;\n  height: 19px;\n  left: 0;\n  margin-left: -16px;\n  border: 1px solid #e8ebf2;\n  border-radius: 3px;\n  background-color: #fff;\n  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n}\n.needs-validation .checkbox input[type=checkbox]:checked + label::before {\n  font-family: IcoFont;\n  content: \"\\efab\";\n  text-align: center;\n  line-height: 1;\n  font-size: 18px;\n}\n.needs-validation .checkbox-primary input[type=checkbox]:checked + label::before {\n  border-color: #12571a;\n  color: #12571a;\n}\n.needs-validation .radio-animated label {\n  margin-right: 20px;\n}\n.needs-validation textarea {\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.badge-warning {\n  color: #ffffff;\n}\n\n.user-list img {\n  border-radius: 100%;\n}\n\n/**=====================\n  Admin CSS Ends\n==========================**/\n/**=====================\n      Button CSS start\n==========================**/\n.btn {\n  font-size: 14px;\n  padding: 0.5rem 1.5rem;\n  border-radius: 5px;\n  letter-spacing: 1px;\n  line-height: 20px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  font-size: 18px;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  font-size: 12px;\n}\n\n.btn-xs {\n  padding: 0.05rem 0.4rem;\n  font-size: 11px;\n}\n\n.large-btn {\n  margin-bottom: -20px;\n}\n.large-btn .btn {\n  margin-right: 5px;\n  margin-bottom: 15px;\n}\n\n.input-air-primary {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-primary:focus {\n  border-color: #12571a;\n}\n\n.input-air-secondary {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-secondary:focus {\n  border-color: #13c9ca;\n}\n\n.input-air-success {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-success:focus {\n  border-color: #81ba00;\n}\n\n.input-air-danger {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-danger:focus {\n  border-color: #a5a5a5;\n}\n\n.input-air-info {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-info:focus {\n  border-color: #00a8ff;\n}\n\n.input-air-light {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-light:focus {\n  border-color: #f8f8f9;\n}\n\n.input-air-dark {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-dark:focus {\n  border-color: #2a3142;\n}\n\n.input-air-warning {\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n.input-air-warning:focus {\n  border-color: #ffbc58;\n}\n\n.form-bg-primary {\n  background: #12571a;\n  border-color: #12571a;\n  color: #ffffff;\n}\n.form-bg-primary:focus {\n  border-color: #12571a;\n  background: #12571a;\n  color: #ffffff;\n}\n.form-bg-primary:focus:active {\n  border-color: #12571a;\n  background: #12571a;\n  color: #ffffff;\n}\n\n.form-bg-secondary {\n  background: #13c9ca;\n  border-color: #13c9ca;\n  color: #ffffff;\n}\n.form-bg-secondary:focus {\n  border-color: #13c9ca;\n  background: #13c9ca;\n  color: #ffffff;\n}\n.form-bg-secondary:focus:active {\n  border-color: #13c9ca;\n  background: #13c9ca;\n  color: #ffffff;\n}\n\n.form-bg-success {\n  background: #81ba00;\n  border-color: #81ba00;\n  color: #ffffff;\n}\n.form-bg-success:focus {\n  border-color: #81ba00;\n  background: #81ba00;\n  color: #ffffff;\n}\n.form-bg-success:focus:active {\n  border-color: #81ba00;\n  background: #81ba00;\n  color: #ffffff;\n}\n\n.form-bg-danger {\n  background: #a5a5a5;\n  border-color: #a5a5a5;\n  color: #ffffff;\n}\n.form-bg-danger:focus {\n  border-color: #a5a5a5;\n  background: #a5a5a5;\n  color: #ffffff;\n}\n.form-bg-danger:focus:active {\n  border-color: #a5a5a5;\n  background: #a5a5a5;\n  color: #ffffff;\n}\n\n.form-bg-info {\n  background: #00a8ff;\n  border-color: #00a8ff;\n  color: #ffffff;\n}\n.form-bg-info:focus {\n  border-color: #00a8ff;\n  background: #00a8ff;\n  color: #ffffff;\n}\n.form-bg-info:focus:active {\n  border-color: #00a8ff;\n  background: #00a8ff;\n  color: #ffffff;\n}\n\n.form-bg-light {\n  background: #f8f8f9;\n  border-color: #f8f8f9;\n  color: #2a3142;\n}\n.form-bg-light:focus {\n  border-color: #f8f8f9;\n  background: #f8f8f9;\n  color: #2a3142;\n}\n.form-bg-light:focus:active {\n  border-color: #f8f8f9;\n  background: #f8f8f9;\n  color: #2a3142;\n}\n\n.form-bg-dark {\n  background: #2a3142;\n  border-color: #2a3142;\n  color: #ffffff;\n}\n.form-bg-dark:focus {\n  border-color: #2a3142;\n  background: #2a3142;\n  color: #ffffff;\n}\n.form-bg-dark:focus:active {\n  border-color: #2a3142;\n  background: #2a3142;\n  color: #ffffff;\n}\n\n.form-bg-warning {\n  background: #ffbc58;\n  border-color: #ffbc58;\n  color: #ffffff;\n}\n.form-bg-warning:focus {\n  border-color: #ffbc58;\n  background: #ffbc58;\n  color: #ffffff;\n}\n.form-bg-warning:focus:active {\n  border-color: #ffbc58;\n  background: #ffbc58;\n  color: #ffffff;\n}\n\n.btn-warning {\n  color: #ffffff;\n}\n.btn-warning:hover, .btn-warning.disabled {\n  color: #ffffff;\n}\n\n.btn-primary-gradien {\n  background-image: linear-gradient(to right, #197924 0%, #0b3510 51%, #197924 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-primary-gradien:focus, .btn-primary-gradien:active, .btn-primary-gradien.active {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, #197924, 0%, #0b3510, 100%, #ffffff) !important;\n}\n\n.btn-secondary-gradien {\n  background-image: linear-gradient(to right, #1ce9ea 0%, #0fa4a5 51%, #1ce9ea 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-secondary-gradien:hover, .btn-secondary-gradien:focus, .btn-secondary-gradien:active, .btn-secondary-gradien.active, .btn-secondary-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, #1ce9ea, 0%, #0fa4a5, 100%, #ffffff) !important;\n}\n\n.btn-success-gradien {\n  background-image: linear-gradient(to right, #9de300 0%, #659100 51%, #9de300 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-success-gradien:hover, .btn-success-gradien:focus, .btn-success-gradien:active, .btn-success-gradien.active, .btn-success-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, #9de300, 0%, #659100, 100%, #ffffff) !important;\n}\n\n.btn-danger-gradien {\n  background-image: linear-gradient(to right, #b9b9b9 0%, #919191 51%, #b9b9b9 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-danger-gradien:hover, .btn-danger-gradien:focus, .btn-danger-gradien:active, .btn-danger-gradien.active, .btn-danger-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, #b9b9b9, 0%, #919191, 100%, #ffffff) !important;\n}\n\n.btn-warning-gradien {\n  background-image: linear-gradient(to right, #ffcc81 0%, #ffac2f 51%, #ffcc81 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-warning-gradien:hover, .btn-warning-gradien:focus, .btn-warning-gradien:active, .btn-warning-gradien.active, .btn-warning-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, #ffcc81, 0%, #ffac2f, 100%, #ffffff) !important;\n}\n\n.btn-info-gradien {\n  background-image: linear-gradient(to right, #29b6ff 0%, #008dd6 51%, #29b6ff 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-info-gradien:hover, .btn-info-gradien:focus, .btn-info-gradien:active, .btn-info-gradien.active, .btn-info-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, #29b6ff, 0%, #008dd6, 100%, #ffffff) !important;\n}\n\n.btn-light {\n  margin-left: 7px;\n}\n\n.btn-light-gradien {\n  background-image: linear-gradient(to right, white 0%, #e2e2e6 51%, white 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-light-gradien:hover, .btn-light-gradien:focus, .btn-light-gradien:active, .btn-light-gradien.active, .btn-light-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, white, 0%, #e2e2e6, 100%, #ffffff) !important;\n}\n\n.btn-dark-gradien {\n  background-image: linear-gradient(to right, #3a445b 0%, #1a1e29 51%, #3a445b 100%);\n  border: none;\n  color: #ffffff;\n  background-size: auto 200%;\n  transition: all 0.3s ease;\n}\n.btn-dark-gradien:hover, .btn-dark-gradien:focus, .btn-dark-gradien:active, .btn-dark-gradien.active, .btn-dark-gradien.hover {\n  transition: 1.5s;\n  background-position: right center;\n  background-image: linear-gradient(to right, #3a445b, 0%, #1a1e29, 100%, #ffffff) !important;\n}\n\n[class*=-gradien]:hover {\n  background-size: 50% 100%;\n  transition: all 0.3s ease;\n  color: #ffffff;\n}\n\n/**=====================\n Button CSS end\n==========================**/\n/**=====================\n      Card CSS Start\n==========================**/\n.card {\n  margin-bottom: 30px;\n  border: 0px;\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n  border-radius: 8px;\n  box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\n}\n.card .card-header {\n  background-color: #ffffff;\n  border-bottom: none;\n  padding: 30px;\n  border-bottom: 1px solid #f8f8f9;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.card .card-header h5, .card .card-header .h5 {\n  font-size: 18px;\n  margin-bottom: 0;\n  text-transform: capitalize;\n  font-weight: 600;\n  line-height: 24px;\n}\n.card .card-header > span {\n  font-size: 12px;\n  color: #777777;\n  margin-top: 5px;\n  display: block;\n  letter-spacing: 1px;\n}\n.card .card-body {\n  padding: 30px;\n  background-color: transparent;\n}\n.card .card-body p:last-child {\n  margin-bottom: 0;\n}\n.card .sub-title {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding-bottom: 5px;\n  margin-bottom: 8px;\n  font-size: 18px;\n}\n.card .card-footer {\n  background-color: #ffffff;\n  border-top: 1px solid #f8f8f9;\n  padding: 30px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.card-header .nav-material {\n  margin-bottom: -13px;\n}\n\n/**=====================\n     Card CSS End\n==========================**/\n/**=====================\n      Footer CSS Start\n==========================**/\nfooter {\n  background-color: #ffffff;\n  border-top: 1px solid #f8f8f9;\n  padding: 15px;\n  bottom: 0;\n  left: 0;\n}\nfooter a {\n  font-weight: 600;\n}\n\n.page-wrapper .page-body-wrapper footer {\n  margin-left: 255px;\n  transition: all 0.3s ease;\n  bottom: 0;\n  z-index: 8;\n}\n.page-wrapper .page-body-wrapper footer p {\n  color: rgb(165, 165, 165);\n}\n.page-wrapper .page-body-wrapper footer p i {\n  color: #a5a5a5;\n  margin-left: 5px;\n}\n\n/**=====================\n      Footer CSS Ends\n==========================**/\n/**=====================\n      General CSS Start\n==========================**/\nh1, .h1 {\n  font-size: 60px;\n  color: #222222;\n  font-weight: 700;\n  text-transform: uppercase;\n}\nh1 span, .h1 span {\n  font-size: 107px;\n  font-weight: 700;\n  color: #12571a;\n}\n\nh2, .h2 {\n  font-size: 36px;\n  text-transform: uppercase;\n  font-weight: 700;\n  color: #000000;\n  line-height: 1;\n  letter-spacing: 0.02em;\n}\n\nh3, .h3 {\n  font-size: 24px;\n  font-weight: 400;\n  color: #777777;\n  letter-spacing: 0.03em;\n}\n\nh4, .h4 {\n  font-size: 18px;\n  text-transform: capitalize;\n  font-weight: 400;\n  letter-spacing: 0.03em;\n  line-height: 1;\n}\n\ndel {\n  font-size: 14px;\n  color: #aaaaaa;\n  font-weight: 400;\n}\n\nh5, .h5 {\n  font-size: 16px;\n  font-weight: 400;\n  color: #222222;\n  line-height: 24px;\n  letter-spacing: 0.05em;\n}\n\nh6, .h6 {\n  font-size: 14px;\n  font-weight: 400;\n  color: #777777;\n  line-height: 24px;\n}\n\nbody {\n  background-color: rgba(246, 246, 246, 0.6);\n  font-size: 14px;\n  overflow-x: hidden;\n  font-family: work-Sans, sans-serif;\n  color: #313131;\n  position: relative;\n}\n\nul {\n  padding-left: 0px;\n  list-style-type: none;\n  margin-bottom: 0;\n  padding-right: 0px;\n}\n\nli {\n  display: inline-block;\n}\n\n* a {\n  color: #12571a;\n}\n\n*.btn:focus {\n  box-shadow: none !important;\n}\n\np {\n  color: #777777;\n  font-size: 13px;\n  line-height: 1.7;\n  letter-spacing: 0.7px;\n}\n\ncode {\n  color: #12571a !important;\n  background-color: #f8f8f9;\n  padding: 3px;\n  margin: 0 3px;\n  border-radius: 2px;\n}\n\na {\n  transition: 0.5s ease;\n}\na:hover {\n  text-decoration: none;\n  transition: 0.5s ease;\n}\na:focus {\n  outline: none;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n:focus {\n  outline-color: #12571a;\n}\n\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\nsvg {\n  vertical-align: baseline;\n}\n\ninput:focus {\n  outline-color: transparent;\n}\n\n.txt-dark {\n  color: #1b252a !important;\n}\n\n.txt-success {\n  color: #81ba00 !important;\n}\n\n.txt-danger {\n  color: #a5a5a5 !important;\n}\n\n/**=====================\n      General CSS Ends\n==========================**/\n/**=====================\n    Header CSS Start\n==========================**/\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li.active > a, .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li:hover > a {\n  color: #313131;\n  border-left-color: #2a3142;\n  transition: 0.3s;\n}\n\n.onhover-show-div {\n  box-shadow: 0 0 2px 2px #f8f8f9;\n  transform: translateY(30px);\n  opacity: 0;\n  visibility: hidden;\n  left: 0;\n}\n\n.nav-menus .onhover-dropdown:hover .onhover-show-div {\n  opacity: 1;\n  transform: translateY(0px);\n  visibility: visible;\n}\n.nav-menus .onhover-dropdown:hover .onhover-show-div:before {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #ffffff;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  left: 10px;\n  z-index: 2;\n}\n.nav-menus .onhover-dropdown:hover .onhover-show-div:after {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #898989;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  left: 10px;\n  z-index: 1;\n}\n\n/*======= Page Header css Start ======= */\n.page-wrapper .page-main-header {\n  background-color: #ffffff;\n  height: 80px;\n  position: fixed;\n  top: 0;\n  z-index: 10;\n  box-shadow: 0 0 10px 1px rgba(68, 102, 242, 0.05);\n  width: calc(100% - 255px);\n  display: flex;\n  align-items: center;\n  margin-left: 255px;\n  transition: 0.3s;\n}\n.page-wrapper .page-main-header.open {\n  margin-left: 0;\n  width: 100%;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-body {\n  min-height: calc(100vh - 80px);\n  margin-top: 80px;\n  padding: 0 15px;\n  position: relative;\n  background-color: #f8f8f9;\n}\n.page-wrapper .page-body-wrapper .page-header {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n.page-wrapper .page-body-wrapper .page-header .row {\n  align-items: center;\n}\n.page-wrapper .page-body-wrapper .page-header .row .page-header-left {\n  display: flex;\n  align-items: center;\n}\n.page-wrapper .page-body-wrapper .page-header .row h3, .page-wrapper .page-body-wrapper .page-header .row .h3 {\n  font-size: 24px;\n  margin-bottom: 0;\n  font-weight: 800;\n  text-transform: uppercase;\n  font-family: Nunito;\n}\n.page-wrapper .page-body-wrapper .page-header .row h3 small, .page-wrapper .page-body-wrapper .page-header .row .h3 small, .page-wrapper .page-body-wrapper .page-header .row h3 .small, .page-wrapper .page-body-wrapper .page-header .row .h3 .small {\n  display: block;\n  font-size: 12px;\n  margin-top: 7px;\n  letter-spacing: 1px;\n  text-transform: capitalize;\n  color: #777777;\n  font-weight: 400;\n}\n.page-wrapper .page-body-wrapper .page-header .breadcrumb {\n  background-color: transparent;\n  padding: 0;\n  margin-bottom: 0;\n}\n.page-wrapper .page-body-wrapper .page-header .breadcrumb .breadcrumb-item {\n  font-family: Nunito;\n}\n.page-wrapper .page-body-wrapper .page-header .breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n  content: \"/\";\n}\n.page-wrapper .page-body-wrapper .page-header .breadcrumb .breadcrumb-item a svg {\n  width: 14px;\n  height: 14px;\n  vertical-align: text-top;\n}\n\n/*======= Page Header css ends  ======= */\n/**======Main Header css Start ======**/\n.page-main-header {\n  max-width: 100vw;\n}\n.page-main-header .main-header-right {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 40px;\n  margin: 0;\n}\n.page-main-header .main-header-right svg {\n  color: #12571a;\n}\n.page-main-header .main-header-right svg line,\n.page-main-header .main-header-right svg polyline {\n  color: #12571a;\n}\n.page-main-header .main-header-right .nav-left i {\n  margin-right: 20px;\n}\n.page-main-header .main-header-right .nav-left input:focus {\n  outline: 0 !important;\n}\n.page-main-header .main-header-right .nav-right {\n  text-align: right;\n  padding-left: 0px;\n}\n.page-main-header .main-header-right .nav-right ul li .media .dotted-animation {\n  position: relative;\n  right: -3px;\n  top: -7px;\n}\n.page-main-header .main-header-right .nav-right ul li .media .dotted-animation .animate-circle {\n  position: absolute;\n  top: -20px;\n  right: -4px;\n  height: 25px;\n  width: 25px;\n  z-index: 10;\n  border: 5px solid #12571a;\n  border-radius: 70px;\n  animation: heartbit 1s ease-out;\n  animation-iteration-count: infinite;\n}\n.page-main-header .main-header-right .nav-right ul li .media .dotted-animation .main-circle {\n  width: 6px;\n  height: 6px;\n  border-radius: 30px;\n  background-color: #12571a;\n  position: absolute;\n  right: 6px;\n  top: -10px;\n}\n.page-main-header .main-header-right .nav-right ul li svg {\n  margin-top: 10px;\n  width: 18px;\n  height: 18px;\n}\n.page-main-header .main-header-right .nav-right ul li svg path {\n  color: #12571a;\n}\n.page-main-header .main-header-right .nav-right ul li .dot {\n  width: 3px;\n  height: 3px;\n  border-radius: 30px;\n  background-color: #12571a;\n  position: absolute;\n  right: 17px;\n  bottom: 6px;\n  animation: blink 1.5s infinite;\n}\n.page-main-header .main-header-right .nav-right ul li .dot-chat {\n  right: 4px;\n  bottom: -11px;\n}\n.page-main-header .main-header-right .nav-right .notification {\n  position: absolute;\n  top: 21px;\n  right: -1px;\n  font-size: 9px;\n  animation: blink 1.5s infinite;\n}\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  70% {\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.page-main-header .main-header-right .nav-right .icon-user {\n  font-size: 16px;\n}\n@keyframes heartbit {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  25% {\n    transform: scale(0.1);\n    opacity: 0.1;\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.3;\n  }\n  75% {\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.page-main-header .main-header-right .nav-right > ul {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.page-main-header .main-header-right .nav-right > ul > li {\n  position: relative;\n  border-left: 1px solid #eff0f1;\n  padding: 0 20px;\n}\n.page-main-header .main-header-right .nav-right > ul > li:first-child {\n  width: 25%;\n  border-left: none;\n}\n.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group {\n  width: 100%;\n  position: relative;\n}\n.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:focus {\n  outline-color: transparent;\n}\n.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group input:focus {\n  outline-color: transparent;\n  box-shadow: none;\n}\n.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:before {\n  position: absolute;\n  content: \"\";\n  width: 1px;\n  height: 25px;\n  background: #e8ebf2;\n  left: 51px;\n  top: 11px;\n}\n.page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:after {\n  position: absolute;\n  content: \"\\f002\";\n  font-family: FontAwesome;\n  top: 12px;\n  left: 22px;\n  color: #8e8e8e;\n}\n.page-main-header .main-header-right .nav-right > ul > li:last-child {\n  border-left: none;\n  padding-right: 0;\n}\n.page-main-header .main-header-right .nav-right > ul > li:nth-child(5) {\n  border-left: none;\n  border-right: 1px solid #eff0f1;\n  padding-left: 0;\n}\n.page-main-header .main-header-right .nav-right > ul > li a.txt-dark {\n  text-decoration: none;\n}\n.page-main-header .main-header-right .nav-right > ul > li h6, .page-main-header .main-header-right .nav-right > ul > li .h6 {\n  margin-top: 4px;\n  margin-bottom: 4px;\n  color: #12571a;\n}\n.page-main-header .main-header-right .nav-right > ul > li h6 ul, .page-main-header .main-header-right .nav-right > ul > li .h6 ul {\n  left: inherit;\n  right: -10px;\n  width: 130px;\n}\n.page-main-header .main-header-right .nav-right > ul > li h6 ul:before, .page-main-header .main-header-right .nav-right > ul > li .h6 ul:before, .page-main-header .main-header-right .nav-right > ul > li h6 ul:after, .page-main-header .main-header-right .nav-right > ul > li .h6 ul:after {\n  left: inherit;\n  right: 10px;\n}\n.page-main-header .main-header-right .nav-right > ul > li h6 ul li, .page-main-header .main-header-right .nav-right > ul > li .h6 ul li {\n  display: block;\n}\n.page-main-header .main-header-right .nav-right > ul > li h6 ul li a, .page-main-header .main-header-right .nav-right > ul > li .h6 ul li a {\n  font-size: 14px;\n  color: #2a3142;\n}\n.page-main-header .main-header-right .nav-right > ul > li h6 ul li a i, .page-main-header .main-header-right .nav-right > ul > li .h6 ul li a i {\n  margin-left: 10px;\n  font-size: 13px;\n  color: #2a3142;\n}\n.page-main-header .main-header-right .nav-right > ul .flag-icon {\n  font-size: 16px;\n}\n.page-main-header .main-header-right .nav-right .notification-dropdown {\n  top: 57px;\n}\n.page-main-header .main-header-right .nav-right .language-dropdown {\n  width: 160px;\n  text-align: left;\n  top: 57px;\n}\n.page-main-header .main-header-right .nav-right .language-dropdown li {\n  padding-top: 10px;\n}\n.page-main-header .main-header-right .nav-right .language-dropdown li a {\n  color: #2a3142;\n  text-decoration: none;\n}\n.page-main-header .main-header-right .nav-right .language-dropdown li a i {\n  margin-right: 10px;\n}\n.page-main-header .main-header-right .nav-right .language-dropdown li:first-child {\n  padding-top: 0;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown {\n  right: -10px;\n  left: inherit;\n  width: 150px;\n  top: 63px;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown:before, .page-main-header .main-header-right .nav-right .profile-dropdown:after {\n  left: inherit;\n  right: 10px;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li {\n  display: block;\n  text-align: left;\n  padding-top: 10px;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li:nth-child(3) {\n  padding-bottom: 10px;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li:nth-child(4) {\n  border-top: 1px solid #eff0f1;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li:first-child {\n  padding-top: 0;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a {\n  color: #12571a;\n  transition: 0.3s;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg {\n  color: #12571a !important;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg path,\n.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg line,\n.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a svg polyline {\n  color: #12571a !important;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li a {\n  color: #313131;\n  transition: 0.3s;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li a svg {\n  margin-right: 10px;\n  color: #313131;\n}\n.page-main-header .main-header-right .nav-right .profile-dropdown li a svg polyline {\n  color: #313131;\n}\n.page-main-header .main-header-right li {\n  display: inline-block;\n  position: relative;\n}\n\n.nav-menus .notification-badge {\n  position: absolute;\n  right: 10px;\n  top: 1px;\n  padding: 4px 7px;\n}\n.nav-menus .onhover-dropdown {\n  cursor: pointer;\n  position: relative;\n}\n.nav-menus .onhover-dropdown:before {\n  display: none;\n}\n.nav-menus .search-form input {\n  border: 1px solid #eff0f1;\n  padding: 10px 10px 10px 70px;\n  border-radius: 50px;\n  background-color: #f8f8f9;\n  font-size: 14px;\n}\n\nul.notification-dropdown.onhover-show-div {\n  width: 330px;\n  right: -18px;\n  left: initial;\n}\nul.notification-dropdown.onhover-show-div:before, ul.notification-dropdown.onhover-show-div:after {\n  left: inherit !important;\n  right: 35px !important;\n}\nul.notification-dropdown.onhover-show-div li {\n  display: block;\n  padding: 12px 20px;\n  border-bottom: 1px solid #f8f8f9;\n  text-align: left;\n}\nul.notification-dropdown.onhover-show-div li a {\n  text-decoration: none;\n}\nul.notification-dropdown.onhover-show-div li h6 small, ul.notification-dropdown.onhover-show-div li .h6 small, ul.notification-dropdown.onhover-show-div li h6 .small, ul.notification-dropdown.onhover-show-div li .h6 .small {\n  padding-top: 5px;\n  color: #898989;\n  font-size: 12px;\n}\nul.notification-dropdown.onhover-show-div li span svg {\n  margin-top: 0 !important;\n  margin-right: 10px;\n  vertical-align: text-top;\n}\nul.notification-dropdown.onhover-show-div li span .shopping-color path,\nul.notification-dropdown.onhover-show-div li span .shopping-color line {\n  color: #12571a;\n}\nul.notification-dropdown.onhover-show-div li span .download-color path,\nul.notification-dropdown.onhover-show-div li span .download-color line {\n  color: #81ba00;\n}\nul.notification-dropdown.onhover-show-div li span .alert-color path,\nul.notification-dropdown.onhover-show-div li span .alert-color line {\n  color: #a5a5a5;\n}\nul.notification-dropdown.onhover-show-div li p {\n  margin-left: 30px;\n}\nul.notification-dropdown.onhover-show-div li + li:hover {\n  background-color: #f8f8f9;\n}\n\n.onhover-show-div {\n  top: 80px;\n  position: absolute;\n  z-index: 8;\n  background-color: #ffffff;\n  transition: all linear 0.3s;\n}\n.onhover-show-div li a svg {\n  margin-top: 0 !important;\n}\n.onhover-show-div li a svg path,\n.onhover-show-div li a svg line {\n  color: #313131 !important;\n}\n\n/**======Main Header css Ends ======**/\n/**=====================\n    Sidebar CSS Start\n==========================**/\n.page-wrapper .page-body-wrapper .sidebar {\n  height: calc(100vh - 80px);\n  overflow: auto;\n  box-shadow: 0 0 11px rgba(143, 164, 232, 0.08);\n}\n.page-wrapper .page-body-wrapper .page-sidebar {\n  width: 255px;\n  position: fixed;\n  background: #ffffff;\n  top: 0;\n  height: 100vh;\n  z-index: 9;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .main-header-left {\n  display: inline-flex;\n  width: 100%;\n  height: 80px;\n  padding: 12px;\n  align-items: center;\n  background-color: transparent;\n  z-index: 10;\n  box-shadow: -3px 1px 3px 1px rgba(68, 102, 242, 0.1);\n}\n.page-wrapper .page-body-wrapper .page-sidebar .main-header-left .logo-wrapper {\n  padding-left: 10px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {\n  padding: 25px 10px;\n  box-shadow: 3px 2px 7px -1px rgba(127, 151, 249, 0.13);\n  position: relative;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6, .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .h6 {\n  color: #12571a;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  margin-bottom: 3px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 10px;\n  margin-bottom: 0px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user img {\n  box-shadow: 0 0 15px rgba(68, 102, 242, 0.3);\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {\n  list-style: none;\n  margin: 0;\n  padding: 20px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {\n  font-size: 14px;\n  letter-spacing: 0.5px;\n  padding-bottom: 12px;\n  padding-top: 12px;\n  text-transform: capitalize;\n  font-weight: 600;\n  color: #313131;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header svg {\n  width: 14px;\n  height: 14px;\n  margin-right: 14px;\n  stroke-width: 3px;\n  vertical-align: text-bottom;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu.menu-open li.active .fa-angle-down:before {\n  content: \"\\f104\";\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a {\n  display: block;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.active {\n  color: #12571a;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a:hover {\n  color: #12571a;\n  padding-left: 3px;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i {\n  margin-right: 7px;\n  text-align: right;\n  margin-top: 3px;\n  font-size: 15px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i:before {\n  content: \"\\f105\";\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i ~ i {\n  margin-right: 0;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li .label {\n  margin-top: 3px;\n  margin-right: 5px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li .badge {\n  margin-left: 50px;\n  text-transform: capitalize;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {\n  margin-bottom: 0;\n  padding: 15px;\n  color: #313131;\n  font-weight: 600;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li > a > .fa-angle-down {\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin-right: 10px;\n  margin-top: 10px;\n  transform: rotate(-90deg);\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > a > .fa-angle-right:before {\n  content: \"\\f107\";\n  font-family: FontAwesome;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > .sidebar-submenu {\n  display: block;\n  transform: rotateX(0deg);\n  transform-origin: 10% 10%;\n  transition: transform 0.3s, opacity 0.3s;\n  transform-style: preserve-3d;\n  margin-left: 25px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > .sidebar-submenu a i.pull-right {\n  margin-top: 10px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {\n  text-decoration: none;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu {\n  display: none;\n  transform-style: preserve-3d;\n  transform: rotateX(-90deg);\n  list-style: none;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu .sidebar-submenu {\n  padding-top: 0 !important;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a {\n  padding-bottom: 7px;\n  padding-top: 7px;\n  font-size: 14px;\n  color: #898989;\n  transition: 0.3s;\n  text-transform: capitalize;\n  position: relative;\n  padding-left: 10px;\n  line-height: 2.5;\n  letter-spacing: 0.7px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > .fa-circle {\n  width: 12px;\n  font-size: 4px;\n  position: absolute;\n  left: 0;\n  top: 13px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > i {\n  width: auto;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > .fa-angle-down {\n  width: auto;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a:hover {\n  color: #12571a;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a.active {\n  color: #12571a;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li.active > a {\n  color: #313131;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li.active > a.active {\n  color: #12571a;\n}\n.page-wrapper .page-body-wrapper .page-sidebar ~ .page-body {\n  margin-left: 255px;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar.open {\n  display: block;\n  margin-left: calc(-260px);\n}\n.page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body {\n  margin-left: 0;\n  transition: 0.3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar.open ~ footer {\n  margin-left: 0;\n  padding-right: 15px;\n}\n.page-wrapper .page-body-wrapper .page-sidebar.open ~ .footer-fix {\n  width: calc(100% - 0px);\n}\n.page-wrapper .page-body-wrapper .sidebar-close .page-sidebar {\n  transition: 0.3s;\n  transform: translate(-255px);\n}\n.page-wrapper .page-body-wrapper .sidebar-close .page-body {\n  transition: 0.3s;\n  margin-left: 0 !important;\n}\n\n.right-sidebar {\n  top: 81px;\n  right: -285px;\n  height: 100%;\n  position: fixed;\n  width: 285px;\n  z-index: 9;\n  background-color: #fff;\n  transition: 0.5s;\n  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n}\n.right-sidebar.show {\n  right: 0;\n  transition: 0.3s;\n}\n.right-sidebar .modal-header .modal-title {\n  padding-top: 2px;\n}\n.right-sidebar .friend-list-search {\n  position: relative;\n  background-color: #f8f8f9;\n  padding: 20px;\n}\n.right-sidebar .friend-list-search input {\n  color: #898989;\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #f8f8f9;\n  padding: 10px 15px;\n  border-radius: 25px;\n  letter-spacing: 1px;\n}\n.right-sidebar .friend-list-search .fa {\n  position: absolute;\n  right: 35px;\n  top: 34px;\n  font-size: 14px;\n  color: #e8ebf2;\n}\n.right-sidebar .chat-box .people-list ul {\n  padding-top: 20px;\n}\n.right-sidebar .chat-box .people-list ul li {\n  position: relative;\n}\n.right-sidebar svg {\n  width: 16px;\n  height: 16px;\n  margin-top: 5px;\n}\n\n/**=====================\n    Sidebar CSS Ends\n==========================**/\n/**=====================\n      Generic CSS Start\n==========================**/\n/*====== Padding css starts ======*/\n.p-0 {\n  padding: 0px;\n}\n\n.p-5 {\n  padding: 5px;\n}\n\n.p-10 {\n  padding: 10px;\n}\n\n.p-15 {\n  padding: 15px;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.p-25 {\n  padding: 25px;\n}\n\n.p-30 {\n  padding: 30px;\n}\n\n.p-35 {\n  padding: 35px;\n}\n\n.p-40 {\n  padding: 40px;\n}\n\n.p-45 {\n  padding: 45px;\n}\n\n.p-50 {\n  padding: 50px;\n}\n\n/*====== Padding css ends ======*/\n/*====== Padding-left css starts ======*/\n.p-l-0 {\n  padding-left: 0px;\n}\n\n.p-l-5 {\n  padding-left: 5px;\n}\n\n.p-l-10 {\n  padding-left: 10px;\n}\n\n.p-l-15 {\n  padding-left: 15px;\n}\n\n.p-l-20 {\n  padding-left: 20px;\n}\n\n.p-l-25 {\n  padding-left: 25px;\n}\n\n.p-l-30 {\n  padding-left: 30px;\n}\n\n.p-l-35 {\n  padding-left: 35px;\n}\n\n.p-l-40 {\n  padding-left: 40px;\n}\n\n.p-l-45 {\n  padding-left: 45px;\n}\n\n.p-l-50 {\n  padding-left: 50px;\n}\n\n/*====== Padding-left css ends ======*/\n/*====== Padding-top css starts ======*/\n.p-t-0 {\n  padding-top: 0px !important;\n}\n\n.p-t-5 {\n  padding-top: 5px !important;\n}\n\n.p-t-10 {\n  padding-top: 10px !important;\n}\n\n.p-t-15 {\n  padding-top: 15px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-25 {\n  padding-top: 25px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-35 {\n  padding-top: 35px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-45 {\n  padding-top: 45px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n/*====== Padding-top css ends ======*/\n/*====== Padding-bottom css starts ======*/\n.p-b-0 {\n  padding-bottom: 0px !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-15 {\n  padding-bottom: 15px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-35 {\n  padding-bottom: 35px !important;\n}\n\n.p-b-40 {\n  padding-bottom: 40px !important;\n}\n\n.p-b-45 {\n  padding-bottom: 45px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n/*====== Padding-bottom css ends ======*/\n/*====== Padding-right css starts ======*/\n.p-r-0 {\n  padding-right: 0px;\n}\n\n.p-r-5 {\n  padding-right: 5px;\n}\n\n.p-r-10 {\n  padding-right: 10px;\n}\n\n.p-r-15 {\n  padding-right: 15px;\n}\n\n.p-r-20 {\n  padding-right: 20px;\n}\n\n.p-r-25 {\n  padding-right: 25px;\n}\n\n.p-r-30 {\n  padding-right: 30px;\n}\n\n.p-r-35 {\n  padding-right: 35px;\n}\n\n.p-r-40 {\n  padding-right: 40px;\n}\n\n.p-r-45 {\n  padding-right: 45px;\n}\n\n.p-r-50 {\n  padding-right: 50px;\n}\n\n/*====== Padding-right css ends ======*/\n/*====== Margin css starts ======*/\n.m-0 {\n  margin: 0px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.m-45 {\n  margin: 45px !important;\n}\n\n.m-50 {\n  margin: 50px !important;\n}\n\n/*====== Margin css ends ======*/\n/*====== Margin-top css starts ======*/\n.m-t-0 {\n  margin-top: 0px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-25 {\n  margin-top: 25px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-35 {\n  margin-top: 35px !important;\n}\n\n.m-t-40 {\n  margin-top: 40px !important;\n}\n\n.m-t-45 {\n  margin-top: 45px !important;\n}\n\n.m-t-50 {\n  margin-top: 50px !important;\n}\n\n/*====== Margin-top css ends ======*/\n/*====== Margin-Bottom css starts ======*/\n.m-b-0 {\n  margin-bottom: 0px !important;\n}\n\n.m-b-5 {\n  margin-bottom: 5px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-15 {\n  margin-bottom: 15px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-25 {\n  margin-bottom: 25px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-35 {\n  margin-bottom: 35px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-b-45 {\n  margin-bottom: 45px !important;\n}\n\n.m-b-50 {\n  margin-bottom: 50px !important;\n}\n\n/*====== Margin-Bottom css ends ======*/\n/*====== Margin-left css starts ======*/\n.m-l-0 {\n  margin-left: 0px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-15 {\n  margin-left: 15px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-25 {\n  margin-left: 25px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-l-45 {\n  margin-left: 45px !important;\n}\n\n.m-l-50 {\n  margin-left: 50px !important;\n}\n\n/*====== Margin-left css ends ======*/\n/*====== Margin-right css starts ======*/\n.m-r-0 {\n  margin-right: 0px;\n}\n\n.m-r-5 {\n  margin-right: 5px;\n}\n\n.m-r-10 {\n  margin-right: 10px;\n}\n\n.m-r-15 {\n  margin-right: 15px;\n}\n\n.m-r-20 {\n  margin-right: 20px;\n}\n\n.m-r-25 {\n  margin-right: 25px;\n}\n\n.m-r-30 {\n  margin-right: 30px;\n}\n\n.m-r-35 {\n  margin-right: 35px;\n}\n\n.m-r-40 {\n  margin-right: 40px;\n}\n\n.m-r-45 {\n  margin-right: 45px;\n}\n\n.m-r-50 {\n  margin-right: 50px;\n}\n\n/*====== Margin-right css ends ======*/\n/*====== Border-radius css starts ======*/\n.b-r-0 {\n  border-radius: 0px !important;\n}\n\n.b-r-1 {\n  border-radius: 1px !important;\n}\n\n.b-r-2 {\n  border-radius: 2px !important;\n}\n\n.b-r-3 {\n  border-radius: 3px !important;\n}\n\n.b-r-4 {\n  border-radius: 4px !important;\n}\n\n.b-r-5 {\n  border-radius: 5px !important;\n}\n\n.b-r-6 {\n  border-radius: 6px !important;\n}\n\n.b-r-7 {\n  border-radius: 7px !important;\n}\n\n.b-r-8 {\n  border-radius: 8px !important;\n}\n\n.b-r-9 {\n  border-radius: 9px !important;\n}\n\n.b-r-10 {\n  border-radius: 10px !important;\n}\n\n/*====== Border-radius css ends ======*/\n/*====== Font-size css starts ======*/\n.f-12 {\n  font-size: 12px;\n}\n\n.f-14 {\n  font-size: 14px;\n}\n\n.f-16 {\n  font-size: 16px;\n}\n\n.f-18 {\n  font-size: 18px;\n}\n\n.f-20 {\n  font-size: 20px;\n}\n\n.f-22 {\n  font-size: 22px;\n}\n\n.f-24 {\n  font-size: 24px;\n}\n\n.f-26 {\n  font-size: 26px;\n}\n\n.f-28 {\n  font-size: 28px;\n}\n\n.f-30 {\n  font-size: 30px;\n}\n\n.f-32 {\n  font-size: 32px;\n}\n\n.f-34 {\n  font-size: 34px;\n}\n\n.f-36 {\n  font-size: 36px;\n}\n\n.f-38 {\n  font-size: 38px;\n}\n\n.f-40 {\n  font-size: 40px;\n}\n\n.f-42 {\n  font-size: 42px;\n}\n\n.f-44 {\n  font-size: 44px;\n}\n\n.f-46 {\n  font-size: 46px;\n}\n\n.f-48 {\n  font-size: 48px;\n}\n\n.f-50 {\n  font-size: 50px;\n}\n\n.f-52 {\n  font-size: 52px;\n}\n\n.f-54 {\n  font-size: 54px;\n}\n\n.f-56 {\n  font-size: 56px;\n}\n\n.f-58 {\n  font-size: 58px;\n}\n\n.f-60 {\n  font-size: 60px;\n}\n\n.f-62 {\n  font-size: 62px;\n}\n\n.f-64 {\n  font-size: 64px;\n}\n\n.f-66 {\n  font-size: 66px;\n}\n\n.f-68 {\n  font-size: 68px;\n}\n\n.f-70 {\n  font-size: 70px;\n}\n\n.f-72 {\n  font-size: 72px;\n}\n\n.f-74 {\n  font-size: 74px;\n}\n\n.f-76 {\n  font-size: 76px;\n}\n\n.f-78 {\n  font-size: 78px;\n}\n\n.f-80 {\n  font-size: 80px;\n}\n\n.f-82 {\n  font-size: 82px;\n}\n\n.f-84 {\n  font-size: 84px;\n}\n\n.f-86 {\n  font-size: 86px;\n}\n\n.f-88 {\n  font-size: 88px;\n}\n\n.f-90 {\n  font-size: 90px;\n}\n\n.f-92 {\n  font-size: 92px;\n}\n\n.f-94 {\n  font-size: 94px;\n}\n\n.f-96 {\n  font-size: 96px;\n}\n\n.f-98 {\n  font-size: 98px;\n}\n\n.f-100 {\n  font-size: 100px;\n}\n\n/*====== Font-size css ends ======*/\n/*====== Font-weight css starts ======*/\n.f-w-100 {\n  font-weight: 100;\n}\n\n.f-w-300 {\n  font-weight: 300;\n}\n\n.f-w-400 {\n  font-weight: 400;\n}\n\n.f-w-600 {\n  font-weight: 600;\n}\n\n.f-w-700 {\n  font-weight: 700;\n}\n\n.f-w-900 {\n  font-weight: 900;\n}\n\n/*====== Font-weight css ends ======*/\n/*====== Font-style css starts ======*/\n.f-s-normal {\n  font-style: normal;\n}\n\n.f-s-italic {\n  font-style: italic;\n}\n\n.f-s-oblique {\n  font-style: oblique;\n}\n\n.f-s-initial {\n  font-style: initial;\n}\n\n.f-s-inherit {\n  font-style: inherit;\n}\n\n/*====== Font-style css ends ======*/\n/*====== Text-Decoration css starts ======*/\n.text-overline {\n  text-decoration: overline;\n}\n\n.text-line-through {\n  text-decoration: line-through;\n}\n\n.text-underline {\n  text-decoration: underline;\n}\n\n.text-dashed {\n  text-decoration: dashed;\n}\n\n.text-blink {\n  text-decoration: blink;\n}\n\n.text-dotted {\n  text-decoration: dotted;\n}\n\n.text-initial {\n  text-decoration: initial;\n}\n\n.text-none {\n  text-decoration: none;\n}\n\n.text-solid {\n  text-decoration: solid;\n}\n\n.text-wavy {\n  text-decoration: wavy;\n}\n\n.text-inherit {\n  text-decoration: inherit;\n}\n\n.text-double {\n  text-decoration: double;\n}\n\n/*====== Text-Decoration css ends ======*/\n/*====== Vertical-Align css starts ======*/\n.baseline {\n  vertical-align: baseline;\n}\n\n.sub {\n  vertical-align: sub;\n}\n\n.super {\n  vertical-align: super;\n}\n\n.top {\n  vertical-align: top;\n}\n\n.text-top {\n  vertical-align: text-top;\n}\n\n.middle {\n  vertical-align: middle;\n}\n\n.bottom {\n  vertical-align: bottom;\n}\n\n.text-bottom {\n  vertical-align: text-bottom;\n}\n\n.initial {\n  vertical-align: initial;\n}\n\n.inherit {\n  vertical-align: inherit;\n}\n\n/*====== Vertical-Align css ends ======*/\n/*====== Position css starts ======*/\n.p-static {\n  position: static;\n}\n\n.p-absolute {\n  position: absolute;\n}\n\n.p-fixed {\n  position: fixed;\n}\n\n.p-relative {\n  position: relative;\n}\n\n.p-initial {\n  position: initial;\n}\n\n.p-inherit {\n  position: inherit;\n}\n\n/*====== Position css ends ======*/\n/*====== Float css starts ======*/\n.f-left {\n  float: left;\n}\n\n.f-right {\n  float: right;\n}\n\n.f-none {\n  float: none;\n}\n\n/*====== Float css ends ======*/\n/*====== Overflow css starts ======*/\n.o-hidden {\n  overflow: hidden;\n}\n\n.o-visible {\n  overflow: visible;\n}\n\n.o-auto {\n  overflow: auto;\n}\n\n/*====== Overflow css ends ======*/\n/*====== Image-sizes css starts ======*/\n.img-10 {\n  width: 10px !important;\n}\n\n.img-20 {\n  width: 20px !important;\n}\n\n.img-30 {\n  width: 30px !important;\n}\n\n.img-40 {\n  width: 40px !important;\n}\n\n.img-50 {\n  width: 50px !important;\n}\n\n.img-60 {\n  width: 60px !important;\n}\n\n.img-70 {\n  width: 70px !important;\n}\n\n.img-80 {\n  width: 80px !important;\n}\n\n.img-90 {\n  width: 90px !important;\n}\n\n.img-100 {\n  width: 100px !important;\n}\n\n/*====== Image-sizes css ends ======*/\n/*======= Text css starts ===========*/\n.font-primary {\n  color: #12571a !important;\n}\n\n.font-secondary {\n  color: #13c9ca !important;\n}\n\n.font-success {\n  color: #81ba00 !important;\n}\n\n.font-danger {\n  color: #a5a5a5 !important;\n}\n\n.font-info {\n  color: #00a8ff !important;\n}\n\n.font-light {\n  color: #f8f8f9 !important;\n}\n\n.font-dark {\n  color: #2a3142 !important;\n}\n\n.font-warning {\n  color: #ffbc58 !important;\n}\n\n/*======= Text css ends ===========*/\n/*======= Label-color css starts  ======= */\n.label {\n  border-radius: 2px;\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 1;\n  margin-bottom: 0;\n  text-transform: capitalize;\n}\n\n/*======= Label-color css ends  ======= */\n/*======= Badge-color css starts  ======= */\n.badge-primary {\n  background-color: #12571a;\n}\n\n.badge-secondary {\n  background-color: #13c9ca;\n}\n\n.badge-success {\n  background-color: #81ba00;\n}\n\n.badge-danger {\n  background-color: #a5a5a5;\n}\n\n.badge-info {\n  background-color: #00a8ff;\n}\n\n.badge-light {\n  background-color: #f8f8f9;\n}\n\n.badge-dark {\n  background-color: #2a3142;\n}\n\n.badge-warning {\n  background-color: #ffbc58;\n}\n\n/*======= Badge-color css end  ======= */\n/*======= Background-color css starts  ======= */\n.bg-primary {\n  background-color: #12571a !important;\n  color: #ffffff;\n}\n\n.bg-secondary {\n  background-color: #13c9ca !important;\n  color: #ffffff;\n}\n\n.bg-success {\n  background-color: #81ba00 !important;\n  color: #ffffff;\n}\n\n.bg-danger {\n  background-color: #a5a5a5 !important;\n  color: #ffffff;\n}\n\n.bg-info {\n  background-color: #00a8ff !important;\n  color: #ffffff;\n}\n\n.bg-light {\n  background-color: #f8f8f9 !important;\n  color: #ffffff;\n}\n\n.bg-dark {\n  background-color: #2a3142 !important;\n  color: #ffffff;\n}\n\n.bg-warning {\n  background-color: #ffbc58 !important;\n  color: #ffffff;\n}\n\n/*======= Background-color css end  ======= */\n/*======= Font-color css starts  ======= */\n/*======= Font-color css end  ======= */\n/*======= Button-color css starts  ======= */\n.btn-primary {\n  background-color: #12571a !important;\n  border-color: #12571a !important;\n}\n.btn-primary.disabled {\n  background-color: #12571a !important;\n  border-color: #12571a !important;\n}\n.btn-primary:disabled {\n  background-color: #12571a !important;\n  border-color: #12571a !important;\n}\n.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active {\n  background-color: #092d0d !important;\n  border-color: #092d0d !important;\n}\n.btn-primary:focus {\n  box-shadow: 0 0 0 0.2rem #2ed441;\n}\n\n.btn-secondary {\n  background-color: #13c9ca !important;\n  border-color: #13c9ca !important;\n}\n.btn-secondary.disabled {\n  background-color: #13c9ca !important;\n  border-color: #13c9ca !important;\n}\n.btn-secondary:disabled {\n  background-color: #13c9ca !important;\n  border-color: #13c9ca !important;\n}\n.btn-secondary:hover, .btn-secondary:focus, .btn-secondary:active, .btn-secondary.active {\n  background-color: #0f9b9b !important;\n  border-color: #0f9b9b !important;\n}\n.btn-secondary:focus {\n  box-shadow: 0 0 0 0.2rem #83f3f3;\n}\n\n.btn-success {\n  background-color: #81ba00 !important;\n  border-color: #81ba00 !important;\n}\n.btn-success.disabled {\n  background-color: #81ba00 !important;\n  border-color: #81ba00 !important;\n}\n.btn-success:disabled {\n  background-color: #81ba00 !important;\n  border-color: #81ba00 !important;\n}\n.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active {\n  background-color: #5e8700 !important;\n  border-color: #5e8700 !important;\n}\n.btn-success:focus {\n  box-shadow: 0 0 0 0.2rem #cbff54;\n}\n\n.btn-danger {\n  background-color: #a5a5a5 !important;\n  border-color: #a5a5a5 !important;\n}\n.btn-danger.disabled {\n  background-color: #a5a5a5 !important;\n  border-color: #a5a5a5 !important;\n}\n.btn-danger:disabled {\n  background-color: #a5a5a5 !important;\n  border-color: #a5a5a5 !important;\n}\n.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active {\n  background-color: #8c8c8c !important;\n  border-color: #8c8c8c !important;\n}\n.btn-danger:focus {\n  box-shadow: 0 0 0 0.2rem #f2f2f2;\n}\n\n.btn-info {\n  background-color: #00a8ff !important;\n  border-color: #00a8ff !important;\n}\n.btn-info.disabled {\n  background-color: #00a8ff !important;\n  border-color: #00a8ff !important;\n}\n.btn-info:disabled {\n  background-color: #00a8ff !important;\n  border-color: #00a8ff !important;\n}\n.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active {\n  background-color: #0086cc !important;\n  border-color: #0086cc !important;\n}\n.btn-info:focus {\n  box-shadow: 0 0 0 0.2rem #99dcff;\n}\n\n.btn-light {\n  background-color: #f8f8f9 !important;\n  border-color: #f8f8f9 !important;\n}\n.btn-light.disabled {\n  background-color: #f8f8f9 !important;\n  border-color: #f8f8f9 !important;\n}\n.btn-light:disabled {\n  background-color: #f8f8f9 !important;\n  border-color: #f8f8f9 !important;\n}\n.btn-light:hover, .btn-light:focus, .btn-light:active, .btn-light.active {\n  background-color: #dddde1 !important;\n  border-color: #dddde1 !important;\n}\n.btn-light:focus {\n  box-shadow: 0 0 0 0.2rem white;\n}\n\n.btn-dark {\n  background-color: #2a3142 !important;\n  border-color: #2a3142 !important;\n}\n.btn-dark.disabled {\n  background-color: #2a3142 !important;\n  border-color: #2a3142 !important;\n}\n.btn-dark:disabled {\n  background-color: #2a3142 !important;\n  border-color: #2a3142 !important;\n}\n.btn-dark:hover, .btn-dark:focus, .btn-dark:active, .btn-dark.active {\n  background-color: #161a23 !important;\n  border-color: #161a23 !important;\n}\n.btn-dark:focus {\n  box-shadow: 0 0 0 0.2rem #67779e;\n}\n\n.btn-warning {\n  background-color: #ffbc58 !important;\n  border-color: #ffbc58 !important;\n}\n.btn-warning.disabled {\n  background-color: #ffbc58 !important;\n  border-color: #ffbc58 !important;\n}\n.btn-warning:disabled {\n  background-color: #ffbc58 !important;\n  border-color: #ffbc58 !important;\n}\n.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active {\n  background-color: #ffa825 !important;\n  border-color: #ffa825 !important;\n}\n.btn-warning:focus {\n  box-shadow: 0 0 0 0.2rem #fff9f1;\n}\n\n/*======= Button-color css ends  ======= */\n.btn-primary:not([disabled]):not(.disabled).active {\n  background-color: #092d0d;\n  border-color: #092d0d;\n  box-shadow: none !important;\n}\n.btn-primary:not([disabled]):not(.disabled).active:hover, .btn-primary:not([disabled]):not(.disabled).active:focus, .btn-primary:not([disabled]):not(.disabled).active:active, .btn-primary:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #092d0d;\n  border-color: #092d0d;\n}\n\n.btn-secondary:not([disabled]):not(.disabled).active {\n  background-color: #0f9b9b;\n  border-color: #0f9b9b;\n  box-shadow: none !important;\n}\n.btn-secondary:not([disabled]):not(.disabled).active:hover, .btn-secondary:not([disabled]):not(.disabled).active:focus, .btn-secondary:not([disabled]):not(.disabled).active:active, .btn-secondary:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #0f9b9b;\n  border-color: #0f9b9b;\n}\n\n.btn-success:not([disabled]):not(.disabled).active {\n  background-color: #5e8700;\n  border-color: #5e8700;\n  box-shadow: none !important;\n}\n.btn-success:not([disabled]):not(.disabled).active:hover, .btn-success:not([disabled]):not(.disabled).active:focus, .btn-success:not([disabled]):not(.disabled).active:active, .btn-success:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #5e8700;\n  border-color: #5e8700;\n}\n\n.btn-danger:not([disabled]):not(.disabled).active {\n  background-color: #8c8c8c;\n  border-color: #8c8c8c;\n  box-shadow: none !important;\n}\n.btn-danger:not([disabled]):not(.disabled).active:hover, .btn-danger:not([disabled]):not(.disabled).active:focus, .btn-danger:not([disabled]):not(.disabled).active:active, .btn-danger:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #8c8c8c;\n  border-color: #8c8c8c;\n}\n\n.btn-info:not([disabled]):not(.disabled).active {\n  background-color: #0086cc;\n  border-color: #0086cc;\n  box-shadow: none !important;\n}\n.btn-info:not([disabled]):not(.disabled).active:hover, .btn-info:not([disabled]):not(.disabled).active:focus, .btn-info:not([disabled]):not(.disabled).active:active, .btn-info:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #0086cc;\n  border-color: #0086cc;\n}\n\n.btn-light:not([disabled]):not(.disabled).active {\n  background-color: #dddde1;\n  border-color: #dddde1;\n  box-shadow: none !important;\n}\n.btn-light:not([disabled]):not(.disabled).active:hover, .btn-light:not([disabled]):not(.disabled).active:focus, .btn-light:not([disabled]):not(.disabled).active:active, .btn-light:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #dddde1;\n  border-color: #dddde1;\n}\n\n.btn-dark:not([disabled]):not(.disabled).active {\n  background-color: #161a23;\n  border-color: #161a23;\n  box-shadow: none !important;\n}\n.btn-dark:not([disabled]):not(.disabled).active:hover, .btn-dark:not([disabled]):not(.disabled).active:focus, .btn-dark:not([disabled]):not(.disabled).active:active, .btn-dark:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #161a23;\n  border-color: #161a23;\n}\n\n.btn-warning:not([disabled]):not(.disabled).active {\n  background-color: #ffa825;\n  border-color: #ffa825;\n  box-shadow: none !important;\n}\n.btn-warning:not([disabled]):not(.disabled).active:hover, .btn-warning:not([disabled]):not(.disabled).active:focus, .btn-warning:not([disabled]):not(.disabled).active:active, .btn-warning:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #ffa825;\n  border-color: #ffa825;\n}\n\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active {\n  background-color: #12571a;\n  border-color: #12571a;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-primary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-primary-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #092d0d !important;\n  border-color: #092d0d !important;\n}\n\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active {\n  background-color: #13c9ca;\n  border-color: #13c9ca;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active:active, .btn-outline-secondary-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #0f9b9b !important;\n  border-color: #0f9b9b !important;\n}\n\n.btn-outline-success-2x:not([disabled]):not(.disabled).active {\n  background-color: #81ba00;\n  border-color: #81ba00;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-success-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-success-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-success-2x:not([disabled]):not(.disabled).active:active, .btn-outline-success-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #5e8700 !important;\n  border-color: #5e8700 !important;\n}\n\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active {\n  background-color: #a5a5a5;\n  border-color: #a5a5a5;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-danger-2x:not([disabled]):not(.disabled).active:active, .btn-outline-danger-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #8c8c8c !important;\n  border-color: #8c8c8c !important;\n}\n\n.btn-outline-info-2x:not([disabled]):not(.disabled).active {\n  background-color: #00a8ff;\n  border-color: #00a8ff;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-info-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-info-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-info-2x:not([disabled]):not(.disabled).active:active, .btn-outline-info-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #0086cc !important;\n  border-color: #0086cc !important;\n}\n\n.btn-outline-light-2x:not([disabled]):not(.disabled).active {\n  background-color: #f8f8f9;\n  border-color: #f8f8f9;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-light-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-light-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-light-2x:not([disabled]):not(.disabled).active:active, .btn-outline-light-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #dddde1 !important;\n  border-color: #dddde1 !important;\n}\n\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active {\n  background-color: #2a3142;\n  border-color: #2a3142;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-dark-2x:not([disabled]):not(.disabled).active:active, .btn-outline-dark-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #161a23 !important;\n  border-color: #161a23 !important;\n}\n\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active {\n  background-color: #ffbc58;\n  border-color: #ffbc58;\n  box-shadow: none !important;\n  color: white;\n}\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active:hover, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:focus, .btn-outline-warning-2x:not([disabled]):not(.disabled).active:active, .btn-outline-warning-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  box-shadow: none !important;\n  background-color: #ffa825 !important;\n  border-color: #ffa825 !important;\n}\n\n/*======= Table-Border-Bottom-color css starts  ======= */\ntable thead .border-bottom-primary th,\ntable tbody .border-bottom-primary th,\ntable tbody .border-bottom-primary td {\n  border-bottom: 1px solid #12571a;\n}\n\ntable thead .border-bottom-secondary th,\ntable tbody .border-bottom-secondary th,\ntable tbody .border-bottom-secondary td {\n  border-bottom: 1px solid #13c9ca;\n}\n\ntable thead .border-bottom-success th,\ntable tbody .border-bottom-success th,\ntable tbody .border-bottom-success td {\n  border-bottom: 1px solid #81ba00;\n}\n\ntable thead .border-bottom-danger th,\ntable tbody .border-bottom-danger th,\ntable tbody .border-bottom-danger td {\n  border-bottom: 1px solid #a5a5a5;\n}\n\ntable thead .border-bottom-info th,\ntable tbody .border-bottom-info th,\ntable tbody .border-bottom-info td {\n  border-bottom: 1px solid #00a8ff;\n}\n\ntable thead .border-bottom-light th,\ntable tbody .border-bottom-light th,\ntable tbody .border-bottom-light td {\n  border-bottom: 1px solid #f8f8f9;\n}\n\ntable thead .border-bottom-dark th,\ntable tbody .border-bottom-dark th,\ntable tbody .border-bottom-dark td {\n  border-bottom: 1px solid #2a3142;\n}\n\ntable thead .border-bottom-warning th,\ntable tbody .border-bottom-warning th,\ntable tbody .border-bottom-warning td {\n  border-bottom: 1px solid #ffbc58;\n}\n\n/*======= Table-Border-Bottom-color css ends  ======= */\n/*======= Table styling css starts  ======= */\n.table-styling .table-primary,\n.table-styling.table-primary {\n  background-color: #12571a;\n  color: #ffffff;\n  border: 3px solid #12571a;\n}\n.table-styling .table-primary thead,\n.table-styling.table-primary thead {\n  background-color: #092d0d;\n  border: 3px solid #092d0d;\n}\n\n.table-styling .table-secondary,\n.table-styling.table-secondary {\n  background-color: #13c9ca;\n  color: #ffffff;\n  border: 3px solid #13c9ca;\n}\n.table-styling .table-secondary thead,\n.table-styling.table-secondary thead {\n  background-color: #0f9b9b;\n  border: 3px solid #0f9b9b;\n}\n\n.table-styling .table-success,\n.table-styling.table-success {\n  background-color: #81ba00;\n  color: #ffffff;\n  border: 3px solid #81ba00;\n}\n.table-styling .table-success thead,\n.table-styling.table-success thead {\n  background-color: #5e8700;\n  border: 3px solid #5e8700;\n}\n\n.table-styling .table-danger,\n.table-styling.table-danger {\n  background-color: #a5a5a5;\n  color: #ffffff;\n  border: 3px solid #a5a5a5;\n}\n.table-styling .table-danger thead,\n.table-styling.table-danger thead {\n  background-color: #8c8c8c;\n  border: 3px solid #8c8c8c;\n}\n\n.table-styling .table-info,\n.table-styling.table-info {\n  background-color: #00a8ff;\n  color: #ffffff;\n  border: 3px solid #00a8ff;\n}\n.table-styling .table-info thead,\n.table-styling.table-info thead {\n  background-color: #0086cc;\n  border: 3px solid #0086cc;\n}\n\n.table-styling .table-light,\n.table-styling.table-light {\n  background-color: #f8f8f9;\n  color: #ffffff;\n  border: 3px solid #f8f8f9;\n}\n.table-styling .table-light thead,\n.table-styling.table-light thead {\n  background-color: #dddde1;\n  border: 3px solid #dddde1;\n}\n\n.table-styling .table-dark,\n.table-styling.table-dark {\n  background-color: #2a3142;\n  color: #ffffff;\n  border: 3px solid #2a3142;\n}\n.table-styling .table-dark thead,\n.table-styling.table-dark thead {\n  background-color: #161a23;\n  border: 3px solid #161a23;\n}\n\n.table-styling .table-warning,\n.table-styling.table-warning {\n  background-color: #ffbc58;\n  color: #ffffff;\n  border: 3px solid #ffbc58;\n}\n.table-styling .table-warning thead,\n.table-styling.table-warning thead {\n  background-color: #ffa825;\n  border: 3px solid #ffa825;\n}\n\n/*======= Table styling css ends  ======= */\n/*======= All-Borders-color css starts  ======= */\n.b-primary {\n  border: 1px solid #12571a !important;\n}\n\n.b-t-primary {\n  border-top: 1px solid #12571a !important;\n}\n\n.b-b-primary {\n  border-bottom: 1px solid #12571a !important;\n}\n\n.b-l-primary {\n  border-left: 1px solid #12571a !important;\n}\n\n.b-r-primary {\n  border-right: 1px solid #12571a !important;\n}\n\n.b-secondary {\n  border: 1px solid #13c9ca !important;\n}\n\n.b-t-secondary {\n  border-top: 1px solid #13c9ca !important;\n}\n\n.b-b-secondary {\n  border-bottom: 1px solid #13c9ca !important;\n}\n\n.b-l-secondary {\n  border-left: 1px solid #13c9ca !important;\n}\n\n.b-r-secondary {\n  border-right: 1px solid #13c9ca !important;\n}\n\n.b-success {\n  border: 1px solid #81ba00 !important;\n}\n\n.b-t-success {\n  border-top: 1px solid #81ba00 !important;\n}\n\n.b-b-success {\n  border-bottom: 1px solid #81ba00 !important;\n}\n\n.b-l-success {\n  border-left: 1px solid #81ba00 !important;\n}\n\n.b-r-success {\n  border-right: 1px solid #81ba00 !important;\n}\n\n.b-danger {\n  border: 1px solid #a5a5a5 !important;\n}\n\n.b-t-danger {\n  border-top: 1px solid #a5a5a5 !important;\n}\n\n.b-b-danger {\n  border-bottom: 1px solid #a5a5a5 !important;\n}\n\n.b-l-danger {\n  border-left: 1px solid #a5a5a5 !important;\n}\n\n.b-r-danger {\n  border-right: 1px solid #a5a5a5 !important;\n}\n\n.b-info {\n  border: 1px solid #00a8ff !important;\n}\n\n.b-t-info {\n  border-top: 1px solid #00a8ff !important;\n}\n\n.b-b-info {\n  border-bottom: 1px solid #00a8ff !important;\n}\n\n.b-l-info {\n  border-left: 1px solid #00a8ff !important;\n}\n\n.b-r-info {\n  border-right: 1px solid #00a8ff !important;\n}\n\n.b-light {\n  border: 1px solid #f8f8f9 !important;\n}\n\n.b-t-light {\n  border-top: 1px solid #f8f8f9 !important;\n}\n\n.b-b-light {\n  border-bottom: 1px solid #f8f8f9 !important;\n}\n\n.b-l-light {\n  border-left: 1px solid #f8f8f9 !important;\n}\n\n.b-r-light {\n  border-right: 1px solid #f8f8f9 !important;\n}\n\n.b-dark {\n  border: 1px solid #2a3142 !important;\n}\n\n.b-t-dark {\n  border-top: 1px solid #2a3142 !important;\n}\n\n.b-b-dark {\n  border-bottom: 1px solid #2a3142 !important;\n}\n\n.b-l-dark {\n  border-left: 1px solid #2a3142 !important;\n}\n\n.b-r-dark {\n  border-right: 1px solid #2a3142 !important;\n}\n\n.b-warning {\n  border: 1px solid #ffbc58 !important;\n}\n\n.b-t-warning {\n  border-top: 1px solid #ffbc58 !important;\n}\n\n.b-b-warning {\n  border-bottom: 1px solid #ffbc58 !important;\n}\n\n.b-l-warning {\n  border-left: 1px solid #ffbc58 !important;\n}\n\n.b-r-warning {\n  border-right: 1px solid #ffbc58 !important;\n}\n\n/*======= All-Borders-color css ends  ======= */\n/*====== Border width css starts ======*/\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-6 {\n  border-width: 6px !important;\n}\n\n.border-7 {\n  border-width: 7px !important;\n}\n\n.border-8 {\n  border-width: 8px !important;\n}\n\n.border-9 {\n  border-width: 9px !important;\n}\n\n.border-10 {\n  border-width: 10px !important;\n}\n\n/*====== Border width css ends ======*/\n.opacity-0 {\n  opacity: 0;\n}\n\n.shadow-0 {\n  box-shadow: none;\n}\n\n/**====== custom scrollbar css start ======**/\n.digits {\n  font-family: work-Sans, sans-serif;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px #e8ebf2;\n}\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(18, 87, 26, 0.17);\n}\n\n/**====== Custom scrollbar css end ======**/\n/**====== Animation css Start ======**/\n.line pre {\n  font-size: 100%;\n}\n\n/**====== Animation css end ======**/\n/**=====================\n      Generic CSS Ends\n==========================**/\n/**=====================\n     Chat CSS Start\n==========================**/\n.chat-box .toogle-bar {\n  display: none;\n}\n.chat-box .people-list .search {\n  position: relative;\n}\n.chat-box .people-list .search .form-control {\n  background-color: #f1f4fb;\n  border: 1px solid #f8f8f9;\n}\n.chat-box .people-list .search .form-control::placeholder {\n  color: #aaaaaa;\n}\n.chat-box .people-list .search i {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 14px;\n  color: #e8ebf2;\n}\n.chat-box .people-list ul {\n  padding: 0;\n}\n.chat-box .people-list ul li {\n  padding-bottom: 20px;\n}\n.chat-box .people-list ul li:last-child {\n  padding-bottom: 0;\n}\n.chat-box .user-image {\n  float: left;\n  width: 52px;\n  height: 52px;\n  margin-right: 5px;\n}\n.chat-box .about {\n  float: left;\n  margin-top: 5px;\n  padding-left: 10px;\n}\n.chat-box .about .name {\n  color: #2a3142;\n  letter-spacing: 1px;\n  font-weight: 600;\n}\n.chat-box .status {\n  color: #aaaaaa;\n  letter-spacing: 1px;\n  font-size: 12px;\n  margin-top: 5px;\n}\n.chat-box .status .chat-status {\n  font-weight: 600;\n  color: #313131;\n}\n.chat-box .status p {\n  font-size: 14px;\n}\n\n.status-circle {\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  border-radius: 50%;\n  border: 2px solid #ffffff;\n}\n\n.away {\n  background-color: #ffbc58;\n}\n\n.online {\n  background-color: #81ba00;\n}\n\n.offline {\n  background-color: #a5a5a5;\n}\n\n/**=====================\n      Chat CSS Ends\n==========================**/\n.market-chart {\n  height: 303px;\n}\n\n.needs-validation .form-select {\n  background: white;\n}\n.needs-validation .form-control {\n  border-radius: 0.25rem;\n  padding: 0.48rem 0.75rem;\n}\n\n.license-key[disabled] {\n  cursor: not-allowed;\n}\n\n.checkbox label {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.checkbox .form-check-input {\n  margin-top: 13px;\n  margin-bottom: 10px;\n}\n\n.form-row .form-control {\n  font-size: 14px;\n  letter-spacing: 1px;\n}\n.form-row .form-select {\n  font-size: 14px;\n  letter-spacing: 1px;\n}\n\n/*=====================\n    Responsive CSS start\n==========================*/\n@media only screen and (max-width: 1780px) and (min-width: 1661px) {\n  .add-product-form .qty-box {\n    width: 20%;\n  }\n  .products-table table tr td:first-child {\n    min-width: 255px;\n  }\n}\n@media only screen and (max-width: 1660px) {\n  .translation-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+1) {\n    width: 200px;\n  }\n  .product-list .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2),\n  .category-table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2),\n  .order-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(n+2) {\n    width: 170px;\n  }\n  .add-product-form .qty-box {\n    width: 20%;\n  }\n  .products-table table tr td:first-child {\n    min-width: 268px;\n  }\n}\n@media screen and (max-width: 1440px) and (min-width: 1366px) {\n  .flot-chart-container {\n    height: 350px;\n  }\n  .product-adding .col-xl-5 {\n    flex: 0 0 36%;\n    max-width: 36%;\n  }\n  .product-adding .col-xl-7 {\n    flex: 0 0 64%;\n    max-width: 64%;\n  }\n}\n@media only screen and (max-width: 1366px) {\n  .transactions .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell + .rdt_TableCell {\n    width: 150px;\n  }\n  .product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {\n    width: 150px;\n  }\n  .report-employee h2, .report-employee .h2 {\n    font-size: 32px;\n  }\n  .add-product-form .qty-box {\n    width: 24%;\n  }\n  .slick-slide img {\n    margin: 0 auto;\n  }\n  .page-main-header .main-header-right .nav-right > ul > li:first-child {\n    width: 32%;\n  }\n  .product-adding .add-product-form {\n    margin-top: 30px;\n  }\n  .user-list table tr td:nth-child(5),\n  .user-list table tr th:nth-child(5) {\n    width: 195px !important;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  .product-page-details {\n    margin-top: 30px;\n  }\n  .user-list table tr th,\n  .user-list table tr td {\n    width: 200px !important;\n  }\n}\n@media screen and (max-device-width: 1366px) and (min-device-width: 1200px) {\n  .xl-100 {\n    max-width: 100%;\n    flex: 0 0 100%;\n  }\n  .xl-50 {\n    max-width: 50%;\n    flex: 0 0 50%;\n  }\n  .product-adding .col-xl-5,\n  .product-adding .col-xl-7 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .product-adding .add-product-form {\n    margin-top: 30px;\n  }\n  .user-list table tr td:first-child,\n  .user-list table tr th:first-child {\n    width: 130px !important;\n  }\n  .profile-table table tr th,\n  .profile-table table tr td {\n    width: 200px !important;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .page-wrapper .page-main-header .main-header-right .main-header-left {\n    padding: 0;\n  }\n  .authentication-box {\n    padding: 30px;\n  }\n  .authentication-box .container .bg-primary {\n    padding: 40px;\n  }\n  .btn-popup {\n    margin-bottom: 20px;\n  }\n  .order-graph .order-graph-bottom {\n    margin-top: 20px;\n  }\n  .card .card-body,\n  .card .card-header {\n    padding: 20px;\n  }\n  .page-wrapper .page-main-header.open {\n    z-index: 11;\n  }\n  .right-sidebar {\n    top: 127px;\n  }\n  .page-wrapper .page-body-wrapper .page-header .row h3, .page-wrapper .page-body-wrapper .page-header .row .h3 {\n    font-size: 22px;\n  }\n  .page-wrapper .page-body-wrapper .page-header .row .pull-right {\n    float: none;\n    margin-top: 5px;\n  }\n  .page-wrapper .page-body-wrapper .page-sidebar {\n    top: 60px !important;\n    height: calc(100vh - 60px) !important;\n  }\n  .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body {\n    margin-left: 0;\n    margin-top: 60px;\n  }\n  .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body .page-header .row .page-header-left {\n    display: inherit;\n  }\n  .page-wrapper .page-body-wrapper .sidebar {\n    height: calc(100vh - 60px);\n  }\n  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body {\n    margin-top: 60px;\n  }\n  .page-wrapper .page-body-wrapper footer {\n    margin-left: 0;\n  }\n  .page-wrapper .page-main-header {\n    height: 60px;\n    margin-left: 0;\n    width: 100%;\n    z-index: 11;\n  }\n  .page-wrapper .page-main-header .main-header-left .logo-wrapper img {\n    height: 23px;\n    margin-top: 0;\n    margin-right: 15px;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right {\n    position: unset;\n    padding: 0;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul {\n    top: 60px;\n    position: absolute;\n    z-index: -1;\n    background-color: #fff;\n    -webkit-transition: all linear 0.3s;\n    transition: all linear 0.3s;\n    -webkit-box-shadow: 0 2px 2px 2px #efefef;\n    box-shadow: 0 2px 2px 2px #efefef;\n    width: 100%;\n    left: 0;\n    padding: 0 40px;\n    -webkit-transform: translateY(-35px) scaleY(0);\n    transform: translateY(-35px) scaleY(0);\n    opacity: 0;\n    visibility: hidden;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li {\n    margin: 10px 0;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > .mobile-toggle {\n    cursor: pointer;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > .mobile-toggle svg circle {\n    color: #12571a;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul.open {\n    z-index: 1;\n    opacity: 1;\n    -webkit-transform: translateY(0px) scaleY(1);\n    transform: translateY(0px) scaleY(1);\n    visibility: visible;\n  }\n  .page-header {\n    padding-top: 25px !important;\n    padding-bottom: 25px !important;\n  }\n  .page-header .row .page-header-left .breadcrumb {\n    margin-top: 5px;\n    margin-left: 0;\n  }\n  .product-page-details {\n    text-align: left !important;\n  }\n  .add-product .bigImg img {\n    width: 460px;\n  }\n  .product-adding .add-product-form {\n    margin-top: 20px;\n  }\n  .tab-coupon {\n    margin-bottom: 20px;\n  }\n  .deactivate-account {\n    margin-top: 20px;\n  }\n  .sell-graph canvas {\n    height: 312px !important;\n  }\n  .needs-validation h4, .needs-validation .h4 {\n    font-size: 16px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .react-tabs .react-datepicker-wrapper .react-datepicker__input-container {\n    margin-left: 0;\n  }\n  .checkbox-space {\n    padding: 0 15px;\n  }\n  .react-datepicker__input-container {\n    margin-left: 15px;\n  }\n  .authentication-box .form-footer,\n  .authentication-box .form-button {\n    text-align: center;\n  }\n  .authentication-box .form-footer > span,\n  .authentication-box .form-button > span {\n    padding: 0;\n    left: 0;\n    right: 0;\n  }\n  .page-main-header .main-header-right .nav-right > ul > li:first-child {\n    width: 40%;\n  }\n  .products-table table tr td:first-child,\n  .products-table table tr th:first-child {\n    min-width: 280px;\n  }\n  .products-table table tr td:nth-child(3),\n  .products-table table tr th:nth-child(3) {\n    min-width: 110px;\n  }\n  .page-wrapper .page-body-wrapper .page-header .row .col {\n    flex-basis: unset;\n  }\n  .page-wrapper .page-body-wrapper .page-header .row .col .pull-right {\n    float: none;\n    margin-top: 20px;\n  }\n  .page-wrapper .page-body-wrapper footer .row div {\n    text-align: center;\n  }\n  .page-wrapper .page-body-wrapper footer .row div .pull-right {\n    float: none;\n  }\n  .footer-fix .pull-right {\n    float: none !important;\n    text-align: center !important;\n  }\n  .add-product-form .form-group .form-control,\n  .add-product-form .form-group select {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n  .add-product-form .input-group .touchspin {\n    width: 30% !important;\n  }\n  .add-product-form .radio-animated label {\n    margin-bottom: 0;\n  }\n  .add-product-form .editor-space {\n    padding: 0 15px;\n  }\n  .add-product-form textarea {\n    margin: 0 15px;\n  }\n  .add-product-form .qty-box {\n    width: 29%;\n  }\n  .add-product .bigImg img {\n    width: 400px;\n  }\n  .digital-add textarea {\n    margin: 0 !important;\n  }\n  .digital-add .form-group select,\n  .digital-add .form-group .form-control {\n    width: 100% !important;\n  }\n  .digital-add .form-group label {\n    margin-bottom: 0 !important;\n  }\n  .needs-validation .form-group.row {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .needs-validation .form-group .form-control,\n  .needs-validation .form-group select {\n    width: 100%;\n    margin: 0 auto;\n  }\n  .needs-validation .form-group .checkbox {\n    padding-left: 15px;\n  }\n  .needs-validation .form-group label {\n    margin-bottom: 4px;\n  }\n  .needs-validation .radio-animated label {\n    margin-bottom: 0;\n  }\n  .needs-validation .editor-space {\n    padding: 0 15px;\n  }\n  .needs-validation textarea {\n    margin: 0 15px;\n  }\n}\n@media only screen and (max-width: 577px) {\n  footer {\n    margin-bottom: 0 !important;\n  }\n}\n@media only screen and (max-width: 575px) {\n  .react-tabs .needs-validation .row > div[class*=col-] {\n    padding: 0 12px !important;\n  }\n  .authentication-box .btn-primary {\n    margin-top: 10px;\n  }\n  .sales-chart {\n    height: 200px;\n  }\n  .report-last-sm canvas {\n    height: 200px !important;\n  }\n  .dropzone .dzu-input {\n    width: 90%;\n  }\n  .product-right .timer span {\n    width: 55px;\n  }\n  .market-chart {\n    height: 205px;\n  }\n  .ct-4.flot-chart-container {\n    height: 240px;\n  }\n  .sell-graph canvas {\n    height: 250px !important;\n  }\n  .btn-popup {\n    margin-bottom: 15px;\n  }\n  .static-top-widget div.align-self-center svg {\n    width: 20px;\n    height: 20px;\n  }\n  .latest-order-table table tr td {\n    min-width: 100px;\n  }\n  .latest-order-table table tr td + td {\n    min-width: 150px;\n  }\n  .latest-order-table table tr td:nth-child(3) {\n    min-width: 200px;\n  }\n  .card {\n    margin-bottom: 15px;\n  }\n  .card .card-header {\n    padding: 15px;\n  }\n  .card .card-header h5, .card .card-header .h5 {\n    font-size: 17px;\n  }\n  .card .card-body {\n    padding: 15px;\n  }\n  .sm-order-space,\n  .xl-space {\n    margin-top: 15px;\n  }\n  .order-graph .order-graph-bottom {\n    margin-top: 15px;\n  }\n  .order-graph .order-graph-bottom h6, .order-graph .order-graph-bottom .h6 {\n    margin-right: 0;\n  }\n  .order-graph .order-graph-bottom .media {\n    margin-bottom: 15px;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .d-sm-none:after {\n    display: none;\n  }\n  ul.notification-dropdown.onhover-show-div {\n    width: 284px;\n    right: -112px;\n  }\n  ul.notification-dropdown.onhover-show-div:before, ul.notification-dropdown.onhover-show-div:after {\n    right: 135px !important;\n  }\n  .page-wrapper .page-main-header .main-header-right {\n    padding: 0 15px;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul {\n    padding: 0 0;\n    justify-content: flex-start;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li:first-child {\n    width: auto;\n    margin: 0;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:before {\n    display: none;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:after {\n    display: none;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-group {\n    margin-bottom: 0;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-control-plaintext.open {\n    -webkit-transform: translateY(0px) scaleY(1);\n    transform: translateY(0px) scaleY(1);\n    opacity: 1;\n    visibility: visible;\n    -webkit-transition: all linear 0.3s;\n    transition: all linear 0.3s;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-control-plaintext {\n    top: 60px;\n    position: absolute;\n    -webkit-transition: all linear 0.3s;\n    transition: all linear 0.3s;\n    left: 0;\n    background-color: #fff;\n    -webkit-transform: translateY(-35px) scaleY(0);\n    transform: translateY(-35px) scaleY(0);\n    opacity: 0;\n    visibility: hidden;\n    width: 180px;\n    padding: 10px 10px 10px 15px;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .mobile-search svg {\n    color: #12571a;\n  }\n  .page-wrapper .search-form .form-group {\n    margin-right: 0;\n  }\n  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body .activity .media .gradient-round.gradient-line-1:after {\n    bottom: -41px;\n  }\n  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body .activity .media .gradient-round.small-line:after {\n    bottom: -19px;\n    height: 12px;\n  }\n  .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body .activity .media .gradient-round.medium-line:after {\n    bottom: -34px;\n  }\n  .page-wrapper .page-body-wrapper .page-body {\n    padding: 0;\n  }\n  .page-wrapper .page-body-wrapper .page-header {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .profile-details img {\n    margin-bottom: 15px;\n  }\n  .project-status {\n    margin-top: 15px;\n  }\n  .project-status .media {\n    margin-top: 15px;\n  }\n  .profile-card ul {\n    display: inherit;\n    margin-bottom: 15px;\n  }\n  .profile-card ul li {\n    display: block;\n    text-align: center;\n  }\n  .profile-table table tbody tr td:first-child {\n    min-width: 150px;\n  }\n  .account-setting h5, .account-setting .h5 {\n    margin-bottom: 15px;\n  }\n  .deactivate-account {\n    margin-top: 15px;\n  }\n  .deactivate-account .btn {\n    margin-top: 15px;\n  }\n  .sm-label-radio {\n    margin-bottom: 4px !important;\n  }\n  .permission-block .attribute-blocks .form-group {\n    padding-bottom: 15px;\n  }\n  .needs-validation textarea {\n    margin: 0 10px;\n  }\n  .needs-validation h4, .needs-validation .h4 {\n    margin-bottom: 15px;\n  }\n  .needs-validation .permission-block .attribute-blocks .row {\n    padding-left: 15px;\n  }\n  .needs-validation .permission-block .attribute-blocks + .attribute-blocks h5, .needs-validation .permission-block .attribute-blocks + .attribute-blocks .h5 {\n    margin-top: 20px;\n  }\n  .needs-validation .radio_animated {\n    margin: 0 10px 0 0;\n  }\n  .needs-validation .radio-animated label {\n    margin-right: 15px;\n  }\n  .tab-coupon {\n    display: grid;\n    text-align: center;\n  }\n  .add-product-form .form-group .form-control {\n    width: 93%;\n    margin: 0 auto;\n  }\n  .add-product-form .form-group .col-xl-8 {\n    padding: 0;\n  }\n  .add-product-form .form-group fieldset {\n    padding-left: 0;\n  }\n  .add-product-form .form-group label {\n    padding: 0;\n  }\n  .add-product-form .qty-box {\n    width: 162px;\n  }\n  .add-product-form .qty-box .input-group .form-control {\n    width: 80px;\n  }\n  .add-product-form .description-sm {\n    padding: 0 !important;\n  }\n  .add-product ul li .box-input-file {\n    width: 15px;\n    height: 15px;\n  }\n  .add-product ul li .box-input-file img {\n    width: 40px !important;\n    height: 40px !important;\n  }\n  .file-upload-product {\n    margin-top: 11px;\n  }\n  .file-upload-product li {\n    margin-bottom: 34px !important;\n  }\n}\n@media only screen and (max-width: 360px) {\n  .product-right .timer {\n    padding: 15px 0 15px 30px;\n  }\n  .page-main-header .main-header-right .nav-right .profile-dropdown {\n    right: 6px;\n  }\n  .authentication-box {\n    padding: 30px 15px;\n  }\n  .authentication-box .forgot-pass {\n    float: none;\n    padding-top: 10px;\n  }\n  .authentication-box .container .form-group {\n    margin-bottom: 1rem;\n  }\n  .authentication-box .container h3, .authentication-box .container .h3 {\n    font-size: 20px;\n  }\n  .authentication-box .container p {\n    line-height: 1.6;\n  }\n  .authentication-box .container .bg-primary {\n    padding: 30px 15px;\n  }\n  .authentication-box .container .svg-icon {\n    padding: 17px;\n    height: 90px;\n    width: 90px;\n    margin-bottom: 25px;\n  }\n  .authentication-box .container .svg-icon svg {\n    height: 50px;\n  }\n  .nav-menus .notification-badge {\n    right: 0;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li {\n    padding: 0 13px;\n  }\n  .page-wrapper .page-main-header .main-header-right .nav-right > ul > li .dot {\n    right: 13px;\n  }\n  .footer {\n    padding-left: 0;\n    padding-right: 0 !important;\n  }\n  .footer p {\n    font-size: 12px;\n  }\n  .add-product .bigImg img {\n    width: 300px;\n  }\n  .product-page-main .btn {\n    padding: 5px 12px;\n  }\n}\n@media only screen and (max-height: 800px) {\n  .right-sidebar .chat-box .friend-list {\n    max-height: calc(100vh - 150px);\n    overflow: scroll;\n  }\n}\n/*=====================\n  Responsive CSS End\n==========================*/\n.custom-theme {\n  position: fixed;\n  right: 0;\n  width: 40px;\n  height: 38px;\n  display: flex;\n  z-index: 1;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  text-decoration: none;\n  border-radius: 5px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  background-color: #f7f7f7;\n  box-shadow: 0px 0px 5px 0px rgba(154, 154, 154, 0.54);\n  top: calc(50% + 34px);\n  cursor: pointer;\n}\n\n/**=====================\n    RTL CSS Start\n==========================**/\nbody.rtl {\n  direction: rtl;\n}\nbody.rtl .m-r-15 {\n  margin-left: 15px;\n  margin-right: unset;\n}\nbody.rtl .me-2,\nbody.rtl .mx-2 {\n  margin-left: 0.5rem !important;\n  margin-right: unset !important;\n}\nbody.rtl .form-select {\n  padding: 0.375rem 0.75rem 0.375rem 1.75rem;\n}\nbody.rtl .ps-0,\nbody.rtl .px-0 {\n  padding-right: 0 !important;\n  padding-left: unset !important;\n}\nbody.rtl .me-sm-2 {\n  margin-right: unset;\n  margin-left: 0.5rem !important;\n}\nbody.rtl .m-r-10 {\n  margin-left: 10px;\n  margin-right: unset;\n}\nbody.rtl .radio_animated,\nbody.rtl .checkbox_animated {\n  margin: 0 8px 0 1rem;\n}\nbody.rtl .btn-light {\n  margin-left: unset;\n  margin-right: 7px;\n}\nbody.rtl .onhover-show-div {\n  left: unset;\n  right: 0;\n}\nbody.rtl .page-wrapper .page-body-wrapper footer.footer.open {\n  margin-right: 0;\n  margin-left: unset;\n}\nbody.rtl .page-wrapper .page-main-header .main-header-left .logo-wrapper img {\n  margin-left: 15px;\n  margin-right: unset;\n}\nbody.rtl .rdt_Pagination > div {\n  direction: ltr;\n}\nbody.rtl .digital-add .form-group .radio_animated {\n  margin-left: 8px;\n  margin-right: unset;\n}\nbody.rtl .dropzone .dzu-input {\n  margin-right: 15px;\n  margin-left: unset;\n}\nbody.rtl .product-right .timer {\n  padding: 15px 40px 15px 0;\n}\nbody.rtl .product-right .timer span .padding-l {\n  padding-left: unset;\n  padding-right: 22px;\n}\nbody.rtl .breadcrumb-item + .breadcrumb-item {\n  padding-right: 0.5rem;\n  padding-left: unset;\n}\nbody.rtl .breadcrumb-item + .breadcrumb-item::before {\n  float: right;\n  padding-left: 0.5rem;\n  padding-right: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li {\n  border-left: unset;\n  border-right: 1px solid #eff0f1;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:hover .language-dropdown.onhover-show-div::before {\n  right: 10px !important;\n  left: unset !important;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:hover .language-dropdown.onhover-show-div::after {\n  right: 10px !important;\n  left: unset !important;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:nth-child(5) {\n  border-right: unset;\n  border-left: 1px solid #eff0f1;\n  padding-left: 20px;\n  padding-right: 0;\n}\nbody.rtl .page-main-header .main-header-right .nav-right .profile-dropdown {\n  right: unset;\n  left: -10px;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a i::before {\n  content: \"\\f104\";\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .main-header-left .logo-wrapper {\n  padding-left: unset;\n  padding-right: 10px;\n}\nbody.rtl .authentication-box .back-btn {\n  float: left;\n}\nbody.rtl .authentication-box .form-footer > span {\n  padding-right: unset;\n  padding-left: 20px;\n}\nbody.rtl .authentication-box .form-horizontal .form-terms .custom-control {\n  padding-left: unset;\n  padding-right: 24px;\n}\nbody.rtl .authentication-box .tab2-card .nav-tabs .nav-link svg {\n  margin-left: 5px;\n  margin-right: unset;\n}\nbody.rtl .needs-validation .form-group {\n  text-align: right;\n}\nbody.rtl .needs-validation .form-group .checkbox {\n  padding-right: 0;\n  padding-left: unset;\n}\nbody.rtl .needs-validation .permission-block .attribute-blocks {\n  padding-right: 15px;\n  padding-left: unset;\n  text-align: right;\n}\nbody.rtl .needs-validation .permission-block .attribute-blocks .row {\n  padding-right: 20px;\n  padding-left: unset;\n}\nbody.rtl .needs-validation .checkbox {\n  right: 0;\n  margin-left: -16px;\n}\nbody.rtl .needs-validation .checkbox label {\n  padding-right: 16px;\n  padding-left: unset;\n}\nbody.rtl .needs-validation .checkbox label::before {\n  right: 0;\n  left: unset;\n  margin-left: unset;\n  margin-right: -16px;\n}\nbody.rtl .needs-validation .radio-animated label {\n  margin-left: 20px;\n  margin-right: unset;\n}\nbody.rtl .modal-footer > :not(:last-child) {\n  margin-left: 0.25rem;\n  margin-right: unset;\n}\nbody.rtl .jsgrid-button + .jsgrid-button {\n  margin-right: 5px;\n  margin-left: unset;\n}\nbody.rtl .custom-theme {\n  left: 0;\n  right: unset;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\nbody.rtl .text-end {\n  text-align: left !important;\n}\nbody.rtl .br-wrapper {\n  text-align: right;\n}\nbody.rtl .card .card-header .card-header-right {\n  left: 20px;\n  right: unset;\n}\nbody.rtl .card .card-header .card-header-right .card-option {\n  text-align: left;\n}\nbody.rtl .card .card-header .card-header-right .card-option.list-unstyled {\n  padding-right: 0;\n  padding-left: unset;\n}\nbody.rtl code[class*=language-],\nbody.rtl pre[class*=language-] {\n  text-align: right;\n}\nbody.rtl .code-box-copy__btn {\n  right: unset;\n  left: 11px;\n}\nbody.rtl table thead tr th,\nbody.rtl table thead tr td,\nbody.rtl table tbody tr th,\nbody.rtl table tbody tr td {\n  text-align: right;\n}\nbody.rtl .pull-right {\n  float: left;\n}\nbody.rtl .status-circle {\n  right: 40px;\n  left: unset;\n}\nbody.rtl .right-sidebar.show {\n  left: 0;\n  right: unset;\n}\nbody.rtl .right-sidebar .friend-list-search .fa {\n  left: 35px;\n  right: unset;\n}\nbody.rtl .right-sidebar .chat-box .about {\n  float: right;\n  padding-right: 10px;\n  padding-left: unset;\n  text-align: right;\n}\nbody.rtl .right-sidebar .chat-box .friend-list {\n  text-align: right;\n}\nbody.rtl .right-sidebar .chat-box .user-image {\n  float: right;\n  margin-left: 5px;\n  margin-right: 0;\n}\nbody.rtl .nav-menus .search-form input {\n  padding: 10px 70px 10px 10px;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div li {\n  text-align: right;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6, body.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .h6,\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {\n  text-align: center;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li {\n  text-align: right;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active > .sidebar-submenu {\n  margin-right: 15px;\n  margin-left: unset;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a {\n  padding-right: 10px;\n  padding-left: unset;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu > li > a > .fa-circle {\n  right: 0;\n  left: unset;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header svg {\n  margin-right: unset;\n  margin-left: 14px;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body {\n  margin-right: 255px;\n  margin-left: unset;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar.open {\n  margin-right: -260px;\n  margin-left: unset;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar.open ~ .page-body,\nbody.rtl .page-wrapper .page-body-wrapper .page-sidebar.open ~ footer {\n  margin-right: 0;\n}\nbody.rtl .page-wrapper .page-body-wrapper .page-header .row h3, body.rtl .page-wrapper .page-body-wrapper .page-header .row .h3 {\n  text-align: right;\n}\nbody.rtl .page-wrapper .page-body-wrapper footer {\n  margin-right: 255px;\n  margin-left: unset;\n}\nbody.rtl .page-wrapper .page-body-wrapper footer p i {\n  margin-right: 5px;\n  margin-left: unset;\n}\nbody.rtl .page-main-header {\n  margin-right: 255px;\n  margin-left: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right {\n  text-align: left;\n  padding-right: 0;\n  padding-left: 12px;\n}\nbody.rtl .page-main-header .main-header-right .nav-right .profile-dropdown li svg {\n  margin-right: unset;\n  margin-left: 10px;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li {\n  text-align: right;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:before {\n  right: 0;\n  left: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li .dot {\n  left: 17px;\n  right: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li .media .dotted-animation {\n  left: -3px;\n  right: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li .media .dotted-animation .main-circle {\n  left: 6px;\n  right: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li .media .dotted-animation .animate-circle {\n  left: -4px;\n  right: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:before {\n  left: 10px;\n  right: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li.onhover-dropdown:hover .onhover-show-div:after {\n  left: 10px;\n  right: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li.onhover-dropdown:last-child {\n  padding-left: 0;\n  padding-right: 20px;\n  border-right: none;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:first-child {\n  border-right: none;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:after {\n  right: 22px;\n  left: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:first-child .search-form .form-group:before {\n  right: 51px;\n  left: unset;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li:last-child {\n  padding-right: 20px;\n  padding-left: 0;\n}\nbody.rtl .page-main-header .main-header-right .nav-right > ul > li i.ms-2 {\n  margin-right: 0.5rem !important;\n  margin-left: unset !important;\n}\nbody.rtl .page-main-header .main-header-right .nav-right .language-dropdown {\n  text-align: right;\n}\nbody.rtl .page-main-header .main-header-right .nav-right .language-dropdown li a i {\n  margin-left: 10px;\n}\nbody.rtl .page-main-header .main-header-right .nav-right .profile-dropdown li a svg {\n  margin-right: unset;\n  margin-left: 10px;\n}\nbody.rtl .page-main-header .main-header-right .mobile-sidebar {\n  padding-right: 20px;\n}\nbody.rtl .page-main-header.open {\n  margin-right: 0;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div {\n  right: initial;\n  left: -30px;\n  padding: 0;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div:before {\n  right: inherit !important;\n  left: 35px !important;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div:after {\n  right: inherit !important;\n  left: 35px !important;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div li {\n  margin-right: 0 !important;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div li span.badge {\n  margin-left: unset !important;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div li span svg {\n  margin-right: unset;\n  margin-left: 10px;\n}\nbody.rtl ul.notification-dropdown.onhover-show-div li .notification-icon {\n  margin-left: 20px;\n  margin-right: unset;\n}\nbody.rtl .owl-carousel {\n  direction: ltr;\n}\nbody.rtl .media .media-body {\n  text-align: right;\n}\nbody.rtl .order-graph .order-graph-bottom h6, body.rtl .order-graph .order-graph-bottom .h6 {\n  margin-right: 15px !important;\n  margin-left: 30px;\n}\nbody.rtl .latest-order-table .btn {\n  float: right;\n}\nbody.rtl .product-physical table tr th:nth-child(2),\nbody.rtl .product-physical table tr td:nth-child(2) {\n  text-align: right;\n}\nbody.rtl .product-page-details .color-variant,\nbody.rtl .product-page-details .size-box,\nbody.rtl .product-right .color-variant,\nbody.rtl .product-right .size-box {\n  text-align: right;\n}\nbody.rtl .add-product-form .qty-box .input-group .input-group-append .btn {\n  border-right: none !important;\n  border-left: 1px solid #dddddd !important;\n}\nbody.rtl .add-product-form .qty-box .input-group .btn-primary.bootstrap-touchspin-down {\n  border-left: none !important;\n  border-right: 1px solid #dddddd !important;\n}\nbody.rtl .add-product-form .offset-sm-4 {\n  text-align: right;\n}\nbody.rtl .timer {\n  float: right;\n}\nbody.rtl .timer ~ .m-t-15 {\n  clear: both;\n  text-align: right;\n  padding-top: 15px;\n}\nbody.rtl .timer span .padding-l {\n  right: 35px;\n  left: unset;\n  padding-right: 0;\n}\nbody.rtl .product-list table tr td,\nbody.rtl .product-list table tr th,\nbody.rtl .report-table table tr td,\nbody.rtl .report-table table tr th {\n  text-align: right !important;\n}\nbody.rtl .product-list table tr td:last-child,\nbody.rtl .product-list table tr th:last-child,\nbody.rtl .report-table table tr td:last-child,\nbody.rtl .report-table table tr th:last-child {\n  text-align: center !important;\n}\nbody.rtl .dropzone .dz-preview .dz-error-mark,\nbody.rtl .dropzone .dz-preview .dz-success-mark {\n  left: unset;\n  right: 48%;\n  margin-right: -27px;\n  margin-left: unset;\n}\nbody.rtl .dropzone.dz-clickable .dz-message * {\n  text-align: center;\n}\nbody.rtl .digital-add .col-form-label {\n  display: block;\n  text-align: right;\n}\nbody.rtl .dataTables_wrapper .dataTables_filter input[type=search] {\n  margin-right: 10px;\n  margin-left: unset;\n}\nbody.rtl .dataTables_wrapper table.dataTable .vendor-list img {\n  margin-left: 20px;\n  margin-right: unset;\n}\nbody.rtl .category-table table tr td:nth-child(3),\nbody.rtl .category-table table tr th:nth-child(3) {\n  text-align: right;\n}\nbody.rtl .media-table table tr td:last-child,\nbody.rtl .media-table table tr th:last-child {\n  text-align: right !important;\n}\nbody.rtl .profile-details h5, body.rtl .profile-details .h5 {\n  text-align: center;\n}\nbody.rtl .account-setting {\n  text-align: right;\n}\n@media only screen and (max-width: 991px) {\n  body.rtl .product-page-details {\n    text-align: right !important;\n  }\n  body.rtl .page-wrapper .page-main-header {\n    margin-right: 0;\n  }\n  body.rtl .page-wrapper .page-body-wrapper .page-sidebar ~ .page-body,\n  body.rtl .page-wrapper .page-body-wrapper .page-sidebar ~ footer {\n    margin-right: 0;\n  }\n}\n@media only screen and (max-width: 767px) {\n  body.rtl .needs-validation .form-group .checkbox {\n    padding-right: 15px;\n    padding-left: unset;\n  }\n  body.rtl .page-wrapper .page-body-wrapper footer p {\n    text-align: center;\n  }\n}\n@media only screen and (max-width: 575px) {\n  body.rtl .add-product-form .form-group fieldset {\n    padding-left: 12px;\n    padding-right: 0;\n  }\n  body.rtl .page-wrapper .page-main-header .main-header-right .nav-right > ul .search-form .form-control-plaintext {\n    left: unset;\n    right: 0;\n  }\n  body.rtl ul.notification-dropdown.onhover-show-div {\n    right: unset;\n    left: -112px;\n  }\n  body.rtl ul.notification-dropdown.onhover-show-div::before, body.rtl ul.notification-dropdown.onhover-show-div::after {\n    right: unset !important;\n    left: 135px !important;\n  }\n}\n@media only screen and (max-width: 360px) {\n  body.rtl .page-wrapper .page-main-header .main-header-right .nav-right > ul > li .dot {\n    left: 13px;\n    right: unset;\n  }\n  body.rtl .product-right .timer {\n    padding: 15px 30px 15px 0;\n  }\n}\n@media (min-width: 1200px) {\n  body.rtl .offset-xl-3 {\n    margin-right: 25%;\n    margin-left: unset;\n  }\n}\n\n/**=====================\n    RTL CSS End\n==========================**/\n.flag-icon-background, .flag-icon {\n  background-size: contain;\n  background-position: 50%;\n  background-repeat: no-repeat;\n}\n\n.flag-icon {\n  position: relative;\n  display: inline-block;\n  width: 1.3333333333em;\n  line-height: 1em;\n}\n.flag-icon:before {\n  content: \" \";\n}\n.flag-icon.flag-icon-squared {\n  width: 1em;\n}\n\n.flag-icon-es-ct {\n  background-image: url(../../fonts/flag-icon/es-ct.svg);\n}\n.flag-icon-es-ct.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/es-ct.svg);\n}\n\n.flag-icon-eu {\n  background-image: url(../../fonts/flag-icon/eu.svg);\n}\n.flag-icon-eu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/eu.svg);\n}\n\n.flag-icon-gb-eng {\n  background-image: url(../../fonts/flag-icon/gb-eng.svg);\n}\n.flag-icon-gb-eng.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gb-eng.svg);\n}\n\n.flag-icon-gb-nir {\n  background-image: url(../../fonts/flag-icon/gb-nir.svg);\n}\n.flag-icon-gb-nir.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gb-nir.svg);\n}\n\n.flag-icon-gb-sct {\n  background-image: url(../../fonts/flag-icon/gb-sct.svg);\n}\n.flag-icon-gb-sct.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gb-sct.svg);\n}\n\n.flag-icon-gb-wls {\n  background-image: url(../../fonts/flag-icon/gb-wls.svg);\n}\n.flag-icon-gb-wls.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gb-wls.svg);\n}\n\n.flag-icon-un {\n  background-image: url(../../fonts/flag-icon/un.svg);\n}\n.flag-icon-un.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/un.svg);\n}\n\n.flag-icon-ad {\n  background-image: url(../../fonts/flag-icon/ad.svg);\n}\n.flag-icon-ad.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ad.svg);\n}\n\n.flag-icon-ae {\n  background-image: url(../../fonts/flag-icon/ae.svg);\n}\n.flag-icon-ae.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ae.svg);\n}\n\n.flag-icon-af {\n  background-image: url(../../fonts/flag-icon/af.svg);\n}\n.flag-icon-af.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/af.svg);\n}\n\n.flag-icon-ag {\n  background-image: url(../../fonts/flag-icon/ag.svg);\n}\n.flag-icon-ag.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ag.svg);\n}\n\n.flag-icon-ai {\n  background-image: url(../../fonts/flag-icon/ai.svg);\n}\n.flag-icon-ai.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ai.svg);\n}\n\n.flag-icon-al {\n  background-image: url(../../fonts/flag-icon/al.svg);\n}\n.flag-icon-al.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/al.svg);\n}\n\n.flag-icon-am {\n  background-image: url(../../fonts/flag-icon/am.svg);\n}\n.flag-icon-am.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/am.svg);\n}\n\n.flag-icon-ao {\n  background-image: url(../../fonts/flag-icon/ao.svg);\n}\n.flag-icon-ao.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ao.svg);\n}\n\n.flag-icon-aq {\n  background-image: url(../../fonts/flag-icon/aq.svg);\n}\n.flag-icon-aq.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/aq.svg);\n}\n\n.flag-icon-ar {\n  background-image: url(../../fonts/flag-icon/ar.svg);\n}\n.flag-icon-ar.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ar.svg);\n}\n\n.flag-icon-as {\n  background-image: url(../../fonts/flag-icon/as.svg);\n}\n.flag-icon-as.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/as.svg);\n}\n\n.flag-icon-at {\n  background-image: url(../../fonts/flag-icon/at.svg);\n}\n.flag-icon-at.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/at.svg);\n}\n\n.flag-icon-au {\n  background-image: url(../../fonts/flag-icon/au.svg);\n}\n.flag-icon-au.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/au.svg);\n}\n\n.flag-icon-aw {\n  background-image: url(../../fonts/flag-icon/aw.svg);\n}\n.flag-icon-aw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/aw.svg);\n}\n\n.flag-icon-ax {\n  background-image: url(../../fonts/flag-icon/ax.svg);\n}\n.flag-icon-ax.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ax.svg);\n}\n\n.flag-icon-az {\n  background-image: url(../../fonts/flag-icon/az.svg);\n}\n.flag-icon-az.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/az.svg);\n}\n\n.flag-icon-ba {\n  background-image: url(../../fonts/flag-icon/ba.svg);\n}\n.flag-icon-ba.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ba.svg);\n}\n\n.flag-icon-bb {\n  background-image: url(../../fonts/flag-icon/bb.svg);\n}\n.flag-icon-bb.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bb.svg);\n}\n\n.flag-icon-bd {\n  background-image: url(../../fonts/flag-icon/bd.svg);\n}\n.flag-icon-bd.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bd.svg);\n}\n\n.flag-icon-be {\n  background-image: url(../../fonts/flag-icon/be.svg);\n}\n.flag-icon-be.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/be.svg);\n}\n\n.flag-icon-bf {\n  background-image: url(../../fonts/flag-icon/bf.svg);\n}\n.flag-icon-bf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bf.svg);\n}\n\n.flag-icon-bg {\n  background-image: url(../../fonts/flag-icon/bg.svg);\n}\n.flag-icon-bg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bg.svg);\n}\n\n.flag-icon-bh {\n  background-image: url(../../fonts/flag-icon/bh.svg);\n}\n.flag-icon-bh.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bh.svg);\n}\n\n.flag-icon-bi {\n  background-image: url(../../fonts/flag-icon/bi.svg);\n}\n.flag-icon-bi.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bi.svg);\n}\n\n.flag-icon-bj {\n  background-image: url(../../fonts/flag-icon/bj.svg);\n}\n.flag-icon-bj.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bj.svg);\n}\n\n.flag-icon-bl {\n  background-image: url(../../fonts/flag-icon/bl.svg);\n}\n.flag-icon-bl.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bl.svg);\n}\n\n.flag-icon-bm {\n  background-image: url(../../fonts/flag-icon/bm.svg);\n}\n.flag-icon-bm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bm.svg);\n}\n\n.flag-icon-bn {\n  background-image: url(../../fonts/flag-icon/bn.svg);\n}\n.flag-icon-bn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bn.svg);\n}\n\n.flag-icon-bo {\n  background-image: url(../../fonts/flag-icon/bo.svg);\n}\n.flag-icon-bo.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bo.svg);\n}\n\n.flag-icon-bq {\n  background-image: url(../../fonts/flag-icon/bq.svg);\n}\n.flag-icon-bq.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bq.svg);\n}\n\n.flag-icon-br {\n  background-image: url(../../fonts/flag-icon/br.svg);\n}\n.flag-icon-br.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/br.svg);\n}\n\n.flag-icon-bs {\n  background-image: url(../../fonts/flag-icon/bs.svg);\n}\n.flag-icon-bs.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bs.svg);\n}\n\n.flag-icon-bt {\n  background-image: url(../../fonts/flag-icon/bt.svg);\n}\n.flag-icon-bt.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bt.svg);\n}\n\n.flag-icon-bv {\n  background-image: url(../../fonts/flag-icon/bv.svg);\n}\n.flag-icon-bv.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bv.svg);\n}\n\n.flag-icon-bw {\n  background-image: url(../../fonts/flag-icon/bw.svg);\n}\n.flag-icon-bw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bw.svg);\n}\n\n.flag-icon-by {\n  background-image: url(../../fonts/flag-icon/by.svg);\n}\n.flag-icon-by.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/by.svg);\n}\n\n.flag-icon-bz {\n  background-image: url(../../fonts/flag-icon/bz.svg);\n}\n.flag-icon-bz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/bz.svg);\n}\n\n.flag-icon-ca {\n  background-image: url(../../fonts/flag-icon/ca.svg);\n}\n.flag-icon-ca.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ca.svg);\n}\n\n.flag-icon-cc {\n  background-image: url(../../fonts/flag-icon/cc.svg);\n}\n.flag-icon-cc.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cc.svg);\n}\n\n.flag-icon-cd {\n  background-image: url(../../fonts/flag-icon/cd.svg);\n}\n.flag-icon-cd.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cd.svg);\n}\n\n.flag-icon-cf {\n  background-image: url(../../fonts/flag-icon/cf.svg);\n}\n.flag-icon-cf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cf.svg);\n}\n\n.flag-icon-cg {\n  background-image: url(../../fonts/flag-icon/cg.svg);\n}\n.flag-icon-cg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cg.svg);\n}\n\n.flag-icon-ch {\n  background-image: url(../../fonts/flag-icon/ch.svg);\n}\n.flag-icon-ch.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ch.svg);\n}\n\n.flag-icon-ci {\n  background-image: url(../../fonts/flag-icon/ci.svg);\n}\n.flag-icon-ci.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ci.svg);\n}\n\n.flag-icon-ck {\n  background-image: url(../../fonts/flag-icon/ck.svg);\n}\n.flag-icon-ck.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ck.svg);\n}\n\n.flag-icon-cl {\n  background-image: url(../../fonts/flag-icon/cl.svg);\n}\n.flag-icon-cl.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cl.svg);\n}\n\n.flag-icon-cm {\n  background-image: url(../../fonts/flag-icon/cm.svg);\n}\n.flag-icon-cm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cm.svg);\n}\n\n.flag-icon-cn {\n  background-image: url(../../fonts/flag-icon/cn.svg);\n}\n.flag-icon-cn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cn.svg);\n}\n\n.flag-icon-co {\n  background-image: url(../../fonts/flag-icon/co.svg);\n}\n.flag-icon-co.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/co.svg);\n}\n\n.flag-icon-cr {\n  background-image: url(../../fonts/flag-icon/cr.svg);\n}\n.flag-icon-cr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cr.svg);\n}\n\n.flag-icon-cu {\n  background-image: url(../../fonts/flag-icon/cu.svg);\n}\n.flag-icon-cu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cu.svg);\n}\n\n.flag-icon-cv {\n  background-image: url(../../fonts/flag-icon/cv.svg);\n}\n.flag-icon-cv.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cv.svg);\n}\n\n.flag-icon-cw {\n  background-image: url(../../fonts/flag-icon/cw.svg);\n}\n.flag-icon-cw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cw.svg);\n}\n\n.flag-icon-cx {\n  background-image: url(../../fonts/flag-icon/cx.svg);\n}\n.flag-icon-cx.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cx.svg);\n}\n\n.flag-icon-cy {\n  background-image: url(../../fonts/flag-icon/cy.svg);\n}\n.flag-icon-cy.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cy.svg);\n}\n\n.flag-icon-cz {\n  background-image: url(../../fonts/flag-icon/cz.svg);\n}\n.flag-icon-cz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/cz.svg);\n}\n\n.flag-icon-de {\n  background-image: url(../../fonts/flag-icon/de.svg);\n}\n.flag-icon-de.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/de.svg);\n}\n\n.flag-icon-dj {\n  background-image: url(../../fonts/flag-icon/dj.svg);\n}\n.flag-icon-dj.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/dj.svg);\n}\n\n.flag-icon-dk {\n  background-image: url(../../fonts/flag-icon/dk.svg);\n}\n.flag-icon-dk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/dk.svg);\n}\n\n.flag-icon-dm {\n  background-image: url(../../fonts/flag-icon/dm.svg);\n}\n.flag-icon-dm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/dm.svg);\n}\n\n.flag-icon-do {\n  background-image: url(../../fonts/flag-icon/do.svg);\n}\n.flag-icon-do.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/do.svg);\n}\n\n.flag-icon-dz {\n  background-image: url(../../fonts/flag-icon/dz.svg);\n}\n.flag-icon-dz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/dz.svg);\n}\n\n.flag-icon-ec {\n  background-image: url(../../fonts/flag-icon/ec.svg);\n}\n.flag-icon-ec.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ec.svg);\n}\n\n.flag-icon-ee {\n  background-image: url(../../fonts/flag-icon/ee.svg);\n}\n.flag-icon-ee.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ee.svg);\n}\n\n.flag-icon-eg {\n  background-image: url(../../fonts/flag-icon/eg.svg);\n}\n.flag-icon-eg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/eg.svg);\n}\n\n.flag-icon-eh {\n  background-image: url(../../fonts/flag-icon/eh.svg);\n}\n.flag-icon-eh.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/eh.svg);\n}\n\n.flag-icon-er {\n  background-image: url(../../fonts/flag-icon/er.svg);\n}\n.flag-icon-er.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/er.svg);\n}\n\n.flag-icon-es {\n  background-image: url(../../fonts/flag-icon/es.svg);\n}\n.flag-icon-es.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/es.svg);\n}\n\n.flag-icon-et {\n  background-image: url(../../fonts/flag-icon/et.svg);\n}\n.flag-icon-et.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/et.svg);\n}\n\n.flag-icon-fi {\n  background-image: url(../../fonts/flag-icon/fi.svg);\n}\n.flag-icon-fi.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/fi.svg);\n}\n\n.flag-icon-fj {\n  background-image: url(../../fonts/flag-icon/fj.svg);\n}\n.flag-icon-fj.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/fj.svg);\n}\n\n.flag-icon-fk {\n  background-image: url(../../fonts/flag-icon/fk.svg);\n}\n.flag-icon-fk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/fk.svg);\n}\n\n.flag-icon-fm {\n  background-image: url(../../fonts/flag-icon/fm.svg);\n}\n.flag-icon-fm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/fm.svg);\n}\n\n.flag-icon-fo {\n  background-image: url(../../fonts/flag-icon/fo.svg);\n}\n.flag-icon-fo.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/fo.svg);\n}\n\n.flag-icon-fr {\n  background-image: url(../../fonts/flag-icon/fr.svg);\n}\n.flag-icon-fr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/fr.svg);\n}\n\n.flag-icon-ga {\n  background-image: url(../../fonts/flag-icon/ga.svg);\n}\n.flag-icon-ga.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ga.svg);\n}\n\n.flag-icon-gb {\n  background-image: url(../../fonts/flag-icon/gb.svg);\n}\n.flag-icon-gb.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gb.svg);\n}\n\n.flag-icon-gd {\n  background-image: url(../../fonts/flag-icon/gd.svg);\n}\n.flag-icon-gd.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gd.svg);\n}\n\n.flag-icon-ge {\n  background-image: url(../../fonts/flag-icon/ge.svg);\n}\n.flag-icon-ge.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ge.svg);\n}\n\n.flag-icon-gf {\n  background-image: url(../../fonts/flag-icon/gf.svg);\n}\n.flag-icon-gf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gf.svg);\n}\n\n.flag-icon-gg {\n  background-image: url(../../fonts/flag-icon/gg.svg);\n}\n.flag-icon-gg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gg.svg);\n}\n\n.flag-icon-gh {\n  background-image: url(../../fonts/flag-icon/gh.svg);\n}\n.flag-icon-gh.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gh.svg);\n}\n\n.flag-icon-gi {\n  background-image: url(../../fonts/flag-icon/gi.svg);\n}\n.flag-icon-gi.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gi.svg);\n}\n\n.flag-icon-gl {\n  background-image: url(../../fonts/flag-icon/gl.svg);\n}\n.flag-icon-gl.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gl.svg);\n}\n\n.flag-icon-gm {\n  background-image: url(../../fonts/flag-icon/gm.svg);\n}\n.flag-icon-gm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gm.svg);\n}\n\n.flag-icon-gn {\n  background-image: url(../../fonts/flag-icon/gn.svg);\n}\n.flag-icon-gn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gn.svg);\n}\n\n.flag-icon-gp {\n  background-image: url(../../fonts/flag-icon/gp.svg);\n}\n.flag-icon-gp.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gp.svg);\n}\n\n.flag-icon-gq {\n  background-image: url(../../fonts/flag-icon/gq.svg);\n}\n.flag-icon-gq.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gq.svg);\n}\n\n.flag-icon-gr {\n  background-image: url(../../fonts/flag-icon/gr.svg);\n}\n.flag-icon-gr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gr.svg);\n}\n\n.flag-icon-gs {\n  background-image: url(../../fonts/flag-icon/gs.svg);\n}\n.flag-icon-gs.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gs.svg);\n}\n\n.flag-icon-gt {\n  background-image: url(../../fonts/flag-icon/gt.svg);\n}\n.flag-icon-gt.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gt.svg);\n}\n\n.flag-icon-gu {\n  background-image: url(../../fonts/flag-icon/gu.svg);\n}\n.flag-icon-gu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gu.svg);\n}\n\n.flag-icon-gw {\n  background-image: url(../../fonts/flag-icon/gw.svg);\n}\n.flag-icon-gw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gw.svg);\n}\n\n.flag-icon-gy {\n  background-image: url(../../fonts/flag-icon/gy.svg);\n}\n.flag-icon-gy.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/gy.svg);\n}\n\n.flag-icon-hk {\n  background-image: url(../../fonts/flag-icon/hk.svg);\n}\n.flag-icon-hk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/hk.svg);\n}\n\n.flag-icon-hm {\n  background-image: url(../../fonts/flag-icon/hm.svg);\n}\n.flag-icon-hm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/hm.svg);\n}\n\n.flag-icon-hn {\n  background-image: url(../../fonts/flag-icon/hn.svg);\n}\n.flag-icon-hn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/hn.svg);\n}\n\n.flag-icon-hr {\n  background-image: url(../../fonts/flag-icon/hr.svg);\n}\n.flag-icon-hr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/hr.svg);\n}\n\n.flag-icon-ht {\n  background-image: url(../../fonts/flag-icon/ht.svg);\n}\n.flag-icon-ht.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ht.svg);\n}\n\n.flag-icon-hu {\n  background-image: url(../../fonts/flag-icon/hu.svg);\n}\n.flag-icon-hu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/hu.svg);\n}\n\n.flag-icon-id {\n  background-image: url(../../fonts/flag-icon/id.svg);\n}\n.flag-icon-id.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/id.svg);\n}\n\n.flag-icon-ie {\n  background-image: url(../../fonts/flag-icon/ie.svg);\n}\n.flag-icon-ie.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ie.svg);\n}\n\n.flag-icon-il {\n  background-image: url(../../fonts/flag-icon/il.svg);\n}\n.flag-icon-il.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/il.svg);\n}\n\n.flag-icon-im {\n  background-image: url(../../fonts/flag-icon/im.svg);\n}\n.flag-icon-im.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/im.svg);\n}\n\n.flag-icon-in {\n  background-image: url(../../fonts/flag-icon/in.svg);\n}\n.flag-icon-in.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/in.svg);\n}\n\n.flag-icon-io {\n  background-image: url(../../fonts/flag-icon/io.svg);\n}\n.flag-icon-io.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/io.svg);\n}\n\n.flag-icon-iq {\n  background-image: url(../../fonts/flag-icon/iq.svg);\n}\n.flag-icon-iq.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/iq.svg);\n}\n\n.flag-icon-ir {\n  background-image: url(../../fonts/flag-icon/ir.svg);\n}\n.flag-icon-ir.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ir.svg);\n}\n\n.flag-icon-is {\n  background-image: url(../../fonts/flag-icon/is.svg);\n}\n.flag-icon-is.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/is.svg);\n}\n\n.flag-icon-it {\n  background-image: url(../../fonts/flag-icon/it.svg);\n}\n.flag-icon-it.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/it.svg);\n}\n\n.flag-icon-je {\n  background-image: url(../../fonts/flag-icon/je.svg);\n}\n.flag-icon-je.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/je.svg);\n}\n\n.flag-icon-jm {\n  background-image: url(../../fonts/flag-icon/jm.svg);\n}\n.flag-icon-jm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/jm.svg);\n}\n\n.flag-icon-jo {\n  background-image: url(../../fonts/flag-icon/jo.svg);\n}\n.flag-icon-jo.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/jo.svg);\n}\n\n.flag-icon-jp {\n  background-image: url(../../fonts/flag-icon/jp.svg);\n}\n.flag-icon-jp.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/jp.svg);\n}\n\n.flag-icon-ke {\n  background-image: url(../../fonts/flag-icon/ke.svg);\n}\n.flag-icon-ke.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ke.svg);\n}\n\n.flag-icon-kg {\n  background-image: url(../../fonts/flag-icon/kg.svg);\n}\n.flag-icon-kg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/kg.svg);\n}\n\n.flag-icon-kh {\n  background-image: url(../../fonts/flag-icon/kh.svg);\n}\n.flag-icon-kh.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/kh.svg);\n}\n\n.flag-icon-ki {\n  background-image: url(../../fonts/flag-icon/ki.svg);\n}\n.flag-icon-ki.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ki.svg);\n}\n\n.flag-icon-km {\n  background-image: url(../../fonts/flag-icon/km.svg);\n}\n.flag-icon-km.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/km.svg);\n}\n\n.flag-icon-kn {\n  background-image: url(../../fonts/flag-icon/kn.svg);\n}\n.flag-icon-kn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/kn.svg);\n}\n\n.flag-icon-kp {\n  background-image: url(../../fonts/flag-icon/kp.svg);\n}\n.flag-icon-kp.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/kp.svg);\n}\n\n.flag-icon-kr {\n  background-image: url(../../fonts/flag-icon/kr.svg);\n}\n.flag-icon-kr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/kr.svg);\n}\n\n.flag-icon-kw {\n  background-image: url(../../fonts/flag-icon/kw.svg);\n}\n.flag-icon-kw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/kw.svg);\n}\n\n.flag-icon-ky {\n  background-image: url(../../fonts/flag-icon/ky.svg);\n}\n.flag-icon-ky.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ky.svg);\n}\n\n.flag-icon-kz {\n  background-image: url(../../fonts/flag-icon/kz.svg);\n}\n.flag-icon-kz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/kz.svg);\n}\n\n.flag-icon-la {\n  background-image: url(../../fonts/flag-icon/la.svg);\n}\n.flag-icon-la.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/la.svg);\n}\n\n.flag-icon-lb {\n  background-image: url(../../fonts/flag-icon/lb.svg);\n}\n.flag-icon-lb.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/lb.svg);\n}\n\n.flag-icon-lc {\n  background-image: url(../../fonts/flag-icon/lc.svg);\n}\n.flag-icon-lc.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/lc.svg);\n}\n\n.flag-icon-li {\n  background-image: url(../../fonts/flag-icon/li.svg);\n}\n.flag-icon-li.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/li.svg);\n}\n\n.flag-icon-lk {\n  background-image: url(../../fonts/flag-icon/lk.svg);\n}\n.flag-icon-lk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/lk.svg);\n}\n\n.flag-icon-lr {\n  background-image: url(../../fonts/flag-icon/lr.svg);\n}\n.flag-icon-lr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/lr.svg);\n}\n\n.flag-icon-ls {\n  background-image: url(../../fonts/flag-icon/ls.svg);\n}\n.flag-icon-ls.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ls.svg);\n}\n\n.flag-icon-lt {\n  background-image: url(../../fonts/flag-icon/lt.svg);\n}\n.flag-icon-lt.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/lt.svg);\n}\n\n.flag-icon-lu {\n  background-image: url(../../fonts/flag-icon/lu.svg);\n}\n.flag-icon-lu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/lu.svg);\n}\n\n.flag-icon-lv {\n  background-image: url(../../fonts/flag-icon/lv.svg);\n}\n.flag-icon-lv.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/lv.svg);\n}\n\n.flag-icon-ly {\n  background-image: url(../../fonts/flag-icon/ly.svg);\n}\n.flag-icon-ly.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ly.svg);\n}\n\n.flag-icon-ma {\n  background-image: url(../../fonts/flag-icon/ma.svg);\n}\n.flag-icon-ma.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ma.svg);\n}\n\n.flag-icon-mc {\n  background-image: url(../../fonts/flag-icon/mc.svg);\n}\n.flag-icon-mc.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mc.svg);\n}\n\n.flag-icon-md {\n  background-image: url(../../fonts/flag-icon/md.svg);\n}\n.flag-icon-md.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/md.svg);\n}\n\n.flag-icon-me {\n  background-image: url(../../fonts/flag-icon/me.svg);\n}\n.flag-icon-me.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/me.svg);\n}\n\n.flag-icon-mf {\n  background-image: url(../../fonts/flag-icon/mf.svg);\n}\n.flag-icon-mf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mf.svg);\n}\n\n.flag-icon-mg {\n  background-image: url(../../fonts/flag-icon/mg.svg);\n}\n.flag-icon-mg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mg.svg);\n}\n\n.flag-icon-mh {\n  background-image: url(../../fonts/flag-icon/mh.svg);\n}\n.flag-icon-mh.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mh.svg);\n}\n\n.flag-icon-mk {\n  background-image: url(../../fonts/flag-icon/mk.svg);\n}\n.flag-icon-mk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mk.svg);\n}\n\n.flag-icon-ml {\n  background-image: url(../../fonts/flag-icon/ml.svg);\n}\n.flag-icon-ml.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ml.svg);\n}\n\n.flag-icon-mm {\n  background-image: url(../../fonts/flag-icon/mm.svg);\n}\n.flag-icon-mm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mm.svg);\n}\n\n.flag-icon-mn {\n  background-image: url(../../fonts/flag-icon/mn.svg);\n}\n.flag-icon-mn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mn.svg);\n}\n\n.flag-icon-mo {\n  background-image: url(../../fonts/flag-icon/mo.svg);\n}\n.flag-icon-mo.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mo.svg);\n}\n\n.flag-icon-mp {\n  background-image: url(../../fonts/flag-icon/mp.svg);\n}\n.flag-icon-mp.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mp.svg);\n}\n\n.flag-icon-mq {\n  background-image: url(../../fonts/flag-icon/mq.svg);\n}\n.flag-icon-mq.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mq.svg);\n}\n\n.flag-icon-mr {\n  background-image: url(../../fonts/flag-icon/mr.svg);\n}\n.flag-icon-mr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mr.svg);\n}\n\n.flag-icon-ms {\n  background-image: url(../../fonts/flag-icon/ms.svg);\n}\n.flag-icon-ms.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ms.svg);\n}\n\n.flag-icon-mt {\n  background-image: url(../../fonts/flag-icon/mt.svg);\n}\n.flag-icon-mt.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mt.svg);\n}\n\n.flag-icon-mu {\n  background-image: url(../../fonts/flag-icon/mu.svg);\n}\n.flag-icon-mu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mu.svg);\n}\n\n.flag-icon-mv {\n  background-image: url(../../fonts/flag-icon/mv.svg);\n}\n.flag-icon-mv.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mv.svg);\n}\n\n.flag-icon-mw {\n  background-image: url(../../fonts/flag-icon/mw.svg);\n}\n.flag-icon-mw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mw.svg);\n}\n\n.flag-icon-mx {\n  background-image: url(../../fonts/flag-icon/mx.svg);\n}\n.flag-icon-mx.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mx.svg);\n}\n\n.flag-icon-my {\n  background-image: url(../../fonts/flag-icon/my.svg);\n}\n.flag-icon-my.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/my.svg);\n}\n\n.flag-icon-mz {\n  background-image: url(../../fonts/flag-icon/mz.svg);\n}\n.flag-icon-mz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/mz.svg);\n}\n\n.flag-icon-na {\n  background-image: url(../../fonts/flag-icon/na.svg);\n}\n.flag-icon-na.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/na.svg);\n}\n\n.flag-icon-nc {\n  background-image: url(../../fonts/flag-icon/nc.svg);\n}\n.flag-icon-nc.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/nc.svg);\n}\n\n.flag-icon-ne {\n  background-image: url(../../fonts/flag-icon/ne.svg);\n}\n.flag-icon-ne.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ne.svg);\n}\n\n.flag-icon-nf {\n  background-image: url(../../fonts/flag-icon/nf.svg);\n}\n.flag-icon-nf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/nf.svg);\n}\n\n.flag-icon-ng {\n  background-image: url(../../fonts/flag-icon/ng.svg);\n}\n.flag-icon-ng.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ng.svg);\n}\n\n.flag-icon-ni {\n  background-image: url(../../fonts/flag-icon/ni.svg);\n}\n.flag-icon-ni.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ni.svg);\n}\n\n.flag-icon-nl {\n  background-image: url(../../fonts/flag-icon/nl.svg);\n}\n.flag-icon-nl.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/nl.svg);\n}\n\n.flag-icon-no {\n  background-image: url(../../fonts/flag-icon/no.svg);\n}\n.flag-icon-no.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/no.svg);\n}\n\n.flag-icon-np {\n  background-image: url(../../fonts/flag-icon/np.svg);\n}\n.flag-icon-np.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/np.svg);\n}\n\n.flag-icon-nr {\n  background-image: url(../../fonts/flag-icon/nr.svg);\n}\n.flag-icon-nr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/nr.svg);\n}\n\n.flag-icon-nu {\n  background-image: url(../../fonts/flag-icon/nu.svg);\n}\n.flag-icon-nu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/nu.svg);\n}\n\n.flag-icon-nz {\n  background-image: url(../../fonts/flag-icon/nz.svg);\n}\n.flag-icon-nz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/nz.svg);\n}\n\n.flag-icon-om {\n  background-image: url(../../fonts/flag-icon/om.svg);\n}\n.flag-icon-om.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/om.svg);\n}\n\n.flag-icon-pa {\n  background-image: url(../../fonts/flag-icon/pa.svg);\n}\n.flag-icon-pa.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pa.svg);\n}\n\n.flag-icon-pe {\n  background-image: url(../../fonts/flag-icon/pe.svg);\n}\n.flag-icon-pe.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pe.svg);\n}\n\n.flag-icon-pf {\n  background-image: url(../../fonts/flag-icon/pf.svg);\n}\n.flag-icon-pf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pf.svg);\n}\n\n.flag-icon-pg {\n  background-image: url(../../fonts/flag-icon/pg.svg);\n}\n.flag-icon-pg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pg.svg);\n}\n\n.flag-icon-ph {\n  background-image: url(../../fonts/flag-icon/ph.svg);\n}\n.flag-icon-ph.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ph.svg);\n}\n\n.flag-icon-pk {\n  background-image: url(../../fonts/flag-icon/pk.svg);\n}\n.flag-icon-pk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pk.svg);\n}\n\n.flag-icon-pl {\n  background-image: url(../../fonts/flag-icon/pl.svg);\n}\n.flag-icon-pl.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pl.svg);\n}\n\n.flag-icon-pm {\n  background-image: url(../../fonts/flag-icon/pm.svg);\n}\n.flag-icon-pm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pm.svg);\n}\n\n.flag-icon-pn {\n  background-image: url(../../fonts/flag-icon/pn.svg);\n}\n.flag-icon-pn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pn.svg);\n}\n\n.flag-icon-pr {\n  background-image: url(../../fonts/flag-icon/pr.svg);\n}\n.flag-icon-pr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pr.svg);\n}\n\n.flag-icon-ps {\n  background-image: url(../../fonts/flag-icon/ps.svg);\n}\n.flag-icon-ps.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ps.svg);\n}\n\n.flag-icon-pt {\n  background-image: url(../../fonts/flag-icon/pt.svg);\n}\n.flag-icon-pt.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pt.svg);\n}\n\n.flag-icon-pw {\n  background-image: url(../../fonts/flag-icon/pw.svg);\n}\n.flag-icon-pw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/pw.svg);\n}\n\n.flag-icon-py {\n  background-image: url(../../fonts/flag-icon/py.svg);\n}\n.flag-icon-py.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/py.svg);\n}\n\n.flag-icon-qa {\n  background-image: url(../../fonts/flag-icon/qa.svg);\n}\n.flag-icon-qa.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/qa.svg);\n}\n\n.flag-icon-re {\n  background-image: url(../../fonts/flag-icon/re.svg);\n}\n.flag-icon-re.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/re.svg);\n}\n\n.flag-icon-ro {\n  background-image: url(../../fonts/flag-icon/ro.svg);\n}\n.flag-icon-ro.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ro.svg);\n}\n\n.flag-icon-rs {\n  background-image: url(../../fonts/flag-icon/rs.svg);\n}\n.flag-icon-rs.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/rs.svg);\n}\n\n.flag-icon-ru {\n  background-image: url(../../fonts/flag-icon/ru.svg);\n}\n.flag-icon-ru.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ru.svg);\n}\n\n.flag-icon-rw {\n  background-image: url(../../fonts/flag-icon/rw.svg);\n}\n.flag-icon-rw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/rw.svg);\n}\n\n.flag-icon-sa {\n  background-image: url(../../fonts/flag-icon/sa.svg);\n}\n.flag-icon-sa.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sa.svg);\n}\n\n.flag-icon-sb {\n  background-image: url(../../fonts/flag-icon/sb.svg);\n}\n.flag-icon-sb.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sb.svg);\n}\n\n.flag-icon-sc {\n  background-image: url(../../fonts/flag-icon/sc.svg);\n}\n.flag-icon-sc.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sc.svg);\n}\n\n.flag-icon-sd {\n  background-image: url(../../fonts/flag-icon/sd.svg);\n}\n.flag-icon-sd.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sd.svg);\n}\n\n.flag-icon-se {\n  background-image: url(../../fonts/flag-icon/se.svg);\n}\n.flag-icon-se.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/se.svg);\n}\n\n.flag-icon-sg {\n  background-image: url(../../fonts/flag-icon/sg.svg);\n}\n.flag-icon-sg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sg.svg);\n}\n\n.flag-icon-sh {\n  background-image: url(../../fonts/flag-icon/sh.svg);\n}\n.flag-icon-sh.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sh.svg);\n}\n\n.flag-icon-si {\n  background-image: url(../../fonts/flag-icon/si.svg);\n}\n.flag-icon-si.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/si.svg);\n}\n\n.flag-icon-sj {\n  background-image: url(../../fonts/flag-icon/sj.svg);\n}\n.flag-icon-sj.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sj.svg);\n}\n\n.flag-icon-sk {\n  background-image: url(../../fonts/flag-icon/sk.svg);\n}\n.flag-icon-sk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sk.svg);\n}\n\n.flag-icon-sl {\n  background-image: url(../../fonts/flag-icon/sl.svg);\n}\n.flag-icon-sl.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sl.svg);\n}\n\n.flag-icon-sm {\n  background-image: url(../../fonts/flag-icon/sm.svg);\n}\n.flag-icon-sm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sm.svg);\n}\n\n.flag-icon-sn {\n  background-image: url(../../fonts/flag-icon/sn.svg);\n}\n.flag-icon-sn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sn.svg);\n}\n\n.flag-icon-so {\n  background-image: url(../../fonts/flag-icon/so.svg);\n}\n.flag-icon-so.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/so.svg);\n}\n\n.flag-icon-sr {\n  background-image: url(../../fonts/flag-icon/sr.svg);\n}\n.flag-icon-sr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sr.svg);\n}\n\n.flag-icon-ss {\n  background-image: url(../../fonts/flag-icon/ss.svg);\n}\n.flag-icon-ss.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ss.svg);\n}\n\n.flag-icon-st {\n  background-image: url(../../fonts/flag-icon/st.svg);\n}\n.flag-icon-st.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/st.svg);\n}\n\n.flag-icon-sv {\n  background-image: url(../../fonts/flag-icon/sv.svg);\n}\n.flag-icon-sv.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sv.svg);\n}\n\n.flag-icon-sx {\n  background-image: url(../../fonts/flag-icon/sx.svg);\n}\n.flag-icon-sx.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sx.svg);\n}\n\n.flag-icon-sy {\n  background-image: url(../../fonts/flag-icon/sy.svg);\n}\n.flag-icon-sy.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sy.svg);\n}\n\n.flag-icon-sz {\n  background-image: url(../../fonts/flag-icon/sz.svg);\n}\n.flag-icon-sz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/sz.svg);\n}\n\n.flag-icon-tc {\n  background-image: url(../../fonts/flag-icon/tc.svg);\n}\n.flag-icon-tc.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tc.svg);\n}\n\n.flag-icon-td {\n  background-image: url(../../fonts/flag-icon/td.svg);\n}\n.flag-icon-td.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/td.svg);\n}\n\n.flag-icon-tf {\n  background-image: url(../../fonts/flag-icon/tf.svg);\n}\n.flag-icon-tf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tf.svg);\n}\n\n.flag-icon-tg {\n  background-image: url(../../fonts/flag-icon/tg.svg);\n}\n.flag-icon-tg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tg.svg);\n}\n\n.flag-icon-th {\n  background-image: url(../../fonts/flag-icon/th.svg);\n}\n.flag-icon-th.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/th.svg);\n}\n\n.flag-icon-tj {\n  background-image: url(../../fonts/flag-icon/tj.svg);\n}\n.flag-icon-tj.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tj.svg);\n}\n\n.flag-icon-tk {\n  background-image: url(../../fonts/flag-icon/tk.svg);\n}\n.flag-icon-tk.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tk.svg);\n}\n\n.flag-icon-tl {\n  background-image: url(../../fonts/flag-icon/tl.svg);\n}\n.flag-icon-tl.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tl.svg);\n}\n\n.flag-icon-tm {\n  background-image: url(../../fonts/flag-icon/tm.svg);\n}\n.flag-icon-tm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tm.svg);\n}\n\n.flag-icon-tn {\n  background-image: url(../../fonts/flag-icon/tn.svg);\n}\n.flag-icon-tn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tn.svg);\n}\n\n.flag-icon-to {\n  background-image: url(../../fonts/flag-icon/to.svg);\n}\n.flag-icon-to.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/to.svg);\n}\n\n.flag-icon-tr {\n  background-image: url(../../fonts/flag-icon/tr.svg);\n}\n.flag-icon-tr.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tr.svg);\n}\n\n.flag-icon-tt {\n  background-image: url(../../fonts/flag-icon/tt.svg);\n}\n.flag-icon-tt.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tt.svg);\n}\n\n.flag-icon-tv {\n  background-image: url(../../fonts/flag-icon/tv.svg);\n}\n.flag-icon-tv.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tv.svg);\n}\n\n.flag-icon-tw {\n  background-image: url(../../fonts/flag-icon/tw.svg);\n}\n.flag-icon-tw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tw.svg);\n}\n\n.flag-icon-tz {\n  background-image: url(../../fonts/flag-icon/tz.svg);\n}\n.flag-icon-tz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/tz.svg);\n}\n\n.flag-icon-ua {\n  background-image: url(../../fonts/flag-icon/ua.svg);\n}\n.flag-icon-ua.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ua.svg);\n}\n\n.flag-icon-ug {\n  background-image: url(../../fonts/flag-icon/ug.svg);\n}\n.flag-icon-ug.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ug.svg);\n}\n\n.flag-icon-um {\n  background-image: url(../../fonts/flag-icon/um.svg);\n}\n.flag-icon-um.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/um.svg);\n}\n\n.flag-icon-us {\n  background-image: url(../../fonts/flag-icon/us.svg);\n}\n.flag-icon-us.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/us.svg);\n}\n\n.flag-icon-uy {\n  background-image: url(../../fonts/flag-icon/uy.svg);\n}\n.flag-icon-uy.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/uy.svg);\n}\n\n.flag-icon-uz {\n  background-image: url(../../fonts/flag-icon/uz.svg);\n}\n.flag-icon-uz.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/uz.svg);\n}\n\n.flag-icon-va {\n  background-image: url(../../fonts/flag-icon/va.svg);\n}\n.flag-icon-va.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/va.svg);\n}\n\n.flag-icon-vc {\n  background-image: url(../../fonts/flag-icon/vc.svg);\n}\n.flag-icon-vc.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/vc.svg);\n}\n\n.flag-icon-ve {\n  background-image: url(../../fonts/flag-icon/ve.svg);\n}\n.flag-icon-ve.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ve.svg);\n}\n\n.flag-icon-vg {\n  background-image: url(../../fonts/flag-icon/vg.svg);\n}\n.flag-icon-vg.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/vg.svg);\n}\n\n.flag-icon-vi {\n  background-image: url(../../fonts/flag-icon/vi.svg);\n}\n.flag-icon-vi.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/vi.svg);\n}\n\n.flag-icon-vn {\n  background-image: url(../../fonts/flag-icon/vn.svg);\n}\n.flag-icon-vn.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/vn.svg);\n}\n\n.flag-icon-vu {\n  background-image: url(../../fonts/flag-icon/vu.svg);\n}\n.flag-icon-vu.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/vu.svg);\n}\n\n.flag-icon-wf {\n  background-image: url(../../fonts/flag-icon/wf.svg);\n}\n.flag-icon-wf.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/wf.svg);\n}\n\n.flag-icon-ws {\n  background-image: url(../../fonts/flag-icon/ws.svg);\n}\n.flag-icon-ws.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ws.svg);\n}\n\n.flag-icon-ye {\n  background-image: url(../../fonts/flag-icon/ye.svg);\n}\n.flag-icon-ye.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/ye.svg);\n}\n\n.flag-icon-yt {\n  background-image: url(../../fonts/flag-icon/yt.svg);\n}\n.flag-icon-yt.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/yt.svg);\n}\n\n.flag-icon-za {\n  background-image: url(../../fonts/flag-icon/za.svg);\n}\n.flag-icon-za.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/za.svg);\n}\n\n.flag-icon-zm {\n  background-image: url(../../fonts/flag-icon/zm.svg);\n}\n.flag-icon-zm.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/zm.svg);\n}\n\n.flag-icon-zw {\n  background-image: url(../../fonts/flag-icon/zw.svg);\n}\n.flag-icon-zw.flag-icon-squared {\n  background-image: url(../../fonts/flag-icon/zw.svg);\n}\n\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: \"themify\";\n  src: url(\"../../fonts/themify.eot?-fvbane\");\n  src: url(\"../../fonts/themify.eot?#iefix-fvbane\") format(\"embedded-opentype\"), url(\"../../fonts/themify.woff?-fvbane\") format(\"woff\"), url(\"../../fonts/themify.ttf?-fvbane\") format(\"truetype\"), url(\"../../fonts/themify.svg?-fvbane#themify\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=icon-],\n[class*=\" icon-\"] {\n  font-family: \"themify\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  *margin-right: 0.3em;\n}\n\n[class^=icon-]:before,\n[class*=\" icon-\"]:before {\n  text-decoration: inherit;\n  display: inline-block;\n  speak: none;\n}\n\n/* makes the font 33% larger relative to the icon container */\n.icon-large:before {\n  vertical-align: -10%;\n  font-size: 1.3333333333em;\n}\n\n/* makes sure icons active on rollover in links */\na [class^=icon-],\na [class*=\" icon-\"] {\n  display: inline;\n}\n\n/* increased font size for icon-large */\n[class^=icon-].icon-fixed-width,\n[class*=\" icon-\"].icon-fixed-width {\n  display: inline-block;\n  width: 1.1428571429em;\n  text-align: right;\n  padding-right: 0.2857142857em;\n}\n[class^=icon-].icon-fixed-width.icon-large,\n[class*=\" icon-\"].icon-fixed-width.icon-large {\n  width: 1.4285714286em;\n}\n\n.icons-ul {\n  margin-left: 2.1428571429em;\n  list-style-type: none;\n}\n.icons-ul > li {\n  position: relative;\n}\n.icons-ul .icon-li {\n  position: absolute;\n  left: -2.1428571429em;\n  width: 2.1428571429em;\n  text-align: center;\n  line-height: inherit;\n}\n\n[class^=icon-].hide,\n[class*=\" icon-\"].hide {\n  display: none;\n}\n\n.icon-muted {\n  color: #eeeeee;\n}\n\n.icon-light {\n  color: white;\n}\n\n.icon-dark {\n  color: #333333;\n}\n\n.icon-border {\n  border: solid 1px #eeeeee;\n  padding: 0.2em 0.25em 0.15em;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n\n.icon-2x {\n  font-size: 2em;\n}\n.icon-2x.icon-border {\n  border-width: 2px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.icon-3x {\n  font-size: 3em;\n}\n.icon-3x.icon-border {\n  border-width: 3px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n}\n\n.icon-4x {\n  font-size: 4em;\n}\n.icon-4x.icon-border {\n  border-width: 4px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n}\n\n.icon-5x {\n  font-size: 5em;\n}\n.icon-5x.icon-border {\n  border-width: 5px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pull-left {\n  float: left;\n}\n\n[class^=icon-].pull-left,\n[class*=\" icon-\"].pull-left {\n  margin-right: 0.3em;\n}\n[class^=icon-].pull-right,\n[class*=\" icon-\"].pull-right {\n  margin-left: 0.3em;\n}\n\n/* EXTRAS\n * -------------------------- */\n/* Stacked and layered icon */\n.icon-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: -35%;\n}\n.icon-stack [class^=icon-],\n.icon-stack [class*=\" icon-\"] {\n  display: block;\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  font-size: 1em;\n  line-height: inherit;\n  *line-height: 2em;\n}\n.icon-stack .icon-stack-base {\n  font-size: 2em;\n  *line-height: 1em;\n}\n\n/* Animated rotating icon */\n.icon-spin {\n  display: inline-block;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  -webkit-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear;\n}\n\n/* Prevent stack and spinners from being taken inline when inside a link */\na .icon-stack,\na .icon-spin {\n  display: inline-block;\n  text-decoration: none;\n}\n\n@-moz-keyframes spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(359deg);\n  }\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -o-transform: rotate(0deg);\n  }\n  100% {\n    -o-transform: rotate(359deg);\n  }\n}\n@-ms-keyframes spin {\n  0% {\n    -ms-transform: rotate(0deg);\n  }\n  100% {\n    -ms-transform: rotate(359deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n/* Icon rotations and mirroring */\n.icon-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n\n.icon-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n\n.icon-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n\n.icon-flip-horizontal:before {\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.icon-flip-vertical:before {\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n/* ensure rotation occurs inside anchor tags */\na .icon-rotate-90:before, a .icon-rotate-180:before, a .icon-rotate-270:before, a .icon-flip-horizontal:before, a .icon-flip-vertical:before {\n  display: inline-block;\n}\n\n.icon-wand:before {\n  content: \"\\e600\";\n}\n\n.icon-volume:before {\n  content: \"\\e601\";\n}\n\n.icon-user:before {\n  content: \"\\e602\";\n}\n\n.icon-unlock:before {\n  content: \"\\e603\";\n}\n\n.icon-unlink:before {\n  content: \"\\e604\";\n}\n\n.icon-trash:before {\n  content: \"\\e605\";\n}\n\n.icon-thought:before {\n  content: \"\\e606\";\n}\n\n.icon-target:before {\n  content: \"\\e607\";\n}\n\n.icon-tag:before {\n  content: \"\\e608\";\n}\n\n.icon-tablet:before {\n  content: \"\\e609\";\n}\n\n.icon-star:before {\n  content: \"\\e60a\";\n}\n\n.icon-spray:before {\n  content: \"\\e60b\";\n}\n\n.icon-signal:before {\n  content: \"\\e60c\";\n}\n\n.icon-shopping-cart:before {\n  content: \"\\e60d\";\n}\n\n.icon-shopping-cart-full:before {\n  content: \"\\e60e\";\n}\n\n.icon-settings:before {\n  content: \"\\e60f\";\n}\n\n.ti-search:before {\n  content: \"\\e610\";\n}\n\n.icon-zoom-in:before {\n  content: \"\\e611\";\n}\n\n.icon-zoom-out:before {\n  content: \"\\e612\";\n}\n\n.icon-cut:before {\n  content: \"\\e613\";\n}\n\n.icon-ruler:before {\n  content: \"\\e614\";\n}\n\n.icon-ruler-pencil:before {\n  content: \"\\e615\";\n}\n\n.icon-ruler-alt:before {\n  content: \"\\e616\";\n}\n\n.icon-bookmark:before {\n  content: \"\\e617\";\n}\n\n.icon-bookmark-alt:before {\n  content: \"\\e618\";\n}\n\n.icon-reload:before {\n  content: \"\\e619\";\n}\n\n.icon-plus:before {\n  content: \"\\e61a\";\n}\n\n.icon-pin:before {\n  content: \"\\e61b\";\n}\n\n.icon-pencil:before {\n  content: \"\\e61c\";\n}\n\n.icon-pencil-alt:before {\n  content: \"\\e61d\";\n}\n\n.icon-paint-roller:before {\n  content: \"\\e61e\";\n}\n\n.icon-paint-bucket:before {\n  content: \"\\e61f\";\n}\n\n.icon-na:before {\n  content: \"\\e620\";\n}\n\n.icon-mobile:before {\n  content: \"\\e621\";\n}\n\n.icon-minus:before {\n  content: \"\\e622\";\n}\n\n.icon-medall:before {\n  content: \"\\e623\";\n}\n\n.icon-medall-alt:before {\n  content: \"\\e624\";\n}\n\n.icon-marker:before {\n  content: \"\\e625\";\n}\n\n.icon-marker-alt:before {\n  content: \"\\e626\";\n}\n\n.icon-arrow-up:before {\n  content: \"\\e627\";\n}\n\n.icon-arrow-right:before {\n  content: \"\\e628\";\n}\n\n.icon-arrow-left:before {\n  content: \"\\e629\";\n}\n\n.icon-arrow-down:before {\n  content: \"\\e62a\";\n}\n\n.icon-lock:before {\n  content: \"\\e62b\";\n}\n\n.icon-location-arrow:before {\n  content: \"\\e62c\";\n}\n\n.icon-link:before {\n  content: \"\\e62d\";\n}\n\n.icon-layout:before {\n  content: \"\\e62e\";\n}\n\n.icon-layers:before {\n  content: \"\\e62f\";\n}\n\n.icon-layers-alt:before {\n  content: \"\\e630\";\n}\n\n.icon-key:before {\n  content: \"\\e631\";\n}\n\n.icon-import:before {\n  content: \"\\e632\";\n}\n\n.icon-image:before {\n  content: \"\\e633\";\n}\n\n.icon-heart:before {\n  content: \"\\e634\";\n}\n\n.icon-heart-broken:before {\n  content: \"\\e635\";\n}\n\n.icon-hand-stop:before {\n  content: \"\\e636\";\n}\n\n.icon-hand-open:before {\n  content: \"\\e637\";\n}\n\n.icon-hand-drag:before {\n  content: \"\\e638\";\n}\n\n.icon-folder:before {\n  content: \"\\e639\";\n}\n\n.icon-flag:before {\n  content: \"\\e63a\";\n}\n\n.icon-flag-alt:before {\n  content: \"\\e63b\";\n}\n\n.icon-flag-alt-2:before {\n  content: \"\\e63c\";\n}\n\n.icon-eye:before {\n  content: \"\\e63d\";\n}\n\n.icon-export:before {\n  content: \"\\e63e\";\n}\n\n.icon-exchange-vertical:before {\n  content: \"\\e63f\";\n}\n\n.icon-desktop:before {\n  content: \"\\e640\";\n}\n\n.icon-cup:before {\n  content: \"\\e641\";\n}\n\n.icon-crown:before {\n  content: \"\\e642\";\n}\n\n.icon-comments:before {\n  content: \"\\e643\";\n}\n\n.icon-comment:before {\n  content: \"\\e644\";\n}\n\n.icon-comment-alt:before {\n  content: \"\\e645\";\n}\n\n.icon-close:before {\n  content: \"\\e646\";\n}\n\n.icon-clip:before {\n  content: \"\\e647\";\n}\n\n.icon-angle-up:before {\n  content: \"\\e648\";\n}\n\n.icon-angle-right:before {\n  content: \"\\e649\";\n}\n\n.icon-angle-left:before {\n  content: \"\\e64a\";\n}\n\n.icon-angle-down:before {\n  content: \"\\e64b\";\n}\n\n.icon-check:before {\n  content: \"\\e64c\";\n}\n\n.icon-check-box:before {\n  content: \"\\e64d\";\n}\n\n.icon-camera:before {\n  content: \"\\e64e\";\n}\n\n.icon-announcement:before {\n  content: \"\\e64f\";\n}\n\n.icon-brush:before {\n  content: \"\\e650\";\n}\n\n.icon-briefcase:before {\n  content: \"\\e651\";\n}\n\n.icon-bolt:before {\n  content: \"\\e652\";\n}\n\n.icon-bolt-alt:before {\n  content: \"\\e653\";\n}\n\n.icon-blackboard:before {\n  content: \"\\e654\";\n}\n\n.icon-bag:before {\n  content: \"\\e655\";\n}\n\n.icon-move:before {\n  content: \"\\e656\";\n}\n\n.icon-arrows-vertical:before {\n  content: \"\\e657\";\n}\n\n.icon-arrows-horizontal:before {\n  content: \"\\e658\";\n}\n\n.icon-fullscreen:before {\n  content: \"\\e659\";\n}\n\n.icon-arrow-top-right:before {\n  content: \"\\e65a\";\n}\n\n.icon-arrow-top-left:before {\n  content: \"\\e65b\";\n}\n\n.icon-arrow-circle-up:before {\n  content: \"\\e65c\";\n}\n\n.icon-arrow-circle-right:before {\n  content: \"\\e65d\";\n}\n\n.icon-arrow-circle-left:before {\n  content: \"\\e65e\";\n}\n\n.icon-arrow-circle-down:before {\n  content: \"\\e65f\";\n}\n\n.icon-angle-double-up:before {\n  content: \"\\e660\";\n}\n\n.icon-angle-double-right:before {\n  content: \"\\e661\";\n}\n\n.icon-angle-double-left:before {\n  content: \"\\e662\";\n}\n\n.icon-angle-double-down:before {\n  content: \"\\e663\";\n}\n\n.icon-zip:before {\n  content: \"\\e664\";\n}\n\n.icon-world:before {\n  content: \"\\e665\";\n}\n\n.icon-wheelchair:before {\n  content: \"\\e666\";\n}\n\n.icon-view-list:before {\n  content: \"\\e667\";\n}\n\n.icon-view-list-alt:before {\n  content: \"\\e668\";\n}\n\n.icon-view-grid:before {\n  content: \"\\e669\";\n}\n\n.icon-uppercase:before {\n  content: \"\\e66a\";\n}\n\n.icon-upload:before {\n  content: \"\\e66b\";\n}\n\n.icon-underline:before {\n  content: \"\\e66c\";\n}\n\n.icon-truck:before {\n  content: \"\\e66d\";\n}\n\n.icon-timer:before {\n  content: \"\\e66e\";\n}\n\n.icon-ticket:before {\n  content: \"\\e66f\";\n}\n\n.icon-thumb-up:before {\n  content: \"\\e670\";\n}\n\n.icon-thumb-down:before {\n  content: \"\\e671\";\n}\n\n.icon-text:before {\n  content: \"\\e672\";\n}\n\n.icon-stats-up:before {\n  content: \"\\e673\";\n}\n\n.icon-stats-down:before {\n  content: \"\\e674\";\n}\n\n.icon-split-v:before {\n  content: \"\\e675\";\n}\n\n.icon-split-h:before {\n  content: \"\\e676\";\n}\n\n.icon-smallcap:before {\n  content: \"\\e677\";\n}\n\n.icon-shine:before {\n  content: \"\\e678\";\n}\n\n.icon-shift-right:before {\n  content: \"\\e679\";\n}\n\n.icon-shift-left:before {\n  content: \"\\e67a\";\n}\n\n.icon-shield:before {\n  content: \"\\e67b\";\n}\n\n.icon-notepad:before {\n  content: \"\\e67c\";\n}\n\n.icon-server:before {\n  content: \"\\e67d\";\n}\n\n.icon-quote-right:before {\n  content: \"\\e67e\";\n}\n\n.icon-quote-left:before {\n  content: \"\\e67f\";\n}\n\n.icon-pulse:before {\n  content: \"\\e680\";\n}\n\n.icon-printer:before {\n  content: \"\\e681\";\n}\n\n.icon-power-off:before {\n  content: \"\\e682\";\n}\n\n.icon-plug:before {\n  content: \"\\e683\";\n}\n\n.icon-pie-chart:before {\n  content: \"\\e684\";\n}\n\n.icon-paragraph:before {\n  content: \"\\e685\";\n}\n\n.icon-panel:before {\n  content: \"\\e686\";\n}\n\n.icon-package:before {\n  content: \"\\e687\";\n}\n\n.icon-music:before {\n  content: \"\\e688\";\n}\n\n.icon-music-alt:before {\n  content: \"\\e689\";\n}\n\n.icon-mouse:before {\n  content: \"\\e68a\";\n}\n\n.icon-mouse-alt:before {\n  content: \"\\e68b\";\n}\n\n.icon-money:before {\n  content: \"\\e68c\";\n}\n\n.icon-microphone:before {\n  content: \"\\e68d\";\n}\n\n.icon-menu:before {\n  content: \"\\e68e\";\n}\n\n.icon-menu-alt:before {\n  content: \"\\e68f\";\n}\n\n.icon-map:before {\n  content: \"\\e690\";\n}\n\n.icon-map-alt:before {\n  content: \"\\e691\";\n}\n\n.icon-loop:before {\n  content: \"\\e692\";\n}\n\n.icon-location-pin:before {\n  content: \"\\e693\";\n}\n\n.icon-list:before {\n  content: \"\\e694\";\n}\n\n.icon-light-bulb:before {\n  content: \"\\e695\";\n}\n\n.icon-Italic:before {\n  content: \"\\e696\";\n}\n\n.icon-info:before {\n  content: \"\\e697\";\n}\n\n.icon-infinite:before {\n  content: \"\\e698\";\n}\n\n.icon-id-badge:before {\n  content: \"\\e699\";\n}\n\n.icon-hummer:before {\n  content: \"\\e69a\";\n}\n\n.icon-home:before {\n  content: \"\\e69b\";\n}\n\n.icon-help:before {\n  content: \"\\e69c\";\n}\n\n.icon-headphone:before {\n  content: \"\\e69d\";\n}\n\n.icon-harddrives:before {\n  content: \"\\e69e\";\n}\n\n.icon-harddrive:before {\n  content: \"\\e69f\";\n}\n\n.icon-gift:before {\n  content: \"\\e6a0\";\n}\n\n.icon-game:before {\n  content: \"\\e6a1\";\n}\n\n.icon-filter:before {\n  content: \"\\e6a2\";\n}\n\n.icon-files:before {\n  content: \"\\e6a3\";\n}\n\n.icon-file:before {\n  content: \"\\e6a4\";\n}\n\n.icon-eraser:before {\n  content: \"\\e6a5\";\n}\n\n.icon-envelope:before {\n  content: \"\\e6a6\";\n}\n\n.icon-download:before {\n  content: \"\\e6a7\";\n}\n\n.icon-direction:before {\n  content: \"\\e6a8\";\n}\n\n.icon-direction-alt:before {\n  content: \"\\e6a9\";\n}\n\n.icon-dashboard:before {\n  content: \"\\e6aa\";\n}\n\n.icon-control-stop:before {\n  content: \"\\e6ab\";\n}\n\n.icon-control-shuffle:before {\n  content: \"\\e6ac\";\n}\n\n.icon-control-play:before {\n  content: \"\\e6ad\";\n}\n\n.icon-control-pause:before {\n  content: \"\\e6ae\";\n}\n\n.icon-control-forward:before {\n  content: \"\\e6af\";\n}\n\n.icon-control-backward:before {\n  content: \"\\e6b0\";\n}\n\n.icon-cloud:before {\n  content: \"\\e6b1\";\n}\n\n.icon-cloud-up:before {\n  content: \"\\e6b2\";\n}\n\n.icon-cloud-down:before {\n  content: \"\\e6b3\";\n}\n\n.icon-clipboard:before {\n  content: \"\\e6b4\";\n}\n\n.icon-car:before {\n  content: \"\\e6b5\";\n}\n\n.icon-calendar:before {\n  content: \"\\e6b6\";\n}\n\n.icon-book:before {\n  content: \"\\e6b7\";\n}\n\n.icon-bell:before {\n  content: \"\\e6b8\";\n}\n\n.icon-basketball:before {\n  content: \"\\e6b9\";\n}\n\n.icon-bar-chart:before {\n  content: \"\\e6ba\";\n}\n\n.icon-bar-chart-alt:before {\n  content: \"\\e6bb\";\n}\n\n.icon-back-right:before {\n  content: \"\\e6bc\";\n}\n\n.icon-back-left:before {\n  content: \"\\e6bd\";\n}\n\n.icon-arrows-corner:before {\n  content: \"\\e6be\";\n}\n\n.icon-archive:before {\n  content: \"\\e6bf\";\n}\n\n.icon-anchor:before {\n  content: \"\\e6c0\";\n}\n\n.icon-align-right:before {\n  content: \"\\e6c1\";\n}\n\n.icon-align-left:before {\n  content: \"\\e6c2\";\n}\n\n.icon-align-justify:before {\n  content: \"\\e6c3\";\n}\n\n.icon-align-center:before {\n  content: \"\\e6c4\";\n}\n\n.icon-alert:before {\n  content: \"\\e6c5\";\n}\n\n.icon-alarm-clock:before {\n  content: \"\\e6c6\";\n}\n\n.icon-agenda:before {\n  content: \"\\e6c7\";\n}\n\n.icon-write:before {\n  content: \"\\e6c8\";\n}\n\n.icon-window:before {\n  content: \"\\e6c9\";\n}\n\n.icon-widgetized:before {\n  content: \"\\e6ca\";\n}\n\n.icon-widget:before {\n  content: \"\\e6cb\";\n}\n\n.icon-widget-alt:before {\n  content: \"\\e6cc\";\n}\n\n.icon-wallet:before {\n  content: \"\\e6cd\";\n}\n\n.icon-video-clapper:before {\n  content: \"\\e6ce\";\n}\n\n.icon-video-camera:before {\n  content: \"\\e6cf\";\n}\n\n.icon-vector:before {\n  content: \"\\e6d0\";\n}\n\n.icon-themify-logo:before {\n  content: \"\\e6d1\";\n}\n\n.icon-themify-favicon:before {\n  content: \"\\e6d2\";\n}\n\n.icon-themify-favicon-alt:before {\n  content: \"\\e6d3\";\n}\n\n.icon-support:before {\n  content: \"\\e6d4\";\n}\n\n.icon-stamp:before {\n  content: \"\\e6d5\";\n}\n\n.icon-split-v-alt:before {\n  content: \"\\e6d6\";\n}\n\n.icon-slice:before {\n  content: \"\\e6d7\";\n}\n\n.icon-shortcode:before {\n  content: \"\\e6d8\";\n}\n\n.icon-shift-right-alt:before {\n  content: \"\\e6d9\";\n}\n\n.icon-shift-left-alt:before {\n  content: \"\\e6da\";\n}\n\n.icon-ruler-alt-2:before {\n  content: \"\\e6db\";\n}\n\n.icon-receipt:before {\n  content: \"\\e6dc\";\n}\n\n.icon-pin2:before {\n  content: \"\\e6dd\";\n}\n\n.icon-pin-alt:before {\n  content: \"\\e6de\";\n}\n\n.icon-pencil-alt2:before {\n  content: \"\\e6df\";\n}\n\n.icon-palette:before {\n  content: \"\\e6e0\";\n}\n\n.icon-more:before {\n  content: \"\\e6e1\";\n}\n\n.icon-more-alt:before {\n  content: \"\\e6e2\";\n}\n\n.icon-microphone-alt:before {\n  content: \"\\e6e3\";\n}\n\n.icon-magnet:before {\n  content: \"\\e6e4\";\n}\n\n.icon-line-double:before {\n  content: \"\\e6e5\";\n}\n\n.icon-line-dotted:before {\n  content: \"\\e6e6\";\n}\n\n.icon-line-dashed:before {\n  content: \"\\e6e7\";\n}\n\n.icon-layout-width-full:before {\n  content: \"\\e6e8\";\n}\n\n.icon-layout-width-default:before {\n  content: \"\\e6e9\";\n}\n\n.icon-layout-width-default-alt:before {\n  content: \"\\e6ea\";\n}\n\n.icon-layout-tab:before {\n  content: \"\\e6eb\";\n}\n\n.icon-layout-tab-window:before {\n  content: \"\\e6ec\";\n}\n\n.icon-layout-tab-v:before {\n  content: \"\\e6ed\";\n}\n\n.icon-layout-tab-min:before {\n  content: \"\\e6ee\";\n}\n\n.icon-layout-slider:before {\n  content: \"\\e6ef\";\n}\n\n.icon-layout-slider-alt:before {\n  content: \"\\e6f0\";\n}\n\n.icon-layout-sidebar-right:before {\n  content: \"\\e6f1\";\n}\n\n.icon-layout-sidebar-none:before {\n  content: \"\\e6f2\";\n}\n\n.icon-layout-sidebar-left:before {\n  content: \"\\e6f3\";\n}\n\n.icon-layout-placeholder:before {\n  content: \"\\e6f4\";\n}\n\n.icon-layout-menu:before {\n  content: \"\\e6f5\";\n}\n\n.icon-layout-menu-v:before {\n  content: \"\\e6f6\";\n}\n\n.icon-layout-menu-separated:before {\n  content: \"\\e6f7\";\n}\n\n.icon-layout-menu-full:before {\n  content: \"\\e6f8\";\n}\n\n.icon-layout-media-right-alt:before {\n  content: \"\\e6f9\";\n}\n\n.icon-layout-media-right:before {\n  content: \"\\e6fa\";\n}\n\n.icon-layout-media-overlay:before {\n  content: \"\\e6fb\";\n}\n\n.icon-layout-media-overlay-alt:before {\n  content: \"\\e6fc\";\n}\n\n.icon-layout-media-overlay-alt-2:before {\n  content: \"\\e6fd\";\n}\n\n.icon-layout-media-left-alt:before {\n  content: \"\\e6fe\";\n}\n\n.icon-layout-media-left:before {\n  content: \"\\e6ff\";\n}\n\n.icon-layout-media-center-alt:before {\n  content: \"\\e700\";\n}\n\n.icon-layout-media-center:before {\n  content: \"\\e701\";\n}\n\n.icon-layout-list-thumb:before {\n  content: \"\\e702\";\n}\n\n.icon-layout-list-thumb-alt:before {\n  content: \"\\e703\";\n}\n\n.icon-layout-list-post:before {\n  content: \"\\e704\";\n}\n\n.icon-layout-list-large-image:before {\n  content: \"\\e705\";\n}\n\n.icon-layout-line-solid:before {\n  content: \"\\e706\";\n}\n\n.icon-layout-grid4:before {\n  content: \"\\e707\";\n}\n\n.icon-layout-grid3:before {\n  content: \"\\e708\";\n}\n\n.icon-layout-grid2:before {\n  content: \"\\e709\";\n}\n\n.icon-layout-grid2-thumb:before {\n  content: \"\\e70a\";\n}\n\n.icon-layout-cta-right:before {\n  content: \"\\e70b\";\n}\n\n.icon-layout-cta-left:before {\n  content: \"\\e70c\";\n}\n\n.icon-layout-cta-center:before {\n  content: \"\\e70d\";\n}\n\n.icon-layout-cta-btn-right:before {\n  content: \"\\e70e\";\n}\n\n.icon-layout-cta-btn-left:before {\n  content: \"\\e70f\";\n}\n\n.icon-layout-column4:before {\n  content: \"\\e710\";\n}\n\n.icon-layout-column3:before {\n  content: \"\\e711\";\n}\n\n.icon-layout-column2:before {\n  content: \"\\e712\";\n}\n\n.icon-layout-accordion-separated:before {\n  content: \"\\e713\";\n}\n\n.icon-layout-accordion-merged:before {\n  content: \"\\e714\";\n}\n\n.icon-layout-accordion-list:before {\n  content: \"\\e715\";\n}\n\n.icon-ink-pen:before {\n  content: \"\\e716\";\n}\n\n.icon-info-alt:before {\n  content: \"\\e717\";\n}\n\n.icon-help-alt:before {\n  content: \"\\e718\";\n}\n\n.icon-headphone-alt:before {\n  content: \"\\e719\";\n}\n\n.icon-hand-point-up:before {\n  content: \"\\e71a\";\n}\n\n.icon-hand-point-right:before {\n  content: \"\\e71b\";\n}\n\n.icon-hand-point-left:before {\n  content: \"\\e71c\";\n}\n\n.icon-hand-point-down:before {\n  content: \"\\e71d\";\n}\n\n.icon-gallery:before {\n  content: \"\\e71e\";\n}\n\n.icon-face-smile:before {\n  content: \"\\e71f\";\n}\n\n.icon-face-sad:before {\n  content: \"\\e720\";\n}\n\n.icon-credit-card:before {\n  content: \"\\e721\";\n}\n\n.icon-control-skip-forward:before {\n  content: \"\\e722\";\n}\n\n.icon-control-skip-backward:before {\n  content: \"\\e723\";\n}\n\n.icon-control-record:before {\n  content: \"\\e724\";\n}\n\n.icon-control-eject:before {\n  content: \"\\e725\";\n}\n\n.icon-comments-smiley:before {\n  content: \"\\e726\";\n}\n\n.icon-brush-alt:before {\n  content: \"\\e727\";\n}\n\n.icon-youtube:before {\n  content: \"\\e728\";\n}\n\n.icon-vimeo:before {\n  content: \"\\e729\";\n}\n\n.icon-twitter:before {\n  content: \"\\e72a\";\n}\n\n.icon-time:before {\n  content: \"\\e72b\";\n}\n\n.icon-tumblr:before {\n  content: \"\\e72c\";\n}\n\n.icon-skype:before {\n  content: \"\\e72d\";\n}\n\n.icon-share:before {\n  content: \"\\e72e\";\n}\n\n.icon-share-alt:before {\n  content: \"\\e72f\";\n}\n\n.icon-rocket:before {\n  content: \"\\e730\";\n}\n\n.icon-pinterest:before {\n  content: \"\\e731\";\n}\n\n.icon-new-window:before {\n  content: \"\\e732\";\n}\n\n.icon-microsoft:before {\n  content: \"\\e733\";\n}\n\n.icon-list-ol:before {\n  content: \"\\e734\";\n}\n\n.icon-linkedin:before {\n  content: \"\\e735\";\n}\n\n.icon-layout-sidebar-2:before {\n  content: \"\\e736\";\n}\n\n.icon-layout-grid4-alt:before {\n  content: \"\\e737\";\n}\n\n.icon-layout-grid3-alt:before {\n  content: \"\\e738\";\n}\n\n.icon-layout-grid2-alt:before {\n  content: \"\\e739\";\n}\n\n.icon-layout-column4-alt:before {\n  content: \"\\e73a\";\n}\n\n.icon-layout-column3-alt:before {\n  content: \"\\e73b\";\n}\n\n.icon-layout-column2-alt:before {\n  content: \"\\e73c\";\n}\n\n.icon-instagram:before {\n  content: \"\\e73d\";\n}\n\n.icon-google:before {\n  content: \"\\e73e\";\n}\n\n.icon-github:before {\n  content: \"\\e73f\";\n}\n\n.icon-flickr:before {\n  content: \"\\e740\";\n}\n\n.icon-facebook:before {\n  content: \"\\e741\";\n}\n\n.icon-dropbox:before {\n  content: \"\\e742\";\n}\n\n.icon-dribbble:before {\n  content: \"\\e743\";\n}\n\n.icon-apple:before {\n  content: \"\\e744\";\n}\n\n.icon-android:before {\n  content: \"\\e745\";\n}\n\n.icon-save:before {\n  content: \"\\e746\";\n}\n\n.icon-save-alt:before {\n  content: \"\\e747\";\n}\n\n.icon-yahoo:before {\n  content: \"\\e748\";\n}\n\n.icon-wordpress:before {\n  content: \"\\e749\";\n}\n\n.icon-vimeo-alt:before {\n  content: \"\\e74a\";\n}\n\n.icon-twitter-alt:before {\n  content: \"\\e74b\";\n}\n\n.icon-tumblr-alt:before {\n  content: \"\\e74c\";\n}\n\n.icon-trello:before {\n  content: \"\\e74d\";\n}\n\n.icon-stack-overflow:before {\n  content: \"\\e74e\";\n}\n\n.icon-soundcloud:before {\n  content: \"\\e74f\";\n}\n\n.icon-sharethis:before {\n  content: \"\\e750\";\n}\n\n.icon-sharethis-alt:before {\n  content: \"\\e751\";\n}\n\n.icon-reddit:before {\n  content: \"\\e752\";\n}\n\n.icon-pinterest-alt:before {\n  content: \"\\e753\";\n}\n\n.icon-microsoft-alt:before {\n  content: \"\\e754\";\n}\n\n.icon-linux:before {\n  content: \"\\e755\";\n}\n\n.icon-jsfiddle:before {\n  content: \"\\e756\";\n}\n\n.icon-joomla:before {\n  content: \"\\e757\";\n}\n\n.icon-html5:before {\n  content: \"\\e758\";\n}\n\n.icon-flickr-alt:before {\n  content: \"\\e759\";\n}\n\n.icon-email:before {\n  content: \"\\e75a\";\n}\n\n.icon-drupal:before {\n  content: \"\\e75b\";\n}\n\n.icon-dropbox-alt:before {\n  content: \"\\e75c\";\n}\n\n.icon-css3:before {\n  content: \"\\e75d\";\n}\n\n.icon-rss:before {\n  content: \"\\e75e\";\n}\n\n.icon-rss-alt:before {\n  content: \"\\e75f\";\n}\n\n/**\n * @package IcoFont by ThemeHunt - https://themehunt.com\n * @version 1.0.0 Beta\n * @author IcoFont http://icofont.com\n * @copyright Copyright (c) 2018 IcoFont\n * @license - http://icofont.com/license/\n*/\n@font-face {\n  font-family: \"icofont\";\n  src: url(\"../../fonts/ico/icofont.eot?v=1.0.0-beta\");\n  src: url(\"../../fonts/ico/icofont.eot?v=1.0.0-beta#iefix\") format(\"embedded-opentype\"), url(\"../../fonts/ico/icofont.ttf?v=1.0.0-beta\") format(\"truetype\"), url(\"../../fonts/ico/icofont.woff?v=1.0.0-beta\") format(\"woff\"), url(\"../../fonts/ico/icofont.svg?v=1.0.0-beta#icofont\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.icofont {\n  font-family: \"IcoFont\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icofont-angry-monster:before {\n  content: \"\\e901\";\n}\n\n.icofont-bathtub:before {\n  content: \"\\e902\";\n}\n\n.icofont-bird-wings:before {\n  content: \"\\e903\";\n}\n\n.icofont-bow:before {\n  content: \"\\e904\";\n}\n\n.icofont-brain-alt:before {\n  content: \"\\e905\";\n}\n\n.icofont-butterfly-alt:before {\n  content: \"\\e906\";\n}\n\n.icofont-castle:before {\n  content: \"\\e907\";\n}\n\n.icofont-circuit:before {\n  content: \"\\e908\";\n}\n\n.icofont-dart:before {\n  content: \"\\e909\";\n}\n\n.icofont-dice-alt:before {\n  content: \"\\e90a\";\n}\n\n.icofont-disability-race:before {\n  content: \"\\e90b\";\n}\n\n.icofont-diving-goggle:before {\n  content: \"\\e90c\";\n}\n\n.icofont-fire-alt:before {\n  content: \"\\e90d\";\n}\n\n.icofont-flame-torch:before {\n  content: \"\\e90e\";\n}\n\n.icofont-flora-flower:before {\n  content: \"\\e90f\";\n}\n\n.icofont-flora:before {\n  content: \"\\e910\";\n}\n\n.icofont-gift-box:before {\n  content: \"\\e911\";\n}\n\n.icofont-halloween-pumpkin:before {\n  content: \"\\e912\";\n}\n\n.icofont-hand-power:before {\n  content: \"\\e913\";\n}\n\n.icofont-hand-thunder:before {\n  content: \"\\e914\";\n}\n\n.icofont-king-crown:before {\n  content: \"\\e915\";\n}\n\n.icofont-king-monster:before {\n  content: \"\\e916\";\n}\n\n.icofont-love:before {\n  content: \"\\e917\";\n}\n\n.icofont-magician-hat:before {\n  content: \"\\e918\";\n}\n\n.icofont-native-american:before {\n  content: \"\\e919\";\n}\n\n.icofont-open-eye:before {\n  content: \"\\e91a\";\n}\n\n.icofont-owl-look:before {\n  content: \"\\e91b\";\n}\n\n.icofont-phoenix:before {\n  content: \"\\e91c\";\n}\n\n.icofont-queen-crown:before {\n  content: \"\\e91d\";\n}\n\n.icofont-robot-face:before {\n  content: \"\\e91e\";\n}\n\n.icofont-sand-clock:before {\n  content: \"\\e91f\";\n}\n\n.icofont-shield-alt:before {\n  content: \"\\e920\";\n}\n\n.icofont-ship-wheel:before {\n  content: \"\\e921\";\n}\n\n.icofont-skull-danger:before {\n  content: \"\\e922\";\n}\n\n.icofont-skull-face:before {\n  content: \"\\e923\";\n}\n\n.icofont-snail:before {\n  content: \"\\e924\";\n}\n\n.icofont-snow-alt:before {\n  content: \"\\e925\";\n}\n\n.icofont-snow-flake:before {\n  content: \"\\e926\";\n}\n\n.icofont-snowmobile:before {\n  content: \"\\e927\";\n}\n\n.icofont-space-shuttle:before {\n  content: \"\\e928\";\n}\n\n.icofont-star-shape:before {\n  content: \"\\e929\";\n}\n\n.icofont-swirl:before {\n  content: \"\\e92a\";\n}\n\n.icofont-tattoo-wing:before {\n  content: \"\\e92b\";\n}\n\n.icofont-throne:before {\n  content: \"\\e92c\";\n}\n\n.icofont-touch:before {\n  content: \"\\e92d\";\n}\n\n.icofont-tree-alt:before {\n  content: \"\\e92e\";\n}\n\n.icofont-triangle:before {\n  content: \"\\e92f\";\n}\n\n.icofont-unity-hand:before {\n  content: \"\\e930\";\n}\n\n.icofont-weed:before {\n  content: \"\\e931\";\n}\n\n.icofont-woman-bird:before {\n  content: \"\\e932\";\n}\n\n.icofont-animal-bat:before {\n  content: \"\\e933\";\n}\n\n.icofont-animal-bear-tracks:before {\n  content: \"\\e934\";\n}\n\n.icofont-animal-bear:before {\n  content: \"\\e935\";\n}\n\n.icofont-animal-bird-alt:before {\n  content: \"\\e936\";\n}\n\n.icofont-animal-bird:before {\n  content: \"\\e937\";\n}\n\n.icofont-animal-bone:before {\n  content: \"\\e938\";\n}\n\n.icofont-animal-bull:before {\n  content: \"\\e939\";\n}\n\n.icofont-animal-camel-alt:before {\n  content: \"\\e93a\";\n}\n\n.icofont-animal-camel-head:before {\n  content: \"\\e93b\";\n}\n\n.icofont-animal-camel:before {\n  content: \"\\e93c\";\n}\n\n.icofont-animal-cat-alt-1:before {\n  content: \"\\e93d\";\n}\n\n.icofont-animal-cat-alt-2:before {\n  content: \"\\e93e\";\n}\n\n.icofont-animal-cat-alt-3:before {\n  content: \"\\e93f\";\n}\n\n.icofont-animal-cat-alt-4:before {\n  content: \"\\e940\";\n}\n\n.icofont-animal-cat-with-dog:before {\n  content: \"\\e941\";\n}\n\n.icofont-animal-cat:before {\n  content: \"\\e942\";\n}\n\n.icofont-animal-cow-head:before {\n  content: \"\\e943\";\n}\n\n.icofont-animal-cow:before {\n  content: \"\\e944\";\n}\n\n.icofont-animal-crab:before {\n  content: \"\\e945\";\n}\n\n.icofont-animal-crocodile:before {\n  content: \"\\e946\";\n}\n\n.icofont-animal-deer-head:before {\n  content: \"\\e947\";\n}\n\n.icofont-animal-dog-alt:before {\n  content: \"\\e948\";\n}\n\n.icofont-animal-dog-barking:before {\n  content: \"\\e949\";\n}\n\n.icofont-animal-dog:before {\n  content: \"\\e94a\";\n}\n\n.icofont-animal-dolphin:before {\n  content: \"\\e94b\";\n}\n\n.icofont-animal-duck-tracks:before {\n  content: \"\\e94c\";\n}\n\n.icofont-animal-eagle-head:before {\n  content: \"\\e94d\";\n}\n\n.icofont-animal-eaten-fish:before {\n  content: \"\\e94e\";\n}\n\n.icofont-animal-elephant-alt:before {\n  content: \"\\e94f\";\n}\n\n.icofont-animal-elephant-head-alt:before {\n  content: \"\\e950\";\n}\n\n.icofont-animal-elephant-head:before {\n  content: \"\\e951\";\n}\n\n.icofont-animal-elephant:before {\n  content: \"\\e952\";\n}\n\n.icofont-animal-elk:before {\n  content: \"\\e953\";\n}\n\n.icofont-animal-fish-alt-1:before {\n  content: \"\\e954\";\n}\n\n.icofont-animal-fish-alt-2:before {\n  content: \"\\e955\";\n}\n\n.icofont-animal-fish-alt-3:before {\n  content: \"\\e956\";\n}\n\n.icofont-animal-fish-alt-4:before {\n  content: \"\\e957\";\n}\n\n.icofont-animal-fish:before {\n  content: \"\\e958\";\n}\n\n.icofont-animal-fox-alt:before {\n  content: \"\\e959\";\n}\n\n.icofont-animal-fox:before {\n  content: \"\\e95a\";\n}\n\n.icofont-animal-frog-tracks:before {\n  content: \"\\e95b\";\n}\n\n.icofont-animal-frog:before {\n  content: \"\\e95c\";\n}\n\n.icofont-animal-froggy:before {\n  content: \"\\e95d\";\n}\n\n.icofont-animal-giraffe-alt:before {\n  content: \"\\e95e\";\n}\n\n.icofont-animal-giraffe:before {\n  content: \"\\e95f\";\n}\n\n.icofont-animal-goat-head-alt-1:before {\n  content: \"\\e960\";\n}\n\n.icofont-animal-goat-head-alt-2:before {\n  content: \"\\e961\";\n}\n\n.icofont-animal-goat-head:before {\n  content: \"\\e962\";\n}\n\n.icofont-animal-gorilla:before {\n  content: \"\\e963\";\n}\n\n.icofont-animal-hen-tracks:before {\n  content: \"\\e964\";\n}\n\n.icofont-animal-horse-head-alt-1:before {\n  content: \"\\e965\";\n}\n\n.icofont-animal-horse-head-alt-2:before {\n  content: \"\\e966\";\n}\n\n.icofont-animal-horse-head:before {\n  content: \"\\e967\";\n}\n\n.icofont-animal-horse-tracks:before {\n  content: \"\\e968\";\n}\n\n.icofont-animal-jellyfish:before {\n  content: \"\\e969\";\n}\n\n.icofont-animal-kangaroo:before {\n  content: \"\\e96a\";\n}\n\n.icofont-animal-lemur:before {\n  content: \"\\e96b\";\n}\n\n.icofont-animal-lion-alt:before {\n  content: \"\\e96c\";\n}\n\n.icofont-animal-lion-head-alt:before {\n  content: \"\\e96d\";\n}\n\n.icofont-animal-lion-head:before {\n  content: \"\\e96e\";\n}\n\n.icofont-animal-lion:before {\n  content: \"\\e96f\";\n}\n\n.icofont-animal-monkey-alt-1:before {\n  content: \"\\e970\";\n}\n\n.icofont-animal-monkey-alt-2:before {\n  content: \"\\e971\";\n}\n\n.icofont-animal-monkey-alt-3:before {\n  content: \"\\e972\";\n}\n\n.icofont-animal-monkey:before {\n  content: \"\\e973\";\n}\n\n.icofont-animal-octopus-alt:before {\n  content: \"\\e974\";\n}\n\n.icofont-animal-octopus:before {\n  content: \"\\e975\";\n}\n\n.icofont-animal-owl:before {\n  content: \"\\e976\";\n}\n\n.icofont-animal-panda-alt:before {\n  content: \"\\e977\";\n}\n\n.icofont-animal-panda:before {\n  content: \"\\e978\";\n}\n\n.icofont-animal-panther:before {\n  content: \"\\e979\";\n}\n\n.icofont-animal-parrot-lip:before {\n  content: \"\\e97a\";\n}\n\n.icofont-animal-parrot:before {\n  content: \"\\e97b\";\n}\n\n.icofont-animal-paw:before {\n  content: \"\\e97c\";\n}\n\n.icofont-animal-pelican:before {\n  content: \"\\e97d\";\n}\n\n.icofont-animal-penguin:before {\n  content: \"\\e97e\";\n}\n\n.icofont-animal-pig-alt:before {\n  content: \"\\e97f\";\n}\n\n.icofont-animal-pig:before {\n  content: \"\\e980\";\n}\n\n.icofont-animal-pigeon-alt:before {\n  content: \"\\e981\";\n}\n\n.icofont-animal-pigeon:before {\n  content: \"\\e982\";\n}\n\n.icofont-animal-pigeons:before {\n  content: \"\\e983\";\n}\n\n.icofont-animal-rabbit-running:before {\n  content: \"\\e984\";\n}\n\n.icofont-animal-rat-alt:before {\n  content: \"\\e985\";\n}\n\n.icofont-animal-rhino-head:before {\n  content: \"\\e986\";\n}\n\n.icofont-animal-rhino:before {\n  content: \"\\e987\";\n}\n\n.icofont-animal-rooster:before {\n  content: \"\\e988\";\n}\n\n.icofont-animal-seahorse:before {\n  content: \"\\e989\";\n}\n\n.icofont-animal-seal:before {\n  content: \"\\e98a\";\n}\n\n.icofont-animal-shrimp:before {\n  content: \"\\e98b\";\n}\n\n.icofont-animal-snail-alt-1:before {\n  content: \"\\e98c\";\n}\n\n.icofont-animal-snail-alt-2:before {\n  content: \"\\e98d\";\n}\n\n.icofont-animal-snail:before {\n  content: \"\\e98e\";\n}\n\n.icofont-animal-snake:before {\n  content: \"\\e98f\";\n}\n\n.icofont-animal-squid:before {\n  content: \"\\e990\";\n}\n\n.icofont-animal-squirrel:before {\n  content: \"\\e991\";\n}\n\n.icofont-animal-tiger-alt:before {\n  content: \"\\e992\";\n}\n\n.icofont-animal-tiger:before {\n  content: \"\\e993\";\n}\n\n.icofont-animal-turtle:before {\n  content: \"\\e994\";\n}\n\n.icofont-animal-whale:before {\n  content: \"\\e995\";\n}\n\n.icofont-animal-woodpecker:before {\n  content: \"\\e996\";\n}\n\n.icofont-animal-zebra:before {\n  content: \"\\e997\";\n}\n\n.icofont-brand-acer:before {\n  content: \"\\e998\";\n}\n\n.icofont-brand-adidas:before {\n  content: \"\\e999\";\n}\n\n.icofont-brand-adobe:before {\n  content: \"\\e99a\";\n}\n\n.icofont-brand-air-new-zealand:before {\n  content: \"\\e99b\";\n}\n\n.icofont-brand-airbnb:before {\n  content: \"\\e99c\";\n}\n\n.icofont-brand-aircell:before {\n  content: \"\\e99d\";\n}\n\n.icofont-brand-airtel:before {\n  content: \"\\e99e\";\n}\n\n.icofont-brand-alcatel:before {\n  content: \"\\e99f\";\n}\n\n.icofont-brand-alibaba:before {\n  content: \"\\e9a0\";\n}\n\n.icofont-brand-aliexpress:before {\n  content: \"\\e9a1\";\n}\n\n.icofont-brand-alipay:before {\n  content: \"\\e9a2\";\n}\n\n.icofont-brand-amazon:before {\n  content: \"\\e9a3\";\n}\n\n.icofont-brand-amd:before {\n  content: \"\\e9a4\";\n}\n\n.icofont-brand-american-airlines:before {\n  content: \"\\e9a5\";\n}\n\n.icofont-brand-android-robot:before {\n  content: \"\\e9a6\";\n}\n\n.icofont-brand-android:before {\n  content: \"\\e9a7\";\n}\n\n.icofont-brand-aol:before {\n  content: \"\\e9a8\";\n}\n\n.icofont-brand-apple:before {\n  content: \"\\e9a9\";\n}\n\n.icofont-brand-appstore:before {\n  content: \"\\e9aa\";\n}\n\n.icofont-brand-asus:before {\n  content: \"\\e9ab\";\n}\n\n.icofont-brand-ati:before {\n  content: \"\\e9ac\";\n}\n\n.icofont-brand-att:before {\n  content: \"\\e9ad\";\n}\n\n.icofont-brand-audi:before {\n  content: \"\\e9ae\";\n}\n\n.icofont-brand-axiata:before {\n  content: \"\\e9af\";\n}\n\n.icofont-brand-bada:before {\n  content: \"\\e9b0\";\n}\n\n.icofont-brand-bbc:before {\n  content: \"\\e9b1\";\n}\n\n.icofont-brand-bing:before {\n  content: \"\\e9b2\";\n}\n\n.icofont-brand-blackberry:before {\n  content: \"\\e9b3\";\n}\n\n.icofont-brand-bmw:before {\n  content: \"\\e9b4\";\n}\n\n.icofont-brand-box:before {\n  content: \"\\e9b5\";\n}\n\n.icofont-brand-burger-king:before {\n  content: \"\\e9b6\";\n}\n\n.icofont-brand-business-insider:before {\n  content: \"\\e9b7\";\n}\n\n.icofont-brand-buzzfeed:before {\n  content: \"\\e9b8\";\n}\n\n.icofont-brand-cannon:before {\n  content: \"\\e9b9\";\n}\n\n.icofont-brand-casio:before {\n  content: \"\\e9ba\";\n}\n\n.icofont-brand-china-mobile:before {\n  content: \"\\e9bb\";\n}\n\n.icofont-brand-china-telecom:before {\n  content: \"\\e9bc\";\n}\n\n.icofont-brand-china-unicom:before {\n  content: \"\\e9bd\";\n}\n\n.icofont-brand-cisco:before {\n  content: \"\\e9be\";\n}\n\n.icofont-brand-citibank:before {\n  content: \"\\e9bf\";\n}\n\n.icofont-brand-cnet:before {\n  content: \"\\e9c0\";\n}\n\n.icofont-brand-cnn:before {\n  content: \"\\e9c1\";\n}\n\n.icofont-brand-cocal-cola:before {\n  content: \"\\e9c2\";\n}\n\n.icofont-brand-compaq:before {\n  content: \"\\e9c3\";\n}\n\n.icofont-brand-copy:before {\n  content: \"\\e9c4\";\n}\n\n.icofont-brand-debian:before {\n  content: \"\\e9c5\";\n}\n\n.icofont-brand-delicious:before {\n  content: \"\\e9c6\";\n}\n\n.icofont-brand-dell:before {\n  content: \"\\e9c7\";\n}\n\n.icofont-brand-designbump:before {\n  content: \"\\e9c8\";\n}\n\n.icofont-brand-designfloat:before {\n  content: \"\\e9c9\";\n}\n\n.icofont-brand-disney:before {\n  content: \"\\e9ca\";\n}\n\n.icofont-brand-dodge:before {\n  content: \"\\e9cb\";\n}\n\n.icofont-brand-dove:before {\n  content: \"\\e9cc\";\n}\n\n.icofont-brand-ebay:before {\n  content: \"\\e9cd\";\n}\n\n.icofont-brand-eleven:before {\n  content: \"\\e9ce\";\n}\n\n.icofont-brand-emirates:before {\n  content: \"\\e9cf\";\n}\n\n.icofont-brand-espn:before {\n  content: \"\\e9d0\";\n}\n\n.icofont-brand-etihad-airways:before {\n  content: \"\\e9d1\";\n}\n\n.icofont-brand-etisalat:before {\n  content: \"\\e9d2\";\n}\n\n.icofont-brand-etsy:before {\n  content: \"\\e9d3\";\n}\n\n.icofont-brand-facebook:before {\n  content: \"\\e9d4\";\n}\n\n.icofont-brand-fastrack:before {\n  content: \"\\e9d5\";\n}\n\n.icofont-brand-fedex:before {\n  content: \"\\e9d6\";\n}\n\n.icofont-brand-ferrari:before {\n  content: \"\\e9d7\";\n}\n\n.icofont-brand-fitbit:before {\n  content: \"\\e9d8\";\n}\n\n.icofont-brand-flikr:before {\n  content: \"\\e9d9\";\n}\n\n.icofont-brand-forbes:before {\n  content: \"\\e9da\";\n}\n\n.icofont-brand-foursquare:before {\n  content: \"\\e9db\";\n}\n\n.icofont-brand-fox:before {\n  content: \"\\e9dc\";\n}\n\n.icofont-brand-foxconn:before {\n  content: \"\\e9dd\";\n}\n\n.icofont-brand-fujitsu:before {\n  content: \"\\e9de\";\n}\n\n.icofont-brand-general-electric:before {\n  content: \"\\e9df\";\n}\n\n.icofont-brand-gillette:before {\n  content: \"\\e9e0\";\n}\n\n.icofont-brand-gizmodo:before {\n  content: \"\\e9e1\";\n}\n\n.icofont-brand-gnome:before {\n  content: \"\\e9e2\";\n}\n\n.icofont-brand-google:before {\n  content: \"\\e9e3\";\n}\n\n.icofont-brand-gopro:before {\n  content: \"\\e9e4\";\n}\n\n.icofont-brand-gucci:before {\n  content: \"\\e9e5\";\n}\n\n.icofont-brand-hallmark:before {\n  content: \"\\e9e6\";\n}\n\n.icofont-brand-hi5:before {\n  content: \"\\e9e7\";\n}\n\n.icofont-brand-honda:before {\n  content: \"\\e9e8\";\n}\n\n.icofont-brand-hp:before {\n  content: \"\\e9e9\";\n}\n\n.icofont-brand-hsbc:before {\n  content: \"\\e9ea\";\n}\n\n.icofont-brand-htc:before {\n  content: \"\\e9eb\";\n}\n\n.icofont-brand-huawei:before {\n  content: \"\\e9ec\";\n}\n\n.icofont-brand-hulu:before {\n  content: \"\\e9ed\";\n}\n\n.icofont-brand-hyundai:before {\n  content: \"\\e9ee\";\n}\n\n.icofont-brand-ibm:before {\n  content: \"\\e9ef\";\n}\n\n.icofont-brand-icofont:before {\n  content: \"\\e9f0\";\n}\n\n.icofont-brand-icq:before {\n  content: \"\\e9f1\";\n}\n\n.icofont-brand-ikea:before {\n  content: \"\\e9f2\";\n}\n\n.icofont-brand-imdb:before {\n  content: \"\\e9f3\";\n}\n\n.icofont-brand-indiegogo:before {\n  content: \"\\e9f4\";\n}\n\n.icofont-brand-intel:before {\n  content: \"\\e9f5\";\n}\n\n.icofont-brand-ipair:before {\n  content: \"\\e9f6\";\n}\n\n.icofont-brand-jaguar:before {\n  content: \"\\e9f7\";\n}\n\n.icofont-brand-java:before {\n  content: \"\\e9f8\";\n}\n\n.icofont-brand-joomshaper:before {\n  content: \"\\e9f9\";\n}\n\n.icofont-brand-kickstarter:before {\n  content: \"\\e9fa\";\n}\n\n.icofont-brand-kik:before {\n  content: \"\\e9fb\";\n}\n\n.icofont-brand-lastfm:before {\n  content: \"\\e9fc\";\n}\n\n.icofont-brand-lego:before {\n  content: \"\\e9fd\";\n}\n\n.icofont-brand-lenovo:before {\n  content: \"\\e9fe\";\n}\n\n.icofont-brand-levis:before {\n  content: \"\\e9ff\";\n}\n\n.icofont-brand-lexus:before {\n  content: \"\\ea00\";\n}\n\n.icofont-brand-lg:before {\n  content: \"\\ea01\";\n}\n\n.icofont-brand-life-hacker:before {\n  content: \"\\ea02\";\n}\n\n.icofont-brand-line-messenger:before {\n  content: \"\\ea03\";\n}\n\n.icofont-brand-linkedin:before {\n  content: \"\\ea04\";\n}\n\n.icofont-brand-linux-mint:before {\n  content: \"\\ea05\";\n}\n\n.icofont-brand-linux:before {\n  content: \"\\ea06\";\n}\n\n.icofont-brand-lionix:before {\n  content: \"\\ea07\";\n}\n\n.icofont-brand-live-messenger:before {\n  content: \"\\ea08\";\n}\n\n.icofont-brand-loreal:before {\n  content: \"\\ea09\";\n}\n\n.icofont-brand-louis-vuitton:before {\n  content: \"\\ea0a\";\n}\n\n.icofont-brand-mac-os:before {\n  content: \"\\ea0b\";\n}\n\n.icofont-brand-marvel-app:before {\n  content: \"\\ea0c\";\n}\n\n.icofont-brand-mashable:before {\n  content: \"\\ea0d\";\n}\n\n.icofont-brand-mazda:before {\n  content: \"\\ea0e\";\n}\n\n.icofont-brand-mcdonals:before {\n  content: \"\\ea0f\";\n}\n\n.icofont-brand-mercedes:before {\n  content: \"\\ea10\";\n}\n\n.icofont-brand-micromax:before {\n  content: \"\\ea11\";\n}\n\n.icofont-brand-microsoft:before {\n  content: \"\\ea12\";\n}\n\n.icofont-brand-mobileme:before {\n  content: \"\\ea13\";\n}\n\n.icofont-brand-mobily:before {\n  content: \"\\ea14\";\n}\n\n.icofont-brand-motorola:before {\n  content: \"\\ea15\";\n}\n\n.icofont-brand-msi:before {\n  content: \"\\ea16\";\n}\n\n.icofont-brand-mts:before {\n  content: \"\\ea17\";\n}\n\n.icofont-brand-myspace:before {\n  content: \"\\ea18\";\n}\n\n.icofont-brand-mytv:before {\n  content: \"\\ea19\";\n}\n\n.icofont-brand-nasa:before {\n  content: \"\\ea1a\";\n}\n\n.icofont-brand-natgeo:before {\n  content: \"\\ea1b\";\n}\n\n.icofont-brand-nbc:before {\n  content: \"\\ea1c\";\n}\n\n.icofont-brand-nescafe:before {\n  content: \"\\ea1d\";\n}\n\n.icofont-brand-nestle:before {\n  content: \"\\ea1e\";\n}\n\n.icofont-brand-netflix:before {\n  content: \"\\ea1f\";\n}\n\n.icofont-brand-nexus:before {\n  content: \"\\ea20\";\n}\n\n.icofont-brand-nike:before {\n  content: \"\\ea21\";\n}\n\n.icofont-brand-nokia:before {\n  content: \"\\ea22\";\n}\n\n.icofont-brand-nvidia:before {\n  content: \"\\ea23\";\n}\n\n.icofont-brand-omega:before {\n  content: \"\\ea24\";\n}\n\n.icofont-brand-opensuse:before {\n  content: \"\\ea25\";\n}\n\n.icofont-brand-oracle:before {\n  content: \"\\ea26\";\n}\n\n.icofont-brand-panasonic:before {\n  content: \"\\ea27\";\n}\n\n.icofont-brand-paypal:before {\n  content: \"\\ea28\";\n}\n\n.icofont-brand-pepsi:before {\n  content: \"\\ea29\";\n}\n\n.icofont-brand-philips:before {\n  content: \"\\ea2a\";\n}\n\n.icofont-brand-pizza-hut:before {\n  content: \"\\ea2b\";\n}\n\n.icofont-brand-playstation:before {\n  content: \"\\ea2c\";\n}\n\n.icofont-brand-puma:before {\n  content: \"\\ea2d\";\n}\n\n.icofont-brand-qatar-air:before {\n  content: \"\\ea2e\";\n}\n\n.icofont-brand-qvc:before {\n  content: \"\\ea2f\";\n}\n\n.icofont-brand-readernaut:before {\n  content: \"\\ea30\";\n}\n\n.icofont-brand-redbull:before {\n  content: \"\\ea31\";\n}\n\n.icofont-brand-reebok:before {\n  content: \"\\ea32\";\n}\n\n.icofont-brand-reuters:before {\n  content: \"\\ea33\";\n}\n\n.icofont-brand-samsung:before {\n  content: \"\\ea34\";\n}\n\n.icofont-brand-sap:before {\n  content: \"\\ea35\";\n}\n\n.icofont-brand-saudia-airlines:before {\n  content: \"\\ea36\";\n}\n\n.icofont-brand-scribd:before {\n  content: \"\\ea37\";\n}\n\n.icofont-brand-shell:before {\n  content: \"\\ea38\";\n}\n\n.icofont-brand-siemens:before {\n  content: \"\\ea39\";\n}\n\n.icofont-brand-sk-telecom:before {\n  content: \"\\ea3a\";\n}\n\n.icofont-brand-slideshare:before {\n  content: \"\\ea3b\";\n}\n\n.icofont-brand-smashing-magazine:before {\n  content: \"\\ea3c\";\n}\n\n.icofont-brand-snapchat:before {\n  content: \"\\ea3d\";\n}\n\n.icofont-brand-sony-ericsson:before {\n  content: \"\\ea3e\";\n}\n\n.icofont-brand-sony:before {\n  content: \"\\ea3f\";\n}\n\n.icofont-brand-soundcloud:before {\n  content: \"\\ea40\";\n}\n\n.icofont-brand-sprint:before {\n  content: \"\\ea41\";\n}\n\n.icofont-brand-squidoo:before {\n  content: \"\\ea42\";\n}\n\n.icofont-brand-starbucks:before {\n  content: \"\\ea43\";\n}\n\n.icofont-brand-stc:before {\n  content: \"\\ea44\";\n}\n\n.icofont-brand-steam:before {\n  content: \"\\ea45\";\n}\n\n.icofont-brand-suzuki:before {\n  content: \"\\ea46\";\n}\n\n.icofont-brand-symbian:before {\n  content: \"\\ea47\";\n}\n\n.icofont-brand-t-mobile:before {\n  content: \"\\ea48\";\n}\n\n.icofont-brand-tango:before {\n  content: \"\\ea49\";\n}\n\n.icofont-brand-target:before {\n  content: \"\\ea4a\";\n}\n\n.icofont-brand-tata-indicom:before {\n  content: \"\\ea4b\";\n}\n\n.icofont-brand-techcrunch:before {\n  content: \"\\ea4c\";\n}\n\n.icofont-brand-telenor:before {\n  content: \"\\ea4d\";\n}\n\n.icofont-brand-teliasonera:before {\n  content: \"\\ea4e\";\n}\n\n.icofont-brand-tesla:before {\n  content: \"\\ea4f\";\n}\n\n.icofont-brand-the-verge:before {\n  content: \"\\ea50\";\n}\n\n.icofont-brand-thenextweb:before {\n  content: \"\\ea51\";\n}\n\n.icofont-brand-toshiba:before {\n  content: \"\\ea52\";\n}\n\n.icofont-brand-toyota:before {\n  content: \"\\ea53\";\n}\n\n.icofont-brand-tribenet:before {\n  content: \"\\ea54\";\n}\n\n.icofont-brand-ubuntu:before {\n  content: \"\\ea55\";\n}\n\n.icofont-brand-unilever:before {\n  content: \"\\ea56\";\n}\n\n.icofont-brand-vaio:before {\n  content: \"\\ea57\";\n}\n\n.icofont-brand-verizon:before {\n  content: \"\\ea58\";\n}\n\n.icofont-brand-viber:before {\n  content: \"\\ea59\";\n}\n\n.icofont-brand-vodafone:before {\n  content: \"\\ea5a\";\n}\n\n.icofont-brand-volkswagen:before {\n  content: \"\\ea5b\";\n}\n\n.icofont-brand-walmart:before {\n  content: \"\\ea5c\";\n}\n\n.icofont-brand-warnerbros:before {\n  content: \"\\ea5d\";\n}\n\n.icofont-brand-whatsapp:before {\n  content: \"\\ea5e\";\n}\n\n.icofont-brand-wikipedia:before {\n  content: \"\\ea5f\";\n}\n\n.icofont-brand-windows:before {\n  content: \"\\ea60\";\n}\n\n.icofont-brand-wire:before {\n  content: \"\\ea61\";\n}\n\n.icofont-brand-yahoobuzz:before {\n  content: \"\\ea62\";\n}\n\n.icofont-brand-yamaha:before {\n  content: \"\\ea63\";\n}\n\n.icofont-brand-youtube:before {\n  content: \"\\ea64\";\n}\n\n.icofont-brand-zain:before {\n  content: \"\\ea65\";\n}\n\n.icofont-bank-alt:before {\n  content: \"\\ea66\";\n}\n\n.icofont-barcode:before {\n  content: \"\\ea67\";\n}\n\n.icofont-basket:before {\n  content: \"\\ea68\";\n}\n\n.icofont-bill-alt:before {\n  content: \"\\ea69\";\n}\n\n.icofont-billboard:before {\n  content: \"\\ea6a\";\n}\n\n.icofont-briefcase-alt-1:before {\n  content: \"\\ea6b\";\n}\n\n.icofont-briefcase-alt-2:before {\n  content: \"\\ea6c\";\n}\n\n.icofont-building-alt:before {\n  content: \"\\ea6d\";\n}\n\n.icofont-businessman:before {\n  content: \"\\ea6e\";\n}\n\n.icofont-businesswoman:before {\n  content: \"\\ea6f\";\n}\n\n.icofont-cart-alt:before {\n  content: \"\\ea70\";\n}\n\n.icofont-chair:before {\n  content: \"\\ea71\";\n}\n\n.icofont-clip:before {\n  content: \"\\ea72\";\n}\n\n.icofont-coins:before {\n  content: \"\\ea73\";\n}\n\n.icofont-company:before {\n  content: \"\\ea74\";\n}\n\n.icofont-contact-add:before {\n  content: \"\\ea75\";\n}\n\n.icofont-deal:before {\n  content: \"\\ea76\";\n}\n\n.icofont-files:before {\n  content: \"\\ea77\";\n}\n\n.icofont-growth:before {\n  content: \"\\ea78\";\n}\n\n.icofont-id-card:before {\n  content: \"\\ea79\";\n}\n\n.icofont-idea:before {\n  content: \"\\ea7a\";\n}\n\n.icofont-list:before {\n  content: \"\\ea7b\";\n}\n\n.icofont-meeting-add:before {\n  content: \"\\ea7c\";\n}\n\n.icofont-money-bag:before {\n  content: \"\\ea7d\";\n}\n\n.icofont-people:before {\n  content: \"\\ea7e\";\n}\n\n.icofont-pie-chart:before {\n  content: \"\\ea7f\";\n}\n\n.icofont-presentation-alt:before {\n  content: \"\\ea80\";\n}\n\n.icofont-stamp:before {\n  content: \"\\ea81\";\n}\n\n.icofont-stock-mobile:before {\n  content: \"\\ea82\";\n}\n\n.icofont-support:before {\n  content: \"\\ea83\";\n}\n\n.icofont-tasks-alt:before {\n  content: \"\\ea84\";\n}\n\n.icofont-wheel:before {\n  content: \"\\ea85\";\n}\n\n.icofont-chart-arrows-axis:before {\n  content: \"\\ea86\";\n}\n\n.icofont-chart-bar-graph:before {\n  content: \"\\ea87\";\n}\n\n.icofont-chart-flow-alt-1:before {\n  content: \"\\ea88\";\n}\n\n.icofont-chart-flow-alt-2:before {\n  content: \"\\ea89\";\n}\n\n.icofont-chart-flow:before {\n  content: \"\\ea8a\";\n}\n\n.icofont-chart-histogram-alt:before {\n  content: \"\\ea8b\";\n}\n\n.icofont-chart-histogram:before {\n  content: \"\\ea8c\";\n}\n\n.icofont-chart-line-alt:before {\n  content: \"\\ea8d\";\n}\n\n.icofont-chart-line:before {\n  content: \"\\ea8e\";\n}\n\n.icofont-chart-pie-alt:before {\n  content: \"\\ea8f\";\n}\n\n.icofont-chart-pie:before {\n  content: \"\\ea90\";\n}\n\n.icofont-chart-radar-graph:before {\n  content: \"\\ea91\";\n}\n\n.icofont-cur-afghani-false:before {\n  content: \"\\ea92\";\n}\n\n.icofont-cur-afghani-minus:before {\n  content: \"\\ea93\";\n}\n\n.icofont-cur-afghani-plus:before {\n  content: \"\\ea94\";\n}\n\n.icofont-cur-afghani-true:before {\n  content: \"\\ea95\";\n}\n\n.icofont-cur-afghani:before {\n  content: \"\\ea96\";\n}\n\n.icofont-cur-baht-false:before {\n  content: \"\\ea97\";\n}\n\n.icofont-cur-baht-minus:before {\n  content: \"\\ea98\";\n}\n\n.icofont-cur-baht-plus:before {\n  content: \"\\ea99\";\n}\n\n.icofont-cur-baht-true:before {\n  content: \"\\ea9a\";\n}\n\n.icofont-cur-baht:before {\n  content: \"\\ea9b\";\n}\n\n.icofont-cur-bitcoin-false:before {\n  content: \"\\ea9c\";\n}\n\n.icofont-cur-bitcoin-minus:before {\n  content: \"\\ea9d\";\n}\n\n.icofont-cur-bitcoin-plus:before {\n  content: \"\\ea9e\";\n}\n\n.icofont-cur-bitcoin-true:before {\n  content: \"\\ea9f\";\n}\n\n.icofont-cur-bitcoin:before {\n  content: \"\\eaa0\";\n}\n\n.icofont-cur-dollar-flase:before {\n  content: \"\\eaa1\";\n}\n\n.icofont-cur-dollar-minus:before {\n  content: \"\\eaa2\";\n}\n\n.icofont-cur-dollar-plus:before {\n  content: \"\\eaa3\";\n}\n\n.icofont-cur-dollar-true:before {\n  content: \"\\eaa4\";\n}\n\n.icofont-cur-dollar:before {\n  content: \"\\eaa5\";\n}\n\n.icofont-cur-dong-false:before {\n  content: \"\\eaa6\";\n}\n\n.icofont-cur-dong-minus:before {\n  content: \"\\eaa7\";\n}\n\n.icofont-cur-dong-plus:before {\n  content: \"\\eaa8\";\n}\n\n.icofont-cur-dong-true:before {\n  content: \"\\eaa9\";\n}\n\n.icofont-cur-dong:before {\n  content: \"\\eaaa\";\n}\n\n.icofont-cur-euro-false:before {\n  content: \"\\eaab\";\n}\n\n.icofont-cur-euro-minus:before {\n  content: \"\\eaac\";\n}\n\n.icofont-cur-euro-plus:before {\n  content: \"\\eaad\";\n}\n\n.icofont-cur-euro-true:before {\n  content: \"\\eaae\";\n}\n\n.icofont-cur-euro:before {\n  content: \"\\eaaf\";\n}\n\n.icofont-cur-frank-false:before {\n  content: \"\\eab0\";\n}\n\n.icofont-cur-frank-minus:before {\n  content: \"\\eab1\";\n}\n\n.icofont-cur-frank-plus:before {\n  content: \"\\eab2\";\n}\n\n.icofont-cur-frank-true:before {\n  content: \"\\eab3\";\n}\n\n.icofont-cur-frank:before {\n  content: \"\\eab4\";\n}\n\n.icofont-cur-hryvnia-false:before {\n  content: \"\\eab5\";\n}\n\n.icofont-cur-hryvnia-minus:before {\n  content: \"\\eab6\";\n}\n\n.icofont-cur-hryvnia-plus:before {\n  content: \"\\eab7\";\n}\n\n.icofont-cur-hryvnia-true:before {\n  content: \"\\eab8\";\n}\n\n.icofont-cur-hryvnia:before {\n  content: \"\\eab9\";\n}\n\n.icofont-cur-lira-false:before {\n  content: \"\\eaba\";\n}\n\n.icofont-cur-lira-minus:before {\n  content: \"\\eabb\";\n}\n\n.icofont-cur-lira-plus:before {\n  content: \"\\eabc\";\n}\n\n.icofont-cur-lira-true:before {\n  content: \"\\eabd\";\n}\n\n.icofont-cur-lira:before {\n  content: \"\\eabe\";\n}\n\n.icofont-cur-peseta-false:before {\n  content: \"\\eabf\";\n}\n\n.icofont-cur-peseta-minus:before {\n  content: \"\\eac0\";\n}\n\n.icofont-cur-peseta-plus:before {\n  content: \"\\eac1\";\n}\n\n.icofont-cur-peseta-true:before {\n  content: \"\\eac2\";\n}\n\n.icofont-cur-peseta:before {\n  content: \"\\eac3\";\n}\n\n.icofont-cur-peso-false:before {\n  content: \"\\eac4\";\n}\n\n.icofont-cur-peso-minus:before {\n  content: \"\\eac5\";\n}\n\n.icofont-cur-peso-plus:before {\n  content: \"\\eac6\";\n}\n\n.icofont-cur-peso-true:before {\n  content: \"\\eac7\";\n}\n\n.icofont-cur-peso:before {\n  content: \"\\eac8\";\n}\n\n.icofont-cur-pound-false:before {\n  content: \"\\eac9\";\n}\n\n.icofont-cur-pound-minus:before {\n  content: \"\\eaca\";\n}\n\n.icofont-cur-pound-plus:before {\n  content: \"\\eacb\";\n}\n\n.icofont-cur-pound-true:before {\n  content: \"\\eacc\";\n}\n\n.icofont-cur-pound:before {\n  content: \"\\eacd\";\n}\n\n.icofont-cur-renminbi-false:before {\n  content: \"\\eace\";\n}\n\n.icofont-cur-renminbi-minus:before {\n  content: \"\\eacf\";\n}\n\n.icofont-cur-renminbi-plus:before {\n  content: \"\\ead0\";\n}\n\n.icofont-cur-renminbi-true:before {\n  content: \"\\ead1\";\n}\n\n.icofont-cur-renminbi:before {\n  content: \"\\ead2\";\n}\n\n.icofont-cur-riyal-false:before {\n  content: \"\\ead3\";\n}\n\n.icofont-cur-riyal-minus:before {\n  content: \"\\ead4\";\n}\n\n.icofont-cur-riyal-plus:before {\n  content: \"\\ead5\";\n}\n\n.icofont-cur-riyal-true:before {\n  content: \"\\ead6\";\n}\n\n.icofont-cur-riyal:before {\n  content: \"\\ead7\";\n}\n\n.icofont-cur-rouble-false:before {\n  content: \"\\ead8\";\n}\n\n.icofont-cur-rouble-minus:before {\n  content: \"\\ead9\";\n}\n\n.icofont-cur-rouble-plus:before {\n  content: \"\\eada\";\n}\n\n.icofont-cur-rouble-true:before {\n  content: \"\\eadb\";\n}\n\n.icofont-cur-rouble:before {\n  content: \"\\eadc\";\n}\n\n.icofont-cur-rupee-false:before {\n  content: \"\\eadd\";\n}\n\n.icofont-cur-rupee-minus:before {\n  content: \"\\eade\";\n}\n\n.icofont-cur-rupee-plus:before {\n  content: \"\\eadf\";\n}\n\n.icofont-cur-rupee-true:before {\n  content: \"\\eae0\";\n}\n\n.icofont-cur-rupee:before {\n  content: \"\\eae1\";\n}\n\n.icofont-cur-taka-false:before {\n  content: \"\\eae2\";\n}\n\n.icofont-cur-taka-minus:before {\n  content: \"\\eae3\";\n}\n\n.icofont-cur-taka-plus:before {\n  content: \"\\eae4\";\n}\n\n.icofont-cur-taka-true:before {\n  content: \"\\eae5\";\n}\n\n.icofont-cur-taka:before {\n  content: \"\\eae6\";\n}\n\n.icofont-cur-turkish-lira-false:before {\n  content: \"\\eae7\";\n}\n\n.icofont-cur-turkish-lira-minus:before {\n  content: \"\\eae8\";\n}\n\n.icofont-cur-turkish-lira-plus:before {\n  content: \"\\eae9\";\n}\n\n.icofont-cur-turkish-lira-true:before {\n  content: \"\\eaea\";\n}\n\n.icofont-cur-turkish-lira:before {\n  content: \"\\eaeb\";\n}\n\n.icofont-cur-won-false:before {\n  content: \"\\eaec\";\n}\n\n.icofont-cur-won-minus:before {\n  content: \"\\eaed\";\n}\n\n.icofont-cur-won-plus:before {\n  content: \"\\eaee\";\n}\n\n.icofont-cur-won-true:before {\n  content: \"\\eaef\";\n}\n\n.icofont-cur-won:before {\n  content: \"\\eaf0\";\n}\n\n.icofont-cur-yen-false:before {\n  content: \"\\eaf1\";\n}\n\n.icofont-cur-yen-minus:before {\n  content: \"\\eaf2\";\n}\n\n.icofont-cur-yen-plus:before {\n  content: \"\\eaf3\";\n}\n\n.icofont-cur-yen-true:before {\n  content: \"\\eaf4\";\n}\n\n.icofont-cur-yen:before {\n  content: \"\\eaf5\";\n}\n\n.icofont-android-nexus:before {\n  content: \"\\eaf6\";\n}\n\n.icofont-android-tablet:before {\n  content: \"\\eaf7\";\n}\n\n.icofont-apple-watch:before {\n  content: \"\\eaf8\";\n}\n\n.icofont-drwaing-tablet:before {\n  content: \"\\eaf9\";\n}\n\n.icofont-earphone:before {\n  content: \"\\eafa\";\n}\n\n.icofont-flash-drive:before {\n  content: \"\\eafb\";\n}\n\n.icofont-game-control:before {\n  content: \"\\eafc\";\n}\n\n.icofont-headphone-alt:before {\n  content: \"\\eafd\";\n}\n\n.icofont-htc-one:before {\n  content: \"\\eafe\";\n}\n\n.icofont-imac:before {\n  content: \"\\eaff\";\n}\n\n.icofont-ipad-touch:before {\n  content: \"\\eb00\";\n}\n\n.icofont-iphone:before {\n  content: \"\\eb01\";\n}\n\n.icofont-ipod-nano:before {\n  content: \"\\eb02\";\n}\n\n.icofont-ipod-touch:before {\n  content: \"\\eb03\";\n}\n\n.icofont-keyboard-alt:before {\n  content: \"\\eb04\";\n}\n\n.icofont-keyboard-wireless:before {\n  content: \"\\eb05\";\n}\n\n.icofont-laptop-alt:before {\n  content: \"\\eb06\";\n}\n\n.icofont-macbook:before {\n  content: \"\\eb07\";\n}\n\n.icofont-magic-mouse:before {\n  content: \"\\eb08\";\n}\n\n.icofont-microphone-alt:before {\n  content: \"\\eb09\";\n}\n\n.icofont-monitor:before {\n  content: \"\\eb0a\";\n}\n\n.icofont-mouse:before {\n  content: \"\\eb0b\";\n}\n\n.icofont-nintendo:before {\n  content: \"\\eb0c\";\n}\n\n.icofont-playstation:before {\n  content: \"\\eb0d\";\n}\n\n.icofont-psvita:before {\n  content: \"\\eb0e\";\n}\n\n.icofont-radio-mic:before {\n  content: \"\\eb0f\";\n}\n\n.icofont-refrigerator:before {\n  content: \"\\eb10\";\n}\n\n.icofont-samsung-galaxy:before {\n  content: \"\\eb11\";\n}\n\n.icofont-surface-tablet:before {\n  content: \"\\eb12\";\n}\n\n.icofont-washing-machine:before {\n  content: \"\\eb13\";\n}\n\n.icofont-wifi-router:before {\n  content: \"\\eb14\";\n}\n\n.icofont-wii-u:before {\n  content: \"\\eb15\";\n}\n\n.icofont-windows-lumia:before {\n  content: \"\\eb16\";\n}\n\n.icofont-wireless-mouse:before {\n  content: \"\\eb17\";\n}\n\n.icofont-xbox-360:before {\n  content: \"\\eb18\";\n}\n\n.icofont-arrow-down:before {\n  content: \"\\eb19\";\n}\n\n.icofont-arrow-left:before {\n  content: \"\\eb1a\";\n}\n\n.icofont-arrow-right:before {\n  content: \"\\eb1b\";\n}\n\n.icofont-arrow-up:before {\n  content: \"\\eb1c\";\n}\n\n.icofont-block-down:before {\n  content: \"\\eb1d\";\n}\n\n.icofont-block-left:before {\n  content: \"\\eb1e\";\n}\n\n.icofont-block-right:before {\n  content: \"\\eb1f\";\n}\n\n.icofont-block-up:before {\n  content: \"\\eb20\";\n}\n\n.icofont-bubble-down:before {\n  content: \"\\eb21\";\n}\n\n.icofont-bubble-left:before {\n  content: \"\\eb22\";\n}\n\n.icofont-bubble-right:before {\n  content: \"\\eb23\";\n}\n\n.icofont-bubble-up:before {\n  content: \"\\eb24\";\n}\n\n.icofont-caret-down:before {\n  content: \"\\eb25\";\n}\n\n.icofont-caret-left:before {\n  content: \"\\eb26\";\n}\n\n.icofont-caret-right:before {\n  content: \"\\eb27\";\n}\n\n.icofont-caret-up:before {\n  content: \"\\eb28\";\n}\n\n.icofont-circled-down:before {\n  content: \"\\eb29\";\n}\n\n.icofont-circled-left:before {\n  content: \"\\eb2a\";\n}\n\n.icofont-circled-right:before {\n  content: \"\\eb2b\";\n}\n\n.icofont-circled-up:before {\n  content: \"\\eb2c\";\n}\n\n.icofont-collapse:before {\n  content: \"\\eb2d\";\n}\n\n.icofont-cursor-drag:before {\n  content: \"\\eb2e\";\n}\n\n.icofont-curved-double-left:before {\n  content: \"\\eb2f\";\n}\n\n.icofont-curved-double-right:before {\n  content: \"\\eb30\";\n}\n\n.icofont-curved-down:before {\n  content: \"\\eb31\";\n}\n\n.icofont-curved-left:before {\n  content: \"\\eb32\";\n}\n\n.icofont-curved-right:before {\n  content: \"\\eb33\";\n}\n\n.icofont-curved-up:before {\n  content: \"\\eb34\";\n}\n\n.icofont-dotted-down:before {\n  content: \"\\eb35\";\n}\n\n.icofont-dotted-left:before {\n  content: \"\\eb36\";\n}\n\n.icofont-dotted-right:before {\n  content: \"\\eb37\";\n}\n\n.icofont-dotted-up:before {\n  content: \"\\eb38\";\n}\n\n.icofont-double-left:before {\n  content: \"\\eb39\";\n}\n\n.icofont-double-right:before {\n  content: \"\\eb3a\";\n}\n\n.icofont-drag:before {\n  content: \"\\eb3b\";\n}\n\n.icofont-drag1:before {\n  content: \"\\eb3c\";\n}\n\n.icofont-drag2:before {\n  content: \"\\eb3d\";\n}\n\n.icofont-drag3:before {\n  content: \"\\eb3e\";\n}\n\n.icofont-expand-alt:before {\n  content: \"\\eb3f\";\n}\n\n.icofont-hand-down:before {\n  content: \"\\eb40\";\n}\n\n.icofont-hand-drag:before {\n  content: \"\\eb41\";\n}\n\n.icofont-hand-drag1:before {\n  content: \"\\eb42\";\n}\n\n.icofont-hand-drag2:before {\n  content: \"\\eb43\";\n}\n\n.icofont-hand-drawn-alt-down:before {\n  content: \"\\eb44\";\n}\n\n.icofont-hand-drawn-alt-left:before {\n  content: \"\\eb45\";\n}\n\n.icofont-hand-drawn-alt-right:before {\n  content: \"\\eb46\";\n}\n\n.icofont-hand-drawn-alt-up:before {\n  content: \"\\eb47\";\n}\n\n.icofont-hand-drawn-down:before {\n  content: \"\\eb48\";\n}\n\n.icofont-hand-drawn-left:before {\n  content: \"\\eb49\";\n}\n\n.icofont-hand-drawn-right:before {\n  content: \"\\eb4a\";\n}\n\n.icofont-hand-drawn-up:before {\n  content: \"\\eb4b\";\n}\n\n.icofont-hand-left:before {\n  content: \"\\eb4c\";\n}\n\n.icofont-hand-right:before {\n  content: \"\\eb4d\";\n}\n\n.icofont-hand-up:before {\n  content: \"\\eb4e\";\n}\n\n.icofont-line-block-down:before {\n  content: \"\\eb4f\";\n}\n\n.icofont-line-block-left:before {\n  content: \"\\eb50\";\n}\n\n.icofont-line-block-right:before {\n  content: \"\\eb51\";\n}\n\n.icofont-line-block-up:before {\n  content: \"\\eb52\";\n}\n\n.icofont-long-arrow-down:before {\n  content: \"\\eb53\";\n}\n\n.icofont-long-arrow-left:before {\n  content: \"\\eb54\";\n}\n\n.icofont-long-arrow-right:before {\n  content: \"\\eb55\";\n}\n\n.icofont-long-arrow-up:before {\n  content: \"\\eb56\";\n}\n\n.icofont-rounded-collapse:before {\n  content: \"\\eb57\";\n}\n\n.icofont-rounded-double-left:before {\n  content: \"\\eb58\";\n}\n\n.icofont-rounded-double-right:before {\n  content: \"\\eb59\";\n}\n\n.icofont-rounded-down:before {\n  content: \"\\eb5a\";\n}\n\n.icofont-rounded-expand:before {\n  content: \"\\eb5b\";\n}\n\n.icofont-rounded-left-down:before {\n  content: \"\\eb5c\";\n}\n\n.icofont-rounded-left-up:before {\n  content: \"\\eb5d\";\n}\n\n.icofont-rounded-left:before {\n  content: \"\\eb5e\";\n}\n\n.icofont-rounded-right-down:before {\n  content: \"\\eb5f\";\n}\n\n.icofont-rounded-right-up:before {\n  content: \"\\eb60\";\n}\n\n.icofont-rounded-right:before {\n  content: \"\\eb61\";\n}\n\n.icofont-rounded-up:before {\n  content: \"\\eb62\";\n}\n\n.icofont-scroll-bubble-down:before {\n  content: \"\\eb63\";\n}\n\n.icofont-scroll-bubble-left:before {\n  content: \"\\eb64\";\n}\n\n.icofont-scroll-bubble-right:before {\n  content: \"\\eb65\";\n}\n\n.icofont-scroll-bubble-up:before {\n  content: \"\\eb66\";\n}\n\n.icofont-scroll-double-down:before {\n  content: \"\\eb67\";\n}\n\n.icofont-scroll-double-left:before {\n  content: \"\\eb68\";\n}\n\n.icofont-scroll-double-right:before {\n  content: \"\\eb69\";\n}\n\n.icofont-scroll-double-up:before {\n  content: \"\\eb6a\";\n}\n\n.icofont-scroll-down:before {\n  content: \"\\eb6b\";\n}\n\n.icofont-scroll-left:before {\n  content: \"\\eb6c\";\n}\n\n.icofont-scroll-long-down:before {\n  content: \"\\eb6d\";\n}\n\n.icofont-scroll-long-left:before {\n  content: \"\\eb6e\";\n}\n\n.icofont-scroll-long-right:before {\n  content: \"\\eb6f\";\n}\n\n.icofont-scroll-long-up:before {\n  content: \"\\eb70\";\n}\n\n.icofont-scroll-right:before {\n  content: \"\\eb71\";\n}\n\n.icofont-scroll-up:before {\n  content: \"\\eb72\";\n}\n\n.icofont-simple-down:before {\n  content: \"\\eb73\";\n}\n\n.icofont-simple-left-down:before {\n  content: \"\\eb74\";\n}\n\n.icofont-simple-left-up:before {\n  content: \"\\eb75\";\n}\n\n.icofont-simple-left:before {\n  content: \"\\eb76\";\n}\n\n.icofont-simple-right-down:before {\n  content: \"\\eb77\";\n}\n\n.icofont-simple-right-up:before {\n  content: \"\\eb78\";\n}\n\n.icofont-simple-right:before {\n  content: \"\\eb79\";\n}\n\n.icofont-simple-up:before {\n  content: \"\\eb7a\";\n}\n\n.icofont-square-down:before {\n  content: \"\\eb7b\";\n}\n\n.icofont-square-left:before {\n  content: \"\\eb7c\";\n}\n\n.icofont-square-right:before {\n  content: \"\\eb7d\";\n}\n\n.icofont-square-up:before {\n  content: \"\\eb7e\";\n}\n\n.icofont-stylish-down:before {\n  content: \"\\eb7f\";\n}\n\n.icofont-stylish-left:before {\n  content: \"\\eb80\";\n}\n\n.icofont-stylish-right:before {\n  content: \"\\eb81\";\n}\n\n.icofont-stylish-up:before {\n  content: \"\\eb82\";\n}\n\n.icofont-swoosh-down:before {\n  content: \"\\eb83\";\n}\n\n.icofont-swoosh-left:before {\n  content: \"\\eb84\";\n}\n\n.icofont-swoosh-right:before {\n  content: \"\\eb85\";\n}\n\n.icofont-swoosh-up:before {\n  content: \"\\eb86\";\n}\n\n.icofont-thin-double-left:before {\n  content: \"\\eb87\";\n}\n\n.icofont-thin-double-right:before {\n  content: \"\\eb88\";\n}\n\n.icofont-thin-down:before {\n  content: \"\\eb89\";\n}\n\n.icofont-thin-left:before {\n  content: \"\\eb8a\";\n}\n\n.icofont-thin-right:before {\n  content: \"\\eb8b\";\n}\n\n.icofont-thin-up:before {\n  content: \"\\eb8c\";\n}\n\n.icofont-atom:before {\n  content: \"\\eb8d\";\n}\n\n.icofont-award:before {\n  content: \"\\eb8e\";\n}\n\n.icofont-bell-alt:before {\n  content: \"\\eb8f\";\n}\n\n.icofont-book-alt:before {\n  content: \"\\eb90\";\n}\n\n.icofont-brainstorming:before {\n  content: \"\\eb91\";\n}\n\n.icofont-certificate-alt-1:before {\n  content: \"\\eb92\";\n}\n\n.icofont-certificate-alt-2:before {\n  content: \"\\eb93\";\n}\n\n.icofont-dna-alt-2:before {\n  content: \"\\eb94\";\n}\n\n.icofont-education:before {\n  content: \"\\eb95\";\n}\n\n.icofont-electron:before {\n  content: \"\\eb96\";\n}\n\n.icofont-fountain-pen:before {\n  content: \"\\eb97\";\n}\n\n.icofont-globe-alt:before {\n  content: \"\\eb98\";\n}\n\n.icofont-graduate-alt:before {\n  content: \"\\eb99\";\n}\n\n.icofont-group-students:before {\n  content: \"\\eb9a\";\n}\n\n.icofont-hat-alt:before {\n  content: \"\\eb9b\";\n}\n\n.icofont-hat:before {\n  content: \"\\eb9c\";\n}\n\n.icofont-instrument:before {\n  content: \"\\eb9d\";\n}\n\n.icofont-lamp-light:before {\n  content: \"\\eb9e\";\n}\n\n.icofont-microscope-alt:before {\n  content: \"\\eb9f\";\n}\n\n.icofont-paper:before {\n  content: \"\\eba0\";\n}\n\n.icofont-pen-alt-4:before {\n  content: \"\\eba1\";\n}\n\n.icofont-pen-nib:before {\n  content: \"\\eba2\";\n}\n\n.icofont-pencil-alt-5:before {\n  content: \"\\eba3\";\n}\n\n.icofont-quill-pen:before {\n  content: \"\\eba4\";\n}\n\n.icofont-read-book-alt:before {\n  content: \"\\eba5\";\n}\n\n.icofont-read-book:before {\n  content: \"\\eba6\";\n}\n\n.icofont-school-bag:before {\n  content: \"\\eba7\";\n}\n\n.icofont-school-bus:before {\n  content: \"\\eba8\";\n}\n\n.icofont-student-alt:before {\n  content: \"\\eba9\";\n}\n\n.icofont-student:before {\n  content: \"\\ebaa\";\n}\n\n.icofont-teacher:before {\n  content: \"\\ebab\";\n}\n\n.icofont-test-bulb:before {\n  content: \"\\ebac\";\n}\n\n.icofont-test-tube-alt:before {\n  content: \"\\ebad\";\n}\n\n.icofont-university:before {\n  content: \"\\ebae\";\n}\n\n.icofont-emo-angry:before {\n  content: \"\\ebaf\";\n}\n\n.icofont-emo-astonished:before {\n  content: \"\\ebb0\";\n}\n\n.icofont-emo-confounded:before {\n  content: \"\\ebb1\";\n}\n\n.icofont-emo-confused:before {\n  content: \"\\ebb2\";\n}\n\n.icofont-emo-crying:before {\n  content: \"\\ebb3\";\n}\n\n.icofont-emo-dizzy:before {\n  content: \"\\ebb4\";\n}\n\n.icofont-emo-expressionless:before {\n  content: \"\\ebb5\";\n}\n\n.icofont-emo-heart-eyes:before {\n  content: \"\\ebb6\";\n}\n\n.icofont-emo-laughing:before {\n  content: \"\\ebb7\";\n}\n\n.icofont-emo-nerd-smile:before {\n  content: \"\\ebb8\";\n}\n\n.icofont-emo-open-mouth:before {\n  content: \"\\ebb9\";\n}\n\n.icofont-emo-rage:before {\n  content: \"\\ebba\";\n}\n\n.icofont-emo-rolling-eyes:before {\n  content: \"\\ebbb\";\n}\n\n.icofont-emo-sad:before {\n  content: \"\\ebbc\";\n}\n\n.icofont-emo-simple-smile:before {\n  content: \"\\ebbd\";\n}\n\n.icofont-emo-slightly-smile:before {\n  content: \"\\ebbe\";\n}\n\n.icofont-emo-smirk:before {\n  content: \"\\ebbf\";\n}\n\n.icofont-emo-stuck-out-tongue:before {\n  content: \"\\ebc0\";\n}\n\n.icofont-emo-wink-smile:before {\n  content: \"\\ebc1\";\n}\n\n.icofont-emo-worried:before {\n  content: \"\\ebc2\";\n}\n\n.icofont-architecture-alt:before {\n  content: \"\\ebc3\";\n}\n\n.icofont-architecture:before {\n  content: \"\\ebc4\";\n}\n\n.icofont-barricade:before {\n  content: \"\\ebc5\";\n}\n\n.icofont-bricks:before {\n  content: \"\\ebc6\";\n}\n\n.icofont-calculations:before {\n  content: \"\\ebc7\";\n}\n\n.icofont-cement-mix:before {\n  content: \"\\ebc8\";\n}\n\n.icofont-cement-mixer:before {\n  content: \"\\ebc9\";\n}\n\n.icofont-danger-zone:before {\n  content: \"\\ebca\";\n}\n\n.icofont-drill:before {\n  content: \"\\ebcb\";\n}\n\n.icofont-eco-energy:before {\n  content: \"\\ebcc\";\n}\n\n.icofont-eco-environmen:before {\n  content: \"\\ebcd\";\n}\n\n.icofont-energy-air:before {\n  content: \"\\ebce\";\n}\n\n.icofont-energy-oil:before {\n  content: \"\\ebcf\";\n}\n\n.icofont-energy-savings:before {\n  content: \"\\ebd0\";\n}\n\n.icofont-energy-solar:before {\n  content: \"\\ebd1\";\n}\n\n.icofont-energy-water:before {\n  content: \"\\ebd2\";\n}\n\n.icofont-engineer:before {\n  content: \"\\ebd3\";\n}\n\n.icofont-fire-extinguisher-alt:before {\n  content: \"\\ebd4\";\n}\n\n.icofont-fix-tools:before {\n  content: \"\\ebd5\";\n}\n\n.icofont-glue-oil:before {\n  content: \"\\ebd6\";\n}\n\n.icofont-hammer-alt:before {\n  content: \"\\ebd7\";\n}\n\n.icofont-help-robot:before {\n  content: \"\\ebd8\";\n}\n\n.icofont-industries-alt-1:before {\n  content: \"\\ebd9\";\n}\n\n.icofont-industries-alt-2:before {\n  content: \"\\ebda\";\n}\n\n.icofont-industries-alt-3:before {\n  content: \"\\ebdb\";\n}\n\n.icofont-industries-alt-4:before {\n  content: \"\\ebdc\";\n}\n\n.icofont-industries-alt-5:before {\n  content: \"\\ebdd\";\n}\n\n.icofont-industries:before {\n  content: \"\\ebde\";\n}\n\n.icofont-labour:before {\n  content: \"\\ebdf\";\n}\n\n.icofont-mining:before {\n  content: \"\\ebe0\";\n}\n\n.icofont-paint-brush:before {\n  content: \"\\ebe1\";\n}\n\n.icofont-pollution:before {\n  content: \"\\ebe2\";\n}\n\n.icofont-power-zone:before {\n  content: \"\\ebe3\";\n}\n\n.icofont-radio-active:before {\n  content: \"\\ebe4\";\n}\n\n.icofont-recycle-alt:before {\n  content: \"\\ebe5\";\n}\n\n.icofont-recycling-man:before {\n  content: \"\\ebe6\";\n}\n\n.icofont-safety-hat-light:before {\n  content: \"\\ebe7\";\n}\n\n.icofont-safety-hat:before {\n  content: \"\\ebe8\";\n}\n\n.icofont-saw:before {\n  content: \"\\ebe9\";\n}\n\n.icofont-screw-driver:before {\n  content: \"\\ebea\";\n}\n\n.icofont-settings-alt:before {\n  content: \"\\ebeb\";\n}\n\n.icofont-tools-alt-1:before {\n  content: \"\\ebec\";\n}\n\n.icofont-tools-alt-2:before {\n  content: \"\\ebed\";\n}\n\n.icofont-tools-bag:before {\n  content: \"\\ebee\";\n}\n\n.icofont-trolley:before {\n  content: \"\\ebef\";\n}\n\n.icofont-trowel:before {\n  content: \"\\ebf0\";\n}\n\n.icofont-under-construction-alt:before {\n  content: \"\\ebf1\";\n}\n\n.icofont-under-construction:before {\n  content: \"\\ebf2\";\n}\n\n.icofont-vehicle-cement:before {\n  content: \"\\ebf3\";\n}\n\n.icofont-vehicle-crane:before {\n  content: \"\\ebf4\";\n}\n\n.icofont-vehicle-delivery-van:before {\n  content: \"\\ebf5\";\n}\n\n.icofont-vehicle-dozer:before {\n  content: \"\\ebf6\";\n}\n\n.icofont-vehicle-excavator:before {\n  content: \"\\ebf7\";\n}\n\n.icofont-vehicle-trucktor:before {\n  content: \"\\ebf8\";\n}\n\n.icofont-vehicle-wrecking:before {\n  content: \"\\ebf9\";\n}\n\n.icofont-worker-group:before {\n  content: \"\\ebfa\";\n}\n\n.icofont-worker:before {\n  content: \"\\ebfb\";\n}\n\n.icofont-wrench:before {\n  content: \"\\ebfc\";\n}\n\n.icofont-file-audio:before {\n  content: \"\\ebfd\";\n}\n\n.icofont-file-avi-mp4:before {\n  content: \"\\ebfe\";\n}\n\n.icofont-file-bmp:before {\n  content: \"\\ebff\";\n}\n\n.icofont-file-code:before {\n  content: \"\\ec00\";\n}\n\n.icofont-file-css:before {\n  content: \"\\ec01\";\n}\n\n.icofont-file-document:before {\n  content: \"\\ec02\";\n}\n\n.icofont-file-eps:before {\n  content: \"\\ec03\";\n}\n\n.icofont-file-excel:before {\n  content: \"\\ec04\";\n}\n\n.icofont-file-exe:before {\n  content: \"\\ec05\";\n}\n\n.icofont-file-file:before {\n  content: \"\\ec06\";\n}\n\n.icofont-file-flv:before {\n  content: \"\\ec07\";\n}\n\n.icofont-file-gif:before {\n  content: \"\\ec08\";\n}\n\n.icofont-file-html5:before {\n  content: \"\\ec09\";\n}\n\n.icofont-file-image:before {\n  content: \"\\ec0a\";\n}\n\n.icofont-file-iso:before {\n  content: \"\\ec0b\";\n}\n\n.icofont-file-java:before {\n  content: \"\\ec0c\";\n}\n\n.icofont-file-javascript:before {\n  content: \"\\ec0d\";\n}\n\n.icofont-file-jpg:before {\n  content: \"\\ec0e\";\n}\n\n.icofont-file-midi:before {\n  content: \"\\ec0f\";\n}\n\n.icofont-file-mov:before {\n  content: \"\\ec10\";\n}\n\n.icofont-file-mp3:before {\n  content: \"\\ec11\";\n}\n\n.icofont-file-pdf:before {\n  content: \"\\ec12\";\n}\n\n.icofont-file-php:before {\n  content: \"\\ec13\";\n}\n\n.icofont-file-png:before {\n  content: \"\\ec14\";\n}\n\n.icofont-file-powerpoint:before {\n  content: \"\\ec15\";\n}\n\n.icofont-file-presentation:before {\n  content: \"\\ec16\";\n}\n\n.icofont-file-psb:before {\n  content: \"\\ec17\";\n}\n\n.icofont-file-psd:before {\n  content: \"\\ec18\";\n}\n\n.icofont-file-python:before {\n  content: \"\\ec19\";\n}\n\n.icofont-file-ruby:before {\n  content: \"\\ec1a\";\n}\n\n.icofont-file-spreadsheet:before {\n  content: \"\\ec1b\";\n}\n\n.icofont-file-sql:before {\n  content: \"\\ec1c\";\n}\n\n.icofont-file-svg:before {\n  content: \"\\ec1d\";\n}\n\n.icofont-file-text:before {\n  content: \"\\ec1e\";\n}\n\n.icofont-file-tiff:before {\n  content: \"\\ec1f\";\n}\n\n.icofont-file-video:before {\n  content: \"\\ec20\";\n}\n\n.icofont-file-wave:before {\n  content: \"\\ec21\";\n}\n\n.icofont-file-wmv:before {\n  content: \"\\ec22\";\n}\n\n.icofont-file-word:before {\n  content: \"\\ec23\";\n}\n\n.icofont-file-zip:before {\n  content: \"\\ec24\";\n}\n\n.icofont-apple:before {\n  content: \"\\ec25\";\n}\n\n.icofont-arabian-coffee:before {\n  content: \"\\ec26\";\n}\n\n.icofont-artichoke:before {\n  content: \"\\ec27\";\n}\n\n.icofont-asparagus:before {\n  content: \"\\ec28\";\n}\n\n.icofont-avocado:before {\n  content: \"\\ec29\";\n}\n\n.icofont-baby-food:before {\n  content: \"\\ec2a\";\n}\n\n.icofont-banana:before {\n  content: \"\\ec2b\";\n}\n\n.icofont-bbq:before {\n  content: \"\\ec2c\";\n}\n\n.icofont-beans:before {\n  content: \"\\ec2d\";\n}\n\n.icofont-beer:before {\n  content: \"\\ec2e\";\n}\n\n.icofont-bell-pepper-capsicum:before {\n  content: \"\\ec2f\";\n}\n\n.icofont-birthday-cake:before {\n  content: \"\\ec30\";\n}\n\n.icofont-bread:before {\n  content: \"\\ec31\";\n}\n\n.icofont-broccoli:before {\n  content: \"\\ec32\";\n}\n\n.icofont-burger:before {\n  content: \"\\ec33\";\n}\n\n.icofont-cabbage:before {\n  content: \"\\ec34\";\n}\n\n.icofont-carrot:before {\n  content: \"\\ec35\";\n}\n\n.icofont-cauli-flower:before {\n  content: \"\\ec36\";\n}\n\n.icofont-cheese:before {\n  content: \"\\ec37\";\n}\n\n.icofont-chef:before {\n  content: \"\\ec38\";\n}\n\n.icofont-cherry:before {\n  content: \"\\ec39\";\n}\n\n.icofont-chicken-fry:before {\n  content: \"\\ec3a\";\n}\n\n.icofont-chicken:before {\n  content: \"\\ec3b\";\n}\n\n.icofont-cocktail:before {\n  content: \"\\ec3c\";\n}\n\n.icofont-coconut:before {\n  content: \"\\ec3d\";\n}\n\n.icofont-coffee-alt:before {\n  content: \"\\ec3e\";\n}\n\n.icofont-coffee-mug:before {\n  content: \"\\ec3f\";\n}\n\n.icofont-coffee-pot:before {\n  content: \"\\ec40\";\n}\n\n.icofont-cola:before {\n  content: \"\\ec41\";\n}\n\n.icofont-corn:before {\n  content: \"\\ec42\";\n}\n\n.icofont-croissant:before {\n  content: \"\\ec43\";\n}\n\n.icofont-crop-plant:before {\n  content: \"\\ec44\";\n}\n\n.icofont-cucumber:before {\n  content: \"\\ec45\";\n}\n\n.icofont-cup-cake:before {\n  content: \"\\ec46\";\n}\n\n.icofont-dining-table:before {\n  content: \"\\ec47\";\n}\n\n.icofont-donut:before {\n  content: \"\\ec48\";\n}\n\n.icofont-egg-plant:before {\n  content: \"\\ec49\";\n}\n\n.icofont-egg-poached:before {\n  content: \"\\ec4a\";\n}\n\n.icofont-farmer:before {\n  content: \"\\ec4b\";\n}\n\n.icofont-farmer1:before {\n  content: \"\\ec4c\";\n}\n\n.icofont-fast-food:before {\n  content: \"\\ec4d\";\n}\n\n.icofont-fish:before {\n  content: \"\\ec4e\";\n}\n\n.icofont-food-basket:before {\n  content: \"\\ec4f\";\n}\n\n.icofont-food-cart:before {\n  content: \"\\ec50\";\n}\n\n.icofont-fork-and-knife:before {\n  content: \"\\ec51\";\n}\n\n.icofont-french-fries:before {\n  content: \"\\ec52\";\n}\n\n.icofont-fresh-juice:before {\n  content: \"\\ec53\";\n}\n\n.icofont-fruits:before {\n  content: \"\\ec54\";\n}\n\n.icofont-grapes:before {\n  content: \"\\ec55\";\n}\n\n.icofont-honey:before {\n  content: \"\\ec56\";\n}\n\n.icofont-hot-dog:before {\n  content: \"\\ec57\";\n}\n\n.icofont-hotel-alt:before {\n  content: \"\\ec58\";\n}\n\n.icofont-ice-cream-alt:before {\n  content: \"\\ec59\";\n}\n\n.icofont-ice-cream:before {\n  content: \"\\ec5a\";\n}\n\n.icofont-ketchup:before {\n  content: \"\\ec5b\";\n}\n\n.icofont-kiwi:before {\n  content: \"\\ec5c\";\n}\n\n.icofont-layered-cake:before {\n  content: \"\\ec5d\";\n}\n\n.icofont-lemon-alt:before {\n  content: \"\\ec5e\";\n}\n\n.icofont-lobster:before {\n  content: \"\\ec5f\";\n}\n\n.icofont-mango:before {\n  content: \"\\ec60\";\n}\n\n.icofont-milk:before {\n  content: \"\\ec61\";\n}\n\n.icofont-mushroom:before {\n  content: \"\\ec62\";\n}\n\n.icofont-noodles:before {\n  content: \"\\ec63\";\n}\n\n.icofont-onion:before {\n  content: \"\\ec64\";\n}\n\n.icofont-orange:before {\n  content: \"\\ec65\";\n}\n\n.icofont-pear:before {\n  content: \"\\ec66\";\n}\n\n.icofont-peas:before {\n  content: \"\\ec67\";\n}\n\n.icofont-pepper:before {\n  content: \"\\ec68\";\n}\n\n.icofont-pie-alt:before {\n  content: \"\\ec69\";\n}\n\n.icofont-pineapple:before {\n  content: \"\\ec6a\";\n}\n\n.icofont-pizza-slice:before {\n  content: \"\\ec6b\";\n}\n\n.icofont-pizza:before {\n  content: \"\\ec6c\";\n}\n\n.icofont-plant:before {\n  content: \"\\ec6d\";\n}\n\n.icofont-popcorn:before {\n  content: \"\\ec6e\";\n}\n\n.icofont-potato:before {\n  content: \"\\ec6f\";\n}\n\n.icofont-pumpkin:before {\n  content: \"\\ec70\";\n}\n\n.icofont-raddish:before {\n  content: \"\\ec71\";\n}\n\n.icofont-restaurant-menu:before {\n  content: \"\\ec72\";\n}\n\n.icofont-restaurant:before {\n  content: \"\\ec73\";\n}\n\n.icofont-salt-and-pepper:before {\n  content: \"\\ec74\";\n}\n\n.icofont-sandwich:before {\n  content: \"\\ec75\";\n}\n\n.icofont-sausage:before {\n  content: \"\\ec76\";\n}\n\n.icofont-shrimp:before {\n  content: \"\\ec77\";\n}\n\n.icofont-sof-drinks:before {\n  content: \"\\ec78\";\n}\n\n.icofont-soup-bowl:before {\n  content: \"\\ec79\";\n}\n\n.icofont-spoon-and-fork:before {\n  content: \"\\ec7a\";\n}\n\n.icofont-steak:before {\n  content: \"\\ec7b\";\n}\n\n.icofont-strawberry:before {\n  content: \"\\ec7c\";\n}\n\n.icofont-sub-sandwich:before {\n  content: \"\\ec7d\";\n}\n\n.icofont-sushi:before {\n  content: \"\\ec7e\";\n}\n\n.icofont-taco:before {\n  content: \"\\ec7f\";\n}\n\n.icofont-tea-pot:before {\n  content: \"\\ec80\";\n}\n\n.icofont-tea:before {\n  content: \"\\ec81\";\n}\n\n.icofont-tomato:before {\n  content: \"\\ec82\";\n}\n\n.icofont-waiter-alt:before {\n  content: \"\\ec83\";\n}\n\n.icofont-watermelon:before {\n  content: \"\\ec84\";\n}\n\n.icofont-wheat:before {\n  content: \"\\ec85\";\n}\n\n.icofont-abc:before {\n  content: \"\\ec86\";\n}\n\n.icofont-baby-cloth:before {\n  content: \"\\ec87\";\n}\n\n.icofont-baby-milk-bottle:before {\n  content: \"\\ec88\";\n}\n\n.icofont-baby-trolley:before {\n  content: \"\\ec89\";\n}\n\n.icofont-back-pack:before {\n  content: \"\\ec8a\";\n}\n\n.icofont-candy:before {\n  content: \"\\ec8b\";\n}\n\n.icofont-cycling:before {\n  content: \"\\ec8c\";\n}\n\n.icofont-holding-hands:before {\n  content: \"\\ec8d\";\n}\n\n.icofont-infant-nipple:before {\n  content: \"\\ec8e\";\n}\n\n.icofont-kids-scooter:before {\n  content: \"\\ec8f\";\n}\n\n.icofont-safety-pin:before {\n  content: \"\\ec90\";\n}\n\n.icofont-teddy-bear:before {\n  content: \"\\ec91\";\n}\n\n.icofont-toy-ball:before {\n  content: \"\\ec92\";\n}\n\n.icofont-toy-cat:before {\n  content: \"\\ec93\";\n}\n\n.icofont-toy-duck:before {\n  content: \"\\ec94\";\n}\n\n.icofont-toy-elephant:before {\n  content: \"\\ec95\";\n}\n\n.icofont-toy-hand:before {\n  content: \"\\ec96\";\n}\n\n.icofont-toy-horse:before {\n  content: \"\\ec97\";\n}\n\n.icofont-toy-lattu:before {\n  content: \"\\ec98\";\n}\n\n.icofont-toy-train:before {\n  content: \"\\ec99\";\n}\n\n.icofont-unique-idea:before {\n  content: \"\\ec9a\";\n}\n\n.icofont-bag-alt:before {\n  content: \"\\ec9b\";\n}\n\n.icofont-burglar:before {\n  content: \"\\ec9c\";\n}\n\n.icofont-cannon-firing:before {\n  content: \"\\ec9d\";\n}\n\n.icofont-cc-camera:before {\n  content: \"\\ec9e\";\n}\n\n.icofont-cop-badge:before {\n  content: \"\\ec9f\";\n}\n\n.icofont-cop:before {\n  content: \"\\eca0\";\n}\n\n.icofont-court-hammer:before {\n  content: \"\\eca1\";\n}\n\n.icofont-court:before {\n  content: \"\\eca2\";\n}\n\n.icofont-finger-print:before {\n  content: \"\\eca3\";\n}\n\n.icofont-handcuff-alt:before {\n  content: \"\\eca4\";\n}\n\n.icofont-handcuff:before {\n  content: \"\\eca5\";\n}\n\n.icofont-investigation:before {\n  content: \"\\eca6\";\n}\n\n.icofont-investigator:before {\n  content: \"\\eca7\";\n}\n\n.icofont-jail:before {\n  content: \"\\eca8\";\n}\n\n.icofont-judge:before {\n  content: \"\\eca9\";\n}\n\n.icofont-law-alt-1:before {\n  content: \"\\ecaa\";\n}\n\n.icofont-law-alt-2:before {\n  content: \"\\ecab\";\n}\n\n.icofont-law-alt-3:before {\n  content: \"\\ecac\";\n}\n\n.icofont-law-book:before {\n  content: \"\\ecad\";\n}\n\n.icofont-law-document:before {\n  content: \"\\ecae\";\n}\n\n.icofont-law:before {\n  content: \"\\ecaf\";\n}\n\n.icofont-lawyer-alt-1:before {\n  content: \"\\ecb0\";\n}\n\n.icofont-lawyer-alt-2:before {\n  content: \"\\ecb1\";\n}\n\n.icofont-lawyer:before {\n  content: \"\\ecb2\";\n}\n\n.icofont-order:before {\n  content: \"\\ecb3\";\n}\n\n.icofont-pistol:before {\n  content: \"\\ecb4\";\n}\n\n.icofont-police-badge:before {\n  content: \"\\ecb5\";\n}\n\n.icofont-police-cap:before {\n  content: \"\\ecb6\";\n}\n\n.icofont-police-car-alt-1:before {\n  content: \"\\ecb7\";\n}\n\n.icofont-police-car-alt-2:before {\n  content: \"\\ecb8\";\n}\n\n.icofont-police-hat:before {\n  content: \"\\ecb9\";\n}\n\n.icofont-police-van:before {\n  content: \"\\ecba\";\n}\n\n.icofont-police:before {\n  content: \"\\ecbb\";\n}\n\n.icofont-protect:before {\n  content: \"\\ecbc\";\n}\n\n.icofont-scales:before {\n  content: \"\\ecbd\";\n}\n\n.icofont-thief-alt:before {\n  content: \"\\ecbe\";\n}\n\n.icofont-thief:before {\n  content: \"\\ecbf\";\n}\n\n.icofont-abacus-alt:before {\n  content: \"\\ecc0\";\n}\n\n.icofont-abacus:before {\n  content: \"\\ecc1\";\n}\n\n.icofont-angle:before {\n  content: \"\\ecc2\";\n}\n\n.icofont-calculator-alt-1:before {\n  content: \"\\ecc3\";\n}\n\n.icofont-calculator-alt-2:before {\n  content: \"\\ecc4\";\n}\n\n.icofont-circle-ruler-alt:before {\n  content: \"\\ecc5\";\n}\n\n.icofont-circle-ruler:before {\n  content: \"\\ecc6\";\n}\n\n.icofont-compass-alt-1:before {\n  content: \"\\ecc7\";\n}\n\n.icofont-compass-alt-2:before {\n  content: \"\\ecc8\";\n}\n\n.icofont-compass-alt-3:before {\n  content: \"\\ecc9\";\n}\n\n.icofont-compass-alt-4:before {\n  content: \"\\ecca\";\n}\n\n.icofont-degrees-alt-1:before {\n  content: \"\\eccb\";\n}\n\n.icofont-degrees-alt-2:before {\n  content: \"\\eccc\";\n}\n\n.icofont-degrees:before {\n  content: \"\\eccd\";\n}\n\n.icofont-golden-ratio:before {\n  content: \"\\ecce\";\n}\n\n.icofont-marker-alt-1:before {\n  content: \"\\eccf\";\n}\n\n.icofont-marker-alt-2:before {\n  content: \"\\ecd0\";\n}\n\n.icofont-marker-alt-3:before {\n  content: \"\\ecd1\";\n}\n\n.icofont-mathematical-alt-1:before {\n  content: \"\\ecd2\";\n}\n\n.icofont-mathematical-alt-2:before {\n  content: \"\\ecd3\";\n}\n\n.icofont-mathematical:before {\n  content: \"\\ecd4\";\n}\n\n.icofont-pen-alt-1:before {\n  content: \"\\ecd5\";\n}\n\n.icofont-pen-alt-2:before {\n  content: \"\\ecd6\";\n}\n\n.icofont-pen-alt-3:before {\n  content: \"\\ecd7\";\n}\n\n.icofont-pen-holder-alt-1:before {\n  content: \"\\ecd8\";\n}\n\n.icofont-pen-holder:before {\n  content: \"\\ecd9\";\n}\n\n.icofont-pencil-alt-1:before {\n  content: \"\\ecda\";\n}\n\n.icofont-pencil-alt-2:before {\n  content: \"\\ecdb\";\n}\n\n.icofont-pencil-alt-3:before {\n  content: \"\\ecdc\";\n}\n\n.icofont-pencil-alt-4:before {\n  content: \"\\ecdd\";\n}\n\n.icofont-ruler-alt-1:before {\n  content: \"\\ecde\";\n}\n\n.icofont-ruler-alt-2:before {\n  content: \"\\ecdf\";\n}\n\n.icofont-ruler-compass-alt:before {\n  content: \"\\ece0\";\n}\n\n.icofont-ruler-compass:before {\n  content: \"\\ece1\";\n}\n\n.icofont-ruler-pencil-alt-1:before {\n  content: \"\\ece2\";\n}\n\n.icofont-ruler-pencil-alt-2:before {\n  content: \"\\ece3\";\n}\n\n.icofont-ruler-pencil:before {\n  content: \"\\ece4\";\n}\n\n.icofont-ruler:before {\n  content: \"\\ece5\";\n}\n\n.icofont-rulers-alt:before {\n  content: \"\\ece6\";\n}\n\n.icofont-rulers:before {\n  content: \"\\ece7\";\n}\n\n.icofont-square-root:before {\n  content: \"\\ece8\";\n}\n\n.icofont-aids:before {\n  content: \"\\ece9\";\n}\n\n.icofont-ambulance:before {\n  content: \"\\ecea\";\n}\n\n.icofont-autism:before {\n  content: \"\\eceb\";\n}\n\n.icofont-bandage:before {\n  content: \"\\ecec\";\n}\n\n.icofont-bed-patient:before {\n  content: \"\\eced\";\n}\n\n.icofont-blind:before {\n  content: \"\\ecee\";\n}\n\n.icofont-blood-drop:before {\n  content: \"\\ecef\";\n}\n\n.icofont-blood-test:before {\n  content: \"\\ecf0\";\n}\n\n.icofont-blood:before {\n  content: \"\\ecf1\";\n}\n\n.icofont-capsule:before {\n  content: \"\\ecf2\";\n}\n\n.icofont-crutches:before {\n  content: \"\\ecf3\";\n}\n\n.icofont-dna-alt-1:before {\n  content: \"\\ecf4\";\n}\n\n.icofont-dna:before {\n  content: \"\\ecf5\";\n}\n\n.icofont-doctor-alt:before {\n  content: \"\\ecf6\";\n}\n\n.icofont-doctor:before {\n  content: \"\\ecf7\";\n}\n\n.icofont-drug-pack:before {\n  content: \"\\ecf8\";\n}\n\n.icofont-drug:before {\n  content: \"\\ecf9\";\n}\n\n.icofont-eye-alt:before {\n  content: \"\\ecfa\";\n}\n\n.icofont-first-aid-alt:before {\n  content: \"\\ecfb\";\n}\n\n.icofont-garbage:before {\n  content: \"\\ecfc\";\n}\n\n.icofont-heart-alt:before {\n  content: \"\\ecfd\";\n}\n\n.icofont-heartbeat:before {\n  content: \"\\ecfe\";\n}\n\n.icofont-herbal:before {\n  content: \"\\ecff\";\n}\n\n.icofont-hospital:before {\n  content: \"\\ed00\";\n}\n\n.icofont-icu:before {\n  content: \"\\ed01\";\n}\n\n.icofont-injection-syringe:before {\n  content: \"\\ed02\";\n}\n\n.icofont-laboratory:before {\n  content: \"\\ed03\";\n}\n\n.icofont-medical-sign-alt:before {\n  content: \"\\ed04\";\n}\n\n.icofont-medical-sign:before {\n  content: \"\\ed05\";\n}\n\n.icofont-nurse-alt:before {\n  content: \"\\ed06\";\n}\n\n.icofont-nurse:before {\n  content: \"\\ed07\";\n}\n\n.icofont-nursing-home:before {\n  content: \"\\ed08\";\n}\n\n.icofont-operation-theater:before {\n  content: \"\\ed09\";\n}\n\n.icofont-paralysis-disability:before {\n  content: \"\\ed0a\";\n}\n\n.icofont-pills:before {\n  content: \"\\ed0b\";\n}\n\n.icofont-prescription:before {\n  content: \"\\ed0c\";\n}\n\n.icofont-pulse:before {\n  content: \"\\ed0d\";\n}\n\n.icofont-stethoscope-alt:before {\n  content: \"\\ed0e\";\n}\n\n.icofont-stethoscope:before {\n  content: \"\\ed0f\";\n}\n\n.icofont-stretcher:before {\n  content: \"\\ed10\";\n}\n\n.icofont-surgeon-alt:before {\n  content: \"\\ed11\";\n}\n\n.icofont-surgeon:before {\n  content: \"\\ed12\";\n}\n\n.icofont-tablets:before {\n  content: \"\\ed13\";\n}\n\n.icofont-test-bottle:before {\n  content: \"\\ed14\";\n}\n\n.icofont-test-tube:before {\n  content: \"\\ed15\";\n}\n\n.icofont-thermometer-alt:before {\n  content: \"\\ed16\";\n}\n\n.icofont-tooth:before {\n  content: \"\\ed17\";\n}\n\n.icofont-xray:before {\n  content: \"\\ed18\";\n}\n\n.icofont-ui-add:before {\n  content: \"\\ed19\";\n}\n\n.icofont-ui-alarm:before {\n  content: \"\\ed1a\";\n}\n\n.icofont-ui-battery:before {\n  content: \"\\ed1b\";\n}\n\n.icofont-ui-block:before {\n  content: \"\\ed1c\";\n}\n\n.icofont-ui-bluetooth:before {\n  content: \"\\ed1d\";\n}\n\n.icofont-ui-brightness:before {\n  content: \"\\ed1e\";\n}\n\n.icofont-ui-browser:before {\n  content: \"\\ed1f\";\n}\n\n.icofont-ui-calculator:before {\n  content: \"\\ed20\";\n}\n\n.icofont-ui-calendar:before {\n  content: \"\\ed21\";\n}\n\n.icofont-ui-call:before {\n  content: \"\\ed22\";\n}\n\n.icofont-ui-camera:before {\n  content: \"\\ed23\";\n}\n\n.icofont-ui-cart:before {\n  content: \"\\ed24\";\n}\n\n.icofont-ui-cell-phone:before {\n  content: \"\\ed25\";\n}\n\n.icofont-ui-chat:before {\n  content: \"\\ed26\";\n}\n\n.icofont-ui-check:before {\n  content: \"\\ed27\";\n}\n\n.icofont-ui-clip-board:before {\n  content: \"\\ed28\";\n}\n\n.icofont-ui-clip:before {\n  content: \"\\ed29\";\n}\n\n.icofont-ui-clock:before {\n  content: \"\\ed2a\";\n}\n\n.icofont-ui-close:before {\n  content: \"\\ed2b\";\n}\n\n.icofont-ui-contact-list:before {\n  content: \"\\ed2c\";\n}\n\n.icofont-ui-copy:before {\n  content: \"\\ed2d\";\n}\n\n.icofont-ui-cut:before {\n  content: \"\\ed2e\";\n}\n\n.icofont-ui-delete:before {\n  content: \"\\ed2f\";\n}\n\n.icofont-ui-dial-phone:before {\n  content: \"\\ed30\";\n}\n\n.icofont-ui-edit:before {\n  content: \"\\ed31\";\n}\n\n.icofont-ui-email:before {\n  content: \"\\ed32\";\n}\n\n.icofont-ui-file:before {\n  content: \"\\ed33\";\n}\n\n.icofont-ui-fire-wall:before {\n  content: \"\\ed34\";\n}\n\n.icofont-ui-flash-light:before {\n  content: \"\\ed35\";\n}\n\n.icofont-ui-flight:before {\n  content: \"\\ed36\";\n}\n\n.icofont-ui-folder:before {\n  content: \"\\ed37\";\n}\n\n.icofont-ui-game:before {\n  content: \"\\ed38\";\n}\n\n.icofont-ui-handicapped:before {\n  content: \"\\ed39\";\n}\n\n.icofont-ui-head-phone:before {\n  content: \"\\ed3a\";\n}\n\n.icofont-ui-home:before {\n  content: \"\\ed3b\";\n}\n\n.icofont-ui-image:before {\n  content: \"\\ed3c\";\n}\n\n.icofont-ui-keyboard:before {\n  content: \"\\ed3d\";\n}\n\n.icofont-ui-laoding:before {\n  content: \"\\ed3e\";\n}\n\n.icofont-ui-lock:before {\n  content: \"\\ed3f\";\n}\n\n.icofont-ui-love-add:before {\n  content: \"\\ed40\";\n}\n\n.icofont-ui-love-broken:before {\n  content: \"\\ed41\";\n}\n\n.icofont-ui-love-remove:before {\n  content: \"\\ed42\";\n}\n\n.icofont-ui-love:before {\n  content: \"\\ed43\";\n}\n\n.icofont-ui-map:before {\n  content: \"\\ed44\";\n}\n\n.icofont-ui-message:before {\n  content: \"\\ed45\";\n}\n\n.icofont-ui-messaging:before {\n  content: \"\\ed46\";\n}\n\n.icofont-ui-movie:before {\n  content: \"\\ed47\";\n}\n\n.icofont-ui-music-player:before {\n  content: \"\\ed48\";\n}\n\n.icofont-ui-music:before {\n  content: \"\\ed49\";\n}\n\n.icofont-ui-mute:before {\n  content: \"\\ed4a\";\n}\n\n.icofont-ui-network:before {\n  content: \"\\ed4b\";\n}\n\n.icofont-ui-next:before {\n  content: \"\\ed4c\";\n}\n\n.icofont-ui-note:before {\n  content: \"\\ed4d\";\n}\n\n.icofont-ui-office:before {\n  content: \"\\ed4e\";\n}\n\n.icofont-ui-password:before {\n  content: \"\\ed4f\";\n}\n\n.icofont-ui-pause:before {\n  content: \"\\ed50\";\n}\n\n.icofont-ui-play-stop:before {\n  content: \"\\ed51\";\n}\n\n.icofont-ui-play:before {\n  content: \"\\ed52\";\n}\n\n.icofont-ui-pointer:before {\n  content: \"\\ed53\";\n}\n\n.icofont-ui-power:before {\n  content: \"\\ed54\";\n}\n\n.icofont-ui-press:before {\n  content: \"\\ed55\";\n}\n\n.icofont-ui-previous:before {\n  content: \"\\ed56\";\n}\n\n.icofont-ui-rate-add:before {\n  content: \"\\ed57\";\n}\n\n.icofont-ui-rate-blank:before {\n  content: \"\\ed58\";\n}\n\n.icofont-ui-rate-remove:before {\n  content: \"\\ed59\";\n}\n\n.icofont-ui-rating:before {\n  content: \"\\ed5a\";\n}\n\n.icofont-ui-record:before {\n  content: \"\\ed5b\";\n}\n\n.icofont-ui-remove:before {\n  content: \"\\ed5c\";\n}\n\n.icofont-ui-reply:before {\n  content: \"\\ed5d\";\n}\n\n.icofont-ui-rotation:before {\n  content: \"\\ed5e\";\n}\n\n.icofont-ui-rss:before {\n  content: \"\\ed5f\";\n}\n\n.icofont-ui-search:before {\n  content: \"\\ed60\";\n}\n\n.icofont-ui-settings:before {\n  content: \"\\ed61\";\n}\n\n.icofont-ui-social-link:before {\n  content: \"\\ed62\";\n}\n\n.icofont-ui-tag:before {\n  content: \"\\ed63\";\n}\n\n.icofont-ui-text-chat:before {\n  content: \"\\ed64\";\n}\n\n.icofont-ui-text-loading:before {\n  content: \"\\ed65\";\n}\n\n.icofont-ui-theme:before {\n  content: \"\\ed66\";\n}\n\n.icofont-ui-timer:before {\n  content: \"\\ed67\";\n}\n\n.icofont-ui-touch-phone:before {\n  content: \"\\ed68\";\n}\n\n.icofont-ui-travel:before {\n  content: \"\\ed69\";\n}\n\n.icofont-ui-unlock:before {\n  content: \"\\ed6a\";\n}\n\n.icofont-ui-user-group:before {\n  content: \"\\ed6b\";\n}\n\n.icofont-ui-user:before {\n  content: \"\\ed6c\";\n}\n\n.icofont-ui-v-card:before {\n  content: \"\\ed6d\";\n}\n\n.icofont-ui-video-chat:before {\n  content: \"\\ed6e\";\n}\n\n.icofont-ui-video-message:before {\n  content: \"\\ed6f\";\n}\n\n.icofont-ui-video-play:before {\n  content: \"\\ed70\";\n}\n\n.icofont-ui-video:before {\n  content: \"\\ed71\";\n}\n\n.icofont-ui-volume:before {\n  content: \"\\ed72\";\n}\n\n.icofont-ui-weather:before {\n  content: \"\\ed73\";\n}\n\n.icofont-ui-wifi:before {\n  content: \"\\ed74\";\n}\n\n.icofont-ui-zoom-in:before {\n  content: \"\\ed75\";\n}\n\n.icofont-ui-zoom-out:before {\n  content: \"\\ed76\";\n}\n\n.icofont-cassette-player:before {\n  content: \"\\ed77\";\n}\n\n.icofont-cassette:before {\n  content: \"\\ed78\";\n}\n\n.icofont-forward:before {\n  content: \"\\ed79\";\n}\n\n.icofont-game:before {\n  content: \"\\ed7a\";\n}\n\n.icofont-guiter:before {\n  content: \"\\ed7b\";\n}\n\n.icofont-headphone-alt-1:before {\n  content: \"\\ed7c\";\n}\n\n.icofont-headphone-alt-2:before {\n  content: \"\\ed7d\";\n}\n\n.icofont-headphone-alt-3:before {\n  content: \"\\ed7e\";\n}\n\n.icofont-listening:before {\n  content: \"\\ed7f\";\n}\n\n.icofont-megaphone-alt:before {\n  content: \"\\ed80\";\n}\n\n.icofont-megaphone:before {\n  content: \"\\ed81\";\n}\n\n.icofont-movie:before {\n  content: \"\\ed82\";\n}\n\n.icofont-mp3-player:before {\n  content: \"\\ed83\";\n}\n\n.icofont-multimedia:before {\n  content: \"\\ed84\";\n}\n\n.icofont-music-disk:before {\n  content: \"\\ed85\";\n}\n\n.icofont-music-note:before {\n  content: \"\\ed86\";\n}\n\n.icofont-pause:before {\n  content: \"\\ed87\";\n}\n\n.icofont-play-alt-1:before {\n  content: \"\\ed88\";\n}\n\n.icofont-play-alt-2:before {\n  content: \"\\ed89\";\n}\n\n.icofont-play-alt-3:before {\n  content: \"\\ed8a\";\n}\n\n.icofont-play-pause:before {\n  content: \"\\ed8b\";\n}\n\n.icofont-record:before {\n  content: \"\\ed8c\";\n}\n\n.icofont-retro-music-disk:before {\n  content: \"\\ed8d\";\n}\n\n.icofont-rewind:before {\n  content: \"\\ed8e\";\n}\n\n.icofont-song-notes:before {\n  content: \"\\ed8f\";\n}\n\n.icofont-sound-wave-alt:before {\n  content: \"\\ed90\";\n}\n\n.icofont-sound-wave:before {\n  content: \"\\ed91\";\n}\n\n.icofont-stop:before {\n  content: \"\\ed92\";\n}\n\n.icofont-video-alt:before {\n  content: \"\\ed93\";\n}\n\n.icofont-video-cam:before {\n  content: \"\\ed94\";\n}\n\n.icofont-volume-bar:before {\n  content: \"\\ed95\";\n}\n\n.icofont-volume-mute:before {\n  content: \"\\ed96\";\n}\n\n.icofont-youtube-play:before {\n  content: \"\\ed97\";\n}\n\n.icofont-amazon-alt:before {\n  content: \"\\ed98\";\n}\n\n.icofont-amazon:before {\n  content: \"\\ed99\";\n}\n\n.icofont-american-express-alt:before {\n  content: \"\\ed9a\";\n}\n\n.icofont-american-express:before {\n  content: \"\\ed9b\";\n}\n\n.icofont-apple-pay-alt:before {\n  content: \"\\ed9c\";\n}\n\n.icofont-apple-pay:before {\n  content: \"\\ed9d\";\n}\n\n.icofont-bank-transfer-alt:before {\n  content: \"\\ed9e\";\n}\n\n.icofont-bank-transfer:before {\n  content: \"\\ed9f\";\n}\n\n.icofont-braintree-alt:before {\n  content: \"\\eda0\";\n}\n\n.icofont-braintree:before {\n  content: \"\\eda1\";\n}\n\n.icofont-cash-on-delivery-alt:before {\n  content: \"\\eda2\";\n}\n\n.icofont-cash-on-delivery:before {\n  content: \"\\eda3\";\n}\n\n.icofont-checkout-alt:before {\n  content: \"\\eda4\";\n}\n\n.icofont-checkout:before {\n  content: \"\\eda5\";\n}\n\n.icofont-diners-club-alt-1:before {\n  content: \"\\eda6\";\n}\n\n.icofont-diners-club-alt-2:before {\n  content: \"\\eda7\";\n}\n\n.icofont-diners-club-alt-3:before {\n  content: \"\\eda8\";\n}\n\n.icofont-diners-club:before {\n  content: \"\\eda9\";\n}\n\n.icofont-discover-alt:before {\n  content: \"\\edaa\";\n}\n\n.icofont-discover:before {\n  content: \"\\edab\";\n}\n\n.icofont-eway-alt:before {\n  content: \"\\edac\";\n}\n\n.icofont-eway:before {\n  content: \"\\edad\";\n}\n\n.icofont-google-wallet-alt-1:before {\n  content: \"\\edae\";\n}\n\n.icofont-google-wallet-alt-2:before {\n  content: \"\\edaf\";\n}\n\n.icofont-google-wallet-alt-3:before {\n  content: \"\\edb0\";\n}\n\n.icofont-google-wallet:before {\n  content: \"\\edb1\";\n}\n\n.icofont-jcb-alt:before {\n  content: \"\\edb2\";\n}\n\n.icofont-jcb:before {\n  content: \"\\edb3\";\n}\n\n.icofont-maestro-alt:before {\n  content: \"\\edb4\";\n}\n\n.icofont-maestro:before {\n  content: \"\\edb5\";\n}\n\n.icofont-mastercard-alt:before {\n  content: \"\\edb6\";\n}\n\n.icofont-mastercard:before {\n  content: \"\\edb7\";\n}\n\n.icofont-payoneer-alt:before {\n  content: \"\\edb8\";\n}\n\n.icofont-payoneer:before {\n  content: \"\\edb9\";\n}\n\n.icofont-paypal-alt:before {\n  content: \"\\edba\";\n}\n\n.icofont-paypal:before {\n  content: \"\\edbb\";\n}\n\n.icofont-sage-alt:before {\n  content: \"\\edbc\";\n}\n\n.icofont-sage:before {\n  content: \"\\edbd\";\n}\n\n.icofont-skrill-alt:before {\n  content: \"\\edbe\";\n}\n\n.icofont-skrill:before {\n  content: \"\\edbf\";\n}\n\n.icofont-stripe-alt:before {\n  content: \"\\edc0\";\n}\n\n.icofont-stripe:before {\n  content: \"\\edc1\";\n}\n\n.icofont-visa-alt:before {\n  content: \"\\edc2\";\n}\n\n.icofont-visa-electron:before {\n  content: \"\\edc3\";\n}\n\n.icofont-visa:before {\n  content: \"\\edc4\";\n}\n\n.icofont-western-union-alt:before {\n  content: \"\\edc5\";\n}\n\n.icofont-western-union:before {\n  content: \"\\edc6\";\n}\n\n.icofont-boy:before {\n  content: \"\\edc7\";\n}\n\n.icofont-business-man-alt-1:before {\n  content: \"\\edc8\";\n}\n\n.icofont-business-man-alt-2:before {\n  content: \"\\edc9\";\n}\n\n.icofont-business-man-alt-3:before {\n  content: \"\\edca\";\n}\n\n.icofont-business-man:before {\n  content: \"\\edcb\";\n}\n\n.icofont-funky-man:before {\n  content: \"\\edcc\";\n}\n\n.icofont-girl-alt:before {\n  content: \"\\edcd\";\n}\n\n.icofont-girl:before {\n  content: \"\\edce\";\n}\n\n.icofont-hotel-boy-alt:before {\n  content: \"\\edcf\";\n}\n\n.icofont-hotel-boy:before {\n  content: \"\\edd0\";\n}\n\n.icofont-man-in-glasses:before {\n  content: \"\\edd1\";\n}\n\n.icofont-user-alt-1:before {\n  content: \"\\edd2\";\n}\n\n.icofont-user-alt-2:before {\n  content: \"\\edd3\";\n}\n\n.icofont-user-alt-3:before {\n  content: \"\\edd4\";\n}\n\n.icofont-user-alt-4:before {\n  content: \"\\edd5\";\n}\n\n.icofont-user-alt-5:before {\n  content: \"\\edd6\";\n}\n\n.icofont-user-alt-6:before {\n  content: \"\\edd7\";\n}\n\n.icofont-user-alt-7:before {\n  content: \"\\edd8\";\n}\n\n.icofont-user-female:before {\n  content: \"\\edd9\";\n}\n\n.icofont-user-male:before {\n  content: \"\\edda\";\n}\n\n.icofont-user-suited:before {\n  content: \"\\eddb\";\n}\n\n.icofont-user:before {\n  content: \"\\eddc\";\n}\n\n.icofont-users-alt-1:before {\n  content: \"\\eddd\";\n}\n\n.icofont-users-alt-2:before {\n  content: \"\\edde\";\n}\n\n.icofont-users-alt-3:before {\n  content: \"\\eddf\";\n}\n\n.icofont-users-alt-4:before {\n  content: \"\\ede0\";\n}\n\n.icofont-users-alt-5:before {\n  content: \"\\ede1\";\n}\n\n.icofont-users-alt-6:before {\n  content: \"\\ede2\";\n}\n\n.icofont-users-social:before {\n  content: \"\\ede3\";\n}\n\n.icofont-users:before {\n  content: \"\\ede4\";\n}\n\n.icofont-waiter:before {\n  content: \"\\ede5\";\n}\n\n.icofont-woman-in-glasses:before {\n  content: \"\\ede6\";\n}\n\n.icofont-document-search:before {\n  content: \"\\ede7\";\n}\n\n.icofont-folder-search:before {\n  content: \"\\ede8\";\n}\n\n.icofont-home-search:before {\n  content: \"\\ede9\";\n}\n\n.icofont-job-search:before {\n  content: \"\\edea\";\n}\n\n.icofont-map-search:before {\n  content: \"\\edeb\";\n}\n\n.icofont-restaurant-search:before {\n  content: \"\\edec\";\n}\n\n.icofont-search-alt-1:before {\n  content: \"\\eded\";\n}\n\n.icofont-search-alt-2:before {\n  content: \"\\edee\";\n}\n\n.icofont-search:before {\n  content: \"\\edef\";\n}\n\n.icofont-stock-search:before {\n  content: \"\\edf0\";\n}\n\n.icofont-user-search:before {\n  content: \"\\edf1\";\n}\n\n.icofont-social-aim:before {\n  content: \"\\edf2\";\n}\n\n.icofont-social-badoo:before {\n  content: \"\\edf3\";\n}\n\n.icofont-social-bebo:before {\n  content: \"\\edf4\";\n}\n\n.icofont-social-behance:before {\n  content: \"\\edf5\";\n}\n\n.icofont-social-blogger:before {\n  content: \"\\edf6\";\n}\n\n.icofont-social-bootstrap:before {\n  content: \"\\edf7\";\n}\n\n.icofont-social-brightkite:before {\n  content: \"\\edf8\";\n}\n\n.icofont-social-cloudapp:before {\n  content: \"\\edf9\";\n}\n\n.icofont-social-concrete5:before {\n  content: \"\\edfa\";\n}\n\n.icofont-social-designbump:before {\n  content: \"\\edfb\";\n}\n\n.icofont-social-designfloat:before {\n  content: \"\\edfc\";\n}\n\n.icofont-social-deviantart:before {\n  content: \"\\edfd\";\n}\n\n.icofont-social-digg:before {\n  content: \"\\edfe\";\n}\n\n.icofont-social-dotcms:before {\n  content: \"\\edff\";\n}\n\n.icofont-social-dribble:before {\n  content: \"\\ee00\";\n}\n\n.icofont-social-dropbox:before {\n  content: \"\\ee01\";\n}\n\n.icofont-brand-drupal:before {\n  content: \"\\ee02\";\n}\n\n.icofont-social-ebuddy:before {\n  content: \"\\ee03\";\n}\n\n.icofont-social-ello:before {\n  content: \"\\ee04\";\n}\n\n.icofont-social-ember:before {\n  content: \"\\ee05\";\n}\n\n.icofont-social-envato:before {\n  content: \"\\ee06\";\n}\n\n.icofont-social-evernote:before {\n  content: \"\\ee07\";\n}\n\n.icofont-social-facebook:before {\n  content: \"\\ee08\";\n}\n\n.icofont-social-feedburner:before {\n  content: \"\\ee09\";\n}\n\n.icofont-social-folkd:before {\n  content: \"\\ee0a\";\n}\n\n.icofont-social-friendfeed:before {\n  content: \"\\ee0b\";\n}\n\n.icofont-social-ghost:before {\n  content: \"\\ee0c\";\n}\n\n.icofont-social-github:before {\n  content: \"\\ee0d\";\n}\n\n.icofont-social-gnome:before {\n  content: \"\\ee0e\";\n}\n\n.icofont-social-google-buzz:before {\n  content: \"\\ee0f\";\n}\n\n.icofont-social-google-map:before {\n  content: \"\\ee10\";\n}\n\n.icofont-social-google-plus:before {\n  content: \"\\ee11\";\n}\n\n.icofont-social-google-talk:before {\n  content: \"\\ee12\";\n}\n\n.icofont-social-hype-machine:before {\n  content: \"\\ee13\";\n}\n\n.icofont-social-instagram:before {\n  content: \"\\ee14\";\n}\n\n.icofont-brand-joomla:before {\n  content: \"\\ee15\";\n}\n\n.icofont-social-kickstarter:before {\n  content: \"\\ee16\";\n}\n\n.icofont-social-line:before {\n  content: \"\\ee17\";\n}\n\n.icofont-social-linux-mint:before {\n  content: \"\\ee18\";\n}\n\n.icofont-social-livejournal:before {\n  content: \"\\ee19\";\n}\n\n.icofont-social-magento:before {\n  content: \"\\ee1a\";\n}\n\n.icofont-social-meetup:before {\n  content: \"\\ee1b\";\n}\n\n.icofont-social-mixx:before {\n  content: \"\\ee1c\";\n}\n\n.icofont-social-newsvine:before {\n  content: \"\\ee1d\";\n}\n\n.icofont-social-nimbuss:before {\n  content: \"\\ee1e\";\n}\n\n.icofont-social-opencart:before {\n  content: \"\\ee1f\";\n}\n\n.icofont-social-oscommerce:before {\n  content: \"\\ee20\";\n}\n\n.icofont-social-pandora:before {\n  content: \"\\ee21\";\n}\n\n.icofont-social-picasa:before {\n  content: \"\\ee22\";\n}\n\n.icofont-social-pinterest:before {\n  content: \"\\ee23\";\n}\n\n.icofont-social-prestashop:before {\n  content: \"\\ee24\";\n}\n\n.icofont-social-qik:before {\n  content: \"\\ee25\";\n}\n\n.icofont-social-readernaut:before {\n  content: \"\\ee26\";\n}\n\n.icofont-social-reddit:before {\n  content: \"\\ee27\";\n}\n\n.icofont-social-rss:before {\n  content: \"\\ee28\";\n}\n\n.icofont-social-shopify:before {\n  content: \"\\ee29\";\n}\n\n.icofont-social-silverstripe:before {\n  content: \"\\ee2a\";\n}\n\n.icofont-social-skype:before {\n  content: \"\\ee2b\";\n}\n\n.icofont-social-slashdot:before {\n  content: \"\\ee2c\";\n}\n\n.icofont-social-smugmug:before {\n  content: \"\\ee2d\";\n}\n\n.icofont-social-steam:before {\n  content: \"\\ee2e\";\n}\n\n.icofont-social-stumbleupon:before {\n  content: \"\\ee2f\";\n}\n\n.icofont-social-technorati:before {\n  content: \"\\ee30\";\n}\n\n.icofont-social-telegram:before {\n  content: \"\\ee31\";\n}\n\n.icofont-social-tinder:before {\n  content: \"\\ee32\";\n}\n\n.icofont-social-tumblr:before {\n  content: \"\\ee33\";\n}\n\n.icofont-social-twitter:before {\n  content: \"\\ee34\";\n}\n\n.icofont-social-typo3:before {\n  content: \"\\ee35\";\n}\n\n.icofont-social-ubercart:before {\n  content: \"\\ee36\";\n}\n\n.icofont-social-viber:before {\n  content: \"\\ee37\";\n}\n\n.icofont-social-viddler:before {\n  content: \"\\ee38\";\n}\n\n.icofont-social-vimeo:before {\n  content: \"\\ee39\";\n}\n\n.icofont-social-vine:before {\n  content: \"\\ee3a\";\n}\n\n.icofont-social-virb:before {\n  content: \"\\ee3b\";\n}\n\n.icofont-social-virtuemart:before {\n  content: \"\\ee3c\";\n}\n\n.icofont-social-wechat:before {\n  content: \"\\ee3d\";\n}\n\n.icofont-brand-wordpress:before {\n  content: \"\\ee3e\";\n}\n\n.icofont-social-xing:before {\n  content: \"\\ee3f\";\n}\n\n.icofont-social-yahoo:before {\n  content: \"\\ee40\";\n}\n\n.icofont-social-yelp:before {\n  content: \"\\ee41\";\n}\n\n.icofont-social-zencart:before {\n  content: \"\\ee42\";\n}\n\n.icofont-badminton-birdie:before {\n  content: \"\\ee43\";\n}\n\n.icofont-baseball:before {\n  content: \"\\ee44\";\n}\n\n.icofont-baseballer:before {\n  content: \"\\ee45\";\n}\n\n.icofont-basketball-hoop:before {\n  content: \"\\ee46\";\n}\n\n.icofont-basketball:before {\n  content: \"\\ee47\";\n}\n\n.icofont-billiard-ball:before {\n  content: \"\\ee48\";\n}\n\n.icofont-boot-alt-1:before {\n  content: \"\\ee49\";\n}\n\n.icofont-boot-alt-2:before {\n  content: \"\\ee4a\";\n}\n\n.icofont-bowling-alt:before {\n  content: \"\\ee4b\";\n}\n\n.icofont-bowling:before {\n  content: \"\\ee4c\";\n}\n\n.icofont-canoe:before {\n  content: \"\\ee4d\";\n}\n\n.icofont-cheer-leader:before {\n  content: \"\\ee4e\";\n}\n\n.icofont-climbing:before {\n  content: \"\\ee4f\";\n}\n\n.icofont-corner:before {\n  content: \"\\ee50\";\n}\n\n.icofont-cyclist:before {\n  content: \"\\ee51\";\n}\n\n.icofont-dumbbell-alt:before {\n  content: \"\\ee52\";\n}\n\n.icofont-dumbbell:before {\n  content: \"\\ee53\";\n}\n\n.icofont-field-alt:before {\n  content: \"\\ee54\";\n}\n\n.icofont-field:before {\n  content: \"\\ee55\";\n}\n\n.icofont-football-alt:before {\n  content: \"\\ee56\";\n}\n\n.icofont-foul:before {\n  content: \"\\ee57\";\n}\n\n.icofont-goal-keeper:before {\n  content: \"\\ee58\";\n}\n\n.icofont-goal:before {\n  content: \"\\ee59\";\n}\n\n.icofont-golf-alt:before {\n  content: \"\\ee5a\";\n}\n\n.icofont-golf-bag:before {\n  content: \"\\ee5b\";\n}\n\n.icofont-golf-field:before {\n  content: \"\\ee5c\";\n}\n\n.icofont-golf:before {\n  content: \"\\ee5d\";\n}\n\n.icofont-golfer:before {\n  content: \"\\ee5e\";\n}\n\n.icofont-gym-alt-1:before {\n  content: \"\\ee5f\";\n}\n\n.icofont-gym-alt-2:before {\n  content: \"\\ee60\";\n}\n\n.icofont-gym-alt-3:before {\n  content: \"\\ee61\";\n}\n\n.icofont-gym:before {\n  content: \"\\ee62\";\n}\n\n.icofont-hand-grippers:before {\n  content: \"\\ee63\";\n}\n\n.icofont-heart-beat-alt:before {\n  content: \"\\ee64\";\n}\n\n.icofont-helmet:before {\n  content: \"\\ee65\";\n}\n\n.icofont-hockey-alt:before {\n  content: \"\\ee66\";\n}\n\n.icofont-hockey:before {\n  content: \"\\ee67\";\n}\n\n.icofont-ice-skate:before {\n  content: \"\\ee68\";\n}\n\n.icofont-jersey-alt:before {\n  content: \"\\ee69\";\n}\n\n.icofont-jersey:before {\n  content: \"\\ee6a\";\n}\n\n.icofont-jumping:before {\n  content: \"\\ee6b\";\n}\n\n.icofont-kick:before {\n  content: \"\\ee6c\";\n}\n\n.icofont-leg:before {\n  content: \"\\ee6d\";\n}\n\n.icofont-match-review:before {\n  content: \"\\ee6e\";\n}\n\n.icofont-medal-alt:before {\n  content: \"\\ee6f\";\n}\n\n.icofont-muscle-alt:before {\n  content: \"\\ee70\";\n}\n\n.icofont-muscle:before {\n  content: \"\\ee71\";\n}\n\n.icofont-offside:before {\n  content: \"\\ee72\";\n}\n\n.icofont-olympic-logo:before {\n  content: \"\\ee73\";\n}\n\n.icofont-olympic:before {\n  content: \"\\ee74\";\n}\n\n.icofont-padding:before {\n  content: \"\\ee75\";\n}\n\n.icofont-penalty-card:before {\n  content: \"\\ee76\";\n}\n\n.icofont-racer:before {\n  content: \"\\ee77\";\n}\n\n.icofont-racing-car:before {\n  content: \"\\ee78\";\n}\n\n.icofont-racing-flag-alt:before {\n  content: \"\\ee79\";\n}\n\n.icofont-racing-flag:before {\n  content: \"\\ee7a\";\n}\n\n.icofont-racings-wheel:before {\n  content: \"\\ee7b\";\n}\n\n.icofont-referee:before {\n  content: \"\\ee7c\";\n}\n\n.icofont-refree-jersey:before {\n  content: \"\\ee7d\";\n}\n\n.icofont-result:before {\n  content: \"\\ee7e\";\n}\n\n.icofont-rugby-ball:before {\n  content: \"\\ee7f\";\n}\n\n.icofont-rugby-player:before {\n  content: \"\\ee80\";\n}\n\n.icofont-rugby:before {\n  content: \"\\ee81\";\n}\n\n.icofont-runner-alt-1:before {\n  content: \"\\ee82\";\n}\n\n.icofont-runner-alt-2:before {\n  content: \"\\ee83\";\n}\n\n.icofont-runner:before {\n  content: \"\\ee84\";\n}\n\n.icofont-score-board:before {\n  content: \"\\ee85\";\n}\n\n.icofont-skiing-man:before {\n  content: \"\\ee86\";\n}\n\n.icofont-skydiving-goggles:before {\n  content: \"\\ee87\";\n}\n\n.icofont-snow-mobile:before {\n  content: \"\\ee88\";\n}\n\n.icofont-steering:before {\n  content: \"\\ee89\";\n}\n\n.icofont-substitute:before {\n  content: \"\\ee8a\";\n}\n\n.icofont-swimmer:before {\n  content: \"\\ee8b\";\n}\n\n.icofont-table-tennis:before {\n  content: \"\\ee8c\";\n}\n\n.icofont-team-alt:before {\n  content: \"\\ee8d\";\n}\n\n.icofont-team:before {\n  content: \"\\ee8e\";\n}\n\n.icofont-tennis-player:before {\n  content: \"\\ee8f\";\n}\n\n.icofont-tennis:before {\n  content: \"\\ee90\";\n}\n\n.icofont-time:before {\n  content: \"\\ee91\";\n}\n\n.icofont-track:before {\n  content: \"\\ee92\";\n}\n\n.icofont-tracking:before {\n  content: \"\\ee93\";\n}\n\n.icofont-trophy-alt:before {\n  content: \"\\ee94\";\n}\n\n.icofont-trophy:before {\n  content: \"\\ee95\";\n}\n\n.icofont-volleyball-alt:before {\n  content: \"\\ee96\";\n}\n\n.icofont-volleyball-fire:before {\n  content: \"\\ee97\";\n}\n\n.icofont-volleyball:before {\n  content: \"\\ee98\";\n}\n\n.icofont-water-bottle:before {\n  content: \"\\ee99\";\n}\n\n.icofont-whisle:before {\n  content: \"\\ee9a\";\n}\n\n.icofont-win-trophy:before {\n  content: \"\\ee9b\";\n}\n\n.icofont-align-center:before {\n  content: \"\\ee9c\";\n}\n\n.icofont-align-left:before {\n  content: \"\\ee9d\";\n}\n\n.icofont-align-right:before {\n  content: \"\\ee9e\";\n}\n\n.icofont-all-caps:before {\n  content: \"\\ee9f\";\n}\n\n.icofont-bold:before {\n  content: \"\\eea0\";\n}\n\n.icofont-brush:before {\n  content: \"\\eea1\";\n}\n\n.icofont-clip-board:before {\n  content: \"\\eea2\";\n}\n\n.icofont-code-alt:before {\n  content: \"\\eea3\";\n}\n\n.icofont-color-bucket:before {\n  content: \"\\eea4\";\n}\n\n.icofont-color-picker:before {\n  content: \"\\eea5\";\n}\n\n.icofont-copy-alt:before {\n  content: \"\\eea6\";\n}\n\n.icofont-copy-black:before {\n  content: \"\\eea7\";\n}\n\n.icofont-cut:before {\n  content: \"\\eea8\";\n}\n\n.icofont-delete-alt:before {\n  content: \"\\eea9\";\n}\n\n.icofont-edit-alt:before {\n  content: \"\\eeaa\";\n}\n\n.icofont-eraser-alt:before {\n  content: \"\\eeab\";\n}\n\n.icofont-file-alt:before {\n  content: \"\\eeac\";\n}\n\n.icofont-font:before {\n  content: \"\\eead\";\n}\n\n.icofont-header:before {\n  content: \"\\eeae\";\n}\n\n.icofont-indent:before {\n  content: \"\\eeaf\";\n}\n\n.icofont-italic-alt:before {\n  content: \"\\eeb0\";\n}\n\n.icofont-justify-all:before {\n  content: \"\\eeb1\";\n}\n\n.icofont-justify-center:before {\n  content: \"\\eeb2\";\n}\n\n.icofont-justify-left:before {\n  content: \"\\eeb3\";\n}\n\n.icofont-justify-right:before {\n  content: \"\\eeb4\";\n}\n\n.icofont-line-height:before {\n  content: \"\\eeb5\";\n}\n\n.icofont-link-alt:before {\n  content: \"\\eeb6\";\n}\n\n.icofont-listine-dots:before {\n  content: \"\\eeb7\";\n}\n\n.icofont-listing-box:before {\n  content: \"\\eeb8\";\n}\n\n.icofont-listing-number:before {\n  content: \"\\eeb9\";\n}\n\n.icofont-marker:before {\n  content: \"\\eeba\";\n}\n\n.icofont-outdent:before {\n  content: \"\\eebb\";\n}\n\n.icofont-paper-clip:before {\n  content: \"\\eebc\";\n}\n\n.icofont-paragraph:before {\n  content: \"\\eebd\";\n}\n\n.icofont-pin:before {\n  content: \"\\eebe\";\n}\n\n.icofont-printer:before {\n  content: \"\\eebf\";\n}\n\n.icofont-redo:before {\n  content: \"\\eec0\";\n}\n\n.icofont-rotation:before {\n  content: \"\\eec1\";\n}\n\n.icofont-save:before {\n  content: \"\\eec2\";\n}\n\n.icofont-small-cap:before {\n  content: \"\\eec3\";\n}\n\n.icofont-strike-through:before {\n  content: \"\\eec4\";\n}\n\n.icofont-sub-listing:before {\n  content: \"\\eec5\";\n}\n\n.icofont-subscript:before {\n  content: \"\\eec6\";\n}\n\n.icofont-superscript:before {\n  content: \"\\eec7\";\n}\n\n.icofont-table:before {\n  content: \"\\eec8\";\n}\n\n.icofont-text-height:before {\n  content: \"\\eec9\";\n}\n\n.icofont-text-width:before {\n  content: \"\\eeca\";\n}\n\n.icofont-trash:before {\n  content: \"\\eecb\";\n}\n\n.icofont-underline:before {\n  content: \"\\eecc\";\n}\n\n.icofont-undo:before {\n  content: \"\\eecd\";\n}\n\n.icofont-unlink:before {\n  content: \"\\eece\";\n}\n\n.icofont-air-balloon:before {\n  content: \"\\eecf\";\n}\n\n.icofont-airplane-alt:before {\n  content: \"\\eed0\";\n}\n\n.icofont-airplane:before {\n  content: \"\\eed1\";\n}\n\n.icofont-ambulance-crescent:before {\n  content: \"\\eed2\";\n}\n\n.icofont-ambulance-cross:before {\n  content: \"\\eed3\";\n}\n\n.icofont-articulated-truck:before {\n  content: \"\\eed4\";\n}\n\n.icofont-auto-rickshaw:before {\n  content: \"\\eed5\";\n}\n\n.icofont-bicycle-alt-1:before {\n  content: \"\\eed6\";\n}\n\n.icofont-bicycle-alt-2:before {\n  content: \"\\eed7\";\n}\n\n.icofont-bull-dozer:before {\n  content: \"\\eed8\";\n}\n\n.icofont-bus-alt-1:before {\n  content: \"\\eed9\";\n}\n\n.icofont-bus-alt-2:before {\n  content: \"\\eeda\";\n}\n\n.icofont-bus-alt-3:before {\n  content: \"\\eedb\";\n}\n\n.icofont-cable-car:before {\n  content: \"\\eedc\";\n}\n\n.icofont-car-alt-1:before {\n  content: \"\\eedd\";\n}\n\n.icofont-car-alt-2:before {\n  content: \"\\eede\";\n}\n\n.icofont-car-alt-3:before {\n  content: \"\\eedf\";\n}\n\n.icofont-car-alt-4:before {\n  content: \"\\eee0\";\n}\n\n.icofont-concrete-mixer:before {\n  content: \"\\eee1\";\n}\n\n.icofont-delivery-time:before {\n  content: \"\\eee2\";\n}\n\n.icofont-excavator:before {\n  content: \"\\eee3\";\n}\n\n.icofont-fast-delivery:before {\n  content: \"\\eee4\";\n}\n\n.icofont-fire-truck-alt:before {\n  content: \"\\eee5\";\n}\n\n.icofont-fire-truck:before {\n  content: \"\\eee6\";\n}\n\n.icofont-fork-lift:before {\n  content: \"\\eee7\";\n}\n\n.icofont-free-delivery:before {\n  content: \"\\eee8\";\n}\n\n.icofont-golf-cart:before {\n  content: \"\\eee9\";\n}\n\n.icofont-helicopter:before {\n  content: \"\\eeea\";\n}\n\n.icofont-motor-bike-alt:before {\n  content: \"\\eeeb\";\n}\n\n.icofont-motor-bike:before {\n  content: \"\\eeec\";\n}\n\n.icofont-motor-biker:before {\n  content: \"\\eeed\";\n}\n\n.icofont-oil-truck:before {\n  content: \"\\eeee\";\n}\n\n.icofont-police-car:before {\n  content: \"\\eeef\";\n}\n\n.icofont-rickshaw:before {\n  content: \"\\eef0\";\n}\n\n.icofont-rocket-alt-1:before {\n  content: \"\\eef1\";\n}\n\n.icofont-rocket-alt-2:before {\n  content: \"\\eef2\";\n}\n\n.icofont-sail-boat:before {\n  content: \"\\eef3\";\n}\n\n.icofont-scooter:before {\n  content: \"\\eef4\";\n}\n\n.icofont-sea-plane:before {\n  content: \"\\eef5\";\n}\n\n.icofont-ship-alt:before {\n  content: \"\\eef6\";\n}\n\n.icofont-speed-boat:before {\n  content: \"\\eef7\";\n}\n\n.icofont-taxi:before {\n  content: \"\\eef8\";\n}\n\n.icofont-tow-truck:before {\n  content: \"\\eef9\";\n}\n\n.icofont-tractor:before {\n  content: \"\\eefa\";\n}\n\n.icofont-traffic-light:before {\n  content: \"\\eefb\";\n}\n\n.icofont-train-line:before {\n  content: \"\\eefc\";\n}\n\n.icofont-train-steam:before {\n  content: \"\\eefd\";\n}\n\n.icofont-tram:before {\n  content: \"\\eefe\";\n}\n\n.icofont-truck-alt:before {\n  content: \"\\eeff\";\n}\n\n.icofont-truck-loaded:before {\n  content: \"\\ef00\";\n}\n\n.icofont-truck:before {\n  content: \"\\ef01\";\n}\n\n.icofont-van-alt:before {\n  content: \"\\ef02\";\n}\n\n.icofont-van:before {\n  content: \"\\ef03\";\n}\n\n.icofont-yacht:before {\n  content: \"\\ef04\";\n}\n\n.icofont-5-star-hotel:before {\n  content: \"\\ef05\";\n}\n\n.icofont-anchor-alt:before {\n  content: \"\\ef06\";\n}\n\n.icofont-beach-bed:before {\n  content: \"\\ef07\";\n}\n\n.icofont-camping-vest:before {\n  content: \"\\ef08\";\n}\n\n.icofont-coconut-alt:before {\n  content: \"\\ef09\";\n}\n\n.icofont-direction-sign:before {\n  content: \"\\ef0a\";\n}\n\n.icofont-hill-side:before {\n  content: \"\\ef0b\";\n}\n\n.icofont-island-alt:before {\n  content: \"\\ef0c\";\n}\n\n.icofont-long-drive:before {\n  content: \"\\ef0d\";\n}\n\n.icofont-map-pins:before {\n  content: \"\\ef0e\";\n}\n\n.icofont-plane-ticket:before {\n  content: \"\\ef0f\";\n}\n\n.icofont-sail-boat-alt-1:before {\n  content: \"\\ef10\";\n}\n\n.icofont-sail-boat-alt-2:before {\n  content: \"\\ef11\";\n}\n\n.icofont-sandals-female:before {\n  content: \"\\ef12\";\n}\n\n.icofont-sandals-male:before {\n  content: \"\\ef13\";\n}\n\n.icofont-travelling:before {\n  content: \"\\ef14\";\n}\n\n.icofont-breakdown:before {\n  content: \"\\ef15\";\n}\n\n.icofont-celsius:before {\n  content: \"\\ef16\";\n}\n\n.icofont-clouds:before {\n  content: \"\\ef17\";\n}\n\n.icofont-cloudy:before {\n  content: \"\\ef18\";\n}\n\n.icofont-compass-alt:before {\n  content: \"\\ef19\";\n}\n\n.icofont-dust:before {\n  content: \"\\ef1a\";\n}\n\n.icofont-eclipse:before {\n  content: \"\\ef1b\";\n}\n\n.icofont-fahrenheit:before {\n  content: \"\\ef1c\";\n}\n\n.icofont-forest-fire:before {\n  content: \"\\ef1d\";\n}\n\n.icofont-full-night:before {\n  content: \"\\ef1e\";\n}\n\n.icofont-full-sunny:before {\n  content: \"\\ef1f\";\n}\n\n.icofont-hail-night:before {\n  content: \"\\ef20\";\n}\n\n.icofont-hail-rainy-night:before {\n  content: \"\\ef21\";\n}\n\n.icofont-hail-rainy-sunny:before {\n  content: \"\\ef22\";\n}\n\n.icofont-hail-rainy:before {\n  content: \"\\ef23\";\n}\n\n.icofont-hail-sunny:before {\n  content: \"\\ef24\";\n}\n\n.icofont-hail-thunder-night:before {\n  content: \"\\ef25\";\n}\n\n.icofont-hail-thunder-sunny:before {\n  content: \"\\ef26\";\n}\n\n.icofont-hail-thunder:before {\n  content: \"\\ef27\";\n}\n\n.icofont-hail:before {\n  content: \"\\ef28\";\n}\n\n.icofont-hill-night:before {\n  content: \"\\ef29\";\n}\n\n.icofont-hill-sunny:before {\n  content: \"\\ef2a\";\n}\n\n.icofont-hill:before {\n  content: \"\\ef2b\";\n}\n\n.icofont-hurricane:before {\n  content: \"\\ef2c\";\n}\n\n.icofont-island:before {\n  content: \"\\ef2d\";\n}\n\n.icofont-meteor:before {\n  content: \"\\ef2e\";\n}\n\n.icofont-night:before {\n  content: \"\\ef2f\";\n}\n\n.icofont-rainy-night:before {\n  content: \"\\ef30\";\n}\n\n.icofont-rainy-sunny:before {\n  content: \"\\ef31\";\n}\n\n.icofont-rainy-thunder:before {\n  content: \"\\ef32\";\n}\n\n.icofont-rainy:before {\n  content: \"\\ef33\";\n}\n\n.icofont-showy-night-hail:before {\n  content: \"\\ef34\";\n}\n\n.icofont-snow-temp:before {\n  content: \"\\ef35\";\n}\n\n.icofont-snow:before {\n  content: \"\\ef36\";\n}\n\n.icofont-snowy-hail:before {\n  content: \"\\ef37\";\n}\n\n.icofont-snowy-night-rainy:before {\n  content: \"\\ef38\";\n}\n\n.icofont-snowy-night:before {\n  content: \"\\ef39\";\n}\n\n.icofont-snowy-rainy:before {\n  content: \"\\ef3a\";\n}\n\n.icofont-snowy-sunny-hail:before {\n  content: \"\\ef3b\";\n}\n\n.icofont-snowy-sunny-rainy:before {\n  content: \"\\ef3c\";\n}\n\n.icofont-snowy-sunny:before {\n  content: \"\\ef3d\";\n}\n\n.icofont-snowy-thunder-night:before {\n  content: \"\\ef3e\";\n}\n\n.icofont-snowy-thunder-sunny:before {\n  content: \"\\ef3f\";\n}\n\n.icofont-snowy-thunder:before {\n  content: \"\\ef40\";\n}\n\n.icofont-snowy-windy-night:before {\n  content: \"\\ef41\";\n}\n\n.icofont-snowy-windy-sunny:before {\n  content: \"\\ef42\";\n}\n\n.icofont-snowy-windy:before {\n  content: \"\\ef43\";\n}\n\n.icofont-snowy:before {\n  content: \"\\ef44\";\n}\n\n.icofont-sun-alt:before {\n  content: \"\\ef45\";\n}\n\n.icofont-sun-rise:before {\n  content: \"\\ef46\";\n}\n\n.icofont-sun-set:before {\n  content: \"\\ef47\";\n}\n\n.icofont-sunny-day-temp:before {\n  content: \"\\ef48\";\n}\n\n.icofont-sunny:before {\n  content: \"\\ef49\";\n}\n\n.icofont-thermometer:before {\n  content: \"\\ef4a\";\n}\n\n.icofont-thinder-light:before {\n  content: \"\\ef4b\";\n}\n\n.icofont-tornado:before {\n  content: \"\\ef4c\";\n}\n\n.icofont-umbrella-alt:before {\n  content: \"\\ef4d\";\n}\n\n.icofont-volcano:before {\n  content: \"\\ef4e\";\n}\n\n.icofont-wave:before {\n  content: \"\\ef4f\";\n}\n\n.icofont-wind-scale-0:before {\n  content: \"\\ef50\";\n}\n\n.icofont-wind-scale-1:before {\n  content: \"\\ef51\";\n}\n\n.icofont-wind-scale-2:before {\n  content: \"\\ef52\";\n}\n\n.icofont-wind-scale-3:before {\n  content: \"\\ef53\";\n}\n\n.icofont-wind-scale-4:before {\n  content: \"\\ef54\";\n}\n\n.icofont-wind-scale-5:before {\n  content: \"\\ef55\";\n}\n\n.icofont-wind-scale-6:before {\n  content: \"\\ef56\";\n}\n\n.icofont-wind-scale-7:before {\n  content: \"\\ef57\";\n}\n\n.icofont-wind-scale-8:before {\n  content: \"\\ef58\";\n}\n\n.icofont-wind-scale-9:before {\n  content: \"\\ef59\";\n}\n\n.icofont-wind-scale-10:before {\n  content: \"\\ef5a\";\n}\n\n.icofont-wind-scale-11:before {\n  content: \"\\ef5b\";\n}\n\n.icofont-wind-scale-12:before {\n  content: \"\\ef5c\";\n}\n\n.icofont-wind-waves:before {\n  content: \"\\ef5d\";\n}\n\n.icofont-wind:before {\n  content: \"\\ef5e\";\n}\n\n.icofont-windy-hail:before {\n  content: \"\\ef5f\";\n}\n\n.icofont-windy-night:before {\n  content: \"\\ef60\";\n}\n\n.icofont-windy-raining:before {\n  content: \"\\ef61\";\n}\n\n.icofont-windy-sunny:before {\n  content: \"\\ef62\";\n}\n\n.icofont-windy-thunder-raining:before {\n  content: \"\\ef63\";\n}\n\n.icofont-windy-thunder:before {\n  content: \"\\ef64\";\n}\n\n.icofont-windy:before {\n  content: \"\\ef65\";\n}\n\n.icofont-addons:before {\n  content: \"\\ef66\";\n}\n\n.icofont-address-book:before {\n  content: \"\\ef67\";\n}\n\n.icofont-adjust:before {\n  content: \"\\ef68\";\n}\n\n.icofont-alarm:before {\n  content: \"\\ef69\";\n}\n\n.icofont-anchor:before {\n  content: \"\\ef6a\";\n}\n\n.icofont-archive:before {\n  content: \"\\ef6b\";\n}\n\n.icofont-at:before {\n  content: \"\\ef6c\";\n}\n\n.icofont-attachment:before {\n  content: \"\\ef6d\";\n}\n\n.icofont-audio:before {\n  content: \"\\ef6e\";\n}\n\n.icofont-auto-mobile:before {\n  content: \"\\ef6f\";\n}\n\n.icofont-automation:before {\n  content: \"\\ef70\";\n}\n\n.icofont-baby:before {\n  content: \"\\ef71\";\n}\n\n.icofont-badge:before {\n  content: \"\\ef72\";\n}\n\n.icofont-bag:before {\n  content: \"\\ef73\";\n}\n\n.icofont-ban:before {\n  content: \"\\ef74\";\n}\n\n.icofont-bank:before {\n  content: \"\\ef75\";\n}\n\n.icofont-bar-code:before {\n  content: \"\\ef76\";\n}\n\n.icofont-bars:before {\n  content: \"\\ef77\";\n}\n\n.icofont-battery-empty:before {\n  content: \"\\ef78\";\n}\n\n.icofont-battery-full:before {\n  content: \"\\ef79\";\n}\n\n.icofont-battery-half:before {\n  content: \"\\ef7a\";\n}\n\n.icofont-battery-low:before {\n  content: \"\\ef7b\";\n}\n\n.icofont-beach:before {\n  content: \"\\ef7c\";\n}\n\n.icofont-beaker:before {\n  content: \"\\ef7d\";\n}\n\n.icofont-bear:before {\n  content: \"\\ef7e\";\n}\n\n.icofont-beard:before {\n  content: \"\\ef7f\";\n}\n\n.icofont-bed:before {\n  content: \"\\ef80\";\n}\n\n.icofont-bell:before {\n  content: \"\\ef81\";\n}\n\n.icofont-beverage:before {\n  content: \"\\ef82\";\n}\n\n.icofont-bicycle:before {\n  content: \"\\ef83\";\n}\n\n.icofont-bill:before {\n  content: \"\\ef84\";\n}\n\n.icofont-bin:before {\n  content: \"\\ef85\";\n}\n\n.icofont-binary:before {\n  content: \"\\ef86\";\n}\n\n.icofont-binoculars:before {\n  content: \"\\ef87\";\n}\n\n.icofont-bird:before {\n  content: \"\\ef88\";\n}\n\n.icofont-birds:before {\n  content: \"\\ef89\";\n}\n\n.icofont-black-board:before {\n  content: \"\\ef8a\";\n}\n\n.icofont-bluetooth:before {\n  content: \"\\ef8b\";\n}\n\n.icofont-bolt:before {\n  content: \"\\ef8c\";\n}\n\n.icofont-bomb:before {\n  content: \"\\ef8d\";\n}\n\n.icofont-book-mark:before {\n  content: \"\\ef8e\";\n}\n\n.icofont-book:before {\n  content: \"\\ef8f\";\n}\n\n.icofont-boot:before {\n  content: \"\\ef90\";\n}\n\n.icofont-box:before {\n  content: \"\\ef91\";\n}\n\n.icofont-brain:before {\n  content: \"\\ef92\";\n}\n\n.icofont-briefcase:before {\n  content: \"\\ef93\";\n}\n\n.icofont-broken:before {\n  content: \"\\ef94\";\n}\n\n.icofont-bucket:before {\n  content: \"\\ef95\";\n}\n\n.icofont-bucket1:before {\n  content: \"\\ef96\";\n}\n\n.icofont-bucket2:before {\n  content: \"\\ef97\";\n}\n\n.icofont-bug:before {\n  content: \"\\ef98\";\n}\n\n.icofont-building:before {\n  content: \"\\ef99\";\n}\n\n.icofont-bullet:before {\n  content: \"\\ef9a\";\n}\n\n.icofont-bullhorn:before {\n  content: \"\\ef9b\";\n}\n\n.icofont-bullseye:before {\n  content: \"\\ef9c\";\n}\n\n.icofont-bus:before {\n  content: \"\\ef9d\";\n}\n\n.icofont-butterfly:before {\n  content: \"\\ef9e\";\n}\n\n.icofont-cab:before {\n  content: \"\\ef9f\";\n}\n\n.icofont-calculator:before {\n  content: \"\\efa0\";\n}\n\n.icofont-calendar:before {\n  content: \"\\efa1\";\n}\n\n.icofont-camera-alt:before {\n  content: \"\\efa2\";\n}\n\n.icofont-camera:before {\n  content: \"\\efa3\";\n}\n\n.icofont-car:before {\n  content: \"\\efa4\";\n}\n\n.icofont-card:before {\n  content: \"\\efa5\";\n}\n\n.icofont-cart:before {\n  content: \"\\efa6\";\n}\n\n.icofont-cc:before {\n  content: \"\\efa7\";\n}\n\n.icofont-certificate:before {\n  content: \"\\efa8\";\n}\n\n.icofont-charging:before {\n  content: \"\\efa9\";\n}\n\n.icofont-chat:before {\n  content: \"\\efaa\";\n}\n\n.icofont-check-alt:before {\n  content: \"\\efab\";\n}\n\n.icofont-check-circled:before {\n  content: \"\\efac\";\n}\n\n.icofont-check:before {\n  content: \"\\efad\";\n}\n\n.icofont-checked:before {\n  content: \"\\efae\";\n}\n\n.icofont-children-care:before {\n  content: \"\\efaf\";\n}\n\n.icofont-clock-time:before {\n  content: \"\\efb0\";\n}\n\n.icofont-close-circled:before {\n  content: \"\\efb1\";\n}\n\n.icofont-close-line-circled:before {\n  content: \"\\efb2\";\n}\n\n.icofont-close-line-squared-alt:before {\n  content: \"\\efb3\";\n}\n\n.icofont-close-line-squared:before {\n  content: \"\\efb4\";\n}\n\n.icofont-close-line:before {\n  content: \"\\efb5\";\n}\n\n.icofont-close-squared-alt:before {\n  content: \"\\efb6\";\n}\n\n.icofont-close-squared:before {\n  content: \"\\efb7\";\n}\n\n.icofont-close:before {\n  content: \"\\efb8\";\n}\n\n.icofont-cloud-download:before {\n  content: \"\\efb9\";\n}\n\n.icofont-cloud-refresh:before {\n  content: \"\\efba\";\n}\n\n.icofont-cloud-upload:before {\n  content: \"\\efbb\";\n}\n\n.icofont-cloud:before {\n  content: \"\\efbc\";\n}\n\n.icofont-code-not-allowed:before {\n  content: \"\\efbd\";\n}\n\n.icofont-code:before {\n  content: \"\\efbe\";\n}\n\n.icofont-coffee-cup:before {\n  content: \"\\efbf\";\n}\n\n.icofont-comment:before {\n  content: \"\\efc0\";\n}\n\n.icofont-compass:before {\n  content: \"\\efc1\";\n}\n\n.icofont-computer:before {\n  content: \"\\efc2\";\n}\n\n.icofont-connection:before {\n  content: \"\\efc3\";\n}\n\n.icofont-console:before {\n  content: \"\\efc4\";\n}\n\n.icofont-contacts:before {\n  content: \"\\efc5\";\n}\n\n.icofont-contrast:before {\n  content: \"\\efc6\";\n}\n\n.icofont-copy:before {\n  content: \"\\efc7\";\n}\n\n.icofont-copyright:before {\n  content: \"\\efc8\";\n}\n\n.icofont-credit-card:before {\n  content: \"\\efc9\";\n}\n\n.icofont-crop:before {\n  content: \"\\efca\";\n}\n\n.icofont-crown:before {\n  content: \"\\efcb\";\n}\n\n.icofont-cube:before {\n  content: \"\\efcc\";\n}\n\n.icofont-cubes:before {\n  content: \"\\efcd\";\n}\n\n.icofont-culinary:before {\n  content: \"\\efce\";\n}\n\n.icofont-dashboard-web:before {\n  content: \"\\efcf\";\n}\n\n.icofont-dashboard:before {\n  content: \"\\efd0\";\n}\n\n.icofont-data:before {\n  content: \"\\efd1\";\n}\n\n.icofont-database-add:before {\n  content: \"\\efd2\";\n}\n\n.icofont-database-locked:before {\n  content: \"\\efd3\";\n}\n\n.icofont-database-remove:before {\n  content: \"\\efd4\";\n}\n\n.icofont-database:before {\n  content: \"\\efd5\";\n}\n\n.icofont-delete:before {\n  content: \"\\efd6\";\n}\n\n.icofont-diamond:before {\n  content: \"\\efd7\";\n}\n\n.icofont-dice:before {\n  content: \"\\efd8\";\n}\n\n.icofont-disabled:before {\n  content: \"\\efd9\";\n}\n\n.icofont-disc:before {\n  content: \"\\efda\";\n}\n\n.icofont-diskette:before {\n  content: \"\\efdb\";\n}\n\n.icofont-document-folder:before {\n  content: \"\\efdc\";\n}\n\n.icofont-download-alt:before {\n  content: \"\\efdd\";\n}\n\n.icofont-download:before {\n  content: \"\\efde\";\n}\n\n.icofont-downloaded:before {\n  content: \"\\efdf\";\n}\n\n.icofont-earth:before {\n  content: \"\\efe0\";\n}\n\n.icofont-ebook:before {\n  content: \"\\efe1\";\n}\n\n.icofont-edit:before {\n  content: \"\\efe2\";\n}\n\n.icofont-eject:before {\n  content: \"\\efe3\";\n}\n\n.icofont-email:before {\n  content: \"\\efe4\";\n}\n\n.icofont-envelope-open:before {\n  content: \"\\efe5\";\n}\n\n.icofont-envelope:before {\n  content: \"\\efe6\";\n}\n\n.icofont-eraser:before {\n  content: \"\\efe7\";\n}\n\n.icofont-error:before {\n  content: \"\\efe8\";\n}\n\n.icofont-exchange:before {\n  content: \"\\efe9\";\n}\n\n.icofont-exclamation-circle:before {\n  content: \"\\efea\";\n}\n\n.icofont-exclamation-square:before {\n  content: \"\\efeb\";\n}\n\n.icofont-exclamation-tringle:before {\n  content: \"\\efec\";\n}\n\n.icofont-exclamation:before {\n  content: \"\\efed\";\n}\n\n.icofont-exit:before {\n  content: \"\\efee\";\n}\n\n.icofont-expand:before {\n  content: \"\\efef\";\n}\n\n.icofont-external-link:before {\n  content: \"\\eff0\";\n}\n\n.icofont-external:before {\n  content: \"\\eff1\";\n}\n\n.icofont-eye-blocked:before {\n  content: \"\\eff2\";\n}\n\n.icofont-eye-dropper:before {\n  content: \"\\eff3\";\n}\n\n.icofont-eye:before {\n  content: \"\\eff4\";\n}\n\n.icofont-favourite:before {\n  content: \"\\eff5\";\n}\n\n.icofont-fax:before {\n  content: \"\\eff6\";\n}\n\n.icofont-female:before {\n  content: \"\\eff7\";\n}\n\n.icofont-file:before {\n  content: \"\\eff8\";\n}\n\n.icofont-film:before {\n  content: \"\\eff9\";\n}\n\n.icofont-filter:before {\n  content: \"\\effa\";\n}\n\n.icofont-fire-burn:before {\n  content: \"\\effb\";\n}\n\n.icofont-fire-extinguisher:before {\n  content: \"\\effc\";\n}\n\n.icofont-fire:before {\n  content: \"\\effd\";\n}\n\n.icofont-first-aid:before {\n  content: \"\\effe\";\n}\n\n.icofont-flag-alt-1:before {\n  content: \"\\efff\";\n}\n\n.icofont-flag-alt-2:before {\n  content: \"\\f000\";\n}\n\n.icofont-flag:before {\n  content: \"\\f001\";\n}\n\n.icofont-flash-light:before {\n  content: \"\\f002\";\n}\n\n.icofont-flash:before {\n  content: \"\\f003\";\n}\n\n.icofont-flask:before {\n  content: \"\\f004\";\n}\n\n.icofont-focus:before {\n  content: \"\\f005\";\n}\n\n.icofont-folder-open:before {\n  content: \"\\f006\";\n}\n\n.icofont-folder:before {\n  content: \"\\f007\";\n}\n\n.icofont-foot-print:before {\n  content: \"\\f008\";\n}\n\n.icofont-football-american:before {\n  content: \"\\f009\";\n}\n\n.icofont-football:before {\n  content: \"\\f00a\";\n}\n\n.icofont-game-console:before {\n  content: \"\\f00b\";\n}\n\n.icofont-game-pad:before {\n  content: \"\\f00c\";\n}\n\n.icofont-gavel:before {\n  content: \"\\f00d\";\n}\n\n.icofont-gear:before {\n  content: \"\\f00e\";\n}\n\n.icofont-gears:before {\n  content: \"\\f00f\";\n}\n\n.icofont-gift:before {\n  content: \"\\f010\";\n}\n\n.icofont-glass:before {\n  content: \"\\f011\";\n}\n\n.icofont-globe:before {\n  content: \"\\f012\";\n}\n\n.icofont-graduate:before {\n  content: \"\\f013\";\n}\n\n.icofont-graffiti:before {\n  content: \"\\f014\";\n}\n\n.icofont-grocery:before {\n  content: \"\\f015\";\n}\n\n.icofont-group:before {\n  content: \"\\f016\";\n}\n\n.icofont-hammer:before {\n  content: \"\\f017\";\n}\n\n.icofont-hand:before {\n  content: \"\\f018\";\n}\n\n.icofont-hanger:before {\n  content: \"\\f019\";\n}\n\n.icofont-hard-disk:before {\n  content: \"\\f01a\";\n}\n\n.icofont-headphone:before {\n  content: \"\\f01b\";\n}\n\n.icofont-heart-beat:before {\n  content: \"\\f01c\";\n}\n\n.icofont-heart:before {\n  content: \"\\f01d\";\n}\n\n.icofont-history:before {\n  content: \"\\f01e\";\n}\n\n.icofont-home:before {\n  content: \"\\f01f\";\n}\n\n.icofont-horn:before {\n  content: \"\\f020\";\n}\n\n.icofont-hotel:before {\n  content: \"\\f021\";\n}\n\n.icofont-hour-glass:before {\n  content: \"\\f022\";\n}\n\n.icofont-id:before {\n  content: \"\\f023\";\n}\n\n.icofont-image:before {\n  content: \"\\f024\";\n}\n\n.icofont-inbox:before {\n  content: \"\\f025\";\n}\n\n.icofont-infinite:before {\n  content: \"\\f026\";\n}\n\n.icofont-info-circle:before {\n  content: \"\\f027\";\n}\n\n.icofont-info-square:before {\n  content: \"\\f028\";\n}\n\n.icofont-info:before {\n  content: \"\\f029\";\n}\n\n.icofont-institution:before {\n  content: \"\\f02a\";\n}\n\n.icofont-interface:before {\n  content: \"\\f02b\";\n}\n\n.icofont-invisible:before {\n  content: \"\\f02c\";\n}\n\n.icofont-italic:before {\n  content: \"\\f02d\";\n}\n\n.icofont-jacket:before {\n  content: \"\\f02e\";\n}\n\n.icofont-jar:before {\n  content: \"\\f02f\";\n}\n\n.icofont-jewlery:before {\n  content: \"\\f030\";\n}\n\n.icofont-karate:before {\n  content: \"\\f031\";\n}\n\n.icofont-key-hole:before {\n  content: \"\\f032\";\n}\n\n.icofont-key:before {\n  content: \"\\f033\";\n}\n\n.icofont-keyboard:before {\n  content: \"\\f034\";\n}\n\n.icofont-kid:before {\n  content: \"\\f035\";\n}\n\n.icofont-label:before {\n  content: \"\\f036\";\n}\n\n.icofont-lamp:before {\n  content: \"\\f037\";\n}\n\n.icofont-laptop:before {\n  content: \"\\f038\";\n}\n\n.icofont-layers:before {\n  content: \"\\f039\";\n}\n\n.icofont-layout:before {\n  content: \"\\f03a\";\n}\n\n.icofont-leaf:before {\n  content: \"\\f03b\";\n}\n\n.icofont-leaflet:before {\n  content: \"\\f03c\";\n}\n\n.icofont-learn:before {\n  content: \"\\f03d\";\n}\n\n.icofont-legal:before {\n  content: \"\\f03e\";\n}\n\n.icofont-lego:before {\n  content: \"\\f03f\";\n}\n\n.icofont-lemon:before {\n  content: \"\\f040\";\n}\n\n.icofont-lens:before {\n  content: \"\\f041\";\n}\n\n.icofont-letter:before {\n  content: \"\\f042\";\n}\n\n.icofont-letterbox:before {\n  content: \"\\f043\";\n}\n\n.icofont-library:before {\n  content: \"\\f044\";\n}\n\n.icofont-license:before {\n  content: \"\\f045\";\n}\n\n.icofont-life-bouy:before {\n  content: \"\\f046\";\n}\n\n.icofont-life-buoy:before {\n  content: \"\\f047\";\n}\n\n.icofont-life-jacket:before {\n  content: \"\\f048\";\n}\n\n.icofont-life-ring:before {\n  content: \"\\f049\";\n}\n\n.icofont-light-bulb:before {\n  content: \"\\f04a\";\n}\n\n.icofont-lighter:before {\n  content: \"\\f04b\";\n}\n\n.icofont-lightning-ray:before {\n  content: \"\\f04c\";\n}\n\n.icofont-like:before {\n  content: \"\\f04d\";\n}\n\n.icofont-link:before {\n  content: \"\\f04e\";\n}\n\n.icofont-live-support:before {\n  content: \"\\f04f\";\n}\n\n.icofont-location-arrow:before {\n  content: \"\\f050\";\n}\n\n.icofont-location-pin:before {\n  content: \"\\f051\";\n}\n\n.icofont-lock:before {\n  content: \"\\f052\";\n}\n\n.icofont-login:before {\n  content: \"\\f053\";\n}\n\n.icofont-logout:before {\n  content: \"\\f054\";\n}\n\n.icofont-lollipop:before {\n  content: \"\\f055\";\n}\n\n.icofont-look:before {\n  content: \"\\f056\";\n}\n\n.icofont-loop:before {\n  content: \"\\f057\";\n}\n\n.icofont-luggage:before {\n  content: \"\\f058\";\n}\n\n.icofont-lunch:before {\n  content: \"\\f059\";\n}\n\n.icofont-lungs:before {\n  content: \"\\f05a\";\n}\n\n.icofont-magic-alt:before {\n  content: \"\\f05b\";\n}\n\n.icofont-magic:before {\n  content: \"\\f05c\";\n}\n\n.icofont-magnet:before {\n  content: \"\\f05d\";\n}\n\n.icofont-mail-box:before {\n  content: \"\\f05e\";\n}\n\n.icofont-mail:before {\n  content: \"\\f05f\";\n}\n\n.icofont-male:before {\n  content: \"\\f060\";\n}\n\n.icofont-map:before {\n  content: \"\\f061\";\n}\n\n.icofont-math:before {\n  content: \"\\f062\";\n}\n\n.icofont-maximize:before {\n  content: \"\\f063\";\n}\n\n.icofont-measure:before {\n  content: \"\\f064\";\n}\n\n.icofont-medal:before {\n  content: \"\\f065\";\n}\n\n.icofont-medical:before {\n  content: \"\\f066\";\n}\n\n.icofont-medicine:before {\n  content: \"\\f067\";\n}\n\n.icofont-mega-phone:before {\n  content: \"\\f068\";\n}\n\n.icofont-memorial:before {\n  content: \"\\f069\";\n}\n\n.icofont-memory-card:before {\n  content: \"\\f06a\";\n}\n\n.icofont-mic-mute:before {\n  content: \"\\f06b\";\n}\n\n.icofont-mic:before {\n  content: \"\\f06c\";\n}\n\n.icofont-micro-chip:before {\n  content: \"\\f06d\";\n}\n\n.icofont-microphone:before {\n  content: \"\\f06e\";\n}\n\n.icofont-microscope:before {\n  content: \"\\f06f\";\n}\n\n.icofont-military:before {\n  content: \"\\f070\";\n}\n\n.icofont-mill:before {\n  content: \"\\f071\";\n}\n\n.icofont-minus-circle:before {\n  content: \"\\f072\";\n}\n\n.icofont-minus-square:before {\n  content: \"\\f073\";\n}\n\n.icofont-minus:before {\n  content: \"\\f074\";\n}\n\n.icofont-mobile-phone:before {\n  content: \"\\f075\";\n}\n\n.icofont-molecule:before {\n  content: \"\\f076\";\n}\n\n.icofont-money:before {\n  content: \"\\f077\";\n}\n\n.icofont-moon:before {\n  content: \"\\f078\";\n}\n\n.icofont-mop:before {\n  content: \"\\f079\";\n}\n\n.icofont-muffin:before {\n  content: \"\\f07a\";\n}\n\n.icofont-music-alt:before {\n  content: \"\\f07b\";\n}\n\n.icofont-music-notes:before {\n  content: \"\\f07c\";\n}\n\n.icofont-music:before {\n  content: \"\\f07d\";\n}\n\n.icofont-mustache:before {\n  content: \"\\f07e\";\n}\n\n.icofont-mute-volume:before {\n  content: \"\\f07f\";\n}\n\n.icofont-navigation-menu:before {\n  content: \"\\f080\";\n}\n\n.icofont-navigation:before {\n  content: \"\\f081\";\n}\n\n.icofont-network-tower:before {\n  content: \"\\f082\";\n}\n\n.icofont-network:before {\n  content: \"\\f083\";\n}\n\n.icofont-news:before {\n  content: \"\\f084\";\n}\n\n.icofont-newspaper:before {\n  content: \"\\f085\";\n}\n\n.icofont-no-smoking:before {\n  content: \"\\f086\";\n}\n\n.icofont-not-allowed:before {\n  content: \"\\f087\";\n}\n\n.icofont-notebook:before {\n  content: \"\\f088\";\n}\n\n.icofont-notepad:before {\n  content: \"\\f089\";\n}\n\n.icofont-notification:before {\n  content: \"\\f08a\";\n}\n\n.icofont-numbered:before {\n  content: \"\\f08b\";\n}\n\n.icofont-opposite:before {\n  content: \"\\f08c\";\n}\n\n.icofont-optic:before {\n  content: \"\\f08d\";\n}\n\n.icofont-options:before {\n  content: \"\\f08e\";\n}\n\n.icofont-package:before {\n  content: \"\\f08f\";\n}\n\n.icofont-page:before {\n  content: \"\\f090\";\n}\n\n.icofont-paint:before {\n  content: \"\\f091\";\n}\n\n.icofont-paper-plane:before {\n  content: \"\\f092\";\n}\n\n.icofont-paperclip:before {\n  content: \"\\f093\";\n}\n\n.icofont-papers:before {\n  content: \"\\f094\";\n}\n\n.icofont-paw:before {\n  content: \"\\f095\";\n}\n\n.icofont-pay:before {\n  content: \"\\f096\";\n}\n\n.icofont-pen:before {\n  content: \"\\f097\";\n}\n\n.icofont-pencil:before {\n  content: \"\\f098\";\n}\n\n.icofont-penguin-linux:before {\n  content: \"\\f099\";\n}\n\n.icofont-pestle:before {\n  content: \"\\f09a\";\n}\n\n.icofont-phone-circle:before {\n  content: \"\\f09b\";\n}\n\n.icofont-phone:before {\n  content: \"\\f09c\";\n}\n\n.icofont-picture:before {\n  content: \"\\f09d\";\n}\n\n.icofont-pie:before {\n  content: \"\\f09e\";\n}\n\n.icofont-pine:before {\n  content: \"\\f09f\";\n}\n\n.icofont-pixels:before {\n  content: \"\\f0a0\";\n}\n\n.icofont-play:before {\n  content: \"\\f0a1\";\n}\n\n.icofont-plugin:before {\n  content: \"\\f0a2\";\n}\n\n.icofont-plus-circle:before {\n  content: \"\\f0a3\";\n}\n\n.icofont-plus-square:before {\n  content: \"\\f0a4\";\n}\n\n.icofont-plus:before {\n  content: \"\\f0a5\";\n}\n\n.icofont-polygonal:before {\n  content: \"\\f0a6\";\n}\n\n.icofont-power:before {\n  content: \"\\f0a7\";\n}\n\n.icofont-presentation:before {\n  content: \"\\f0a8\";\n}\n\n.icofont-price:before {\n  content: \"\\f0a9\";\n}\n\n.icofont-print:before {\n  content: \"\\f0aa\";\n}\n\n.icofont-puzzle:before {\n  content: \"\\f0ab\";\n}\n\n.icofont-qr-code:before {\n  content: \"\\f0ac\";\n}\n\n.icofont-queen:before {\n  content: \"\\f0ad\";\n}\n\n.icofont-question-circle:before {\n  content: \"\\f0ae\";\n}\n\n.icofont-question-square:before {\n  content: \"\\f0af\";\n}\n\n.icofont-question:before {\n  content: \"\\f0b0\";\n}\n\n.icofont-quote-left:before {\n  content: \"\\f0b1\";\n}\n\n.icofont-quote-right:before {\n  content: \"\\f0b2\";\n}\n\n.icofont-radio:before {\n  content: \"\\f0b3\";\n}\n\n.icofont-random:before {\n  content: \"\\f0b4\";\n}\n\n.icofont-recycle:before {\n  content: \"\\f0b5\";\n}\n\n.icofont-refresh:before {\n  content: \"\\f0b6\";\n}\n\n.icofont-repair:before {\n  content: \"\\f0b7\";\n}\n\n.icofont-reply-all:before {\n  content: \"\\f0b8\";\n}\n\n.icofont-reply:before {\n  content: \"\\f0b9\";\n}\n\n.icofont-resize:before {\n  content: \"\\f0ba\";\n}\n\n.icofont-responsive:before {\n  content: \"\\f0bb\";\n}\n\n.icofont-retweet:before {\n  content: \"\\f0bc\";\n}\n\n.icofont-road:before {\n  content: \"\\f0bd\";\n}\n\n.icofont-robot:before {\n  content: \"\\f0be\";\n}\n\n.icofont-rocket:before {\n  content: \"\\f0bf\";\n}\n\n.icofont-royal:before {\n  content: \"\\f0c0\";\n}\n\n.icofont-rss-feed:before {\n  content: \"\\f0c1\";\n}\n\n.icofont-safety:before {\n  content: \"\\f0c2\";\n}\n\n.icofont-sale-discount:before {\n  content: \"\\f0c3\";\n}\n\n.icofont-satellite:before {\n  content: \"\\f0c4\";\n}\n\n.icofont-send-mail:before {\n  content: \"\\f0c5\";\n}\n\n.icofont-server:before {\n  content: \"\\f0c6\";\n}\n\n.icofont-settings:before {\n  content: \"\\f0c7\";\n}\n\n.icofont-share-alt:before {\n  content: \"\\f0c8\";\n}\n\n.icofont-share-boxed:before {\n  content: \"\\f0c9\";\n}\n\n.icofont-share:before {\n  content: \"\\f0ca\";\n}\n\n.icofont-shield:before {\n  content: \"\\f0cb\";\n}\n\n.icofont-ship:before {\n  content: \"\\f0cc\";\n}\n\n.icofont-shopping-cart:before {\n  content: \"\\f0cd\";\n}\n\n.icofont-sign-in:before {\n  content: \"\\f0ce\";\n}\n\n.icofont-sign-out:before {\n  content: \"\\f0cf\";\n}\n\n.icofont-signal:before {\n  content: \"\\f0d0\";\n}\n\n.icofont-site-map:before {\n  content: \"\\f0d1\";\n}\n\n.icofont-smart-phone:before {\n  content: \"\\f0d2\";\n}\n\n.icofont-soccer:before {\n  content: \"\\f0d3\";\n}\n\n.icofont-sort-alt:before {\n  content: \"\\f0d4\";\n}\n\n.icofont-sort:before {\n  content: \"\\f0d5\";\n}\n\n.icofont-space:before {\n  content: \"\\f0d6\";\n}\n\n.icofont-spanner:before {\n  content: \"\\f0d7\";\n}\n\n.icofont-speech-comments:before {\n  content: \"\\f0d8\";\n}\n\n.icofont-speed-meter:before {\n  content: \"\\f0d9\";\n}\n\n.icofont-spinner-alt-1:before {\n  content: \"\\f0da\";\n}\n\n.icofont-spinner-alt-2:before {\n  content: \"\\f0db\";\n}\n\n.icofont-spinner-alt-3:before {\n  content: \"\\f0dc\";\n}\n\n.icofont-spinner-alt-4:before {\n  content: \"\\f0dd\";\n}\n\n.icofont-spinner-alt-5:before {\n  content: \"\\f0de\";\n}\n\n.icofont-spinner-alt-6:before {\n  content: \"\\f0df\";\n}\n\n.icofont-spinner:before {\n  content: \"\\f0e0\";\n}\n\n.icofont-spreadsheet:before {\n  content: \"\\f0e1\";\n}\n\n.icofont-square:before {\n  content: \"\\f0e2\";\n}\n\n.icofont-ssl-security:before {\n  content: \"\\f0e3\";\n}\n\n.icofont-star-alt-1:before {\n  content: \"\\f0e4\";\n}\n\n.icofont-star-alt-2:before {\n  content: \"\\f0e5\";\n}\n\n.icofont-star:before {\n  content: \"\\f0e6\";\n}\n\n.icofont-street-view:before {\n  content: \"\\f0e7\";\n}\n\n.icofont-sun:before {\n  content: \"\\f0e8\";\n}\n\n.icofont-support-faq:before {\n  content: \"\\f0e9\";\n}\n\n.icofont-tack-pin:before {\n  content: \"\\f0ea\";\n}\n\n.icofont-tag:before {\n  content: \"\\f0eb\";\n}\n\n.icofont-tags:before {\n  content: \"\\f0ec\";\n}\n\n.icofont-tasks:before {\n  content: \"\\f0ed\";\n}\n\n.icofont-telephone:before {\n  content: \"\\f0ee\";\n}\n\n.icofont-telescope:before {\n  content: \"\\f0ef\";\n}\n\n.icofont-terminal:before {\n  content: \"\\f0f0\";\n}\n\n.icofont-thumbs-down:before {\n  content: \"\\f0f1\";\n}\n\n.icofont-thumbs-up:before {\n  content: \"\\f0f2\";\n}\n\n.icofont-tick-boxed:before {\n  content: \"\\f0f3\";\n}\n\n.icofont-tick-mark:before {\n  content: \"\\f0f4\";\n}\n\n.icofont-ticket:before {\n  content: \"\\f0f5\";\n}\n\n.icofont-tie:before {\n  content: \"\\f0f6\";\n}\n\n.icofont-toggle-off:before {\n  content: \"\\f0f7\";\n}\n\n.icofont-toggle-on:before {\n  content: \"\\f0f8\";\n}\n\n.icofont-tools:before {\n  content: \"\\f0f9\";\n}\n\n.icofont-transparent:before {\n  content: \"\\f0fa\";\n}\n\n.icofont-tree:before {\n  content: \"\\f0fb\";\n}\n\n.icofont-umbrella:before {\n  content: \"\\f0fc\";\n}\n\n.icofont-unlock:before {\n  content: \"\\f0fd\";\n}\n\n.icofont-unlocked:before {\n  content: \"\\f0fe\";\n}\n\n.icofont-upload-alt:before {\n  content: \"\\f0ff\";\n}\n\n.icofont-upload:before {\n  content: \"\\f100\";\n}\n\n.icofont-usb-drive:before {\n  content: \"\\f101\";\n}\n\n.icofont-usb:before {\n  content: \"\\f102\";\n}\n\n.icofont-vector-path:before {\n  content: \"\\f103\";\n}\n\n.icofont-verification-check:before {\n  content: \"\\f104\";\n}\n\n.icofont-video-clapper:before {\n  content: \"\\f105\";\n}\n\n.icofont-video:before {\n  content: \"\\f106\";\n}\n\n.icofont-volume-down:before {\n  content: \"\\f107\";\n}\n\n.icofont-volume-off:before {\n  content: \"\\f108\";\n}\n\n.icofont-volume-up:before {\n  content: \"\\f109\";\n}\n\n.icofont-wall-clock:before {\n  content: \"\\f10a\";\n}\n\n.icofont-wall:before {\n  content: \"\\f10b\";\n}\n\n.icofont-wallet:before {\n  content: \"\\f10c\";\n}\n\n.icofont-warning-alt:before {\n  content: \"\\f10d\";\n}\n\n.icofont-warning:before {\n  content: \"\\f10e\";\n}\n\n.icofont-water-drop:before {\n  content: \"\\f10f\";\n}\n\n.icofont-web:before {\n  content: \"\\f110\";\n}\n\n.icofont-wheelchair:before {\n  content: \"\\f111\";\n}\n\n.icofont-wifi-alt:before {\n  content: \"\\f112\";\n}\n\n.icofont-wifi:before {\n  content: \"\\f113\";\n}\n\n.icofont-world:before {\n  content: \"\\f114\";\n}\n\n.icofont-zigzag:before {\n  content: \"\\f115\";\n}\n\n.icofont-zipped:before {\n  content: \"\\f116\";\n}\n\n.icofont-social-500px:before {\n  content: \"\\f117\";\n}\n\n.icofont-social-baidu-tieba:before {\n  content: \"\\f118\";\n}\n\n.icofont-social-bbm-messenger:before {\n  content: \"\\f119\";\n}\n\n.icofont-social-delicious:before {\n  content: \"\\f11a\";\n}\n\n.icofont-social-dribbble:before {\n  content: \"\\f11b\";\n}\n\n.icofont-social-facebook-messenger:before {\n  content: \"\\f11c\";\n}\n\n.icofont-social-flikr:before {\n  content: \"\\f11d\";\n}\n\n.icofont-social-foursquare:before {\n  content: \"\\f11e\";\n}\n\n.icofont-social-google-hangouts:before {\n  content: \"\\f11f\";\n}\n\n.icofont-social-kakaotalk:before {\n  content: \"\\f120\";\n}\n\n.icofont-social-kik:before {\n  content: \"\\f121\";\n}\n\n.icofont-social-kiwibox:before {\n  content: \"\\f122\";\n}\n\n.icofont-social-linkedin:before {\n  content: \"\\f123\";\n}\n\n.icofont-social-meetme:before {\n  content: \"\\f124\";\n}\n\n.icofont-social-odnoklassniki:before {\n  content: \"\\f125\";\n}\n\n.icofont-social-photobucket:before {\n  content: \"\\f126\";\n}\n\n.icofont-social-qq:before {\n  content: \"\\f127\";\n}\n\n.icofont-social-renren:before {\n  content: \"\\f128\";\n}\n\n.icofont-social-slack:before {\n  content: \"\\f129\";\n}\n\n.icofont-social-slidshare:before {\n  content: \"\\f12a\";\n}\n\n.icofont-social-snapchat:before {\n  content: \"\\f12b\";\n}\n\n.icofont-social-soundcloud:before {\n  content: \"\\f12c\";\n}\n\n.icofont-social-spotify:before {\n  content: \"\\f12d\";\n}\n\n.icofont-social-stack-exchange:before {\n  content: \"\\f12e\";\n}\n\n.icofont-social-stack-overflow:before {\n  content: \"\\f12f\";\n}\n\n.icofont-social-tagged:before {\n  content: \"\\f130\";\n}\n\n.icofont-social-trello:before {\n  content: \"\\f131\";\n}\n\n.icofont-social-twitch:before {\n  content: \"\\f132\";\n}\n\n.icofont-social-vk:before {\n  content: \"\\f133\";\n}\n\n.icofont-social-weibo:before {\n  content: \"\\f134\";\n}\n\n.icofont-social-whatsapp:before {\n  content: \"\\f135\";\n}\n\n.icofont-social-youku:before {\n  content: \"\\f136\";\n}\n\n.icofont-social-youtube-play:before {\n  content: \"\\f137\";\n}\n\n.icofont-social-youtube:before {\n  content: \"\\f138\";\n}\n\n.icofont-brand-xiaomi:before {\n  content: \"\\f139\";\n}\n\n/*Font size*/\n.icofont-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.icofont-2x {\n  font-size: 2em;\n}\n\n.icofont-3x {\n  font-size: 3em;\n}\n\n.icofont-4x {\n  font-size: 4em;\n}\n\n.icofont-5x {\n  font-size: 5em;\n}\n\n.icofont-fw {\n  display: inline-block;\n  width: 1.28571429em;\n  text-align: center;\n  width: 1.28571429em;\n  text-align: center;\n}\n\n/*Fixed Width Icons*/\n/*Custom list icons*/\n.icofont-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.icofont-ul > li {\n  position: relative;\n}\n\n.icofont-li {\n  position: absolute;\n  left: -2.14285714em;\n  width: 2.14285714em;\n  top: 0.14285714em;\n  text-align: center;\n}\n\n/*Animation*/\n.icofont-rotate {\n  display: inline-block;\n  -webkit-animation: icofont-rotate 2s infinite linear;\n  animation: icofont-rotate 2s infinite linear;\n}\n\n@-webkit-keyframes icofont-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes icofont-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n/* FONT PATH\n * -------------------------- */\n@font-face {\n  font-family: \"FontAwesome\";\n  src: url(\"../../fonts/font-awesome/fontawesome-webfont.eot?v=4.7.0\");\n  src: url(\"../../fonts/font-awesome/fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"), url(\"../../fonts/font-awesome/fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"), url(\"../../fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"), url(\"../../fonts/font-awesome/fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"), url(\"../../fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* makes the font 33% larger relative to the icon container */\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-fw {\n  width: 1.2857142857em;\n  text-align: center;\n}\n\n.fa-ul {\n  padding-left: 0;\n  margin-left: 2.1428571429em;\n  list-style-type: none;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  position: absolute;\n  left: -2.1428571429em;\n  width: 2.1428571429em;\n  top: 0.1428571429em;\n  text-align: center;\n}\n.fa-li.fa-lg {\n  left: -1.8571428571em;\n}\n\n.fa-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n/* Deprecated as of 4.4.0 */\n.pull-right {\n  float: right;\n}\n\n.pull-left {\n  float: left;\n}\n\n.fa.pull-left {\n  margin-right: 0.3em;\n}\n.fa.pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n  animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n  animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  filter: none;\n}\n\n.fa-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.fa-stack-1x, .fa-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.fa-stack-1x {\n  line-height: inherit;\n}\n\n.fa-stack-2x {\n  font-size: 2em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n.fa-glass:before {\n  content: \"\\f000\";\n}\n\n.fa-music:before {\n  content: \"\\f001\";\n}\n\n.fa-search:before {\n  content: \"\\f002\";\n}\n\n.fa-envelope-o:before {\n  content: \"\\f003\";\n}\n\n.fa-heart:before {\n  content: \"\\f004\";\n}\n\n.fa-star:before {\n  content: \"\\f005\";\n}\n\n.fa-star-o:before {\n  content: \"\\f006\";\n}\n\n.fa-user:before {\n  content: \"\\f007\";\n}\n\n.fa-film:before {\n  content: \"\\f008\";\n}\n\n.fa-th-large:before {\n  content: \"\\f009\";\n}\n\n.fa-th:before {\n  content: \"\\f00a\";\n}\n\n.fa-th-list:before {\n  content: \"\\f00b\";\n}\n\n.fa-check:before {\n  content: \"\\f00c\";\n}\n\n.fa-remove:before,\n.fa-close:before,\n.fa-times:before {\n  content: \"\\f00d\";\n}\n\n.fa-search-plus:before {\n  content: \"\\f00e\";\n}\n\n.fa-search-minus:before {\n  content: \"\\f010\";\n}\n\n.fa-power-off:before {\n  content: \"\\f011\";\n}\n\n.fa-signal:before {\n  content: \"\\f012\";\n}\n\n.fa-gear:before,\n.fa-cog:before {\n  content: \"\\f013\";\n}\n\n.fa-trash-o:before {\n  content: \"\\f014\";\n}\n\n.fa-home:before {\n  content: \"\\f015\";\n}\n\n.fa-file-o:before {\n  content: \"\\f016\";\n}\n\n.fa-clock-o:before {\n  content: \"\\f017\";\n}\n\n.fa-road:before {\n  content: \"\\f018\";\n}\n\n.fa-download:before {\n  content: \"\\f019\";\n}\n\n.fa-arrow-circle-o-down:before {\n  content: \"\\f01a\";\n}\n\n.fa-arrow-circle-o-up:before {\n  content: \"\\f01b\";\n}\n\n.fa-inbox:before {\n  content: \"\\f01c\";\n}\n\n.fa-play-circle-o:before {\n  content: \"\\f01d\";\n}\n\n.fa-rotate-right:before,\n.fa-repeat:before {\n  content: \"\\f01e\";\n}\n\n.fa-refresh:before {\n  content: \"\\f021\";\n}\n\n.fa-list-alt:before {\n  content: \"\\f022\";\n}\n\n.fa-lock:before {\n  content: \"\\f023\";\n}\n\n.fa-flag:before {\n  content: \"\\f024\";\n}\n\n.fa-headphones:before {\n  content: \"\\f025\";\n}\n\n.fa-volume-off:before {\n  content: \"\\f026\";\n}\n\n.fa-volume-down:before {\n  content: \"\\f027\";\n}\n\n.fa-volume-up:before {\n  content: \"\\f028\";\n}\n\n.fa-qrcode:before {\n  content: \"\\f029\";\n}\n\n.fa-barcode:before {\n  content: \"\\f02a\";\n}\n\n.fa-tag:before {\n  content: \"\\f02b\";\n}\n\n.fa-tags:before {\n  content: \"\\f02c\";\n}\n\n.fa-book:before {\n  content: \"\\f02d\";\n}\n\n.fa-bookmark:before {\n  content: \"\\f02e\";\n}\n\n.fa-print:before {\n  content: \"\\f02f\";\n}\n\n.fa-camera:before {\n  content: \"\\f030\";\n}\n\n.fa-font:before {\n  content: \"\\f031\";\n}\n\n.fa-bold:before {\n  content: \"\\f032\";\n}\n\n.fa-italic:before {\n  content: \"\\f033\";\n}\n\n.fa-text-height:before {\n  content: \"\\f034\";\n}\n\n.fa-text-width:before {\n  content: \"\\f035\";\n}\n\n.fa-align-left:before {\n  content: \"\\f036\";\n}\n\n.fa-align-center:before {\n  content: \"\\f037\";\n}\n\n.fa-align-right:before {\n  content: \"\\f038\";\n}\n\n.fa-align-justify:before {\n  content: \"\\f039\";\n}\n\n.fa-list:before {\n  content: \"\\f03a\";\n}\n\n.fa-dedent:before,\n.fa-outdent:before {\n  content: \"\\f03b\";\n}\n\n.fa-indent:before {\n  content: \"\\f03c\";\n}\n\n.fa-video-camera:before {\n  content: \"\\f03d\";\n}\n\n.fa-photo:before,\n.fa-image:before,\n.fa-picture-o:before {\n  content: \"\\f03e\";\n}\n\n.fa-pencil:before {\n  content: \"\\f040\";\n}\n\n.fa-map-marker:before {\n  content: \"\\f041\";\n}\n\n.fa-adjust:before {\n  content: \"\\f042\";\n}\n\n.fa-tint:before {\n  content: \"\\f043\";\n}\n\n.fa-edit:before,\n.fa-pencil-square-o:before {\n  content: \"\\f044\";\n}\n\n.fa-share-square-o:before {\n  content: \"\\f045\";\n}\n\n.fa-check-square-o:before {\n  content: \"\\f046\";\n}\n\n.fa-arrows:before {\n  content: \"\\f047\";\n}\n\n.fa-step-backward:before {\n  content: \"\\f048\";\n}\n\n.fa-fast-backward:before {\n  content: \"\\f049\";\n}\n\n.fa-backward:before {\n  content: \"\\f04a\";\n}\n\n.fa-play:before {\n  content: \"\\f04b\";\n}\n\n.fa-pause:before {\n  content: \"\\f04c\";\n}\n\n.fa-stop:before {\n  content: \"\\f04d\";\n}\n\n.fa-forward:before {\n  content: \"\\f04e\";\n}\n\n.fa-fast-forward:before {\n  content: \"\\f050\";\n}\n\n.fa-step-forward:before {\n  content: \"\\f051\";\n}\n\n.fa-eject:before {\n  content: \"\\f052\";\n}\n\n.fa-chevron-left:before {\n  content: \"\\f053\";\n}\n\n.fa-chevron-right:before {\n  content: \"\\f054\";\n}\n\n.fa-plus-circle:before {\n  content: \"\\f055\";\n}\n\n.fa-minus-circle:before {\n  content: \"\\f056\";\n}\n\n.fa-times-circle:before {\n  content: \"\\f057\";\n}\n\n.fa-check-circle:before {\n  content: \"\\f058\";\n}\n\n.fa-question-circle:before {\n  content: \"\\f059\";\n}\n\n.fa-info-circle:before {\n  content: \"\\f05a\";\n}\n\n.fa-crosshairs:before {\n  content: \"\\f05b\";\n}\n\n.fa-times-circle-o:before {\n  content: \"\\f05c\";\n}\n\n.fa-check-circle-o:before {\n  content: \"\\f05d\";\n}\n\n.fa-ban:before {\n  content: \"\\f05e\";\n}\n\n.fa-arrow-left:before {\n  content: \"\\f060\";\n}\n\n.fa-arrow-right:before {\n  content: \"\\f061\";\n}\n\n.fa-arrow-up:before {\n  content: \"\\f062\";\n}\n\n.fa-arrow-down:before {\n  content: \"\\f063\";\n}\n\n.fa-mail-forward:before,\n.fa-share:before {\n  content: \"\\f064\";\n}\n\n.fa-expand:before {\n  content: \"\\f065\";\n}\n\n.fa-compress:before {\n  content: \"\\f066\";\n}\n\n.fa-plus:before {\n  content: \"\\f067\";\n}\n\n.fa-minus:before {\n  content: \"\\f068\";\n}\n\n.fa-asterisk:before {\n  content: \"\\f069\";\n}\n\n.fa-exclamation-circle:before {\n  content: \"\\f06a\";\n}\n\n.fa-gift:before {\n  content: \"\\f06b\";\n}\n\n.fa-leaf:before {\n  content: \"\\f06c\";\n}\n\n.fa-fire:before {\n  content: \"\\f06d\";\n}\n\n.fa-eye:before {\n  content: \"\\f06e\";\n}\n\n.fa-eye-slash:before {\n  content: \"\\f070\";\n}\n\n.fa-warning:before,\n.fa-exclamation-triangle:before {\n  content: \"\\f071\";\n}\n\n.fa-plane:before {\n  content: \"\\f072\";\n}\n\n.fa-calendar:before {\n  content: \"\\f073\";\n}\n\n.fa-random:before {\n  content: \"\\f074\";\n}\n\n.fa-comment:before {\n  content: \"\\f075\";\n}\n\n.fa-magnet:before {\n  content: \"\\f076\";\n}\n\n.fa-chevron-up:before {\n  content: \"\\f077\";\n}\n\n.fa-chevron-down:before {\n  content: \"\\f078\";\n}\n\n.fa-retweet:before {\n  content: \"\\f079\";\n}\n\n.fa-shopping-cart:before {\n  content: \"\\f07a\";\n}\n\n.fa-folder:before {\n  content: \"\\f07b\";\n}\n\n.fa-folder-open:before {\n  content: \"\\f07c\";\n}\n\n.fa-arrows-v:before {\n  content: \"\\f07d\";\n}\n\n.fa-arrows-h:before {\n  content: \"\\f07e\";\n}\n\n.fa-bar-chart-o:before,\n.fa-bar-chart:before {\n  content: \"\\f080\";\n}\n\n.fa-twitter-square:before {\n  content: \"\\f081\";\n}\n\n.fa-facebook-square:before {\n  content: \"\\f082\";\n}\n\n.fa-camera-retro:before {\n  content: \"\\f083\";\n}\n\n.fa-key:before {\n  content: \"\\f084\";\n}\n\n.fa-gears:before,\n.fa-cogs:before {\n  content: \"\\f085\";\n}\n\n.fa-comments:before {\n  content: \"\\f086\";\n}\n\n.fa-thumbs-o-up:before {\n  content: \"\\f087\";\n}\n\n.fa-thumbs-o-down:before {\n  content: \"\\f088\";\n}\n\n.fa-star-half:before {\n  content: \"\\f089\";\n}\n\n.fa-heart-o:before {\n  content: \"\\f08a\";\n}\n\n.fa-sign-out:before {\n  content: \"\\f08b\";\n}\n\n.fa-linkedin-square:before {\n  content: \"\\f08c\";\n}\n\n.fa-thumb-tack:before {\n  content: \"\\f08d\";\n}\n\n.fa-external-link:before {\n  content: \"\\f08e\";\n}\n\n.fa-sign-in:before {\n  content: \"\\f090\";\n}\n\n.fa-trophy:before {\n  content: \"\\f091\";\n}\n\n.fa-github-square:before {\n  content: \"\\f092\";\n}\n\n.fa-upload:before {\n  content: \"\\f093\";\n}\n\n.fa-lemon-o:before {\n  content: \"\\f094\";\n}\n\n.fa-phone:before {\n  content: \"\\f095\";\n}\n\n.fa-square-o:before {\n  content: \"\\f096\";\n}\n\n.fa-bookmark-o:before {\n  content: \"\\f097\";\n}\n\n.fa-phone-square:before {\n  content: \"\\f098\";\n}\n\n.fa-twitter:before {\n  content: \"\\f099\";\n}\n\n.fa-facebook-f:before,\n.fa-facebook:before {\n  content: \"\\f09a\";\n}\n\n.fa-github:before {\n  content: \"\\f09b\";\n}\n\n.fa-unlock:before {\n  content: \"\\f09c\";\n}\n\n.fa-credit-card:before {\n  content: \"\\f09d\";\n}\n\n.fa-feed:before,\n.fa-rss:before {\n  content: \"\\f09e\";\n}\n\n.fa-hdd-o:before {\n  content: \"\\f0a0\";\n}\n\n.fa-bullhorn:before {\n  content: \"\\f0a1\";\n}\n\n.fa-bell:before {\n  content: \"\\f0f3\";\n}\n\n.fa-certificate:before {\n  content: \"\\f0a3\";\n}\n\n.fa-hand-o-right:before {\n  content: \"\\f0a4\";\n}\n\n.fa-hand-o-left:before {\n  content: \"\\f0a5\";\n}\n\n.fa-hand-o-up:before {\n  content: \"\\f0a6\";\n}\n\n.fa-hand-o-down:before {\n  content: \"\\f0a7\";\n}\n\n.fa-arrow-circle-left:before {\n  content: \"\\f0a8\";\n}\n\n.fa-arrow-circle-right:before {\n  content: \"\\f0a9\";\n}\n\n.fa-arrow-circle-up:before {\n  content: \"\\f0aa\";\n}\n\n.fa-arrow-circle-down:before {\n  content: \"\\f0ab\";\n}\n\n.fa-globe:before {\n  content: \"\\f0ac\";\n}\n\n.fa-wrench:before {\n  content: \"\\f0ad\";\n}\n\n.fa-tasks:before {\n  content: \"\\f0ae\";\n}\n\n.fa-filter:before {\n  content: \"\\f0b0\";\n}\n\n.fa-briefcase:before {\n  content: \"\\f0b1\";\n}\n\n.fa-arrows-alt:before {\n  content: \"\\f0b2\";\n}\n\n.fa-group:before,\n.fa-users:before {\n  content: \"\\f0c0\";\n}\n\n.fa-chain:before,\n.fa-link:before {\n  content: \"\\f0c1\";\n}\n\n.fa-cloud:before {\n  content: \"\\f0c2\";\n}\n\n.fa-flask:before {\n  content: \"\\f0c3\";\n}\n\n.fa-cut:before,\n.fa-scissors:before {\n  content: \"\\f0c4\";\n}\n\n.fa-copy:before,\n.fa-files-o:before {\n  content: \"\\f0c5\";\n}\n\n.fa-paperclip:before {\n  content: \"\\f0c6\";\n}\n\n.fa-save:before,\n.fa-floppy-o:before {\n  content: \"\\f0c7\";\n}\n\n.fa-square:before {\n  content: \"\\f0c8\";\n}\n\n.fa-navicon:before,\n.fa-reorder:before,\n.fa-bars:before {\n  content: \"\\f0c9\";\n}\n\n.fa-list-ul:before {\n  content: \"\\f0ca\";\n}\n\n.fa-list-ol:before {\n  content: \"\\f0cb\";\n}\n\n.fa-strikethrough:before {\n  content: \"\\f0cc\";\n}\n\n.fa-underline:before {\n  content: \"\\f0cd\";\n}\n\n.fa-table:before {\n  content: \"\\f0ce\";\n}\n\n.fa-magic:before {\n  content: \"\\f0d0\";\n}\n\n.fa-truck:before {\n  content: \"\\f0d1\";\n}\n\n.fa-pinterest:before {\n  content: \"\\f0d2\";\n}\n\n.fa-pinterest-square:before {\n  content: \"\\f0d3\";\n}\n\n.fa-google-plus-square:before {\n  content: \"\\f0d4\";\n}\n\n.fa-google-plus:before {\n  content: \"\\f0d5\";\n}\n\n.fa-money:before {\n  content: \"\\f0d6\";\n}\n\n.fa-caret-down:before {\n  content: \"\\f0d7\";\n}\n\n.fa-caret-up:before {\n  content: \"\\f0d8\";\n}\n\n.fa-caret-left:before {\n  content: \"\\f0d9\";\n}\n\n.fa-caret-right:before {\n  content: \"\\f0da\";\n}\n\n.fa-columns:before {\n  content: \"\\f0db\";\n}\n\n.fa-unsorted:before,\n.fa-sort:before {\n  content: \"\\f0dc\";\n}\n\n.fa-sort-down:before,\n.fa-sort-desc:before {\n  content: \"\\f0dd\";\n}\n\n.fa-sort-up:before,\n.fa-sort-asc:before {\n  content: \"\\f0de\";\n}\n\n.fa-envelope:before {\n  content: \"\\f0e0\";\n}\n\n.fa-linkedin:before {\n  content: \"\\f0e1\";\n}\n\n.fa-rotate-left:before,\n.fa-undo:before {\n  content: \"\\f0e2\";\n}\n\n.fa-legal:before,\n.fa-gavel:before {\n  content: \"\\f0e3\";\n}\n\n.fa-dashboard:before,\n.fa-tachometer:before {\n  content: \"\\f0e4\";\n}\n\n.fa-comment-o:before {\n  content: \"\\f0e5\";\n}\n\n.fa-comments-o:before {\n  content: \"\\f0e6\";\n}\n\n.fa-flash:before,\n.fa-bolt:before {\n  content: \"\\f0e7\";\n}\n\n.fa-sitemap:before {\n  content: \"\\f0e8\";\n}\n\n.fa-umbrella:before {\n  content: \"\\f0e9\";\n}\n\n.fa-paste:before,\n.fa-clipboard:before {\n  content: \"\\f0ea\";\n}\n\n.fa-lightbulb-o:before {\n  content: \"\\f0eb\";\n}\n\n.fa-exchange:before {\n  content: \"\\f0ec\";\n}\n\n.fa-cloud-download:before {\n  content: \"\\f0ed\";\n}\n\n.fa-cloud-upload:before {\n  content: \"\\f0ee\";\n}\n\n.fa-user-md:before {\n  content: \"\\f0f0\";\n}\n\n.fa-stethoscope:before {\n  content: \"\\f0f1\";\n}\n\n.fa-suitcase:before {\n  content: \"\\f0f2\";\n}\n\n.fa-bell-o:before {\n  content: \"\\f0a2\";\n}\n\n.fa-coffee:before {\n  content: \"\\f0f4\";\n}\n\n.fa-cutlery:before {\n  content: \"\\f0f5\";\n}\n\n.fa-file-text-o:before {\n  content: \"\\f0f6\";\n}\n\n.fa-building-o:before {\n  content: \"\\f0f7\";\n}\n\n.fa-hospital-o:before {\n  content: \"\\f0f8\";\n}\n\n.fa-ambulance:before {\n  content: \"\\f0f9\";\n}\n\n.fa-medkit:before {\n  content: \"\\f0fa\";\n}\n\n.fa-fighter-jet:before {\n  content: \"\\f0fb\";\n}\n\n.fa-beer:before {\n  content: \"\\f0fc\";\n}\n\n.fa-h-square:before {\n  content: \"\\f0fd\";\n}\n\n.fa-plus-square:before {\n  content: \"\\f0fe\";\n}\n\n.fa-angle-double-left:before {\n  content: \"\\f100\";\n}\n\n.fa-angle-double-right:before {\n  content: \"\\f101\";\n}\n\n.fa-angle-double-up:before {\n  content: \"\\f102\";\n}\n\n.fa-angle-double-down:before {\n  content: \"\\f103\";\n}\n\n.fa-angle-left:before {\n  content: \"\\f104\";\n}\n\n.fa-angle-right:before {\n  content: \"\\f105\";\n}\n\n.fa-angle-up:before {\n  content: \"\\f106\";\n}\n\n.fa-angle-down:before {\n  content: \"\\f107\";\n}\n\n.fa-desktop:before {\n  content: \"\\f108\";\n}\n\n.fa-laptop:before {\n  content: \"\\f109\";\n}\n\n.fa-tablet:before {\n  content: \"\\f10a\";\n}\n\n.fa-mobile-phone:before,\n.fa-mobile:before {\n  content: \"\\f10b\";\n}\n\n.fa-circle-o:before {\n  content: \"\\f10c\";\n}\n\n.fa-quote-left:before {\n  content: \"\\f10d\";\n}\n\n.fa-quote-right:before {\n  content: \"\\f10e\";\n}\n\n.fa-spinner:before {\n  content: \"\\f110\";\n}\n\n.fa-circle:before {\n  content: \"\\f111\";\n}\n\n.fa-mail-reply:before,\n.fa-reply:before {\n  content: \"\\f112\";\n}\n\n.fa-github-alt:before {\n  content: \"\\f113\";\n}\n\n.fa-folder-o:before {\n  content: \"\\f114\";\n}\n\n.fa-folder-open-o:before {\n  content: \"\\f115\";\n}\n\n.fa-smile-o:before {\n  content: \"\\f118\";\n}\n\n.fa-frown-o:before {\n  content: \"\\f119\";\n}\n\n.fa-meh-o:before {\n  content: \"\\f11a\";\n}\n\n.fa-gamepad:before {\n  content: \"\\f11b\";\n}\n\n.fa-keyboard-o:before {\n  content: \"\\f11c\";\n}\n\n.fa-flag-o:before {\n  content: \"\\f11d\";\n}\n\n.fa-flag-checkered:before {\n  content: \"\\f11e\";\n}\n\n.fa-terminal:before {\n  content: \"\\f120\";\n}\n\n.fa-code:before {\n  content: \"\\f121\";\n}\n\n.fa-mail-reply-all:before,\n.fa-reply-all:before {\n  content: \"\\f122\";\n}\n\n.fa-star-half-empty:before,\n.fa-star-half-full:before,\n.fa-star-half-o:before {\n  content: \"\\f123\";\n}\n\n.fa-location-arrow:before {\n  content: \"\\f124\";\n}\n\n.fa-crop:before {\n  content: \"\\f125\";\n}\n\n.fa-code-fork:before {\n  content: \"\\f126\";\n}\n\n.fa-unlink:before,\n.fa-chain-broken:before {\n  content: \"\\f127\";\n}\n\n.fa-question:before {\n  content: \"\\f128\";\n}\n\n.fa-info:before {\n  content: \"\\f129\";\n}\n\n.fa-exclamation:before {\n  content: \"\\f12a\";\n}\n\n.fa-superscript:before {\n  content: \"\\f12b\";\n}\n\n.fa-subscript:before {\n  content: \"\\f12c\";\n}\n\n.fa-eraser:before {\n  content: \"\\f12d\";\n}\n\n.fa-puzzle-piece:before {\n  content: \"\\f12e\";\n}\n\n.fa-microphone:before {\n  content: \"\\f130\";\n}\n\n.fa-microphone-slash:before {\n  content: \"\\f131\";\n}\n\n.fa-shield:before {\n  content: \"\\f132\";\n}\n\n.fa-calendar-o:before {\n  content: \"\\f133\";\n}\n\n.fa-fire-extinguisher:before {\n  content: \"\\f134\";\n}\n\n.fa-rocket:before {\n  content: \"\\f135\";\n}\n\n.fa-maxcdn:before {\n  content: \"\\f136\";\n}\n\n.fa-chevron-circle-left:before {\n  content: \"\\f137\";\n}\n\n.fa-chevron-circle-right:before {\n  content: \"\\f138\";\n}\n\n.fa-chevron-circle-up:before {\n  content: \"\\f139\";\n}\n\n.fa-chevron-circle-down:before {\n  content: \"\\f13a\";\n}\n\n.fa-html5:before {\n  content: \"\\f13b\";\n}\n\n.fa-css3:before {\n  content: \"\\f13c\";\n}\n\n.fa-anchor:before {\n  content: \"\\f13d\";\n}\n\n.fa-unlock-alt:before {\n  content: \"\\f13e\";\n}\n\n.fa-bullseye:before {\n  content: \"\\f140\";\n}\n\n.fa-ellipsis-h:before {\n  content: \"\\f141\";\n}\n\n.fa-ellipsis-v:before {\n  content: \"\\f142\";\n}\n\n.fa-rss-square:before {\n  content: \"\\f143\";\n}\n\n.fa-play-circle:before {\n  content: \"\\f144\";\n}\n\n.fa-ticket:before {\n  content: \"\\f145\";\n}\n\n.fa-minus-square:before {\n  content: \"\\f146\";\n}\n\n.fa-minus-square-o:before {\n  content: \"\\f147\";\n}\n\n.fa-level-up:before {\n  content: \"\\f148\";\n}\n\n.fa-level-down:before {\n  content: \"\\f149\";\n}\n\n.fa-check-square:before {\n  content: \"\\f14a\";\n}\n\n.fa-pencil-square:before {\n  content: \"\\f14b\";\n}\n\n.fa-external-link-square:before {\n  content: \"\\f14c\";\n}\n\n.fa-share-square:before {\n  content: \"\\f14d\";\n}\n\n.fa-compass:before {\n  content: \"\\f14e\";\n}\n\n.fa-toggle-down:before,\n.fa-caret-square-o-down:before {\n  content: \"\\f150\";\n}\n\n.fa-toggle-up:before,\n.fa-caret-square-o-up:before {\n  content: \"\\f151\";\n}\n\n.fa-toggle-right:before,\n.fa-caret-square-o-right:before {\n  content: \"\\f152\";\n}\n\n.fa-euro:before,\n.fa-eur:before {\n  content: \"\\f153\";\n}\n\n.fa-gbp:before {\n  content: \"\\f154\";\n}\n\n.fa-dollar:before,\n.fa-usd:before {\n  content: \"\\f155\";\n}\n\n.fa-rupee:before,\n.fa-inr:before {\n  content: \"\\f156\";\n}\n\n.fa-cny:before,\n.fa-rmb:before,\n.fa-yen:before,\n.fa-jpy:before {\n  content: \"\\f157\";\n}\n\n.fa-ruble:before,\n.fa-rouble:before,\n.fa-rub:before {\n  content: \"\\f158\";\n}\n\n.fa-won:before,\n.fa-krw:before {\n  content: \"\\f159\";\n}\n\n.fa-bitcoin:before,\n.fa-btc:before {\n  content: \"\\f15a\";\n}\n\n.fa-file:before {\n  content: \"\\f15b\";\n}\n\n.fa-file-text:before {\n  content: \"\\f15c\";\n}\n\n.fa-sort-alpha-asc:before {\n  content: \"\\f15d\";\n}\n\n.fa-sort-alpha-desc:before {\n  content: \"\\f15e\";\n}\n\n.fa-sort-amount-asc:before {\n  content: \"\\f160\";\n}\n\n.fa-sort-amount-desc:before {\n  content: \"\\f161\";\n}\n\n.fa-sort-numeric-asc:before {\n  content: \"\\f162\";\n}\n\n.fa-sort-numeric-desc:before {\n  content: \"\\f163\";\n}\n\n.fa-thumbs-up:before {\n  content: \"\\f164\";\n}\n\n.fa-thumbs-down:before {\n  content: \"\\f165\";\n}\n\n.fa-youtube-square:before {\n  content: \"\\f166\";\n}\n\n.fa-youtube:before {\n  content: \"\\f167\";\n}\n\n.fa-xing:before {\n  content: \"\\f168\";\n}\n\n.fa-xing-square:before {\n  content: \"\\f169\";\n}\n\n.fa-youtube-play:before {\n  content: \"\\f16a\";\n}\n\n.fa-dropbox:before {\n  content: \"\\f16b\";\n}\n\n.fa-stack-overflow:before {\n  content: \"\\f16c\";\n}\n\n.fa-instagram:before {\n  content: \"\\f16d\";\n}\n\n.fa-flickr:before {\n  content: \"\\f16e\";\n}\n\n.fa-adn:before {\n  content: \"\\f170\";\n}\n\n.fa-bitbucket:before {\n  content: \"\\f171\";\n}\n\n.fa-bitbucket-square:before {\n  content: \"\\f172\";\n}\n\n.fa-tumblr:before {\n  content: \"\\f173\";\n}\n\n.fa-tumblr-square:before {\n  content: \"\\f174\";\n}\n\n.fa-long-arrow-down:before {\n  content: \"\\f175\";\n}\n\n.fa-long-arrow-up:before {\n  content: \"\\f176\";\n}\n\n.fa-long-arrow-left:before {\n  content: \"\\f177\";\n}\n\n.fa-long-arrow-right:before {\n  content: \"\\f178\";\n}\n\n.fa-apple:before {\n  content: \"\\f179\";\n}\n\n.fa-windows:before {\n  content: \"\\f17a\";\n}\n\n.fa-android:before {\n  content: \"\\f17b\";\n}\n\n.fa-linux:before {\n  content: \"\\f17c\";\n}\n\n.fa-dribbble:before {\n  content: \"\\f17d\";\n}\n\n.fa-skype:before {\n  content: \"\\f17e\";\n}\n\n.fa-foursquare:before {\n  content: \"\\f180\";\n}\n\n.fa-trello:before {\n  content: \"\\f181\";\n}\n\n.fa-female:before {\n  content: \"\\f182\";\n}\n\n.fa-male:before {\n  content: \"\\f183\";\n}\n\n.fa-gittip:before,\n.fa-gratipay:before {\n  content: \"\\f184\";\n}\n\n.fa-sun-o:before {\n  content: \"\\f185\";\n}\n\n.fa-moon-o:before {\n  content: \"\\f186\";\n}\n\n.fa-archive:before {\n  content: \"\\f187\";\n}\n\n.fa-bug:before {\n  content: \"\\f188\";\n}\n\n.fa-vk:before {\n  content: \"\\f189\";\n}\n\n.fa-weibo:before {\n  content: \"\\f18a\";\n}\n\n.fa-renren:before {\n  content: \"\\f18b\";\n}\n\n.fa-pagelines:before {\n  content: \"\\f18c\";\n}\n\n.fa-stack-exchange:before {\n  content: \"\\f18d\";\n}\n\n.fa-arrow-circle-o-right:before {\n  content: \"\\f18e\";\n}\n\n.fa-arrow-circle-o-left:before {\n  content: \"\\f190\";\n}\n\n.fa-toggle-left:before,\n.fa-caret-square-o-left:before {\n  content: \"\\f191\";\n}\n\n.fa-dot-circle-o:before {\n  content: \"\\f192\";\n}\n\n.fa-wheelchair:before {\n  content: \"\\f193\";\n}\n\n.fa-vimeo-square:before {\n  content: \"\\f194\";\n}\n\n.fa-turkish-lira:before,\n.fa-try:before {\n  content: \"\\f195\";\n}\n\n.fa-plus-square-o:before {\n  content: \"\\f196\";\n}\n\n.fa-space-shuttle:before {\n  content: \"\\f197\";\n}\n\n.fa-slack:before {\n  content: \"\\f198\";\n}\n\n.fa-envelope-square:before {\n  content: \"\\f199\";\n}\n\n.fa-wordpress:before {\n  content: \"\\f19a\";\n}\n\n.fa-openid:before {\n  content: \"\\f19b\";\n}\n\n.fa-institution:before,\n.fa-bank:before,\n.fa-university:before {\n  content: \"\\f19c\";\n}\n\n.fa-mortar-board:before,\n.fa-graduation-cap:before {\n  content: \"\\f19d\";\n}\n\n.fa-yahoo:before {\n  content: \"\\f19e\";\n}\n\n.fa-google:before {\n  content: \"\\f1a0\";\n}\n\n.fa-reddit:before {\n  content: \"\\f1a1\";\n}\n\n.fa-reddit-square:before {\n  content: \"\\f1a2\";\n}\n\n.fa-stumbleupon-circle:before {\n  content: \"\\f1a3\";\n}\n\n.fa-stumbleupon:before {\n  content: \"\\f1a4\";\n}\n\n.fa-delicious:before {\n  content: \"\\f1a5\";\n}\n\n.fa-digg:before {\n  content: \"\\f1a6\";\n}\n\n.fa-pied-piper-pp:before {\n  content: \"\\f1a7\";\n}\n\n.fa-pied-piper-alt:before {\n  content: \"\\f1a8\";\n}\n\n.fa-drupal:before {\n  content: \"\\f1a9\";\n}\n\n.fa-joomla:before {\n  content: \"\\f1aa\";\n}\n\n.fa-language:before {\n  content: \"\\f1ab\";\n}\n\n.fa-fax:before {\n  content: \"\\f1ac\";\n}\n\n.fa-building:before {\n  content: \"\\f1ad\";\n}\n\n.fa-child:before {\n  content: \"\\f1ae\";\n}\n\n.fa-paw:before {\n  content: \"\\f1b0\";\n}\n\n.fa-spoon:before {\n  content: \"\\f1b1\";\n}\n\n.fa-cube:before {\n  content: \"\\f1b2\";\n}\n\n.fa-cubes:before {\n  content: \"\\f1b3\";\n}\n\n.fa-behance:before {\n  content: \"\\f1b4\";\n}\n\n.fa-behance-square:before {\n  content: \"\\f1b5\";\n}\n\n.fa-steam:before {\n  content: \"\\f1b6\";\n}\n\n.fa-steam-square:before {\n  content: \"\\f1b7\";\n}\n\n.fa-recycle:before {\n  content: \"\\f1b8\";\n}\n\n.fa-automobile:before,\n.fa-car:before {\n  content: \"\\f1b9\";\n}\n\n.fa-cab:before,\n.fa-taxi:before {\n  content: \"\\f1ba\";\n}\n\n.fa-tree:before {\n  content: \"\\f1bb\";\n}\n\n.fa-spotify:before {\n  content: \"\\f1bc\";\n}\n\n.fa-deviantart:before {\n  content: \"\\f1bd\";\n}\n\n.fa-soundcloud:before {\n  content: \"\\f1be\";\n}\n\n.fa-database:before {\n  content: \"\\f1c0\";\n}\n\n.fa-file-pdf-o:before {\n  content: \"\\f1c1\";\n}\n\n.fa-file-word-o:before {\n  content: \"\\f1c2\";\n}\n\n.fa-file-excel-o:before {\n  content: \"\\f1c3\";\n}\n\n.fa-file-powerpoint-o:before {\n  content: \"\\f1c4\";\n}\n\n.fa-file-photo-o:before,\n.fa-file-picture-o:before,\n.fa-file-image-o:before {\n  content: \"\\f1c5\";\n}\n\n.fa-file-zip-o:before,\n.fa-file-archive-o:before {\n  content: \"\\f1c6\";\n}\n\n.fa-file-sound-o:before,\n.fa-file-audio-o:before {\n  content: \"\\f1c7\";\n}\n\n.fa-file-movie-o:before,\n.fa-file-video-o:before {\n  content: \"\\f1c8\";\n}\n\n.fa-file-code-o:before {\n  content: \"\\f1c9\";\n}\n\n.fa-vine:before {\n  content: \"\\f1ca\";\n}\n\n.fa-codepen:before {\n  content: \"\\f1cb\";\n}\n\n.fa-jsfiddle:before {\n  content: \"\\f1cc\";\n}\n\n.fa-life-bouy:before,\n.fa-life-buoy:before,\n.fa-life-saver:before,\n.fa-support:before,\n.fa-life-ring:before {\n  content: \"\\f1cd\";\n}\n\n.fa-circle-o-notch:before {\n  content: \"\\f1ce\";\n}\n\n.fa-ra:before,\n.fa-resistance:before,\n.fa-rebel:before {\n  content: \"\\f1d0\";\n}\n\n.fa-ge:before,\n.fa-empire:before {\n  content: \"\\f1d1\";\n}\n\n.fa-git-square:before {\n  content: \"\\f1d2\";\n}\n\n.fa-git:before {\n  content: \"\\f1d3\";\n}\n\n.fa-y-combinator-square:before,\n.fa-yc-square:before,\n.fa-hacker-news:before {\n  content: \"\\f1d4\";\n}\n\n.fa-tencent-weibo:before {\n  content: \"\\f1d5\";\n}\n\n.fa-qq:before {\n  content: \"\\f1d6\";\n}\n\n.fa-wechat:before,\n.fa-weixin:before {\n  content: \"\\f1d7\";\n}\n\n.fa-send:before,\n.fa-paper-plane:before {\n  content: \"\\f1d8\";\n}\n\n.fa-send-o:before,\n.fa-paper-plane-o:before {\n  content: \"\\f1d9\";\n}\n\n.fa-history:before {\n  content: \"\\f1da\";\n}\n\n.fa-circle-thin:before {\n  content: \"\\f1db\";\n}\n\n.fa-header:before {\n  content: \"\\f1dc\";\n}\n\n.fa-paragraph:before {\n  content: \"\\f1dd\";\n}\n\n.fa-sliders:before {\n  content: \"\\f1de\";\n}\n\n.fa-share-alt:before {\n  content: \"\\f1e0\";\n}\n\n.fa-share-alt-square:before {\n  content: \"\\f1e1\";\n}\n\n.fa-bomb:before {\n  content: \"\\f1e2\";\n}\n\n.fa-soccer-ball-o:before,\n.fa-futbol-o:before {\n  content: \"\\f1e3\";\n}\n\n.fa-tty:before {\n  content: \"\\f1e4\";\n}\n\n.fa-binoculars:before {\n  content: \"\\f1e5\";\n}\n\n.fa-plug:before {\n  content: \"\\f1e6\";\n}\n\n.fa-slideshare:before {\n  content: \"\\f1e7\";\n}\n\n.fa-twitch:before {\n  content: \"\\f1e8\";\n}\n\n.fa-yelp:before {\n  content: \"\\f1e9\";\n}\n\n.fa-newspaper-o:before {\n  content: \"\\f1ea\";\n}\n\n.fa-wifi:before {\n  content: \"\\f1eb\";\n}\n\n.fa-calculator:before {\n  content: \"\\f1ec\";\n}\n\n.fa-paypal:before {\n  content: \"\\f1ed\";\n}\n\n.fa-google-wallet:before {\n  content: \"\\f1ee\";\n}\n\n.fa-cc-visa:before {\n  content: \"\\f1f0\";\n}\n\n.fa-cc-mastercard:before {\n  content: \"\\f1f1\";\n}\n\n.fa-cc-discover:before {\n  content: \"\\f1f2\";\n}\n\n.fa-cc-amex:before {\n  content: \"\\f1f3\";\n}\n\n.fa-cc-paypal:before {\n  content: \"\\f1f4\";\n}\n\n.fa-cc-stripe:before {\n  content: \"\\f1f5\";\n}\n\n.fa-bell-slash:before {\n  content: \"\\f1f6\";\n}\n\n.fa-bell-slash-o:before {\n  content: \"\\f1f7\";\n}\n\n.fa-trash:before {\n  content: \"\\f1f8\";\n}\n\n.fa-copyright:before {\n  content: \"\\f1f9\";\n}\n\n.fa-at:before {\n  content: \"\\f1fa\";\n}\n\n.fa-eyedropper:before {\n  content: \"\\f1fb\";\n}\n\n.fa-paint-brush:before {\n  content: \"\\f1fc\";\n}\n\n.fa-birthday-cake:before {\n  content: \"\\f1fd\";\n}\n\n.fa-area-chart:before {\n  content: \"\\f1fe\";\n}\n\n.fa-pie-chart:before {\n  content: \"\\f200\";\n}\n\n.fa-line-chart:before {\n  content: \"\\f201\";\n}\n\n.fa-lastfm:before {\n  content: \"\\f202\";\n}\n\n.fa-lastfm-square:before {\n  content: \"\\f203\";\n}\n\n.fa-toggle-off:before {\n  content: \"\\f204\";\n}\n\n.fa-toggle-on:before {\n  content: \"\\f205\";\n}\n\n.fa-bicycle:before {\n  content: \"\\f206\";\n}\n\n.fa-bus:before {\n  content: \"\\f207\";\n}\n\n.fa-ioxhost:before {\n  content: \"\\f208\";\n}\n\n.fa-angellist:before {\n  content: \"\\f209\";\n}\n\n.fa-cc:before {\n  content: \"\\f20a\";\n}\n\n.fa-shekel:before,\n.fa-sheqel:before,\n.fa-ils:before {\n  content: \"\\f20b\";\n}\n\n.fa-meanpath:before {\n  content: \"\\f20c\";\n}\n\n.fa-buysellads:before {\n  content: \"\\f20d\";\n}\n\n.fa-connectdevelop:before {\n  content: \"\\f20e\";\n}\n\n.fa-dashcube:before {\n  content: \"\\f210\";\n}\n\n.fa-forumbee:before {\n  content: \"\\f211\";\n}\n\n.fa-leanpub:before {\n  content: \"\\f212\";\n}\n\n.fa-sellsy:before {\n  content: \"\\f213\";\n}\n\n.fa-shirtsinbulk:before {\n  content: \"\\f214\";\n}\n\n.fa-simplybuilt:before {\n  content: \"\\f215\";\n}\n\n.fa-skyatlas:before {\n  content: \"\\f216\";\n}\n\n.fa-cart-plus:before {\n  content: \"\\f217\";\n}\n\n.fa-cart-arrow-down:before {\n  content: \"\\f218\";\n}\n\n.fa-diamond:before {\n  content: \"\\f219\";\n}\n\n.fa-ship:before {\n  content: \"\\f21a\";\n}\n\n.fa-user-secret:before {\n  content: \"\\f21b\";\n}\n\n.fa-motorcycle:before {\n  content: \"\\f21c\";\n}\n\n.fa-street-view:before {\n  content: \"\\f21d\";\n}\n\n.fa-heartbeat:before {\n  content: \"\\f21e\";\n}\n\n.fa-venus:before {\n  content: \"\\f221\";\n}\n\n.fa-mars:before {\n  content: \"\\f222\";\n}\n\n.fa-mercury:before {\n  content: \"\\f223\";\n}\n\n.fa-intersex:before,\n.fa-transgender:before {\n  content: \"\\f224\";\n}\n\n.fa-transgender-alt:before {\n  content: \"\\f225\";\n}\n\n.fa-venus-double:before {\n  content: \"\\f226\";\n}\n\n.fa-mars-double:before {\n  content: \"\\f227\";\n}\n\n.fa-venus-mars:before {\n  content: \"\\f228\";\n}\n\n.fa-mars-stroke:before {\n  content: \"\\f229\";\n}\n\n.fa-mars-stroke-v:before {\n  content: \"\\f22a\";\n}\n\n.fa-mars-stroke-h:before {\n  content: \"\\f22b\";\n}\n\n.fa-neuter:before {\n  content: \"\\f22c\";\n}\n\n.fa-genderless:before {\n  content: \"\\f22d\";\n}\n\n.fa-facebook-official:before {\n  content: \"\\f230\";\n}\n\n.fa-pinterest-p:before {\n  content: \"\\f231\";\n}\n\n.fa-whatsapp:before {\n  content: \"\\f232\";\n}\n\n.fa-server:before {\n  content: \"\\f233\";\n}\n\n.fa-user-plus:before {\n  content: \"\\f234\";\n}\n\n.fa-user-times:before {\n  content: \"\\f235\";\n}\n\n.fa-hotel:before,\n.fa-bed:before {\n  content: \"\\f236\";\n}\n\n.fa-viacoin:before {\n  content: \"\\f237\";\n}\n\n.fa-train:before {\n  content: \"\\f238\";\n}\n\n.fa-subway:before {\n  content: \"\\f239\";\n}\n\n.fa-medium:before {\n  content: \"\\f23a\";\n}\n\n.fa-yc:before,\n.fa-y-combinator:before {\n  content: \"\\f23b\";\n}\n\n.fa-optin-monster:before {\n  content: \"\\f23c\";\n}\n\n.fa-opencart:before {\n  content: \"\\f23d\";\n}\n\n.fa-expeditedssl:before {\n  content: \"\\f23e\";\n}\n\n.fa-battery-4:before,\n.fa-battery:before,\n.fa-battery-full:before {\n  content: \"\\f240\";\n}\n\n.fa-battery-3:before,\n.fa-battery-three-quarters:before {\n  content: \"\\f241\";\n}\n\n.fa-battery-2:before,\n.fa-battery-half:before {\n  content: \"\\f242\";\n}\n\n.fa-battery-1:before,\n.fa-battery-quarter:before {\n  content: \"\\f243\";\n}\n\n.fa-battery-0:before,\n.fa-battery-empty:before {\n  content: \"\\f244\";\n}\n\n.fa-mouse-pointer:before {\n  content: \"\\f245\";\n}\n\n.fa-i-cursor:before {\n  content: \"\\f246\";\n}\n\n.fa-object-group:before {\n  content: \"\\f247\";\n}\n\n.fa-object-ungroup:before {\n  content: \"\\f248\";\n}\n\n.fa-sticky-note:before {\n  content: \"\\f249\";\n}\n\n.fa-sticky-note-o:before {\n  content: \"\\f24a\";\n}\n\n.fa-cc-jcb:before {\n  content: \"\\f24b\";\n}\n\n.fa-cc-diners-club:before {\n  content: \"\\f24c\";\n}\n\n.fa-clone:before {\n  content: \"\\f24d\";\n}\n\n.fa-balance-scale:before {\n  content: \"\\f24e\";\n}\n\n.fa-hourglass-o:before {\n  content: \"\\f250\";\n}\n\n.fa-hourglass-1:before,\n.fa-hourglass-start:before {\n  content: \"\\f251\";\n}\n\n.fa-hourglass-2:before,\n.fa-hourglass-half:before {\n  content: \"\\f252\";\n}\n\n.fa-hourglass-3:before,\n.fa-hourglass-end:before {\n  content: \"\\f253\";\n}\n\n.fa-hourglass:before {\n  content: \"\\f254\";\n}\n\n.fa-hand-grab-o:before,\n.fa-hand-rock-o:before {\n  content: \"\\f255\";\n}\n\n.fa-hand-stop-o:before,\n.fa-hand-paper-o:before {\n  content: \"\\f256\";\n}\n\n.fa-hand-scissors-o:before {\n  content: \"\\f257\";\n}\n\n.fa-hand-lizard-o:before {\n  content: \"\\f258\";\n}\n\n.fa-hand-spock-o:before {\n  content: \"\\f259\";\n}\n\n.fa-hand-pointer-o:before {\n  content: \"\\f25a\";\n}\n\n.fa-hand-peace-o:before {\n  content: \"\\f25b\";\n}\n\n.fa-trademark:before {\n  content: \"\\f25c\";\n}\n\n.fa-registered:before {\n  content: \"\\f25d\";\n}\n\n.fa-creative-commons:before {\n  content: \"\\f25e\";\n}\n\n.fa-gg:before {\n  content: \"\\f260\";\n}\n\n.fa-gg-circle:before {\n  content: \"\\f261\";\n}\n\n.fa-tripadvisor:before {\n  content: \"\\f262\";\n}\n\n.fa-odnoklassniki:before {\n  content: \"\\f263\";\n}\n\n.fa-odnoklassniki-square:before {\n  content: \"\\f264\";\n}\n\n.fa-get-pocket:before {\n  content: \"\\f265\";\n}\n\n.fa-wikipedia-w:before {\n  content: \"\\f266\";\n}\n\n.fa-safari:before {\n  content: \"\\f267\";\n}\n\n.fa-chrome:before {\n  content: \"\\f268\";\n}\n\n.fa-firefox:before {\n  content: \"\\f269\";\n}\n\n.fa-opera:before {\n  content: \"\\f26a\";\n}\n\n.fa-internet-explorer:before {\n  content: \"\\f26b\";\n}\n\n.fa-tv:before,\n.fa-television:before {\n  content: \"\\f26c\";\n}\n\n.fa-contao:before {\n  content: \"\\f26d\";\n}\n\n.fa-500px:before {\n  content: \"\\f26e\";\n}\n\n.fa-amazon:before {\n  content: \"\\f270\";\n}\n\n.fa-calendar-plus-o:before {\n  content: \"\\f271\";\n}\n\n.fa-calendar-minus-o:before {\n  content: \"\\f272\";\n}\n\n.fa-calendar-times-o:before {\n  content: \"\\f273\";\n}\n\n.fa-calendar-check-o:before {\n  content: \"\\f274\";\n}\n\n.fa-industry:before {\n  content: \"\\f275\";\n}\n\n.fa-map-pin:before {\n  content: \"\\f276\";\n}\n\n.fa-map-signs:before {\n  content: \"\\f277\";\n}\n\n.fa-map-o:before {\n  content: \"\\f278\";\n}\n\n.fa-map:before {\n  content: \"\\f279\";\n}\n\n.fa-commenting:before {\n  content: \"\\f27a\";\n}\n\n.fa-commenting-o:before {\n  content: \"\\f27b\";\n}\n\n.fa-houzz:before {\n  content: \"\\f27c\";\n}\n\n.fa-vimeo:before {\n  content: \"\\f27d\";\n}\n\n.fa-black-tie:before {\n  content: \"\\f27e\";\n}\n\n.fa-fonticons:before {\n  content: \"\\f280\";\n}\n\n.fa-reddit-alien:before {\n  content: \"\\f281\";\n}\n\n.fa-edge:before {\n  content: \"\\f282\";\n}\n\n.fa-credit-card-alt:before {\n  content: \"\\f283\";\n}\n\n.fa-codiepie:before {\n  content: \"\\f284\";\n}\n\n.fa-modx:before {\n  content: \"\\f285\";\n}\n\n.fa-fort-awesome:before {\n  content: \"\\f286\";\n}\n\n.fa-usb:before {\n  content: \"\\f287\";\n}\n\n.fa-product-hunt:before {\n  content: \"\\f288\";\n}\n\n.fa-mixcloud:before {\n  content: \"\\f289\";\n}\n\n.fa-scribd:before {\n  content: \"\\f28a\";\n}\n\n.fa-pause-circle:before {\n  content: \"\\f28b\";\n}\n\n.fa-pause-circle-o:before {\n  content: \"\\f28c\";\n}\n\n.fa-stop-circle:before {\n  content: \"\\f28d\";\n}\n\n.fa-stop-circle-o:before {\n  content: \"\\f28e\";\n}\n\n.fa-shopping-bag:before {\n  content: \"\\f290\";\n}\n\n.fa-shopping-basket:before {\n  content: \"\\f291\";\n}\n\n.fa-hashtag:before {\n  content: \"\\f292\";\n}\n\n.fa-bluetooth:before {\n  content: \"\\f293\";\n}\n\n.fa-bluetooth-b:before {\n  content: \"\\f294\";\n}\n\n.fa-percent:before {\n  content: \"\\f295\";\n}\n\n.fa-gitlab:before {\n  content: \"\\f296\";\n}\n\n.fa-wpbeginner:before {\n  content: \"\\f297\";\n}\n\n.fa-wpforms:before {\n  content: \"\\f298\";\n}\n\n.fa-envira:before {\n  content: \"\\f299\";\n}\n\n.fa-universal-access:before {\n  content: \"\\f29a\";\n}\n\n.fa-wheelchair-alt:before {\n  content: \"\\f29b\";\n}\n\n.fa-question-circle-o:before {\n  content: \"\\f29c\";\n}\n\n.fa-blind:before {\n  content: \"\\f29d\";\n}\n\n.fa-audio-description:before {\n  content: \"\\f29e\";\n}\n\n.fa-volume-control-phone:before {\n  content: \"\\f2a0\";\n}\n\n.fa-braille:before {\n  content: \"\\f2a1\";\n}\n\n.fa-assistive-listening-systems:before {\n  content: \"\\f2a2\";\n}\n\n.fa-asl-interpreting:before,\n.fa-american-sign-language-interpreting:before {\n  content: \"\\f2a3\";\n}\n\n.fa-deafness:before,\n.fa-hard-of-hearing:before,\n.fa-deaf:before {\n  content: \"\\f2a4\";\n}\n\n.fa-glide:before {\n  content: \"\\f2a5\";\n}\n\n.fa-glide-g:before {\n  content: \"\\f2a6\";\n}\n\n.fa-signing:before,\n.fa-sign-language:before {\n  content: \"\\f2a7\";\n}\n\n.fa-low-vision:before {\n  content: \"\\f2a8\";\n}\n\n.fa-viadeo:before {\n  content: \"\\f2a9\";\n}\n\n.fa-viadeo-square:before {\n  content: \"\\f2aa\";\n}\n\n.fa-snapchat:before {\n  content: \"\\f2ab\";\n}\n\n.fa-snapchat-ghost:before {\n  content: \"\\f2ac\";\n}\n\n.fa-snapchat-square:before {\n  content: \"\\f2ad\";\n}\n\n.fa-pied-piper:before {\n  content: \"\\f2ae\";\n}\n\n.fa-first-order:before {\n  content: \"\\f2b0\";\n}\n\n.fa-yoast:before {\n  content: \"\\f2b1\";\n}\n\n.fa-themeisle:before {\n  content: \"\\f2b2\";\n}\n\n.fa-google-plus-circle:before,\n.fa-google-plus-official:before {\n  content: \"\\f2b3\";\n}\n\n.fa-fa:before,\n.fa-font-awesome:before {\n  content: \"\\f2b4\";\n}\n\n.fa-handshake-o:before {\n  content: \"\\f2b5\";\n}\n\n.fa-envelope-open:before {\n  content: \"\\f2b6\";\n}\n\n.fa-envelope-open-o:before {\n  content: \"\\f2b7\";\n}\n\n.fa-linode:before {\n  content: \"\\f2b8\";\n}\n\n.fa-address-book:before {\n  content: \"\\f2b9\";\n}\n\n.fa-address-book-o:before {\n  content: \"\\f2ba\";\n}\n\n.fa-vcard:before,\n.fa-address-card:before {\n  content: \"\\f2bb\";\n}\n\n.fa-vcard-o:before,\n.fa-address-card-o:before {\n  content: \"\\f2bc\";\n}\n\n.fa-user-circle:before {\n  content: \"\\f2bd\";\n}\n\n.fa-user-circle-o:before {\n  content: \"\\f2be\";\n}\n\n.fa-user-o:before {\n  content: \"\\f2c0\";\n}\n\n.fa-id-badge:before {\n  content: \"\\f2c1\";\n}\n\n.fa-drivers-license:before,\n.fa-id-card:before {\n  content: \"\\f2c2\";\n}\n\n.fa-drivers-license-o:before,\n.fa-id-card-o:before {\n  content: \"\\f2c3\";\n}\n\n.fa-quora:before {\n  content: \"\\f2c4\";\n}\n\n.fa-free-code-camp:before {\n  content: \"\\f2c5\";\n}\n\n.fa-telegram:before {\n  content: \"\\f2c6\";\n}\n\n.fa-thermometer-4:before,\n.fa-thermometer:before,\n.fa-thermometer-full:before {\n  content: \"\\f2c7\";\n}\n\n.fa-thermometer-3:before,\n.fa-thermometer-three-quarters:before {\n  content: \"\\f2c8\";\n}\n\n.fa-thermometer-2:before,\n.fa-thermometer-half:before {\n  content: \"\\f2c9\";\n}\n\n.fa-thermometer-1:before,\n.fa-thermometer-quarter:before {\n  content: \"\\f2ca\";\n}\n\n.fa-thermometer-0:before,\n.fa-thermometer-empty:before {\n  content: \"\\f2cb\";\n}\n\n.fa-shower:before {\n  content: \"\\f2cc\";\n}\n\n.fa-bathtub:before,\n.fa-s15:before,\n.fa-bath:before {\n  content: \"\\f2cd\";\n}\n\n.fa-podcast:before {\n  content: \"\\f2ce\";\n}\n\n.fa-window-maximize:before {\n  content: \"\\f2d0\";\n}\n\n.fa-window-minimize:before {\n  content: \"\\f2d1\";\n}\n\n.fa-window-restore:before {\n  content: \"\\f2d2\";\n}\n\n.fa-times-rectangle:before,\n.fa-window-close:before {\n  content: \"\\f2d3\";\n}\n\n.fa-times-rectangle-o:before,\n.fa-window-close-o:before {\n  content: \"\\f2d4\";\n}\n\n.fa-bandcamp:before {\n  content: \"\\f2d5\";\n}\n\n.fa-grav:before {\n  content: \"\\f2d6\";\n}\n\n.fa-etsy:before {\n  content: \"\\f2d7\";\n}\n\n.fa-imdb:before {\n  content: \"\\f2d8\";\n}\n\n.fa-ravelry:before {\n  content: \"\\f2d9\";\n}\n\n.fa-eercast:before {\n  content: \"\\f2da\";\n}\n\n.fa-microchip:before {\n  content: \"\\f2db\";\n}\n\n.fa-snowflake-o:before {\n  content: \"\\f2dc\";\n}\n\n.fa-superpowers:before {\n  content: \"\\f2dd\";\n}\n\n.fa-wpexplorer:before {\n  content: \"\\f2de\";\n}\n\n.fa-meetup:before {\n  content: \"\\f2e0\";\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n}\n\n.date-row {\n  display: flex;\n  justify-content: space-between;\n  background-color: #f8f9fa;\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin-bottom: 8px;\n  align-items: center;\n  font-weight: 500;\n}","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.2 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/**=====================\r\n    Admin CSS Start\r\n==========================**/\r\n.card-left {\r\n  z-index: 1;\r\n}\r\n.checkbox-space {\r\n  padding: 0;\r\n}\r\n.form-group {\r\n  margin-bottom: 1rem;\r\n}\r\n.page-wrapper {\r\n  .page-body-wrapper {\r\n    footer {\r\n      &.footer.open {\r\n        margin-left: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n.modal {\r\n  .modal-dialog {\r\n    .modal-content {\r\n      .modal-header {\r\n        .close {\r\n          background-color: unset;\r\n          border: unset;\r\n          span {\r\n            font-size: 24px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n// react plugin css\r\n.category-table,\r\n.products-list.product-physical {\r\n  .rdt_Table {\r\n    .rdt_TableBody {\r\n      .rdt_TableRow {\r\n        .rdt_TableCell {\r\n          &:first-child,\r\n          &:nth-child(4) {\r\n            > div {\r\n              background-color: $auth-bg-color;\r\n            }\r\n          }\r\n          &:nth-child(2),\r\n          &:last-child {\r\n            > div {\r\n              background-color: $white;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.order-datatable {\r\n  .rdt_Table {\r\n    border: 1px solid rgba($black, 0.1);\r\n    .rdt_TableCell,\r\n    .rdt_TableCol {\r\n      padding: 7px 5px;\r\n    }\r\n    .rdt_TableHead {\r\n      box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\r\n      z-index: 1;\r\n      .rdt_TableHeadRow {\r\n        .rdt_TableCol {\r\n          flex: 100 0 auto;\r\n          width: 100px;\r\n          padding: 5px;\r\n          border-right: 1px solid rgba($black, 0.05);\r\n          .rdt_TableCol_Sortable {\r\n            justify-content: center;\r\n            padding: 18px;\r\n            background-color: $light-color;\r\n          }\r\n          b {\r\n            font-size: 14px;\r\n            color: $theme-body-font-color;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .rdt_TableBody {\r\n      .rdt_TableRow {\r\n        .rdt_TableCell {\r\n          justify-content: center;\r\n          font-size: 14px;\r\n          border-right: 1px solid rgba($black, 0.05);\r\n          background-color: $white;\r\n          &:nth-child(2),\r\n          &:nth-child(3),\r\n          &:nth-child(5),\r\n          &:last-child {\r\n            > div {\r\n              background-color: $white;\r\n            }\r\n          }\r\n          > div {\r\n            padding: 5px;\r\n            background-color: $auth-bg-color;\r\n            flex: 100 0 auto;\r\n            width: 100px;\r\n            line-height: 1.5;\r\n            .badge {\r\n              padding: 4px 6px 5px;\r\n            }\r\n          }\r\n          &:last-child {\r\n            border-right: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.product-list,\r\n.translation-list,\r\n.category-table {\r\n  .rdt_Table {\r\n    .rdt_TableHead {\r\n      .rdt_TableHeadRow {\r\n        .rdt_TableCol {\r\n          &:last-child {\r\n            .rdt_TableCol_Sortable {\r\n              padding: 10px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .rdt_TableBody {\r\n      .rdt_TableRow {\r\n        .rdt_TableCell {\r\n          &:first-child,\r\n          &:nth-child(4) {\r\n            > div {\r\n              background-color: $auth-bg-color !important;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.product-list,\r\n.translation-list,\r\n.category-table,\r\n.transactions,\r\n.product-physical {\r\n  .rdt_Table {\r\n    border: 1px solid rgba($black, 0.1);\r\n    .rdt_TableCell,\r\n    .rdt_TableCol {\r\n      padding: 7px 5px;\r\n    }\r\n    .rdt_TableHead {\r\n      box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\r\n      z-index: 1;\r\n      .rdt_TableHeadRow {\r\n        .rdt_TableCol {\r\n          flex: 100 0 auto;\r\n          width: 100px;\r\n          padding: 5px;\r\n          border-right: 1px solid rgba($black, 0.05);\r\n          .rdt_TableCol_Sortable {\r\n            justify-content: center;\r\n            padding: 18px;\r\n            background-color: $light-color;\r\n          }\r\n          b {\r\n            font-size: 14px;\r\n            color: $theme-body-font-color;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .rdt_TableBody {\r\n      .rdt_TableRow {\r\n        .rdt_TableCell {\r\n          justify-content: center;\r\n          font-size: 14px;\r\n          border-right: 1px solid rgba($black, 0.05);\r\n          background-color: $white;\r\n          &:first-child,\r\n          &:nth-child(4),\r\n          &:last-child {\r\n            > div {\r\n              background-color: $white;\r\n            }\r\n          }\r\n          > div {\r\n            padding: 5px;\r\n            background-color: $auth-bg-color;\r\n            flex: 100 0 auto;\r\n            width: 100px;\r\n            line-height: 1.5;\r\n          }\r\n          &:last-child {\r\n            border-right: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.react-datepicker__input-container {\r\n  input {\r\n    border-radius: 0.25rem;\r\n    padding: 0.48rem 0.75rem;\r\n    border: 1px solid #ced4da;\r\n  }\r\n}\r\n.react-datepicker__day--selected,\r\n.react-datepicker__day--in-selecting-range,\r\n.react-datepicker__day--in-range,\r\n.react-datepicker__month-text--selected,\r\n.react-datepicker__month-text--in-selecting-range,\r\n.react-datepicker__month-text--in-range {\r\n  background-color: $primary-color !important;\r\n}\r\n.form-label-center {\r\n  .form-group {\r\n    label {\r\n      margin-top: 8px;\r\n    }\r\n    .form-group {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n.tab-coupon {\r\n  li {\r\n    color: $primary-color;\r\n  }\r\n}\r\n.styles_modal__gNwvD {\r\n  padding: 0;\r\n  button {\r\n    svg {\r\n      width: 18px;\r\n    }\r\n  }\r\n}\r\n.product-page-details {\r\n  h2 {\r\n    margin-bottom: 5px !important;\r\n  }\r\n  label {\r\n    margin-bottom: 0 !important;\r\n  }\r\n  .product-price {\r\n    h3 {\r\n      color: $dark-font;\r\n    }\r\n  }\r\n}\r\n.product-slider {\r\n  margin-bottom: 20px;\r\n}\r\n.small-slick {\r\n  .slick-slide {\r\n    &.slick-current {\r\n      div {\r\n        .item {\r\n          border: 1px solid $primary-color;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.checkbox_animated {\r\n  cursor: pointer;\r\n  position: relative;\r\n  margin: 0 20px 0 0;\r\n  &:checked,\r\n  &:not(:checked) {\r\n    box-shadow: none;\r\n  }\r\n  &:before {\r\n    transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\r\n    transform: rotate(-45deg) scale(0, 0);\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0.25rem;\r\n    top: 0.225rem;\r\n    z-index: 1;\r\n    width: 0.75rem;\r\n    height: 0.375rem;\r\n    border: 2px solid $primary-color;\r\n    border-top-style: none;\r\n    border-right-style: none;\r\n  }\r\n  &:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -0.125rem;\r\n    left: -1px;\r\n    width: 1.3rem;\r\n    height: 1.3rem;\r\n    background: $white;\r\n    border: 2px solid $light-gray;\r\n    cursor: pointer;\r\n  }\r\n  &:checked:before {\r\n    transform: rotate(-45deg) scale(1, 1);\r\n  }\r\n}\r\n.radio_animated {\r\n  position: relative;\r\n  margin: 0 1rem 0 0;\r\n  cursor: pointer;\r\n  vertical-align: -2px;\r\n  &:checked,\r\n  &:not(:checked) {\r\n    box-shadow: none;\r\n  }\r\n  &:before {\r\n    transition: transform 0.4s cubic-bezier(0.45, 1.8, 0.5, 0.75);\r\n    transform: scale(0, 0);\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0.125rem;\r\n    z-index: 1;\r\n    width: 0.75rem;\r\n    height: 0.75rem;\r\n    background: $primary-color;\r\n    border-radius: 50%;\r\n  }\r\n  &:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -0.25rem;\r\n    left: -0.125rem;\r\n    width: 1.25rem;\r\n    height: 1.25rem;\r\n    background: $white;\r\n    border: 2px solid $light-gray;\r\n    border-radius: 50%;\r\n  }\r\n  &:checked:before {\r\n    transform: scale(1, 1);\r\n  }\r\n}\r\na {\r\n  &:hover {\r\n    color: $primary-color;\r\n  }\r\n}\r\n.btn-popup {\r\n  margin-bottom: 30px;\r\n}\r\n// category\r\n.add-product {\r\n  .bigImg {\r\n    img {\r\n      width: 500px;\r\n    }\r\n  }\r\n  ul {\r\n    li {\r\n      display: flex;\r\n      margin-bottom: 15px;\r\n      .box-input-file {\r\n        width: 50px;\r\n        height: 50px;\r\n        background-color: #dddddd;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        vertical-align: middle;\r\n        .upload {\r\n          position: absolute;\r\n          width: 70px;\r\n          left: 0;\r\n          right: 0;\r\n          opacity: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.file-upload-product {\r\n  .uploadImg {\r\n    width: 50px !important;\r\n    height: 50px !important;\r\n  }\r\n}\r\n.dropzone {\r\n  text-align: center;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n  padding: 50px;\r\n  border: 2px dashed $theme-deafult;\r\n  border-radius: 15px;\r\n  border-image: none;\r\n  background: transparent;\r\n  box-sizing: border-box;\r\n  min-height: 150px;\r\n  position: relative;\r\n  i {\r\n    font-size: 50px;\r\n    color: $theme-deafult;\r\n  }\r\n  .dzu-input {\r\n    border: 1px solid #ddd;\r\n    padding: 6px;\r\n    margin-left: 15px;\r\n  }\r\n  .dzu-previewStatusContainer,\r\n  .dzu-submitButtonContainer {\r\n    display: none;\r\n  }\r\n  .dzu-previewImage {\r\n    width: 75px;\r\n  }\r\n}\r\n.digital-add {\r\n  .col-form-label {\r\n    font-family: $font-nunito;\r\n  }\r\n  .form-control {\r\n    font-size: 14px;\r\n  }\r\n  .form-group {\r\n    .radio_animated {\r\n      margin-right: 16px;\r\n    }\r\n  }\r\n  textarea {\r\n    width: 100%;\r\n  }\r\n}\r\n.add-product-form {\r\n  .form-group {\r\n    align-items: center;\r\n    label {\r\n      font-size: 16px;\r\n      font-weight: 600;\r\n    }\r\n    &:last-child {\r\n      align-items: end;\r\n    }\r\n    .form-control {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n  fieldset {\r\n    padding-left: 15px;\r\n    border: none;\r\n  }\r\n  .qty-box {\r\n    width: 15%;\r\n    .touchspin {\r\n      text-align: center;\r\n    }\r\n    .bootstrap-touchspin-prefix {\r\n      display: none;\r\n    }\r\n    .bootstrap-touchspin-postfix {\r\n      display: none;\r\n    }\r\n    .input-group {\r\n      justify-content: flex-start;\r\n      button {\r\n        padding: 12px;\r\n        i {\r\n          font-weight: 900;\r\n          color: #222222;\r\n        }\r\n      }\r\n      .btn-primary {\r\n        background-color: $transparent-color !important;\r\n        border: 1px solid #ddd !important;\r\n        &.bootstrap-touchspin-down {\r\n          border-right: none !important;\r\n        }\r\n      }\r\n      .input-group-append {\r\n        margin-left: 0;\r\n        .btn {\r\n          border-left: none !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.chart-block canvas {\r\n  width: 100%;\r\n}\r\n.sales-carousel {\r\n  .value-graph {\r\n    h3 {\r\n      color: $theme-body-font-color;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n  .media {\r\n    .small-box {\r\n      width: 50px;\r\n      height: 50px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n  }\r\n}\r\n.small-chartjs {\r\n  canvas {\r\n    width: 100% !important;\r\n    height: 60px !important;\r\n  }\r\n}\r\n.order-graph {\r\n  h6 {\r\n    color: $theme-body-font-color;\r\n    font-family: $font-nunito;\r\n    font-weight: 700;\r\n    margin-bottom: 20px;\r\n  }\r\n  .order-graph-bottom {\r\n    margin-top: 30px;\r\n    h6 {\r\n      color: $light-text;\r\n      margin-left: 15px;\r\n      margin-right: 30px;\r\n      span {\r\n        color: $theme-body-font-color;\r\n      }\r\n    }\r\n    .media {\r\n      margin-bottom: 20px;\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n      @each $shape-name, $shape-color in (primary, $primary-color),\r\n        (secondary, $secondary-color), (success, $success-color),\r\n        (danger, $danger-color), (info, $info-color), (light, $light-color),\r\n        (dark, $dark-color), (warning, $warning-color)\r\n      {\r\n        .order-shape-#{$shape-name} {\r\n          background-color: $shape-color;\r\n          width: 18px;\r\n          height: 8px;\r\n          margin-top: 7px;\r\n          border-radius: 4px;\r\n        }\r\n      }\r\n    }\r\n    @each $order-name, $order-color in (primary, $primary-color),\r\n      (secondary, $secondary-color), (success, $success-color),\r\n      (danger, $danger-color), (info, $info-color), (light, $light-color),\r\n      (dark, $dark-color), (warning, $warning-color)\r\n    {\r\n      .order-color-#{$order-name} {\r\n        background-color: $order-color;\r\n        width: 8px;\r\n        height: 8px;\r\n        margin-top: 7px;\r\n        border-radius: 2px;\r\n      }\r\n    }\r\n  }\r\n}\r\n.datepickers-container {\r\n  top: -86px;\r\n}\r\n.datepicker--nav {\r\n  color: $theme-deafult;\r\n}\r\n.datepicker--nav-action {\r\n  color: $theme-deafult;\r\n  background-color: $theme-deafult;\r\n}\r\n.datepicker--nav-action:hover {\r\n  color: $theme-deafult;\r\n}\r\n.datepicker--nav-title i {\r\n  color: $theme-deafult;\r\n}\r\n.table {\r\n  thead {\r\n    th {\r\n      border-bottom: 2px solid $light-gray;\r\n    }\r\n  }\r\n}\r\n.authentication-box {\r\n  min-width: 100vw;\r\n  min-height: 100vh;\r\n  width: auto;\r\n  height: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  .slick-slider {\r\n    margin-bottom: 30px;\r\n  }\r\n  .custom-checkbox\r\n    .custom-control-input:checked\r\n    ~ .custom-control-label::before {\r\n    background-color: $primary-color;\r\n  }\r\n  .back-btn {\r\n    float: right;\r\n    margin: 0;\r\n    font-size: 14px;\r\n    position: relative;\r\n    padding-left: 60px !important;\r\n    svg {\r\n      position: absolute;\r\n      left: 30px;\r\n      height: 18px;\r\n    }\r\n  }\r\n  .row {\r\n    align-items: center;\r\n  }\r\n  .tab2-card {\r\n    .nav-tabs {\r\n      .nav-link {\r\n        font-size: 18px;\r\n        svg {\r\n          width: 20px;\r\n          vertical-align: sub;\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .form-horizontal {\r\n    .form-terms {\r\n      .custom-control {\r\n        padding-left: 24px;\r\n        span {\r\n          a {\r\n            text-decoration: none;\r\n          }\r\n          .forgot-pass {\r\n            color: $primary-color;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .btn-primary {\r\n    border-radius: 25px;\r\n    margin-top: 12px;\r\n    font-weight: 400;\r\n    padding: 11px 45px;\r\n  }\r\n  .form-footer {\r\n    position: relative;\r\n    padding-top: 25px;\r\n    border-top: 1px solid #f3f3f3;\r\n    margin-top: 25px;\r\n    > span {\r\n      position: absolute;\r\n      top: -11px;\r\n      padding-right: 20px;\r\n      background-color: #fff;\r\n      color: #909090;\r\n    }\r\n    .social {\r\n      margin-bottom: 0;\r\n      border-bottom: 0;\r\n      li {\r\n        padding: 10px;\r\n        border-radius: 100%;\r\n        border: 1px solid #12571a;\r\n        height: 40px;\r\n        width: 40px;\r\n        margin-right: 10px;\r\n        text-align: center;\r\n        display: inline-block;\r\n        i {\r\n          font-size: 12px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .slick-dots {\r\n    li {\r\n      &.slick-active {\r\n        button:before {\r\n          color: $white;\r\n        }\r\n      }\r\n      button {\r\n        &:before {\r\n          font-size: 12px;\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .container {\r\n    max-width: 900px;\r\n    .bg-primary {\r\n      padding: 50px;\r\n      background-image: url(\"../../images/dashboard/login-bg.png\");\r\n      background-position: center;\r\n      box-shadow: 1px 5px 24px 0 rgba(13, 84, 4, 0.8);\r\n    }\r\n    .form-group {\r\n      margin-bottom: 1.5rem;\r\n    }\r\n    .svg-icon {\r\n      padding: 24px;\r\n      margin: 0 auto;\r\n      border: 2px dashed $white;\r\n      border-radius: 100%;\r\n      height: 130px;\r\n      width: 130px;\r\n      margin-bottom: 40px;\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n    p {\r\n      color: rgba($white, 0.9);\r\n      font-size: 15px;\r\n      line-height: 2;\r\n      text-align: center;\r\n    }\r\n    h3 {\r\n      color: $white;\r\n      font-weight: 600;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n.media {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n.media-body {\r\n  flex: 1 1;\r\n}\r\n.auth-form {\r\n  .form-control {\r\n    border-radius: 25px;\r\n    padding: 9px 25px;\r\n    border: 1px solid #eaeaea;\r\n  }\r\n}\r\n.switch-sm {\r\n  .switch {\r\n    width: 25px;\r\n    height: 16px;\r\n    margin-top: 10px;\r\n    margin-bottom: 0px;\r\n  }\r\n}\r\n.page-wrapper {\r\n  .page-body-wrapper {\r\n    .page-sidebar {\r\n      .sidebar-menu {\r\n        li {\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n    footer {\r\n      p {\r\n        line-height: 1.7;\r\n      }\r\n    }\r\n    .page-header {\r\n      .row {\r\n        h3 {\r\n          color: #000;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.widget-cards {\r\n  border-radius: 25px !important;\r\n}\r\n.static-top-widget {\r\n  div.align-self-center {\r\n    svg {\r\n      width: 25px;\r\n      height: 25px;\r\n      vertical-align: middle;\r\n    }\r\n  }\r\n  .media-body {\r\n    align-self: center !important;\r\n    h3 {\r\n      font-family: $font-work-sans, $font-serif;\r\n      color: $white;\r\n      small {\r\n        font-size: 11px;\r\n      }\r\n    }\r\n  }\r\n  .icons-widgets {\r\n    .text-center {\r\n      width: 50px;\r\n      height: 50px;\r\n      border-radius: 100%;\r\n      background-color: $white;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n  }\r\n}\r\n.flot-chart-container {\r\n  height: 400px;\r\n}\r\n.user-status {\r\n  table {\r\n    tbody {\r\n      tr {\r\n        td {\r\n          vertical-align: middle;\r\n          padding: 12px;\r\n          border-top: 1px solid $white-4;\r\n          .d-inline-block {\r\n            margin-top: 11px;\r\n          }\r\n          .image-sm-size {\r\n            img {\r\n              width: 41px;\r\n            }\r\n          }\r\n        }\r\n        &:last-child td {\r\n          padding-bottom: 0;\r\n          border-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n    thead {\r\n      tr {\r\n        th {\r\n          border-top: 0;\r\n          font-size: 16px;\r\n          color: $dark-color;\r\n          font-weight: 600;\r\n          padding: 0 12px 12px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.card-block {\r\n  .table-responsive {\r\n    .table {\r\n      caption {\r\n        padding-left: 10px;\r\n      }\r\n    }\r\n    .table-bordered {\r\n      td {\r\n        vertical-align: middle;\r\n      }\r\n    }\r\n  }\r\n  .table-border-radius {\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n  }\r\n}\r\n// product list\r\n.products-admin {\r\n  .product-box {\r\n    padding: 20px;\r\n    .img-wrapper {\r\n      position: relative;\r\n    }\r\n    .lable-block {\r\n      .lable3 {\r\n        border-radius: 100%;\r\n        background-color: $theme-deafult;\r\n        text-align: center;\r\n        font-size: 14px;\r\n        font-weight: 700;\r\n        position: absolute;\r\n        padding: 12px 6px;\r\n        text-transform: uppercase;\r\n        color: $white;\r\n        top: 7px;\r\n        left: 7px;\r\n        z-index: 1;\r\n      }\r\n      .lable4 {\r\n        position: absolute;\r\n        font-size: 14px;\r\n        font-weight: 700;\r\n        text-transform: uppercase;\r\n        writing-mode: vertical-rl;\r\n        transform: rotate(-180deg);\r\n        top: 7px;\r\n        right: 7px;\r\n        letter-spacing: 0.1em;\r\n        z-index: 1;\r\n      }\r\n    }\r\n    .product-detail {\r\n      .rating {\r\n        margin-top: 15px !important;\r\n        i {\r\n          padding-right: 5px;\r\n          &:nth-child(-n + 4) {\r\n            color: $star-yellow;\r\n          }\r\n          &:last-child {\r\n            color: $star-yellow;\r\n          }\r\n        }\r\n      }\r\n      a {\r\n        text-decoration: none;\r\n      }\r\n      h6 {\r\n        line-height: 1;\r\n        margin-bottom: 0;\r\n        padding-top: 2px;\r\n        padding-bottom: 5px;\r\n        transition: all 0.5s ease;\r\n        font-size: 16px;\r\n        color: $grey;\r\n      }\r\n      h4 {\r\n        font-size: 18px;\r\n        color: $dark-font;\r\n        font-weight: 700;\r\n        margin-bottom: 0;\r\n        transition: all 0.5s ease;\r\n        color: $dark-font !important;\r\n      }\r\n      del {\r\n        font-size: 14px;\r\n        color: $font-grey;\r\n        font-weight: 400;\r\n      }\r\n      .color-variant {\r\n        padding-top: 15px;\r\n        li {\r\n          display: inline-block;\r\n          height: 20px;\r\n          width: 20px;\r\n          border-radius: 100%;\r\n          margin-right: 5px;\r\n          transition: all 0.1s ease;\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n    .front {\r\n      position: relative;\r\n      .product-hover {\r\n        position: absolute;\r\n        height: 100%;\r\n        width: 100%;\r\n        top: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        background-color: rgba($white, 0.7);\r\n        opacity: 0;\r\n        border-radius: 100%;\r\n        transform: scale(0);\r\n        transition: all 0.3s ease;\r\n        ul {\r\n          li {\r\n            display: inline-block;\r\n            box-shadow: 1px 1px 2px 1px rgba($black, 0.08);\r\n            padding: 9px 14px;\r\n            background-color: $white;\r\n            font-size: 18px;\r\n            border-radius: 100%;\r\n            line-height: 1.6;\r\n            height: 45px;\r\n            width: 45px;\r\n            margin: 0 3px;\r\n            .btn {\r\n              padding: 0;\r\n              background-color: $transparent-color;\r\n              .editBtn {\r\n                width: 18px;\r\n              }\r\n              svg {\r\n                stroke-width: 1;\r\n              }\r\n              .deleteBtn {\r\n                width: 19px;\r\n                margin-top: 0;\r\n                margin-left: -2px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      &:hover {\r\n        .product-hover {\r\n          opacity: 1;\r\n          border-radius: 0%;\r\n          transform: scale(1);\r\n          transition: all 0.3s ease;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n// product Detail\r\n.size-modal {\r\n  &.modal-dialog {\r\n    .modal-header {\r\n      align-items: flex-start;\r\n    }\r\n  }\r\n}\r\n.product-right {\r\n  .timer {\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n    padding-left: 40px;\r\n    display: inline-block;\r\n    margin-top: 10px;\r\n    background-color: #f7f7f7;\r\n    p {\r\n      color: #222222;\r\n      font-size: 18px;\r\n    }\r\n    span {\r\n      width: 70px;\r\n      display: inline-block;\r\n      .padding-l {\r\n        padding-left: 22px;\r\n        display: inline;\r\n      }\r\n    }\r\n    .timer-cal {\r\n      font-size: 12px;\r\n      color: #777777;\r\n    }\r\n  }\r\n  .size-box {\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    ul {\r\n      li {\r\n        height: 35px;\r\n        width: 35px;\r\n        border-radius: 50%;\r\n        margin-right: 10px;\r\n        cursor: pointer;\r\n        border: 1px solid #f7f7f7;\r\n        text-align: center;\r\n        display: inline-block;\r\n        &.active {\r\n          background-color: #f7f7f7 !important;\r\n        }\r\n        a {\r\n          color: #222222 !important;\r\n          font-size: 18px;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n          height: 100%;\r\n          text-decoration: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .color-variant {\r\n    margin-bottom: 10px !important;\r\n    li {\r\n      height: 30px;\r\n      width: 30px;\r\n      cursor: pointer;\r\n      display: inline-block;\r\n      border-radius: 100%;\r\n      margin-right: 5px;\r\n      transition: all 0.1s ease;\r\n      vertical-align: middle;\r\n    }\r\n  }\r\n  .product-title {\r\n    color: #222222;\r\n    text-transform: capitalize;\r\n    font-weight: 700;\r\n    margin-bottom: 0;\r\n    a {\r\n      color: $theme-deafult !important;\r\n      text-decoration: none;\r\n    }\r\n    p {\r\n      margin-bottom: 0;\r\n      line-height: 1.5em;\r\n    }\r\n    h3 {\r\n      font-size: 26px;\r\n      color: #222222;\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n  h2 {\r\n    text-transform: uppercase;\r\n    margin-bottom: 15px;\r\n    font-size: 25px;\r\n    line-height: 1.2em;\r\n  }\r\n}\r\n.bg-light0 {\r\n  background-color: $light-grey;\r\n}\r\n.bg-light1 {\r\n  background-color: $pink;\r\n}\r\n.bg-light2 {\r\n  background-color: $blue;\r\n}\r\n// profile\r\n.react-tabs {\r\n  .nav-tabs {\r\n    .nav-link {\r\n      color: $font-color;\r\n      transition: 0.3s;\r\n      cursor: pointer;\r\n      &.react-tabs__tab--selected,\r\n      &:hover,\r\n      &:focus {\r\n        border-color: $transparent-color $transparent-color $transparent-color !important;\r\n        border-bottom: 2px solid $primary-color !important;\r\n        color: $primary-color;\r\n        outline: $transparent-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n.deactivate-account {\r\n  margin-top: 30px;\r\n  .btn {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n.account-setting {\r\n  h5 {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n.profile-card {\r\n  ul {\r\n    margin-bottom: 30px;\r\n    border-bottom: 1px solid $white-4;\r\n    li {\r\n      svg {\r\n        width: 18px;\r\n        vertical-align: middle;\r\n      }\r\n    }\r\n  }\r\n}\r\n.profile-details {\r\n  img {\r\n    margin-bottom: 20px;\r\n  }\r\n  .social {\r\n    margin-top: 15px;\r\n    .btn-showcase {\r\n      margin-bottom: -10px;\r\n      .btn {\r\n        padding: 8px 13px;\r\n        margin: 0 5px 20px;\r\n        border-radius: 100%;\r\n        width: 40px;\r\n        height: 40px;\r\n      }\r\n      .btn-fb {\r\n        background-color: #50598e;\r\n        color: $white;\r\n      }\r\n      .btn-google {\r\n        background-color: #c64e40;\r\n        color: $white;\r\n      }\r\n      .btn-twitter {\r\n        background-color: #6fa2d8;\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n}\r\n.project-status {\r\n  margin-top: 20px;\r\n  .media {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n.sm-progress-bar {\r\n  height: 6px;\r\n}\r\n.profile-table {\r\n  table {\r\n    tbody {\r\n      tr {\r\n        td {\r\n          padding: 12px;\r\n          border-bottom: 0;\r\n          &:first-child {\r\n            width: 250px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    th,\r\n    td {\r\n      border-top: none;\r\n    }\r\n  }\r\n}\r\n// reports\r\n.report-employee {\r\n  .card-header {\r\n    border-bottom: none !important;\r\n  }\r\n  .flot-chart-container {\r\n    height: 323px;\r\n  }\r\n}\r\n.sales-chart {\r\n  height: 307px;\r\n}\r\n.expense-chart {\r\n  #area-chart1 {\r\n    height: 307px;\r\n  }\r\n}\r\n// profile\r\n.profile-card {\r\n  .media {\r\n    align-items: center;\r\n    img {\r\n      margin-right: 20px;\r\n    }\r\n  }\r\n}\r\n// Media\r\n.dropzone {\r\n  .dz-preview {\r\n    box-shadow: 0px 0px 3px $primary-color;\r\n    .dz-error-message {\r\n      color: $primary-color !important;\r\n      background: $transparent-color !important;\r\n      border: 1px solid $primary-color !important;\r\n      &:after {\r\n        border-bottom: 6px solid $primary-color !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n//tabs\r\n.tab-coupon {\r\n  margin-bottom: 30px;\r\n}\r\n.needs-validation {\r\n  .permission-block {\r\n    .attribute-blocks {\r\n      padding-left: 15px;\r\n      .row {\r\n        padding-left: 20px;\r\n      }\r\n      + .attribute-blocks {\r\n        h5 {\r\n          margin-top: 30px;\r\n        }\r\n      }\r\n      h6 {\r\n        border-bottom: 1px solid $light-semi-gray;\r\n        margin-bottom: 15px;\r\n        padding-bottom: 5px;\r\n      }\r\n    }\r\n  }\r\n  h4 {\r\n    font-weight: 600;\r\n    margin-bottom: 20px;\r\n  }\r\n  input {\r\n    font-size: 14px;\r\n  }\r\n  .form-group {\r\n    align-items: center;\r\n    label {\r\n      margin-bottom: 0;\r\n      span {\r\n        color: red;\r\n      }\r\n    }\r\n    .checkbox {\r\n      padding-left: 0;\r\n    }\r\n  }\r\n  .editor-label {\r\n    align-items: end;\r\n  }\r\n  .editor-space {\r\n    padding: 0;\r\n  }\r\n  .checkbox {\r\n    input {\r\n      opacity: 0;\r\n    }\r\n    label {\r\n      display: inline-block;\r\n      position: relative;\r\n      padding-left: 16px;\r\n      cursor: pointer;\r\n      margin-top: 10px;\r\n      margin-bottom: 10px;\r\n      &::before {\r\n        content: \"\";\r\n        display: inline-block;\r\n        position: absolute;\r\n        width: 19px;\r\n        height: 19px;\r\n        left: 0;\r\n        margin-left: -16px;\r\n        border: 1px solid #e8ebf2;\r\n        border-radius: 3px;\r\n        background-color: #fff;\r\n        -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\r\n        transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\r\n      }\r\n    }\r\n    input[type=\"checkbox\"]:checked + label::before {\r\n      font-family: $font-ICO;\r\n      content: \"\\efab\";\r\n      text-align: center;\r\n      line-height: 1;\r\n      font-size: 18px;\r\n    }\r\n  }\r\n  .checkbox-primary {\r\n    input[type=\"checkbox\"]:checked + label::before {\r\n      border-color: $primary-color;\r\n      color: $primary-color;\r\n    }\r\n  }\r\n  .radio-animated {\r\n    label {\r\n      margin-right: 20px;\r\n    }\r\n  }\r\n  textarea {\r\n    border: 1px solid #ced4da;\r\n    border-radius: 0.25rem;\r\n  }\r\n}\r\n// datatable\r\n.badge-warning {\r\n  color: $white;\r\n}\r\n.user-list {\r\n  img {\r\n    border-radius: 100%;\r\n  }\r\n}\r\n/**=====================\r\n  Admin CSS Ends\r\n==========================**/\r\n/**=====================\r\n      Button CSS start\r\n==========================**/\r\n@mixin btn-gradien(\r\n  $deg,\r\n  $leftcolor,\r\n  $leftcolor-per,\r\n  $rightcolor,\r\n  $rightcolor-per,\r\n  $font-color\r\n) {\r\n  background-image: linear-gradient(\r\n    to right,\r\n    $leftcolor 0%,\r\n    $rightcolor 51%,\r\n    $leftcolor 100%\r\n  );\r\n  border: none;\r\n  color: $font-color;\r\n  background-size: auto 200%;\r\n  transition: all 0.3s ease;\r\n}\r\n@mixin btn-squre($border-radius) {\r\n  border-radius: $border-radius + px;\r\n}\r\n@mixin btn-pill($border-radius) {\r\n  border-radius: $border-radius + px;\r\n}\r\n@mixin btn-pill-first($radius) {\r\n  border-radius: $radius + px 0 0 $radius + px;\r\n}\r\n@mixin btn-pill-last($radius) {\r\n  border-radius: 0 $radius + px $radius + px 0;\r\n}\r\n.btn {\r\n  font-size: $btn-font-size;\r\n  padding: $btn-padding;\r\n  border-radius: 5px;\r\n  letter-spacing: 1px;\r\n  line-height: 20px;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n}\r\n.btn-lg {\r\n  font-size: $btn-lg-font-size;\r\n}\r\n.btn-sm {\r\n  font-size: $btn-sm-font-size;\r\n}\r\n.btn-xs {\r\n  padding: $btn-xs-padding;\r\n  font-size: $btn-xs-font-size;\r\n}\r\n.large-btn {\r\n  .btn {\r\n    margin-right: 5px;\r\n    margin-bottom: 15px;\r\n  }\r\n  margin-bottom: -20px;\r\n}\r\n// forms //\r\n@each $btn-name, $btn-color in (primary, $primary-color),\r\n  (secondary, $secondary-color), (success, $success-color),\r\n  (danger, $danger-color), (info, $info-color), (light, $light-color),\r\n  (dark, $dark-color), (warning, $warning-color)\r\n{\r\n  .input-air-#{$btn-name} {\r\n    box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\r\n    &:focus {\r\n      border-color: $btn-color;\r\n    }\r\n  }\r\n}\r\n//input background //\r\n@each $btn-name, $btn-color in (primary, $primary-color),\r\n  (secondary, $secondary-color), (success, $success-color),\r\n  (danger, $danger-color), (info, $info-color), (light, $light-color),\r\n  (dark, $dark-color), (warning, $warning-color)\r\n{\r\n  .form-bg-#{$btn-name} {\r\n    background: $btn-color;\r\n    border-color: $btn-color;\r\n    @if ($btn-name == light) {\r\n      color: $dark-color;\r\n    } @else {\r\n      color: $white;\r\n    }\r\n    &:focus {\r\n      border-color: $btn-color;\r\n      background: $btn-color;\r\n      @if ($btn-name == light) {\r\n        color: $dark-color;\r\n      } @else {\r\n        color: $white;\r\n      }\r\n      &:active {\r\n        border-color: $btn-color;\r\n        background: $btn-color;\r\n        @if ($btn-name == light) {\r\n          color: $dark-color;\r\n        } @else {\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.btn-warning {\r\n  color: $white;\r\n  &:hover,\r\n  &.disabled {\r\n    color: $white;\r\n  }\r\n}\r\n.btn-primary-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($primary-color, 8%),\r\n    0%,\r\n    darken($primary-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:focus,\r\n  &:active,\r\n  &.active {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($primary-color, 8%),\r\n      0%,\r\n      darken($primary-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n.btn-secondary-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($secondary-color, 8%),\r\n    0%,\r\n    darken($secondary-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &.active,\r\n  &.hover {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($secondary-color, 8%),\r\n      0%,\r\n      darken($secondary-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n.btn-success-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($success-color, 8%),\r\n    0%,\r\n    darken($success-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &.active,\r\n  &.hover {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($success-color, 8%),\r\n      0%,\r\n      darken($success-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n.btn-danger-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($danger-color, 8%),\r\n    0%,\r\n    darken($danger-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &.active,\r\n  &.hover {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($danger-color, 8%),\r\n      0%,\r\n      darken($danger-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n.btn-warning-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($warning-color, 8%),\r\n    0%,\r\n    darken($warning-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &.active,\r\n  &.hover {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($warning-color, 8%),\r\n      0%,\r\n      darken($warning-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n.btn-info-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($info-color, 8%),\r\n    0%,\r\n    darken($info-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &.active,\r\n  &.hover {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($info-color, 8%),\r\n      0%,\r\n      darken($info-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n.btn-light {\r\n  margin-left: 7px;\r\n}\r\n.btn-light-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($light-color, 8%),\r\n    0%,\r\n    darken($light-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &.active,\r\n  &.hover {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($light-color, 8%),\r\n      0%,\r\n      darken($light-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n.btn-dark-gradien {\r\n  @include btn-gradien(\r\n    60,\r\n    lighten($dark-color, 8%),\r\n    0%,\r\n    darken($dark-color, 8%),\r\n    100%,\r\n    $white\r\n  );\r\n  &:hover,\r\n  &:focus,\r\n  &:active,\r\n  &.active,\r\n  &.hover {\r\n    transition: 1.5s;\r\n    background-position: right center;\r\n    background-image: linear-gradient(\r\n      to right,\r\n      lighten($dark-color, 8%),\r\n      0%,\r\n      darken($dark-color, 8%),\r\n      100%,\r\n      $white\r\n    ) !important;\r\n  }\r\n}\r\n[class*=\"-gradien\"] {\r\n  &:hover {\r\n    background-size: 50% 100%;\r\n    transition: all 0.3s ease;\r\n    color: $white;\r\n  }\r\n}\r\n/**=====================\r\n Button CSS end\r\n==========================**/\r\n/**=====================\r\n      Card CSS Start\r\n==========================**/\r\n.card {\r\n  margin-bottom: $card-margin-bottom;\r\n  border: $card-border-width;\r\n  transition: all 0.3s ease;\r\n  letter-spacing: 0.5px;\r\n  border-radius: $card-border-radious;\r\n  box-shadow: $card-box-shadow;\r\n  .card-header {\r\n    background-color: $card-header-bg-color;\r\n    border-bottom: none;\r\n    padding: $card-padding;\r\n    border-bottom: 1px solid $card-border-color;\r\n    border-top-left-radius: $card-border-radious;\r\n    border-top-right-radius: $card-border-radious;\r\n    h5 {\r\n      font-size: $card-header-font-size;\r\n      margin-bottom: 0;\r\n      text-transform: $card-header-font-transform;\r\n      font-weight: $card-header-font-weight;\r\n      line-height: 24px;\r\n    }\r\n    > span {\r\n      font-size: $card-header-span-size;\r\n      color: $card-header-span-color;\r\n      margin-top: 5px;\r\n      display: block;\r\n      letter-spacing: 1px;\r\n    }\r\n  }\r\n  .card-body {\r\n    padding: $card-padding;\r\n    background-color: $card-body-bg-color;\r\n    p {\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n  }\r\n  .sub-title {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n    padding-bottom: 5px;\r\n    margin-bottom: 8px;\r\n    font-size: 18px;\r\n  }\r\n  .card-footer {\r\n    background-color: $card-footer-bg-color;\r\n    border-top: 1px solid $card-border-color;\r\n    padding: $card-padding;\r\n    border-bottom-left-radius: $card-border-radious;\r\n    border-bottom-right-radius: $card-border-radious;\r\n  }\r\n}\r\n.card-header {\r\n  .nav-material {\r\n    margin-bottom: -13px;\r\n  }\r\n}\r\n/**=====================\r\n     Card CSS End\r\n==========================**/\r\n/**=====================\r\n      Footer CSS Start\r\n==========================**/\r\nfooter {\r\n  background-color: $footer_bg_color;\r\n  border-top: 1px solid $footer_top_bgr_color;\r\n  padding: 15px;\r\n  bottom: 0;\r\n  left: 0;\r\n  a {\r\n    font-weight: 600;\r\n  }\r\n}\r\n.page-wrapper {\r\n  .page-body-wrapper {\r\n    footer {\r\n      margin-left: 255px;\r\n      transition: all 0.3s ease;\r\n      bottom: 0;\r\n      z-index: 8;\r\n      p {\r\n        color: rgb(165, 165, 165);\r\n        i {\r\n          color: $danger-color;\r\n          margin-left: 5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n/**=====================\r\n      Footer CSS Ends\r\n==========================**/\r\n/**=====================\r\n      General CSS Start\r\n==========================**/\r\n//Custom css Start\r\nh1 {\r\n  font-size: 60px;\r\n  color: $dark-font;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  span {\r\n    font-size: 107px;\r\n    font-weight: 700;\r\n    color: $primary-color;\r\n  }\r\n}\r\nh2 {\r\n  font-size: 36px;\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n  color: $black;\r\n  line-height: 1;\r\n  letter-spacing: 0.02em;\r\n}\r\nh3 {\r\n  font-size: 24px;\r\n  font-weight: 400;\r\n  color: $grey;\r\n  letter-spacing: 0.03em;\r\n}\r\nh4 {\r\n  font-size: 18px;\r\n  text-transform: capitalize;\r\n  font-weight: 400;\r\n  letter-spacing: 0.03em;\r\n  line-height: 1;\r\n}\r\ndel {\r\n  font-size: 14px;\r\n  color: $font-grey;\r\n  font-weight: 400;\r\n}\r\nh5 {\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  color: $dark-font;\r\n  line-height: 24px;\r\n  letter-spacing: 0.05em;\r\n}\r\nh6 {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: $grey;\r\n  line-height: 24px;\r\n}\r\nbody {\r\n  background-color: $body-bg-color;\r\n  font-size: $body-font-size;\r\n  overflow-x: hidden;\r\n  font-family: $font-work-sans, $font-serif;\r\n  color: $theme-body-font-color;\r\n  position: relative;\r\n}\r\nul {\r\n  padding-left: $ul-padding-left;\r\n  list-style-type: none;\r\n  margin-bottom: 0;\r\n  padding-right: $ul-padding-right;\r\n}\r\nli {\r\n  display: inline-block;\r\n}\r\n* a {\r\n  color: $primary-color;\r\n}\r\n*.btn:focus {\r\n  box-shadow: $btn-focus-box-shadow !important;\r\n}\r\np {\r\n  color: $grey;\r\n  font-size: $paragraph-font-size;\r\n  line-height: $paragraph-line-height;\r\n  letter-spacing: $paragraph-letter-spacing;\r\n}\r\ncode {\r\n  color: $code-tag-color !important;\r\n  background-color: $code-tag-bg-color;\r\n  padding: $code-tag-padding;\r\n  margin: $code-tag-margin;\r\n  border-radius: $code-tag-border-radious;\r\n}\r\na {\r\n  transition: 0.5s ease;\r\n  &:hover {\r\n    text-decoration: none;\r\n    transition: 0.5s ease;\r\n  }\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\nbutton {\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\n:focus {\r\n  outline-color: $all-focus-outline-color;\r\n}\r\n.disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\nsvg {\r\n  vertical-align: baseline;\r\n}\r\ninput {\r\n  &:focus {\r\n    outline-color: $transparent-color;\r\n  }\r\n}\r\n.txt-dark {\r\n  color: $theme-font-color !important;\r\n}\r\n.txt-success {\r\n  color: $success-color !important;\r\n}\r\n.txt-danger {\r\n  color: $danger-color !important;\r\n}\r\n/**=====================\r\n      General CSS Ends\r\n==========================**/\r\n/**=====================\r\n    Header CSS Start\r\n==========================**/\r\n$header-size: 80px;\r\n%common {\r\n  color: $theme-body-font-color;\r\n  border-left-color: $dark-color;\r\n  transition: $sidebar-transition;\r\n}\r\n%for-animated-hover {\r\n  box-shadow: 0 0 2px 2px $light-color;\r\n  transform: translateY(30px);\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  left: 0;\r\n}\r\n%for-animated-hover-box {\r\n  opacity: 1;\r\n  transform: translateY(0px);\r\n  visibility: visible;\r\n  &:before {\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid $white;\r\n    content: \"\";\r\n    top: -7px;\r\n    position: absolute;\r\n    left: 10px;\r\n    z-index: 2;\r\n  }\r\n  &:after {\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 7px solid transparent;\r\n    border-right: 7px solid transparent;\r\n    border-bottom: 7px solid $dark-gray;\r\n    content: \"\";\r\n    top: -7px;\r\n    position: absolute;\r\n    left: 10px;\r\n    z-index: 1;\r\n  }\r\n}\r\n%sidebar-icon {\r\n  display: block;\r\n  transform: rotateX(0deg);\r\n  z-index: 1;\r\n  background-color: $white;\r\n  color: $dark-gray;\r\n  font-size: 14px;\r\n  opacity: 1;\r\n  margin-top: -70px;\r\n  padding: 10px 0;\r\n  text-align: left;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);\r\n  position: absolute;\r\n  width: 245px;\r\n  margin-left: 115px;\r\n}\r\n/*======= Page Header css Start ======= */\r\n.page-wrapper {\r\n  .page-main-header {\r\n    background-color: $main-header-bg-color;\r\n    height: $header-size;\r\n    position: $main-header-position;\r\n    top: $main-header-top;\r\n    z-index: $main-header-z-index;\r\n    box-shadow: $main-header-shadow;\r\n    width: calc(100% - #{$sidebar-width});\r\n    display: flex;\r\n    align-items: center;\r\n    margin-left: $sidebar-width;\r\n    transition: $sidebar-transition;\r\n    &.open {\r\n      margin-left: 0;\r\n      width: 100%;\r\n      transition: $sidebar-transition;\r\n    }\r\n  }\r\n  .page-body-wrapper {\r\n    .page-body {\r\n      min-height: calc(100vh - #{$header-size});\r\n      margin-top: $header-size;\r\n      padding: $page-body-padding;\r\n      position: relative;\r\n      background-color: $light-color;\r\n    }\r\n    .page-header {\r\n      padding-top: $page-header-padding;\r\n      padding-bottom: $page-header-padding;\r\n      .row {\r\n        align-items: center;\r\n        .page-header-left {\r\n          display: flex;\r\n          align-items: center;\r\n        }\r\n        h3 {\r\n          font-size: $page-title-font-size;\r\n          margin-bottom: $page-title-margin-bottom;\r\n          font-weight: $page-title-font-weight;\r\n          text-transform: $page-title-text-tranform;\r\n          font-family: $font-nunito;\r\n          small {\r\n            display: block;\r\n            font-size: 12px;\r\n            margin-top: 7px;\r\n            letter-spacing: 1px;\r\n            text-transform: capitalize;\r\n            color: $theme-body-sub-title-color;\r\n            font-weight: 400;\r\n          }\r\n        }\r\n      }\r\n      .breadcrumb {\r\n        background-color: $transparent-color;\r\n        padding: 0;\r\n        margin-bottom: 0;\r\n        .breadcrumb-item {\r\n          font-family: $font-nunito;\r\n          & + .breadcrumb-item {\r\n            &:before {\r\n              content: $breadcrumb-content;\r\n            }\r\n          }\r\n          a {\r\n            svg {\r\n              width: $breadcrumb-size;\r\n              height: $breadcrumb-size;\r\n              vertical-align: $breadcrumb-svg-icon-align;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n/*======= Page Header css ends  ======= */\r\n/**======Main Header css Start ======**/\r\n.page-main-header {\r\n  max-width: 100vw;\r\n  .main-header-right {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: $main-header-right-padding;\r\n    margin: 0;\r\n    svg {\r\n      color: $main-header-right-toggle-color;\r\n      line,\r\n      polyline {\r\n        color: $main-header-right-toggle-color;\r\n      }\r\n    }\r\n    .nav-left {\r\n      i {\r\n        margin-right: 20px;\r\n      }\r\n      input:focus {\r\n        outline: 0 !important;\r\n      }\r\n    }\r\n    .nav-right {\r\n      text-align: right;\r\n      padding-left: $main-header-right-nav-right;\r\n      ul {\r\n        li {\r\n          .media {\r\n            .dotted-animation {\r\n              position: relative;\r\n              right: -3px;\r\n              top: -7px;\r\n              .animate-circle {\r\n                position: absolute;\r\n                top: -20px;\r\n                right: -4px;\r\n                height: 25px;\r\n                width: 25px;\r\n                z-index: 10;\r\n                border: 5px solid $primary-color;\r\n                border-radius: 70px;\r\n                animation: heartbit 1s ease-out;\r\n                animation-iteration-count: infinite;\r\n              }\r\n              .main-circle {\r\n                width: 6px;\r\n                height: 6px;\r\n                border-radius: 30px;\r\n                background-color: $primary-color;\r\n                position: absolute;\r\n                right: 6px;\r\n                top: -10px;\r\n              }\r\n            }\r\n          }\r\n          svg {\r\n            margin-top: $main-header-right-nav-icon-margin-top;\r\n            width: $main-header-right-nav-icon-size;\r\n            height: $main-header-right-nav-icon-size;\r\n            path {\r\n              color: $main-header-right-nav-icon-color;\r\n            }\r\n          }\r\n          .dot {\r\n            width: 3px;\r\n            height: 3px;\r\n            border-radius: 30px;\r\n            background-color: $main-header-right-nav-icon-color;\r\n            position: absolute;\r\n            right: 17px;\r\n            bottom: 6px;\r\n            animation: blink 1.5s infinite;\r\n          }\r\n          .dot-chat {\r\n            right: 4px;\r\n            bottom: -11px;\r\n          }\r\n        }\r\n      }\r\n      .notification {\r\n        position: absolute;\r\n        top: 21px;\r\n        right: -1px;\r\n        font-size: 9px;\r\n        animation: blink 1.5s infinite;\r\n        @keyframes blink {\r\n          0% {\r\n            opacity: 1;\r\n          }\r\n\r\n          70% {\r\n            opacity: 1;\r\n          }\r\n\r\n          80% {\r\n            opacity: 0;\r\n          }\r\n\r\n          100% {\r\n            opacity: 0;\r\n          }\r\n        }\r\n      }\r\n      .icon-user {\r\n        font-size: 16px;\r\n      }\r\n      @keyframes heartbit {\r\n        0% {\r\n          transform: scale(0);\r\n          opacity: 0;\r\n        }\r\n        25% {\r\n          transform: scale(0.1);\r\n          opacity: 0.1;\r\n        }\r\n        50% {\r\n          transform: scale(0.5);\r\n          opacity: 0.3;\r\n        }\r\n        75% {\r\n          transform: scale(0.8);\r\n          opacity: 0.5;\r\n        }\r\n        100% {\r\n          transform: scale(1);\r\n          opacity: 0;\r\n        }\r\n      }\r\n      > ul {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        align-items: center;\r\n        > li {\r\n          position: relative;\r\n          border-left: 1px solid $light-semi-gray;\r\n          padding: 0 20px;\r\n          &:first-child {\r\n            width: 25%;\r\n            border-left: none;\r\n            .search-form {\r\n              .form-group {\r\n                width: 100%;\r\n                position: relative;\r\n                &:focus {\r\n                  outline-color: transparent;\r\n                }\r\n                input {\r\n                  &:focus {\r\n                    outline-color: transparent;\r\n                    box-shadow: none;\r\n                  }\r\n                }\r\n                &:before {\r\n                  position: absolute;\r\n                  content: \"\";\r\n                  width: 1px;\r\n                  height: 25px;\r\n                  background: $light-gray;\r\n                  left: 51px;\r\n                  top: 11px;\r\n                }\r\n                &:after {\r\n                  position: absolute;\r\n                  content: \"\\f002\";\r\n                  font-family: $font-awesome;\r\n                  top: 12px;\r\n                  left: 22px;\r\n                  color: #8e8e8e;\r\n                }\r\n              }\r\n            }\r\n          }\r\n          &:last-child {\r\n            border-left: none;\r\n            padding-right: 0;\r\n          }\r\n          &:nth-child(5) {\r\n            border-left: none;\r\n            border-right: 1px solid $light-semi-gray;\r\n            padding-left: 0;\r\n          }\r\n          a.txt-dark {\r\n            text-decoration: none;\r\n          }\r\n          h6 {\r\n            margin-top: 4px;\r\n            margin-bottom: 4px;\r\n            color: $primary-color;\r\n            ul {\r\n              left: inherit;\r\n              right: -10px;\r\n              width: 130px;\r\n              &:before,\r\n              &:after {\r\n                left: inherit;\r\n                right: 10px;\r\n              }\r\n              li {\r\n                display: block;\r\n                a {\r\n                  font-size: 14px;\r\n                  color: $dark-color;\r\n                  i {\r\n                    margin-left: 10px;\r\n                    font-size: 13px;\r\n                    color: $dark-color;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n        .flag-icon {\r\n          font-size: 16px;\r\n        }\r\n      }\r\n      .notification-dropdown {\r\n        top: 57px;\r\n      }\r\n      .language-dropdown {\r\n        width: 160px;\r\n        text-align: left;\r\n        top: 57px;\r\n        li {\r\n          padding-top: 10px;\r\n          a {\r\n            color: $dark-color;\r\n            text-decoration: none;\r\n            i {\r\n              margin-right: 10px;\r\n            }\r\n          }\r\n          &:first-child {\r\n            padding-top: 0;\r\n          }\r\n        }\r\n      }\r\n      .profile-dropdown {\r\n        right: -10px;\r\n        left: inherit;\r\n        width: 150px;\r\n        top: 63px;\r\n        &:before,\r\n        &:after {\r\n          left: inherit;\r\n          right: 10px;\r\n        }\r\n        li {\r\n          display: block;\r\n          text-align: left;\r\n          padding-top: 10px;\r\n          &:nth-child(3) {\r\n            padding-bottom: 10px;\r\n          }\r\n          &:nth-child(4) {\r\n            border-top: 1px solid $light-semi-gray;\r\n          }\r\n          &:first-child {\r\n            padding-top: 0;\r\n          }\r\n          &:hover {\r\n            a {\r\n              color: $primary-color;\r\n              transition: $sidebar-transition;\r\n              svg {\r\n                color: $primary-color !important;\r\n                path,\r\n                line,\r\n                polyline {\r\n                  color: $primary-color !important;\r\n                }\r\n              }\r\n            }\r\n          }\r\n          a {\r\n            color: $theme-body-font-color;\r\n            transition: $sidebar-transition;\r\n            display: flex;\r\n            align-items: center;\r\n            text-decoration: none;\r\n            svg {\r\n              margin-right: 10px;\r\n              color: $theme-body-font-color;\r\n              polyline {\r\n                color: $theme-body-font-color;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    li {\r\n      display: inline-block;\r\n      position: relative;\r\n    }\r\n  }\r\n}\r\n.nav-menus {\r\n  .notification-badge {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 1px;\r\n    padding: 4px 7px;\r\n  }\r\n  .onhover-dropdown {\r\n    cursor: pointer;\r\n    position: relative;\r\n    &:before {\r\n      display: none;\r\n    }\r\n    &:hover {\r\n      .onhover-show-div {\r\n        @extend %for-animated-hover-box;\r\n      }\r\n    }\r\n  }\r\n  .search-form {\r\n    input {\r\n      border: 1px solid #eff0f1;\r\n      padding: 10px 10px 10px 70px;\r\n      border-radius: 50px;\r\n      background-color: $light-color;\r\n      font-size: 14px;\r\n    }\r\n  }\r\n}\r\nul.notification-dropdown.onhover-show-div {\r\n  width: 330px;\r\n  right: -18px;\r\n  left: initial;\r\n  &:before,\r\n  &:after {\r\n    left: inherit !important;\r\n    right: 35px !important;\r\n  }\r\n  li {\r\n    display: block;\r\n    padding: 12px 20px;\r\n    border-bottom: 1px solid $light-color;\r\n    text-align: left;\r\n    a {\r\n      text-decoration: none;\r\n    }\r\n    h6 {\r\n      small {\r\n        padding-top: 5px;\r\n        color: $dark-gray;\r\n        font-size: 12px;\r\n      }\r\n    }\r\n    span {\r\n      svg {\r\n        margin-top: 0 !important;\r\n        margin-right: 10px;\r\n        vertical-align: text-top;\r\n      }\r\n      .shopping-color {\r\n        path,\r\n        line {\r\n          color: $primary-color;\r\n        }\r\n      }\r\n      .download-color {\r\n        path,\r\n        line {\r\n          color: $success-color;\r\n        }\r\n      }\r\n      .alert-color {\r\n        path,\r\n        line {\r\n          color: $danger-color;\r\n        }\r\n      }\r\n    }\r\n    p {\r\n      margin-left: 30px;\r\n    }\r\n    + li {\r\n      &:hover {\r\n        background-color: $light-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n.onhover-show-div {\r\n  top: $header-size;\r\n  position: absolute;\r\n  z-index: 8;\r\n  background-color: $white;\r\n  transition: all linear 0.3s;\r\n  @extend %for-animated-hover;\r\n  li {\r\n    a {\r\n      svg {\r\n        margin-top: 0 !important;\r\n        path,\r\n        line {\r\n          color: $theme-body-font-color !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n/**======Main Header css Ends ======**/\r\n/**=====================\r\n    Sidebar CSS Start\r\n==========================**/\r\n.page-wrapper {\r\n  .page-body-wrapper {\r\n    .sidebar {\r\n      height: calc(100vh - #{$header-size});\r\n      overflow: auto;\r\n      box-shadow: $sidebar-shadow;\r\n    }\r\n    .page-sidebar {\r\n      width: $sidebar-width;\r\n      position: $sidebar-position;\r\n      background: $sidebar-background-color;\r\n      top: 0;\r\n      height: calc(100vh);\r\n      z-index: $sidebar-z-index;\r\n      transition: $sidebar-transition;\r\n      .main-header-left {\r\n        display: inline-flex;\r\n        width: 100%;\r\n        height: $header-size;\r\n        padding: $main-header-padding;\r\n        align-items: center;\r\n        background-color: $main-header-left-bg-color;\r\n        z-index: $main-header-z-index;\r\n        box-shadow: -3px 1px 3px 1px rgba(68, 102, 242, 0.1);\r\n        .logo-wrapper {\r\n          padding-left: 10px;\r\n          height: 100%;\r\n          display: flex;\r\n          align-items: center;\r\n        }\r\n      }\r\n      .sidebar-user {\r\n        padding: $sidebar-user-section-padding;\r\n        box-shadow: $sidebar-user-section-shadow;\r\n        position: relative;\r\n        h6 {\r\n          color: $sidebar-profile-name-txt-color;\r\n          text-transform: $sidebar-profile-name-txt-transfer;\r\n          font-weight: $sidebar-profile-name-txt-weight;\r\n          letter-spacing: $sidebar-profile-name-letter-specing;\r\n          margin-bottom: $sidebar-profile-name-marging;\r\n        }\r\n        p {\r\n          text-transform: $sidebar-profile-name-txt-transfer;\r\n          font-weight: $sidebar-profile-name-txt-weight;\r\n          font-size: $sidebar-profile-sub-title-font-size;\r\n          margin-bottom: $sidebar-profile-sub-title-margin;\r\n        }\r\n        img {\r\n          box-shadow: $sidebar-profile-img-shadow;\r\n        }\r\n      }\r\n      .sidebar-menu {\r\n        list-style: $sidebar-menu-list-style;\r\n        margin: $sidebar-menu-list-margin;\r\n        padding: $sidebar-menu-padding;\r\n        .sidebar-header {\r\n          font-size: $sidebar-font-size;\r\n          letter-spacing: $sidebar-letter-specing;\r\n          padding-bottom: $sidebar-padding-bottom;\r\n          padding-top: $sidebar-padding-top;\r\n          text-transform: $sidebar-txt-transform;\r\n          font-weight: $sidebar-font-weight;\r\n          color: $sidebar-font-color;\r\n          svg {\r\n            width: $sidebar-icon-size;\r\n            height: $sidebar-icon-size;\r\n            margin-right: $sidebar-icon-margin;\r\n            stroke-width: $sidebar-icon-stroke-width;\r\n            vertical-align: text-bottom;\r\n          }\r\n        }\r\n        .sidebar-submenu {\r\n          &.menu-open {\r\n            li {\r\n              &.active {\r\n                .fa-angle-down {\r\n                  &:before {\r\n                    content: \"\\f104\";\r\n                    transition: $sidebar-transition;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n        > li {\r\n          > a {\r\n            display: block;\r\n            transition: $sidebar-transition;\r\n            &.active {\r\n              color: $sidebar-hover-txt-color;\r\n              transition: $sidebar-transition;\r\n            }\r\n            &:hover {\r\n              color: $sidebar-hover-txt-color;\r\n              padding-left: $sidebar-heading-hover-padding;\r\n              transition: $sidebar-transition;\r\n            }\r\n            i {\r\n              margin-right: 7px;\r\n              text-align: right;\r\n              margin-top: 3px;\r\n              font-size: $sidebar-arrow-size;\r\n              &:before {\r\n                content: $sidebar-close-icon;\r\n              }\r\n              & ~ i {\r\n                margin-right: 0;\r\n              }\r\n            }\r\n          }\r\n          .label {\r\n            margin-top: 3px;\r\n            margin-right: 5px;\r\n          }\r\n          .badge {\r\n            margin-left: 50px;\r\n            text-transform: capitalize;\r\n          }\r\n          &:hover > a {\r\n            @extend %common;\r\n          }\r\n          &.active > a {\r\n            @extend %common;\r\n          }\r\n        }\r\n        li {\r\n          &.sidebar-header {\r\n            margin-bottom: $sidebar-sub-header-margin;\r\n            padding: $sidebar-sub-header-padding;\r\n            color: $sidebar-font-color;\r\n            font-weight: $sidebar-font-weight;\r\n            transition: $sidebar-transition;\r\n          }\r\n          > a {\r\n            > .fa-angle-down {\r\n              width: auto;\r\n              height: auto;\r\n              padding: 0;\r\n              margin-right: 10px;\r\n              margin-top: 10px;\r\n              transform: rotate(-90deg);\r\n              transition: $sidebar-transition;\r\n            }\r\n          }\r\n          &.active {\r\n            > {\r\n              a {\r\n                > .fa-angle-right {\r\n                  &:before {\r\n                    content: $sidebar-open-icon;\r\n                    font-family: $sidebar-icon-font-family;\r\n                    transition: $sidebar-transition;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n            > .sidebar-submenu {\r\n              display: block;\r\n              transform: rotateX(0deg);\r\n              transform-origin: 10% 10%;\r\n              transition: transform $sidebar-transition,\r\n                opacity $sidebar-transition;\r\n              transform-style: preserve-3d;\r\n              margin-left: 25px;\r\n              a {\r\n                i.pull-right {\r\n                  margin-top: 10px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n        a {\r\n          text-decoration: none;\r\n        }\r\n        .sidebar-submenu {\r\n          display: none;\r\n          transform-style: preserve-3d;\r\n          transform: rotateX(-90deg);\r\n          list-style: none;\r\n          .sidebar-submenu {\r\n            padding-top: 0 !important;\r\n          }\r\n          > li {\r\n            > a {\r\n              padding-bottom: 7px;\r\n              padding-top: 7px;\r\n              font-size: 14px;\r\n              color: $dark-gray;\r\n              transition: $sidebar-transition;\r\n              text-transform: $sidebar-text-transform;\r\n              position: relative;\r\n              padding-left: 10px;\r\n              line-height: 2.5;\r\n              letter-spacing: 0.7px;\r\n              > {\r\n                .fa-circle {\r\n                  width: 12px;\r\n                  font-size: 4px;\r\n                  position: absolute;\r\n                  left: 0;\r\n                  top: 13px;\r\n                }\r\n                i {\r\n                  width: auto;\r\n                }\r\n                .fa-angle-down {\r\n                  width: auto;\r\n                }\r\n              }\r\n              &:hover {\r\n                color: $primary-color;\r\n                transition: $sidebar-transition;\r\n              }\r\n              &.active {\r\n                color: $primary-color;\r\n              }\r\n            }\r\n            &.active > a {\r\n              color: $theme-body-font-color;\r\n              &.active {\r\n                color: $primary-color;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      ~ .page-body {\r\n        margin-left: $sidebar-width;\r\n        transition: $sidebar-transition;\r\n      }\r\n      &.open {\r\n        display: block;\r\n        margin-left: calc(-#{$sidebar-width + 5px});\r\n        ~ .page-body {\r\n          margin-left: 0;\r\n          transition: $sidebar-transition;\r\n        }\r\n        ~ footer {\r\n          margin-left: 0;\r\n          padding-right: 15px;\r\n        }\r\n        ~ .footer-fix {\r\n          width: calc(100% - 0px);\r\n        }\r\n      }\r\n    }\r\n    .sidebar-close {\r\n      .page-sidebar {\r\n        transition: $sidebar-transition;\r\n        transform: translate(-$sidebar-width);\r\n      }\r\n      .page-body {\r\n        transition: $sidebar-transition;\r\n        margin-left: 0 !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n.right-sidebar {\r\n  top: 81px;\r\n  right: -285px;\r\n  height: 100%;\r\n  position: fixed;\r\n  width: 285px;\r\n  z-index: 9;\r\n  background-color: #fff;\r\n  transition: 0.5s;\r\n  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\r\n  &.show {\r\n    right: 0;\r\n    transition: $sidebar-transition;\r\n  }\r\n  .modal-header {\r\n    .modal-title {\r\n      padding-top: 2px;\r\n    }\r\n  }\r\n  .friend-list-search {\r\n    position: relative;\r\n    background-color: $light-color;\r\n    padding: 20px;\r\n    input {\r\n      color: $dark-gray;\r\n      width: 100%;\r\n      background-color: $white;\r\n      border: 1px solid $light-color;\r\n      padding: 10px 15px;\r\n      border-radius: 25px;\r\n      letter-spacing: 1px;\r\n    }\r\n    .fa {\r\n      position: absolute;\r\n      right: 35px;\r\n      top: 34px;\r\n      font-size: 14px;\r\n      color: $light-gray;\r\n    }\r\n  }\r\n  .chat-box {\r\n    .people-list {\r\n      ul {\r\n        padding-top: 20px;\r\n        li {\r\n          position: relative;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  svg {\r\n    width: 16px;\r\n    height: 16px;\r\n    margin-top: 5px;\r\n  }\r\n}\r\n/**=====================\r\n    Sidebar CSS Ends\r\n==========================**/\r\n/**=====================\r\n      Generic CSS Start\r\n==========================**/\r\n/*====== Padding css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .p-#{$i} {\r\n    padding: #{$i}px;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Padding css ends ======*/\r\n/*====== Padding-left css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .p-l-#{$i} {\r\n    padding-left: #{$i}px;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Padding-left css ends ======*/\r\n/*====== Padding-top css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .p-t-#{$i} {\r\n    padding-top: #{$i}px !important;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Padding-top css ends ======*/\r\n/*====== Padding-bottom css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .p-b-#{$i} {\r\n    padding-bottom: #{$i}px !important;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Padding-bottom css ends ======*/\r\n/*====== Padding-right css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .p-r-#{$i} {\r\n    padding-right: #{$i}px;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Padding-right css ends ======*/\r\n/*====== Margin css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .m-#{$i} {\r\n    margin: #{$i}px !important;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Margin css ends ======*/\r\n/*====== Margin-top css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .m-t-#{$i} {\r\n    margin-top: #{$i}px !important;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Margin-top css ends ======*/\r\n/*====== Margin-Bottom css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .m-b-#{$i} {\r\n    margin-bottom: #{$i}px !important;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Margin-Bottom css ends ======*/\r\n/*====== Margin-left css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .m-l-#{$i} {\r\n    margin-left: #{$i}px !important;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Margin-left css ends ======*/\r\n/*====== Margin-right css starts ======*/\r\n$i: 0;\r\n@while $i<=50 {\r\n  .m-r-#{$i} {\r\n    margin-right: #{$i}px;\r\n  }\r\n  $i: $i + 5;\r\n}\r\n/*====== Margin-right css ends ======*/\r\n/*====== Border-radius css starts ======*/\r\n$i: 0;\r\n@while $i<=10 {\r\n  .b-r-#{$i} {\r\n    border-radius: #{$i}px !important;\r\n  }\r\n  $i: $i + 1;\r\n}\r\n/*====== Border-radius css ends ======*/\r\n/*====== Font-size css starts ======*/\r\n$i: 12;\r\n@while $i<=100 {\r\n  .f-#{$i} {\r\n    font-size: #{$i}px;\r\n  }\r\n  $i: $i + 2;\r\n}\r\n/*====== Font-size css ends ======*/\r\n/*====== Font-weight css starts ======*/\r\n$i: 100, 300, 400, 600, 700, 900;\r\n@each $val in $i {\r\n  .f-w-#{$val} {\r\n    font-weight: $val;\r\n  }\r\n}\r\n/*====== Font-weight css ends ======*/\r\n/*====== Font-style css starts ======*/\r\n$i: normal, italic, oblique, initial, inherit;\r\n@each $val in $i {\r\n  .f-s-#{$val} {\r\n    font-style: $val;\r\n  }\r\n}\r\n/*====== Font-style css ends ======*/\r\n/*====== Text-Decoration css starts ======*/\r\n$i: overline, line-through, underline, dashed, blink, dotted, initial, none,\r\n  solid, wavy, inherit, double;\r\n@each $val in $i {\r\n  .text-#{$val} {\r\n    text-decoration: $val;\r\n  }\r\n}\r\n/*====== Text-Decoration css ends ======*/\r\n/*====== Vertical-Align css starts ======*/\r\n$i: baseline, sub, super, top, text-top, middle, bottom, text-bottom, initial,\r\n  inherit;\r\n@each $val in $i {\r\n  .#{$val} {\r\n    vertical-align: $val;\r\n  }\r\n}\r\n/*====== Vertical-Align css ends ======*/\r\n/*====== Position css starts ======*/\r\n$i: static, absolute, fixed, relative, initial, inherit;\r\n@each $val in $i {\r\n  .p-#{$val} {\r\n    position: $val;\r\n  }\r\n}\r\n/*====== Position css ends ======*/\r\n/*====== Float css starts ======*/\r\n$i: left, right, none;\r\n@each $val in $i {\r\n  .f-#{$val} {\r\n    float: $val;\r\n  }\r\n}\r\n/*====== Float css ends ======*/\r\n/*====== Overflow css starts ======*/\r\n$i: hidden, visible, auto;\r\n@each $val in $i {\r\n  .o-#{$val} {\r\n    overflow: $val;\r\n  }\r\n}\r\n/*====== Overflow css ends ======*/\r\n/*====== Image-sizes css starts ======*/\r\n$i: 10;\r\n@while $i<=100 {\r\n  .img-#{$i} {\r\n    width: #{$i}px !important;\r\n  }\r\n  $i: $i + 10;\r\n}\r\n/*====== Image-sizes css ends ======*/\r\n/*======= Text css starts ===========*/\r\n$text-name: primary, secondary, success, danger, info, light, dark, warning;\r\n$text-color: $primary-color, $secondary-color, $success-color, $danger-color,\r\n  $info-color, $light-color, $dark-color, $warning-color;\r\n@each $var in $text-name {\r\n  $i: index($text-name, $var);\r\n  .font-#{$var} {\r\n    color: nth($text-color, $i) !important;\r\n  }\r\n}\r\n/*======= Text css ends ===========*/\r\n/*======= Label-color css starts  ======= */\r\n.label {\r\n  border-radius: 2px;\r\n  color: $white;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n  margin-bottom: 0;\r\n  text-transform: capitalize;\r\n}\r\n/*======= Label-color css ends  ======= */\r\n/*======= Badge-color css starts  ======= */\r\n$badge-name: primary, secondary, success, danger, info, light, dark, warning;\r\n$badge-color: $primary-color, $secondary-color, $success-color, $danger-color,\r\n  $info-color, $light-color, $dark-color, $warning-color;\r\n@each $var in $badge-name {\r\n  $i: index($badge-name, $var);\r\n  .badge-#{$var} {\r\n    background-color: nth($badge-color, $i);\r\n  }\r\n}\r\n/*======= Badge-color css end  ======= */\r\n/*======= Background-color css starts  ======= */\r\n$background-name: primary, secondary, success, danger, info, light, dark,\r\n  warning;\r\n$background-color: $primary-color, $secondary-color, $success-color,\r\n  $danger-color, $info-color, $light-color, $dark-color, $warning-color;\r\n@each $var in $background-name {\r\n  $i: index($background-name, $var);\r\n  .bg-#{$var} {\r\n    background-color: nth($background-color, $i) !important;\r\n    color: $white;\r\n  }\r\n}\r\n/*======= Background-color css end  ======= */\r\n/*======= Font-color css starts  ======= */\r\n$text-name: primary, secondary, success, danger, info, light, dark, warning,\r\n  google-plus, twitter, linkedin, fb;\r\n$label-color: $primary-color, $secondary-color, $success-color, $danger-color,\r\n  $info-color, $light-color, $dark-color, $warning-color;\r\n/*======= Font-color css end  ======= */\r\n/*======= Button-color css starts  ======= */\r\n// btn--color//\r\n@each $btn-name, $btn-color in (primary, $primary-color),\r\n  (secondary, $secondary-color), (success, $success-color),\r\n  (danger, $danger-color), (info, $info-color), (light, $light-color),\r\n  (dark, $dark-color), (warning, $warning-color)\r\n{\r\n  .btn-#{$btn-name} {\r\n    background-color: $btn-color !important;\r\n    border-color: $btn-color !important;\r\n    &.disabled {\r\n      background-color: $btn-color !important;\r\n      border-color: $btn-color !important;\r\n    }\r\n    &:disabled {\r\n      background-color: $btn-color !important;\r\n      border-color: $btn-color !important;\r\n    }\r\n    &:hover,\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      background-color: darken($btn-color, 10%) !important;\r\n      border-color: darken($btn-color, 10%) !important;\r\n    }\r\n    &:focus {\r\n      box-shadow: 0 0 0 0.2rem lighten($btn-color, 30%);\r\n    }\r\n  }\r\n}\r\n/*======= Button-color css ends  ======= */\r\n//active button css //\r\n@each $btn-name, $btn-color in (primary, $primary-color),\r\n  (secondary, $secondary-color), (success, $success-color),\r\n  (danger, $danger-color), (info, $info-color), (light, $light-color),\r\n  (dark, $dark-color), (warning, $warning-color)\r\n{\r\n  .btn-#{$btn-name}:not([disabled]):not(.disabled).active {\r\n    background-color: darken($btn-color, 10%);\r\n    border-color: darken($btn-color, 10%);\r\n    box-shadow: none !important;\r\n    &:hover,\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      color: white;\r\n      background-color: darken($btn-color, 10%);\r\n      border-color: darken($btn-color, 10%);\r\n    }\r\n  }\r\n}\r\n//* active button css end *//\r\n@each $btn-name, $btn-color in (primary, $primary-color),\r\n  (secondary, $secondary-color), (success, $success-color),\r\n  (danger, $danger-color), (info, $info-color), (light, $light-color),\r\n  (dark, $dark-color), (warning, $warning-color)\r\n{\r\n  .btn-outline-#{$btn-name}-2x:not([disabled]):not(.disabled).active {\r\n    background-color: $btn-color;\r\n    border-color: $btn-color;\r\n    box-shadow: none !important;\r\n    color: white;\r\n    &:hover,\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      color: white;\r\n      box-shadow: none !important;\r\n      background-color: darken($btn-color, 10%) !important;\r\n      border-color: darken($btn-color, 10%) !important;\r\n    }\r\n  }\r\n}\r\n/*======= Table-Border-Bottom-color css starts  ======= */\r\n$border-name: primary, secondary, success, danger, info, light, dark, warning;\r\n$border-color: $primary-color, $secondary-color, $success-color, $danger-color,\r\n  $info-color, $light-color, $dark-color, $warning-color;\r\n@each $var in $border-name {\r\n  $i: index($border-name, $var);\r\n  table thead .border-bottom-#{$var} th,\r\n  table tbody .border-bottom-#{$var} th,\r\n  table tbody .border-bottom-#{$var} td {\r\n    border-bottom: 1px solid nth($border-color, $i);\r\n  }\r\n}\r\n/*======= Table-Border-Bottom-color css ends  ======= */\r\n/*======= Table styling css starts  ======= */\r\n$table-name: primary, secondary, success, danger, info, light, dark, warning;\r\n$table-color: $primary-color, $secondary-color, $success-color, $danger-color,\r\n  $info-color, $light-color, $dark-color, $warning-color;\r\n@each $var in $table-name {\r\n  $i: index($table-name, $var);\r\n  .table-styling .table-#{$var},\r\n  .table-styling.table-#{$var} {\r\n    background-color: nth($border-color, $i);\r\n    color: $white;\r\n    border: 3px solid nth($border-color, $i);\r\n    thead {\r\n      background-color: darken(nth($border-color, $i), 10%);\r\n      border: 3px solid darken(nth($border-color, $i), 10%);\r\n    }\r\n  }\r\n}\r\n/*======= Table styling css ends  ======= */\r\n/*======= All-Borders-color css starts  ======= */\r\n$b-name: primary, secondary, success, danger, info, light, dark, warning;\r\n$b-color: $primary-color, $secondary-color, $success-color, $danger-color,\r\n  $info-color, $light-color, $dark-color, $warning-color;\r\n@each $var in $b-name {\r\n  $i: index($b-name, $var);\r\n  .b-#{$var} {\r\n    border: 1px solid nth($b-color, $i) !important;\r\n  }\r\n  .b-t-#{$var} {\r\n    border-top: 1px solid nth($b-color, $i) !important;\r\n  }\r\n  .b-b-#{$var} {\r\n    border-bottom: 1px solid nth($b-color, $i) !important;\r\n  }\r\n  .b-l-#{$var} {\r\n    border-left: 1px solid nth($b-color, $i) !important;\r\n  }\r\n  .b-r-#{$var} {\r\n    border-right: 1px solid nth($b-color, $i) !important;\r\n  }\r\n}\r\n/*======= All-Borders-color css ends  ======= */\r\n/*====== Border width css starts ======*/\r\n$i: 1;\r\n@while $i<=10 {\r\n  .border-#{$i} {\r\n    border-width: #{$i}px !important;\r\n  }\r\n  $i: $i + 1;\r\n}\r\n/*====== Border width css ends ======*/\r\n.opacity-0 {\r\n  opacity: 0;\r\n}\r\n.shadow-0 {\r\n  box-shadow: none;\r\n}\r\n/**====== custom scrollbar css start ======**/\r\n.digits {\r\n  font-family: $font-work-sans, $font-serif;\r\n}\r\n.custom-scrollbar {\r\n  &::-webkit-scrollbar-track {\r\n    -webkit-box-shadow: inset 0 0 6px $light-gray;\r\n  }\r\n  &::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: rgba($primary-color, 0.17);\r\n  }\r\n}\r\n/**====== Custom scrollbar css end ======**/\r\n/**====== Animation css Start ======**/\r\n.line {\r\n  pre {\r\n    font-size: 100%;\r\n  }\r\n}\r\n/**====== Animation css end ======**/\r\n/**=====================\r\n      Generic CSS Ends\r\n==========================**/\r\n/**=====================\r\n     Chat CSS Start\r\n==========================**/\r\n.chat-box {\r\n  .toogle-bar {\r\n    display: none;\r\n  }\r\n  .people-list {\r\n    .search {\r\n      position: relative;\r\n      .form-control {\r\n        background-color: $light-body-bg-color;\r\n        border: 1px solid $light-color;\r\n        &::placeholder {\r\n          color: $semi-dark;\r\n        }\r\n      }\r\n      i {\r\n        position: absolute;\r\n        right: 10px;\r\n        top: 10px;\r\n        font-size: 14px;\r\n        color: $light-gray;\r\n      }\r\n    }\r\n    ul {\r\n      padding: 0;\r\n      li {\r\n        padding-bottom: 20px;\r\n        &:last-child {\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .user-image {\r\n    float: left;\r\n    width: 52px;\r\n    height: 52px;\r\n    margin-right: 5px;\r\n  }\r\n  .about {\r\n    float: left;\r\n    margin-top: 5px;\r\n    padding-left: 10px;\r\n    .name {\r\n      color: $dark-color;\r\n      letter-spacing: 1px;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n  .status {\r\n    color: $semi-dark;\r\n    letter-spacing: 1px;\r\n    font-size: 12px;\r\n    margin-top: 5px;\r\n    .chat-status {\r\n      font-weight: 600;\r\n      color: $theme-body-font-color;\r\n    }\r\n    p {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n}\r\n.status-circle {\r\n  width: 10px;\r\n  height: 10px;\r\n  position: absolute;\r\n  top: 40px;\r\n  left: 40px;\r\n  border-radius: 50%;\r\n  border: 2px solid $white;\r\n}\r\n.away {\r\n  background-color: $warning-color;\r\n}\r\n.online {\r\n  background-color: $success-color;\r\n}\r\n.offline {\r\n  background-color: $danger-color;\r\n}\r\n/**=====================\r\n      Chat CSS Ends\r\n==========================**/\r\n.market-chart {\r\n  height: 303px;\r\n}\r\n.needs-validation {\r\n  .form-select {\r\n    background: white;\r\n  }\r\n  .form-control {\r\n    border-radius: 0.25rem;\r\n    padding: 0.48rem 0.75rem;\r\n  }\r\n}\r\n.license-key[disabled] {\r\n  cursor: not-allowed;\r\n}\r\n.checkbox {\r\n  label {\r\n    display: inline-block;\r\n    position: relative;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n  }\r\n  .form-check-input {\r\n    margin-top: 13px;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n.form-row {\r\n  .form-control {\r\n    font-size: 14px;\r\n    letter-spacing: 1px;\r\n  }\r\n  .form-select {\r\n    font-size: 14px;\r\n    letter-spacing: 1px;\r\n  }\r\n}\r\n/*=====================\r\n    Responsive CSS start\r\n==========================*/\r\n@media only screen and (max-width: 1780px) and (min-width: 1661px) {\r\n  .add-product-form {\r\n    .qty-box {\r\n      width: 20%;\r\n    }\r\n  }\r\n  .products-table {\r\n    table {\r\n      tr {\r\n        td {\r\n          &:first-child {\r\n            min-width: 255px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 1660px) {\r\n  .translation-list {\r\n    .rdt_Table {\r\n      .rdt_TableBody {\r\n        .rdt_TableRow {\r\n          .rdt_TableCell {\r\n            &:nth-child(n + 1) {\r\n              width: 200px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .product-list,\r\n  .category-table,\r\n  .order-datatable {\r\n    .rdt_Table {\r\n      .rdt_TableBody {\r\n        .rdt_TableRow {\r\n          .rdt_TableCell {\r\n            &:nth-child(n + 2) {\r\n              width: 170px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .add-product-form {\r\n    .qty-box {\r\n      width: 20%;\r\n    }\r\n  }\r\n  .products-table {\r\n    table {\r\n      tr {\r\n        td {\r\n          &:first-child {\r\n            min-width: 268px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n@media screen and (max-width: 1440px) and (min-width: 1366px) {\r\n  .flot-chart-container {\r\n    height: 350px;\r\n  }\r\n  .product-adding {\r\n    .col-xl-5 {\r\n      flex: 0 0 36%;\r\n      max-width: 36%;\r\n    }\r\n    .col-xl-7 {\r\n      flex: 0 0 64%;\r\n      max-width: 64%;\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 1366px) {\r\n  .transactions {\r\n    .rdt_Table {\r\n      .rdt_TableBody {\r\n        .rdt_TableRow {\r\n          .rdt_TableCell {\r\n            + .rdt_TableCell {\r\n              width: 150px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .product-physical {\r\n    .rdt_Table {\r\n      .rdt_TableHead {\r\n        .rdt_TableHeadRow {\r\n          .rdt_TableCol {\r\n            width: 150px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .report-employee {\r\n    h2 {\r\n      font-size: 32px;\r\n    }\r\n  }\r\n  .add-product-form {\r\n    .qty-box {\r\n      width: 24%;\r\n    }\r\n  }\r\n  .slick-slide {\r\n    img {\r\n      margin: 0 auto;\r\n    }\r\n  }\r\n  .page-main-header {\r\n    .main-header-right {\r\n      .nav-right {\r\n        > ul {\r\n          > li {\r\n            &:first-child {\r\n              width: 32%;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .product-adding {\r\n    .add-product-form {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n  .user-list {\r\n    table {\r\n      tr {\r\n        td,\r\n        th {\r\n          &:nth-child(5) {\r\n            width: 195px !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 1199px) {\r\n  // product detail\r\n  .product-page-details {\r\n    margin-top: 30px;\r\n  }\r\n  .user-list {\r\n    table {\r\n      tr {\r\n        th,\r\n        td {\r\n          width: 200px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n@media screen and (max-device-width: 1366px) and (min-device-width: 1200px) {\r\n  .xl-100 {\r\n    max-width: 100%;\r\n    flex: 0 0 100%;\r\n  }\r\n  .xl-50 {\r\n    max-width: 50%;\r\n    flex: 0 0 50%;\r\n  }\r\n  .product-adding {\r\n    .col-xl-5,\r\n    .col-xl-7 {\r\n      flex: 0 0 100%;\r\n      max-width: 100%;\r\n    }\r\n    .add-product-form {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n  .user-list {\r\n    table {\r\n      tr {\r\n        td,\r\n        th {\r\n          &:first-child {\r\n            width: 130px !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  // profile\r\n  .profile-table {\r\n    table {\r\n      tr {\r\n        th,\r\n        td {\r\n          width: 200px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 991px) {\r\n  .page-wrapper {\r\n    .page-main-header {\r\n      .main-header-right {\r\n        .main-header-left {\r\n          padding: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .authentication-box {\r\n    padding: 30px;\r\n    .container {\r\n      .bg-primary {\r\n        padding: 40px;\r\n      }\r\n    }\r\n  }\r\n  .btn-popup {\r\n    margin-bottom: 20px;\r\n  }\r\n  .order-graph {\r\n    .order-graph-bottom {\r\n      margin-top: 20px;\r\n    }\r\n  }\r\n  .card {\r\n    .card-body,\r\n    .card-header {\r\n      padding: 20px;\r\n    }\r\n  }\r\n  .page-wrapper {\r\n    .page-main-header {\r\n      &.open {\r\n        z-index: 11;\r\n      }\r\n    }\r\n  }\r\n  .right-sidebar {\r\n    top: 127px;\r\n  }\r\n  .page-wrapper {\r\n    .page-body-wrapper {\r\n      .page-header {\r\n        .row {\r\n          h3 {\r\n            font-size: 22px;\r\n          }\r\n          .pull-right {\r\n            float: none;\r\n            margin-top: 5px;\r\n          }\r\n        }\r\n      }\r\n      .page-sidebar {\r\n        top: 60px !important;\r\n        height: calc(100vh - 60px) !important;\r\n        ~ {\r\n          .page-body {\r\n            margin-left: 0;\r\n            margin-top: 60px;\r\n            .page-header {\r\n              .row {\r\n                .page-header-left {\r\n                  display: inherit;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .sidebar {\r\n        height: calc(100vh - 60px);\r\n      }\r\n      .page-sidebar.open {\r\n        ~ {\r\n          .page-body {\r\n            margin-top: 60px;\r\n          }\r\n        }\r\n      }\r\n      footer {\r\n        margin-left: 0;\r\n      }\r\n    }\r\n    .page-main-header {\r\n      height: 60px;\r\n      margin-left: 0;\r\n      width: 100%;\r\n      z-index: 11;\r\n      .main-header-left {\r\n        .logo-wrapper {\r\n          img {\r\n            height: 23px;\r\n            margin-top: 0;\r\n            margin-right: 15px;\r\n          }\r\n        }\r\n      }\r\n      .main-header-right {\r\n        .nav-right {\r\n          position: unset;\r\n          padding: 0;\r\n          > ul {\r\n            top: 60px;\r\n            position: absolute;\r\n            z-index: -1;\r\n            background-color: #fff;\r\n            -webkit-transition: all linear 0.3s;\r\n            transition: all linear 0.3s;\r\n            -webkit-box-shadow: 0 2px 2px 2px #efefef;\r\n            box-shadow: 0 2px 2px 2px #efefef;\r\n            width: 100%;\r\n            left: 0;\r\n            padding: 0 40px;\r\n            -webkit-transform: translateY(-35px) scaleY(0);\r\n            transform: translateY(-35px) scaleY(0);\r\n            opacity: 0;\r\n            visibility: hidden;\r\n            > li {\r\n              margin: 10px 0;\r\n            }\r\n          }\r\n          > .mobile-toggle {\r\n            cursor: pointer;\r\n            display: -webkit-box;\r\n            display: -ms-flexbox;\r\n            display: flex;\r\n            -webkit-box-align: center;\r\n            -ms-flex-align: center;\r\n            align-items: center;\r\n            svg {\r\n              circle {\r\n                color: $theme-deafult;\r\n              }\r\n            }\r\n          }\r\n          > ul.open {\r\n            z-index: 1;\r\n            opacity: 1;\r\n            -webkit-transform: translateY(0px) scaleY(1);\r\n            transform: translateY(0px) scaleY(1);\r\n            visibility: visible;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .page-header {\r\n    padding-top: 25px !important;\r\n    padding-bottom: 25px !important;\r\n    .row {\r\n      .page-header-left {\r\n        .breadcrumb {\r\n          margin-top: 5px;\r\n          margin-left: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  // product detail\r\n  .product-page-details {\r\n    text-align: left !important;\r\n  }\r\n  // add product page\r\n  .add-product {\r\n    .bigImg {\r\n      img {\r\n        width: 460px;\r\n      }\r\n    }\r\n  }\r\n  .product-adding {\r\n    .add-product-form {\r\n      margin-top: 20px;\r\n    }\r\n  }\r\n  // tab css\r\n  .tab-coupon {\r\n    margin-bottom: 20px;\r\n  }\r\n  // profile\r\n  .deactivate-account {\r\n    margin-top: 20px;\r\n  }\r\n  // reports\r\n  .sell-graph {\r\n    canvas {\r\n      height: 312px !important;\r\n    }\r\n  }\r\n  // forms\r\n  .needs-validation {\r\n    h4 {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 767px) {\r\n  .react-tabs {\r\n    .react-datepicker-wrapper {\r\n      .react-datepicker__input-container {\r\n        margin-left: 0;\r\n      }\r\n    }\r\n  }\r\n  .checkbox-space {\r\n    padding: 0 15px;\r\n  }\r\n  .react-datepicker__input-container {\r\n    margin-left: 15px;\r\n  }\r\n  .authentication-box {\r\n    .form-footer,\r\n    .form-button {\r\n      text-align: center;\r\n      > span {\r\n        padding: 0;\r\n        left: 0;\r\n        right: 0;\r\n      }\r\n    }\r\n  }\r\n  .page-main-header {\r\n    .main-header-right {\r\n      .nav-right {\r\n        > ul {\r\n          > li {\r\n            &:first-child {\r\n              width: 40%;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .products-table {\r\n    table {\r\n      tr {\r\n        td,\r\n        th {\r\n          &:first-child {\r\n            min-width: 280px;\r\n          }\r\n          &:nth-child(3) {\r\n            min-width: 110px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .page-wrapper {\r\n    .page-body-wrapper {\r\n      .page-header {\r\n        .row {\r\n          .col {\r\n            flex-basis: unset;\r\n            .pull-right {\r\n              float: none;\r\n              margin-top: 20px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      footer {\r\n        .row {\r\n          div {\r\n            text-align: center;\r\n            .pull-right {\r\n              float: none;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .footer-fix {\r\n    .pull-right {\r\n      float: none !important;\r\n      text-align: center !important;\r\n    }\r\n  }\r\n  // add product page\r\n  .add-product-form {\r\n    .form-group {\r\n      .form-control,\r\n      select {\r\n        width: 100% !important;\r\n        margin: 0 !important;\r\n      }\r\n    }\r\n    .input-group {\r\n      .touchspin {\r\n        width: 30% !important;\r\n      }\r\n    }\r\n    .radio-animated {\r\n      label {\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n    .editor-space {\r\n      padding: 0 15px;\r\n    }\r\n    textarea {\r\n      margin: 0 15px;\r\n    }\r\n    .qty-box {\r\n      width: 29%;\r\n    }\r\n  }\r\n  .add-product {\r\n    .bigImg {\r\n      img {\r\n        width: 400px;\r\n      }\r\n    }\r\n  }\r\n  .digital-add {\r\n    textarea {\r\n      margin: 0 !important;\r\n    }\r\n    .form-group {\r\n      select,\r\n      .form-control {\r\n        width: 100% !important;\r\n      }\r\n      label {\r\n        margin-bottom: 0 !important;\r\n      }\r\n    }\r\n  }\r\n  // coupon page\r\n  .needs-validation {\r\n    .form-group {\r\n      &.row {\r\n        margin-left: 0;\r\n        margin-right: 0;\r\n      }\r\n      .form-control,\r\n      select {\r\n        width: 100%;\r\n        margin: 0 auto;\r\n      }\r\n      .checkbox {\r\n        padding-left: 15px;\r\n      }\r\n      label {\r\n        margin-bottom: 4px;\r\n      }\r\n    }\r\n    .radio-animated {\r\n      label {\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n    .editor-space {\r\n      padding: 0 15px;\r\n    }\r\n    textarea {\r\n      margin: 0 15px;\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 577px) {\r\n  footer {\r\n    margin-bottom: 0 !important;\r\n  }\r\n}\r\n@media only screen and (max-width: 575px) {\r\n  .react-tabs {\r\n    .needs-validation {\r\n      .row {\r\n        > div[class*=\"col-\"] {\r\n          padding: 0 12px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .authentication-box .btn-primary {\r\n    margin-top: 10px;\r\n  }\r\n  .sales-chart {\r\n    height: 200px;\r\n  }\r\n  .report-last-sm {\r\n    canvas {\r\n      height: 200px !important;\r\n    }\r\n  }\r\n  .dropzone {\r\n    .dzu-input {\r\n      width: 90%;\r\n    }\r\n  }\r\n  .product-right {\r\n    .timer {\r\n      span {\r\n        width: 55px;\r\n      }\r\n    }\r\n  }\r\n  .market-chart {\r\n    height: 205px;\r\n  }\r\n  .ct-4 {\r\n    &.flot-chart-container {\r\n      height: 240px;\r\n    }\r\n  }\r\n  .sell-graph {\r\n    canvas {\r\n      height: 250px !important;\r\n    }\r\n  }\r\n  .btn-popup {\r\n    margin-bottom: 15px;\r\n  }\r\n  .static-top-widget {\r\n    div {\r\n      &.align-self-center {\r\n        svg {\r\n          width: 20px;\r\n          height: 20px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .latest-order-table {\r\n    table {\r\n      tr {\r\n        td {\r\n          min-width: 100px;\r\n          + td {\r\n            min-width: 150px;\r\n          }\r\n          &:nth-child(3) {\r\n            min-width: 200px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .card {\r\n    margin-bottom: 15px;\r\n    .card-header {\r\n      padding: 15px;\r\n      h5 {\r\n        font-size: 17px;\r\n      }\r\n    }\r\n    .card-body {\r\n      padding: 15px;\r\n    }\r\n  }\r\n  .sm-order-space,\r\n  .xl-space {\r\n    margin-top: 15px;\r\n  }\r\n  .order-graph {\r\n    .order-graph-bottom {\r\n      margin-top: 15px;\r\n      h6 {\r\n        margin-right: 0;\r\n      }\r\n      .media {\r\n        margin-bottom: 15px;\r\n      }\r\n    }\r\n  }\r\n  .form-inline {\r\n    .form-control-plaintext {\r\n      display: inline-block;\r\n    }\r\n  }\r\n  .d-sm-none {\r\n    &:after {\r\n      display: none;\r\n    }\r\n  }\r\n  ul {\r\n    &.notification-dropdown {\r\n      &.onhover-show-div {\r\n        width: 284px;\r\n        right: -112px;\r\n        &:before,\r\n        &:after {\r\n          right: 135px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .page-wrapper {\r\n    .page-main-header {\r\n      .main-header-right {\r\n        padding: 0 15px;\r\n        .nav-right {\r\n          > ul {\r\n            padding: 0 0;\r\n            justify-content: flex-start;\r\n            > li {\r\n              &:first-child {\r\n                .search-form {\r\n                  .form-group {\r\n                    &:before {\r\n                      display: none;\r\n                    }\r\n                    &:after {\r\n                      display: none;\r\n                    }\r\n                  }\r\n                }\r\n                width: auto;\r\n                margin: 0;\r\n              }\r\n            }\r\n            .search-form {\r\n              .form-group {\r\n                margin-bottom: 0;\r\n              }\r\n              .form-control-plaintext.open {\r\n                -webkit-transform: translateY(0px) scaleY(1);\r\n                transform: translateY(0px) scaleY(1);\r\n                opacity: 1;\r\n                visibility: visible;\r\n                -webkit-transition: all linear 0.3s;\r\n                transition: all linear 0.3s;\r\n              }\r\n              .form-control-plaintext {\r\n                top: 60px;\r\n                position: absolute;\r\n                -webkit-transition: all linear 0.3s;\r\n                transition: all linear 0.3s;\r\n                left: 0;\r\n                background-color: #fff;\r\n                -webkit-transform: translateY(-35px) scaleY(0);\r\n                transform: translateY(-35px) scaleY(0);\r\n                opacity: 0;\r\n                visibility: hidden;\r\n                width: 180px;\r\n                padding: 10px 10px 10px 15px;\r\n              }\r\n              .mobile-search {\r\n                svg {\r\n                  color: $theme-deafult;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .search-form {\r\n      .form-group {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n    .page-body-wrapper {\r\n      .page-sidebar.open {\r\n        ~ {\r\n          .page-body {\r\n            .activity {\r\n              .media {\r\n                .gradient-round.gradient-line-1 {\r\n                  &:after {\r\n                    bottom: -41px;\r\n                  }\r\n                }\r\n                .gradient-round.small-line {\r\n                  &:after {\r\n                    bottom: -19px;\r\n                    height: 12px;\r\n                  }\r\n                }\r\n                .gradient-round.medium-line {\r\n                  &:after {\r\n                    bottom: -34px;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .page-body {\r\n        padding: 0;\r\n      }\r\n      .page-header {\r\n        padding-top: 20px !important;\r\n        padding-bottom: 20px !important;\r\n      }\r\n    }\r\n  }\r\n  // profile\r\n  .profile-details {\r\n    img {\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n  .project-status {\r\n    margin-top: 15px;\r\n    .media {\r\n      margin-top: 15px;\r\n    }\r\n  }\r\n  .profile-card {\r\n    ul {\r\n      display: inherit;\r\n      margin-bottom: 15px;\r\n      li {\r\n        display: block;\r\n        text-align: center;\r\n      }\r\n    }\r\n  }\r\n  .profile-table {\r\n    table {\r\n      tbody {\r\n        tr {\r\n          td {\r\n            &:first-child {\r\n              min-width: 150px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .account-setting {\r\n    h5 {\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n  .deactivate-account {\r\n    margin-top: 15px;\r\n    .btn {\r\n      margin-top: 15px;\r\n    }\r\n  }\r\n  // create user\r\n  .sm-label-radio {\r\n    margin-bottom: 4px !important;\r\n  }\r\n  .permission-block {\r\n    .attribute-blocks {\r\n      .form-group {\r\n        padding-bottom: 15px;\r\n      }\r\n    }\r\n  }\r\n  .needs-validation {\r\n    textarea {\r\n      margin: 0 10px;\r\n    }\r\n    h4 {\r\n      margin-bottom: 15px;\r\n    }\r\n    .permission-block {\r\n      .attribute-blocks {\r\n        .row {\r\n          padding-left: 15px;\r\n        }\r\n        + .attribute-blocks {\r\n          h5 {\r\n            margin-top: 20px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .radio_animated {\r\n      margin: 0 10px 0 0;\r\n    }\r\n    .radio-animated {\r\n      label {\r\n        margin-right: 15px;\r\n      }\r\n    }\r\n  }\r\n  // tab css\r\n  .tab-coupon {\r\n    display: grid;\r\n    text-align: center;\r\n  }\r\n  // add product css\r\n  .add-product-form {\r\n    .form-group {\r\n      .form-control {\r\n        width: 93%;\r\n        margin: 0 auto;\r\n      }\r\n      .col-xl-8 {\r\n        padding: 0;\r\n      }\r\n      fieldset {\r\n        padding-left: 0;\r\n      }\r\n      label {\r\n        padding: 0;\r\n      }\r\n    }\r\n    .qty-box {\r\n      width: 162px;\r\n      .input-group {\r\n        .form-control {\r\n          width: 80px;\r\n        }\r\n      }\r\n    }\r\n    .description-sm {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n  .add-product {\r\n    ul {\r\n      li {\r\n        .box-input-file {\r\n          width: 15px;\r\n          height: 15px;\r\n          img {\r\n            width: 40px !important;\r\n            height: 40px !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .file-upload-product {\r\n    margin-top: 11px;\r\n    li {\r\n      margin-bottom: 34px !important;\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 360px) {\r\n  .product-right {\r\n    .timer {\r\n      padding: 15px 0 15px 30px;\r\n    }\r\n  }\r\n  .page-main-header {\r\n    .main-header-right {\r\n      .nav-right {\r\n        .profile-dropdown {\r\n          right: 6px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .authentication-box {\r\n    padding: 30px 15px;\r\n    .forgot-pass {\r\n      float: none;\r\n      padding-top: 10px;\r\n    }\r\n    .container {\r\n      .form-group {\r\n        margin-bottom: 1rem;\r\n      }\r\n      h3 {\r\n        font-size: 20px;\r\n      }\r\n      p {\r\n        line-height: 1.6;\r\n      }\r\n      .bg-primary {\r\n        padding: 30px 15px;\r\n      }\r\n      .svg-icon {\r\n        padding: 17px;\r\n        height: 90px;\r\n        width: 90px;\r\n        margin-bottom: 25px;\r\n        svg {\r\n          height: 50px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .nav-menus {\r\n    .notification-badge {\r\n      right: 0;\r\n    }\r\n  }\r\n  .page-wrapper {\r\n    .page-main-header {\r\n      .main-header-right {\r\n        .nav-right {\r\n          > ul {\r\n            > li {\r\n              padding: 0 13px;\r\n              .dot {\r\n                right: 13px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .footer {\r\n    padding-left: 0;\r\n    padding-right: 0 !important;\r\n    p {\r\n      font-size: 12px;\r\n    }\r\n  }\r\n  .add-product {\r\n    .bigImg {\r\n      img {\r\n        width: 300px;\r\n      }\r\n    }\r\n  }\r\n  // product detail\r\n  .product-page-main {\r\n    .btn {\r\n      padding: 5px 12px;\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-height: 800px) {\r\n  .right-sidebar {\r\n    .chat-box {\r\n      .friend-list {\r\n        max-height: calc(100vh - 150px);\r\n        overflow: scroll;\r\n      }\r\n    }\r\n  }\r\n}\r\n/*=====================\r\n  Responsive CSS End\r\n==========================*/\r\n","//fonts\r\n$font_0: Lato;\r\n$font_1: sans-serif;\r\n$font-themify: themify;\r\n$font-awesome: FontAwesome;\r\n$font-ICO: IcoFont;\r\n$font-work-sans: work-Sans;\r\n$font-nunito: Nunito;\r\n$font-serif: sans-serif;\r\n//colors\r\n$white: #ffffff;\r\n$white-dark: #eeeeee;\r\n$black: #000000;\r\n$grey01: #111111;\r\n$dark-font: #222222;\r\n$grey-dark: #2d2a25;\r\n$font-color: #333333;\r\n$grey: #777777;\r\n$grey-light: #a1a1a1;\r\n$border: #dddada;\r\n$round-border: #dddddd;\r\n$grey-lighter: #f9f9f9;\r\n$theme-deafult: #12571a;\r\n$grey-darken: #393230;\r\n$grey-link: #948e8c;\r\n$grey-font: #938d8c;\r\n$dark-footer: #2e2726;\r\n$form-bg: #f5f2f2;\r\n$grey-shade: #7f786d;\r\n$darker-footer: #25221e;\r\n$border-color: #38352f;\r\n$border-grey: #f1f5f4;\r\n$font-grey: #aaaaaa;\r\n$star-yellow: #ffa200;\r\n$border-bottom-g: #525252;\r\n$top-header: #f8f8f8;\r\n$header-font: #999999;\r\n$shadow: #ededed;\r\n$box-border: #ecececa8;\r\n$grey-about: #f7f7f7;\r\n$grey2: #555555;\r\n$grey3: #efefef;\r\n$grey4: #444444;\r\n$grey5: #888888;\r\n$grey6: #6f6f6f;\r\n$grey7: #40494f;\r\n$grey8: #c0c0c0;\r\n$sidebar-border: #f5f2f2;\r\n$sidebar-color: #938d8c;\r\n$modal: #ffba00;\r\n$bg-color: #d0edff;\r\n$bg-color1: #f1e7e6;\r\n$bg-color2: #bfbfbf;\r\n$light-grey: #d0edff;\r\n$pink: #f1e7e6;\r\n$blue: #bfbfbf;\r\n$icon: #6f6f6f;\r\n$color-red: #276730;\r\n$gradient1: #01effc;\r\n$gradient2: #485ff2;\r\n$left-sidebar: #2b2b2b;\r\n// dark layput variable //\r\n$dark-body: #2b2b2b;\r\n$dark-top: #232323;\r\n$dark-border: #404040;\r\n$dark-link: #cbcbcb;\r\n$dark-span: #929292;\r\n$dark-footer-bg: #383838;\r\n$white-1: #f1f3f5;\r\n$white-2: #eaedef;\r\n$white-3: #e7eaec;\r\n$white-4: #dee2e6;\r\n$white-5: #cfd4da;\r\n// Theme colors variables\r\n$primary-color: $theme-deafult;\r\n$secondary-color: #13c9ca;\r\n$success-color: #81ba00;\r\n$info-color: #00a8ff;\r\n$warning-color: #ffbc58;\r\n$danger-color: #a5a5a5;\r\n$light-color: #f8f8f9;\r\n$semi-dark: #aaaaaa;\r\n$light-semi-gray: #eff0f1;\r\n$light-gray: #e8ebf2;\r\n$dark-gray: #898989;\r\n$dark-color: #2a3142;\r\n$gray-60: #999999;\r\n$transparent-color: transparent;\r\n$auth-bg-color: #fafafa;\r\n$light: #f6f6f6;\r\n$light-text: #999;\r\n// Tables settings\r\n$horizontal-border-color: #dee2e6;\r\n$table-b-margin: 0px;\r\n$table-footer-font-weight: bold;\r\n$table-inverse-color: $white;\r\n$table-hover-color: $light;\r\n$table-padding: 0.75rem;\r\n$table-xl-padding: 1.25rem 2rem;\r\n$table-xl-font: 120%;\r\n$table-lg-padding: 0.9rem 2rem;\r\n$table-lg-font: 110%;\r\n$table-de-padding: 0.75rem 2rem;\r\n$table-de-font: 100%;\r\n$table-sm-padding: 0.5rem 2rem;\r\n$table-sm-font: 90%;\r\n$table-xs-padding: 0.2rem 2rem;\r\n$table-xs-font: 80%;\r\n$horizontal-border-color: #dee2e6;\r\n$horizontal-padding: 0.75rem 2rem;\r\n$table-inverse-bg-color: #292b2c;\r\n// General variables\r\n$theme-font-color: #1b252a;\r\n$theme-body-font-color: #313131;\r\n$theme-body-sub-title-color: #777777;\r\n//sidabr main settings\r\n$sidebar-width: 255px;\r\n$sidebar-position: fixed;\r\n$sidebar-background-color: $white;\r\n$sidebar-shadow: 0 0 11px rgba(143, 164, 232, 0.08);\r\n$sidebar-overflow: auto;\r\n$sidebar-z-index: 9;\r\n$sidebar-transition: 0.3s;\r\n//main header left settings\r\n$main-header-left-bg-color: $transparent-color;\r\n$main-header-padding: 12px;\r\n$main-header-z-index: 9;\r\n$main-header-right-padding: 0 40px;\r\n$main-header-right-toggle-color: $primary-color;\r\n$main-header-right-nav-right: 0px;\r\n$main-header-right-nav-icon-size: 18px;\r\n$main-header-right-nav-icon-color: $primary-color;\r\n$main-header-right-nav-icon-margin-top: 10px;\r\n//page settings\r\n$page-body-padding: 0 15px;\r\n$page-body-bg-color: $light-color;\r\n$page-body-margin-bottom: 0px;\r\n$page-header-padding: 30px;\r\n$page-title-font-size: 24px;\r\n$page-title-margin-bottom: 0;\r\n$page-title-font-weight: 800;\r\n$page-title-text-tranform: uppercase;\r\n$breadcrumb-size: 14px;\r\n$breadcrumb-content: \"/\";\r\n$breadcrumb-svg-icon-align: text-top;\r\n//Header settings\r\n$main-header-bg-color: $white;\r\n$main-header-position: fixed;\r\n$main-header-top: 0;\r\n$main-header-z-index: 10;\r\n$main-header-shadow: 0 0 10px 1px rgba(68, 102, 242, 0.05);\r\n//General tag settings\r\n$body-bg-color: rgba(246, 246, 246, 0.6);\r\n$body-font-size: 14px;\r\n$body-font-color: $theme-body-font-color;\r\n$ul-padding-left: 0px;\r\n$ul-padding-right: 0px;\r\n$ancher-color: $primary-color;\r\n$btn-focus-box-shadow: none;\r\n$all-focus-outline-color: $primary-color;\r\n$paragraph-font-size: 13px;\r\n$paragraph-line-height: 1.7;\r\n$paragraph-letter-spacing: 0.7px;\r\n$code-tag-color: $primary-color;\r\n$code-tag-bg-color: $light-color;\r\n$code-tag-padding: 3px;\r\n$code-tag-margin: 0 3px;\r\n$code-tag-border-radious: 2px;\r\n$blockquote-padding: 15px;\r\n$blockquote-border: 4px solid $light-gray;\r\n$small-tag-padding: 10px;\r\n$small-tag-color: $dark-color;\r\n$pre-tag-bg-color: rgba(68, 102, 242, 0.05);\r\n$pre-tag-padding: 20px 0;\r\n$list-group-active-bg-color: $primary-color;\r\n$list-group-active-border-color: $primary-color;\r\n$list-group-img-size: 40px;\r\n$list-group-margin: 10px;\r\n//footer settings\r\n$footer_bg_color: $white;\r\n$footer_top_bgr_color: $light-color;\r\n$footer_link_align: right;\r\n$footer_dark_color: $dark-color;\r\n$footer_dark__txt_color: $white;\r\n//Card settings\r\n$card-padding: 30px;\r\n$card-margin-bottom: 30px;\r\n$card-border-width: 0px;\r\n$card-border-color: $light-color;\r\n$card-border-radious: 8px;\r\n$card-box-shadow: 1px 5px 24px 0 rgba(68, 102, 242, 0.05);\r\n$card-header-font-weight: 600;\r\n$card-header-bg-color: $white;\r\n$card-header-font-size: 18px;\r\n$card-header-font-transform: capitalize;\r\n$card-header-font-color: $theme-body-font-color;\r\n$card-header-span-size: 12px;\r\n$card-header-span-color: $theme-body-sub-title-color;\r\n$card-body-bg-color: $transparent-color;\r\n$card-footer-bg-color: $white;\r\n//breadcrumb setting\r\n$breadcrumb-ancher-color: $white;\r\n$breadcrumb-ancher-dark-color: $black;\r\n//buttons setting\r\n$btn-font-size: 14px;\r\n$btn-padding: 0.5rem 1.5rem;\r\n$btn-lg-font-size: 18px;\r\n$btn-sm-font-size: 12px;\r\n$btn-xs-font-size: 11px;\r\n$btn-xs-padding: 0.05rem 0.4rem;\r\n//error input color start\r\n$light-body-bg-color: #f1f4fb;\r\n//sidebar profile settings\r\n$sidebar-user-section-padding: 25px 10px;\r\n$sidebar-user-section-shadow: 3px 2px 7px -1px rgba(127, 151, 249, 0.13);\r\n$sidebar-profile-name-txt-color: $primary-color;\r\n$sidebar-profile-name-txt-transfer: uppercase;\r\n$sidebar-profile-name-txt-weight: 600;\r\n$sidebar-profile-name-letter-specing: 1.5px;\r\n$sidebar-profile-name-marging: 3px;\r\n$sidebar-profile-sub-title-font-size: 10px;\r\n$sidebar-profile-sub-title-margin: 0px;\r\n$sidebar-profile-img-shadow: 0 0 15px rgba(68, 102, 242, 0.3);\r\n//Sidebar main menu setting\r\n$sidebar-menu-padding: 20px;\r\n$sidebar-menu-list-style: none;\r\n$sidebar-menu-list-margin: 0;\r\n$sidebar-icon-size: 14px;\r\n$sidebar-icon-margin: 14px;\r\n$sidebar-icon-stroke-width: 3px;\r\n$sidebar-font-size: 14px;\r\n$sidebar-letter-specing: 0.5px;\r\n$sidebar-txt-transform: capitalize;\r\n$sidebar-font-weight: 600;\r\n$sidebar-font-color: $theme-body-font-color;\r\n$sidebar-padding-top: 12px;\r\n$sidebar-padding-bottom: 12px;\r\n$sidebar-sub-header-padding: 15px;\r\n$sidebar-sub-header-margin: 0;\r\n$sidebar-text-transform: capitalize;\r\n$sidebar-heading-hover-padding: 3px;\r\n$sidebar-hover-txt-color: $primary-color;\r\n$sidebar-arrow-margin-top: 2px;\r\n$sidebar-arrow-size: 15px;\r\n$sidebar-arrow-color: $theme-body-font-color;\r\n$sidebar-open-icon: \"\\f107\";\r\n$sidebar-close-icon: \"\\f105\";\r\n$sidebar-icon-font-family: $font-awesome;\r\n",".custom-theme {\n  position: fixed;\n  right: 0;\n  width: 40px;\n  height: 38px;\n  display: flex;\n  z-index: 1;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  text-decoration: none;\n  border-radius: 5px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  background-color: $grey-about;\n  box-shadow: 0px 0px 5px 0px rgba(154, 154, 154, 0.54);\n  top: calc(50% + 34px);\n  cursor: pointer;\n}\n/**=====================\n    RTL CSS Start\n==========================**/\nbody {\n  &.rtl {\n    direction: rtl;\n    .m-r-15 {\n      margin-left: 15px;\n      margin-right: unset;\n    }\n    .me-2,\n    .mx-2 {\n      margin-left: 0.5rem !important;\n      margin-right: unset !important;\n    }\n    .form-select {\n      padding: 0.375rem 0.75rem 0.375rem 1.75rem;\n    }\n    .ps-0,\n    .px-0 {\n      padding-right: 0 !important;\n      padding-left: unset !important;\n    }\n    .me-sm-2{\n      margin-right: unset;\n      margin-left: 0.5rem !important;\n    }\n    .m-r-10 {\n      margin-left: 10px;\n      margin-right: unset;\n    }\n    .radio_animated,\n    .checkbox_animated {\n      margin: 0 8px 0 1rem;\n    }\n    .btn-light{\n      margin-left: unset;\n      margin-right: 7px;\n    }\n    .onhover-show-div{\n      left: unset;\n      right: 0;\n    }\n    .page-wrapper{\n      .page-body-wrapper{\n        footer{\n          &.footer.open{\n            margin-right: 0;\n            margin-left: unset;\n          }\n        }\n      }\n    }\n    .page-wrapper{\n      .page-main-header{\n        .main-header-left{\n          .logo-wrapper{\n            img{\n              margin-left: 15px;\n              margin-right: unset;\n            }\n          }\n        }\n      }\n    }\n    .rdt_Pagination{\n      > div{\n        direction: ltr;\n      }\n    }\n    .digital-add {\n      .form-group {\n        .radio_animated {\n          margin-left: 8px;\n          margin-right: unset;\n        }\n      }\n    }\n    .dropzone{\n      .dzu-input{\n        margin-right: 15px;\n        margin-left: unset;\n      }\n    } \n    .product-right{\n      .timer{\n        padding: 15px 40px 15px 0;\n        span{\n          .padding-l{\n            padding-left: unset;\n            padding-right: 22px;\n          }\n        }\n      }\n    } \n    .breadcrumb-item{\n      + .breadcrumb-item{\n        padding-right: 0.5rem;\n        padding-left: unset;\n        &::before{\n          float: right;\n          padding-left: 0.5rem;\n          padding-right: unset;\n        }\n      }\n    }\n    .page-main-header{\n      .main-header-right{\n        .nav-right{\n          > ul{\n            > li{\n              border-left: unset;\n              border-right: 1px solid $light-semi-gray;\n              &:hover{\n                .language-dropdown.onhover-show-div{\n                  &::before{\n                    right: 10px !important;\n                    left: unset !important;\n                  }\n                  &::after{\n                    right: 10px !important;\n                    left: unset !important;\n                  }\n                }\n              }\n              &:nth-child(5){\n                border-right: unset;\n                border-left: 1px solid $light-semi-gray;\n                padding-left: 20px;\n                padding-right: 0;\n              }\n            }\n          }\n          .profile-dropdown{\n            right: unset;\n            left: -10px;\n          }\n        }\n      }\n    }   \n    .page-wrapper{\n      .page-body-wrapper{\n        .page-sidebar{\n          .sidebar-menu{\n            > li{\n              > a{\n                i{\n                  &::before{\n                    content: \"\\f104\";\n                  }\n                }\n              }\n            }\n          }\n          .main-header-left{\n            .logo-wrapper{\n              padding-left: unset;\n              padding-right: 10px;\n            }\n          }\n        }\n      }\n    }    \n    .authentication-box{\n      .back-btn{\n        float: left;\n      }\n      .form-footer{\n        > span{\n          padding-right: unset;\n          padding-left: 20px;\n        }\n      }\n      .form-horizontal{\n        .form-terms{\n          .custom-control{\n            padding-left: unset;\n            padding-right: 24px;\n          }\n        }\n      }\n      .tab2-card{\n        .nav-tabs{\n          .nav-link{\n            svg{\n              margin-left: 5px;\n              margin-right: unset;\n            }\n          }\n        }\n      }\n    }\n    .needs-validation {\n      .form-group {\n        text-align: right;\n        .checkbox {\n          padding-right: 0;\n          padding-left: unset;\n        }\n      }\n      .permission-block {\n        .attribute-blocks {\n          padding-right: 15px;\n          padding-left: unset;\n          text-align: right;\n          .row {\n            padding-right: 20px;\n            padding-left: unset;\n          }\n        }\n      }\n      .checkbox {\n        label {\n          padding-right: 16px;\n          padding-left: unset;\n          &::before {\n            right: 0;\n            left: unset;\n            margin-left: unset;\n            margin-right: -16px;\n          }\n        }\n        right: 0;\n        margin-left: -16px;\n      }\n      .radio-animated {\n        label {\n          margin-left: 20px;\n          margin-right: unset;\n        }\n      }\n    }\n    .modal-footer {\n      > :not(:last-child) {\n        margin-left: 0.25rem;\n        margin-right: unset;\n      }\n    }\n    .jsgrid-button {\n      + .jsgrid-button {\n        margin-right: 5px;\n        margin-left: unset;\n      }\n    }\n    .custom-theme {\n      left: 0;\n      right: unset;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n    }\n    .text-end {\n      text-align: left !important;\n    }\n    .br-wrapper {\n      text-align: right;\n    }\n    .card {\n      .card-header {\n        .card-header-right {\n          left: 20px;\n          right: unset;\n          .card-option {\n            text-align: left;\n            &.list-unstyled {\n              padding-right: 0;\n              padding-left: unset;\n            }\n          }\n        }\n      }\n    }\n    code[class*=\"language-\"],\n    pre[class*=\"language-\"] {\n      text-align: right;\n    }\n    .code-box-copy__btn {\n      right: unset;\n      left: 11px;\n    }\n    table {\n      thead,\n      tbody {\n        tr {\n          th,\n          td {\n            text-align: right;\n          }\n        }\n      }\n    }\n    .pull-right {\n      float: left;\n    }\n    .status-circle {\n      right: 40px;\n      left: unset;\n    }\n    .right-sidebar {\n      &.show {\n        left: 0;\n        right: unset;\n      }\n      .friend-list-search {\n        .fa {\n          left: 35px;\n          right: unset;\n        }\n      }\n      .chat-box {\n        .about {\n          float: right;\n          padding-right: 10px;\n          padding-left: unset;\n          text-align: right;\n        }\n        .friend-list {\n          text-align: right;\n        }\n        .user-image {\n          float: right;\n          margin-left: 5px;\n          margin-right: 0;\n        }\n      }\n    }\n    .nav-menus {\n      .search-form {\n        input {\n          padding: 10px 70px 10px 10px;\n        }\n      }\n    }\n    ul {\n      &.notification-dropdown {\n        &.onhover-show-div {\n          li {\n            text-align: right;\n          }\n        }\n      }\n    }\n    // sidebar main page\n    .page-wrapper {\n      .page-body-wrapper {\n        .page-sidebar {\n          .sidebar-user {\n            h6,\n            p {\n              text-align: center;\n            }\n          }\n          .sidebar-menu {\n            li {\n              text-align: right;\n              &.active {\n                > .sidebar-submenu {\n                  margin-right: 15px;\n                  margin-left: unset;\n                }\n              }\n            }\n            .sidebar-submenu {\n              > li {\n                > a {\n                  padding-right: 10px;\n                  padding-left: unset;\n                  > .fa-circle {\n                    right: 0;\n                    left: unset;\n                  }\n                }\n              }\n            }\n            .sidebar-header {\n              svg {\n                margin-right: unset;\n                margin-left: 14px;\n              }\n            }\n          }\n          ~ .page-body {\n            margin-right: 255px;\n            margin-left: unset;\n          }\n          &.open {\n            margin-right: calc(-260px);\n            margin-left: unset;\n            ~ .page-body,\n            ~ footer {\n              margin-right: 0;\n            }\n          }\n        }\n        .page-header {\n          .row {\n            h3 {\n              text-align: right;\n            }\n          }\n        }\n        footer {\n          margin-right: 255px;\n          margin-left: unset;\n          p {\n            i {\n              margin-right: 5px;\n              margin-left: unset;\n            }\n          }\n        }\n      }\n    }\n    // page main header\n    .page-main-header {\n      margin-right: 255px;\n      margin-left: unset;\n      .main-header-right {\n        .nav-right {\n          text-align: left;\n          padding-right: 0;\n          padding-left: 12px;\n          .profile-dropdown {\n            li {\n              svg {\n                margin-right: unset;\n                margin-left: 10px;\n              }\n            }\n          }\n          > ul {\n            > li {\n              &:before {\n                right: 0;\n                left: unset;\n              }\n              .dot {\n                left: 17px;\n                right: unset;\n              }\n              .media {\n                .dotted-animation {\n                  left: -3px;\n                  right: unset;\n                  .main-circle {\n                    left: 6px;\n                    right: unset;\n                  }\n                  .animate-circle {\n                    left: -4px;\n                    right: unset;\n                  }\n                }\n              }\n              &.onhover-dropdown {\n                &:hover {\n                  .onhover-show-div {\n                    &:before {\n                      left: 10px;\n                      right: unset;\n                    }\n                    &:after {\n                      left: 10px;\n                      right: unset;\n                    }\n                  }\n                }\n                &:last-child {\n                  padding-left: 0;\n                  padding-right: 20px;\n                  border-right: none;\n                }\n              }\n              &:first-child {\n                border-right: none;\n                .search-form {\n                  .form-group {\n                    &:after {\n                      right: 22px;\n                      left: unset;\n                    }\n                    &:before {\n                      right: 51px;\n                      left: unset;\n                    }\n                  }\n                }\n              }\n              &:last-child {\n                padding-right: 20px;\n                padding-left: 0;\n              }\n              text-align: right;\n              i {\n                &.ms-2 {\n                  margin-right: 0.5rem !important;\n                  margin-left: unset !important;\n                }\n              }\n            }\n          }\n          .language-dropdown {\n            text-align: right;\n            li {\n              a {\n                i {\n                  margin-left: 10px;\n                }\n              }\n            }\n          }\n          .profile-dropdown {\n            li {\n              a {\n                svg {\n                  margin-right: unset;\n                  margin-left: 10px;\n                }\n              }\n            }\n          }\n        }\n        .mobile-sidebar {\n          padding-right: 20px;\n        }\n      }\n      &.open {\n        margin-right: 0;\n      }\n    }\n    ul {\n      &.notification-dropdown {\n        &.onhover-show-div {\n          right: initial;\n          left: -30px;\n          padding: 0;\n          &:before {\n            right: inherit !important;\n            left: 35px !important;\n          }\n          &:after {\n            right: inherit !important;\n            left: 35px !important;\n          }\n          li {\n            margin-right: 0 !important;\n            span {\n              &.badge {\n                margin-left: unset !important;\n              }\n              svg {\n                margin-right: unset;\n                margin-left: 10px;\n              }\n            }\n            .notification-icon {\n              margin-left: 20px;\n              margin-right: unset;\n            }\n          }\n        }\n      }\n    }\n    .owl-carousel {\n      direction: ltr;\n    }\n    // default page\n    .media {\n      .media-body {\n        text-align: right;\n      }\n    }\n    .order-graph {\n      .order-graph-bottom {\n        h6 {\n          margin-right: 15px !important;\n          margin-left: 30px;\n        }\n      }\n    }\n    .latest-order-table {\n      .btn {\n        float: right;\n      }\n    }\n    // product\n    .product-physical {\n      table {\n        tr {\n          th,\n          td {\n            &:nth-child(2) {\n              text-align: right;\n            }\n          }\n        }\n      }\n    }\n    .product-page-details,\n    .product-right {\n      .color-variant,\n      .size-box {\n        text-align: right;\n      }\n    }\n    .add-product-form {\n      .qty-box {\n        .input-group {\n          .input-group-append {\n            .btn {\n              border-right: none !important;\n              border-left: 1px solid $round-border !important;\n            }\n          }\n          .btn-primary {\n            &.bootstrap-touchspin-down {\n              border-left: none !important;\n              border-right: 1px solid $round-border !important;\n            }\n          }\n        }\n      }\n      .offset-sm-4 {\n        text-align: right;\n      }\n    }\n    .timer {\n      float: right;\n      ~ .m-t-15 {\n        clear: both;\n        text-align: right;\n        padding-top: 15px;\n      }\n      span {\n        .padding-l {\n          right: 35px;\n          left: unset;\n          padding-right: 0;\n        }\n      }\n    }\n    .product-list,\n    .report-table {\n      table {\n        tr {\n          td,\n          th {\n            text-align: right !important;\n            &:last-child {\n              text-align: center !important;\n            }\n          }\n        }\n      }\n    }\n    .dropzone {\n      .dz-preview {\n        .dz-error-mark,\n        .dz-success-mark {\n          left: unset;\n          right: 48%;\n          margin-right: -27px;\n          margin-left: unset;\n        }\n      }\n      &.dz-clickable {\n        .dz-message {\n          * {\n            text-align: center;\n          }\n        }\n      }\n    }\n    .digital-add {\n      .col-form-label {\n        display: block;\n        text-align: right;\n      }\n    }\n    // datatables\n    .dataTables_wrapper {\n      .dataTables_filter {\n        input[type=\"search\"] {\n          margin-right: 10px;\n          margin-left: unset;\n        }\n      }\n      table {\n        &.dataTable {\n          .vendor-list {\n            img {\n              margin-left: 20px;\n              margin-right: unset;\n            }\n          }\n        }\n      }\n    }\n    .category-table {\n      table {\n        tr {\n          td,\n          th {\n            &:nth-child(3) {\n              text-align: right;\n            }\n          }\n        }\n      }\n    }\n    .media-table {\n      table {\n        tr {\n          td,\n          th {\n            &:last-child {\n              text-align: right !important;\n            }\n          }\n        }\n      }\n    }\n    // profile page\n    .profile-details {\n      h5 {\n        text-align: center;\n      }\n    }\n    .account-setting {\n      text-align: right;\n    }\n    @media only screen and (max-width: 991px) {\n      .product-page-details{\n        text-align: right !important;\n      }\n      .page-wrapper {\n        .page-main-header {\n          margin-right: 0;\n        }\n        .page-body-wrapper {\n          .page-sidebar {\n            ~ .page-body,\n            ~ footer {\n              margin-right: 0;\n            }\n          }\n        }\n      }\n    }\n    @media only screen and (max-width: 767px) {\n      .needs-validation {\n        .form-group {\n          .checkbox {\n            padding-right: 15px;\n            padding-left: unset;\n          }\n        }\n      }\n      .page-wrapper {\n        .page-body-wrapper {\n          footer {\n            p {\n              text-align: center;\n            }\n          }\n        }\n      }\n    }\n    @media only screen and (max-width: 575px) {\n      .add-product-form{\n        .form-group{\n          fieldset{\n            padding-left: 12px;\n            padding-right: 0;\n          }\n        }\n      }  \n      .page-wrapper{\n        .page-main-header{\n          .main-header-right{\n            .nav-right{\n              > ul{\n                .search-form{\n                  .form-control-plaintext{\n                    left: unset;\n                    right: 0;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      ul.notification-dropdown.onhover-show-div{\n        right: unset;\n        left: -112px;\n        &::before, &::after{\n          right: unset !important;\n          left: 135px !important;\n        }\n      }\n    }\n    @media only screen and (max-width: 360px) {\n      .page-wrapper{\n        .page-main-header{\n          .main-header-right{\n            .nav-right{\n              > ul{\n                > li{\n                  .dot{\n                    left: 13px;\n                    right: unset;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }   \n      .product-right{\n        .timer{\n          padding: 15px 30px 15px 0;\n        }\n      }\n    }\n    @media (min-width: 1200px) {\n      .offset-xl-3 {\n        margin-right: 25%;\n        margin-left: unset;\n      }\n    }\n  }\n}\n/**=====================\n    RTL CSS End\n==========================**/",".flag-icon-background {\r\n  background-size: contain;\r\n  background-position: 50%;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.flag-icon {\r\n  @extend .flag-icon-background;\r\n  position: relative;\r\n  display: inline-block;\r\n  width: (4 / 3) * 1em;\r\n  line-height: 1em;\r\n  &:before {\r\n    content: '\\00a0';\r\n  }\r\n  &.flag-icon-squared {\r\n    width: 1em;\r\n  }\r\n}\r\n\r\n@mixin flag-icon($country) {\r\n  .flag-icon-#{$country} {\r\n    background-image: url(../../fonts/flag-icon/#{$country}.svg);\r\n    &.flag-icon-squared {\r\n      background-image: url(../../fonts/flag-icon/#{$country}.svg);\r\n    }\r\n  }\r\n}\r\n","/* FONT PATH\r\n * -------------------------- */\r\n\r\n@font-face {\r\n\tfont-family: 'themify';\r\n\tsrc:url('#{$ti-font-path}/themify.eot?-fvbane');\r\n\tsrc:url('#{$ti-font-path}/themify.eot?#iefix-fvbane') format('embedded-opentype'),\r\n\t\turl('#{$ti-font-path}/themify.woff?-fvbane') format('woff'),\r\n\t\turl('#{$ti-font-path}/themify.ttf?-fvbane') format('truetype'),\r\n\t\turl('#{$ti-font-path}/themify.svg?-fvbane#themify') format('svg');\r\n\tfont-weight: normal;\r\n\tfont-style: normal;\r\n}\r\n","\r\n[class^=\"icon-\"],\r\n[class*=\" icon-\"] {\r\n  @include icon-themify-icons();\r\n}\r\n\r\n[class^=\"icon-\"]:before,\r\n[class*=\" icon-\"]:before {\r\n  text-decoration: inherit;\r\n  display: inline-block;\r\n  speak: none;\r\n}\r\n\r\n/* makes the font 33% larger relative to the icon container */\r\n.icon-large:before {\r\n  vertical-align: -10%;\r\n  font-size: (4em/3);\r\n}\r\n\r\n/* makes sure icons active on rollover in links */\r\na {\r\n  [class^=\"icon-\"],\r\n  [class*=\" icon-\"] {\r\n    display: inline;\r\n  }\r\n}\r\n\r\n/* increased font size for icon-large */\r\n[class^=\"icon-\"],\r\n[class*=\" icon-\"] {\r\n  &.icon-fixed-width {\r\n    display: inline-block;\r\n    width: (16em/14);\r\n    text-align: right;\r\n    padding-right: (4em/14);\r\n    &.icon-large {\r\n      width: (20em/14);\r\n    }\r\n  }\r\n}\r\n\r\n.icons-ul {\r\n  margin-left: $icons-li-width;\r\n  list-style-type: none;\r\n\r\n  > li { position: relative; }\r\n\r\n  .icon-li {\r\n    position: absolute;\r\n    left: -$icons-li-width;\r\n    width: $icons-li-width;\r\n    text-align: center;\r\n    line-height: inherit;\r\n  }\r\n}\r\n\r\n// allows usage of the hide class directly on font awesome icons\r\n[class^=\"icon-\"],\r\n[class*=\" icon-\"] {\r\n  &.hide {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.icon-muted { color: $iconMuted; }\r\n.icon-light { color: $iconLight; }\r\n.icon-dark { color: $iconDark; }\r\n\r\n// Icon Borders\r\n// -------------------------\r\n\r\n.icon-border {\r\n  border: solid 1px $borderColor;\r\n  padding: .2em .25em .15em;\r\n  @include border-radius(3px);\r\n}\r\n\r\n// Icon Sizes\r\n// -------------------------\r\n\r\n.icon-2x {\r\n  font-size: 2em;\r\n  &.icon-border {\r\n    border-width: 2px;\r\n    @include border-radius(4px);\r\n  }\r\n}\r\n.icon-3x {\r\n  font-size: 3em;\r\n  &.icon-border {\r\n    border-width: 3px;\r\n    @include border-radius(5px);\r\n  }\r\n}\r\n.icon-4x {\r\n  font-size: 4em;\r\n  &.icon-border {\r\n    border-width: 4px;\r\n    @include border-radius(6px);\r\n  }\r\n}\r\n\r\n.icon-5x {\r\n  font-size: 5em;\r\n  &.icon-border {\r\n    border-width: 5px;\r\n    @include border-radius(7px);\r\n  }\r\n}\r\n\r\n\r\n// Floats & Margins\r\n// -------------------------\r\n\r\n// Quick floats\r\n.pull-right { float: right; }\r\n.pull-left { float: left; }\r\n\r\n[class^=\"icon-\"],\r\n[class*=\" icon-\"] {\r\n  &.pull-left {\r\n    margin-right: .3em;\r\n  }\r\n  &.pull-right {\r\n    margin-left: .3em;\r\n  }\r\n}\r\n","// Mixins\r\n// --------------------------\r\n\r\n// FONT / MARGINS / FONT SIZE / COLOUR\r\n@mixin icon($i, $m:10px, $fs:18px, $c:inherit) {\r\n  &:before { @include icon-themify-icons(); content: $i; margin-right: $m; font-size: $fs; color:$c;}\r\n}\r\n@mixin iconafter($i, $m:10px, $fs:18px, $c:inherit) {\r\n  &:after { @include icon-themify-icons(); content: $i; margin-left: $m; font-size: $fs; color:$c; }\r\n}\r\n\r\n@mixin icon-themify-icons() {\r\n  font-family: 'themify';\r\nspeak: none;\r\nfont-style: normal;\r\nfont-weight: normal;\r\nfont-variant: normal;\r\ntext-transform: none;\r\nline-height: 1;\r\n-webkit-font-smoothing: antialiased;\r\n-moz-osx-font-smoothing: grayscale;\r\n  *margin-right: .3em; // fixes ie7 issues\r\n}\r\n\r\n@mixin border-radius($radius) {\r\n  -webkit-border-radius: $radius;\r\n  -moz-border-radius: $radius;\r\n  border-radius: $radius;\r\n}\r\n\r\n\r\n@mixin icon-stack($width: 2em, $height: 2em, $top-font-size: 1em, $base-font-size: 2em) {\r\n  .icon-stack {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: $width;\r\n    height: $height;\r\n    line-height: $width;\r\n    vertical-align: -35%;\r\n    [class^=\"icon-\"],\r\n    [class*=\" icon-\"] {\r\n      display: block;\r\n      text-align: center;\r\n      position: absolute;\r\n      width: 100%;\r\n      height: 100%;\r\n      font-size: $top-font-size;\r\n      line-height: inherit;\r\n      *line-height: $height;\r\n    }\r\n    .icon-stack-base {\r\n      font-size: $base-font-size;\r\n      *line-height: #{$height / $base-font-size}em;\r\n    }\r\n  }\r\n}\r\n","$ti-font-path: \"../../fonts\" !default;\r\n\r\n$borderColor: #eeeeee !default;\r\n$iconMuted: #eeeeee !default;\r\n$iconLight: white !default;\r\n$iconDark: #333333 !default;\r\n$icons-li-width: (30em/14);\r\n\r\n\r\n$wand : \"\\e600\";\r\n$volume : \"\\e601\";\r\n$user : \"\\e602\";\r\n$unlock : \"\\e603\";\r\n$unlink : \"\\e604\";\r\n$trash : \"\\e605\";\r\n$thought : \"\\e606\";\r\n$target : \"\\e607\";\r\n$tag : \"\\e608\";\r\n$tablet : \"\\e609\";\r\n$star : \"\\e60a\";\r\n$spray : \"\\e60b\";\r\n$signal : \"\\e60c\";\r\n$shopping-cart : \"\\e60d\";\r\n$shopping-cart-full : \"\\e60e\";\r\n$settings : \"\\e60f\";\r\n$search : \"\\e610\";\r\n$zoom-in : \"\\e611\";\r\n$zoom-out : \"\\e612\";\r\n$cut : \"\\e613\";\r\n$ruler : \"\\e614\";\r\n$ruler-pencil : \"\\e615\";\r\n$ruler-alt : \"\\e616\";\r\n$bookmark : \"\\e617\";\r\n$bookmark-alt : \"\\e618\";\r\n$reload : \"\\e619\";\r\n$plus : \"\\e61a\";\r\n$pin : \"\\e61b\";\r\n$pencil : \"\\e61c\";\r\n$pencil-alt : \"\\e61d\";\r\n$paint-roller : \"\\e61e\";\r\n$paint-bucket : \"\\e61f\";\r\n$na : \"\\e620\";\r\n$mobile : \"\\e621\";\r\n$minus : \"\\e622\";\r\n$medall : \"\\e623\";\r\n$medall-alt : \"\\e624\";\r\n$marker : \"\\e625\";\r\n$marker-alt : \"\\e626\";\r\n$arrow-up : \"\\e627\";\r\n$arrow-right : \"\\e628\";\r\n$arrow-left : \"\\e629\";\r\n$arrow-down : \"\\e62a\";\r\n$lock : \"\\e62b\";\r\n$location-arrow : \"\\e62c\";\r\n$link : \"\\e62d\";\r\n$layout : \"\\e62e\";\r\n$layers : \"\\e62f\";\r\n$layers-alt : \"\\e630\";\r\n$key : \"\\e631\";\r\n$import : \"\\e632\";\r\n$image : \"\\e633\";\r\n$heart : \"\\e634\";\r\n$heart-broken : \"\\e635\";\r\n$hand-stop : \"\\e636\";\r\n$hand-open : \"\\e637\";\r\n$hand-drag : \"\\e638\";\r\n$folder : \"\\e639\";\r\n$flag : \"\\e63a\";\r\n$flag-alt : \"\\e63b\";\r\n$flag-alt-2 : \"\\e63c\";\r\n$eye : \"\\e63d\";\r\n$export : \"\\e63e\";\r\n$exchange-vertical : \"\\e63f\";\r\n$desktop : \"\\e640\";\r\n$cup : \"\\e641\";\r\n$crown : \"\\e642\";\r\n$comments : \"\\e643\";\r\n$comment : \"\\e644\";\r\n$comment-alt : \"\\e645\";\r\n$close : \"\\e646\";\r\n$clip : \"\\e647\";\r\n$angle-up : \"\\e648\";\r\n$angle-right : \"\\e649\";\r\n$angle-left : \"\\e64a\";\r\n$angle-down : \"\\e64b\";\r\n$check : \"\\e64c\";\r\n$check-box : \"\\e64d\";\r\n$camera : \"\\e64e\";\r\n$announcement : \"\\e64f\";\r\n$brush : \"\\e650\";\r\n$briefcase : \"\\e651\";\r\n$bolt : \"\\e652\";\r\n$bolt-alt : \"\\e653\";\r\n$blackboard : \"\\e654\";\r\n$bag : \"\\e655\";\r\n$move : \"\\e656\";\r\n$arrows-vertical : \"\\e657\";\r\n$arrows-horizontal : \"\\e658\";\r\n$fullscreen : \"\\e659\";\r\n$arrow-top-right : \"\\e65a\";\r\n$arrow-top-left : \"\\e65b\";\r\n$arrow-circle-up : \"\\e65c\";\r\n$arrow-circle-right : \"\\e65d\";\r\n$arrow-circle-left : \"\\e65e\";\r\n$arrow-circle-down : \"\\e65f\";\r\n$angle-double-up : \"\\e660\";\r\n$angle-double-right : \"\\e661\";\r\n$angle-double-left : \"\\e662\";\r\n$angle-double-down : \"\\e663\";\r\n$zip : \"\\e664\";\r\n$world : \"\\e665\";\r\n$wheelchair : \"\\e666\";\r\n$view-list : \"\\e667\";\r\n$view-list-alt : \"\\e668\";\r\n$view-grid : \"\\e669\";\r\n$uppercase : \"\\e66a\";\r\n$upload : \"\\e66b\";\r\n$underline : \"\\e66c\";\r\n$truck : \"\\e66d\";\r\n$timer : \"\\e66e\";\r\n$ticket : \"\\e66f\";\r\n$thumb-up : \"\\e670\";\r\n$thumb-down : \"\\e671\";\r\n$text : \"\\e672\";\r\n$stats-up : \"\\e673\";\r\n$stats-down : \"\\e674\";\r\n$split-v : \"\\e675\";\r\n$split-h : \"\\e676\";\r\n$smallcap : \"\\e677\";\r\n$shine : \"\\e678\";\r\n$shift-right : \"\\e679\";\r\n$shift-left : \"\\e67a\";\r\n$shield : \"\\e67b\";\r\n$notepad : \"\\e67c\";\r\n$server : \"\\e67d\";\r\n$quote-right : \"\\e67e\";\r\n$quote-left : \"\\e67f\";\r\n$pulse : \"\\e680\";\r\n$printer : \"\\e681\";\r\n$power-off : \"\\e682\";\r\n$plug : \"\\e683\";\r\n$pie-chart : \"\\e684\";\r\n$paragraph : \"\\e685\";\r\n$panel : \"\\e686\";\r\n$package : \"\\e687\";\r\n$music : \"\\e688\";\r\n$music-alt : \"\\e689\";\r\n$mouse : \"\\e68a\";\r\n$mouse-alt : \"\\e68b\";\r\n$money : \"\\e68c\";\r\n$microphone : \"\\e68d\";\r\n$menu : \"\\e68e\";\r\n$menu-alt : \"\\e68f\";\r\n$map : \"\\e690\";\r\n$map-alt : \"\\e691\";\r\n$loop : \"\\e692\";\r\n$location-pin : \"\\e693\";\r\n$list : \"\\e694\";\r\n$light-bulb : \"\\e695\";\r\n$Italic : \"\\e696\";\r\n$info : \"\\e697\";\r\n$infinite : \"\\e698\";\r\n$id-badge : \"\\e699\";\r\n$hummer : \"\\e69a\";\r\n$home : \"\\e69b\";\r\n$help : \"\\e69c\";\r\n$headphone : \"\\e69d\";\r\n$harddrives : \"\\e69e\";\r\n$harddrive : \"\\e69f\";\r\n$gift : \"\\e6a0\";\r\n$game : \"\\e6a1\";\r\n$filter : \"\\e6a2\";\r\n$files : \"\\e6a3\";\r\n$file : \"\\e6a4\";\r\n$eraser : \"\\e6a5\";\r\n$envelope : \"\\e6a6\";\r\n$download : \"\\e6a7\";\r\n$direction : \"\\e6a8\";\r\n$direction-alt : \"\\e6a9\";\r\n$dashboard : \"\\e6aa\";\r\n$control-stop : \"\\e6ab\";\r\n$control-shuffle : \"\\e6ac\";\r\n$control-play : \"\\e6ad\";\r\n$control-pause : \"\\e6ae\";\r\n$control-forward : \"\\e6af\";\r\n$control-backward : \"\\e6b0\";\r\n$cloud : \"\\e6b1\";\r\n$cloud-up : \"\\e6b2\";\r\n$cloud-down : \"\\e6b3\";\r\n$clipboard : \"\\e6b4\";\r\n$car : \"\\e6b5\";\r\n$calendar : \"\\e6b6\";\r\n$book : \"\\e6b7\";\r\n$bell : \"\\e6b8\";\r\n$basketball : \"\\e6b9\";\r\n$bar-chart : \"\\e6ba\";\r\n$bar-chart-alt : \"\\e6bb\";\r\n$back-right : \"\\e6bc\";\r\n$back-left : \"\\e6bd\";\r\n$arrows-corner : \"\\e6be\";\r\n$archive : \"\\e6bf\";\r\n$anchor : \"\\e6c0\";\r\n$align-right : \"\\e6c1\";\r\n$align-left : \"\\e6c2\";\r\n$align-justify : \"\\e6c3\";\r\n$align-center : \"\\e6c4\";\r\n$alert : \"\\e6c5\";\r\n$alarm-clock : \"\\e6c6\";\r\n$agenda : \"\\e6c7\";\r\n$write : \"\\e6c8\";\r\n$window : \"\\e6c9\";\r\n$widgetized : \"\\e6ca\";\r\n$widget : \"\\e6cb\";\r\n$widget-alt : \"\\e6cc\";\r\n$wallet : \"\\e6cd\";\r\n$video-clapper : \"\\e6ce\";\r\n$video-camera : \"\\e6cf\";\r\n$vector : \"\\e6d0\";\r\n$themify-logo : \"\\e6d1\";\r\n$themify-favicon : \"\\e6d2\";\r\n$themify-favicon-alt : \"\\e6d3\";\r\n$support : \"\\e6d4\";\r\n$stamp : \"\\e6d5\";\r\n$split-v-alt : \"\\e6d6\";\r\n$slice : \"\\e6d7\";\r\n$shortcode : \"\\e6d8\";\r\n$shift-right-alt : \"\\e6d9\";\r\n$shift-left-alt : \"\\e6da\";\r\n$ruler-alt-2 : \"\\e6db\";\r\n$receipt : \"\\e6dc\";\r\n$pin2 : \"\\e6dd\";\r\n$pin-alt : \"\\e6de\";\r\n$pencil-alt2 : \"\\e6df\";\r\n$palette : \"\\e6e0\";\r\n$more : \"\\e6e1\";\r\n$more-alt : \"\\e6e2\";\r\n$microphone-alt : \"\\e6e3\";\r\n$magnet : \"\\e6e4\";\r\n$line-double : \"\\e6e5\";\r\n$line-dotted : \"\\e6e6\";\r\n$line-dashed : \"\\e6e7\";\r\n$layout-width-full : \"\\e6e8\";\r\n$layout-width-default : \"\\e6e9\";\r\n$layout-width-default-alt : \"\\e6ea\";\r\n$layout-tab : \"\\e6eb\";\r\n$layout-tab-window : \"\\e6ec\";\r\n$layout-tab-v : \"\\e6ed\";\r\n$layout-tab-min : \"\\e6ee\";\r\n$layout-slider : \"\\e6ef\";\r\n$layout-slider-alt : \"\\e6f0\";\r\n$layout-sidebar-right : \"\\e6f1\";\r\n$layout-sidebar-none : \"\\e6f2\";\r\n$layout-sidebar-left : \"\\e6f3\";\r\n$layout-placeholder : \"\\e6f4\";\r\n$layout-menu : \"\\e6f5\";\r\n$layout-menu-v : \"\\e6f6\";\r\n$layout-menu-separated : \"\\e6f7\";\r\n$layout-menu-full : \"\\e6f8\";\r\n$layout-media-right-alt : \"\\e6f9\";\r\n$layout-media-right : \"\\e6fa\";\r\n$layout-media-overlay : \"\\e6fb\";\r\n$layout-media-overlay-alt : \"\\e6fc\";\r\n$layout-media-overlay-alt-2 : \"\\e6fd\";\r\n$layout-media-left-alt : \"\\e6fe\";\r\n$layout-media-left : \"\\e6ff\";\r\n$layout-media-center-alt : \"\\e700\";\r\n$layout-media-center : \"\\e701\";\r\n$layout-list-thumb : \"\\e702\";\r\n$layout-list-thumb-alt : \"\\e703\";\r\n$layout-list-post : \"\\e704\";\r\n$layout-list-large-image : \"\\e705\";\r\n$layout-line-solid : \"\\e706\";\r\n$layout-grid4 : \"\\e707\";\r\n$layout-grid3 : \"\\e708\";\r\n$layout-grid2 : \"\\e709\";\r\n$layout-grid2-thumb : \"\\e70a\";\r\n$layout-cta-right : \"\\e70b\";\r\n$layout-cta-left : \"\\e70c\";\r\n$layout-cta-center : \"\\e70d\";\r\n$layout-cta-btn-right : \"\\e70e\";\r\n$layout-cta-btn-left : \"\\e70f\";\r\n$layout-column4 : \"\\e710\";\r\n$layout-column3 : \"\\e711\";\r\n$layout-column2 : \"\\e712\";\r\n$layout-accordion-separated : \"\\e713\";\r\n$layout-accordion-merged : \"\\e714\";\r\n$layout-accordion-list : \"\\e715\";\r\n$ink-pen : \"\\e716\";\r\n$info-alt : \"\\e717\";\r\n$help-alt : \"\\e718\";\r\n$headphone-alt : \"\\e719\";\r\n$hand-point-up : \"\\e71a\";\r\n$hand-point-right : \"\\e71b\";\r\n$hand-point-left : \"\\e71c\";\r\n$hand-point-down : \"\\e71d\";\r\n$gallery : \"\\e71e\";\r\n$face-smile : \"\\e71f\";\r\n$face-sad : \"\\e720\";\r\n$credit-card : \"\\e721\";\r\n$control-skip-forward : \"\\e722\";\r\n$control-skip-backward : \"\\e723\";\r\n$control-record : \"\\e724\";\r\n$control-eject : \"\\e725\";\r\n$comments-smiley : \"\\e726\";\r\n$brush-alt : \"\\e727\";\r\n$youtube : \"\\e728\";\r\n$vimeo : \"\\e729\";\r\n$twitter : \"\\e72a\";\r\n$time : \"\\e72b\";\r\n$tumblr : \"\\e72c\";\r\n$skype : \"\\e72d\";\r\n$share : \"\\e72e\";\r\n$share-alt : \"\\e72f\";\r\n$rocket : \"\\e730\";\r\n$pinterest : \"\\e731\";\r\n$new-window : \"\\e732\";\r\n$microsoft : \"\\e733\";\r\n$list-ol : \"\\e734\";\r\n$linkedin : \"\\e735\";\r\n$layout-sidebar-2 : \"\\e736\";\r\n$layout-grid4-alt : \"\\e737\";\r\n$layout-grid3-alt : \"\\e738\";\r\n$layout-grid2-alt : \"\\e739\";\r\n$layout-column4-alt : \"\\e73a\";\r\n$layout-column3-alt : \"\\e73b\";\r\n$layout-column2-alt : \"\\e73c\";\r\n$instagram : \"\\e73d\";\r\n$google : \"\\e73e\";\r\n$github : \"\\e73f\";\r\n$flickr : \"\\e740\";\r\n$facebook : \"\\e741\";\r\n$dropbox : \"\\e742\";\r\n$dribbble : \"\\e743\";\r\n$apple : \"\\e744\";\r\n$android : \"\\e745\";\r\n$save : \"\\e746\";\r\n$save-alt : \"\\e747\";\r\n$yahoo : \"\\e748\";\r\n$wordpress : \"\\e749\";\r\n$vimeo-alt : \"\\e74a\";\r\n$twitter-alt : \"\\e74b\";\r\n$tumblr-alt : \"\\e74c\";\r\n$trello : \"\\e74d\";\r\n$stack-overflow : \"\\e74e\";\r\n$soundcloud : \"\\e74f\";\r\n$sharethis : \"\\e750\";\r\n$sharethis-alt : \"\\e751\";\r\n$reddit : \"\\e752\";\r\n$pinterest-alt : \"\\e753\";\r\n$microsoft-alt : \"\\e754\";\r\n$linux : \"\\e755\";\r\n$jsfiddle : \"\\e756\";\r\n$joomla : \"\\e757\";\r\n$html5 : \"\\e758\";\r\n$flickr-alt : \"\\e759\";\r\n$email : \"\\e75a\";\r\n$drupal : \"\\e75b\";\r\n$dropbox-alt : \"\\e75c\";\r\n$css3 : \"\\e75d\";\r\n$rss : \"\\e75e\";\r\n$rss-alt: \"\\e75f\";\r\n","/* EXTRAS\r\n * -------------------------- */\r\n\r\n/* Stacked and layered icon */\r\n@include icon-stack();\r\n\r\n/* Animated rotating icon */\r\n.icon-spin {\r\n  display: inline-block;\r\n  -moz-animation: spin 2s infinite linear;\r\n  -o-animation: spin 2s infinite linear;\r\n  -webkit-animation: spin 2s infinite linear;\r\n  animation: spin 2s infinite linear;\r\n}\r\n\r\n/* Prevent stack and spinners from being taken inline when inside a link */\r\na .icon-stack,\r\na .icon-spin {\r\n  display: inline-block;\r\n  text-decoration: none;\r\n}\r\n\r\n@-moz-keyframes spin {\r\n  0% { -moz-transform: rotate(0deg); }\r\n  100% { -moz-transform: rotate(359deg); }\r\n}\r\n@-webkit-keyframes spin {\r\n  0% { -webkit-transform: rotate(0deg); }\r\n  100% { -webkit-transform: rotate(359deg); }\r\n}\r\n@-o-keyframes spin {\r\n  0% { -o-transform: rotate(0deg); }\r\n  100% { -o-transform: rotate(359deg); }\r\n}\r\n@-ms-keyframes spin {\r\n  0% { -ms-transform: rotate(0deg); }\r\n  100% { -ms-transform: rotate(359deg); }\r\n}\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(359deg); }\r\n}\r\n\r\n@mixin spinicon(){\r\n  @include icon-FontAwesome();\r\n  \r\n  display: inline-block;\r\n  -moz-animation: spin 2s infinite linear;\r\n  -o-animation: spin 2s infinite linear;\r\n  -webkit-animation: spin 2s infinite linear;\r\n  animation: spin 2s infinite linear;\r\n\r\n  content: $spinner;\r\n}\r\n\r\n/* Icon rotations and mirroring */\r\n.icon-rotate-90:before {\r\n  -webkit-transform: rotate(90deg);\r\n  -moz-transform: rotate(90deg);\r\n  -ms-transform: rotate(90deg);\r\n  -o-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\r\n}\r\n\r\n.icon-rotate-180:before {\r\n  -webkit-transform: rotate(180deg);\r\n  -moz-transform: rotate(180deg);\r\n  -ms-transform: rotate(180deg);\r\n  -o-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n}\r\n\r\n.icon-rotate-270:before {\r\n  -webkit-transform: rotate(270deg);\r\n  -moz-transform: rotate(270deg);\r\n  -ms-transform: rotate(270deg);\r\n  -o-transform: rotate(270deg);\r\n  transform: rotate(270deg);\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\r\n}\r\n\r\n.icon-flip-horizontal:before {\r\n  -webkit-transform: scale(-1, 1);\r\n  -moz-transform: scale(-1, 1);\r\n  -ms-transform: scale(-1, 1);\r\n  -o-transform: scale(-1, 1);\r\n  transform: scale(-1, 1);\r\n}\r\n\r\n.icon-flip-vertical:before {\r\n  -webkit-transform: scale(1, -1);\r\n  -moz-transform: scale(1, -1);\r\n  -ms-transform: scale(1, -1);\r\n  -o-transform: scale(1, -1);\r\n  transform: scale(1, -1);\r\n}\r\n\r\n/* ensure rotation occurs inside anchor tags */\r\na {\r\n  .icon-rotate-90, .icon-rotate-180, .icon-rotate-270, .icon-flip-horizontal, .icon-flip-vertical {\r\n    &:before { display: inline-block; }\r\n  }\r\n}\r\n",".icon-wand:before {content: \"\\e600\";}\r\n.icon-volume:before {content: \"\\e601\";}\r\n.icon-user:before {content: \"\\e602\";}\r\n.icon-unlock:before {content: \"\\e603\";}\r\n.icon-unlink:before {content: \"\\e604\";}\r\n.icon-trash:before {content: \"\\e605\";}\r\n.icon-thought:before {content: \"\\e606\";}\r\n.icon-target:before {content: \"\\e607\";}\r\n.icon-tag:before {content: \"\\e608\";}\r\n.icon-tablet:before {content: \"\\e609\";}\r\n.icon-star:before {content: \"\\e60a\";}\r\n.icon-spray:before {content: \"\\e60b\";}\r\n.icon-signal:before {content: \"\\e60c\";}\r\n.icon-shopping-cart:before {content: \"\\e60d\";}\r\n.icon-shopping-cart-full:before {content: \"\\e60e\";}\r\n.icon-settings:before {content: \"\\e60f\";}\r\n.ti-search:before {content: \"\\e610\";}\r\n.icon-zoom-in:before {content: \"\\e611\";}\r\n.icon-zoom-out:before {content: \"\\e612\";}\r\n.icon-cut:before {content: \"\\e613\";}\r\n.icon-ruler:before {content: \"\\e614\";}\r\n.icon-ruler-pencil:before {content: \"\\e615\";}\r\n.icon-ruler-alt:before {content: \"\\e616\";}\r\n.icon-bookmark:before {content: \"\\e617\";}\r\n.icon-bookmark-alt:before {content: \"\\e618\";}\r\n.icon-reload:before {content: \"\\e619\";}\r\n.icon-plus:before {content: \"\\e61a\";}\r\n.icon-pin:before {content: \"\\e61b\";}\r\n.icon-pencil:before {content: \"\\e61c\";}\r\n.icon-pencil-alt:before {content: \"\\e61d\";}\r\n.icon-paint-roller:before {content: \"\\e61e\";}\r\n.icon-paint-bucket:before {content: \"\\e61f\";}\r\n.icon-na:before {content: \"\\e620\";}\r\n.icon-mobile:before {content: \"\\e621\";}\r\n.icon-minus:before {content: \"\\e622\";}\r\n.icon-medall:before {content: \"\\e623\";}\r\n.icon-medall-alt:before {content: \"\\e624\";}\r\n.icon-marker:before {content: \"\\e625\";}\r\n.icon-marker-alt:before {content: \"\\e626\";}\r\n.icon-arrow-up:before {content: \"\\e627\";}\r\n.icon-arrow-right:before {content: \"\\e628\";}\r\n.icon-arrow-left:before {content: \"\\e629\";}\r\n.icon-arrow-down:before {content: \"\\e62a\";}\r\n.icon-lock:before {content: \"\\e62b\";}\r\n.icon-location-arrow:before {content: \"\\e62c\";}\r\n.icon-link:before {content: \"\\e62d\";}\r\n.icon-layout:before {content: \"\\e62e\";}\r\n.icon-layers:before {content: \"\\e62f\";}\r\n.icon-layers-alt:before {content: \"\\e630\";}\r\n.icon-key:before {content: \"\\e631\";}\r\n.icon-import:before {content: \"\\e632\";}\r\n.icon-image:before {content: \"\\e633\";}\r\n.icon-heart:before {content: \"\\e634\";}\r\n.icon-heart-broken:before {content: \"\\e635\";}\r\n.icon-hand-stop:before {content: \"\\e636\";}\r\n.icon-hand-open:before {content: \"\\e637\";}\r\n.icon-hand-drag:before {content: \"\\e638\";}\r\n.icon-folder:before {content: \"\\e639\";}\r\n.icon-flag:before {content: \"\\e63a\";}\r\n.icon-flag-alt:before {content: \"\\e63b\";}\r\n.icon-flag-alt-2:before {content: \"\\e63c\";}\r\n.icon-eye:before {content: \"\\e63d\";}\r\n.icon-export:before {content: \"\\e63e\";}\r\n.icon-exchange-vertical:before {content: \"\\e63f\";}\r\n.icon-desktop:before {content: \"\\e640\";}\r\n.icon-cup:before {content: \"\\e641\";}\r\n.icon-crown:before {content: \"\\e642\";}\r\n.icon-comments:before {content: \"\\e643\";}\r\n.icon-comment:before {content: \"\\e644\";}\r\n.icon-comment-alt:before {content: \"\\e645\";}\r\n.icon-close:before {content: \"\\e646\";}\r\n.icon-clip:before {content: \"\\e647\";}\r\n.icon-angle-up:before {content: \"\\e648\";}\r\n.icon-angle-right:before {content: \"\\e649\";}\r\n.icon-angle-left:before {content: \"\\e64a\";}\r\n.icon-angle-down:before {content: \"\\e64b\";}\r\n.icon-check:before {content: \"\\e64c\";}\r\n.icon-check-box:before {content: \"\\e64d\";}\r\n.icon-camera:before {content: \"\\e64e\";}\r\n.icon-announcement:before {content: \"\\e64f\";}\r\n.icon-brush:before {content: \"\\e650\";}\r\n.icon-briefcase:before {content: \"\\e651\";}\r\n.icon-bolt:before {content: \"\\e652\";}\r\n.icon-bolt-alt:before {content: \"\\e653\";}\r\n.icon-blackboard:before {content: \"\\e654\";}\r\n.icon-bag:before {content: \"\\e655\";}\r\n.icon-move:before {content: \"\\e656\";}\r\n.icon-arrows-vertical:before {content: \"\\e657\";}\r\n.icon-arrows-horizontal:before {content: \"\\e658\";}\r\n.icon-fullscreen:before {content: \"\\e659\";}\r\n.icon-arrow-top-right:before {content: \"\\e65a\";}\r\n.icon-arrow-top-left:before {content: \"\\e65b\";}\r\n.icon-arrow-circle-up:before {content: \"\\e65c\";}\r\n.icon-arrow-circle-right:before {content: \"\\e65d\";}\r\n.icon-arrow-circle-left:before {content: \"\\e65e\";}\r\n.icon-arrow-circle-down:before {content: \"\\e65f\";}\r\n.icon-angle-double-up:before {content: \"\\e660\";}\r\n.icon-angle-double-right:before {content: \"\\e661\";}\r\n.icon-angle-double-left:before {content: \"\\e662\";}\r\n.icon-angle-double-down:before {content: \"\\e663\";}\r\n.icon-zip:before {content: \"\\e664\";}\r\n.icon-world:before {content: \"\\e665\";}\r\n.icon-wheelchair:before {content: \"\\e666\";}\r\n.icon-view-list:before {content: \"\\e667\";}\r\n.icon-view-list-alt:before {content: \"\\e668\";}\r\n.icon-view-grid:before {content: \"\\e669\";}\r\n.icon-uppercase:before {content: \"\\e66a\";}\r\n.icon-upload:before {content: \"\\e66b\";}\r\n.icon-underline:before {content: \"\\e66c\";}\r\n.icon-truck:before {content: \"\\e66d\";}\r\n.icon-timer:before {content: \"\\e66e\";}\r\n.icon-ticket:before {content: \"\\e66f\";}\r\n.icon-thumb-up:before {content: \"\\e670\";}\r\n.icon-thumb-down:before {content: \"\\e671\";}\r\n.icon-text:before {content: \"\\e672\";}\r\n.icon-stats-up:before {content: \"\\e673\";}\r\n.icon-stats-down:before {content: \"\\e674\";}\r\n.icon-split-v:before {content: \"\\e675\";}\r\n.icon-split-h:before {content: \"\\e676\";}\r\n.icon-smallcap:before {content: \"\\e677\";}\r\n.icon-shine:before {content: \"\\e678\";}\r\n.icon-shift-right:before {content: \"\\e679\";}\r\n.icon-shift-left:before {content: \"\\e67a\";}\r\n.icon-shield:before {content: \"\\e67b\";}\r\n.icon-notepad:before {content: \"\\e67c\";}\r\n.icon-server:before {content: \"\\e67d\";}\r\n.icon-quote-right:before {content: \"\\e67e\";}\r\n.icon-quote-left:before {content: \"\\e67f\";}\r\n.icon-pulse:before {content: \"\\e680\";}\r\n.icon-printer:before {content: \"\\e681\";}\r\n.icon-power-off:before {content: \"\\e682\";}\r\n.icon-plug:before {content: \"\\e683\";}\r\n.icon-pie-chart:before {content: \"\\e684\";}\r\n.icon-paragraph:before {content: \"\\e685\";}\r\n.icon-panel:before {content: \"\\e686\";}\r\n.icon-package:before {content: \"\\e687\";}\r\n.icon-music:before {content: \"\\e688\";}\r\n.icon-music-alt:before {content: \"\\e689\";}\r\n.icon-mouse:before {content: \"\\e68a\";}\r\n.icon-mouse-alt:before {content: \"\\e68b\";}\r\n.icon-money:before {content: \"\\e68c\";}\r\n.icon-microphone:before {content: \"\\e68d\";}\r\n.icon-menu:before {content: \"\\e68e\";}\r\n.icon-menu-alt:before {content: \"\\e68f\";}\r\n.icon-map:before {content: \"\\e690\";}\r\n.icon-map-alt:before {content: \"\\e691\";}\r\n.icon-loop:before {content: \"\\e692\";}\r\n.icon-location-pin:before {content: \"\\e693\";}\r\n.icon-list:before {content: \"\\e694\";}\r\n.icon-light-bulb:before {content: \"\\e695\";}\r\n.icon-Italic:before {content: \"\\e696\";}\r\n.icon-info:before {content: \"\\e697\";}\r\n.icon-infinite:before {content: \"\\e698\";}\r\n.icon-id-badge:before {content: \"\\e699\";}\r\n.icon-hummer:before {content: \"\\e69a\";}\r\n.icon-home:before {content: \"\\e69b\";}\r\n.icon-help:before {content: \"\\e69c\";}\r\n.icon-headphone:before {content: \"\\e69d\";}\r\n.icon-harddrives:before {content: \"\\e69e\";}\r\n.icon-harddrive:before {content: \"\\e69f\";}\r\n.icon-gift:before {content: \"\\e6a0\";}\r\n.icon-game:before {content: \"\\e6a1\";}\r\n.icon-filter:before {content: \"\\e6a2\";}\r\n.icon-files:before {content: \"\\e6a3\";}\r\n.icon-file:before {content: \"\\e6a4\";}\r\n.icon-eraser:before {content: \"\\e6a5\";}\r\n.icon-envelope:before {content: \"\\e6a6\";}\r\n.icon-download:before {content: \"\\e6a7\";}\r\n.icon-direction:before {content: \"\\e6a8\";}\r\n.icon-direction-alt:before {content: \"\\e6a9\";}\r\n.icon-dashboard:before {content: \"\\e6aa\";}\r\n.icon-control-stop:before {content: \"\\e6ab\";}\r\n.icon-control-shuffle:before {content: \"\\e6ac\";}\r\n.icon-control-play:before {content: \"\\e6ad\";}\r\n.icon-control-pause:before {content: \"\\e6ae\";}\r\n.icon-control-forward:before {content: \"\\e6af\";}\r\n.icon-control-backward:before {content: \"\\e6b0\";}\r\n.icon-cloud:before {content: \"\\e6b1\";}\r\n.icon-cloud-up:before {content: \"\\e6b2\";}\r\n.icon-cloud-down:before {content: \"\\e6b3\";}\r\n.icon-clipboard:before {content: \"\\e6b4\";}\r\n.icon-car:before {content: \"\\e6b5\";}\r\n.icon-calendar:before {content: \"\\e6b6\";}\r\n.icon-book:before {content: \"\\e6b7\";}\r\n.icon-bell:before {content: \"\\e6b8\";}\r\n.icon-basketball:before {content: \"\\e6b9\";}\r\n.icon-bar-chart:before {content: \"\\e6ba\";}\r\n.icon-bar-chart-alt:before {content: \"\\e6bb\";}\r\n.icon-back-right:before {content: \"\\e6bc\";}\r\n.icon-back-left:before {content: \"\\e6bd\";}\r\n.icon-arrows-corner:before {content: \"\\e6be\";}\r\n.icon-archive:before {content: \"\\e6bf\";}\r\n.icon-anchor:before {content: \"\\e6c0\";}\r\n.icon-align-right:before {content: \"\\e6c1\";}\r\n.icon-align-left:before {content: \"\\e6c2\";}\r\n.icon-align-justify:before {content: \"\\e6c3\";}\r\n.icon-align-center:before {content: \"\\e6c4\";}\r\n.icon-alert:before {content: \"\\e6c5\";}\r\n.icon-alarm-clock:before {content: \"\\e6c6\";}\r\n.icon-agenda:before {content: \"\\e6c7\";}\r\n.icon-write:before {content: \"\\e6c8\";}\r\n.icon-window:before {content: \"\\e6c9\";}\r\n.icon-widgetized:before {content: \"\\e6ca\";}\r\n.icon-widget:before {content: \"\\e6cb\";}\r\n.icon-widget-alt:before {content: \"\\e6cc\";}\r\n.icon-wallet:before {content: \"\\e6cd\";}\r\n.icon-video-clapper:before {content: \"\\e6ce\";}\r\n.icon-video-camera:before {content: \"\\e6cf\";}\r\n.icon-vector:before {content: \"\\e6d0\";}\r\n.icon-themify-logo:before {content: \"\\e6d1\";}\r\n.icon-themify-favicon:before {content: \"\\e6d2\";}\r\n.icon-themify-favicon-alt:before {content: \"\\e6d3\";}\r\n.icon-support:before {content: \"\\e6d4\";}\r\n.icon-stamp:before {content: \"\\e6d5\";}\r\n.icon-split-v-alt:before {content: \"\\e6d6\";}\r\n.icon-slice:before {content: \"\\e6d7\";}\r\n.icon-shortcode:before {content: \"\\e6d8\";}\r\n.icon-shift-right-alt:before {content: \"\\e6d9\";}\r\n.icon-shift-left-alt:before {content: \"\\e6da\";}\r\n.icon-ruler-alt-2:before {content: \"\\e6db\";}\r\n.icon-receipt:before {content: \"\\e6dc\";}\r\n.icon-pin2:before {content: \"\\e6dd\";}\r\n.icon-pin-alt:before {content: \"\\e6de\";}\r\n.icon-pencil-alt2:before {content: \"\\e6df\";}\r\n.icon-palette:before {content: \"\\e6e0\";}\r\n.icon-more:before {content: \"\\e6e1\";}\r\n.icon-more-alt:before {content: \"\\e6e2\";}\r\n.icon-microphone-alt:before {content: \"\\e6e3\";}\r\n.icon-magnet:before {content: \"\\e6e4\";}\r\n.icon-line-double:before {content: \"\\e6e5\";}\r\n.icon-line-dotted:before {content: \"\\e6e6\";}\r\n.icon-line-dashed:before {content: \"\\e6e7\";}\r\n.icon-layout-width-full:before {content: \"\\e6e8\";}\r\n.icon-layout-width-default:before {content: \"\\e6e9\";}\r\n.icon-layout-width-default-alt:before {content: \"\\e6ea\";}\r\n.icon-layout-tab:before {content: \"\\e6eb\";}\r\n.icon-layout-tab-window:before {content: \"\\e6ec\";}\r\n.icon-layout-tab-v:before {content: \"\\e6ed\";}\r\n.icon-layout-tab-min:before {content: \"\\e6ee\";}\r\n.icon-layout-slider:before {content: \"\\e6ef\";}\r\n.icon-layout-slider-alt:before {content: \"\\e6f0\";}\r\n.icon-layout-sidebar-right:before {content: \"\\e6f1\";}\r\n.icon-layout-sidebar-none:before {content: \"\\e6f2\";}\r\n.icon-layout-sidebar-left:before {content: \"\\e6f3\";}\r\n.icon-layout-placeholder:before {content: \"\\e6f4\";}\r\n.icon-layout-menu:before {content: \"\\e6f5\";}\r\n.icon-layout-menu-v:before {content: \"\\e6f6\";}\r\n.icon-layout-menu-separated:before {content: \"\\e6f7\";}\r\n.icon-layout-menu-full:before {content: \"\\e6f8\";}\r\n.icon-layout-media-right-alt:before {content: \"\\e6f9\";}\r\n.icon-layout-media-right:before {content: \"\\e6fa\";}\r\n.icon-layout-media-overlay:before {content: \"\\e6fb\";}\r\n.icon-layout-media-overlay-alt:before {content: \"\\e6fc\";}\r\n.icon-layout-media-overlay-alt-2:before {content: \"\\e6fd\";}\r\n.icon-layout-media-left-alt:before {content: \"\\e6fe\";}\r\n.icon-layout-media-left:before {content: \"\\e6ff\";}\r\n.icon-layout-media-center-alt:before {content: \"\\e700\";}\r\n.icon-layout-media-center:before {content: \"\\e701\";}\r\n.icon-layout-list-thumb:before {content: \"\\e702\";}\r\n.icon-layout-list-thumb-alt:before {content: \"\\e703\";}\r\n.icon-layout-list-post:before {content: \"\\e704\";}\r\n.icon-layout-list-large-image:before {content: \"\\e705\";}\r\n.icon-layout-line-solid:before {content: \"\\e706\";}\r\n.icon-layout-grid4:before {content: \"\\e707\";}\r\n.icon-layout-grid3:before {content: \"\\e708\";}\r\n.icon-layout-grid2:before {content: \"\\e709\";}\r\n.icon-layout-grid2-thumb:before {content: \"\\e70a\";}\r\n.icon-layout-cta-right:before {content: \"\\e70b\";}\r\n.icon-layout-cta-left:before {content: \"\\e70c\";}\r\n.icon-layout-cta-center:before {content: \"\\e70d\";}\r\n.icon-layout-cta-btn-right:before {content: \"\\e70e\";}\r\n.icon-layout-cta-btn-left:before {content: \"\\e70f\";}\r\n.icon-layout-column4:before {content: \"\\e710\";}\r\n.icon-layout-column3:before {content: \"\\e711\";}\r\n.icon-layout-column2:before {content: \"\\e712\";}\r\n.icon-layout-accordion-separated:before {content: \"\\e713\";}\r\n.icon-layout-accordion-merged:before {content: \"\\e714\";}\r\n.icon-layout-accordion-list:before {content: \"\\e715\";}\r\n.icon-ink-pen:before {content: \"\\e716\";}\r\n.icon-info-alt:before {content: \"\\e717\";}\r\n.icon-help-alt:before {content: \"\\e718\";}\r\n.icon-headphone-alt:before {content: \"\\e719\";}\r\n.icon-hand-point-up:before {content: \"\\e71a\";}\r\n.icon-hand-point-right:before {content: \"\\e71b\";}\r\n.icon-hand-point-left:before {content: \"\\e71c\";}\r\n.icon-hand-point-down:before {content: \"\\e71d\";}\r\n.icon-gallery:before {content: \"\\e71e\";}\r\n.icon-face-smile:before {content: \"\\e71f\";}\r\n.icon-face-sad:before {content: \"\\e720\";}\r\n.icon-credit-card:before {content: \"\\e721\";}\r\n.icon-control-skip-forward:before {content: \"\\e722\";}\r\n.icon-control-skip-backward:before {content: \"\\e723\";}\r\n.icon-control-record:before {content: \"\\e724\";}\r\n.icon-control-eject:before {content: \"\\e725\";}\r\n.icon-comments-smiley:before {content: \"\\e726\";}\r\n.icon-brush-alt:before {content: \"\\e727\";}\r\n.icon-youtube:before {content: \"\\e728\";}\r\n.icon-vimeo:before {content: \"\\e729\";}\r\n.icon-twitter:before {content: \"\\e72a\";}\r\n.icon-time:before {content: \"\\e72b\";}\r\n.icon-tumblr:before {content: \"\\e72c\";}\r\n.icon-skype:before {content: \"\\e72d\";}\r\n.icon-share:before {content: \"\\e72e\";}\r\n.icon-share-alt:before {content: \"\\e72f\";}\r\n.icon-rocket:before {content: \"\\e730\";}\r\n.icon-pinterest:before {content: \"\\e731\";}\r\n.icon-new-window:before {content: \"\\e732\";}\r\n.icon-microsoft:before {content: \"\\e733\";}\r\n.icon-list-ol:before {content: \"\\e734\";}\r\n.icon-linkedin:before {content: \"\\e735\";}\r\n.icon-layout-sidebar-2:before {content: \"\\e736\";}\r\n.icon-layout-grid4-alt:before {content: \"\\e737\";}\r\n.icon-layout-grid3-alt:before {content: \"\\e738\";}\r\n.icon-layout-grid2-alt:before {content: \"\\e739\";}\r\n.icon-layout-column4-alt:before {content: \"\\e73a\";}\r\n.icon-layout-column3-alt:before {content: \"\\e73b\";}\r\n.icon-layout-column2-alt:before {content: \"\\e73c\";}\r\n.icon-instagram:before {content: \"\\e73d\";}\r\n.icon-google:before {content: \"\\e73e\";}\r\n.icon-github:before {content: \"\\e73f\";}\r\n.icon-flickr:before {content: \"\\e740\";}\r\n.icon-facebook:before {content: \"\\e741\";}\r\n.icon-dropbox:before {content: \"\\e742\";}\r\n.icon-dribbble:before {content: \"\\e743\";}\r\n.icon-apple:before {content: \"\\e744\";}\r\n.icon-android:before {content: \"\\e745\";}\r\n.icon-save:before {content: \"\\e746\";}\r\n.icon-save-alt:before {content: \"\\e747\";}\r\n.icon-yahoo:before {content: \"\\e748\";}\r\n.icon-wordpress:before {content: \"\\e749\";}\r\n.icon-vimeo-alt:before {content: \"\\e74a\";}\r\n.icon-twitter-alt:before {content: \"\\e74b\";}\r\n.icon-tumblr-alt:before {content: \"\\e74c\";}\r\n.icon-trello:before {content: \"\\e74d\";}\r\n.icon-stack-overflow:before {content: \"\\e74e\";}\r\n.icon-soundcloud:before {content: \"\\e74f\";}\r\n.icon-sharethis:before {content: \"\\e750\";}\r\n.icon-sharethis-alt:before {content: \"\\e751\";}\r\n.icon-reddit:before {content: \"\\e752\";}\r\n.icon-pinterest-alt:before {content: \"\\e753\";}\r\n.icon-microsoft-alt:before {content: \"\\e754\";}\r\n.icon-linux:before {content: \"\\e755\";}\r\n.icon-jsfiddle:before {content: \"\\e756\";}\r\n.icon-joomla:before {content: \"\\e757\";}\r\n.icon-html5:before {content: \"\\e758\";}\r\n.icon-flickr-alt:before {content: \"\\e759\";}\r\n.icon-email:before {content: \"\\e75a\";}\r\n.icon-drupal:before {content: \"\\e75b\";}\r\n.icon-dropbox-alt:before {content: \"\\e75c\";}\r\n.icon-css3:before {content: \"\\e75d\";}\r\n.icon-rss:before {content: \"\\e75e\";}\r\n.icon-rss-alt:before {content: \"\\e75f\";}\r\n","/**\r\n * @package IcoFont by ThemeHunt - https://themehunt.com\r\n * @version 1.0.0 Beta\r\n * @author IcoFont http://icofont.com\r\n * @copyright Copyright (c) 2018 IcoFont\r\n * @license - http://icofont.com/license/\r\n*/\r\n\r\n@font-face {\r\n\tfont-family: 'icofont';\r\n\tsrc: url('../../fonts/ico/icofont.eot?v=1.0.0-beta');\r\n\tsrc: url('../../fonts/ico/icofont.eot?v=1.0.0-beta#iefix') format(\"embedded-opentype\"), url('../../fonts/ico/icofont.ttf?v=1.0.0-beta') format(\"truetype\"), url('../../fonts/ico/icofont.woff?v=1.0.0-beta') format(\"woff\"), url('../../fonts/ico/icofont.svg?v=1.0.0-beta#icofont') format(\"svg\");\r\n\tfont-weight: normal;\r\n\tfont-style: normal;\r\n}\r\n\r\n\r\n.icofont {\r\n\tfont-family: 'IcoFont' !important;\r\n\tspeak: none;\r\n\tfont-style: normal;\r\n\tfont-weight: normal;\r\n\tfont-variant: normal;\r\n\ttext-transform: none;\r\n\tline-height: 1;\r\n\t/* Better Font Rendering =========== */\r\n\t-webkit-font-smoothing: antialiased;\r\n\t-moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.icofont-angry-monster:before {\r\n\tcontent: \"\\e901\";\r\n}\r\n\r\n.icofont-bathtub:before {\r\n\tcontent: \"\\e902\";\r\n}\r\n\r\n.icofont-bird-wings:before {\r\n\tcontent: \"\\e903\";\r\n}\r\n\r\n.icofont-bow:before {\r\n\tcontent: \"\\e904\";\r\n}\r\n\r\n.icofont-brain-alt:before {\r\n\tcontent: \"\\e905\";\r\n}\r\n\r\n.icofont-butterfly-alt:before {\r\n\tcontent: \"\\e906\";\r\n}\r\n\r\n.icofont-castle:before {\r\n\tcontent: \"\\e907\";\r\n}\r\n\r\n.icofont-circuit:before {\r\n\tcontent: \"\\e908\";\r\n}\r\n\r\n.icofont-dart:before {\r\n\tcontent: \"\\e909\";\r\n}\r\n\r\n.icofont-dice-alt:before {\r\n\tcontent: \"\\e90a\";\r\n}\r\n\r\n.icofont-disability-race:before {\r\n\tcontent: \"\\e90b\";\r\n}\r\n\r\n.icofont-diving-goggle:before {\r\n\tcontent: \"\\e90c\";\r\n}\r\n\r\n.icofont-fire-alt:before {\r\n\tcontent: \"\\e90d\";\r\n}\r\n\r\n.icofont-flame-torch:before {\r\n\tcontent: \"\\e90e\";\r\n}\r\n\r\n.icofont-flora-flower:before {\r\n\tcontent: \"\\e90f\";\r\n}\r\n\r\n.icofont-flora:before {\r\n\tcontent: \"\\e910\";\r\n}\r\n\r\n.icofont-gift-box:before {\r\n\tcontent: \"\\e911\";\r\n}\r\n\r\n.icofont-halloween-pumpkin:before {\r\n\tcontent: \"\\e912\";\r\n}\r\n\r\n.icofont-hand-power:before {\r\n\tcontent: \"\\e913\";\r\n}\r\n\r\n.icofont-hand-thunder:before {\r\n\tcontent: \"\\e914\";\r\n}\r\n\r\n.icofont-king-crown:before {\r\n\tcontent: \"\\e915\";\r\n}\r\n\r\n.icofont-king-monster:before {\r\n\tcontent: \"\\e916\";\r\n}\r\n\r\n.icofont-love:before {\r\n\tcontent: \"\\e917\";\r\n}\r\n\r\n.icofont-magician-hat:before {\r\n\tcontent: \"\\e918\";\r\n}\r\n\r\n.icofont-native-american:before {\r\n\tcontent: \"\\e919\";\r\n}\r\n\r\n.icofont-open-eye:before {\r\n\tcontent: \"\\e91a\";\r\n}\r\n\r\n.icofont-owl-look:before {\r\n\tcontent: \"\\e91b\";\r\n}\r\n\r\n.icofont-phoenix:before {\r\n\tcontent: \"\\e91c\";\r\n}\r\n\r\n.icofont-queen-crown:before {\r\n\tcontent: \"\\e91d\";\r\n}\r\n\r\n.icofont-robot-face:before {\r\n\tcontent: \"\\e91e\";\r\n}\r\n\r\n.icofont-sand-clock:before {\r\n\tcontent: \"\\e91f\";\r\n}\r\n\r\n.icofont-shield-alt:before {\r\n\tcontent: \"\\e920\";\r\n}\r\n\r\n.icofont-ship-wheel:before {\r\n\tcontent: \"\\e921\";\r\n}\r\n\r\n.icofont-skull-danger:before {\r\n\tcontent: \"\\e922\";\r\n}\r\n\r\n.icofont-skull-face:before {\r\n\tcontent: \"\\e923\";\r\n}\r\n\r\n.icofont-snail:before {\r\n\tcontent: \"\\e924\";\r\n}\r\n\r\n.icofont-snow-alt:before {\r\n\tcontent: \"\\e925\";\r\n}\r\n\r\n.icofont-snow-flake:before {\r\n\tcontent: \"\\e926\";\r\n}\r\n\r\n.icofont-snowmobile:before {\r\n\tcontent: \"\\e927\";\r\n}\r\n\r\n.icofont-space-shuttle:before {\r\n\tcontent: \"\\e928\";\r\n}\r\n\r\n.icofont-star-shape:before {\r\n\tcontent: \"\\e929\";\r\n}\r\n\r\n.icofont-swirl:before {\r\n\tcontent: \"\\e92a\";\r\n}\r\n\r\n.icofont-tattoo-wing:before {\r\n\tcontent: \"\\e92b\";\r\n}\r\n\r\n.icofont-throne:before {\r\n\tcontent: \"\\e92c\";\r\n}\r\n\r\n.icofont-touch:before {\r\n\tcontent: \"\\e92d\";\r\n}\r\n\r\n.icofont-tree-alt:before {\r\n\tcontent: \"\\e92e\";\r\n}\r\n\r\n.icofont-triangle:before {\r\n\tcontent: \"\\e92f\";\r\n}\r\n\r\n.icofont-unity-hand:before {\r\n\tcontent: \"\\e930\";\r\n}\r\n\r\n.icofont-weed:before {\r\n\tcontent: \"\\e931\";\r\n}\r\n\r\n.icofont-woman-bird:before {\r\n\tcontent: \"\\e932\";\r\n}\r\n\r\n.icofont-animal-bat:before {\r\n\tcontent: \"\\e933\";\r\n}\r\n\r\n.icofont-animal-bear-tracks:before {\r\n\tcontent: \"\\e934\";\r\n}\r\n\r\n.icofont-animal-bear:before {\r\n\tcontent: \"\\e935\";\r\n}\r\n\r\n.icofont-animal-bird-alt:before {\r\n\tcontent: \"\\e936\";\r\n}\r\n\r\n.icofont-animal-bird:before {\r\n\tcontent: \"\\e937\";\r\n}\r\n\r\n.icofont-animal-bone:before {\r\n\tcontent: \"\\e938\";\r\n}\r\n\r\n.icofont-animal-bull:before {\r\n\tcontent: \"\\e939\";\r\n}\r\n\r\n.icofont-animal-camel-alt:before {\r\n\tcontent: \"\\e93a\";\r\n}\r\n\r\n.icofont-animal-camel-head:before {\r\n\tcontent: \"\\e93b\";\r\n}\r\n\r\n.icofont-animal-camel:before {\r\n\tcontent: \"\\e93c\";\r\n}\r\n\r\n.icofont-animal-cat-alt-1:before {\r\n\tcontent: \"\\e93d\";\r\n}\r\n\r\n.icofont-animal-cat-alt-2:before {\r\n\tcontent: \"\\e93e\";\r\n}\r\n\r\n.icofont-animal-cat-alt-3:before {\r\n\tcontent: \"\\e93f\";\r\n}\r\n\r\n.icofont-animal-cat-alt-4:before {\r\n\tcontent: \"\\e940\";\r\n}\r\n\r\n.icofont-animal-cat-with-dog:before {\r\n\tcontent: \"\\e941\";\r\n}\r\n\r\n.icofont-animal-cat:before {\r\n\tcontent: \"\\e942\";\r\n}\r\n\r\n.icofont-animal-cow-head:before {\r\n\tcontent: \"\\e943\";\r\n}\r\n\r\n.icofont-animal-cow:before {\r\n\tcontent: \"\\e944\";\r\n}\r\n\r\n.icofont-animal-crab:before {\r\n\tcontent: \"\\e945\";\r\n}\r\n\r\n.icofont-animal-crocodile:before {\r\n\tcontent: \"\\e946\";\r\n}\r\n\r\n.icofont-animal-deer-head:before {\r\n\tcontent: \"\\e947\";\r\n}\r\n\r\n.icofont-animal-dog-alt:before {\r\n\tcontent: \"\\e948\";\r\n}\r\n\r\n.icofont-animal-dog-barking:before {\r\n\tcontent: \"\\e949\";\r\n}\r\n\r\n.icofont-animal-dog:before {\r\n\tcontent: \"\\e94a\";\r\n}\r\n\r\n.icofont-animal-dolphin:before {\r\n\tcontent: \"\\e94b\";\r\n}\r\n\r\n.icofont-animal-duck-tracks:before {\r\n\tcontent: \"\\e94c\";\r\n}\r\n\r\n.icofont-animal-eagle-head:before {\r\n\tcontent: \"\\e94d\";\r\n}\r\n\r\n.icofont-animal-eaten-fish:before {\r\n\tcontent: \"\\e94e\";\r\n}\r\n\r\n.icofont-animal-elephant-alt:before {\r\n\tcontent: \"\\e94f\";\r\n}\r\n\r\n.icofont-animal-elephant-head-alt:before {\r\n\tcontent: \"\\e950\";\r\n}\r\n\r\n.icofont-animal-elephant-head:before {\r\n\tcontent: \"\\e951\";\r\n}\r\n\r\n.icofont-animal-elephant:before {\r\n\tcontent: \"\\e952\";\r\n}\r\n\r\n.icofont-animal-elk:before {\r\n\tcontent: \"\\e953\";\r\n}\r\n\r\n.icofont-animal-fish-alt-1:before {\r\n\tcontent: \"\\e954\";\r\n}\r\n\r\n.icofont-animal-fish-alt-2:before {\r\n\tcontent: \"\\e955\";\r\n}\r\n\r\n.icofont-animal-fish-alt-3:before {\r\n\tcontent: \"\\e956\";\r\n}\r\n\r\n.icofont-animal-fish-alt-4:before {\r\n\tcontent: \"\\e957\";\r\n}\r\n\r\n.icofont-animal-fish:before {\r\n\tcontent: \"\\e958\";\r\n}\r\n\r\n.icofont-animal-fox-alt:before {\r\n\tcontent: \"\\e959\";\r\n}\r\n\r\n.icofont-animal-fox:before {\r\n\tcontent: \"\\e95a\";\r\n}\r\n\r\n.icofont-animal-frog-tracks:before {\r\n\tcontent: \"\\e95b\";\r\n}\r\n\r\n.icofont-animal-frog:before {\r\n\tcontent: \"\\e95c\";\r\n}\r\n\r\n.icofont-animal-froggy:before {\r\n\tcontent: \"\\e95d\";\r\n}\r\n\r\n.icofont-animal-giraffe-alt:before {\r\n\tcontent: \"\\e95e\";\r\n}\r\n\r\n.icofont-animal-giraffe:before {\r\n\tcontent: \"\\e95f\";\r\n}\r\n\r\n.icofont-animal-goat-head-alt-1:before {\r\n\tcontent: \"\\e960\";\r\n}\r\n\r\n.icofont-animal-goat-head-alt-2:before {\r\n\tcontent: \"\\e961\";\r\n}\r\n\r\n.icofont-animal-goat-head:before {\r\n\tcontent: \"\\e962\";\r\n}\r\n\r\n.icofont-animal-gorilla:before {\r\n\tcontent: \"\\e963\";\r\n}\r\n\r\n.icofont-animal-hen-tracks:before {\r\n\tcontent: \"\\e964\";\r\n}\r\n\r\n.icofont-animal-horse-head-alt-1:before {\r\n\tcontent: \"\\e965\";\r\n}\r\n\r\n.icofont-animal-horse-head-alt-2:before {\r\n\tcontent: \"\\e966\";\r\n}\r\n\r\n.icofont-animal-horse-head:before {\r\n\tcontent: \"\\e967\";\r\n}\r\n\r\n.icofont-animal-horse-tracks:before {\r\n\tcontent: \"\\e968\";\r\n}\r\n\r\n.icofont-animal-jellyfish:before {\r\n\tcontent: \"\\e969\";\r\n}\r\n\r\n.icofont-animal-kangaroo:before {\r\n\tcontent: \"\\e96a\";\r\n}\r\n\r\n.icofont-animal-lemur:before {\r\n\tcontent: \"\\e96b\";\r\n}\r\n\r\n.icofont-animal-lion-alt:before {\r\n\tcontent: \"\\e96c\";\r\n}\r\n\r\n.icofont-animal-lion-head-alt:before {\r\n\tcontent: \"\\e96d\";\r\n}\r\n\r\n.icofont-animal-lion-head:before {\r\n\tcontent: \"\\e96e\";\r\n}\r\n\r\n.icofont-animal-lion:before {\r\n\tcontent: \"\\e96f\";\r\n}\r\n\r\n.icofont-animal-monkey-alt-1:before {\r\n\tcontent: \"\\e970\";\r\n}\r\n\r\n.icofont-animal-monkey-alt-2:before {\r\n\tcontent: \"\\e971\";\r\n}\r\n\r\n.icofont-animal-monkey-alt-3:before {\r\n\tcontent: \"\\e972\";\r\n}\r\n\r\n.icofont-animal-monkey:before {\r\n\tcontent: \"\\e973\";\r\n}\r\n\r\n.icofont-animal-octopus-alt:before {\r\n\tcontent: \"\\e974\";\r\n}\r\n\r\n.icofont-animal-octopus:before {\r\n\tcontent: \"\\e975\";\r\n}\r\n\r\n.icofont-animal-owl:before {\r\n\tcontent: \"\\e976\";\r\n}\r\n\r\n.icofont-animal-panda-alt:before {\r\n\tcontent: \"\\e977\";\r\n}\r\n\r\n.icofont-animal-panda:before {\r\n\tcontent: \"\\e978\";\r\n}\r\n\r\n.icofont-animal-panther:before {\r\n\tcontent: \"\\e979\";\r\n}\r\n\r\n.icofont-animal-parrot-lip:before {\r\n\tcontent: \"\\e97a\";\r\n}\r\n\r\n.icofont-animal-parrot:before {\r\n\tcontent: \"\\e97b\";\r\n}\r\n\r\n.icofont-animal-paw:before {\r\n\tcontent: \"\\e97c\";\r\n}\r\n\r\n.icofont-animal-pelican:before {\r\n\tcontent: \"\\e97d\";\r\n}\r\n\r\n.icofont-animal-penguin:before {\r\n\tcontent: \"\\e97e\";\r\n}\r\n\r\n.icofont-animal-pig-alt:before {\r\n\tcontent: \"\\e97f\";\r\n}\r\n\r\n.icofont-animal-pig:before {\r\n\tcontent: \"\\e980\";\r\n}\r\n\r\n.icofont-animal-pigeon-alt:before {\r\n\tcontent: \"\\e981\";\r\n}\r\n\r\n.icofont-animal-pigeon:before {\r\n\tcontent: \"\\e982\";\r\n}\r\n\r\n.icofont-animal-pigeons:before {\r\n\tcontent: \"\\e983\";\r\n}\r\n\r\n.icofont-animal-rabbit-running:before {\r\n\tcontent: \"\\e984\";\r\n}\r\n\r\n.icofont-animal-rat-alt:before {\r\n\tcontent: \"\\e985\";\r\n}\r\n\r\n.icofont-animal-rhino-head:before {\r\n\tcontent: \"\\e986\";\r\n}\r\n\r\n.icofont-animal-rhino:before {\r\n\tcontent: \"\\e987\";\r\n}\r\n\r\n.icofont-animal-rooster:before {\r\n\tcontent: \"\\e988\";\r\n}\r\n\r\n.icofont-animal-seahorse:before {\r\n\tcontent: \"\\e989\";\r\n}\r\n\r\n.icofont-animal-seal:before {\r\n\tcontent: \"\\e98a\";\r\n}\r\n\r\n.icofont-animal-shrimp:before {\r\n\tcontent: \"\\e98b\";\r\n}\r\n\r\n.icofont-animal-snail-alt-1:before {\r\n\tcontent: \"\\e98c\";\r\n}\r\n\r\n.icofont-animal-snail-alt-2:before {\r\n\tcontent: \"\\e98d\";\r\n}\r\n\r\n.icofont-animal-snail:before {\r\n\tcontent: \"\\e98e\";\r\n}\r\n\r\n.icofont-animal-snake:before {\r\n\tcontent: \"\\e98f\";\r\n}\r\n\r\n.icofont-animal-squid:before {\r\n\tcontent: \"\\e990\";\r\n}\r\n\r\n.icofont-animal-squirrel:before {\r\n\tcontent: \"\\e991\";\r\n}\r\n\r\n.icofont-animal-tiger-alt:before {\r\n\tcontent: \"\\e992\";\r\n}\r\n\r\n.icofont-animal-tiger:before {\r\n\tcontent: \"\\e993\";\r\n}\r\n\r\n.icofont-animal-turtle:before {\r\n\tcontent: \"\\e994\";\r\n}\r\n\r\n.icofont-animal-whale:before {\r\n\tcontent: \"\\e995\";\r\n}\r\n\r\n.icofont-animal-woodpecker:before {\r\n\tcontent: \"\\e996\";\r\n}\r\n\r\n.icofont-animal-zebra:before {\r\n\tcontent: \"\\e997\";\r\n}\r\n\r\n.icofont-brand-acer:before {\r\n\tcontent: \"\\e998\";\r\n}\r\n\r\n.icofont-brand-adidas:before {\r\n\tcontent: \"\\e999\";\r\n}\r\n\r\n.icofont-brand-adobe:before {\r\n\tcontent: \"\\e99a\";\r\n}\r\n\r\n.icofont-brand-air-new-zealand:before {\r\n\tcontent: \"\\e99b\";\r\n}\r\n\r\n.icofont-brand-airbnb:before {\r\n\tcontent: \"\\e99c\";\r\n}\r\n\r\n.icofont-brand-aircell:before {\r\n\tcontent: \"\\e99d\";\r\n}\r\n\r\n.icofont-brand-airtel:before {\r\n\tcontent: \"\\e99e\";\r\n}\r\n\r\n.icofont-brand-alcatel:before {\r\n\tcontent: \"\\e99f\";\r\n}\r\n\r\n.icofont-brand-alibaba:before {\r\n\tcontent: \"\\e9a0\";\r\n}\r\n\r\n.icofont-brand-aliexpress:before {\r\n\tcontent: \"\\e9a1\";\r\n}\r\n\r\n.icofont-brand-alipay:before {\r\n\tcontent: \"\\e9a2\";\r\n}\r\n\r\n.icofont-brand-amazon:before {\r\n\tcontent: \"\\e9a3\";\r\n}\r\n\r\n.icofont-brand-amd:before {\r\n\tcontent: \"\\e9a4\";\r\n}\r\n\r\n.icofont-brand-american-airlines:before {\r\n\tcontent: \"\\e9a5\";\r\n}\r\n\r\n.icofont-brand-android-robot:before {\r\n\tcontent: \"\\e9a6\";\r\n}\r\n\r\n.icofont-brand-android:before {\r\n\tcontent: \"\\e9a7\";\r\n}\r\n\r\n.icofont-brand-aol:before {\r\n\tcontent: \"\\e9a8\";\r\n}\r\n\r\n.icofont-brand-apple:before {\r\n\tcontent: \"\\e9a9\";\r\n}\r\n\r\n.icofont-brand-appstore:before {\r\n\tcontent: \"\\e9aa\";\r\n}\r\n\r\n.icofont-brand-asus:before {\r\n\tcontent: \"\\e9ab\";\r\n}\r\n\r\n.icofont-brand-ati:before {\r\n\tcontent: \"\\e9ac\";\r\n}\r\n\r\n.icofont-brand-att:before {\r\n\tcontent: \"\\e9ad\";\r\n}\r\n\r\n.icofont-brand-audi:before {\r\n\tcontent: \"\\e9ae\";\r\n}\r\n\r\n.icofont-brand-axiata:before {\r\n\tcontent: \"\\e9af\";\r\n}\r\n\r\n.icofont-brand-bada:before {\r\n\tcontent: \"\\e9b0\";\r\n}\r\n\r\n.icofont-brand-bbc:before {\r\n\tcontent: \"\\e9b1\";\r\n}\r\n\r\n.icofont-brand-bing:before {\r\n\tcontent: \"\\e9b2\";\r\n}\r\n\r\n.icofont-brand-blackberry:before {\r\n\tcontent: \"\\e9b3\";\r\n}\r\n\r\n.icofont-brand-bmw:before {\r\n\tcontent: \"\\e9b4\";\r\n}\r\n\r\n.icofont-brand-box:before {\r\n\tcontent: \"\\e9b5\";\r\n}\r\n\r\n.icofont-brand-burger-king:before {\r\n\tcontent: \"\\e9b6\";\r\n}\r\n\r\n.icofont-brand-business-insider:before {\r\n\tcontent: \"\\e9b7\";\r\n}\r\n\r\n.icofont-brand-buzzfeed:before {\r\n\tcontent: \"\\e9b8\";\r\n}\r\n\r\n.icofont-brand-cannon:before {\r\n\tcontent: \"\\e9b9\";\r\n}\r\n\r\n.icofont-brand-casio:before {\r\n\tcontent: \"\\e9ba\";\r\n}\r\n\r\n.icofont-brand-china-mobile:before {\r\n\tcontent: \"\\e9bb\";\r\n}\r\n\r\n.icofont-brand-china-telecom:before {\r\n\tcontent: \"\\e9bc\";\r\n}\r\n\r\n.icofont-brand-china-unicom:before {\r\n\tcontent: \"\\e9bd\";\r\n}\r\n\r\n.icofont-brand-cisco:before {\r\n\tcontent: \"\\e9be\";\r\n}\r\n\r\n.icofont-brand-citibank:before {\r\n\tcontent: \"\\e9bf\";\r\n}\r\n\r\n.icofont-brand-cnet:before {\r\n\tcontent: \"\\e9c0\";\r\n}\r\n\r\n.icofont-brand-cnn:before {\r\n\tcontent: \"\\e9c1\";\r\n}\r\n\r\n.icofont-brand-cocal-cola:before {\r\n\tcontent: \"\\e9c2\";\r\n}\r\n\r\n.icofont-brand-compaq:before {\r\n\tcontent: \"\\e9c3\";\r\n}\r\n\r\n.icofont-brand-copy:before {\r\n\tcontent: \"\\e9c4\";\r\n}\r\n\r\n.icofont-brand-debian:before {\r\n\tcontent: \"\\e9c5\";\r\n}\r\n\r\n.icofont-brand-delicious:before {\r\n\tcontent: \"\\e9c6\";\r\n}\r\n\r\n.icofont-brand-dell:before {\r\n\tcontent: \"\\e9c7\";\r\n}\r\n\r\n.icofont-brand-designbump:before {\r\n\tcontent: \"\\e9c8\";\r\n}\r\n\r\n.icofont-brand-designfloat:before {\r\n\tcontent: \"\\e9c9\";\r\n}\r\n\r\n.icofont-brand-disney:before {\r\n\tcontent: \"\\e9ca\";\r\n}\r\n\r\n.icofont-brand-dodge:before {\r\n\tcontent: \"\\e9cb\";\r\n}\r\n\r\n.icofont-brand-dove:before {\r\n\tcontent: \"\\e9cc\";\r\n}\r\n\r\n.icofont-brand-ebay:before {\r\n\tcontent: \"\\e9cd\";\r\n}\r\n\r\n.icofont-brand-eleven:before {\r\n\tcontent: \"\\e9ce\";\r\n}\r\n\r\n.icofont-brand-emirates:before {\r\n\tcontent: \"\\e9cf\";\r\n}\r\n\r\n.icofont-brand-espn:before {\r\n\tcontent: \"\\e9d0\";\r\n}\r\n\r\n.icofont-brand-etihad-airways:before {\r\n\tcontent: \"\\e9d1\";\r\n}\r\n\r\n.icofont-brand-etisalat:before {\r\n\tcontent: \"\\e9d2\";\r\n}\r\n\r\n.icofont-brand-etsy:before {\r\n\tcontent: \"\\e9d3\";\r\n}\r\n\r\n.icofont-brand-facebook:before {\r\n\tcontent: \"\\e9d4\";\r\n}\r\n\r\n.icofont-brand-fastrack:before {\r\n\tcontent: \"\\e9d5\";\r\n}\r\n\r\n.icofont-brand-fedex:before {\r\n\tcontent: \"\\e9d6\";\r\n}\r\n\r\n.icofont-brand-ferrari:before {\r\n\tcontent: \"\\e9d7\";\r\n}\r\n\r\n.icofont-brand-fitbit:before {\r\n\tcontent: \"\\e9d8\";\r\n}\r\n\r\n.icofont-brand-flikr:before {\r\n\tcontent: \"\\e9d9\";\r\n}\r\n\r\n.icofont-brand-forbes:before {\r\n\tcontent: \"\\e9da\";\r\n}\r\n\r\n.icofont-brand-foursquare:before {\r\n\tcontent: \"\\e9db\";\r\n}\r\n\r\n.icofont-brand-fox:before {\r\n\tcontent: \"\\e9dc\";\r\n}\r\n\r\n.icofont-brand-foxconn:before {\r\n\tcontent: \"\\e9dd\";\r\n}\r\n\r\n.icofont-brand-fujitsu:before {\r\n\tcontent: \"\\e9de\";\r\n}\r\n\r\n.icofont-brand-general-electric:before {\r\n\tcontent: \"\\e9df\";\r\n}\r\n\r\n.icofont-brand-gillette:before {\r\n\tcontent: \"\\e9e0\";\r\n}\r\n\r\n.icofont-brand-gizmodo:before {\r\n\tcontent: \"\\e9e1\";\r\n}\r\n\r\n.icofont-brand-gnome:before {\r\n\tcontent: \"\\e9e2\";\r\n}\r\n\r\n.icofont-brand-google:before {\r\n\tcontent: \"\\e9e3\";\r\n}\r\n\r\n.icofont-brand-gopro:before {\r\n\tcontent: \"\\e9e4\";\r\n}\r\n\r\n.icofont-brand-gucci:before {\r\n\tcontent: \"\\e9e5\";\r\n}\r\n\r\n.icofont-brand-hallmark:before {\r\n\tcontent: \"\\e9e6\";\r\n}\r\n\r\n.icofont-brand-hi5:before {\r\n\tcontent: \"\\e9e7\";\r\n}\r\n\r\n.icofont-brand-honda:before {\r\n\tcontent: \"\\e9e8\";\r\n}\r\n\r\n.icofont-brand-hp:before {\r\n\tcontent: \"\\e9e9\";\r\n}\r\n\r\n.icofont-brand-hsbc:before {\r\n\tcontent: \"\\e9ea\";\r\n}\r\n\r\n.icofont-brand-htc:before {\r\n\tcontent: \"\\e9eb\";\r\n}\r\n\r\n.icofont-brand-huawei:before {\r\n\tcontent: \"\\e9ec\";\r\n}\r\n\r\n.icofont-brand-hulu:before {\r\n\tcontent: \"\\e9ed\";\r\n}\r\n\r\n.icofont-brand-hyundai:before {\r\n\tcontent: \"\\e9ee\";\r\n}\r\n\r\n.icofont-brand-ibm:before {\r\n\tcontent: \"\\e9ef\";\r\n}\r\n\r\n.icofont-brand-icofont:before {\r\n\tcontent: \"\\e9f0\";\r\n}\r\n\r\n.icofont-brand-icq:before {\r\n\tcontent: \"\\e9f1\";\r\n}\r\n\r\n.icofont-brand-ikea:before {\r\n\tcontent: \"\\e9f2\";\r\n}\r\n\r\n.icofont-brand-imdb:before {\r\n\tcontent: \"\\e9f3\";\r\n}\r\n\r\n.icofont-brand-indiegogo:before {\r\n\tcontent: \"\\e9f4\";\r\n}\r\n\r\n.icofont-brand-intel:before {\r\n\tcontent: \"\\e9f5\";\r\n}\r\n\r\n.icofont-brand-ipair:before {\r\n\tcontent: \"\\e9f6\";\r\n}\r\n\r\n.icofont-brand-jaguar:before {\r\n\tcontent: \"\\e9f7\";\r\n}\r\n\r\n.icofont-brand-java:before {\r\n\tcontent: \"\\e9f8\";\r\n}\r\n\r\n.icofont-brand-joomshaper:before {\r\n\tcontent: \"\\e9f9\";\r\n}\r\n\r\n.icofont-brand-kickstarter:before {\r\n\tcontent: \"\\e9fa\";\r\n}\r\n\r\n.icofont-brand-kik:before {\r\n\tcontent: \"\\e9fb\";\r\n}\r\n\r\n.icofont-brand-lastfm:before {\r\n\tcontent: \"\\e9fc\";\r\n}\r\n\r\n.icofont-brand-lego:before {\r\n\tcontent: \"\\e9fd\";\r\n}\r\n\r\n.icofont-brand-lenovo:before {\r\n\tcontent: \"\\e9fe\";\r\n}\r\n\r\n.icofont-brand-levis:before {\r\n\tcontent: \"\\e9ff\";\r\n}\r\n\r\n.icofont-brand-lexus:before {\r\n\tcontent: \"\\ea00\";\r\n}\r\n\r\n.icofont-brand-lg:before {\r\n\tcontent: \"\\ea01\";\r\n}\r\n\r\n.icofont-brand-life-hacker:before {\r\n\tcontent: \"\\ea02\";\r\n}\r\n\r\n.icofont-brand-line-messenger:before {\r\n\tcontent: \"\\ea03\";\r\n}\r\n\r\n.icofont-brand-linkedin:before {\r\n\tcontent: \"\\ea04\";\r\n}\r\n\r\n.icofont-brand-linux-mint:before {\r\n\tcontent: \"\\ea05\";\r\n}\r\n\r\n.icofont-brand-linux:before {\r\n\tcontent: \"\\ea06\";\r\n}\r\n\r\n.icofont-brand-lionix:before {\r\n\tcontent: \"\\ea07\";\r\n}\r\n\r\n.icofont-brand-live-messenger:before {\r\n\tcontent: \"\\ea08\";\r\n}\r\n\r\n.icofont-brand-loreal:before {\r\n\tcontent: \"\\ea09\";\r\n}\r\n\r\n.icofont-brand-louis-vuitton:before {\r\n\tcontent: \"\\ea0a\";\r\n}\r\n\r\n.icofont-brand-mac-os:before {\r\n\tcontent: \"\\ea0b\";\r\n}\r\n\r\n.icofont-brand-marvel-app:before {\r\n\tcontent: \"\\ea0c\";\r\n}\r\n\r\n.icofont-brand-mashable:before {\r\n\tcontent: \"\\ea0d\";\r\n}\r\n\r\n.icofont-brand-mazda:before {\r\n\tcontent: \"\\ea0e\";\r\n}\r\n\r\n.icofont-brand-mcdonals:before {\r\n\tcontent: \"\\ea0f\";\r\n}\r\n\r\n.icofont-brand-mercedes:before {\r\n\tcontent: \"\\ea10\";\r\n}\r\n\r\n.icofont-brand-micromax:before {\r\n\tcontent: \"\\ea11\";\r\n}\r\n\r\n.icofont-brand-microsoft:before {\r\n\tcontent: \"\\ea12\";\r\n}\r\n\r\n.icofont-brand-mobileme:before {\r\n\tcontent: \"\\ea13\";\r\n}\r\n\r\n.icofont-brand-mobily:before {\r\n\tcontent: \"\\ea14\";\r\n}\r\n\r\n.icofont-brand-motorola:before {\r\n\tcontent: \"\\ea15\";\r\n}\r\n\r\n.icofont-brand-msi:before {\r\n\tcontent: \"\\ea16\";\r\n}\r\n\r\n.icofont-brand-mts:before {\r\n\tcontent: \"\\ea17\";\r\n}\r\n\r\n.icofont-brand-myspace:before {\r\n\tcontent: \"\\ea18\";\r\n}\r\n\r\n.icofont-brand-mytv:before {\r\n\tcontent: \"\\ea19\";\r\n}\r\n\r\n.icofont-brand-nasa:before {\r\n\tcontent: \"\\ea1a\";\r\n}\r\n\r\n.icofont-brand-natgeo:before {\r\n\tcontent: \"\\ea1b\";\r\n}\r\n\r\n.icofont-brand-nbc:before {\r\n\tcontent: \"\\ea1c\";\r\n}\r\n\r\n.icofont-brand-nescafe:before {\r\n\tcontent: \"\\ea1d\";\r\n}\r\n\r\n.icofont-brand-nestle:before {\r\n\tcontent: \"\\ea1e\";\r\n}\r\n\r\n.icofont-brand-netflix:before {\r\n\tcontent: \"\\ea1f\";\r\n}\r\n\r\n.icofont-brand-nexus:before {\r\n\tcontent: \"\\ea20\";\r\n}\r\n\r\n.icofont-brand-nike:before {\r\n\tcontent: \"\\ea21\";\r\n}\r\n\r\n.icofont-brand-nokia:before {\r\n\tcontent: \"\\ea22\";\r\n}\r\n\r\n.icofont-brand-nvidia:before {\r\n\tcontent: \"\\ea23\";\r\n}\r\n\r\n.icofont-brand-omega:before {\r\n\tcontent: \"\\ea24\";\r\n}\r\n\r\n.icofont-brand-opensuse:before {\r\n\tcontent: \"\\ea25\";\r\n}\r\n\r\n.icofont-brand-oracle:before {\r\n\tcontent: \"\\ea26\";\r\n}\r\n\r\n.icofont-brand-panasonic:before {\r\n\tcontent: \"\\ea27\";\r\n}\r\n\r\n.icofont-brand-paypal:before {\r\n\tcontent: \"\\ea28\";\r\n}\r\n\r\n.icofont-brand-pepsi:before {\r\n\tcontent: \"\\ea29\";\r\n}\r\n\r\n.icofont-brand-philips:before {\r\n\tcontent: \"\\ea2a\";\r\n}\r\n\r\n.icofont-brand-pizza-hut:before {\r\n\tcontent: \"\\ea2b\";\r\n}\r\n\r\n.icofont-brand-playstation:before {\r\n\tcontent: \"\\ea2c\";\r\n}\r\n\r\n.icofont-brand-puma:before {\r\n\tcontent: \"\\ea2d\";\r\n}\r\n\r\n.icofont-brand-qatar-air:before {\r\n\tcontent: \"\\ea2e\";\r\n}\r\n\r\n.icofont-brand-qvc:before {\r\n\tcontent: \"\\ea2f\";\r\n}\r\n\r\n.icofont-brand-readernaut:before {\r\n\tcontent: \"\\ea30\";\r\n}\r\n\r\n.icofont-brand-redbull:before {\r\n\tcontent: \"\\ea31\";\r\n}\r\n\r\n.icofont-brand-reebok:before {\r\n\tcontent: \"\\ea32\";\r\n}\r\n\r\n.icofont-brand-reuters:before {\r\n\tcontent: \"\\ea33\";\r\n}\r\n\r\n.icofont-brand-samsung:before {\r\n\tcontent: \"\\ea34\";\r\n}\r\n\r\n.icofont-brand-sap:before {\r\n\tcontent: \"\\ea35\";\r\n}\r\n\r\n.icofont-brand-saudia-airlines:before {\r\n\tcontent: \"\\ea36\";\r\n}\r\n\r\n.icofont-brand-scribd:before {\r\n\tcontent: \"\\ea37\";\r\n}\r\n\r\n.icofont-brand-shell:before {\r\n\tcontent: \"\\ea38\";\r\n}\r\n\r\n.icofont-brand-siemens:before {\r\n\tcontent: \"\\ea39\";\r\n}\r\n\r\n.icofont-brand-sk-telecom:before {\r\n\tcontent: \"\\ea3a\";\r\n}\r\n\r\n.icofont-brand-slideshare:before {\r\n\tcontent: \"\\ea3b\";\r\n}\r\n\r\n.icofont-brand-smashing-magazine:before {\r\n\tcontent: \"\\ea3c\";\r\n}\r\n\r\n.icofont-brand-snapchat:before {\r\n\tcontent: \"\\ea3d\";\r\n}\r\n\r\n.icofont-brand-sony-ericsson:before {\r\n\tcontent: \"\\ea3e\";\r\n}\r\n\r\n.icofont-brand-sony:before {\r\n\tcontent: \"\\ea3f\";\r\n}\r\n\r\n.icofont-brand-soundcloud:before {\r\n\tcontent: \"\\ea40\";\r\n}\r\n\r\n.icofont-brand-sprint:before {\r\n\tcontent: \"\\ea41\";\r\n}\r\n\r\n.icofont-brand-squidoo:before {\r\n\tcontent: \"\\ea42\";\r\n}\r\n\r\n.icofont-brand-starbucks:before {\r\n\tcontent: \"\\ea43\";\r\n}\r\n\r\n.icofont-brand-stc:before {\r\n\tcontent: \"\\ea44\";\r\n}\r\n\r\n.icofont-brand-steam:before {\r\n\tcontent: \"\\ea45\";\r\n}\r\n\r\n.icofont-brand-suzuki:before {\r\n\tcontent: \"\\ea46\";\r\n}\r\n\r\n.icofont-brand-symbian:before {\r\n\tcontent: \"\\ea47\";\r\n}\r\n\r\n.icofont-brand-t-mobile:before {\r\n\tcontent: \"\\ea48\";\r\n}\r\n\r\n.icofont-brand-tango:before {\r\n\tcontent: \"\\ea49\";\r\n}\r\n\r\n.icofont-brand-target:before {\r\n\tcontent: \"\\ea4a\";\r\n}\r\n\r\n.icofont-brand-tata-indicom:before {\r\n\tcontent: \"\\ea4b\";\r\n}\r\n\r\n.icofont-brand-techcrunch:before {\r\n\tcontent: \"\\ea4c\";\r\n}\r\n\r\n.icofont-brand-telenor:before {\r\n\tcontent: \"\\ea4d\";\r\n}\r\n\r\n.icofont-brand-teliasonera:before {\r\n\tcontent: \"\\ea4e\";\r\n}\r\n\r\n.icofont-brand-tesla:before {\r\n\tcontent: \"\\ea4f\";\r\n}\r\n\r\n.icofont-brand-the-verge:before {\r\n\tcontent: \"\\ea50\";\r\n}\r\n\r\n.icofont-brand-thenextweb:before {\r\n\tcontent: \"\\ea51\";\r\n}\r\n\r\n.icofont-brand-toshiba:before {\r\n\tcontent: \"\\ea52\";\r\n}\r\n\r\n.icofont-brand-toyota:before {\r\n\tcontent: \"\\ea53\";\r\n}\r\n\r\n.icofont-brand-tribenet:before {\r\n\tcontent: \"\\ea54\";\r\n}\r\n\r\n.icofont-brand-ubuntu:before {\r\n\tcontent: \"\\ea55\";\r\n}\r\n\r\n.icofont-brand-unilever:before {\r\n\tcontent: \"\\ea56\";\r\n}\r\n\r\n.icofont-brand-vaio:before {\r\n\tcontent: \"\\ea57\";\r\n}\r\n\r\n.icofont-brand-verizon:before {\r\n\tcontent: \"\\ea58\";\r\n}\r\n\r\n.icofont-brand-viber:before {\r\n\tcontent: \"\\ea59\";\r\n}\r\n\r\n.icofont-brand-vodafone:before {\r\n\tcontent: \"\\ea5a\";\r\n}\r\n\r\n.icofont-brand-volkswagen:before {\r\n\tcontent: \"\\ea5b\";\r\n}\r\n\r\n.icofont-brand-walmart:before {\r\n\tcontent: \"\\ea5c\";\r\n}\r\n\r\n.icofont-brand-warnerbros:before {\r\n\tcontent: \"\\ea5d\";\r\n}\r\n\r\n.icofont-brand-whatsapp:before {\r\n\tcontent: \"\\ea5e\";\r\n}\r\n\r\n.icofont-brand-wikipedia:before {\r\n\tcontent: \"\\ea5f\";\r\n}\r\n\r\n.icofont-brand-windows:before {\r\n\tcontent: \"\\ea60\";\r\n}\r\n\r\n.icofont-brand-wire:before {\r\n\tcontent: \"\\ea61\";\r\n}\r\n\r\n.icofont-brand-yahoobuzz:before {\r\n\tcontent: \"\\ea62\";\r\n}\r\n\r\n.icofont-brand-yamaha:before {\r\n\tcontent: \"\\ea63\";\r\n}\r\n\r\n.icofont-brand-youtube:before {\r\n\tcontent: \"\\ea64\";\r\n}\r\n\r\n.icofont-brand-zain:before {\r\n\tcontent: \"\\ea65\";\r\n}\r\n\r\n.icofont-bank-alt:before {\r\n\tcontent: \"\\ea66\";\r\n}\r\n\r\n.icofont-barcode:before {\r\n\tcontent: \"\\ea67\";\r\n}\r\n\r\n.icofont-basket:before {\r\n\tcontent: \"\\ea68\";\r\n}\r\n\r\n.icofont-bill-alt:before {\r\n\tcontent: \"\\ea69\";\r\n}\r\n\r\n.icofont-billboard:before {\r\n\tcontent: \"\\ea6a\";\r\n}\r\n\r\n.icofont-briefcase-alt-1:before {\r\n\tcontent: \"\\ea6b\";\r\n}\r\n\r\n.icofont-briefcase-alt-2:before {\r\n\tcontent: \"\\ea6c\";\r\n}\r\n\r\n.icofont-building-alt:before {\r\n\tcontent: \"\\ea6d\";\r\n}\r\n\r\n.icofont-businessman:before {\r\n\tcontent: \"\\ea6e\";\r\n}\r\n\r\n.icofont-businesswoman:before {\r\n\tcontent: \"\\ea6f\";\r\n}\r\n\r\n.icofont-cart-alt:before {\r\n\tcontent: \"\\ea70\";\r\n}\r\n\r\n.icofont-chair:before {\r\n\tcontent: \"\\ea71\";\r\n}\r\n\r\n.icofont-clip:before {\r\n\tcontent: \"\\ea72\";\r\n}\r\n\r\n.icofont-coins:before {\r\n\tcontent: \"\\ea73\";\r\n}\r\n\r\n.icofont-company:before {\r\n\tcontent: \"\\ea74\";\r\n}\r\n\r\n.icofont-contact-add:before {\r\n\tcontent: \"\\ea75\";\r\n}\r\n\r\n.icofont-deal:before {\r\n\tcontent: \"\\ea76\";\r\n}\r\n\r\n.icofont-files:before {\r\n\tcontent: \"\\ea77\";\r\n}\r\n\r\n.icofont-growth:before {\r\n\tcontent: \"\\ea78\";\r\n}\r\n\r\n.icofont-id-card:before {\r\n\tcontent: \"\\ea79\";\r\n}\r\n\r\n.icofont-idea:before {\r\n\tcontent: \"\\ea7a\";\r\n}\r\n\r\n.icofont-list:before {\r\n\tcontent: \"\\ea7b\";\r\n}\r\n\r\n.icofont-meeting-add:before {\r\n\tcontent: \"\\ea7c\";\r\n}\r\n\r\n.icofont-money-bag:before {\r\n\tcontent: \"\\ea7d\";\r\n}\r\n\r\n.icofont-people:before {\r\n\tcontent: \"\\ea7e\";\r\n}\r\n\r\n.icofont-pie-chart:before {\r\n\tcontent: \"\\ea7f\";\r\n}\r\n\r\n.icofont-presentation-alt:before {\r\n\tcontent: \"\\ea80\";\r\n}\r\n\r\n.icofont-stamp:before {\r\n\tcontent: \"\\ea81\";\r\n}\r\n\r\n.icofont-stock-mobile:before {\r\n\tcontent: \"\\ea82\";\r\n}\r\n\r\n.icofont-support:before {\r\n\tcontent: \"\\ea83\";\r\n}\r\n\r\n.icofont-tasks-alt:before {\r\n\tcontent: \"\\ea84\";\r\n}\r\n\r\n.icofont-wheel:before {\r\n\tcontent: \"\\ea85\";\r\n}\r\n\r\n.icofont-chart-arrows-axis:before {\r\n\tcontent: \"\\ea86\";\r\n}\r\n\r\n.icofont-chart-bar-graph:before {\r\n\tcontent: \"\\ea87\";\r\n}\r\n\r\n.icofont-chart-flow-alt-1:before {\r\n\tcontent: \"\\ea88\";\r\n}\r\n\r\n.icofont-chart-flow-alt-2:before {\r\n\tcontent: \"\\ea89\";\r\n}\r\n\r\n.icofont-chart-flow:before {\r\n\tcontent: \"\\ea8a\";\r\n}\r\n\r\n.icofont-chart-histogram-alt:before {\r\n\tcontent: \"\\ea8b\";\r\n}\r\n\r\n.icofont-chart-histogram:before {\r\n\tcontent: \"\\ea8c\";\r\n}\r\n\r\n.icofont-chart-line-alt:before {\r\n\tcontent: \"\\ea8d\";\r\n}\r\n\r\n.icofont-chart-line:before {\r\n\tcontent: \"\\ea8e\";\r\n}\r\n\r\n.icofont-chart-pie-alt:before {\r\n\tcontent: \"\\ea8f\";\r\n}\r\n\r\n.icofont-chart-pie:before {\r\n\tcontent: \"\\ea90\";\r\n}\r\n\r\n.icofont-chart-radar-graph:before {\r\n\tcontent: \"\\ea91\";\r\n}\r\n\r\n.icofont-cur-afghani-false:before {\r\n\tcontent: \"\\ea92\";\r\n}\r\n\r\n.icofont-cur-afghani-minus:before {\r\n\tcontent: \"\\ea93\";\r\n}\r\n\r\n.icofont-cur-afghani-plus:before {\r\n\tcontent: \"\\ea94\";\r\n}\r\n\r\n.icofont-cur-afghani-true:before {\r\n\tcontent: \"\\ea95\";\r\n}\r\n\r\n.icofont-cur-afghani:before {\r\n\tcontent: \"\\ea96\";\r\n}\r\n\r\n.icofont-cur-baht-false:before {\r\n\tcontent: \"\\ea97\";\r\n}\r\n\r\n.icofont-cur-baht-minus:before {\r\n\tcontent: \"\\ea98\";\r\n}\r\n\r\n.icofont-cur-baht-plus:before {\r\n\tcontent: \"\\ea99\";\r\n}\r\n\r\n.icofont-cur-baht-true:before {\r\n\tcontent: \"\\ea9a\";\r\n}\r\n\r\n.icofont-cur-baht:before {\r\n\tcontent: \"\\ea9b\";\r\n}\r\n\r\n.icofont-cur-bitcoin-false:before {\r\n\tcontent: \"\\ea9c\";\r\n}\r\n\r\n.icofont-cur-bitcoin-minus:before {\r\n\tcontent: \"\\ea9d\";\r\n}\r\n\r\n.icofont-cur-bitcoin-plus:before {\r\n\tcontent: \"\\ea9e\";\r\n}\r\n\r\n.icofont-cur-bitcoin-true:before {\r\n\tcontent: \"\\ea9f\";\r\n}\r\n\r\n.icofont-cur-bitcoin:before {\r\n\tcontent: \"\\eaa0\";\r\n}\r\n\r\n.icofont-cur-dollar-flase:before {\r\n\tcontent: \"\\eaa1\";\r\n}\r\n\r\n.icofont-cur-dollar-minus:before {\r\n\tcontent: \"\\eaa2\";\r\n}\r\n\r\n.icofont-cur-dollar-plus:before {\r\n\tcontent: \"\\eaa3\";\r\n}\r\n\r\n.icofont-cur-dollar-true:before {\r\n\tcontent: \"\\eaa4\";\r\n}\r\n\r\n.icofont-cur-dollar:before {\r\n\tcontent: \"\\eaa5\";\r\n}\r\n\r\n.icofont-cur-dong-false:before {\r\n\tcontent: \"\\eaa6\";\r\n}\r\n\r\n.icofont-cur-dong-minus:before {\r\n\tcontent: \"\\eaa7\";\r\n}\r\n\r\n.icofont-cur-dong-plus:before {\r\n\tcontent: \"\\eaa8\";\r\n}\r\n\r\n.icofont-cur-dong-true:before {\r\n\tcontent: \"\\eaa9\";\r\n}\r\n\r\n.icofont-cur-dong:before {\r\n\tcontent: \"\\eaaa\";\r\n}\r\n\r\n.icofont-cur-euro-false:before {\r\n\tcontent: \"\\eaab\";\r\n}\r\n\r\n.icofont-cur-euro-minus:before {\r\n\tcontent: \"\\eaac\";\r\n}\r\n\r\n.icofont-cur-euro-plus:before {\r\n\tcontent: \"\\eaad\";\r\n}\r\n\r\n.icofont-cur-euro-true:before {\r\n\tcontent: \"\\eaae\";\r\n}\r\n\r\n.icofont-cur-euro:before {\r\n\tcontent: \"\\eaaf\";\r\n}\r\n\r\n.icofont-cur-frank-false:before {\r\n\tcontent: \"\\eab0\";\r\n}\r\n\r\n.icofont-cur-frank-minus:before {\r\n\tcontent: \"\\eab1\";\r\n}\r\n\r\n.icofont-cur-frank-plus:before {\r\n\tcontent: \"\\eab2\";\r\n}\r\n\r\n.icofont-cur-frank-true:before {\r\n\tcontent: \"\\eab3\";\r\n}\r\n\r\n.icofont-cur-frank:before {\r\n\tcontent: \"\\eab4\";\r\n}\r\n\r\n.icofont-cur-hryvnia-false:before {\r\n\tcontent: \"\\eab5\";\r\n}\r\n\r\n.icofont-cur-hryvnia-minus:before {\r\n\tcontent: \"\\eab6\";\r\n}\r\n\r\n.icofont-cur-hryvnia-plus:before {\r\n\tcontent: \"\\eab7\";\r\n}\r\n\r\n.icofont-cur-hryvnia-true:before {\r\n\tcontent: \"\\eab8\";\r\n}\r\n\r\n.icofont-cur-hryvnia:before {\r\n\tcontent: \"\\eab9\";\r\n}\r\n\r\n.icofont-cur-lira-false:before {\r\n\tcontent: \"\\eaba\";\r\n}\r\n\r\n.icofont-cur-lira-minus:before {\r\n\tcontent: \"\\eabb\";\r\n}\r\n\r\n.icofont-cur-lira-plus:before {\r\n\tcontent: \"\\eabc\";\r\n}\r\n\r\n.icofont-cur-lira-true:before {\r\n\tcontent: \"\\eabd\";\r\n}\r\n\r\n.icofont-cur-lira:before {\r\n\tcontent: \"\\eabe\";\r\n}\r\n\r\n.icofont-cur-peseta-false:before {\r\n\tcontent: \"\\eabf\";\r\n}\r\n\r\n.icofont-cur-peseta-minus:before {\r\n\tcontent: \"\\eac0\";\r\n}\r\n\r\n.icofont-cur-peseta-plus:before {\r\n\tcontent: \"\\eac1\";\r\n}\r\n\r\n.icofont-cur-peseta-true:before {\r\n\tcontent: \"\\eac2\";\r\n}\r\n\r\n.icofont-cur-peseta:before {\r\n\tcontent: \"\\eac3\";\r\n}\r\n\r\n.icofont-cur-peso-false:before {\r\n\tcontent: \"\\eac4\";\r\n}\r\n\r\n.icofont-cur-peso-minus:before {\r\n\tcontent: \"\\eac5\";\r\n}\r\n\r\n.icofont-cur-peso-plus:before {\r\n\tcontent: \"\\eac6\";\r\n}\r\n\r\n.icofont-cur-peso-true:before {\r\n\tcontent: \"\\eac7\";\r\n}\r\n\r\n.icofont-cur-peso:before {\r\n\tcontent: \"\\eac8\";\r\n}\r\n\r\n.icofont-cur-pound-false:before {\r\n\tcontent: \"\\eac9\";\r\n}\r\n\r\n.icofont-cur-pound-minus:before {\r\n\tcontent: \"\\eaca\";\r\n}\r\n\r\n.icofont-cur-pound-plus:before {\r\n\tcontent: \"\\eacb\";\r\n}\r\n\r\n.icofont-cur-pound-true:before {\r\n\tcontent: \"\\eacc\";\r\n}\r\n\r\n.icofont-cur-pound:before {\r\n\tcontent: \"\\eacd\";\r\n}\r\n\r\n.icofont-cur-renminbi-false:before {\r\n\tcontent: \"\\eace\";\r\n}\r\n\r\n.icofont-cur-renminbi-minus:before {\r\n\tcontent: \"\\eacf\";\r\n}\r\n\r\n.icofont-cur-renminbi-plus:before {\r\n\tcontent: \"\\ead0\";\r\n}\r\n\r\n.icofont-cur-renminbi-true:before {\r\n\tcontent: \"\\ead1\";\r\n}\r\n\r\n.icofont-cur-renminbi:before {\r\n\tcontent: \"\\ead2\";\r\n}\r\n\r\n.icofont-cur-riyal-false:before {\r\n\tcontent: \"\\ead3\";\r\n}\r\n\r\n.icofont-cur-riyal-minus:before {\r\n\tcontent: \"\\ead4\";\r\n}\r\n\r\n.icofont-cur-riyal-plus:before {\r\n\tcontent: \"\\ead5\";\r\n}\r\n\r\n.icofont-cur-riyal-true:before {\r\n\tcontent: \"\\ead6\";\r\n}\r\n\r\n.icofont-cur-riyal:before {\r\n\tcontent: \"\\ead7\";\r\n}\r\n\r\n.icofont-cur-rouble-false:before {\r\n\tcontent: \"\\ead8\";\r\n}\r\n\r\n.icofont-cur-rouble-minus:before {\r\n\tcontent: \"\\ead9\";\r\n}\r\n\r\n.icofont-cur-rouble-plus:before {\r\n\tcontent: \"\\eada\";\r\n}\r\n\r\n.icofont-cur-rouble-true:before {\r\n\tcontent: \"\\eadb\";\r\n}\r\n\r\n.icofont-cur-rouble:before {\r\n\tcontent: \"\\eadc\";\r\n}\r\n\r\n.icofont-cur-rupee-false:before {\r\n\tcontent: \"\\eadd\";\r\n}\r\n\r\n.icofont-cur-rupee-minus:before {\r\n\tcontent: \"\\eade\";\r\n}\r\n\r\n.icofont-cur-rupee-plus:before {\r\n\tcontent: \"\\eadf\";\r\n}\r\n\r\n.icofont-cur-rupee-true:before {\r\n\tcontent: \"\\eae0\";\r\n}\r\n\r\n.icofont-cur-rupee:before {\r\n\tcontent: \"\\eae1\";\r\n}\r\n\r\n.icofont-cur-taka-false:before {\r\n\tcontent: \"\\eae2\";\r\n}\r\n\r\n.icofont-cur-taka-minus:before {\r\n\tcontent: \"\\eae3\";\r\n}\r\n\r\n.icofont-cur-taka-plus:before {\r\n\tcontent: \"\\eae4\";\r\n}\r\n\r\n.icofont-cur-taka-true:before {\r\n\tcontent: \"\\eae5\";\r\n}\r\n\r\n.icofont-cur-taka:before {\r\n\tcontent: \"\\eae6\";\r\n}\r\n\r\n.icofont-cur-turkish-lira-false:before {\r\n\tcontent: \"\\eae7\";\r\n}\r\n\r\n.icofont-cur-turkish-lira-minus:before {\r\n\tcontent: \"\\eae8\";\r\n}\r\n\r\n.icofont-cur-turkish-lira-plus:before {\r\n\tcontent: \"\\eae9\";\r\n}\r\n\r\n.icofont-cur-turkish-lira-true:before {\r\n\tcontent: \"\\eaea\";\r\n}\r\n\r\n.icofont-cur-turkish-lira:before {\r\n\tcontent: \"\\eaeb\";\r\n}\r\n\r\n.icofont-cur-won-false:before {\r\n\tcontent: \"\\eaec\";\r\n}\r\n\r\n.icofont-cur-won-minus:before {\r\n\tcontent: \"\\eaed\";\r\n}\r\n\r\n.icofont-cur-won-plus:before {\r\n\tcontent: \"\\eaee\";\r\n}\r\n\r\n.icofont-cur-won-true:before {\r\n\tcontent: \"\\eaef\";\r\n}\r\n\r\n.icofont-cur-won:before {\r\n\tcontent: \"\\eaf0\";\r\n}\r\n\r\n.icofont-cur-yen-false:before {\r\n\tcontent: \"\\eaf1\";\r\n}\r\n\r\n.icofont-cur-yen-minus:before {\r\n\tcontent: \"\\eaf2\";\r\n}\r\n\r\n.icofont-cur-yen-plus:before {\r\n\tcontent: \"\\eaf3\";\r\n}\r\n\r\n.icofont-cur-yen-true:before {\r\n\tcontent: \"\\eaf4\";\r\n}\r\n\r\n.icofont-cur-yen:before {\r\n\tcontent: \"\\eaf5\";\r\n}\r\n\r\n.icofont-android-nexus:before {\r\n\tcontent: \"\\eaf6\";\r\n}\r\n\r\n.icofont-android-tablet:before {\r\n\tcontent: \"\\eaf7\";\r\n}\r\n\r\n.icofont-apple-watch:before {\r\n\tcontent: \"\\eaf8\";\r\n}\r\n\r\n.icofont-drwaing-tablet:before {\r\n\tcontent: \"\\eaf9\";\r\n}\r\n\r\n.icofont-earphone:before {\r\n\tcontent: \"\\eafa\";\r\n}\r\n\r\n.icofont-flash-drive:before {\r\n\tcontent: \"\\eafb\";\r\n}\r\n\r\n.icofont-game-control:before {\r\n\tcontent: \"\\eafc\";\r\n}\r\n\r\n.icofont-headphone-alt:before {\r\n\tcontent: \"\\eafd\";\r\n}\r\n\r\n.icofont-htc-one:before {\r\n\tcontent: \"\\eafe\";\r\n}\r\n\r\n.icofont-imac:before {\r\n\tcontent: \"\\eaff\";\r\n}\r\n\r\n.icofont-ipad-touch:before {\r\n\tcontent: \"\\eb00\";\r\n}\r\n\r\n.icofont-iphone:before {\r\n\tcontent: \"\\eb01\";\r\n}\r\n\r\n.icofont-ipod-nano:before {\r\n\tcontent: \"\\eb02\";\r\n}\r\n\r\n.icofont-ipod-touch:before {\r\n\tcontent: \"\\eb03\";\r\n}\r\n\r\n.icofont-keyboard-alt:before {\r\n\tcontent: \"\\eb04\";\r\n}\r\n\r\n.icofont-keyboard-wireless:before {\r\n\tcontent: \"\\eb05\";\r\n}\r\n\r\n.icofont-laptop-alt:before {\r\n\tcontent: \"\\eb06\";\r\n}\r\n\r\n.icofont-macbook:before {\r\n\tcontent: \"\\eb07\";\r\n}\r\n\r\n.icofont-magic-mouse:before {\r\n\tcontent: \"\\eb08\";\r\n}\r\n\r\n.icofont-microphone-alt:before {\r\n\tcontent: \"\\eb09\";\r\n}\r\n\r\n.icofont-monitor:before {\r\n\tcontent: \"\\eb0a\";\r\n}\r\n\r\n.icofont-mouse:before {\r\n\tcontent: \"\\eb0b\";\r\n}\r\n\r\n.icofont-nintendo:before {\r\n\tcontent: \"\\eb0c\";\r\n}\r\n\r\n.icofont-playstation:before {\r\n\tcontent: \"\\eb0d\";\r\n}\r\n\r\n.icofont-psvita:before {\r\n\tcontent: \"\\eb0e\";\r\n}\r\n\r\n.icofont-radio-mic:before {\r\n\tcontent: \"\\eb0f\";\r\n}\r\n\r\n.icofont-refrigerator:before {\r\n\tcontent: \"\\eb10\";\r\n}\r\n\r\n.icofont-samsung-galaxy:before {\r\n\tcontent: \"\\eb11\";\r\n}\r\n\r\n.icofont-surface-tablet:before {\r\n\tcontent: \"\\eb12\";\r\n}\r\n\r\n.icofont-washing-machine:before {\r\n\tcontent: \"\\eb13\";\r\n}\r\n\r\n.icofont-wifi-router:before {\r\n\tcontent: \"\\eb14\";\r\n}\r\n\r\n.icofont-wii-u:before {\r\n\tcontent: \"\\eb15\";\r\n}\r\n\r\n.icofont-windows-lumia:before {\r\n\tcontent: \"\\eb16\";\r\n}\r\n\r\n.icofont-wireless-mouse:before {\r\n\tcontent: \"\\eb17\";\r\n}\r\n\r\n.icofont-xbox-360:before {\r\n\tcontent: \"\\eb18\";\r\n}\r\n\r\n.icofont-arrow-down:before {\r\n\tcontent: \"\\eb19\";\r\n}\r\n\r\n.icofont-arrow-left:before {\r\n\tcontent: \"\\eb1a\";\r\n}\r\n\r\n.icofont-arrow-right:before {\r\n\tcontent: \"\\eb1b\";\r\n}\r\n\r\n.icofont-arrow-up:before {\r\n\tcontent: \"\\eb1c\";\r\n}\r\n\r\n.icofont-block-down:before {\r\n\tcontent: \"\\eb1d\";\r\n}\r\n\r\n.icofont-block-left:before {\r\n\tcontent: \"\\eb1e\";\r\n}\r\n\r\n.icofont-block-right:before {\r\n\tcontent: \"\\eb1f\";\r\n}\r\n\r\n.icofont-block-up:before {\r\n\tcontent: \"\\eb20\";\r\n}\r\n\r\n.icofont-bubble-down:before {\r\n\tcontent: \"\\eb21\";\r\n}\r\n\r\n.icofont-bubble-left:before {\r\n\tcontent: \"\\eb22\";\r\n}\r\n\r\n.icofont-bubble-right:before {\r\n\tcontent: \"\\eb23\";\r\n}\r\n\r\n.icofont-bubble-up:before {\r\n\tcontent: \"\\eb24\";\r\n}\r\n\r\n.icofont-caret-down:before {\r\n\tcontent: \"\\eb25\";\r\n}\r\n\r\n.icofont-caret-left:before {\r\n\tcontent: \"\\eb26\";\r\n}\r\n\r\n.icofont-caret-right:before {\r\n\tcontent: \"\\eb27\";\r\n}\r\n\r\n.icofont-caret-up:before {\r\n\tcontent: \"\\eb28\";\r\n}\r\n\r\n.icofont-circled-down:before {\r\n\tcontent: \"\\eb29\";\r\n}\r\n\r\n.icofont-circled-left:before {\r\n\tcontent: \"\\eb2a\";\r\n}\r\n\r\n.icofont-circled-right:before {\r\n\tcontent: \"\\eb2b\";\r\n}\r\n\r\n.icofont-circled-up:before {\r\n\tcontent: \"\\eb2c\";\r\n}\r\n\r\n.icofont-collapse:before {\r\n\tcontent: \"\\eb2d\";\r\n}\r\n\r\n.icofont-cursor-drag:before {\r\n\tcontent: \"\\eb2e\";\r\n}\r\n\r\n.icofont-curved-double-left:before {\r\n\tcontent: \"\\eb2f\";\r\n}\r\n\r\n.icofont-curved-double-right:before {\r\n\tcontent: \"\\eb30\";\r\n}\r\n\r\n.icofont-curved-down:before {\r\n\tcontent: \"\\eb31\";\r\n}\r\n\r\n.icofont-curved-left:before {\r\n\tcontent: \"\\eb32\";\r\n}\r\n\r\n.icofont-curved-right:before {\r\n\tcontent: \"\\eb33\";\r\n}\r\n\r\n.icofont-curved-up:before {\r\n\tcontent: \"\\eb34\";\r\n}\r\n\r\n.icofont-dotted-down:before {\r\n\tcontent: \"\\eb35\";\r\n}\r\n\r\n.icofont-dotted-left:before {\r\n\tcontent: \"\\eb36\";\r\n}\r\n\r\n.icofont-dotted-right:before {\r\n\tcontent: \"\\eb37\";\r\n}\r\n\r\n.icofont-dotted-up:before {\r\n\tcontent: \"\\eb38\";\r\n}\r\n\r\n.icofont-double-left:before {\r\n\tcontent: \"\\eb39\";\r\n}\r\n\r\n.icofont-double-right:before {\r\n\tcontent: \"\\eb3a\";\r\n}\r\n\r\n.icofont-drag:before {\r\n\tcontent: \"\\eb3b\";\r\n}\r\n\r\n.icofont-drag1:before {\r\n\tcontent: \"\\eb3c\";\r\n}\r\n\r\n.icofont-drag2:before {\r\n\tcontent: \"\\eb3d\";\r\n}\r\n\r\n.icofont-drag3:before {\r\n\tcontent: \"\\eb3e\";\r\n}\r\n\r\n.icofont-expand-alt:before {\r\n\tcontent: \"\\eb3f\";\r\n}\r\n\r\n.icofont-hand-down:before {\r\n\tcontent: \"\\eb40\";\r\n}\r\n\r\n.icofont-hand-drag:before {\r\n\tcontent: \"\\eb41\";\r\n}\r\n\r\n.icofont-hand-drag1:before {\r\n\tcontent: \"\\eb42\";\r\n}\r\n\r\n.icofont-hand-drag2:before {\r\n\tcontent: \"\\eb43\";\r\n}\r\n\r\n.icofont-hand-drawn-alt-down:before {\r\n\tcontent: \"\\eb44\";\r\n}\r\n\r\n.icofont-hand-drawn-alt-left:before {\r\n\tcontent: \"\\eb45\";\r\n}\r\n\r\n.icofont-hand-drawn-alt-right:before {\r\n\tcontent: \"\\eb46\";\r\n}\r\n\r\n.icofont-hand-drawn-alt-up:before {\r\n\tcontent: \"\\eb47\";\r\n}\r\n\r\n.icofont-hand-drawn-down:before {\r\n\tcontent: \"\\eb48\";\r\n}\r\n\r\n.icofont-hand-drawn-left:before {\r\n\tcontent: \"\\eb49\";\r\n}\r\n\r\n.icofont-hand-drawn-right:before {\r\n\tcontent: \"\\eb4a\";\r\n}\r\n\r\n.icofont-hand-drawn-up:before {\r\n\tcontent: \"\\eb4b\";\r\n}\r\n\r\n.icofont-hand-left:before {\r\n\tcontent: \"\\eb4c\";\r\n}\r\n\r\n.icofont-hand-right:before {\r\n\tcontent: \"\\eb4d\";\r\n}\r\n\r\n.icofont-hand-up:before {\r\n\tcontent: \"\\eb4e\";\r\n}\r\n\r\n.icofont-line-block-down:before {\r\n\tcontent: \"\\eb4f\";\r\n}\r\n\r\n.icofont-line-block-left:before {\r\n\tcontent: \"\\eb50\";\r\n}\r\n\r\n.icofont-line-block-right:before {\r\n\tcontent: \"\\eb51\";\r\n}\r\n\r\n.icofont-line-block-up:before {\r\n\tcontent: \"\\eb52\";\r\n}\r\n\r\n.icofont-long-arrow-down:before {\r\n\tcontent: \"\\eb53\";\r\n}\r\n\r\n.icofont-long-arrow-left:before {\r\n\tcontent: \"\\eb54\";\r\n}\r\n\r\n.icofont-long-arrow-right:before {\r\n\tcontent: \"\\eb55\";\r\n}\r\n\r\n.icofont-long-arrow-up:before {\r\n\tcontent: \"\\eb56\";\r\n}\r\n\r\n.icofont-rounded-collapse:before {\r\n\tcontent: \"\\eb57\";\r\n}\r\n\r\n.icofont-rounded-double-left:before {\r\n\tcontent: \"\\eb58\";\r\n}\r\n\r\n.icofont-rounded-double-right:before {\r\n\tcontent: \"\\eb59\";\r\n}\r\n\r\n.icofont-rounded-down:before {\r\n\tcontent: \"\\eb5a\";\r\n}\r\n\r\n.icofont-rounded-expand:before {\r\n\tcontent: \"\\eb5b\";\r\n}\r\n\r\n.icofont-rounded-left-down:before {\r\n\tcontent: \"\\eb5c\";\r\n}\r\n\r\n.icofont-rounded-left-up:before {\r\n\tcontent: \"\\eb5d\";\r\n}\r\n\r\n.icofont-rounded-left:before {\r\n\tcontent: \"\\eb5e\";\r\n}\r\n\r\n.icofont-rounded-right-down:before {\r\n\tcontent: \"\\eb5f\";\r\n}\r\n\r\n.icofont-rounded-right-up:before {\r\n\tcontent: \"\\eb60\";\r\n}\r\n\r\n.icofont-rounded-right:before {\r\n\tcontent: \"\\eb61\";\r\n}\r\n\r\n.icofont-rounded-up:before {\r\n\tcontent: \"\\eb62\";\r\n}\r\n\r\n.icofont-scroll-bubble-down:before {\r\n\tcontent: \"\\eb63\";\r\n}\r\n\r\n.icofont-scroll-bubble-left:before {\r\n\tcontent: \"\\eb64\";\r\n}\r\n\r\n.icofont-scroll-bubble-right:before {\r\n\tcontent: \"\\eb65\";\r\n}\r\n\r\n.icofont-scroll-bubble-up:before {\r\n\tcontent: \"\\eb66\";\r\n}\r\n\r\n.icofont-scroll-double-down:before {\r\n\tcontent: \"\\eb67\";\r\n}\r\n\r\n.icofont-scroll-double-left:before {\r\n\tcontent: \"\\eb68\";\r\n}\r\n\r\n.icofont-scroll-double-right:before {\r\n\tcontent: \"\\eb69\";\r\n}\r\n\r\n.icofont-scroll-double-up:before {\r\n\tcontent: \"\\eb6a\";\r\n}\r\n\r\n.icofont-scroll-down:before {\r\n\tcontent: \"\\eb6b\";\r\n}\r\n\r\n.icofont-scroll-left:before {\r\n\tcontent: \"\\eb6c\";\r\n}\r\n\r\n.icofont-scroll-long-down:before {\r\n\tcontent: \"\\eb6d\";\r\n}\r\n\r\n.icofont-scroll-long-left:before {\r\n\tcontent: \"\\eb6e\";\r\n}\r\n\r\n.icofont-scroll-long-right:before {\r\n\tcontent: \"\\eb6f\";\r\n}\r\n\r\n.icofont-scroll-long-up:before {\r\n\tcontent: \"\\eb70\";\r\n}\r\n\r\n.icofont-scroll-right:before {\r\n\tcontent: \"\\eb71\";\r\n}\r\n\r\n.icofont-scroll-up:before {\r\n\tcontent: \"\\eb72\";\r\n}\r\n\r\n.icofont-simple-down:before {\r\n\tcontent: \"\\eb73\";\r\n}\r\n\r\n.icofont-simple-left-down:before {\r\n\tcontent: \"\\eb74\";\r\n}\r\n\r\n.icofont-simple-left-up:before {\r\n\tcontent: \"\\eb75\";\r\n}\r\n\r\n.icofont-simple-left:before {\r\n\tcontent: \"\\eb76\";\r\n}\r\n\r\n.icofont-simple-right-down:before {\r\n\tcontent: \"\\eb77\";\r\n}\r\n\r\n.icofont-simple-right-up:before {\r\n\tcontent: \"\\eb78\";\r\n}\r\n\r\n.icofont-simple-right:before {\r\n\tcontent: \"\\eb79\";\r\n}\r\n\r\n.icofont-simple-up:before {\r\n\tcontent: \"\\eb7a\";\r\n}\r\n\r\n.icofont-square-down:before {\r\n\tcontent: \"\\eb7b\";\r\n}\r\n\r\n.icofont-square-left:before {\r\n\tcontent: \"\\eb7c\";\r\n}\r\n\r\n.icofont-square-right:before {\r\n\tcontent: \"\\eb7d\";\r\n}\r\n\r\n.icofont-square-up:before {\r\n\tcontent: \"\\eb7e\";\r\n}\r\n\r\n.icofont-stylish-down:before {\r\n\tcontent: \"\\eb7f\";\r\n}\r\n\r\n.icofont-stylish-left:before {\r\n\tcontent: \"\\eb80\";\r\n}\r\n\r\n.icofont-stylish-right:before {\r\n\tcontent: \"\\eb81\";\r\n}\r\n\r\n.icofont-stylish-up:before {\r\n\tcontent: \"\\eb82\";\r\n}\r\n\r\n.icofont-swoosh-down:before {\r\n\tcontent: \"\\eb83\";\r\n}\r\n\r\n.icofont-swoosh-left:before {\r\n\tcontent: \"\\eb84\";\r\n}\r\n\r\n.icofont-swoosh-right:before {\r\n\tcontent: \"\\eb85\";\r\n}\r\n\r\n.icofont-swoosh-up:before {\r\n\tcontent: \"\\eb86\";\r\n}\r\n\r\n.icofont-thin-double-left:before {\r\n\tcontent: \"\\eb87\";\r\n}\r\n\r\n.icofont-thin-double-right:before {\r\n\tcontent: \"\\eb88\";\r\n}\r\n\r\n.icofont-thin-down:before {\r\n\tcontent: \"\\eb89\";\r\n}\r\n\r\n.icofont-thin-left:before {\r\n\tcontent: \"\\eb8a\";\r\n}\r\n\r\n.icofont-thin-right:before {\r\n\tcontent: \"\\eb8b\";\r\n}\r\n\r\n.icofont-thin-up:before {\r\n\tcontent: \"\\eb8c\";\r\n}\r\n\r\n.icofont-atom:before {\r\n\tcontent: \"\\eb8d\";\r\n}\r\n\r\n.icofont-award:before {\r\n\tcontent: \"\\eb8e\";\r\n}\r\n\r\n.icofont-bell-alt:before {\r\n\tcontent: \"\\eb8f\";\r\n}\r\n\r\n.icofont-book-alt:before {\r\n\tcontent: \"\\eb90\";\r\n}\r\n\r\n.icofont-brainstorming:before {\r\n\tcontent: \"\\eb91\";\r\n}\r\n\r\n.icofont-certificate-alt-1:before {\r\n\tcontent: \"\\eb92\";\r\n}\r\n\r\n.icofont-certificate-alt-2:before {\r\n\tcontent: \"\\eb93\";\r\n}\r\n\r\n.icofont-dna-alt-2:before {\r\n\tcontent: \"\\eb94\";\r\n}\r\n\r\n.icofont-education:before {\r\n\tcontent: \"\\eb95\";\r\n}\r\n\r\n.icofont-electron:before {\r\n\tcontent: \"\\eb96\";\r\n}\r\n\r\n.icofont-fountain-pen:before {\r\n\tcontent: \"\\eb97\";\r\n}\r\n\r\n.icofont-globe-alt:before {\r\n\tcontent: \"\\eb98\";\r\n}\r\n\r\n.icofont-graduate-alt:before {\r\n\tcontent: \"\\eb99\";\r\n}\r\n\r\n.icofont-group-students:before {\r\n\tcontent: \"\\eb9a\";\r\n}\r\n\r\n.icofont-hat-alt:before {\r\n\tcontent: \"\\eb9b\";\r\n}\r\n\r\n.icofont-hat:before {\r\n\tcontent: \"\\eb9c\";\r\n}\r\n\r\n.icofont-instrument:before {\r\n\tcontent: \"\\eb9d\";\r\n}\r\n\r\n.icofont-lamp-light:before {\r\n\tcontent: \"\\eb9e\";\r\n}\r\n\r\n.icofont-microscope-alt:before {\r\n\tcontent: \"\\eb9f\";\r\n}\r\n\r\n.icofont-paper:before {\r\n\tcontent: \"\\eba0\";\r\n}\r\n\r\n.icofont-pen-alt-4:before {\r\n\tcontent: \"\\eba1\";\r\n}\r\n\r\n.icofont-pen-nib:before {\r\n\tcontent: \"\\eba2\";\r\n}\r\n\r\n.icofont-pencil-alt-5:before {\r\n\tcontent: \"\\eba3\";\r\n}\r\n\r\n.icofont-quill-pen:before {\r\n\tcontent: \"\\eba4\";\r\n}\r\n\r\n.icofont-read-book-alt:before {\r\n\tcontent: \"\\eba5\";\r\n}\r\n\r\n.icofont-read-book:before {\r\n\tcontent: \"\\eba6\";\r\n}\r\n\r\n.icofont-school-bag:before {\r\n\tcontent: \"\\eba7\";\r\n}\r\n\r\n.icofont-school-bus:before {\r\n\tcontent: \"\\eba8\";\r\n}\r\n\r\n.icofont-student-alt:before {\r\n\tcontent: \"\\eba9\";\r\n}\r\n\r\n.icofont-student:before {\r\n\tcontent: \"\\ebaa\";\r\n}\r\n\r\n.icofont-teacher:before {\r\n\tcontent: \"\\ebab\";\r\n}\r\n\r\n.icofont-test-bulb:before {\r\n\tcontent: \"\\ebac\";\r\n}\r\n\r\n.icofont-test-tube-alt:before {\r\n\tcontent: \"\\ebad\";\r\n}\r\n\r\n.icofont-university:before {\r\n\tcontent: \"\\ebae\";\r\n}\r\n\r\n.icofont-emo-angry:before {\r\n\tcontent: \"\\ebaf\";\r\n}\r\n\r\n.icofont-emo-astonished:before {\r\n\tcontent: \"\\ebb0\";\r\n}\r\n\r\n.icofont-emo-confounded:before {\r\n\tcontent: \"\\ebb1\";\r\n}\r\n\r\n.icofont-emo-confused:before {\r\n\tcontent: \"\\ebb2\";\r\n}\r\n\r\n.icofont-emo-crying:before {\r\n\tcontent: \"\\ebb3\";\r\n}\r\n\r\n.icofont-emo-dizzy:before {\r\n\tcontent: \"\\ebb4\";\r\n}\r\n\r\n.icofont-emo-expressionless:before {\r\n\tcontent: \"\\ebb5\";\r\n}\r\n\r\n.icofont-emo-heart-eyes:before {\r\n\tcontent: \"\\ebb6\";\r\n}\r\n\r\n.icofont-emo-laughing:before {\r\n\tcontent: \"\\ebb7\";\r\n}\r\n\r\n.icofont-emo-nerd-smile:before {\r\n\tcontent: \"\\ebb8\";\r\n}\r\n\r\n.icofont-emo-open-mouth:before {\r\n\tcontent: \"\\ebb9\";\r\n}\r\n\r\n.icofont-emo-rage:before {\r\n\tcontent: \"\\ebba\";\r\n}\r\n\r\n.icofont-emo-rolling-eyes:before {\r\n\tcontent: \"\\ebbb\";\r\n}\r\n\r\n.icofont-emo-sad:before {\r\n\tcontent: \"\\ebbc\";\r\n}\r\n\r\n.icofont-emo-simple-smile:before {\r\n\tcontent: \"\\ebbd\";\r\n}\r\n\r\n.icofont-emo-slightly-smile:before {\r\n\tcontent: \"\\ebbe\";\r\n}\r\n\r\n.icofont-emo-smirk:before {\r\n\tcontent: \"\\ebbf\";\r\n}\r\n\r\n.icofont-emo-stuck-out-tongue:before {\r\n\tcontent: \"\\ebc0\";\r\n}\r\n\r\n.icofont-emo-wink-smile:before {\r\n\tcontent: \"\\ebc1\";\r\n}\r\n\r\n.icofont-emo-worried:before {\r\n\tcontent: \"\\ebc2\";\r\n}\r\n\r\n.icofont-architecture-alt:before {\r\n\tcontent: \"\\ebc3\";\r\n}\r\n\r\n.icofont-architecture:before {\r\n\tcontent: \"\\ebc4\";\r\n}\r\n\r\n.icofont-barricade:before {\r\n\tcontent: \"\\ebc5\";\r\n}\r\n\r\n.icofont-bricks:before {\r\n\tcontent: \"\\ebc6\";\r\n}\r\n\r\n.icofont-calculations:before {\r\n\tcontent: \"\\ebc7\";\r\n}\r\n\r\n.icofont-cement-mix:before {\r\n\tcontent: \"\\ebc8\";\r\n}\r\n\r\n.icofont-cement-mixer:before {\r\n\tcontent: \"\\ebc9\";\r\n}\r\n\r\n.icofont-danger-zone:before {\r\n\tcontent: \"\\ebca\";\r\n}\r\n\r\n.icofont-drill:before {\r\n\tcontent: \"\\ebcb\";\r\n}\r\n\r\n.icofont-eco-energy:before {\r\n\tcontent: \"\\ebcc\";\r\n}\r\n\r\n.icofont-eco-environmen:before {\r\n\tcontent: \"\\ebcd\";\r\n}\r\n\r\n.icofont-energy-air:before {\r\n\tcontent: \"\\ebce\";\r\n}\r\n\r\n.icofont-energy-oil:before {\r\n\tcontent: \"\\ebcf\";\r\n}\r\n\r\n.icofont-energy-savings:before {\r\n\tcontent: \"\\ebd0\";\r\n}\r\n\r\n.icofont-energy-solar:before {\r\n\tcontent: \"\\ebd1\";\r\n}\r\n\r\n.icofont-energy-water:before {\r\n\tcontent: \"\\ebd2\";\r\n}\r\n\r\n.icofont-engineer:before {\r\n\tcontent: \"\\ebd3\";\r\n}\r\n\r\n.icofont-fire-extinguisher-alt:before {\r\n\tcontent: \"\\ebd4\";\r\n}\r\n\r\n.icofont-fix-tools:before {\r\n\tcontent: \"\\ebd5\";\r\n}\r\n\r\n.icofont-glue-oil:before {\r\n\tcontent: \"\\ebd6\";\r\n}\r\n\r\n.icofont-hammer-alt:before {\r\n\tcontent: \"\\ebd7\";\r\n}\r\n\r\n.icofont-help-robot:before {\r\n\tcontent: \"\\ebd8\";\r\n}\r\n\r\n.icofont-industries-alt-1:before {\r\n\tcontent: \"\\ebd9\";\r\n}\r\n\r\n.icofont-industries-alt-2:before {\r\n\tcontent: \"\\ebda\";\r\n}\r\n\r\n.icofont-industries-alt-3:before {\r\n\tcontent: \"\\ebdb\";\r\n}\r\n\r\n.icofont-industries-alt-4:before {\r\n\tcontent: \"\\ebdc\";\r\n}\r\n\r\n.icofont-industries-alt-5:before {\r\n\tcontent: \"\\ebdd\";\r\n}\r\n\r\n.icofont-industries:before {\r\n\tcontent: \"\\ebde\";\r\n}\r\n\r\n.icofont-labour:before {\r\n\tcontent: \"\\ebdf\";\r\n}\r\n\r\n.icofont-mining:before {\r\n\tcontent: \"\\ebe0\";\r\n}\r\n\r\n.icofont-paint-brush:before {\r\n\tcontent: \"\\ebe1\";\r\n}\r\n\r\n.icofont-pollution:before {\r\n\tcontent: \"\\ebe2\";\r\n}\r\n\r\n.icofont-power-zone:before {\r\n\tcontent: \"\\ebe3\";\r\n}\r\n\r\n.icofont-radio-active:before {\r\n\tcontent: \"\\ebe4\";\r\n}\r\n\r\n.icofont-recycle-alt:before {\r\n\tcontent: \"\\ebe5\";\r\n}\r\n\r\n.icofont-recycling-man:before {\r\n\tcontent: \"\\ebe6\";\r\n}\r\n\r\n.icofont-safety-hat-light:before {\r\n\tcontent: \"\\ebe7\";\r\n}\r\n\r\n.icofont-safety-hat:before {\r\n\tcontent: \"\\ebe8\";\r\n}\r\n\r\n.icofont-saw:before {\r\n\tcontent: \"\\ebe9\";\r\n}\r\n\r\n.icofont-screw-driver:before {\r\n\tcontent: \"\\ebea\";\r\n}\r\n\r\n.icofont-settings-alt:before {\r\n\tcontent: \"\\ebeb\";\r\n}\r\n\r\n.icofont-tools-alt-1:before {\r\n\tcontent: \"\\ebec\";\r\n}\r\n\r\n.icofont-tools-alt-2:before {\r\n\tcontent: \"\\ebed\";\r\n}\r\n\r\n.icofont-tools-bag:before {\r\n\tcontent: \"\\ebee\";\r\n}\r\n\r\n.icofont-trolley:before {\r\n\tcontent: \"\\ebef\";\r\n}\r\n\r\n.icofont-trowel:before {\r\n\tcontent: \"\\ebf0\";\r\n}\r\n\r\n.icofont-under-construction-alt:before {\r\n\tcontent: \"\\ebf1\";\r\n}\r\n\r\n.icofont-under-construction:before {\r\n\tcontent: \"\\ebf2\";\r\n}\r\n\r\n.icofont-vehicle-cement:before {\r\n\tcontent: \"\\ebf3\";\r\n}\r\n\r\n.icofont-vehicle-crane:before {\r\n\tcontent: \"\\ebf4\";\r\n}\r\n\r\n.icofont-vehicle-delivery-van:before {\r\n\tcontent: \"\\ebf5\";\r\n}\r\n\r\n.icofont-vehicle-dozer:before {\r\n\tcontent: \"\\ebf6\";\r\n}\r\n\r\n.icofont-vehicle-excavator:before {\r\n\tcontent: \"\\ebf7\";\r\n}\r\n\r\n.icofont-vehicle-trucktor:before {\r\n\tcontent: \"\\ebf8\";\r\n}\r\n\r\n.icofont-vehicle-wrecking:before {\r\n\tcontent: \"\\ebf9\";\r\n}\r\n\r\n.icofont-worker-group:before {\r\n\tcontent: \"\\ebfa\";\r\n}\r\n\r\n.icofont-worker:before {\r\n\tcontent: \"\\ebfb\";\r\n}\r\n\r\n.icofont-wrench:before {\r\n\tcontent: \"\\ebfc\";\r\n}\r\n\r\n.icofont-file-audio:before {\r\n\tcontent: \"\\ebfd\";\r\n}\r\n\r\n.icofont-file-avi-mp4:before {\r\n\tcontent: \"\\ebfe\";\r\n}\r\n\r\n.icofont-file-bmp:before {\r\n\tcontent: \"\\ebff\";\r\n}\r\n\r\n.icofont-file-code:before {\r\n\tcontent: \"\\ec00\";\r\n}\r\n\r\n.icofont-file-css:before {\r\n\tcontent: \"\\ec01\";\r\n}\r\n\r\n.icofont-file-document:before {\r\n\tcontent: \"\\ec02\";\r\n}\r\n\r\n.icofont-file-eps:before {\r\n\tcontent: \"\\ec03\";\r\n}\r\n\r\n.icofont-file-excel:before {\r\n\tcontent: \"\\ec04\";\r\n}\r\n\r\n.icofont-file-exe:before {\r\n\tcontent: \"\\ec05\";\r\n}\r\n\r\n.icofont-file-file:before {\r\n\tcontent: \"\\ec06\";\r\n}\r\n\r\n.icofont-file-flv:before {\r\n\tcontent: \"\\ec07\";\r\n}\r\n\r\n.icofont-file-gif:before {\r\n\tcontent: \"\\ec08\";\r\n}\r\n\r\n.icofont-file-html5:before {\r\n\tcontent: \"\\ec09\";\r\n}\r\n\r\n.icofont-file-image:before {\r\n\tcontent: \"\\ec0a\";\r\n}\r\n\r\n.icofont-file-iso:before {\r\n\tcontent: \"\\ec0b\";\r\n}\r\n\r\n.icofont-file-java:before {\r\n\tcontent: \"\\ec0c\";\r\n}\r\n\r\n.icofont-file-javascript:before {\r\n\tcontent: \"\\ec0d\";\r\n}\r\n\r\n.icofont-file-jpg:before {\r\n\tcontent: \"\\ec0e\";\r\n}\r\n\r\n.icofont-file-midi:before {\r\n\tcontent: \"\\ec0f\";\r\n}\r\n\r\n.icofont-file-mov:before {\r\n\tcontent: \"\\ec10\";\r\n}\r\n\r\n.icofont-file-mp3:before {\r\n\tcontent: \"\\ec11\";\r\n}\r\n\r\n.icofont-file-pdf:before {\r\n\tcontent: \"\\ec12\";\r\n}\r\n\r\n.icofont-file-php:before {\r\n\tcontent: \"\\ec13\";\r\n}\r\n\r\n.icofont-file-png:before {\r\n\tcontent: \"\\ec14\";\r\n}\r\n\r\n.icofont-file-powerpoint:before {\r\n\tcontent: \"\\ec15\";\r\n}\r\n\r\n.icofont-file-presentation:before {\r\n\tcontent: \"\\ec16\";\r\n}\r\n\r\n.icofont-file-psb:before {\r\n\tcontent: \"\\ec17\";\r\n}\r\n\r\n.icofont-file-psd:before {\r\n\tcontent: \"\\ec18\";\r\n}\r\n\r\n.icofont-file-python:before {\r\n\tcontent: \"\\ec19\";\r\n}\r\n\r\n.icofont-file-ruby:before {\r\n\tcontent: \"\\ec1a\";\r\n}\r\n\r\n.icofont-file-spreadsheet:before {\r\n\tcontent: \"\\ec1b\";\r\n}\r\n\r\n.icofont-file-sql:before {\r\n\tcontent: \"\\ec1c\";\r\n}\r\n\r\n.icofont-file-svg:before {\r\n\tcontent: \"\\ec1d\";\r\n}\r\n\r\n.icofont-file-text:before {\r\n\tcontent: \"\\ec1e\";\r\n}\r\n\r\n.icofont-file-tiff:before {\r\n\tcontent: \"\\ec1f\";\r\n}\r\n\r\n.icofont-file-video:before {\r\n\tcontent: \"\\ec20\";\r\n}\r\n\r\n.icofont-file-wave:before {\r\n\tcontent: \"\\ec21\";\r\n}\r\n\r\n.icofont-file-wmv:before {\r\n\tcontent: \"\\ec22\";\r\n}\r\n\r\n.icofont-file-word:before {\r\n\tcontent: \"\\ec23\";\r\n}\r\n\r\n.icofont-file-zip:before {\r\n\tcontent: \"\\ec24\";\r\n}\r\n\r\n.icofont-apple:before {\r\n\tcontent: \"\\ec25\";\r\n}\r\n\r\n.icofont-arabian-coffee:before {\r\n\tcontent: \"\\ec26\";\r\n}\r\n\r\n.icofont-artichoke:before {\r\n\tcontent: \"\\ec27\";\r\n}\r\n\r\n.icofont-asparagus:before {\r\n\tcontent: \"\\ec28\";\r\n}\r\n\r\n.icofont-avocado:before {\r\n\tcontent: \"\\ec29\";\r\n}\r\n\r\n.icofont-baby-food:before {\r\n\tcontent: \"\\ec2a\";\r\n}\r\n\r\n.icofont-banana:before {\r\n\tcontent: \"\\ec2b\";\r\n}\r\n\r\n.icofont-bbq:before {\r\n\tcontent: \"\\ec2c\";\r\n}\r\n\r\n.icofont-beans:before {\r\n\tcontent: \"\\ec2d\";\r\n}\r\n\r\n.icofont-beer:before {\r\n\tcontent: \"\\ec2e\";\r\n}\r\n\r\n.icofont-bell-pepper-capsicum:before {\r\n\tcontent: \"\\ec2f\";\r\n}\r\n\r\n.icofont-birthday-cake:before {\r\n\tcontent: \"\\ec30\";\r\n}\r\n\r\n.icofont-bread:before {\r\n\tcontent: \"\\ec31\";\r\n}\r\n\r\n.icofont-broccoli:before {\r\n\tcontent: \"\\ec32\";\r\n}\r\n\r\n.icofont-burger:before {\r\n\tcontent: \"\\ec33\";\r\n}\r\n\r\n.icofont-cabbage:before {\r\n\tcontent: \"\\ec34\";\r\n}\r\n\r\n.icofont-carrot:before {\r\n\tcontent: \"\\ec35\";\r\n}\r\n\r\n.icofont-cauli-flower:before {\r\n\tcontent: \"\\ec36\";\r\n}\r\n\r\n.icofont-cheese:before {\r\n\tcontent: \"\\ec37\";\r\n}\r\n\r\n.icofont-chef:before {\r\n\tcontent: \"\\ec38\";\r\n}\r\n\r\n.icofont-cherry:before {\r\n\tcontent: \"\\ec39\";\r\n}\r\n\r\n.icofont-chicken-fry:before {\r\n\tcontent: \"\\ec3a\";\r\n}\r\n\r\n.icofont-chicken:before {\r\n\tcontent: \"\\ec3b\";\r\n}\r\n\r\n.icofont-cocktail:before {\r\n\tcontent: \"\\ec3c\";\r\n}\r\n\r\n.icofont-coconut:before {\r\n\tcontent: \"\\ec3d\";\r\n}\r\n\r\n.icofont-coffee-alt:before {\r\n\tcontent: \"\\ec3e\";\r\n}\r\n\r\n.icofont-coffee-mug:before {\r\n\tcontent: \"\\ec3f\";\r\n}\r\n\r\n.icofont-coffee-pot:before {\r\n\tcontent: \"\\ec40\";\r\n}\r\n\r\n.icofont-cola:before {\r\n\tcontent: \"\\ec41\";\r\n}\r\n\r\n.icofont-corn:before {\r\n\tcontent: \"\\ec42\";\r\n}\r\n\r\n.icofont-croissant:before {\r\n\tcontent: \"\\ec43\";\r\n}\r\n\r\n.icofont-crop-plant:before {\r\n\tcontent: \"\\ec44\";\r\n}\r\n\r\n.icofont-cucumber:before {\r\n\tcontent: \"\\ec45\";\r\n}\r\n\r\n.icofont-cup-cake:before {\r\n\tcontent: \"\\ec46\";\r\n}\r\n\r\n.icofont-dining-table:before {\r\n\tcontent: \"\\ec47\";\r\n}\r\n\r\n.icofont-donut:before {\r\n\tcontent: \"\\ec48\";\r\n}\r\n\r\n.icofont-egg-plant:before {\r\n\tcontent: \"\\ec49\";\r\n}\r\n\r\n.icofont-egg-poached:before {\r\n\tcontent: \"\\ec4a\";\r\n}\r\n\r\n.icofont-farmer:before {\r\n\tcontent: \"\\ec4b\";\r\n}\r\n\r\n.icofont-farmer1:before {\r\n\tcontent: \"\\ec4c\";\r\n}\r\n\r\n.icofont-fast-food:before {\r\n\tcontent: \"\\ec4d\";\r\n}\r\n\r\n.icofont-fish:before {\r\n\tcontent: \"\\ec4e\";\r\n}\r\n\r\n.icofont-food-basket:before {\r\n\tcontent: \"\\ec4f\";\r\n}\r\n\r\n.icofont-food-cart:before {\r\n\tcontent: \"\\ec50\";\r\n}\r\n\r\n.icofont-fork-and-knife:before {\r\n\tcontent: \"\\ec51\";\r\n}\r\n\r\n.icofont-french-fries:before {\r\n\tcontent: \"\\ec52\";\r\n}\r\n\r\n.icofont-fresh-juice:before {\r\n\tcontent: \"\\ec53\";\r\n}\r\n\r\n.icofont-fruits:before {\r\n\tcontent: \"\\ec54\";\r\n}\r\n\r\n.icofont-grapes:before {\r\n\tcontent: \"\\ec55\";\r\n}\r\n\r\n.icofont-honey:before {\r\n\tcontent: \"\\ec56\";\r\n}\r\n\r\n.icofont-hot-dog:before {\r\n\tcontent: \"\\ec57\";\r\n}\r\n\r\n.icofont-hotel-alt:before {\r\n\tcontent: \"\\ec58\";\r\n}\r\n\r\n.icofont-ice-cream-alt:before {\r\n\tcontent: \"\\ec59\";\r\n}\r\n\r\n.icofont-ice-cream:before {\r\n\tcontent: \"\\ec5a\";\r\n}\r\n\r\n.icofont-ketchup:before {\r\n\tcontent: \"\\ec5b\";\r\n}\r\n\r\n.icofont-kiwi:before {\r\n\tcontent: \"\\ec5c\";\r\n}\r\n\r\n.icofont-layered-cake:before {\r\n\tcontent: \"\\ec5d\";\r\n}\r\n\r\n.icofont-lemon-alt:before {\r\n\tcontent: \"\\ec5e\";\r\n}\r\n\r\n.icofont-lobster:before {\r\n\tcontent: \"\\ec5f\";\r\n}\r\n\r\n.icofont-mango:before {\r\n\tcontent: \"\\ec60\";\r\n}\r\n\r\n.icofont-milk:before {\r\n\tcontent: \"\\ec61\";\r\n}\r\n\r\n.icofont-mushroom:before {\r\n\tcontent: \"\\ec62\";\r\n}\r\n\r\n.icofont-noodles:before {\r\n\tcontent: \"\\ec63\";\r\n}\r\n\r\n.icofont-onion:before {\r\n\tcontent: \"\\ec64\";\r\n}\r\n\r\n.icofont-orange:before {\r\n\tcontent: \"\\ec65\";\r\n}\r\n\r\n.icofont-pear:before {\r\n\tcontent: \"\\ec66\";\r\n}\r\n\r\n.icofont-peas:before {\r\n\tcontent: \"\\ec67\";\r\n}\r\n\r\n.icofont-pepper:before {\r\n\tcontent: \"\\ec68\";\r\n}\r\n\r\n.icofont-pie-alt:before {\r\n\tcontent: \"\\ec69\";\r\n}\r\n\r\n.icofont-pineapple:before {\r\n\tcontent: \"\\ec6a\";\r\n}\r\n\r\n.icofont-pizza-slice:before {\r\n\tcontent: \"\\ec6b\";\r\n}\r\n\r\n.icofont-pizza:before {\r\n\tcontent: \"\\ec6c\";\r\n}\r\n\r\n.icofont-plant:before {\r\n\tcontent: \"\\ec6d\";\r\n}\r\n\r\n.icofont-popcorn:before {\r\n\tcontent: \"\\ec6e\";\r\n}\r\n\r\n.icofont-potato:before {\r\n\tcontent: \"\\ec6f\";\r\n}\r\n\r\n.icofont-pumpkin:before {\r\n\tcontent: \"\\ec70\";\r\n}\r\n\r\n.icofont-raddish:before {\r\n\tcontent: \"\\ec71\";\r\n}\r\n\r\n.icofont-restaurant-menu:before {\r\n\tcontent: \"\\ec72\";\r\n}\r\n\r\n.icofont-restaurant:before {\r\n\tcontent: \"\\ec73\";\r\n}\r\n\r\n.icofont-salt-and-pepper:before {\r\n\tcontent: \"\\ec74\";\r\n}\r\n\r\n.icofont-sandwich:before {\r\n\tcontent: \"\\ec75\";\r\n}\r\n\r\n.icofont-sausage:before {\r\n\tcontent: \"\\ec76\";\r\n}\r\n\r\n.icofont-shrimp:before {\r\n\tcontent: \"\\ec77\";\r\n}\r\n\r\n.icofont-sof-drinks:before {\r\n\tcontent: \"\\ec78\";\r\n}\r\n\r\n.icofont-soup-bowl:before {\r\n\tcontent: \"\\ec79\";\r\n}\r\n\r\n.icofont-spoon-and-fork:before {\r\n\tcontent: \"\\ec7a\";\r\n}\r\n\r\n.icofont-steak:before {\r\n\tcontent: \"\\ec7b\";\r\n}\r\n\r\n.icofont-strawberry:before {\r\n\tcontent: \"\\ec7c\";\r\n}\r\n\r\n.icofont-sub-sandwich:before {\r\n\tcontent: \"\\ec7d\";\r\n}\r\n\r\n.icofont-sushi:before {\r\n\tcontent: \"\\ec7e\";\r\n}\r\n\r\n.icofont-taco:before {\r\n\tcontent: \"\\ec7f\";\r\n}\r\n\r\n.icofont-tea-pot:before {\r\n\tcontent: \"\\ec80\";\r\n}\r\n\r\n.icofont-tea:before {\r\n\tcontent: \"\\ec81\";\r\n}\r\n\r\n.icofont-tomato:before {\r\n\tcontent: \"\\ec82\";\r\n}\r\n\r\n.icofont-waiter-alt:before {\r\n\tcontent: \"\\ec83\";\r\n}\r\n\r\n.icofont-watermelon:before {\r\n\tcontent: \"\\ec84\";\r\n}\r\n\r\n.icofont-wheat:before {\r\n\tcontent: \"\\ec85\";\r\n}\r\n\r\n.icofont-abc:before {\r\n\tcontent: \"\\ec86\";\r\n}\r\n\r\n.icofont-baby-cloth:before {\r\n\tcontent: \"\\ec87\";\r\n}\r\n\r\n.icofont-baby-milk-bottle:before {\r\n\tcontent: \"\\ec88\";\r\n}\r\n\r\n.icofont-baby-trolley:before {\r\n\tcontent: \"\\ec89\";\r\n}\r\n\r\n.icofont-back-pack:before {\r\n\tcontent: \"\\ec8a\";\r\n}\r\n\r\n.icofont-candy:before {\r\n\tcontent: \"\\ec8b\";\r\n}\r\n\r\n.icofont-cycling:before {\r\n\tcontent: \"\\ec8c\";\r\n}\r\n\r\n.icofont-holding-hands:before {\r\n\tcontent: \"\\ec8d\";\r\n}\r\n\r\n.icofont-infant-nipple:before {\r\n\tcontent: \"\\ec8e\";\r\n}\r\n\r\n.icofont-kids-scooter:before {\r\n\tcontent: \"\\ec8f\";\r\n}\r\n\r\n.icofont-safety-pin:before {\r\n\tcontent: \"\\ec90\";\r\n}\r\n\r\n.icofont-teddy-bear:before {\r\n\tcontent: \"\\ec91\";\r\n}\r\n\r\n.icofont-toy-ball:before {\r\n\tcontent: \"\\ec92\";\r\n}\r\n\r\n.icofont-toy-cat:before {\r\n\tcontent: \"\\ec93\";\r\n}\r\n\r\n.icofont-toy-duck:before {\r\n\tcontent: \"\\ec94\";\r\n}\r\n\r\n.icofont-toy-elephant:before {\r\n\tcontent: \"\\ec95\";\r\n}\r\n\r\n.icofont-toy-hand:before {\r\n\tcontent: \"\\ec96\";\r\n}\r\n\r\n.icofont-toy-horse:before {\r\n\tcontent: \"\\ec97\";\r\n}\r\n\r\n.icofont-toy-lattu:before {\r\n\tcontent: \"\\ec98\";\r\n}\r\n\r\n.icofont-toy-train:before {\r\n\tcontent: \"\\ec99\";\r\n}\r\n\r\n.icofont-unique-idea:before {\r\n\tcontent: \"\\ec9a\";\r\n}\r\n\r\n.icofont-bag-alt:before {\r\n\tcontent: \"\\ec9b\";\r\n}\r\n\r\n.icofont-burglar:before {\r\n\tcontent: \"\\ec9c\";\r\n}\r\n\r\n.icofont-cannon-firing:before {\r\n\tcontent: \"\\ec9d\";\r\n}\r\n\r\n.icofont-cc-camera:before {\r\n\tcontent: \"\\ec9e\";\r\n}\r\n\r\n.icofont-cop-badge:before {\r\n\tcontent: \"\\ec9f\";\r\n}\r\n\r\n.icofont-cop:before {\r\n\tcontent: \"\\eca0\";\r\n}\r\n\r\n.icofont-court-hammer:before {\r\n\tcontent: \"\\eca1\";\r\n}\r\n\r\n.icofont-court:before {\r\n\tcontent: \"\\eca2\";\r\n}\r\n\r\n.icofont-finger-print:before {\r\n\tcontent: \"\\eca3\";\r\n}\r\n\r\n.icofont-handcuff-alt:before {\r\n\tcontent: \"\\eca4\";\r\n}\r\n\r\n.icofont-handcuff:before {\r\n\tcontent: \"\\eca5\";\r\n}\r\n\r\n.icofont-investigation:before {\r\n\tcontent: \"\\eca6\";\r\n}\r\n\r\n.icofont-investigator:before {\r\n\tcontent: \"\\eca7\";\r\n}\r\n\r\n.icofont-jail:before {\r\n\tcontent: \"\\eca8\";\r\n}\r\n\r\n.icofont-judge:before {\r\n\tcontent: \"\\eca9\";\r\n}\r\n\r\n.icofont-law-alt-1:before {\r\n\tcontent: \"\\ecaa\";\r\n}\r\n\r\n.icofont-law-alt-2:before {\r\n\tcontent: \"\\ecab\";\r\n}\r\n\r\n.icofont-law-alt-3:before {\r\n\tcontent: \"\\ecac\";\r\n}\r\n\r\n.icofont-law-book:before {\r\n\tcontent: \"\\ecad\";\r\n}\r\n\r\n.icofont-law-document:before {\r\n\tcontent: \"\\ecae\";\r\n}\r\n\r\n.icofont-law:before {\r\n\tcontent: \"\\ecaf\";\r\n}\r\n\r\n.icofont-lawyer-alt-1:before {\r\n\tcontent: \"\\ecb0\";\r\n}\r\n\r\n.icofont-lawyer-alt-2:before {\r\n\tcontent: \"\\ecb1\";\r\n}\r\n\r\n.icofont-lawyer:before {\r\n\tcontent: \"\\ecb2\";\r\n}\r\n\r\n.icofont-order:before {\r\n\tcontent: \"\\ecb3\";\r\n}\r\n\r\n.icofont-pistol:before {\r\n\tcontent: \"\\ecb4\";\r\n}\r\n\r\n.icofont-police-badge:before {\r\n\tcontent: \"\\ecb5\";\r\n}\r\n\r\n.icofont-police-cap:before {\r\n\tcontent: \"\\ecb6\";\r\n}\r\n\r\n.icofont-police-car-alt-1:before {\r\n\tcontent: \"\\ecb7\";\r\n}\r\n\r\n.icofont-police-car-alt-2:before {\r\n\tcontent: \"\\ecb8\";\r\n}\r\n\r\n.icofont-police-hat:before {\r\n\tcontent: \"\\ecb9\";\r\n}\r\n\r\n.icofont-police-van:before {\r\n\tcontent: \"\\ecba\";\r\n}\r\n\r\n.icofont-police:before {\r\n\tcontent: \"\\ecbb\";\r\n}\r\n\r\n.icofont-protect:before {\r\n\tcontent: \"\\ecbc\";\r\n}\r\n\r\n.icofont-scales:before {\r\n\tcontent: \"\\ecbd\";\r\n}\r\n\r\n.icofont-thief-alt:before {\r\n\tcontent: \"\\ecbe\";\r\n}\r\n\r\n.icofont-thief:before {\r\n\tcontent: \"\\ecbf\";\r\n}\r\n\r\n.icofont-abacus-alt:before {\r\n\tcontent: \"\\ecc0\";\r\n}\r\n\r\n.icofont-abacus:before {\r\n\tcontent: \"\\ecc1\";\r\n}\r\n\r\n.icofont-angle:before {\r\n\tcontent: \"\\ecc2\";\r\n}\r\n\r\n.icofont-calculator-alt-1:before {\r\n\tcontent: \"\\ecc3\";\r\n}\r\n\r\n.icofont-calculator-alt-2:before {\r\n\tcontent: \"\\ecc4\";\r\n}\r\n\r\n.icofont-circle-ruler-alt:before {\r\n\tcontent: \"\\ecc5\";\r\n}\r\n\r\n.icofont-circle-ruler:before {\r\n\tcontent: \"\\ecc6\";\r\n}\r\n\r\n.icofont-compass-alt-1:before {\r\n\tcontent: \"\\ecc7\";\r\n}\r\n\r\n.icofont-compass-alt-2:before {\r\n\tcontent: \"\\ecc8\";\r\n}\r\n\r\n.icofont-compass-alt-3:before {\r\n\tcontent: \"\\ecc9\";\r\n}\r\n\r\n.icofont-compass-alt-4:before {\r\n\tcontent: \"\\ecca\";\r\n}\r\n\r\n.icofont-degrees-alt-1:before {\r\n\tcontent: \"\\eccb\";\r\n}\r\n\r\n.icofont-degrees-alt-2:before {\r\n\tcontent: \"\\eccc\";\r\n}\r\n\r\n.icofont-degrees:before {\r\n\tcontent: \"\\eccd\";\r\n}\r\n\r\n.icofont-golden-ratio:before {\r\n\tcontent: \"\\ecce\";\r\n}\r\n\r\n.icofont-marker-alt-1:before {\r\n\tcontent: \"\\eccf\";\r\n}\r\n\r\n.icofont-marker-alt-2:before {\r\n\tcontent: \"\\ecd0\";\r\n}\r\n\r\n.icofont-marker-alt-3:before {\r\n\tcontent: \"\\ecd1\";\r\n}\r\n\r\n.icofont-mathematical-alt-1:before {\r\n\tcontent: \"\\ecd2\";\r\n}\r\n\r\n.icofont-mathematical-alt-2:before {\r\n\tcontent: \"\\ecd3\";\r\n}\r\n\r\n.icofont-mathematical:before {\r\n\tcontent: \"\\ecd4\";\r\n}\r\n\r\n.icofont-pen-alt-1:before {\r\n\tcontent: \"\\ecd5\";\r\n}\r\n\r\n.icofont-pen-alt-2:before {\r\n\tcontent: \"\\ecd6\";\r\n}\r\n\r\n.icofont-pen-alt-3:before {\r\n\tcontent: \"\\ecd7\";\r\n}\r\n\r\n.icofont-pen-holder-alt-1:before {\r\n\tcontent: \"\\ecd8\";\r\n}\r\n\r\n.icofont-pen-holder:before {\r\n\tcontent: \"\\ecd9\";\r\n}\r\n\r\n.icofont-pencil-alt-1:before {\r\n\tcontent: \"\\ecda\";\r\n}\r\n\r\n.icofont-pencil-alt-2:before {\r\n\tcontent: \"\\ecdb\";\r\n}\r\n\r\n.icofont-pencil-alt-3:before {\r\n\tcontent: \"\\ecdc\";\r\n}\r\n\r\n.icofont-pencil-alt-4:before {\r\n\tcontent: \"\\ecdd\";\r\n}\r\n\r\n.icofont-ruler-alt-1:before {\r\n\tcontent: \"\\ecde\";\r\n}\r\n\r\n.icofont-ruler-alt-2:before {\r\n\tcontent: \"\\ecdf\";\r\n}\r\n\r\n.icofont-ruler-compass-alt:before {\r\n\tcontent: \"\\ece0\";\r\n}\r\n\r\n.icofont-ruler-compass:before {\r\n\tcontent: \"\\ece1\";\r\n}\r\n\r\n.icofont-ruler-pencil-alt-1:before {\r\n\tcontent: \"\\ece2\";\r\n}\r\n\r\n.icofont-ruler-pencil-alt-2:before {\r\n\tcontent: \"\\ece3\";\r\n}\r\n\r\n.icofont-ruler-pencil:before {\r\n\tcontent: \"\\ece4\";\r\n}\r\n\r\n.icofont-ruler:before {\r\n\tcontent: \"\\ece5\";\r\n}\r\n\r\n.icofont-rulers-alt:before {\r\n\tcontent: \"\\ece6\";\r\n}\r\n\r\n.icofont-rulers:before {\r\n\tcontent: \"\\ece7\";\r\n}\r\n\r\n.icofont-square-root:before {\r\n\tcontent: \"\\ece8\";\r\n}\r\n\r\n.icofont-aids:before {\r\n\tcontent: \"\\ece9\";\r\n}\r\n\r\n.icofont-ambulance:before {\r\n\tcontent: \"\\ecea\";\r\n}\r\n\r\n.icofont-autism:before {\r\n\tcontent: \"\\eceb\";\r\n}\r\n\r\n.icofont-bandage:before {\r\n\tcontent: \"\\ecec\";\r\n}\r\n\r\n.icofont-bed-patient:before {\r\n\tcontent: \"\\eced\";\r\n}\r\n\r\n.icofont-blind:before {\r\n\tcontent: \"\\ecee\";\r\n}\r\n\r\n.icofont-blood-drop:before {\r\n\tcontent: \"\\ecef\";\r\n}\r\n\r\n.icofont-blood-test:before {\r\n\tcontent: \"\\ecf0\";\r\n}\r\n\r\n.icofont-blood:before {\r\n\tcontent: \"\\ecf1\";\r\n}\r\n\r\n.icofont-capsule:before {\r\n\tcontent: \"\\ecf2\";\r\n}\r\n\r\n.icofont-crutches:before {\r\n\tcontent: \"\\ecf3\";\r\n}\r\n\r\n.icofont-dna-alt-1:before {\r\n\tcontent: \"\\ecf4\";\r\n}\r\n\r\n.icofont-dna:before {\r\n\tcontent: \"\\ecf5\";\r\n}\r\n\r\n.icofont-doctor-alt:before {\r\n\tcontent: \"\\ecf6\";\r\n}\r\n\r\n.icofont-doctor:before {\r\n\tcontent: \"\\ecf7\";\r\n}\r\n\r\n.icofont-drug-pack:before {\r\n\tcontent: \"\\ecf8\";\r\n}\r\n\r\n.icofont-drug:before {\r\n\tcontent: \"\\ecf9\";\r\n}\r\n\r\n.icofont-eye-alt:before {\r\n\tcontent: \"\\ecfa\";\r\n}\r\n\r\n.icofont-first-aid-alt:before {\r\n\tcontent: \"\\ecfb\";\r\n}\r\n\r\n.icofont-garbage:before {\r\n\tcontent: \"\\ecfc\";\r\n}\r\n\r\n.icofont-heart-alt:before {\r\n\tcontent: \"\\ecfd\";\r\n}\r\n\r\n.icofont-heartbeat:before {\r\n\tcontent: \"\\ecfe\";\r\n}\r\n\r\n.icofont-herbal:before {\r\n\tcontent: \"\\ecff\";\r\n}\r\n\r\n.icofont-hospital:before {\r\n\tcontent: \"\\ed00\";\r\n}\r\n\r\n.icofont-icu:before {\r\n\tcontent: \"\\ed01\";\r\n}\r\n\r\n.icofont-injection-syringe:before {\r\n\tcontent: \"\\ed02\";\r\n}\r\n\r\n.icofont-laboratory:before {\r\n\tcontent: \"\\ed03\";\r\n}\r\n\r\n.icofont-medical-sign-alt:before {\r\n\tcontent: \"\\ed04\";\r\n}\r\n\r\n.icofont-medical-sign:before {\r\n\tcontent: \"\\ed05\";\r\n}\r\n\r\n.icofont-nurse-alt:before {\r\n\tcontent: \"\\ed06\";\r\n}\r\n\r\n.icofont-nurse:before {\r\n\tcontent: \"\\ed07\";\r\n}\r\n\r\n.icofont-nursing-home:before {\r\n\tcontent: \"\\ed08\";\r\n}\r\n\r\n.icofont-operation-theater:before {\r\n\tcontent: \"\\ed09\";\r\n}\r\n\r\n.icofont-paralysis-disability:before {\r\n\tcontent: \"\\ed0a\";\r\n}\r\n\r\n.icofont-pills:before {\r\n\tcontent: \"\\ed0b\";\r\n}\r\n\r\n.icofont-prescription:before {\r\n\tcontent: \"\\ed0c\";\r\n}\r\n\r\n.icofont-pulse:before {\r\n\tcontent: \"\\ed0d\";\r\n}\r\n\r\n.icofont-stethoscope-alt:before {\r\n\tcontent: \"\\ed0e\";\r\n}\r\n\r\n.icofont-stethoscope:before {\r\n\tcontent: \"\\ed0f\";\r\n}\r\n\r\n.icofont-stretcher:before {\r\n\tcontent: \"\\ed10\";\r\n}\r\n\r\n.icofont-surgeon-alt:before {\r\n\tcontent: \"\\ed11\";\r\n}\r\n\r\n.icofont-surgeon:before {\r\n\tcontent: \"\\ed12\";\r\n}\r\n\r\n.icofont-tablets:before {\r\n\tcontent: \"\\ed13\";\r\n}\r\n\r\n.icofont-test-bottle:before {\r\n\tcontent: \"\\ed14\";\r\n}\r\n\r\n.icofont-test-tube:before {\r\n\tcontent: \"\\ed15\";\r\n}\r\n\r\n.icofont-thermometer-alt:before {\r\n\tcontent: \"\\ed16\";\r\n}\r\n\r\n.icofont-tooth:before {\r\n\tcontent: \"\\ed17\";\r\n}\r\n\r\n.icofont-xray:before {\r\n\tcontent: \"\\ed18\";\r\n}\r\n\r\n.icofont-ui-add:before {\r\n\tcontent: \"\\ed19\";\r\n}\r\n\r\n.icofont-ui-alarm:before {\r\n\tcontent: \"\\ed1a\";\r\n}\r\n\r\n.icofont-ui-battery:before {\r\n\tcontent: \"\\ed1b\";\r\n}\r\n\r\n.icofont-ui-block:before {\r\n\tcontent: \"\\ed1c\";\r\n}\r\n\r\n.icofont-ui-bluetooth:before {\r\n\tcontent: \"\\ed1d\";\r\n}\r\n\r\n.icofont-ui-brightness:before {\r\n\tcontent: \"\\ed1e\";\r\n}\r\n\r\n.icofont-ui-browser:before {\r\n\tcontent: \"\\ed1f\";\r\n}\r\n\r\n.icofont-ui-calculator:before {\r\n\tcontent: \"\\ed20\";\r\n}\r\n\r\n.icofont-ui-calendar:before {\r\n\tcontent: \"\\ed21\";\r\n}\r\n\r\n.icofont-ui-call:before {\r\n\tcontent: \"\\ed22\";\r\n}\r\n\r\n.icofont-ui-camera:before {\r\n\tcontent: \"\\ed23\";\r\n}\r\n\r\n.icofont-ui-cart:before {\r\n\tcontent: \"\\ed24\";\r\n}\r\n\r\n.icofont-ui-cell-phone:before {\r\n\tcontent: \"\\ed25\";\r\n}\r\n\r\n.icofont-ui-chat:before {\r\n\tcontent: \"\\ed26\";\r\n}\r\n\r\n.icofont-ui-check:before {\r\n\tcontent: \"\\ed27\";\r\n}\r\n\r\n.icofont-ui-clip-board:before {\r\n\tcontent: \"\\ed28\";\r\n}\r\n\r\n.icofont-ui-clip:before {\r\n\tcontent: \"\\ed29\";\r\n}\r\n\r\n.icofont-ui-clock:before {\r\n\tcontent: \"\\ed2a\";\r\n}\r\n\r\n.icofont-ui-close:before {\r\n\tcontent: \"\\ed2b\";\r\n}\r\n\r\n.icofont-ui-contact-list:before {\r\n\tcontent: \"\\ed2c\";\r\n}\r\n\r\n.icofont-ui-copy:before {\r\n\tcontent: \"\\ed2d\";\r\n}\r\n\r\n.icofont-ui-cut:before {\r\n\tcontent: \"\\ed2e\";\r\n}\r\n\r\n.icofont-ui-delete:before {\r\n\tcontent: \"\\ed2f\";\r\n}\r\n\r\n.icofont-ui-dial-phone:before {\r\n\tcontent: \"\\ed30\";\r\n}\r\n\r\n.icofont-ui-edit:before {\r\n\tcontent: \"\\ed31\";\r\n}\r\n\r\n.icofont-ui-email:before {\r\n\tcontent: \"\\ed32\";\r\n}\r\n\r\n.icofont-ui-file:before {\r\n\tcontent: \"\\ed33\";\r\n}\r\n\r\n.icofont-ui-fire-wall:before {\r\n\tcontent: \"\\ed34\";\r\n}\r\n\r\n.icofont-ui-flash-light:before {\r\n\tcontent: \"\\ed35\";\r\n}\r\n\r\n.icofont-ui-flight:before {\r\n\tcontent: \"\\ed36\";\r\n}\r\n\r\n.icofont-ui-folder:before {\r\n\tcontent: \"\\ed37\";\r\n}\r\n\r\n.icofont-ui-game:before {\r\n\tcontent: \"\\ed38\";\r\n}\r\n\r\n.icofont-ui-handicapped:before {\r\n\tcontent: \"\\ed39\";\r\n}\r\n\r\n.icofont-ui-head-phone:before {\r\n\tcontent: \"\\ed3a\";\r\n}\r\n\r\n.icofont-ui-home:before {\r\n\tcontent: \"\\ed3b\";\r\n}\r\n\r\n.icofont-ui-image:before {\r\n\tcontent: \"\\ed3c\";\r\n}\r\n\r\n.icofont-ui-keyboard:before {\r\n\tcontent: \"\\ed3d\";\r\n}\r\n\r\n.icofont-ui-laoding:before {\r\n\tcontent: \"\\ed3e\";\r\n}\r\n\r\n.icofont-ui-lock:before {\r\n\tcontent: \"\\ed3f\";\r\n}\r\n\r\n.icofont-ui-love-add:before {\r\n\tcontent: \"\\ed40\";\r\n}\r\n\r\n.icofont-ui-love-broken:before {\r\n\tcontent: \"\\ed41\";\r\n}\r\n\r\n.icofont-ui-love-remove:before {\r\n\tcontent: \"\\ed42\";\r\n}\r\n\r\n.icofont-ui-love:before {\r\n\tcontent: \"\\ed43\";\r\n}\r\n\r\n.icofont-ui-map:before {\r\n\tcontent: \"\\ed44\";\r\n}\r\n\r\n.icofont-ui-message:before {\r\n\tcontent: \"\\ed45\";\r\n}\r\n\r\n.icofont-ui-messaging:before {\r\n\tcontent: \"\\ed46\";\r\n}\r\n\r\n.icofont-ui-movie:before {\r\n\tcontent: \"\\ed47\";\r\n}\r\n\r\n.icofont-ui-music-player:before {\r\n\tcontent: \"\\ed48\";\r\n}\r\n\r\n.icofont-ui-music:before {\r\n\tcontent: \"\\ed49\";\r\n}\r\n\r\n.icofont-ui-mute:before {\r\n\tcontent: \"\\ed4a\";\r\n}\r\n\r\n.icofont-ui-network:before {\r\n\tcontent: \"\\ed4b\";\r\n}\r\n\r\n.icofont-ui-next:before {\r\n\tcontent: \"\\ed4c\";\r\n}\r\n\r\n.icofont-ui-note:before {\r\n\tcontent: \"\\ed4d\";\r\n}\r\n\r\n.icofont-ui-office:before {\r\n\tcontent: \"\\ed4e\";\r\n}\r\n\r\n.icofont-ui-password:before {\r\n\tcontent: \"\\ed4f\";\r\n}\r\n\r\n.icofont-ui-pause:before {\r\n\tcontent: \"\\ed50\";\r\n}\r\n\r\n.icofont-ui-play-stop:before {\r\n\tcontent: \"\\ed51\";\r\n}\r\n\r\n.icofont-ui-play:before {\r\n\tcontent: \"\\ed52\";\r\n}\r\n\r\n.icofont-ui-pointer:before {\r\n\tcontent: \"\\ed53\";\r\n}\r\n\r\n.icofont-ui-power:before {\r\n\tcontent: \"\\ed54\";\r\n}\r\n\r\n.icofont-ui-press:before {\r\n\tcontent: \"\\ed55\";\r\n}\r\n\r\n.icofont-ui-previous:before {\r\n\tcontent: \"\\ed56\";\r\n}\r\n\r\n.icofont-ui-rate-add:before {\r\n\tcontent: \"\\ed57\";\r\n}\r\n\r\n.icofont-ui-rate-blank:before {\r\n\tcontent: \"\\ed58\";\r\n}\r\n\r\n.icofont-ui-rate-remove:before {\r\n\tcontent: \"\\ed59\";\r\n}\r\n\r\n.icofont-ui-rating:before {\r\n\tcontent: \"\\ed5a\";\r\n}\r\n\r\n.icofont-ui-record:before {\r\n\tcontent: \"\\ed5b\";\r\n}\r\n\r\n.icofont-ui-remove:before {\r\n\tcontent: \"\\ed5c\";\r\n}\r\n\r\n.icofont-ui-reply:before {\r\n\tcontent: \"\\ed5d\";\r\n}\r\n\r\n.icofont-ui-rotation:before {\r\n\tcontent: \"\\ed5e\";\r\n}\r\n\r\n.icofont-ui-rss:before {\r\n\tcontent: \"\\ed5f\";\r\n}\r\n\r\n.icofont-ui-search:before {\r\n\tcontent: \"\\ed60\";\r\n}\r\n\r\n.icofont-ui-settings:before {\r\n\tcontent: \"\\ed61\";\r\n}\r\n\r\n.icofont-ui-social-link:before {\r\n\tcontent: \"\\ed62\";\r\n}\r\n\r\n.icofont-ui-tag:before {\r\n\tcontent: \"\\ed63\";\r\n}\r\n\r\n.icofont-ui-text-chat:before {\r\n\tcontent: \"\\ed64\";\r\n}\r\n\r\n.icofont-ui-text-loading:before {\r\n\tcontent: \"\\ed65\";\r\n}\r\n\r\n.icofont-ui-theme:before {\r\n\tcontent: \"\\ed66\";\r\n}\r\n\r\n.icofont-ui-timer:before {\r\n\tcontent: \"\\ed67\";\r\n}\r\n\r\n.icofont-ui-touch-phone:before {\r\n\tcontent: \"\\ed68\";\r\n}\r\n\r\n.icofont-ui-travel:before {\r\n\tcontent: \"\\ed69\";\r\n}\r\n\r\n.icofont-ui-unlock:before {\r\n\tcontent: \"\\ed6a\";\r\n}\r\n\r\n.icofont-ui-user-group:before {\r\n\tcontent: \"\\ed6b\";\r\n}\r\n\r\n.icofont-ui-user:before {\r\n\tcontent: \"\\ed6c\";\r\n}\r\n\r\n.icofont-ui-v-card:before {\r\n\tcontent: \"\\ed6d\";\r\n}\r\n\r\n.icofont-ui-video-chat:before {\r\n\tcontent: \"\\ed6e\";\r\n}\r\n\r\n.icofont-ui-video-message:before {\r\n\tcontent: \"\\ed6f\";\r\n}\r\n\r\n.icofont-ui-video-play:before {\r\n\tcontent: \"\\ed70\";\r\n}\r\n\r\n.icofont-ui-video:before {\r\n\tcontent: \"\\ed71\";\r\n}\r\n\r\n.icofont-ui-volume:before {\r\n\tcontent: \"\\ed72\";\r\n}\r\n\r\n.icofont-ui-weather:before {\r\n\tcontent: \"\\ed73\";\r\n}\r\n\r\n.icofont-ui-wifi:before {\r\n\tcontent: \"\\ed74\";\r\n}\r\n\r\n.icofont-ui-zoom-in:before {\r\n\tcontent: \"\\ed75\";\r\n}\r\n\r\n.icofont-ui-zoom-out:before {\r\n\tcontent: \"\\ed76\";\r\n}\r\n\r\n.icofont-cassette-player:before {\r\n\tcontent: \"\\ed77\";\r\n}\r\n\r\n.icofont-cassette:before {\r\n\tcontent: \"\\ed78\";\r\n}\r\n\r\n.icofont-forward:before {\r\n\tcontent: \"\\ed79\";\r\n}\r\n\r\n.icofont-game:before {\r\n\tcontent: \"\\ed7a\";\r\n}\r\n\r\n.icofont-guiter:before {\r\n\tcontent: \"\\ed7b\";\r\n}\r\n\r\n.icofont-headphone-alt-1:before {\r\n\tcontent: \"\\ed7c\";\r\n}\r\n\r\n.icofont-headphone-alt-2:before {\r\n\tcontent: \"\\ed7d\";\r\n}\r\n\r\n.icofont-headphone-alt-3:before {\r\n\tcontent: \"\\ed7e\";\r\n}\r\n\r\n.icofont-listening:before {\r\n\tcontent: \"\\ed7f\";\r\n}\r\n\r\n.icofont-megaphone-alt:before {\r\n\tcontent: \"\\ed80\";\r\n}\r\n\r\n.icofont-megaphone:before {\r\n\tcontent: \"\\ed81\";\r\n}\r\n\r\n.icofont-movie:before {\r\n\tcontent: \"\\ed82\";\r\n}\r\n\r\n.icofont-mp3-player:before {\r\n\tcontent: \"\\ed83\";\r\n}\r\n\r\n.icofont-multimedia:before {\r\n\tcontent: \"\\ed84\";\r\n}\r\n\r\n.icofont-music-disk:before {\r\n\tcontent: \"\\ed85\";\r\n}\r\n\r\n.icofont-music-note:before {\r\n\tcontent: \"\\ed86\";\r\n}\r\n\r\n.icofont-pause:before {\r\n\tcontent: \"\\ed87\";\r\n}\r\n\r\n.icofont-play-alt-1:before {\r\n\tcontent: \"\\ed88\";\r\n}\r\n\r\n.icofont-play-alt-2:before {\r\n\tcontent: \"\\ed89\";\r\n}\r\n\r\n.icofont-play-alt-3:before {\r\n\tcontent: \"\\ed8a\";\r\n}\r\n\r\n.icofont-play-pause:before {\r\n\tcontent: \"\\ed8b\";\r\n}\r\n\r\n.icofont-record:before {\r\n\tcontent: \"\\ed8c\";\r\n}\r\n\r\n.icofont-retro-music-disk:before {\r\n\tcontent: \"\\ed8d\";\r\n}\r\n\r\n.icofont-rewind:before {\r\n\tcontent: \"\\ed8e\";\r\n}\r\n\r\n.icofont-song-notes:before {\r\n\tcontent: \"\\ed8f\";\r\n}\r\n\r\n.icofont-sound-wave-alt:before {\r\n\tcontent: \"\\ed90\";\r\n}\r\n\r\n.icofont-sound-wave:before {\r\n\tcontent: \"\\ed91\";\r\n}\r\n\r\n.icofont-stop:before {\r\n\tcontent: \"\\ed92\";\r\n}\r\n\r\n.icofont-video-alt:before {\r\n\tcontent: \"\\ed93\";\r\n}\r\n\r\n.icofont-video-cam:before {\r\n\tcontent: \"\\ed94\";\r\n}\r\n\r\n.icofont-volume-bar:before {\r\n\tcontent: \"\\ed95\";\r\n}\r\n\r\n.icofont-volume-mute:before {\r\n\tcontent: \"\\ed96\";\r\n}\r\n\r\n.icofont-youtube-play:before {\r\n\tcontent: \"\\ed97\";\r\n}\r\n\r\n.icofont-amazon-alt:before {\r\n\tcontent: \"\\ed98\";\r\n}\r\n\r\n.icofont-amazon:before {\r\n\tcontent: \"\\ed99\";\r\n}\r\n\r\n.icofont-american-express-alt:before {\r\n\tcontent: \"\\ed9a\";\r\n}\r\n\r\n.icofont-american-express:before {\r\n\tcontent: \"\\ed9b\";\r\n}\r\n\r\n.icofont-apple-pay-alt:before {\r\n\tcontent: \"\\ed9c\";\r\n}\r\n\r\n.icofont-apple-pay:before {\r\n\tcontent: \"\\ed9d\";\r\n}\r\n\r\n.icofont-bank-transfer-alt:before {\r\n\tcontent: \"\\ed9e\";\r\n}\r\n\r\n.icofont-bank-transfer:before {\r\n\tcontent: \"\\ed9f\";\r\n}\r\n\r\n.icofont-braintree-alt:before {\r\n\tcontent: \"\\eda0\";\r\n}\r\n\r\n.icofont-braintree:before {\r\n\tcontent: \"\\eda1\";\r\n}\r\n\r\n.icofont-cash-on-delivery-alt:before {\r\n\tcontent: \"\\eda2\";\r\n}\r\n\r\n.icofont-cash-on-delivery:before {\r\n\tcontent: \"\\eda3\";\r\n}\r\n\r\n.icofont-checkout-alt:before {\r\n\tcontent: \"\\eda4\";\r\n}\r\n\r\n.icofont-checkout:before {\r\n\tcontent: \"\\eda5\";\r\n}\r\n\r\n.icofont-diners-club-alt-1:before {\r\n\tcontent: \"\\eda6\";\r\n}\r\n\r\n.icofont-diners-club-alt-2:before {\r\n\tcontent: \"\\eda7\";\r\n}\r\n\r\n.icofont-diners-club-alt-3:before {\r\n\tcontent: \"\\eda8\";\r\n}\r\n\r\n.icofont-diners-club:before {\r\n\tcontent: \"\\eda9\";\r\n}\r\n\r\n.icofont-discover-alt:before {\r\n\tcontent: \"\\edaa\";\r\n}\r\n\r\n.icofont-discover:before {\r\n\tcontent: \"\\edab\";\r\n}\r\n\r\n.icofont-eway-alt:before {\r\n\tcontent: \"\\edac\";\r\n}\r\n\r\n.icofont-eway:before {\r\n\tcontent: \"\\edad\";\r\n}\r\n\r\n.icofont-google-wallet-alt-1:before {\r\n\tcontent: \"\\edae\";\r\n}\r\n\r\n.icofont-google-wallet-alt-2:before {\r\n\tcontent: \"\\edaf\";\r\n}\r\n\r\n.icofont-google-wallet-alt-3:before {\r\n\tcontent: \"\\edb0\";\r\n}\r\n\r\n.icofont-google-wallet:before {\r\n\tcontent: \"\\edb1\";\r\n}\r\n\r\n.icofont-jcb-alt:before {\r\n\tcontent: \"\\edb2\";\r\n}\r\n\r\n.icofont-jcb:before {\r\n\tcontent: \"\\edb3\";\r\n}\r\n\r\n.icofont-maestro-alt:before {\r\n\tcontent: \"\\edb4\";\r\n}\r\n\r\n.icofont-maestro:before {\r\n\tcontent: \"\\edb5\";\r\n}\r\n\r\n.icofont-mastercard-alt:before {\r\n\tcontent: \"\\edb6\";\r\n}\r\n\r\n.icofont-mastercard:before {\r\n\tcontent: \"\\edb7\";\r\n}\r\n\r\n.icofont-payoneer-alt:before {\r\n\tcontent: \"\\edb8\";\r\n}\r\n\r\n.icofont-payoneer:before {\r\n\tcontent: \"\\edb9\";\r\n}\r\n\r\n.icofont-paypal-alt:before {\r\n\tcontent: \"\\edba\";\r\n}\r\n\r\n.icofont-paypal:before {\r\n\tcontent: \"\\edbb\";\r\n}\r\n\r\n.icofont-sage-alt:before {\r\n\tcontent: \"\\edbc\";\r\n}\r\n\r\n.icofont-sage:before {\r\n\tcontent: \"\\edbd\";\r\n}\r\n\r\n.icofont-skrill-alt:before {\r\n\tcontent: \"\\edbe\";\r\n}\r\n\r\n.icofont-skrill:before {\r\n\tcontent: \"\\edbf\";\r\n}\r\n\r\n.icofont-stripe-alt:before {\r\n\tcontent: \"\\edc0\";\r\n}\r\n\r\n.icofont-stripe:before {\r\n\tcontent: \"\\edc1\";\r\n}\r\n\r\n.icofont-visa-alt:before {\r\n\tcontent: \"\\edc2\";\r\n}\r\n\r\n.icofont-visa-electron:before {\r\n\tcontent: \"\\edc3\";\r\n}\r\n\r\n.icofont-visa:before {\r\n\tcontent: \"\\edc4\";\r\n}\r\n\r\n.icofont-western-union-alt:before {\r\n\tcontent: \"\\edc5\";\r\n}\r\n\r\n.icofont-western-union:before {\r\n\tcontent: \"\\edc6\";\r\n}\r\n\r\n.icofont-boy:before {\r\n\tcontent: \"\\edc7\";\r\n}\r\n\r\n.icofont-business-man-alt-1:before {\r\n\tcontent: \"\\edc8\";\r\n}\r\n\r\n.icofont-business-man-alt-2:before {\r\n\tcontent: \"\\edc9\";\r\n}\r\n\r\n.icofont-business-man-alt-3:before {\r\n\tcontent: \"\\edca\";\r\n}\r\n\r\n.icofont-business-man:before {\r\n\tcontent: \"\\edcb\";\r\n}\r\n\r\n.icofont-funky-man:before {\r\n\tcontent: \"\\edcc\";\r\n}\r\n\r\n.icofont-girl-alt:before {\r\n\tcontent: \"\\edcd\";\r\n}\r\n\r\n.icofont-girl:before {\r\n\tcontent: \"\\edce\";\r\n}\r\n\r\n.icofont-hotel-boy-alt:before {\r\n\tcontent: \"\\edcf\";\r\n}\r\n\r\n.icofont-hotel-boy:before {\r\n\tcontent: \"\\edd0\";\r\n}\r\n\r\n.icofont-man-in-glasses:before {\r\n\tcontent: \"\\edd1\";\r\n}\r\n\r\n.icofont-user-alt-1:before {\r\n\tcontent: \"\\edd2\";\r\n}\r\n\r\n.icofont-user-alt-2:before {\r\n\tcontent: \"\\edd3\";\r\n}\r\n\r\n.icofont-user-alt-3:before {\r\n\tcontent: \"\\edd4\";\r\n}\r\n\r\n.icofont-user-alt-4:before {\r\n\tcontent: \"\\edd5\";\r\n}\r\n\r\n.icofont-user-alt-5:before {\r\n\tcontent: \"\\edd6\";\r\n}\r\n\r\n.icofont-user-alt-6:before {\r\n\tcontent: \"\\edd7\";\r\n}\r\n\r\n.icofont-user-alt-7:before {\r\n\tcontent: \"\\edd8\";\r\n}\r\n\r\n.icofont-user-female:before {\r\n\tcontent: \"\\edd9\";\r\n}\r\n\r\n.icofont-user-male:before {\r\n\tcontent: \"\\edda\";\r\n}\r\n\r\n.icofont-user-suited:before {\r\n\tcontent: \"\\eddb\";\r\n}\r\n\r\n.icofont-user:before {\r\n\tcontent: \"\\eddc\";\r\n}\r\n\r\n.icofont-users-alt-1:before {\r\n\tcontent: \"\\eddd\";\r\n}\r\n\r\n.icofont-users-alt-2:before {\r\n\tcontent: \"\\edde\";\r\n}\r\n\r\n.icofont-users-alt-3:before {\r\n\tcontent: \"\\eddf\";\r\n}\r\n\r\n.icofont-users-alt-4:before {\r\n\tcontent: \"\\ede0\";\r\n}\r\n\r\n.icofont-users-alt-5:before {\r\n\tcontent: \"\\ede1\";\r\n}\r\n\r\n.icofont-users-alt-6:before {\r\n\tcontent: \"\\ede2\";\r\n}\r\n\r\n.icofont-users-social:before {\r\n\tcontent: \"\\ede3\";\r\n}\r\n\r\n.icofont-users:before {\r\n\tcontent: \"\\ede4\";\r\n}\r\n\r\n.icofont-waiter:before {\r\n\tcontent: \"\\ede5\";\r\n}\r\n\r\n.icofont-woman-in-glasses:before {\r\n\tcontent: \"\\ede6\";\r\n}\r\n\r\n.icofont-document-search:before {\r\n\tcontent: \"\\ede7\";\r\n}\r\n\r\n.icofont-folder-search:before {\r\n\tcontent: \"\\ede8\";\r\n}\r\n\r\n.icofont-home-search:before {\r\n\tcontent: \"\\ede9\";\r\n}\r\n\r\n.icofont-job-search:before {\r\n\tcontent: \"\\edea\";\r\n}\r\n\r\n.icofont-map-search:before {\r\n\tcontent: \"\\edeb\";\r\n}\r\n\r\n.icofont-restaurant-search:before {\r\n\tcontent: \"\\edec\";\r\n}\r\n\r\n.icofont-search-alt-1:before {\r\n\tcontent: \"\\eded\";\r\n}\r\n\r\n.icofont-search-alt-2:before {\r\n\tcontent: \"\\edee\";\r\n}\r\n\r\n.icofont-search:before {\r\n\tcontent: \"\\edef\";\r\n}\r\n\r\n.icofont-stock-search:before {\r\n\tcontent: \"\\edf0\";\r\n}\r\n\r\n.icofont-user-search:before {\r\n\tcontent: \"\\edf1\";\r\n}\r\n\r\n.icofont-social-aim:before {\r\n\tcontent: \"\\edf2\";\r\n}\r\n\r\n.icofont-social-badoo:before {\r\n\tcontent: \"\\edf3\";\r\n}\r\n\r\n.icofont-social-bebo:before {\r\n\tcontent: \"\\edf4\";\r\n}\r\n\r\n.icofont-social-behance:before {\r\n\tcontent: \"\\edf5\";\r\n}\r\n\r\n.icofont-social-blogger:before {\r\n\tcontent: \"\\edf6\";\r\n}\r\n\r\n.icofont-social-bootstrap:before {\r\n\tcontent: \"\\edf7\";\r\n}\r\n\r\n.icofont-social-brightkite:before {\r\n\tcontent: \"\\edf8\";\r\n}\r\n\r\n.icofont-social-cloudapp:before {\r\n\tcontent: \"\\edf9\";\r\n}\r\n\r\n.icofont-social-concrete5:before {\r\n\tcontent: \"\\edfa\";\r\n}\r\n\r\n.icofont-social-designbump:before {\r\n\tcontent: \"\\edfb\";\r\n}\r\n\r\n.icofont-social-designfloat:before {\r\n\tcontent: \"\\edfc\";\r\n}\r\n\r\n.icofont-social-deviantart:before {\r\n\tcontent: \"\\edfd\";\r\n}\r\n\r\n.icofont-social-digg:before {\r\n\tcontent: \"\\edfe\";\r\n}\r\n\r\n.icofont-social-dotcms:before {\r\n\tcontent: \"\\edff\";\r\n}\r\n\r\n.icofont-social-dribble:before {\r\n\tcontent: \"\\ee00\";\r\n}\r\n\r\n.icofont-social-dropbox:before {\r\n\tcontent: \"\\ee01\";\r\n}\r\n\r\n.icofont-brand-drupal:before {\r\n\tcontent: \"\\ee02\";\r\n}\r\n\r\n.icofont-social-ebuddy:before {\r\n\tcontent: \"\\ee03\";\r\n}\r\n\r\n.icofont-social-ello:before {\r\n\tcontent: \"\\ee04\";\r\n}\r\n\r\n.icofont-social-ember:before {\r\n\tcontent: \"\\ee05\";\r\n}\r\n\r\n.icofont-social-envato:before {\r\n\tcontent: \"\\ee06\";\r\n}\r\n\r\n.icofont-social-evernote:before {\r\n\tcontent: \"\\ee07\";\r\n}\r\n\r\n.icofont-social-facebook:before {\r\n\tcontent: \"\\ee08\";\r\n}\r\n\r\n.icofont-social-feedburner:before {\r\n\tcontent: \"\\ee09\";\r\n}\r\n\r\n.icofont-social-folkd:before {\r\n\tcontent: \"\\ee0a\";\r\n}\r\n\r\n.icofont-social-friendfeed:before {\r\n\tcontent: \"\\ee0b\";\r\n}\r\n\r\n.icofont-social-ghost:before {\r\n\tcontent: \"\\ee0c\";\r\n}\r\n\r\n.icofont-social-github:before {\r\n\tcontent: \"\\ee0d\";\r\n}\r\n\r\n.icofont-social-gnome:before {\r\n\tcontent: \"\\ee0e\";\r\n}\r\n\r\n.icofont-social-google-buzz:before {\r\n\tcontent: \"\\ee0f\";\r\n}\r\n\r\n.icofont-social-google-map:before {\r\n\tcontent: \"\\ee10\";\r\n}\r\n\r\n.icofont-social-google-plus:before {\r\n\tcontent: \"\\ee11\";\r\n}\r\n\r\n.icofont-social-google-talk:before {\r\n\tcontent: \"\\ee12\";\r\n}\r\n\r\n.icofont-social-hype-machine:before {\r\n\tcontent: \"\\ee13\";\r\n}\r\n\r\n.icofont-social-instagram:before {\r\n\tcontent: \"\\ee14\";\r\n}\r\n\r\n.icofont-brand-joomla:before {\r\n\tcontent: \"\\ee15\";\r\n}\r\n\r\n.icofont-social-kickstarter:before {\r\n\tcontent: \"\\ee16\";\r\n}\r\n\r\n.icofont-social-line:before {\r\n\tcontent: \"\\ee17\";\r\n}\r\n\r\n.icofont-social-linux-mint:before {\r\n\tcontent: \"\\ee18\";\r\n}\r\n\r\n.icofont-social-livejournal:before {\r\n\tcontent: \"\\ee19\";\r\n}\r\n\r\n.icofont-social-magento:before {\r\n\tcontent: \"\\ee1a\";\r\n}\r\n\r\n.icofont-social-meetup:before {\r\n\tcontent: \"\\ee1b\";\r\n}\r\n\r\n.icofont-social-mixx:before {\r\n\tcontent: \"\\ee1c\";\r\n}\r\n\r\n.icofont-social-newsvine:before {\r\n\tcontent: \"\\ee1d\";\r\n}\r\n\r\n.icofont-social-nimbuss:before {\r\n\tcontent: \"\\ee1e\";\r\n}\r\n\r\n.icofont-social-opencart:before {\r\n\tcontent: \"\\ee1f\";\r\n}\r\n\r\n.icofont-social-oscommerce:before {\r\n\tcontent: \"\\ee20\";\r\n}\r\n\r\n.icofont-social-pandora:before {\r\n\tcontent: \"\\ee21\";\r\n}\r\n\r\n.icofont-social-picasa:before {\r\n\tcontent: \"\\ee22\";\r\n}\r\n\r\n.icofont-social-pinterest:before {\r\n\tcontent: \"\\ee23\";\r\n}\r\n\r\n.icofont-social-prestashop:before {\r\n\tcontent: \"\\ee24\";\r\n}\r\n\r\n.icofont-social-qik:before {\r\n\tcontent: \"\\ee25\";\r\n}\r\n\r\n.icofont-social-readernaut:before {\r\n\tcontent: \"\\ee26\";\r\n}\r\n\r\n.icofont-social-reddit:before {\r\n\tcontent: \"\\ee27\";\r\n}\r\n\r\n.icofont-social-rss:before {\r\n\tcontent: \"\\ee28\";\r\n}\r\n\r\n.icofont-social-shopify:before {\r\n\tcontent: \"\\ee29\";\r\n}\r\n\r\n.icofont-social-silverstripe:before {\r\n\tcontent: \"\\ee2a\";\r\n}\r\n\r\n.icofont-social-skype:before {\r\n\tcontent: \"\\ee2b\";\r\n}\r\n\r\n.icofont-social-slashdot:before {\r\n\tcontent: \"\\ee2c\";\r\n}\r\n\r\n.icofont-social-smugmug:before {\r\n\tcontent: \"\\ee2d\";\r\n}\r\n\r\n.icofont-social-steam:before {\r\n\tcontent: \"\\ee2e\";\r\n}\r\n\r\n.icofont-social-stumbleupon:before {\r\n\tcontent: \"\\ee2f\";\r\n}\r\n\r\n.icofont-social-technorati:before {\r\n\tcontent: \"\\ee30\";\r\n}\r\n\r\n.icofont-social-telegram:before {\r\n\tcontent: \"\\ee31\";\r\n}\r\n\r\n.icofont-social-tinder:before {\r\n\tcontent: \"\\ee32\";\r\n}\r\n\r\n.icofont-social-tumblr:before {\r\n\tcontent: \"\\ee33\";\r\n}\r\n\r\n.icofont-social-twitter:before {\r\n\tcontent: \"\\ee34\";\r\n}\r\n\r\n.icofont-social-typo3:before {\r\n\tcontent: \"\\ee35\";\r\n}\r\n\r\n.icofont-social-ubercart:before {\r\n\tcontent: \"\\ee36\";\r\n}\r\n\r\n.icofont-social-viber:before {\r\n\tcontent: \"\\ee37\";\r\n}\r\n\r\n.icofont-social-viddler:before {\r\n\tcontent: \"\\ee38\";\r\n}\r\n\r\n.icofont-social-vimeo:before {\r\n\tcontent: \"\\ee39\";\r\n}\r\n\r\n.icofont-social-vine:before {\r\n\tcontent: \"\\ee3a\";\r\n}\r\n\r\n.icofont-social-virb:before {\r\n\tcontent: \"\\ee3b\";\r\n}\r\n\r\n.icofont-social-virtuemart:before {\r\n\tcontent: \"\\ee3c\";\r\n}\r\n\r\n.icofont-social-wechat:before {\r\n\tcontent: \"\\ee3d\";\r\n}\r\n\r\n.icofont-brand-wordpress:before {\r\n\tcontent: \"\\ee3e\";\r\n}\r\n\r\n.icofont-social-xing:before {\r\n\tcontent: \"\\ee3f\";\r\n}\r\n\r\n.icofont-social-yahoo:before {\r\n\tcontent: \"\\ee40\";\r\n}\r\n\r\n.icofont-social-yelp:before {\r\n\tcontent: \"\\ee41\";\r\n}\r\n\r\n.icofont-social-zencart:before {\r\n\tcontent: \"\\ee42\";\r\n}\r\n\r\n.icofont-badminton-birdie:before {\r\n\tcontent: \"\\ee43\";\r\n}\r\n\r\n.icofont-baseball:before {\r\n\tcontent: \"\\ee44\";\r\n}\r\n\r\n.icofont-baseballer:before {\r\n\tcontent: \"\\ee45\";\r\n}\r\n\r\n.icofont-basketball-hoop:before {\r\n\tcontent: \"\\ee46\";\r\n}\r\n\r\n.icofont-basketball:before {\r\n\tcontent: \"\\ee47\";\r\n}\r\n\r\n.icofont-billiard-ball:before {\r\n\tcontent: \"\\ee48\";\r\n}\r\n\r\n.icofont-boot-alt-1:before {\r\n\tcontent: \"\\ee49\";\r\n}\r\n\r\n.icofont-boot-alt-2:before {\r\n\tcontent: \"\\ee4a\";\r\n}\r\n\r\n.icofont-bowling-alt:before {\r\n\tcontent: \"\\ee4b\";\r\n}\r\n\r\n.icofont-bowling:before {\r\n\tcontent: \"\\ee4c\";\r\n}\r\n\r\n.icofont-canoe:before {\r\n\tcontent: \"\\ee4d\";\r\n}\r\n\r\n.icofont-cheer-leader:before {\r\n\tcontent: \"\\ee4e\";\r\n}\r\n\r\n.icofont-climbing:before {\r\n\tcontent: \"\\ee4f\";\r\n}\r\n\r\n.icofont-corner:before {\r\n\tcontent: \"\\ee50\";\r\n}\r\n\r\n.icofont-cyclist:before {\r\n\tcontent: \"\\ee51\";\r\n}\r\n\r\n.icofont-dumbbell-alt:before {\r\n\tcontent: \"\\ee52\";\r\n}\r\n\r\n.icofont-dumbbell:before {\r\n\tcontent: \"\\ee53\";\r\n}\r\n\r\n.icofont-field-alt:before {\r\n\tcontent: \"\\ee54\";\r\n}\r\n\r\n.icofont-field:before {\r\n\tcontent: \"\\ee55\";\r\n}\r\n\r\n.icofont-football-alt:before {\r\n\tcontent: \"\\ee56\";\r\n}\r\n\r\n.icofont-foul:before {\r\n\tcontent: \"\\ee57\";\r\n}\r\n\r\n.icofont-goal-keeper:before {\r\n\tcontent: \"\\ee58\";\r\n}\r\n\r\n.icofont-goal:before {\r\n\tcontent: \"\\ee59\";\r\n}\r\n\r\n.icofont-golf-alt:before {\r\n\tcontent: \"\\ee5a\";\r\n}\r\n\r\n.icofont-golf-bag:before {\r\n\tcontent: \"\\ee5b\";\r\n}\r\n\r\n.icofont-golf-field:before {\r\n\tcontent: \"\\ee5c\";\r\n}\r\n\r\n.icofont-golf:before {\r\n\tcontent: \"\\ee5d\";\r\n}\r\n\r\n.icofont-golfer:before {\r\n\tcontent: \"\\ee5e\";\r\n}\r\n\r\n.icofont-gym-alt-1:before {\r\n\tcontent: \"\\ee5f\";\r\n}\r\n\r\n.icofont-gym-alt-2:before {\r\n\tcontent: \"\\ee60\";\r\n}\r\n\r\n.icofont-gym-alt-3:before {\r\n\tcontent: \"\\ee61\";\r\n}\r\n\r\n.icofont-gym:before {\r\n\tcontent: \"\\ee62\";\r\n}\r\n\r\n.icofont-hand-grippers:before {\r\n\tcontent: \"\\ee63\";\r\n}\r\n\r\n.icofont-heart-beat-alt:before {\r\n\tcontent: \"\\ee64\";\r\n}\r\n\r\n.icofont-helmet:before {\r\n\tcontent: \"\\ee65\";\r\n}\r\n\r\n.icofont-hockey-alt:before {\r\n\tcontent: \"\\ee66\";\r\n}\r\n\r\n.icofont-hockey:before {\r\n\tcontent: \"\\ee67\";\r\n}\r\n\r\n.icofont-ice-skate:before {\r\n\tcontent: \"\\ee68\";\r\n}\r\n\r\n.icofont-jersey-alt:before {\r\n\tcontent: \"\\ee69\";\r\n}\r\n\r\n.icofont-jersey:before {\r\n\tcontent: \"\\ee6a\";\r\n}\r\n\r\n.icofont-jumping:before {\r\n\tcontent: \"\\ee6b\";\r\n}\r\n\r\n.icofont-kick:before {\r\n\tcontent: \"\\ee6c\";\r\n}\r\n\r\n.icofont-leg:before {\r\n\tcontent: \"\\ee6d\";\r\n}\r\n\r\n.icofont-match-review:before {\r\n\tcontent: \"\\ee6e\";\r\n}\r\n\r\n.icofont-medal-alt:before {\r\n\tcontent: \"\\ee6f\";\r\n}\r\n\r\n.icofont-muscle-alt:before {\r\n\tcontent: \"\\ee70\";\r\n}\r\n\r\n.icofont-muscle:before {\r\n\tcontent: \"\\ee71\";\r\n}\r\n\r\n.icofont-offside:before {\r\n\tcontent: \"\\ee72\";\r\n}\r\n\r\n.icofont-olympic-logo:before {\r\n\tcontent: \"\\ee73\";\r\n}\r\n\r\n.icofont-olympic:before {\r\n\tcontent: \"\\ee74\";\r\n}\r\n\r\n.icofont-padding:before {\r\n\tcontent: \"\\ee75\";\r\n}\r\n\r\n.icofont-penalty-card:before {\r\n\tcontent: \"\\ee76\";\r\n}\r\n\r\n.icofont-racer:before {\r\n\tcontent: \"\\ee77\";\r\n}\r\n\r\n.icofont-racing-car:before {\r\n\tcontent: \"\\ee78\";\r\n}\r\n\r\n.icofont-racing-flag-alt:before {\r\n\tcontent: \"\\ee79\";\r\n}\r\n\r\n.icofont-racing-flag:before {\r\n\tcontent: \"\\ee7a\";\r\n}\r\n\r\n.icofont-racings-wheel:before {\r\n\tcontent: \"\\ee7b\";\r\n}\r\n\r\n.icofont-referee:before {\r\n\tcontent: \"\\ee7c\";\r\n}\r\n\r\n.icofont-refree-jersey:before {\r\n\tcontent: \"\\ee7d\";\r\n}\r\n\r\n.icofont-result:before {\r\n\tcontent: \"\\ee7e\";\r\n}\r\n\r\n.icofont-rugby-ball:before {\r\n\tcontent: \"\\ee7f\";\r\n}\r\n\r\n.icofont-rugby-player:before {\r\n\tcontent: \"\\ee80\";\r\n}\r\n\r\n.icofont-rugby:before {\r\n\tcontent: \"\\ee81\";\r\n}\r\n\r\n.icofont-runner-alt-1:before {\r\n\tcontent: \"\\ee82\";\r\n}\r\n\r\n.icofont-runner-alt-2:before {\r\n\tcontent: \"\\ee83\";\r\n}\r\n\r\n.icofont-runner:before {\r\n\tcontent: \"\\ee84\";\r\n}\r\n\r\n.icofont-score-board:before {\r\n\tcontent: \"\\ee85\";\r\n}\r\n\r\n.icofont-skiing-man:before {\r\n\tcontent: \"\\ee86\";\r\n}\r\n\r\n.icofont-skydiving-goggles:before {\r\n\tcontent: \"\\ee87\";\r\n}\r\n\r\n.icofont-snow-mobile:before {\r\n\tcontent: \"\\ee88\";\r\n}\r\n\r\n.icofont-steering:before {\r\n\tcontent: \"\\ee89\";\r\n}\r\n\r\n.icofont-substitute:before {\r\n\tcontent: \"\\ee8a\";\r\n}\r\n\r\n.icofont-swimmer:before {\r\n\tcontent: \"\\ee8b\";\r\n}\r\n\r\n.icofont-table-tennis:before {\r\n\tcontent: \"\\ee8c\";\r\n}\r\n\r\n.icofont-team-alt:before {\r\n\tcontent: \"\\ee8d\";\r\n}\r\n\r\n.icofont-team:before {\r\n\tcontent: \"\\ee8e\";\r\n}\r\n\r\n.icofont-tennis-player:before {\r\n\tcontent: \"\\ee8f\";\r\n}\r\n\r\n.icofont-tennis:before {\r\n\tcontent: \"\\ee90\";\r\n}\r\n\r\n.icofont-time:before {\r\n\tcontent: \"\\ee91\";\r\n}\r\n\r\n.icofont-track:before {\r\n\tcontent: \"\\ee92\";\r\n}\r\n\r\n.icofont-tracking:before {\r\n\tcontent: \"\\ee93\";\r\n}\r\n\r\n.icofont-trophy-alt:before {\r\n\tcontent: \"\\ee94\";\r\n}\r\n\r\n.icofont-trophy:before {\r\n\tcontent: \"\\ee95\";\r\n}\r\n\r\n.icofont-volleyball-alt:before {\r\n\tcontent: \"\\ee96\";\r\n}\r\n\r\n.icofont-volleyball-fire:before {\r\n\tcontent: \"\\ee97\";\r\n}\r\n\r\n.icofont-volleyball:before {\r\n\tcontent: \"\\ee98\";\r\n}\r\n\r\n.icofont-water-bottle:before {\r\n\tcontent: \"\\ee99\";\r\n}\r\n\r\n.icofont-whisle:before {\r\n\tcontent: \"\\ee9a\";\r\n}\r\n\r\n.icofont-win-trophy:before {\r\n\tcontent: \"\\ee9b\";\r\n}\r\n\r\n.icofont-align-center:before {\r\n\tcontent: \"\\ee9c\";\r\n}\r\n\r\n.icofont-align-left:before {\r\n\tcontent: \"\\ee9d\";\r\n}\r\n\r\n.icofont-align-right:before {\r\n\tcontent: \"\\ee9e\";\r\n}\r\n\r\n.icofont-all-caps:before {\r\n\tcontent: \"\\ee9f\";\r\n}\r\n\r\n.icofont-bold:before {\r\n\tcontent: \"\\eea0\";\r\n}\r\n\r\n.icofont-brush:before {\r\n\tcontent: \"\\eea1\";\r\n}\r\n\r\n.icofont-clip-board:before {\r\n\tcontent: \"\\eea2\";\r\n}\r\n\r\n.icofont-code-alt:before {\r\n\tcontent: \"\\eea3\";\r\n}\r\n\r\n.icofont-color-bucket:before {\r\n\tcontent: \"\\eea4\";\r\n}\r\n\r\n.icofont-color-picker:before {\r\n\tcontent: \"\\eea5\";\r\n}\r\n\r\n.icofont-copy-alt:before {\r\n\tcontent: \"\\eea6\";\r\n}\r\n\r\n.icofont-copy-black:before {\r\n\tcontent: \"\\eea7\";\r\n}\r\n\r\n.icofont-cut:before {\r\n\tcontent: \"\\eea8\";\r\n}\r\n\r\n.icofont-delete-alt:before {\r\n\tcontent: \"\\eea9\";\r\n}\r\n\r\n.icofont-edit-alt:before {\r\n\tcontent: \"\\eeaa\";\r\n}\r\n\r\n.icofont-eraser-alt:before {\r\n\tcontent: \"\\eeab\";\r\n}\r\n\r\n.icofont-file-alt:before {\r\n\tcontent: \"\\eeac\";\r\n}\r\n\r\n.icofont-font:before {\r\n\tcontent: \"\\eead\";\r\n}\r\n\r\n.icofont-header:before {\r\n\tcontent: \"\\eeae\";\r\n}\r\n\r\n.icofont-indent:before {\r\n\tcontent: \"\\eeaf\";\r\n}\r\n\r\n.icofont-italic-alt:before {\r\n\tcontent: \"\\eeb0\";\r\n}\r\n\r\n.icofont-justify-all:before {\r\n\tcontent: \"\\eeb1\";\r\n}\r\n\r\n.icofont-justify-center:before {\r\n\tcontent: \"\\eeb2\";\r\n}\r\n\r\n.icofont-justify-left:before {\r\n\tcontent: \"\\eeb3\";\r\n}\r\n\r\n.icofont-justify-right:before {\r\n\tcontent: \"\\eeb4\";\r\n}\r\n\r\n.icofont-line-height:before {\r\n\tcontent: \"\\eeb5\";\r\n}\r\n\r\n.icofont-link-alt:before {\r\n\tcontent: \"\\eeb6\";\r\n}\r\n\r\n.icofont-listine-dots:before {\r\n\tcontent: \"\\eeb7\";\r\n}\r\n\r\n.icofont-listing-box:before {\r\n\tcontent: \"\\eeb8\";\r\n}\r\n\r\n.icofont-listing-number:before {\r\n\tcontent: \"\\eeb9\";\r\n}\r\n\r\n.icofont-marker:before {\r\n\tcontent: \"\\eeba\";\r\n}\r\n\r\n.icofont-outdent:before {\r\n\tcontent: \"\\eebb\";\r\n}\r\n\r\n.icofont-paper-clip:before {\r\n\tcontent: \"\\eebc\";\r\n}\r\n\r\n.icofont-paragraph:before {\r\n\tcontent: \"\\eebd\";\r\n}\r\n\r\n.icofont-pin:before {\r\n\tcontent: \"\\eebe\";\r\n}\r\n\r\n.icofont-printer:before {\r\n\tcontent: \"\\eebf\";\r\n}\r\n\r\n.icofont-redo:before {\r\n\tcontent: \"\\eec0\";\r\n}\r\n\r\n.icofont-rotation:before {\r\n\tcontent: \"\\eec1\";\r\n}\r\n\r\n.icofont-save:before {\r\n\tcontent: \"\\eec2\";\r\n}\r\n\r\n.icofont-small-cap:before {\r\n\tcontent: \"\\eec3\";\r\n}\r\n\r\n.icofont-strike-through:before {\r\n\tcontent: \"\\eec4\";\r\n}\r\n\r\n.icofont-sub-listing:before {\r\n\tcontent: \"\\eec5\";\r\n}\r\n\r\n.icofont-subscript:before {\r\n\tcontent: \"\\eec6\";\r\n}\r\n\r\n.icofont-superscript:before {\r\n\tcontent: \"\\eec7\";\r\n}\r\n\r\n.icofont-table:before {\r\n\tcontent: \"\\eec8\";\r\n}\r\n\r\n.icofont-text-height:before {\r\n\tcontent: \"\\eec9\";\r\n}\r\n\r\n.icofont-text-width:before {\r\n\tcontent: \"\\eeca\";\r\n}\r\n\r\n.icofont-trash:before {\r\n\tcontent: \"\\eecb\";\r\n}\r\n\r\n.icofont-underline:before {\r\n\tcontent: \"\\eecc\";\r\n}\r\n\r\n.icofont-undo:before {\r\n\tcontent: \"\\eecd\";\r\n}\r\n\r\n.icofont-unlink:before {\r\n\tcontent: \"\\eece\";\r\n}\r\n\r\n.icofont-air-balloon:before {\r\n\tcontent: \"\\eecf\";\r\n}\r\n\r\n.icofont-airplane-alt:before {\r\n\tcontent: \"\\eed0\";\r\n}\r\n\r\n.icofont-airplane:before {\r\n\tcontent: \"\\eed1\";\r\n}\r\n\r\n.icofont-ambulance-crescent:before {\r\n\tcontent: \"\\eed2\";\r\n}\r\n\r\n.icofont-ambulance-cross:before {\r\n\tcontent: \"\\eed3\";\r\n}\r\n\r\n.icofont-articulated-truck:before {\r\n\tcontent: \"\\eed4\";\r\n}\r\n\r\n.icofont-auto-rickshaw:before {\r\n\tcontent: \"\\eed5\";\r\n}\r\n\r\n.icofont-bicycle-alt-1:before {\r\n\tcontent: \"\\eed6\";\r\n}\r\n\r\n.icofont-bicycle-alt-2:before {\r\n\tcontent: \"\\eed7\";\r\n}\r\n\r\n.icofont-bull-dozer:before {\r\n\tcontent: \"\\eed8\";\r\n}\r\n\r\n.icofont-bus-alt-1:before {\r\n\tcontent: \"\\eed9\";\r\n}\r\n\r\n.icofont-bus-alt-2:before {\r\n\tcontent: \"\\eeda\";\r\n}\r\n\r\n.icofont-bus-alt-3:before {\r\n\tcontent: \"\\eedb\";\r\n}\r\n\r\n.icofont-cable-car:before {\r\n\tcontent: \"\\eedc\";\r\n}\r\n\r\n.icofont-car-alt-1:before {\r\n\tcontent: \"\\eedd\";\r\n}\r\n\r\n.icofont-car-alt-2:before {\r\n\tcontent: \"\\eede\";\r\n}\r\n\r\n.icofont-car-alt-3:before {\r\n\tcontent: \"\\eedf\";\r\n}\r\n\r\n.icofont-car-alt-4:before {\r\n\tcontent: \"\\eee0\";\r\n}\r\n\r\n.icofont-concrete-mixer:before {\r\n\tcontent: \"\\eee1\";\r\n}\r\n\r\n.icofont-delivery-time:before {\r\n\tcontent: \"\\eee2\";\r\n}\r\n\r\n.icofont-excavator:before {\r\n\tcontent: \"\\eee3\";\r\n}\r\n\r\n.icofont-fast-delivery:before {\r\n\tcontent: \"\\eee4\";\r\n}\r\n\r\n.icofont-fire-truck-alt:before {\r\n\tcontent: \"\\eee5\";\r\n}\r\n\r\n.icofont-fire-truck:before {\r\n\tcontent: \"\\eee6\";\r\n}\r\n\r\n.icofont-fork-lift:before {\r\n\tcontent: \"\\eee7\";\r\n}\r\n\r\n.icofont-free-delivery:before {\r\n\tcontent: \"\\eee8\";\r\n}\r\n\r\n.icofont-golf-cart:before {\r\n\tcontent: \"\\eee9\";\r\n}\r\n\r\n.icofont-helicopter:before {\r\n\tcontent: \"\\eeea\";\r\n}\r\n\r\n.icofont-motor-bike-alt:before {\r\n\tcontent: \"\\eeeb\";\r\n}\r\n\r\n.icofont-motor-bike:before {\r\n\tcontent: \"\\eeec\";\r\n}\r\n\r\n.icofont-motor-biker:before {\r\n\tcontent: \"\\eeed\";\r\n}\r\n\r\n.icofont-oil-truck:before {\r\n\tcontent: \"\\eeee\";\r\n}\r\n\r\n.icofont-police-car:before {\r\n\tcontent: \"\\eeef\";\r\n}\r\n\r\n.icofont-rickshaw:before {\r\n\tcontent: \"\\eef0\";\r\n}\r\n\r\n.icofont-rocket-alt-1:before {\r\n\tcontent: \"\\eef1\";\r\n}\r\n\r\n.icofont-rocket-alt-2:before {\r\n\tcontent: \"\\eef2\";\r\n}\r\n\r\n.icofont-sail-boat:before {\r\n\tcontent: \"\\eef3\";\r\n}\r\n\r\n.icofont-scooter:before {\r\n\tcontent: \"\\eef4\";\r\n}\r\n\r\n.icofont-sea-plane:before {\r\n\tcontent: \"\\eef5\";\r\n}\r\n\r\n.icofont-ship-alt:before {\r\n\tcontent: \"\\eef6\";\r\n}\r\n\r\n.icofont-speed-boat:before {\r\n\tcontent: \"\\eef7\";\r\n}\r\n\r\n.icofont-taxi:before {\r\n\tcontent: \"\\eef8\";\r\n}\r\n\r\n.icofont-tow-truck:before {\r\n\tcontent: \"\\eef9\";\r\n}\r\n\r\n.icofont-tractor:before {\r\n\tcontent: \"\\eefa\";\r\n}\r\n\r\n.icofont-traffic-light:before {\r\n\tcontent: \"\\eefb\";\r\n}\r\n\r\n.icofont-train-line:before {\r\n\tcontent: \"\\eefc\";\r\n}\r\n\r\n.icofont-train-steam:before {\r\n\tcontent: \"\\eefd\";\r\n}\r\n\r\n.icofont-tram:before {\r\n\tcontent: \"\\eefe\";\r\n}\r\n\r\n.icofont-truck-alt:before {\r\n\tcontent: \"\\eeff\";\r\n}\r\n\r\n.icofont-truck-loaded:before {\r\n\tcontent: \"\\ef00\";\r\n}\r\n\r\n.icofont-truck:before {\r\n\tcontent: \"\\ef01\";\r\n}\r\n\r\n.icofont-van-alt:before {\r\n\tcontent: \"\\ef02\";\r\n}\r\n\r\n.icofont-van:before {\r\n\tcontent: \"\\ef03\";\r\n}\r\n\r\n.icofont-yacht:before {\r\n\tcontent: \"\\ef04\";\r\n}\r\n\r\n.icofont-5-star-hotel:before {\r\n\tcontent: \"\\ef05\";\r\n}\r\n\r\n.icofont-anchor-alt:before {\r\n\tcontent: \"\\ef06\";\r\n}\r\n\r\n.icofont-beach-bed:before {\r\n\tcontent: \"\\ef07\";\r\n}\r\n\r\n.icofont-camping-vest:before {\r\n\tcontent: \"\\ef08\";\r\n}\r\n\r\n.icofont-coconut-alt:before {\r\n\tcontent: \"\\ef09\";\r\n}\r\n\r\n.icofont-direction-sign:before {\r\n\tcontent: \"\\ef0a\";\r\n}\r\n\r\n.icofont-hill-side:before {\r\n\tcontent: \"\\ef0b\";\r\n}\r\n\r\n.icofont-island-alt:before {\r\n\tcontent: \"\\ef0c\";\r\n}\r\n\r\n.icofont-long-drive:before {\r\n\tcontent: \"\\ef0d\";\r\n}\r\n\r\n.icofont-map-pins:before {\r\n\tcontent: \"\\ef0e\";\r\n}\r\n\r\n.icofont-plane-ticket:before {\r\n\tcontent: \"\\ef0f\";\r\n}\r\n\r\n.icofont-sail-boat-alt-1:before {\r\n\tcontent: \"\\ef10\";\r\n}\r\n\r\n.icofont-sail-boat-alt-2:before {\r\n\tcontent: \"\\ef11\";\r\n}\r\n\r\n.icofont-sandals-female:before {\r\n\tcontent: \"\\ef12\";\r\n}\r\n\r\n.icofont-sandals-male:before {\r\n\tcontent: \"\\ef13\";\r\n}\r\n\r\n.icofont-travelling:before {\r\n\tcontent: \"\\ef14\";\r\n}\r\n\r\n.icofont-breakdown:before {\r\n\tcontent: \"\\ef15\";\r\n}\r\n\r\n.icofont-celsius:before {\r\n\tcontent: \"\\ef16\";\r\n}\r\n\r\n.icofont-clouds:before {\r\n\tcontent: \"\\ef17\";\r\n}\r\n\r\n.icofont-cloudy:before {\r\n\tcontent: \"\\ef18\";\r\n}\r\n\r\n.icofont-compass-alt:before {\r\n\tcontent: \"\\ef19\";\r\n}\r\n\r\n.icofont-dust:before {\r\n\tcontent: \"\\ef1a\";\r\n}\r\n\r\n.icofont-eclipse:before {\r\n\tcontent: \"\\ef1b\";\r\n}\r\n\r\n.icofont-fahrenheit:before {\r\n\tcontent: \"\\ef1c\";\r\n}\r\n\r\n.icofont-forest-fire:before {\r\n\tcontent: \"\\ef1d\";\r\n}\r\n\r\n.icofont-full-night:before {\r\n\tcontent: \"\\ef1e\";\r\n}\r\n\r\n.icofont-full-sunny:before {\r\n\tcontent: \"\\ef1f\";\r\n}\r\n\r\n.icofont-hail-night:before {\r\n\tcontent: \"\\ef20\";\r\n}\r\n\r\n.icofont-hail-rainy-night:before {\r\n\tcontent: \"\\ef21\";\r\n}\r\n\r\n.icofont-hail-rainy-sunny:before {\r\n\tcontent: \"\\ef22\";\r\n}\r\n\r\n.icofont-hail-rainy:before {\r\n\tcontent: \"\\ef23\";\r\n}\r\n\r\n.icofont-hail-sunny:before {\r\n\tcontent: \"\\ef24\";\r\n}\r\n\r\n.icofont-hail-thunder-night:before {\r\n\tcontent: \"\\ef25\";\r\n}\r\n\r\n.icofont-hail-thunder-sunny:before {\r\n\tcontent: \"\\ef26\";\r\n}\r\n\r\n.icofont-hail-thunder:before {\r\n\tcontent: \"\\ef27\";\r\n}\r\n\r\n.icofont-hail:before {\r\n\tcontent: \"\\ef28\";\r\n}\r\n\r\n.icofont-hill-night:before {\r\n\tcontent: \"\\ef29\";\r\n}\r\n\r\n.icofont-hill-sunny:before {\r\n\tcontent: \"\\ef2a\";\r\n}\r\n\r\n.icofont-hill:before {\r\n\tcontent: \"\\ef2b\";\r\n}\r\n\r\n.icofont-hurricane:before {\r\n\tcontent: \"\\ef2c\";\r\n}\r\n\r\n.icofont-island:before {\r\n\tcontent: \"\\ef2d\";\r\n}\r\n\r\n.icofont-meteor:before {\r\n\tcontent: \"\\ef2e\";\r\n}\r\n\r\n.icofont-night:before {\r\n\tcontent: \"\\ef2f\";\r\n}\r\n\r\n.icofont-rainy-night:before {\r\n\tcontent: \"\\ef30\";\r\n}\r\n\r\n.icofont-rainy-sunny:before {\r\n\tcontent: \"\\ef31\";\r\n}\r\n\r\n.icofont-rainy-thunder:before {\r\n\tcontent: \"\\ef32\";\r\n}\r\n\r\n.icofont-rainy:before {\r\n\tcontent: \"\\ef33\";\r\n}\r\n\r\n.icofont-showy-night-hail:before {\r\n\tcontent: \"\\ef34\";\r\n}\r\n\r\n.icofont-snow-temp:before {\r\n\tcontent: \"\\ef35\";\r\n}\r\n\r\n.icofont-snow:before {\r\n\tcontent: \"\\ef36\";\r\n}\r\n\r\n.icofont-snowy-hail:before {\r\n\tcontent: \"\\ef37\";\r\n}\r\n\r\n.icofont-snowy-night-rainy:before {\r\n\tcontent: \"\\ef38\";\r\n}\r\n\r\n.icofont-snowy-night:before {\r\n\tcontent: \"\\ef39\";\r\n}\r\n\r\n.icofont-snowy-rainy:before {\r\n\tcontent: \"\\ef3a\";\r\n}\r\n\r\n.icofont-snowy-sunny-hail:before {\r\n\tcontent: \"\\ef3b\";\r\n}\r\n\r\n.icofont-snowy-sunny-rainy:before {\r\n\tcontent: \"\\ef3c\";\r\n}\r\n\r\n.icofont-snowy-sunny:before {\r\n\tcontent: \"\\ef3d\";\r\n}\r\n\r\n.icofont-snowy-thunder-night:before {\r\n\tcontent: \"\\ef3e\";\r\n}\r\n\r\n.icofont-snowy-thunder-sunny:before {\r\n\tcontent: \"\\ef3f\";\r\n}\r\n\r\n.icofont-snowy-thunder:before {\r\n\tcontent: \"\\ef40\";\r\n}\r\n\r\n.icofont-snowy-windy-night:before {\r\n\tcontent: \"\\ef41\";\r\n}\r\n\r\n.icofont-snowy-windy-sunny:before {\r\n\tcontent: \"\\ef42\";\r\n}\r\n\r\n.icofont-snowy-windy:before {\r\n\tcontent: \"\\ef43\";\r\n}\r\n\r\n.icofont-snowy:before {\r\n\tcontent: \"\\ef44\";\r\n}\r\n\r\n.icofont-sun-alt:before {\r\n\tcontent: \"\\ef45\";\r\n}\r\n\r\n.icofont-sun-rise:before {\r\n\tcontent: \"\\ef46\";\r\n}\r\n\r\n.icofont-sun-set:before {\r\n\tcontent: \"\\ef47\";\r\n}\r\n\r\n.icofont-sunny-day-temp:before {\r\n\tcontent: \"\\ef48\";\r\n}\r\n\r\n.icofont-sunny:before {\r\n\tcontent: \"\\ef49\";\r\n}\r\n\r\n.icofont-thermometer:before {\r\n\tcontent: \"\\ef4a\";\r\n}\r\n\r\n.icofont-thinder-light:before {\r\n\tcontent: \"\\ef4b\";\r\n}\r\n\r\n.icofont-tornado:before {\r\n\tcontent: \"\\ef4c\";\r\n}\r\n\r\n.icofont-umbrella-alt:before {\r\n\tcontent: \"\\ef4d\";\r\n}\r\n\r\n.icofont-volcano:before {\r\n\tcontent: \"\\ef4e\";\r\n}\r\n\r\n.icofont-wave:before {\r\n\tcontent: \"\\ef4f\";\r\n}\r\n\r\n.icofont-wind-scale-0:before {\r\n\tcontent: \"\\ef50\";\r\n}\r\n\r\n.icofont-wind-scale-1:before {\r\n\tcontent: \"\\ef51\";\r\n}\r\n\r\n.icofont-wind-scale-2:before {\r\n\tcontent: \"\\ef52\";\r\n}\r\n\r\n.icofont-wind-scale-3:before {\r\n\tcontent: \"\\ef53\";\r\n}\r\n\r\n.icofont-wind-scale-4:before {\r\n\tcontent: \"\\ef54\";\r\n}\r\n\r\n.icofont-wind-scale-5:before {\r\n\tcontent: \"\\ef55\";\r\n}\r\n\r\n.icofont-wind-scale-6:before {\r\n\tcontent: \"\\ef56\";\r\n}\r\n\r\n.icofont-wind-scale-7:before {\r\n\tcontent: \"\\ef57\";\r\n}\r\n\r\n.icofont-wind-scale-8:before {\r\n\tcontent: \"\\ef58\";\r\n}\r\n\r\n.icofont-wind-scale-9:before {\r\n\tcontent: \"\\ef59\";\r\n}\r\n\r\n.icofont-wind-scale-10:before {\r\n\tcontent: \"\\ef5a\";\r\n}\r\n\r\n.icofont-wind-scale-11:before {\r\n\tcontent: \"\\ef5b\";\r\n}\r\n\r\n.icofont-wind-scale-12:before {\r\n\tcontent: \"\\ef5c\";\r\n}\r\n\r\n.icofont-wind-waves:before {\r\n\tcontent: \"\\ef5d\";\r\n}\r\n\r\n.icofont-wind:before {\r\n\tcontent: \"\\ef5e\";\r\n}\r\n\r\n.icofont-windy-hail:before {\r\n\tcontent: \"\\ef5f\";\r\n}\r\n\r\n.icofont-windy-night:before {\r\n\tcontent: \"\\ef60\";\r\n}\r\n\r\n.icofont-windy-raining:before {\r\n\tcontent: \"\\ef61\";\r\n}\r\n\r\n.icofont-windy-sunny:before {\r\n\tcontent: \"\\ef62\";\r\n}\r\n\r\n.icofont-windy-thunder-raining:before {\r\n\tcontent: \"\\ef63\";\r\n}\r\n\r\n.icofont-windy-thunder:before {\r\n\tcontent: \"\\ef64\";\r\n}\r\n\r\n.icofont-windy:before {\r\n\tcontent: \"\\ef65\";\r\n}\r\n\r\n.icofont-addons:before {\r\n\tcontent: \"\\ef66\";\r\n}\r\n\r\n.icofont-address-book:before {\r\n\tcontent: \"\\ef67\";\r\n}\r\n\r\n.icofont-adjust:before {\r\n\tcontent: \"\\ef68\";\r\n}\r\n\r\n.icofont-alarm:before {\r\n\tcontent: \"\\ef69\";\r\n}\r\n\r\n.icofont-anchor:before {\r\n\tcontent: \"\\ef6a\";\r\n}\r\n\r\n.icofont-archive:before {\r\n\tcontent: \"\\ef6b\";\r\n}\r\n\r\n.icofont-at:before {\r\n\tcontent: \"\\ef6c\";\r\n}\r\n\r\n.icofont-attachment:before {\r\n\tcontent: \"\\ef6d\";\r\n}\r\n\r\n.icofont-audio:before {\r\n\tcontent: \"\\ef6e\";\r\n}\r\n\r\n.icofont-auto-mobile:before {\r\n\tcontent: \"\\ef6f\";\r\n}\r\n\r\n.icofont-automation:before {\r\n\tcontent: \"\\ef70\";\r\n}\r\n\r\n.icofont-baby:before {\r\n\tcontent: \"\\ef71\";\r\n}\r\n\r\n.icofont-badge:before {\r\n\tcontent: \"\\ef72\";\r\n}\r\n\r\n.icofont-bag:before {\r\n\tcontent: \"\\ef73\";\r\n}\r\n\r\n.icofont-ban:before {\r\n\tcontent: \"\\ef74\";\r\n}\r\n\r\n.icofont-bank:before {\r\n\tcontent: \"\\ef75\";\r\n}\r\n\r\n.icofont-bar-code:before {\r\n\tcontent: \"\\ef76\";\r\n}\r\n\r\n.icofont-bars:before {\r\n\tcontent: \"\\ef77\";\r\n}\r\n\r\n.icofont-battery-empty:before {\r\n\tcontent: \"\\ef78\";\r\n}\r\n\r\n.icofont-battery-full:before {\r\n\tcontent: \"\\ef79\";\r\n}\r\n\r\n.icofont-battery-half:before {\r\n\tcontent: \"\\ef7a\";\r\n}\r\n\r\n.icofont-battery-low:before {\r\n\tcontent: \"\\ef7b\";\r\n}\r\n\r\n.icofont-beach:before {\r\n\tcontent: \"\\ef7c\";\r\n}\r\n\r\n.icofont-beaker:before {\r\n\tcontent: \"\\ef7d\";\r\n}\r\n\r\n.icofont-bear:before {\r\n\tcontent: \"\\ef7e\";\r\n}\r\n\r\n.icofont-beard:before {\r\n\tcontent: \"\\ef7f\";\r\n}\r\n\r\n.icofont-bed:before {\r\n\tcontent: \"\\ef80\";\r\n}\r\n\r\n.icofont-bell:before {\r\n\tcontent: \"\\ef81\";\r\n}\r\n\r\n.icofont-beverage:before {\r\n\tcontent: \"\\ef82\";\r\n}\r\n\r\n.icofont-bicycle:before {\r\n\tcontent: \"\\ef83\";\r\n}\r\n\r\n.icofont-bill:before {\r\n\tcontent: \"\\ef84\";\r\n}\r\n\r\n.icofont-bin:before {\r\n\tcontent: \"\\ef85\";\r\n}\r\n\r\n.icofont-binary:before {\r\n\tcontent: \"\\ef86\";\r\n}\r\n\r\n.icofont-binoculars:before {\r\n\tcontent: \"\\ef87\";\r\n}\r\n\r\n.icofont-bird:before {\r\n\tcontent: \"\\ef88\";\r\n}\r\n\r\n.icofont-birds:before {\r\n\tcontent: \"\\ef89\";\r\n}\r\n\r\n.icofont-black-board:before {\r\n\tcontent: \"\\ef8a\";\r\n}\r\n\r\n.icofont-bluetooth:before {\r\n\tcontent: \"\\ef8b\";\r\n}\r\n\r\n.icofont-bolt:before {\r\n\tcontent: \"\\ef8c\";\r\n}\r\n\r\n.icofont-bomb:before {\r\n\tcontent: \"\\ef8d\";\r\n}\r\n\r\n.icofont-book-mark:before {\r\n\tcontent: \"\\ef8e\";\r\n}\r\n\r\n.icofont-book:before {\r\n\tcontent: \"\\ef8f\";\r\n}\r\n\r\n.icofont-boot:before {\r\n\tcontent: \"\\ef90\";\r\n}\r\n\r\n.icofont-box:before {\r\n\tcontent: \"\\ef91\";\r\n}\r\n\r\n.icofont-brain:before {\r\n\tcontent: \"\\ef92\";\r\n}\r\n\r\n.icofont-briefcase:before {\r\n\tcontent: \"\\ef93\";\r\n}\r\n\r\n.icofont-broken:before {\r\n\tcontent: \"\\ef94\";\r\n}\r\n\r\n.icofont-bucket:before {\r\n\tcontent: \"\\ef95\";\r\n}\r\n\r\n.icofont-bucket1:before {\r\n\tcontent: \"\\ef96\";\r\n}\r\n\r\n.icofont-bucket2:before {\r\n\tcontent: \"\\ef97\";\r\n}\r\n\r\n.icofont-bug:before {\r\n\tcontent: \"\\ef98\";\r\n}\r\n\r\n.icofont-building:before {\r\n\tcontent: \"\\ef99\";\r\n}\r\n\r\n.icofont-bullet:before {\r\n\tcontent: \"\\ef9a\";\r\n}\r\n\r\n.icofont-bullhorn:before {\r\n\tcontent: \"\\ef9b\";\r\n}\r\n\r\n.icofont-bullseye:before {\r\n\tcontent: \"\\ef9c\";\r\n}\r\n\r\n.icofont-bus:before {\r\n\tcontent: \"\\ef9d\";\r\n}\r\n\r\n.icofont-butterfly:before {\r\n\tcontent: \"\\ef9e\";\r\n}\r\n\r\n.icofont-cab:before {\r\n\tcontent: \"\\ef9f\";\r\n}\r\n\r\n.icofont-calculator:before {\r\n\tcontent: \"\\efa0\";\r\n}\r\n\r\n.icofont-calendar:before {\r\n\tcontent: \"\\efa1\";\r\n}\r\n\r\n.icofont-camera-alt:before {\r\n\tcontent: \"\\efa2\";\r\n}\r\n\r\n.icofont-camera:before {\r\n\tcontent: \"\\efa3\";\r\n}\r\n\r\n.icofont-car:before {\r\n\tcontent: \"\\efa4\";\r\n}\r\n\r\n.icofont-card:before {\r\n\tcontent: \"\\efa5\";\r\n}\r\n\r\n.icofont-cart:before {\r\n\tcontent: \"\\efa6\";\r\n}\r\n\r\n.icofont-cc:before {\r\n\tcontent: \"\\efa7\";\r\n}\r\n\r\n.icofont-certificate:before {\r\n\tcontent: \"\\efa8\";\r\n}\r\n\r\n.icofont-charging:before {\r\n\tcontent: \"\\efa9\";\r\n}\r\n\r\n.icofont-chat:before {\r\n\tcontent: \"\\efaa\";\r\n}\r\n\r\n.icofont-check-alt:before {\r\n\tcontent: \"\\efab\";\r\n}\r\n\r\n.icofont-check-circled:before {\r\n\tcontent: \"\\efac\";\r\n}\r\n\r\n.icofont-check:before {\r\n\tcontent: \"\\efad\";\r\n}\r\n\r\n.icofont-checked:before {\r\n\tcontent: \"\\efae\";\r\n}\r\n\r\n.icofont-children-care:before {\r\n\tcontent: \"\\efaf\";\r\n}\r\n\r\n.icofont-clock-time:before {\r\n\tcontent: \"\\efb0\";\r\n}\r\n\r\n.icofont-close-circled:before {\r\n\tcontent: \"\\efb1\";\r\n}\r\n\r\n.icofont-close-line-circled:before {\r\n\tcontent: \"\\efb2\";\r\n}\r\n\r\n.icofont-close-line-squared-alt:before {\r\n\tcontent: \"\\efb3\";\r\n}\r\n\r\n.icofont-close-line-squared:before {\r\n\tcontent: \"\\efb4\";\r\n}\r\n\r\n.icofont-close-line:before {\r\n\tcontent: \"\\efb5\";\r\n}\r\n\r\n.icofont-close-squared-alt:before {\r\n\tcontent: \"\\efb6\";\r\n}\r\n\r\n.icofont-close-squared:before {\r\n\tcontent: \"\\efb7\";\r\n}\r\n\r\n.icofont-close:before {\r\n\tcontent: \"\\efb8\";\r\n}\r\n\r\n.icofont-cloud-download:before {\r\n\tcontent: \"\\efb9\";\r\n}\r\n\r\n.icofont-cloud-refresh:before {\r\n\tcontent: \"\\efba\";\r\n}\r\n\r\n.icofont-cloud-upload:before {\r\n\tcontent: \"\\efbb\";\r\n}\r\n\r\n.icofont-cloud:before {\r\n\tcontent: \"\\efbc\";\r\n}\r\n\r\n.icofont-code-not-allowed:before {\r\n\tcontent: \"\\efbd\";\r\n}\r\n\r\n.icofont-code:before {\r\n\tcontent: \"\\efbe\";\r\n}\r\n\r\n.icofont-coffee-cup:before {\r\n\tcontent: \"\\efbf\";\r\n}\r\n\r\n.icofont-comment:before {\r\n\tcontent: \"\\efc0\";\r\n}\r\n\r\n.icofont-compass:before {\r\n\tcontent: \"\\efc1\";\r\n}\r\n\r\n.icofont-computer:before {\r\n\tcontent: \"\\efc2\";\r\n}\r\n\r\n.icofont-connection:before {\r\n\tcontent: \"\\efc3\";\r\n}\r\n\r\n.icofont-console:before {\r\n\tcontent: \"\\efc4\";\r\n}\r\n\r\n.icofont-contacts:before {\r\n\tcontent: \"\\efc5\";\r\n}\r\n\r\n.icofont-contrast:before {\r\n\tcontent: \"\\efc6\";\r\n}\r\n\r\n.icofont-copy:before {\r\n\tcontent: \"\\efc7\";\r\n}\r\n\r\n.icofont-copyright:before {\r\n\tcontent: \"\\efc8\";\r\n}\r\n\r\n.icofont-credit-card:before {\r\n\tcontent: \"\\efc9\";\r\n}\r\n\r\n.icofont-crop:before {\r\n\tcontent: \"\\efca\";\r\n}\r\n\r\n.icofont-crown:before {\r\n\tcontent: \"\\efcb\";\r\n}\r\n\r\n.icofont-cube:before {\r\n\tcontent: \"\\efcc\";\r\n}\r\n\r\n.icofont-cubes:before {\r\n\tcontent: \"\\efcd\";\r\n}\r\n\r\n.icofont-culinary:before {\r\n\tcontent: \"\\efce\";\r\n}\r\n\r\n.icofont-dashboard-web:before {\r\n\tcontent: \"\\efcf\";\r\n}\r\n\r\n.icofont-dashboard:before {\r\n\tcontent: \"\\efd0\";\r\n}\r\n\r\n.icofont-data:before {\r\n\tcontent: \"\\efd1\";\r\n}\r\n\r\n.icofont-database-add:before {\r\n\tcontent: \"\\efd2\";\r\n}\r\n\r\n.icofont-database-locked:before {\r\n\tcontent: \"\\efd3\";\r\n}\r\n\r\n.icofont-database-remove:before {\r\n\tcontent: \"\\efd4\";\r\n}\r\n\r\n.icofont-database:before {\r\n\tcontent: \"\\efd5\";\r\n}\r\n\r\n.icofont-delete:before {\r\n\tcontent: \"\\efd6\";\r\n}\r\n\r\n.icofont-diamond:before {\r\n\tcontent: \"\\efd7\";\r\n}\r\n\r\n.icofont-dice:before {\r\n\tcontent: \"\\efd8\";\r\n}\r\n\r\n.icofont-disabled:before {\r\n\tcontent: \"\\efd9\";\r\n}\r\n\r\n.icofont-disc:before {\r\n\tcontent: \"\\efda\";\r\n}\r\n\r\n.icofont-diskette:before {\r\n\tcontent: \"\\efdb\";\r\n}\r\n\r\n.icofont-document-folder:before {\r\n\tcontent: \"\\efdc\";\r\n}\r\n\r\n.icofont-download-alt:before {\r\n\tcontent: \"\\efdd\";\r\n}\r\n\r\n.icofont-download:before {\r\n\tcontent: \"\\efde\";\r\n}\r\n\r\n.icofont-downloaded:before {\r\n\tcontent: \"\\efdf\";\r\n}\r\n\r\n.icofont-earth:before {\r\n\tcontent: \"\\efe0\";\r\n}\r\n\r\n.icofont-ebook:before {\r\n\tcontent: \"\\efe1\";\r\n}\r\n\r\n.icofont-edit:before {\r\n\tcontent: \"\\efe2\";\r\n}\r\n\r\n.icofont-eject:before {\r\n\tcontent: \"\\efe3\";\r\n}\r\n\r\n.icofont-email:before {\r\n\tcontent: \"\\efe4\";\r\n}\r\n\r\n.icofont-envelope-open:before {\r\n\tcontent: \"\\efe5\";\r\n}\r\n\r\n.icofont-envelope:before {\r\n\tcontent: \"\\efe6\";\r\n}\r\n\r\n.icofont-eraser:before {\r\n\tcontent: \"\\efe7\";\r\n}\r\n\r\n.icofont-error:before {\r\n\tcontent: \"\\efe8\";\r\n}\r\n\r\n.icofont-exchange:before {\r\n\tcontent: \"\\efe9\";\r\n}\r\n\r\n.icofont-exclamation-circle:before {\r\n\tcontent: \"\\efea\";\r\n}\r\n\r\n.icofont-exclamation-square:before {\r\n\tcontent: \"\\efeb\";\r\n}\r\n\r\n.icofont-exclamation-tringle:before {\r\n\tcontent: \"\\efec\";\r\n}\r\n\r\n.icofont-exclamation:before {\r\n\tcontent: \"\\efed\";\r\n}\r\n\r\n.icofont-exit:before {\r\n\tcontent: \"\\efee\";\r\n}\r\n\r\n.icofont-expand:before {\r\n\tcontent: \"\\efef\";\r\n}\r\n\r\n.icofont-external-link:before {\r\n\tcontent: \"\\eff0\";\r\n}\r\n\r\n.icofont-external:before {\r\n\tcontent: \"\\eff1\";\r\n}\r\n\r\n.icofont-eye-blocked:before {\r\n\tcontent: \"\\eff2\";\r\n}\r\n\r\n.icofont-eye-dropper:before {\r\n\tcontent: \"\\eff3\";\r\n}\r\n\r\n.icofont-eye:before {\r\n\tcontent: \"\\eff4\";\r\n}\r\n\r\n.icofont-favourite:before {\r\n\tcontent: \"\\eff5\";\r\n}\r\n\r\n.icofont-fax:before {\r\n\tcontent: \"\\eff6\";\r\n}\r\n\r\n.icofont-female:before {\r\n\tcontent: \"\\eff7\";\r\n}\r\n\r\n.icofont-file:before {\r\n\tcontent: \"\\eff8\";\r\n}\r\n\r\n.icofont-film:before {\r\n\tcontent: \"\\eff9\";\r\n}\r\n\r\n.icofont-filter:before {\r\n\tcontent: \"\\effa\";\r\n}\r\n\r\n.icofont-fire-burn:before {\r\n\tcontent: \"\\effb\";\r\n}\r\n\r\n.icofont-fire-extinguisher:before {\r\n\tcontent: \"\\effc\";\r\n}\r\n\r\n.icofont-fire:before {\r\n\tcontent: \"\\effd\";\r\n}\r\n\r\n.icofont-first-aid:before {\r\n\tcontent: \"\\effe\";\r\n}\r\n\r\n.icofont-flag-alt-1:before {\r\n\tcontent: \"\\efff\";\r\n}\r\n\r\n.icofont-flag-alt-2:before {\r\n\tcontent: \"\\f000\";\r\n}\r\n\r\n.icofont-flag:before {\r\n\tcontent: \"\\f001\";\r\n}\r\n\r\n.icofont-flash-light:before {\r\n\tcontent: \"\\f002\";\r\n}\r\n\r\n.icofont-flash:before {\r\n\tcontent: \"\\f003\";\r\n}\r\n\r\n.icofont-flask:before {\r\n\tcontent: \"\\f004\";\r\n}\r\n\r\n.icofont-focus:before {\r\n\tcontent: \"\\f005\";\r\n}\r\n\r\n.icofont-folder-open:before {\r\n\tcontent: \"\\f006\";\r\n}\r\n\r\n.icofont-folder:before {\r\n\tcontent: \"\\f007\";\r\n}\r\n\r\n.icofont-foot-print:before {\r\n\tcontent: \"\\f008\";\r\n}\r\n\r\n.icofont-football-american:before {\r\n\tcontent: \"\\f009\";\r\n}\r\n\r\n.icofont-football:before {\r\n\tcontent: \"\\f00a\";\r\n}\r\n\r\n.icofont-game-console:before {\r\n\tcontent: \"\\f00b\";\r\n}\r\n\r\n.icofont-game-pad:before {\r\n\tcontent: \"\\f00c\";\r\n}\r\n\r\n.icofont-gavel:before {\r\n\tcontent: \"\\f00d\";\r\n}\r\n\r\n.icofont-gear:before {\r\n\tcontent: \"\\f00e\";\r\n}\r\n\r\n.icofont-gears:before {\r\n\tcontent: \"\\f00f\";\r\n}\r\n\r\n.icofont-gift:before {\r\n\tcontent: \"\\f010\";\r\n}\r\n\r\n.icofont-glass:before {\r\n\tcontent: \"\\f011\";\r\n}\r\n\r\n.icofont-globe:before {\r\n\tcontent: \"\\f012\";\r\n}\r\n\r\n.icofont-graduate:before {\r\n\tcontent: \"\\f013\";\r\n}\r\n\r\n.icofont-graffiti:before {\r\n\tcontent: \"\\f014\";\r\n}\r\n\r\n.icofont-grocery:before {\r\n\tcontent: \"\\f015\";\r\n}\r\n\r\n.icofont-group:before {\r\n\tcontent: \"\\f016\";\r\n}\r\n\r\n.icofont-hammer:before {\r\n\tcontent: \"\\f017\";\r\n}\r\n\r\n.icofont-hand:before {\r\n\tcontent: \"\\f018\";\r\n}\r\n\r\n.icofont-hanger:before {\r\n\tcontent: \"\\f019\";\r\n}\r\n\r\n.icofont-hard-disk:before {\r\n\tcontent: \"\\f01a\";\r\n}\r\n\r\n.icofont-headphone:before {\r\n\tcontent: \"\\f01b\";\r\n}\r\n\r\n.icofont-heart-beat:before {\r\n\tcontent: \"\\f01c\";\r\n}\r\n\r\n.icofont-heart:before {\r\n\tcontent: \"\\f01d\";\r\n}\r\n\r\n.icofont-history:before {\r\n\tcontent: \"\\f01e\";\r\n}\r\n\r\n.icofont-home:before {\r\n\tcontent: \"\\f01f\";\r\n}\r\n\r\n.icofont-horn:before {\r\n\tcontent: \"\\f020\";\r\n}\r\n\r\n.icofont-hotel:before {\r\n\tcontent: \"\\f021\";\r\n}\r\n\r\n.icofont-hour-glass:before {\r\n\tcontent: \"\\f022\";\r\n}\r\n\r\n.icofont-id:before {\r\n\tcontent: \"\\f023\";\r\n}\r\n\r\n.icofont-image:before {\r\n\tcontent: \"\\f024\";\r\n}\r\n\r\n.icofont-inbox:before {\r\n\tcontent: \"\\f025\";\r\n}\r\n\r\n.icofont-infinite:before {\r\n\tcontent: \"\\f026\";\r\n}\r\n\r\n.icofont-info-circle:before {\r\n\tcontent: \"\\f027\";\r\n}\r\n\r\n.icofont-info-square:before {\r\n\tcontent: \"\\f028\";\r\n}\r\n\r\n.icofont-info:before {\r\n\tcontent: \"\\f029\";\r\n}\r\n\r\n.icofont-institution:before {\r\n\tcontent: \"\\f02a\";\r\n}\r\n\r\n.icofont-interface:before {\r\n\tcontent: \"\\f02b\";\r\n}\r\n\r\n.icofont-invisible:before {\r\n\tcontent: \"\\f02c\";\r\n}\r\n\r\n.icofont-italic:before {\r\n\tcontent: \"\\f02d\";\r\n}\r\n\r\n.icofont-jacket:before {\r\n\tcontent: \"\\f02e\";\r\n}\r\n\r\n.icofont-jar:before {\r\n\tcontent: \"\\f02f\";\r\n}\r\n\r\n.icofont-jewlery:before {\r\n\tcontent: \"\\f030\";\r\n}\r\n\r\n.icofont-karate:before {\r\n\tcontent: \"\\f031\";\r\n}\r\n\r\n.icofont-key-hole:before {\r\n\tcontent: \"\\f032\";\r\n}\r\n\r\n.icofont-key:before {\r\n\tcontent: \"\\f033\";\r\n}\r\n\r\n.icofont-keyboard:before {\r\n\tcontent: \"\\f034\";\r\n}\r\n\r\n.icofont-kid:before {\r\n\tcontent: \"\\f035\";\r\n}\r\n\r\n.icofont-label:before {\r\n\tcontent: \"\\f036\";\r\n}\r\n\r\n.icofont-lamp:before {\r\n\tcontent: \"\\f037\";\r\n}\r\n\r\n.icofont-laptop:before {\r\n\tcontent: \"\\f038\";\r\n}\r\n\r\n.icofont-layers:before {\r\n\tcontent: \"\\f039\";\r\n}\r\n\r\n.icofont-layout:before {\r\n\tcontent: \"\\f03a\";\r\n}\r\n\r\n.icofont-leaf:before {\r\n\tcontent: \"\\f03b\";\r\n}\r\n\r\n.icofont-leaflet:before {\r\n\tcontent: \"\\f03c\";\r\n}\r\n\r\n.icofont-learn:before {\r\n\tcontent: \"\\f03d\";\r\n}\r\n\r\n.icofont-legal:before {\r\n\tcontent: \"\\f03e\";\r\n}\r\n\r\n.icofont-lego:before {\r\n\tcontent: \"\\f03f\";\r\n}\r\n\r\n.icofont-lemon:before {\r\n\tcontent: \"\\f040\";\r\n}\r\n\r\n.icofont-lens:before {\r\n\tcontent: \"\\f041\";\r\n}\r\n\r\n.icofont-letter:before {\r\n\tcontent: \"\\f042\";\r\n}\r\n\r\n.icofont-letterbox:before {\r\n\tcontent: \"\\f043\";\r\n}\r\n\r\n.icofont-library:before {\r\n\tcontent: \"\\f044\";\r\n}\r\n\r\n.icofont-license:before {\r\n\tcontent: \"\\f045\";\r\n}\r\n\r\n.icofont-life-bouy:before {\r\n\tcontent: \"\\f046\";\r\n}\r\n\r\n.icofont-life-buoy:before {\r\n\tcontent: \"\\f047\";\r\n}\r\n\r\n.icofont-life-jacket:before {\r\n\tcontent: \"\\f048\";\r\n}\r\n\r\n.icofont-life-ring:before {\r\n\tcontent: \"\\f049\";\r\n}\r\n\r\n.icofont-light-bulb:before {\r\n\tcontent: \"\\f04a\";\r\n}\r\n\r\n.icofont-lighter:before {\r\n\tcontent: \"\\f04b\";\r\n}\r\n\r\n.icofont-lightning-ray:before {\r\n\tcontent: \"\\f04c\";\r\n}\r\n\r\n.icofont-like:before {\r\n\tcontent: \"\\f04d\";\r\n}\r\n\r\n.icofont-link:before {\r\n\tcontent: \"\\f04e\";\r\n}\r\n\r\n.icofont-live-support:before {\r\n\tcontent: \"\\f04f\";\r\n}\r\n\r\n.icofont-location-arrow:before {\r\n\tcontent: \"\\f050\";\r\n}\r\n\r\n.icofont-location-pin:before {\r\n\tcontent: \"\\f051\";\r\n}\r\n\r\n.icofont-lock:before {\r\n\tcontent: \"\\f052\";\r\n}\r\n\r\n.icofont-login:before {\r\n\tcontent: \"\\f053\";\r\n}\r\n\r\n.icofont-logout:before {\r\n\tcontent: \"\\f054\";\r\n}\r\n\r\n.icofont-lollipop:before {\r\n\tcontent: \"\\f055\";\r\n}\r\n\r\n.icofont-look:before {\r\n\tcontent: \"\\f056\";\r\n}\r\n\r\n.icofont-loop:before {\r\n\tcontent: \"\\f057\";\r\n}\r\n\r\n.icofont-luggage:before {\r\n\tcontent: \"\\f058\";\r\n}\r\n\r\n.icofont-lunch:before {\r\n\tcontent: \"\\f059\";\r\n}\r\n\r\n.icofont-lungs:before {\r\n\tcontent: \"\\f05a\";\r\n}\r\n\r\n.icofont-magic-alt:before {\r\n\tcontent: \"\\f05b\";\r\n}\r\n\r\n.icofont-magic:before {\r\n\tcontent: \"\\f05c\";\r\n}\r\n\r\n.icofont-magnet:before {\r\n\tcontent: \"\\f05d\";\r\n}\r\n\r\n.icofont-mail-box:before {\r\n\tcontent: \"\\f05e\";\r\n}\r\n\r\n.icofont-mail:before {\r\n\tcontent: \"\\f05f\";\r\n}\r\n\r\n.icofont-male:before {\r\n\tcontent: \"\\f060\";\r\n}\r\n\r\n.icofont-map:before {\r\n\tcontent: \"\\f061\";\r\n}\r\n\r\n.icofont-math:before {\r\n\tcontent: \"\\f062\";\r\n}\r\n\r\n.icofont-maximize:before {\r\n\tcontent: \"\\f063\";\r\n}\r\n\r\n.icofont-measure:before {\r\n\tcontent: \"\\f064\";\r\n}\r\n\r\n.icofont-medal:before {\r\n\tcontent: \"\\f065\";\r\n}\r\n\r\n.icofont-medical:before {\r\n\tcontent: \"\\f066\";\r\n}\r\n\r\n.icofont-medicine:before {\r\n\tcontent: \"\\f067\";\r\n}\r\n\r\n.icofont-mega-phone:before {\r\n\tcontent: \"\\f068\";\r\n}\r\n\r\n.icofont-memorial:before {\r\n\tcontent: \"\\f069\";\r\n}\r\n\r\n.icofont-memory-card:before {\r\n\tcontent: \"\\f06a\";\r\n}\r\n\r\n.icofont-mic-mute:before {\r\n\tcontent: \"\\f06b\";\r\n}\r\n\r\n.icofont-mic:before {\r\n\tcontent: \"\\f06c\";\r\n}\r\n\r\n.icofont-micro-chip:before {\r\n\tcontent: \"\\f06d\";\r\n}\r\n\r\n.icofont-microphone:before {\r\n\tcontent: \"\\f06e\";\r\n}\r\n\r\n.icofont-microscope:before {\r\n\tcontent: \"\\f06f\";\r\n}\r\n\r\n.icofont-military:before {\r\n\tcontent: \"\\f070\";\r\n}\r\n\r\n.icofont-mill:before {\r\n\tcontent: \"\\f071\";\r\n}\r\n\r\n.icofont-minus-circle:before {\r\n\tcontent: \"\\f072\";\r\n}\r\n\r\n.icofont-minus-square:before {\r\n\tcontent: \"\\f073\";\r\n}\r\n\r\n.icofont-minus:before {\r\n\tcontent: \"\\f074\";\r\n}\r\n\r\n.icofont-mobile-phone:before {\r\n\tcontent: \"\\f075\";\r\n}\r\n\r\n.icofont-molecule:before {\r\n\tcontent: \"\\f076\";\r\n}\r\n\r\n.icofont-money:before {\r\n\tcontent: \"\\f077\";\r\n}\r\n\r\n.icofont-moon:before {\r\n\tcontent: \"\\f078\";\r\n}\r\n\r\n.icofont-mop:before {\r\n\tcontent: \"\\f079\";\r\n}\r\n\r\n.icofont-muffin:before {\r\n\tcontent: \"\\f07a\";\r\n}\r\n\r\n.icofont-music-alt:before {\r\n\tcontent: \"\\f07b\";\r\n}\r\n\r\n.icofont-music-notes:before {\r\n\tcontent: \"\\f07c\";\r\n}\r\n\r\n.icofont-music:before {\r\n\tcontent: \"\\f07d\";\r\n}\r\n\r\n.icofont-mustache:before {\r\n\tcontent: \"\\f07e\";\r\n}\r\n\r\n.icofont-mute-volume:before {\r\n\tcontent: \"\\f07f\";\r\n}\r\n\r\n.icofont-navigation-menu:before {\r\n\tcontent: \"\\f080\";\r\n}\r\n\r\n.icofont-navigation:before {\r\n\tcontent: \"\\f081\";\r\n}\r\n\r\n.icofont-network-tower:before {\r\n\tcontent: \"\\f082\";\r\n}\r\n\r\n.icofont-network:before {\r\n\tcontent: \"\\f083\";\r\n}\r\n\r\n.icofont-news:before {\r\n\tcontent: \"\\f084\";\r\n}\r\n\r\n.icofont-newspaper:before {\r\n\tcontent: \"\\f085\";\r\n}\r\n\r\n.icofont-no-smoking:before {\r\n\tcontent: \"\\f086\";\r\n}\r\n\r\n.icofont-not-allowed:before {\r\n\tcontent: \"\\f087\";\r\n}\r\n\r\n.icofont-notebook:before {\r\n\tcontent: \"\\f088\";\r\n}\r\n\r\n.icofont-notepad:before {\r\n\tcontent: \"\\f089\";\r\n}\r\n\r\n.icofont-notification:before {\r\n\tcontent: \"\\f08a\";\r\n}\r\n\r\n.icofont-numbered:before {\r\n\tcontent: \"\\f08b\";\r\n}\r\n\r\n.icofont-opposite:before {\r\n\tcontent: \"\\f08c\";\r\n}\r\n\r\n.icofont-optic:before {\r\n\tcontent: \"\\f08d\";\r\n}\r\n\r\n.icofont-options:before {\r\n\tcontent: \"\\f08e\";\r\n}\r\n\r\n.icofont-package:before {\r\n\tcontent: \"\\f08f\";\r\n}\r\n\r\n.icofont-page:before {\r\n\tcontent: \"\\f090\";\r\n}\r\n\r\n.icofont-paint:before {\r\n\tcontent: \"\\f091\";\r\n}\r\n\r\n.icofont-paper-plane:before {\r\n\tcontent: \"\\f092\";\r\n}\r\n\r\n.icofont-paperclip:before {\r\n\tcontent: \"\\f093\";\r\n}\r\n\r\n.icofont-papers:before {\r\n\tcontent: \"\\f094\";\r\n}\r\n\r\n.icofont-paw:before {\r\n\tcontent: \"\\f095\";\r\n}\r\n\r\n.icofont-pay:before {\r\n\tcontent: \"\\f096\";\r\n}\r\n\r\n.icofont-pen:before {\r\n\tcontent: \"\\f097\";\r\n}\r\n\r\n.icofont-pencil:before {\r\n\tcontent: \"\\f098\";\r\n}\r\n\r\n.icofont-penguin-linux:before {\r\n\tcontent: \"\\f099\";\r\n}\r\n\r\n.icofont-pestle:before {\r\n\tcontent: \"\\f09a\";\r\n}\r\n\r\n.icofont-phone-circle:before {\r\n\tcontent: \"\\f09b\";\r\n}\r\n\r\n.icofont-phone:before {\r\n\tcontent: \"\\f09c\";\r\n}\r\n\r\n.icofont-picture:before {\r\n\tcontent: \"\\f09d\";\r\n}\r\n\r\n.icofont-pie:before {\r\n\tcontent: \"\\f09e\";\r\n}\r\n\r\n.icofont-pine:before {\r\n\tcontent: \"\\f09f\";\r\n}\r\n\r\n.icofont-pixels:before {\r\n\tcontent: \"\\f0a0\";\r\n}\r\n\r\n.icofont-play:before {\r\n\tcontent: \"\\f0a1\";\r\n}\r\n\r\n.icofont-plugin:before {\r\n\tcontent: \"\\f0a2\";\r\n}\r\n\r\n.icofont-plus-circle:before {\r\n\tcontent: \"\\f0a3\";\r\n}\r\n\r\n.icofont-plus-square:before {\r\n\tcontent: \"\\f0a4\";\r\n}\r\n\r\n.icofont-plus:before {\r\n\tcontent: \"\\f0a5\";\r\n}\r\n\r\n.icofont-polygonal:before {\r\n\tcontent: \"\\f0a6\";\r\n}\r\n\r\n.icofont-power:before {\r\n\tcontent: \"\\f0a7\";\r\n}\r\n\r\n.icofont-presentation:before {\r\n\tcontent: \"\\f0a8\";\r\n}\r\n\r\n.icofont-price:before {\r\n\tcontent: \"\\f0a9\";\r\n}\r\n\r\n.icofont-print:before {\r\n\tcontent: \"\\f0aa\";\r\n}\r\n\r\n.icofont-puzzle:before {\r\n\tcontent: \"\\f0ab\";\r\n}\r\n\r\n.icofont-qr-code:before {\r\n\tcontent: \"\\f0ac\";\r\n}\r\n\r\n.icofont-queen:before {\r\n\tcontent: \"\\f0ad\";\r\n}\r\n\r\n.icofont-question-circle:before {\r\n\tcontent: \"\\f0ae\";\r\n}\r\n\r\n.icofont-question-square:before {\r\n\tcontent: \"\\f0af\";\r\n}\r\n\r\n.icofont-question:before {\r\n\tcontent: \"\\f0b0\";\r\n}\r\n\r\n.icofont-quote-left:before {\r\n\tcontent: \"\\f0b1\";\r\n}\r\n\r\n.icofont-quote-right:before {\r\n\tcontent: \"\\f0b2\";\r\n}\r\n\r\n.icofont-radio:before {\r\n\tcontent: \"\\f0b3\";\r\n}\r\n\r\n.icofont-random:before {\r\n\tcontent: \"\\f0b4\";\r\n}\r\n\r\n.icofont-recycle:before {\r\n\tcontent: \"\\f0b5\";\r\n}\r\n\r\n.icofont-refresh:before {\r\n\tcontent: \"\\f0b6\";\r\n}\r\n\r\n.icofont-repair:before {\r\n\tcontent: \"\\f0b7\";\r\n}\r\n\r\n.icofont-reply-all:before {\r\n\tcontent: \"\\f0b8\";\r\n}\r\n\r\n.icofont-reply:before {\r\n\tcontent: \"\\f0b9\";\r\n}\r\n\r\n.icofont-resize:before {\r\n\tcontent: \"\\f0ba\";\r\n}\r\n\r\n.icofont-responsive:before {\r\n\tcontent: \"\\f0bb\";\r\n}\r\n\r\n.icofont-retweet:before {\r\n\tcontent: \"\\f0bc\";\r\n}\r\n\r\n.icofont-road:before {\r\n\tcontent: \"\\f0bd\";\r\n}\r\n\r\n.icofont-robot:before {\r\n\tcontent: \"\\f0be\";\r\n}\r\n\r\n.icofont-rocket:before {\r\n\tcontent: \"\\f0bf\";\r\n}\r\n\r\n.icofont-royal:before {\r\n\tcontent: \"\\f0c0\";\r\n}\r\n\r\n.icofont-rss-feed:before {\r\n\tcontent: \"\\f0c1\";\r\n}\r\n\r\n.icofont-safety:before {\r\n\tcontent: \"\\f0c2\";\r\n}\r\n\r\n.icofont-sale-discount:before {\r\n\tcontent: \"\\f0c3\";\r\n}\r\n\r\n.icofont-satellite:before {\r\n\tcontent: \"\\f0c4\";\r\n}\r\n\r\n.icofont-send-mail:before {\r\n\tcontent: \"\\f0c5\";\r\n}\r\n\r\n.icofont-server:before {\r\n\tcontent: \"\\f0c6\";\r\n}\r\n\r\n.icofont-settings:before {\r\n\tcontent: \"\\f0c7\";\r\n}\r\n\r\n.icofont-share-alt:before {\r\n\tcontent: \"\\f0c8\";\r\n}\r\n\r\n.icofont-share-boxed:before {\r\n\tcontent: \"\\f0c9\";\r\n}\r\n\r\n.icofont-share:before {\r\n\tcontent: \"\\f0ca\";\r\n}\r\n\r\n.icofont-shield:before {\r\n\tcontent: \"\\f0cb\";\r\n}\r\n\r\n.icofont-ship:before {\r\n\tcontent: \"\\f0cc\";\r\n}\r\n\r\n.icofont-shopping-cart:before {\r\n\tcontent: \"\\f0cd\";\r\n}\r\n\r\n.icofont-sign-in:before {\r\n\tcontent: \"\\f0ce\";\r\n}\r\n\r\n.icofont-sign-out:before {\r\n\tcontent: \"\\f0cf\";\r\n}\r\n\r\n.icofont-signal:before {\r\n\tcontent: \"\\f0d0\";\r\n}\r\n\r\n.icofont-site-map:before {\r\n\tcontent: \"\\f0d1\";\r\n}\r\n\r\n.icofont-smart-phone:before {\r\n\tcontent: \"\\f0d2\";\r\n}\r\n\r\n.icofont-soccer:before {\r\n\tcontent: \"\\f0d3\";\r\n}\r\n\r\n.icofont-sort-alt:before {\r\n\tcontent: \"\\f0d4\";\r\n}\r\n\r\n.icofont-sort:before {\r\n\tcontent: \"\\f0d5\";\r\n}\r\n\r\n.icofont-space:before {\r\n\tcontent: \"\\f0d6\";\r\n}\r\n\r\n.icofont-spanner:before {\r\n\tcontent: \"\\f0d7\";\r\n}\r\n\r\n.icofont-speech-comments:before {\r\n\tcontent: \"\\f0d8\";\r\n}\r\n\r\n.icofont-speed-meter:before {\r\n\tcontent: \"\\f0d9\";\r\n}\r\n\r\n.icofont-spinner-alt-1:before {\r\n\tcontent: \"\\f0da\";\r\n}\r\n\r\n.icofont-spinner-alt-2:before {\r\n\tcontent: \"\\f0db\";\r\n}\r\n\r\n.icofont-spinner-alt-3:before {\r\n\tcontent: \"\\f0dc\";\r\n}\r\n\r\n.icofont-spinner-alt-4:before {\r\n\tcontent: \"\\f0dd\";\r\n}\r\n\r\n.icofont-spinner-alt-5:before {\r\n\tcontent: \"\\f0de\";\r\n}\r\n\r\n.icofont-spinner-alt-6:before {\r\n\tcontent: \"\\f0df\";\r\n}\r\n\r\n.icofont-spinner:before {\r\n\tcontent: \"\\f0e0\";\r\n}\r\n\r\n.icofont-spreadsheet:before {\r\n\tcontent: \"\\f0e1\";\r\n}\r\n\r\n.icofont-square:before {\r\n\tcontent: \"\\f0e2\";\r\n}\r\n\r\n.icofont-ssl-security:before {\r\n\tcontent: \"\\f0e3\";\r\n}\r\n\r\n.icofont-star-alt-1:before {\r\n\tcontent: \"\\f0e4\";\r\n}\r\n\r\n.icofont-star-alt-2:before {\r\n\tcontent: \"\\f0e5\";\r\n}\r\n\r\n.icofont-star:before {\r\n\tcontent: \"\\f0e6\";\r\n}\r\n\r\n.icofont-street-view:before {\r\n\tcontent: \"\\f0e7\";\r\n}\r\n\r\n.icofont-sun:before {\r\n\tcontent: \"\\f0e8\";\r\n}\r\n\r\n.icofont-support-faq:before {\r\n\tcontent: \"\\f0e9\";\r\n}\r\n\r\n.icofont-tack-pin:before {\r\n\tcontent: \"\\f0ea\";\r\n}\r\n\r\n.icofont-tag:before {\r\n\tcontent: \"\\f0eb\";\r\n}\r\n\r\n.icofont-tags:before {\r\n\tcontent: \"\\f0ec\";\r\n}\r\n\r\n.icofont-tasks:before {\r\n\tcontent: \"\\f0ed\";\r\n}\r\n\r\n.icofont-telephone:before {\r\n\tcontent: \"\\f0ee\";\r\n}\r\n\r\n.icofont-telescope:before {\r\n\tcontent: \"\\f0ef\";\r\n}\r\n\r\n.icofont-terminal:before {\r\n\tcontent: \"\\f0f0\";\r\n}\r\n\r\n.icofont-thumbs-down:before {\r\n\tcontent: \"\\f0f1\";\r\n}\r\n\r\n.icofont-thumbs-up:before {\r\n\tcontent: \"\\f0f2\";\r\n}\r\n\r\n.icofont-tick-boxed:before {\r\n\tcontent: \"\\f0f3\";\r\n}\r\n\r\n.icofont-tick-mark:before {\r\n\tcontent: \"\\f0f4\";\r\n}\r\n\r\n.icofont-ticket:before {\r\n\tcontent: \"\\f0f5\";\r\n}\r\n\r\n.icofont-tie:before {\r\n\tcontent: \"\\f0f6\";\r\n}\r\n\r\n.icofont-toggle-off:before {\r\n\tcontent: \"\\f0f7\";\r\n}\r\n\r\n.icofont-toggle-on:before {\r\n\tcontent: \"\\f0f8\";\r\n}\r\n\r\n.icofont-tools:before {\r\n\tcontent: \"\\f0f9\";\r\n}\r\n\r\n.icofont-transparent:before {\r\n\tcontent: \"\\f0fa\";\r\n}\r\n\r\n.icofont-tree:before {\r\n\tcontent: \"\\f0fb\";\r\n}\r\n\r\n.icofont-umbrella:before {\r\n\tcontent: \"\\f0fc\";\r\n}\r\n\r\n.icofont-unlock:before {\r\n\tcontent: \"\\f0fd\";\r\n}\r\n\r\n.icofont-unlocked:before {\r\n\tcontent: \"\\f0fe\";\r\n}\r\n\r\n.icofont-upload-alt:before {\r\n\tcontent: \"\\f0ff\";\r\n}\r\n\r\n.icofont-upload:before {\r\n\tcontent: \"\\f100\";\r\n}\r\n\r\n.icofont-usb-drive:before {\r\n\tcontent: \"\\f101\";\r\n}\r\n\r\n.icofont-usb:before {\r\n\tcontent: \"\\f102\";\r\n}\r\n\r\n.icofont-vector-path:before {\r\n\tcontent: \"\\f103\";\r\n}\r\n\r\n.icofont-verification-check:before {\r\n\tcontent: \"\\f104\";\r\n}\r\n\r\n.icofont-video-clapper:before {\r\n\tcontent: \"\\f105\";\r\n}\r\n\r\n.icofont-video:before {\r\n\tcontent: \"\\f106\";\r\n}\r\n\r\n.icofont-volume-down:before {\r\n\tcontent: \"\\f107\";\r\n}\r\n\r\n.icofont-volume-off:before {\r\n\tcontent: \"\\f108\";\r\n}\r\n\r\n.icofont-volume-up:before {\r\n\tcontent: \"\\f109\";\r\n}\r\n\r\n.icofont-wall-clock:before {\r\n\tcontent: \"\\f10a\";\r\n}\r\n\r\n.icofont-wall:before {\r\n\tcontent: \"\\f10b\";\r\n}\r\n\r\n.icofont-wallet:before {\r\n\tcontent: \"\\f10c\";\r\n}\r\n\r\n.icofont-warning-alt:before {\r\n\tcontent: \"\\f10d\";\r\n}\r\n\r\n.icofont-warning:before {\r\n\tcontent: \"\\f10e\";\r\n}\r\n\r\n.icofont-water-drop:before {\r\n\tcontent: \"\\f10f\";\r\n}\r\n\r\n.icofont-web:before {\r\n\tcontent: \"\\f110\";\r\n}\r\n\r\n.icofont-wheelchair:before {\r\n\tcontent: \"\\f111\";\r\n}\r\n\r\n.icofont-wifi-alt:before {\r\n\tcontent: \"\\f112\";\r\n}\r\n\r\n.icofont-wifi:before {\r\n\tcontent: \"\\f113\";\r\n}\r\n\r\n.icofont-world:before {\r\n\tcontent: \"\\f114\";\r\n}\r\n\r\n.icofont-zigzag:before {\r\n\tcontent: \"\\f115\";\r\n}\r\n\r\n.icofont-zipped:before {\r\n\tcontent: \"\\f116\";\r\n}\r\n\r\n.icofont-social-500px:before {\r\n\tcontent: \"\\f117\";\r\n}\r\n\r\n.icofont-social-baidu-tieba:before {\r\n\tcontent: \"\\f118\";\r\n}\r\n\r\n.icofont-social-bbm-messenger:before {\r\n\tcontent: \"\\f119\";\r\n}\r\n\r\n.icofont-social-delicious:before {\r\n\tcontent: \"\\f11a\";\r\n}\r\n\r\n.icofont-social-dribbble:before {\r\n\tcontent: \"\\f11b\";\r\n}\r\n\r\n.icofont-social-facebook-messenger:before {\r\n\tcontent: \"\\f11c\";\r\n}\r\n\r\n.icofont-social-flikr:before {\r\n\tcontent: \"\\f11d\";\r\n}\r\n\r\n.icofont-social-foursquare:before {\r\n\tcontent: \"\\f11e\";\r\n}\r\n\r\n.icofont-social-google-hangouts:before {\r\n\tcontent: \"\\f11f\";\r\n}\r\n\r\n.icofont-social-kakaotalk:before {\r\n\tcontent: \"\\f120\";\r\n}\r\n\r\n.icofont-social-kik:before {\r\n\tcontent: \"\\f121\";\r\n}\r\n\r\n.icofont-social-kiwibox:before {\r\n\tcontent: \"\\f122\";\r\n}\r\n\r\n.icofont-social-linkedin:before {\r\n\tcontent: \"\\f123\";\r\n}\r\n\r\n.icofont-social-meetme:before {\r\n\tcontent: \"\\f124\";\r\n}\r\n\r\n.icofont-social-odnoklassniki:before {\r\n\tcontent: \"\\f125\";\r\n}\r\n\r\n.icofont-social-photobucket:before {\r\n\tcontent: \"\\f126\";\r\n}\r\n\r\n.icofont-social-qq:before {\r\n\tcontent: \"\\f127\";\r\n}\r\n\r\n.icofont-social-renren:before {\r\n\tcontent: \"\\f128\";\r\n}\r\n\r\n.icofont-social-slack:before {\r\n\tcontent: \"\\f129\";\r\n}\r\n\r\n.icofont-social-slidshare:before {\r\n\tcontent: \"\\f12a\";\r\n}\r\n\r\n.icofont-social-snapchat:before {\r\n\tcontent: \"\\f12b\";\r\n}\r\n\r\n.icofont-social-soundcloud:before {\r\n\tcontent: \"\\f12c\";\r\n}\r\n\r\n.icofont-social-spotify:before {\r\n\tcontent: \"\\f12d\";\r\n}\r\n\r\n.icofont-social-stack-exchange:before {\r\n\tcontent: \"\\f12e\";\r\n}\r\n\r\n.icofont-social-stack-overflow:before {\r\n\tcontent: \"\\f12f\";\r\n}\r\n\r\n.icofont-social-tagged:before {\r\n\tcontent: \"\\f130\";\r\n}\r\n\r\n.icofont-social-trello:before {\r\n\tcontent: \"\\f131\";\r\n}\r\n\r\n.icofont-social-twitch:before {\r\n\tcontent: \"\\f132\";\r\n}\r\n\r\n.icofont-social-vk:before {\r\n\tcontent: \"\\f133\";\r\n}\r\n\r\n.icofont-social-weibo:before {\r\n\tcontent: \"\\f134\";\r\n}\r\n\r\n.icofont-social-whatsapp:before {\r\n\tcontent: \"\\f135\";\r\n}\r\n\r\n.icofont-social-youku:before {\r\n\tcontent: \"\\f136\";\r\n}\r\n\r\n.icofont-social-youtube-play:before {\r\n\tcontent: \"\\f137\";\r\n}\r\n\r\n.icofont-social-youtube:before {\r\n\tcontent: \"\\f138\";\r\n}\r\n\r\n.icofont-brand-xiaomi:before {\r\n\tcontent: \"\\f139\";\r\n}\r\n\r\n/*Font size*/\r\n\r\n.icofont-lg {\r\n\tfont-size: 1.33333333em;\r\n\tline-height: .75em;\r\n\tvertical-align: -15%;\r\n}\r\n\r\n.icofont-2x {\r\n\tfont-size: 2em;\r\n}\r\n\r\n.icofont-3x {\r\n\tfont-size: 3em;\r\n}\r\n\r\n.icofont-4x {\r\n\tfont-size: 4em;\r\n}\r\n\r\n.icofont-5x {\r\n\tfont-size: 5em;\r\n}\r\n\r\n.icofont-fw {\r\n\tdisplay: inline-block;\r\n\twidth: 1.28571429em;\r\n\ttext-align: center;\r\n\twidth: 1.28571429em;\r\n\ttext-align: center;\r\n}\r\n\r\n/*Fixed Width Icons*/\r\n\r\n/*Custom list icons*/\r\n\r\n.icofont-ul {\r\n\tpadding-left: 0;\r\n\tmargin-left: 2.14285714em;\r\n\tlist-style-type: none;\r\n\t> li {\r\n\t\tposition: relative;\r\n\t}\r\n}\r\n\r\n.icofont-li {\r\n\tposition: absolute;\r\n\tleft: -2.14285714em;\r\n\twidth: 2.14285714em;\r\n\ttop: .14285714em;\r\n\ttext-align: center;\r\n}\r\n\r\n/*Animation*/\r\n\r\n.icofont-rotate {\r\n\tdisplay: inline-block;\r\n\t-webkit-animation: icofont-rotate 2s infinite linear;\r\n\tanimation: icofont-rotate 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes icofont-rotate {\r\n\t0% {\r\n\t\t-webkit-transform: rotate(0deg);\r\n\t\ttransform: rotate(0deg);\r\n\t}\r\n\r\n\t100% {\r\n\t\t-webkit-transform: rotate(359deg);\r\n\t\ttransform: rotate(359deg);\r\n\t}\r\n}\r\n\r\n\r\n@keyframes icofont-rotate {\r\n\t0% {\r\n\t\t-webkit-transform: rotate(0deg);\r\n\t\ttransform: rotate(0deg);\r\n\t}\r\n\r\n\t100% {\r\n\t\t-webkit-transform: rotate(359deg);\r\n\t\ttransform: rotate(359deg);\r\n\t}\r\n}","/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */\n\n@import \"font-awesome/variables\";\n@import \"font-awesome/mixins\";\n@import \"font-awesome/path\";\n@import \"font-awesome/core\";\n@import \"font-awesome/larger\";\n@import \"font-awesome/fixed-width\";\n@import \"font-awesome/list\";\n@import \"font-awesome/bordered-pulled\";\n@import \"font-awesome/animated\";\n@import \"font-awesome/rotated-flipped\";\n@import \"font-awesome/stacked\";\n@import \"font-awesome/icons\";\n@import \"font-awesome/screen-reader\";\n","/* FONT PATH\n * -------------------------- */\n\n @font-face {\n  font-family: 'FontAwesome';\n  src: url('#{$fa-font-path}/font-awesome/fontawesome-webfont.eot?v=#{$fa-version}');\n  src: url('#{$fa-font-path}/font-awesome/fontawesome-webfont.eot?#iefix&v=#{$fa-version}') format('embedded-opentype'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.woff2?v=#{$fa-version}') format('woff2'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.woff?v=#{$fa-version}') format('woff'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.ttf?v=#{$fa-version}') format('truetype'),\n    url('#{$fa-font-path}/font-awesome/fontawesome-webfont.svg?v=#{$fa-version}#fontawesomeregular') format('svg');\n//  src: url('#{$fa-font-path}/FontAwesome.otf') format('opentype'); // used when developing fonts\n  font-weight: normal;\n  font-style: normal;\n}\n","// Base Class Definition\n// -------------------------\n\n.#{$fa-css-prefix} {\n  display: inline-block;\n  font: normal normal normal #{$fa-font-size-base}/#{$fa-line-height-base} FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n","// Icon Sizes\n// -------------------------\n\n/* makes the font 33% larger relative to the icon container */\n.#{$fa-css-prefix}-lg {\n  font-size: (4em / 3);\n  line-height: (3em / 4);\n  vertical-align: -15%;\n}\n.#{$fa-css-prefix}-2x { font-size: 2em; }\n.#{$fa-css-prefix}-3x { font-size: 3em; }\n.#{$fa-css-prefix}-4x { font-size: 4em; }\n.#{$fa-css-prefix}-5x { font-size: 5em; }\n","// Fixed Width Icons\n// -------------------------\n.#{$fa-css-prefix}-fw {\n  width: (18em / 14);\n  text-align: center;\n}\n","// List Icons\n// -------------------------\n\n.#{$fa-css-prefix}-ul {\n  padding-left: 0;\n  margin-left: $fa-li-width;\n  list-style-type: none;\n  > li { position: relative; }\n}\n.#{$fa-css-prefix}-li {\n  position: absolute;\n  left: -$fa-li-width;\n  width: $fa-li-width;\n  top: (2em / 14);\n  text-align: center;\n  &.#{$fa-css-prefix}-lg {\n    left: -$fa-li-width + (4em / 14);\n  }\n}\n","// Variables\n// --------------------------\n\n$fa-font-path:        \"../../fonts\" !default;\n$fa-font-size-base:   14px !default;\n$fa-line-height-base: 1 !default;\n//$fa-font-path:        \"//netdna.bootstrapcdn.com/font-awesome/4.7.0/fonts\" !default; // for referencing Bootstrap CDN font files directly\n$fa-css-prefix:       fa !default;\n$fa-version:          \"4.7.0\" !default;\n$fa-border-color:     #eee !default;\n$fa-inverse:          #fff !default;\n$fa-li-width:         (30em / 14) !default;\n\n$fa-var-500px: \"\\f26e\";\n$fa-var-address-book: \"\\f2b9\";\n$fa-var-address-book-o: \"\\f2ba\";\n$fa-var-address-card: \"\\f2bb\";\n$fa-var-address-card-o: \"\\f2bc\";\n$fa-var-adjust: \"\\f042\";\n$fa-var-adn: \"\\f170\";\n$fa-var-align-center: \"\\f037\";\n$fa-var-align-justify: \"\\f039\";\n$fa-var-align-left: \"\\f036\";\n$fa-var-align-right: \"\\f038\";\n$fa-var-amazon: \"\\f270\";\n$fa-var-ambulance: \"\\f0f9\";\n$fa-var-american-sign-language-interpreting: \"\\f2a3\";\n$fa-var-anchor: \"\\f13d\";\n$fa-var-android: \"\\f17b\";\n$fa-var-angellist: \"\\f209\";\n$fa-var-angle-double-down: \"\\f103\";\n$fa-var-angle-double-left: \"\\f100\";\n$fa-var-angle-double-right: \"\\f101\";\n$fa-var-angle-double-up: \"\\f102\";\n$fa-var-angle-down: \"\\f107\";\n$fa-var-angle-left: \"\\f104\";\n$fa-var-angle-right: \"\\f105\";\n$fa-var-angle-up: \"\\f106\";\n$fa-var-apple: \"\\f179\";\n$fa-var-archive: \"\\f187\";\n$fa-var-area-chart: \"\\f1fe\";\n$fa-var-arrow-circle-down: \"\\f0ab\";\n$fa-var-arrow-circle-left: \"\\f0a8\";\n$fa-var-arrow-circle-o-down: \"\\f01a\";\n$fa-var-arrow-circle-o-left: \"\\f190\";\n$fa-var-arrow-circle-o-right: \"\\f18e\";\n$fa-var-arrow-circle-o-up: \"\\f01b\";\n$fa-var-arrow-circle-right: \"\\f0a9\";\n$fa-var-arrow-circle-up: \"\\f0aa\";\n$fa-var-arrow-down: \"\\f063\";\n$fa-var-arrow-left: \"\\f060\";\n$fa-var-arrow-right: \"\\f061\";\n$fa-var-arrow-up: \"\\f062\";\n$fa-var-arrows: \"\\f047\";\n$fa-var-arrows-alt: \"\\f0b2\";\n$fa-var-arrows-h: \"\\f07e\";\n$fa-var-arrows-v: \"\\f07d\";\n$fa-var-asl-interpreting: \"\\f2a3\";\n$fa-var-assistive-listening-systems: \"\\f2a2\";\n$fa-var-asterisk: \"\\f069\";\n$fa-var-at: \"\\f1fa\";\n$fa-var-audio-description: \"\\f29e\";\n$fa-var-automobile: \"\\f1b9\";\n$fa-var-backward: \"\\f04a\";\n$fa-var-balance-scale: \"\\f24e\";\n$fa-var-ban: \"\\f05e\";\n$fa-var-bandcamp: \"\\f2d5\";\n$fa-var-bank: \"\\f19c\";\n$fa-var-bar-chart: \"\\f080\";\n$fa-var-bar-chart-o: \"\\f080\";\n$fa-var-barcode: \"\\f02a\";\n$fa-var-bars: \"\\f0c9\";\n$fa-var-bath: \"\\f2cd\";\n$fa-var-bathtub: \"\\f2cd\";\n$fa-var-battery: \"\\f240\";\n$fa-var-battery-0: \"\\f244\";\n$fa-var-battery-1: \"\\f243\";\n$fa-var-battery-2: \"\\f242\";\n$fa-var-battery-3: \"\\f241\";\n$fa-var-battery-4: \"\\f240\";\n$fa-var-battery-empty: \"\\f244\";\n$fa-var-battery-full: \"\\f240\";\n$fa-var-battery-half: \"\\f242\";\n$fa-var-battery-quarter: \"\\f243\";\n$fa-var-battery-three-quarters: \"\\f241\";\n$fa-var-bed: \"\\f236\";\n$fa-var-beer: \"\\f0fc\";\n$fa-var-behance: \"\\f1b4\";\n$fa-var-behance-square: \"\\f1b5\";\n$fa-var-bell: \"\\f0f3\";\n$fa-var-bell-o: \"\\f0a2\";\n$fa-var-bell-slash: \"\\f1f6\";\n$fa-var-bell-slash-o: \"\\f1f7\";\n$fa-var-bicycle: \"\\f206\";\n$fa-var-binoculars: \"\\f1e5\";\n$fa-var-birthday-cake: \"\\f1fd\";\n$fa-var-bitbucket: \"\\f171\";\n$fa-var-bitbucket-square: \"\\f172\";\n$fa-var-bitcoin: \"\\f15a\";\n$fa-var-black-tie: \"\\f27e\";\n$fa-var-blind: \"\\f29d\";\n$fa-var-bluetooth: \"\\f293\";\n$fa-var-bluetooth-b: \"\\f294\";\n$fa-var-bold: \"\\f032\";\n$fa-var-bolt: \"\\f0e7\";\n$fa-var-bomb: \"\\f1e2\";\n$fa-var-book: \"\\f02d\";\n$fa-var-bookmark: \"\\f02e\";\n$fa-var-bookmark-o: \"\\f097\";\n$fa-var-braille: \"\\f2a1\";\n$fa-var-briefcase: \"\\f0b1\";\n$fa-var-btc: \"\\f15a\";\n$fa-var-bug: \"\\f188\";\n$fa-var-building: \"\\f1ad\";\n$fa-var-building-o: \"\\f0f7\";\n$fa-var-bullhorn: \"\\f0a1\";\n$fa-var-bullseye: \"\\f140\";\n$fa-var-bus: \"\\f207\";\n$fa-var-buysellads: \"\\f20d\";\n$fa-var-cab: \"\\f1ba\";\n$fa-var-calculator: \"\\f1ec\";\n$fa-var-calendar: \"\\f073\";\n$fa-var-calendar-check-o: \"\\f274\";\n$fa-var-calendar-minus-o: \"\\f272\";\n$fa-var-calendar-o: \"\\f133\";\n$fa-var-calendar-plus-o: \"\\f271\";\n$fa-var-calendar-times-o: \"\\f273\";\n$fa-var-camera: \"\\f030\";\n$fa-var-camera-retro: \"\\f083\";\n$fa-var-car: \"\\f1b9\";\n$fa-var-caret-down: \"\\f0d7\";\n$fa-var-caret-left: \"\\f0d9\";\n$fa-var-caret-right: \"\\f0da\";\n$fa-var-caret-square-o-down: \"\\f150\";\n$fa-var-caret-square-o-left: \"\\f191\";\n$fa-var-caret-square-o-right: \"\\f152\";\n$fa-var-caret-square-o-up: \"\\f151\";\n$fa-var-caret-up: \"\\f0d8\";\n$fa-var-cart-arrow-down: \"\\f218\";\n$fa-var-cart-plus: \"\\f217\";\n$fa-var-cc: \"\\f20a\";\n$fa-var-cc-amex: \"\\f1f3\";\n$fa-var-cc-diners-club: \"\\f24c\";\n$fa-var-cc-discover: \"\\f1f2\";\n$fa-var-cc-jcb: \"\\f24b\";\n$fa-var-cc-mastercard: \"\\f1f1\";\n$fa-var-cc-paypal: \"\\f1f4\";\n$fa-var-cc-stripe: \"\\f1f5\";\n$fa-var-cc-visa: \"\\f1f0\";\n$fa-var-certificate: \"\\f0a3\";\n$fa-var-chain: \"\\f0c1\";\n$fa-var-chain-broken: \"\\f127\";\n$fa-var-check: \"\\f00c\";\n$fa-var-check-circle: \"\\f058\";\n$fa-var-check-circle-o: \"\\f05d\";\n$fa-var-check-square: \"\\f14a\";\n$fa-var-check-square-o: \"\\f046\";\n$fa-var-chevron-circle-down: \"\\f13a\";\n$fa-var-chevron-circle-left: \"\\f137\";\n$fa-var-chevron-circle-right: \"\\f138\";\n$fa-var-chevron-circle-up: \"\\f139\";\n$fa-var-chevron-down: \"\\f078\";\n$fa-var-chevron-left: \"\\f053\";\n$fa-var-chevron-right: \"\\f054\";\n$fa-var-chevron-up: \"\\f077\";\n$fa-var-child: \"\\f1ae\";\n$fa-var-chrome: \"\\f268\";\n$fa-var-circle: \"\\f111\";\n$fa-var-circle-o: \"\\f10c\";\n$fa-var-circle-o-notch: \"\\f1ce\";\n$fa-var-circle-thin: \"\\f1db\";\n$fa-var-clipboard: \"\\f0ea\";\n$fa-var-clock-o: \"\\f017\";\n$fa-var-clone: \"\\f24d\";\n$fa-var-close: \"\\f00d\";\n$fa-var-cloud: \"\\f0c2\";\n$fa-var-cloud-download: \"\\f0ed\";\n$fa-var-cloud-upload: \"\\f0ee\";\n$fa-var-cny: \"\\f157\";\n$fa-var-code: \"\\f121\";\n$fa-var-code-fork: \"\\f126\";\n$fa-var-codepen: \"\\f1cb\";\n$fa-var-codiepie: \"\\f284\";\n$fa-var-coffee: \"\\f0f4\";\n$fa-var-cog: \"\\f013\";\n$fa-var-cogs: \"\\f085\";\n$fa-var-columns: \"\\f0db\";\n$fa-var-comment: \"\\f075\";\n$fa-var-comment-o: \"\\f0e5\";\n$fa-var-commenting: \"\\f27a\";\n$fa-var-commenting-o: \"\\f27b\";\n$fa-var-comments: \"\\f086\";\n$fa-var-comments-o: \"\\f0e6\";\n$fa-var-compass: \"\\f14e\";\n$fa-var-compress: \"\\f066\";\n$fa-var-connectdevelop: \"\\f20e\";\n$fa-var-contao: \"\\f26d\";\n$fa-var-copy: \"\\f0c5\";\n$fa-var-copyright: \"\\f1f9\";\n$fa-var-creative-commons: \"\\f25e\";\n$fa-var-credit-card: \"\\f09d\";\n$fa-var-credit-card-alt: \"\\f283\";\n$fa-var-crop: \"\\f125\";\n$fa-var-crosshairs: \"\\f05b\";\n$fa-var-css3: \"\\f13c\";\n$fa-var-cube: \"\\f1b2\";\n$fa-var-cubes: \"\\f1b3\";\n$fa-var-cut: \"\\f0c4\";\n$fa-var-cutlery: \"\\f0f5\";\n$fa-var-dashboard: \"\\f0e4\";\n$fa-var-dashcube: \"\\f210\";\n$fa-var-database: \"\\f1c0\";\n$fa-var-deaf: \"\\f2a4\";\n$fa-var-deafness: \"\\f2a4\";\n$fa-var-dedent: \"\\f03b\";\n$fa-var-delicious: \"\\f1a5\";\n$fa-var-desktop: \"\\f108\";\n$fa-var-deviantart: \"\\f1bd\";\n$fa-var-diamond: \"\\f219\";\n$fa-var-digg: \"\\f1a6\";\n$fa-var-dollar: \"\\f155\";\n$fa-var-dot-circle-o: \"\\f192\";\n$fa-var-download: \"\\f019\";\n$fa-var-dribbble: \"\\f17d\";\n$fa-var-drivers-license: \"\\f2c2\";\n$fa-var-drivers-license-o: \"\\f2c3\";\n$fa-var-dropbox: \"\\f16b\";\n$fa-var-drupal: \"\\f1a9\";\n$fa-var-edge: \"\\f282\";\n$fa-var-edit: \"\\f044\";\n$fa-var-eercast: \"\\f2da\";\n$fa-var-eject: \"\\f052\";\n$fa-var-ellipsis-h: \"\\f141\";\n$fa-var-ellipsis-v: \"\\f142\";\n$fa-var-empire: \"\\f1d1\";\n$fa-var-envelope: \"\\f0e0\";\n$fa-var-envelope-o: \"\\f003\";\n$fa-var-envelope-open: \"\\f2b6\";\n$fa-var-envelope-open-o: \"\\f2b7\";\n$fa-var-envelope-square: \"\\f199\";\n$fa-var-envira: \"\\f299\";\n$fa-var-eraser: \"\\f12d\";\n$fa-var-etsy: \"\\f2d7\";\n$fa-var-eur: \"\\f153\";\n$fa-var-euro: \"\\f153\";\n$fa-var-exchange: \"\\f0ec\";\n$fa-var-exclamation: \"\\f12a\";\n$fa-var-exclamation-circle: \"\\f06a\";\n$fa-var-exclamation-triangle: \"\\f071\";\n$fa-var-expand: \"\\f065\";\n$fa-var-expeditedssl: \"\\f23e\";\n$fa-var-external-link: \"\\f08e\";\n$fa-var-external-link-square: \"\\f14c\";\n$fa-var-eye: \"\\f06e\";\n$fa-var-eye-slash: \"\\f070\";\n$fa-var-eyedropper: \"\\f1fb\";\n$fa-var-fa: \"\\f2b4\";\n$fa-var-facebook: \"\\f09a\";\n$fa-var-facebook-f: \"\\f09a\";\n$fa-var-facebook-official: \"\\f230\";\n$fa-var-facebook-square: \"\\f082\";\n$fa-var-fast-backward: \"\\f049\";\n$fa-var-fast-forward: \"\\f050\";\n$fa-var-fax: \"\\f1ac\";\n$fa-var-feed: \"\\f09e\";\n$fa-var-female: \"\\f182\";\n$fa-var-fighter-jet: \"\\f0fb\";\n$fa-var-file: \"\\f15b\";\n$fa-var-file-archive-o: \"\\f1c6\";\n$fa-var-file-audio-o: \"\\f1c7\";\n$fa-var-file-code-o: \"\\f1c9\";\n$fa-var-file-excel-o: \"\\f1c3\";\n$fa-var-file-image-o: \"\\f1c5\";\n$fa-var-file-movie-o: \"\\f1c8\";\n$fa-var-file-o: \"\\f016\";\n$fa-var-file-pdf-o: \"\\f1c1\";\n$fa-var-file-photo-o: \"\\f1c5\";\n$fa-var-file-picture-o: \"\\f1c5\";\n$fa-var-file-powerpoint-o: \"\\f1c4\";\n$fa-var-file-sound-o: \"\\f1c7\";\n$fa-var-file-text: \"\\f15c\";\n$fa-var-file-text-o: \"\\f0f6\";\n$fa-var-file-video-o: \"\\f1c8\";\n$fa-var-file-word-o: \"\\f1c2\";\n$fa-var-file-zip-o: \"\\f1c6\";\n$fa-var-files-o: \"\\f0c5\";\n$fa-var-film: \"\\f008\";\n$fa-var-filter: \"\\f0b0\";\n$fa-var-fire: \"\\f06d\";\n$fa-var-fire-extinguisher: \"\\f134\";\n$fa-var-firefox: \"\\f269\";\n$fa-var-first-order: \"\\f2b0\";\n$fa-var-flag: \"\\f024\";\n$fa-var-flag-checkered: \"\\f11e\";\n$fa-var-flag-o: \"\\f11d\";\n$fa-var-flash: \"\\f0e7\";\n$fa-var-flask: \"\\f0c3\";\n$fa-var-flickr: \"\\f16e\";\n$fa-var-floppy-o: \"\\f0c7\";\n$fa-var-folder: \"\\f07b\";\n$fa-var-folder-o: \"\\f114\";\n$fa-var-folder-open: \"\\f07c\";\n$fa-var-folder-open-o: \"\\f115\";\n$fa-var-font: \"\\f031\";\n$fa-var-font-awesome: \"\\f2b4\";\n$fa-var-fonticons: \"\\f280\";\n$fa-var-fort-awesome: \"\\f286\";\n$fa-var-forumbee: \"\\f211\";\n$fa-var-forward: \"\\f04e\";\n$fa-var-foursquare: \"\\f180\";\n$fa-var-free-code-camp: \"\\f2c5\";\n$fa-var-frown-o: \"\\f119\";\n$fa-var-futbol-o: \"\\f1e3\";\n$fa-var-gamepad: \"\\f11b\";\n$fa-var-gavel: \"\\f0e3\";\n$fa-var-gbp: \"\\f154\";\n$fa-var-ge: \"\\f1d1\";\n$fa-var-gear: \"\\f013\";\n$fa-var-gears: \"\\f085\";\n$fa-var-genderless: \"\\f22d\";\n$fa-var-get-pocket: \"\\f265\";\n$fa-var-gg: \"\\f260\";\n$fa-var-gg-circle: \"\\f261\";\n$fa-var-gift: \"\\f06b\";\n$fa-var-git: \"\\f1d3\";\n$fa-var-git-square: \"\\f1d2\";\n$fa-var-github: \"\\f09b\";\n$fa-var-github-alt: \"\\f113\";\n$fa-var-github-square: \"\\f092\";\n$fa-var-gitlab: \"\\f296\";\n$fa-var-gittip: \"\\f184\";\n$fa-var-glass: \"\\f000\";\n$fa-var-glide: \"\\f2a5\";\n$fa-var-glide-g: \"\\f2a6\";\n$fa-var-globe: \"\\f0ac\";\n$fa-var-google: \"\\f1a0\";\n$fa-var-google-plus: \"\\f0d5\";\n$fa-var-google-plus-circle: \"\\f2b3\";\n$fa-var-google-plus-official: \"\\f2b3\";\n$fa-var-google-plus-square: \"\\f0d4\";\n$fa-var-google-wallet: \"\\f1ee\";\n$fa-var-graduation-cap: \"\\f19d\";\n$fa-var-gratipay: \"\\f184\";\n$fa-var-grav: \"\\f2d6\";\n$fa-var-group: \"\\f0c0\";\n$fa-var-h-square: \"\\f0fd\";\n$fa-var-hacker-news: \"\\f1d4\";\n$fa-var-hand-grab-o: \"\\f255\";\n$fa-var-hand-lizard-o: \"\\f258\";\n$fa-var-hand-o-down: \"\\f0a7\";\n$fa-var-hand-o-left: \"\\f0a5\";\n$fa-var-hand-o-right: \"\\f0a4\";\n$fa-var-hand-o-up: \"\\f0a6\";\n$fa-var-hand-paper-o: \"\\f256\";\n$fa-var-hand-peace-o: \"\\f25b\";\n$fa-var-hand-pointer-o: \"\\f25a\";\n$fa-var-hand-rock-o: \"\\f255\";\n$fa-var-hand-scissors-o: \"\\f257\";\n$fa-var-hand-spock-o: \"\\f259\";\n$fa-var-hand-stop-o: \"\\f256\";\n$fa-var-handshake-o: \"\\f2b5\";\n$fa-var-hard-of-hearing: \"\\f2a4\";\n$fa-var-hashtag: \"\\f292\";\n$fa-var-hdd-o: \"\\f0a0\";\n$fa-var-header: \"\\f1dc\";\n$fa-var-headphones: \"\\f025\";\n$fa-var-heart: \"\\f004\";\n$fa-var-heart-o: \"\\f08a\";\n$fa-var-heartbeat: \"\\f21e\";\n$fa-var-history: \"\\f1da\";\n$fa-var-home: \"\\f015\";\n$fa-var-hospital-o: \"\\f0f8\";\n$fa-var-hotel: \"\\f236\";\n$fa-var-hourglass: \"\\f254\";\n$fa-var-hourglass-1: \"\\f251\";\n$fa-var-hourglass-2: \"\\f252\";\n$fa-var-hourglass-3: \"\\f253\";\n$fa-var-hourglass-end: \"\\f253\";\n$fa-var-hourglass-half: \"\\f252\";\n$fa-var-hourglass-o: \"\\f250\";\n$fa-var-hourglass-start: \"\\f251\";\n$fa-var-houzz: \"\\f27c\";\n$fa-var-html5: \"\\f13b\";\n$fa-var-i-cursor: \"\\f246\";\n$fa-var-id-badge: \"\\f2c1\";\n$fa-var-id-card: \"\\f2c2\";\n$fa-var-id-card-o: \"\\f2c3\";\n$fa-var-ils: \"\\f20b\";\n$fa-var-image: \"\\f03e\";\n$fa-var-imdb: \"\\f2d8\";\n$fa-var-inbox: \"\\f01c\";\n$fa-var-indent: \"\\f03c\";\n$fa-var-industry: \"\\f275\";\n$fa-var-info: \"\\f129\";\n$fa-var-info-circle: \"\\f05a\";\n$fa-var-inr: \"\\f156\";\n$fa-var-instagram: \"\\f16d\";\n$fa-var-institution: \"\\f19c\";\n$fa-var-internet-explorer: \"\\f26b\";\n$fa-var-intersex: \"\\f224\";\n$fa-var-ioxhost: \"\\f208\";\n$fa-var-italic: \"\\f033\";\n$fa-var-joomla: \"\\f1aa\";\n$fa-var-jpy: \"\\f157\";\n$fa-var-jsfiddle: \"\\f1cc\";\n$fa-var-key: \"\\f084\";\n$fa-var-keyboard-o: \"\\f11c\";\n$fa-var-krw: \"\\f159\";\n$fa-var-language: \"\\f1ab\";\n$fa-var-laptop: \"\\f109\";\n$fa-var-lastfm: \"\\f202\";\n$fa-var-lastfm-square: \"\\f203\";\n$fa-var-leaf: \"\\f06c\";\n$fa-var-leanpub: \"\\f212\";\n$fa-var-legal: \"\\f0e3\";\n$fa-var-lemon-o: \"\\f094\";\n$fa-var-level-down: \"\\f149\";\n$fa-var-level-up: \"\\f148\";\n$fa-var-life-bouy: \"\\f1cd\";\n$fa-var-life-buoy: \"\\f1cd\";\n$fa-var-life-ring: \"\\f1cd\";\n$fa-var-life-saver: \"\\f1cd\";\n$fa-var-lightbulb-o: \"\\f0eb\";\n$fa-var-line-chart: \"\\f201\";\n$fa-var-link: \"\\f0c1\";\n$fa-var-linkedin: \"\\f0e1\";\n$fa-var-linkedin-square: \"\\f08c\";\n$fa-var-linode: \"\\f2b8\";\n$fa-var-linux: \"\\f17c\";\n$fa-var-list: \"\\f03a\";\n$fa-var-list-alt: \"\\f022\";\n$fa-var-list-ol: \"\\f0cb\";\n$fa-var-list-ul: \"\\f0ca\";\n$fa-var-location-arrow: \"\\f124\";\n$fa-var-lock: \"\\f023\";\n$fa-var-long-arrow-down: \"\\f175\";\n$fa-var-long-arrow-left: \"\\f177\";\n$fa-var-long-arrow-right: \"\\f178\";\n$fa-var-long-arrow-up: \"\\f176\";\n$fa-var-low-vision: \"\\f2a8\";\n$fa-var-magic: \"\\f0d0\";\n$fa-var-magnet: \"\\f076\";\n$fa-var-mail-forward: \"\\f064\";\n$fa-var-mail-reply: \"\\f112\";\n$fa-var-mail-reply-all: \"\\f122\";\n$fa-var-male: \"\\f183\";\n$fa-var-map: \"\\f279\";\n$fa-var-map-marker: \"\\f041\";\n$fa-var-map-o: \"\\f278\";\n$fa-var-map-pin: \"\\f276\";\n$fa-var-map-signs: \"\\f277\";\n$fa-var-mars: \"\\f222\";\n$fa-var-mars-double: \"\\f227\";\n$fa-var-mars-stroke: \"\\f229\";\n$fa-var-mars-stroke-h: \"\\f22b\";\n$fa-var-mars-stroke-v: \"\\f22a\";\n$fa-var-maxcdn: \"\\f136\";\n$fa-var-meanpath: \"\\f20c\";\n$fa-var-medium: \"\\f23a\";\n$fa-var-medkit: \"\\f0fa\";\n$fa-var-meetup: \"\\f2e0\";\n$fa-var-meh-o: \"\\f11a\";\n$fa-var-mercury: \"\\f223\";\n$fa-var-microchip: \"\\f2db\";\n$fa-var-microphone: \"\\f130\";\n$fa-var-microphone-slash: \"\\f131\";\n$fa-var-minus: \"\\f068\";\n$fa-var-minus-circle: \"\\f056\";\n$fa-var-minus-square: \"\\f146\";\n$fa-var-minus-square-o: \"\\f147\";\n$fa-var-mixcloud: \"\\f289\";\n$fa-var-mobile: \"\\f10b\";\n$fa-var-mobile-phone: \"\\f10b\";\n$fa-var-modx: \"\\f285\";\n$fa-var-money: \"\\f0d6\";\n$fa-var-moon-o: \"\\f186\";\n$fa-var-mortar-board: \"\\f19d\";\n$fa-var-motorcycle: \"\\f21c\";\n$fa-var-mouse-pointer: \"\\f245\";\n$fa-var-music: \"\\f001\";\n$fa-var-navicon: \"\\f0c9\";\n$fa-var-neuter: \"\\f22c\";\n$fa-var-newspaper-o: \"\\f1ea\";\n$fa-var-object-group: \"\\f247\";\n$fa-var-object-ungroup: \"\\f248\";\n$fa-var-odnoklassniki: \"\\f263\";\n$fa-var-odnoklassniki-square: \"\\f264\";\n$fa-var-opencart: \"\\f23d\";\n$fa-var-openid: \"\\f19b\";\n$fa-var-opera: \"\\f26a\";\n$fa-var-optin-monster: \"\\f23c\";\n$fa-var-outdent: \"\\f03b\";\n$fa-var-pagelines: \"\\f18c\";\n$fa-var-paint-brush: \"\\f1fc\";\n$fa-var-paper-plane: \"\\f1d8\";\n$fa-var-paper-plane-o: \"\\f1d9\";\n$fa-var-paperclip: \"\\f0c6\";\n$fa-var-paragraph: \"\\f1dd\";\n$fa-var-paste: \"\\f0ea\";\n$fa-var-pause: \"\\f04c\";\n$fa-var-pause-circle: \"\\f28b\";\n$fa-var-pause-circle-o: \"\\f28c\";\n$fa-var-paw: \"\\f1b0\";\n$fa-var-paypal: \"\\f1ed\";\n$fa-var-pencil: \"\\f040\";\n$fa-var-pencil-square: \"\\f14b\";\n$fa-var-pencil-square-o: \"\\f044\";\n$fa-var-percent: \"\\f295\";\n$fa-var-phone: \"\\f095\";\n$fa-var-phone-square: \"\\f098\";\n$fa-var-photo: \"\\f03e\";\n$fa-var-picture-o: \"\\f03e\";\n$fa-var-pie-chart: \"\\f200\";\n$fa-var-pied-piper: \"\\f2ae\";\n$fa-var-pied-piper-alt: \"\\f1a8\";\n$fa-var-pied-piper-pp: \"\\f1a7\";\n$fa-var-pinterest: \"\\f0d2\";\n$fa-var-pinterest-p: \"\\f231\";\n$fa-var-pinterest-square: \"\\f0d3\";\n$fa-var-plane: \"\\f072\";\n$fa-var-play: \"\\f04b\";\n$fa-var-play-circle: \"\\f144\";\n$fa-var-play-circle-o: \"\\f01d\";\n$fa-var-plug: \"\\f1e6\";\n$fa-var-plus: \"\\f067\";\n$fa-var-plus-circle: \"\\f055\";\n$fa-var-plus-square: \"\\f0fe\";\n$fa-var-plus-square-o: \"\\f196\";\n$fa-var-podcast: \"\\f2ce\";\n$fa-var-power-off: \"\\f011\";\n$fa-var-print: \"\\f02f\";\n$fa-var-product-hunt: \"\\f288\";\n$fa-var-puzzle-piece: \"\\f12e\";\n$fa-var-qq: \"\\f1d6\";\n$fa-var-qrcode: \"\\f029\";\n$fa-var-question: \"\\f128\";\n$fa-var-question-circle: \"\\f059\";\n$fa-var-question-circle-o: \"\\f29c\";\n$fa-var-quora: \"\\f2c4\";\n$fa-var-quote-left: \"\\f10d\";\n$fa-var-quote-right: \"\\f10e\";\n$fa-var-ra: \"\\f1d0\";\n$fa-var-random: \"\\f074\";\n$fa-var-ravelry: \"\\f2d9\";\n$fa-var-rebel: \"\\f1d0\";\n$fa-var-recycle: \"\\f1b8\";\n$fa-var-reddit: \"\\f1a1\";\n$fa-var-reddit-alien: \"\\f281\";\n$fa-var-reddit-square: \"\\f1a2\";\n$fa-var-refresh: \"\\f021\";\n$fa-var-registered: \"\\f25d\";\n$fa-var-remove: \"\\f00d\";\n$fa-var-renren: \"\\f18b\";\n$fa-var-reorder: \"\\f0c9\";\n$fa-var-repeat: \"\\f01e\";\n$fa-var-reply: \"\\f112\";\n$fa-var-reply-all: \"\\f122\";\n$fa-var-resistance: \"\\f1d0\";\n$fa-var-retweet: \"\\f079\";\n$fa-var-rmb: \"\\f157\";\n$fa-var-road: \"\\f018\";\n$fa-var-rocket: \"\\f135\";\n$fa-var-rotate-left: \"\\f0e2\";\n$fa-var-rotate-right: \"\\f01e\";\n$fa-var-rouble: \"\\f158\";\n$fa-var-rss: \"\\f09e\";\n$fa-var-rss-square: \"\\f143\";\n$fa-var-rub: \"\\f158\";\n$fa-var-ruble: \"\\f158\";\n$fa-var-rupee: \"\\f156\";\n$fa-var-s15: \"\\f2cd\";\n$fa-var-safari: \"\\f267\";\n$fa-var-save: \"\\f0c7\";\n$fa-var-scissors: \"\\f0c4\";\n$fa-var-scribd: \"\\f28a\";\n$fa-var-search: \"\\f002\";\n$fa-var-search-minus: \"\\f010\";\n$fa-var-search-plus: \"\\f00e\";\n$fa-var-sellsy: \"\\f213\";\n$fa-var-send: \"\\f1d8\";\n$fa-var-send-o: \"\\f1d9\";\n$fa-var-server: \"\\f233\";\n$fa-var-share: \"\\f064\";\n$fa-var-share-alt: \"\\f1e0\";\n$fa-var-share-alt-square: \"\\f1e1\";\n$fa-var-share-square: \"\\f14d\";\n$fa-var-share-square-o: \"\\f045\";\n$fa-var-shekel: \"\\f20b\";\n$fa-var-sheqel: \"\\f20b\";\n$fa-var-shield: \"\\f132\";\n$fa-var-ship: \"\\f21a\";\n$fa-var-shirtsinbulk: \"\\f214\";\n$fa-var-shopping-bag: \"\\f290\";\n$fa-var-shopping-basket: \"\\f291\";\n$fa-var-shopping-cart: \"\\f07a\";\n$fa-var-shower: \"\\f2cc\";\n$fa-var-sign-in: \"\\f090\";\n$fa-var-sign-language: \"\\f2a7\";\n$fa-var-sign-out: \"\\f08b\";\n$fa-var-signal: \"\\f012\";\n$fa-var-signing: \"\\f2a7\";\n$fa-var-simplybuilt: \"\\f215\";\n$fa-var-sitemap: \"\\f0e8\";\n$fa-var-skyatlas: \"\\f216\";\n$fa-var-skype: \"\\f17e\";\n$fa-var-slack: \"\\f198\";\n$fa-var-sliders: \"\\f1de\";\n$fa-var-slideshare: \"\\f1e7\";\n$fa-var-smile-o: \"\\f118\";\n$fa-var-snapchat: \"\\f2ab\";\n$fa-var-snapchat-ghost: \"\\f2ac\";\n$fa-var-snapchat-square: \"\\f2ad\";\n$fa-var-snowflake-o: \"\\f2dc\";\n$fa-var-soccer-ball-o: \"\\f1e3\";\n$fa-var-sort: \"\\f0dc\";\n$fa-var-sort-alpha-asc: \"\\f15d\";\n$fa-var-sort-alpha-desc: \"\\f15e\";\n$fa-var-sort-amount-asc: \"\\f160\";\n$fa-var-sort-amount-desc: \"\\f161\";\n$fa-var-sort-asc: \"\\f0de\";\n$fa-var-sort-desc: \"\\f0dd\";\n$fa-var-sort-down: \"\\f0dd\";\n$fa-var-sort-numeric-asc: \"\\f162\";\n$fa-var-sort-numeric-desc: \"\\f163\";\n$fa-var-sort-up: \"\\f0de\";\n$fa-var-soundcloud: \"\\f1be\";\n$fa-var-space-shuttle: \"\\f197\";\n$fa-var-spinner: \"\\f110\";\n$fa-var-spoon: \"\\f1b1\";\n$fa-var-spotify: \"\\f1bc\";\n$fa-var-square: \"\\f0c8\";\n$fa-var-square-o: \"\\f096\";\n$fa-var-stack-exchange: \"\\f18d\";\n$fa-var-stack-overflow: \"\\f16c\";\n$fa-var-star: \"\\f005\";\n$fa-var-star-half: \"\\f089\";\n$fa-var-star-half-empty: \"\\f123\";\n$fa-var-star-half-full: \"\\f123\";\n$fa-var-star-half-o: \"\\f123\";\n$fa-var-star-o: \"\\f006\";\n$fa-var-steam: \"\\f1b6\";\n$fa-var-steam-square: \"\\f1b7\";\n$fa-var-step-backward: \"\\f048\";\n$fa-var-step-forward: \"\\f051\";\n$fa-var-stethoscope: \"\\f0f1\";\n$fa-var-sticky-note: \"\\f249\";\n$fa-var-sticky-note-o: \"\\f24a\";\n$fa-var-stop: \"\\f04d\";\n$fa-var-stop-circle: \"\\f28d\";\n$fa-var-stop-circle-o: \"\\f28e\";\n$fa-var-street-view: \"\\f21d\";\n$fa-var-strikethrough: \"\\f0cc\";\n$fa-var-stumbleupon: \"\\f1a4\";\n$fa-var-stumbleupon-circle: \"\\f1a3\";\n$fa-var-subscript: \"\\f12c\";\n$fa-var-subway: \"\\f239\";\n$fa-var-suitcase: \"\\f0f2\";\n$fa-var-sun-o: \"\\f185\";\n$fa-var-superpowers: \"\\f2dd\";\n$fa-var-superscript: \"\\f12b\";\n$fa-var-support: \"\\f1cd\";\n$fa-var-table: \"\\f0ce\";\n$fa-var-tablet: \"\\f10a\";\n$fa-var-tachometer: \"\\f0e4\";\n$fa-var-tag: \"\\f02b\";\n$fa-var-tags: \"\\f02c\";\n$fa-var-tasks: \"\\f0ae\";\n$fa-var-taxi: \"\\f1ba\";\n$fa-var-telegram: \"\\f2c6\";\n$fa-var-television: \"\\f26c\";\n$fa-var-tencent-weibo: \"\\f1d5\";\n$fa-var-terminal: \"\\f120\";\n$fa-var-text-height: \"\\f034\";\n$fa-var-text-width: \"\\f035\";\n$fa-var-th: \"\\f00a\";\n$fa-var-th-large: \"\\f009\";\n$fa-var-th-list: \"\\f00b\";\n$fa-var-themeisle: \"\\f2b2\";\n$fa-var-thermometer: \"\\f2c7\";\n$fa-var-thermometer-0: \"\\f2cb\";\n$fa-var-thermometer-1: \"\\f2ca\";\n$fa-var-thermometer-2: \"\\f2c9\";\n$fa-var-thermometer-3: \"\\f2c8\";\n$fa-var-thermometer-4: \"\\f2c7\";\n$fa-var-thermometer-empty: \"\\f2cb\";\n$fa-var-thermometer-full: \"\\f2c7\";\n$fa-var-thermometer-half: \"\\f2c9\";\n$fa-var-thermometer-quarter: \"\\f2ca\";\n$fa-var-thermometer-three-quarters: \"\\f2c8\";\n$fa-var-thumb-tack: \"\\f08d\";\n$fa-var-thumbs-down: \"\\f165\";\n$fa-var-thumbs-o-down: \"\\f088\";\n$fa-var-thumbs-o-up: \"\\f087\";\n$fa-var-thumbs-up: \"\\f164\";\n$fa-var-ticket: \"\\f145\";\n$fa-var-times: \"\\f00d\";\n$fa-var-times-circle: \"\\f057\";\n$fa-var-times-circle-o: \"\\f05c\";\n$fa-var-times-rectangle: \"\\f2d3\";\n$fa-var-times-rectangle-o: \"\\f2d4\";\n$fa-var-tint: \"\\f043\";\n$fa-var-toggle-down: \"\\f150\";\n$fa-var-toggle-left: \"\\f191\";\n$fa-var-toggle-off: \"\\f204\";\n$fa-var-toggle-on: \"\\f205\";\n$fa-var-toggle-right: \"\\f152\";\n$fa-var-toggle-up: \"\\f151\";\n$fa-var-trademark: \"\\f25c\";\n$fa-var-train: \"\\f238\";\n$fa-var-transgender: \"\\f224\";\n$fa-var-transgender-alt: \"\\f225\";\n$fa-var-trash: \"\\f1f8\";\n$fa-var-trash-o: \"\\f014\";\n$fa-var-tree: \"\\f1bb\";\n$fa-var-trello: \"\\f181\";\n$fa-var-tripadvisor: \"\\f262\";\n$fa-var-trophy: \"\\f091\";\n$fa-var-truck: \"\\f0d1\";\n$fa-var-try: \"\\f195\";\n$fa-var-tty: \"\\f1e4\";\n$fa-var-tumblr: \"\\f173\";\n$fa-var-tumblr-square: \"\\f174\";\n$fa-var-turkish-lira: \"\\f195\";\n$fa-var-tv: \"\\f26c\";\n$fa-var-twitch: \"\\f1e8\";\n$fa-var-twitter: \"\\f099\";\n$fa-var-twitter-square: \"\\f081\";\n$fa-var-umbrella: \"\\f0e9\";\n$fa-var-underline: \"\\f0cd\";\n$fa-var-undo: \"\\f0e2\";\n$fa-var-universal-access: \"\\f29a\";\n$fa-var-university: \"\\f19c\";\n$fa-var-unlink: \"\\f127\";\n$fa-var-unlock: \"\\f09c\";\n$fa-var-unlock-alt: \"\\f13e\";\n$fa-var-unsorted: \"\\f0dc\";\n$fa-var-upload: \"\\f093\";\n$fa-var-usb: \"\\f287\";\n$fa-var-usd: \"\\f155\";\n$fa-var-user: \"\\f007\";\n$fa-var-user-circle: \"\\f2bd\";\n$fa-var-user-circle-o: \"\\f2be\";\n$fa-var-user-md: \"\\f0f0\";\n$fa-var-user-o: \"\\f2c0\";\n$fa-var-user-plus: \"\\f234\";\n$fa-var-user-secret: \"\\f21b\";\n$fa-var-user-times: \"\\f235\";\n$fa-var-users: \"\\f0c0\";\n$fa-var-vcard: \"\\f2bb\";\n$fa-var-vcard-o: \"\\f2bc\";\n$fa-var-venus: \"\\f221\";\n$fa-var-venus-double: \"\\f226\";\n$fa-var-venus-mars: \"\\f228\";\n$fa-var-viacoin: \"\\f237\";\n$fa-var-viadeo: \"\\f2a9\";\n$fa-var-viadeo-square: \"\\f2aa\";\n$fa-var-video-camera: \"\\f03d\";\n$fa-var-vimeo: \"\\f27d\";\n$fa-var-vimeo-square: \"\\f194\";\n$fa-var-vine: \"\\f1ca\";\n$fa-var-vk: \"\\f189\";\n$fa-var-volume-control-phone: \"\\f2a0\";\n$fa-var-volume-down: \"\\f027\";\n$fa-var-volume-off: \"\\f026\";\n$fa-var-volume-up: \"\\f028\";\n$fa-var-warning: \"\\f071\";\n$fa-var-wechat: \"\\f1d7\";\n$fa-var-weibo: \"\\f18a\";\n$fa-var-weixin: \"\\f1d7\";\n$fa-var-whatsapp: \"\\f232\";\n$fa-var-wheelchair: \"\\f193\";\n$fa-var-wheelchair-alt: \"\\f29b\";\n$fa-var-wifi: \"\\f1eb\";\n$fa-var-wikipedia-w: \"\\f266\";\n$fa-var-window-close: \"\\f2d3\";\n$fa-var-window-close-o: \"\\f2d4\";\n$fa-var-window-maximize: \"\\f2d0\";\n$fa-var-window-minimize: \"\\f2d1\";\n$fa-var-window-restore: \"\\f2d2\";\n$fa-var-windows: \"\\f17a\";\n$fa-var-won: \"\\f159\";\n$fa-var-wordpress: \"\\f19a\";\n$fa-var-wpbeginner: \"\\f297\";\n$fa-var-wpexplorer: \"\\f2de\";\n$fa-var-wpforms: \"\\f298\";\n$fa-var-wrench: \"\\f0ad\";\n$fa-var-xing: \"\\f168\";\n$fa-var-xing-square: \"\\f169\";\n$fa-var-y-combinator: \"\\f23b\";\n$fa-var-y-combinator-square: \"\\f1d4\";\n$fa-var-yahoo: \"\\f19e\";\n$fa-var-yc: \"\\f23b\";\n$fa-var-yc-square: \"\\f1d4\";\n$fa-var-yelp: \"\\f1e9\";\n$fa-var-yen: \"\\f157\";\n$fa-var-yoast: \"\\f2b1\";\n$fa-var-youtube: \"\\f167\";\n$fa-var-youtube-play: \"\\f16a\";\n$fa-var-youtube-square: \"\\f166\";\n\n","// Bordered & Pulled\n// -------------------------\n\n.#{$fa-css-prefix}-border {\n  padding: .2em .25em .15em;\n  border: solid .08em $fa-border-color;\n  border-radius: .1em;\n}\n\n.#{$fa-css-prefix}-pull-left { float: left; }\n.#{$fa-css-prefix}-pull-right { float: right; }\n\n.#{$fa-css-prefix} {\n  &.#{$fa-css-prefix}-pull-left { margin-right: .3em; }\n  &.#{$fa-css-prefix}-pull-right { margin-left: .3em; }\n}\n\n/* Deprecated as of 4.4.0 */\n.pull-right { float: right; }\n.pull-left { float: left; }\n\n.#{$fa-css-prefix} {\n  &.pull-left { margin-right: .3em; }\n  &.pull-right { margin-left: .3em; }\n}\n","// Spinning Icons\n// --------------------------\n\n.#{$fa-css-prefix}-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.#{$fa-css-prefix}-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n","// Rotated & Flipped Icons\n// -------------------------\n\n.#{$fa-css-prefix}-rotate-90  { @include fa-icon-rotate(90deg, 1);  }\n.#{$fa-css-prefix}-rotate-180 { @include fa-icon-rotate(180deg, 2); }\n.#{$fa-css-prefix}-rotate-270 { @include fa-icon-rotate(270deg, 3); }\n\n.#{$fa-css-prefix}-flip-horizontal { @include fa-icon-flip(-1, 1, 0); }\n.#{$fa-css-prefix}-flip-vertical   { @include fa-icon-flip(1, -1, 2); }\n\n// Hook for IE8-9\n// -------------------------\n\n:root .#{$fa-css-prefix}-rotate-90,\n:root .#{$fa-css-prefix}-rotate-180,\n:root .#{$fa-css-prefix}-rotate-270,\n:root .#{$fa-css-prefix}-flip-horizontal,\n:root .#{$fa-css-prefix}-flip-vertical {\n  filter: none;\n}\n","// Mixins\n// --------------------------\n\n@mixin fa-icon() {\n  display: inline-block;\n  font: normal normal normal #{$fa-font-size-base}/#{$fa-line-height-base} FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n\n@mixin fa-icon-rotate($degrees, $rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation})\";\n  -webkit-transform: rotate($degrees);\n      -ms-transform: rotate($degrees);\n          transform: rotate($degrees);\n}\n\n@mixin fa-icon-flip($horiz, $vert, $rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation}, mirror=1)\";\n  -webkit-transform: scale($horiz, $vert);\n      -ms-transform: scale($horiz, $vert);\n          transform: scale($horiz, $vert);\n}\n\n\n// Only display content to screen readers. A la Bootstrap 4.\n//\n// See: http://a11yproject.com/posts/how-to-hide-content/\n\n@mixin sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see http://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n  }\n}\n","// Stacked Icons\n// -------------------------\n\n.#{$fa-css-prefix}-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.#{$fa-css-prefix}-stack-1x, .#{$fa-css-prefix}-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.#{$fa-css-prefix}-stack-1x { line-height: inherit; }\n.#{$fa-css-prefix}-stack-2x { font-size: 2em; }\n.#{$fa-css-prefix}-inverse { color: $fa-inverse; }\n","/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n\n.#{$fa-css-prefix}-glass:before { content: $fa-var-glass; }\n.#{$fa-css-prefix}-music:before { content: $fa-var-music; }\n.#{$fa-css-prefix}-search:before { content: $fa-var-search; }\n.#{$fa-css-prefix}-envelope-o:before { content: $fa-var-envelope-o; }\n.#{$fa-css-prefix}-heart:before { content: $fa-var-heart; }\n.#{$fa-css-prefix}-star:before { content: $fa-var-star; }\n.#{$fa-css-prefix}-star-o:before { content: $fa-var-star-o; }\n.#{$fa-css-prefix}-user:before { content: $fa-var-user; }\n.#{$fa-css-prefix}-film:before { content: $fa-var-film; }\n.#{$fa-css-prefix}-th-large:before { content: $fa-var-th-large; }\n.#{$fa-css-prefix}-th:before { content: $fa-var-th; }\n.#{$fa-css-prefix}-th-list:before { content: $fa-var-th-list; }\n.#{$fa-css-prefix}-check:before { content: $fa-var-check; }\n.#{$fa-css-prefix}-remove:before,\n.#{$fa-css-prefix}-close:before,\n.#{$fa-css-prefix}-times:before { content: $fa-var-times; }\n.#{$fa-css-prefix}-search-plus:before { content: $fa-var-search-plus; }\n.#{$fa-css-prefix}-search-minus:before { content: $fa-var-search-minus; }\n.#{$fa-css-prefix}-power-off:before { content: $fa-var-power-off; }\n.#{$fa-css-prefix}-signal:before { content: $fa-var-signal; }\n.#{$fa-css-prefix}-gear:before,\n.#{$fa-css-prefix}-cog:before { content: $fa-var-cog; }\n.#{$fa-css-prefix}-trash-o:before { content: $fa-var-trash-o; }\n.#{$fa-css-prefix}-home:before { content: $fa-var-home; }\n.#{$fa-css-prefix}-file-o:before { content: $fa-var-file-o; }\n.#{$fa-css-prefix}-clock-o:before { content: $fa-var-clock-o; }\n.#{$fa-css-prefix}-road:before { content: $fa-var-road; }\n.#{$fa-css-prefix}-download:before { content: $fa-var-download; }\n.#{$fa-css-prefix}-arrow-circle-o-down:before { content: $fa-var-arrow-circle-o-down; }\n.#{$fa-css-prefix}-arrow-circle-o-up:before { content: $fa-var-arrow-circle-o-up; }\n.#{$fa-css-prefix}-inbox:before { content: $fa-var-inbox; }\n.#{$fa-css-prefix}-play-circle-o:before { content: $fa-var-play-circle-o; }\n.#{$fa-css-prefix}-rotate-right:before,\n.#{$fa-css-prefix}-repeat:before { content: $fa-var-repeat; }\n.#{$fa-css-prefix}-refresh:before { content: $fa-var-refresh; }\n.#{$fa-css-prefix}-list-alt:before { content: $fa-var-list-alt; }\n.#{$fa-css-prefix}-lock:before { content: $fa-var-lock; }\n.#{$fa-css-prefix}-flag:before { content: $fa-var-flag; }\n.#{$fa-css-prefix}-headphones:before { content: $fa-var-headphones; }\n.#{$fa-css-prefix}-volume-off:before { content: $fa-var-volume-off; }\n.#{$fa-css-prefix}-volume-down:before { content: $fa-var-volume-down; }\n.#{$fa-css-prefix}-volume-up:before { content: $fa-var-volume-up; }\n.#{$fa-css-prefix}-qrcode:before { content: $fa-var-qrcode; }\n.#{$fa-css-prefix}-barcode:before { content: $fa-var-barcode; }\n.#{$fa-css-prefix}-tag:before { content: $fa-var-tag; }\n.#{$fa-css-prefix}-tags:before { content: $fa-var-tags; }\n.#{$fa-css-prefix}-book:before { content: $fa-var-book; }\n.#{$fa-css-prefix}-bookmark:before { content: $fa-var-bookmark; }\n.#{$fa-css-prefix}-print:before { content: $fa-var-print; }\n.#{$fa-css-prefix}-camera:before { content: $fa-var-camera; }\n.#{$fa-css-prefix}-font:before { content: $fa-var-font; }\n.#{$fa-css-prefix}-bold:before { content: $fa-var-bold; }\n.#{$fa-css-prefix}-italic:before { content: $fa-var-italic; }\n.#{$fa-css-prefix}-text-height:before { content: $fa-var-text-height; }\n.#{$fa-css-prefix}-text-width:before { content: $fa-var-text-width; }\n.#{$fa-css-prefix}-align-left:before { content: $fa-var-align-left; }\n.#{$fa-css-prefix}-align-center:before { content: $fa-var-align-center; }\n.#{$fa-css-prefix}-align-right:before { content: $fa-var-align-right; }\n.#{$fa-css-prefix}-align-justify:before { content: $fa-var-align-justify; }\n.#{$fa-css-prefix}-list:before { content: $fa-var-list; }\n.#{$fa-css-prefix}-dedent:before,\n.#{$fa-css-prefix}-outdent:before { content: $fa-var-outdent; }\n.#{$fa-css-prefix}-indent:before { content: $fa-var-indent; }\n.#{$fa-css-prefix}-video-camera:before { content: $fa-var-video-camera; }\n.#{$fa-css-prefix}-photo:before,\n.#{$fa-css-prefix}-image:before,\n.#{$fa-css-prefix}-picture-o:before { content: $fa-var-picture-o; }\n.#{$fa-css-prefix}-pencil:before { content: $fa-var-pencil; }\n.#{$fa-css-prefix}-map-marker:before { content: $fa-var-map-marker; }\n.#{$fa-css-prefix}-adjust:before { content: $fa-var-adjust; }\n.#{$fa-css-prefix}-tint:before { content: $fa-var-tint; }\n.#{$fa-css-prefix}-edit:before,\n.#{$fa-css-prefix}-pencil-square-o:before { content: $fa-var-pencil-square-o; }\n.#{$fa-css-prefix}-share-square-o:before { content: $fa-var-share-square-o; }\n.#{$fa-css-prefix}-check-square-o:before { content: $fa-var-check-square-o; }\n.#{$fa-css-prefix}-arrows:before { content: $fa-var-arrows; }\n.#{$fa-css-prefix}-step-backward:before { content: $fa-var-step-backward; }\n.#{$fa-css-prefix}-fast-backward:before { content: $fa-var-fast-backward; }\n.#{$fa-css-prefix}-backward:before { content: $fa-var-backward; }\n.#{$fa-css-prefix}-play:before { content: $fa-var-play; }\n.#{$fa-css-prefix}-pause:before { content: $fa-var-pause; }\n.#{$fa-css-prefix}-stop:before { content: $fa-var-stop; }\n.#{$fa-css-prefix}-forward:before { content: $fa-var-forward; }\n.#{$fa-css-prefix}-fast-forward:before { content: $fa-var-fast-forward; }\n.#{$fa-css-prefix}-step-forward:before { content: $fa-var-step-forward; }\n.#{$fa-css-prefix}-eject:before { content: $fa-var-eject; }\n.#{$fa-css-prefix}-chevron-left:before { content: $fa-var-chevron-left; }\n.#{$fa-css-prefix}-chevron-right:before { content: $fa-var-chevron-right; }\n.#{$fa-css-prefix}-plus-circle:before { content: $fa-var-plus-circle; }\n.#{$fa-css-prefix}-minus-circle:before { content: $fa-var-minus-circle; }\n.#{$fa-css-prefix}-times-circle:before { content: $fa-var-times-circle; }\n.#{$fa-css-prefix}-check-circle:before { content: $fa-var-check-circle; }\n.#{$fa-css-prefix}-question-circle:before { content: $fa-var-question-circle; }\n.#{$fa-css-prefix}-info-circle:before { content: $fa-var-info-circle; }\n.#{$fa-css-prefix}-crosshairs:before { content: $fa-var-crosshairs; }\n.#{$fa-css-prefix}-times-circle-o:before { content: $fa-var-times-circle-o; }\n.#{$fa-css-prefix}-check-circle-o:before { content: $fa-var-check-circle-o; }\n.#{$fa-css-prefix}-ban:before { content: $fa-var-ban; }\n.#{$fa-css-prefix}-arrow-left:before { content: $fa-var-arrow-left; }\n.#{$fa-css-prefix}-arrow-right:before { content: $fa-var-arrow-right; }\n.#{$fa-css-prefix}-arrow-up:before { content: $fa-var-arrow-up; }\n.#{$fa-css-prefix}-arrow-down:before { content: $fa-var-arrow-down; }\n.#{$fa-css-prefix}-mail-forward:before,\n.#{$fa-css-prefix}-share:before { content: $fa-var-share; }\n.#{$fa-css-prefix}-expand:before { content: $fa-var-expand; }\n.#{$fa-css-prefix}-compress:before { content: $fa-var-compress; }\n.#{$fa-css-prefix}-plus:before { content: $fa-var-plus; }\n.#{$fa-css-prefix}-minus:before { content: $fa-var-minus; }\n.#{$fa-css-prefix}-asterisk:before { content: $fa-var-asterisk; }\n.#{$fa-css-prefix}-exclamation-circle:before { content: $fa-var-exclamation-circle; }\n.#{$fa-css-prefix}-gift:before { content: $fa-var-gift; }\n.#{$fa-css-prefix}-leaf:before { content: $fa-var-leaf; }\n.#{$fa-css-prefix}-fire:before { content: $fa-var-fire; }\n.#{$fa-css-prefix}-eye:before { content: $fa-var-eye; }\n.#{$fa-css-prefix}-eye-slash:before { content: $fa-var-eye-slash; }\n.#{$fa-css-prefix}-warning:before,\n.#{$fa-css-prefix}-exclamation-triangle:before { content: $fa-var-exclamation-triangle; }\n.#{$fa-css-prefix}-plane:before { content: $fa-var-plane; }\n.#{$fa-css-prefix}-calendar:before { content: $fa-var-calendar; }\n.#{$fa-css-prefix}-random:before { content: $fa-var-random; }\n.#{$fa-css-prefix}-comment:before { content: $fa-var-comment; }\n.#{$fa-css-prefix}-magnet:before { content: $fa-var-magnet; }\n.#{$fa-css-prefix}-chevron-up:before { content: $fa-var-chevron-up; }\n.#{$fa-css-prefix}-chevron-down:before { content: $fa-var-chevron-down; }\n.#{$fa-css-prefix}-retweet:before { content: $fa-var-retweet; }\n.#{$fa-css-prefix}-shopping-cart:before { content: $fa-var-shopping-cart; }\n.#{$fa-css-prefix}-folder:before { content: $fa-var-folder; }\n.#{$fa-css-prefix}-folder-open:before { content: $fa-var-folder-open; }\n.#{$fa-css-prefix}-arrows-v:before { content: $fa-var-arrows-v; }\n.#{$fa-css-prefix}-arrows-h:before { content: $fa-var-arrows-h; }\n.#{$fa-css-prefix}-bar-chart-o:before,\n.#{$fa-css-prefix}-bar-chart:before { content: $fa-var-bar-chart; }\n.#{$fa-css-prefix}-twitter-square:before { content: $fa-var-twitter-square; }\n.#{$fa-css-prefix}-facebook-square:before { content: $fa-var-facebook-square; }\n.#{$fa-css-prefix}-camera-retro:before { content: $fa-var-camera-retro; }\n.#{$fa-css-prefix}-key:before { content: $fa-var-key; }\n.#{$fa-css-prefix}-gears:before,\n.#{$fa-css-prefix}-cogs:before { content: $fa-var-cogs; }\n.#{$fa-css-prefix}-comments:before { content: $fa-var-comments; }\n.#{$fa-css-prefix}-thumbs-o-up:before { content: $fa-var-thumbs-o-up; }\n.#{$fa-css-prefix}-thumbs-o-down:before { content: $fa-var-thumbs-o-down; }\n.#{$fa-css-prefix}-star-half:before { content: $fa-var-star-half; }\n.#{$fa-css-prefix}-heart-o:before { content: $fa-var-heart-o; }\n.#{$fa-css-prefix}-sign-out:before { content: $fa-var-sign-out; }\n.#{$fa-css-prefix}-linkedin-square:before { content: $fa-var-linkedin-square; }\n.#{$fa-css-prefix}-thumb-tack:before { content: $fa-var-thumb-tack; }\n.#{$fa-css-prefix}-external-link:before { content: $fa-var-external-link; }\n.#{$fa-css-prefix}-sign-in:before { content: $fa-var-sign-in; }\n.#{$fa-css-prefix}-trophy:before { content: $fa-var-trophy; }\n.#{$fa-css-prefix}-github-square:before { content: $fa-var-github-square; }\n.#{$fa-css-prefix}-upload:before { content: $fa-var-upload; }\n.#{$fa-css-prefix}-lemon-o:before { content: $fa-var-lemon-o; }\n.#{$fa-css-prefix}-phone:before { content: $fa-var-phone; }\n.#{$fa-css-prefix}-square-o:before { content: $fa-var-square-o; }\n.#{$fa-css-prefix}-bookmark-o:before { content: $fa-var-bookmark-o; }\n.#{$fa-css-prefix}-phone-square:before { content: $fa-var-phone-square; }\n.#{$fa-css-prefix}-twitter:before { content: $fa-var-twitter; }\n.#{$fa-css-prefix}-facebook-f:before,\n.#{$fa-css-prefix}-facebook:before { content: $fa-var-facebook; }\n.#{$fa-css-prefix}-github:before { content: $fa-var-github; }\n.#{$fa-css-prefix}-unlock:before { content: $fa-var-unlock; }\n.#{$fa-css-prefix}-credit-card:before { content: $fa-var-credit-card; }\n.#{$fa-css-prefix}-feed:before,\n.#{$fa-css-prefix}-rss:before { content: $fa-var-rss; }\n.#{$fa-css-prefix}-hdd-o:before { content: $fa-var-hdd-o; }\n.#{$fa-css-prefix}-bullhorn:before { content: $fa-var-bullhorn; }\n.#{$fa-css-prefix}-bell:before { content: $fa-var-bell; }\n.#{$fa-css-prefix}-certificate:before { content: $fa-var-certificate; }\n.#{$fa-css-prefix}-hand-o-right:before { content: $fa-var-hand-o-right; }\n.#{$fa-css-prefix}-hand-o-left:before { content: $fa-var-hand-o-left; }\n.#{$fa-css-prefix}-hand-o-up:before { content: $fa-var-hand-o-up; }\n.#{$fa-css-prefix}-hand-o-down:before { content: $fa-var-hand-o-down; }\n.#{$fa-css-prefix}-arrow-circle-left:before { content: $fa-var-arrow-circle-left; }\n.#{$fa-css-prefix}-arrow-circle-right:before { content: $fa-var-arrow-circle-right; }\n.#{$fa-css-prefix}-arrow-circle-up:before { content: $fa-var-arrow-circle-up; }\n.#{$fa-css-prefix}-arrow-circle-down:before { content: $fa-var-arrow-circle-down; }\n.#{$fa-css-prefix}-globe:before { content: $fa-var-globe; }\n.#{$fa-css-prefix}-wrench:before { content: $fa-var-wrench; }\n.#{$fa-css-prefix}-tasks:before { content: $fa-var-tasks; }\n.#{$fa-css-prefix}-filter:before { content: $fa-var-filter; }\n.#{$fa-css-prefix}-briefcase:before { content: $fa-var-briefcase; }\n.#{$fa-css-prefix}-arrows-alt:before { content: $fa-var-arrows-alt; }\n.#{$fa-css-prefix}-group:before,\n.#{$fa-css-prefix}-users:before { content: $fa-var-users; }\n.#{$fa-css-prefix}-chain:before,\n.#{$fa-css-prefix}-link:before { content: $fa-var-link; }\n.#{$fa-css-prefix}-cloud:before { content: $fa-var-cloud; }\n.#{$fa-css-prefix}-flask:before { content: $fa-var-flask; }\n.#{$fa-css-prefix}-cut:before,\n.#{$fa-css-prefix}-scissors:before { content: $fa-var-scissors; }\n.#{$fa-css-prefix}-copy:before,\n.#{$fa-css-prefix}-files-o:before { content: $fa-var-files-o; }\n.#{$fa-css-prefix}-paperclip:before { content: $fa-var-paperclip; }\n.#{$fa-css-prefix}-save:before,\n.#{$fa-css-prefix}-floppy-o:before { content: $fa-var-floppy-o; }\n.#{$fa-css-prefix}-square:before { content: $fa-var-square; }\n.#{$fa-css-prefix}-navicon:before,\n.#{$fa-css-prefix}-reorder:before,\n.#{$fa-css-prefix}-bars:before { content: $fa-var-bars; }\n.#{$fa-css-prefix}-list-ul:before { content: $fa-var-list-ul; }\n.#{$fa-css-prefix}-list-ol:before { content: $fa-var-list-ol; }\n.#{$fa-css-prefix}-strikethrough:before { content: $fa-var-strikethrough; }\n.#{$fa-css-prefix}-underline:before { content: $fa-var-underline; }\n.#{$fa-css-prefix}-table:before { content: $fa-var-table; }\n.#{$fa-css-prefix}-magic:before { content: $fa-var-magic; }\n.#{$fa-css-prefix}-truck:before { content: $fa-var-truck; }\n.#{$fa-css-prefix}-pinterest:before { content: $fa-var-pinterest; }\n.#{$fa-css-prefix}-pinterest-square:before { content: $fa-var-pinterest-square; }\n.#{$fa-css-prefix}-google-plus-square:before { content: $fa-var-google-plus-square; }\n.#{$fa-css-prefix}-google-plus:before { content: $fa-var-google-plus; }\n.#{$fa-css-prefix}-money:before { content: $fa-var-money; }\n.#{$fa-css-prefix}-caret-down:before { content: $fa-var-caret-down; }\n.#{$fa-css-prefix}-caret-up:before { content: $fa-var-caret-up; }\n.#{$fa-css-prefix}-caret-left:before { content: $fa-var-caret-left; }\n.#{$fa-css-prefix}-caret-right:before { content: $fa-var-caret-right; }\n.#{$fa-css-prefix}-columns:before { content: $fa-var-columns; }\n.#{$fa-css-prefix}-unsorted:before,\n.#{$fa-css-prefix}-sort:before { content: $fa-var-sort; }\n.#{$fa-css-prefix}-sort-down:before,\n.#{$fa-css-prefix}-sort-desc:before { content: $fa-var-sort-desc; }\n.#{$fa-css-prefix}-sort-up:before,\n.#{$fa-css-prefix}-sort-asc:before { content: $fa-var-sort-asc; }\n.#{$fa-css-prefix}-envelope:before { content: $fa-var-envelope; }\n.#{$fa-css-prefix}-linkedin:before { content: $fa-var-linkedin; }\n.#{$fa-css-prefix}-rotate-left:before,\n.#{$fa-css-prefix}-undo:before { content: $fa-var-undo; }\n.#{$fa-css-prefix}-legal:before,\n.#{$fa-css-prefix}-gavel:before { content: $fa-var-gavel; }\n.#{$fa-css-prefix}-dashboard:before,\n.#{$fa-css-prefix}-tachometer:before { content: $fa-var-tachometer; }\n.#{$fa-css-prefix}-comment-o:before { content: $fa-var-comment-o; }\n.#{$fa-css-prefix}-comments-o:before { content: $fa-var-comments-o; }\n.#{$fa-css-prefix}-flash:before,\n.#{$fa-css-prefix}-bolt:before { content: $fa-var-bolt; }\n.#{$fa-css-prefix}-sitemap:before { content: $fa-var-sitemap; }\n.#{$fa-css-prefix}-umbrella:before { content: $fa-var-umbrella; }\n.#{$fa-css-prefix}-paste:before,\n.#{$fa-css-prefix}-clipboard:before { content: $fa-var-clipboard; }\n.#{$fa-css-prefix}-lightbulb-o:before { content: $fa-var-lightbulb-o; }\n.#{$fa-css-prefix}-exchange:before { content: $fa-var-exchange; }\n.#{$fa-css-prefix}-cloud-download:before { content: $fa-var-cloud-download; }\n.#{$fa-css-prefix}-cloud-upload:before { content: $fa-var-cloud-upload; }\n.#{$fa-css-prefix}-user-md:before { content: $fa-var-user-md; }\n.#{$fa-css-prefix}-stethoscope:before { content: $fa-var-stethoscope; }\n.#{$fa-css-prefix}-suitcase:before { content: $fa-var-suitcase; }\n.#{$fa-css-prefix}-bell-o:before { content: $fa-var-bell-o; }\n.#{$fa-css-prefix}-coffee:before { content: $fa-var-coffee; }\n.#{$fa-css-prefix}-cutlery:before { content: $fa-var-cutlery; }\n.#{$fa-css-prefix}-file-text-o:before { content: $fa-var-file-text-o; }\n.#{$fa-css-prefix}-building-o:before { content: $fa-var-building-o; }\n.#{$fa-css-prefix}-hospital-o:before { content: $fa-var-hospital-o; }\n.#{$fa-css-prefix}-ambulance:before { content: $fa-var-ambulance; }\n.#{$fa-css-prefix}-medkit:before { content: $fa-var-medkit; }\n.#{$fa-css-prefix}-fighter-jet:before { content: $fa-var-fighter-jet; }\n.#{$fa-css-prefix}-beer:before { content: $fa-var-beer; }\n.#{$fa-css-prefix}-h-square:before { content: $fa-var-h-square; }\n.#{$fa-css-prefix}-plus-square:before { content: $fa-var-plus-square; }\n.#{$fa-css-prefix}-angle-double-left:before { content: $fa-var-angle-double-left; }\n.#{$fa-css-prefix}-angle-double-right:before { content: $fa-var-angle-double-right; }\n.#{$fa-css-prefix}-angle-double-up:before { content: $fa-var-angle-double-up; }\n.#{$fa-css-prefix}-angle-double-down:before { content: $fa-var-angle-double-down; }\n.#{$fa-css-prefix}-angle-left:before { content: $fa-var-angle-left; }\n.#{$fa-css-prefix}-angle-right:before { content: $fa-var-angle-right; }\n.#{$fa-css-prefix}-angle-up:before { content: $fa-var-angle-up; }\n.#{$fa-css-prefix}-angle-down:before { content: $fa-var-angle-down; }\n.#{$fa-css-prefix}-desktop:before { content: $fa-var-desktop; }\n.#{$fa-css-prefix}-laptop:before { content: $fa-var-laptop; }\n.#{$fa-css-prefix}-tablet:before { content: $fa-var-tablet; }\n.#{$fa-css-prefix}-mobile-phone:before,\n.#{$fa-css-prefix}-mobile:before { content: $fa-var-mobile; }\n.#{$fa-css-prefix}-circle-o:before { content: $fa-var-circle-o; }\n.#{$fa-css-prefix}-quote-left:before { content: $fa-var-quote-left; }\n.#{$fa-css-prefix}-quote-right:before { content: $fa-var-quote-right; }\n.#{$fa-css-prefix}-spinner:before { content: $fa-var-spinner; }\n.#{$fa-css-prefix}-circle:before { content: $fa-var-circle; }\n.#{$fa-css-prefix}-mail-reply:before,\n.#{$fa-css-prefix}-reply:before { content: $fa-var-reply; }\n.#{$fa-css-prefix}-github-alt:before { content: $fa-var-github-alt; }\n.#{$fa-css-prefix}-folder-o:before { content: $fa-var-folder-o; }\n.#{$fa-css-prefix}-folder-open-o:before { content: $fa-var-folder-open-o; }\n.#{$fa-css-prefix}-smile-o:before { content: $fa-var-smile-o; }\n.#{$fa-css-prefix}-frown-o:before { content: $fa-var-frown-o; }\n.#{$fa-css-prefix}-meh-o:before { content: $fa-var-meh-o; }\n.#{$fa-css-prefix}-gamepad:before { content: $fa-var-gamepad; }\n.#{$fa-css-prefix}-keyboard-o:before { content: $fa-var-keyboard-o; }\n.#{$fa-css-prefix}-flag-o:before { content: $fa-var-flag-o; }\n.#{$fa-css-prefix}-flag-checkered:before { content: $fa-var-flag-checkered; }\n.#{$fa-css-prefix}-terminal:before { content: $fa-var-terminal; }\n.#{$fa-css-prefix}-code:before { content: $fa-var-code; }\n.#{$fa-css-prefix}-mail-reply-all:before,\n.#{$fa-css-prefix}-reply-all:before { content: $fa-var-reply-all; }\n.#{$fa-css-prefix}-star-half-empty:before,\n.#{$fa-css-prefix}-star-half-full:before,\n.#{$fa-css-prefix}-star-half-o:before { content: $fa-var-star-half-o; }\n.#{$fa-css-prefix}-location-arrow:before { content: $fa-var-location-arrow; }\n.#{$fa-css-prefix}-crop:before { content: $fa-var-crop; }\n.#{$fa-css-prefix}-code-fork:before { content: $fa-var-code-fork; }\n.#{$fa-css-prefix}-unlink:before,\n.#{$fa-css-prefix}-chain-broken:before { content: $fa-var-chain-broken; }\n.#{$fa-css-prefix}-question:before { content: $fa-var-question; }\n.#{$fa-css-prefix}-info:before { content: $fa-var-info; }\n.#{$fa-css-prefix}-exclamation:before { content: $fa-var-exclamation; }\n.#{$fa-css-prefix}-superscript:before { content: $fa-var-superscript; }\n.#{$fa-css-prefix}-subscript:before { content: $fa-var-subscript; }\n.#{$fa-css-prefix}-eraser:before { content: $fa-var-eraser; }\n.#{$fa-css-prefix}-puzzle-piece:before { content: $fa-var-puzzle-piece; }\n.#{$fa-css-prefix}-microphone:before { content: $fa-var-microphone; }\n.#{$fa-css-prefix}-microphone-slash:before { content: $fa-var-microphone-slash; }\n.#{$fa-css-prefix}-shield:before { content: $fa-var-shield; }\n.#{$fa-css-prefix}-calendar-o:before { content: $fa-var-calendar-o; }\n.#{$fa-css-prefix}-fire-extinguisher:before { content: $fa-var-fire-extinguisher; }\n.#{$fa-css-prefix}-rocket:before { content: $fa-var-rocket; }\n.#{$fa-css-prefix}-maxcdn:before { content: $fa-var-maxcdn; }\n.#{$fa-css-prefix}-chevron-circle-left:before { content: $fa-var-chevron-circle-left; }\n.#{$fa-css-prefix}-chevron-circle-right:before { content: $fa-var-chevron-circle-right; }\n.#{$fa-css-prefix}-chevron-circle-up:before { content: $fa-var-chevron-circle-up; }\n.#{$fa-css-prefix}-chevron-circle-down:before { content: $fa-var-chevron-circle-down; }\n.#{$fa-css-prefix}-html5:before { content: $fa-var-html5; }\n.#{$fa-css-prefix}-css3:before { content: $fa-var-css3; }\n.#{$fa-css-prefix}-anchor:before { content: $fa-var-anchor; }\n.#{$fa-css-prefix}-unlock-alt:before { content: $fa-var-unlock-alt; }\n.#{$fa-css-prefix}-bullseye:before { content: $fa-var-bullseye; }\n.#{$fa-css-prefix}-ellipsis-h:before { content: $fa-var-ellipsis-h; }\n.#{$fa-css-prefix}-ellipsis-v:before { content: $fa-var-ellipsis-v; }\n.#{$fa-css-prefix}-rss-square:before { content: $fa-var-rss-square; }\n.#{$fa-css-prefix}-play-circle:before { content: $fa-var-play-circle; }\n.#{$fa-css-prefix}-ticket:before { content: $fa-var-ticket; }\n.#{$fa-css-prefix}-minus-square:before { content: $fa-var-minus-square; }\n.#{$fa-css-prefix}-minus-square-o:before { content: $fa-var-minus-square-o; }\n.#{$fa-css-prefix}-level-up:before { content: $fa-var-level-up; }\n.#{$fa-css-prefix}-level-down:before { content: $fa-var-level-down; }\n.#{$fa-css-prefix}-check-square:before { content: $fa-var-check-square; }\n.#{$fa-css-prefix}-pencil-square:before { content: $fa-var-pencil-square; }\n.#{$fa-css-prefix}-external-link-square:before { content: $fa-var-external-link-square; }\n.#{$fa-css-prefix}-share-square:before { content: $fa-var-share-square; }\n.#{$fa-css-prefix}-compass:before { content: $fa-var-compass; }\n.#{$fa-css-prefix}-toggle-down:before,\n.#{$fa-css-prefix}-caret-square-o-down:before { content: $fa-var-caret-square-o-down; }\n.#{$fa-css-prefix}-toggle-up:before,\n.#{$fa-css-prefix}-caret-square-o-up:before { content: $fa-var-caret-square-o-up; }\n.#{$fa-css-prefix}-toggle-right:before,\n.#{$fa-css-prefix}-caret-square-o-right:before { content: $fa-var-caret-square-o-right; }\n.#{$fa-css-prefix}-euro:before,\n.#{$fa-css-prefix}-eur:before { content: $fa-var-eur; }\n.#{$fa-css-prefix}-gbp:before { content: $fa-var-gbp; }\n.#{$fa-css-prefix}-dollar:before,\n.#{$fa-css-prefix}-usd:before { content: $fa-var-usd; }\n.#{$fa-css-prefix}-rupee:before,\n.#{$fa-css-prefix}-inr:before { content: $fa-var-inr; }\n.#{$fa-css-prefix}-cny:before,\n.#{$fa-css-prefix}-rmb:before,\n.#{$fa-css-prefix}-yen:before,\n.#{$fa-css-prefix}-jpy:before { content: $fa-var-jpy; }\n.#{$fa-css-prefix}-ruble:before,\n.#{$fa-css-prefix}-rouble:before,\n.#{$fa-css-prefix}-rub:before { content: $fa-var-rub; }\n.#{$fa-css-prefix}-won:before,\n.#{$fa-css-prefix}-krw:before { content: $fa-var-krw; }\n.#{$fa-css-prefix}-bitcoin:before,\n.#{$fa-css-prefix}-btc:before { content: $fa-var-btc; }\n.#{$fa-css-prefix}-file:before { content: $fa-var-file; }\n.#{$fa-css-prefix}-file-text:before { content: $fa-var-file-text; }\n.#{$fa-css-prefix}-sort-alpha-asc:before { content: $fa-var-sort-alpha-asc; }\n.#{$fa-css-prefix}-sort-alpha-desc:before { content: $fa-var-sort-alpha-desc; }\n.#{$fa-css-prefix}-sort-amount-asc:before { content: $fa-var-sort-amount-asc; }\n.#{$fa-css-prefix}-sort-amount-desc:before { content: $fa-var-sort-amount-desc; }\n.#{$fa-css-prefix}-sort-numeric-asc:before { content: $fa-var-sort-numeric-asc; }\n.#{$fa-css-prefix}-sort-numeric-desc:before { content: $fa-var-sort-numeric-desc; }\n.#{$fa-css-prefix}-thumbs-up:before { content: $fa-var-thumbs-up; }\n.#{$fa-css-prefix}-thumbs-down:before { content: $fa-var-thumbs-down; }\n.#{$fa-css-prefix}-youtube-square:before { content: $fa-var-youtube-square; }\n.#{$fa-css-prefix}-youtube:before { content: $fa-var-youtube; }\n.#{$fa-css-prefix}-xing:before { content: $fa-var-xing; }\n.#{$fa-css-prefix}-xing-square:before { content: $fa-var-xing-square; }\n.#{$fa-css-prefix}-youtube-play:before { content: $fa-var-youtube-play; }\n.#{$fa-css-prefix}-dropbox:before { content: $fa-var-dropbox; }\n.#{$fa-css-prefix}-stack-overflow:before { content: $fa-var-stack-overflow; }\n.#{$fa-css-prefix}-instagram:before { content: $fa-var-instagram; }\n.#{$fa-css-prefix}-flickr:before { content: $fa-var-flickr; }\n.#{$fa-css-prefix}-adn:before { content: $fa-var-adn; }\n.#{$fa-css-prefix}-bitbucket:before { content: $fa-var-bitbucket; }\n.#{$fa-css-prefix}-bitbucket-square:before { content: $fa-var-bitbucket-square; }\n.#{$fa-css-prefix}-tumblr:before { content: $fa-var-tumblr; }\n.#{$fa-css-prefix}-tumblr-square:before { content: $fa-var-tumblr-square; }\n.#{$fa-css-prefix}-long-arrow-down:before { content: $fa-var-long-arrow-down; }\n.#{$fa-css-prefix}-long-arrow-up:before { content: $fa-var-long-arrow-up; }\n.#{$fa-css-prefix}-long-arrow-left:before { content: $fa-var-long-arrow-left; }\n.#{$fa-css-prefix}-long-arrow-right:before { content: $fa-var-long-arrow-right; }\n.#{$fa-css-prefix}-apple:before { content: $fa-var-apple; }\n.#{$fa-css-prefix}-windows:before { content: $fa-var-windows; }\n.#{$fa-css-prefix}-android:before { content: $fa-var-android; }\n.#{$fa-css-prefix}-linux:before { content: $fa-var-linux; }\n.#{$fa-css-prefix}-dribbble:before { content: $fa-var-dribbble; }\n.#{$fa-css-prefix}-skype:before { content: $fa-var-skype; }\n.#{$fa-css-prefix}-foursquare:before { content: $fa-var-foursquare; }\n.#{$fa-css-prefix}-trello:before { content: $fa-var-trello; }\n.#{$fa-css-prefix}-female:before { content: $fa-var-female; }\n.#{$fa-css-prefix}-male:before { content: $fa-var-male; }\n.#{$fa-css-prefix}-gittip:before,\n.#{$fa-css-prefix}-gratipay:before { content: $fa-var-gratipay; }\n.#{$fa-css-prefix}-sun-o:before { content: $fa-var-sun-o; }\n.#{$fa-css-prefix}-moon-o:before { content: $fa-var-moon-o; }\n.#{$fa-css-prefix}-archive:before { content: $fa-var-archive; }\n.#{$fa-css-prefix}-bug:before { content: $fa-var-bug; }\n.#{$fa-css-prefix}-vk:before { content: $fa-var-vk; }\n.#{$fa-css-prefix}-weibo:before { content: $fa-var-weibo; }\n.#{$fa-css-prefix}-renren:before { content: $fa-var-renren; }\n.#{$fa-css-prefix}-pagelines:before { content: $fa-var-pagelines; }\n.#{$fa-css-prefix}-stack-exchange:before { content: $fa-var-stack-exchange; }\n.#{$fa-css-prefix}-arrow-circle-o-right:before { content: $fa-var-arrow-circle-o-right; }\n.#{$fa-css-prefix}-arrow-circle-o-left:before { content: $fa-var-arrow-circle-o-left; }\n.#{$fa-css-prefix}-toggle-left:before,\n.#{$fa-css-prefix}-caret-square-o-left:before { content: $fa-var-caret-square-o-left; }\n.#{$fa-css-prefix}-dot-circle-o:before { content: $fa-var-dot-circle-o; }\n.#{$fa-css-prefix}-wheelchair:before { content: $fa-var-wheelchair; }\n.#{$fa-css-prefix}-vimeo-square:before { content: $fa-var-vimeo-square; }\n.#{$fa-css-prefix}-turkish-lira:before,\n.#{$fa-css-prefix}-try:before { content: $fa-var-try; }\n.#{$fa-css-prefix}-plus-square-o:before { content: $fa-var-plus-square-o; }\n.#{$fa-css-prefix}-space-shuttle:before { content: $fa-var-space-shuttle; }\n.#{$fa-css-prefix}-slack:before { content: $fa-var-slack; }\n.#{$fa-css-prefix}-envelope-square:before { content: $fa-var-envelope-square; }\n.#{$fa-css-prefix}-wordpress:before { content: $fa-var-wordpress; }\n.#{$fa-css-prefix}-openid:before { content: $fa-var-openid; }\n.#{$fa-css-prefix}-institution:before,\n.#{$fa-css-prefix}-bank:before,\n.#{$fa-css-prefix}-university:before { content: $fa-var-university; }\n.#{$fa-css-prefix}-mortar-board:before,\n.#{$fa-css-prefix}-graduation-cap:before { content: $fa-var-graduation-cap; }\n.#{$fa-css-prefix}-yahoo:before { content: $fa-var-yahoo; }\n.#{$fa-css-prefix}-google:before { content: $fa-var-google; }\n.#{$fa-css-prefix}-reddit:before { content: $fa-var-reddit; }\n.#{$fa-css-prefix}-reddit-square:before { content: $fa-var-reddit-square; }\n.#{$fa-css-prefix}-stumbleupon-circle:before { content: $fa-var-stumbleupon-circle; }\n.#{$fa-css-prefix}-stumbleupon:before { content: $fa-var-stumbleupon; }\n.#{$fa-css-prefix}-delicious:before { content: $fa-var-delicious; }\n.#{$fa-css-prefix}-digg:before { content: $fa-var-digg; }\n.#{$fa-css-prefix}-pied-piper-pp:before { content: $fa-var-pied-piper-pp; }\n.#{$fa-css-prefix}-pied-piper-alt:before { content: $fa-var-pied-piper-alt; }\n.#{$fa-css-prefix}-drupal:before { content: $fa-var-drupal; }\n.#{$fa-css-prefix}-joomla:before { content: $fa-var-joomla; }\n.#{$fa-css-prefix}-language:before { content: $fa-var-language; }\n.#{$fa-css-prefix}-fax:before { content: $fa-var-fax; }\n.#{$fa-css-prefix}-building:before { content: $fa-var-building; }\n.#{$fa-css-prefix}-child:before { content: $fa-var-child; }\n.#{$fa-css-prefix}-paw:before { content: $fa-var-paw; }\n.#{$fa-css-prefix}-spoon:before { content: $fa-var-spoon; }\n.#{$fa-css-prefix}-cube:before { content: $fa-var-cube; }\n.#{$fa-css-prefix}-cubes:before { content: $fa-var-cubes; }\n.#{$fa-css-prefix}-behance:before { content: $fa-var-behance; }\n.#{$fa-css-prefix}-behance-square:before { content: $fa-var-behance-square; }\n.#{$fa-css-prefix}-steam:before { content: $fa-var-steam; }\n.#{$fa-css-prefix}-steam-square:before { content: $fa-var-steam-square; }\n.#{$fa-css-prefix}-recycle:before { content: $fa-var-recycle; }\n.#{$fa-css-prefix}-automobile:before,\n.#{$fa-css-prefix}-car:before { content: $fa-var-car; }\n.#{$fa-css-prefix}-cab:before,\n.#{$fa-css-prefix}-taxi:before { content: $fa-var-taxi; }\n.#{$fa-css-prefix}-tree:before { content: $fa-var-tree; }\n.#{$fa-css-prefix}-spotify:before { content: $fa-var-spotify; }\n.#{$fa-css-prefix}-deviantart:before { content: $fa-var-deviantart; }\n.#{$fa-css-prefix}-soundcloud:before { content: $fa-var-soundcloud; }\n.#{$fa-css-prefix}-database:before { content: $fa-var-database; }\n.#{$fa-css-prefix}-file-pdf-o:before { content: $fa-var-file-pdf-o; }\n.#{$fa-css-prefix}-file-word-o:before { content: $fa-var-file-word-o; }\n.#{$fa-css-prefix}-file-excel-o:before { content: $fa-var-file-excel-o; }\n.#{$fa-css-prefix}-file-powerpoint-o:before { content: $fa-var-file-powerpoint-o; }\n.#{$fa-css-prefix}-file-photo-o:before,\n.#{$fa-css-prefix}-file-picture-o:before,\n.#{$fa-css-prefix}-file-image-o:before { content: $fa-var-file-image-o; }\n.#{$fa-css-prefix}-file-zip-o:before,\n.#{$fa-css-prefix}-file-archive-o:before { content: $fa-var-file-archive-o; }\n.#{$fa-css-prefix}-file-sound-o:before,\n.#{$fa-css-prefix}-file-audio-o:before { content: $fa-var-file-audio-o; }\n.#{$fa-css-prefix}-file-movie-o:before,\n.#{$fa-css-prefix}-file-video-o:before { content: $fa-var-file-video-o; }\n.#{$fa-css-prefix}-file-code-o:before { content: $fa-var-file-code-o; }\n.#{$fa-css-prefix}-vine:before { content: $fa-var-vine; }\n.#{$fa-css-prefix}-codepen:before { content: $fa-var-codepen; }\n.#{$fa-css-prefix}-jsfiddle:before { content: $fa-var-jsfiddle; }\n.#{$fa-css-prefix}-life-bouy:before,\n.#{$fa-css-prefix}-life-buoy:before,\n.#{$fa-css-prefix}-life-saver:before,\n.#{$fa-css-prefix}-support:before,\n.#{$fa-css-prefix}-life-ring:before { content: $fa-var-life-ring; }\n.#{$fa-css-prefix}-circle-o-notch:before { content: $fa-var-circle-o-notch; }\n.#{$fa-css-prefix}-ra:before,\n.#{$fa-css-prefix}-resistance:before,\n.#{$fa-css-prefix}-rebel:before { content: $fa-var-rebel; }\n.#{$fa-css-prefix}-ge:before,\n.#{$fa-css-prefix}-empire:before { content: $fa-var-empire; }\n.#{$fa-css-prefix}-git-square:before { content: $fa-var-git-square; }\n.#{$fa-css-prefix}-git:before { content: $fa-var-git; }\n.#{$fa-css-prefix}-y-combinator-square:before,\n.#{$fa-css-prefix}-yc-square:before,\n.#{$fa-css-prefix}-hacker-news:before { content: $fa-var-hacker-news; }\n.#{$fa-css-prefix}-tencent-weibo:before { content: $fa-var-tencent-weibo; }\n.#{$fa-css-prefix}-qq:before { content: $fa-var-qq; }\n.#{$fa-css-prefix}-wechat:before,\n.#{$fa-css-prefix}-weixin:before { content: $fa-var-weixin; }\n.#{$fa-css-prefix}-send:before,\n.#{$fa-css-prefix}-paper-plane:before { content: $fa-var-paper-plane; }\n.#{$fa-css-prefix}-send-o:before,\n.#{$fa-css-prefix}-paper-plane-o:before { content: $fa-var-paper-plane-o; }\n.#{$fa-css-prefix}-history:before { content: $fa-var-history; }\n.#{$fa-css-prefix}-circle-thin:before { content: $fa-var-circle-thin; }\n.#{$fa-css-prefix}-header:before { content: $fa-var-header; }\n.#{$fa-css-prefix}-paragraph:before { content: $fa-var-paragraph; }\n.#{$fa-css-prefix}-sliders:before { content: $fa-var-sliders; }\n.#{$fa-css-prefix}-share-alt:before { content: $fa-var-share-alt; }\n.#{$fa-css-prefix}-share-alt-square:before { content: $fa-var-share-alt-square; }\n.#{$fa-css-prefix}-bomb:before { content: $fa-var-bomb; }\n.#{$fa-css-prefix}-soccer-ball-o:before,\n.#{$fa-css-prefix}-futbol-o:before { content: $fa-var-futbol-o; }\n.#{$fa-css-prefix}-tty:before { content: $fa-var-tty; }\n.#{$fa-css-prefix}-binoculars:before { content: $fa-var-binoculars; }\n.#{$fa-css-prefix}-plug:before { content: $fa-var-plug; }\n.#{$fa-css-prefix}-slideshare:before { content: $fa-var-slideshare; }\n.#{$fa-css-prefix}-twitch:before { content: $fa-var-twitch; }\n.#{$fa-css-prefix}-yelp:before { content: $fa-var-yelp; }\n.#{$fa-css-prefix}-newspaper-o:before { content: $fa-var-newspaper-o; }\n.#{$fa-css-prefix}-wifi:before { content: $fa-var-wifi; }\n.#{$fa-css-prefix}-calculator:before { content: $fa-var-calculator; }\n.#{$fa-css-prefix}-paypal:before { content: $fa-var-paypal; }\n.#{$fa-css-prefix}-google-wallet:before { content: $fa-var-google-wallet; }\n.#{$fa-css-prefix}-cc-visa:before { content: $fa-var-cc-visa; }\n.#{$fa-css-prefix}-cc-mastercard:before { content: $fa-var-cc-mastercard; }\n.#{$fa-css-prefix}-cc-discover:before { content: $fa-var-cc-discover; }\n.#{$fa-css-prefix}-cc-amex:before { content: $fa-var-cc-amex; }\n.#{$fa-css-prefix}-cc-paypal:before { content: $fa-var-cc-paypal; }\n.#{$fa-css-prefix}-cc-stripe:before { content: $fa-var-cc-stripe; }\n.#{$fa-css-prefix}-bell-slash:before { content: $fa-var-bell-slash; }\n.#{$fa-css-prefix}-bell-slash-o:before { content: $fa-var-bell-slash-o; }\n.#{$fa-css-prefix}-trash:before { content: $fa-var-trash; }\n.#{$fa-css-prefix}-copyright:before { content: $fa-var-copyright; }\n.#{$fa-css-prefix}-at:before { content: $fa-var-at; }\n.#{$fa-css-prefix}-eyedropper:before { content: $fa-var-eyedropper; }\n.#{$fa-css-prefix}-paint-brush:before { content: $fa-var-paint-brush; }\n.#{$fa-css-prefix}-birthday-cake:before { content: $fa-var-birthday-cake; }\n.#{$fa-css-prefix}-area-chart:before { content: $fa-var-area-chart; }\n.#{$fa-css-prefix}-pie-chart:before { content: $fa-var-pie-chart; }\n.#{$fa-css-prefix}-line-chart:before { content: $fa-var-line-chart; }\n.#{$fa-css-prefix}-lastfm:before { content: $fa-var-lastfm; }\n.#{$fa-css-prefix}-lastfm-square:before { content: $fa-var-lastfm-square; }\n.#{$fa-css-prefix}-toggle-off:before { content: $fa-var-toggle-off; }\n.#{$fa-css-prefix}-toggle-on:before { content: $fa-var-toggle-on; }\n.#{$fa-css-prefix}-bicycle:before { content: $fa-var-bicycle; }\n.#{$fa-css-prefix}-bus:before { content: $fa-var-bus; }\n.#{$fa-css-prefix}-ioxhost:before { content: $fa-var-ioxhost; }\n.#{$fa-css-prefix}-angellist:before { content: $fa-var-angellist; }\n.#{$fa-css-prefix}-cc:before { content: $fa-var-cc; }\n.#{$fa-css-prefix}-shekel:before,\n.#{$fa-css-prefix}-sheqel:before,\n.#{$fa-css-prefix}-ils:before { content: $fa-var-ils; }\n.#{$fa-css-prefix}-meanpath:before { content: $fa-var-meanpath; }\n.#{$fa-css-prefix}-buysellads:before { content: $fa-var-buysellads; }\n.#{$fa-css-prefix}-connectdevelop:before { content: $fa-var-connectdevelop; }\n.#{$fa-css-prefix}-dashcube:before { content: $fa-var-dashcube; }\n.#{$fa-css-prefix}-forumbee:before { content: $fa-var-forumbee; }\n.#{$fa-css-prefix}-leanpub:before { content: $fa-var-leanpub; }\n.#{$fa-css-prefix}-sellsy:before { content: $fa-var-sellsy; }\n.#{$fa-css-prefix}-shirtsinbulk:before { content: $fa-var-shirtsinbulk; }\n.#{$fa-css-prefix}-simplybuilt:before { content: $fa-var-simplybuilt; }\n.#{$fa-css-prefix}-skyatlas:before { content: $fa-var-skyatlas; }\n.#{$fa-css-prefix}-cart-plus:before { content: $fa-var-cart-plus; }\n.#{$fa-css-prefix}-cart-arrow-down:before { content: $fa-var-cart-arrow-down; }\n.#{$fa-css-prefix}-diamond:before { content: $fa-var-diamond; }\n.#{$fa-css-prefix}-ship:before { content: $fa-var-ship; }\n.#{$fa-css-prefix}-user-secret:before { content: $fa-var-user-secret; }\n.#{$fa-css-prefix}-motorcycle:before { content: $fa-var-motorcycle; }\n.#{$fa-css-prefix}-street-view:before { content: $fa-var-street-view; }\n.#{$fa-css-prefix}-heartbeat:before { content: $fa-var-heartbeat; }\n.#{$fa-css-prefix}-venus:before { content: $fa-var-venus; }\n.#{$fa-css-prefix}-mars:before { content: $fa-var-mars; }\n.#{$fa-css-prefix}-mercury:before { content: $fa-var-mercury; }\n.#{$fa-css-prefix}-intersex:before,\n.#{$fa-css-prefix}-transgender:before { content: $fa-var-transgender; }\n.#{$fa-css-prefix}-transgender-alt:before { content: $fa-var-transgender-alt; }\n.#{$fa-css-prefix}-venus-double:before { content: $fa-var-venus-double; }\n.#{$fa-css-prefix}-mars-double:before { content: $fa-var-mars-double; }\n.#{$fa-css-prefix}-venus-mars:before { content: $fa-var-venus-mars; }\n.#{$fa-css-prefix}-mars-stroke:before { content: $fa-var-mars-stroke; }\n.#{$fa-css-prefix}-mars-stroke-v:before { content: $fa-var-mars-stroke-v; }\n.#{$fa-css-prefix}-mars-stroke-h:before { content: $fa-var-mars-stroke-h; }\n.#{$fa-css-prefix}-neuter:before { content: $fa-var-neuter; }\n.#{$fa-css-prefix}-genderless:before { content: $fa-var-genderless; }\n.#{$fa-css-prefix}-facebook-official:before { content: $fa-var-facebook-official; }\n.#{$fa-css-prefix}-pinterest-p:before { content: $fa-var-pinterest-p; }\n.#{$fa-css-prefix}-whatsapp:before { content: $fa-var-whatsapp; }\n.#{$fa-css-prefix}-server:before { content: $fa-var-server; }\n.#{$fa-css-prefix}-user-plus:before { content: $fa-var-user-plus; }\n.#{$fa-css-prefix}-user-times:before { content: $fa-var-user-times; }\n.#{$fa-css-prefix}-hotel:before,\n.#{$fa-css-prefix}-bed:before { content: $fa-var-bed; }\n.#{$fa-css-prefix}-viacoin:before { content: $fa-var-viacoin; }\n.#{$fa-css-prefix}-train:before { content: $fa-var-train; }\n.#{$fa-css-prefix}-subway:before { content: $fa-var-subway; }\n.#{$fa-css-prefix}-medium:before { content: $fa-var-medium; }\n.#{$fa-css-prefix}-yc:before,\n.#{$fa-css-prefix}-y-combinator:before { content: $fa-var-y-combinator; }\n.#{$fa-css-prefix}-optin-monster:before { content: $fa-var-optin-monster; }\n.#{$fa-css-prefix}-opencart:before { content: $fa-var-opencart; }\n.#{$fa-css-prefix}-expeditedssl:before { content: $fa-var-expeditedssl; }\n.#{$fa-css-prefix}-battery-4:before,\n.#{$fa-css-prefix}-battery:before,\n.#{$fa-css-prefix}-battery-full:before { content: $fa-var-battery-full; }\n.#{$fa-css-prefix}-battery-3:before,\n.#{$fa-css-prefix}-battery-three-quarters:before { content: $fa-var-battery-three-quarters; }\n.#{$fa-css-prefix}-battery-2:before,\n.#{$fa-css-prefix}-battery-half:before { content: $fa-var-battery-half; }\n.#{$fa-css-prefix}-battery-1:before,\n.#{$fa-css-prefix}-battery-quarter:before { content: $fa-var-battery-quarter; }\n.#{$fa-css-prefix}-battery-0:before,\n.#{$fa-css-prefix}-battery-empty:before { content: $fa-var-battery-empty; }\n.#{$fa-css-prefix}-mouse-pointer:before { content: $fa-var-mouse-pointer; }\n.#{$fa-css-prefix}-i-cursor:before { content: $fa-var-i-cursor; }\n.#{$fa-css-prefix}-object-group:before { content: $fa-var-object-group; }\n.#{$fa-css-prefix}-object-ungroup:before { content: $fa-var-object-ungroup; }\n.#{$fa-css-prefix}-sticky-note:before { content: $fa-var-sticky-note; }\n.#{$fa-css-prefix}-sticky-note-o:before { content: $fa-var-sticky-note-o; }\n.#{$fa-css-prefix}-cc-jcb:before { content: $fa-var-cc-jcb; }\n.#{$fa-css-prefix}-cc-diners-club:before { content: $fa-var-cc-diners-club; }\n.#{$fa-css-prefix}-clone:before { content: $fa-var-clone; }\n.#{$fa-css-prefix}-balance-scale:before { content: $fa-var-balance-scale; }\n.#{$fa-css-prefix}-hourglass-o:before { content: $fa-var-hourglass-o; }\n.#{$fa-css-prefix}-hourglass-1:before,\n.#{$fa-css-prefix}-hourglass-start:before { content: $fa-var-hourglass-start; }\n.#{$fa-css-prefix}-hourglass-2:before,\n.#{$fa-css-prefix}-hourglass-half:before { content: $fa-var-hourglass-half; }\n.#{$fa-css-prefix}-hourglass-3:before,\n.#{$fa-css-prefix}-hourglass-end:before { content: $fa-var-hourglass-end; }\n.#{$fa-css-prefix}-hourglass:before { content: $fa-var-hourglass; }\n.#{$fa-css-prefix}-hand-grab-o:before,\n.#{$fa-css-prefix}-hand-rock-o:before { content: $fa-var-hand-rock-o; }\n.#{$fa-css-prefix}-hand-stop-o:before,\n.#{$fa-css-prefix}-hand-paper-o:before { content: $fa-var-hand-paper-o; }\n.#{$fa-css-prefix}-hand-scissors-o:before { content: $fa-var-hand-scissors-o; }\n.#{$fa-css-prefix}-hand-lizard-o:before { content: $fa-var-hand-lizard-o; }\n.#{$fa-css-prefix}-hand-spock-o:before { content: $fa-var-hand-spock-o; }\n.#{$fa-css-prefix}-hand-pointer-o:before { content: $fa-var-hand-pointer-o; }\n.#{$fa-css-prefix}-hand-peace-o:before { content: $fa-var-hand-peace-o; }\n.#{$fa-css-prefix}-trademark:before { content: $fa-var-trademark; }\n.#{$fa-css-prefix}-registered:before { content: $fa-var-registered; }\n.#{$fa-css-prefix}-creative-commons:before { content: $fa-var-creative-commons; }\n.#{$fa-css-prefix}-gg:before { content: $fa-var-gg; }\n.#{$fa-css-prefix}-gg-circle:before { content: $fa-var-gg-circle; }\n.#{$fa-css-prefix}-tripadvisor:before { content: $fa-var-tripadvisor; }\n.#{$fa-css-prefix}-odnoklassniki:before { content: $fa-var-odnoklassniki; }\n.#{$fa-css-prefix}-odnoklassniki-square:before { content: $fa-var-odnoklassniki-square; }\n.#{$fa-css-prefix}-get-pocket:before { content: $fa-var-get-pocket; }\n.#{$fa-css-prefix}-wikipedia-w:before { content: $fa-var-wikipedia-w; }\n.#{$fa-css-prefix}-safari:before { content: $fa-var-safari; }\n.#{$fa-css-prefix}-chrome:before { content: $fa-var-chrome; }\n.#{$fa-css-prefix}-firefox:before { content: $fa-var-firefox; }\n.#{$fa-css-prefix}-opera:before { content: $fa-var-opera; }\n.#{$fa-css-prefix}-internet-explorer:before { content: $fa-var-internet-explorer; }\n.#{$fa-css-prefix}-tv:before,\n.#{$fa-css-prefix}-television:before { content: $fa-var-television; }\n.#{$fa-css-prefix}-contao:before { content: $fa-var-contao; }\n.#{$fa-css-prefix}-500px:before { content: $fa-var-500px; }\n.#{$fa-css-prefix}-amazon:before { content: $fa-var-amazon; }\n.#{$fa-css-prefix}-calendar-plus-o:before { content: $fa-var-calendar-plus-o; }\n.#{$fa-css-prefix}-calendar-minus-o:before { content: $fa-var-calendar-minus-o; }\n.#{$fa-css-prefix}-calendar-times-o:before { content: $fa-var-calendar-times-o; }\n.#{$fa-css-prefix}-calendar-check-o:before { content: $fa-var-calendar-check-o; }\n.#{$fa-css-prefix}-industry:before { content: $fa-var-industry; }\n.#{$fa-css-prefix}-map-pin:before { content: $fa-var-map-pin; }\n.#{$fa-css-prefix}-map-signs:before { content: $fa-var-map-signs; }\n.#{$fa-css-prefix}-map-o:before { content: $fa-var-map-o; }\n.#{$fa-css-prefix}-map:before { content: $fa-var-map; }\n.#{$fa-css-prefix}-commenting:before { content: $fa-var-commenting; }\n.#{$fa-css-prefix}-commenting-o:before { content: $fa-var-commenting-o; }\n.#{$fa-css-prefix}-houzz:before { content: $fa-var-houzz; }\n.#{$fa-css-prefix}-vimeo:before { content: $fa-var-vimeo; }\n.#{$fa-css-prefix}-black-tie:before { content: $fa-var-black-tie; }\n.#{$fa-css-prefix}-fonticons:before { content: $fa-var-fonticons; }\n.#{$fa-css-prefix}-reddit-alien:before { content: $fa-var-reddit-alien; }\n.#{$fa-css-prefix}-edge:before { content: $fa-var-edge; }\n.#{$fa-css-prefix}-credit-card-alt:before { content: $fa-var-credit-card-alt; }\n.#{$fa-css-prefix}-codiepie:before { content: $fa-var-codiepie; }\n.#{$fa-css-prefix}-modx:before { content: $fa-var-modx; }\n.#{$fa-css-prefix}-fort-awesome:before { content: $fa-var-fort-awesome; }\n.#{$fa-css-prefix}-usb:before { content: $fa-var-usb; }\n.#{$fa-css-prefix}-product-hunt:before { content: $fa-var-product-hunt; }\n.#{$fa-css-prefix}-mixcloud:before { content: $fa-var-mixcloud; }\n.#{$fa-css-prefix}-scribd:before { content: $fa-var-scribd; }\n.#{$fa-css-prefix}-pause-circle:before { content: $fa-var-pause-circle; }\n.#{$fa-css-prefix}-pause-circle-o:before { content: $fa-var-pause-circle-o; }\n.#{$fa-css-prefix}-stop-circle:before { content: $fa-var-stop-circle; }\n.#{$fa-css-prefix}-stop-circle-o:before { content: $fa-var-stop-circle-o; }\n.#{$fa-css-prefix}-shopping-bag:before { content: $fa-var-shopping-bag; }\n.#{$fa-css-prefix}-shopping-basket:before { content: $fa-var-shopping-basket; }\n.#{$fa-css-prefix}-hashtag:before { content: $fa-var-hashtag; }\n.#{$fa-css-prefix}-bluetooth:before { content: $fa-var-bluetooth; }\n.#{$fa-css-prefix}-bluetooth-b:before { content: $fa-var-bluetooth-b; }\n.#{$fa-css-prefix}-percent:before { content: $fa-var-percent; }\n.#{$fa-css-prefix}-gitlab:before { content: $fa-var-gitlab; }\n.#{$fa-css-prefix}-wpbeginner:before { content: $fa-var-wpbeginner; }\n.#{$fa-css-prefix}-wpforms:before { content: $fa-var-wpforms; }\n.#{$fa-css-prefix}-envira:before { content: $fa-var-envira; }\n.#{$fa-css-prefix}-universal-access:before { content: $fa-var-universal-access; }\n.#{$fa-css-prefix}-wheelchair-alt:before { content: $fa-var-wheelchair-alt; }\n.#{$fa-css-prefix}-question-circle-o:before { content: $fa-var-question-circle-o; }\n.#{$fa-css-prefix}-blind:before { content: $fa-var-blind; }\n.#{$fa-css-prefix}-audio-description:before { content: $fa-var-audio-description; }\n.#{$fa-css-prefix}-volume-control-phone:before { content: $fa-var-volume-control-phone; }\n.#{$fa-css-prefix}-braille:before { content: $fa-var-braille; }\n.#{$fa-css-prefix}-assistive-listening-systems:before { content: $fa-var-assistive-listening-systems; }\n.#{$fa-css-prefix}-asl-interpreting:before,\n.#{$fa-css-prefix}-american-sign-language-interpreting:before { content: $fa-var-american-sign-language-interpreting; }\n.#{$fa-css-prefix}-deafness:before,\n.#{$fa-css-prefix}-hard-of-hearing:before,\n.#{$fa-css-prefix}-deaf:before { content: $fa-var-deaf; }\n.#{$fa-css-prefix}-glide:before { content: $fa-var-glide; }\n.#{$fa-css-prefix}-glide-g:before { content: $fa-var-glide-g; }\n.#{$fa-css-prefix}-signing:before,\n.#{$fa-css-prefix}-sign-language:before { content: $fa-var-sign-language; }\n.#{$fa-css-prefix}-low-vision:before { content: $fa-var-low-vision; }\n.#{$fa-css-prefix}-viadeo:before { content: $fa-var-viadeo; }\n.#{$fa-css-prefix}-viadeo-square:before { content: $fa-var-viadeo-square; }\n.#{$fa-css-prefix}-snapchat:before { content: $fa-var-snapchat; }\n.#{$fa-css-prefix}-snapchat-ghost:before { content: $fa-var-snapchat-ghost; }\n.#{$fa-css-prefix}-snapchat-square:before { content: $fa-var-snapchat-square; }\n.#{$fa-css-prefix}-pied-piper:before { content: $fa-var-pied-piper; }\n.#{$fa-css-prefix}-first-order:before { content: $fa-var-first-order; }\n.#{$fa-css-prefix}-yoast:before { content: $fa-var-yoast; }\n.#{$fa-css-prefix}-themeisle:before { content: $fa-var-themeisle; }\n.#{$fa-css-prefix}-google-plus-circle:before,\n.#{$fa-css-prefix}-google-plus-official:before { content: $fa-var-google-plus-official; }\n.#{$fa-css-prefix}-fa:before,\n.#{$fa-css-prefix}-font-awesome:before { content: $fa-var-font-awesome; }\n.#{$fa-css-prefix}-handshake-o:before { content: $fa-var-handshake-o; }\n.#{$fa-css-prefix}-envelope-open:before { content: $fa-var-envelope-open; }\n.#{$fa-css-prefix}-envelope-open-o:before { content: $fa-var-envelope-open-o; }\n.#{$fa-css-prefix}-linode:before { content: $fa-var-linode; }\n.#{$fa-css-prefix}-address-book:before { content: $fa-var-address-book; }\n.#{$fa-css-prefix}-address-book-o:before { content: $fa-var-address-book-o; }\n.#{$fa-css-prefix}-vcard:before,\n.#{$fa-css-prefix}-address-card:before { content: $fa-var-address-card; }\n.#{$fa-css-prefix}-vcard-o:before,\n.#{$fa-css-prefix}-address-card-o:before { content: $fa-var-address-card-o; }\n.#{$fa-css-prefix}-user-circle:before { content: $fa-var-user-circle; }\n.#{$fa-css-prefix}-user-circle-o:before { content: $fa-var-user-circle-o; }\n.#{$fa-css-prefix}-user-o:before { content: $fa-var-user-o; }\n.#{$fa-css-prefix}-id-badge:before { content: $fa-var-id-badge; }\n.#{$fa-css-prefix}-drivers-license:before,\n.#{$fa-css-prefix}-id-card:before { content: $fa-var-id-card; }\n.#{$fa-css-prefix}-drivers-license-o:before,\n.#{$fa-css-prefix}-id-card-o:before { content: $fa-var-id-card-o; }\n.#{$fa-css-prefix}-quora:before { content: $fa-var-quora; }\n.#{$fa-css-prefix}-free-code-camp:before { content: $fa-var-free-code-camp; }\n.#{$fa-css-prefix}-telegram:before { content: $fa-var-telegram; }\n.#{$fa-css-prefix}-thermometer-4:before,\n.#{$fa-css-prefix}-thermometer:before,\n.#{$fa-css-prefix}-thermometer-full:before { content: $fa-var-thermometer-full; }\n.#{$fa-css-prefix}-thermometer-3:before,\n.#{$fa-css-prefix}-thermometer-three-quarters:before { content: $fa-var-thermometer-three-quarters; }\n.#{$fa-css-prefix}-thermometer-2:before,\n.#{$fa-css-prefix}-thermometer-half:before { content: $fa-var-thermometer-half; }\n.#{$fa-css-prefix}-thermometer-1:before,\n.#{$fa-css-prefix}-thermometer-quarter:before { content: $fa-var-thermometer-quarter; }\n.#{$fa-css-prefix}-thermometer-0:before,\n.#{$fa-css-prefix}-thermometer-empty:before { content: $fa-var-thermometer-empty; }\n.#{$fa-css-prefix}-shower:before { content: $fa-var-shower; }\n.#{$fa-css-prefix}-bathtub:before,\n.#{$fa-css-prefix}-s15:before,\n.#{$fa-css-prefix}-bath:before { content: $fa-var-bath; }\n.#{$fa-css-prefix}-podcast:before { content: $fa-var-podcast; }\n.#{$fa-css-prefix}-window-maximize:before { content: $fa-var-window-maximize; }\n.#{$fa-css-prefix}-window-minimize:before { content: $fa-var-window-minimize; }\n.#{$fa-css-prefix}-window-restore:before { content: $fa-var-window-restore; }\n.#{$fa-css-prefix}-times-rectangle:before,\n.#{$fa-css-prefix}-window-close:before { content: $fa-var-window-close; }\n.#{$fa-css-prefix}-times-rectangle-o:before,\n.#{$fa-css-prefix}-window-close-o:before { content: $fa-var-window-close-o; }\n.#{$fa-css-prefix}-bandcamp:before { content: $fa-var-bandcamp; }\n.#{$fa-css-prefix}-grav:before { content: $fa-var-grav; }\n.#{$fa-css-prefix}-etsy:before { content: $fa-var-etsy; }\n.#{$fa-css-prefix}-imdb:before { content: $fa-var-imdb; }\n.#{$fa-css-prefix}-ravelry:before { content: $fa-var-ravelry; }\n.#{$fa-css-prefix}-eercast:before { content: $fa-var-eercast; }\n.#{$fa-css-prefix}-microchip:before { content: $fa-var-microchip; }\n.#{$fa-css-prefix}-snowflake-o:before { content: $fa-var-snowflake-o; }\n.#{$fa-css-prefix}-superpowers:before { content: $fa-var-superpowers; }\n.#{$fa-css-prefix}-wpexplorer:before { content: $fa-var-wpexplorer; }\n.#{$fa-css-prefix}-meetup:before { content: $fa-var-meetup; }\n","// Screen Readers\n// -------------------------\n\n.sr-only { @include sr-only(); }\n.sr-only-focusable { @include sr-only-focusable(); }\n","@import \"~bootstrap-scss/bootstrap.scss\";\r\n@import 'theme/variables';\r\n@import 'theme/admin_style';\r\n@import 'theme/rtl';\r\n@import 'flag-icon.scss';\r\n@import 'themify.scss';\r\n@import 'icoicon/icons';\r\n@import 'font-awesome.scss';\r\n\r\n.date-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  background-color: #f8f9fa;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  margin-bottom: 8px;\r\n  align-items: center;\r\n  font-weight: 500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
